webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = extractV1SellersItems;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapV1SellersToFilterAccounts;
/* harmony export (immutable) */ __webpack_exports__["g"] = extractMarketplaceCodesFromV1SellersBody;
/* unused harmony export DEFAULT_MARKETPLACE_FILTER_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MARKETPLACE_FILTER_COUNTRIES_ALL; });
/* unused harmony export MARKETPLACE_AMAZON_SUFFIX */
/* harmony export (immutable) */ __webpack_exports__["a"] = getMarketplaceAmazonSuffix;
/* harmony export (immutable) */ __webpack_exports__["f"] = buildMarketplaceFilterCodes;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildMarketplaceFilterDropdownItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


function unwrapId(v) {
  if (v == null || v === '') return null;
  if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v)) === 'object' && v.value !== undefined) return unwrapId(v.value);
  return v;
}

function extractV1SellersItems(body) {
  if (!body) return [];
  if (Array.isArray(body)) return body;
  var keys = ['item', 'items', 'content', 'sellers', 'sellerAccounts', 'seller_accounts', 'data'];
  for (var i = 0; i < keys.length; i++) {
    var arr = body[keys[i]];
    if (Array.isArray(arr)) return arr;
  }
  return [];
}

function mapV1SellersToFilterAccounts(items) {
  if (!Array.isArray(items)) return [];
  return items.map(function (u) {
    if (!u) return null;
    var sid = unwrapId(u.sellerId != null ? u.sellerId : u.seller_id);
    if (sid == null || sid === '') sid = unwrapId(u.id);
    if (sid == null || sid === '') return null;
    var name = u.nickName || u.nickname || u.name || u.accountNickName || u.storefrontName;
    if (!name) name = 'Storefront ' + String(sid).slice(-6);
    var n = Number(sid);
    var id = isNaN(n) ? sid : n;
    var region = u.region || u.marketplaceRegion || 'NA';
    var mp = u.marketplace || u.marketplaceIso31662Code || u.marketplaceCode;
    return { id: id, name: name, region: region, marketplace: mp };
  }).filter(Boolean);
}

function normalizeMarketplaceFilterCode(raw) {
  if (raw == null || raw === '') return null;
  var m = String(raw).trim().toUpperCase();
  if (!m) return null;
  if (m === 'GB') m = 'UK';
  return m;
}

function extractMarketplaceCodesFromV1SellersBody(body) {
  var seen = {};
  var list = [];
  function pushRaw(raw) {
    var c = normalizeMarketplaceFilterCode(raw);
    if (!c || seen[c]) return;
    seen[c] = true;
    list.push(c);
  }
  function pushEntry(m) {
    if (m == null) return;
    if (typeof m === 'string') {
      pushRaw(m);
      return;
    }
    if ((typeof m === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(m)) === 'object') {
      pushRaw(m.code || m.marketplace || m.marketplaceCode || m.marketplace_code || m.countryCode || m.country_code);
    }
  }

  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return list;

  var af = body.availableFilters || body.available_filters;
  if (af && Array.isArray(af.marketplaces)) {
    for (var ai = 0; ai < af.marketplaces.length; ai++) {
      pushEntry(af.marketplaces[ai]);
    }
  }

  var rootArrays = ['availableMarketplaces', 'available_marketplaces', 'marketplaces'];
  for (var ri = 0; ri < rootArrays.length; ri++) {
    var arr = body[rootArrays[ri]];
    if (!Array.isArray(arr)) continue;
    for (var aj = 0; aj < arr.length; aj++) {
      pushEntry(arr[aj]);
    }
  }

  var items = extractV1SellersItems(body);
  for (var ii = 0; ii < items.length; ii++) {
    var u = items[ii];
    if (!u || (typeof u === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(u)) !== 'object') continue;
    pushRaw(u.marketplace || u.marketplaceIso31662Code || u.marketplaceCode || u.marketplace_code);

    var nestedKeys = ['marketplaces', 'listed_marketplaces', 'marketplaceCodes', 'marketplace_codes', 'sellerMarketplaces', 'seller_marketplaces', 'marketplaceParticipations'];
    for (var nk = 0; nk < nestedKeys.length; nk++) {
      var nested = u[nestedKeys[nk]];
      if (!Array.isArray(nested)) continue;
      for (var ni = 0; ni < nested.length; ni++) {
        var el = nested[ni];
        if (typeof el === 'string') pushRaw(el);else if (el && (typeof el === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(el)) === 'object') {
          pushRaw(el.marketplace || el.marketplaceCode || el.marketplace_code || el.code || el.countryCode);
        }
      }
    }
  }

  return list;
}

var DEFAULT_MARKETPLACE_FILTER_ORDER = ['US', 'CA', 'MX', 'BR', 'UK', 'DE', 'FR', 'ES', 'IT', 'NL', 'BE', 'SE', 'PL', 'AT', 'IN', 'JP', 'AU', 'SG', 'AE', 'SA', 'EG', 'TR', 'ZA'];

var MARKETPLACE_FILTER_COUNTRIES_ALL = ['US', 'CA', 'MX', 'BR', 's', 'UK', 'DE', 'FR', 'ES', 'IT', 'NL', 'BE', 'SE', 'PL', 'AT', 'IN', 'JP', 'AU', 'SG', 'AE', 'SA', 'EG', 'TR', 'ZA'];

var MARKETPLACE_AMAZON_SUFFIX = {
  US: 'com',
  CA: 'ca',
  MX: 'com.mx',
  BR: 'com.br',
  UK: 'co.uk',
  DE: 'de',
  FR: 'fr',
  ES: 'es',
  IT: 'it',
  NL: 'nl',
  BE: 'be',
  SE: 'se',
  PL: 'pl',
  AT: 'at',
  IN: 'in',
  JP: 'co.jp',
  AU: 'com.au',
  SG: 'sg',
  AE: 'ae',
  SA: 'sa',
  EG: 'eg',
  TR: 'com.tr',
  ZA: 'co.za'
};

function getMarketplaceAmazonSuffix(country) {
  if (!country) return '';
  var code = String(country).trim().toUpperCase();
  if (code === 'GB') code = 'UK';
  return MARKETPLACE_AMAZON_SUFFIX[code] || code.toLowerCase();
}

function buildMarketplaceFilterCodes(opts) {
  opts = opts || {};
  var canonicalOrder = opts.canonicalOrder || DEFAULT_MARKETPLACE_FILTER_ORDER;
  var seen = {};
  var merged = [];

  function add(raw) {
    var c = normalizeMarketplaceFilterCode(raw);
    if (!c || seen[c]) return;
    seen[c] = true;
    merged.push(c);
  }

  var af = opts.fromAvailableFilters;
  if (Array.isArray(af)) {
    for (var i = 0; i < af.length; i++) {
      var m = af[i];
      add(typeof m === 'string' ? m : m && (m.code || m.marketplace || m.marketplaceCode));
    }
  }

  if (opts.v1SellersBody) {
    var fromV1 = extractMarketplaceCodesFromV1SellersBody(opts.v1SellersBody);
    for (var v = 0; v < fromV1.length; v++) {
      add(fromV1[v]);
    }
  }

  var sorted = [];
  var canonicalSet = {};
  for (var k = 0; k < canonicalOrder.length; k++) {
    var key = canonicalOrder[k];
    if (key === 's') continue;
    canonicalSet[key] = true;
    if (seen[key]) sorted.push(key);
  }
  for (var j = 0; j < merged.length; j++) {
    if (!canonicalSet[merged[j]] && sorted.indexOf(merged[j]) < 0) sorted.push(merged[j]);
  }
  return sorted;
}

function buildMarketplaceFilterDropdownItems(userCountries, countriesAll) {
  var allowed = Array.isArray(userCountries) ? userCountries : [];
  var all = Array.isArray(countriesAll) && countriesAll.length ? countriesAll : MARKETPLACE_FILTER_COUNTRIES_ALL;

  var allowedSet = {};
  for (var i = 0; i < allowed.length; i++) {
    var code = normalizeMarketplaceFilterCode(allowed[i]);
    if (code) allowedSet[code] = true;
  }

  var out = [];
  var seen = {};
  for (var j = 0; j < all.length; j++) {
    var c = all[j];
    if (c === 's') {
      out.push('s');
      continue;
    }
    var n = normalizeMarketplaceFilterCode(c);
    if (!n || !allowedSet[n] || seen[n]) continue;
    seen[n] = true;
    out.push(n);
  }

  for (var k = 0; k < allowed.length; k++) {
    var extra = normalizeMarketplaceFilterCode(allowed[k]);
    if (!extra || seen[extra]) continue;
    seen[extra] = true;
    out.push(extra);
  }

  while (out.length && out[0] === 's') {
    out.shift();
  }while (out.length && out[out.length - 1] === 's') {
    out.pop();
  }var cleaned = [];
  for (var m = 0; m < out.length; m++) {
    if (out[m] === 's' && (!cleaned.length || cleaned[cleaned.length - 1] === 's')) continue;
    cleaned.push(out[m]);
  }
  return cleaned;
}

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pushGtmEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = markConnectStoreStarted;
/* harmony export (immutable) */ __webpack_exports__["b"] = maybeFireConnectStoreSuccess;
/* harmony export (immutable) */ __webpack_exports__["d"] = fireConnectStoreSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



var CONNECT_STARTED_KEY = 'sk_gtm_connect_store_started';
var CONNECT_SUCCESS_FIRED_KEY = 'sk_gtm_connect_store_success_fired';
var CONNECT_METHOD_KEY = 'sk_gtm_connect_store_method';

function pushGtmEvent(payload, onDone) {
  window.dataLayer = window.dataLayer || [];
  var done = typeof onDone === 'function' ? onDone : null;
  if (!done) {
    window.dataLayer.push(payload);
    return;
  }

  var finished = false;
  var timeoutMs = payload && payload.eventTimeout || 2000;
  function finish() {
    if (finished) return;
    finished = true;
    done();
  }

  var pushPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, payload, {
    eventCallback: finish,
    eventTimeout: timeoutMs
  });
  window.dataLayer.push(pushPayload);

  setTimeout(finish, timeoutMs);
}

function markConnectStoreStarted(method) {
  try {
    sessionStorage.setItem(CONNECT_STARTED_KEY, '1');
    sessionStorage.removeItem(CONNECT_SUCCESS_FIRED_KEY);
    if (method) sessionStorage.setItem(CONNECT_METHOD_KEY, method);else sessionStorage.removeItem(CONNECT_METHOD_KEY);
  } catch (e) {}
}

function maybeFireConnectStoreSuccess() {
  var method = null;
  try {
    if (sessionStorage.getItem(CONNECT_SUCCESS_FIRED_KEY) === '1') return false;
    if (sessionStorage.getItem(CONNECT_STARTED_KEY) !== '1') return false;
    method = sessionStorage.getItem(CONNECT_METHOD_KEY);
    sessionStorage.setItem(CONNECT_SUCCESS_FIRED_KEY, '1');
    sessionStorage.removeItem(CONNECT_STARTED_KEY);
    sessionStorage.removeItem(CONNECT_METHOD_KEY);
  } catch (e) {
    return false;
  }
  var payload = { event: 'connect_store_success', step: 2 };
  if (method) payload.method = method;
  pushGtmEvent(payload);
  return true;
}

function fireConnectStoreSuccess(method, onDone) {
  try {
    if (sessionStorage.getItem(CONNECT_SUCCESS_FIRED_KEY) === '1') {
      if (typeof onDone === 'function') onDone();
      return false;
    }
    sessionStorage.setItem(CONNECT_SUCCESS_FIRED_KEY, '1');
    sessionStorage.removeItem(CONNECT_STARTED_KEY);
    sessionStorage.removeItem(CONNECT_METHOD_KEY);
  } catch (e) {}
  var payload = { event: 'connect_store_success', step: 2 };
  if (method) payload.method = method;
  pushGtmEvent(payload, onDone);
  return true;
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  "data-v-14e48463",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUBSCRIPTION_SUMMARY_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBSCRIPTION_RESUME_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRO_ANNUAL_UI_ENABLED; });
/* unused harmony export TRIAL_LOCKOUT_ENABLED */
/* unused harmony export CANCELED_LOCKOUT_ENABLED */
/* unused harmony export PAST_DUE_LOCKOUT_GRACE_MS */
/* unused harmony export PAST_DUE_LOCKOUT_ENABLED */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeSubscriptionSummary;
/* unused harmony export hasPostTrialPlanSelected */
/* unused harmony export selectedPostTrialPlanKeyFromSummary */
/* unused harmony export highlightedTrialPlanKey */
/* harmony export (immutable) */ __webpack_exports__["m"] = displaySelectedPlanKeyFromContext;
/* unused harmony export trialDaysRemainingFromSummary */
/* harmony export (immutable) */ __webpack_exports__["x"] = isSubscriptionStatusActive;
/* harmony export (immutable) */ __webpack_exports__["o"] = isSubscriptionStatusPastDue;
/* unused harmony export pastDueLockoutEpochFromSummary */
/* unused harmony export millisUntilPastDueLockout */
/* unused harmony export isPastDueGracePeriodElapsed */
/* harmony export (immutable) */ __webpack_exports__["i"] = hasPaymentMethodFromSummary;
/* unused harmony export isSubscriptionStatusCanceled */
/* harmony export (immutable) */ __webpack_exports__["n"] = isSubscriptionCancelScheduledActive;
/* harmony export (immutable) */ __webpack_exports__["f"] = shouldShowCanceledLockout;
/* harmony export (immutable) */ __webpack_exports__["k"] = canceledLockoutCopyFromSummary;
/* harmony export (immutable) */ __webpack_exports__["j"] = pastDueLockoutCopyFromSummary;
/* harmony export (immutable) */ __webpack_exports__["g"] = shouldShowPastDueLockout;
/* unused harmony export scheduledCancelStripContentFromSummary */
/* harmony export (immutable) */ __webpack_exports__["h"] = shouldShowTrialLockout;
/* harmony export (immutable) */ __webpack_exports__["e"] = trialStripContentFromSummary;
/* harmony export (immutable) */ __webpack_exports__["d"] = shouldShowTrialStrip;
/* harmony export (immutable) */ __webpack_exports__["p"] = isTrialActiveFromSummary;
/* harmony export (immutable) */ __webpack_exports__["q"] = isTrialExpiredFromSummary;
/* unused harmony export isPaidActiveFromSummary */
/* harmony export (immutable) */ __webpack_exports__["s"] = planNameFromSummary;
/* unused harmony export planKeyFromSummary */
/* harmony export (immutable) */ __webpack_exports__["r"] = isFlatYearlyPlanFromSummary;
/* unused harmony export isProAnnualPlanFromSummary */
/* harmony export (immutable) */ __webpack_exports__["v"] = currentPlanKeyFromSummary;
/* harmony export (immutable) */ __webpack_exports__["l"] = isProPlanFromSummary;
/* unused harmony export isStarterPlanFromSummary */
/* unused harmony export isStarterOrProBillingTenant */
/* harmony export (immutable) */ __webpack_exports__["u"] = subscriptionEndEpochFromSummary;
/* harmony export (immutable) */ __webpack_exports__["t"] = formatSubscriptionEndDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__ = __webpack_require__(61);





var SUBSCRIPTION_SUMMARY_URL = '/api/billing/subscription/summary';
var SUBSCRIPTION_RESUME_URL = '/api/billing/subscription/resume';

var PRO_ANNUAL_UI_ENABLED = false;

var TRIAL_LOCKOUT_ENABLED = false;

var CANCELED_LOCKOUT_ENABLED = true;

var PAST_DUE_LOCKOUT_GRACE_MS = 2 * 24 * 60 * 60 * 1000;

var PAST_DUE_LOCKOUT_ENABLED = true;

function truthyFlag(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

function normalizeSubscriptionSummary(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  var statusRaw = body.status != null ? body.status : '';
  return {
    planName: body.planName != null ? body.planName : body.plan_name || '',
    subscriptionEndDate: body.subscriptionEndDate != null ? body.subscriptionEndDate : body.subscription_end_date || '',
    subscriptionEndDateEpoch: body.subscriptionEndDateEpoch != null ? body.subscriptionEndDateEpoch : body.subscription_end_date_epoch,
    paymentInfoAdded: truthyFlag(body.paymentInfoAdded != null ? body.paymentInfoAdded : body.payment_info_added),
    status: String(statusRaw).toLowerCase(),
    trialExpired: truthyFlag(body.trialExpired != null ? body.trialExpired : body.trial_expired),
    trialActive: truthyFlag(body.trialActive != null ? body.trialActive : body.trial_active),
    cancelAtPeriodEnd: truthyFlag(body.cancelAtPeriodEnd != null ? body.cancelAtPeriodEnd : body.cancel_at_period_end),
    selectedPostTrialPlan: body.selectedPostTrialPlan != null ? body.selectedPostTrialPlan : body.selected_post_trial_plan || null,
    planKey: body.planKey != null ? body.planKey : body.plan_key || '',
    planLabel: body.planLabel != null ? body.planLabel : body.plan_label || '',
    modernPlan: truthyFlag(body.modernPlan != null ? body.modernPlan : body.modern_plan),
    billingInterval: body.billingInterval != null ? body.billingInterval : body.billing_interval || null,
    planFeeCents: optionalNumber(body.planFeeCents != null ? body.planFeeCents : body.plan_fee_cents),

    proAnnualPriceCents: optionalNumber(body.proAnnualPriceCents != null ? body.proAnnualPriceCents : body.pro_annual_price_cents)
  };
}

function optionalNumber(value) {
  if (value == null || value === '' || isNaN(Number(value))) return null;
  return Number(value);
}

function hasPostTrialPlanSelected(summary) {
  return selectedPostTrialPlanKeyFromSummary(summary) != null;
}

function selectedPostTrialPlanKeyFromSummary(summary) {
  if (!summary) return null;
  var raw = summary.selectedPostTrialPlan;
  if (raw == null || raw === '') return null;
  var s = String(raw).toLowerCase().trim();
  if (s === 'starter' || s === 'pro' || s === 'pro_annual') return s;
  if (s.indexOf('annual') >= 0) return 'pro_annual';
  if (s.indexOf('pro') >= 0) return 'pro';
  if (s.indexOf('starter') >= 0) return 'starter';
  return null;
}

function highlightedTrialPlanKey(summary, volumeRecommendedKey) {
  var selected = selectedPostTrialPlanKeyFromSummary(summary);
  if (selected) return selected;
  return volumeRecommendedKey || null;
}

function displaySelectedPlanKeyFromContext(summary, isProPlan) {
  var picked = selectedPostTrialPlanKeyFromSummary(summary);
  if (picked) return picked;
  if (isProPlan) return 'pro';
  if (summary && planNameFromSummary(summary)) return 'starter';
  return null;
}

function trialDaysRemainingFromSummary(summary) {
  if (!summary) return null;
  var epoch = subscriptionEndEpochFromSummary(summary);
  if (epoch == null) return null;
  var endMs = epoch * 1000;
  var diff = endMs - Date.now();
  return Math.max(0, Math.ceil(diff / (24 * 60 * 60 * 1000)));
}

function isSubscriptionStatusActive(summary) {
  if (!summary || !summary.status) return false;
  return String(summary.status).toLowerCase() === 'active';
}

function isSubscriptionStatusPastDue(summary) {
  if (!summary || !summary.status) return false;
  return String(summary.status).toLowerCase() === 'past_due';
}

function pastDueLockoutEpochFromSummary(summary, graceMs) {
  if (!isSubscriptionStatusPastDue(summary)) return null;
  var endEpoch = subscriptionEndEpochFromSummary(summary);
  if (endEpoch == null) return null;
  var graceSec = Math.floor((graceMs != null ? graceMs : PAST_DUE_LOCKOUT_GRACE_MS) / 1000);
  return endEpoch + graceSec;
}

function millisUntilPastDueLockout(summary, graceMs) {
  var lockoutEpoch = pastDueLockoutEpochFromSummary(summary, graceMs);
  if (lockoutEpoch == null) return null;
  return Math.max(0, lockoutEpoch * 1000 - Date.now());
}

function isPastDueGracePeriodElapsed(summary, graceMs) {
  if (!isSubscriptionStatusPastDue(summary)) return false;
  var lockoutEpoch = pastDueLockoutEpochFromSummary(summary, graceMs);
  if (lockoutEpoch == null) return false;
  return Date.now() >= lockoutEpoch * 1000;
}

function hasPaymentMethodFromSummary(summary) {
  return !!(summary && summary.paymentInfoAdded);
}

function isSubscriptionStatusCanceled(summary) {
  if (!summary || !summary.status) return false;
  var s = String(summary.status).toLowerCase();
  return s === 'canceled' || s === 'cancelled';
}

function isSubscriptionCancelScheduledActive(summary) {
  if (!summary || !summary.cancelAtPeriodEnd) return false;
  if (isSubscriptionStatusCanceled(summary)) return false;
  return isSubscriptionStatusActive(summary) || isSubscriptionStatusPastDue(summary);
}

function shouldShowCanceledLockout(summary, paymentStatus) {
  if (!CANCELED_LOCKOUT_ENABLED) return false;
  if (isSubscriptionCancelScheduledActive(summary)) return false;
  if (summary && isSubscriptionStatusActive(summary) && !isSubscriptionStatusCanceled(summary)) {
    return false;
  }
  if (paymentStatus === 403) {
    if (!summary) return true;
    return isSubscriptionStatusCanceled(summary);
  }
  if (!isStarterOrProBillingTenant(summary)) return false;
  if (!summary) return false;
  if (isSubscriptionStatusPastDue(summary)) return false;
  return isSubscriptionStatusCanceled(summary);
}

function canceledLockoutCopyFromSummary(summary) {
  var endLabel = formatSubscriptionEndDate(summary);
  var when = endLabel !== '—' ? ' Your access ended on <strong>' + endLabel + '</strong>.' : '';
  return {
    title: 'Your subscription has ended',
    messageHtml: 'You cancelled your SentryKit subscription.' + when + ' Dashboard access, real-time alerts, and Buy Box monitoring are paused. Your data stays in your account — contact support if you need help.'
  };
}

function pastDueLockoutCopyFromSummary(summary) {
  return {
    title: 'Payment required',
    messageHtml: '<strong>Your payment failed more than 2 days ago.</strong> Dashboard access and alerts are paused until you update your payment method. Your plan and data are unchanged.'
  };
}

function shouldShowPastDueLockout(summary, billingOpts) {
  if (!PAST_DUE_LOCKOUT_ENABLED) return false;
  if (!summary || !isSubscriptionStatusPastDue(summary)) return false;
  if (shouldShowCanceledLockout(summary, null)) return false;
  billingOpts = billingOpts || {};
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__["a" /* isLegacyBillingUserType */])(billingOpts)) return false;
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__["b" /* isNewBillingScreenVariant */])(billingOpts)) return false;
  if (!isStarterOrProBillingTenant(summary)) return false;
  return isPastDueGracePeriodElapsed(summary);
}

function scheduledCancelStripContentFromSummary(summary) {
  if (!isSubscriptionCancelScheduledActive(summary)) return null;
  var endLabel = formatSubscriptionEndDate(summary);
  return {
    tone: 'amber',
    messageHtml: '<strong>Subscription ends ' + endLabel + '.</strong> You still have full access until then. Resume your subscription anytime to keep alerts running.',
    ctaLabel: 'Resume subscription →',
    ctaHash: '',
    ctaAction: 'resume',
    dismissible: true
  };
}

function shouldShowTrialLockout(summary, billingOpts) {
  if (!TRIAL_LOCKOUT_ENABLED) return false;
  if (shouldShowCanceledLockout(summary, null)) return false;
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__["b" /* isNewBillingScreenVariant */])(billingOpts || {})) return false;
  if (!summary) return false;
  if (isSubscriptionStatusActive(summary)) return false;
  if (isSubscriptionStatusPastDue(summary)) return false;
  return isTrialExpiredFromSummary(summary);
}

function trialStripContentFromSummary(summary, billingOpts) {
  billingOpts = billingOpts || {};
  var scheduledCancel = scheduledCancelStripContentFromSummary(summary);
  if (scheduledCancel) return scheduledCancel;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__["a" /* isLegacyBillingUserType */])(billingOpts)) return null;
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__billingScreenVariant_js__["b" /* isNewBillingScreenVariant */])(billingOpts)) return null;
  if (!summary) return null;
  if (isSubscriptionStatusActive(summary)) return null;

  if (isSubscriptionStatusPastDue(summary)) {
    if (shouldShowPastDueLockout(summary, billingOpts)) return null;
    var daysLeft = 2;
    var untilLockout = millisUntilPastDueLockout(summary);
    if (untilLockout != null && untilLockout > 0) {
      daysLeft = Math.max(1, Math.ceil(untilLockout / (24 * 60 * 60 * 1000)));
    }
    return {
      tone: 'past-due',
      messageHtml: '<strong>Payment failed.</strong> Update your payment method within ' + daysLeft + ' day' + (daysLeft === 1 ? '' : 's') + ' to avoid losing dashboard access.',
      ctaLabel: 'Update payment method →',
      ctaHash: '#payment-method',
      dismissible: false
    };
  }

  var endLabel = formatSubscriptionEndDate(summary);
  var days = trialDaysRemainingFromSummary(summary);

  if (isTrialExpiredFromSummary(summary)) {
    return {
      tone: 'expired',
      messageHtml: '<strong>Your trial has ended.</strong> Pick a plan to resume service — your data is safe.',
      ctaLabel: 'Pick a plan now →',
      ctaHash: '',
      dismissible: false
    };
  }

  if (!isTrialActiveFromSummary(summary)) return null;

  if (summary.paymentInfoAdded && hasPostTrialPlanSelected(summary)) return null;
  if (days != null && days > 7) return null;

  if (days === 0) {
    return {
      tone: 'red',
      messageHtml: '<strong>Your trial ends today.</strong> Complete setup now or your alerts and dashboard access will pause at midnight.',
      ctaLabel: 'Complete setup →',
      ctaHash: '',
      dismissible: true
    };
  }

  if (days != null && days >= 1 && days <= 3) {
    if (!summary.paymentInfoAdded) {
      return {
        tone: 'orange',
        messageHtml: '<strong>' + days + (days === 1 ? ' day' : ' days') + ' left.</strong> Add a payment method to keep your access after ' + endLabel + ' — no charge until then.',
        ctaLabel: 'Add payment method →',
        ctaHash: '#payment-method',
        dismissible: true
      };
    }
    return {
      tone: 'orange',
      messageHtml: '<strong>' + days + (days === 1 ? ' day' : ' days') + ' left.</strong> Pick a plan to keep your access after ' + endLabel + '.',
      ctaLabel: 'Pick your plan →',
      ctaHash: '',
      dismissible: true
    };
  }

  if (days != null && days >= 4 && days <= 7) {
    return {
      tone: 'amber',
      messageHtml: '<strong>' + days + ' days left in your trial.</strong> Pick a plan to keep your alerts running after ' + endLabel + '.',
      ctaLabel: 'Pick your plan →',
      ctaHash: '',
      dismissible: true
    };
  }

  return null;
}

function shouldShowTrialStrip(summary, dismissed, billingOpts) {
  billingOpts = billingOpts || {};
  if (shouldShowPastDueLockout(summary, billingOpts)) return false;
  var content = trialStripContentFromSummary(summary, billingOpts);
  if (!content) return false;
  if (dismissed && content.dismissible) return false;
  return true;
}

function isTrialActiveFromSummary(summary) {
  if (!summary) return false;
  if (isSubscriptionStatusActive(summary)) return false;
  if (isSubscriptionStatusPastDue(summary)) return false;
  if (summary.trialExpired) return false;
  return summary.trialActive === true;
}

function isTrialExpiredFromSummary(summary) {
  if (!summary) return false;
  if (isSubscriptionStatusActive(summary)) return false;
  if (isSubscriptionStatusPastDue(summary)) return false;
  return summary.trialExpired === true;
}

function isPaidActiveFromSummary(summary) {
  if (!summary) return false;
  if (isTrialActiveFromSummary(summary)) return false;
  if (isTrialExpiredFromSummary(summary)) return false;
  return summary.status === 'active';
}

function planNameFromSummary(summary) {
  if (!summary || !summary.planName) return '';
  return String(summary.planName).trim();
}

function planKeyFromSummary(summary) {
  if (!summary) return '';
  var raw = summary.planKey != null ? summary.planKey : summary.plan_key;
  return String(raw == null ? '' : raw).trim().toUpperCase();
}

function isFlatYearlyPlanFromSummary(summary) {
  if (!summary) return false;
  if (planKeyFromSummary(summary) === 'FLAT_YEARLY') return true;
  if (summary.tier === 'flat_yearly' || summary.planTier === 'flat_yearly') return true;
  return planNameFromSummary(summary).toLowerCase().indexOf('flat yearly') >= 0;
}

function isProAnnualPlanFromSummary(summary) {
  if (!summary) return false;
  if (planKeyFromSummary(summary) === 'PRO_ANNUAL') return true;
  return planNameFromSummary(summary).toLowerCase().indexOf('pro annual') >= 0;
}

function currentPlanKeyFromSummary(summary) {
  if (!summary) return null;
  if (isFlatYearlyPlanFromSummary(summary)) return null;
  if (isProAnnualPlanFromSummary(summary)) return 'pro_annual';
  if (isProPlanFromSummary(summary)) return 'pro';
  if (planKeyFromSummary(summary) === 'STARTER' || isStarterPlanFromSummary(summary)) return 'starter';
  return null;
}

function isProPlanFromSummary(summary) {
  if (isFlatYearlyPlanFromSummary(summary)) return false;
  var key = planKeyFromSummary(summary);
  if (key === 'PRO' || key === 'PRO_ANNUAL') return true;
  var name = planNameFromSummary(summary).toLowerCase();
  if (!name) return false;
  return name.indexOf('pro') >= 0;
}

function isStarterPlanFromSummary(summary) {
  var name = planNameFromSummary(summary).toLowerCase();
  if (!name) return false;
  return name.indexOf('starter') >= 0;
}

function isStarterOrProBillingTenant(summary) {
  if (!summary) return false;
  var plan = planNameFromSummary(summary).toLowerCase();

  var key = planKeyFromSummary(summary);
  if (key === 'STARTER' || key === 'PRO' || key === 'PRO_ANNUAL' || key === 'FLAT_YEARLY') return true;
  if (summary.modernPlan === true) return true;
  if (plan) {
    if (plan.indexOf('legacy') >= 0 || plan.indexOf('daily') >= 0 || plan.indexOf('meter') >= 0) {
      return false;
    }
    if (plan.indexOf('flat yearly') >= 0 || plan.indexOf('starter') >= 0 || plan.indexOf('pro') >= 0) return true;

    return false;
  }

  var status = String(summary.status || '').toLowerCase();
  if (status === 'trialing' || summary.trialActive || summary.trialExpired) return true;
  return false;
}

function subscriptionEndEpochFromSummary(summary) {
  if (!summary) return null;
  var epoch = summary.subscriptionEndDateEpoch;
  if (epoch != null && epoch !== '' && !isNaN(Number(epoch))) return Number(epoch);
  var iso = summary.subscriptionEndDate;
  if (!iso) return null;
  var ms = Date.parse(String(iso));
  if (isNaN(ms)) return null;
  return Math.floor(ms / 1000);
}

function formatSubscriptionEndDate(summary, formatter) {
  if (!summary) return '—';
  var iso = summary.subscriptionEndDate;
  if (iso) {
    var d = new Date(String(iso));
    if (!isNaN(d.getTime())) {
      if (typeof formatter === 'function') return formatter(d);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
  }
  var epoch = subscriptionEndEpochFromSummary(summary);
  if (epoch != null) {
    var d2 = new Date(epoch * 1000);
    if (!isNaN(d2.getTime())) {
      if (typeof formatter === 'function') return formatter(d2);
      return d2.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
  }
  return '—';
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSafeAppInternalPath */
/* unused harmony export encodeBackQuery */
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeBackQuery;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildProductDetailsQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = backLinkLabelForPath;


var ALLOWED_PATHS = ['/products', '/issues', '/alerts', '/stock', '/home', '/all-alerts', '/old-dashboard'];

function isSafeAppInternalPath(fullPath) {
  if (!fullPath || typeof fullPath !== 'string' || fullPath.charAt(0) !== '/') return false;
  if (fullPath.indexOf('/../') >= 0 || fullPath.indexOf('/./') >= 0) return false;
  var q = fullPath.indexOf('?');
  var hash = fullPath.indexOf('#');
  var end = q >= 0 ? q : hash >= 0 ? hash : fullPath.length;
  var path = fullPath.slice(0, end);
  if (!path || path.indexOf('//') === 0) return false;
  for (var i = 0; i < ALLOWED_PATHS.length; i++) {
    if (path === ALLOWED_PATHS[i]) return true;
  }
  return false;
}

function encodeBackQuery(fullPath) {
  if (!isSafeAppInternalPath(fullPath)) return null;
  try {
    return encodeURIComponent(fullPath);
  } catch (e) {
    return null;
  }
}

function decodeBackQuery(encoded) {
  if (encoded == null || encoded === '') return null;
  try {
    var decoded = decodeURIComponent(typeof encoded === 'string' ? encoded : String(encoded));
    if (!isSafeAppInternalPath(decoded)) return null;
    return decoded;
  } catch (e) {
    return null;
  }
}

function buildProductDetailsQuery(id, currentFullPath) {
  var q = { id: String(id).replace(/^PROD-/i, '') };
  var enc = encodeBackQuery(currentFullPath);
  if (enc) q.back = enc;
  return q;
}

function backLinkLabelForPath(fullPath) {
  if (!fullPath) return 'Back';
  var path = fullPath.split('?')[0];
  if (path === '/products') return 'Back to Products';
  if (path === '/issues' || path === '/alerts') return 'Back to Alerts';
  if (path === '/stock') return 'Back to Stock';
  if (path === '/home' || path === '/old-dashboard') return 'Back to Dashboard';
  if (path === '/all-alerts') return 'Back to All Alerts';
  return 'Back';
}

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_MARKETPLACES_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AMAZON_CONNECT_MARKETPLACES_BY_REGION; });
/* unused harmony export defaultMarketplaceIdForRegion */
/* harmony export (immutable) */ __webpack_exports__["a"] = amazonAuthorizationQueryMarketplace;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAllMarketplacesSelection;
/* harmony export (immutable) */ __webpack_exports__["g"] = regionMarketplaceCodes;
/* harmony export (immutable) */ __webpack_exports__["e"] = regionAllMarketplacesLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = findConnectMarketplaceOption;

var DEFAULT_MARKETPLACE_ID_BY_REGION = {
  NA: 'ATVPDKIKX0DER',
  EU: 'A1F83G8C2ARO7P',
  IN: 'A21TJRUUN4KGV',
  ME: 'A2VIGQ35RCS4UG',
  FE: 'A1VC38T7YXB528'
};

var ALL_MARKETPLACES_SELECTION = 'ALL';

var AMAZON_CONNECT_MARKETPLACES_BY_REGION = {
  NA: [{ label: 'United States', code: 'US', marketplaceId: 'ATVPDKIKX0DER' }, { label: 'Canada', code: 'CA', marketplaceId: 'A2EUQ1WTGCTBG2' }, { label: 'Mexico', code: 'MX', marketplaceId: 'A1AM78C64UM0Y8' }, { label: 'Brazil', code: 'BR', marketplaceId: 'A2Q3Y263D00KWC' }],
  EU: [{ label: 'United Kingdom', code: 'UK', marketplaceId: 'A1F83G8C2ARO7P' }, { label: 'Germany', code: 'DE', marketplaceId: 'A1PA6795UKMFR9' }, { label: 'France', code: 'FR', marketplaceId: 'A13V1IB3VIYZZH' }, { label: 'Spain', code: 'ES', marketplaceId: 'A1RKKUPIHCS9HS' }, { label: 'Italy', code: 'IT', marketplaceId: 'APJ6JRA9NG5V4' }, { label: 'Netherlands', code: 'NL', marketplaceId: 'A1805IZSGTT6HS' }, { label: 'Belgium', code: 'BE', marketplaceId: 'AMEN7PMS3EDWL' }, { label: 'Sweden', code: 'SE', marketplaceId: 'A2NODRKZP88ZB9' }, { label: 'Poland', code: 'PL', marketplaceId: 'A1C3SOZRARQ6R3' }, { label: 'South Africa', code: 'ZA', marketplaceId: 'AE08WJ6YKNBMC' }],
  ME: [{ label: 'United Arab Emirates', code: 'AE', marketplaceId: 'A2VIGQ35RCS4UG' }, { label: 'Saudi Arabia', code: 'SA', marketplaceId: 'A17E79C6D8DWNP' }, { label: 'Egypt', code: 'EG', marketplaceId: 'ARBP9OOSHTCHU' }, { label: 'Turkey', code: 'TR', marketplaceId: 'A33AVAJ2PDY3EV' }],
  IN: [{ label: 'India', code: 'IN', marketplaceId: 'A21TJRUUN4KGV' }],
  FE: [{ label: 'Japan', code: 'JP', marketplaceId: 'A1VC38T7YXB528' }, { label: 'Australia', code: 'AU', marketplaceId: 'A39IBJ37TRP1C6' }, { label: 'Singapore', code: 'SG', marketplaceId: 'A19VAU5U5O7RUS' }]
};

function defaultMarketplaceIdForRegion(region) {
  if (region == null || region === '') return DEFAULT_MARKETPLACE_ID_BY_REGION.NA;
  var key = String(region).toUpperCase();
  return DEFAULT_MARKETPLACE_ID_BY_REGION[key] || DEFAULT_MARKETPLACE_ID_BY_REGION.NA;
}

function amazonAuthorizationQueryMarketplace(region, marketplaceOverride) {
  if (marketplaceOverride != null && String(marketplaceOverride).trim() !== '') {
    return String(marketplaceOverride).trim();
  }
  return defaultMarketplaceIdForRegion(region);
}

function isAllMarketplacesSelection(marketplaceId) {
  return marketplaceId === ALL_MARKETPLACES_SELECTION;
}

function regionMarketplaceCodes(region) {
  var key = region == null ? '' : String(region).toUpperCase();
  var list = AMAZON_CONNECT_MARKETPLACES_BY_REGION[key];
  if (!list) return [];
  return list.map(function (o) {
    return o.code;
  });
}

function regionAllMarketplacesLabel(region) {
  var codes = regionMarketplaceCodes(region);
  if (!codes.length) return 'All marketplaces';
  return 'All marketplaces (' + codes.join(', ') + ')';
}

function findConnectMarketplaceOption(region, marketplaceId) {
  if (!region || !marketplaceId || isAllMarketplacesSelection(marketplaceId)) return null;
  var key = String(region).toUpperCase();
  var list = AMAZON_CONNECT_MARKETPLACES_BY_REGION[key];
  if (!list) return null;
  var id = String(marketplaceId).trim();
  for (var i = 0; i < list.length; i++) {
    if (list[i].marketplaceId === id) return list[i];
  }
  return null;
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = watchdogTypeToApiParam;
/* harmony export (immutable) */ __webpack_exports__["d"] = watchdogTypeFromApi;
/* harmony export (immutable) */ __webpack_exports__["g"] = parseSummaryJsonPayload;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseAlertCountsHttpPayload;
/* unused harmony export issuesUiDateRangeToApiTimeRange */
/* harmony export (immutable) */ __webpack_exports__["e"] = buildSummaryRequestParams;
/* unused harmony export normalizeSummaryWatchdogRow */
/* harmony export (immutable) */ __webpack_exports__["h"] = summaryItemsToLegacyMaps;
/* harmony export (immutable) */ __webpack_exports__["b"] = parsePeriodChangesBody;
/* harmony export (immutable) */ __webpack_exports__["c"] = periodChangesCategoryBarWidth;
/* harmony export (immutable) */ __webpack_exports__["i"] = parseAlertCountsBody;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);




function watchdogTypeToApiParam(frontendKey) {
  if (!frontendKey) return 'lost_buybox';
  return String(frontendKey).replace(/([A-Z])/g, '_$1').replace(/^_/, '').toLowerCase();
}

var WATCHDOG_TYPE_API_TO_FRONTEND = {
  buybox: 'lostBuybox',
  lost_buybox: 'lostBuybox',
  number_of_sellers: 'numberOfSellers',
  listing_suspended: 'listingSuspended',
  no_add_to_cart: 'noAddToCart',
  sales_drop: 'salesDrop',
  keyword: 'keyword',
  bad_review: 'badReview',
  top_review: 'topReview',
  image_missing: 'imageMissing',
  star_rating_recent_change: 'starRatingRecentChange',
  product_details_recent_change: 'productDetailsRecentChange',
  product_category_recent_change: 'productCategoryRecentChange',
  best_seller_badge: 'bestSellerBadge',
  bad_seller_feedback: 'badSellerFeedback',
  price: 'price',
  search_ban: 'searchBan',
  inventory: 'inventory',
  fbm_inventory: 'fbmInventory',
  daily_fixed_limits: 'dailyFixedLimits',
  daily_limits_rolling_avg: 'dailyLimitsRollingAvg',

  hours_without_sales: 'salesDrop',
  bsr_limits: 'bsrLimits',
  review_count_drop: 'reviewCountDrop',
  fba_fee_change: 'fbaFeeChange',
  competitor_price: 'competitorPrice',
  competitive_price: 'competitivePrice',
  review_health: 'reviewHealth',
  prime: 'prime',
  amazon_choice_badge: 'amazonChoiceBadge',
  subscribe_and_save: 'subscribeAndSave',
  parent_product_change: 'parentProductChange',
  adult_classification: 'adultClassification'
};

function watchdogTypeFromApi(apiKey) {
  if (apiKey == null || apiKey === '') return 'lostBuybox';
  var s = String(apiKey).trim();
  var direct = WATCHDOG_TYPE_API_TO_FRONTEND[s];
  if (direct) return direct;
  var lower = s.toLowerCase();
  var byLower = WATCHDOG_TYPE_API_TO_FRONTEND[lower];
  if (byLower) return byLower;
  return s.replace(/_([a-z])/g, function (_, c) {
    return c.toUpperCase();
  });
}

function parseSummaryJsonPayload(response) {
  if (!response || (typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response)) !== 'object') return {};
  var raw = response.body;
  if (raw === undefined || raw === null || raw === '') raw = response.data;
  if (raw === undefined || raw === null || raw === '') raw = response.jsonBody;
  if (typeof raw === 'string') {
    var s = raw.trim();
    if (!s) return {};
    try {
      raw = JSON.parse(s);
    } catch (e) {
      return {};
    }
  }
  return (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw !== null ? raw : {};
}

function parseAlertCountsHttpPayload(response) {
  return parseSummaryJsonPayload(response);
}

function issuesUiDateRangeToApiTimeRange(uiRange) {
  var r = uiRange == null ? '' : String(uiRange).trim().toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
  if (r === 'all' || r === 'all_time' || r === 'alltime' || r === '') return 'all_time';
  if (r === 'today') return 'today';
  if (r === '7d' || r === 'last_7_days' || r === 'last7days') return 'last_7_days';
  if (r === '30d' || r === 'last_30_days' || r === '30_days') return 'last_30_days';
  if (r === '90d' || r === 'last_90_days' || r === '90_days') return 'last_90_days';
  if (r === 'custom') return 'custom';
  return 'all_time';
}

function buildSummaryRequestParams(filterByMarket, filterBySellAcc, uiDateRange, customRange) {
  var params = {};
  if (filterByMarket && filterByMarket.length > 0) {
    params.marketplaces = filterByMarket.map(function (m) {
      return String(m).toUpperCase();
    }).join(',');
  }
  if (filterBySellAcc && filterBySellAcc.length > 0) {
    params.seller_ids = filterBySellAcc.map(function (id) {
      var n = Number(id);
      return isNaN(n) ? String(id) : n;
    }).join(',');
  }
  var timeRange = issuesUiDateRangeToApiTimeRange(uiDateRange);
  if (timeRange === 'custom') {
    if (customRange && customRange.start && customRange.end) {
      params.start_date = customRange.start;
      params.end_date = customRange.end;
    } else {
      timeRange = 'all_time';
    }
  }
  params.time_range = timeRange;
  return params;
}

function mapIssueStatusToNumber(raw) {
  if (raw === undefined || raw === null) return 0;
  if (typeof raw === 'number' && !isNaN(raw)) return raw;
  var s = String(raw).toLowerCase();
  if (s === 'seen') return 1;
  if (s === 'resolved') return 3;
  return 0;
}

function mapApiStatusToNumeric(status) {
  if (status === undefined || status === null) return 0;
  if (typeof status === 'number') return status;
  var s = String(status).toLowerCase();
  if (s === 'red') return 2;
  if (s === 'yellow' || s === 'amber') return 1;
  if (s === 'green') return 99;
  return 0;
}

function syntheticLostBuyboxMessage(details) {
  if (!details || (typeof details === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(details)) !== 'object') return '';
  if (details.lost_to_amazon) return 'Lost to Amazon';
  if (details.lost_to_whitelisted_seller) return 'Lost to whitelisted seller';
  if (details.lost_to_another_seller) return 'Lost to another seller';
  if (details.has_own_offer) return 'Buy Box rotating';
  return '';
}

function isLikelyHttpImageUrl(u) {
  if (u == null || u === '') return false;
  return (/^https?:\/\//i.test(String(u).trim())
  );
}

function normalizeProductForStore(product, frontendWdType) {
  if (!product || (typeof product === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(product)) !== 'object') return null;

  var rawId = product.id != null ? product.id : product.productId;
  var id = rawId != null ? String(rawId) : null;
  if (!id) return null;
  var rawTitle = product.name || product.productTitle || '';
  var asinStr = product.asin ? String(product.asin).trim() : '';
  var title = rawTitle ? String(rawTitle).trim() : '';
  if (!title && asinStr) title = asinStr;
  var imgPick = product.large_image_url || product.largeImageUrl || product.image_url || product.imageUrl || null;
  var img = imgPick != null && isLikelyHttpImageUrl(imgPick) ? String(imgPick).trim() : null;
  var sellerFromProduct = product.seller_id != null ? product.seller_id : product.sellerId;
  var row = {
    productId: id,
    productTitle: title,
    largeImageUrl: img,
    imageUrl: img,
    asin: product.asin || '',
    marketplace: product.marketplace || '',
    seller_key: product.seller_key,
    seller_id: sellerFromProduct,
    productUrl: product.productUrl || product.product_url || ''
  };
  if (frontendWdType === 'badReview' && product.productReviewsUrl) row.productReviewsUrl = product.productReviewsUrl;
  if (frontendWdType === 'topReview' && product.productTopReviewsUrl) row.productTopReviewsUrl = product.productTopReviewsUrl;
  return row;
}

function normalizeSummaryWatchdogRow(row, frontendWdType, fromResolvedList) {
  if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(row)) !== 'object') return { item: null, productEntry: null };

  var wid = row.watchdog_id != null ? row.watchdog_id : row.watchDogId;
  var key = wid != null ? String(wid) : null;

  var statusDetails = row.statusDetails;
  if (statusDetails == null && row.status_details != null) statusDetails = row.status_details;
  if (!statusDetails || (typeof statusDetails === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(statusDetails)) !== 'object') statusDetails = {};

  var productRaw = row.product;
  var productEntry = normalizeProductForStore(productRaw, frontendWdType);
  var productIdFromRow = row.productId != null ? String(row.productId) : row.product_id != null ? String(row.product_id) : null;
  var productId = productEntry ? productEntry.productId : productIdFromRow;

  var numericStatus = mapApiStatusToNumeric(row.status);
  var msg = typeof statusDetails.message === 'string' ? statusDetails.message : '';
  if (!msg && frontendWdType === 'lostBuybox') {
    msg = syntheticLostBuyboxMessage(statusDetails);
  }

  var statusDetailsOut = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, statusDetails);
  if (msg && !statusDetailsOut.message) statusDetailsOut.message = msg;

  var item = {
    watchDogItemId: key || 'wd_' + Math.random().toString(36).slice(2),
    watchDogId: wid,
    productId: productId,
    status: numericStatus,
    issueStatus: fromResolvedList ? 3 : mapIssueStatusToNumber(row.issue_status != null ? row.issue_status : row.issueStatus),
    muted: !!row.muted,
    date: row.status_change_timestamp || row.date || row.updated_at || null,
    marketplace: row.marketplace || productRaw && productRaw.marketplace || null,
    sellerId: row.seller_id != null ? row.seller_id : row.sellerId,
    statusDetails: statusDetailsOut,
    title: productEntry ? productEntry.productTitle : '',
    asin: productRaw && productRaw.asin ? String(productRaw.asin) : ''
  };

  if ((!item.title || !String(item.title).trim()) && productIdFromRow && item.asin) {
    item.title = String(item.asin).trim();
  }

  var origKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row);
  for (var k = 0; k < origKeys.length; k++) {
    var ok = origKeys[k];
    if (item[ok] === undefined) item[ok] = row[ok];
  }

  return { item: item, productEntry: productEntry ? { id: productEntry.productId, row: productEntry } : null };
}

function summaryItemsToLegacyMaps(body, frontendWdType) {
  var itemsObj = {};
  var productsPatch = {};

  function ingestArray(arr, fromResolvedList) {
    if (!Array.isArray(arr)) return;
    for (var i = 0; i < arr.length; i++) {
      var pair = normalizeSummaryWatchdogRow(arr[i], frontendWdType, fromResolvedList);
      if (!pair.item) continue;
      var kid = pair.item.watchDogItemId;
      itemsObj[kid] = pair.item;
      if (pair.productEntry) productsPatch[pair.productEntry.id] = pair.productEntry.row;
    }
  }

  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(body)) !== 'object') {
    return { items: itemsObj, productsPatch: productsPatch, summaryTotals: null };
  }

  var active = body.active || {};
  ingestArray(active.red, false);
  ingestArray(active.yellow, false);
  ingestArray(body.resolved, true);

  var summaryTotals = null;
  var meta = body.meta;
  if (meta && meta.totals && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(meta.totals) === 'object') {
    var t = meta.totals;
    summaryTotals = {
      activeRed: Number(t.active_red) || 0,
      activeYellow: Number(t.active_yellow) || 0,
      resolved: Number(t.resolved) || 0
    };
  }

  return { items: itemsObj, productsPatch: productsPatch, summaryTotals: summaryTotals };
}

function parsePeriodChangesBody(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(body)) !== 'object') {
    return {
      periodStart: null,
      periodEnd: null,
      connectedStorefrontsCount: null,
      activeListedAsinsCount: null,
      watchdogChangesCount: null,
      checksRunCount: null,
      marketplacesCoveredCount: null,
      categories: [],
      total: null,
      filters: null
    };
  }
  var categories = body.categories;
  if (!Array.isArray(categories)) categories = [];
  return {
    periodStart: body.period_start != null ? body.period_start : body.periodStart,
    periodEnd: body.period_end != null ? body.period_end : body.periodEnd,
    connectedStorefrontsCount: body.connected_storefronts_count != null ? body.connected_storefronts_count : body.connectedStorefrontsCount,
    activeListedAsinsCount: body.active_listed_asins_count != null ? body.active_listed_asins_count : body.activeListedAsinsCount,
    watchdogChangesCount: body.watchdog_changes_count != null ? body.watchdog_changes_count : body.watchdogChangesCount,
    checksRunCount: body.checks_run_count != null ? body.checks_run_count : body.checksRunCount,
    listingsWatchedCount: body.listings_watched_count != null ? body.listings_watched_count : body.listingsWatchedCount,
    marketplacesCoveredCount: body.marketplaces_covered_count != null ? body.marketplaces_covered_count : body.marketplacesCoveredCount,
    categories: categories.map(function (row) {
      if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(row)) !== 'object') return { key: '', label: '', count: 0 };
      return {
        key: row.key != null ? String(row.key) : '',
        label: row.label != null ? String(row.label) : '',
        count: Number(row.count) || 0
      };
    }),
    estimatedImpactProtectedCents: body.estimated_impact_protected_cents != null ? body.estimated_impact_protected_cents : body.estimatedImpactProtectedCents,
    total: body.total != null ? body.total : null,
    filters: body.filters || null
  };
}

function periodChangesCategoryBarWidth(count, maxCount) {
  var n = Number(count);
  var max = Number(maxCount);
  if (isNaN(n) || n <= 0 || isNaN(max) || max <= 0) return '0%';
  return Math.max(4, Math.min(100, Math.round(n / max * 100))) + '%';
}

function parseAlertCountsBody(body, wdListSet) {
  var out = {};
  var rows = body && body.watchdog_types || body && body.watchdogTypes || [];
  var restrict = wdListSet && (typeof wdListSet === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(wdListSet)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(wdListSet).length > 0;
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(row)) !== 'object') continue;

    var wt = row.watchdog_type != null ? row.watchdog_type : row.watchdogType;
    if (wt == null || wt === '') continue;
    wt = String(wt).trim();
    var fk = watchdogTypeFromApi(wt);
    if (restrict && !wdListSet[fk]) continue;
    var red = Number(row.red) || 0;
    var yellow = Number(row.yellow) || 0;
    if (!out[fk]) out[fk] = { red: 0, yellow: 0 };
    out[fk].red += red;
    out[fk].yellow += yellow;
  }
  return out;
}

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skwhite_noslogan.5033894.png";

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDER_VOLUME_UI_ENABLED; });
/* unused harmony export ELEVATED_PRO_ORDER_LIMIT_BY_TENANT_ID */
/* unused harmony export TENANT_IDS_WITHOUT_ORDER_CAP */
/* unused harmony export tenantIdFromValue */
/* harmony export (immutable) */ __webpack_exports__["a"] = tenantIdFromIdentityBody;
/* harmony export (immutable) */ __webpack_exports__["f"] = tenantIdFromOrderVolumeBody;
/* unused harmony export syncTenantIdFromOrderVolume */
/* unused harmony export tenantHasNoOrderCap */
/* unused harmony export isTenantWithoutOrderCap */
/* harmony export (immutable) */ __webpack_exports__["g"] = proMonthlyOrderLimitForTenant;
/* unused harmony export packageKeyFromDetails */
/* unused harmony export monthlyOrderLimitForPackageKey */
/* unused harmony export applyTenantProOrderLimit */
/* unused harmony export isStarterOrProPlanKey */
/* unused harmony export isFlatYearlyPlanKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PRO_INCLUDED_STOREFRONTS; });
/* unused harmony export PRO_BASE_MONTHLY_PRICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STARTER_MONTHLY_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return STARTER_MAX_STOREFRONTS; });
/* harmony export (immutable) */ __webpack_exports__["h"] = proStorefrontUnitRate;
/* harmony export (immutable) */ __webpack_exports__["i"] = proMonthlyPriceForStorefrontCount;
/* harmony export (immutable) */ __webpack_exports__["o"] = connectedStorefrontsCountFromPeriodChanges;
/* unused harmony export storefrontMeterPlanBadge */
/* unused harmony export isProOrderVolumePlan */
/* harmony export (immutable) */ __webpack_exports__["r"] = isStarterOrderVolumePlan;
/* harmony export (immutable) */ __webpack_exports__["s"] = canAddStorefrontForPlan;
/* unused harmony export resolveOrderVolumePlanKey */
/* unused harmony export isStarterOrProPackage */
/* harmony export (immutable) */ __webpack_exports__["c"] = isOrderVolumeBillingEligible;
/* harmony export (immutable) */ __webpack_exports__["e"] = shouldShowOrderVolumeUi;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTrialOrderVolumeUser;
/* harmony export (immutable) */ __webpack_exports__["k"] = userHasNoMonthlyOrderCap;
/* unused harmony export fallbackMonthlyOrderVolume */
/* harmony export (immutable) */ __webpack_exports__["l"] = resolveMonthlyOrderVolumeForDisplay;
/* harmony export (immutable) */ __webpack_exports__["m"] = shouldShowOrderVolumeLimit;
/* unused harmony export epochFromPeriodValue */
/* unused harmony export currentBillingMonthEpochs */
/* harmony export (immutable) */ __webpack_exports__["n"] = currentBillingMonthDateStrings;
/* unused harmony export orderVolumeApiParams */
/* unused harmony export planBadgeFromPackageOrApi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__billingScreenVariant_js__ = __webpack_require__(61);






var ORDER_VOLUME_UI_ENABLED = false;

var ELEVATED_PRO_ORDER_LIMIT_BY_TENANT_ID = {};

var TENANT_IDS_WITHOUT_ORDER_CAP = {
  '1377998158123013': true
};

function tenantIdFromValue(value) {
  if (value == null || value === '') return null;
  return String(value).trim();
}

function tenantIdFromIdentityBody(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  if (body.tenantId != null) return tenantIdFromValue(body.tenantId);
  if (body.tenant_id != null) return tenantIdFromValue(body.tenant_id);
  if (body.tenant && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.tenant) === 'object') {
    if (body.tenant.id != null) return tenantIdFromValue(body.tenant.id);
    if (body.tenant.tenantId != null) return tenantIdFromValue(body.tenant.tenantId);
    if (body.tenant.tenant_id != null) return tenantIdFromValue(body.tenant.tenant_id);
  }
  return null;
}

function tenantIdFromOrderVolumeBody(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  if (body.tenantId != null) return tenantIdFromValue(body.tenantId);
  if (body.tenant_id != null) return tenantIdFromValue(body.tenant_id);
  return null;
}

function syncTenantIdFromOrderVolume(ctx, orderVolumeBody) {
  var id = tenantIdFromOrderVolumeBody(orderVolumeBody);
  if (!id || !ctx) return id;
  ctx.tenantId = id;
  if (ctx.$root) ctx.$root.tenantId = id;
  return id;
}

function tenantHasNoOrderCap(tenantId) {
  var id = tenantIdFromValue(tenantId);
  return !!(id && TENANT_IDS_WITHOUT_ORDER_CAP[id]);
}

function isTenantWithoutOrderCap(opts) {
  return tenantHasNoOrderCap(tenantIdFromOpts(opts));
}

function proMonthlyOrderLimitForTenant(tenantId) {
  if (tenantHasNoOrderCap(tenantId)) return null;
  var id = tenantIdFromValue(tenantId);
  if (id && ELEVATED_PRO_ORDER_LIMIT_BY_TENANT_ID[id] != null) {
    return ELEVATED_PRO_ORDER_LIMIT_BY_TENANT_ID[id];
  }
  return 10000;
}

function packageKeyFromDetails(packageDetails) {
  if (!packageDetails) return '';
  var raw = packageDetails.packageKey != null ? packageDetails.packageKey : packageDetails.package_key;
  return String(raw == null ? '' : raw).trim().toUpperCase();
}

function monthlyOrderLimitForPackageKey(packageKey, tenantId) {
  if (tenantHasNoOrderCap(tenantId)) return null;
  var pk = String(packageKey || '').trim().toUpperCase();
  if (pk === 'PRO' || pk === 'PRO_ANNUAL') return proMonthlyOrderLimitForTenant(tenantId);
  if (pk === 'STARTER') return 2000;
  if (pk === 'FLAT_YEARLY') return null;
  return null;
}

function tenantIdFromOpts(opts) {
  opts = opts || {};
  var fromOrderVolume = tenantIdFromOrderVolumeBody(opts.orderVolumeBody);
  if (fromOrderVolume) return fromOrderVolume;
  if (opts.tenantId != null) return tenantIdFromValue(opts.tenantId);
  return tenantIdFromIdentityBody(opts.identityBody);
}

function applyTenantProOrderLimit(monthlyOrderVolume, packageDetails, tenantId) {
  if (!monthlyOrderVolume || monthlyOrderVolume.limit == null) return monthlyOrderVolume;
  if (tenantHasNoOrderCap(tenantId)) return monthlyOrderVolume;
  var packageKey = packageKeyFromDetails(packageDetails);
  if (packageKey !== 'PRO' && packageKey !== 'PRO_ANNUAL') return monthlyOrderVolume;
  var cap = proMonthlyOrderLimitForTenant(tenantId);
  if (Number(monthlyOrderVolume.limit) === cap) return monthlyOrderVolume;
  var used = Number(monthlyOrderVolume.used);
  if (isNaN(used)) used = 0;
  var remaining = Math.max(0, cap - used);
  var percentUsed = cap > 0 ? Math.min(100, Math.round(used / cap * 1000) / 10) : 0;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, monthlyOrderVolume, {
    limit: cap,
    remaining: remaining,
    percentUsed: percentUsed
  });
}

function isStarterOrProPlanKey(packageKey) {
  var pk = String(packageKey || '').trim().toUpperCase();
  return pk === 'STARTER' || pk === 'PRO' || pk === 'PRO_ANNUAL' || pk === 'FLAT_YEARLY';
}

function isFlatYearlyPlanKey(packageKey) {
  return String(packageKey || '').trim().toUpperCase() === 'FLAT_YEARLY';
}

var PRO_INCLUDED_STOREFRONTS = 5;

var PRO_BASE_MONTHLY_PRICE = 49;

var STARTER_MONTHLY_PRICE = 19;

var STARTER_MAX_STOREFRONTS = 2;

function proStorefrontUnitRate(storefrontNumber) {
  var n = Number(storefrontNumber);
  if (isNaN(n) || n <= PRO_INCLUDED_STOREFRONTS) return 0;
  if (n <= 15) return 19;
  if (n <= 30) return 14;
  if (n <= 60) return 10;
  return 7;
}

function proMonthlyPriceForStorefrontCount(count) {
  var n = Math.max(0, Math.floor(Number(count) || 0));
  var total = PRO_BASE_MONTHLY_PRICE;
  for (var i = PRO_INCLUDED_STOREFRONTS + 1; i <= n; i++) {
    total += proStorefrontUnitRate(i);
  }
  return total;
}

function connectedStorefrontsCountFromPeriodChanges(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  var raw = body.connected_storefronts_count != null ? body.connected_storefronts_count : body.connectedStorefrontsCount;
  if (raw == null || raw === '' || isNaN(Number(raw))) return null;
  return Math.max(0, Math.floor(Number(raw)));
}

function storefrontMeterPlanBadge(packageDetails, orderVolumeBody, opts) {
  var pk = resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts);
  if (pk === 'PRO' || pk === 'PRO_ANNUAL') return 'PRO';
  if (pk === 'STARTER') return 'STARTER';
  if (pk === 'FLAT_YEARLY') return 'FLAT YEARLY';
  return pk || 'PLAN';
}

function isProOrderVolumePlan(packageDetails, orderVolumeBody, opts) {
  var pk = resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts);
  return pk === 'PRO' || pk === 'PRO_ANNUAL';
}

function isStarterOrderVolumePlan(packageDetails, orderVolumeBody, opts) {
  return resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts) === 'STARTER';
}

function canAddStorefrontForPlan(packageDetails, connectedCount, opts) {
  if (!isStarterOrderVolumePlan(packageDetails, opts && opts.orderVolumeBody, opts)) return true;
  var n = Math.max(0, Math.floor(Number(connectedCount) || 0));
  return n < STARTER_MAX_STOREFRONTS;
}

function planNameImpliesStarterOrPro(name) {
  var n = String(name || '').toLowerCase().trim();
  if (!n) return null;
  if (n.indexOf('standard') >= 0 || n.indexOf('legacy') >= 0 || n.indexOf('daily') >= 0) return null;
  if (n.indexOf('flat yearly') >= 0) return 'FLAT_YEARLY';
  if (n.indexOf('starter') >= 0) return 'STARTER';
  if (n.indexOf('pro annual') >= 0) return 'PRO_ANNUAL';
  if (n === 'pro' || n.indexOf('pro plan') >= 0 || /^pro\b/.test(n)) return 'PRO';
  return null;
}

function resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts) {
  opts = opts || {};
  var plan = orderVolumeBody && orderVolumeBody.plan;
  if (plan) {
    var fromPlanKey = plan.packageKey != null ? plan.packageKey : plan.package_key;
    if (fromPlanKey != null && String(fromPlanKey).trim() !== '') {
      return String(fromPlanKey).trim().toUpperCase();
    }
    var fromPlanName = planNameImpliesStarterOrPro(plan.name || plan.planName);
    if (fromPlanName) return fromPlanName;
  }
  var fromPkg = packageKeyFromDetails(packageDetails);
  if (fromPkg) return fromPkg;
  if (packageDetails) {
    var fromPkgName = planNameImpliesStarterOrPro(packageDetails.name || packageDetails.packageName);
    if (fromPkgName) return fromPkgName;
  }
  var summary = opts.subscriptionSummary;
  if (summary && summary.planName) {
    var fromSummary = planNameImpliesStarterOrPro(summary.planName);
    if (fromSummary) return fromSummary;
  }
  return '';
}

function isStarterOrProPackage(packageDetails, orderVolumeBody, opts) {
  return isStarterOrProPlanKey(resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts));
}

function isOrderVolumeBillingEligible(body) {
  return !!(body && body.eligible === true);
}

function shouldShowOrderVolumeUi(packageDetails, orderVolumeBody, opts) {
  opts = opts || {};
  var variant = opts.billingVariant != null ? opts.billingVariant : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__billingScreenVariant_js__["c" /* resolveBillingScreenVariant */])({
    hasDailyPricing: opts.hasDailyPricing,
    packageDetails: packageDetails,
    billingUserTypeRaw: opts.billingUserTypeRaw,
    billingSummary: opts.billingSummary
  });
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__billingScreenVariant_js__["a" /* isLegacyBillingUserType */])(opts)) return false;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__billingScreenVariant_js__["d" /* isLegacyOrDailyBillingVariant */])(variant)) return false;
  if (variant !== 'new') return false;
  if (!isStarterOrProPackage(packageDetails, orderVolumeBody, opts)) return false;
  if (orderVolumeBody && orderVolumeBody.eligible === false) return false;
  return true;
}

function truthyFlag(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

function isTrialOrderVolumeUser(opts) {
  opts = opts || {};
  var summary = opts.subscriptionSummary;
  if (summary && (typeof summary === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(summary)) === 'object') {
    var status = String(summary.status || '').toLowerCase();
    if (status === 'active' || status === 'past_due') return false;
    if (summary.trialExpired) return false;
    if (summary.trialActive) return true;
    return false;
  }
  var body = opts.orderVolumeBody;
  if (body) {
    if (truthyFlag(body.trial) || truthyFlag(body.onTrial) || truthyFlag(body.isTrial)) return true;
    if (truthyFlag(body.inTrialPeriod) || truthyFlag(body.in_trial_period)) return true;
    var plan = body.plan;
    if (plan && (truthyFlag(plan.trial) || truthyFlag(plan.onTrial) || truthyFlag(plan.isTrial))) return true;
  }
  var pd = opts.packageDetails;
  if (pd) {
    if (truthyFlag(pd.trial) || truthyFlag(pd.onTrial) || truthyFlag(pd.inTrial)) return true;
    var status = pd.subscriptionStatus || pd.subscription_status || pd.stripeSubscriptionStatus;
    if (status && String(status).toLowerCase() === 'trialing') return true;
  }
  var ps = opts.paymentStatus;
  if ((ps === 0 || ps === 2) && isStarterOrProPackage(pd, body, opts)) return true;
  if (opts.hasPaymentMethodOnFile === false && isStarterOrProPackage(pd, body, opts)) return true;
  return false;
}

function userHasNoMonthlyOrderCap(opts) {
  return isTrialOrderVolumeUser(opts) || isTenantWithoutOrderCap(opts);
}

function fallbackMonthlyOrderVolume(packageDetails, periodEndEpoch, opts) {
  opts = opts || {};
  if (!isStarterOrProPackage(packageDetails, opts.orderVolumeBody, opts)) return null;
  var ctx = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ packageDetails: packageDetails }, opts || {});
  var isTrial = isTrialOrderVolumeUser(ctx);
  var noCap = userHasNoMonthlyOrderCap(ctx);
  var pk = packageKeyFromDetails(packageDetails);
  var tenantId = tenantIdFromOpts(opts);
  var pkgLimit = monthlyOrderLimitForPackageKey(pk, tenantId);
  var flatYearly = isFlatYearlyPlanKey(pk);
  var limit = noCap || flatYearly ? null : pkgLimit != null ? pkgLimit : 2000;
  var resetsAt = '';
  if (periodEndEpoch) {
    var d = new Date(Number(periodEndEpoch) * 1000);
    if (!isNaN(d.getTime())) {
      resetsAt = d.toISOString().slice(0, 10);
    }
  }
  return {
    used: 0,
    limit: limit,
    remaining: noCap ? null : limit,
    percentUsed: 0,
    resetsAt: resetsAt
  };
}

function resolveMonthlyOrderVolumeForDisplay(packageDetails, orderVolumeBody, periodEndEpoch, opts) {
  opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    packageDetails: packageDetails,
    orderVolumeBody: orderVolumeBody
  }, opts || {});
  var mov = null;
  if (isOrderVolumeBillingEligible(orderVolumeBody) && orderVolumeBody.monthlyOrderVolume) {
    mov = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, orderVolumeBody.monthlyOrderVolume);
  } else {
    mov = fallbackMonthlyOrderVolume(packageDetails, periodEndEpoch, opts);
  }
  if (!mov) return null;
  mov = applyTenantProOrderLimit(mov, packageDetails, tenantIdFromOpts(opts));
  if (!userHasNoMonthlyOrderCap(opts)) return mov;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, mov, {
    limit: null,
    remaining: null,
    percentUsed: 0
  });
}

function shouldShowOrderVolumeLimit(monthlyOrderVolume, opts) {
  if (userHasNoMonthlyOrderCap(opts)) return false;
  return monthlyOrderVolume != null && monthlyOrderVolume.limit != null;
}

function epochFromPeriodValue(value, role) {
  if (value == null || value === '') return null;
  var n = Number(value);
  if (!isNaN(n) && String(value).trim() !== '' && !String(value).includes('-')) {
    if (n > 1e12) n = Math.floor(n / 1000);
    return Math.floor(n);
  }
  var s = String(value).trim();
  var d;
  if (s.indexOf('T') >= 0) {
    d = new Date(s);
  } else if (role === 'end') {
    d = new Date(s + 'T23:59:59Z');
  } else {
    d = new Date(s + 'T00:00:00Z');
  }
  if (isNaN(d.getTime())) return null;
  return Math.floor(d.getTime() / 1000);
}

var CURRENT_BILLING_MONTH_MIN_DAYS = 27;
var CURRENT_BILLING_MONTH_MAX_DAYS = 35;

function currentBillingMonthEpochs(periodStartEpoch, periodEndEpoch) {
  var end = epochFromPeriodValue(periodEndEpoch, 'end');
  if (end == null) return { from: null, to: null };

  var from = null;
  if (periodStartEpoch != null && periodStartEpoch !== '') {
    var candidate = epochFromPeriodValue(periodStartEpoch, 'start');
    if (candidate != null && end > candidate) {
      var days = (end - candidate) / 86400;
      if (days >= CURRENT_BILLING_MONTH_MIN_DAYS && days <= CURRENT_BILLING_MONTH_MAX_DAYS) {
        from = candidate;
      }
    }
  }
  if (from == null) {
    var endDate = new Date(end * 1000);
    var startDate = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth() - 1, endDate.getUTCDate(), 0, 0, 0, 0));
    from = Math.floor(startDate.getTime() / 1000);
  }
  return { from: from, to: end };
}

function currentBillingMonthDateStrings(periodStartEpoch, periodEndEpoch) {
  var range = currentBillingMonthEpochs(periodStartEpoch, periodEndEpoch);
  if (range.from == null || range.to == null) return null;
  return {
    periodStart: new Date(range.from * 1000).toISOString().slice(0, 10),
    periodEnd: new Date(range.to * 1000).toISOString().slice(0, 10)
  };
}

function orderVolumeApiParams(opts) {
  opts = opts || {};
  var range = currentBillingMonthEpochs(opts.periodStart, opts.periodEnd);
  var params = {};
  if (range.from != null) params.from = range.from;
  if (range.to != null) params.to = range.to;
  return params;
}

function planBadgeFromPackageOrApi(packageDetails, orderVolumeBody, opts) {
  var ctx = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    packageDetails: packageDetails,
    orderVolumeBody: orderVolumeBody
  }, opts || {});
  if (isTrialOrderVolumeUser(ctx)) {
    return 'TRIAL';
  }
  var plan = orderVolumeBody && orderVolumeBody.plan;
  if (plan && plan.name) return String(plan.name).toUpperCase();
  if (plan && plan.packageKey) return String(plan.packageKey).toUpperCase();
  var pk = resolveOrderVolumePlanKey(packageDetails, orderVolumeBody, opts);
  if (pk === 'PRO' || pk === 'PRO_ANNUAL' || pk === 'STARTER' || pk === 'FLAT_YEARLY') return pk;
  if (packageDetails) {
    var name = packageDetails.name || packageDetails.packageName;
    if (name) return String(name).toUpperCase();
  }
  return 'PLAN';
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AMAZON_MARKETPLACE_HOSTS */
/* unused harmony export SELLER_CENTRAL_HOSTS */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeMarketplaceCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = amazonHostForMarketplace;
/* unused harmony export sellerCentralHostForMarketplace */
/* harmony export (immutable) */ __webpack_exports__["e"] = extractAsinFromUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = amazonListingUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = sellerCentralAsinUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = marketplaceColumnLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = marketplaceFlagClass;


var AMAZON_MARKETPLACE_HOSTS = {
  DE: 'www.amazon.de',
  CN: 'www.amazon.cn',
  UK: 'www.amazon.co.uk',
  JP: 'www.amazon.co.jp',
  FR: 'www.amazon.fr',
  ES: 'www.amazon.es',
  IT: 'www.amazon.it',
  US: 'www.amazon.com',
  MX: 'www.amazon.com.mx',
  IN: 'www.amazon.in',
  CA: 'www.amazon.ca',
  BR: 'www.amazon.com.br',
  NL: 'www.amazon.nl',
  TR: 'www.amazon.com.tr',
  AE: 'www.amazon.ae',
  SA: 'www.amazon.sa',
  AU: 'www.amazon.com.au',
  SG: 'www.amazon.sg',
  PL: 'www.amazon.pl',
  SE: 'www.amazon.se',
  BE: 'www.amazon.com.be',
  AT: 'www.amazon.de',
  ZA: 'www.amazon.co.za',
  EG: 'www.amazon.eg',
  IE: 'www.amazon.ie'
};

var SELLER_CENTRAL_HOSTS = {
  US: 'sellercentral.amazon.com',
  CA: 'sellercentral.amazon.ca',
  MX: 'sellercentral.amazon.com.mx',
  BR: 'sellercentral.amazon.com.br',
  UK: 'sellercentral.amazon.co.uk',
  DE: 'sellercentral.amazon.de',
  FR: 'sellercentral.amazon.fr',
  IT: 'sellercentral.amazon.it',
  ES: 'sellercentral.amazon.es',
  NL: 'sellercentral.amazon.nl',
  BE: 'sellercentral.amazon.com.be',
  SE: 'sellercentral.amazon.se',
  PL: 'sellercentral.amazon.pl',
  TR: 'sellercentral.amazon.com.tr',
  IN: 'sellercentral.amazon.in',
  AE: 'sellercentral.amazon.ae',
  SA: 'sellercentral.amazon.sa',
  EG: 'sellercentral.amazon.eg',
  AU: 'sellercentral.amazon.com.au',
  SG: 'sellercentral.amazon.sg',
  JP: 'sellercentral-japan.amazon.com',
  ZA: 'sellercentral.amazon.co.za',
  AT: 'sellercentral.amazon.de',
  IE: 'sellercentral.amazon.co.uk',
  CN: 'sellercentral.amazon.cn'
};

function normalizeMarketplaceCode(marketplace) {
  if (marketplace == null || marketplace === '') return '';
  var mp = String(marketplace).trim().toUpperCase();
  if (mp === 'GB') return 'UK';
  return mp;
}

function amazonHostForMarketplace(marketplace, fallbackUrl) {
  var mp = normalizeMarketplaceCode(marketplace);
  if (mp && AMAZON_MARKETPLACE_HOSTS[mp]) return AMAZON_MARKETPLACE_HOSTS[mp];
  if (fallbackUrl && typeof fallbackUrl === 'string') {
    try {
      var u = new URL(fallbackUrl);
      if (/amazon\./i.test(u.hostname)) return u.hostname;
    } catch (e) {}
  }
  return AMAZON_MARKETPLACE_HOSTS.US;
}

function sellerCentralHostForMarketplace(marketplace) {
  var mp = normalizeMarketplaceCode(marketplace);
  if (mp && SELLER_CENTRAL_HOSTS[mp]) return SELLER_CENTRAL_HOSTS[mp];
  return SELLER_CENTRAL_HOSTS.US;
}

function extractAsinFromUrl(url) {
  if (!url || typeof url !== 'string') return null;
  var dp = url.match(/\/dp\/([A-Z0-9]{10})/i);
  if (dp) return dp[1].toUpperCase();
  var gp = url.match(/\/gp\/product\/([A-Z0-9]{10})/i);
  if (gp) return gp[1].toUpperCase();
  return null;
}

function amazonListingUrl(asin, marketplace, fallbackUrl) {
  var code = asin ? String(asin).trim().toUpperCase() : '';
  if (!code) code = extractAsinFromUrl(fallbackUrl) || '';
  if (!code) return fallbackUrl || null;
  var host = amazonHostForMarketplace(marketplace, fallbackUrl);
  return 'https://' + host + '/dp/' + code;
}

function sellerCentralAsinUrl(asin, marketplace) {
  var code = asin ? String(asin).trim().toUpperCase() : '';
  if (!code) return null;
  var mp = normalizeMarketplaceCode(marketplace);
  if (!mp || !SELLER_CENTRAL_HOSTS[mp]) return null;
  var host = SELLER_CENTRAL_HOSTS[mp];
  return 'https://' + host + '/inventory?search=' + encodeURIComponent(code);
}

function marketplaceColumnLabel(marketplace) {
  var mp = normalizeMarketplaceCode(marketplace);
  if (!mp) return '';
  return mp + ' Marketplace';
}

function marketplaceFlagClass(marketplace) {
  var mp = normalizeMarketplaceCode(marketplace).toLowerCase();
  if (!mp) return 'flag';
  if (mp === 'uk') return 'gb flag';
  return mp + ' flag';
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CURRENCY_SYMBOLS */
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrencySymbol;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrencyForMarketplace;

var CURRENCY_SYMBOLS = {
  USD: '$',
  CAD: 'CA$',
  MXN: 'MX$',
  BRL: 'R$',
  GBP: '£',
  EUR: '€',
  SEK: 'kr',
  PLN: 'zł',
  JPY: '¥',
  AUD: 'A$',
  SGD: 'S$',
  INR: '₹',
  AED: 'AED',
  SAR: 'SAR',
  EGP: 'E£',
  ZAR: 'R',
  TRY: '₺',
  CNY: '¥'
};

var MARKETPLACE_TO_CURRENCY = {
  US: 'USD',
  CA: 'CAD',
  MX: 'MXN',
  BR: 'BRL',
  UK: 'GBP',
  GB: 'GBP',
  DE: 'EUR',
  FR: 'EUR',
  ES: 'EUR',
  IT: 'EUR',
  NL: 'EUR',
  BE: 'EUR',
  IE: 'EUR',
  SE: 'SEK',
  PL: 'PLN',
  TR: 'TRY',
  IN: 'INR',
  JP: 'JPY',
  AU: 'AUD',
  SG: 'SGD',
  AE: 'AED',
  SA: 'SAR',
  EG: 'EGP',
  ZA: 'ZAR',
  CN: 'CNY'
};

function getCurrencySymbol(isoCode) {
  if (!isoCode) return '$';
  var c = String(isoCode).toUpperCase();
  return CURRENCY_SYMBOLS[c] || '$';
}

function getCurrencyForMarketplace(marketplace) {
  if (!marketplace) return '$';
  var code = String(marketplace).toUpperCase();
  var iso = MARKETPLACE_TO_CURRENCY[code];
  if (iso) return getCurrencySymbol(iso);
  return '$';
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = numOrNull;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRating;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatCount;
/* harmony export (immutable) */ __webpack_exports__["g"] = ratingSummary;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatSnapshotDate;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatSignedDelta;
/* harmony export (immutable) */ __webpack_exports__["f"] = reviewHealthDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function numOrNull(v) {
  if (v == null || v === '') return null;
  var n = Number(v);
  return isFinite(n) ? n : null;
}

function formatRating(v) {
  var n = numOrNull(v);
  return n == null ? '—' : n.toFixed(1);
}

function formatCount(v) {
  var n = numOrNull(v);
  return n == null ? '—' : Math.round(n).toLocaleString('en-US');
}

function ratingSummary(rating, count) {
  var r = numOrNull(rating);
  if (r == null || r <= 0) return '—';
  var c = numOrNull(count);
  return '★ ' + formatRating(rating) + (c == null ? '' : ' (' + formatCount(c) + ')');
}

function formatSnapshotDate(value, withYear) {
  if (!value) return '';
  var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  var y, mo, d;
  if (m) {
    y = Number(m[1]);mo = Number(m[2]) - 1;d = Number(m[3]);
  } else {
    var dt = new Date(value);
    if (isNaN(dt.getTime())) return '';
    y = dt.getFullYear();mo = dt.getMonth();d = dt.getDate();
  }
  return d + ' ' + MONTHS_SHORT[mo] + (withYear ? ' ' + y : '');
}

function formatSignedDelta(current, previous) {
  var c = numOrNull(current);
  var p = numOrNull(previous);
  if (c == null || p == null) return null;
  var diff = Math.round(c - p);
  if (diff === 0) return '0';
  return (diff > 0 ? '+' : '−') + Math.abs(diff).toLocaleString('en-US');
}

function pick(details, snake, camel) {
  if (!details) return undefined;
  return details[snake] != null ? details[snake] : details[camel];
}

function reviewHealthDetails(details) {
  var d = details && (typeof details === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(details)) === 'object' ? details : {};
  var reasons = pick(d, 'reasons', 'reasons');
  if (!Array.isArray(reasons)) reasons = [];
  var rows = [];
  reasons.forEach(function (reason) {
    if (reason === 'rating_drop') {
      rows.push({
        reason: reason,
        text: 'Star rating ' + formatRating(pick(d, 'previous_display_rating', 'previousDisplayRating')) + ' → ' + formatRating(pick(d, 'display_rating', 'displayRating'))
      });
    } else if (reason === 'rating_count_drop') {
      var cur = pick(d, 'total_rating_count', 'totalRatingCount');
      var prev = pick(d, 'previous_total_rating_count', 'previousTotalRatingCount');
      var delta = formatSignedDelta(cur, prev);
      rows.push({
        reason: reason,
        text: 'Rating count ' + formatCount(prev) + ' → ' + formatCount(cur) + (delta ? ' (' + delta + ')' : '')
      });
    } else if (reason === 'new_critical_reviews') {
      var n = numOrNull(pick(d, 'low_rating_review_count', 'lowRatingReviewCount'));
      rows.push({
        reason: reason,
        text: n == null ? 'New critical reviews' : n + ' new critical review' + (n === 1 ? '' : 's')
      });
    }
  });
  var variations = pick(d, 'variation_asins', 'variationAsins');
  var variationAsins = Array.isArray(variations) ? variations.filter(Boolean) : [];
  var reviewsUrl = pick(d, 'reviews_url', 'reviewsUrl') || null;
  var criticalUrl = pick(d, 'critical_reviews_url', 'criticalReviewsUrl') || null;
  return {
    rows: rows,
    variationAsins: variationAsins,
    reviewsUrl: reasons.indexOf('new_critical_reviews') >= 0 && criticalUrl ? criticalUrl : reviewsUrl
  };
}

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SK_ONBOARDING_PIPELINE_DONE */
/* unused harmony export SK_ONBOARDING_CONNECT_DEFERRED */
/* harmony export (immutable) */ __webpack_exports__["a"] = readPipelineDoneHint;
/* harmony export (immutable) */ __webpack_exports__["b"] = readConnectDeferredHint;
/* harmony export (immutable) */ __webpack_exports__["c"] = setPipelineDoneHint;
/* harmony export (immutable) */ __webpack_exports__["g"] = setConnectDeferredHint;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearConnectDeferredHint;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearPipelineDoneHint;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearOnboardingSessionHints;


var SK_ONBOARDING_PIPELINE_DONE = 'sk_onboarding_pipeline_done';
var SK_ONBOARDING_CONNECT_DEFERRED = 'sk_onboarding_connect_deferred';

function readPipelineDoneHint() {
  try {
    return sessionStorage.getItem(SK_ONBOARDING_PIPELINE_DONE) === '1';
  } catch (e) {
    return false;
  }
}

function readConnectDeferredHint() {
  try {
    return sessionStorage.getItem(SK_ONBOARDING_CONNECT_DEFERRED) === '1';
  } catch (e) {
    return false;
  }
}

function setPipelineDoneHint() {
  try {
    sessionStorage.setItem(SK_ONBOARDING_PIPELINE_DONE, '1');
  } catch (e) {}
}

function setConnectDeferredHint() {
  try {
    sessionStorage.setItem(SK_ONBOARDING_CONNECT_DEFERRED, '1');
  } catch (e) {}
}

function clearConnectDeferredHint() {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_CONNECT_DEFERRED);
  } catch (e) {}
}

function clearPipelineDoneHint() {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_PIPELINE_DONE);
  } catch (e) {}
}

function clearOnboardingSessionHints() {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_PIPELINE_DONE);
    sessionStorage.removeItem(SK_ONBOARDING_CONNECT_DEFERRED);
  } catch (e) {}
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeBillingUserType */
/* unused harmony export billingUserTypeFromOpts */
/* harmony export (immutable) */ __webpack_exports__["a"] = isLegacyBillingUserType;
/* unused harmony export isDailyBillingUserType */
/* harmony export (immutable) */ __webpack_exports__["c"] = resolveBillingScreenVariant;
/* harmony export (immutable) */ __webpack_exports__["d"] = isLegacyOrDailyBillingVariant;
/* harmony export (immutable) */ __webpack_exports__["b"] = isNewBillingScreenVariant;


function normalizeBillingUserType(raw) {
  return ('' + (raw === undefined || raw === null ? '' : raw)).trim().toLowerCase().replace(/\s+/g, '_');
}

function billingUserTypeFromOpts(opts) {
  opts = opts || {};
  var billingSummary = opts.billingSummary;
  var packageDetails = opts.packageDetails;
  return billingSummary && billingSummary.userType || billingSummary && billingSummary.user_type || opts.billingUserTypeRaw || packageDetails && packageDetails.subscriptionBillingUserType || packageDetails && packageDetails.subscription_billing_user_type || '';
}

function isLegacyBillingUserType(opts) {
  var s = normalizeBillingUserType(billingUserTypeFromOpts(opts));
  return ['legacy', 'legacy_paid', 'legacy_free', 'legacy_paying'].indexOf(s) >= 0;
}

function isDailyBillingUserType(opts) {
  var s = normalizeBillingUserType(billingUserTypeFromOpts(opts));
  return ['daily', 'daily_usage', 'daily_meter', 'meter'].indexOf(s) >= 0;
}

function resolveBillingScreenVariant(opts) {
  opts = opts || {};
  var hasDailyPricing = !!opts.hasDailyPricing;

  if (hasDailyPricing) return 'daily_usage';
  if (isLegacyBillingUserType(opts)) return 'legacy';
  if (isDailyBillingUserType(opts)) return 'daily_usage';

  return 'new';
}

function isLegacyOrDailyBillingVariant(variant) {
  return variant === 'legacy' || variant === 'daily_usage';
}

function isNewBillingScreenVariant(opts) {
  return resolveBillingScreenVariant(opts) === 'new';
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startBillingPaymentModalFlow */
/* unused harmony export endBillingPaymentModalFlow */
/* harmony export (immutable) */ __webpack_exports__["a"] = requestOpenBillingPaymentModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = resolveHasPaymentMethod;
/* harmony export (immutable) */ __webpack_exports__["d"] = upgradeSubscriptionToPlan;
/* harmony export (immutable) */ __webpack_exports__["c"] = upgradeSubscriptionToPro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscriptionBilling__ = __webpack_require__(26);
/* unused harmony reexport hasPaymentMethodFromSummary */





var BILLING_SETTINGS_PATH = '/settings/billing';
var OPEN_PAYMENT_MODAL_MAX_ATTEMPTS = 30;



function startBillingPaymentModalFlow(root) {
  if (root) root.billingPaymentModalFlowActive = true;
}

function endBillingPaymentModalFlow(root) {
  if (root) {
    root.billingPaymentModalFlowActive = false;
    root.pendingOpenBillingPaymentModal = false;
  }
}

function tryInvokeOpenBillingPaymentModal(vm, attempt) {
  if (!vm || !vm.$root) return;
  if (typeof vm.$root.openBillingPaymentModal === 'function') {
    startBillingPaymentModalFlow(vm.$root);
    vm.$root.pendingOpenBillingPaymentModal = false;
    vm.$root.openBillingPaymentModal();
    return;
  }
  if (attempt >= OPEN_PAYMENT_MODAL_MAX_ATTEMPTS) return;
  setTimeout(function () {
    tryInvokeOpenBillingPaymentModal(vm, attempt + 1);
  }, 80 + attempt * 40);
}

function requestOpenBillingPaymentModal(vm) {
  if (!vm || !vm.$root) return;
  startBillingPaymentModalFlow(vm.$root);
  vm.$root.pendingOpenBillingPaymentModal = true;
  vm.$root.$emit('billing-open-payment-modal');
  if (vm.$route.path !== BILLING_SETTINGS_PATH) {
    vm.$router.push(BILLING_SETTINGS_PATH);
  }
  tryInvokeOpenBillingPaymentModal(vm, 0);
}

function resolveHasPaymentMethod(vm) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__subscriptionBilling__["i" /* hasPaymentMethodFromSummary */])(vm.$root && vm.$root.subscriptionSummary)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
  }
  return vm.$http.get('/api/billing/payment-methods').then(function (res) {
    var body = res.body || {};
    var raw = body.paymentMethods || body.payment_methods || body.data;
    if (Array.isArray(raw) && raw.length > 0) return true;
    if (Array.isArray(body) && body.length > 0) return true;
    if (body && body.id) return true;
    return false;
  }, function () {
    return false;
  });
}

function refreshSummaryAfterUpgrade(vm, res) {
  if (vm.$root && vm.$root.loadSubscriptionSummary) {
    return vm.$root.loadSubscriptionSummary().then(function () {
      return res;
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
}

function upgradeSubscriptionToPlan(vm, planKey) {
  return vm.$http.put('/api/billing/subscription/upgrade', { plan: planKey || 'pro' }).then(function (res) {
    return refreshSummaryAfterUpgrade(vm, res);
  });
}

function upgradeSubscriptionToPro(vm) {
  return upgradeSubscriptionToPlan(vm, 'pro');
}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRequestGate;
/* harmony export (immutable) */ __webpack_exports__["b"] = isRequestAborted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



function createRequestGate() {
  var requests = [];
  var _generation = 0;

  return {
    begin: function begin() {
      _generation += 1;
      for (var i = 0; i < requests.length; i++) {
        try {
          if (requests[i] && typeof requests[i].abort === 'function') {
            requests[i].abort();
          }
        } catch (e) {}
      }
      requests = [];
      return _generation;
    },

    generation: function generation() {
      return _generation;
    },
    isCurrent: function isCurrent(gen) {
      return gen === _generation;
    },

    trackOpts: function trackOpts(opts) {
      opts = opts ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, opts) : {};
      var prevBefore = opts.before;
      opts.before = function (request) {
        requests.push(request);
        if (typeof prevBefore === 'function') prevBefore(request);
      };
      return opts;
    },
    clear: function clear() {
      requests = [];
    }
  };
}

function isRequestAborted(err) {
  if (!err) return false;
  if (err.status === 0 && (err.statusText === 'abort' || err.statusText === 'AbortError')) return true;
  if (err.message && /abort/i.test(String(err.message))) return true;
  return false;
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseJsonIfNeeded;
/* harmony export (immutable) */ __webpack_exports__["d"] = extractThresholdGetItems;
/* harmony export (immutable) */ __webpack_exports__["a"] = productIdFromThresholdRow;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseEntity;
/* harmony export (immutable) */ __webpack_exports__["e"] = listingIdFromProduct;
/* harmony export (immutable) */ __webpack_exports__["g"] = unwrapApiNumber;
/* harmony export (immutable) */ __webpack_exports__["f"] = fbmThresholdFromSettings;
/* harmony export (immutable) */ __webpack_exports__["h"] = formFieldsFromFbaSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




function parseJsonIfNeeded(v) {
  if (v == null) return null;
  if (typeof v === 'string') {
    try {
      return JSON.parse(v);
    } catch (e) {
      return null;
    }
  }
  return v;
}

function extractThresholdGetItems(rawBody) {
  if (Array.isArray(rawBody)) return rawBody;
  var body = parseJsonIfNeeded(rawBody);
  if (body == null) body = rawBody;
  if (body == null) return [];
  if (typeof body === 'string') {
    body = parseJsonIfNeeded(body);
    if (body == null || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') return [];
  }
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.items)) return body.items;
  if (body.items && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.items) === 'object' && !Array.isArray(body.items)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body.items).map(function (k) {
      return body.items[k];
    }).filter(Boolean);
  }
  var data = body.data;
  data = parseJsonIfNeeded(data);
  if (data != null && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data)) return data;
  }
  if (body.result && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.result) === 'object') {
    if (Array.isArray(body.result.items)) return body.result.items;
    if (Array.isArray(body.result)) return body.result;
  }
  if (body.payload && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.payload) === 'object' && Array.isArray(body.payload.items)) return body.payload.items;
  if (Array.isArray(body.listings)) return body.listings;
  if (Array.isArray(body.rows)) return body.rows;
  if (Array.isArray(body.results)) return body.results;
  if (Array.isArray(body.content)) return body.content;
  if (Array.isArray(body.records)) return body.records;
  if (body._embedded && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body._embedded) === 'object') {
    var emb = body._embedded;
    if (Array.isArray(emb.items)) return emb.items;
    if (Array.isArray(emb.stockAlertThresholds)) return emb.stockAlertThresholds;
    var ek = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(emb);
    for (var ei = 0; ei < ek.length; ei++) {
      if (Array.isArray(emb[ek[ei]])) return emb[ek[ei]];
    }
  }
  var dataScan = parseJsonIfNeeded(body.data);
  if (dataScan == null) dataScan = body.data;
  if (dataScan != null && (typeof dataScan === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dataScan)) === 'object' && !Array.isArray(dataScan)) {
    var dk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataScan);
    for (var di = 0; di < dk.length; di++) {
      var dv = dataScan[dk[di]];
      if (Array.isArray(dv) && dv.length && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dv[0]) === 'object') return dv;
    }
  }
  var bk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body);
  for (var bi = 0; bi < bk.length; bi++) {
    var bv = body[bk[bi]];
    if (!Array.isArray(bv) || !bv.length || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(bv[0]) !== 'object') continue;
    var z = bv[0];
    if (z.product_id != null || z.productId != null || z.listing_id != null || z.asin != null) return bv;
  }
  return [];
}

function productIdFromThresholdRow(row) {
  if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(row)) !== 'object') return '';
  if (row.product_id != null) return String(row.product_id);
  if (row.productId != null) return String(row.productId);
  if (row.listing_id != null) return String(row.listing_id);
  if (row.id != null) return String(row.id);
  return '';
}

function httpResponseEntity(res) {
  if (res == null) return null;
  if (res.body !== undefined && res.body !== null && res.body !== '') return res.body;
  if (res.data !== undefined && res.data !== null && res.data !== '') return res.data;
  if (res.bodyText != null && res.bodyText !== '') return res.bodyText;
  return null;
}

function listingIdFromProduct(p) {
  if (!p || (typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p)) !== 'object') return '';
  if (p.productId !== undefined && p.productId !== null && p.productId !== '') return String(p.productId);
  if (p.product_id !== undefined && p.product_id !== null && p.product_id !== '') return String(p.product_id);
  if (p.id !== undefined && p.id !== null && p.id !== '') return String(p.id);
  return '';
}

function unwrapApiNumber(v) {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'number' && !isNaN(v)) return v;
  if (typeof v === 'string') {
    var t = v.trim();
    if (t === '') return null;
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) === 'object' && v !== null) {
    if ('value' in v) return unwrapApiNumber(v.value);
    if ('$numberDecimal' in v) return unwrapApiNumber(v.$numberDecimal);
  }
  var x = Number(v);
  return isNaN(x) ? null : x;
}

function fbmThresholdFromSettings(s) {
  if (!s || (typeof s === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(s)) !== 'object') return null;
  var t = s.threshold;
  if (t === undefined || t === null) t = s.fbm_threshold;
  if (t === undefined || t === null) t = s.redThreshold;
  if (t === undefined || t === null) t = s.red_threshold;
  var n = unwrapApiNumber(t);
  return n !== null && n >= 0 ? n : null;
}

function formFieldsFromFbaSettings(s) {
  s = s || {};
  function numNonNeg(v) {
    var n = unwrapApiNumber(v);
    if (n === null) return null;
    return n >= 0 ? n : null;
  }
  function numPos(v) {
    var n = unwrapApiNumber(v);
    if (n === null) return null;
    return n > 0 ? n : null;
  }
  function pick(a, b) {
    return a !== undefined && a !== null ? a : b;
  }
  return {
    amberThreshold: numNonNeg(pick(s.amberThreshold, s.amber_threshold)),
    redThreshold: numNonNeg(pick(s.redThreshold, s.red_threshold)),
    amberDays: numNonNeg(pick(s.amberDays, s.amber_days)),
    redDays: numNonNeg(pick(s.redDays, s.red_days)),
    velocityLookbackDays: numPos(pick(s.velocityLookbackDays, s.velocity_lookback_days))
  };
}

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.0db2093.jpg";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.348a16a.jpg";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.50da728.jpg";

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = categoryFromAlertEmailType;
/* harmony export (immutable) */ __webpack_exports__["c"] = alertIdFromQuery;
/* harmony export (immutable) */ __webpack_exports__["d"] = itemMatchesAlertId;
/* harmony export (immutable) */ __webpack_exports__["a"] = issuesLocationFromAlertsEmailQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__watchdogSummaryApi_js__ = __webpack_require__(33);






var ALERT_EMAIL_TYPE_TO_CATEGORY = {
  content: 'productDetailsRecentChange',
  content_change: 'productDetailsRecentChange',
  content_changed: 'productDetailsRecentChange',
  product_details: 'productDetailsRecentChange',
  product_details_recent_change: 'productDetailsRecentChange',
  productdetailsrecentchange: 'productDetailsRecentChange',
  buybox: 'lostBuybox',
  lost_buybox: 'lostBuybox',
  buybox_lost: 'lostBuybox',
  hijacker: 'numberOfSellers',
  number_of_sellers: 'numberOfSellers',
  price: 'price',
  price_change: 'price',
  inventory: 'inventory',
  inventory_change: 'inventory',
  fbm_inventory: 'fbmInventory',
  sales: 'salesDrop',
  sales_drop: 'salesDrop',
  sales_volume: 'salesDrop',
  listing_suspended: 'listingSuspended',
  search_ban: 'searchBan',
  image_missing: 'imageMissing',
  category: 'productCategoryRecentChange',
  product_category_recent_change: 'productCategoryRecentChange',
  parent_product_change: 'parentProductChange',
  adult_classification: 'adultClassification'
};

function categoryFromAlertEmailType(type) {
  if (type == null || type === '') return null;
  var raw = Array.isArray(type) ? type[0] : type;
  var s = String(raw).trim();
  if (!s) return null;
  var lower = s.toLowerCase().replace(/-/g, '_');
  if (ALERT_EMAIL_TYPE_TO_CATEGORY[lower]) return ALERT_EMAIL_TYPE_TO_CATEGORY[lower];
  if (ALERT_EMAIL_TYPE_TO_CATEGORY[lower.replace(/_/g, '')]) {
    return ALERT_EMAIL_TYPE_TO_CATEGORY[lower.replace(/_/g, '')];
  }
  var fromApi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__watchdogSummaryApi_js__["d" /* watchdogTypeFromApi */])(lower);
  return fromApi || null;
}

function alertIdFromQuery(query) {
  if (!query || (typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(query)) !== 'object') return '';
  var raw = query.alertId != null ? query.alertId : query.id != null ? query.id : query.watchDogId != null ? query.watchDogId : query.watchdog_id != null ? query.watchdog_id : '';
  if (Array.isArray(raw)) raw = raw[0];
  var s = raw != null ? String(raw).trim() : '';
  return s;
}

function itemMatchesAlertId(item, alertId) {
  if (!item || !alertId) return false;
  var t = String(alertId);
  if (item.watchDogId != null && String(item.watchDogId) === t) return true;
  if (item.watchDogItemId != null && String(item.watchDogItemId) === t) return true;
  return false;
}

function issuesLocationFromAlertsEmailQuery(query) {
  var src = query && (typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(query)) === 'object' ? query : {};
  var next = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(src).forEach(function (k) {
    if (k === 'type' || k === 'id' || k === 'watchDogId' || k === 'watchdog_id') return;
    if (src[k] != null && src[k] !== '') next[k] = src[k];
  });

  var category = src.category;
  if (!category && src.type != null && src.type !== '') {
    category = categoryFromAlertEmailType(src.type);
  }
  if (category) next.category = category;

  var alertId = alertIdFromQuery(src);
  if (alertId) next.alertId = alertId;

  return { path: '/issues', query: next };
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CALENDLY_BOOKING_URL */
/* unused harmony export loadCalendly */
/* harmony export (immutable) */ __webpack_exports__["b"] = openCalendlyBooking;
/* harmony export (immutable) */ __webpack_exports__["a"] = registerCalendlyTracking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gtmEvents__ = __webpack_require__(22);


var CALENDLY_BOOKING_URL = 'https://calendly.com/raghav-tiwari-sentrykit/30min?hide_gdpr_banner=1&utm_source=app&utm_medium=connect_page&utm_campaign=connect_help';

var CALENDLY_ORIGIN = 'https://calendly.com';
var WIDGET_CSS = 'https://assets.calendly.com/assets/external/widget.css';
var WIDGET_JS = 'https://assets.calendly.com/assets/external/widget.js';

var pending = null;
var lastSource = 'connect';
var trackingRegistered = false;

function loadCalendly(cb, onError) {
  if (window.Calendly) return cb();
  if (pending) {
    pending.push({ cb: cb, onError: onError });
    return;
  }
  pending = [{ cb: cb, onError: onError }];
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = WIDGET_CSS;
  document.head.appendChild(link);
  var script = document.createElement('script');
  script.src = WIDGET_JS;
  script.async = true;
  script.onload = function () {
    var queue = pending;
    pending = null;
    queue.forEach(function (q) {
      q.cb();
    });
  };
  script.onerror = function () {
    var queue = pending;
    pending = null;

    if (script.parentNode) script.parentNode.removeChild(script);
    queue.forEach(function (q) {
      if (q.onError) q.onError();
    });
  };
  document.head.appendChild(script);
}

function openCalendlyBooking(prefill, source) {
  lastSource = source || 'connect';
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_call_click', source: lastSource });
  var p = prefill || {};
  var widgetPrefill = {};
  if (p.name) widgetPrefill.name = p.name;
  if (p.email) widgetPrefill.email = p.email;
  loadCalendly(function () {
    window.Calendly.initPopupWidget({ url: CALENDLY_BOOKING_URL, prefill: widgetPrefill });
  }, function () {
    window.open(CALENDLY_BOOKING_URL, '_blank', 'noopener');
  });
}

function registerCalendlyTracking() {
  if (trackingRegistered) return;
  trackingRegistered = true;
  window.addEventListener('message', function (e) {
    if (e.origin !== CALENDLY_ORIGIN || !e.data || !e.data.event) return;
    if (e.data.event === 'calendly.date_and_time_selected') __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__gtmEvents__["a" /* pushGtmEvent */])({ event: 'calendly_time_selected', source: lastSource });
    if (e.data.event === 'calendly.event_scheduled') __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__gtmEvents__["a" /* pushGtmEvent */])({ event: 'calendly_booked', source: lastSource });
  });
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EMAIL_ADDRESSES_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EMAIL_VERIFICATION_RESEND_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IDENTITY_SETTINGS_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACCOUNT_SETTINGS_PATH; });
/* unused harmony export parseVerifiedFlag */
/* harmony export (immutable) */ __webpack_exports__["d"] = emailAddressListFromResponseBody;
/* harmony export (immutable) */ __webpack_exports__["c"] = verificationStatusFromEmailAddresses;
/* harmony export (immutable) */ __webpack_exports__["e"] = verificationStatusFromIdentitySettings;
/* harmony export (immutable) */ __webpack_exports__["g"] = verificationStatusFromAuthBody;
/* harmony export (immutable) */ __webpack_exports__["h"] = verifyEmailStripContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var EMAIL_ADDRESSES_URL = '/api/identity/email-addresses';
var EMAIL_VERIFICATION_RESEND_URL = '/api/identity/verify-email/resend';
var IDENTITY_SETTINGS_URL = '/api/identity/settings';
var ACCOUNT_SETTINGS_PATH = '/settings/account';

function truthyFlag(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

function falsyFlag(value) {
  return value === false || value === 'false' || value === 0 || value === '0';
}

function parseVerifiedFlag(value) {
  if (value === undefined || value === null || value === '') return null;
  if (truthyFlag(value)) return true;
  if (falsyFlag(value)) return false;
  if (typeof value === 'string') {
    var s = value.trim().toLowerCase();
    if (s === 'verified' || s === 'yes') return true;
    if (s === 'unverified' || s === 'no' || s === 'pending') return false;
  }
  return null;
}

function normalizeEmail(email) {
  return email != null ? String(email).trim().toLowerCase() : '';
}

function pickId(row) {
  if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(row)) !== 'object') return null;
  var id = row.emailAddressId != null ? row.emailAddressId : row.email_address_id != null ? row.email_address_id : row.userAccountId != null ? row.userAccountId : row.user_account_id != null ? row.user_account_id : row.id != null ? row.id : null;
  if (id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined) id = id.value;
  if (id == null || id === '') return null;
  return id;
}

function rowEmail(row) {
  if (!row) return '';
  return normalizeEmail(row.email != null ? row.email : row.emailAddress);
}

function rowIsVerified(row) {
  if (!row) return null;
  var v = parseVerifiedFlag(row.isVerified);
  if (v !== null) return v;
  v = parseVerifiedFlag(row.is_verified);
  if (v !== null) return v;
  v = parseVerifiedFlag(row.emailVerified);
  if (v !== null) return v;
  v = parseVerifiedFlag(row.email_verified);
  if (v !== null) return v;
  v = parseVerifiedFlag(row.verified);
  if (v !== null) return v;
  if (row.status != null) {
    v = parseVerifiedFlag(row.status);
    if (v !== null) return v;
  }
  return null;
}

function emailAddressListFromResponseBody(body) {
  if (!body) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.emailAddresses)) return body.emailAddresses;
  if (Array.isArray(body.email_addresses)) return body.email_addresses;
  if (Array.isArray(body.emails)) return body.emails;
  if (Array.isArray(body.data)) return body.data;
  if (body.data && Array.isArray(body.data.emailAddresses)) return body.data.emailAddresses;
  if (body.data && Array.isArray(body.data.email_addresses)) return body.data.email_addresses;
  return [];
}

function verificationStatusFromEmailAddresses(list, loginEmail) {
  if (!Array.isArray(list) || list.length === 0) return null;
  var want = normalizeEmail(loginEmail);
  var match = null;
  if (want) {
    for (var i = 0; i < list.length; i++) {
      if (rowEmail(list[i]) === want) {
        match = list[i];
        break;
      }
    }

    if (!match) return null;
  } else {
    match = list.filter(function (r) {
      return r && (r.isPrimary === true || r.is_primary === true);
    })[0] || list[0];
  }
  if (!match) return null;
  var verified = rowIsVerified(match);
  if (verified === null) return null;
  return {
    emailVerified: verified,
    email: rowEmail(match) || want,
    emailAddressId: pickId(match)
  };
}

function verificationStatusFromIdentitySettings(body, loginEmail) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  var want = normalizeEmail(loginEmail || body.email);
  var accounts = Array.isArray(body.user_account) ? body.user_account : Array.isArray(body.userAccount) ? body.userAccount : [];
  var match = null;
  if (want && accounts.length) {
    for (var i = 0; i < accounts.length; i++) {
      if (rowEmail(accounts[i]) === want) {
        match = accounts[i];
        break;
      }
    }
  }
  if (!match && !want && accounts.length) {
    match = accounts.filter(function (ua) {
      return ua && (ua.isPrimary === true || ua.is_primary === true);
    })[0] || accounts[0];
  }
  if (match) {
    var verified = rowIsVerified(match);
    if (verified === null) {
      verified = true;
    }
    return {
      emailVerified: verified,
      email: rowEmail(match) || want,
      emailAddressId: pickId(match)
    };
  }
  var bodyVerified = parseVerifiedFlag(body.emailVerified);
  if (bodyVerified === null) bodyVerified = parseVerifiedFlag(body.email_verified);
  if (bodyVerified === null) bodyVerified = parseVerifiedFlag(body.isVerified);
  if (bodyVerified === null) bodyVerified = parseVerifiedFlag(body.is_verified);
  if (bodyVerified === null) return null;
  return {
    emailVerified: bodyVerified,
    email: want || normalizeEmail(body.email),
    emailAddressId: pickId(body)
  };
}

function verificationStatusFromAuthBody(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
  var verified = parseVerifiedFlag(body.emailVerified);
  if (verified === null) verified = parseVerifiedFlag(body.email_verified);
  if (verified === null) verified = parseVerifiedFlag(body.isVerified);
  if (verified === null) verified = parseVerifiedFlag(body.is_verified);
  if (verified === null) verified = parseVerifiedFlag(body.verified);
  if (verified === null) return null;
  return {
    emailVerified: verified,
    email: normalizeEmail(body.email),
    emailAddressId: pickId(body)
  };
}

function verifyEmailStripContent(opts) {
  opts = opts || {};
  var email = opts.email ? String(opts.email) : '';
  var sent = !!opts.verificationEmailSent;
  var sending = !!opts.verificationEmailSending;
  var messageHtml = sent ? 'Verification email sent' + (email ? ' to <strong>' + escapeHtml(email) + '</strong>' : '') + '. Check your inbox — email alerts stay off until you verify.' : 'Verify your account' + (email ? ' (<strong>' + escapeHtml(email) + '</strong>)' : '') + ' \u2014 otherwise email alerts won\u2019t trigger for you.';
  return {
    tone: 'orange',
    messageHtml: messageHtml,
    ctaLabel: sending ? 'Sending\u2026' : sent ? 'Resend again' : 'Resend verification',
    ctaAction: 'resend-verification',
    dismissible: false
  };
}

function escapeHtml(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isSignupPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAsgtgSignupPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = isConnectInvitePath;
/* harmony export (immutable) */ __webpack_exports__["a"] = isPublicAuthPath;


function normalizePath(path) {
  return String(path || '').toLowerCase().replace(/\/+$/, '') || '/';
}

function isSignupPath(path) {
  var p = normalizePath(path);
  return p === '/signup' || p === '/asgtg/signup';
}

function isAsgtgSignupPath(path) {
  return normalizePath(path) === '/asgtg/signup';
}

function isConnectInvitePath(path) {
  return (/^\/connect\/invite\/[^/]+$/.test(normalizePath(path))
  );
}

function isPublicAuthPath(path) {
  var p = normalizePath(path);
  return p === '/login' || isSignupPath(path) || p === '/forgotpassword' || p === '/resetpassword' || p === '/verify-email' || isConnectInvitePath(path);
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_productPricing_js__ = __webpack_require__(433);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    productReader: function productReader() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_productPricing_js__["a" /* createProductReaderFromVm */])(this);
    }
  },
  methods: {
    readProduct: function readProduct(product) {
      return this.productReader.read(product);
    },
    hasProductCogs: function hasProductCogs(product) {
      return this.productReader.hasCogs(product);
    },
    getProductCogs: function getProductCogs(product) {
      return this.productReader.getCogs(product);
    },
    getProductMargin: function getProductMargin(product) {
      return this.productReader.getMargin(product);
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_CAMPAIGNS */
/* unused harmony export SET_PRODUCTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SELLERS; });
var SET_CAMPAIGNS = 'SET_CAMPAIGNS';
var SET_PRODUCTS = 'SET_PRODUCTS';
var SET_SELLERS = 'SET_SELLERS';

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AMAZON_AUTHORIZATION_REDIRECT_URL */
/* harmony export (immutable) */ __webpack_exports__["a"] = startAmazonAuthorization;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtmEvents__ = __webpack_require__(22);




var AMAZON_AUTHORIZATION_REDIRECT_URL = '/api/identity/amazon/authorization/redirect';

var START_FAILED = 'Failed to start authorization';

function startAmazonAuthorization(http, options) {
  var opts = options || {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__gtmEvents__["c" /* markConnectStoreStarted */])(opts.method);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var amazonUrl = null;
    var gtmDone = false;
    var failed = false;
    function goAmazonWhenReady() {
      if (failed || !amazonUrl || !gtmDone) return;
      window.location = amazonUrl;
      resolve(amazonUrl);
    }
    function fail(message) {
      failed = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_store_failed', error_reason: message });
      reject(message);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__gtmEvents__["a" /* pushGtmEvent */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ event: 'connect_store_started', step: 2 }, opts.gtm), function () {
      gtmDone = true;
      goAmazonWhenReady();
    });
    http.get(opts.url || AMAZON_AUTHORIZATION_REDIRECT_URL, { params: opts.params }).then(function (response) {
      amazonUrl = response.body && response.body.location;
      if (!amazonUrl) return fail(START_FAILED);
      goAmazonWhenReady();
    }, function (response) {
      fail(response.body && response.body.message || START_FAILED);
    });
  });
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = {
  logoShieldIcon: __webpack_require__(626),
  sentrykitWordmark: __webpack_require__(627)
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_SSO_ERROR_MESSAGES; });
/* harmony export (immutable) */ __webpack_exports__["c"] = googleReturnPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = startGoogleSignIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtmEvents__ = __webpack_require__(22);




var GOOGLE_SSO_ERROR_MESSAGES = {
  google_cancelled: 'Google sign-in was cancelled. You can try again or use your email.',
  google_unverified: "Your Google email isn't verified. Verify it with Google, or use your email instead.",
  google_mismatch: 'This email is linked to a different Google account. Log in with your password, or use the Google account you signed up with.',
  google_expired: 'Your Google sign-in expired. Please try again.',
  google_unavailable: "Google sign-in isn't available right now. Please use your email.",
  google_failed: 'Something went wrong with Google sign-in. Please try again or use your email.',
  account_locked: 'This account is temporarily locked after too many attempts. Try again later or reset your password.'
};

var TRANSIENT_PARAMS = ['sso', 'sso_error', 'finish', 'handoff'];

function googleReturnPath(route) {
  var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, route.query);
  TRANSIENT_PARAMS.forEach(function (key) {
    delete query[key];
  });
  var search = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(query[key]);
  }).join('&');
  return route.path + (search ? '?' + search : '');
}

function startGoogleSignIn(intent, returnPath, source) {
  var url = '/api/auth/google/start?intent=' + encodeURIComponent(intent) + '&source=' + encodeURIComponent(source || '') + '&return=' + encodeURIComponent(returnPath);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_click', provider: 'google' }, function () {
    window.location = url;
  });
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export itemMatchesMarketFilter */
/* unused harmony export itemMatchesSellerFilter */
/* unused harmony export itemHasProductContext */
/* unused harmony export itemMatchesDateRange */
/* harmony export (immutable) */ __webpack_exports__["a"] = filterIssuesItemsGlobally;
/* harmony export (immutable) */ __webpack_exports__["f"] = isCompetitorPriceOpenChange;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIssuesActiveTabItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = isIssuesResolvedTabItem;
/* unused harmony export countIssuesCategoryVisible */
/* harmony export (immutable) */ __webpack_exports__["d"] = countIssuesNewAlertsFiltered;
/* harmony export (immutable) */ __webpack_exports__["e"] = sortIssuesItemsForTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




function itemMatchesMarketFilter(item, filterByMarket, products) {
  if (!filterByMarket || filterByMarket.length === 0) return true;
  var mp = item.marketplace == null || item.marketplace === '' ? '' : String(item.marketplace).toUpperCase();
  if (!mp && products && item.productId && products[item.productId]) {
    var pmp = products[item.productId].marketplace;
    if (pmp != null && pmp !== '') mp = String(pmp).toUpperCase();
  }
  if (mp === 'GB') mp = 'UK';
  var filters = filterByMarket;
  for (var i = 0; i < filters.length; i++) {
    var f = String(filters[i]).toUpperCase();
    var x = f === 'GB' ? 'UK' : f;
    if (x === mp) return true;
  }
  return false;
}

function itemMatchesSellerFilter(item, filterBySellAcc) {
  if (!filterBySellAcc || filterBySellAcc.length === 0) return true;
  if (item.sellerId === null || item.sellerId === undefined) return false;
  var sid = item.sellerId;
  var filters = filterBySellAcc;
  for (var j = 0; j < filters.length; j++) {
    var f = filters[j];
    if (String(f) === String(sid)) return true;
    var nf = Number(f);
    var ns = Number(sid);
    if (!isNaN(nf) && !isNaN(ns) && nf === ns) return true;
  }
  return false;
}

function itemHasProductContext(i, products) {
  if (i.productId != null && i.productId !== '' && products[i.productId]) return true;
  if (i.productId != null && i.productId !== '') {
    if (i.asin && String(i.asin).trim()) return true;
    if (i.title && String(i.title).trim()) return true;
    var msg = i.statusDetails && i.statusDetails.message;
    if (msg && String(msg).trim()) return true;
  }
  if (i.watchDogId != null && i.watchDogId !== '' && (i.productId == null || i.productId === '')) {
    return true;
  }
  return false;
}

function itemMatchesDateRange(item, dateRange, nowMs) {
  if (!dateRange || dateRange === 'all' || dateRange === 'all time') return true;
  var now = nowMs != null ? nowMs : Date.now();
  var cutoff = 0;
  if (dateRange === 'today') {
    var todayStart = new Date(now);
    todayStart.setHours(0, 0, 0, 0);
    cutoff = todayStart.getTime();
  } else if (dateRange === '7d') {
    cutoff = now - 7 * 24 * 60 * 60 * 1000;
  } else if (dateRange === '30d') {
    cutoff = now - 30 * 24 * 60 * 60 * 1000;
  } else if (dateRange === '90d') {
    cutoff = now - 90 * 24 * 60 * 60 * 1000;
  }
  if (cutoff <= 0) return true;
  if (!item.date) return true;
  return new Date(item.date).getTime() >= cutoff;
}

function filterIssuesItemsGlobally(itemsArray, products, filterByMarket, filterBySellAcc, dateRange, nowMs) {
  var arr = itemsArray.slice();
  if (filterByMarket && filterByMarket.length > 0) {
    arr = arr.filter(function (i) {
      return itemMatchesMarketFilter(i, filterByMarket, products);
    });
  }
  if (filterBySellAcc && filterBySellAcc.length > 0) {
    arr = arr.filter(function (i) {
      return itemMatchesSellerFilter(i, filterBySellAcc);
    });
  }
  arr = arr.filter(function (i) {
    return itemHasProductContext(i, products);
  });
  arr = arr.filter(function (i) {
    return itemMatchesDateRange(i, dateRange, nowMs);
  });
  return arr;
}

function isCompetitorPriceOpenChange(item) {
  if (!item || item.muted || item.issueStatus === 3) return false;
  if (item.status !== 0 && item.status !== 99 && String(item.status).toLowerCase() !== 'green') return false;
  var d = item.statusDetails || {};
  var change = d.last_competitor_change || d.lastCompetitorChange;
  return !!(change && (typeof change === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(change)) === 'object');
}

function isIssuesActiveTabItem(item) {
  if (isCompetitorPriceOpenChange(item)) return true;
  return (item.status === 1 || item.status === 2) && !item.muted && item.issueStatus < 3;
}

function isIssuesResolvedTabItem(item) {
  if (!item || item.muted) return false;
  if (isCompetitorPriceOpenChange(item)) return false;

  if (item.issueStatus === 3) return true;
  return item.status === 99 || item.status === 0;
}

function countIssuesCategoryVisible(itemsObj, products, filterByMarket, filterBySellAcc, dateRange, nowMs) {
  var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(itemsObj || {});
  arr = filterIssuesItemsGlobally(arr, products || {}, filterByMarket || [], filterBySellAcc || [], dateRange, nowMs);
  var active = 0;
  for (var i = 0; i < arr.length; i++) {
    if (isIssuesActiveTabItem(arr[i])) active++;
  }
  return active;
}

function countIssuesNewAlertsFiltered(itemsObj, products, filterByMarket, filterBySellAcc, dateRange, nowMs) {
  var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(itemsObj || {});
  arr = filterIssuesItemsGlobally(arr, products || {}, filterByMarket || [], filterBySellAcc || [], dateRange, nowMs);
  var count = 0;
  for (var j = 0; j < arr.length; j++) {
    var item = arr[j];
    if (item && !item.muted && item.issueStatus === 0 && (item.status === 1 || item.status === 2 || isCompetitorPriceOpenChange(item))) {
      count++;
    }
  }
  return count;
}

function sortIssuesItemsForTab(arr, tab, products) {
  arr.sort(function (a, b) {
    var prodA = a.productId && products[a.productId] ? products[a.productId] : null;
    var prodB = b.productId && products[b.productId] ? products[b.productId] : null;
    var titleA = prodA && prodA.productTitle ? prodA.productTitle : '';
    var titleB = prodB && prodB.productTitle ? prodB.productTitle : '';
    return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
  });
  if (tab === 'active') {
    arr.sort(function (a, b) {
      return b.status - a.status;
    });
  }
  return arr;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isProductAddonApplicable */
/* unused harmony export resolveProductAddonCount */
/* unused harmony export productAddonMonthlyFeeCents */
/* unused harmony export totalSubscriptionFeeCents */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatAccountPlanPricingSubline;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLegacyBillingPricingLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



function num(value) {
  var n = Number(value);
  return isNaN(n) ? 0 : n;
}

function isProductAddonApplicable(packageDetails) {
  if (!packageDetails || (typeof packageDetails === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(packageDetails)) !== 'object') return false;
  var fee = num(packageDetails.addonSubscriptionFeeCents != null ? packageDetails.addonSubscriptionFeeCents : packageDetails.addon_subscription_fee_cents);
  var block = num(packageDetails.addonSubscriptionProducts != null ? packageDetails.addonSubscriptionProducts : packageDetails.addon_subscription_products);
  return fee > 0 && block > 0;
}

function resolveProductAddonCount(packageDetails, addonCount) {
  if (addonCount != null && addonCount !== '') return Math.max(0, num(addonCount));
  if (packageDetails) {
    var fromPkg = packageDetails.addonCount != null ? packageDetails.addonCount : packageDetails.addon_count;
    if (fromPkg != null && fromPkg !== '') return Math.max(0, num(fromPkg));
    var suggested = packageDetails.suggestedAddonCount != null ? packageDetails.suggestedAddonCount : packageDetails.suggested_addon_count;
    if (suggested != null && suggested !== '') return Math.max(0, num(suggested));
  }
  return 0;
}

function productAddonMonthlyFeeCents(packageDetails, addonCount) {
  if (!isProductAddonApplicable(packageDetails)) return 0;
  var count = resolveProductAddonCount(packageDetails, addonCount);
  var fee = num(packageDetails.addonSubscriptionFeeCents || packageDetails.addon_subscription_fee_cents);
  return count * fee;
}

function totalSubscriptionFeeCents(packageDetails, addonCount) {
  if (!packageDetails) return 0;
  var base = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents);
  return base + productAddonMonthlyFeeCents(packageDetails, addonCount);
}

function formatDollars(cents, fixed) {
  var n = num(cents) / 100;
  if (fixed) return '$' + n.toFixed(fixed);
  if (Math.floor(n) === n) return '$' + n;
  return '$' + n.toFixed(2);
}

function formatAccountPlanPricingSubline(packageDetails, addonCount) {
  if (!packageDetails) return '';
  var baseCents = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents);
  var count = resolveProductAddonCount(packageDetails, addonCount);

  var packageKey = String(packageDetails.packageKey != null ? packageDetails.packageKey : packageDetails.package_key || '').toUpperCase();
  var period = packageKey === 'FLAT_YEARLY' || String(packageDetails.tier || '') === 'flat_yearly' ? '/year' : '/month';

  if (!isProductAddonApplicable(packageDetails) || count <= 0) {
    return formatDollars(baseCents) + period;
  }

  var totalCents = totalSubscriptionFeeCents(packageDetails, count);
  return formatDollars(totalCents) + '/month (+' + count + ' add-on' + (count === 1 ? '' : 's') + ')';
}

function formatLegacyBillingPricingLine(packageDetails, addonCount) {
  if (!packageDetails) return '';
  var baseCents = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents);
  var count = resolveProductAddonCount(packageDetails, addonCount);

  if (!isProductAddonApplicable(packageDetails)) {
    return formatDollars(baseCents, 0) + '/mo base · see invoices for ASIN usage';
  }

  if (count <= 0) {
    return formatDollars(baseCents, 0) + '/mo base · add-ons apply above included listings';
  }

  var addonFeeCents = num(packageDetails.addonSubscriptionFeeCents || packageDetails.addon_subscription_fee_cents);
  var block = num(packageDetails.addonSubscriptionProducts || packageDetails.addon_subscription_products);
  var totalCents = totalSubscriptionFeeCents(packageDetails, count);
  var perBlock = formatDollars(addonFeeCents, 0);
  return formatDollars(totalCents, 0) + '/mo total (' + formatDollars(baseCents, 0) + ' base + ' + count + ' add-on' + (count === 1 ? '' : 's') + ' @ ' + perBlock + '/mo per ' + block + ' listings)';
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseJsonIfNeeded;
/* harmony export (immutable) */ __webpack_exports__["e"] = extractSalesVolumeListItems;
/* harmony export (immutable) */ __webpack_exports__["c"] = productIdFromSalesVolumeRow;
/* harmony export (immutable) */ __webpack_exports__["a"] = salesVolumeHttpResponseEntity;
/* harmony export (immutable) */ __webpack_exports__["g"] = salesVolumeListingIdFromProduct;
/* unused harmony export unwrapApiNumber */
/* harmony export (immutable) */ __webpack_exports__["d"] = salesVolumeFormToApiSettings;
/* harmony export (immutable) */ __webpack_exports__["f"] = formFieldsFromSalesVolumeSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




function parseJsonIfNeeded(v) {
  if (v == null) return null;
  if (typeof v === 'string') {
    try {
      return JSON.parse(v);
    } catch (e) {
      return null;
    }
  }
  return v;
}

function extractSalesVolumeListItems(rawBody) {
  if (Array.isArray(rawBody)) return rawBody;
  var body = parseJsonIfNeeded(rawBody);
  if (body == null) body = rawBody;
  if (body == null) return [];
  if (typeof body === 'string') {
    body = parseJsonIfNeeded(body);
    if (body == null || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body)) !== 'object') return [];
  }
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.items)) return body.items;
  if (body.items && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.items) === 'object' && !Array.isArray(body.items)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body.items).map(function (k) {
      return body.items[k];
    }).filter(Boolean);
  }
  var data = body.data;
  data = parseJsonIfNeeded(data);
  if (data != null && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data)) return data;
  }
  if (body.result && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.result) === 'object') {
    if (Array.isArray(body.result.items)) return body.result.items;
    if (Array.isArray(body.result)) return body.result;
  }
  if (body.payload && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body.payload) === 'object' && Array.isArray(body.payload.items)) return body.payload.items;
  if (Array.isArray(body.listings)) return body.listings;
  if (Array.isArray(body.rows)) return body.rows;
  if (Array.isArray(body.results)) return body.results;
  if (Array.isArray(body.content)) return body.content;
  if (Array.isArray(body.records)) return body.records;
  if (body._embedded && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(body._embedded) === 'object') {
    var emb = body._embedded;
    if (Array.isArray(emb.salesVolumeAlertThresholds)) return emb.salesVolumeAlertThresholds;
    if (Array.isArray(emb.items)) return emb.items;
    var ek = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(emb);
    for (var ei = 0; ei < ek.length; ei++) {
      if (Array.isArray(emb[ek[ei]])) return emb[ek[ei]];
    }
  }
  var dataScan = parseJsonIfNeeded(body.data);
  if (dataScan == null) dataScan = body.data;
  if (dataScan != null && (typeof dataScan === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dataScan)) === 'object' && !Array.isArray(dataScan)) {
    var dk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataScan);
    for (var di = 0; di < dk.length; di++) {
      var dv = dataScan[dk[di]];
      if (Array.isArray(dv) && dv.length && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dv[0]) === 'object') return dv;
    }
  }
  var bk = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(body);
  for (var bi = 0; bi < bk.length; bi++) {
    var bv = body[bk[bi]];
    if (!Array.isArray(bv) || !bv.length || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(bv[0]) !== 'object') continue;
    var z = bv[0];
    if (z.product_id != null || z.productId != null || z.listing_id != null || z.asin != null) return bv;
  }
  return [];
}

function productIdFromSalesVolumeRow(row) {
  if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(row)) !== 'object') return '';
  if (row.product_id != null) return String(row.product_id);
  if (row.productId != null) return String(row.productId);
  if (row.listing_id != null) return String(row.listing_id);
  if (row.id != null) return String(row.id);
  return '';
}

function salesVolumeHttpResponseEntity(res) {
  if (res == null) return null;
  if (Array.isArray(res)) return res;
  if (res.body !== undefined && res.body !== null && res.body !== '') return res.body;
  if (res.data !== undefined && res.data !== null && res.data !== '') return res.data;
  if (res.bodyText != null && res.bodyText !== '') return res.bodyText;
  if ((typeof res === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(res)) === 'object' && !Array.isArray(res)) {
    var hasListShape = Object.prototype.hasOwnProperty.call(res, 'items') || Object.prototype.hasOwnProperty.call(res, 'total') || Object.prototype.hasOwnProperty.call(res, 'page') || Object.prototype.hasOwnProperty.call(res, 'page_size');

    if (hasListShape) return res;
  }
  return null;
}

function salesVolumeListingIdFromProduct(p) {
  if (!p || (typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p)) !== 'object') return '';
  if (p.productId !== undefined && p.productId !== null && p.productId !== '') return String(p.productId);
  if (p.product_id !== undefined && p.product_id !== null && p.product_id !== '') return String(p.product_id);
  if (p.id !== undefined && p.id !== null && p.id !== '') return String(p.id);
  return '';
}

function unwrapApiNumber(v) {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'number' && !isNaN(v)) return v;
  if (typeof v === 'string') {
    var t = v.trim();
    if (t === '') return null;
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) === 'object' && v !== null) {
    if ('value' in v) return unwrapApiNumber(v.value);
    if ('$numberDecimal' in v) return unwrapApiNumber(v.$numberDecimal);
  }
  var x = Number(v);
  return isNaN(x) ? null : x;
}

function toPayloadVal(v) {
  if (v === null || v === undefined || v === '') return null;
  var n = Number(v);
  return isNaN(n) ? null : n;
}

function salesVolumeFormToApiSettings(form) {
  if (!form || (typeof form === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(form)) !== 'object') return {};
  return {
    no_sales_hours: toPayloadVal(form.noSalesHours),
    daily_sales_floor: toPayloadVal(form.dailyFloor),
    daily_sales_ceiling: toPayloadVal(form.dailyCeiling),
    rolling_drop_percent: toPayloadVal(form.rollingDrop),
    rolling_spike_percent: toPayloadVal(form.rollingSpike),
    rolling_avg_days: toPayloadVal(form.rollingDays),
    rolling_min_units: toPayloadVal(form.rollingMinUnits),
    bsr_alert_above: toPayloadVal(form.bsrAbove)
  };
}

function numNonNeg(v) {
  var n = unwrapApiNumber(v);
  if (n === null) return null;
  return n >= 0 ? n : null;
}

function numPos(v) {
  var n = unwrapApiNumber(v);
  if (n === null) return null;
  return n > 0 ? n : null;
}

function pick(a, b) {
  return a !== undefined && a !== null ? a : b;
}

function formFieldsFromSalesVolumeSettings(s) {
  s = s || {};
  return {
    noSalesHours: numPos(pick(s.no_sales_hours, s.noSalesHours)),
    dailyFloor: numNonNeg(pick(s.daily_sales_floor, s.dailyFloor)),
    dailyCeiling: numNonNeg(pick(s.daily_sales_ceiling, s.dailyCeiling)),
    rollingDrop: numPos(pick(s.rolling_drop_percent, s.rollingDropPercent)),
    rollingSpike: numPos(pick(s.rolling_spike_percent, s.rollingSpikePercent)),
    rollingDays: numPos(pick(s.rolling_avg_days, s.rollingAvgDays)),
    rollingMinUnits: numNonNeg(pick(s.rolling_min_units, s.rollingMinUnits)),
    bsrAbove: numPos(pick(s.bsr_alert_above, s.bsrAlertAbove))
  };
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STRIPE_PUBLISHABLE_KEY_DEV */
/* unused harmony export isDevSentrykitHost */
/* harmony export (immutable) */ __webpack_exports__["a"] = stripePublishableKey;


var STRIPE_PUBLISHABLE_KEY_DEV = 'pk_test_FsvViTDQA6DQaHXMFpvvd0uH';

function isDevSentrykitHost() {
  if (typeof window === 'undefined' || !window.location) return false;
  var host = String(window.location.hostname || '').toLowerCase();
  return host === 'dev.sentrykit.com';
}

function stripePublishableKey() {
  if (isDevSentrykitHost()) {
    return STRIPE_PUBLISHABLE_KEY_DEV;
  }
  return "pk_live_51IiN5zCYSDSBygvjHlMVXP4xJwK3BGmNg0OInT2Dw7QiJv5jxHt3cTheowMg6cHeXpbs9OWGxpfU6WxeMO6NpkJp00RmGpHkzx" || '';
}

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  "data-v-3c7bdfe3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-44b641d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-0510c92c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)
__webpack_require__(557)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-4095c260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-4c494172",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  "data-v-3562ec3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  "data-v-5773c2e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);



var styleInjected = false;

function injectStyle() {
  if (styleInjected || typeof document === 'undefined') return;
  styleInjected = true;
  var style = document.createElement('style');
  style.textContent = ['@keyframes sk-autofill-start { from { opacity: 1 } to { opacity: 1 } }', 'input[data-sk-search]:-webkit-autofill { animation-name: sk-autofill-start; animation-duration: 1ms; }', 'input[data-sk-search] { -webkit-appearance: textfield; appearance: textfield; }', 'input[data-sk-search][readonly] { cursor: text; background-color: #fff !important; opacity: 1; }', 'input[data-sk-search]::-webkit-search-decoration,', 'input[data-sk-search]::-webkit-search-cancel-button,', 'input[data-sk-search]::-webkit-search-results-button,', 'input[data-sk-search]::-webkit-search-results-decoration { -webkit-appearance: none; display: none; }'].join('\n');
  document.head.appendChild(style);
}

function wanted(binding) {
  if (!binding || !Object.prototype.hasOwnProperty.call(binding, 'value')) return null;
  if (binding.value == null) return '';
  return String(binding.value);
}

function remember(el, binding) {
  var want = wanted(binding);
  el._skAccepted = want == null ? el.value || '' : want;
}

function markUser(el) {
  el._skUserEdited = true;
  el.removeAttribute('readonly');
}

function rejectUnsolicited(el) {
  if (el._skUserEdited) {
    el._skAccepted = el.value;
    return;
  }
  var accepted = el._skAccepted == null ? '' : el._skAccepted;
  if (el.value === accepted) return;
  el._skRejecting = true;
  el.value = accepted;
  el._skRejecting = false;
}

function unlock(el) {
  el.removeAttribute('readonly');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    injectStyle();
    el.setAttribute('data-sk-search', 'true');
    el.setAttribute('autocomplete', 'off');
    el.setAttribute('autocorrect', 'off');
    el.setAttribute('autocapitalize', 'none');
    el.setAttribute('spellcheck', 'false');
    el.setAttribute('data-lpignore', 'true');
    el.setAttribute('data-1p-ignore', 'true');
    el.setAttribute('data-bwignore', 'true');
    el.setAttribute('data-form-type', 'other');
    el.setAttribute('name', 'sk-q-' + Math.random().toString(36).slice(2));
    el.setAttribute('readonly', 'readonly');
    el._skUserEdited = false;
    el._skRejecting = false;
    remember(el, binding);

    el.addEventListener('pointerdown', function () {
      unlock(el);
    });
    el.addEventListener('keydown', function () {
      markUser(el);
    });
    el.addEventListener('paste', function () {
      markUser(el);
    });
    el.addEventListener('drop', function () {
      markUser(el);
    });
    el.addEventListener('focus', function () {
      unlock(el);
      setTimeout(function () {
        rejectUnsolicited(el);
      }, 0);
      setTimeout(function () {
        rejectUnsolicited(el);
      }, 250);
      setTimeout(function () {
        rejectUnsolicited(el);
      }, 800);
    });

    el.addEventListener('input', function () {
      rejectUnsolicited(el);
    }, true);
    el.addEventListener('change', function () {
      rejectUnsolicited(el);
    }, true);
    el.addEventListener('animationstart', function (e) {
      if (e.animationName === 'sk-autofill-start') rejectUnsolicited(el);
    });
  },
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
      if (el._skUserEdited || el._skRejecting) return;
      remember(el, binding);
      rejectUnsolicited(el);
    });
  },
  componentUpdated: function componentUpdated(el, binding) {
    if (el._skUserEdited || el._skRejecting) return;
    remember(el, binding);
    if (el.value !== el._skAccepted) el.value = el._skAccepted;
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_sellers__ = __webpack_require__(428);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  modules: {
    sellers: __WEBPACK_IMPORTED_MODULE_4__modules_sellers__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].store
  },
  strict: false,
  plugins: []
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, store);
var translationsEn = { 'content_dummy': 'This is some default content' };
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('en', translationsEn);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set('en');

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSharedApiSession;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);



function createSharedApiSession() {
  var values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null);
  var inflight = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null);

  return {
    get: function get(key, loader, force) {
      if (!force && Object.prototype.hasOwnProperty.call(values, key)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(values[key]);
      }
      if (!force && inflight[key]) return inflight[key];
      inflight[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(loader).then(function (value) {
        values[key] = value;
        delete inflight[key];
        return value;
      }, function (err) {
        delete inflight[key];
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
      return inflight[key];
    },
    clear: function clear(key) {
      if (key == null) {
        values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null);
        inflight = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null);
        return;
      }
      delete values[key];
      delete inflight[key];
    },
    peek: function peek(key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : undefined;
    }
  };
}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-02d8dd74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  "data-v-0b4cd658",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-33c95238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  "data-v-3d529a0d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  "data-v-de9b34fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  "data-v-d420b0f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(754),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  "data-v-5f1be5e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  "data-v-064bffce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-43c7358d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  "data-v-59e2cff7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  "data-v-5467dc7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  "data-v-a5c1d08a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  "data-v-1d3edbc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  "data-v-6c161ef2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  "data-v-32ce7ad0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-5648897c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  "data-v-8703e158",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  "data-v-b3f63c28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-ce22300c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)
__webpack_require__(586)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-7c0fe644",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  "data-v-2bd1f5cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) { /*
 * # Semantic UI - 2.3.1
 * https://github.com/Semantic-Org/Semantic-UI
 * http://www.semantic-ui.com/
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
!function(e,t,n,i){e.site=e.fn.site=function(o){var a,r,s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1),f=e.isPlainObject(o)?e.extend(!0,{},e.site.settings,o):e.extend({},e.site.settings),m=f.namespace,g=f.error,p="module-"+m,h=e(n),v=this,b=h.data(p);return a={initialize:function(){a.instantiate()},instantiate:function(){a.verbose("Storing instance of site",a),b=a,h.data(p,a)},normalize:function(){a.fix.console(),a.fix.requestAnimationFrame()},fix:{console:function(){a.debug("Normalizing window.console"),console!==i&&console.log!==i||(a.verbose("Console not available, normalizing events"),a.disable.console()),void 0!==console.group&&void 0!==console.groupEnd&&void 0!==console.groupCollapsed||(a.verbose("Console group not available, normalizing events"),t.console.group=function(){},t.console.groupEnd=function(){},t.console.groupCollapsed=function(){}),void 0===console.markTimeline&&(a.verbose("Mark timeline not available, normalizing events"),t.console.markTimeline=function(){})},consoleClear:function(){a.debug("Disabling programmatic console clearing"),t.console.clear=function(){}},requestAnimationFrame:function(){a.debug("Normalizing requestAnimationFrame"),t.requestAnimationFrame===i&&(a.debug("RequestAnimationFrame not available, normalizing event"),t.requestAnimationFrame=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)})}},moduleExists:function(t){return e.fn[t]!==i&&e.fn[t].settings!==i},enabled:{modules:function(t){var n=[];return t=t||f.modules,e.each(t,function(e,t){a.moduleExists(t)&&n.push(t)}),n}},disabled:{modules:function(t){var n=[];return t=t||f.modules,e.each(t,function(e,t){a.moduleExists(t)||n.push(t)}),n}},change:{setting:function(t,n,o,r){o="string"==typeof o?"all"===o?f.modules:[o]:o||f.modules,r=r===i||r,e.each(o,function(i,o){var s,l=!a.moduleExists(o)||(e.fn[o].settings.namespace||!1);a.moduleExists(o)&&(a.verbose("Changing default setting",t,n,o),e.fn[o].settings[t]=n,r&&l&&(s=e(":data(module-"+l+")")).length>0&&(a.verbose("Modifying existing settings",s),s[o]("setting",t,n)))})},settings:function(t,n,o){n="string"==typeof n?[n]:n||f.modules,o=o===i||o,e.each(n,function(n,i){var r;a.moduleExists(i)&&(a.verbose("Changing default setting",t,i),e.extend(!0,e.fn[i].settings,t),o&&m&&(r=e(":data(module-"+m+")")).length>0&&(a.verbose("Modifying existing settings",r),r[i]("setting",t)))})}},enable:{console:function(){a.console(!0)},debug:function(e,t){e=e||f.modules,a.debug("Enabling debug for modules",e),a.change.setting("debug",!0,e,t)},verbose:function(e,t){e=e||f.modules,a.debug("Enabling verbose debug for modules",e),a.change.setting("verbose",!0,e,t)}},disable:{console:function(){a.console(!1)},debug:function(e,t){e=e||f.modules,a.debug("Disabling debug for modules",e),a.change.setting("debug",!1,e,t)},verbose:function(e,t){e=e||f.modules,a.debug("Disabling verbose debug for modules",e),a.change.setting("verbose",!1,e,t)}},console:function(e){if(e){if(b.cache.console===i)return void a.error(g.console);a.debug("Restoring console function"),t.console=b.cache.console}else a.debug("Disabling console function"),b.cache.console=t.console,t.console={clear:function(){},error:function(){},group:function(){},groupCollapsed:function(){},groupEnd:function(){},info:function(){},log:function(){},markTimeline:function(){},warn:function(){}}},destroy:function(){a.verbose("Destroying previous site for",h),h.removeData(p)},cache:{},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,a,t);else{if(n===i)return a[t];a[t]=n}},debug:function(){f.debug&&(f.performance?a.performance.log(arguments):(a.debug=Function.prototype.bind.call(console.info,console,f.name+":"),a.debug.apply(console,arguments)))},verbose:function(){f.verbose&&f.debug&&(f.performance?a.performance.log(arguments):(a.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),a.verbose.apply(console,arguments)))},error:function(){a.error=Function.prototype.bind.call(console.error,console,f.name+":"),a.error.apply(console,arguments)},performance:{log:function(e){var t,n;f.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Element:v,Name:e[0],Arguments:[].slice.call(e,1)||"","Execution Time":n})),clearTimeout(a.performance.timer),a.performance.timer=setTimeout(a.performance.display,500)},display:function(){var t=f.name+":",n=0;s=!1,clearTimeout(a.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,o){var s,l,c,u=b;return n=n||d,o=v||o,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(n,o){var r=n!=s?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(u[r])&&n!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[o])||n==s)return u[o]!==i?(l=u[o],!1):(a.error(g.method,t),!1);u=u[o]}})),e.isFunction(l)?c=l.apply(o,n):l!==i&&(c=l),e.isArray(r)?r.push(c):r!==i?r=[r,c]:c!==i&&(r=c),l}},u?(b===i&&a.initialize(),a.invoke(c)):(b!==i&&a.destroy(),a.initialize()),r!==i?r:this},e.site.settings={name:"Site",namespace:"site",error:{console:"Console cannot be restored, most likely it was overwritten outside of module",method:"The method you called is not defined."},debug:!1,verbose:!1,performance:!0,modules:["accordion","api","checkbox","dimmer","dropdown","embed","form","modal","nag","popup","rating","shape","sidebar","state","sticky","tab","transition","visit","visibility"],siteNamespace:"site",namespaceStub:{cache:{},config:{},sections:{},section:{},utilities:{}}},e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(n){return!!e.data(n,t)}}):function(t,n,i){return!!e.data(t,i[3])}})}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.form=function(t){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u=arguments[1],d="string"==typeof c,f=[].slice.call(arguments,1);return a.each(function(){var m,g,p,h,v,b,y,x,C,w,S,k,T,A,R,P,E=e(this),F=this,O=[],D=!1;(P={initialize:function(){P.get.settings(),d?(R===i&&P.instantiate(),P.invoke(c)):(R!==i&&R.invoke("destroy"),P.verbose("Initializing form validation",E,v),P.bindEvents(),P.set.defaults(),P.instantiate())},instantiate:function(){P.verbose("Storing instance of module",P),R=P,E.data(T,P)},destroy:function(){P.verbose("Destroying previous module",R),P.removeEvents(),E.removeData(T)},refresh:function(){P.verbose("Refreshing selector cache"),m=E.find(x.field),g=E.find(x.group),p=E.find(x.message),E.find(x.prompt),h=E.find(x.submit),E.find(x.clear),E.find(x.reset)},submit:function(){P.verbose("Submitting form",E),E.submit()},attachEvents:function(t,n){n=n||"submit",e(t).on("click"+A,function(e){P[n](),e.preventDefault()})},bindEvents:function(){P.verbose("Attaching form events"),E.on("submit"+A,P.validate.form).on("blur"+A,x.field,P.event.field.blur).on("click"+A,x.submit,P.submit).on("click"+A,x.reset,P.reset).on("click"+A,x.clear,P.clear),v.keyboardShortcuts&&E.on("keydown"+A,x.field,P.event.field.keydown),m.each(function(){var t=e(this),n=t.prop("type"),i=P.get.changeEvent(n,t);e(this).on(i+A,P.event.field.change)})},clear:function(){m.each(function(){var t=e(this),n=t.parent(),i=t.closest(g),o=i.find(x.prompt),a=t.data(y.defaultValue)||"",r=n.is(x.uiCheckbox),s=n.is(x.uiDropdown);i.hasClass(C.error)&&(P.verbose("Resetting error on field",i),i.removeClass(C.error),o.remove()),s?(P.verbose("Resetting dropdown value",n,a),n.dropdown("clear")):r?t.prop("checked",!1):(P.verbose("Resetting field value",t,a),t.val(""))})},reset:function(){m.each(function(){var t=e(this),n=t.parent(),o=t.closest(g),a=o.find(x.prompt),r=t.data(y.defaultValue),s=n.is(x.uiCheckbox),l=n.is(x.uiDropdown),c=o.hasClass(C.error);r!==i&&(c&&(P.verbose("Resetting error on field",o),o.removeClass(C.error),a.remove()),l?(P.verbose("Resetting dropdown value",n,r),n.dropdown("restore defaults")):s?(P.verbose("Resetting checkbox value",n,r),t.prop("checked",r)):(P.verbose("Resetting field value",t,r),t.val(r)))})},determine:{isValid:function(){var t=!0;return e.each(b,function(e,n){P.validate.field(n,e,!0)||(t=!1)}),t}},is:{bracketedRule:function(e){return e.type&&e.type.match(v.regExp.bracket)},shorthandFields:function(e){var t=e[Object.keys(e)[0]];return P.is.shorthandRules(t)},shorthandRules:function(t){return"string"==typeof t||e.isArray(t)},empty:function(e){return!e||0===e.length||(e.is('input[type="checkbox"]')?!e.is(":checked"):P.is.blank(e))},blank:function(t){return""===e.trim(t.val())},valid:function(t){var n=!0;return t?(P.verbose("Checking if field is valid",t),P.validate.field(b[t],t,!1)):(P.verbose("Checking if form is valid"),e.each(b,function(e,t){P.is.valid(e)||(n=!1)}),n)}},removeEvents:function(){E.off(A),m.off(A),h.off(A),m.off(A)},event:{field:{keydown:function(t){var n=e(this),i=t.which,o=n.is(x.input),a=n.is(x.checkbox),r=n.closest(x.uiDropdown).length>0,s=13;i==27&&(P.verbose("Escape key pressed blurring field"),n.blur()),t.ctrlKey||i!=s||!o||r||a||(D||(n.one("keyup"+A,P.event.field.keyup),P.submit(),P.debug("Enter pressed on input submitting form")),D=!0)},keyup:function(){D=!1},blur:function(t){var n=e(this),i=n.closest(g),o=P.get.validation(n);i.hasClass(C.error)?(P.debug("Revalidating field",n,o),o&&P.validate.field(o)):"blur"==v.on&&o&&P.validate.field(o)},change:function(t){var n=e(this),i=n.closest(g),o=P.get.validation(n);o&&("change"==v.on||i.hasClass(C.error)&&v.revalidate)&&(clearTimeout(P.timer),P.timer=setTimeout(function(){P.debug("Revalidating field",n,P.get.validation(n)),P.validate.field(o)},v.delay))}}},get:{ancillaryValue:function(e){return!(!e.type||!e.value&&!P.is.bracketedRule(e))&&(e.value!==i?e.value:e.type.match(v.regExp.bracket)[1]+"")},ruleName:function(e){return P.is.bracketedRule(e)?e.type.replace(e.type.match(v.regExp.bracket)[0],""):e.type},changeEvent:function(e,t){return"checkbox"==e||"radio"==e||"hidden"==e||t.is("select")?"change":P.get.inputEvent()},inputEvent:function(){return n.createElement("input").oninput!==i?"input":n.createElement("input").onpropertychange!==i?"propertychange":"keyup"},fieldsFromShorthand:function(t){var n={};return e.each(t,function(t,i){"string"==typeof i&&(i=[i]),n[t]={rules:[]},e.each(i,function(e,i){n[t].rules.push({type:i})})}),n},prompt:function(t,n){var i,o,a=P.get.ruleName(t),r=P.get.ancillaryValue(t),s=P.get.field(n.identifier),l=s.val(),c=e.isFunction(t.prompt)?t.prompt(l):t.prompt||v.prompt[a]||v.text.unspecifiedRule,u=-1!==c.search("{value}"),d=-1!==c.search("{name}");return u&&(c=c.replace("{value}",s.val())),d&&(o=1==(i=s.closest(x.group).find("label").eq(0)).length?i.text():s.prop("placeholder")||v.text.unspecifiedField,c=c.replace("{name}",o)),c=(c=c.replace("{identifier}",n.identifier)).replace("{ruleValue}",r),t.prompt||P.verbose("Using default validation prompt for type",c,a),c},settings:function(){if(e.isPlainObject(t)){var n=Object.keys(t);n.length>0&&(t[n[0]].identifier!==i&&t[n[0]].rules!==i)?(v=e.extend(!0,{},e.fn.form.settings,u),b=e.extend({},e.fn.form.settings.defaults,t),P.error(v.error.oldSyntax,F),P.verbose("Extending settings from legacy parameters",b,v)):(t.fields&&P.is.shorthandFields(t.fields)&&(t.fields=P.get.fieldsFromShorthand(t.fields)),v=e.extend(!0,{},e.fn.form.settings,t),b=e.extend({},e.fn.form.settings.defaults,v.fields),P.verbose("Extending settings",b,v))}else v=e.fn.form.settings,b=e.fn.form.settings.defaults,P.verbose("Using default form validation",b,v);k=v.namespace,y=v.metadata,x=v.selector,C=v.className,w=v.regExp,S=v.error,T="module-"+k,A="."+k,R=E.data(T),P.refresh()},field:function(t){return P.verbose("Finding field with identifier",t),t=P.escape.string(t),m.filter("#"+t).length>0?m.filter("#"+t):m.filter('[name="'+t+'"]').length>0?m.filter('[name="'+t+'"]'):m.filter('[name="'+t+'[]"]').length>0?m.filter('[name="'+t+'[]"]'):m.filter("[data-"+y.validate+'="'+t+'"]').length>0?m.filter("[data-"+y.validate+'="'+t+'"]'):e("<input/>")},fields:function(t){var n=e();return e.each(t,function(e,t){n=n.add(P.get.field(t))}),n},validation:function(t){var n,i;return!!b&&(e.each(b,function(e,o){i=o.identifier||e,P.get.field(i)[0]==t[0]&&(o.identifier=i,n=o)}),n||!1)},value:function(e){var t=[];return t.push(e),P.get.values.call(F,t)[e]},values:function(t){var n={};return(e.isArray(t)?P.get.fields(t):m).each(function(t,o){var a=e(o),r=(a.prop("type"),a.prop("name")),s=a.val(),l=a.is(x.checkbox),c=a.is(x.radio),u=-1!==r.indexOf("[]"),d=!!l&&a.is(":checked");r&&(u?(r=r.replace("[]",""),n[r]||(n[r]=[]),l?d?n[r].push(s||!0):n[r].push(!1):n[r].push(s)):c?n[r]!==i&&0!=n[r]||(n[r]=!!d&&(s||!0)):n[r]=l?!!d&&(s||!0):s)}),n}},has:{field:function(e){return P.verbose("Checking for existence of a field with identifier",e),"string"!=typeof(e=P.escape.string(e))&&P.error(S.identifier,e),m.filter("#"+e).length>0||(m.filter('[name="'+e+'"]').length>0||m.filter("[data-"+y.validate+'="'+e+'"]').length>0)}},escape:{string:function(e){return(e=String(e)).replace(w.escape,"\\$&")}},add:{rule:function(e,t){P.add.field(e,t)},field:function(t,n){var i={};P.is.shorthandRules(n)?(n=e.isArray(n)?n:[n],i[t]={rules:[]},e.each(n,function(e,n){i[t].rules.push({type:n})})):i[t]=n,b=e.extend({},b,i),P.debug("Adding rules",i,b)},fields:function(t){var n;n=t&&P.is.shorthandFields(t)?P.get.fieldsFromShorthand(t):t,b=e.extend({},b,n)},prompt:function(t,n){var o=P.get.field(t).closest(g),a=o.children(x.prompt),r=0!==a.length;n="string"==typeof n?[n]:n,P.verbose("Adding field error state",t),o.addClass(C.error),v.inline&&(r||(a=v.templates.prompt(n)).appendTo(o),a.html(n[0]),r?P.verbose("Inline errors are disabled, no inline error added",t):v.transition&&e.fn.transition!==i&&E.transition("is supported")?(P.verbose("Displaying error with css transition",v.transition),a.transition(v.transition+" in",v.duration)):(P.verbose("Displaying error with fallback javascript animation"),a.fadeIn(v.duration)))},errors:function(e){P.debug("Adding form error messages",e),P.set.error(),p.html(v.templates.error(e))}},remove:{rule:function(t,n){var o=e.isArray(n)?n:[n];if(n==i)return P.debug("Removed all rules"),void(b[t].rules=[]);b[t]!=i&&e.isArray(b[t].rules)&&e.each(b[t].rules,function(e,n){-1!==o.indexOf(n.type)&&(P.debug("Removed rule",n.type),b[t].rules.splice(e,1))})},field:function(t){var n=e.isArray(t)?t:[t];e.each(n,function(e,t){P.remove.rule(t)})},rules:function(t,n){e.isArray(t)?e.each(fields,function(e,t){P.remove.rule(t,n)}):P.remove.rule(t,n)},fields:function(e){P.remove.field(e)},prompt:function(t){var n=P.get.field(t).closest(g),o=n.children(x.prompt);n.removeClass(C.error),v.inline&&o.is(":visible")&&(P.verbose("Removing prompt for field",t),v.transition&&e.fn.transition!==i&&E.transition("is supported")?o.transition(v.transition+" out",v.duration,function(){o.remove()}):o.fadeOut(v.duration,function(){o.remove()}))}},set:{success:function(){E.removeClass(C.error).addClass(C.success)},defaults:function(){m.each(function(){var t=e(this),n=t.filter(x.checkbox).length>0?t.is(":checked"):t.val();t.data(y.defaultValue,n)})},error:function(){E.removeClass(C.success).addClass(C.error)},value:function(e,t){var n={};return n[e]=t,P.set.values.call(F,n)},values:function(t){e.isEmptyObject(t)||e.each(t,function(t,n){var i,o=P.get.field(t),a=o.parent(),r=e.isArray(n),s=a.is(x.uiCheckbox),l=a.is(x.uiDropdown),c=o.is(x.radio)&&s;o.length>0&&(r&&s?(P.verbose("Selecting multiple",n,o),a.checkbox("uncheck"),e.each(n,function(e,t){i=o.filter('[value="'+t+'"]'),a=i.parent(),i.length>0&&a.checkbox("check")})):c?(P.verbose("Selecting radio value",n,o),o.filter('[value="'+n+'"]').parent(x.uiCheckbox).checkbox("check")):s?(P.verbose("Setting checkbox value",n,a),!0===n?a.checkbox("check"):a.checkbox("uncheck")):l?(P.verbose("Setting dropdown value",n,a),a.dropdown("set selected",n)):(P.verbose("Setting field value",n,o),o.val(n)))})}},validate:{form:function(e,t){var n=P.get.values();if(D)return!1;if(O=[],P.determine.isValid()){if(P.debug("Form has no validation errors, submitting"),P.set.success(),!0!==t)return v.onSuccess.call(F,e,n)}else if(P.debug("Form has errors"),P.set.error(),v.inline||P.add.errors(O),E.data("moduleApi")!==i&&e.stopImmediatePropagation(),!0!==t)return v.onFailure.call(F,O,n)},field:function(t,n,o){o=o===i||o,"string"==typeof t&&(P.verbose("Validating field",t),n=t,t=b[t]);var a=t.identifier||n,r=P.get.field(a),s=!!t.depends&&P.get.field(t.depends),l=!0,c=[];return t.identifier||(P.debug("Using field name as identifier",a),t.identifier=a),r.prop("disabled")?(P.debug("Field is disabled. Skipping",a),l=!0):t.optional&&P.is.blank(r)?(P.debug("Field is optional and blank. Skipping",a),l=!0):t.depends&&P.is.empty(s)?(P.debug("Field depends on another value that is not present or empty. Skipping",s),l=!0):t.rules!==i&&e.each(t.rules,function(e,n){P.has.field(a)&&!P.validate.rule(t,n)&&(P.debug("Field is invalid",a,n.type),c.push(P.get.prompt(n,t)),l=!1)}),l?(o&&(P.remove.prompt(a,c),v.onValid.call(r)),!0):(o&&(O=O.concat(c),P.add.prompt(a,c),v.onInvalid.call(r,c)),!1)},rule:function(t,n){var o=P.get.field(t.identifier),a=(n.type,o.val()),r=P.get.ancillaryValue(n),s=P.get.ruleName(n),l=v.rules[s];if(e.isFunction(l))return a=a===i||""===a||null===a?"":e.trim(a+""),l.call(o,a,r);P.error(S.noRule,s)}},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];v[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,P,t);else{if(n===i)return P[t];P[t]=n}},debug:function(){!v.silent&&v.debug&&(v.performance?P.performance.log(arguments):(P.debug=Function.prototype.bind.call(console.info,console,v.name+":"),P.debug.apply(console,arguments)))},verbose:function(){!v.silent&&v.verbose&&v.debug&&(v.performance?P.performance.log(arguments):(P.verbose=Function.prototype.bind.call(console.info,console,v.name+":"),P.verbose.apply(console,arguments)))},error:function(){v.silent||(P.error=Function.prototype.bind.call(console.error,console,v.name+":"),P.error.apply(console,arguments))},performance:{log:function(e){var t,n;v.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:F,"Execution Time":n})),clearTimeout(P.performance.timer),P.performance.timer=setTimeout(P.performance.display,500)},display:function(){var t=v.name+":",n=0;s=!1,clearTimeout(P.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=R;return n=n||f,a=F||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}}).initialize()}),o!==i?o:this},e.fn.form.settings={name:"Form",namespace:"form",debug:!1,verbose:!1,performance:!0,fields:!1,keyboardShortcuts:!0,on:"submit",inline:!1,delay:200,revalidate:!0,transition:"scale",duration:200,onValid:function(){},onInvalid:function(){},onSuccess:function(){return!0},onFailure:function(){return!1},metadata:{defaultValue:"default",validate:"validate"},regExp:{htmlID:/^[a-zA-Z][\w:.-]*$/g,bracket:/\[(.*)\]/i,decimal:/^\d+\.?\d*$/,email:/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,escape:/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,flags:/^\/(.*)\/(.*)?/,integer:/^\-?\d+$/,number:/^\-?\d*(\.\d+)?$/,url:/(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/i},text:{unspecifiedRule:"Please enter a valid value",unspecifiedField:"This field"},prompt:{empty:"{name} must have a value",checked:"{name} must be checked",email:"{name} must be a valid e-mail",url:"{name} must be a valid url",regExp:"{name} is not formatted correctly",integer:"{name} must be an integer",decimal:"{name} must be a decimal number",number:"{name} must be set to a number",is:'{name} must be "{ruleValue}"',isExactly:'{name} must be exactly "{ruleValue}"',not:'{name} cannot be set to "{ruleValue}"',notExactly:'{name} cannot be set to exactly "{ruleValue}"',contain:'{name} must contain "{ruleValue}"',containExactly:'{name} must contain exactly "{ruleValue}"',doesntContain:'{name} cannot contain  "{ruleValue}"',doesntContainExactly:'{name} cannot contain exactly "{ruleValue}"',minLength:"{name} must be at least {ruleValue} characters",length:"{name} must be at least {ruleValue} characters",exactLength:"{name} must be exactly {ruleValue} characters",maxLength:"{name} cannot be longer than {ruleValue} characters",match:"{name} must match {ruleValue} field",different:"{name} must have a different value than {ruleValue} field",creditCard:"{name} must be a valid credit card number",minCount:"{name} must have at least {ruleValue} choices",exactCount:"{name} must have exactly {ruleValue} choices",maxCount:"{name} must have {ruleValue} or less choices"},selector:{checkbox:'input[type="checkbox"], input[type="radio"]',clear:".clear",field:"input, textarea, select",group:".field",input:"input",message:".error.message",prompt:".prompt.label",radio:'input[type="radio"]',reset:'.reset:not([type="reset"])',submit:'.submit:not([type="submit"])',uiCheckbox:".ui.checkbox",uiDropdown:".ui.dropdown"},className:{error:"error",label:"ui prompt label",pressed:"down",success:"success"},error:{identifier:"You must specify a string identifier for each field",method:"The method you called is not defined.",noRule:"There is no rule matching the one you specified",oldSyntax:"Starting in 2.0 forms now only take a single settings object. Validation settings converted to new syntax automatically."},templates:{error:function(t){var n='<ul class="list">';return e.each(t,function(e,t){n+="<li>"+t+"</li>"}),e(n+="</ul>")},prompt:function(t){return e("<div/>").addClass("ui basic red pointing prompt label").html(t[0])}},rules:{empty:function(t){return!(t===i||""===t||e.isArray(t)&&0===t.length)},checked:function(){return e(this).filter(":checked").length>0},email:function(t){return e.fn.form.settings.regExp.email.test(t)},url:function(t){return e.fn.form.settings.regExp.url.test(t)},regExp:function(t,n){if(n instanceof RegExp)return t.match(n);var i,o=n.match(e.fn.form.settings.regExp.flags);return o&&(n=o.length>=2?o[1]:n,i=o.length>=3?o[2]:""),t.match(new RegExp(n,i))},integer:function(t,n){var o,a,r,s=e.fn.form.settings.regExp.integer;return n&&-1===["",".."].indexOf(n)&&(-1==n.indexOf("..")?s.test(n)&&(o=a=n-0):(r=n.split("..",2),s.test(r[0])&&(o=r[0]-0),s.test(r[1])&&(a=r[1]-0))),s.test(t)&&(o===i||t>=o)&&(a===i||t<=a)},decimal:function(t){return e.fn.form.settings.regExp.decimal.test(t)},number:function(t){return e.fn.form.settings.regExp.number.test(t)},is:function(e,t){return t="string"==typeof t?t.toLowerCase():t,(e="string"==typeof e?e.toLowerCase():e)==t},isExactly:function(e,t){return e==t},not:function(e,t){return(e="string"==typeof e?e.toLowerCase():e)!=(t="string"==typeof t?t.toLowerCase():t)},notExactly:function(e,t){return e!=t},contains:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1!==t.search(new RegExp(n,"i"))},containsExactly:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1!==t.search(new RegExp(n))},doesntContain:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1===t.search(new RegExp(n,"i"))},doesntContainExactly:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1===t.search(new RegExp(n))},minLength:function(e,t){return e!==i&&e.length>=t},length:function(e,t){return e!==i&&e.length>=t},exactLength:function(e,t){return e!==i&&e.length==t},maxLength:function(e,t){return e!==i&&e.length<=t},match:function(t,n){var o;e(this);return e('[data-validate="'+n+'"]').length>0?o=e('[data-validate="'+n+'"]').val():e("#"+n).length>0?o=e("#"+n).val():e('[name="'+n+'"]').length>0?o=e('[name="'+n+'"]').val():e('[name="'+n+'[]"]').length>0&&(o=e('[name="'+n+'[]"]')),o!==i&&t.toString()==o.toString()},different:function(t,n){var o;e(this);return e('[data-validate="'+n+'"]').length>0?o=e('[data-validate="'+n+'"]').val():e("#"+n).length>0?o=e("#"+n).val():e('[name="'+n+'"]').length>0?o=e('[name="'+n+'"]').val():e('[name="'+n+'[]"]').length>0&&(o=e('[name="'+n+'[]"]')),o!==i&&t.toString()!==o.toString()},creditCard:function(t,n){var i,o,a={visa:{pattern:/^4/,length:[16]},amex:{pattern:/^3[47]/,length:[15]},mastercard:{pattern:/^5[1-5]/,length:[16]},discover:{pattern:/^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,length:[16]},unionPay:{pattern:/^(62|88)/,length:[16,17,18,19]},jcb:{pattern:/^35(2[89]|[3-8][0-9])/,length:[16]},maestro:{pattern:/^(5018|5020|5038|6304|6759|676[1-3])/,length:[12,13,14,15,16,17,18,19]},dinersClub:{pattern:/^(30[0-5]|^36)/,length:[14]},laser:{pattern:/^(6304|670[69]|6771)/,length:[16,17,18,19]},visaElectron:{pattern:/^(4026|417500|4508|4844|491(3|7))/,length:[16]}},r={},s=!1,l="string"==typeof n&&n.split(",");if("string"==typeof t&&0!==t.length){if(t=t.replace(/[\-]/g,""),l&&(e.each(l,function(n,i){(o=a[i])&&(r={length:-1!==e.inArray(t.length,o.length),pattern:-1!==t.search(o.pattern)}).length&&r.pattern&&(s=!0)}),!s))return!1;if((i={number:-1!==e.inArray(t.length,a.unionPay.length),pattern:-1!==t.search(a.unionPay.pattern)}).number&&i.pattern)return!0;for(var c=t.length,u=0,d=[[0,1,2,3,4,5,6,7,8,9],[0,2,4,6,8,1,3,5,7,9]],f=0;c--;)f+=d[u][parseInt(t.charAt(c),10)],u^=1;return f%10==0&&f>0}},minCount:function(e,t){return 0==t||(1==t?""!==e:e.split(",").length>=t)},exactCount:function(e,t){return 0==t?""===e:1==t?""!==e&&-1===e.search(","):e.split(",").length==t},maxCount:function(e,t){return 0!=t&&(1==t?-1===e.search(","):e.split(",").length<=t)}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.accordion=function(n){var o,a=e(this),r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame;return a.each(function(){var d,f,m=e.isPlainObject(n)?e.extend(!0,{},e.fn.accordion.settings,n):e.extend({},e.fn.accordion.settings),g=m.className,p=m.namespace,h=m.selector,v=m.error,b="."+p,y="module-"+p,x=a.selector||"",C=e(this),w=C.find(h.title),S=C.find(h.content),k=this,T=C.data(y);f={initialize:function(){f.debug("Initializing",C),f.bind.events(),m.observeChanges&&f.observeChanges(),f.instantiate()},instantiate:function(){T=f,C.data(y,f)},destroy:function(){f.debug("Destroying previous instance",C),C.off(b).removeData(y)},refresh:function(){w=C.find(h.title),S=C.find(h.content)},observeChanges:function(){"MutationObserver"in t&&((d=new MutationObserver(function(e){f.debug("DOM tree modified, updating selector cache"),f.refresh()})).observe(k,{childList:!0,subtree:!0}),f.debug("Setting up mutation observer",d))},bind:{events:function(){f.debug("Binding delegated events"),C.on(m.on+b,h.trigger,f.event.click)}},event:{click:function(){f.toggle.call(this)}},toggle:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(S),a=o.hasClass(g.animating),r=o.hasClass(g.active),s=r&&!a,l=!r&&a;f.debug("Toggling visibility of content",n),s||l?m.collapsible?f.close.call(n):f.debug("Cannot close accordion content collapsing is disabled"):f.open.call(n)},open:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(S),a=o.hasClass(g.animating);o.hasClass(g.active)||a?f.debug("Accordion already open, skipping",o):(f.debug("Opening accordion content",n),m.onOpening.call(o),m.onChanging.call(o),m.exclusive&&f.closeOthers.call(n),n.addClass(g.active),o.stop(!0,!0).addClass(g.animating),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?o.children().transition({animation:"fade in",queue:!1,useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):o.children().stop(!0,!0).animate({opacity:1},m.duration,f.resetOpacity)),o.slideDown(m.duration,m.easing,function(){o.removeClass(g.animating).addClass(g.active),f.reset.display.call(this),m.onOpen.call(this),m.onChange.call(this)}))},close:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(S),a=o.hasClass(g.animating),r=o.hasClass(g.active);!r&&!(!r&&a)||r&&a||(f.debug("Closing accordion content",o),m.onClosing.call(o),m.onChanging.call(o),n.removeClass(g.active),o.stop(!0,!0).addClass(g.animating),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?o.children().transition({animation:"fade out",queue:!1,useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):o.children().stop(!0,!0).animate({opacity:0},m.duration,f.resetOpacity)),o.slideUp(m.duration,m.easing,function(){o.removeClass(g.animating).removeClass(g.active),f.reset.display.call(this),m.onClose.call(this),m.onChange.call(this)}))},closeOthers:function(t){var n,o,a,r=t!==i?w.eq(t):e(this).closest(h.title),s=r.parents(h.content).prev(h.title),l=r.closest(h.accordion),c=h.title+"."+g.active+":visible",u=h.content+"."+g.active+":visible";m.closeNested?a=(n=l.find(c).not(s)).next(S):(n=l.find(c).not(s),o=l.find(u).find(c).not(s),a=(n=n.not(o)).next(S)),n.length>0&&(f.debug("Exclusive enabled, closing other content",n),n.removeClass(g.active),a.removeClass(g.animating).stop(!0,!0),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?a.children().transition({animation:"fade out",useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):a.children().stop(!0,!0).animate({opacity:0},m.duration,f.resetOpacity)),a.slideUp(m.duration,m.easing,function(){e(this).removeClass(g.active),f.reset.display.call(this)}))},reset:{display:function(){f.verbose("Removing inline display from element",this),e(this).css("display",""),""===e(this).attr("style")&&e(this).attr("style","").removeAttr("style")},opacity:function(){f.verbose("Removing inline opacity from element",this),e(this).css("opacity",""),""===e(this).attr("style")&&e(this).attr("style","").removeAttr("style")}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(f.debug("Changing internal",t,n),n===i)return f[t];e.isPlainObject(t)?e.extend(!0,f,t):f[t]=n},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n;m.performance&&(n=(t=(new Date).getTime())-(r||t),r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:k,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;r=!1,clearTimeout(f.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",x&&(t+=" '"+x+"'"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,n,a){var r,s,l,c=T;return n=n||u,a=k||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(f.error(v.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},c?(T===i&&f.initialize(),f.invoke(l)):(T!==i&&T.invoke("destroy"),f.initialize())}),o!==i?o:this},e.fn.accordion.settings={name:"Accordion",namespace:"accordion",silent:!1,debug:!1,verbose:!1,performance:!0,on:"click",observeChanges:!0,exclusive:!0,collapsible:!0,closeNested:!1,animateChildren:!0,duration:350,easing:"easeOutQuad",onOpening:function(){},onClosing:function(){},onChanging:function(){},onOpen:function(){},onClose:function(){},onChange:function(){},error:{method:"The method you called is not defined"},className:{active:"active",animating:"animating"},selector:{accordion:".accordion",title:".title",trigger:".title",content:".content"}},e.extend(e.easing,{easeOutQuad:function(e,t,n,i,o){return-i*(t/=o)*(t-2)+n}})}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.checkbox=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return r.each(function(){var r,m,g=e.extend(!0,{},e.fn.checkbox.settings,o),p=g.className,h=g.namespace,v=g.selector,b=g.error,y="."+h,x="module-"+h,C=e(this),w=e(this).children(v.label),S=e(this).children(v.input),k=S[0],T=!1,A=!1,R=C.data(x),P=this;m={initialize:function(){m.verbose("Initializing checkbox",g),m.create.label(),m.bind.events(),m.set.tabbable(),m.hide.input(),m.observeChanges(),m.instantiate(),m.setup()},instantiate:function(){m.verbose("Storing instance of module",m),R=m,C.data(x,m)},destroy:function(){m.verbose("Destroying module"),m.unbind.events(),m.show.input(),C.removeData(x)},fix:{reference:function(){C.is(v.input)&&(m.debug("Behavior called on <input> adjusting invoked element"),C=C.closest(v.checkbox),m.refresh())}},setup:function(){m.set.initialLoad(),m.is.indeterminate()?(m.debug("Initial value is indeterminate"),m.indeterminate()):m.is.checked()?(m.debug("Initial value is checked"),m.check()):(m.debug("Initial value is unchecked"),m.uncheck()),m.remove.initialLoad()},refresh:function(){w=C.children(v.label),S=C.children(v.input),k=S[0]},hide:{input:function(){m.verbose("Modifying <input> z-index to be unselectable"),S.addClass(p.hidden)}},show:{input:function(){m.verbose("Modifying <input> z-index to be selectable"),S.removeClass(p.hidden)}},observeChanges:function(){"MutationObserver"in t&&((r=new MutationObserver(function(e){m.debug("DOM tree modified, updating selector cache"),m.refresh()})).observe(P,{childList:!0,subtree:!0}),m.debug("Setting up mutation observer",r))},attachEvents:function(t,n){var i=e(t);n=e.isFunction(m[n])?m[n]:m.toggle,i.length>0?(m.debug("Attaching checkbox events to element",t,n),i.on("click"+y,n)):m.error(b.notFound)},event:{click:function(t){var n=e(t.target);n.is(v.input)?m.verbose("Using default check action on initialized checkbox"):n.is(v.link)?m.debug("Clicking link inside checkbox, skipping toggle"):(m.toggle(),S.focus(),t.preventDefault())},keydown:function(e){var t=e.which,n=13,i=32;t==27?(m.verbose("Escape key pressed blurring field"),S.blur(),A=!0):e.ctrlKey||t!=i&&t!=n?A=!1:(m.verbose("Enter/space key pressed, toggling checkbox"),m.toggle(),A=!0)},keyup:function(e){A&&e.preventDefault()}},check:function(){m.should.allowCheck()&&(m.debug("Checking checkbox",S),m.set.checked(),m.should.ignoreCallbacks()||(g.onChecked.call(k),g.onChange.call(k)))},uncheck:function(){m.should.allowUncheck()&&(m.debug("Unchecking checkbox"),m.set.unchecked(),m.should.ignoreCallbacks()||(g.onUnchecked.call(k),g.onChange.call(k)))},indeterminate:function(){m.should.allowIndeterminate()?m.debug("Checkbox is already indeterminate"):(m.debug("Making checkbox indeterminate"),m.set.indeterminate(),m.should.ignoreCallbacks()||(g.onIndeterminate.call(k),g.onChange.call(k)))},determinate:function(){m.should.allowDeterminate()?m.debug("Checkbox is already determinate"):(m.debug("Making checkbox determinate"),m.set.determinate(),m.should.ignoreCallbacks()||(g.onDeterminate.call(k),g.onChange.call(k)))},enable:function(){m.is.enabled()?m.debug("Checkbox is already enabled"):(m.debug("Enabling checkbox"),m.set.enabled(),g.onEnable.call(k),g.onEnabled.call(k))},disable:function(){m.is.disabled()?m.debug("Checkbox is already disabled"):(m.debug("Disabling checkbox"),m.set.disabled(),g.onDisable.call(k),g.onDisabled.call(k))},get:{radios:function(){var t=m.get.name();return e('input[name="'+t+'"]').closest(v.checkbox)},otherRadios:function(){return m.get.radios().not(C)},name:function(){return S.attr("name")}},is:{initialLoad:function(){return T},radio:function(){return S.hasClass(p.radio)||"radio"==S.attr("type")},indeterminate:function(){return S.prop("indeterminate")!==i&&S.prop("indeterminate")},checked:function(){return S.prop("checked")!==i&&S.prop("checked")},disabled:function(){return S.prop("disabled")!==i&&S.prop("disabled")},enabled:function(){return!m.is.disabled()},determinate:function(){return!m.is.indeterminate()},unchecked:function(){return!m.is.checked()}},should:{allowCheck:function(){return m.is.determinate()&&m.is.checked()&&!m.should.forceCallbacks()?(m.debug("Should not allow check, checkbox is already checked"),!1):!1!==g.beforeChecked.apply(k)||(m.debug("Should not allow check, beforeChecked cancelled"),!1)},allowUncheck:function(){return m.is.determinate()&&m.is.unchecked()&&!m.should.forceCallbacks()?(m.debug("Should not allow uncheck, checkbox is already unchecked"),!1):!1!==g.beforeUnchecked.apply(k)||(m.debug("Should not allow uncheck, beforeUnchecked cancelled"),!1)},allowIndeterminate:function(){return m.is.indeterminate()&&!m.should.forceCallbacks()?(m.debug("Should not allow indeterminate, checkbox is already indeterminate"),!1):!1!==g.beforeIndeterminate.apply(k)||(m.debug("Should not allow indeterminate, beforeIndeterminate cancelled"),!1)},allowDeterminate:function(){return m.is.determinate()&&!m.should.forceCallbacks()?(m.debug("Should not allow determinate, checkbox is already determinate"),!1):!1!==g.beforeDeterminate.apply(k)||(m.debug("Should not allow determinate, beforeDeterminate cancelled"),!1)},forceCallbacks:function(){return m.is.initialLoad()&&g.fireOnInit},ignoreCallbacks:function(){return T&&!g.fireOnInit}},can:{change:function(){return!(C.hasClass(p.disabled)||C.hasClass(p.readOnly)||S.prop("disabled")||S.prop("readonly"))},uncheck:function(){return"boolean"==typeof g.uncheckable?g.uncheckable:!m.is.radio()}},set:{initialLoad:function(){T=!0},checked:function(){m.verbose("Setting class to checked"),C.removeClass(p.indeterminate).addClass(p.checked),m.is.radio()&&m.uncheckOthers(),m.is.indeterminate()||!m.is.checked()?(m.verbose("Setting state to checked",k),S.prop("indeterminate",!1).prop("checked",!0),m.trigger.change()):m.debug("Input is already checked, skipping input property change")},unchecked:function(){m.verbose("Removing checked class"),C.removeClass(p.indeterminate).removeClass(p.checked),m.is.indeterminate()||!m.is.unchecked()?(m.debug("Setting state to unchecked"),S.prop("indeterminate",!1).prop("checked",!1),m.trigger.change()):m.debug("Input is already unchecked")},indeterminate:function(){m.verbose("Setting class to indeterminate"),C.addClass(p.indeterminate),m.is.indeterminate()?m.debug("Input is already indeterminate, skipping input property change"):(m.debug("Setting state to indeterminate"),S.prop("indeterminate",!0),m.trigger.change())},determinate:function(){m.verbose("Removing indeterminate class"),C.removeClass(p.indeterminate),m.is.determinate()?m.debug("Input is already determinate, skipping input property change"):(m.debug("Setting state to determinate"),S.prop("indeterminate",!1))},disabled:function(){m.verbose("Setting class to disabled"),C.addClass(p.disabled),m.is.disabled()?m.debug("Input is already disabled, skipping input property change"):(m.debug("Setting state to disabled"),S.prop("disabled","disabled"),m.trigger.change())},enabled:function(){m.verbose("Removing disabled class"),C.removeClass(p.disabled),m.is.enabled()?m.debug("Input is already enabled, skipping input property change"):(m.debug("Setting state to enabled"),S.prop("disabled",!1),m.trigger.change())},tabbable:function(){m.verbose("Adding tabindex to checkbox"),S.attr("tabindex")===i&&S.attr("tabindex",0)}},remove:{initialLoad:function(){T=!1}},trigger:{change:function(){var e=n.createEvent("HTMLEvents"),t=S[0];t&&(m.verbose("Triggering native change event"),e.initEvent("change",!0,!1),t.dispatchEvent(e))}},create:{label:function(){S.prevAll(v.label).length>0?(S.prev(v.label).detach().insertAfter(S),m.debug("Moving existing label",w)):m.has.label()||(w=e("<label>").insertAfter(S),m.debug("Creating label",w))}},has:{label:function(){return w.length>0}},bind:{events:function(){m.verbose("Attaching checkbox events"),C.on("click"+y,m.event.click).on("keydown"+y,v.input,m.event.keydown).on("keyup"+y,v.input,m.event.keyup)}},unbind:{events:function(){m.debug("Removing events"),C.off(y)}},uncheckOthers:function(){var e=m.get.otherRadios();m.debug("Unchecking other radios",e),e.removeClass(p.checked)},toggle:function(){m.can.change()?m.is.indeterminate()||m.is.unchecked()?(m.debug("Currently unchecked"),m.check()):m.is.checked()&&m.can.uncheck()&&(m.debug("Currently checked"),m.uncheck()):m.is.radio()||m.debug("Checkbox is read-only or disabled, ignoring toggle")},setting:function(t,n){if(m.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];e.isPlainObject(g[t])?e.extend(!0,g[t],n):g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n;g.performance&&(n=(t=(new Date).getTime())-(l||t),l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:P,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;l=!1,clearTimeout(m.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=R;return n=n||f,o=P||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(m.error(b.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(R===i&&m.initialize(),m.invoke(u)):(R!==i&&R.invoke("destroy"),m.initialize())}),a!==i?a:this},e.fn.checkbox.settings={name:"Checkbox",namespace:"checkbox",silent:!1,debug:!1,verbose:!0,performance:!0,uncheckable:"auto",fireOnInit:!1,onChange:function(){},beforeChecked:function(){},beforeUnchecked:function(){},beforeDeterminate:function(){},beforeIndeterminate:function(){},onChecked:function(){},onUnchecked:function(){},onDeterminate:function(){},onIndeterminate:function(){},onEnable:function(){},onDisable:function(){},onEnabled:function(){},onDisabled:function(){},className:{checked:"checked",indeterminate:"indeterminate",disabled:"disabled",hidden:"hidden",radio:"radio",readOnly:"read-only"},error:{method:"The method you called is not defined"},selector:{checkbox:".ui.checkbox",label:"label, .box",input:'input[type="checkbox"], input[type="radio"]',link:"a[href]"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.dimmer=function(t){var o,a=e(this),r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);return a.each(function(){var d,f,m,g=e.isPlainObject(t)?e.extend(!0,{},e.fn.dimmer.settings,t):e.extend({},e.fn.dimmer.settings),p=g.selector,h=g.namespace,v=g.className,b=g.error,y="."+h,x="module-"+h,C=a.selector||"",w="ontouchstart"in n.documentElement?"touchstart":"click",S=e(this),k=this,T=S.data(x);(m={preinitialize:function(){m.is.dimmer()?(f=S.parent(),d=S):(f=S,d=m.has.dimmer()?g.dimmerName?f.find(p.dimmer).filter("."+g.dimmerName):f.find(p.dimmer):m.create(),m.set.variation())},initialize:function(){m.debug("Initializing dimmer",g),m.bind.events(),m.set.dimmable(),m.instantiate()},instantiate:function(){m.verbose("Storing instance of module",m),T=m,S.data(x,T)},destroy:function(){m.verbose("Destroying previous module",d),m.unbind.events(),m.remove.variation(),f.off(y)},bind:{events:function(){"hover"==g.on?f.on("mouseenter"+y,m.show).on("mouseleave"+y,m.hide):"click"==g.on&&f.on(w+y,m.toggle),m.is.page()&&(m.debug("Setting as a page dimmer",f),m.set.pageDimmer()),m.is.closable()&&(m.verbose("Adding dimmer close event",d),f.on(w+y,p.dimmer,m.event.click))}},unbind:{events:function(){S.removeData(x),f.off(y)}},event:{click:function(t){m.verbose("Determining if event occured on dimmer",t),(0===d.find(t.target).length||e(t.target).is(p.content))&&(m.hide(),t.stopImmediatePropagation())}},addContent:function(t){var n=e(t);m.debug("Add content to dimmer",n),n.parent()[0]!==d[0]&&n.detach().appendTo(d)},create:function(){var t=e(g.template.dimmer());return g.dimmerName&&(m.debug("Creating named dimmer",g.dimmerName),t.addClass(g.dimmerName)),t.appendTo(f),t},show:function(t){t=e.isFunction(t)?t:function(){},m.debug("Showing dimmer",d,g),m.is.dimmed()&&!m.is.animating()||!m.is.enabled()?m.debug("Dimmer is already shown or disabled"):(m.animate.show(t),g.onShow.call(k),g.onChange.call(k))},hide:function(t){t=e.isFunction(t)?t:function(){},m.is.dimmed()||m.is.animating()?(m.debug("Hiding dimmer",d),m.animate.hide(t),g.onHide.call(k),g.onChange.call(k)):m.debug("Dimmer is not visible")},toggle:function(){m.verbose("Toggling dimmer visibility",d),m.is.dimmed()?m.hide():m.show()},animate:{show:function(t){t=e.isFunction(t)?t:function(){},g.useCSS&&e.fn.transition!==i&&d.transition("is supported")?("auto"!==g.opacity&&m.set.opacity(),d.transition({displayType:"flex",animation:g.transition+" in",queue:!1,duration:m.get.duration(),useFailSafe:!0,onStart:function(){m.set.dimmed()},onComplete:function(){m.set.active(),t()}})):(m.verbose("Showing dimmer animation with javascript"),m.set.dimmed(),"auto"==g.opacity&&(g.opacity=.8),d.stop().css({opacity:0,width:"100%",height:"100%"}).fadeTo(m.get.duration(),g.opacity,function(){d.removeAttr("style"),m.set.active(),t()}))},hide:function(t){t=e.isFunction(t)?t:function(){},g.useCSS&&e.fn.transition!==i&&d.transition("is supported")?(m.verbose("Hiding dimmer with css"),d.transition({displayType:"flex",animation:g.transition+" out",queue:!1,duration:m.get.duration(),useFailSafe:!0,onStart:function(){m.remove.dimmed()},onComplete:function(){m.remove.active(),t()}})):(m.verbose("Hiding dimmer with javascript"),m.remove.dimmed(),d.stop().fadeOut(m.get.duration(),function(){m.remove.active(),d.removeAttr("style"),t()}))}},get:{dimmer:function(){return d},duration:function(){return"object"==typeof g.duration?m.is.active()?g.duration.hide:g.duration.show:g.duration}},has:{dimmer:function(){return g.dimmerName?S.find(p.dimmer).filter("."+g.dimmerName).length>0:S.find(p.dimmer).length>0}},is:{active:function(){return d.hasClass(v.active)},animating:function(){return d.is(":animated")||d.hasClass(v.animating)},closable:function(){return"auto"==g.closable?"hover"!=g.on:g.closable},dimmer:function(){return S.hasClass(v.dimmer)},dimmable:function(){return S.hasClass(v.dimmable)},dimmed:function(){return f.hasClass(v.dimmed)},disabled:function(){return f.hasClass(v.disabled)},enabled:function(){return!m.is.disabled()},page:function(){return f.is("body")},pageDimmer:function(){return d.hasClass(v.pageDimmer)}},can:{show:function(){return!d.hasClass(v.disabled)}},set:{opacity:function(e){var t=d.css("background-color"),n=t.split(","),i=n&&3==n.length,o=n&&4==n.length;e=0===g.opacity?0:g.opacity||e,i||o?(n[3]=e+")",t=n.join(",")):t="rgba(0, 0, 0, "+e+")",m.debug("Setting opacity to",e),d.css("background-color",t)},active:function(){d.addClass(v.active)},dimmable:function(){f.addClass(v.dimmable)},dimmed:function(){f.addClass(v.dimmed)},pageDimmer:function(){d.addClass(v.pageDimmer)},disabled:function(){d.addClass(v.disabled)},variation:function(e){(e=e||g.variation)&&d.addClass(e)}},remove:{active:function(){d.removeClass(v.active)},dimmed:function(){f.removeClass(v.dimmed)},disabled:function(){d.removeClass(v.disabled)},variation:function(e){(e=e||g.variation)&&d.removeClass(e)}},setting:function(t,n){if(m.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];e.isPlainObject(g[t])?e.extend(!0,g[t],n):g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n;g.performance&&(n=(t=(new Date).getTime())-(r||t),r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:k,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;r=!1,clearTimeout(m.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",C&&(t+=" '"+C+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,n,a){var r,s,l,c=T;return n=n||u,a=k||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(m.error(b.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}}).preinitialize(),c?(T===i&&m.initialize(),m.invoke(l)):(T!==i&&T.invoke("destroy"),m.initialize())}),o!==i?o:this},e.fn.dimmer.settings={name:"Dimmer",namespace:"dimmer",silent:!1,debug:!1,verbose:!1,performance:!0,dimmerName:!1,variation:!1,closable:"auto",useCSS:!0,transition:"fade",on:!1,opacity:"auto",duration:{show:500,hide:500},onChange:function(){},onShow:function(){},onHide:function(){},error:{method:"The method you called is not defined."},className:{active:"active",animating:"animating",dimmable:"dimmable",dimmed:"dimmed",dimmer:"dimmer",disabled:"disabled",hide:"hide",pageDimmer:"page",show:"show"},selector:{dimmer:"> .ui.dimmer",content:".ui.dimmer > .content, .ui.dimmer > .content > .center"},template:{dimmer:function(){return e("<div />").attr("class","ui dimmer")}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.dropdown=function(o){var a,r=e(this),s=e(n),l=r.selector||"",c="ontouchstart"in n.documentElement,u=(new Date).getTime(),d=[],f=arguments[0],m="string"==typeof f,g=[].slice.call(arguments,1);return r.each(function(p){var h,v,b,y,x,C,w,S,k=e.isPlainObject(o)?e.extend(!0,{},e.fn.dropdown.settings,o):e.extend({},e.fn.dropdown.settings),T=k.className,A=k.message,R=k.fields,P=k.keys,E=k.metadata,F=k.namespace,O=k.regExp,D=k.selector,q=k.error,j=k.templates,z="."+F,I="module-"+F,M=e(this),L=e(k.context),V=M.find(D.text),N=M.find(D.search),H=M.find(D.sizer),U=M.find(D.input),W=M.find(D.icon),B=M.prev().find(D.text).length>0?M.prev().find(D.text):M.prev(),Q=M.children(D.menu),X=Q.find(D.item),$=!1,Y=!1,Z=!1,K=this,J=M.data(I);S={initialize:function(){S.debug("Initializing dropdown",k),S.is.alreadySetup()?S.setup.reference():(S.setup.layout(),k.values&&S.change.values(k.values),S.refreshData(),S.save.defaults(),S.restore.selected(),S.create.id(),S.bind.events(),S.observeChanges(),S.instantiate())},instantiate:function(){S.verbose("Storing instance of dropdown",S),J=S,M.data(I,S)},destroy:function(){S.verbose("Destroying previous dropdown",M),S.remove.tabbable(),M.off(z).removeData(I),Q.off(z),s.off(y),S.disconnect.menuObserver(),S.disconnect.selectObserver()},observeChanges:function(){"MutationObserver"in t&&(C=new MutationObserver(S.event.select.mutation),w=new MutationObserver(S.event.menu.mutation),S.debug("Setting up mutation observer",C,w),S.observe.select(),S.observe.menu())},disconnect:{menuObserver:function(){w&&w.disconnect()},selectObserver:function(){C&&C.disconnect()}},observe:{select:function(){S.has.input()&&C.observe(M[0],{childList:!0,subtree:!0})},menu:function(){S.has.menu()&&w.observe(Q[0],{childList:!0,subtree:!0})}},create:{id:function(){x=(Math.random().toString(16)+"000000000").substr(2,8),y="."+x,S.verbose("Creating unique id for element",x)},userChoice:function(t){var n,o,a;return!!(t=t||S.get.userValues())&&(t=e.isArray(t)?t:[t],e.each(t,function(t,r){!1===S.get.item(r)&&(a=k.templates.addition(S.add.variables(A.addResult,r)),o=e("<div />").html(a).attr("data-"+E.value,r).attr("data-"+E.text,r).addClass(T.addition).addClass(T.item),k.hideAdditions&&o.addClass(T.hidden),n=n===i?o:n.add(o),S.verbose("Creating user choices for value",r,o))}),n)},userLabels:function(t){var n=S.get.userValues();n&&(S.debug("Adding user labels",n),e.each(n,function(e,t){S.verbose("Adding custom user value"),S.add.label(t,t)}))},menu:function(){Q=e("<div />").addClass(T.menu).appendTo(M)},sizer:function(){H=e("<span />").addClass(T.sizer).insertAfter(N)}},search:function(e){e=e!==i?e:S.get.query(),S.verbose("Searching for query",e),S.has.minCharacters(e)?S.filter(e):S.hide()},select:{firstUnfiltered:function(){S.verbose("Selecting first non-filtered element"),S.remove.selectedItem(),X.not(D.unselectable).not(D.addition+D.hidden).eq(0).addClass(T.selected)},nextAvailable:function(e){var t=(e=e.eq(0)).nextAll(D.item).not(D.unselectable).eq(0),n=e.prevAll(D.item).not(D.unselectable).eq(0);t.length>0?(S.verbose("Moving selection to",t),t.addClass(T.selected)):(S.verbose("Moving selection to",n),n.addClass(T.selected))}},setup:{api:function(){var e={debug:k.debug,urlData:{value:S.get.value(),query:S.get.query()},on:!1};S.verbose("First request, initializing API"),M.api(e)},layout:function(){M.is("select")&&(S.setup.select(),S.setup.returnedObject()),S.has.menu()||S.create.menu(),S.is.search()&&!S.has.search()&&(S.verbose("Adding search input"),N=e("<input />").addClass(T.search).prop("autocomplete","off").insertBefore(V)),S.is.multiple()&&S.is.searchSelection()&&!S.has.sizer()&&S.create.sizer(),k.allowTab&&S.set.tabbable()},select:function(){var t=S.get.selectValues();S.debug("Dropdown initialized on a select",t),M.is("select")&&(U=M),U.parent(D.dropdown).length>0?(S.debug("UI dropdown already exists. Creating dropdown menu only"),M=U.closest(D.dropdown),S.has.menu()||S.create.menu(),Q=M.children(D.menu),S.setup.menu(t)):(S.debug("Creating entire dropdown from select"),M=e("<div />").attr("class",U.attr("class")).addClass(T.selection).addClass(T.dropdown).html(j.dropdown(t)).insertBefore(U),U.hasClass(T.multiple)&&!1===U.prop("multiple")&&(S.error(q.missingMultiple),U.prop("multiple",!0)),U.is("[multiple]")&&S.set.multiple(),U.prop("disabled")&&(S.debug("Disabling dropdown"),M.addClass(T.disabled)),U.removeAttr("class").detach().prependTo(M)),S.refresh()},menu:function(e){Q.html(j.menu(e,R)),X=Q.find(D.item)},reference:function(){S.debug("Dropdown behavior was called on select, replacing with closest dropdown"),M=M.parent(D.dropdown),J=M.data(I),K=M.get(0),S.refresh(),S.setup.returnedObject()},returnedObject:function(){var e=r.slice(0,p),t=r.slice(p+1);r=e.add(M).add(t)}},refresh:function(){S.refreshSelectors(),S.refreshData()},refreshItems:function(){X=Q.find(D.item)},refreshSelectors:function(){S.verbose("Refreshing selector cache"),V=M.find(D.text),N=M.find(D.search),U=M.find(D.input),W=M.find(D.icon),B=M.prev().find(D.text).length>0?M.prev().find(D.text):M.prev(),Q=M.children(D.menu),X=Q.find(D.item)},refreshData:function(){S.verbose("Refreshing cached metadata"),X.removeData(E.text).removeData(E.value)},clearData:function(){S.verbose("Clearing metadata"),X.removeData(E.text).removeData(E.value),M.removeData(E.defaultText).removeData(E.defaultValue).removeData(E.placeholderText)},toggle:function(){S.verbose("Toggling menu visibility"),S.is.active()?S.hide():S.show()},show:function(t){if(t=e.isFunction(t)?t:function(){},!S.can.show()&&S.is.remote()&&(S.debug("No API results retrieved, searching before show"),S.queryRemote(S.get.query(),S.show)),S.can.show()&&!S.is.active()){if(S.debug("Showing dropdown"),!S.has.message()||S.has.maxSelections()||S.has.allResultsFiltered()||S.remove.message(),S.is.allFiltered())return!0;!1!==k.onShow.call(K)&&S.animate.show(function(){S.can.click()&&S.bind.intent(),S.has.menuSearch()&&S.focusSearch(),S.set.visible(),t.call(K)})}},hide:function(t){t=e.isFunction(t)?t:function(){},S.is.active()&&!S.is.animatingOutward()&&(S.debug("Hiding dropdown"),!1!==k.onHide.call(K)&&S.animate.hide(function(){S.remove.visible(),t.call(K)}))},hideOthers:function(){S.verbose("Finding other dropdowns to hide"),r.not(M).has(D.menu+"."+T.visible).dropdown("hide")},hideMenu:function(){S.verbose("Hiding menu  instantaneously"),S.remove.active(),S.remove.visible(),Q.transition("hide")},hideSubMenus:function(){var e=Q.children(D.item).find(D.menu);S.verbose("Hiding sub menus",e),e.transition("hide")},bind:{events:function(){c&&S.bind.touchEvents(),S.bind.keyboardEvents(),S.bind.inputEvents(),S.bind.mouseEvents()},touchEvents:function(){S.debug("Touch device detected binding additional touch events"),S.is.searchSelection()||S.is.single()&&M.on("touchstart"+z,S.event.test.toggle),Q.on("touchstart"+z,D.item,S.event.item.mouseenter)},keyboardEvents:function(){S.verbose("Binding keyboard events"),M.on("keydown"+z,S.event.keydown),S.has.search()&&M.on(S.get.inputEvent()+z,D.search,S.event.input),S.is.multiple()&&s.on("keydown"+y,S.event.document.keydown)},inputEvents:function(){S.verbose("Binding input change events"),M.on("change"+z,D.input,S.event.change)},mouseEvents:function(){S.verbose("Binding mouse events"),S.is.multiple()&&M.on("click"+z,D.label,S.event.label.click).on("click"+z,D.remove,S.event.remove.click),S.is.searchSelection()?(M.on("mousedown"+z,S.event.mousedown).on("mouseup"+z,S.event.mouseup).on("mousedown"+z,D.menu,S.event.menu.mousedown).on("mouseup"+z,D.menu,S.event.menu.mouseup).on("click"+z,D.icon,S.event.icon.click).on("focus"+z,D.search,S.event.search.focus).on("click"+z,D.search,S.event.search.focus).on("blur"+z,D.search,S.event.search.blur).on("click"+z,D.text,S.event.text.focus),S.is.multiple()&&M.on("click"+z,S.event.click)):("click"==k.on?M.on("click"+z,D.icon,S.event.icon.click).on("click"+z,S.event.test.toggle):"hover"==k.on?M.on("mouseenter"+z,S.delay.show).on("mouseleave"+z,S.delay.hide):M.on(k.on+z,S.toggle),M.on("mousedown"+z,S.event.mousedown).on("mouseup"+z,S.event.mouseup).on("focus"+z,S.event.focus),S.has.menuSearch()?M.on("blur"+z,D.search,S.event.search.blur):M.on("blur"+z,S.event.blur)),Q.on("mouseenter"+z,D.item,S.event.item.mouseenter).on("mouseleave"+z,D.item,S.event.item.mouseleave).on("click"+z,D.item,S.event.item.click)},intent:function(){S.verbose("Binding hide intent event to document"),c&&s.on("touchstart"+y,S.event.test.touch).on("touchmove"+y,S.event.test.touch),s.on("click"+y,S.event.test.hide)}},unbind:{intent:function(){S.verbose("Removing hide intent event from document"),c&&s.off("touchstart"+y).off("touchmove"+y),s.off("click"+y)}},filter:function(e){var t=e!==i?e:S.get.query(),n=function(){S.is.multiple()&&S.filterActive(),(e||!e&&0==S.get.activeItem().length)&&S.select.firstUnfiltered(),S.has.allResultsFiltered()?k.onNoResults.call(K,t)?k.allowAdditions?k.hideAdditions&&(S.verbose("User addition with no menu, setting empty style"),S.set.empty(),S.hideMenu()):(S.verbose("All items filtered, showing message",t),S.add.message(A.noResults)):(S.verbose("All items filtered, hiding dropdown",t),S.hideMenu()):(S.remove.empty(),S.remove.message()),k.allowAdditions&&S.add.userSuggestion(e),S.is.searchSelection()&&S.can.show()&&S.is.focusedOnSearch()&&S.show()};k.useLabels&&S.has.maxSelections()||(k.apiSettings?S.can.useAPI()?S.queryRemote(t,function(){k.filterRemoteData&&S.filterItems(t),n()}):S.error(q.noAPI):(S.filterItems(t),n()))},queryRemote:function(t,n){var i={errorDuration:!1,cache:"local",throttle:k.throttle,urlData:{query:t},onError:function(){S.add.message(A.serverError),n()},onFailure:function(){S.add.message(A.serverError),n()},onSuccess:function(e){S.remove.message(),S.setup.menu({values:e[R.remoteValues]}),n()}};M.api("get request")||S.setup.api(),i=e.extend(!0,{},i,k.apiSettings),M.api("setting",i).api("query")},filterItems:function(t){var n=t!==i?t:S.get.query(),o=null,a=S.escape.string(n),r=new RegExp("^"+a,"igm");S.has.query()&&(o=[],S.verbose("Searching for matching values",n),X.each(function(){var t,i,a=e(this);if("both"==k.match||"text"==k.match){if(-1!==(t=String(S.get.choiceText(a,!1))).search(r))return o.push(this),!0;if("exact"===k.fullTextSearch&&S.exactSearch(n,t))return o.push(this),!0;if(!0===k.fullTextSearch&&S.fuzzySearch(n,t))return o.push(this),!0}if("both"==k.match||"value"==k.match){if(-1!==(i=String(S.get.choiceValue(a,t))).search(r))return o.push(this),!0;if("exact"===k.fullTextSearch&&S.exactSearch(n,i))return o.push(this),!0;if(!0===k.fullTextSearch&&S.fuzzySearch(n,i))return o.push(this),!0}})),S.debug("Showing only matched items",n),S.remove.filteredItem(),o&&X.not(o).addClass(T.filtered)},fuzzySearch:function(e,t){var n=t.length,i=e.length;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;if(i===n)return e===t;e:for(var o=0,a=0;o<i;o++){for(var r=e.charCodeAt(o);a<n;)if(t.charCodeAt(a++)===r)continue e;return!1}return!0},exactSearch:function(e,t){return e=e.toLowerCase(),(t=t.toLowerCase()).indexOf(e)>-1},filterActive:function(){k.useLabels&&X.filter("."+T.active).addClass(T.filtered)},focusSearch:function(e){S.has.search()&&!S.is.focusedOnSearch()&&(e?(M.off("focus"+z,D.search),N.focus(),M.on("focus"+z,D.search,S.event.search.focus)):N.focus())},forceSelection:function(){var e=X.not(T.filtered).filter("."+T.selected).eq(0),t=X.not(T.filtered).filter("."+T.active).eq(0),n=e.length>0?e:t;if(n.length>0&&!S.is.multiple())return S.debug("Forcing partial selection to selected item",n),void S.event.item.click.call(n,{},!0);k.allowAdditions?(S.set.selected(S.get.query()),S.remove.searchTerm()):S.remove.searchTerm()},change:{values:function(t){k.allowAdditions||S.clear(),S.debug("Creating dropdown with specified values",t),S.setup.menu({values:t}),e.each(t,function(e,t){if(1==t.selected)return S.debug("Setting initial selection to",t.value),S.set.selected(t.value),!0})}},event:{change:function(){Z||(S.debug("Input changed, updating selection"),S.set.selected())},focus:function(){k.showOnFocus&&!$&&S.is.hidden()&&!v&&S.show()},blur:function(e){v=n.activeElement===this,$||v||(S.remove.activeLabel(),S.hide())},mousedown:function(){S.is.searchSelection()?b=!0:$=!0},mouseup:function(){S.is.searchSelection()?b=!1:$=!1},click:function(t){e(t.target).is(M)&&(S.is.focusedOnSearch()?S.show():S.focusSearch())},search:{focus:function(){$=!0,S.is.multiple()&&S.remove.activeLabel(),k.showOnFocus&&S.search()},blur:function(e){v=n.activeElement===this,S.is.searchSelection()&&!b&&(Y||v||(k.forceSelection&&S.forceSelection(),S.hide())),b=!1}},icon:{click:function(e){S.toggle()}},text:{focus:function(e){$=!0,S.focusSearch()}},input:function(e){(S.is.multiple()||S.is.searchSelection())&&S.set.filtered(),clearTimeout(S.timer),S.timer=setTimeout(S.search,k.delay.search)},label:{click:function(t){var n=e(this),i=M.find(D.label),o=i.filter("."+T.active),a=n.nextAll("."+T.active),r=n.prevAll("."+T.active),s=a.length>0?n.nextUntil(a).add(o).add(n):n.prevUntil(r).add(o).add(n);t.shiftKey?(o.removeClass(T.active),s.addClass(T.active)):t.ctrlKey?n.toggleClass(T.active):(o.removeClass(T.active),n.addClass(T.active)),k.onLabelSelect.apply(this,i.filter("."+T.active))}},remove:{click:function(){var t=e(this).parent();t.hasClass(T.active)?S.remove.activeLabels():S.remove.activeLabels(t)}},test:{toggle:function(e){var t=S.is.multiple()?S.show:S.toggle;S.is.bubbledLabelClick(e)||S.is.bubbledIconClick(e)||S.determine.eventOnElement(e,t)&&e.preventDefault()},touch:function(e){S.determine.eventOnElement(e,function(){"touchstart"==e.type?S.timer=setTimeout(function(){S.hide()},k.delay.touch):"touchmove"==e.type&&clearTimeout(S.timer)}),e.stopPropagation()},hide:function(e){S.determine.eventInModule(e,S.hide)}},select:{mutation:function(t){S.debug("<select> modified, recreating menu");var n=!1;e.each(t,function(t,i){if(e(i.target).is("select")||e(i.addedNodes).is("select"))return n=!0,!0}),n&&(S.disconnect.selectObserver(),S.refresh(),S.setup.select(),S.set.selected(),S.observe.select())}},menu:{mutation:function(t){var n=t[0],i=n.addedNodes?e(n.addedNodes[0]):e(!1),o=n.removedNodes?e(n.removedNodes[0]):e(!1),a=i.add(o),r=a.is(D.addition)||a.closest(D.addition).length>0,s=a.is(D.message)||a.closest(D.message).length>0;r||s?(S.debug("Updating item selector cache"),S.refreshItems()):(S.debug("Menu modified, updating selector cache"),S.refresh())},mousedown:function(){Y=!0},mouseup:function(){Y=!1}},item:{mouseenter:function(t){var n=e(t.target),i=e(this),o=i.children(D.menu),a=i.siblings(D.item).children(D.menu),r=o.length>0;!(o.find(n).length>0)&&r&&(clearTimeout(S.itemTimer),S.itemTimer=setTimeout(function(){S.verbose("Showing sub-menu",o),e.each(a,function(){S.animate.hide(!1,e(this))}),S.animate.show(!1,o)},k.delay.show),t.preventDefault())},mouseleave:function(t){var n=e(this).children(D.menu);n.length>0&&(clearTimeout(S.itemTimer),S.itemTimer=setTimeout(function(){S.verbose("Hiding sub-menu",n),S.animate.hide(!1,n)},k.delay.hide))},click:function(t,i){var o=e(this),a=e(t?t.target:""),r=o.find(D.menu),s=S.get.choiceText(o),l=S.get.choiceValue(o,s),c=r.length>0,u=r.find(a).length>0;S.has.menuSearch()&&e(n.activeElement).blur(),u||c&&!k.allowCategorySelection||(S.is.searchSelection()&&(k.allowAdditions&&S.remove.userAddition(),S.remove.searchTerm(),S.is.focusedOnSearch()||1==i||S.focusSearch(!0)),k.useLabels||(S.remove.filteredItem(),S.set.scrollPosition(o)),S.determine.selectAction.call(this,s,l))}},document:{keydown:function(e){var t=e.which;if(S.is.inObject(t,P)){var n=M.find(D.label),i=n.filter("."+T.active),o=(i.data(E.value),n.index(i)),a=n.length,r=i.length>0,s=i.length>1,l=0===o,c=o+1==a,u=S.is.searchSelection(),d=S.is.focusedOnSearch(),f=S.is.focused(),m=d&&0===S.get.caretPosition();if(u&&!r&&!d)return;t==P.leftArrow?!f&&!m||r?r&&(e.shiftKey?S.verbose("Adding previous label to selection"):(S.verbose("Selecting previous label"),n.removeClass(T.active)),l&&!s?i.addClass(T.active):i.prev(D.siblingLabel).addClass(T.active).end(),e.preventDefault()):(S.verbose("Selecting previous label"),n.last().addClass(T.active)):t==P.rightArrow?(f&&!r&&n.first().addClass(T.active),r&&(e.shiftKey?S.verbose("Adding next label to selection"):(S.verbose("Selecting next label"),n.removeClass(T.active)),c?u?d?n.removeClass(T.active):S.focusSearch():s?i.next(D.siblingLabel).addClass(T.active):i.addClass(T.active):i.next(D.siblingLabel).addClass(T.active),e.preventDefault())):t==P.deleteKey||t==P.backspace?r?(S.verbose("Removing active labels"),c&&u&&!d&&S.focusSearch(),i.last().next(D.siblingLabel).addClass(T.active),S.remove.activeLabels(i),e.preventDefault()):m&&!r&&t==P.backspace&&(S.verbose("Removing last label on input backspace"),i=n.last().addClass(T.active),S.remove.activeLabels(i)):i.removeClass(T.active)}}},keydown:function(e){var t=e.which;if(S.is.inObject(t,P)){var n,i=X.not(D.unselectable).filter("."+T.selected).eq(0),o=Q.children("."+T.active).eq(0),a=i.length>0?i:o,r=a.length>0?a.siblings(":not(."+T.filtered+")").addBack():Q.children(":not(."+T.filtered+")"),s=a.children(D.menu),l=a.closest(D.menu),c=l.hasClass(T.visible)||l.hasClass(T.animating)||l.parent(D.menu).length>0,u=s.length>0,d=a.length>0,f=a.not(D.unselectable).length>0,m=t==P.delimiter&&k.allowAdditions&&S.is.multiple();if(k.allowAdditions&&k.hideAdditions&&(t==P.enter||m)&&f&&(S.verbose("Selecting item from keyboard shortcut",a),S.event.item.click.call(a,e),S.is.searchSelection()&&S.remove.searchTerm()),S.is.visible()){if((t==P.enter||m)&&(t==P.enter&&d&&u&&!k.allowCategorySelection?(S.verbose("Pressed enter on unselectable category, opening sub menu"),t=P.rightArrow):f&&(S.verbose("Selecting item from keyboard shortcut",a),S.event.item.click.call(a,e),S.is.searchSelection()&&S.remove.searchTerm()),e.preventDefault()),d&&(t==P.leftArrow&&l[0]!==Q[0]&&(S.verbose("Left key pressed, closing sub-menu"),S.animate.hide(!1,l),a.removeClass(T.selected),l.closest(D.item).addClass(T.selected),e.preventDefault()),t==P.rightArrow&&u&&(S.verbose("Right key pressed, opening sub-menu"),S.animate.show(!1,s),a.removeClass(T.selected),s.find(D.item).eq(0).addClass(T.selected),e.preventDefault())),t==P.upArrow){if(n=d&&c?a.prevAll(D.item+":not("+D.unselectable+")").eq(0):X.eq(0),r.index(n)<0)return S.verbose("Up key pressed but reached top of current menu"),void e.preventDefault();S.verbose("Up key pressed, changing active item"),a.removeClass(T.selected),n.addClass(T.selected),S.set.scrollPosition(n),k.selectOnKeydown&&S.is.single()&&S.set.selectedItem(n),e.preventDefault()}if(t==P.downArrow){if(0===(n=d&&c?n=a.nextAll(D.item+":not("+D.unselectable+")").eq(0):X.eq(0)).length)return S.verbose("Down key pressed but reached bottom of current menu"),void e.preventDefault();S.verbose("Down key pressed, changing active item"),X.removeClass(T.selected),n.addClass(T.selected),S.set.scrollPosition(n),k.selectOnKeydown&&S.is.single()&&S.set.selectedItem(n),e.preventDefault()}t==P.pageUp&&(S.scrollPage("up"),e.preventDefault()),t==P.pageDown&&(S.scrollPage("down"),e.preventDefault()),t==P.escape&&(S.verbose("Escape key pressed, closing dropdown"),S.hide())}else m&&e.preventDefault(),t!=P.downArrow||S.is.visible()||(S.verbose("Down key pressed, showing dropdown"),S.show(),e.preventDefault())}else S.has.search()||S.set.selectedLetter(String.fromCharCode(t))}},trigger:{change:function(){var e=n.createEvent("HTMLEvents"),t=U[0];t&&(S.verbose("Triggering native change event"),e.initEvent("change",!0,!1),t.dispatchEvent(e))}},determine:{selectAction:function(t,n){S.verbose("Determining action",k.action),e.isFunction(S.action[k.action])?(S.verbose("Triggering preset action",k.action,t,n),S.action[k.action].call(K,t,n,this)):e.isFunction(k.action)?(S.verbose("Triggering user action",k.action,t,n),k.action.call(K,t,n,this)):S.error(q.action,k.action)},eventInModule:function(t,i){var o=e(t.target),a=o.closest(n.documentElement).length>0,r=o.closest(M).length>0;return i=e.isFunction(i)?i:function(){},a&&!r?(S.verbose("Triggering event",i),i(),!0):(S.verbose("Event occurred in dropdown, canceling callback"),!1)},eventOnElement:function(t,i){var o=e(t.target),a=o.closest(D.siblingLabel),r=n.body.contains(t.target),s=0===M.find(a).length,l=0===o.closest(Q).length;return i=e.isFunction(i)?i:function(){},r&&s&&l?(S.verbose("Triggering event",i),i(),!0):(S.verbose("Event occurred in dropdown menu, canceling callback"),!1)}},action:{nothing:function(){},activate:function(t,n,o){if(n=n!==i?n:t,S.can.activate(e(o))){if(S.set.selected(n,e(o)),S.is.multiple()&&!S.is.allFiltered())return;S.hideAndClear()}},select:function(t,n,o){if(n=n!==i?n:t,S.can.activate(e(o))){if(S.set.value(n,t,e(o)),S.is.multiple()&&!S.is.allFiltered())return;S.hideAndClear()}},combo:function(t,n,o){n=n!==i?n:t,S.set.selected(n,e(o)),S.hideAndClear()},hide:function(e,t,n){S.set.value(t,e),S.hideAndClear()}},get:{id:function(){return x},defaultText:function(){return M.data(E.defaultText)},defaultValue:function(){return M.data(E.defaultValue)},placeholderText:function(){return"auto"!=k.placeholder&&"string"==typeof k.placeholder?k.placeholder:M.data(E.placeholderText)||""},text:function(){return V.text()},query:function(){return e.trim(N.val())},searchWidth:function(e){return e=e!==i?e:N.val(),H.text(e),Math.ceil(H.width()+1)},selectionCount:function(){var t=S.get.values();return S.is.multiple()?e.isArray(t)?t.length:0:""!==S.get.value()?1:0},transition:function(e){return"auto"==k.transition?S.is.upward(e)?"slide up":"slide down":k.transition},userValues:function(){var t=S.get.values();return!!t&&(t=e.isArray(t)?t:[t],e.grep(t,function(e){return!1===S.get.item(e)}))},uniqueArray:function(t){return e.grep(t,function(n,i){return e.inArray(n,t)===i})},caretPosition:function(){var e,t,i=N.get(0);return"selectionStart"in i?i.selectionStart:n.selection?(i.focus(),t=(e=n.selection.createRange()).text.length,e.moveStart("character",-i.value.length),e.text.length-t):void 0},value:function(){var t=U.length>0?U.val():M.data(E.value),n=e.isArray(t)&&1===t.length&&""===t[0];return t===i||n?"":t},values:function(){var e=S.get.value();return""===e?"":!S.has.selectInput()&&S.is.multiple()?"string"==typeof e?e.split(k.delimiter):"":e},remoteValues:function(){var t=S.get.values(),n=!1;return t&&("string"==typeof t&&(t=[t]),e.each(t,function(e,t){var i=S.read.remoteData(t);S.verbose("Restoring value from session data",i,t),i&&(n||(n={}),n[t]=i)})),n},choiceText:function(t,n){if(n=n!==i?n:k.preserveHTML,t)return t.find(D.menu).length>0&&(S.verbose("Retrieving text of element with sub-menu"),(t=t.clone()).find(D.menu).remove(),t.find(D.menuIcon).remove()),t.data(E.text)!==i?t.data(E.text):n?e.trim(t.html()):e.trim(t.text())},choiceValue:function(t,n){return n=n||S.get.choiceText(t),!!t&&(t.data(E.value)!==i?String(t.data(E.value)):"string"==typeof n?e.trim(n.toLowerCase()):String(n))},inputEvent:function(){var e=N[0];return!!e&&(e.oninput!==i?"input":e.onpropertychange!==i?"propertychange":"keyup")},selectValues:function(){var t={values:[]};return M.find("option").each(function(){var n=e(this),o=n.html(),a=n.attr("disabled"),r=n.attr("value")!==i?n.attr("value"):o;"auto"===k.placeholder&&""===r?t.placeholder=o:t.values.push({name:o,value:r,disabled:a})}),k.placeholder&&"auto"!==k.placeholder&&(S.debug("Setting placeholder value to",k.placeholder),t.placeholder=k.placeholder),k.sortSelect?(t.values.sort(function(e,t){return e.name>t.name?1:-1}),S.debug("Retrieved and sorted values from select",t)):S.debug("Retrieved values from select",t),t},activeItem:function(){return X.filter("."+T.active)},selectedItem:function(){var e=X.not(D.unselectable).filter("."+T.selected);return e.length>0?e:X.eq(0)},itemWithAdditions:function(e){var t=S.get.item(e),n=S.create.userChoice(e);return n&&n.length>0&&(t=t.length>0?t.add(n):n),t},item:function(t,n){var o,a,r=!1;return t=t!==i?t:S.get.values()!==i?S.get.values():S.get.text(),o=a?t.length>0:t!==i&&null!==t,a=S.is.multiple()&&e.isArray(t),n=""===t||0===t||(n||!1),o&&X.each(function(){var o=e(this),s=S.get.choiceText(o),l=S.get.choiceValue(o,s);if(null!==l&&l!==i)if(a)-1===e.inArray(String(l),t)&&-1===e.inArray(s,t)||(r=r?r.add(o):o);else if(n){if(S.verbose("Ambiguous dropdown value using strict type check",o,t),l===t||s===t)return r=o,!0}else if(String(l)==String(t)||s==t)return S.verbose("Found select item by value",l,t),r=o,!0}),r}},check:{maxSelections:function(e){return!k.maxSelections||((e=e!==i?e:S.get.selectionCount())>=k.maxSelections?(S.debug("Maximum selection count reached"),k.useLabels&&(X.addClass(T.filtered),S.add.message(A.maxSelections)),!0):(S.verbose("No longer at maximum selection count"),S.remove.message(),S.remove.filteredItem(),S.is.searchSelection()&&S.filterItems(),!1))}},restore:{defaults:function(){S.clear(),S.restore.defaultText(),S.restore.defaultValue()},defaultText:function(){var e=S.get.defaultText();e===S.get.placeholderText?(S.debug("Restoring default placeholder text",e),S.set.placeholderText(e)):(S.debug("Restoring default text",e),S.set.text(e))},placeholderText:function(){S.set.placeholderText()},defaultValue:function(){var e=S.get.defaultValue();e!==i&&(S.debug("Restoring default value",e),""!==e?(S.set.value(e),S.set.selected()):(S.remove.activeItem(),S.remove.selectedItem()))},labels:function(){k.allowAdditions&&(k.useLabels||(S.error(q.labels),k.useLabels=!0),S.debug("Restoring selected values"),S.create.userLabels()),S.check.maxSelections()},selected:function(){S.restore.values(),S.is.multiple()?(S.debug("Restoring previously selected values and labels"),S.restore.labels()):S.debug("Restoring previously selected values")},values:function(){S.set.initialLoad(),k.apiSettings&&k.saveRemoteData&&S.get.remoteValues()?S.restore.remoteValues():S.set.selected(),S.remove.initialLoad()},remoteValues:function(){var t=S.get.remoteValues();S.debug("Recreating selected from session data",t),t&&(S.is.single()?e.each(t,function(e,t){S.set.text(t)}):e.each(t,function(e,t){S.add.label(e,t)}))}},read:{remoteData:function(e){var n;if(t.Storage!==i)return(n=sessionStorage.getItem(e))!==i&&n;S.error(q.noStorage)}},save:{defaults:function(){S.save.defaultText(),S.save.placeholderText(),S.save.defaultValue()},defaultValue:function(){var e=S.get.value();S.verbose("Saving default value as",e),M.data(E.defaultValue,e)},defaultText:function(){var e=S.get.text();S.verbose("Saving default text as",e),M.data(E.defaultText,e)},placeholderText:function(){var e;!1!==k.placeholder&&V.hasClass(T.placeholder)&&(e=S.get.text(),S.verbose("Saving placeholder text as",e),M.data(E.placeholderText,e))},remoteData:function(e,n){t.Storage!==i?(S.verbose("Saving remote data to session storage",n,e),sessionStorage.setItem(n,e)):S.error(q.noStorage)}},clear:function(){S.is.multiple()&&k.useLabels?S.remove.labels():(S.remove.activeItem(),S.remove.selectedItem()),S.set.placeholderText(),S.clearValue()},clearValue:function(){S.set.value("")},scrollPage:function(e,t){var n,i,o=t||S.get.selectedItem(),a=o.closest(D.menu),r=a.outerHeight(),s=a.scrollTop(),l=X.eq(0).outerHeight(),c=Math.floor(r/l),u=(a.prop("scrollHeight"),"up"==e?s-l*c:s+l*c),d=X.not(D.unselectable);i="up"==e?d.index(o)-c:d.index(o)+c,(n=("up"==e?i>=0:i<d.length)?d.eq(i):"up"==e?d.first():d.last()).length>0&&(S.debug("Scrolling page",e,n),o.removeClass(T.selected),n.addClass(T.selected),k.selectOnKeydown&&S.is.single()&&S.set.selectedItem(n),a.scrollTop(u))},set:{filtered:function(){var e=S.is.multiple(),t=S.is.searchSelection(),n=e&&t,i=t?S.get.query():"",o="string"==typeof i&&i.length>0,a=S.get.searchWidth(),r=""!==i;e&&o&&(S.verbose("Adjusting input width",a,k.glyphWidth),N.css("width",a)),o||n&&r?(S.verbose("Hiding placeholder text"),V.addClass(T.filtered)):(!e||n&&!r)&&(S.verbose("Showing placeholder text"),V.removeClass(T.filtered))},empty:function(){M.addClass(T.empty)},loading:function(){M.addClass(T.loading)},placeholderText:function(e){e=e||S.get.placeholderText(),S.debug("Setting placeholder text",e),S.set.text(e),V.addClass(T.placeholder)},tabbable:function(){S.is.searchSelection()?(S.debug("Added tabindex to searchable dropdown"),N.val("").attr("tabindex",0),Q.attr("tabindex",-1)):(S.debug("Added tabindex to dropdown"),M.attr("tabindex")===i&&(M.attr("tabindex",0),Q.attr("tabindex",-1)))},initialLoad:function(){S.verbose("Setting initial load"),h=!0},activeItem:function(e){k.allowAdditions&&e.filter(D.addition).length>0?e.addClass(T.filtered):e.addClass(T.active)},partialSearch:function(e){var t=S.get.query().length;N.val(e.substr(0,t))},scrollPosition:function(e,t){var n,o,a,r,s,l;n=(e=e||S.get.selectedItem()).closest(D.menu),o=e&&e.length>0,t=t!==i&&t,e&&n.length>0&&o&&(e.position().top,n.addClass(T.loading),a=(r=n.scrollTop())-n.offset().top+e.offset().top,t||(l=r+n.height()<a+5,s=a-5<r),S.debug("Scrolling to active item",a),(t||s||l)&&n.scrollTop(a),n.removeClass(T.loading))},text:function(e){"select"!==k.action&&("combo"==k.action?(S.debug("Changing combo button text",e,B),k.preserveHTML?B.html(e):B.text(e)):(e!==S.get.placeholderText()&&V.removeClass(T.placeholder),S.debug("Changing text",e,V),V.removeClass(T.filtered),k.preserveHTML?V.html(e):V.text(e)))},selectedItem:function(e){var t=S.get.choiceValue(e),n=S.get.choiceText(e,!1),i=S.get.choiceText(e,!0);S.debug("Setting user selection to item",e),S.remove.activeItem(),S.set.partialSearch(n),S.set.activeItem(e),S.set.selected(t,e),S.set.text(i)},selectedLetter:function(t){var n,i=X.filter("."+T.selected),o=!1;i.length>0&&S.has.firstLetter(i,t)&&(n=i.nextAll(X).eq(0),S.has.firstLetter(n,t)&&(o=n)),o||X.each(function(){if(S.has.firstLetter(e(this),t))return o=e(this),!1}),o&&(S.verbose("Scrolling to next value with letter",t),S.set.scrollPosition(o),i.removeClass(T.selected),o.addClass(T.selected),k.selectOnKeydown&&S.is.single()&&S.set.selectedItem(o))},direction:function(e){"auto"==k.direction?(S.remove.upward(),S.can.openDownward(e)?S.remove.upward(e):S.set.upward(e),S.is.leftward(e)||S.can.openRightward(e)||S.set.leftward(e)):"upward"==k.direction&&S.set.upward(e)},upward:function(e){(e||M).addClass(T.upward)},leftward:function(e){(e||Q).addClass(T.leftward)},value:function(e,t,n){var o=S.escape.value(e),a=U.length>0,r=S.get.values(),s=e!==i?String(e):e;if(a){if(!k.allowReselection&&s==r&&(S.verbose("Skipping value update already same value",e,r),!S.is.initialLoad()))return;S.is.single()&&S.has.selectInput()&&S.can.extendSelect()&&(S.debug("Adding user option",e),S.add.optionValue(e)),S.debug("Updating input value",o,r),Z=!0,U.val(o),!1===k.fireOnInit&&S.is.initialLoad()?S.debug("Input native change event ignored on initial load"):S.trigger.change(),Z=!1}else S.verbose("Storing value in metadata",o,U),o!==r&&M.data(E.value,s);!1===k.fireOnInit&&S.is.initialLoad()?S.verbose("No callback on initial load",k.onChange):k.onChange.call(K,e,t,n)},active:function(){M.addClass(T.active)},multiple:function(){M.addClass(T.multiple)},visible:function(){M.addClass(T.visible)},exactly:function(e,t){S.debug("Setting selected to exact values"),S.clear(),S.set.selected(e,t)},selected:function(t,n){var i=S.is.multiple();(n=k.allowAdditions?n||S.get.itemWithAdditions(t):n||S.get.item(t))&&(S.debug("Setting selected menu item to",n),S.is.multiple()&&S.remove.searchWidth(),S.is.single()?(S.remove.activeItem(),S.remove.selectedItem()):k.useLabels&&S.remove.selectedItem(),n.each(function(){var t=e(this),o=S.get.choiceText(t),a=S.get.choiceValue(t,o),r=t.hasClass(T.filtered),s=t.hasClass(T.active),l=t.hasClass(T.addition),c=i&&1==n.length;i?!s||l?(k.apiSettings&&k.saveRemoteData&&S.save.remoteData(o,a),k.useLabels?(S.add.label(a,o,c),S.add.value(a,o,t),S.set.activeItem(t),S.filterActive(),S.select.nextAvailable(n)):(S.add.value(a,o,t),S.set.text(S.add.variables(A.count)),S.set.activeItem(t))):r||(S.debug("Selected active value, removing label"),S.remove.selected(a)):(k.apiSettings&&k.saveRemoteData&&S.save.remoteData(o,a),S.set.text(o),S.set.value(a,o,t),t.addClass(T.active).addClass(T.selected))}))}},add:{label:function(t,n,i){var o,a=S.is.searchSelection()?N:V,r=S.escape.value(t);k.ignoreCase&&(r=r.toLowerCase()),o=e("<a />").addClass(T.label).attr("data-"+E.value,r).html(j.label(r,n)),o=k.onLabelCreate.call(o,r,n),S.has.label(t)?S.debug("User selection already exists, skipping",r):(k.label.variation&&o.addClass(k.label.variation),!0===i?(S.debug("Animating in label",o),o.addClass(T.hidden).insertBefore(a).transition(k.label.transition,k.label.duration)):(S.debug("Adding selection label",o),o.insertBefore(a)))},message:function(t){var n=Q.children(D.message),i=k.templates.message(S.add.variables(t));n.length>0?n.html(i):n=e("<div/>").html(i).addClass(T.message).appendTo(Q)},optionValue:function(t){var n=S.escape.value(t);U.find('option[value="'+S.escape.string(n)+'"]').length>0||(S.disconnect.selectObserver(),S.is.single()&&(S.verbose("Removing previous user addition"),U.find("option."+T.addition).remove()),e("<option/>").prop("value",n).addClass(T.addition).html(t).appendTo(U),S.verbose("Adding user addition as an <option>",t),S.observe.select())},userSuggestion:function(e){var t,n=Q.children(D.addition),i=S.get.item(e),o=i&&i.not(D.addition).length,a=n.length>0;k.useLabels&&S.has.maxSelections()||(""===e||o?n.remove():(a?(n.data(E.value,e).data(E.text,e).attr("data-"+E.value,e).attr("data-"+E.text,e).removeClass(T.filtered),k.hideAdditions||(t=k.templates.addition(S.add.variables(A.addResult,e)),n.html(t)),S.verbose("Replacing user suggestion with new value",n)):((n=S.create.userChoice(e)).prependTo(Q),S.verbose("Adding item choice to menu corresponding with user choice addition",n)),k.hideAdditions&&!S.is.allFiltered()||n.addClass(T.selected).siblings().removeClass(T.selected),S.refreshItems()))},variables:function(e,t){var n,i,o=-1!==e.search("{count}"),a=-1!==e.search("{maxCount}"),r=-1!==e.search("{term}");return S.verbose("Adding templated variables to message",e),o&&(n=S.get.selectionCount(),e=e.replace("{count}",n)),a&&(n=S.get.selectionCount(),e=e.replace("{maxCount}",k.maxSelections)),r&&(i=t||S.get.query(),e=e.replace("{term}",i)),e},value:function(t,n,i){var o,a=S.get.values();S.has.value(t)?S.debug("Value already selected"):""!==t?(e.isArray(a)?(o=a.concat([t]),o=S.get.uniqueArray(o)):o=[t],S.has.selectInput()?S.can.extendSelect()&&(S.debug("Adding value to select",t,o,U),S.add.optionValue(t)):(o=o.join(k.delimiter),S.debug("Setting hidden input to delimited value",o,U)),!1===k.fireOnInit&&S.is.initialLoad()?S.verbose("Skipping onadd callback on initial load",k.onAdd):k.onAdd.call(K,t,n,i),S.set.value(o,t,n,i),S.check.maxSelections()):S.debug("Cannot select blank values from multiselect")}},remove:{active:function(){M.removeClass(T.active)},activeLabel:function(){M.find(D.label).removeClass(T.active)},empty:function(){M.removeClass(T.empty)},loading:function(){M.removeClass(T.loading)},initialLoad:function(){h=!1},upward:function(e){(e||M).removeClass(T.upward)},leftward:function(e){(e||Q).removeClass(T.leftward)},visible:function(){M.removeClass(T.visible)},activeItem:function(){X.removeClass(T.active)},filteredItem:function(){k.useLabels&&S.has.maxSelections()||(k.useLabels&&S.is.multiple()?X.not("."+T.active).removeClass(T.filtered):X.removeClass(T.filtered),S.remove.empty())},optionValue:function(e){var t=S.escape.value(e),n=U.find('option[value="'+S.escape.string(t)+'"]');n.length>0&&n.hasClass(T.addition)&&(C&&(C.disconnect(),S.verbose("Temporarily disconnecting mutation observer")),n.remove(),S.verbose("Removing user addition as an <option>",t),C&&C.observe(U[0],{childList:!0,subtree:!0}))},message:function(){Q.children(D.message).remove()},searchWidth:function(){N.css("width","")},searchTerm:function(){S.verbose("Cleared search term"),N.val(""),S.set.filtered()},userAddition:function(){X.filter(D.addition).remove()},selected:function(t,n){if(!(n=k.allowAdditions?n||S.get.itemWithAdditions(t):n||S.get.item(t)))return!1;n.each(function(){var t=e(this),n=S.get.choiceText(t),i=S.get.choiceValue(t,n);S.is.multiple()?k.useLabels?(S.remove.value(i,n,t),S.remove.label(i)):(S.remove.value(i,n,t),0===S.get.selectionCount()?S.set.placeholderText():S.set.text(S.add.variables(A.count))):S.remove.value(i,n,t),t.removeClass(T.filtered).removeClass(T.active),k.useLabels&&t.removeClass(T.selected)})},selectedItem:function(){X.removeClass(T.selected)},value:function(e,t,n){var i,o=S.get.values();S.has.selectInput()?(S.verbose("Input is <select> removing selected option",e),i=S.remove.arrayValue(e,o),S.remove.optionValue(e)):(S.verbose("Removing from delimited values",e),i=(i=S.remove.arrayValue(e,o)).join(k.delimiter)),!1===k.fireOnInit&&S.is.initialLoad()?S.verbose("No callback on initial load",k.onRemove):k.onRemove.call(K,e,t,n),S.set.value(i,t,n),S.check.maxSelections()},arrayValue:function(t,n){return e.isArray(n)||(n=[n]),n=e.grep(n,function(e){return t!=e}),S.verbose("Removed value from delimited string",t,n),n},label:function(e,t){var n=M.find(D.label).filter("[data-"+E.value+'="'+S.escape.string(e)+'"]');S.verbose("Removing label",n),n.remove()},activeLabels:function(e){e=e||M.find(D.label).filter("."+T.active),S.verbose("Removing active label selections",e),S.remove.labels(e)},labels:function(t){t=t||M.find(D.label),S.verbose("Removing labels",t),t.each(function(){var t=e(this),n=t.data(E.value),o=n!==i?String(n):n,a=S.is.userValue(o);!1!==k.onLabelRemove.call(t,n)?(S.remove.message(),a?(S.remove.value(o),S.remove.label(o)):S.remove.selected(o)):S.debug("Label remove callback cancelled removal")})},tabbable:function(){S.is.searchSelection()?(S.debug("Searchable dropdown initialized"),N.removeAttr("tabindex"),Q.removeAttr("tabindex")):(S.debug("Simple selection dropdown initialized"),M.removeAttr("tabindex"),Q.removeAttr("tabindex"))}},has:{menuSearch:function(){return S.has.search()&&N.closest(Q).length>0},search:function(){return N.length>0},sizer:function(){return H.length>0},selectInput:function(){return U.is("select")},minCharacters:function(e){return!k.minCharacters||(e=e!==i?String(e):String(S.get.query())).length>=k.minCharacters},firstLetter:function(e,t){var n;return!(!e||0===e.length||"string"!=typeof t)&&(n=S.get.choiceText(e,!1),(t=t.toLowerCase())==String(n).charAt(0).toLowerCase())},input:function(){return U.length>0},items:function(){return X.length>0},menu:function(){return Q.length>0},message:function(){return 0!==Q.children(D.message).length},label:function(e){var t=S.escape.value(e),n=M.find(D.label);return k.ignoreCase&&(t=t.toLowerCase()),n.filter("[data-"+E.value+'="'+S.escape.string(t)+'"]').length>0},maxSelections:function(){return k.maxSelections&&S.get.selectionCount()>=k.maxSelections},allResultsFiltered:function(){var e=X.not(D.addition);return e.filter(D.unselectable).length===e.length},userSuggestion:function(){return Q.children(D.addition).length>0},query:function(){return""!==S.get.query()},value:function(e){return k.ignoreCase?S.has.valueIgnoringCase(e):S.has.valueMatchingCase(e)},valueMatchingCase:function(t){var n=S.get.values();return!!(e.isArray(n)?n&&-1!==e.inArray(t,n):n==t)},valueIgnoringCase:function(t){var n=S.get.values(),i=!1;return e.isArray(n)||(n=[n]),e.each(n,function(e,n){if(String(t).toLowerCase()==String(n).toLowerCase())return i=!0,!1}),i}},is:{active:function(){return M.hasClass(T.active)},animatingInward:function(){return Q.transition("is inward")},animatingOutward:function(){return Q.transition("is outward")},bubbledLabelClick:function(t){return e(t.target).is("select, input")&&M.closest("label").length>0},bubbledIconClick:function(t){return e(t.target).closest(W).length>0},alreadySetup:function(){return M.is("select")&&M.parent(D.dropdown).data(I)!==i&&0===M.prev().length},animating:function(e){return e?e.transition&&e.transition("is animating"):Q.transition&&Q.transition("is animating")},leftward:function(e){return(e||Q).hasClass(T.leftward)},disabled:function(){return M.hasClass(T.disabled)},focused:function(){return n.activeElement===M[0]},focusedOnSearch:function(){return n.activeElement===N[0]},allFiltered:function(){return(S.is.multiple()||S.has.search())&&!(0==k.hideAdditions&&S.has.userSuggestion())&&!S.has.message()&&S.has.allResultsFiltered()},hidden:function(e){return!S.is.visible(e)},initialLoad:function(){return h},inObject:function(t,n){var i=!1;return e.each(n,function(e,n){if(n==t)return i=!0,!0}),i},multiple:function(){return M.hasClass(T.multiple)},remote:function(){return k.apiSettings&&S.can.useAPI()},single:function(){return!S.is.multiple()},selectMutation:function(t){var n=!1;return e.each(t,function(t,i){if(i.target&&e(i.target).is("select"))return n=!0,!0}),n},search:function(){return M.hasClass(T.search)},searchSelection:function(){return S.has.search()&&1===N.parent(D.dropdown).length},selection:function(){return M.hasClass(T.selection)},userValue:function(t){return-1!==e.inArray(t,S.get.userValues())},upward:function(e){return(e||M).hasClass(T.upward)},visible:function(e){return e?e.hasClass(T.visible):Q.hasClass(T.visible)},verticallyScrollableContext:function(){var e=L.get(0)!==t&&L.css("overflow-y");return"auto"==e||"scroll"==e},horizontallyScrollableContext:function(){var e=L.get(0)!==t&&L.css("overflow-X");return"auto"==e||"scroll"==e}},can:{activate:function(e){return!!k.useLabels||(!S.has.maxSelections()||!(!S.has.maxSelections()||!e.hasClass(T.active)))},openDownward:function(e){var n,i,o=e||Q,a=!0;return o.addClass(T.loading),i={context:{offset:L.get(0)===t?{top:0,left:0}:L.offset(),scrollTop:L.scrollTop(),height:L.outerHeight()},menu:{offset:o.offset(),height:o.outerHeight()}},S.is.verticallyScrollableContext()&&(i.menu.offset.top+=i.context.scrollTop),(n={above:i.context.scrollTop<=i.menu.offset.top-i.context.offset.top-i.menu.height,below:i.context.scrollTop+i.context.height>=i.menu.offset.top-i.context.offset.top+i.menu.height}).below?(S.verbose("Dropdown can fit in context downward",n),a=!0):n.below||n.above?(S.verbose("Dropdown cannot fit below, opening upward",n),a=!1):(S.verbose("Dropdown cannot fit in either direction, favoring downward",n),a=!0),o.removeClass(T.loading),a},openRightward:function(e){var n,i,o=e||Q,a=!0;return o.addClass(T.loading),i={context:{offset:L.get(0)===t?{top:0,left:0}:L.offset(),scrollLeft:L.scrollLeft(),width:L.outerWidth()},menu:{offset:o.offset(),width:o.outerWidth()}},S.is.horizontallyScrollableContext()&&(i.menu.offset.left+=i.context.scrollLeft),(n=i.menu.offset.left-i.context.offset.left+i.menu.width>=i.context.scrollLeft+i.context.width)&&(S.verbose("Dropdown cannot fit in context rightward",n),a=!1),o.removeClass(T.loading),a},click:function(){return c||"click"==k.on},extendSelect:function(){return k.allowAdditions||k.apiSettings},show:function(){return!S.is.disabled()&&(S.has.items()||S.has.message())},useAPI:function(){return e.fn.api!==i}},animate:{show:function(t,n){var o,a=n||Q,r=n?function(){}:function(){S.hideSubMenus(),S.hideOthers(),S.set.active()};t=e.isFunction(t)?t:function(){},S.verbose("Doing menu show animation",a),S.set.direction(n),o=S.get.transition(n),S.is.selection()&&S.set.scrollPosition(S.get.selectedItem(),!0),(S.is.hidden(a)||S.is.animating(a))&&("none"==o?(r(),a.transition("show"),t.call(K)):e.fn.transition!==i&&M.transition("is supported")?a.transition({animation:o+" in",debug:k.debug,verbose:k.verbose,duration:k.duration,queue:!0,onStart:r,onComplete:function(){t.call(K)}}):S.error(q.noTransition,o))},hide:function(t,n){var o=n||Q,a=(n?k.duration:k.duration,n?function(){}:function(){S.can.click()&&S.unbind.intent(),S.remove.active()}),r=S.get.transition(n);t=e.isFunction(t)?t:function(){},(S.is.visible(o)||S.is.animating(o))&&(S.verbose("Doing menu hide animation",o),"none"==r?(a(),o.transition("hide"),t.call(K)):e.fn.transition!==i&&M.transition("is supported")?o.transition({animation:r+" out",duration:k.duration,debug:k.debug,verbose:k.verbose,queue:!1,onStart:a,onComplete:function(){t.call(K)}}):S.error(q.transition))}},hideAndClear:function(){S.remove.searchTerm(),S.has.maxSelections()||(S.has.search()?S.hide(function(){S.remove.filteredItem()}):S.hide())},delay:{show:function(){S.verbose("Delaying show event to ensure user intent"),clearTimeout(S.timer),S.timer=setTimeout(S.show,k.delay.show)},hide:function(){S.verbose("Delaying hide event to ensure user intent"),clearTimeout(S.timer),S.timer=setTimeout(S.hide,k.delay.hide)}},escape:{value:function(t){var n=e.isArray(t),i="string"==typeof t,o=!i&&!n,a=i&&-1!==t.search(O.quote),r=[];return o||!a?t:(S.debug("Encoding quote values for use in select",t),n?(e.each(t,function(e,t){r.push(t.replace(O.quote,"&quot;"))}),r):t.replace(O.quote,"&quot;"))},string:function(e){return(e=String(e)).replace(O.escape,"\\$&")}},setting:function(t,n){if(S.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,k,t);else{if(n===i)return k[t];e.isPlainObject(k[t])?e.extend(!0,k[t],n):k[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,S,t);else{if(n===i)return S[t];S[t]=n}},debug:function(){!k.silent&&k.debug&&(k.performance?S.performance.log(arguments):(S.debug=Function.prototype.bind.call(console.info,console,k.name+":"),S.debug.apply(console,arguments)))},verbose:function(){!k.silent&&k.verbose&&k.debug&&(k.performance?S.performance.log(arguments):(S.verbose=Function.prototype.bind.call(console.info,console,k.name+":"),S.verbose.apply(console,arguments)))},error:function(){k.silent||(S.error=Function.prototype.bind.call(console.error,console,k.name+":"),S.error.apply(console,arguments))},performance:{log:function(e){var t,n;k.performance&&(n=(t=(new Date).getTime())-(u||t),u=t,d.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:K,"Execution Time":n})),clearTimeout(S.performance.timer),S.performance.timer=setTimeout(S.performance.display,500)},display:function(){var t=k.name+":",n=0;u=!1,clearTimeout(S.performance.timer),e.each(d,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",l&&(t+=" '"+l+"'"),(console.group!==i||console.table!==i)&&d.length>0&&(console.groupCollapsed(t),console.table?console.table(d):e.each(d,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),d=[]}},invoke:function(t,n,o){var r,s,l,c=J;return n=n||g,o=K||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(S.error(q.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},m?(J===i&&S.initialize(),S.invoke(f)):(J!==i&&J.invoke("destroy"),S.initialize())}),a!==i?a:r},e.fn.dropdown.settings={silent:!1,debug:!1,verbose:!1,performance:!0,on:"click",action:"activate",values:!1,apiSettings:!1,selectOnKeydown:!0,minCharacters:0,filterRemoteData:!1,saveRemoteData:!0,throttle:200,context:t,direction:"auto",keepOnScreen:!0,match:"both",fullTextSearch:!1,placeholder:"auto",preserveHTML:!0,sortSelect:!1,forceSelection:!0,allowAdditions:!1,ignoreCase:!1,hideAdditions:!0,maxSelections:!1,useLabels:!0,delimiter:",",showOnFocus:!0,allowReselection:!1,allowTab:!0,allowCategorySelection:!1,fireOnInit:!1,transition:"auto",duration:200,glyphWidth:1.037,label:{transition:"scale",duration:200,variation:!1},delay:{hide:300,show:200,search:20,touch:50},onChange:function(e,t,n){},onAdd:function(e,t,n){},onRemove:function(e,t,n){},onLabelSelect:function(e){},onLabelCreate:function(t,n){return e(this)},onLabelRemove:function(e){return!0},onNoResults:function(e){return!0},onShow:function(){},onHide:function(){},name:"Dropdown",namespace:"dropdown",message:{addResult:"Add <b>{term}</b>",count:"{count} selected",maxSelections:"Max {maxCount} selections",noResults:"No results found.",serverError:"There was an error contacting the server"},error:{action:"You called a dropdown action that was not defined",alreadySetup:"Once a select has been initialized behaviors must be called on the created ui dropdown",labels:"Allowing user additions currently requires the use of labels.",missingMultiple:"<select> requires multiple property to be set to correctly preserve multiple values",method:"The method you called is not defined.",noAPI:"The API module is required to load resources remotely",noStorage:"Saving remote data requires session storage",noTransition:"This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>"},regExp:{escape:/[-[\]{}()*+?.,\\^$|#\s]/g,quote:/"/g},metadata:{defaultText:"defaultText",defaultValue:"defaultValue",placeholderText:"placeholder",text:"text",value:"value"},fields:{remoteValues:"results",values:"values",disabled:"disabled",name:"name",value:"value",text:"text"},keys:{backspace:8,delimiter:188,deleteKey:46,enter:13,escape:27,pageUp:33,pageDown:34,leftArrow:37,upArrow:38,rightArrow:39,downArrow:40},selector:{addition:".addition",dropdown:".ui.dropdown",hidden:".hidden",icon:"> .dropdown.icon",input:'> input[type="hidden"], > select',item:".item",label:"> .label",remove:"> .label > .delete.icon",siblingLabel:".label",menu:".menu",message:".message",menuIcon:".dropdown.icon",search:"input.search, .menu > .search > input, .menu input.search",sizer:"> input.sizer",text:"> .text:not(.icon)",unselectable:".disabled, .filtered"},className:{active:"active",addition:"addition",animating:"animating",disabled:"disabled",empty:"empty",dropdown:"ui dropdown",filtered:"filtered",hidden:"hidden transition",item:"item",label:"ui label",loading:"loading",menu:"menu",message:"message",multiple:"multiple",placeholder:"default",sizer:"sizer",search:"search",selected:"selected",selection:"selection",upward:"upward",leftward:"left",visible:"visible"}},e.fn.dropdown.settings.templates={dropdown:function(t){var n=t.placeholder||!1,i=(t.values,"");return i+='<i class="dropdown icon"></i>',t.placeholder?i+='<div class="default text">'+n+"</div>":i+='<div class="text"></div>',i+='<div class="menu">',e.each(t.values,function(e,t){i+=t.disabled?'<div class="disabled item" data-value="'+t.value+'">'+t.name+"</div>":'<div class="item" data-value="'+t.value+'">'+t.name+"</div>"}),i+="</div>"},menu:function(t,n){var i=t[n.values]||{},o="";return e.each(i,function(e,t){var i=t[n.text]?'data-text="'+t[n.text]+'"':"",a=t[n.disabled]?"disabled ":"";o+='<div class="'+a+'item" data-value="'+t[n.value]+'"'+i+">",o+=t[n.name],o+="</div>"}),o},label:function(e,t){return t+'<i class="delete icon"></i>'},message:function(e){return e},addition:function(e){return e}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.embed=function(n){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var f,m=e.isPlainObject(n)?e.extend(!0,{},e.fn.embed.settings,n):e.extend({},e.fn.embed.settings),g=m.selector,p=m.className,h=m.sources,v=m.error,b=m.metadata,y=m.namespace,x=m.templates,C="."+y,w="module-"+y,S=(e(t),e(this)),k=(S.find(g.placeholder),S.find(g.icon),S.find(g.embed)),T=this,A=S.data(w);f={initialize:function(){f.debug("Initializing embed"),f.determine.autoplay(),f.create(),f.bind.events(),f.instantiate()},instantiate:function(){f.verbose("Storing instance of module",f),A=f,S.data(w,f)},destroy:function(){f.verbose("Destroying previous instance of embed"),f.reset(),S.removeData(w).off(C)},refresh:function(){f.verbose("Refreshing selector cache"),S.find(g.placeholder),S.find(g.icon),k=S.find(g.embed)},bind:{events:function(){f.has.placeholder()&&(f.debug("Adding placeholder events"),S.on("click"+C,g.placeholder,f.createAndShow).on("click"+C,g.icon,f.createAndShow))}},create:function(){f.get.placeholder()?f.createPlaceholder():f.createAndShow()},createPlaceholder:function(e){var t=f.get.icon(),n=f.get.url();f.generate.embed(n);e=e||f.get.placeholder(),S.html(x.placeholder(e,t)),f.debug("Creating placeholder for embed",e,t)},createEmbed:function(t){f.refresh(),t=t||f.get.url(),k=e("<div/>").addClass(p.embed).html(f.generate.embed(t)).appendTo(S),m.onCreate.call(T,t),f.debug("Creating embed object",k)},changeEmbed:function(e){k.html(f.generate.embed(e))},createAndShow:function(){f.createEmbed(),f.show()},change:function(e,t,n){f.debug("Changing video to ",e,t,n),S.data(b.source,e).data(b.id,t),n?S.data(b.url,n):S.removeData(b.url),f.has.embed()?f.changeEmbed():f.create()},reset:function(){f.debug("Clearing embed and showing placeholder"),f.remove.active(),f.remove.embed(),f.showPlaceholder(),m.onReset.call(T)},show:function(){f.debug("Showing embed"),f.set.active(),m.onDisplay.call(T)},hide:function(){f.debug("Hiding embed"),f.showPlaceholder()},showPlaceholder:function(){f.debug("Showing placeholder image"),f.remove.active(),m.onPlaceholderDisplay.call(T)},get:{id:function(){return m.id||S.data(b.id)},placeholder:function(){return m.placeholder||S.data(b.placeholder)},icon:function(){return m.icon?m.icon:S.data(b.icon)!==i?S.data(b.icon):f.determine.icon()},source:function(e){return m.source?m.source:S.data(b.source)!==i?S.data(b.source):f.determine.source()},type:function(){var e=f.get.source();return h[e]!==i&&h[e].type},url:function(){return m.url?m.url:S.data(b.url)!==i?S.data(b.url):f.determine.url()}},determine:{autoplay:function(){f.should.autoplay()&&(m.autoplay=!0)},source:function(t){var n=!1;return(t=t||f.get.url())&&e.each(h,function(e,i){if(-1!==t.search(i.domain))return n=e,!1}),n},icon:function(){var e=f.get.source();return h[e]!==i&&h[e].icon},url:function(){var e,t=m.id||S.data(b.id),n=m.source||S.data(b.source);return(e=h[n]!==i&&h[n].url.replace("{id}",t))&&S.data(b.url,e),e}},set:{active:function(){S.addClass(p.active)}},remove:{active:function(){S.removeClass(p.active)},embed:function(){k.empty()}},encode:{parameters:function(e){var t,n=[];for(t in e)n.push(encodeURIComponent(t)+"="+encodeURIComponent(e[t]));return n.join("&amp;")}},generate:{embed:function(e){f.debug("Generating embed html");var t,n,i=f.get.source();return(e=f.get.url(e))?(n=f.generate.parameters(i),t=x.iframe(e,n)):f.error(v.noURL,S),t},parameters:function(t,n){var o=h[t]&&h[t].parameters!==i?h[t].parameters(m):{};return(n=n||m.parameters)&&(o=e.extend({},o,n)),o=m.onEmbed(o),f.encode.parameters(o)}},has:{embed:function(){return k.length>0},placeholder:function(){return m.placeholder||S.data(b.placeholder)}},should:{autoplay:function(){return"auto"===m.autoplay?m.placeholder||S.data(b.placeholder)!==i:m.autoplay}},is:{video:function(){return"video"==f.get.type()}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n;m.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:T,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;s=!1,clearTimeout(f.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=A;return n=n||d,a=T||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(f.error(v.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},u?(A===i&&f.initialize(),f.invoke(c)):(A!==i&&A.invoke("destroy"),f.initialize())}),o!==i?o:this},e.fn.embed.settings={name:"Embed",namespace:"embed",silent:!1,debug:!1,verbose:!1,performance:!0,icon:!1,source:!1,url:!1,id:!1,autoplay:"auto",color:"#444444",hd:!0,brandedUI:!1,parameters:!1,onDisplay:function(){},onPlaceholderDisplay:function(){},onReset:function(){},onCreate:function(e){},onEmbed:function(e){return e},metadata:{id:"id",icon:"icon",placeholder:"placeholder",source:"source",url:"url"},error:{noURL:"No URL specified",method:"The method you called is not defined"},className:{active:"active",embed:"embed"},selector:{embed:".embed",placeholder:".placeholder",icon:".icon"},sources:{youtube:{name:"youtube",type:"video",icon:"video play",domain:"youtube.com",url:"//www.youtube.com/embed/{id}",parameters:function(e){return{autohide:!e.brandedUI,autoplay:e.autoplay,color:e.color||i,hq:e.hd,jsapi:e.api,modestbranding:!e.brandedUI}}},vimeo:{name:"vimeo",type:"video",icon:"video play",domain:"vimeo.com",url:"//player.vimeo.com/video/{id}",parameters:function(e){return{api:e.api,autoplay:e.autoplay,byline:e.brandedUI,color:e.color||i,portrait:e.brandedUI,title:e.brandedUI}}}},templates:{iframe:function(e,t){var n=e;return t&&(n+="?"+t),'<iframe src="'+n+'" width="100%" height="100%" frameborder="0" scrolling="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'},placeholder:function(e,t){var n="";return t&&(n+='<i class="'+t+' icon"></i>'),e&&(n+='<img class="placeholder" src="'+e+'">'),n}},api:!1,onPause:function(){},onPlay:function(){},onStop:function(){}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.modal=function(o){var a,r=e(this),s=e(t),l=e(n),c=e("body"),u=r.selector||"",d=(new Date).getTime(),f=[],m=arguments[0],g="string"==typeof m,p=[].slice.call(arguments,1),h=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var r,v,b,y,x,C,w,S,k,T=e.isPlainObject(o)?e.extend(!0,{},e.fn.modal.settings,o):e.extend({},e.fn.modal.settings),A=T.selector,R=T.className,P=T.namespace,E=T.error,F="."+P,O="module-"+P,D=e(this),q=e(T.context),j=D.find(A.close),z=this,I=D.data(O),M=!1;k={initialize:function(){k.verbose("Initializing dimmer",q),k.create.id(),k.create.dimmer(),k.refreshModals(),k.bind.events(),T.observeChanges&&k.observeChanges(),k.instantiate()},instantiate:function(){k.verbose("Storing instance of modal"),I=k,D.data(O,I)},create:{dimmer:function(){var t={debug:T.debug,variation:!T.centered&&"top aligned",dimmerName:"modals"},n=e.extend(!0,t,T.dimmerSettings);e.fn.dimmer!==i?(k.debug("Creating dimmer"),y=q.dimmer(n),T.detachable?(k.verbose("Modal is detachable, moving content into dimmer"),y.dimmer("add content",D)):k.set.undetached(),x=y.dimmer("get dimmer")):k.error(E.dimmer)},id:function(){w=(Math.random().toString(16)+"000000000").substr(2,8),C="."+w,k.verbose("Creating unique id for element",w)}},destroy:function(){k.verbose("Destroying previous modal"),D.removeData(O).off(F),s.off(C),x.off(C),j.off(F),q.dimmer("destroy")},observeChanges:function(){"MutationObserver"in t&&((S=new MutationObserver(function(e){k.debug("DOM tree modified, refreshing"),k.refresh()})).observe(z,{childList:!0,subtree:!0}),k.debug("Setting up mutation observer",S))},refresh:function(){k.remove.scrolling(),k.cacheSizes(),k.set.screenHeight(),k.set.type()},refreshModals:function(){v=D.siblings(A.modal),r=v.add(D)},attachEvents:function(t,n){var i=e(t);n=e.isFunction(k[n])?k[n]:k.toggle,i.length>0?(k.debug("Attaching modal events to element",t,n),i.off(F).on("click"+F,n)):k.error(E.notFound,t)},bind:{events:function(){k.verbose("Attaching events"),D.on("click"+F,A.close,k.event.close).on("click"+F,A.approve,k.event.approve).on("click"+F,A.deny,k.event.deny),s.on("resize"+C,k.event.resize)}},get:{id:function(){return(Math.random().toString(16)+"000000000").substr(2,8)}},event:{approve:function(){M||!1===T.onApprove.call(z,e(this))?k.verbose("Approve callback returned false cancelling hide"):(M=!0,k.hide(function(){M=!1}))},deny:function(){M||!1===T.onDeny.call(z,e(this))?k.verbose("Deny callback returned false cancelling hide"):(M=!0,k.hide(function(){M=!1}))},close:function(){k.hide()},click:function(t){if(T.closable){var i=e(t.target).closest(A.modal).length>0,o=e.contains(n.documentElement,t.target);!i&&o&&k.is.active()&&(k.debug("Dimmer clicked, hiding all modals"),k.remove.clickaway(),T.allowMultiple?k.hide():k.hideAll())}else k.verbose("Dimmer clicked but closable setting is disabled")},debounce:function(e,t){clearTimeout(k.timer),k.timer=setTimeout(e,t)},keyboard:function(e){27==e.which&&(T.closable?(k.debug("Escape key pressed hiding modal"),k.hide()):k.debug("Escape key pressed, but closable is set to false"),e.preventDefault())},resize:function(){y.dimmer("is active")&&(k.is.animating()||k.is.active())&&h(k.refresh)}},toggle:function(){k.is.active()||k.is.animating()?k.hide():k.show()},show:function(t){t=e.isFunction(t)?t:function(){},k.refreshModals(),k.set.dimmerSettings(),k.showModal(t)},hide:function(t){t=e.isFunction(t)?t:function(){},k.refreshModals(),k.hideModal(t)},showModal:function(t){t=e.isFunction(t)?t:function(){},k.is.animating()||!k.is.active()?(k.showDimmer(),k.cacheSizes(),k.set.screenHeight(),k.set.type(),k.set.clickaway(),!T.allowMultiple&&k.others.active()?k.hideOthers(k.showModal):(T.allowMultiple&&T.detachable&&D.detach().appendTo(x),T.onShow.call(z),T.transition&&e.fn.transition!==i&&D.transition("is supported")?(k.debug("Showing modal with css animations"),D.transition({debug:T.debug,animation:T.transition+" in",queue:T.queue,duration:T.duration,useFailSafe:!0,onComplete:function(){T.onVisible.apply(z),T.keyboardShortcuts&&k.add.keyboardShortcuts(),k.save.focus(),k.set.active(),T.autofocus&&k.set.autofocus(),t()}})):k.error(E.noTransition))):k.debug("Modal is already visible")},hideModal:function(t,n){t=e.isFunction(t)?t:function(){},k.debug("Hiding modal"),!1!==T.onHide.call(z,e(this))?(k.is.animating()||k.is.active())&&(T.transition&&e.fn.transition!==i&&D.transition("is supported")?(k.remove.active(),D.transition({debug:T.debug,animation:T.transition+" out",queue:T.queue,duration:T.duration,useFailSafe:!0,onStart:function(){k.others.active()||n||k.hideDimmer(),T.keyboardShortcuts&&k.remove.keyboardShortcuts()},onComplete:function(){T.onHidden.call(z),k.restore.focus(),t()}})):k.error(E.noTransition)):k.verbose("Hide callback returned false cancelling hide")},showDimmer:function(){y.dimmer("is animating")||!y.dimmer("is active")?(k.debug("Showing dimmer"),y.dimmer("show")):k.debug("Dimmer already visible")},hideDimmer:function(){y.dimmer("is animating")||y.dimmer("is active")?y.dimmer("hide",function(){k.remove.clickaway(),k.remove.screenHeight()}):k.debug("Dimmer is not visible cannot hide")},hideAll:function(t){var n=r.filter("."+R.active+", ."+R.animating);t=e.isFunction(t)?t:function(){},n.length>0&&(k.debug("Hiding all visible modals"),k.hideDimmer(),n.modal("hide modal",t))},hideOthers:function(t){var n=v.filter("."+R.active+", ."+R.animating);t=e.isFunction(t)?t:function(){},n.length>0&&(k.debug("Hiding other modals",v),n.modal("hide modal",t,!0))},others:{active:function(){return v.filter("."+R.active).length>0},animating:function(){return v.filter("."+R.animating).length>0}},add:{keyboardShortcuts:function(){k.verbose("Adding keyboard shortcuts"),l.on("keyup"+F,k.event.keyboard)}},save:{focus:function(){e(n.activeElement).closest(D).length>0||(b=e(n.activeElement).blur())}},restore:{focus:function(){b&&b.length>0&&b.focus()}},remove:{active:function(){D.removeClass(R.active)},clickaway:function(){x.off("click"+C)},bodyStyle:function(){""===c.attr("style")&&(k.verbose("Removing style attribute"),c.removeAttr("style"))},screenHeight:function(){k.debug("Removing page height"),c.css("height","")},keyboardShortcuts:function(){k.verbose("Removing keyboard shortcuts"),l.off("keyup"+F)},scrolling:function(){y.removeClass(R.scrolling),D.removeClass(R.scrolling)}},cacheSizes:function(){D.addClass(R.loading);var o=D.prop("scrollHeight"),a=D.outerHeight();k.cache!==i&&0===a||(k.cache={pageHeight:e(n).outerHeight(),height:a+T.offset,scrollHeight:o+T.offset,contextHeight:"body"==T.context?e(t).height():y.height()},k.cache.topOffset=-k.cache.height/2),D.removeClass(R.loading),k.debug("Caching modal and container sizes",k.cache)},can:{fit:function(){var e=k.cache.contextHeight,t=k.cache.contextHeight/2,n=k.cache.topOffset,i=k.cache.scrollHeight,o=k.cache.height,a=T.padding;return i>o?t+n+i+a<e:o+2*a<e}},is:{active:function(){return D.hasClass(R.active)},animating:function(){return D.transition("is supported")?D.transition("is animating"):D.is(":visible")},scrolling:function(){return y.hasClass(R.scrolling)},modernBrowser:function(){return!(t.ActiveXObject||"ActiveXObject"in t)}},set:{autofocus:function(){var e=D.find("[tabindex], :input").filter(":visible"),t=e.filter("[autofocus]"),n=t.length>0?t.first():e.first();n.length>0&&n.focus()},clickaway:function(){x.on("click"+C,k.event.click)},dimmerSettings:function(){if(e.fn.dimmer!==i){var t={debug:T.debug,dimmerName:"modals",closable:"auto",variation:!T.centered&&"top aligned",duration:{show:T.duration,hide:T.duration}},n=e.extend(!0,t,T.dimmerSettings);T.inverted?(n.variation=n.variation!==i?n.variation+" inverted":"inverted",x.addClass(R.inverted)):x.removeClass(R.inverted),T.blurring?y.addClass(R.blurring):y.removeClass(R.blurring),q.dimmer("setting",n)}else k.error(E.dimmer)},screenHeight:function(){k.can.fit()?c.css("height",""):(k.debug("Modal is taller than page content, resizing page height"),c.css("height",k.cache.height+2*T.padding))},active:function(){D.addClass(R.active)},scrolling:function(){y.addClass(R.scrolling),D.addClass(R.scrolling)},type:function(){k.can.fit()?(k.verbose("Modal fits on screen"),k.others.active()||k.others.animating()||k.remove.scrolling()):(k.verbose("Modal cannot fit on screen setting to scrolling"),k.set.scrolling())},undetached:function(){y.addClass(R.undetached)}},setting:function(t,n){if(k.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,T,t);else{if(n===i)return T[t];e.isPlainObject(T[t])?e.extend(!0,T[t],n):T[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,k,t);else{if(n===i)return k[t];k[t]=n}},debug:function(){!T.silent&&T.debug&&(T.performance?k.performance.log(arguments):(k.debug=Function.prototype.bind.call(console.info,console,T.name+":"),k.debug.apply(console,arguments)))},verbose:function(){!T.silent&&T.verbose&&T.debug&&(T.performance?k.performance.log(arguments):(k.verbose=Function.prototype.bind.call(console.info,console,T.name+":"),k.verbose.apply(console,arguments)))},error:function(){T.silent||(k.error=Function.prototype.bind.call(console.error,console,T.name+":"),k.error.apply(console,arguments))},performance:{log:function(e){var t,n;T.performance&&(n=(t=(new Date).getTime())-(d||t),d=t,f.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:z,"Execution Time":n})),clearTimeout(k.performance.timer),k.performance.timer=setTimeout(k.performance.display,500)},display:function(){var t=T.name+":",n=0;d=!1,clearTimeout(k.performance.timer),e.each(f,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",u&&(t+=" '"+u+"'"),(console.group!==i||console.table!==i)&&f.length>0&&(console.groupCollapsed(t),console.table?console.table(f):e.each(f,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),f=[]}},invoke:function(t,n,o){var r,s,l,c=I;return n=n||p,o=z||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},g?(I===i&&k.initialize(),k.invoke(m)):(I!==i&&I.invoke("destroy"),k.initialize())}),a!==i?a:this},e.fn.modal.settings={name:"Modal",namespace:"modal",silent:!1,debug:!1,verbose:!1,performance:!0,observeChanges:!1,allowMultiple:!1,detachable:!0,closable:!0,autofocus:!0,inverted:!1,blurring:!1,centered:!0,dimmerSettings:{closable:!1,useCSS:!0},keyboardShortcuts:!0,context:"body",queue:!1,duration:500,offset:0,transition:"scale",padding:50,onShow:function(){},onVisible:function(){},onHide:function(){return!0},onHidden:function(){},onApprove:function(){return!0},onDeny:function(){return!0},selector:{close:"> .close",approve:".actions .positive, .actions .approve, .actions .ok",deny:".actions .negative, .actions .deny, .actions .cancel",modal:".ui.modal"},error:{dimmer:"UI Dimmer, a required component is not included in this page",method:"The method you called is not defined.",notFound:"The element you specified could not be found"},className:{active:"active",animating:"animating",blurring:"blurring",inverted:"inverted",loading:"loading",scrolling:"scrolling",undetached:"undetached"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.nag=function(n){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f=e.isPlainObject(n)?e.extend(!0,{},e.fn.nag.settings,n):e.extend({},e.fn.nag.settings),m=(f.className,f.selector),g=f.error,p=f.namespace,h="."+p,v=p+"-module",b=e(this),y=(b.find(m.close),f.context?e(f.context):e("body")),x=this,C=b.data(v);t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame;a={initialize:function(){a.verbose("Initializing element"),b.on("click"+h,m.close,a.dismiss).data(v,a),f.detachable&&b.parent()[0]!==y[0]&&b.detach().prependTo(y),f.displayTime>0&&setTimeout(a.hide,f.displayTime),a.show()},destroy:function(){a.verbose("Destroying instance"),b.removeData(v).off(h)},show:function(){a.should.show()&&!b.is(":visible")&&(a.debug("Showing nag",f.animation.show),"fade"==f.animation.show?b.fadeIn(f.duration,f.easing):b.slideDown(f.duration,f.easing))},hide:function(){a.debug("Showing nag",f.animation.hide),"fade"==f.animation.show?b.fadeIn(f.duration,f.easing):b.slideUp(f.duration,f.easing)},onHide:function(){a.debug("Removing nag",f.animation.hide),b.remove(),f.onHide&&f.onHide()},dismiss:function(e){f.storageMethod&&a.storage.set(f.key,f.value),a.hide(),e.stopImmediatePropagation(),e.preventDefault()},should:{show:function(){return f.persist?(a.debug("Persistent nag is set, can show nag"),!0):a.storage.get(f.key)!=f.value.toString()?(a.debug("Stored value is not set, can show nag",a.storage.get(f.key)),!0):(a.debug("Stored value is set, cannot show nag",a.storage.get(f.key)),!1)}},get:{storageOptions:function(){var e={};return f.expires&&(e.expires=f.expires),f.domain&&(e.domain=f.domain),f.path&&(e.path=f.path),e}},clear:function(){a.storage.remove(f.key)},storage:{set:function(n,o){var r=a.get.storageOptions();if("localstorage"==f.storageMethod&&t.localStorage!==i)t.localStorage.setItem(n,o),a.debug("Value stored using local storage",n,o);else if("sessionstorage"==f.storageMethod&&t.sessionStorage!==i)t.sessionStorage.setItem(n,o),a.debug("Value stored using session storage",n,o);else{if(e.cookie===i)return void a.error(g.noCookieStorage);e.cookie(n,o,r),a.debug("Value stored using cookie",n,o,r)}},get:function(n,o){var r;return"localstorage"==f.storageMethod&&t.localStorage!==i?r=t.localStorage.getItem(n):"sessionstorage"==f.storageMethod&&t.sessionStorage!==i?r=t.sessionStorage.getItem(n):e.cookie!==i?r=e.cookie(n):a.error(g.noCookieStorage),"undefined"!=r&&"null"!=r&&r!==i&&null!==r||(r=i),r},remove:function(n){var o=a.get.storageOptions();"localstorage"==f.storageMethod&&t.localStorage!==i?t.localStorage.removeItem(n):"sessionstorage"==f.storageMethod&&t.sessionStorage!==i?t.sessionStorage.removeItem(n):e.cookie!==i?e.removeCookie(n,o):a.error(g.noStorage)}},setting:function(t,n){if(a.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];e.isPlainObject(f[t])?e.extend(!0,f[t],n):f[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,a,t);else{if(n===i)return a[t];a[t]=n}},debug:function(){!f.silent&&f.debug&&(f.performance?a.performance.log(arguments):(a.debug=Function.prototype.bind.call(console.info,console,f.name+":"),a.debug.apply(console,arguments)))},verbose:function(){!f.silent&&f.verbose&&f.debug&&(f.performance?a.performance.log(arguments):(a.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),a.verbose.apply(console,arguments)))},error:function(){f.silent||(a.error=Function.prototype.bind.call(console.error,console,f.name+":"),a.error.apply(console,arguments))},performance:{log:function(e){var t,n;f.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:x,"Execution Time":n})),clearTimeout(a.performance.timer),a.performance.timer=setTimeout(a.performance.display,500)},display:function(){var t=f.name+":",n=0;s=!1,clearTimeout(a.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,r){var s,l,c,u=C;return n=n||d,r=x||r,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(n,o){var r=n!=s?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(u[r])&&n!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[o])||n==s)return u[o]!==i?(l=u[o],!1):(a.error(g.method,t),!1);u=u[o]}})),e.isFunction(l)?c=l.apply(r,n):l!==i&&(c=l),e.isArray(o)?o.push(c):o!==i?o=[o,c]:c!==i&&(o=c),l}},u?(C===i&&a.initialize(),a.invoke(c)):(C!==i&&C.invoke("destroy"),a.initialize())}),o!==i?o:this},e.fn.nag.settings={name:"Nag",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"Nag",persist:!1,displayTime:0,animation:{show:"slide",hide:"slide"},context:!1,detachable:!1,expires:30,domain:!1,path:"/",storageMethod:"cookie",key:"nag",value:"dismiss",error:{noCookieStorage:"$.cookie is not included. A storage solution is required.",noStorage:"Neither $.cookie or store is defined. A storage solution is required for storing state",method:"The method you called is not defined."},className:{bottom:"bottom",fixed:"fixed"},selector:{close:".close.icon"},speed:500,easing:"easeOutQuad",onHide:function(){}},e.extend(e.easing,{easeOutQuad:function(e,t,n,i,o){return-i*(t/=o)*(t-2)+n}})}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.popup=function(o){var a,r=e(this),s=e(n),l=e(t),c=e("body"),u=r.selector||"",d=(new Date).getTime(),f=[],m=arguments[0],g="string"==typeof m,p=[].slice.call(arguments,1);return r.each(function(){var r,h,v,b,y,x,C=e.isPlainObject(o)?e.extend(!0,{},e.fn.popup.settings,o):e.extend({},e.fn.popup.settings),w=C.selector,S=C.className,k=C.error,T=C.metadata,A=C.namespace,R="."+C.namespace,P="module-"+A,E=e(this),F=e(C.context),O=e(C.scrollContext),D=e(C.boundary),q=C.target?e(C.target):E,j=0,z=!1,I=!1,M=this,L=E.data(P);x={initialize:function(){x.debug("Initializing",E),x.createID(),x.bind.events(),!x.exists()&&C.preserve&&x.create(),C.observeChanges&&x.observeChanges(),x.instantiate()},instantiate:function(){x.verbose("Storing instance",x),L=x,E.data(P,L)},observeChanges:function(){"MutationObserver"in t&&((v=new MutationObserver(x.event.documentChanged)).observe(n,{childList:!0,subtree:!0}),x.debug("Setting up mutation observer",v))},refresh:function(){C.popup?r=e(C.popup).eq(0):C.inline&&(r=q.nextAll(w.popup).eq(0),C.popup=r),C.popup?(r.addClass(S.loading),h=x.get.offsetParent(),r.removeClass(S.loading),C.movePopup&&x.has.popup()&&x.get.offsetParent(r)[0]!==h[0]&&(x.debug("Moving popup to the same offset parent as target"),r.detach().appendTo(h))):h=C.inline?x.get.offsetParent(q):x.has.popup()?x.get.offsetParent(r):c,h.is("html")&&h[0]!==c[0]&&(x.debug("Setting page as offset parent"),h=c),x.get.variation()&&x.set.variation()},reposition:function(){x.refresh(),x.set.position()},destroy:function(){x.debug("Destroying previous module"),v&&v.disconnect(),r&&!C.preserve&&x.removePopup(),clearTimeout(x.hideTimer),clearTimeout(x.showTimer),x.unbind.close(),x.unbind.events(),E.removeData(P)},event:{start:function(t){var n=e.isPlainObject(C.delay)?C.delay.show:C.delay;clearTimeout(x.hideTimer),I||(x.showTimer=setTimeout(x.show,n))},end:function(){var t=e.isPlainObject(C.delay)?C.delay.hide:C.delay;clearTimeout(x.showTimer),x.hideTimer=setTimeout(x.hide,t)},touchstart:function(e){I=!0,x.show()},resize:function(){x.is.visible()&&x.set.position()},documentChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==M||e(t).find(M).length>0)&&(x.debug("Element removed from DOM, tearing down events"),x.destroy())})})},hideGracefully:function(t){var i=e(t.target),o=e.contains(n.documentElement,t.target),a=i.closest(w.popup).length>0;t&&!a&&o?(x.debug("Click occurred outside popup hiding popup"),x.hide()):x.debug("Click was inside popup, keeping popup open")}},create:function(){var t=x.get.html(),n=x.get.title(),i=x.get.content();t||i||n?(x.debug("Creating pop-up html"),t||(t=C.templates.popup({title:n,content:i})),r=e("<div/>").addClass(S.popup).data(T.activator,E).html(t),C.inline?(x.verbose("Inserting popup element inline",r),r.insertAfter(E)):(x.verbose("Appending popup element to body",r),r.appendTo(F)),x.refresh(),x.set.variation(),C.hoverable&&x.bind.popup(),C.onCreate.call(r,M)):0!==q.next(w.popup).length?(x.verbose("Pre-existing popup found"),C.inline=!0,C.popup=q.next(w.popup).data(T.activator,E),x.refresh(),C.hoverable&&x.bind.popup()):C.popup?(e(C.popup).data(T.activator,E),x.verbose("Used popup specified in settings"),x.refresh(),C.hoverable&&x.bind.popup()):x.debug("No content specified skipping display",M)},createID:function(){y=(Math.random().toString(16)+"000000000").substr(2,8),b="."+y,x.verbose("Creating unique id for element",y)},toggle:function(){x.debug("Toggling pop-up"),x.is.hidden()?(x.debug("Popup is hidden, showing pop-up"),x.unbind.close(),x.show()):(x.debug("Popup is visible, hiding pop-up"),x.hide())},show:function(e){if(e=e||function(){},x.debug("Showing pop-up",C.transition),x.is.hidden()&&(!x.is.active()||!x.is.dropdown())){if(x.exists()||x.create(),!1===C.onShow.call(r,M))return void x.debug("onShow callback returned false, cancelling popup animation");C.preserve||C.popup||x.refresh(),r&&x.set.position()&&(x.save.conditions(),C.exclusive&&x.hideAll(),x.animate.show(e))}},hide:function(e){if(e=e||function(){},x.is.visible()||x.is.animating()){if(!1===C.onHide.call(r,M))return void x.debug("onHide callback returned false, cancelling popup animation");x.remove.visible(),x.unbind.close(),x.restore.conditions(),x.animate.hide(e)}},hideAll:function(){e(w.popup).filter("."+S.popupVisible).each(function(){e(this).data(T.activator).popup("hide")})},exists:function(){return!!r&&(C.inline||C.popup?x.has.popup():r.closest(F).length>=1)},removePopup:function(){x.has.popup()&&!C.popup&&(x.debug("Removing popup",r),r.remove(),r=i,C.onRemove.call(r,M))},save:{conditions:function(){x.cache={title:E.attr("title")},x.cache.title&&E.removeAttr("title"),x.verbose("Saving original attributes",x.cache.title)}},restore:{conditions:function(){return x.cache&&x.cache.title&&(E.attr("title",x.cache.title),x.verbose("Restoring original attributes",x.cache.title)),!0}},supports:{svg:function(){return"undefined"==typeof SVGGraphicsElement}},animate:{show:function(t){t=e.isFunction(t)?t:function(){},C.transition&&e.fn.transition!==i&&E.transition("is supported")?(x.set.visible(),r.transition({animation:C.transition+" in",queue:!1,debug:C.debug,verbose:C.verbose,duration:C.duration,onComplete:function(){x.bind.close(),t.call(r,M),C.onVisible.call(r,M)}})):x.error(k.noTransition)},hide:function(t){t=e.isFunction(t)?t:function(){},x.debug("Hiding pop-up"),!1!==C.onHide.call(r,M)?C.transition&&e.fn.transition!==i&&E.transition("is supported")?r.transition({animation:C.transition+" out",queue:!1,duration:C.duration,debug:C.debug,verbose:C.verbose,onComplete:function(){x.reset(),t.call(r,M),C.onHidden.call(r,M)}}):x.error(k.noTransition):x.debug("onHide callback returned false, cancelling popup animation")}},change:{content:function(e){r.html(e)}},get:{html:function(){return E.removeData(T.html),E.data(T.html)||C.html},title:function(){return E.removeData(T.title),E.data(T.title)||C.title},content:function(){return E.removeData(T.content),E.data(T.content)||C.content||E.attr("title")},variation:function(){return E.removeData(T.variation),E.data(T.variation)||C.variation},popup:function(){return r},popupOffset:function(){return r.offset()},calculations:function(){var e,n=x.get.offsetParent(r),i=q[0],o=D[0]==t,a=C.inline||C.popup&&C.movePopup?q.position():q.offset(),s=o?{top:0,left:0}:D.offset(),c={},u=o?{top:l.scrollTop(),left:l.scrollLeft()}:{top:0,left:0};if(c={target:{element:q[0],width:q.outerWidth(),height:q.outerHeight(),top:a.top,left:a.left,margin:{}},popup:{width:r.outerWidth(),height:r.outerHeight()},parent:{width:h.outerWidth(),height:h.outerHeight()},screen:{top:s.top,left:s.left,scroll:{top:u.top,left:u.left},width:D.width(),height:D.height()}},n.get(0)!==h.get(0)){var d=n.offset();c.target.top-=d.top,c.target.left-=d.left,c.parent.width=n.outerWidth(),c.parent.height=n.outerHeight()}return C.setFluidWidth&&x.is.fluid()&&(c.container={width:r.parent().outerWidth()},c.popup.width=c.container.width),c.target.margin.top=C.inline?parseInt(t.getComputedStyle(i).getPropertyValue("margin-top"),10):0,c.target.margin.left=C.inline?x.is.rtl()?parseInt(t.getComputedStyle(i).getPropertyValue("margin-right"),10):parseInt(t.getComputedStyle(i).getPropertyValue("margin-left"),10):0,e=c.screen,c.boundary={top:e.top+e.scroll.top,bottom:e.top+e.scroll.top+e.height,left:e.left+e.scroll.left,right:e.left+e.scroll.left+e.width},c},id:function(){return y},startEvent:function(){return"hover"==C.on?"mouseenter":"focus"==C.on&&"focus"},scrollEvent:function(){return"scroll"},endEvent:function(){return"hover"==C.on?"mouseleave":"focus"==C.on&&"blur"},distanceFromBoundary:function(e,t){var n,i,o={};return n=(t=t||x.get.calculations()).popup,i=t.boundary,e&&(o={top:e.top-i.top,left:e.left-i.left,right:i.right-(e.left+n.width),bottom:i.bottom-(e.top+n.height)},x.verbose("Distance from boundaries determined",e,o)),o},offsetParent:function(t){var n=(t!==i?t[0]:q[0]).parentNode,o=e(n);if(n)for(var a="none"===o.css("transform"),r="static"===o.css("position"),s=o.is("body");n&&!s&&r&&a;)n=n.parentNode,a="none"===(o=e(n)).css("transform"),r="static"===o.css("position"),s=o.is("body");return o&&o.length>0?o:e()},positions:function(){return{"top left":!1,"top center":!1,"top right":!1,"bottom left":!1,"bottom center":!1,"bottom right":!1,"left center":!1,"right center":!1}},nextPosition:function(e){var t=e.split(" "),n=t[0],i=t[1],o="top"==n||"bottom"==n,a=!1,r=!1,s=!1;return z||(x.verbose("All available positions available"),z=x.get.positions()),x.debug("Recording last position tried",e),z[e]=!0,"opposite"===C.prefer&&(s=(s=[{top:"bottom",bottom:"top",left:"right",right:"left"}[n],i]).join(" "),a=!0===z[s],x.debug("Trying opposite strategy",s)),"adjacent"===C.prefer&&o&&(s=(s=[n,{left:"center",center:"right",right:"left"}[i]]).join(" "),r=!0===z[s],x.debug("Trying adjacent strategy",s)),(r||a)&&(x.debug("Using backup position",s),s={"top left":"top center","top center":"top right","top right":"right center","right center":"bottom right","bottom right":"bottom center","bottom center":"bottom left","bottom left":"left center","left center":"top left"}[e]),s}},set:{position:function(e,t){if(0!==q.length&&0!==r.length){var n,o,a,s,l,c,u,d;if(t=t||x.get.calculations(),e=e||E.data(T.position)||C.position,n=E.data(T.offset)||C.offset,o=C.distanceAway,a=t.target,s=t.popup,l=t.parent,x.should.centerArrow(t)&&(x.verbose("Adjusting offset to center arrow on small target element"),"top left"!=e&&"bottom left"!=e||(n+=a.width/2,n-=C.arrowPixelsFromEdge),"top right"!=e&&"bottom right"!=e||(n-=a.width/2,n+=C.arrowPixelsFromEdge)),0===a.width&&0===a.height&&!x.is.svg(a.element))return x.debug("Popup target is hidden, no action taken"),!1;switch(C.inline&&(x.debug("Adding margin to calculation",a.margin),"left center"==e||"right center"==e?(n+=a.margin.top,o+=-a.margin.left):"top left"==e||"top center"==e||"top right"==e?(n+=a.margin.left,o-=a.margin.top):(n+=a.margin.left,o+=a.margin.top)),x.debug("Determining popup position from calculations",e,t),x.is.rtl()&&(e=e.replace(/left|right/g,function(e){return"left"==e?"right":"left"}),x.debug("RTL: Popup position updated",e)),j==C.maxSearchDepth&&"string"==typeof C.lastResort&&(e=C.lastResort),e){case"top left":c={top:"auto",bottom:l.height-a.top+o,left:a.left+n,right:"auto"};break;case"top center":c={bottom:l.height-a.top+o,left:a.left+a.width/2-s.width/2+n,top:"auto",right:"auto"};break;case"top right":c={bottom:l.height-a.top+o,right:l.width-a.left-a.width-n,top:"auto",left:"auto"};break;case"left center":c={top:a.top+a.height/2-s.height/2+n,right:l.width-a.left+o,left:"auto",bottom:"auto"};break;case"right center":c={top:a.top+a.height/2-s.height/2+n,left:a.left+a.width+o,bottom:"auto",right:"auto"};break;case"bottom left":c={top:a.top+a.height+o,left:a.left+n,bottom:"auto",right:"auto"};break;case"bottom center":c={top:a.top+a.height+o,left:a.left+a.width/2-s.width/2+n,bottom:"auto",right:"auto"};break;case"bottom right":c={top:a.top+a.height+o,right:l.width-a.left-a.width-n,left:"auto",bottom:"auto"}}if(c===i&&x.error(k.invalidPosition,e),x.debug("Calculated popup positioning values",c),r.css(c).removeClass(S.position).addClass(e).addClass(S.loading),u=x.get.popupOffset(),d=x.get.distanceFromBoundary(u,t),x.is.offstage(d,e)){if(x.debug("Position is outside viewport",e),j<C.maxSearchDepth)return j++,e=x.get.nextPosition(e),x.debug("Trying new position",e),!!r&&x.set.position(e,t);if(!C.lastResort)return x.debug("Popup could not find a position to display",r),x.error(k.cannotPlace,M),x.remove.attempts(),x.remove.loading(),x.reset(),C.onUnplaceable.call(r,M),!1;x.debug("No position found, showing with last position")}return x.debug("Position is on stage",e),x.remove.attempts(),x.remove.loading(),C.setFluidWidth&&x.is.fluid()&&x.set.fluidWidth(t),!0}x.error(k.notFound)},fluidWidth:function(e){e=e||x.get.calculations(),x.debug("Automatically setting element width to parent width",e.parent.width),r.css("width",e.container.width)},variation:function(e){(e=e||x.get.variation())&&x.has.popup()&&(x.verbose("Adding variation to popup",e),r.addClass(e))},visible:function(){E.addClass(S.visible)}},remove:{loading:function(){r.removeClass(S.loading)},variation:function(e){(e=e||x.get.variation())&&(x.verbose("Removing variation",e),r.removeClass(e))},visible:function(){E.removeClass(S.visible)},attempts:function(){x.verbose("Resetting all searched positions"),j=0,z=!1}},bind:{events:function(){x.debug("Binding popup events to module"),"click"==C.on&&E.on("click"+R,x.toggle),"hover"==C.on&&E.on("touchstart"+R,x.event.touchstart),x.get.startEvent()&&E.on(x.get.startEvent()+R,x.event.start).on(x.get.endEvent()+R,x.event.end),C.target&&x.debug("Target set to element",q),l.on("resize"+b,x.event.resize)},popup:function(){x.verbose("Allowing hover events on popup to prevent closing"),r&&x.has.popup()&&r.on("mouseenter"+R,x.event.start).on("mouseleave"+R,x.event.end)},close:function(){(!0===C.hideOnScroll||"auto"==C.hideOnScroll&&"click"!=C.on)&&x.bind.closeOnScroll(),"hover"==C.on&&I&&x.bind.touchClose(),"click"==C.on&&C.closable&&x.bind.clickaway()},closeOnScroll:function(){x.verbose("Binding scroll close event to document"),O.one(x.get.scrollEvent()+b,x.event.hideGracefully)},touchClose:function(){x.verbose("Binding popup touchclose event to document"),s.on("touchstart"+b,function(e){x.verbose("Touched away from popup"),x.event.hideGracefully.call(M,e)})},clickaway:function(){x.verbose("Binding popup close event to document"),s.on("click"+b,function(e){x.verbose("Clicked away from popup"),x.event.hideGracefully.call(M,e)})}},unbind:{events:function(){l.off(b),E.off(R)},close:function(){s.off(b),O.off(b)}},has:{popup:function(){return r&&r.length>0}},should:{centerArrow:function(e){return!x.is.basic()&&e.target.width<=2*C.arrowPixelsFromEdge}},is:{offstage:function(t,n){var i=[];return e.each(t,function(e,t){t<-C.jitter&&(x.debug("Position exceeds allowable distance from edge",e,t,n),i.push(e))}),i.length>0},svg:function(e){return x.supports.svg()&&e instanceof SVGGraphicsElement},basic:function(){return E.hasClass(S.basic)},active:function(){return E.hasClass(S.active)},animating:function(){return r!==i&&r.hasClass(S.animating)},fluid:function(){return r!==i&&r.hasClass(S.fluid)},visible:function(){return r!==i&&r.hasClass(S.popupVisible)},dropdown:function(){return E.hasClass(S.dropdown)},hidden:function(){return!x.is.visible()},rtl:function(){return"rtl"==E.css("direction")}},reset:function(){x.remove.visible(),C.preserve?e.fn.transition!==i&&r.transition("remove transition"):x.removePopup()},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,C,t);else{if(n===i)return C[t];C[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,x,t);else{if(n===i)return x[t];x[t]=n}},debug:function(){!C.silent&&C.debug&&(C.performance?x.performance.log(arguments):(x.debug=Function.prototype.bind.call(console.info,console,C.name+":"),x.debug.apply(console,arguments)))},verbose:function(){!C.silent&&C.verbose&&C.debug&&(C.performance?x.performance.log(arguments):(x.verbose=Function.prototype.bind.call(console.info,console,C.name+":"),x.verbose.apply(console,arguments)))},error:function(){C.silent||(x.error=Function.prototype.bind.call(console.error,console,C.name+":"),x.error.apply(console,arguments))},performance:{log:function(e){var t,n;C.performance&&(n=(t=(new Date).getTime())-(d||t),d=t,f.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:M,"Execution Time":n})),clearTimeout(x.performance.timer),x.performance.timer=setTimeout(x.performance.display,500)},display:function(){var t=C.name+":",n=0;d=!1,clearTimeout(x.performance.timer),e.each(f,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",u&&(t+=" '"+u+"'"),(console.group!==i||console.table!==i)&&f.length>0&&(console.groupCollapsed(t),console.table?console.table(f):e.each(f,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),f=[]}},invoke:function(t,n,o){var r,s,l,c=L;return n=n||p,o=M||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},g?(L===i&&x.initialize(),x.invoke(m)):(L!==i&&L.invoke("destroy"),x.initialize())}),a!==i?a:this},e.fn.popup.settings={name:"Popup",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"popup",observeChanges:!0,onCreate:function(){},onRemove:function(){},onShow:function(){},onVisible:function(){},onHide:function(){},onUnplaceable:function(){},onHidden:function(){},on:"hover",boundary:t,addTouchEvents:!0,position:"top left",variation:"",movePopup:!0,target:!1,popup:!1,inline:!1,preserve:!1,hoverable:!1,content:!1,html:!1,title:!1,closable:!0,hideOnScroll:"auto",exclusive:!1,context:"body",scrollContext:t,prefer:"opposite",lastResort:!1,arrowPixelsFromEdge:20,delay:{show:50,hide:70},setFluidWidth:!0,duration:200,transition:"scale",distanceAway:0,jitter:2,offset:0,maxSearchDepth:15,error:{invalidPosition:"The position you specified is not a valid position",cannotPlace:"Popup does not fit within the boundaries of the viewport",method:"The method you called is not defined.",noTransition:"This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>",notFound:"The target or popup you specified does not exist on the page"},metadata:{activator:"activator",content:"content",html:"html",offset:"offset",position:"position",title:"title",variation:"variation"},className:{active:"active",basic:"basic",animating:"animating",dropdown:"dropdown",fluid:"fluid",loading:"loading",popup:"ui popup",position:"top left center bottom right",visible:"visible",popupVisible:"visible"},selector:{popup:".ui.popup"},templates:{escape:function(e){var t={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};return/[&<>"'`]/.test(e)?e.replace(/[&<>"'`]/g,function(e){return t[e]}):e},popup:function(t){var n="",o=e.fn.popup.settings.templates.escape;return typeof t!==i&&(typeof t.title!==i&&t.title&&(t.title=o(t.title),n+='<div class="header">'+t.title+"</div>"),typeof t.content!==i&&t.content&&(t.content=o(t.content),n+='<div class="content">'+t.content+"</div>")),n}}}}(jQuery,window,document),function(e,t,n,i){"use strict";void 0!==(t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")())&&t.Math==Math||("undefined"!=typeof self&&self.Math==Math?self:Function("return this")());e.fn.progress=function(t){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f=e.isPlainObject(t)?e.extend(!0,{},e.fn.progress.settings,t):e.extend({},e.fn.progress.settings),m=f.className,g=f.metadata,p=f.namespace,h=f.selector,v=f.error,b="."+p,y="module-"+p,x=e(this),C=e(this).find(h.bar),w=e(this).find(h.progress),S=e(this).find(h.label),k=this,T=x.data(y),A=!1;a={initialize:function(){a.debug("Initializing progress bar",f),a.set.duration(),a.set.transitionEvent(),a.read.metadata(),a.read.settings(),a.instantiate()},instantiate:function(){a.verbose("Storing instance of progress",a),T=a,x.data(y,a)},destroy:function(){a.verbose("Destroying previous progress for",x),clearInterval(T.interval),a.remove.state(),x.removeData(y),T=i},reset:function(){a.remove.nextValue(),a.update.progress(0)},complete:function(){(a.percent===i||a.percent<100)&&(a.remove.progressPoll(),a.set.percent(100))},read:{metadata:function(){var e={percent:x.data(g.percent),total:x.data(g.total),value:x.data(g.value)};e.percent&&(a.debug("Current percent value set from metadata",e.percent),a.set.percent(e.percent)),e.total&&(a.debug("Total value set from metadata",e.total),a.set.total(e.total)),e.value&&(a.debug("Current value set from metadata",e.value),a.set.value(e.value),a.set.progress(e.value))},settings:function(){!1!==f.total&&(a.debug("Current total set in settings",f.total),a.set.total(f.total)),!1!==f.value&&(a.debug("Current value set in settings",f.value),a.set.value(f.value),a.set.progress(a.value)),!1!==f.percent&&(a.debug("Current percent set in settings",f.percent),a.set.percent(f.percent))}},bind:{transitionEnd:function(e){var t=a.get.transitionEnd();C.one(t+b,function(t){clearTimeout(a.failSafeTimer),e.call(this,t)}),a.failSafeTimer=setTimeout(function(){C.triggerHandler(t)},f.duration+f.failSafeDelay),a.verbose("Adding fail safe timer",a.timer)}},increment:function(e){var t,n;a.has.total()?n=(t=a.get.value())+(e=e||1):(n=(t=a.get.percent())+(e=e||a.get.randomValue()),100,a.debug("Incrementing percentage by",t,n)),n=a.get.normalizedValue(n),a.set.progress(n)},decrement:function(e){var t,n;a.get.total()?(n=(t=a.get.value())-(e=e||1),a.debug("Decrementing value by",e,t)):(n=(t=a.get.percent())-(e=e||a.get.randomValue()),a.debug("Decrementing percentage by",e,t)),n=a.get.normalizedValue(n),a.set.progress(n)},has:{progressPoll:function(){return a.progressPoll},total:function(){return!1!==a.get.total()}},get:{text:function(e){var t=a.value||0,n=a.total||0,i=A?a.get.displayPercent():a.percent||0,o=a.total>0?n-t:100-i;return e=(e=e||"").replace("{value}",t).replace("{total}",n).replace("{left}",o).replace("{percent}",i),a.verbose("Adding variables to progress bar text",e),e},normalizedValue:function(e){if(e<0)return a.debug("Value cannot decrement below 0"),0;if(a.has.total()){if(e>a.total)return a.debug("Value cannot increment above total",a.total),a.total}else if(e>100)return a.debug("Value cannot increment above 100 percent"),100;return e},updateInterval:function(){return"auto"==f.updateInterval?f.duration:f.updateInterval},randomValue:function(){return a.debug("Generating random increment percentage"),Math.floor(Math.random()*f.random.max+f.random.min)},numericValue:function(e){return"string"==typeof e?""!==e.replace(/[^\d.]/g,"")&&+e.replace(/[^\d.]/g,""):e},transitionEnd:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]},displayPercent:function(){var e=C.width(),t=x.width(),n=e>parseInt(C.css("min-width"),10)?e/t*100:a.percent;return f.precision>0?Math.round(n*(10*f.precision))/(10*f.precision):Math.round(n)},percent:function(){return a.percent||0},value:function(){return a.nextValue||a.value||0},total:function(){return a.total||!1}},create:{progressPoll:function(){a.progressPoll=setTimeout(function(){a.update.toNextValue(),a.remove.progressPoll()},a.get.updateInterval())}},is:{complete:function(){return a.is.success()||a.is.warning()||a.is.error()},success:function(){return x.hasClass(m.success)},warning:function(){return x.hasClass(m.warning)},error:function(){return x.hasClass(m.error)},active:function(){return x.hasClass(m.active)},visible:function(){return x.is(":visible")}},remove:{progressPoll:function(){a.verbose("Removing progress poll timer"),a.progressPoll&&(clearTimeout(a.progressPoll),delete a.progressPoll)},nextValue:function(){a.verbose("Removing progress value stored for next update"),delete a.nextValue},state:function(){a.verbose("Removing stored state"),delete a.total,delete a.percent,delete a.value},active:function(){a.verbose("Removing active state"),x.removeClass(m.active)},success:function(){a.verbose("Removing success state"),x.removeClass(m.success)},warning:function(){a.verbose("Removing warning state"),x.removeClass(m.warning)},error:function(){a.verbose("Removing error state"),x.removeClass(m.error)}},set:{barWidth:function(e){e>100?a.error(v.tooHigh,e):e<0?a.error(v.tooLow,e):(C.css("width",e+"%"),x.attr("data-percent",parseInt(e,10)))},duration:function(e){e="number"==typeof(e=e||f.duration)?e+"ms":e,a.verbose("Setting progress bar transition duration",e),C.css({"transition-duration":e})},percent:function(e){e="string"==typeof e?+e.replace("%",""):e,e=f.precision>0?Math.round(e*(10*f.precision))/(10*f.precision):Math.round(e),a.percent=e,a.has.total()||(a.value=f.precision>0?Math.round(e/100*a.total*(10*f.precision))/(10*f.precision):Math.round(e/100*a.total*10)/10,f.limitValues&&(a.value=a.value>100?100:a.value<0?0:a.value)),a.set.barWidth(e),a.set.labelInterval(),a.set.labels(),f.onChange.call(k,e,a.value,a.total)},labelInterval:function(){clearInterval(a.interval),a.bind.transitionEnd(function(){a.verbose("Bar finished animating, removing continuous label updates"),clearInterval(a.interval),A=!1,a.set.labels()}),A=!0,a.interval=setInterval(function(){e.contains(n.documentElement,k)||(clearInterval(a.interval),A=!1),a.set.labels()},f.framerate)},labels:function(){a.verbose("Setting both bar progress and outer label text"),a.set.barLabel(),a.set.state()},label:function(e){(e=e||"")&&(e=a.get.text(e),a.verbose("Setting label to text",e),S.text(e))},state:function(e){100===(e=e!==i?e:a.percent)?f.autoSuccess&&!(a.is.warning()||a.is.error()||a.is.success())?(a.set.success(),a.debug("Automatically triggering success at 100%")):(a.verbose("Reached 100% removing active state"),a.remove.active(),a.remove.progressPoll()):e>0?(a.verbose("Adjusting active progress bar label",e),a.set.active()):(a.remove.active(),a.set.label(f.text.active))},barLabel:function(e){e!==i?w.text(a.get.text(e)):"ratio"==f.label&&a.total?(a.verbose("Adding ratio to bar label"),w.text(a.get.text(f.text.ratio))):"percent"==f.label&&(a.verbose("Adding percentage to bar label"),w.text(a.get.text(f.text.percent)))},active:function(e){e=e||f.text.active,a.debug("Setting active state"),f.showActivity&&!a.is.active()&&x.addClass(m.active),a.remove.warning(),a.remove.error(),a.remove.success(),(e=f.onLabelUpdate("active",e,a.value,a.total))&&a.set.label(e),a.bind.transitionEnd(function(){f.onActive.call(k,a.value,a.total)})},success:function(e){e=e||f.text.success||f.text.active,a.debug("Setting success state"),x.addClass(m.success),a.remove.active(),a.remove.warning(),a.remove.error(),a.complete(),f.text.success?(e=f.onLabelUpdate("success",e,a.value,a.total),a.set.label(e)):(e=f.onLabelUpdate("active",e,a.value,a.total),a.set.label(e)),a.bind.transitionEnd(function(){f.onSuccess.call(k,a.total)})},warning:function(e){e=e||f.text.warning,a.debug("Setting warning state"),x.addClass(m.warning),a.remove.active(),a.remove.success(),a.remove.error(),a.complete(),(e=f.onLabelUpdate("warning",e,a.value,a.total))&&a.set.label(e),a.bind.transitionEnd(function(){f.onWarning.call(k,a.value,a.total)})},error:function(e){e=e||f.text.error,a.debug("Setting error state"),x.addClass(m.error),a.remove.active(),a.remove.success(),a.remove.warning(),a.complete(),(e=f.onLabelUpdate("error",e,a.value,a.total))&&a.set.label(e),a.bind.transitionEnd(function(){f.onError.call(k,a.value,a.total)})},transitionEvent:function(){a.get.transitionEnd()},total:function(e){a.total=e},value:function(e){a.value=e},progress:function(e){a.has.progressPoll()?(a.debug("Updated within interval, setting next update to use new value",e),a.set.nextValue(e)):(a.debug("First update in progress update interval, immediately updating",e),a.update.progress(e),a.create.progressPoll())},nextValue:function(e){a.nextValue=e}},update:{toNextValue:function(){var e=a.nextValue;e&&(a.debug("Update interval complete using last updated value",e),a.update.progress(e),a.remove.nextValue())},progress:function(e){var t;!1===(e=a.get.numericValue(e))&&a.error(v.nonNumeric,e),e=a.get.normalizedValue(e),a.has.total()?(a.set.value(e),t=e/a.total*100,a.debug("Calculating percent complete from total",t),a.set.percent(t)):(t=e,a.debug("Setting value to exact percentage value",t),a.set.percent(t))}},setting:function(t,n){if(a.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];e.isPlainObject(f[t])?e.extend(!0,f[t],n):f[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,a,t);else{if(n===i)return a[t];a[t]=n}},debug:function(){!f.silent&&f.debug&&(f.performance?a.performance.log(arguments):(a.debug=Function.prototype.bind.call(console.info,console,f.name+":"),a.debug.apply(console,arguments)))},verbose:function(){!f.silent&&f.verbose&&f.debug&&(f.performance?a.performance.log(arguments):(a.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),a.verbose.apply(console,arguments)))},error:function(){f.silent||(a.error=Function.prototype.bind.call(console.error,console,f.name+":"),a.error.apply(console,arguments))},performance:{log:function(e){var t,n;f.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:k,"Execution Time":n})),clearTimeout(a.performance.timer),a.performance.timer=setTimeout(a.performance.display,500)},display:function(){var t=f.name+":",n=0;s=!1,clearTimeout(a.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,r){var s,l,c,u=T;return n=n||d,r=k||r,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(n,o){var r=n!=s?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(u[r])&&n!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[o])||n==s)return u[o]!==i?(l=u[o],!1):(a.error(v.method,t),!1);u=u[o]}})),e.isFunction(l)?c=l.apply(r,n):l!==i&&(c=l),e.isArray(o)?o.push(c):o!==i?o=[o,c]:c!==i&&(o=c),l}},u?(T===i&&a.initialize(),a.invoke(c)):(T!==i&&T.invoke("destroy"),a.initialize())}),o!==i?o:this},e.fn.progress.settings={name:"Progress",namespace:"progress",silent:!1,debug:!1,verbose:!1,performance:!0,random:{min:2,max:5},duration:300,updateInterval:"auto",autoSuccess:!0,showActivity:!0,limitValues:!0,label:"percent",precision:0,framerate:1e3/30,percent:!1,total:!1,value:!1,failSafeDelay:100,onLabelUpdate:function(e,t,n,i){return t},onChange:function(e,t,n){},onSuccess:function(e){},onActive:function(e,t){},onError:function(e,t){},onWarning:function(e,t){},error:{method:"The method you called is not defined.",nonNumeric:"Progress value is non numeric",tooHigh:"Value specified is above 100%",tooLow:"Value specified is below 0%"},regExp:{variable:/\{\$*[A-z0-9]+\}/g},metadata:{percent:"percent",total:"total",value:"value"},selector:{bar:"> .bar",label:"> .label",progress:".bar > .progress"},text:{active:!1,error:!1,success:!1,warning:!1,percent:"{percent}%",ratio:"{value} of {total}"},className:{active:"active",error:"error",success:"success",warning:"warning"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.rating=function(t){var n,o=e(this),a=o.selector||"",r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);return o.each(function(){var d,f,m=e.isPlainObject(t)?e.extend(!0,{},e.fn.rating.settings,t):e.extend({},e.fn.rating.settings),g=m.namespace,p=m.className,h=m.metadata,v=m.selector,b=(m.error,"."+g),y="module-"+g,x=this,C=e(this).data(y),w=e(this),S=w.find(v.icon);f={initialize:function(){f.verbose("Initializing rating module",m),0===S.length&&f.setup.layout(),m.interactive?f.enable():f.disable(),f.set.initialLoad(),f.set.rating(f.get.initialRating()),f.remove.initialLoad(),f.instantiate()},instantiate:function(){f.verbose("Instantiating module",m),C=f,w.data(y,f)},destroy:function(){f.verbose("Destroying previous instance",C),f.remove.events(),w.removeData(y)},refresh:function(){S=w.find(v.icon)},setup:{layout:function(){var t=f.get.maxRating(),n=e.fn.rating.settings.templates.icon(t);f.debug("Generating icon html dynamically"),w.html(n),f.refresh()}},event:{mouseenter:function(){var t=e(this);t.nextAll().removeClass(p.selected),w.addClass(p.selected),t.addClass(p.selected).prevAll().addClass(p.selected)},mouseleave:function(){w.removeClass(p.selected),S.removeClass(p.selected)},click:function(){var t=e(this),n=f.get.rating(),i=S.index(t)+1;("auto"==m.clearable?1===S.length:m.clearable)&&n==i?f.clearRating():f.set.rating(i)}},clearRating:function(){f.debug("Clearing current rating"),f.set.rating(0)},bind:{events:function(){f.verbose("Binding events"),w.on("mouseenter"+b,v.icon,f.event.mouseenter).on("mouseleave"+b,v.icon,f.event.mouseleave).on("click"+b,v.icon,f.event.click)}},remove:{events:function(){f.verbose("Removing events"),w.off(b)},initialLoad:function(){d=!1}},enable:function(){f.debug("Setting rating to interactive mode"),f.bind.events(),w.removeClass(p.disabled)},disable:function(){f.debug("Setting rating to read-only mode"),f.remove.events(),w.addClass(p.disabled)},is:{initialLoad:function(){return d}},get:{initialRating:function(){return w.data(h.rating)!==i?(w.removeData(h.rating),w.data(h.rating)):m.initialRating},maxRating:function(){return w.data(h.maxRating)!==i?(w.removeData(h.maxRating),w.data(h.maxRating)):m.maxRating},rating:function(){var e=S.filter("."+p.active).length;return f.verbose("Current rating retrieved",e),e}},set:{rating:function(e){var t=e-1>=0?e-1:0,n=S.eq(t);w.removeClass(p.selected),S.removeClass(p.selected).removeClass(p.active),e>0&&(f.verbose("Setting current rating to",e),n.prevAll().addBack().addClass(p.active)),f.is.initialLoad()||m.onRate.call(x,e)},initialLoad:function(){d=!0}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n;m.performance&&(n=(t=(new Date).getTime())-(r||t),r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:x,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;r=!1,clearTimeout(f.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",a&&(t+=" '"+a+"'"),o.length>1&&(t+=" ("+o.length+")"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,o,a){var r,s,l,c=C;return o=o||u,a=x||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,o):s!==i&&(l=s),e.isArray(n)?n.push(l):n!==i?n=[n,l]:l!==i&&(n=l),s}},c?(C===i&&f.initialize(),f.invoke(l)):(C!==i&&C.invoke("destroy"),f.initialize())}),n!==i?n:this},e.fn.rating.settings={name:"Rating",namespace:"rating",slent:!1,debug:!1,verbose:!1,performance:!0,initialRating:0,interactive:!0,maxRating:4,clearable:"auto",fireOnInit:!1,onRate:function(e){},error:{method:"The method you called is not defined",noMaximum:"No maximum rating specified. Cannot generate HTML automatically"},metadata:{rating:"rating",maxRating:"maxRating"},className:{active:"active",disabled:"disabled",selected:"selected",loading:"loading"},selector:{icon:".icon"},templates:{icon:function(e){for(var t=1,n="";t<=e;)n+='<i class="icon"></i>',t++;return n}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.search=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return e(this).each(function(){var m,g=e.isPlainObject(o)?e.extend(!0,{},e.fn.search.settings,o):e.extend({},e.fn.search.settings),p=g.className,h=g.metadata,v=g.regExp,b=g.fields,y=g.selector,x=g.error,C=g.namespace,w="."+C,S=C+"-module",k=e(this),T=k.find(y.prompt),A=k.find(y.searchButton),R=k.find(y.results),P=k.find(y.result),E=(k.find(y.category),this),F=k.data(S),O=!1,D=!1;m={initialize:function(){m.verbose("Initializing module"),m.get.settings(),m.determine.searchFields(),m.bind.events(),m.set.type(),m.create.results(),m.instantiate()},instantiate:function(){m.verbose("Storing instance of module",m),F=m,k.data(S,m)},destroy:function(){m.verbose("Destroying instance"),k.off(w).removeData(S)},refresh:function(){m.debug("Refreshing selector cache"),T=k.find(y.prompt),A=k.find(y.searchButton),k.find(y.category),R=k.find(y.results),P=k.find(y.result)},refreshResults:function(){R=k.find(y.results),P=k.find(y.result)},bind:{events:function(){m.verbose("Binding events to search"),g.automatic&&(k.on(m.get.inputEvent()+w,y.prompt,m.event.input),T.attr("autocomplete","off")),k.on("focus"+w,y.prompt,m.event.focus).on("blur"+w,y.prompt,m.event.blur).on("keydown"+w,y.prompt,m.handleKeyboard).on("click"+w,y.searchButton,m.query).on("mousedown"+w,y.results,m.event.result.mousedown).on("mouseup"+w,y.results,m.event.result.mouseup).on("click"+w,y.result,m.event.result.click)}},determine:{searchFields:function(){o&&o.searchFields!==i&&(g.searchFields=o.searchFields)}},event:{input:function(){g.searchDelay?(clearTimeout(m.timer),m.timer=setTimeout(function(){m.is.focused()&&m.query()},g.searchDelay)):m.query()},focus:function(){m.set.focus(),g.searchOnFocus&&m.has.minimumCharacters()&&m.query(function(){m.can.show()&&m.showResults()})},blur:function(e){var t=function(){m.cancel.query(),m.remove.focus(),m.timer=setTimeout(m.hideResults,g.hideDelay)};n.activeElement===this||(D=!1,m.resultsClicked?(m.debug("Determining if user action caused search to close"),k.one("click.close"+w,y.results,function(e){m.is.inMessage(e)||O?T.focus():(O=!1,m.is.animating()||m.is.hidden()||t())})):(m.debug("Input blurred without user action, closing results"),t()))},result:{mousedown:function(){m.resultsClicked=!0},mouseup:function(){m.resultsClicked=!1},click:function(n){m.debug("Search result selected");var i=e(this),o=i.find(y.title).eq(0),a=i.is("a[href]")?i:i.find("a[href]").eq(0),r=a.attr("href")||!1,s=a.attr("target")||!1,l=(o.html(),o.length>0&&o.text()),c=m.get.results(),u=i.data(h.result)||m.get.result(l,c);if(e.isFunction(g.onSelect)&&!1===g.onSelect.call(E,u,c))return m.debug("Custom onSelect callback cancelled default select action"),void(O=!0);m.hideResults(),l&&m.set.value(l),r&&(m.verbose("Opening search link found in result",a),"_blank"==s||n.ctrlKey?t.open(r):t.location.href=r)}}},handleKeyboard:function(e){var t,n=k.find(y.result),i=k.find(y.category),o=n.filter("."+p.active),a=n.index(o),r=n.length,s=o.length>0,l=e.which,c=13,u=38,d=40;if(l==27&&(m.verbose("Escape key pressed, blurring search field"),m.hideResults(),D=!0),m.is.visible())if(l==c){if(m.verbose("Enter key pressed, selecting active result"),n.filter("."+p.active).length>0)return m.event.result.click.call(n.filter("."+p.active),e),e.preventDefault(),!1}else l==u&&s?(m.verbose("Up key pressed, changing active result"),t=a-1<0?a:a-1,i.removeClass(p.active),n.removeClass(p.active).eq(t).addClass(p.active).closest(i).addClass(p.active),e.preventDefault()):l==d&&(m.verbose("Down key pressed, changing active result"),t=a+1>=r?a:a+1,i.removeClass(p.active),n.removeClass(p.active).eq(t).addClass(p.active).closest(i).addClass(p.active),e.preventDefault());else l==c&&(m.verbose("Enter key pressed, executing query"),m.query(),m.set.buttonPressed(),T.one("keyup",m.remove.buttonFocus))},setup:{api:function(t,n){var i={debug:g.debug,on:!1,cache:!0,action:"search",urlData:{query:t},onSuccess:function(e){m.parse.response.call(E,e,t),n()},onFailure:function(){m.displayMessage(x.serverError),n()},onAbort:function(e){},onError:m.error};e.extend(!0,i,g.apiSettings),m.verbose("Setting up API request",i),k.api(i)}},can:{useAPI:function(){return e.fn.api!==i},show:function(){return m.is.focused()&&!m.is.visible()&&!m.is.empty()},transition:function(){return g.transition&&e.fn.transition!==i&&k.transition("is supported")}},is:{animating:function(){return R.hasClass(p.animating)},hidden:function(){return R.hasClass(p.hidden)},inMessage:function(t){if(t.target){var i=e(t.target);return e.contains(n.documentElement,t.target)&&i.closest(y.message).length>0}},empty:function(){return""===R.html()},visible:function(){return R.filter(":visible").length>0},focused:function(){return T.filter(":focus").length>0}},get:{settings:function(){e.isPlainObject(o)&&o.searchFullText&&(g.fullTextSearch=o.searchFullText,m.error(g.error.oldSearchSyntax,E))},inputEvent:function(){var e=T[0];return e!==i&&e.oninput!==i?"input":e!==i&&e.onpropertychange!==i?"propertychange":"keyup"},value:function(){return T.val()},results:function(){return k.data(h.results)},result:function(t,n){var o=["title","id"],a=!1;return t=t!==i?t:m.get.value(),n=n!==i?n:m.get.results(),"category"===g.type?(m.debug("Finding result that matches",t),e.each(n,function(n,i){if(e.isArray(i.results)&&(a=m.search.object(t,i.results,o)[0]))return!1})):(m.debug("Finding result in results object",t),a=m.search.object(t,n,o)[0]),a||!1}},select:{firstResult:function(){m.verbose("Selecting first result"),P.first().addClass(p.active)}},set:{focus:function(){k.addClass(p.focus)},loading:function(){k.addClass(p.loading)},value:function(e){m.verbose("Setting search input value",e),T.val(e)},type:function(e){e=e||g.type,"category"==g.type&&k.addClass(g.type)},buttonPressed:function(){A.addClass(p.pressed)}},remove:{loading:function(){k.removeClass(p.loading)},focus:function(){k.removeClass(p.focus)},buttonPressed:function(){A.removeClass(p.pressed)}},query:function(t){t=e.isFunction(t)?t:function(){};var n=m.get.value(),i=m.read.cache(n);t=t||function(){},m.has.minimumCharacters()?(i?(m.debug("Reading result from cache",n),m.save.results(i.results),m.addResults(i.html),m.inject.id(i.results),t()):(m.debug("Querying for",n),e.isPlainObject(g.source)||e.isArray(g.source)?(m.search.local(n),t()):m.can.useAPI()?m.search.remote(n,t):(m.error(x.source),t())),g.onSearchQuery.call(E,n)):m.hideResults()},search:{local:function(e){var t,n=m.search.object(e,g.content);m.set.loading(),m.save.results(n),m.debug("Returned full local search results",n),g.maxResults>0&&(m.debug("Using specified max results",n),n=n.slice(0,g.maxResults)),"category"==g.type&&(n=m.create.categoryResults(n)),t=m.generateResults({results:n}),m.remove.loading(),m.addResults(t),m.inject.id(n),m.write.cache(e,{html:t,results:n})},remote:function(t,n){n=e.isFunction(n)?n:function(){},k.api("is loading")&&k.api("abort"),m.setup.api(t,n),k.api("query")},object:function(t,n,o){var a=[],r=[],s=[],l=t.toString().replace(v.escape,"\\$&"),c=new RegExp(v.beginsWith+l,"i"),u=function(t,n){var i=-1==e.inArray(n,a),o=-1==e.inArray(n,s),l=-1==e.inArray(n,r);i&&o&&l&&t.push(n)};return n=n||g.source,o=o!==i?o:g.searchFields,e.isArray(o)||(o=[o]),n===i||!1===n?(m.error(x.source),[]):(e.each(o,function(i,o){e.each(n,function(e,n){"string"==typeof n[o]&&(-1!==n[o].search(c)?u(a,n):"exact"===g.fullTextSearch&&m.exactSearch(t,n[o])?u(r,n):1==g.fullTextSearch&&m.fuzzySearch(t,n[o])&&u(s,n))})}),e.merge(r,s),e.merge(a,r),a)}},exactSearch:function(e,t){return e=e.toLowerCase(),(t=t.toLowerCase()).indexOf(e)>-1},fuzzySearch:function(e,t){var n=t.length,i=e.length;if("string"!=typeof e)return!1;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;if(i===n)return e===t;e:for(var o=0,a=0;o<i;o++){for(var r=e.charCodeAt(o);a<n;)if(t.charCodeAt(a++)===r)continue e;return!1}return!0},parse:{response:function(e,t){var n=m.generateResults(e);m.verbose("Parsing server response",e),e!==i&&t!==i&&e[b.results]!==i&&(m.addResults(n),m.inject.id(e[b.results]),m.write.cache(t,{html:n,results:e[b.results]}),m.save.results(e[b.results]))}},cancel:{query:function(){m.can.useAPI()&&k.api("abort")}},has:{minimumCharacters:function(){return m.get.value().length>=g.minCharacters},results:function(){return 0!==R.length&&""!=R.html()}},clear:{cache:function(e){var t=k.data(h.cache);e?e&&t&&t[e]&&(m.debug("Removing value from cache",e),delete t[e],k.data(h.cache,t)):(m.debug("Clearing cache",e),k.removeData(h.cache))}},read:{cache:function(e){var t=k.data(h.cache);return!!g.cache&&(m.verbose("Checking cache for generated html for query",e),"object"==typeof t&&t[e]!==i&&t[e])}},create:{categoryResults:function(t){var n={};return e.each(t,function(e,t){t.category&&(n[t.category]===i?(m.verbose("Creating new category of results",t.category),n[t.category]={name:t.category,results:[t]}):n[t.category].results.push(t))}),n},id:function(e,t){var n,o=e+1;return t!==i?(n=String.fromCharCode(97+t)+o,m.verbose("Creating category result id",n)):(n=o,m.verbose("Creating result id",n)),n},results:function(){0===R.length&&(R=e("<div />").addClass(p.results).appendTo(k))}},inject:{result:function(e,t,n){m.verbose("Injecting result into results");var o=n!==i?R.children().eq(n).children(y.results).first().children(y.result).eq(t):R.children(y.result).eq(t);m.verbose("Injecting results metadata",o),o.data(h.result,e)},id:function(t){m.debug("Injecting unique ids into results");var n=0,o=0;return"category"===g.type?e.each(t,function(t,a){o=0,e.each(a.results,function(e,t){var r=a.results[e];r.id===i&&(r.id=m.create.id(o,n)),m.inject.result(r,o,n),o++}),n++}):e.each(t,function(e,n){var a=t[e];a.id===i&&(a.id=m.create.id(o)),m.inject.result(a,o),o++}),t}},save:{results:function(e){m.verbose("Saving current search results to metadata",e),k.data(h.results,e)}},write:{cache:function(e,t){var n=k.data(h.cache)!==i?k.data(h.cache):{};g.cache&&(m.verbose("Writing generated html to cache",e,t),n[e]=t,k.data(h.cache,n))}},addResults:function(t){if(e.isFunction(g.onResultsAdd)&&!1===g.onResultsAdd.call(R,t))return m.debug("onResultsAdd callback cancelled default action"),!1;t?(R.html(t),m.refreshResults(),g.selectFirstResult&&m.select.firstResult(),m.showResults()):m.hideResults(function(){R.empty()})},showResults:function(t){t=e.isFunction(t)?t:function(){},D||!m.is.visible()&&m.has.results()&&(m.can.transition()?(m.debug("Showing results with css animations"),R.transition({animation:g.transition+" in",debug:g.debug,verbose:g.verbose,duration:g.duration,onComplete:function(){t()},queue:!0})):(m.debug("Showing results with javascript"),R.stop().fadeIn(g.duration,g.easing)),g.onResultsOpen.call(R))},hideResults:function(t){t=e.isFunction(t)?t:function(){},m.is.visible()&&(m.can.transition()?(m.debug("Hiding results with css animations"),R.transition({animation:g.transition+" out",debug:g.debug,verbose:g.verbose,duration:g.duration,onComplete:function(){t()},queue:!0})):(m.debug("Hiding results with javascript"),R.stop().fadeOut(g.duration,g.easing)),g.onResultsClose.call(R))},generateResults:function(t){m.debug("Generating html from response",t);var n=g.templates[g.type],i=e.isPlainObject(t[b.results])&&!e.isEmptyObject(t[b.results]),o=e.isArray(t[b.results])&&t[b.results].length>0,a="";return i||o?(g.maxResults>0&&(i?"standard"==g.type&&m.error(x.maxResults):t[b.results]=t[b.results].slice(0,g.maxResults)),e.isFunction(n)?a=n(t,b):m.error(x.noTemplate,!1)):g.showNoResults&&(a=m.displayMessage(x.noResults,"empty")),g.onResults.call(E,t),a},displayMessage:function(e,t){return t=t||"standard",m.debug("Displaying message",e,t),m.addResults(g.templates.message(e,t)),g.templates.message(e,t)},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n;g.performance&&(n=(t=(new Date).getTime())-(l||t),l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:E,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;l=!1,clearTimeout(m.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),r.length>1&&(t+=" ("+r.length+")"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=F;return n=n||f,o=E||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(F===i&&m.initialize(),m.invoke(u)):(F!==i&&F.invoke("destroy"),m.initialize())}),a!==i?a:this},e.fn.search.settings={name:"Search",namespace:"search",silent:!1,debug:!1,verbose:!1,performance:!0,type:"standard",minCharacters:1,selectFirstResult:!1,apiSettings:!1,source:!1,searchOnFocus:!0,searchFields:["title","description"],displayField:"",fullTextSearch:"exact",automatic:!0,hideDelay:0,searchDelay:200,maxResults:7,cache:!0,showNoResults:!0,transition:"scale",duration:200,easing:"easeOutExpo",onSelect:!1,onResultsAdd:!1,onSearchQuery:function(e){},onResults:function(e){},onResultsOpen:function(){},onResultsClose:function(){},className:{animating:"animating",active:"active",empty:"empty",focus:"focus",hidden:"hidden",loading:"loading",results:"results",pressed:"down"},error:{source:"Cannot search. No source used, and Semantic API module was not included",noResults:"Your search returned no results",logging:"Error in debug logging, exiting.",noEndpoint:"No search endpoint was specified",noTemplate:"A valid template name was not specified.",oldSearchSyntax:"searchFullText setting has been renamed fullTextSearch for consistency, please adjust your settings.",serverError:"There was an issue querying the server.",maxResults:"Results must be an array to use maxResults setting",method:"The method you called is not defined."},metadata:{cache:"cache",results:"results",result:"result"},regExp:{escape:/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,beginsWith:"(?:s|^)"},fields:{categories:"results",categoryName:"name",categoryResults:"results",description:"description",image:"image",price:"price",results:"results",title:"title",url:"url",action:"action",actionText:"text",actionURL:"url"},selector:{prompt:".prompt",searchButton:".search.button",results:".results",message:".results > .message",category:".category",result:".result",title:".title, .name"},templates:{escape:function(e){var t={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};return/[&<>"'`]/.test(e)?e.replace(/[&<>"'`]/g,function(e){return t[e]}):e},message:function(e,t){var n="";return e!==i&&t!==i&&(n+='<div class="message '+t+'">',n+="empty"==t?'<div class="header">No Results</div class="header"><div class="description">'+e+'</div class="description">':' <div class="description">'+e+"</div>",n+="</div>"),n},category:function(t,n){var o="";e.fn.search.settings.templates.escape;return t[n.categoryResults]!==i&&(e.each(t[n.categoryResults],function(t,a){a[n.results]!==i&&a.results.length>0&&(o+='<div class="category">',a[n.categoryName]!==i&&(o+='<div class="name">'+a[n.categoryName]+"</div>"),o+='<div class="results">',e.each(a.results,function(e,t){t[n.url]?o+='<a class="result" href="'+t[n.url]+'">':o+='<a class="result">',t[n.image]!==i&&(o+='<div class="image"> <img src="'+t[n.image]+'"></div>'),o+='<div class="content">',t[n.price]!==i&&(o+='<div class="price">'+t[n.price]+"</div>"),t[n.title]!==i&&(o+='<div class="title">'+t[n.title]+"</div>"),t[n.description]!==i&&(o+='<div class="description">'+t[n.description]+"</div>"),o+="</div>",o+="</a>"}),o+="</div>",o+="</div>")}),t[n.action]&&(o+='<a href="'+t[n.action][n.actionURL]+'" class="action">'+t[n.action][n.actionText]+"</a>"),o)},standard:function(t,n){var o="";return t[n.results]!==i&&(e.each(t[n.results],function(e,t){t[n.url]?o+='<a class="result" href="'+t[n.url]+'">':o+='<a class="result">',t[n.image]!==i&&(o+='<div class="image"> <img src="'+t[n.image]+'"></div>'),o+='<div class="content">',t[n.price]!==i&&(o+='<div class="price">'+t[n.price]+"</div>"),t[n.title]!==i&&(o+='<div class="title">'+t[n.title]+"</div>"),t[n.description]!==i&&(o+='<div class="description">'+t[n.description]+"</div>"),o+="</div>",o+="</a>"}),t[n.action]&&(o+='<a href="'+t[n.action][n.actionURL]+'" class="action">'+t[n.action][n.actionText]+"</a>"),o)}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.shape=function(o){var a,r=e(this),s=(e("body"),(new Date).getTime()),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1),f=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var t,m,g,p=r.selector||"",h=e.isPlainObject(o)?e.extend(!0,{},e.fn.shape.settings,o):e.extend({},e.fn.shape.settings),v=h.namespace,b=h.selector,y=h.error,x=h.className,C="."+v,w="module-"+v,S=e(this),k=S.find(b.sides),T=S.find(b.side),A=!1,R=this,P=S.data(w);g={initialize:function(){g.verbose("Initializing module for",R),g.set.defaultSide(),g.instantiate()},instantiate:function(){g.verbose("Storing instance of module",g),P=g,S.data(w,P)},destroy:function(){g.verbose("Destroying previous module for",R),S.removeData(w).off(C)},refresh:function(){g.verbose("Refreshing selector cache for",R),S=e(R),k=e(this).find(b.shape),T=e(this).find(b.side)},repaint:function(){g.verbose("Forcing repaint event");(k[0]||n.createElement("div")).offsetWidth},animate:function(e,n){g.verbose("Animating box with properties",e),n=n||function(e){g.verbose("Executing animation callback"),e!==i&&e.stopPropagation(),g.reset(),g.set.active()},h.beforeChange.call(m[0]),g.get.transitionEvent()?(g.verbose("Starting CSS animation"),S.addClass(x.animating),k.css(e).one(g.get.transitionEvent(),n),g.set.duration(h.duration),f(function(){S.addClass(x.animating),t.addClass(x.hidden)})):n()},queue:function(e){g.debug("Queueing animation of",e),k.one(g.get.transitionEvent(),function(){g.debug("Executing queued animation"),setTimeout(function(){S.shape(e)},0)})},reset:function(){g.verbose("Animating states reset"),S.removeClass(x.animating).attr("style","").removeAttr("style"),k.attr("style","").removeAttr("style"),T.attr("style","").removeAttr("style").removeClass(x.hidden),m.removeClass(x.animating).attr("style","").removeAttr("style")},is:{complete:function(){return T.filter("."+x.active)[0]==m[0]},animating:function(){return S.hasClass(x.animating)}},set:{defaultSide:function(){t=S.find("."+h.className.active),m=t.next(b.side).length>0?t.next(b.side):S.find(b.side).first(),A=!1,g.verbose("Active side set to",t),g.verbose("Next side set to",m)},duration:function(e){e="number"==typeof(e=e||h.duration)?e+"ms":e,g.verbose("Setting animation duration",e),(h.duration||0===h.duration)&&k.add(T).css({"-webkit-transition-duration":e,"-moz-transition-duration":e,"-ms-transition-duration":e,"-o-transition-duration":e,"transition-duration":e})},currentStageSize:function(){var e=S.find("."+h.className.active),t=e.outerWidth(!0),n=e.outerHeight(!0);S.css({width:t,height:n})},stageSize:function(){var e=S.clone().addClass(x.loading),t=e.find("."+h.className.active),n=A?e.find(b.side).eq(A):t.next(b.side).length>0?t.next(b.side):e.find(b.side).first(),i="next"==h.width?n.outerWidth(!0):"initial"==h.width?S.width():h.width,o="next"==h.height?n.outerHeight(!0):"initial"==h.height?S.height():h.height;t.removeClass(x.active),n.addClass(x.active),e.insertAfter(S),e.remove(),"auto"!=h.width&&(S.css("width",i+h.jitter),g.verbose("Specifying width during animation",i)),"auto"!=h.height&&(S.css("height",o+h.jitter),g.verbose("Specifying height during animation",o))},nextSide:function(e){A=e,m=T.filter(e),A=T.index(m),0===m.length&&(g.set.defaultSide(),g.error(y.side)),g.verbose("Next side manually set to",m)},active:function(){g.verbose("Setting new side to active",m),T.removeClass(x.active),m.addClass(x.active),h.onChange.call(m[0]),g.set.defaultSide()}},flip:{up:function(){if(!g.is.complete()||g.is.animating()||h.allowRepeats)if(g.is.animating())g.queue("flip up");else{g.debug("Flipping up",m);var e=g.get.transform.up();g.set.stageSize(),g.stage.above(),g.animate(e)}else g.debug("Side already visible",m)},down:function(){if(!g.is.complete()||g.is.animating()||h.allowRepeats)if(g.is.animating())g.queue("flip down");else{g.debug("Flipping down",m);var e=g.get.transform.down();g.set.stageSize(),g.stage.below(),g.animate(e)}else g.debug("Side already visible",m)},left:function(){if(!g.is.complete()||g.is.animating()||h.allowRepeats)if(g.is.animating())g.queue("flip left");else{g.debug("Flipping left",m);var e=g.get.transform.left();g.set.stageSize(),g.stage.left(),g.animate(e)}else g.debug("Side already visible",m)},right:function(){if(!g.is.complete()||g.is.animating()||h.allowRepeats)if(g.is.animating())g.queue("flip right");else{g.debug("Flipping right",m);var e=g.get.transform.right();g.set.stageSize(),g.stage.right(),g.animate(e)}else g.debug("Side already visible",m)},over:function(){!g.is.complete()||g.is.animating()||h.allowRepeats?g.is.animating()?g.queue("flip over"):(g.debug("Flipping over",m),g.set.stageSize(),g.stage.behind(),g.animate(g.get.transform.over())):g.debug("Side already visible",m)},back:function(){!g.is.complete()||g.is.animating()||h.allowRepeats?g.is.animating()?g.queue("flip back"):(g.debug("Flipping back",m),g.set.stageSize(),g.stage.behind(),g.animate(g.get.transform.back())):g.debug("Side already visible",m)}},get:{transform:{up:function(){return{transform:"translateY("+-(t.outerHeight(!0)-m.outerHeight(!0))/2+"px) translateZ("+-t.outerHeight(!0)/2+"px) rotateX(-90deg)"}},down:function(){return{transform:"translateY("+-(t.outerHeight(!0)-m.outerHeight(!0))/2+"px) translateZ("+-t.outerHeight(!0)/2+"px) rotateX(90deg)"}},left:function(){return{transform:"translateX("+-(t.outerWidth(!0)-m.outerWidth(!0))/2+"px) translateZ("+-t.outerWidth(!0)/2+"px) rotateY(90deg)"}},right:function(){return{transform:"translateX("+-(t.outerWidth(!0)-m.outerWidth(!0))/2+"px) translateZ("+-t.outerWidth(!0)/2+"px) rotateY(-90deg)"}},over:function(){return{transform:"translateX("+-(t.outerWidth(!0)-m.outerWidth(!0))/2+"px) rotateY(180deg)"}},back:function(){return{transform:"translateX("+-(t.outerWidth(!0)-m.outerWidth(!0))/2+"px) rotateY(-180deg)"}}},transitionEvent:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]},nextSide:function(){return t.next(b.side).length>0?t.next(b.side):S.find(b.side).first()}},stage:{above:function(){var e={origin:(t.outerHeight(!0)-m.outerHeight(!0))/2,depth:{active:m.outerHeight(!0)/2,next:t.outerHeight(!0)/2}};g.verbose("Setting the initial animation position as above",m,e),k.css({transform:"translateZ(-"+e.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+e.depth.active+"px)"}),m.addClass(x.animating).css({top:e.origin+"px",transform:"rotateX(90deg) translateZ("+e.depth.next+"px)"})},below:function(){var e={origin:(t.outerHeight(!0)-m.outerHeight(!0))/2,depth:{active:m.outerHeight(!0)/2,next:t.outerHeight(!0)/2}};g.verbose("Setting the initial animation position as below",m,e),k.css({transform:"translateZ(-"+e.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+e.depth.active+"px)"}),m.addClass(x.animating).css({top:e.origin+"px",transform:"rotateX(-90deg) translateZ("+e.depth.next+"px)"})},left:function(){var e=t.outerWidth(!0),n=m.outerWidth(!0),i={origin:(e-n)/2,depth:{active:n/2,next:e/2}};g.verbose("Setting the initial animation position as left",m,i),k.css({transform:"translateZ(-"+i.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+i.depth.active+"px)"}),m.addClass(x.animating).css({left:i.origin+"px",transform:"rotateY(-90deg) translateZ("+i.depth.next+"px)"})},right:function(){var e=t.outerWidth(!0),n=m.outerWidth(!0),i={origin:(e-n)/2,depth:{active:n/2,next:e/2}};g.verbose("Setting the initial animation position as left",m,i),k.css({transform:"translateZ(-"+i.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+i.depth.active+"px)"}),m.addClass(x.animating).css({left:i.origin+"px",transform:"rotateY(90deg) translateZ("+i.depth.next+"px)"})},behind:function(){var e=t.outerWidth(!0),n=m.outerWidth(!0),i={origin:(e-n)/2,depth:{active:n/2,next:e/2}};g.verbose("Setting the initial animation position as behind",m,i),t.css({transform:"rotateY(0deg)"}),m.addClass(x.animating).css({left:i.origin+"px",transform:"rotateY(-180deg)"})}},setting:function(t,n){if(g.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];e.isPlainObject(h[t])?e.extend(!0,h[t],n):h[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];g[t]=n}},debug:function(){!h.silent&&h.debug&&(h.performance?g.performance.log(arguments):(g.debug=Function.prototype.bind.call(console.info,console,h.name+":"),g.debug.apply(console,arguments)))},verbose:function(){!h.silent&&h.verbose&&h.debug&&(h.performance?g.performance.log(arguments):(g.verbose=Function.prototype.bind.call(console.info,console,h.name+":"),g.verbose.apply(console,arguments)))},error:function(){h.silent||(g.error=Function.prototype.bind.call(console.error,console,h.name+":"),g.error.apply(console,arguments))},performance:{log:function(e){var t,n;h.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:R,"Execution Time":n})),clearTimeout(g.performance.timer),g.performance.timer=setTimeout(g.performance.display,500)},display:function(){var t=h.name+":",n=0;s=!1,clearTimeout(g.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",p&&(t+=" '"+p+"'"),r.length>1&&(t+=" ("+r.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,o){var r,s,l,c=P;return n=n||d,o=R||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},u?(P===i&&g.initialize(),g.invoke(c)):(P!==i&&P.invoke("destroy"),g.initialize())}),a!==i?a:this},e.fn.shape.settings={name:"Shape",silent:!1,debug:!1,verbose:!1,jitter:0,performance:!0,namespace:"shape",width:"initial",height:"initial",beforeChange:function(){},onChange:function(){},allowRepeats:!1,duration:!1,error:{side:"You tried to switch to a side that does not exist.",method:"The method you called is not defined"},className:{animating:"animating",hidden:"hidden",loading:"loading",active:"active"},selector:{sides:".sides",side:".side"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.sidebar=function(o){var a,r=e(this),s=e(t),l=e(n),c=e("html"),u=e("head"),d=r.selector||"",f=(new Date).getTime(),m=[],g=arguments[0],p="string"==typeof g,h=[].slice.call(arguments,1),v=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var r,b,y,x,C,w,S=e.isPlainObject(o)?e.extend(!0,{},e.fn.sidebar.settings,o):e.extend({},e.fn.sidebar.settings),k=S.selector,T=S.className,A=S.namespace,R=S.regExp,P=S.error,E="."+A,F="module-"+A,O=e(this),D=e(S.context),q=O.children(k.sidebar),j=(D.children(k.fixed),D.children(k.pusher)),z=this,I=O.data(F);w={initialize:function(){w.debug("Initializing sidebar",o),w.create.id(),C=w.get.transitionEvent(),S.delaySetup?v(w.setup.layout):w.setup.layout(),v(function(){w.setup.cache()}),w.instantiate()},instantiate:function(){w.verbose("Storing instance of module",w),I=w,O.data(F,w)},create:{id:function(){y=(Math.random().toString(16)+"000000000").substr(2,8),b="."+y,w.verbose("Creating unique id for element",y)}},destroy:function(){w.verbose("Destroying previous module for",O),O.off(E).removeData(F),w.is.ios()&&w.remove.ios(),D.off(b),s.off(b),l.off(b)},event:{clickaway:function(e){var t=j.find(e.target).length>0||j.is(e.target),n=D.is(e.target);t&&(w.verbose("User clicked on dimmed page"),w.hide()),n&&(w.verbose("User clicked on dimmable context (scaled out page)"),w.hide())},touch:function(e){},containScroll:function(e){z.scrollTop<=0&&(z.scrollTop=1),z.scrollTop+z.offsetHeight>=z.scrollHeight&&(z.scrollTop=z.scrollHeight-z.offsetHeight-1)},scroll:function(t){0===e(t.target).closest(k.sidebar).length&&t.preventDefault()}},bind:{clickaway:function(){w.verbose("Adding clickaway events to context",D),S.closable&&D.on("click"+b,w.event.clickaway).on("touchend"+b,w.event.clickaway)},scrollLock:function(){S.scrollLock&&(w.debug("Disabling page scroll"),s.on("DOMMouseScroll"+b,w.event.scroll)),w.verbose("Adding events to contain sidebar scroll"),l.on("touchmove"+b,w.event.touch),O.on("scroll"+E,w.event.containScroll)}},unbind:{clickaway:function(){w.verbose("Removing clickaway events from context",D),D.off(b)},scrollLock:function(){w.verbose("Removing scroll lock from page"),l.off(b),s.off(b),O.off("scroll"+E)}},add:{inlineCSS:function(){var t,n=w.cache.width||O.outerWidth(),i=w.cache.height||O.outerHeight(),o=w.is.rtl(),a=w.get.direction(),s={left:n,right:-n,top:i,bottom:-i};o&&(w.verbose("RTL detected, flipping widths"),s.left=-n,s.right=n),t="<style>","left"===a||"right"===a?(w.debug("Adding CSS rules for animation distance",n),t+=" .ui.visible."+a+".sidebar ~ .fixed, .ui.visible."+a+".sidebar ~ .pusher {   -webkit-transform: translate3d("+s[a]+"px, 0, 0);           transform: translate3d("+s[a]+"px, 0, 0); }"):"top"!==a&&"bottom"!=a||(t+=" .ui.visible."+a+".sidebar ~ .fixed, .ui.visible."+a+".sidebar ~ .pusher {   -webkit-transform: translate3d(0, "+s[a]+"px, 0);           transform: translate3d(0, "+s[a]+"px, 0); }"),w.is.ie()&&("left"===a||"right"===a?(w.debug("Adding CSS rules for animation distance",n),t+=" body.pushable > .ui.visible."+a+".sidebar ~ .pusher:after {   -webkit-transform: translate3d("+s[a]+"px, 0, 0);           transform: translate3d("+s[a]+"px, 0, 0); }"):"top"!==a&&"bottom"!=a||(t+=" body.pushable > .ui.visible."+a+".sidebar ~ .pusher:after {   -webkit-transform: translate3d(0, "+s[a]+"px, 0);           transform: translate3d(0, "+s[a]+"px, 0); }"),t+=" body.pushable > .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher:after, body.pushable > .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher:after {   -webkit-transform: translate3d(0px, 0, 0);           transform: translate3d(0px, 0, 0); }"),r=e(t+="</style>").appendTo(u),w.debug("Adding sizing css to head",r)}},refresh:function(){w.verbose("Refreshing selector cache"),D=e(S.context),q=D.children(k.sidebar),j=D.children(k.pusher),D.children(k.fixed),w.clear.cache()},refreshSidebars:function(){w.verbose("Refreshing other sidebars"),q=D.children(k.sidebar)},repaint:function(){w.verbose("Forcing repaint event"),z.style.display="none";z.offsetHeight;z.scrollTop=z.scrollTop,z.style.display=""},setup:{cache:function(){w.cache={width:O.outerWidth(),height:O.outerHeight(),rtl:"rtl"==O.css("direction")}},layout:function(){0===D.children(k.pusher).length&&(w.debug("Adding wrapper element for sidebar"),w.error(P.pusher),j=e('<div class="pusher" />'),D.children().not(k.omitted).not(q).wrapAll(j),w.refresh()),0!==O.nextAll(k.pusher).length&&O.nextAll(k.pusher)[0]===j[0]||(w.debug("Moved sidebar to correct parent element"),w.error(P.movedSidebar,z),O.detach().prependTo(D),w.refresh()),w.clear.cache(),w.set.pushable(),w.set.direction()}},attachEvents:function(t,n){var i=e(t);n=e.isFunction(w[n])?w[n]:w.toggle,i.length>0?(w.debug("Attaching sidebar events to element",t,n),i.on("click"+E,n)):w.error(P.notFound,t)},show:function(t){if(t=e.isFunction(t)?t:function(){},w.is.hidden()){if(w.refreshSidebars(),S.overlay&&(w.error(P.overlay),S.transition="overlay"),w.refresh(),w.othersActive())if(w.debug("Other sidebars currently visible"),S.exclusive){if("overlay"!=S.transition)return void w.hideOthers(w.show);w.hideOthers()}else S.transition="overlay";w.pushPage(function(){t.call(z),S.onShow.call(z)}),S.onChange.call(z),S.onVisible.call(z)}else w.debug("Sidebar is already visible")},hide:function(t){t=e.isFunction(t)?t:function(){},(w.is.visible()||w.is.animating())&&(w.debug("Hiding sidebar",t),w.refreshSidebars(),w.pullPage(function(){t.call(z),S.onHidden.call(z)}),S.onChange.call(z),S.onHide.call(z))},othersAnimating:function(){return q.not(O).filter("."+T.animating).length>0},othersVisible:function(){return q.not(O).filter("."+T.visible).length>0},othersActive:function(){return w.othersVisible()||w.othersAnimating()},hideOthers:function(e){var t=q.not(O).filter("."+T.visible),n=t.length,i=0;e=e||function(){},t.sidebar("hide",function(){++i==n&&e()})},toggle:function(){w.verbose("Determining toggled direction"),w.is.hidden()?w.show():w.hide()},pushPage:function(t){var n,i,o,a=w.get.transition(),r="overlay"===a||w.othersActive()?O:j;t=e.isFunction(t)?t:function(){},"scale down"==S.transition&&w.scrollToTop(),w.set.transition(a),w.repaint(),n=function(){w.bind.clickaway(),w.add.inlineCSS(),w.set.animating(),w.set.visible()},i=function(){w.set.dimmed()},o=function(e){e.target==r[0]&&(r.off(C+b,o),w.remove.animating(),w.bind.scrollLock(),t.call(z))},r.off(C+b),r.on(C+b,o),v(n),S.dimPage&&!w.othersVisible()&&v(i)},pullPage:function(t){var n,i,o=w.get.transition(),a="overlay"==o||w.othersActive()?O:j;t=e.isFunction(t)?t:function(){},w.verbose("Removing context push state",w.get.direction()),w.unbind.clickaway(),w.unbind.scrollLock(),n=function(){w.set.transition(o),w.set.animating(),w.remove.visible(),S.dimPage&&!w.othersVisible()&&j.removeClass(T.dimmed)},i=function(e){e.target==a[0]&&(a.off(C+b,i),w.remove.animating(),w.remove.transition(),w.remove.inlineCSS(),("scale down"==o||S.returnScroll&&w.is.mobile())&&w.scrollBack(),t.call(z))},a.off(C+b),a.on(C+b,i),v(n)},scrollToTop:function(){w.verbose("Scrolling to top of page to avoid animation issues"),x=e(t).scrollTop(),O.scrollTop(0),t.scrollTo(0,0)},scrollBack:function(){w.verbose("Scrolling back to original page position"),t.scrollTo(0,x)},clear:{cache:function(){w.verbose("Clearing cached dimensions"),w.cache={}}},set:{ios:function(){c.addClass(T.ios)},pushed:function(){D.addClass(T.pushed)},pushable:function(){D.addClass(T.pushable)},dimmed:function(){j.addClass(T.dimmed)},active:function(){O.addClass(T.active)},animating:function(){O.addClass(T.animating)},transition:function(e){e=e||w.get.transition(),O.addClass(e)},direction:function(e){e=e||w.get.direction(),O.addClass(T[e])},visible:function(){O.addClass(T.visible)},overlay:function(){O.addClass(T.overlay)}},remove:{inlineCSS:function(){w.debug("Removing inline css styles",r),r&&r.length>0&&r.remove()},ios:function(){c.removeClass(T.ios)},pushed:function(){D.removeClass(T.pushed)},pushable:function(){D.removeClass(T.pushable)},active:function(){O.removeClass(T.active)},animating:function(){O.removeClass(T.animating)},transition:function(e){e=e||w.get.transition(),O.removeClass(e)},direction:function(e){e=e||w.get.direction(),O.removeClass(T[e])},visible:function(){O.removeClass(T.visible)},overlay:function(){O.removeClass(T.overlay)}},get:{direction:function(){return O.hasClass(T.top)?T.top:O.hasClass(T.right)?T.right:O.hasClass(T.bottom)?T.bottom:T.left},transition:function(){var e,t=w.get.direction();return e=w.is.mobile()?"auto"==S.mobileTransition?S.defaultTransition.mobile[t]:S.mobileTransition:"auto"==S.transition?S.defaultTransition.computer[t]:S.transition,w.verbose("Determined transition",e),e},transitionEvent:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]}},is:{ie:function(){return!t.ActiveXObject&&"ActiveXObject"in t||"ActiveXObject"in t},ios:function(){var e=navigator.userAgent,t=e.match(R.ios),n=e.match(R.mobileChrome);return!(!t||n)&&(w.verbose("Browser was found to be iOS",e),!0)},mobile:function(){var e=navigator.userAgent;return e.match(R.mobile)?(w.verbose("Browser was found to be mobile",e),!0):(w.verbose("Browser is not mobile, using regular transition",e),!1)},hidden:function(){return!w.is.visible()},visible:function(){return O.hasClass(T.visible)},open:function(){return w.is.visible()},closed:function(){return w.is.hidden()},vertical:function(){return O.hasClass(T.top)},animating:function(){return D.hasClass(T.animating)},rtl:function(){return w.cache.rtl===i&&(w.cache.rtl="rtl"==O.css("direction")),w.cache.rtl}},setting:function(t,n){if(w.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,S,t);else{if(n===i)return S[t];e.isPlainObject(S[t])?e.extend(!0,S[t],n):S[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,w,t);else{if(n===i)return w[t];w[t]=n}},debug:function(){!S.silent&&S.debug&&(S.performance?w.performance.log(arguments):(w.debug=Function.prototype.bind.call(console.info,console,S.name+":"),w.debug.apply(console,arguments)))},verbose:function(){!S.silent&&S.verbose&&S.debug&&(S.performance?w.performance.log(arguments):(w.verbose=Function.prototype.bind.call(console.info,console,S.name+":"),w.verbose.apply(console,arguments)))},error:function(){S.silent||(w.error=Function.prototype.bind.call(console.error,console,S.name+":"),w.error.apply(console,arguments))},performance:{log:function(e){var t,n;S.performance&&(n=(t=(new Date).getTime())-(f||t),f=t,m.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:z,"Execution Time":n})),clearTimeout(w.performance.timer),w.performance.timer=setTimeout(w.performance.display,500)},display:function(){var t=S.name+":",n=0;f=!1,clearTimeout(w.performance.timer),e.each(m,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",d&&(t+=" '"+d+"'"),(console.group!==i||console.table!==i)&&m.length>0&&(console.groupCollapsed(t),console.table?console.table(m):e.each(m,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),m=[]}},invoke:function(t,n,o){var r,s,l,c=I;return n=n||h,o=z||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(w.error(P.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},p?(I===i&&w.initialize(),w.invoke(g)):(I!==i&&w.invoke("destroy"),w.initialize())}),a!==i?a:this},e.fn.sidebar.settings={name:"Sidebar",namespace:"sidebar",silent:!1,debug:!1,verbose:!1,performance:!0,transition:"auto",mobileTransition:"auto",defaultTransition:{computer:{left:"uncover",right:"uncover",top:"overlay",bottom:"overlay"},mobile:{left:"uncover",right:"uncover",top:"overlay",bottom:"overlay"}},context:"body",exclusive:!1,closable:!0,dimPage:!0,scrollLock:!1,returnScroll:!1,delaySetup:!1,duration:500,onChange:function(){},onShow:function(){},onHide:function(){},onHidden:function(){},onVisible:function(){},className:{active:"active",animating:"animating",dimmed:"dimmed",ios:"ios",pushable:"pushable",pushed:"pushed",right:"right",top:"top",left:"left",bottom:"bottom",visible:"visible"},selector:{fixed:".fixed",omitted:"script, link, style, .ui.modal, .ui.dimmer, .ui.nag, .ui.fixed",pusher:".pusher",sidebar:".ui.sidebar"},regExp:{ios:/(iPad|iPhone|iPod)/g,mobileChrome:/(CriOS)/g,mobile:/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/g},error:{method:"The method you called is not defined.",pusher:"Had to add pusher element. For optimal performance make sure body content is inside a pusher element",movedSidebar:"Had to move sidebar. For optimal performance make sure sidebar and pusher are direct children of your body tag",overlay:"The overlay setting is no longer supported, use animation: overlay",notFound:"There were no elements that matched the specified selector"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.sticky=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return r.each(function(){var r,m,g,p,h,v=e.isPlainObject(o)?e.extend(!0,{},e.fn.sticky.settings,o):e.extend({},e.fn.sticky.settings),b=v.className,y=v.namespace,x=v.error,C="."+y,w="module-"+y,S=e(this),k=e(t),T=e(v.scrollContext),A=(S.selector,S.data(w)),R=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)},P=this;h={initialize:function(){h.determineContainer(),h.determineContext(),h.verbose("Initializing sticky",v,r),h.save.positions(),h.checkErrors(),h.bind.events(),v.observeChanges&&h.observeChanges(),h.instantiate()},instantiate:function(){h.verbose("Storing instance of module",h),A=h,S.data(w,h)},destroy:function(){h.verbose("Destroying previous instance"),h.reset(),g&&g.disconnect(),p&&p.disconnect(),k.off("load"+C,h.event.load).off("resize"+C,h.event.resize),T.off("scrollchange"+C,h.event.scrollchange),S.removeData(w)},observeChanges:function(){"MutationObserver"in t&&(g=new MutationObserver(h.event.documentChanged),p=new MutationObserver(h.event.changed),g.observe(n,{childList:!0,subtree:!0}),p.observe(P,{childList:!0,subtree:!0}),p.observe(m[0],{childList:!0,subtree:!0}),h.debug("Setting up mutation observer",p))},determineContainer:function(){r=v.container?e(v.container):S.offsetParent()},determineContext:function(){0!==(m=v.context?e(v.context):r).length||h.error(x.invalidContext,v.context,S)},checkErrors:function(){if(h.is.hidden()&&h.error(x.visible,S),h.cache.element.height>h.cache.context.height)return h.reset(),void h.error(x.elementSize,S)},bind:{events:function(){k.on("load"+C,h.event.load).on("resize"+C,h.event.resize),T.off("scroll"+C).on("scroll"+C,h.event.scroll).on("scrollchange"+C,h.event.scrollchange)}},event:{changed:function(e){clearTimeout(h.timer),h.timer=setTimeout(function(){h.verbose("DOM tree modified, updating sticky menu",e),h.refresh()},100)},documentChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==P||e(t).find(P).length>0)&&(h.debug("Element removed from DOM, tearing down events"),h.destroy())})})},load:function(){h.verbose("Page contents finished loading"),R(h.refresh)},resize:function(){h.verbose("Window resized"),R(h.refresh)},scroll:function(){R(function(){T.triggerHandler("scrollchange"+C,T.scrollTop())})},scrollchange:function(e,t){h.stick(t),v.onScroll.call(P)}},refresh:function(e){h.reset(),v.context||h.determineContext(),e&&h.determineContainer(),h.save.positions(),h.stick(),v.onReposition.call(P)},supports:{sticky:function(){var t=e("<div/>");t[0];return t.addClass(b.supported),t.css("position").match("sticky")}},save:{lastScroll:function(e){h.lastScroll=e},elementScroll:function(e){h.elementScroll=e},positions:function(){var e={height:T.height()},t={margin:{top:parseInt(S.css("margin-top"),10),bottom:parseInt(S.css("margin-bottom"),10)},offset:S.offset(),width:S.outerWidth(),height:S.outerHeight()},n={offset:m.offset(),height:m.outerHeight()};r.outerHeight();h.is.standardScroll()||(h.debug("Non-standard scroll. Removing scroll offset from element offset"),e.top=T.scrollTop(),e.left=T.scrollLeft(),t.offset.top+=e.top,n.offset.top+=e.top,t.offset.left+=e.left,n.offset.left+=e.left),h.cache={fits:t.height+v.offset<=e.height,sameHeight:t.height==n.height,scrollContext:{height:e.height},element:{margin:t.margin,top:t.offset.top-t.margin.top,left:t.offset.left,width:t.width,height:t.height,bottom:t.offset.top+t.height},context:{top:n.offset.top,height:n.height,bottom:n.offset.top+n.height}},h.set.containerSize(),h.stick(),h.debug("Caching element positions",h.cache)}},get:{direction:function(e){var t="down";return e=e||T.scrollTop(),h.lastScroll!==i&&(h.lastScroll<e?t="down":h.lastScroll>e&&(t="up")),t},scrollChange:function(e){return e=e||T.scrollTop(),h.lastScroll?e-h.lastScroll:0},currentElementScroll:function(){return h.elementScroll?h.elementScroll:h.is.top()?Math.abs(parseInt(S.css("top"),10))||0:Math.abs(parseInt(S.css("bottom"),10))||0},elementScroll:function(e){e=e||T.scrollTop();var t=h.cache.element,n=h.cache.scrollContext,i=h.get.scrollChange(e),o=t.height-n.height+v.offset,a=h.get.currentElementScroll(),r=a+i;return a=h.cache.fits||r<0?0:r>o?o:r}},remove:{lastScroll:function(){delete h.lastScroll},elementScroll:function(e){delete h.elementScroll},minimumSize:function(){r.css("min-height","")},offset:function(){S.css("margin-top","")}},set:{offset:function(){h.verbose("Setting offset on element",v.offset),S.css("margin-top",v.offset)},containerSize:function(){var e=r.get(0).tagName;"HTML"===e||"body"==e?h.determineContainer():Math.abs(r.outerHeight()-h.cache.context.height)>v.jitter&&(h.debug("Context has padding, specifying exact height for container",h.cache.context.height),r.css({height:h.cache.context.height}))},minimumSize:function(){var e=h.cache.element;r.css("min-height",e.height)},scroll:function(e){h.debug("Setting scroll on element",e),h.elementScroll!=e&&(h.is.top()&&S.css("bottom","").css("top",-e),h.is.bottom()&&S.css("top","").css("bottom",e))},size:function(){0!==h.cache.element.height&&0!==h.cache.element.width&&(P.style.setProperty("width",h.cache.element.width+"px","important"),P.style.setProperty("height",h.cache.element.height+"px","important"))}},is:{standardScroll:function(){return T[0]==t},top:function(){return S.hasClass(b.top)},bottom:function(){return S.hasClass(b.bottom)},initialPosition:function(){return!h.is.fixed()&&!h.is.bound()},hidden:function(){return!S.is(":visible")},bound:function(){return S.hasClass(b.bound)},fixed:function(){return S.hasClass(b.fixed)}},stick:function(e){var t=e||T.scrollTop(),n=h.cache,i=n.fits,o=n.sameHeight,a=n.element,r=n.scrollContext,s=n.context,l=h.is.bottom()&&v.pushing?v.bottomOffset:v.offset,c=(e={top:t+l,bottom:t+l+r.height},h.get.direction(e.top),i?0:h.get.elementScroll(e.top)),u=!i;0!==a.height&&!o&&(h.is.initialPosition()?e.top>=s.bottom?(h.debug("Initial element position is bottom of container"),h.bindBottom()):e.top>a.top&&(a.height+e.top-c>=s.bottom?(h.debug("Initial element position is bottom of container"),h.bindBottom()):(h.debug("Initial element position is fixed"),h.fixTop())):h.is.fixed()?h.is.top()?e.top<=a.top?(h.debug("Fixed element reached top of container"),h.setInitialPosition()):a.height+e.top-c>=s.bottom?(h.debug("Fixed element reached bottom of container"),h.bindBottom()):u&&(h.set.scroll(c),h.save.lastScroll(e.top),h.save.elementScroll(c)):h.is.bottom()&&(e.bottom-a.height<=a.top?(h.debug("Bottom fixed rail has reached top of container"),h.setInitialPosition()):e.bottom>=s.bottom?(h.debug("Bottom fixed rail has reached bottom of container"),h.bindBottom()):u&&(h.set.scroll(c),h.save.lastScroll(e.top),h.save.elementScroll(c))):h.is.bottom()&&(e.top<=a.top?(h.debug("Jumped from bottom fixed to top fixed, most likely used home/end button"),h.setInitialPosition()):v.pushing?h.is.bound()&&e.bottom<=s.bottom&&(h.debug("Fixing bottom attached element to bottom of browser."),h.fixBottom()):h.is.bound()&&e.top<=s.bottom-a.height&&(h.debug("Fixing bottom attached element to top of browser."),h.fixTop())))},bindTop:function(){h.debug("Binding element to top of parent container"),h.remove.offset(),S.css({left:"",top:"",marginBottom:""}).removeClass(b.fixed).removeClass(b.bottom).addClass(b.bound).addClass(b.top),v.onTop.call(P),v.onUnstick.call(P)},bindBottom:function(){h.debug("Binding element to bottom of parent container"),h.remove.offset(),S.css({left:"",top:""}).removeClass(b.fixed).removeClass(b.top).addClass(b.bound).addClass(b.bottom),v.onBottom.call(P),v.onUnstick.call(P)},setInitialPosition:function(){h.debug("Returning to initial position"),h.unfix(),h.unbind()},fixTop:function(){h.debug("Fixing element to top of page"),v.setSize&&h.set.size(),h.set.minimumSize(),h.set.offset(),S.css({left:h.cache.element.left,bottom:"",marginBottom:""}).removeClass(b.bound).removeClass(b.bottom).addClass(b.fixed).addClass(b.top),v.onStick.call(P)},fixBottom:function(){h.debug("Sticking element to bottom of page"),v.setSize&&h.set.size(),h.set.minimumSize(),h.set.offset(),S.css({left:h.cache.element.left,bottom:"",marginBottom:""}).removeClass(b.bound).removeClass(b.top).addClass(b.fixed).addClass(b.bottom),v.onStick.call(P)},unbind:function(){h.is.bound()&&(h.debug("Removing container bound position on element"),h.remove.offset(),S.removeClass(b.bound).removeClass(b.top).removeClass(b.bottom))},unfix:function(){h.is.fixed()&&(h.debug("Removing fixed position on element"),h.remove.minimumSize(),h.remove.offset(),S.removeClass(b.fixed).removeClass(b.top).removeClass(b.bottom),v.onUnstick.call(P))},reset:function(){h.debug("Resetting elements position"),h.unbind(),h.unfix(),h.resetCSS(),h.remove.offset(),h.remove.lastScroll()},resetCSS:function(){S.css({width:"",height:""}),r.css({height:""})},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];v[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];h[t]=n}},debug:function(){!v.silent&&v.debug&&(v.performance?h.performance.log(arguments):(h.debug=Function.prototype.bind.call(console.info,console,v.name+":"),h.debug.apply(console,arguments)))},verbose:function(){!v.silent&&v.verbose&&v.debug&&(v.performance?h.performance.log(arguments):(h.verbose=Function.prototype.bind.call(console.info,console,v.name+":"),h.verbose.apply(console,arguments)))},error:function(){v.silent||(h.error=Function.prototype.bind.call(console.error,console,v.name+":"),h.error.apply(console,arguments))},performance:{log:function(e){var t,n;v.performance&&(n=(t=(new Date).getTime())-(l||t),l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:P,"Execution Time":n})),clearTimeout(h.performance.timer),h.performance.timer=setTimeout(h.performance.display,0)},display:function(){var t=v.name+":",n=0;l=!1,clearTimeout(h.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=A;return n=n||f,o=P||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(A===i&&h.initialize(),h.invoke(u)):(A!==i&&A.invoke("destroy"),h.initialize())}),a!==i?a:this},e.fn.sticky.settings={name:"Sticky",namespace:"sticky",silent:!1,debug:!1,verbose:!0,performance:!0,pushing:!1,context:!1,container:!1,scrollContext:t,offset:0,bottomOffset:0,jitter:5,setSize:!0,observeChanges:!1,onReposition:function(){},onScroll:function(){},onStick:function(){},onUnstick:function(){},onTop:function(){},onBottom:function(){},error:{container:"Sticky element must be inside a relative container",visible:"Element is hidden, you must call refresh after element becomes visible. Use silent setting to surpress this warning in production.",method:"The method you called is not defined.",invalidContext:"Context specified does not exist",elementSize:"Sticky element is larger than its container, cannot create sticky."},className:{bound:"bound",fixed:"fixed",supported:"native",top:"top",bottom:"bottom"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.tab=function(o){var a,r=e.isFunction(this)?e(t):e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1),m=!1;return r.each(function(){var g,p,h,v,b,y,x=e.isPlainObject(o)?e.extend(!0,{},e.fn.tab.settings,o):e.extend({},e.fn.tab.settings),C=x.className,w=x.metadata,S=x.selector,k=x.error,T="."+x.namespace,A="module-"+x.namespace,R=e(this),P={},E=!0,F=0,O=this,D=R.data(A);b={initialize:function(){b.debug("Initializing tab menu item",R),b.fix.callbacks(),b.determineTabs(),b.debug("Determining tabs",x.context,p),x.auto&&b.set.auto(),b.bind.events(),x.history&&!m&&(b.initializeHistory(),m=!0),b.instantiate()},instantiate:function(){b.verbose("Storing instance of module",b),D=b,R.data(A,b)},destroy:function(){b.debug("Destroying tabs",R),R.removeData(A).off(T)},bind:{events:function(){e.isWindow(O)||(b.debug("Attaching tab activation events to element",R),R.on("click"+T,b.event.click))}},determineTabs:function(){var t;"parent"===x.context?(R.closest(S.ui).length>0?(t=R.closest(S.ui),b.verbose("Using closest UI element as parent",t)):t=R,g=t.parent(),b.verbose("Determined parent element for creating context",g)):x.context?(g=e(x.context),b.verbose("Using selector for tab context",x.context,g)):g=e("body"),x.childrenOnly?(p=g.children(S.tabs),b.debug("Searching tab context children for tabs",g,p)):(p=g.find(S.tabs),b.debug("Searching tab context for tabs",g,p))},fix:{callbacks:function(){e.isPlainObject(o)&&(o.onTabLoad||o.onTabInit)&&(o.onTabLoad&&(o.onLoad=o.onTabLoad,delete o.onTabLoad,b.error(k.legacyLoad,o.onLoad)),o.onTabInit&&(o.onFirstLoad=o.onTabInit,delete o.onTabInit,b.error(k.legacyInit,o.onFirstLoad)),x=e.extend(!0,{},e.fn.tab.settings,o))}},initializeHistory:function(){if(b.debug("Initializing page state"),e.address===i)return b.error(k.state),!1;if("state"==x.historyType){if(b.debug("Using HTML5 to manage state"),!1===x.path)return b.error(k.path),!1;e.address.history(!0).state(x.path)}e.address.bind("change",b.event.history.change)},event:{click:function(t){var n=e(this).data(w.tab);n!==i?(x.history?(b.verbose("Updating page state",t),e.address.value(n)):(b.verbose("Changing tab",t),b.changeTab(n)),t.preventDefault()):b.debug("No tab specified")},history:{change:function(t){var n=t.pathNames.join("/")||b.get.initialPath(),o=x.templates.determineTitle(n)||!1;b.performance.display(),b.debug("History change event",n,t),y=t,n!==i&&b.changeTab(n),o&&e.address.title(o)}}},refresh:function(){h&&(b.debug("Refreshing tab",h),b.changeTab(h))},cache:{read:function(e){return e!==i&&P[e]},add:function(e,t){e=e||h,b.debug("Adding cached content for",e),P[e]=t},remove:function(e){e=e||h,b.debug("Removing cached content for",e),delete P[e]}},set:{auto:function(){var t="string"==typeof x.path?x.path.replace(/\/$/,"")+"/{$tab}":"/{$tab}";b.verbose("Setting up automatic tab retrieval from server",t),e.isPlainObject(x.apiSettings)?x.apiSettings.url=t:x.apiSettings={url:t}},loading:function(e){var t=b.get.tabElement(e);t.hasClass(C.loading)||(b.verbose("Setting loading state for",t),t.addClass(C.loading).siblings(p).removeClass(C.active+" "+C.loading),t.length>0&&x.onRequest.call(t[0],e))},state:function(t){e.address.value(t)}},changeTab:function(n){var i=t.history&&t.history.pushState&&x.ignoreFirstLoad&&E,o=x.auto||e.isPlainObject(x.apiSettings),a=o&&!i?b.utilities.pathToArray(n):b.get.defaultPathArray(n);n=b.utilities.arrayToPath(a),e.each(a,function(t,r){var s,l,c,u,d=a.slice(0,t+1),f=b.utilities.arrayToPath(d),m=b.is.tab(f),p=t+1==a.length,S=b.get.tabElement(f);if(b.verbose("Looking for tab",r),m){if(b.verbose("Tab was found",r),h=f,v=b.utilities.filterArray(a,d),p?u=!0:(l=a.slice(0,t+2),c=b.utilities.arrayToPath(l),(u=!b.is.tab(c))&&b.verbose("Tab parameters found",l)),u&&o)return i?(b.debug("Ignoring remote content on first tab load",f),E=!1,b.cache.add(n,S.html()),b.activate.all(f),x.onFirstLoad.call(S[0],f,v,y),x.onLoad.call(S[0],f,v,y)):(b.activate.navigation(f),b.fetch.content(f,n)),!1;b.debug("Opened local tab",f),b.activate.all(f),b.cache.read(f)||(b.cache.add(f,!0),b.debug("First time tab loaded calling tab init"),x.onFirstLoad.call(S[0],f,v,y)),x.onLoad.call(S[0],f,v,y)}else{if(-1!=n.search("/")||""===n)return b.error(k.missingTab,R,g,f),!1;if(f=(s=e("#"+n+', a[name="'+n+'"]')).closest("[data-tab]").data(w.tab),S=b.get.tabElement(f),s&&s.length>0&&f)return b.debug("Anchor link used, opening parent tab",S,s),S.hasClass(C.active)||setTimeout(function(){b.scrollTo(s)},0),b.activate.all(f),b.cache.read(f)||(b.cache.add(f,!0),b.debug("First time tab loaded calling tab init"),x.onFirstLoad.call(S[0],f,v,y)),x.onLoad.call(S[0],f,v,y),!1}})},scrollTo:function(t){var i=!!(t&&t.length>0)&&t.offset().top;!1!==i&&(b.debug("Forcing scroll to an in-page link in a hidden tab",i,t),e(n).scrollTop(i))},update:{content:function(t,n,o){var a=b.get.tabElement(t),r=a[0];o=o!==i?o:x.evaluateScripts,"string"==typeof x.cacheType&&"dom"==x.cacheType.toLowerCase()&&"string"!=typeof n?a.empty().append(e(n).clone(!0)):o?(b.debug("Updating HTML and evaluating inline scripts",t,n),a.html(n)):(b.debug("Updating HTML",t,n),r.innerHTML=n)}},fetch:{content:function(t,n){var o,a,r=b.get.tabElement(t),s={dataType:"html",encodeParameters:!1,on:"now",cache:x.alwaysRefresh,headers:{"X-Remote":!0},onSuccess:function(e){"response"==x.cacheType&&b.cache.add(n,e),b.update.content(t,e),t==h?(b.debug("Content loaded",t),b.activate.tab(t)):b.debug("Content loaded in background",t),x.onFirstLoad.call(r[0],t,v,y),x.onLoad.call(r[0],t,v,y),x.loadOnce?b.cache.add(n,!0):"string"==typeof x.cacheType&&"dom"==x.cacheType.toLowerCase()&&r.children().length>0?setTimeout(function(){var e=r.children().clone(!0);e=e.not("script"),b.cache.add(n,e)},0):b.cache.add(n,r.html())},urlData:{tab:n}},l=r.api("get request")||!1,c=l&&"pending"===l.state();n=n||t,a=b.cache.read(n),x.cache&&a?(b.activate.tab(t),b.debug("Adding cached content",n),x.loadOnce||("once"==x.evaluateScripts?b.update.content(t,a,!1):b.update.content(t,a)),x.onLoad.call(r[0],t,v,y)):c?(b.set.loading(t),b.debug("Content is already loading",n)):e.api!==i?(o=e.extend(!0,{},x.apiSettings,s),b.debug("Retrieving remote content",n,o),b.set.loading(t),r.api(o)):b.error(k.api)}},activate:{all:function(e){b.activate.tab(e),b.activate.navigation(e)},tab:function(e){var t=b.get.tabElement(e),n="siblings"==x.deactivate?t.siblings(p):p.not(t),i=t.hasClass(C.active);b.verbose("Showing tab content for",t),i||(t.addClass(C.active),n.removeClass(C.active+" "+C.loading),t.length>0&&x.onVisible.call(t[0],e))},navigation:function(e){var t=b.get.navElement(e),n="siblings"==x.deactivate?t.siblings(r):r.not(t),i=t.hasClass(C.active);b.verbose("Activating tab navigation for",t,e),i||(t.addClass(C.active),n.removeClass(C.active+" "+C.loading))}},deactivate:{all:function(){b.deactivate.navigation(),b.deactivate.tabs()},navigation:function(){r.removeClass(C.active)},tabs:function(){p.removeClass(C.active+" "+C.loading)}},is:{tab:function(e){return e!==i&&b.get.tabElement(e).length>0}},get:{initialPath:function(){return r.eq(0).data(w.tab)||p.eq(0).data(w.tab)},path:function(){return e.address.value()},defaultPathArray:function(e){return b.utilities.pathToArray(b.get.defaultPath(e))},defaultPath:function(e){var t=r.filter("[data-"+w.tab+'^="'+e+'/"]').eq(0).data(w.tab)||!1;if(t){if(b.debug("Found default tab",t),F<x.maxDepth)return F++,b.get.defaultPath(t);b.error(k.recursion)}else b.debug("No default tabs found for",e,p);return F=0,e},navElement:function(e){return e=e||h,r.filter("[data-"+w.tab+'="'+e+'"]')},tabElement:function(e){var t,n,i,o;return e=e||h,i=b.utilities.pathToArray(e),o=b.utilities.last(i),t=p.filter("[data-"+w.tab+'="'+e+'"]'),n=p.filter("[data-"+w.tab+'="'+o+'"]'),t.length>0?t:n},tab:function(){return h}},utilities:{filterArray:function(t,n){return e.grep(t,function(t){return-1==e.inArray(t,n)})},last:function(t){return!!e.isArray(t)&&t[t.length-1]},pathToArray:function(e){return e===i&&(e=h),"string"==typeof e?e.split("/"):[e]},arrayToPath:function(t){return!!e.isArray(t)&&t.join("/")}},setting:function(t,n){if(b.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,x,t);else{if(n===i)return x[t];e.isPlainObject(x[t])?e.extend(!0,x[t],n):x[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,b,t);else{if(n===i)return b[t];b[t]=n}},debug:function(){!x.silent&&x.debug&&(x.performance?b.performance.log(arguments):(b.debug=Function.prototype.bind.call(console.info,console,x.name+":"),b.debug.apply(console,arguments)))},verbose:function(){!x.silent&&x.verbose&&x.debug&&(x.performance?b.performance.log(arguments):(b.verbose=Function.prototype.bind.call(console.info,console,x.name+":"),b.verbose.apply(console,arguments)))},error:function(){x.silent||(b.error=Function.prototype.bind.call(console.error,console,x.name+":"),b.error.apply(console,arguments))},performance:{log:function(e){var t,n;x.performance&&(n=(t=(new Date).getTime())-(l||t),l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:O,"Execution Time":n})),clearTimeout(b.performance.timer),b.performance.timer=setTimeout(b.performance.display,500)},display:function(){var t=x.name+":",n=0;l=!1,clearTimeout(b.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=D;return n=n||f,o=O||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(b.error(k.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(D===i&&b.initialize(),b.invoke(u)):(D!==i&&D.invoke("destroy"),b.initialize())}),a!==i?a:this},e.tab=function(){e(t).tab.apply(this,arguments)},e.fn.tab.settings={name:"Tab",namespace:"tab",silent:!1,debug:!1,verbose:!1,performance:!0,auto:!1,history:!1,historyType:"hash",path:!1,context:!1,childrenOnly:!1,maxDepth:25,deactivate:"siblings",alwaysRefresh:!1,cache:!0,loadOnce:!1,cacheType:"response",ignoreFirstLoad:!1,apiSettings:!1,evaluateScripts:"once",onFirstLoad:function(e,t,n){},onLoad:function(e,t,n){},onVisible:function(e,t,n){},onRequest:function(e,t,n){},templates:{determineTitle:function(e){}},error:{api:"You attempted to load content without API module",method:"The method you called is not defined",missingTab:"Activated tab cannot be found. Tabs are case-sensitive.",noContent:"The tab you specified is missing a content url.",path:"History enabled, but no path was specified",recursion:"Max recursive depth reached",legacyInit:"onTabInit has been renamed to onFirstLoad in 2.0, please adjust your code.",legacyLoad:"onTabLoad has been renamed to onLoad in 2.0. Please adjust your code",state:"History requires Asual's Address library <https://github.com/asual/jquery-address>"},metadata:{tab:"tab",loaded:"loaded",promise:"promise"},className:{loading:"loading",active:"active"},selector:{tabs:".ui.tab",ui:".ui"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.transition=function(){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments,u=c[0],d=[].slice.call(arguments,1),f="string"==typeof u;t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame;return a.each(function(t){var m,g,p,h,v,b,y,x,C,w=e(this),S=this;(C={initialize:function(){m=C.get.settings.apply(S,c),h=m.className,p=m.error,v=m.metadata,x="."+m.namespace,y="module-"+m.namespace,g=w.data(y)||C,b=C.get.animationEndEvent(),f&&(f=C.invoke(u)),!1===f&&(C.verbose("Converted arguments into settings object",m),m.interval?C.delay(m.animate):C.animate(),C.instantiate())},instantiate:function(){C.verbose("Storing instance of module",C),g=C,w.data(y,g)},destroy:function(){C.verbose("Destroying previous module for",S),w.removeData(y)},refresh:function(){C.verbose("Refreshing display type on next animation"),delete C.displayType},forceRepaint:function(){C.verbose("Forcing element repaint");var e=w.parent(),t=w.next();0===t.length?w.detach().appendTo(e):w.detach().insertBefore(t)},repaint:function(){C.verbose("Repainting element");S.offsetWidth},delay:function(e){var n,o=C.get.animationDirection();o||(o=C.can.transition()?C.get.direction():"static"),e=e!==i?e:m.interval,n="auto"==m.reverse&&o==h.outward||1==m.reverse?(a.length-t)*m.interval:t*m.interval,C.debug("Delaying animation by",n),setTimeout(C.animate,n)},animate:function(e){if(m=e||m,!C.is.supported())return C.error(p.support),!1;if(C.debug("Preparing animation",m.animation),C.is.animating()){if(m.queue)return!m.allowRepeats&&C.has.direction()&&C.is.occurring()&&!0!==C.queuing?C.debug("Animation is currently occurring, preventing queueing same animation",m.animation):C.queue(m.animation),!1;if(!m.allowRepeats&&C.is.occurring())return C.debug("Animation is already occurring, will not execute repeated animation",m.animation),!1;C.debug("New animation started, completing previous early",m.animation),g.complete()}C.can.animate()?C.set.animating(m.animation):C.error(p.noAnimation,m.animation,S)},reset:function(){C.debug("Resetting animation to beginning conditions"),C.remove.animationCallbacks(),C.restore.conditions(),C.remove.animating()},queue:function(e){C.debug("Queueing animation of",e),C.queuing=!0,w.one(b+".queue"+x,function(){C.queuing=!1,C.repaint(),C.animate.apply(this,m)})},complete:function(e){C.debug("Animation complete",m.animation),C.remove.completeCallback(),C.remove.failSafe(),C.is.looping()||(C.is.outward()?(C.verbose("Animation is outward, hiding element"),C.restore.conditions(),C.hide()):C.is.inward()?(C.verbose("Animation is outward, showing element"),C.restore.conditions(),C.show()):(C.verbose("Static animation completed"),C.restore.conditions(),m.onComplete.call(S)))},force:{visible:function(){var e=w.attr("style"),t=C.get.userStyle(),n=C.get.displayType(),o=t+"display: "+n+" !important;",a=w.css("display"),r=e===i||""===e;a!==n?(C.verbose("Overriding default display to show element",n),w.attr("style",o)):r&&w.removeAttr("style")},hidden:function(){var e=w.attr("style"),t=w.css("display"),n=e===i||""===e;"none"===t||C.is.hidden()?n&&w.removeAttr("style"):(C.verbose("Overriding default display to hide element"),w.css("display","none"))}},has:{direction:function(t){var n=!1;return"string"==typeof(t=t||m.animation)&&(t=t.split(" "),e.each(t,function(e,t){t!==h.inward&&t!==h.outward||(n=!0)})),n},inlineDisplay:function(){var t=w.attr("style")||"";return e.isArray(t.match(/display.*?;/,""))}},set:{animating:function(e){var t;C.remove.completeCallback(),e=e||m.animation,t=C.get.animationClass(e),C.save.animation(t),C.force.visible(),C.remove.hidden(),C.remove.direction(),C.start.animation(t)},duration:function(e,t){((t="number"==typeof(t=t||m.duration)?t+"ms":t)||0===t)&&(C.verbose("Setting animation duration",t),w.css({"animation-duration":t}))},direction:function(e){(e=e||C.get.direction())==h.inward?C.set.inward():C.set.outward()},looping:function(){C.debug("Transition set to loop"),w.addClass(h.looping)},hidden:function(){w.addClass(h.transition).addClass(h.hidden)},inward:function(){C.debug("Setting direction to inward"),w.removeClass(h.outward).addClass(h.inward)},outward:function(){C.debug("Setting direction to outward"),w.removeClass(h.inward).addClass(h.outward)},visible:function(){w.addClass(h.transition).addClass(h.visible)}},start:{animation:function(e){e=e||C.get.animationClass(),C.debug("Starting tween",e),w.addClass(e).one(b+".complete"+x,C.complete),m.useFailSafe&&C.add.failSafe(),C.set.duration(m.duration),m.onStart.call(S)}},save:{animation:function(e){C.cache||(C.cache={}),C.cache.animation=e},displayType:function(e){"none"!==e&&w.data(v.displayType,e)},transitionExists:function(t,n){e.fn.transition.exists[t]=n,C.verbose("Saving existence of transition",t,n)}},restore:{conditions:function(){var e=C.get.currentAnimation();e&&(w.removeClass(e),C.verbose("Removing animation class",C.cache)),C.remove.duration()}},add:{failSafe:function(){var e=C.get.duration();C.timer=setTimeout(function(){w.triggerHandler(b)},e+m.failSafeDelay),C.verbose("Adding fail safe timer",C.timer)}},remove:{animating:function(){w.removeClass(h.animating)},animationCallbacks:function(){C.remove.queueCallback(),C.remove.completeCallback()},queueCallback:function(){w.off(".queue"+x)},completeCallback:function(){w.off(".complete"+x)},display:function(){w.css("display","")},direction:function(){w.removeClass(h.inward).removeClass(h.outward)},duration:function(){w.css("animation-duration","")},failSafe:function(){C.verbose("Removing fail safe timer",C.timer),C.timer&&clearTimeout(C.timer)},hidden:function(){w.removeClass(h.hidden)},visible:function(){w.removeClass(h.visible)},looping:function(){C.debug("Transitions are no longer looping"),C.is.looping()&&(C.reset(),w.removeClass(h.looping))},transition:function(){w.removeClass(h.visible).removeClass(h.hidden)}},get:{settings:function(t,n,i){return"object"==typeof t?e.extend(!0,{},e.fn.transition.settings,t):"function"==typeof i?e.extend({},e.fn.transition.settings,{animation:t,onComplete:i,duration:n}):"string"==typeof n||"number"==typeof n?e.extend({},e.fn.transition.settings,{animation:t,duration:n}):"object"==typeof n?e.extend({},e.fn.transition.settings,n,{animation:t}):"function"==typeof n?e.extend({},e.fn.transition.settings,{animation:t,onComplete:n}):e.extend({},e.fn.transition.settings,{animation:t})},animationClass:function(e){var t=e||m.animation,n=C.can.transition()&&!C.has.direction()?C.get.direction()+" ":"";return h.animating+" "+h.transition+" "+n+t},currentAnimation:function(){return!(!C.cache||C.cache.animation===i)&&C.cache.animation},currentDirection:function(){return C.is.inward()?h.inward:h.outward},direction:function(){return C.is.hidden()||!C.is.visible()?h.inward:h.outward},animationDirection:function(t){var n;return"string"==typeof(t=t||m.animation)&&(t=t.split(" "),e.each(t,function(e,t){t===h.inward?n=h.inward:t===h.outward&&(n=h.outward)})),n||!1},duration:function(e){return!1===(e=e||m.duration)&&(e=w.css("animation-duration")||0),"string"==typeof e?e.indexOf("ms")>-1?parseFloat(e):1e3*parseFloat(e):e},displayType:function(e){return e=e===i||e,m.displayType?m.displayType:(e&&w.data(v.displayType)===i&&C.can.transition(!0),w.data(v.displayType))},userStyle:function(e){return(e=e||w.attr("style")||"").replace(/display.*?;/,"")},transitionExists:function(t){return e.fn.transition.exists[t]},animationStartEvent:function(){var e,t=n.createElement("div"),o={animation:"animationstart",OAnimation:"oAnimationStart",MozAnimation:"mozAnimationStart",WebkitAnimation:"webkitAnimationStart"};for(e in o)if(t.style[e]!==i)return o[e];return!1},animationEndEvent:function(){var e,t=n.createElement("div"),o={animation:"animationend",OAnimation:"oAnimationEnd",MozAnimation:"mozAnimationEnd",WebkitAnimation:"webkitAnimationEnd"};for(e in o)if(t.style[e]!==i)return o[e];return!1}},can:{transition:function(t){var n,o,a,r,s,l,c=m.animation,u=C.get.transitionExists(c),d=C.get.displayType(!1);if(u===i||t){if(C.verbose("Determining whether animation exists"),n=w.attr("class"),o=w.prop("tagName"),r=(a=e("<"+o+" />").addClass(n).insertAfter(w)).addClass(c).removeClass(h.inward).removeClass(h.outward).addClass(h.animating).addClass(h.transition).css("animationName"),s=a.addClass(h.inward).css("animationName"),d||(d=a.attr("class",n).removeAttr("style").removeClass(h.hidden).removeClass(h.visible).show().css("display"),C.verbose("Determining final display state",d),C.save.displayType(d)),a.remove(),r!=s)C.debug("Direction exists for animation",c),l=!0;else{if("none"==r||!r)return void C.debug("No animation defined in css",c);C.debug("Static animation found",c,d),l=!1}C.save.transitionExists(c,l)}return u!==i?u:l},animate:function(){return C.can.transition()!==i}},is:{animating:function(){return w.hasClass(h.animating)},inward:function(){return w.hasClass(h.inward)},outward:function(){return w.hasClass(h.outward)},looping:function(){return w.hasClass(h.looping)},occurring:function(e){return e="."+(e=e||m.animation).replace(" ","."),w.filter(e).length>0},visible:function(){return w.is(":visible")},hidden:function(){return"hidden"===w.css("visibility")},supported:function(){return!1!==b}},hide:function(){C.verbose("Hiding element"),C.is.animating()&&C.reset(),S.blur(),C.remove.display(),C.remove.visible(),C.set.hidden(),C.force.hidden(),m.onHide.call(S),m.onComplete.call(S)},show:function(e){C.verbose("Showing element",e),C.remove.hidden(),C.set.visible(),C.force.visible(),m.onShow.call(S),m.onComplete.call(S)},toggle:function(){C.is.visible()?C.hide():C.show()},stop:function(){C.debug("Stopping current animation"),w.triggerHandler(b)},stopAll:function(){C.debug("Stopping all animation"),C.remove.queueCallback(),w.triggerHandler(b)},clear:{queue:function(){C.debug("Clearing animation queue"),C.remove.queueCallback()}},enable:function(){C.verbose("Starting animation"),w.removeClass(h.disabled)},disable:function(){C.debug("Stopping animation"),w.addClass(h.disabled)},setting:function(t,n){if(C.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,C,t);else{if(n===i)return C[t];C[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?C.performance.log(arguments):(C.debug=Function.prototype.bind.call(console.info,console,m.name+":"),C.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?C.performance.log(arguments):(C.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),C.verbose.apply(console,arguments)))},error:function(){m.silent||(C.error=Function.prototype.bind.call(console.error,console,m.name+":"),C.error.apply(console,arguments))},performance:{log:function(e){var t,n;m.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:S,"Execution Time":n})),clearTimeout(C.performance.timer),C.performance.timer=setTimeout(C.performance.display,500)},display:function(){var t=m.name+":",n=0;s=!1,clearTimeout(C.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=g;return n=n||d,a=S||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i&&(s=c[o],!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s!==i&&s}}).initialize()}),o!==i?o:this},e.fn.transition.exists={},e.fn.transition.settings={name:"Transition",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"transition",interval:0,reverse:"auto",onStart:function(){},onComplete:function(){},onShow:function(){},onHide:function(){},useFailSafe:!0,failSafeDelay:100,allowRepeats:!1,displayType:!1,animation:"fade",duration:!1,queue:!0,metadata:{displayType:"display"},className:{animating:"animating",disabled:"disabled",hidden:"hidden",inward:"in",loading:"loading",looping:"looping",outward:"out",transition:"transition",visible:"visible"},error:{noAnimation:"Element is no longer attached to DOM. Unable to animate.  Use silent setting to surpress this warning in production.",repeated:"That animation is already occurring, cancelling repeated animation",method:"The method you called is not defined",support:"This browser does not support CSS animations"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();e.api=e.fn.api=function(n){var o,a=e.isFunction(this)?e(t):e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f,m,g,p,h,v=e.isPlainObject(n)?e.extend(!0,{},e.fn.api.settings,n):e.extend({},e.fn.api.settings),b=v.namespace,y=v.metadata,x=v.selector,C=v.error,w=v.className,S="."+b,k="module-"+b,T=e(this),A=T.closest(x.form),R=v.stateContext?e(v.stateContext):T,P=this,E=R[0],F=T.data(k);h={initialize:function(){u||h.bind.events(),h.instantiate()},instantiate:function(){h.verbose("Storing instance of module",h),F=h,T.data(k,F)},destroy:function(){h.verbose("Destroying previous module for",P),T.removeData(k).off(S)},bind:{events:function(){var e=h.get.event();e?(h.verbose("Attaching API events to element",e),T.on(e+S,h.event.trigger)):"now"==v.on&&(h.debug("Querying API endpoint immediately"),h.query())}},decode:{json:function(e){if(e!==i&&"string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}},read:{cachedResponse:function(e){var n;if(t.Storage!==i)return n=sessionStorage.getItem(e),h.debug("Using cached response",e,n),n=h.decode.json(n);h.error(C.noStorage)}},write:{cachedResponse:function(n,o){o&&""===o?h.debug("Response empty, not caching",o):t.Storage!==i?(e.isPlainObject(o)&&(o=JSON.stringify(o)),sessionStorage.setItem(n,o),h.verbose("Storing cached response for url",n,o)):h.error(C.noStorage)}},query:function(){if(h.is.disabled())h.debug("Element is disabled API request aborted");else{if(h.is.loading()){if(!v.interruptRequests)return void h.debug("Cancelling request, previous request is still pending");h.debug("Interrupting previous request"),h.abort()}if(v.defaultData&&e.extend(!0,v.urlData,h.get.defaultData()),v.serializeForm&&(v.data=h.add.formData(v.data)),!1===(f=h.get.settings()))return h.cancelled=!0,void h.error(C.beforeSend);if(h.cancelled=!1,(m=h.get.templatedURL())||h.is.mocked()){if((m=h.add.urlData(m))||h.is.mocked()){if(f.url=v.base+m,a=e.extend(!0,{},v,{type:v.method||v.type,data:g,url:v.base+m,beforeSend:v.beforeXHR,success:function(){},failure:function(){},complete:function(){}}),h.debug("Querying URL",a.url),h.verbose("Using AJAX settings",a),"local"===v.cache&&h.read.cachedResponse(m))return h.debug("Response returned from local cache"),h.request=h.create.request(),void h.request.resolveWith(E,[h.read.cachedResponse(m)]);v.throttle?v.throttleFirstRequest||h.timer?(h.debug("Throttling request",v.throttle),clearTimeout(h.timer),h.timer=setTimeout(function(){h.timer&&delete h.timer,h.debug("Sending throttled request",g,a.method),h.send.request()},v.throttle)):(h.debug("Sending request",g,a.method),h.send.request(),h.timer=setTimeout(function(){},v.throttle)):(h.debug("Sending request",g,a.method),h.send.request())}}else h.error(C.missingURL)}},should:{removeError:function(){return!0===v.hideError||"auto"===v.hideError&&!h.is.form()}},is:{disabled:function(){return T.filter(x.disabled).length>0},expectingJSON:function(){return"json"===v.dataType||"jsonp"===v.dataType},form:function(){return T.is("form")||R.is("form")},mocked:function(){return v.mockResponse||v.mockResponseAsync||v.response||v.responseAsync},input:function(){return T.is("input")},loading:function(){return!!h.request&&"pending"==h.request.state()},abortedRequest:function(e){return e&&e.readyState!==i&&0===e.readyState?(h.verbose("XHR request determined to be aborted"),!0):(h.verbose("XHR request was not aborted"),!1)},validResponse:function(t){return h.is.expectingJSON()&&e.isFunction(v.successTest)?(h.debug("Checking JSON returned success",v.successTest,t),v.successTest(t)?(h.debug("Response passed success test",t),!0):(h.debug("Response failed success test",t),!1)):(h.verbose("Response is not JSON, skipping validation",v.successTest,t),!0)}},was:{cancelled:function(){return h.cancelled||!1},succesful:function(){return h.request&&"resolved"==h.request.state()},failure:function(){return h.request&&"rejected"==h.request.state()},complete:function(){return h.request&&("resolved"==h.request.state()||"rejected"==h.request.state())}},add:{urlData:function(t,n){var o,a;return t&&(o=t.match(v.regExp.required),a=t.match(v.regExp.optional),n=n||v.urlData,o&&(h.debug("Looking for required URL variables",o),e.each(o,function(o,a){var r=-1!==a.indexOf("$")?a.substr(2,a.length-3):a.substr(1,a.length-2),s=e.isPlainObject(n)&&n[r]!==i?n[r]:T.data(r)!==i?T.data(r):R.data(r)!==i?R.data(r):n[r];if(s===i)return h.error(C.requiredParameter,r,t),t=!1,!1;h.verbose("Found required variable",r,s),s=v.encodeParameters?h.get.urlEncodedValue(s):s,t=t.replace(a,s)})),a&&(h.debug("Looking for optional URL variables",o),e.each(a,function(o,a){var r=-1!==a.indexOf("$")?a.substr(3,a.length-4):a.substr(2,a.length-3),s=e.isPlainObject(n)&&n[r]!==i?n[r]:T.data(r)!==i?T.data(r):R.data(r)!==i?R.data(r):n[r];s!==i?(h.verbose("Optional variable Found",r,s),t=t.replace(a,s)):(h.verbose("Optional variable not found",r),t=-1!==t.indexOf("/"+a)?t.replace("/"+a,""):t.replace(a,""))}))),t},formData:function(t){var n=e.fn.serializeObject!==i,o=n?A.serializeObject():A.serialize();return t=t||v.data,e.isPlainObject(t)?n?(h.debug("Extending existing data with form data",t,o),t=e.extend(!0,{},t,o)):(h.error(C.missingSerialize),h.debug("Cant extend data. Replacing data with form data",t,o),t=o):(h.debug("Adding form data",o),t=o),t}},send:{request:function(){h.set.loading(),h.request=h.create.request(),h.is.mocked()?h.mockedXHR=h.create.mockedXHR():h.xhr=h.create.xhr(),v.onRequest.call(E,h.request,h.xhr)}},event:{trigger:function(e){h.query(),"submit"!=e.type&&"click"!=e.type||e.preventDefault()},xhr:{always:function(){},done:function(t,n,i){var o=this,a=(new Date).getTime()-p,r=v.loadingDuration-a,s=!!e.isFunction(v.onResponse)&&(h.is.expectingJSON()?v.onResponse.call(o,e.extend(!0,{},t)):v.onResponse.call(o,t));r=r>0?r:0,s&&(h.debug("Modified API response in onResponse callback",v.onResponse,s,t),t=s),r>0&&h.debug("Response completed early delaying state change by",r),setTimeout(function(){h.is.validResponse(t)?h.request.resolveWith(o,[t,i]):h.request.rejectWith(o,[i,"invalid"])},r)},fail:function(e,t,n){var i=this,o=(new Date).getTime()-p,a=v.loadingDuration-o;(a=a>0?a:0)>0&&h.debug("Response completed early delaying state change by",a),setTimeout(function(){h.is.abortedRequest(e)?h.request.rejectWith(i,[e,"aborted",n]):h.request.rejectWith(i,[e,"error",t,n])},a)}},request:{done:function(e,t){h.debug("Successful API Response",e),"local"===v.cache&&m&&(h.write.cachedResponse(m,e),h.debug("Saving server response locally",h.cache)),v.onSuccess.call(E,e,T,t)},complete:function(e,t){var n,i;h.was.succesful()?(i=e,n=t):(n=e,i=h.get.responseFromXHR(n)),h.remove.loading(),v.onComplete.call(E,i,T,n)},fail:function(e,t,n){var o=h.get.responseFromXHR(e),r=h.get.errorFromRequest(o,t,n);if("aborted"==t)return h.debug("XHR Aborted (Most likely caused by page navigation or CORS Policy)",t,n),v.onAbort.call(E,t,T,e),!0;"invalid"==t?h.debug("JSON did not pass success test. A server-side error has most likely occurred",o):"error"==t&&e!==i&&(h.debug("XHR produced a server error",t,n),200!=e.status&&n!==i&&""!==n&&h.error(C.statusMessage+n,a.url),v.onError.call(E,r,T,e)),v.errorDuration&&"aborted"!==t&&(h.debug("Adding error state"),h.set.error(),h.should.removeError()&&setTimeout(h.remove.error,v.errorDuration)),h.debug("API Request failed",r,e),v.onFailure.call(E,o,T,e)}}},create:{request:function(){return e.Deferred().always(h.event.request.complete).done(h.event.request.done).fail(h.event.request.fail)},mockedXHR:function(){var t,n,i,o=v.mockResponse||v.response,a=v.mockResponseAsync||v.responseAsync;return i=e.Deferred().always(h.event.xhr.complete).done(h.event.xhr.done).fail(h.event.xhr.fail),o?(e.isFunction(o)?(h.debug("Using specified synchronous callback",o),n=o.call(E,f)):(h.debug("Using settings specified response",o),n=o),i.resolveWith(E,[n,!1,{responseText:n}])):e.isFunction(a)&&(t=function(e){h.debug("Async callback returned response",e),e?i.resolveWith(E,[e,!1,{responseText:e}]):i.rejectWith(E,[{responseText:e},!1,!1])},h.debug("Using specified async response callback",a),a.call(E,f,t)),i},xhr:function(){var t;return t=e.ajax(a).always(h.event.xhr.always).done(h.event.xhr.done).fail(h.event.xhr.fail),h.verbose("Created server request",t,a),t}},set:{error:function(){h.verbose("Adding error state to element",R),R.addClass(w.error)},loading:function(){h.verbose("Adding loading state to element",R),R.addClass(w.loading),p=(new Date).getTime()}},remove:{error:function(){h.verbose("Removing error state from element",R),R.removeClass(w.error)},loading:function(){h.verbose("Removing loading state from element",R),R.removeClass(w.loading)}},get:{responseFromXHR:function(t){return!!e.isPlainObject(t)&&(h.is.expectingJSON()?h.decode.json(t.responseText):t.responseText)},errorFromRequest:function(t,n,o){return e.isPlainObject(t)&&t.error!==i?t.error:v.error[n]!==i?v.error[n]:o},request:function(){return h.request||!1},xhr:function(){return h.xhr||!1},settings:function(){var t;return(t=v.beforeSend.call(E,v))&&(t.success!==i&&(h.debug("Legacy success callback detected",t),h.error(C.legacyParameters,t.success),t.onSuccess=t.success),t.failure!==i&&(h.debug("Legacy failure callback detected",t),h.error(C.legacyParameters,t.failure),t.onFailure=t.failure),t.complete!==i&&(h.debug("Legacy complete callback detected",t),h.error(C.legacyParameters,t.complete),t.onComplete=t.complete)),t===i&&h.error(C.noReturnedValue),!1===t?t:t!==i?e.extend(!0,{},t):e.extend(!0,{},v)},urlEncodedValue:function(e){var n=t.decodeURIComponent(e),i=t.encodeURIComponent(e);return n!==e?(h.debug("URL value is already encoded, avoiding double encoding",e),e):(h.verbose("Encoding value using encodeURIComponent",e,i),i)},defaultData:function(){var t={};return e.isWindow(P)||(h.is.input()?t.value=T.val():h.is.form()||(t.text=T.text())),t},event:function(){return e.isWindow(P)||"now"==v.on?(h.debug("API called without element, no events attached"),!1):"auto"==v.on?T.is("input")?P.oninput!==i?"input":P.onpropertychange!==i?"propertychange":"keyup":T.is("form")?"submit":"click":v.on},templatedURL:function(e){if(e=e||T.data(y.action)||v.action||!1,m=T.data(y.url)||v.url||!1)return h.debug("Using specified url",m),m;if(e){if(h.debug("Looking up url for action",e,v.api),v.api[e]===i&&!h.is.mocked())return void h.error(C.missingAction,v.action,v.api);m=v.api[e]}else h.is.form()&&(m=T.attr("action")||R.attr("action")||!1,h.debug("No url or action specified, defaulting to form action",m));return m}},abort:function(){var e=h.get.xhr();e&&"resolved"!==e.state()&&(h.debug("Cancelling API request"),e.abort())},reset:function(){h.remove.error(),h.remove.loading()},setting:function(t,n){if(h.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];e.isPlainObject(v[t])?e.extend(!0,v[t],n):v[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];h[t]=n}},debug:function(){!v.silent&&v.debug&&(v.performance?h.performance.log(arguments):(h.debug=Function.prototype.bind.call(console.info,console,v.name+":"),h.debug.apply(console,arguments)))},verbose:function(){!v.silent&&v.verbose&&v.debug&&(v.performance?h.performance.log(arguments):(h.verbose=Function.prototype.bind.call(console.info,console,v.name+":"),h.verbose.apply(console,arguments)))},error:function(){v.silent||(h.error=Function.prototype.bind.call(console.error,console,v.name+":"),h.error.apply(console,arguments))},performance:{log:function(e){var t,n;v.performance&&(n=(t=(new Date).getTime())-(s||t),s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"","Execution Time":n})),clearTimeout(h.performance.timer),h.performance.timer=setTimeout(h.performance.display,500)},display:function(){var t=v.name+":",n=0;s=!1,clearTimeout(h.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=F;return n=n||d,a=P||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(h.error(C.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},u?(F===i&&h.initialize(),h.invoke(c)):(F!==i&&F.invoke("destroy"),h.initialize())}),o!==i?o:this},e.api.settings={name:"API",namespace:"api",debug:!1,verbose:!1,performance:!0,api:{},cache:!0,interruptRequests:!0,on:"auto",stateContext:!1,loadingDuration:0,hideError:"auto",errorDuration:2e3,encodeParameters:!0,action:!1,url:!1,base:"",urlData:{},defaultData:!0,serializeForm:!1,throttle:0,throttleFirstRequest:!0,method:"get",data:{},dataType:"json",mockResponse:!1,mockResponseAsync:!1,response:!1,responseAsync:!1,beforeSend:function(e){return e},beforeXHR:function(e){},onRequest:function(e,t){},onResponse:!1,onSuccess:function(e,t){},onComplete:function(e,t){},onFailure:function(e,t){},onError:function(e,t){},onAbort:function(e,t){},successTest:!1,error:{beforeSend:"The before send function has aborted the request",error:"There was an error with your request",exitConditions:"API Request Aborted. Exit conditions met",JSONParse:"JSON could not be parsed during error handling",legacyParameters:"You are using legacy API success callback names",method:"The method you called is not defined",missingAction:"API action used but no url was defined",missingSerialize:"jquery-serialize-object is required to add form data to an existing data object",missingURL:"No URL specified for api event",noReturnedValue:"The beforeSend callback must return a settings object, beforeSend ignored.",noStorage:"Caching responses locally requires session storage",parseError:"There was an error parsing your request",requiredParameter:"Missing a required URL parameter: ",statusMessage:"Server gave an error: ",timeout:"Your request timed out"},regExp:{required:/\{\$*[A-z0-9]+\}/g,optional:/\{\/\$*[A-z0-9]+\}/g},className:{loading:"loading",error:"error"},selector:{disabled:".disabled",form:"form"},metadata:{action:"action",url:"url"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t=void 0!==t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.visibility=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1),m=r.length,g=0;return r.each(function(){var r,p,h,v,b=e.isPlainObject(o)?e.extend(!0,{},e.fn.visibility.settings,o):e.extend({},e.fn.visibility.settings),y=b.className,x=b.namespace,C=b.error,w=b.metadata,S="."+x,k="module-"+x,T=e(t),A=e(this),R=e(b.context),P=(A.selector,A.data(k)),E=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)},F=this,O=!1;v={initialize:function(){v.debug("Initializing",b),v.setup.cache(),v.should.trackChanges()&&("image"==b.type&&v.setup.image(),"fixed"==b.type&&v.setup.fixed(),b.observeChanges&&v.observeChanges(),v.bind.events()),v.save.position(),v.is.visible()||v.error(C.visible,A),b.initialCheck&&v.checkVisibility(),v.instantiate()},instantiate:function(){v.debug("Storing instance",v),A.data(k,v),P=v},destroy:function(){v.verbose("Destroying previous module"),h&&h.disconnect(),p&&p.disconnect(),T.off("load"+S,v.event.load).off("resize"+S,v.event.resize),R.off("scroll"+S,v.event.scroll).off("scrollchange"+S,v.event.scrollchange),"fixed"==b.type&&(v.resetFixed(),v.remove.placeholder()),A.off(S).removeData(k)},observeChanges:function(){"MutationObserver"in t&&(p=new MutationObserver(v.event.contextChanged),h=new MutationObserver(v.event.changed),p.observe(n,{childList:!0,subtree:!0}),h.observe(F,{childList:!0,subtree:!0}),v.debug("Setting up mutation observer",h))},bind:{events:function(){v.verbose("Binding visibility events to scroll and resize"),b.refreshOnLoad&&T.on("load"+S,v.event.load),T.on("resize"+S,v.event.resize),R.off("scroll"+S).on("scroll"+S,v.event.scroll).on("scrollchange"+S,v.event.scrollchange)}},event:{changed:function(e){v.verbose("DOM tree modified, updating visibility calculations"),v.timer=setTimeout(function(){v.verbose("DOM tree modified, updating sticky menu"),v.refresh()},100)},contextChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==F||e(t).find(F).length>0)&&(v.debug("Element removed from DOM, tearing down events"),v.destroy())})})},resize:function(){v.debug("Window resized"),b.refreshOnResize&&E(v.refresh)},load:function(){v.debug("Page finished loading"),E(v.refresh)},scroll:function(){b.throttle?(clearTimeout(v.timer),v.timer=setTimeout(function(){R.triggerHandler("scrollchange"+S,[R.scrollTop()])},b.throttle)):E(function(){R.triggerHandler("scrollchange"+S,[R.scrollTop()])})},scrollchange:function(e,t){v.checkVisibility(t)}},precache:function(t,i){t instanceof Array||(t=[t]);for(var o=t.length,a=0,r=[],s=n.createElement("img"),l=function(){++a>=t.length&&e.isFunction(i)&&i()};o--;)(s=n.createElement("img")).onload=l,s.onerror=l,s.src=t[o],r.push(s)},enableCallbacks:function(){v.debug("Allowing callbacks to occur"),O=!1},disableCallbacks:function(){v.debug("Disabling all callbacks temporarily"),O=!0},should:{trackChanges:function(){return d?(v.debug("One time query, no need to bind events"),!1):(v.debug("Callbacks being attached"),!0)}},setup:{cache:function(){v.cache={occurred:{},screen:{},element:{}}},image:function(){var e=A.data(w.src);e&&(v.verbose("Lazy loading image",e),b.once=!0,b.observeChanges=!1,b.onOnScreen=function(){v.debug("Image on screen",F),v.precache(e,function(){v.set.image(e,function(){++g==m&&b.onAllLoaded.call(this),b.onLoad.call(this)})})})},fixed:function(){v.debug("Setting up fixed"),b.once=!1,b.observeChanges=!1,b.initialCheck=!0,b.refreshOnLoad=!0,o.transition||(b.transition=!1),v.create.placeholder(),v.debug("Added placeholder",r),b.onTopPassed=function(){v.debug("Element passed, adding fixed position",A),v.show.placeholder(),v.set.fixed(),b.transition&&e.fn.transition!==i&&A.transition(b.transition,b.duration)},b.onTopPassedReverse=function(){v.debug("Element returned to position, removing fixed",A),v.hide.placeholder(),v.remove.fixed()}}},create:{placeholder:function(){v.verbose("Creating fixed position placeholder"),r=A.clone(!1).css("display","none").addClass(y.placeholder).insertAfter(A)}},show:{placeholder:function(){v.verbose("Showing placeholder"),r.css("display","block").css("visibility","hidden")}},hide:{placeholder:function(){v.verbose("Hiding placeholder"),r.css("display","none").css("visibility","")}},set:{fixed:function(){v.verbose("Setting element to fixed position"),A.addClass(y.fixed).css({position:"fixed",top:b.offset+"px",left:"auto",zIndex:b.zIndex}),b.onFixed.call(F)},image:function(t,n){if(A.attr("src",t),b.transition)if(e.fn.transition!==i){if(A.hasClass(y.visible))return void v.debug("Transition already occurred on this image, skipping animation");A.transition(b.transition,b.duration,n)}else A.fadeIn(b.duration,n);else A.show()}},is:{onScreen:function(){return v.get.elementCalculations().onScreen},offScreen:function(){return v.get.elementCalculations().offScreen},visible:function(){return!(!v.cache||!v.cache.element)&&!(0===v.cache.element.width&&0===v.cache.element.offset.top)},verticallyScrollableContext:function(){var e=R.get(0)!==t&&R.css("overflow-y");return"auto"==e||"scroll"==e},horizontallyScrollableContext:function(){var e=R.get(0)!==t&&R.css("overflow-x");return"auto"==e||"scroll"==e}},refresh:function(){v.debug("Refreshing constants (width/height)"),"fixed"==b.type&&v.resetFixed(),v.reset(),v.save.position(),b.checkOnRefresh&&v.checkVisibility(),b.onRefresh.call(F)},resetFixed:function(){v.remove.fixed(),v.remove.occurred()},reset:function(){v.verbose("Resetting all cached values"),e.isPlainObject(v.cache)&&(v.cache.screen={},v.cache.element={})},checkVisibility:function(e){v.verbose("Checking visibility of element",v.cache.element),!O&&v.is.visible()&&(v.save.scroll(e),v.save.calculations(),v.passed(),v.passingReverse(),v.topVisibleReverse(),v.bottomVisibleReverse(),v.topPassedReverse(),v.bottomPassedReverse(),v.onScreen(),v.offScreen(),v.passing(),v.topVisible(),v.bottomVisible(),v.topPassed(),v.bottomPassed(),b.onUpdate&&b.onUpdate.call(F,v.get.elementCalculations()))},passed:function(t,n){var o=v.get.elementCalculations();if(t&&n)b.onPassed[t]=n;else{if(t!==i)return v.get.pixelsPassed(t)>o.pixelsPassed;o.passing&&e.each(b.onPassed,function(e,t){o.bottomVisible||o.pixelsPassed>v.get.pixelsPassed(e)?v.execute(t,e):b.once||v.remove.occurred(t)})}},onScreen:function(e){var t=v.get.elementCalculations(),n=e||b.onOnScreen,o="onScreen";if(e&&(v.debug("Adding callback for onScreen",e),b.onOnScreen=e),t.onScreen?v.execute(n,o):b.once||v.remove.occurred(o),e!==i)return t.onOnScreen},offScreen:function(e){var t=v.get.elementCalculations(),n=e||b.onOffScreen,o="offScreen";if(e&&(v.debug("Adding callback for offScreen",e),b.onOffScreen=e),t.offScreen?v.execute(n,o):b.once||v.remove.occurred(o),e!==i)return t.onOffScreen},passing:function(e){var t=v.get.elementCalculations(),n=e||b.onPassing,o="passing";if(e&&(v.debug("Adding callback for passing",e),b.onPassing=e),t.passing?v.execute(n,o):b.once||v.remove.occurred(o),e!==i)return t.passing},topVisible:function(e){var t=v.get.elementCalculations(),n=e||b.onTopVisible,o="topVisible";if(e&&(v.debug("Adding callback for top visible",e),b.onTopVisible=e),t.topVisible?v.execute(n,o):b.once||v.remove.occurred(o),e===i)return t.topVisible},bottomVisible:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomVisible,o="bottomVisible";if(e&&(v.debug("Adding callback for bottom visible",e),b.onBottomVisible=e),t.bottomVisible?v.execute(n,o):b.once||v.remove.occurred(o),e===i)return t.bottomVisible},topPassed:function(e){var t=v.get.elementCalculations(),n=e||b.onTopPassed,o="topPassed";if(e&&(v.debug("Adding callback for top passed",e),b.onTopPassed=e),t.topPassed?v.execute(n,o):b.once||v.remove.occurred(o),e===i)return t.topPassed},bottomPassed:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomPassed,o="bottomPassed";if(e&&(v.debug("Adding callback for bottom passed",e),b.onBottomPassed=e),t.bottomPassed?v.execute(n,o):b.once||v.remove.occurred(o),e===i)return t.bottomPassed},passingReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onPassingReverse,o="passingReverse";if(e&&(v.debug("Adding callback for passing reverse",e),b.onPassingReverse=e),t.passing?b.once||v.remove.occurred(o):v.get.occurred("passing")&&v.execute(n,o),e!==i)return!t.passing},topVisibleReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onTopVisibleReverse,o="topVisibleReverse";if(e&&(v.debug("Adding callback for top visible reverse",e),b.onTopVisibleReverse=e),t.topVisible?b.once||v.remove.occurred(o):v.get.occurred("topVisible")&&v.execute(n,o),e===i)return!t.topVisible},bottomVisibleReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomVisibleReverse,o="bottomVisibleReverse";if(e&&(v.debug("Adding callback for bottom visible reverse",e),b.onBottomVisibleReverse=e),t.bottomVisible?b.once||v.remove.occurred(o):v.get.occurred("bottomVisible")&&v.execute(n,o),e===i)return!t.bottomVisible},topPassedReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onTopPassedReverse,o="topPassedReverse";if(e&&(v.debug("Adding callback for top passed reverse",e),b.onTopPassedReverse=e),t.topPassed?b.once||v.remove.occurred(o):v.get.occurred("topPassed")&&v.execute(n,o),e===i)return!t.onTopPassed},bottomPassedReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomPassedReverse,o="bottomPassedReverse";if(e&&(v.debug("Adding callback for bottom passed reverse",e),b.onBottomPassedReverse=e),t.bottomPassed?b.once||v.remove.occurred(o):v.get.occurred("bottomPassed")&&v.execute(n,o),e===i)return!t.bottomPassed},execute:function(e,t){var n=v.get.elementCalculations(),i=v.get.screenCalculations();(e=e||!1)&&(b.continuous?(v.debug("Callback being called continuously",t,n),e.call(F,n,i)):v.get.occurred(t)||(v.debug("Conditions met",t,n),e.call(F,n,i))),v.save.occurred(t)},remove:{fixed:function(){v.debug("Removing fixed position"),A.removeClass(y.fixed).css({position:"",top:"",left:"",zIndex:""}),b.onUnfixed.call(F)},placeholder:function(){v.debug("Removing placeholder content"),r&&r.remove()},occurred:function(e){if(e){var t=v.cache.occurred;t[e]!==i&&!0===t[e]&&(v.debug("Callback can now be called again",e),v.cache.occurred[e]=!1)}else v.cache.occurred={}}},save:{calculations:function(){v.verbose("Saving all calculations necessary to determine positioning"),v.save.direction(),v.save.screenCalculations(),v.save.elementCalculations()},occurred:function(e){e&&(v.cache.occurred[e]!==i&&!0===v.cache.occurred[e]||(v.verbose("Saving callback occurred",e),v.cache.occurred[e]=!0))},scroll:function(e){e=e+b.offset||R.scrollTop()+b.offset,v.cache.scroll=e},direction:function(){var e,t=v.get.scroll(),n=v.get.lastScroll();return e=t>n&&n?"down":t<n&&n?"up":"static",v.cache.direction=e,v.cache.direction},elementPosition:function(){var e=v.cache.element,t=v.get.screenSize();return v.verbose("Saving element position"),e.fits=e.height<t.height,e.offset=A.offset(),e.width=A.outerWidth(),e.height=A.outerHeight(),v.is.verticallyScrollableContext()&&(e.offset.top+=R.scrollTop()-R.offset().top),v.is.horizontallyScrollableContext()&&(e.offset.left+=R.scrollLeft-R.offset().left),v.cache.element=e,e},elementCalculations:function(){var e=v.get.screenCalculations(),t=v.get.elementPosition();return b.includeMargin?(t.margin={},t.margin.top=parseInt(A.css("margin-top"),10),t.margin.bottom=parseInt(A.css("margin-bottom"),10),t.top=t.offset.top-t.margin.top,t.bottom=t.offset.top+t.height+t.margin.bottom):(t.top=t.offset.top,t.bottom=t.offset.top+t.height),t.topPassed=e.top>=t.top,t.bottomPassed=e.top>=t.bottom,t.topVisible=e.bottom>=t.top&&!t.topPassed,t.bottomVisible=e.bottom>=t.bottom&&!t.bottomPassed,t.pixelsPassed=0,t.percentagePassed=0,t.onScreen=(t.topVisible||t.passing)&&!t.bottomPassed,t.passing=t.topPassed&&!t.bottomPassed,t.offScreen=!t.onScreen,t.passing&&(t.pixelsPassed=e.top-t.top,t.percentagePassed=(e.top-t.top)/t.height),v.cache.element=t,v.verbose("Updated element calculations",t),t},screenCalculations:function(){var e=v.get.scroll();return v.save.direction(),v.cache.screen.top=e,v.cache.screen.bottom=e+v.cache.screen.height,v.cache.screen},screenSize:function(){v.verbose("Saving window position"),v.cache.screen={height:R.height()}},position:function(){v.save.screenSize(),v.save.elementPosition()}},get:{pixelsPassed:function(e){var t=v.get.elementCalculations();return e.search("%")>-1?t.height*(parseInt(e,10)/100):parseInt(e,10)},occurred:function(e){return v.cache.occurred!==i&&v.cache.occurred[e]||!1},direction:function(){return v.cache.direction===i&&v.save.direction(),v.cache.direction},elementPosition:function(){return v.cache.element===i&&v.save.elementPosition(),v.cache.element},elementCalculations:function(){return v.cache.element===i&&v.save.elementCalculations(),v.cache.element},screenCalculations:function(){return v.cache.screen===i&&v.save.screenCalculations(),v.cache.screen},screenSize:function(){return v.cache.screen===i&&v.save.screenSize(),v.cache.screen},scroll:function(){return v.cache.scroll===i&&v.save.scroll(),v.cache.scroll},lastScroll:function(){return v.cache.screen===i?(v.debug("First scroll event, no last scroll could be found"),!1):v.cache.screen.top}},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,b,t);else{if(n===i)return b[t];b[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];v[t]=n}},debug:function(){!b.silent&&b.debug&&(b.performance?v.performance.log(arguments):(v.debug=Function.prototype.bind.call(console.info,console,b.name+":"),v.debug.apply(console,arguments)))},verbose:function(){!b.silent&&b.verbose&&b.debug&&(b.performance?v.performance.log(arguments):(v.verbose=Function.prototype.bind.call(console.info,console,b.name+":"),v.verbose.apply(console,arguments)))},error:function(){b.silent||(v.error=Function.prototype.bind.call(console.error,console,b.name+":"),v.error.apply(console,arguments))},performance:{log:function(e){var t,n;b.performance&&(n=(t=(new Date).getTime())-(l||t),l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:F,"Execution Time":n})),clearTimeout(v.performance.timer),v.performance.timer=setTimeout(v.performance.display,500)},display:function(){var t=b.name+":",n=0;l=!1,clearTimeout(v.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=P;return n=n||f,o=F||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(v.error(C.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(P===i&&v.initialize(),P.save.scroll(),P.save.calculations(),v.invoke(u)):(P!==i&&P.invoke("destroy"),v.initialize())}),a!==i?a:this},e.fn.visibility.settings={name:"Visibility",namespace:"visibility",debug:!1,verbose:!1,performance:!0,observeChanges:!0,initialCheck:!0,refreshOnLoad:!0,refreshOnResize:!0,checkOnRefresh:!0,once:!0,continuous:!1,offset:0,includeMargin:!1,context:t,throttle:!1,type:!1,zIndex:"10",transition:"fade in",duration:1e3,onPassed:{},onOnScreen:!1,onOffScreen:!1,onPassing:!1,onTopVisible:!1,onBottomVisible:!1,onTopPassed:!1,onBottomPassed:!1,onPassingReverse:!1,onTopVisibleReverse:!1,onBottomVisibleReverse:!1,onTopPassedReverse:!1,onBottomPassedReverse:!1,onLoad:function(){},onAllLoaded:function(){},onFixed:function(){},onUnfixed:function(){},onUpdate:!1,onRefresh:function(){},metadata:{src:"src"},className:{fixed:"fixed",placeholder:"placeholder",visible:"visible"},error:{method:"The method you called is not defined.",visible:"Element is hidden, you must call refresh after element becomes visible"}}}(jQuery,window,document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 313 */,
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AllAlertsPage_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AllAlertsPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AllAlertsPage_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AllAlertsPageWrapper',
  components: {
    AllAlertsPage: __WEBPACK_IMPORTED_MODULE_0__components_AllAlertsPage_vue___default.a
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      transitionName: 'sk-fade'
    };
  },
  mounted: function mounted() {
    var el = document.getElementById('preloadr');
    if (el) {
      el.style.transition = 'opacity 0.5s';
      el.style.opacity = '0';
      setTimeout(function () {
        el.style.display = 'none';
      }, 500);
    }
  },
  created: function created() {
    var _this = this;

    this.$router.beforeEach(function (to, from, next) {
      if (from.path === '/signup' || to.path === '/forgotpassword') _this.transitionName = 'sk-slide-left';else _this.transitionName = 'sk-slide-right';
      next();
    });
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BuyBoxDashboard_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BuyBoxDashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BuyBoxDashboard_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyBoxDashboardPage',
  components: {
    BuyBoxDashboard: __WEBPACK_IMPORTED_MODULE_0__components_BuyBoxDashboard_vue___default.a
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectRegionForm_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectRegionForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ConnectRegionForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_amazonAuthorizationStart__ = __webpack_require__(96);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConnectRegionForm: __WEBPACK_IMPORTED_MODULE_1__components_ConnectRegionForm_vue___default.a },
  data: function data() {
    return {
      loading: true,
      status: '',
      inviterName: '',
      accountLabel: '',
      working: false,
      error: ''
    };
  },
  computed: {
    token: function token() {
      return this.$route.params.token;
    }
  },
  methods: {
    loadInvite: function loadInvite() {
      var self = this;
      self.loading = true;
      self.$http.get('/api/v1/connect-invites/' + encodeURIComponent(self.token)).then(function (response) {
        var body = response.body || {};
        self.status = body.status || 'missing';
        self.inviterName = body.inviterName || 'They';
        self.accountLabel = body.accountLabel || 'their';
        self.loading = false;
      }, function (response) {
        self.loading = false;
        self.status = response.status === 410 ? 'expired' : 'missing';
      });
    },
    startConnect: function startConnect(params) {
      var self = this;
      if (self.working) return;
      self.working = true;
      self.error = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonAuthorizationStart__["a" /* startAmazonAuthorization */])(self.$http, {
        url: '/api/v1/connect-invites/' + encodeURIComponent(self.token) + '/authorization/redirect',
        params: params,
        method: 'invite',
        gtm: { source: 'invite', region: params.region, marketplaces: params.marketplaceCodes }
      }).then(function () {}, function (message) {
        self.working = false;
        self.error = message || 'Failed to start authorization';
      });
    }
  },
  created: function created() {
    this.loadInvite();
  },
  mounted: function mounted() {
    var el = document.getElementById('preloadr');
    if (el) {
      el.style.display = 'none';
    }
    var self = this;
    this.onPageShow = function (e) {
      if (e.persisted) self.working = false;
    };
    window.addEventListener('pageshow', this.onPageShow);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ConnectRegionForm_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ConnectRegionForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ConnectRegionForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_team_raghav_112_jpg__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_team_raghav_112_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_team_raghav_112_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_gtmEvents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_amazonAuthorizationStart__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_calendly__ = __webpack_require__(91);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConnectRegionForm: __WEBPACK_IMPORTED_MODULE_2__components_ConnectRegionForm_vue___default.a },
  data: function data() {
    return {
      currentStep: 4,
      selectedPlan: 'free',
      freeSubscriptionReady: false,
      loadingText: '',
      cardError: null,
      billingSetupWarning: null,
      connecting: false,
      copyingLink: false,
      linkNote: '',
      raghavPhoto: __WEBPACK_IMPORTED_MODULE_3__assets_team_raghav_112_jpg___default.a,
      ssoWelcome: false,
      welcomeCaptured: false,
      planConfig: {
        free: { priceId: "price_1TCOSOHB9QcQTKYj7cEXw6kl" }
      },
      connectViewTracked: false
    };
  },
  computed: {
    welcomeMode: function welcomeMode() {
      if (this.ssoWelcome) return 'sso';
      if (this.$route.query.from === 'signup') return 'signup';
      return null;
    },
    welcomeName: function welcomeName() {
      return this.$root.userFirstName || '';
    }
  },
  methods: {
    ensureFreeSubscriptionThenConnect: function ensureFreeSubscriptionThenConnect() {
      var self = this;
      self.selectedPlan = 'free';
      self.cardError = null;
      self.billingSetupWarning = null;
      self.loadingText = 'Setting up your account...';
      var priceId = self.planConfig.free.priceId;
      if (!priceId) {
        console.warn('[Connect] STRIPE_FREE_PLAN is not set; skipping subscription create (local dev).');
        self.loadingText = '';
        self.freeSubscriptionReady = true;
        self.currentStep = 4;
        self.$root.$emit('fb-pixel-event', 'standard', 'CompleteRegistration');
        return;
      }
      self.$http.post('/api/billing/subscription/create', { priceId: priceId }).then(function () {
        self.loadingText = '';
        self.billingSetupWarning = null;
        self.freeSubscriptionReady = true;
        self.currentStep = 4;
        self.$root.$emit('fb-pixel-event', 'standard', 'CompleteRegistration');
      }, function () {
        self.loadingText = '';
        self.freeSubscriptionReady = true;
        self.currentStep = 4;
        self.$root.$emit('fb-pixel-event', 'standard', 'CompleteRegistration');
      });
    },
    handleSetupReturn: function handleSetupReturn() {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('setup_complete') === 'true') {
        window.history.replaceState({}, document.title, '/connect');
        this.ensureFreeSubscriptionThenConnect();
      }
    },
    goToDashboard: function goToDashboard() {
      this.$router.push('/welcome');
      this.$root.$emit('fb-pixel-event', 'custom', 'LoggedInToApp');
    },
    captureWelcome: function captureWelcome() {
      if (this.welcomeCaptured) return;
      this.welcomeCaptured = true;
      if (this.$root.connectWelcome) {
        this.ssoWelcome = true;
        this.$root.connectWelcome = null;
      }
    },
    notYou: function notYou() {
      this.$root.signOutUser('/signup');
    },
    startConnect: function startConnect(params) {
      var self = this;
      if (self.connecting) return;
      self.connecting = true;
      self.cardError = null;
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ path: '/connect' }, params);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonAuthorizationStart__["a" /* startAmazonAuthorization */])(self.$http, {
        params: query,
        method: self.ssoWelcome ? 'google' : 'email',
        gtm: { region: params.region, marketplaces: params.marketplaceCodes }
      }).then(function () {}, function (message) {
        self.connecting = false;
        self.cardError = message || 'Failed to start authorization';
      });
    },
    copyTeammateLink: function copyTeammateLink() {
      var self = this;
      if (self.copyingLink) return;
      self.copyingLink = true;
      self.linkNote = '';
      self.$http.post('/api/v1/connect-invites').then(function (response) {
        var url = response.body && response.body.url;
        self.copyingLink = false;
        if (!url) {
          self.cardError = 'Could not create a link. Try again.';
          return;
        }
        var done = function done() {
          self.linkNote = 'Link copied.';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () {
            self.linkNote = url;
          });
        } else {
          self.linkNote = url;
        }
      }, function () {
        self.copyingLink = false;
        self.cardError = 'Could not create a link. Try again.';
      });
    },
    bookCall: function bookCall() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_calendly__["b" /* openCalendlyBooking */])({
        name: this.$root.userFullName || this.$root.userFirstName || '',
        email: this.$root.userEmail || ''
      }, 'connect');
    },
    openChat: function openChat() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_chat_click', source: 'connect' });
      if (typeof window.Intercom === 'function') window.Intercom('showNewMessage');
    },
    initState: function initState() {
      if (!this.$root.authCompleted) return;
      this.captureWelcome();
      if (this.$root.paymentStatus !== 1 && this.$root.anySellerAccountSetupCompleted) {
        var isRecentConnection = this.$root.secondsSinceFirstSellerAccountCreated != null && this.$root.secondsSinceFirstSellerAccountCreated < 9999;
        var target = isRecentConnection ? '/welcome' : this.$root.defaultPath || '/home';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_gtmEvents__["b" /* maybeFireConnectStoreSuccess */])();
        this.$router.push(target);
        return;
      }

      this.cardError = null;
      if (this.$root.paymentStatus === 2 || this.$root.paymentStatus === 0) {
        this.loadingText = '';
        this.freeSubscriptionReady = true;
        this.currentStep = 4;
        this.$root.$emit('fb-pixel-event', 'standard', 'CompleteRegistration');
      } else {
        this.freeSubscriptionReady = false;
        this.ensureFreeSubscriptionThenConnect();
      }
    }
  },
  watch: {
    '$root.authCompleted': function $rootAuthCompleted(val) {
      if (!val) return;
      this.initState();
    },
    currentStep: function currentStep() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    freeSubscriptionReady: function freeSubscriptionReady(val) {
      if (val && this.currentStep === 4 && !this.connectViewTracked) {
        this.connectViewTracked = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_store_view', step: 2, step_name: 'connect_amazon' });
      }
    }
  },
  created: function created() {
    this.initState();
  },
  mounted: function mounted() {
    var el = document.getElementById('preloadr');
    if (el) {
      el.style.transition = 'opacity 0.5s';
      el.style.opacity = '0';
      setTimeout(function () {
        el.style.display = 'none';
      }, 500);
    }
    this.handleSetupReturn();
    var self = this;
    this.onPageShow = function (e) {
      if (e.persisted) self.connecting = false;
    };
    window.addEventListener('pageshow', this.onPageShow);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_currency_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listViewUrlSync_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__ = __webpack_require__(49);









var API = '/api/v1/fee-claims';
var TABS = [{ key: 'to_claim', label: 'To claim' }, { key: 'fee_up', label: 'Fee went up' }, { key: 'filed', label: 'Filed' }, { key: 'done', label: 'Done' }];
var STATUS_LABELS = {
  to_claim: 'To claim',
  filed: 'Filed',
  refunded: 'Refunded',
  declined: 'Declined',
  to_check: 'To check',
  remeasure_requested: 'Asked Amazon to re-measure',
  corrected: 'Amazon corrected it',
  measurement_right: 'Measurement is right'
};
var MEASURE_LABELS = { size_tier: 'Size tier', dimensions: 'Dimensions', weight: 'Weight' };
var MP_SUFFIX = { US: 'com', CA: 'ca', MX: 'com.mx', UK: 'co.uk', GB: 'co.uk', DE: 'de', FR: 'fr', IT: 'it', ES: 'es', JP: 'co.jp', AU: 'com.au' };
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FeeClaimsPage',
  components: { DashboardLayout: __WEBPACK_IMPORTED_MODULE_2__components_buybox_DashboardLayout_vue___default.a },
  data: function data() {
    return {
      tabs: TABS,

      showKpis: false,
      filter: 'to_claim',
      sellerId: '',
      marketplace: '',
      claims: [],
      kpis: {},
      counts: {},
      sellerOptions: [],
      marketplaceOptions: [],
      loading: false,
      loadError: '',
      notAvailable: false,
      savingId: null,
      downloadingAll: false,
      downloadError: '',
      downloadingId: null,
      rowError: { id: null, message: '' },
      howOpen: false
    };
  },
  computed: {
    isFeeUp: function isFeeUp() {
      return this.filter === 'fee_up';
    }
  },
  mounted: function mounted() {
    var q = this.$route.query || {};
    if (TABS.some(function (t) {
      return t.key === q.filter;
    })) this.filter = q.filter;
    this.load();
  },
  methods: {
    params: function params() {
      var p = { filter: this.filter };
      if (this.sellerId) p.seller_ids = this.sellerId;
      if (this.marketplace) p.marketplaces = this.marketplace;
      return p;
    },
    load: function load() {
      var self = this;
      var gen = this._gen = (this._gen || 0) + 1;
      this.loading = true;
      this.loadError = '';
      return this.$http.get(API, { params: this.params() }).then(function (res) {
        if (gen !== self._gen) return;
        var body = res.body || {};
        self.claims = body.claims || [];
        self.kpis = body.kpis || {};
        self.counts = body.counts || {};
        var f = body.filters || {};
        self.sellerOptions = f.sellers || [];
        self.marketplaceOptions = f.marketplaces || [];
        self.$root.feeClaimsToClaimCount = body.toClaimCount != null ? body.toClaimCount : self.$root.feeClaimsToClaimCount;
        self.loading = false;
      }, function (res) {
        if (gen !== self._gen) return;
        self.loading = false;
        if (res && res.status === 404) {
          self.notAvailable = true;
        } else {
          self.loadError = "Couldn't load fee claims. Please try again.";
        }
      });
    },
    setFilter: function setFilter(key) {
      if (this.filter === key) return;
      this.filter = key;
      this.claims = [];
      this.$router.replace({ path: this.$route.path, query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { filter: key }) });
      this.load();
    },
    setStatus: function setStatus(claim, status) {
      var self = this;
      if (status === claim.status) return;
      this.savingId = claim.id;
      this.$http.patch(API + '/' + claim.id, { status: status }).then(function () {
        self.savingId = null;
        self.load();
        if (self.$root.loadFeeClaimsCount) self.$root.loadFeeClaimsCount(true);
      }, function (res) {
        self.savingId = null;
        var msg = res && res.body && res.body.message;
        window.alert(msg || "Couldn't update the status. Please try again.");
        self.load();
      });
    },
    downloadAll: function downloadAll() {
      var self = this;
      var p = this.params();
      delete p.filter;
      var qs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(p).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]);
      }).join('&');
      this.downloadingAll = true;
      this.downloadError = '';
      this.saveFile(API + '/download' + (qs ? '?' + qs : ''), 'SentryKit - FBA Fee Claims.xlsx', function (status) {
        self.downloadingAll = false;
        if (status !== 200) self.downloadError = status === 404 ? 'Nothing to claim right now.' : "Couldn't build the file. Please try again.";
      });
    },

    downloadOne: function downloadOne(claim) {
      var self = this;
      this.downloadingId = claim.id;
      this.rowError = { id: null, message: '' };
      this.saveFile(API + '/' + claim.id + '/download', 'SentryKit - FBA Fee Claim - ' + claim.sellerSku + '.xlsx', function (status) {
        self.downloadingId = null;
        if (status !== 200) {
          self.rowError = { id: claim.id, message: status === 404 ? "The order list isn't ready yet." : "Couldn't download the file. Please try again." };
        }
      });
    },

    saveFile: function saveFile(path, fallbackName, done) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', path, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        var isXlsx = (xhr.getResponseHeader('Content-Type') || '').indexOf('spreadsheetml') !== -1;
        if (xhr.status === 200 && !isXlsx) return done(0);
        if (xhr.status === 200) {
          var match = (xhr.getResponseHeader('Content-Disposition') || '').match(/filename="?([^";]+)"?/);
          var url = window.URL.createObjectURL(xhr.response);
          var link = document.createElement('a');
          link.href = url;
          link.download = match ? match[1] : fallbackName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(function () {
            window.URL.revokeObjectURL(url);
          }, 1000);
        }
        done(xhr.status);
      };
      xhr.onerror = function () {
        done(0);
      };
      xhr.send();
    },

    comparisonRows: function comparisonRows(claim) {
      if (claim.comparison && claim.comparison.length) return claim.comparison;
      return (claim.evidence || []).map(function (e) {
        var sides = String(e.text).split(' → ');
        return { measure: e.measure, before: sides.length > 1 ? sides[0] : null, after: sides.length > 1 ? sides.slice(1).join(' → ') : e.text };
      });
    },
    asinUrl: function asinUrl(claim) {
      return claim.asin ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["a" /* amazonListingUrl */])(claim.asin, claim.marketplace) : null;
    },
    viewProduct: function viewProduct(claim) {
      this.$router.push({ path: '/product_details', query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(String(claim.productId), this.$route.fullPath) });
    },
    isUp: function isUp(claim) {
      return claim.reason === 'remeasured_up';
    },
    statusLabel: function statusLabel(s) {
      return STATUS_LABELS[s] || s;
    },
    measureLabel: function measureLabel(m) {
      return MEASURE_LABELS[m] || m;
    },
    mpSuffix: function mpSuffix(m) {
      return MP_SUFFIX[m] || String(m).toLowerCase();
    },
    plural: function plural(n, word) {
      var v = n || 0;
      return v + ' ' + word + (v === 1 ? '' : 's');
    },

    kpiAmounts: function kpiAmounts(key) {
      var self = this;
      var list = this.kpis.byCurrency || [];
      if (list.length <= 1) {
        return [this.money(this.kpis[key], this.kpis.currency || list[0] && list[0].currency || 'USD')];
      }
      var shown = list.filter(function (c) {
        return c[key] > 0;
      });
      if (!shown.length) shown = [list[0]];
      return shown.map(function (c) {
        return self.money(c[key], c.currency);
      });
    },

    money: function money(cents, currency) {
      var amount = Math.abs((cents || 0) / 100).toFixed(2);
      var sign = cents < 0 ? '-' : '';
      return currency === null ? sign + amount : sign + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_currency_js__["b" /* getCurrencySymbol */])(currency || 'USD') + amount;
    },
    shortDate: function shortDate(iso) {
      if (!iso) return '';
      var parts = String(iso).split('-');
      if (parts.length < 3) return iso;
      return MONTHS[parseInt(parts[1], 10) - 1] + ' ' + parseInt(parts[2], 10);
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      response: null,
      working: false,
      sent: false
    };
  },
  methods: {
    sendPasswordResetEmail: function sendPasswordResetEmail() {
      var _this = this;

      if (!this.email) return;
      this.working = true;
      this.response = null;
      this.$http.post('/api/auth/sendpasswordresetemail', {
        email: this.email
      }).then(function (response) {
        _this.response = response.status;
        _this.working = false;
        _this.sent = true;
      }, function (response) {
        _this.response = response.status;
        _this.working = false;
        setTimeout(function () {
          _this.response = null;
        }, 4000);
      });
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Watchdog__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Watchdog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Watchdog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WatchdogMenu__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WatchdogMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_WatchdogMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ProductCard__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ProductCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ProductCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ProductList__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ProductList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ProductList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_InventoryList__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_InventoryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_InventoryList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ProductDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Dashboard__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NotificationReel__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NotificationReel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_NotificationReel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Footer__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LoadingSpinner__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LoadingSpinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_LoadingSpinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_HelpMenu__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_HelpMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_HelpMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_PartnerBanner__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_PartnerBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_PartnerBanner__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    Watchdog: __WEBPACK_IMPORTED_MODULE_8__components_Watchdog___default.a,
    WatchdogMenu: __WEBPACK_IMPORTED_MODULE_9__components_WatchdogMenu___default.a,
    Dashboard: __WEBPACK_IMPORTED_MODULE_14__components_Dashboard___default.a,
    HelpMenu: __WEBPACK_IMPORTED_MODULE_18__components_HelpMenu___default.a,
    NotificationReel: __WEBPACK_IMPORTED_MODULE_15__components_NotificationReel___default.a,
    ProductCard: __WEBPACK_IMPORTED_MODULE_10__components_ProductCard___default.a,
    ProductList: __WEBPACK_IMPORTED_MODULE_11__components_ProductList___default.a,
    InventoryList: __WEBPACK_IMPORTED_MODULE_12__components_InventoryList___default.a,
    ProductDetails: __WEBPACK_IMPORTED_MODULE_13__components_ProductDetails___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_16__components_Footer___default.a,
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_17__components_LoadingSpinner___default.a,
    PartnerBanner: __WEBPACK_IMPORTED_MODULE_19__components_PartnerBanner___default.a
  },
  data: function data() {
    var desktopNotifPerm = null;
    if ('Notification' in window) desktopNotifPerm = Notification.permission;
    var urlParams = new URLSearchParams(window.location.search);
    var viewParam = urlParams.get('view');
    var initialDetSel = 'pr';
    var shouldFoldDashboard = viewParam !== null;
    if (viewParam === 'products') {
      initialDetSel = 'pr';
    } else if (viewParam === 'issues') {
      initialDetSel = 'wd';
    } else if (viewParam === 'stock') {
      initialDetSel = 'inv';
    } else {
      initialDetSel = localStorage.getItem('detailViewSelector') === null ? 'pr' : localStorage.getItem('detailViewSelector');
    }
    return {
      dashboardIsFolded: shouldFoldDashboard,
      dashboardIsAnimating: false,
      blockScrolling: false,

      firstEverHere: false,
      detSel: initialDetSel,
      sortListByImportance: true,
      galleryIndexForPopup: 0,
      galleryArrayIdForPopup: [],
      desktopNotifPerm: desktopNotifPerm,
      wdListSorted: [],
      wdNewErrorCounts: {},
      wdMenuUpdateTrigger: '',

      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      filterShowSASelector: false,
      productViewPreference: 'pr',
      lastDismissDate: localStorage.getItem('lastDismissDate'),
      suppressedWatchdogs: []
    };
  },
  methods: {
    setDetailView: function setDetailView(val) {
      this.detSel = val;
      localStorage.setItem('detailViewSelector', val);
      this.$parent.onboarder('viewtype');

      if (val === 'pr' || val === 'pr2') {
        this.productViewPreference = val;
        this.loadProductsList();
      }
      if (val === 'wd' || val === 'wc') {
        this.loadWatchdogsData();
        this.fetchSuppressedWatchdogs();
      }
      if (val === 'inv') {
        this.loadStockData();
      }
    },
    loadDashboardStats: function loadDashboardStats() {
      var _this = this;

      console.log('[HomePage] loadDashboardStats called, $parent.dashboardStats exists:', !!this.$parent.dashboardStats);
      if (this.$parent.dashboardStats) {
        this.$parent.dashboardStats();
      } else {
        console.error('[HomePage] dashboardStats method not found on $parent, retrying in 1 second...');

        setTimeout(function () {
          if (_this.$parent.dashboardStats) {
            console.log('[HomePage] Retry successful, calling dashboardStats');
            _this.$parent.dashboardStats();
          } else {
            console.error('[HomePage] Retry failed, dashboardStats still not found');
          }
        }, 1000);
      }
    },
    loadProductsList: function loadProductsList() {
      if (this.$parent.productsList) {
        var marketplaces = this.filterByMarket.length ? this.filterByMarket.join(',') : null;
        var sellerAccounts = this.filterBySellAcc.length ? this.filterBySellAcc.join(',') : null;
        this.$parent.productsList(marketplaces, sellerAccounts);
      }
    },
    loadWatchdogsData: function loadWatchdogsData() {
      if (this.$parent.watchdogsData) {
        this.$parent.watchdogsData();
      }
    },
    loadStockData: function loadStockData() {
      if (this.$parent.stockData) {
        this.$parent.stocksCurrentPage = 0;
        this.$parent.stockData(0, this.$parent.stocksPageSize);
      }
    },
    productDetails: function productDetails(productId) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ body: {} });
    },
    switchToProdView: function switchToProdView() {
      this.setDetailView(this.productViewPreference);
    },
    toggleDashboard: function toggleDashboard() {
      var _this2 = this;

      this.dashboardIsFolded = !this.dashboardIsFolded;

      this.dashboardIsAnimating = true;
      setTimeout(function () {
        _this2.dashboardIsAnimating = false;
      }, 1100);
      setTimeout(function () {
        _this2.blockScrolling = false;
      }, 600);
      if (!this.dashboardIsFolded) {
        this.loadDashboardStats();
      }
    },
    dvlprmd: function dvlprmd() {
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.stts21kdfslds').removeClass('stts21kdfslds');
    },
    onScroll: function onScroll(e) {
      if (this.$refs.helpMenu && !this.$refs.helpMenu.isModalOpen && !this.dashboardIsFolded) {
        e.preventDefault();
        this.toggleDashboard();
        this.blockScrolling = true;
      }
      if (this.blockScrolling === true) {
        e.preventDefault();
        return false;
      }
    },
    openHelpModal: function openHelpModal(i) {
      this.$refs.helpMenu.openHelpModal(i);
    },
    openProductDetailModal: function openProductDetailModal(galleryArray, galleryIndex) {
      var _this3 = this;

      console.log('[HomePage] openProductDetailModal called with:', galleryArray, galleryIndex);

      if (galleryArray && galleryArray.length > 0 && galleryIndex >= 0) {
        var productId = galleryArray[galleryIndex];
        console.log('[HomePage] productDetails method exists:', !!this.productDetails);
        if (this.productDetails) {
          console.log('[HomePage] Calling productDetails for productId:', productId);
          var result = this.productDetails(productId);
          console.log('[HomePage] productDetails returned:', result, 'type:', typeof result === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(result));
          if (result && typeof result.then === 'function') {
            result.then(function () {
              console.log('[HomePage] Product details loaded, opening modal');

              _this3.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray);
              __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#productDetailModal').modal({
                dimmerSettings: { opacity: 0.9 },
                onHidden: function onHidden() {
                  if ('pushState' in history) {
                    history.pushState('', document.title, window.location.pathname + window.location.search);
                  }
                  __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.ui.dimmer.modals').css('background-color', '');
                }
              }).modal('show');
            }).catch(function (error) {
              console.error('[HomePage] Product details API failed:', error);

              _this3.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray);
              __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#productDetailModal').modal({
                dimmerSettings: { opacity: 0.9 },
                onHidden: function onHidden() {
                  if ('pushState' in history) {
                    history.pushState('', document.title, window.location.pathname + window.location.search);
                  }
                  __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.ui.dimmer.modals').css('background-color', '');
                }
              }).modal('show');
            });
          } else {
            console.error('[HomePage] productDetails did not return a Promise!');
          }
        } else {
          console.error('[HomePage] productDetails method not found!');

          this.$refs.productDetails.setGalleryParams(galleryIndex, galleryArray);
          __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#productDetailModal').modal({
            dimmerSettings: { opacity: 0.9 },
            onHidden: function onHidden() {
              if ('pushState' in history) {
                history.pushState('', document.title, window.location.pathname + window.location.search);
              }
              __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.ui.dimmer.modals').css('background-color', '');
            }
          }).modal('show');
        }
      }
    },
    utilWaitFor: function utilWaitFor(test, onSuccess, timeOut, startCount, maxCount) {
      var _this4 = this;

      if (test()) onSuccess();else {
        if (startCount++ < maxCount) setTimeout(function () {
          return _this4.utilWaitFor(test, onSuccess, timeOut, startCount, maxCount);
        }, timeOut);
      }
    },
    calcWdListSorted: function calcWdListSorted() {
      if (!this.sortListByImportance) return this.$parent.wdList;

      var hasAlert = [];
      var noAlert = [];
      var wd = this.$parent.worldStore.watchDogs;

      for (var i = 0; i < this.$parent.wdList.length; i++) {
        var wdName = this.$parent.wdList[i];
        var alertCount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(wd[wdName].items).filter(function (item) {
          return item.issueStatus === 0 && !item.muted && (item.status === 1 || item.status === 2);
        }).length;
        var list = alertCount > 0 ? hasAlert : noAlert;
        list.push(this.$parent.wdList[i]);
      }
      return hasAlert.concat(noAlert);
    },
    updateFilters: function updateFilters() {
      this.filterUserCountries = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.products).map(function (i) {
        return i.marketplace;
      })));
      this.filterShowSASelector = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$parent.worldStore.sellerAccounts).length > 1;
    },
    fetchSuppressedWatchdogs: function fetchSuppressedWatchdogs() {
      var _this5 = this;

      this.$http.get('/api/operations/tenant-features/suppressed-alerts').then(function (response) {
        console.log('[HomePage] Suppressed watchdogs API response:', response.body);
        _this5.suppressedWatchdogs = response.body.map(function (x) {
          return x.toUpperCase();
        });
      });
    },

    loadStocksPage: function loadStocksPage(page) {
      if (this.$parent.loadStocksPage) {
        this.$parent.loadStocksPage(page);
      }
    },
    nextStocksPage: function nextStocksPage() {
      if (this.$parent.nextStocksPage) {
        this.$parent.nextStocksPage();
      }
    },
    prevStocksPage: function prevStocksPage() {
      if (this.$parent.prevStocksPage) {
        this.$parent.prevStocksPage();
      }
    },
    getPageNumber: function getPageNumber(index) {
      var currentPage = this.$parent.stocksCurrentPage || 0;
      var totalPages = this.$parent.stocksTotalPages || 1;

      if (totalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, currentPage - 2);
      var endPage = Math.min(totalPages - 1, startPage + 4);
      var adjustedStartPage = Math.max(0, endPage - 4);

      return adjustedStartPage + index - 1;
    },

    getCurrentPage: function getCurrentPage() {
      var component = this.$refs.productCard || this.$refs.productList;
      return component ? component.currentPage : 0;
    },
    getTotalPages: function getTotalPages() {
      var component = this.$refs.productCard || this.$refs.productList;
      return component ? component.totalPages : 1;
    },
    getTotalItems: function getTotalItems() {
      var component = this.$refs.productCard || this.$refs.productList;
      return component ? component.totalItems : 0;
    },
    prevPage: function prevPage() {
      var component = this.$refs.productCard || this.$refs.productList;
      if (component) component.prevPage();
    },
    nextPage: function nextPage() {
      var component = this.$refs.productCard || this.$refs.productList;
      if (component) component.nextPage();
    },
    goToPage: function goToPage(page) {
      var component = this.$refs.productCard || this.$refs.productList;
      if (component) component.goToPage(page);
    }
  },
  computed: {
    filteredCountries: function filteredCountries() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterUserCountries, this.filterCountriesAll);
    },
    showPartnerCards: {
      get: function get() {
        var sevenDaysInSeconds = 3600 * 24 * 7;
        sevenDaysInSeconds = 20;

        return this.$root.secondsSinceFirstSellerAccountCreated > sevenDaysInSeconds && (this.lastDismissDate == null || (new Date() - this.lastDismissDate) / 1000 > sevenDaysInSeconds);
      },
      set: function set() {
        this.lastDismissDate = new Date().getTime();
      }
    }
  },
  created: function created() {
    this.fetchSuppressedWatchdogs();
    this.wdListSorted = this.calcWdListSorted();
  },
  mounted: function mounted(e) {
    var _this6 = this;

    window.scrollTo(0, 0);
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(document).on('scroll wheel mousewheel keyup touchmove', this.onScroll);

    if (this.$route.query.view) {
      var view = this.$route.query.view;
      this.dashboardIsFolded = true;
      this.dashboardIsAnimating = true;
      setTimeout(function () {
        _this6.dashboardIsAnimating = false;
      }, 1100);

      if (view === 'products') {
        this.setDetailView('pr');
      } else if (view === 'issues') {
        this.setDetailView('wd');
      } else if (view === 'stock') {
        this.setDetailView('inv');
      }
    } else {
      if (this.detSel === 'pr' || this.detSel === 'pr2') {
        this.loadProductsList();
      } else if (this.detSel === 'wd' || this.detSel === 'wc') {
        this.loadWatchdogsData();
        this.fetchSuppressedWatchdogs();
      } else if (this.detSel === 'inv') {
        this.loadStockData();
      }
    }

    if (!this.$root.anySellerAccountSetupCompleted) {
      this.firstEverHere = true;
      this.$root.anySellerAccountSetupCompleted = true;
    }

    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this.$el).find('#dashSmallDetails div').popup({ delay: { show: 300, hide: 0 }, transition: 'fade' });

    if (this.$root.deeplink.indexOf('pdet-') > -1) {
      var pid = this.$root.deeplink.substr(this.$root.deeplink.indexOf('pdet-') + 5);
      this.utilWaitFor(function () {
        return _this6.$parent.worldStore.products.hasOwnProperty(pid);
      }, function () {
        return _this6.openProductDetailModal([pid], 0);
      }, 250, 0, 180);
    }

    this.wdMenuUpdateTrigger = 'something';

    this.updateFilters();
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#detailsSelector .ui.dropdown.filterc').dropdown({
      onChange: function onChange(v) {
        if (v === '') _this6.filterByMarket = [];else _this6.filterByMarket = v.split(',');
        if (_this6.detSel === 'pr' || _this6.detSel === 'pr2') _this6.loadProductsList();
      }
    });
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#detailsSelector .ui.dropdown.filtersa').dropdown({
      onChange: function onChange(v) {
        if (v === '') _this6.filterBySellAcc = [];else _this6.filterBySellAcc = v.split(',').map(Number);
        if (_this6.detSel === 'pr' || _this6.detSel === 'pr2') _this6.loadProductsList();
      }
    });

    if (this.detSel === 'pr' || this.detSel === 'pr2') {
      this.loadProductsList();
    } else if (this.detSel === 'wd' || this.detSel === 'wc') {
      this.loadWatchdogsData();
    } else if (this.detSel === 'inv') {
      this.loadStockData();
    }

    this.loadDashboardStats();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(document).off('scroll wheel mousewheel keyup touchmove', this.onScroll);
  },
  watch: {
    '$route.query.view': function $routeQueryView(newView) {
      if (newView) {
        if (newView === 'products') {
          this.setDetailView('pr');
        } else if (newView === 'issues') {
          this.setDetailView('wd');
        } else if (newView === 'stock') {
          this.setDetailView('inv');
        }
      }
    },
    '$parent.worldStore': function $parentWorldStore() {
      this.wdListSorted = this.calcWdListSorted();

      this.updateFilters();

      this.loadDashboardStats();
    },
    sortListByImportance: function sortListByImportance() {
      this.wdListSorted = this.calcWdListSorted();
    },
    lastDismissDate: function lastDismissDate(value) {
      localStorage.setItem('lastDismissDate', value);
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Model_Sellers__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Model_Sellers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Model_Sellers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductDetailsChartModal__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductDetailsChartModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ProductDetailsChartModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FirstRunSyncModal_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FirstRunSyncModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_FirstRunSyncModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_onboardingSessionHints_js__ = __webpack_require__(60);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ModelSellers: __WEBPACK_IMPORTED_MODULE_8__components_Model_Sellers___default.a,
    ProductDetailsChartModal: __WEBPACK_IMPORTED_MODULE_9__components_ProductDetailsChartModal___default.a,
    FirstRunSyncModal: __WEBPACK_IMPORTED_MODULE_10__components_FirstRunSyncModal_vue___default.a
  },
  data: function data() {
    var apiVersion = 5;

    var wdList = ['badReview', 'topReview', 'starRatingRecentChange', 'numberOfSellers', 'lostBuybox', 'noAddToCart', 'price', 'salesDrop', 'imageMissing', 'productDetailsRecentChange', 'productCategoryRecentChange', 'bestSellerBadge', 'badSellerFeedback', 'listingSuspended', 'searchBan', 'inventory', 'fbmInventory', 'fbaFeeChange', 'prime', 'amazonChoiceBadge', 'subscribeAndSave', 'parentProductChange', 'adultClassification', 'competitorPrice', 'competitivePrice', 'reviewHealth'];
    var worldStore = { 'state': null, 'sellerAccounts': {}, 'products': {}, 'watchDogs': {}, 'reds': {}, 'ambers': {}, 'currentVersion': apiVersion, 'minVersion': apiVersion, 'announcement': null };
    for (var n in wdList) {
      worldStore.watchDogs[wdList[n]] = { 'status': 0, 'alertsEnabled': null, 'message': '', 'settings': {}, 'items': {} };
    }
    var onboarding = { wdtabs: true, issuestatus: true, viewtype: true, mainmenu: true, desktopnotif: true, saleschrt: true, dtntfy: true, syncing: true };
    for (var _n in onboarding) {
      onboarding[_n] = localStorage.getItem('onb' + _n) === null;
    }
    if ('Notification' in window && Notification.permission !== 'default') onboarding.dtntfy = false;

    return {
      apiVersion: apiVersion,
      email: null,
      errorMessage: null,
      password: null,
      keepMeSignedIn: false,
      loginNeeded: false,
      loginModalElement: null,
      loginError: null,
      offline: false,
      transitionName: '',
      transitionMode: 'out-in',
      worldStore: worldStore,
      wdList: wdList,
      hasSOTW: false,
      sotwi: null,

      stocksCurrentPage: 0,
      stocksPageSize: 20,
      stocksTotalItems: 0,
      stocksTotalPages: 0,
      stocksSummary: null,
      stockSummaryRequestId: 0,

      stockPageProductIds: [],
      loadingIndicator: false,
      announcement: null,
      closedAnnouncementText: null,
      accountErrors: null,
      accountErrorsTextClosed: false,
      onboarding: onboarding,
      stateChangeRequestInFlight: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      manyAsinsModalShowed: false,
      manyAsinsModalClosed: false,
      firstSotw: true,
      onboardingStatus: {
        sellerConnected: false,
        productsImported: false,
        buyboxFetched: false,
        ordersFetched: false,
        completed: false,
        completedAt: null
      },
      onboardingPollTimer: null,

      _onboardingReadyTimeoutId: null,

      onboardingStatusReady: false
    };
  },
  methods: {
    onFirstRunSyncDismiss: function onFirstRunSyncDismiss() {
      this.onboarder('syncing');
    },
    onboarder: function onboarder(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('[data-onboarding=' + id + ']').hide(400);
      setTimeout(function () {
        _this.onboarding[id] = false;
      }, 999);
      localStorage.setItem('onb' + id, 'y');
      if (id === 'dtntfy' && 'Notification' in window) Notification.requestPermission();
    },
    accErrorBoxClose: function accErrorBoxClose() {
      var _this2 = this;

      this.accountErrorsTextClosed = true;
      setTimeout(function () {
        _this2.accountErrorsTextClosed = false;
      }, 1000 * 60 * 60 * 3);
    },
    fetchOnboardingStatus: function fetchOnboardingStatus(forceRefresh) {
      var self = this;
      if (self.onboardingStatus && self.onboardingStatus.completed) {
        self.onboardingStatusReady = true;
        return;
      }
      var s0 = self.onboardingStatus;
      var alreadyAllSteps = s0 && !!s0.sellerConnected && !!s0.productsImported && !!s0.buyboxFetched && !!s0.ordersFetched;
      if (alreadyAllSteps) {
        self.onboardingStatusReady = true;
        return;
      }
      if (self._onboardingReadyTimeoutId) {
        clearTimeout(self._onboardingReadyTimeoutId);
        self._onboardingReadyTimeoutId = null;
      }
      self._onboardingReadyTimeoutId = setTimeout(function () {
        self._onboardingReadyTimeoutId = null;
        if (!self.onboardingStatusReady) {
          self.onboardingStatusReady = true;
        }
      }, 15000);
      var force = !!forceRefresh;
      var statusPromise = self.$root.loadOnboardingStatus ? self.$root.loadOnboardingStatus(force) : self.$http.get('/api/v1/onboarding/status').then(function (response) {
        return response.body || {};
      }, function () {
        return null;
      });
      statusPromise.then(function (data) {
        if (self._onboardingReadyTimeoutId) {
          clearTimeout(self._onboardingReadyTimeoutId);
          self._onboardingReadyTimeoutId = null;
        }
        data = data || {};
        self.onboardingStatusReady = true;
        self.onboardingStatus = {
          sellerConnected: !!data.sellerConnected,
          productsImported: !!data.productsImported,
          buyboxFetched: !!data.buyboxFetched,
          ordersFetched: !!data.ordersFetched,
          completed: !!data.completed,
          completedAt: data.completedAt || null
        };
        var pipelineDone = !!data.completed || !!data.sellerConnected && !!data.productsImported && !!data.buyboxFetched && !!data.ordersFetched;
        if (pipelineDone) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_onboardingSessionHints_js__["c" /* setPipelineDoneHint */])();
        }
        if (data.sellerConnected) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_onboardingSessionHints_js__["f" /* clearConnectDeferredHint */])();
        }
        if (pipelineDone && self.onboardingPollTimer) {
          clearInterval(self.onboardingPollTimer);
          self.onboardingPollTimer = null;
        }
        if (pipelineDone && self.onboarding.syncing) {
          self.onboarding.syncing = false;
          localStorage.setItem('onbsyncing', 'y');
        }
      }, function () {
        if (self._onboardingReadyTimeoutId) {
          clearTimeout(self._onboardingReadyTimeoutId);
          self._onboardingReadyTimeoutId = null;
        }
        self.onboardingStatusReady = true;
      });
    },
    startOnboardingPoll: function startOnboardingPoll() {
      this.fetchOnboardingStatus(false);
      var self = this;
      this.onboardingPollTimer = setInterval(function () {
        var st = self.onboardingStatus;
        var done = st && (st.completed || !!st.sellerConnected && !!st.productsImported && !!st.buyboxFetched && !!st.ordersFetched);
        if (done) {
          clearInterval(self.onboardingPollTimer);
          self.onboardingPollTimer = null;
          return;
        }
        self.fetchOnboardingStatus(true);
      }, 60000);
    },
    signOut: function signOut() {
      clearInterval(this.sotwi);
      this.sotwi = null;
      this.$root.signOutUser();
    },
    goSettings: function goSettings() {
      this.$router.push('/settings');
    },
    login: function login() {
      var _this3 = this;

      this.$http.post('/api/auth/login/standard', {
        email: this.email,
        password: this.password,
        keepMeSignedIn: this.keepMeSignedIn
      }).then(function (response) {
        _this3.password = null;
        _this3.loginError = null;
        _this3.loginNeeded = false;
        _this3.loginModalElement.modal('hide');
      }, function (response) {
        _this3.loginError = response.body.message;
      });
      return false;
    },
    hasInFlightStateChangeRequest: function hasInFlightStateChangeRequest() {
      var threshold = Date.now() - 30000;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.stateChangeRequestInFlight.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;

          if (value > threshold) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },

    updateSotwPolling: function updateSotwPolling() {
      if (this.sotwi) {
        clearInterval(this.sotwi);
        this.sotwi = null;
      }
    },
    stateOfTheWorld: function stateOfTheWorld() {
      this.loadingIndicator = false;
    },
    dashboardStats: function dashboardStats() {
      console.log('[IndexPage] dashboardStats called - COMMENTED OUT');

      return;
    },
    productsList: function productsList(marketplaces, sellerAccounts) {
      var _this4 = this;

      try {
        var params = { productsOnly: true };
        if (marketplaces && String(marketplaces).trim() !== '') params.marketplaces = marketplaces;
        if (sellerAccounts && String(sellerAccounts).trim() !== '') params.sellerAccounts = sellerAccounts;
        this.$http.get('/api/sentinel/products', {
          params: params
        }).then(function (response) {
          try {

            if (typeof response.body === 'string' || response.body instanceof String) {
              console.warn('[IndexPage] Response body is a string, skipping');
              return;
            }

            if (response.body.products) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.body.products).forEach(function (productId) {
                var product = response.body.products[productId];

                if (product.marketplace) {
                  product.marketplace = product.marketplace.toUpperCase();
                }
                if (!product.productGroupId) {
                  product.productGroupId = productId;
                }
                if (!product.productGroupProductIds) {
                  product.productGroupProductIds = [productId];
                }
                if (product.ageHours === undefined) {
                  if (product.salesYesterday !== undefined || product.salesToday !== undefined) {
                    product.ageHours = 0;
                  } else {
                    product.ageHours = -1;
                  }
                }
                if (product.starRating === undefined) product.starRating = product.rating != null ? product.rating : null;
                if (product.bsrRank === undefined) product.bsrRank = product.salesRank || null;
                if (product.salesYesterdayDate === undefined) {
                  if (product.lastUpdated) {
                    var date = new Date(product.lastUpdated);
                    product.salesYesterdayDate = date.getDate();
                    product.salesYesterdayMonth = date.getMonth() + 1;
                  } else {
                    product.salesYesterdayDate = null;
                    product.salesYesterdayMonth = null;
                  }
                }
                if (product.salesTodayDate === undefined) {
                  if (product.lastUpdated) {
                    var _date = new Date(product.lastUpdated);
                    product.salesTodayDate = _date.getDate();
                    product.salesTodayMonth = _date.getMonth() + 1;
                  } else {
                    product.salesTodayDate = null;
                    product.salesTodayMonth = null;
                  }
                }
              });
            }

            var redsByGroupId = {};
            var ambersByGroupId = {};

            if (response.body.reds) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.body.reds).forEach(function (productId) {
                var mainProduct = response.body.products && response.body.products[productId];
                var groupId = mainProduct && mainProduct.productGroupId || productId;
                redsByGroupId[groupId] = (redsByGroupId[groupId] || 0) + 1;
              });
            }

            if (response.body.ambers) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.body.ambers).forEach(function (productId) {
                var mainProduct = response.body.products && response.body.products[productId];
                var groupId = mainProduct && mainProduct.productGroupId || productId;
                ambersByGroupId[groupId] = (ambersByGroupId[groupId] || 0) + 1;
              });
            }

            if (response.body.products) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this4.worldStore.products).forEach(function (key) {
                _this4.$delete(_this4.worldStore.products, key);
              });
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.body.products).forEach(function (productId) {
                _this4.$set(_this4.worldStore.products, productId, response.body.products[productId]);
              });
            }
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this4.worldStore.reds).forEach(function (key) {
              _this4.$delete(_this4.worldStore.reds, key);
            });
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(redsByGroupId).forEach(function (groupId) {
              _this4.$set(_this4.worldStore.reds, groupId, redsByGroupId[groupId]);
            });
            console.log('[IndexPage] Updating ambers:', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(ambersByGroupId).length, 'product groups');
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this4.worldStore.ambers).forEach(function (key) {
              _this4.$delete(_this4.worldStore.ambers, key);
            });
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(ambersByGroupId).forEach(function (groupId) {
              _this4.$set(_this4.worldStore.ambers, groupId, ambersByGroupId[groupId]);
            });
            if (response.body.sellerAccounts) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.body.sellerAccounts).forEach(function (sellerId) {
                _this4.$set(_this4.worldStore.sellerAccounts, sellerId, response.body.sellerAccounts[sellerId]);
              });
            }
          } catch (error) {
            window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
          }
        }, function (response) {
          if (response.status === 0 || response.status === 502 || response.status === 503 || response.status === 504) {
            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 828)).then(function (_ref) {
              var mockProductsService = _ref.mockProductsService;

              mockProductsService.getProducts().then(function (data) {
                try {
                  if (data.products) {
                    _this4.worldStore.products = data.products;
                  }
                  if (data.sellerAccounts) {
                    _this4.worldStore.sellerAccounts = data.sellerAccounts;
                  }
                } catch (error) {
                  console.error('Error loading mock products:', error);
                }
              });
            }).catch(function (error) {
              console.error('Failed to load mock products:', error);
            });
          }
        });
      } catch (error) {
        window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
      }
    },
    watchdogsData: function watchdogsData() {
      return;
    },
    normalizeStockSummary: function normalizeStockSummary(raw) {
      if (!raw || (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(raw)) !== 'object') return null;
      var total = raw.totalProducts != null ? raw.totalProducts : raw.total_products;
      var healthy = raw.healthyStock != null ? raw.healthyStock : raw.healthy_stock;
      var low = raw.lowStockWarning != null ? raw.lowStockWarning : raw.low_stock_warning;
      var out = raw.outOfStock != null ? raw.outOfStock : raw.out_of_stock;
      var pct = raw.healthyPercentage != null ? raw.healthyPercentage : raw.healthy_percentage;
      return {
        totalProducts: Number(total) || 0,
        healthyStock: Number(healthy) || 0,
        lowStockWarning: Number(low) || 0,
        outOfStock: Number(out) || 0,
        healthyPercentage: Number(pct) || 0
      };
    },
    stockData: function stockData(page, pageSize, search, status, marketplaces, sellerAccounts, sort, order, skipSummary) {
      var _this5 = this;

      try {
        var currentPage = page !== undefined ? page : this.stocksCurrentPage;
        var currentPageSize = pageSize || this.stocksPageSize;

        var params = { page: currentPage, pageSize: currentPageSize };
        if (search) params.search = search;
        if (status && status !== 'all') {
          params.status = status === 'critical' ? 'critical' : status;
        }
        if (marketplaces) params.marketplaces = marketplaces;
        if (sellerAccounts) params.sellerAccounts = sellerAccounts;
        if (sort) params.sort = sort;
        if (order) params.order = order;

        if (!skipSummary && currentPage === 0 && (!status || status === 'all')) {
          this.stockSummaryRequestId++;
          this.stocksSummary = {
            totalProducts: 0,
            healthyStock: 0,
            lowStockWarning: 0,
            outOfStock: 0,
            healthyPercentage: 0
          };
        }

        this.$http.get('/api/sentinel/stock', { params: params }).then(function (response) {
          try {
            if (typeof response.body === 'string' || response.body instanceof String) return;

            var body = response.body;

            if (body.pagination) {
              _this5.stocksTotalItems = body.pagination.totalItems || 0;
              _this5.stocksTotalPages = body.pagination.totalPages || 0;
              _this5.stocksCurrentPage = body.pagination.currentPage || 0;
              if (body.pagination.pageSize !== undefined) _this5.stocksPageSize = body.pagination.pageSize;
            }

            if (body.summary) {
              _this5.stocksSummary = _this5.normalizeStockSummary(body.summary);
            } else if ((!status || status === 'all') && body.pagination && (body.pagination.totalItems || 0) === 0) {
              _this5.stocksSummary = {
                totalProducts: 0,
                healthyStock: 0,
                lowStockWarning: 0,
                outOfStock: 0,
                healthyPercentage: 0
              };
            }

            var prevIds = _this5.stockPageProductIds || [];
            prevIds.forEach(function (productId) {
              this.$delete(this.worldStore.products, String(productId));
            }.bind(_this5));

            var products = body.products;
            var newStockProductIds = [];
            if (products && Array.isArray(products)) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var stockProduct = _step2.value;

                  var product = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, stockProduct);
                  var pid = product.productId != null && product.productId !== '' ? product.productId : product.product_id;
                  if (pid === undefined || pid === null || pid === '') continue;
                  product.productId = pid;
                  var key = String(pid);

                  product.productTitle = product.productName || product.productTitle;
                  product.totalQty = product.fbaStock;
                  product.inStockQty = product.fbaAvailable;
                  product.inboundQty = product.fbaInbound;
                  product.fbmQty = product.fbmStock;
                  product.reservedStock = product.reservedStock != null ? product.reservedStock : product.reservedQty;
                  product.fbaTransferring = product.fbaTransferring != null ? product.fbaTransferring : product.pendingTransshipmentQty;
                  product.velocity = product.velocity;
                  product.trend = product.trend;
                  product.daysLeft = product.daysLeft;
                  product.daysLeftDisplay = product.daysLeftDisplay;
                  product.daysLeftSubtitle = product.daysLeftSubtitle;
                  product.status = product.status;
                  product.healthStatus = product.healthStatus;
                  product.avgDailySales = product.velocity;

                  if (product.asin && !product.productUrl) {
                    product.productUrl = 'https://www.amazon.com/dp/' + product.asin;
                  }

                  _this5.$set(_this5.worldStore.products, key, product);
                  newStockProductIds.push(key);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
            _this5.stockPageProductIds = newStockProductIds;

            if (!skipSummary && (!status || status === 'all') && !body.summary && body.pagination && (body.pagination.totalItems || 0) > 0 && currentPage === 0) {
              _this5.stockSummaryData(marketplaces, sellerAccounts);
            }
          } catch (error) {
            window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
          }
        }, function (response) {
          console.error('[IndexPage] stockData failed:', response.status, response);
        });
      } catch (error) {
        window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
      }
    },
    stockSummaryData: function stockSummaryData(marketplaces, sellerAccounts) {
      var _this6 = this;

      try {
        var requestId = ++this.stockSummaryRequestId;
        this.stocksSummary = {
          totalProducts: 0,
          healthyStock: 0,
          lowStockWarning: 0,
          outOfStock: 0,
          healthyPercentage: 0
        };
        var params = {};
        if (marketplaces) params.marketplaces = marketplaces;
        if (sellerAccounts) params.sellerAccounts = sellerAccounts;
        this.$http.get('/api/sentinel/stock/summary', { params: params }).then(function (response) {
          try {
            if (requestId !== _this6.stockSummaryRequestId) return;
            if (typeof response.body === 'string' || response.body instanceof String) return;

            var body = response.body;
            if (body) {
              _this6.stocksSummary = _this6.normalizeStockSummary(body) || _this6.stocksSummary;
            }
          } catch (error) {
            window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
          }
        }, function (response) {
          console.error('[IndexPage] stockSummaryData failed:', response.status, response);
        });
      } catch (error) {
        window.onerror(error.message || 'N/A', error.url || 'N/A', error.lineNumber || 'N/A', error.columnNumber || 'N/A', error.error || error.name || 'N/A');
      }
    },

    loadStocksPage: function loadStocksPage(page) {
      this.stocksCurrentPage = page;
      this.stockData(page, this.stocksPageSize);
    },
    nextStocksPage: function nextStocksPage() {
      if (this.stocksCurrentPage < this.stocksTotalPages - 1) {
        this.loadStocksPage(this.stocksCurrentPage + 1);
      }
    },
    prevStocksPage: function prevStocksPage() {
      if (this.stocksCurrentPage > 0) {
        this.loadStocksPage(this.stocksCurrentPage - 1);
      }
    },
    setIssueStatus: function setIssueStatus(watchDogId, val) {
      var _this7 = this;

      var watchDogs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.worldStore.watchDogs);
      for (var i = 0; i < watchDogs.length; ++i) {
        var wd = watchDogs[i];
        if (wd.hasOwnProperty('items')) {
          var items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(wd.items);
          for (var j = 0; j < items.length; ++j) {
            var item = items[j];
            if (Array.isArray(item)) {
              for (var k = 0; k < item.length; ++k) {
                var item0 = item[k];
                if (item0.hasOwnProperty('watchDogId') && item0.watchDogId === watchDogId) {
                  item0.issueStatus = val;
                }
              }
            } else if (item.hasOwnProperty('watchDogId') && item.watchDogId === watchDogId) {
              item.issueStatus = val;
            }
          }
        }
      }

      var timestamp = Date.now();
      this.stateChangeRequestInFlight.add(timestamp);
      this.$http.post('/api/sentinel/watchdog/set-issue-status/' + watchDogId + '/' + val, {}).then(function (response) {
        _this7.stateChangeRequestInFlight.delete(timestamp);
      }, function (response) {
        _this7.stateChangeRequestInFlight.delete(timestamp);
      });

      this.onboarder('issuestatus');
    },
    setKeywordIssueStatus: function setKeywordIssueStatus(productId, i, val) {
      this.worldStore.watchDogs['keyword'].items[productId][i].issueStatus = val;

      this.$http.post('/api/sentinel/watchdog/set-issue-status/' + this.worldStore.watchDogs['keyword'].items[productId][0].watchDogId + '/' + val, {}).then(function (response) {
        return true;
      }, function (response) {
        return false;
      });
    },
    log: function log(msg) {
      if ((typeof console === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(console)) === 'object' && typeof console.log === 'function') {
        console.log(msg);
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#preloadr').fadeOut(600);

    this.loginModalElement = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#loginModal');
    this.loginModalElement.modal({
      closable: false,
      onDeny: function onDeny() {
        return false;
      },
      onApprove: this.login
    });
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#userMenu .dropdown').dropdown({ 'action': 'hide' });

    if ('Notification' in window && !this.onboarding.dtntfy && Notification.permission === 'default') Notification.requestPermission();
    this.startOnboardingPoll();
  },
  created: function created() {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_6_vue___default.a.http.interceptors.push(function (request, next) {
      if (_this8.loginNeeded && request.url !== '/api/auth/login/standard') {
        _this8.log('Login needed, suppressing request ' + request.method + ' ' + request.url);
        return;
      }
      next(function (response) {
        if (response.url === '/api/auth/login/standard') return;
        if (response.url === '/api/auth/isauthenticated') return;
        if (response.url === '/api/auth/changepwd') return;
        if (response.url === '/api/identity/package') return;
        if (response.url === '/api/billing/subscription/create') return;
        if (response.url === '/api/billing/source') return;
        if (response.url === '/api/v1/onboarding/status') return;
        if (response.url === '/api/support/ticket') return;
        if (response.url && response.url.startsWith('/api/product/asin/exists/')) return;
        if (response.status === 304 && response.url && (response.url.startsWith('/api/sentinel/stateoftheworld') || response.url === '/api/auth/extend')) return;
        if (_this8.$root.offline) return;
        if (response.status === 429) return;
        if (response.status === 401 && response.headers && response.headers.map && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.headers.map).filter(function (k) {
          return k.toLowerCase() === 'www-authenticate';
        }).length > 0) {
          var key = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.headers.map).filter(function (k) {
            return k.toLowerCase() === 'www-authenticate';
          })[0];
          var value = response.headers.map[key];
          if (_this8.email == null || Array.isArray(value) && value.length > 0 && value[0] === 'redirect') {
            _this8.$router.push('/login');
          } else {
            _this8.loginNeeded = true;
          }
        } else if (!response.ok) {}
      });
    });
    this.$router.beforeEach(function (to, from, next) {
      if (_this8.offline) return;
      if (from.path === '/home') _this8.transitionName = 'fromHome';else if (to.path === '/home') _this8.transitionName = 'toHome';else _this8.transitionName = 'fadeLeft';
      _this8.transitionMode = 'out-in';
      next();
    });

    var worldStoreTemp = JSON.parse(sessionStorage.getItem('worldStore'));
    if (this.$route.path !== '/table' && worldStoreTemp !== null) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(worldStoreTemp).indexOf('currentVersion') >= 0 && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(worldStoreTemp).indexOf('userEmail') >= 0 && worldStoreTemp.currentVersion === this.apiVersion) {
        worldStoreTemp.state = null;
        this.worldStore = worldStoreTemp;
        this.hasSOTW = true;
      } else {
        sessionStorage.removeItem('worldStore');
      }
    }
    this.$root._skIndexShellForDashboard = this;
  },
  computed: {
    onboardingPipelineComplete: function onboardingPipelineComplete() {
      var s = this.onboardingStatus;
      if (!s) return false;
      return !!s.completed || !!s.sellerConnected && !!s.productsImported && !!s.buyboxFetched && !!s.ordersFetched;
    },
    showFirstRunSyncModal: function showFirstRunSyncModal() {
      return false;
    }
  },
  watch: {
    loginNeeded: function loginNeeded(val) {
      if (!val) return;
      this.email = this.$root.userEmail;
      this.loginModalElement.modal('show');
    },
    '$parent.$parent.worldStore': function $parent$parentWorldStore(worldStore) {
      if (!this.apiStats) {
        this.stats = this.calcStats(worldStore);
      }
      this.emailConfirmReminder = this.calcEmailConfirmReminder(worldStore);
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.sotwi);
    if (this.onboardingPollTimer) {
      clearInterval(this.onboardingPollTimer);
      this.onboardingPollTimer = null;
    }
    if (this._onboardingReadyTimeoutId) {
      clearTimeout(this._onboardingReadyTimeoutId);
      this._onboardingReadyTimeoutId = null;
    }
    if (this.$root._skIndexShellForDashboard === this) {
      this.$root._skIndexShellForDashboard = null;
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_issuesAlertFilters_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_issuesSummaryFetch_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_requestGate_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_watchdogSummaryApi_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_alertEmailDeepLink_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_amazonMarketplaceUrls_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_issues_styles_IssuesDashboard_css__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_issues_styles_IssuesDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_issues_styles_IssuesDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_issues_AlertCategoriesSidebar_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_issues_AlertCategoriesSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_issues_AlertCategoriesSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_issues_IssuesCategoryDetail_vue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_issues_IssuesCategoryDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_issues_IssuesCategoryDetail_vue__);



















var ISSUES_URL_KEYS = ['category', 'marketplaces', 'sellerAccounts', 'dateRange', 'startDate', 'endDate', 'tab', 'alertId'];

var CUSTOM_RANGE_MAX_DAYS = 90;

function toIsoDate(d) {
  var m = d.getMonth() + 1;
  var day = d.getDate();
  return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
}

function isoDateDaysAgo(days) {
  var d = new Date();
  d.setDate(d.getDate() - days);
  return toIsoDate(d);
}

function isValidCustomRange(start, end) {
  var re = /^\d{4}-\d{2}-\d{2}$/;
  if (!re.test(start || '') || !re.test(end || '')) return false;
  return start <= end && start >= isoDateDaysAgo(CUSTOM_RANGE_MAX_DAYS) && end <= isoDateDaysAgo(0);
}

function formatShortDate(iso) {
  var parts = String(iso).split('-');
  var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

function shallowEqualIssuesQuery(next, routeQuery) {
  var a = next || {};
  var b = routeQuery || {};
  for (var i = 0; i < ISSUES_URL_KEYS.length; i++) {
    var k = ISSUES_URL_KEYS[i];
    var nv = a[k] != null ? String(a[k]) : '';
    var rv = b[k] != null ? String(b[k]) : '';
    if (nv !== rv) return false;
  }
  return true;
}

function categoryQueryOnlyChange(prevQ, nextQ) {
  prevQ = prevQ || {};
  nextQ = nextQ || {};
  var keys = ['marketplaces', 'sellerAccounts', 'dateRange', 'startDate', 'endDate', 'tab', 'alertId'];
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    var pv = prevQ[k] != null ? String(prevQ[k]) : '';
    var nv = nextQ[k] != null ? String(nextQ[k]) : '';
    if (pv !== nv) return false;
  }
  var pc = prevQ.category != null ? String(prevQ.category) : '';
  var nc = nextQ.category != null ? String(nextQ.category) : '';
  return pc !== nc;
}

function resolveIssuesHost(vm) {
  var p = vm.$parent;
  while (p) {
    if (p.wdList && Array.isArray(p.wdList) && p.worldStore) return p;
    p = p.$parent;
  }
  return null;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesPage',
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_13__components_buybox_DashboardLayout_vue___default.a,
    AlertCategoriesSidebar: __WEBPACK_IMPORTED_MODULE_14__components_issues_AlertCategoriesSidebar_vue___default.a,
    IssuesCategoryDetail: __WEBPACK_IMPORTED_MODULE_15__components_issues_IssuesCategoryDetail_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      error: null,
      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,
      sortListByImportance: true,
      activeCategory: 'lostBuybox',
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      filterShowSASelector: false,
      dateRange: 'all',

      customDateStart: '',
      customDateEnd: '',
      showCustomDatePicker: false,
      customDraftStart: '',
      customDraftEnd: '',

      issuesFeeDirection: '',
      alertThresholdsApiBaseUrl: '/api/v1/watchdogs',
      stockAlertThresholdsApiBaseUrl: '/api/v1/stock-alert-thresholds',
      salesVolumeThresholdsApiBaseUrl: '/api/v1/sales-volume-alert-thresholds',

      issuesV1SellerRows: null,

      issuesSellerMarketplaceCodes: [],
      _issuesV1SellersPromise: null,
      issuesListTab: 'active',

      issuesResolvedHidden: false,
      issuesListPage: 1,
      issuesSearchQuery: '',
      issuesItemsMeta: null,
      issuesItemsLoading: false,
      issuesFocusPending: false,
      _applyingIssuesRouteQuery: false,
      _pendingIssuesScrollCategory: null,

      summaryAlertCounts: {},

      issueProductsMap: {},

      _issuesSummaryFetchInFlight: false,
      _issuesFetchDebounce: null,
      _issuesItemsFetchDebounce: null,
      highlightedAlertId: ''
    };
  },
  computed: {
    issuesHost: function issuesHost() {
      return resolveIssuesHost(this);
    },
    issuesWorldStore: function issuesWorldStore() {
      var h = this.issuesHost;
      return h ? h.worldStore : null;
    },
    sellerAccountsList: function sellerAccountsList() {
      var v1 = this.issuesV1SellerRows;
      if (v1 != null && v1.length > 0) {
        return v1.map(function (r) {
          return { sellerId: r.id, accountNickName: r.name, region: r.region || 'NA' };
        });
      }
      var sa = this.issuesWorldStore && this.issuesWorldStore.sellerAccounts;
      return sa ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(sa) : [];
    },

    filterCountriesForDropdown: function filterCountriesForDropdown() {
      var allowed = this.filterUserCountries || [];

      if (allowed.length === 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterCountriesAll.filter(function (c) {
          return c !== 's';
        }), this.filterCountriesAll);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(allowed, this.filterCountriesAll);
    },
    customDateMin: function customDateMin() {
      return isoDateDaysAgo(CUSTOM_RANGE_MAX_DAYS);
    },
    customDateMax: function customDateMax() {
      return isoDateDaysAgo(0);
    },
    customDraftValid: function customDraftValid() {
      return isValidCustomRange(this.customDraftStart, this.customDraftEnd);
    },
    dateRangeLabel: function dateRangeLabel() {
      if (this.dateRange === 'custom' && this.customDateStart && this.customDateEnd) {
        return formatShortDate(this.customDateStart) + ' – ' + formatShortDate(this.customDateEnd);
      }
      var labels = { today: 'Today', '7d': 'Last 7 Days', '30d': 'Last 30 Days', '90d': 'Last 90 Days', all: 'All Time', 'all time': 'All Time' };
      return labels[this.dateRange] || 'All Time';
    },
    marketplacesFilterLabel: function marketplacesFilterLabel() {
      var m = this.filterByMarket;
      if (!m || m.length === 0) return 'All';
      if (m.length === 1) return m[0];
      return m.length + ' selected';
    },
    sellerAccountsFilterLabel: function sellerAccountsFilterLabel() {
      var s = this.filterBySellAcc;
      if (!s || s.length === 0) return 'All';
      if (s.length === 1) {
        var list = this.sellerAccountsList || [];
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].sellerId) === String(s[0])) return list[i].accountNickName || String(s[0]);
        }
        return String(s[0]);
      }
      return s.length + ' selected';
    },
    wdListSorted: function wdListSorted() {
      var host = this.issuesHost;
      if (!host || !host.wdList || !this.sortListByImportance || !host.worldStore) {
        return host && host.wdList || [];
      }

      var hasAlert = [];
      var noAlert = [];
      var wd = host.worldStore.watchDogs;
      var products = host.worldStore.products || {};
      var fm = this.filterByMarket || [];
      var fs = this.filterBySellAcc || [];

      var dr = 'all';

      for (var i = 0; i < host.wdList.length; i++) {
        var wdName = host.wdList[i];
        if (wd[wdName] && wd[wdName].items) {
          var items = wd[wdName].items;
          var arr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(items);
          arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_issuesAlertFilters_js__["a" /* filterIssuesItemsGlobally */])(arr, products, fm, fs, dr);
          var alertCount = 0;
          for (var j = 0; j < arr.length; j++) {
            var item = arr[j];
            if (item.issueStatus === 0 && !item.muted && (item.status === 1 || item.status === 2)) {
              alertCount++;
            }
          }
          var list = alertCount > 0 ? hasAlert : noAlert;
          list.push(host.wdList[i]);
        } else {
          noAlert.push(host.wdList[i]);
        }
      }
      return hasAlert.concat(noAlert);
    },
    displayedWatchdogs: function displayedWatchdogs() {
      if (!this.activeCategory) return this.wdListSorted;
      if (this.wdListSorted.indexOf(this.activeCategory) >= 0) {
        return [this.activeCategory];
      }
      return this.wdListSorted;
    },
    marketplaceColumnOptions: function marketplaceColumnOptions() {
      var list = this.filterCountriesForDropdown || [];
      var out = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i] !== 's') out.push(list[i]);
      }
      return out;
    },
    wdAlertCounts: function wdAlertCounts() {
      var host = this.issuesHost;
      var wdList = host && host.wdList || [];
      var wd = host && host.worldStore && host.worldStore.watchDogs;
      var sac = this.summaryAlertCounts || {};
      var counts = {};
      for (var w = 0; w < wdList.length; w++) {
        var wdName = wdList[w];
        if (wd && wd[wdName] && wd[wdName].status === 21) {
          counts[wdName] = -1;
          continue;
        }
        var c = sac[wdName];
        if (!c) {
          counts[wdName] = 0;
          continue;
        }

        counts[wdName] = (Number(c.red) || 0) + (Number(c.yellow) || 0);
      }
      return counts;
    }
  },
  methods: {
    scrollToWatchdog: function scrollToWatchdog(wdtype) {
      if (this.activeCategory === wdtype) {
        this.activeCategory = '';
        this.syncIssuesRouteQuery();
        return;
      }
      this.activeCategory = wdtype;
      this.syncIssuesRouteQuery();
      var self = this;
      this.$nextTick(function () {
        if (!wdtype) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body,html').stop().animate({ scrollTop: 0 }, 300);
          return;
        }
        var el = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('[data-wdtype=' + wdtype + ']')[0];
        if (!el) return;
        var elY = 0;
        for (var p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) {
          elY += p.offsetTop;
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body,html').stop().animate({ scrollTop: Math.max(0, elY - 100) }, 300);
      });
    },

    fetchWatchdogsData: function fetchWatchdogsData() {
      var self = this;
      if (self._issuesFetchDebounce) clearTimeout(self._issuesFetchDebounce);
      self._issuesFetchDebounce = setTimeout(function () {
        self._issuesFetchDebounce = null;
        self.runIssuesSummaryFetch();
      }, 300);
    },

    scheduleIssuesSummaryItemsOnly: function scheduleIssuesSummaryItemsOnly() {
      var self = this;
      if (self._issuesItemsFetchDebounce) clearTimeout(self._issuesItemsFetchDebounce);
      self._issuesItemsFetchDebounce = setTimeout(function () {
        self._issuesItemsFetchDebounce = null;
        self.fetchIssuesSummaryItemsOnly();
      }, 100);
    },

    fetchIssuesSummaryItemsOnly: function fetchIssuesSummaryItemsOnly() {
      var host = resolveIssuesHost(this);
      if (!host || !host.worldStore) return;
      if (!this._issuesRequestGate) {
        this._issuesRequestGate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_requestGate_js__["a" /* createRequestGate */])();
      }
      this._issuesRequestGate.begin();
      var types = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesSummaryFetch_js__["a" /* computeWatchdogTypesForItemsFetch */])(this, host);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesSummaryFetch_js__["b" /* fetchSummaryItemsForTypes */])(this, host, types, function () {});
    },

    onIssuesSummaryRefreshRequest: function onIssuesSummaryRefreshRequest() {
      var host = resolveIssuesHost(this);
      if (!host || !host.worldStore) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesSummaryFetch_js__["c" /* refreshIssuesSummaryQuiet */])(this, host, function () {});
    },

    runIssuesSummaryFetch: function runIssuesSummaryFetch() {
      var self = this;
      if (self._issuesSummaryFetchInFlight) return;

      var host = resolveIssuesHost(self);
      if (!host || !host.worldStore) {
        console.error('[IssuesPage] No Issues host with worldStore (expected IndexPage ancestor)');
        self.error = 'Unable to load alerts';
        self.loading = false;
        return;
      }

      self.loading = true;
      self.error = null;
      self.issueProductsMap = {};
      self._issuesSummaryFetchInFlight = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesSummaryFetch_js__["d" /* runIssuesSummaryFetchCore */])(self, host, function () {
        self._issuesSummaryFetchInFlight = false;
      });
    },

    updateTimeAgo: function updateTimeAgo() {
      if (!this.lastUpdateTime) {
        this.lastUpdated = 'just now';
        return;
      }

      var now = Date.now();
      var diff = Math.floor((now - this.lastUpdateTime) / 1000);

      if (diff < 60) {
        this.lastUpdated = diff + 's ago';
      } else if (diff < 3600) {
        var minutes = Math.floor(diff / 60);
        this.lastUpdated = minutes + 'm ago';
      } else {
        var hours = Math.floor(diff / 3600);
        this.lastUpdated = hours + 'h ago';
      }
    },
    startTimer: function startTimer() {
      var self = this;
      this.lastUpdateTime = Date.now();
      this.lastUpdated = 'just now';

      this.timerInterval = setInterval(function () {
        self.updateTimeAgo();
      }, 1000);
    },
    loadWatchdogsData: function loadWatchdogsData() {
      this.fetchWatchdogsData();
    },
    updateFilters: function updateFilters() {
      var ws = this.issuesWorldStore;
      if (ws) {
        var marketplaces = [];
        var addMp = function addMp(mp) {
          if (mp == null || mp === '') return;
          var m = String(mp).trim().toUpperCase();
          if (m === 'GB') m = 'UK';
          if (marketplaces.indexOf(m) < 0) marketplaces.push(m);
        };
        var products = ws.products || {};
        var productKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(products);
        for (var i = 0; i < productKeys.length; i++) {
          var p = products[productKeys[i]];
          if (p && p.marketplace) addMp(p.marketplace);
        }
        var sellerMpFromApi = this.issuesSellerMarketplaceCodes || [];
        for (var s = 0; s < sellerMpFromApi.length; s++) {
          addMp(sellerMpFromApi[s]);
        }
        var canonicalOrder = this.filterCountriesAll.filter(function (c) {
          return c !== 's';
        });
        var canonicalSet = {};
        for (var k = 0; k < canonicalOrder.length; k++) {
          canonicalSet[canonicalOrder[k]] = true;
        }var sorted = [];
        for (var o = 0; o < canonicalOrder.length; o++) {
          if (marketplaces.indexOf(canonicalOrder[o]) >= 0) sorted.push(canonicalOrder[o]);
        }
        for (var m = 0; m < marketplaces.length; m++) {
          if (!canonicalSet[marketplaces[m]] && sorted.indexOf(marketplaces[m]) < 0) {
            sorted.push(marketplaces[m]);
          }
        }
        this.filterUserCountries = sorted;
        if (this.filterByMarket.length > 0) {
          var ms = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.filterUserCountries);
          this.filterByMarket = this.filterByMarket.filter(function (x) {
            return ms.has(x);
          });
        }
        var v1 = this.issuesV1SellerRows;
        var saCount = v1 != null && v1.length > 0 ? v1.length : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(ws.sellerAccounts || {}).length;
        this.filterShowSASelector = saCount > 1;
        this.initDropdowns();
      }
    },
    loadIssuesV1Sellers: function loadIssuesV1Sellers() {
      var self = this;
      if (self.issuesV1SellerRows !== null) return;
      if (self._issuesV1SellersPromise) return;
      var sellersPromise = self.$root.loadV1Sellers ? self.$root.loadV1Sellers() : self.$http.get('/api/v1/sellers').then(function (res) {
        return res.body || {};
      });
      self._issuesV1SellersPromise = sellersPromise.then(function (body) {
        body = body || {};
        self.issuesV1SellerRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(body));
        self.issuesSellerMarketplaceCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["g" /* extractMarketplaceCodesFromV1SellersBody */])(body);
        self.updateFilters();
      }, function () {
        self.issuesV1SellerRows = [];
        self.issuesSellerMarketplaceCodes = [];
        self.updateFilters();
      }).then(function () {
        self._issuesV1SellersPromise = null;
      }, function () {
        self._issuesV1SellersPromise = null;
      });
    },

    parseDropdownMulti: function parseDropdownMulti(v) {
      if (v === '' || v === null || v === undefined || v === false) return [];
      if (Array.isArray(v)) return v.map(String).filter(function (s) {
        return s.length > 0;
      });
      if (typeof v === 'string') {
        if (!v.trim()) return [];
        return v.split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean);
      }
      return [];
    },

    hideIssuesNavbarDropdown: function hideIssuesNavbarDropdown(refKey) {
      this.forceCloseIssuesNavbarDropdown(refKey);
    },

    forceCloseIssuesNavbarDropdown: function forceCloseIssuesNavbarDropdown(refKey) {
      var self = this;
      function doClose() {
        var root = self.$refs[refKey];
        if (!root) return;
        var $el = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(root);
        try {
          $el.dropdown('hide');
        } catch (err) {}
        try {
          $el.removeClass('active');
          $el.find('.menu').removeClass('visible');
          $el.find('.menu.transition').removeClass('visible');
        } catch (e2) {}
        try {
          $el.find('input.search').blur();
        } catch (blErr) {}
        var active = document.activeElement;
        if (active && root.contains(active)) {
          try {
            active.blur();
          } catch (e3) {}
        }
      }
      self.$nextTick(function () {
        doClose();
        setTimeout(doClose, 0);
        setTimeout(doClose, 10);
        setTimeout(doClose, 80);
      });
    },

    bindIssuesMultiDropdownCloseOnPick: function bindIssuesMultiDropdownCloseOnPick(refKey) {
      var self = this;
      var root = self.$refs[refKey];
      if (!root) return;
      var $root = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(root);
      $root.off('mouseup.skIssuesDdClose touchend.skIssuesDdClose');
      function scheduleClose() {
        setTimeout(function () {
          self.forceCloseIssuesNavbarDropdown(refKey);
        }, 10);
      }
      $root.on('mouseup.skIssuesDdClose touchend.skIssuesDdClose', '.menu .item:not(.divider)', function (e) {
        if (e.target && e.target.closest && e.target.closest('.divider')) return;
        scheduleClose();
      });
    },

    syncIssuesNavbarDropdownSummaryTexts: function syncIssuesNavbarDropdownSummaryTexts() {
      var self = this;
      self.$nextTick(function () {
        if (self.$refs.filterC) {
          var el = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterC).find('.issues-navbar-dd-summary').first();
          if (el.length) el.text('Marketplaces: ' + self.marketplacesFilterLabel);
        }
        if (self.$refs.filterSA) {
          var el2 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterSA).find('.issues-navbar-dd-summary').first();
          if (el2.length) el2.text('S.Accounts: ' + self.sellerAccountsFilterLabel);
        }
      });
    },
    initDropdowns: function initDropdowns() {
      var self = this;
      self._silenceDropdownChange = true;
      this.$nextTick(function () {
        if (self.$refs.filterC) {
          var $filterC = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterC);
          try {
            $filterC.off('mouseup.skIssuesDdClose touchend.skIssuesDdClose');
          } catch (eOff) {}
          try {
            $filterC.off('click.skIssuesLblDel');
          } catch (eOff2) {}
          try {
            $filterC.dropdown('destroy');
          } catch (e) {}
          $filterC.dropdown({
            fullTextSearch: true,
            onChange: function onChange(v) {
              if (self._silenceDropdownChange) return;
              setTimeout(function () {
                var raw = v;
                try {
                  raw = $filterC.dropdown('get value');
                } catch (eGet) {}
                self.filterByMarket = self.parseDropdownMulti(raw);
                self.syncIssuesNavbarDropdownSummaryTexts();
                self.fetchWatchdogsData();
                self.syncIssuesRouteQuery();
              }, 0);
            }
          });
          self.bindIssuesMultiDropdownCloseOnPick('filterC');
        }
        if (self.$refs.filterSA) {
          var $filterSA = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterSA);
          try {
            $filterSA.off('mouseup.skIssuesDdClose touchend.skIssuesDdClose');
          } catch (eOffSa) {}
          try {
            $filterSA.off('click.skIssuesLblDel');
          } catch (eOffSa2) {}
          try {
            $filterSA.dropdown('destroy');
          } catch (e) {}
          $filterSA.dropdown({
            fullTextSearch: true,
            onChange: function onChange(v) {
              if (self._silenceDropdownChange) return;
              setTimeout(function () {
                var raw = v;
                try {
                  raw = $filterSA.dropdown('get value');
                } catch (eGet) {}
                var vals = self.parseDropdownMulti(raw);
                self.filterBySellAcc = vals.map(function (x) {
                  var n = Number(x);
                  return isNaN(n) ? x : n;
                });
                self.syncIssuesNavbarDropdownSummaryTexts();
                self.fetchWatchdogsData();
                self.syncIssuesRouteQuery();
              }, 0);
            }
          });
          self.bindIssuesMultiDropdownCloseOnPick('filterSA');
        }
        if (self.$refs.filterDate) {
          try {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterDate).dropdown('destroy');
          } catch (e) {}
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterDate).dropdown({
            onChange: function onChange(v) {
              if (self._silenceDropdownChange) return;
              if (v === 'custom') {
                self.openCustomDateRange();
                self.hideIssuesNavbarDropdown('filterDate');
                return;
              }
              self.showCustomDatePicker = false;
              if (v) self.dateRange = v;
              self.issuesListPage = 1;
              self.fetchWatchdogsData();
              self.syncIssuesRouteQuery();
              self.hideIssuesNavbarDropdown('filterDate');
            }
          });
          var dr = self.dateRange === 'all time' ? 'all' : self.dateRange;
          try {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterDate).dropdown('set selected', dr);
          } catch (e2) {}
          self.syncCustomDateDropdownText();
        }
        try {
          if (self.$refs.filterC) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterC).dropdown('set selected', (self.filterByMarket || []).map(String).join(',') || '');
          }
        } catch (efc) {}
        try {
          if (self.$refs.filterSA) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterSA).dropdown('set selected', (self.filterBySellAcc || []).map(String).join(',') || '');
          }
        } catch (efsa) {}
        self.syncIssuesNavbarDropdownSummaryTexts();
        setTimeout(function () {
          self._silenceDropdownChange = false;
        }, 0);
      });
    },
    scrollIssuesListToCategory: function scrollIssuesListToCategory(wdtype) {
      if (!wdtype) return;
      this.$nextTick(function () {
        var el = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('[data-wdtype=' + wdtype + ']')[0];
        if (!el) return;
        var elY = 0;
        for (var p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) {
          elY += p.offsetTop;
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body,html').stop().animate({ scrollTop: Math.max(0, elY - 100) }, 300);
      });
    },
    buildIssuesRouteQuery: function buildIssuesRouteQuery() {
      var o = {};
      if (!this.activeCategory) o.category = 'all';else o.category = this.activeCategory;
      if (this.filterByMarket.length) o.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length) o.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      if (this.dateRange && this.dateRange !== 'all') o.dateRange = this.dateRange;
      if (this.dateRange === 'custom') {
        o.startDate = this.customDateStart;
        o.endDate = this.customDateEnd;
      }
      if (this.issuesListTab && this.issuesListTab !== 'active') o.tab = this.issuesListTab;
      if (this.highlightedAlertId) o.alertId = this.highlightedAlertId;
      return o;
    },
    syncIssuesRouteQuery: function syncIssuesRouteQuery() {
      if (this._applyingIssuesRouteQuery || this.$route.path !== '/issues') return;
      var next = this.buildIssuesRouteQuery();
      if (shallowEqualIssuesQuery(next, this.$route.query)) return;
      this.$router.replace({ path: '/issues', query: next });
    },
    applyIssuesRouteQuery: function applyIssuesRouteQuery(q) {
      if (!q || (typeof q === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(q)) !== 'object') return false;
      var has = false;
      for (var i = 0; i < ISSUES_URL_KEYS.length; i++) {
        var k = ISSUES_URL_KEYS[i];
        if (q[k] != null && q[k] !== '') {
          has = true;
          break;
        }
      }
      if (!has && (q.type || q.id || q.watchDogId || q.watchdog_id)) has = true;
      if (!has) return false;

      this._applyingIssuesRouteQuery = true;
      try {
        if (!Object.prototype.hasOwnProperty.call(q, 'category')) this.activeCategory = 'lostBuybox';
        if (!Object.prototype.hasOwnProperty.call(q, 'marketplaces')) this.filterByMarket = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'sellerAccounts')) this.filterBySellAcc = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'dateRange')) this.dateRange = 'all';
        if (!Object.prototype.hasOwnProperty.call(q, 'tab')) this.issuesListTab = 'active';

        if (Object.prototype.hasOwnProperty.call(q, 'category')) {
          var catRaw = q.category;
          if (Array.isArray(catRaw)) catRaw = catRaw[0];
          var catStr = catRaw != null ? String(catRaw).trim() : '';
          if (!catStr || catStr === 'all') this.activeCategory = '';else this.activeCategory = catStr;
        } else if (q.type) {
          var fromType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_alertEmailDeepLink_js__["b" /* categoryFromAlertEmailType */])(q.type);
          if (fromType) this.activeCategory = fromType;
        }
        var deepId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_alertEmailDeepLink_js__["c" /* alertIdFromQuery */])(q);
        this.highlightedAlertId = deepId;
        this.issuesFocusPending = !!deepId;
        if (Object.prototype.hasOwnProperty.call(q, 'marketplaces') && q.marketplaces) {
          this.filterByMarket = String(q.marketplaces).split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean);
        }
        if (Object.prototype.hasOwnProperty.call(q, 'sellerAccounts') && q.sellerAccounts) {
          this.filterBySellAcc = String(q.sellerAccounts).split(',').map(function (s) {
            var t = s.trim();
            if (!t) return null;
            var n = Number(t);
            return isNaN(n) ? t : n;
          }).filter(function (id) {
            return id != null && id !== '';
          });
        }
        if (Object.prototype.hasOwnProperty.call(q, 'dateRange') && q.dateRange) this.dateRange = q.dateRange;
        if (this.dateRange === 'custom') {
          if (isValidCustomRange(q.startDate, q.endDate)) {
            this.customDateStart = String(q.startDate);
            this.customDateEnd = String(q.endDate);
          } else {
            this.dateRange = 'all';
          }
        }
        if ((q.tab === 'active' || q.tab === 'resolved') && !(this.issuesResolvedHidden && q.tab === 'resolved')) {
          this.issuesListTab = q.tab;
        } else if (this.issuesResolvedHidden) {
          this.issuesListTab = 'active';
        }

        if (Object.prototype.hasOwnProperty.call(q, 'category')) {
          var cRaw = q.category;
          if (Array.isArray(cRaw)) cRaw = cRaw[0];
          var c = cRaw != null ? String(cRaw).trim() : '';
          this._pendingIssuesScrollCategory = c && c !== 'all' ? c : null;
        } else if (this.activeCategory) {
          this._pendingIssuesScrollCategory = this.activeCategory;
        }
      } finally {
        var self = this;
        this.$nextTick(function () {
          self._applyingIssuesRouteQuery = false;
        });
      }
      return true;
    },
    onIssuesTabChange: function onIssuesTabChange(tab) {
      if (this.issuesResolvedHidden && tab === 'resolved') return;
      if (this.issuesListTab === tab) return;
      this.issuesListTab = tab;
      this.issuesListPage = 1;
      this.issuesFocusPending = false;
      this.syncIssuesRouteQuery();
      this.scheduleIssuesSummaryItemsOnly();
    },

    onAlertCountsDelta: function onAlertCountsDelta(delta) {
      if (!delta || !delta.watchdog_type) return;
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_watchdogSummaryApi_js__["d" /* watchdogTypeFromApi */])(delta.watchdog_type);
      if (!key) return;
      var cur = this.summaryAlertCounts && this.summaryAlertCounts[key] || { red: 0, yellow: 0 };
      var next = {
        red: Math.max(0, (cur.red || 0) + (Number(delta.red) || 0)),
        yellow: Math.max(0, (cur.yellow || 0) + (Number(delta.yellow) || 0))
      };
      this.$set(this.summaryAlertCounts, key, next);
      this.$forceUpdate();
    },
    onIssuesPageChange: function onIssuesPageChange(page) {
      var next = parseInt(page, 10);
      if (!next || next < 1 || next === this.issuesListPage) return;
      this.issuesListPage = next;
      this.issuesFocusPending = false;
      this.scheduleIssuesSummaryItemsOnly();
    },
    onIssuesFeeDirectionChange: function onIssuesFeeDirectionChange(direction) {
      var next = direction === 'increase' || direction === 'decrease' ? direction : '';
      if (next === this.issuesFeeDirection) return;
      this.issuesFeeDirection = next;
      this.issuesListPage = 1;
      this.issuesFocusPending = false;
      this.scheduleIssuesSummaryItemsOnly();
    },
    openCustomDateRange: function openCustomDateRange() {
      this.customDraftStart = this.customDateStart || isoDateDaysAgo(29);
      this.customDraftEnd = this.customDateEnd || isoDateDaysAgo(0);
      this.showCustomDatePicker = true;
    },
    applyCustomDateRange: function applyCustomDateRange() {
      if (!this.customDraftValid) return;
      this.customDateStart = this.customDraftStart;
      this.customDateEnd = this.customDraftEnd;
      this.dateRange = 'custom';
      this.showCustomDatePicker = false;
      this.syncCustomDateDropdownText();
      this.issuesListPage = 1;
      this.fetchWatchdogsData();
      this.syncIssuesRouteQuery();
    },

    syncCustomDateDropdownText: function syncCustomDateDropdownText() {
      if (this.dateRange !== 'custom' || !this.$refs.filterDate) return;
      try {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.filterDate).dropdown('set text', 'Date Range: ' + this.dateRangeLabel);
      } catch (e) {}
    },

    cancelCustomDateRange: function cancelCustomDateRange() {
      this.showCustomDatePicker = false;
      var self = this;
      self._silenceDropdownChange = true;
      try {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(self.$refs.filterDate).dropdown('set selected', self.dateRange === 'all time' ? 'all' : self.dateRange);
      } catch (e) {}
      self.syncCustomDateDropdownText();
      self.$nextTick(function () {
        self._silenceDropdownChange = false;
      });
    },
    onIssuesSearchChange: function onIssuesSearchChange(query) {
      var next = query == null ? '' : String(query);
      if (next === this.issuesSearchQuery) return;
      this.issuesSearchQuery = next;
      this.issuesListPage = 1;
      this.issuesFocusPending = false;
      var self = this;
      if (self._issuesSearchDebounce) clearTimeout(self._issuesSearchDebounce);
      self._issuesSearchDebounce = setTimeout(function () {
        self._issuesSearchDebounce = null;
        self.scheduleIssuesSummaryItemsOnly();
      }, 300);
    },
    onMarketplaceColumnFilter: function onMarketplaceColumnFilter(codes) {
      var next = (codes || []).map(__WEBPACK_IMPORTED_MODULE_11__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */]).filter(Boolean);
      this.filterByMarket = next;
      this._silenceDropdownChange = true;
      try {
        if (this.$refs.filterC) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.filterC).dropdown('set selected', next.join(',') || '');
        }
      } catch (e) {}
      this.syncIssuesNavbarDropdownSummaryTexts();
      var self = this;
      this.$nextTick(function () {
        self._silenceDropdownChange = false;
      });
      this.fetchWatchdogsData();
      this.syncIssuesRouteQuery();
    },
    tryFocusDeepLinkedAlert: function tryFocusDeepLinkedAlert() {
      var id = this.highlightedAlertId;
      if (!id) return;
      var found = this.findAlertAcrossWatchdogs(id);
      if (found) {
        if (found.wdtype && this.activeCategory !== found.wdtype) {
          this.activeCategory = found.wdtype;
          this.syncIssuesRouteQuery();
        }
        var onResolved = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_issuesAlertFilters_js__["b" /* isIssuesResolvedTabItem */])(found.item);
        var onActive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_issuesAlertFilters_js__["c" /* isIssuesActiveTabItem */])(found.item);
        if (onResolved && !this.issuesResolvedHidden && this.issuesListTab !== 'resolved') {
          this.issuesListTab = 'resolved';
          this.syncIssuesRouteQuery();
        } else if ((onActive || this.issuesResolvedHidden) && this.issuesListTab !== 'active') {
          this.issuesListTab = 'active';
          this.syncIssuesRouteQuery();
        }
      }
      this.$nextTick(function () {
        var el = document.querySelector('[data-alert-id="' + String(id).replace(/"/g, '') + '"]');
        if (!el) return;
        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        var elY = 0;
        for (var p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) {
          elY += p.offsetTop;
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body,html').stop().animate({ scrollTop: Math.max(0, elY - 120) }, 300);
      });
    },
    findAlertAcrossWatchdogs: function findAlertAcrossWatchdogs(alertId) {
      var ws = this.issuesWorldStore;
      if (!ws || !ws.watchDogs) return null;
      var types = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(ws.watchDogs);
      for (var i = 0; i < types.length; i++) {
        var wd = ws.watchDogs[types[i]];
        var items = wd && wd.items ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(wd.items) : [];
        for (var j = 0; j < items.length; j++) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_alertEmailDeepLink_js__["d" /* itemMatchesAlertId */])(items[j], alertId)) {
            return { wdtype: types[i], item: items[j] };
          }
        }
      }
      return null;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.path !== '/issues') return;
      if (this._applyingIssuesRouteQuery) return;

      if (from && from.path === to.path && shallowEqualIssuesQuery(from.query, to.query)) return;

      var prevQ = from && from.query ? from.query : {};
      var nextQ = to.query || {};
      var catOnly = !!(from && from.path === to.path && categoryQueryOnlyChange(prevQ, nextQ));
      var countsReady = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.summaryAlertCounts || {}).length > 0;

      this.applyIssuesRouteQuery(to.query);
      if (catOnly && countsReady) {
        this.issuesListPage = 1;
        this.issuesFocusPending = false;
        this.scheduleIssuesSummaryItemsOnly();
      } else {
        this.fetchWatchdogsData();
      }
    },
    sellerAccountsList: function sellerAccountsList() {
      this.$nextTick(this.initDropdowns);
    }
  },
  created: function created() {
    this.applyIssuesRouteQuery(this.$route.query);
  },
  mounted: function mounted() {
    this.startTimer();
    this.loadIssuesV1Sellers();
    this.updateFilters();
    this.initDropdowns();
    this.loadWatchdogsData();
    var self = this;
    this.$nextTick(function () {
      self.syncIssuesRouteQuery();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this._issuesFetchDebounce) {
      clearTimeout(this._issuesFetchDebounce);
      this._issuesFetchDebounce = null;
    }
    if (this._issuesItemsFetchDebounce) {
      clearTimeout(this._issuesItemsFetchDebounce);
      this._issuesItemsFetchDebounce = null;
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_googleSignIn__ = __webpack_require__(98);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      keepMeSignedIn: true,
      showPassword: false,
      error: '',
      working: false
    };
  },
  created: function created() {
    var reason = this.$route.query.sso_error;
    if (reason) {
      this.error = __WEBPACK_IMPORTED_MODULE_2__utils_googleSignIn__["a" /* GOOGLE_SSO_ERROR_MESSAGES */][reason] || __WEBPACK_IMPORTED_MODULE_2__utils_googleSignIn__["a" /* GOOGLE_SSO_ERROR_MESSAGES */].google_failed;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_error', provider: 'google', reason: String(reason) });
    }
  },
  methods: {
    continueWithGoogle: function continueWithGoogle() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_googleSignIn__["b" /* startGoogleSignIn */])('login', '/login');
    },
    login: function login() {
      var _this = this;

      this.working = true;
      this.error = '';
      this.$http.post('/api/auth/login/standard', {
        email: this.email,
        password: this.password,
        keepMeSignedIn: this.keepMeSignedIn
      }).then(function () {
        _this.working = false;
        _this.$root.pendingPostCredentialsRedirect = true;
        _this.$root.checkIfAuthenticated();
      }, function (response) {
        _this.working = false;
        _this.error = response.body.message || 'Login failed. Please check your credentials.';
        setTimeout(function () {
          _this.error = '';
        }, 9000);
      });
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      email: '',
      password: '',
      keepMeSignedIn: true,
      error: '',
      working: false
    };
  },
  methods: {
    nextButtonPress: function nextButtonPress() {
      this.$router.push('/settings');
    }
  },
  mounted: function mounted() {},
  created: function created() {
    if (window.location.hostname.includes('sentrykit')) {
      window.hj('event', 'new_pricing_redeemed_ev');
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      password: '',
      password2: '',
      showPassword: false,
      showPassword2: false,
      error: '',
      message: '',
      working: false
    };
  },
  computed: {
    passwordWeak: function passwordWeak() {
      var regex1 = /.*[_\- !"?$%^&*()+={}[\]:;@'~#|<>,.?\\/0123456789].*/;
      var regex2 = /.*[a-zA-Z].*/;
      return this.password.length < 8 || !regex1.test(this.password) || !regex2.test(this.password);
    },
    passwordMismatch: function passwordMismatch() {
      return this.password2 !== this.password;
    },
    isFormValid: function isFormValid() {
      return this.password.length >= 8 && !this.passwordWeak && !this.passwordMismatch;
    }
  },
  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      if (!this.isFormValid) return;
      this.working = true;
      this.error = '';
      this.$http.post('/api/auth/resetpassword', {
        newPassword: this.password,
        passwordResetToken: this.$route.query.token
      }).then(function () {
        _this.message = 'Your password has been successfully changed. Redirecting to login...';
        _this.working = false;
        setTimeout(function () {
          _this.$router.push('/login');
        }, 2000);
      }, function (response) {
        _this.error = response.body.message || 'Failed to reset password. Please try again.';
        _this.working = false;
        setTimeout(function () {
          _this.error = '';
        }, 5000);
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pricing_costs_DefaultMarginTargetSection_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pricing_costs_DefaultMarginTargetSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pricing_costs_DefaultMarginTargetSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pricing_costs_BulkImportSection_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pricing_costs_BulkImportSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pricing_costs_BulkImportSection_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PricingCostsPage',
  components: {
    DefaultMarginTargetSection: __WEBPACK_IMPORTED_MODULE_0__components_pricing_costs_DefaultMarginTargetSection_vue___default.a,
    BulkImportSection: __WEBPACK_IMPORTED_MODULE_1__components_pricing_costs_BulkImportSection_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      downloading: false,
      uploading: false,
      uploadedFile: null,
      successMessage: '',
      errorMessage: '',
      settings: {
        defaultMarginPercentage: 20.0,
        floorPriceAlertEnabled: true
      },
      statistics: {
        totalProducts: 0,
        costsSet: 0,
        missingCosts: 0,
        percentageSet: 0
      },
      formulaDescription: 'Floor Price = (Landed Cost + Amazon Fees) ÷ (1 - Margin%)',
      formulaExample: {
        landed_cost: 10.50,
        amazon_fees: 7.52,
        margin_percentage: 20.0,
        result: 22.53
      },
      appliedFullPageBodyBg: false
    };
  },
  computed: {
    inSettingsHub: function inSettingsHub() {
      return this.$route.name === 'SettingsBulkCogs';
    }
  },
  mounted: function mounted() {
    this.appliedFullPageBodyBg = !this.inSettingsHub;
    if (this.appliedFullPageBodyBg) {
      document.body.style.backgroundColor = '#ffffff';
      document.body.style.background = '#ffffff';
    }
    this.loadSettings();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.appliedFullPageBodyBg) {
      document.body.style.backgroundColor = '';
      document.body.style.background = '';
    }
  },
  methods: {
    onCancel: function onCancel() {
      if (this.inSettingsHub) {
        this.$router.push('/settings/product-tracking');
      } else {
        this.$router.push('/home');
      }
    },
    loadSettings: function loadSettings() {
      var _this = this;

      this.loading = true;
      this.errorMessage = '';

      this.$http.get('/api/v1/pricing_costs/settings').then(function (response) {
        _this.loading = false;
        if (response.body) {
          var data = response.body;

          if (data.default_margin_target) {
            _this.settings.defaultMarginPercentage = data.default_margin_target.minimum_margin_percentage || 20.0;
            _this.settings.floorPriceAlertEnabled = data.default_margin_target.floor_price_alert_enabled !== false;

            if (data.default_margin_target.formula && data.default_margin_target.formula.example) {
              var example = data.default_margin_target.formula.example;
              _this.formulaDescription = data.default_margin_target.formula.description || _this.formulaDescription;
              _this.formulaExample = {
                landed_cost: example.landed_cost || 10.50,
                amazon_fees: example.amazon_fees || 7.52,
                margin_percentage: example.margin_percentage || 20.0,
                result: example.result || 22.53
              };
            }
          }

          if (data.bulk_import && data.bulk_import.statistics) {
            _this.statistics = {
              totalProducts: data.bulk_import.statistics.total_products || 0,
              costsSet: data.bulk_import.statistics.costs_set || 0,
              missingCosts: data.bulk_import.statistics.missing_costs || 0,
              percentageSet: data.bulk_import.statistics.percentage_set || 0
            };
          }
        }
      }, function (error) {
        _this.loading = false;
        console.error('Error loading pricing & costs settings:', error);
        if (error.body && error.body.error) {
          _this.errorMessage = error.body.error;
        } else {
          _this.errorMessage = 'Failed to load settings. Please try again.';
        }
      });
    },
    onMarginChange: function onMarginChange(value) {
      this.settings.defaultMarginPercentage = value;
    },
    onToggleChange: function onToggleChange(checked) {
      this.settings.floorPriceAlertEnabled = checked;
    },
    downloadCSVTemplate: function downloadCSVTemplate() {
      var _this2 = this;

      this.downloading = true;
      this.errorMessage = '';

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/v1/pricing_costs/csv_template', true);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        _this2.downloading = false;

        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;

          var contentDisposition = xhr.getResponseHeader('Content-Disposition');
          var filename = 'product_costs_import_' + new Date().toISOString().split('T')[0] + '.csv';

          if (contentDisposition) {
            var filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          _this2.successMessage = 'CSV template downloaded successfully!';
        } else {
          var _blob = xhr.response;
          var reader = new FileReader();
          reader.onload = function () {
            var errorMsg = 'Failed to download CSV template. Please try again.';
            try {
              var errorJson = JSON.parse(reader.result);
              errorMsg = errorJson.error || errorMsg;
            } catch (e) {}
            _this2.errorMessage = errorMsg;
          };
          reader.readAsText(_blob);
        }
      };

      xhr.onerror = function () {
        _this2.downloading = false;
        _this2.errorMessage = 'Failed to download CSV template. Please check your connection and try again.';
      };

      xhr.send();
    },
    handleFileSelected: function handleFileSelected(file) {
      this.uploadedFile = file;
      this.errorMessage = '';
    },
    handleFileRemoved: function handleFileRemoved() {
      this.uploadedFile = null;
    },
    handleError: function handleError(errorMessage) {
      this.errorMessage = errorMessage;
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      if (!this.uploadedFile) {
        this.errorMessage = 'Please select a file to upload';
        return;
      }

      this.uploading = true;
      this.errorMessage = '';
      this.successMessage = '';

      var formData = new FormData();
      formData.append('file', this.uploadedFile);

      this.$http.post('/api/v1/pricing_costs/bulk_import', formData).then(function (response) {
        _this3.uploading = false;

        if (response.body && response.body.success) {
          var stats = response.body.statistics || {};
          var message = 'Import completed! Processed: ' + (stats.processed || 0) + ', Updated: ' + (stats.updated || 0) + ', Skipped: ' + (stats.skipped || 0);

          if (response.body.import_errors && response.body.import_errors.length > 0) {
            var errorCount = response.body.import_errors.length;
            _this3.errorMessage = errorCount + ' row(s) had errors. Please check the file and try again.';
          } else {
            _this3.successMessage = message;
          }

          _this3.loadSettings();

          _this3.uploadedFile = null;

          if (_this3.saving) {
            _this3.saveSettingsAfterUpload();
          }
        } else {
          _this3.errorMessage = 'Import failed. Please try again.';
          _this3.saving = false;
        }
      }, function (error) {
        _this3.uploading = false;
        console.error('Error uploading file:', error);

        if (error.body && error.body.error) {
          _this3.errorMessage = error.body.error;
        } else if (error.body && error.body.errors && Array.isArray(error.body.errors)) {
          _this3.errorMessage = error.body.errors.join(', ');
        } else {
          _this3.errorMessage = 'Failed to upload file. Please try again.';
        }
        _this3.saving = false;
      });
    },
    saveSettingsAfterUpload: function saveSettingsAfterUpload() {
      var _this4 = this;

      var payload = {
        minimum_margin_percentage: this.settings.defaultMarginPercentage,
        floor_price_alert_enabled: this.settings.floorPriceAlertEnabled
      };

      this.$http.put('/api/v1/pricing_costs/settings', payload).then(function (response) {
        _this4.saving = false;

        if (response.body && response.body.success) {
          if (!_this4.successMessage) {
            _this4.successMessage = 'Settings saved successfully!';
          }
        } else {
          _this4.errorMessage = 'Failed to save settings. Please try again.';
        }
      }, function (error) {
        _this4.saving = false;
        console.error('Error saving settings:', error);

        if (error.body && error.body.errors && Array.isArray(error.body.errors)) {
          _this4.errorMessage = error.body.errors.join(', ');
        } else if (error.body && error.body.error) {
          _this4.errorMessage = error.body.error;
        } else {
          _this4.errorMessage = 'Failed to save settings. Please try again.';
        }
      });
    },
    saveSettings: function saveSettings() {
      var _this5 = this;

      if (this.settings.defaultMarginPercentage < 0 || this.settings.defaultMarginPercentage > 100) {
        this.errorMessage = 'Margin percentage must be between 0 and 100';
        return;
      }

      this.saving = true;
      this.errorMessage = '';
      this.successMessage = '';

      var payload = {
        minimum_margin_percentage: this.settings.defaultMarginPercentage,
        floor_price_alert_enabled: this.settings.floorPriceAlertEnabled
      };

      if (this.uploadedFile) {
        this.uploadFile();

        return;
      }

      this.$http.put('/api/v1/pricing_costs/settings', payload).then(function (response) {
        _this5.saving = false;

        if (response.body && response.body.success) {
          _this5.successMessage = 'Settings saved successfully!';
        } else {
          _this5.errorMessage = 'Failed to save settings. Please try again.';
        }
      }, function (error) {
        _this5.saving = false;
        console.error('Error saving settings:', error);

        if (error.body && error.body.errors && Array.isArray(error.body.errors)) {
          _this5.errorMessage = error.body.errors.join(', ');
        } else if (error.body && error.body.error) {
          _this5.errorMessage = error.body.error;
        } else {
          _this5.errorMessage = 'Failed to save settings. Please try again.';
        }
      });
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_productsettings_ProductSettingsPage_ProductRow__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_productsettings_ProductSettingsPage_ProductRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_productsettings_ProductSettingsPage_ProductRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productsettings_ProductSettingsPage_Pagination__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productsettings_ProductSettingsPage_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_productsettings_ProductSettingsPage_Pagination__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProductRow: __WEBPACK_IMPORTED_MODULE_4__components_productsettings_ProductSettingsPage_ProductRow___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_productsettings_ProductSettingsPage_Pagination___default.a
  },
  data: function data() {
    return {
      flattened: [],
      deepTotal: [],
      deepVisible: [],
      loadingdata: false,
      savingdata: false,
      activeCount: 0,
      originalActiveCount: 0,
      pageSize: 50,
      currentPage: 0,
      currentPageRequested: 0,
      maxPage: 0,
      productMap: {},
      accountsSetupPending: [],
      automaticallyTrackNewProducts: false,
      originalAutomaticallyTrackNewProducts: false,
      filterText: null,
      filterTextLastModifiedAt: null,
      loadError: null
    };
  },
  created: function created() {
    window.dirty = false;
  },
  mounted: function mounted() {
    this.fetchProductTrackingSettings();
  },
  watch: {
    currentPageRequested: function currentPageRequested(val) {
      this.deepVisible = this.refreshPage(val);
      this.currentPage = val;
    },
    automaticallyTrackNewProducts: function automaticallyTrackNewProducts(val) {
      if (this.originalAutomaticallyTrackNewProducts !== this.automaticallyTrackNewProducts) {
        window.dirty = true;
      }
    },
    filterText: function filterText(val) {
      var _this = this;

      var filterTextLastModifiedAt = Date.now();
      this.filterTextLastModifiedAt = filterTextLastModifiedAt;
      setTimeout(function () {
        return _this.filterTextTimedOut(val, filterTextLastModifiedAt);
      }, 500);
    }
  },
  methods: {
    productTrackingSettingsUrl: function productTrackingSettingsUrl() {
      return '/api/product/settings';
    },
    fetchProductTrackingSettings: function fetchProductTrackingSettings() {
      var _this2 = this;

      this.loadingdata = true;
      this.loadError = null;
      var url = this.productTrackingSettingsUrl();
      this.$http.get(url).then(function (response) {
        _this2.flattened = [];
        _this2.deepTotal = [];
        _this2.deepVisible = [];
        _this2.productMap = {};
        _this2.loadError = null;
        _this2.loadingdata = false;
        var body = response.body || {};
        var sellerAccounts = body.sellerAccounts || [];
        _this2.accountsSetupPending = sellerAccounts.filter(function (a) {
          return !a.setupCompleted;
        }).map(function (a) {
          return a.sellerId;
        });
        for (var i = 0; i < sellerAccounts.length; ++i) {
          var sellerAcc = sellerAccounts[i];
          _this2.deepTotal.splice(_this2.deepTotal.length, 0, sellerAcc);
          var products = sellerAcc.products || [];
          for (var j = 0; j < products.length; ++j) {
            var p = products[j];
            _this2.flattened.splice(_this2.flattened.length, 0, [i, j]);
            p['shortNameOrig'] = p.shortName;
            p['showOrig'] = p.show;
            p['activeOrig'] = p.active;
            _this2.productMap[p.productId] = p;
          }
        }
        _this2.maxPage = Math.ceil(_this2.flattened.length / _this2.pageSize) - 1;
        _this2.deepVisible = _this2.maxPage > 0 ? _this2.refreshPage(_this2.currentPage) : _this2.deepTotal;
        _this2.originalActiveCount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this2.productMap).filter(function (p) {
          return p.show;
        }).length;
        _this2.activeCount = _this2.originalActiveCount;
        _this2.originalAutomaticallyTrackNewProducts = body.automaticallyTrackNewProducts;
        _this2.automaticallyTrackNewProducts = _this2.originalAutomaticallyTrackNewProducts;
        var self = _this2;
        __WEBPACK_IMPORTED_MODULE_2_vue___default.a.nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()(self.$el).find('.dimmable').dimmer({
            closable: false
          }).dimmer('show');
        });
      }, function (err) {
        _this2.loadingdata = false;
        var msg = err.body && err.body.message || err.statusText || 'Request failed' + (err.status ? ' (' + err.status + ')' : '');
        _this2.loadError = msg;
      });
    },
    refreshPage: function refreshPage(currentPage) {
      var deepVisible = [];
      for (var i = 0; i < this.deepTotal.length; ++i) {
        var sellerAcc = this.deepTotal[i];
        deepVisible.splice(deepVisible.length, 0, { sellerId: sellerAcc.sellerId, name: sellerAcc.name, products: [] });
      }
      var flattened = this.filteredFlattened();
      for (var _i = currentPage * this.pageSize; _i < Math.min(flattened.length, (currentPage + 1) * this.pageSize); ++_i) {
        var index = flattened[_i];
        var _sellerAcc = this.deepTotal[index[0]];
        var p = _sellerAcc.products[index[1]];
        var products = deepVisible[index[0]].products;
        products.splice(products.length, 0, p);
      }
      window.dirty = false;
      if (!this.filteredText) return deepVisible.filter(function (s) {
        return s.products.length > 0;
      });
      return deepVisible;
    },
    onShortNameChange: function onShortNameChange(event) {
      var i = this.productMap[event.productId];
      if (i.shortName !== event.shortName) {
        i.shortName = event.shortName;
        window.dirty = true;
      }
    },
    onShowChange: function onShowChange(event) {
      var i = this.productMap[event.productId];
      if (i.show === event.show) {
        return;
      }
      var show = i.show;
      i.show = event.show;
      i.active = event.show !== null ? event.show : null;
      if (i.show && !show) {
        this.activeCount++;
      } else if (!i.show && show) {
        this.activeCount--;
      }
      window.dirty = true;
    },
    save: function save() {
      var _this3 = this;

      var result = [];
      var productIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.productMap);
      for (var i = 0; i < productIds.length; ++i) {
        var productId = productIds[i];
        var p = this.productMap[productId];
        var shortNameChanged = p.shortName !== p.shortNameOrig;
        var showChanged = p.show !== p.showOrig || p.activeOrig !== p.active;
        if (shortNameChanged || showChanged) {
          var r = { productId: productId };
          if (shortNameChanged) r['shortName'] = p.shortName;
          if (showChanged) {
            if (p.active === null) {
              r['ignoredUntilNextOrder'] = true;
              r['show'] = false;
            } else {
              if (p.activeOrig === null) r['ignoredUntilNextOrder'] = false;
              r['show'] = p.show;
            }
          }
          result.splice(result.length, 0, r);
        }
      }
      var data = {
        products: result,
        accountsSetupDone: this.accountsSetupPending,
        automaticallyTrackNewProducts: this.originalAutomaticallyTrackNewProducts !== this.automaticallyTrackNewProducts ? this.automaticallyTrackNewProducts : null
      };
      var hadPendingAccountSetup = this.accountsSetupPending.length > 0;
      this.savingdata = true;
      this.$http.put(this.productTrackingSettingsUrl(), data).then(function (response) {
        window.dirty = false;
        _this3.$parent.stateOfTheWorld();
        var ids = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.productMap);
        for (var _i2 = 0; _i2 < ids.length; ++_i2) {
          var _p = _this3.productMap[ids[_i2]];
          _p.shortNameOrig = _p.shortName;
          _p.showOrig = _p.show;
          _p.activeOrig = _p.active;
        }
        _this3.originalAutomaticallyTrackNewProducts = _this3.automaticallyTrackNewProducts;
        _this3.originalActiveCount = _this3.activeCount;
        _this3.accountsSetupPending = [];
        if (hadPendingAccountSetup) {
          _this3.$root.anySellerAccountSetupCompleted = true;
        }
        _this3.savingdata = false;
      }, function (response) {
        _this3.savingdata = false;
      });
    },
    exportExcel: function exportExcel() {
      window.open('/api/product/spreadsheet/v1.0/export', '_self');
    },
    importExcel: function importExcel(e) {
      var _this4 = this;

      if (!e.target.files) return;
      var formData = new FormData();
      formData.append('file', e.target.files[0], 'product-import.xlsx');
      this.$http.post('/api/product/spreadsheet/v1.0/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (resp) {
        _this4.resetFiles();
        _this4.deepTotal = [];
        _this4.deepVisible = [];
        _this4.flattened = [];
        _this4.productMap = {};
        _this4.currentPage = 0;
        _this4.activeCount = 0;
        _this4.originalActiveCount = 0;
        _this4.currentPageRequested = 0;
        _this4.maxPage = 0;
        _this4.accountsSetupPending = [];
        _this4.automaticallyTrackNewProducts = false;
        _this4.originalAutomaticallyTrackNewProducts = false;
        _this4.fetchProductTrackingSettings();
      });
    },
    resetFiles: function resetFiles() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#hidden-product-import-file').val('');
    },
    filteredFlattened: function filteredFlattened() {
      var _this5 = this;

      if (!this.filterText) return this.flattened;
      var regexp = new RegExp('^.*' + this.filterText.toLowerCase().split(' ').filter(function (a) {
        return a.length > 0;
      }).map(function (a) {
        return a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('.*') + '.*$');
      return this.flattened.filter(function (f) {
        var p = _this5.deepTotal[f[0]].products[f[1]];
        return p.asin1 && regexp.test(p.asin1.toLowerCase()) || p.shortName && regexp.test(p.shortName.toLowerCase()) || p.productName && regexp.test(p.productName.toLowerCase());
      });
    },
    filterTextTimedOut: function filterTextTimedOut(filterText, filterTextLastModifiedAt) {
      if (this.filterText !== filterText || this.filterTextLastModifiedAt !== filterTextLastModifiedAt) return;
      this.currentPage = 0;
      this.currentPageRequested = 0;
      this.maxPage = Math.ceil(this.filteredFlattened().length / this.pageSize) - 1;
      this.deepVisible = this.refreshPage(0);
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!window.dirty) {
      next();
    } else if (window.confirm('Please confirm that you want to close your Product Settings.\nYou have some unsaved changes.')) {
      window.dirty = false;
      next();
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductCard_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ProductCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ProductCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ProductTableView_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ProductTableView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ProductTableView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ProductDetails_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ProductDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ProductDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductCostMarginModal_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductCostMarginModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ProductCostMarginModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ProductDetailsChartModal_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ProductDetailsChartModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ProductDetailsChartModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_listViewUrlSync_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_productPricingMixin_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_reviewHealth_js__ = __webpack_require__(51);
























var PRODUCTS_PAGE_STORAGE_KEY = 'sentrykit_products_page_state';

var PRODUCTS_TABLE_SORT_KEYS = ['product', 'buyBox', 'rating', 'salesYesterday', 'salesToday', 'cogs', 'margin'];

var PRODUCTS_URL_KEYS = ['marketplaces', 'sellerAccounts', 'q', 'missingCogs', 'buybox', 'view', 'page', 'sort', 'sortDir'];

function shallowEqualProductsQuery(next, routeQuery) {
  for (var i = 0; i < PRODUCTS_URL_KEYS.length; i++) {
    var k = PRODUCTS_URL_KEYS[i];
    var nv = next[k] != null ? String(next[k]) : '';
    var rv = routeQuery && routeQuery[k] != null ? String(routeQuery[k]) : '';
    if (nv !== rv) return false;
  }
  return true;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductsPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_productPricingMixin_js__["a" /* default */]],
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_12__components_buybox_DashboardLayout_vue___default.a,
    ProductCard: __WEBPACK_IMPORTED_MODULE_13__components_ProductCard_vue___default.a,
    ProductTableView: __WEBPACK_IMPORTED_MODULE_14__components_ProductTableView_vue___default.a,
    ProductDetails: __WEBPACK_IMPORTED_MODULE_15__components_ProductDetails_vue___default.a,
    ProductCostMarginModal: __WEBPACK_IMPORTED_MODULE_16__components_ProductCostMarginModal_vue___default.a,
    ProductDetailsChartModal: __WEBPACK_IMPORTED_MODULE_17__components_ProductDetailsChartModal_vue___default.a
  },
  data: function data() {
    return {
      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,
      asinSearch: '',
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      filterShowSASelector: false,
      filterMissingCogs: false,
      filterByBuyBox: false,
      viewMode: 'grid',
      tableCurrentPage: 0,
      tableItemsPerPage: 20,

      gridCurrentPage: 0,
      gridPageSize: 20,
      gridTotalItems: 0,
      gridTotalPages: 1,

      apiData: null,
      loadingApiData: false,
      apiError: null,
      _syncingDropdowns: false,

      v1SellerAccountRows: null,

      v1SellersApiBody: null,
      _v1SellersPromise: null,

      tableSortKey: 'salesYesterday',
      tableSortDir: 'desc',
      _applyingProductsRouteQuery: false,
      _productsUrlTimer: null
    };
  },

  computed: {
    filteredCountries: function filteredCountries() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterUserCountries, this.filterCountriesAll);
    },
    hasWorldStore: function hasWorldStore() {
      if (this.apiData && this.apiData.products !== undefined) {
        return true;
      }
      return this.$parent && this.$parent.worldStore && this.$parent.worldStore.products !== undefined;
    },
    totalProducts: function totalProducts() {
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.totalProducts || 0;
      }

      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0;
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(this.$parent.worldStore.products).length;
    },
    cogsSetCount: function cogsSetCount() {
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.cogsSet || 0;
      }

      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.products).filter(function (p) {
        return p.cogs && p.cogs > 0;
      }).length;
    },
    cogsMissingCount: function cogsMissingCount() {
      if (this.apiData && this.apiData.summary) {
        return this.apiData.summary.missingCogs || 0;
      }

      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.products) return 0;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.products).filter(function (p) {
        return !p.cogs || p.cogs === 0;
      }).length;
    },
    sellerAccountsList: function sellerAccountsList() {
      var v1 = this.v1SellerAccountRows;
      if (v1 != null && v1.length > 0) {
        return v1.map(function (r) {
          return {
            sellerId: r.id,
            accountNickName: r.name,
            marketplace: r.marketplace
          };
        });
      }
      if (this.apiData && this.apiData.availableFilters && this.apiData.availableFilters.sellerAccounts) {
        console.log('Using seller accounts from availableFilters:', this.apiData.availableFilters.sellerAccounts);
        return this.apiData.availableFilters.sellerAccounts.map(function (sa) {
          return {
            sellerId: sa.id,
            accountNickName: sa.name,
            marketplace: sa.marketplace
          };
        });
      }

      if (this.apiData && this.apiData.products) {
        var products = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.apiData.products);
        var sellerMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
        products.forEach(function (p) {
          if (p.sellerId && !sellerMap.has(p.sellerId)) {
            sellerMap.set(p.sellerId, {
              sellerId: p.sellerId,
              accountNickName: p.sellerName || 'Account ' + p.sellerId,
              marketplace: p.marketplace
            });
          }
        });
        var accounts = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(sellerMap.values());
        console.log('Extracted seller accounts from products:', accounts);
        return accounts;
      }

      if (!this.$parent || !this.$parent.worldStore || !this.$parent.worldStore.sellerAccounts) return [];
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.sellerAccounts);
    },
    filteredProducts: function filteredProducts() {
      var _this = this;

      var products = [];

      if (this.apiData && this.apiData.products) {
        products = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.apiData.products);
      } else if (this.$parent && this.$parent.worldStore && this.$parent.worldStore.products) {
        products = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.products);
        if (this.filterByMarket.length > 0) {
          products = products.filter(function (p) {
            return _this.filterByMarket.indexOf(p.marketplace) >= 0;
          });
        }
        if (this.filterBySellAcc.length > 0) {
          products = products.filter(function (p) {
            return _this.filterBySellAcc.indexOf(p.sellerId) >= 0;
          });
        }
        if (this.filterMissingCogs) {
          products = products.filter(function (p) {
            return !p.cogs || p.cogs === 0;
          });
        }
      }
      return products;
    },
    tableTotalPages: function tableTotalPages() {
      return this.gridTotalPages;
    },
    tableProducts: function tableProducts() {
      return Array.isArray(this.filteredProducts) ? this.filteredProducts : [];
    },
    productData: function productData() {
      if (this.apiData) {
        var products = this.apiData.products || {};
        return {
          products: products,
          reds: this.apiData.reds || {},
          ambers: this.apiData.ambers || {},
          sellerAccounts: this.apiData.sellerAccounts || {},
          watchDogs: {
            inventory: { items: {} },
            buyBox: { items: {} }
          }
        };
      }

      if (this.$parent && this.$parent.worldStore && this.$parent.worldStore.products) {
        return this.$parent.worldStore;
      }
      return null;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push('/home');
    },
    navigateToProducts: function navigateToProducts() {},
    navigateToIssues: function navigateToIssues() {
      this.$router.push('/issues');
    },
    navigateToStock: function navigateToStock() {
      this.$router.push('/stock');
    },
    updateFilters: function updateFilters() {
      if (this.$parent && this.$parent.worldStore) {
        this.filterUserCountries = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.$parent.worldStore.products).map(function (i) {
          return i.marketplace;
        })));
        this.filterShowSASelector = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(this.$parent.worldStore.sellerAccounts).length > 1;
      }
    },
    openProductDetailModal: function openProductDetailModal(productIds, index) {
      if (this.$refs.productDetails) {
        this.$refs.productDetails.open(productIds, index);
      }
    },
    prevPage: function prevPage() {
      var component = this.$refs.productCard;
      if (component) component.prevPage();
    },
    nextPage: function nextPage() {
      var component = this.$refs.productCard;
      if (component) component.nextPage();
    },
    goToPage: function goToPage(page) {
      var component = this.$refs.productCard;
      if (component) component.goToPage(page);
    },
    prevGridPage: function prevGridPage() {
      if (this.gridCurrentPage > 0) {
        this.loadProductsFromBackend(this.gridCurrentPage - 1);
      }
    },
    nextGridPage: function nextGridPage() {
      if (this.gridCurrentPage < this.gridTotalPages - 1) {
        this.loadProductsFromBackend(this.gridCurrentPage + 1);
      }
    },
    goToGridPage: function goToGridPage(page) {
      if (page >= 0 && page < this.gridTotalPages) {
        this.loadProductsFromBackend(page);
      }
    },
    getGridPageNumber: function getGridPageNumber(index) {
      var currentPage = this.gridCurrentPage;
      var totalPages = this.gridTotalPages;

      if (totalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, currentPage - 2);
      var endPage = Math.min(totalPages - 1, startPage + 4);
      var adjustedStartPage = Math.max(0, endPage - 4);

      return adjustedStartPage + index - 1;
    },
    toggleMissingCogsFilter: function toggleMissingCogsFilter() {
      this.filterMissingCogs = !this.filterMissingCogs;
      this.gridCurrentPage = 0;
      this.loadProductsFromBackend(0);
    },
    toggleBuyBoxFilter: function toggleBuyBoxFilter() {
      this.filterByBuyBox = !this.filterByBuyBox;
      this.gridCurrentPage = 0;
      this.loadProductsFromBackend(0);
    },
    handleAsinSearch: function handleAsinSearch() {
      console.log('ASIN search triggered:', this.asinSearch);
      this.gridCurrentPage = 0;
      this.loadProductsFromBackend(0);
    },
    clearAsinSearch: function clearAsinSearch() {
      this.asinSearch = '';
      this.gridCurrentPage = 0;
      this.loadProductsFromBackend(0);
    },
    handleExport: function handleExport() {
      var _this2 = this;

      console.log('Export button clicked');

      var params = {};

      if (this.filterByMarket.length > 0) {
        params.marketplaces = this.filterByMarket.join(',');
      }

      if (this.filterBySellAcc.length > 0) {
        params.sellerAccounts = this.filterBySellAcc.join(',');
      }

      if (this.filterMissingCogs) {
        params.missingCogs = 'true';
      }

      if (this.filterByBuyBox) {
        params.buybox = 'true';
      }

      if (this.asinSearch && this.asinSearch.trim()) {
        params.asin = this.asinSearch.trim();
      }

      console.log('Exporting products with filters:', params);

      var queryString = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');

      var exportUrl = '/api/sentinel/products/export' + (queryString ? '?' + queryString : '');

      this.loadingApiData = true;

      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        _this2.loadingApiData = false;
        _this2.$nextTick(function () {
          return _this2.initializeDropdowns();
        });

        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;

          var contentDisposition = xhr.getResponseHeader('Content-Disposition');
          var filename = 'products_export_' + new Date().toISOString().split('T')[0] + '.csv';

          if (contentDisposition) {
            var filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          console.log('Export download completed:', filename);
        } else {
          var _blob = xhr.response;
          var reader = new FileReader();
          reader.onload = function () {
            var errorMsg = 'Failed to export products. Please try again.';
            try {
              var errorJson = JSON.parse(reader.result);
              errorMsg = errorJson.error || errorMsg;
            } catch (e) {}
            alert('Error: ' + errorMsg);
          };
          reader.readAsText(_blob);
        }
      };

      xhr.onerror = function () {
        _this2.loadingApiData = false;
        _this2.$nextTick(function () {
          return _this2.initializeDropdowns();
        });
        alert('Error: Failed to export products. Please check your connection and try again.');
      };

      xhr.send();
    },
    handleImportCogs: function handleImportCogs() {
      var _this3 = this;

      console.log('Import COGS button clicked');

      var fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.csv';
      fileInput.style.display = 'none';

      fileInput.onchange = function (event) {
        var file = event.target.files[0];
        if (!file) {
          console.log('No file selected');
          return;
        }

        console.log('File selected:', file.name);

        var formData = new FormData();
        formData.append('file', file);

        _this3.loadingApiData = true;

        _this3.$http.post('/api/sentinel/products/import', formData).then(function (response) {
          console.log('Import successful:', response);
          _this3.loadingApiData = false;

          var data = response.body || response.data;
          if (data && data.success && data.results) {
            var results = data.results;
            var message = 'Import completed!\n\n' + ('Total Rows: ' + (results.total_rows || 0) + '\n') + ('Processed: ' + (results.processed || 0) + '\n') + ('Updated: ' + (results.updated || 0) + '\n') + ('Skipped: ' + (results.skipped || 0));

            if (results.errors && results.errors.length > 0) {
              var errorList = results.errors.slice(0, 10).join('\n');
              var moreErrors = results.errors.length > 10 ? '\n... and ' + (results.errors.length - 10) + ' more errors' : '';
              alert(message + ('\n\nErrors:\n' + errorList + moreErrors));
            } else {
              alert(message);
            }
          } else {
            alert(data && data.message ? data.message : 'COGS imported successfully!');
          }
          _this3.loadProductsFromBackend(_this3.gridCurrentPage);
        }, function (error) {
          console.error('Import failed:', error);
          _this3.loadingApiData = false;

          var errorMsg = 'Failed to import COGS. Please check the file format and try again.';
          if (error.body) {
            if (error.body.error) {
              errorMsg = error.body.error;
            } else if (error.body.message) {
              errorMsg = error.body.message;
            }
          } else if (error.message) {
            errorMsg = error.message;
          }
          alert('Error: ' + errorMsg);
        });

        document.body.removeChild(fileInput);
      };

      document.body.appendChild(fileInput);
      fileInput.click();
    },
    handleCogsUpdated: function handleCogsUpdated(productId, cogsValue) {
      console.log('COGS updated for product:', productId, 'new value:', cogsValue);

      this.loadProductsFromBackend(this.gridCurrentPage);
    },
    getMarketplaceSuffix: function getMarketplaceSuffix(country) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["a" /* getMarketplaceAmazonSuffix */])(country);
    },
    showProductDetails: function showProductDetails(productId) {
      this.saveProductsPageState();
      this.flushProductsRouteQuery();
      var cleanId = String(productId).replace(/^PROD-/i, '');
      this.$router.push({ path: '/product_details', query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(cleanId, this.$route.fullPath) });
    },
    flushProductsRouteQuery: function flushProductsRouteQuery() {
      if (this._productsUrlTimer) {
        clearTimeout(this._productsUrlTimer);
        this._productsUrlTimer = null;
      }
      this.syncProductsRouteQuery();
    },
    buildProductsRouteQuery: function buildProductsRouteQuery() {
      var o = {};
      if (this.filterByMarket.length > 0) o.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length > 0) o.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      var qv = (this.asinSearch || '').trim();
      if (qv) o.q = qv;
      if (this.filterMissingCogs) o.missingCogs = '1';
      if (this.filterByBuyBox) o.buybox = '1';
      if (this.viewMode && this.viewMode !== 'grid') o.view = this.viewMode;
      if (this.gridCurrentPage > 0) o.page = String(this.gridCurrentPage);
      if (this.tableSortKey) {
        o.sort = this.tableSortKey;
        o.sortDir = this.tableSortDir || 'desc';
      }
      return o;
    },
    syncProductsRouteQuery: function syncProductsRouteQuery() {
      if (this._applyingProductsRouteQuery || this.$route.path !== '/products') return;
      var next = this.buildProductsRouteQuery();
      if (shallowEqualProductsQuery(next, this.$route.query)) return;
      this.$router.replace({ path: '/products', query: next });
    },
    scheduleProductsUrlSync: function scheduleProductsUrlSync() {
      var _this4 = this;

      if (this._productsUrlTimer) clearTimeout(this._productsUrlTimer);
      this._productsUrlTimer = setTimeout(function () {
        _this4._productsUrlTimer = null;
        _this4.syncProductsRouteQuery();
      }, 400);
    },
    applyProductsRouteQuery: function applyProductsRouteQuery(q) {
      var _this5 = this;

      if (!q || (typeof q === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(q)) !== 'object') return false;
      var has = false;
      for (var i = 0; i < PRODUCTS_URL_KEYS.length; i++) {
        var k = PRODUCTS_URL_KEYS[i];
        if (q[k] != null && q[k] !== '') {
          has = true;
          break;
        }
      }
      if (!has) return false;

      this._applyingProductsRouteQuery = true;
      try {
        if (!Object.prototype.hasOwnProperty.call(q, 'marketplaces')) this.filterByMarket = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'sellerAccounts')) this.filterBySellAcc = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'q')) this.asinSearch = '';
        if (!Object.prototype.hasOwnProperty.call(q, 'missingCogs')) this.filterMissingCogs = false;
        if (!Object.prototype.hasOwnProperty.call(q, 'buybox')) this.filterByBuyBox = false;
        if (!Object.prototype.hasOwnProperty.call(q, 'view')) this.viewMode = 'grid';
        if (!Object.prototype.hasOwnProperty.call(q, 'page')) this.gridCurrentPage = 0;
        if (!Object.prototype.hasOwnProperty.call(q, 'sort')) {
          this.tableSortKey = 'salesYesterday';
          this.tableSortDir = 'desc';
        }
        if (q.marketplaces !== undefined && q.marketplaces !== null && String(q.marketplaces).length) {
          this.filterByMarket = String(q.marketplaces).split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean);
        }
        if (q.sellerAccounts !== undefined && q.sellerAccounts !== null && String(q.sellerAccounts).length) {
          this.filterBySellAcc = String(q.sellerAccounts).split(',').map(function (s) {
            var t = s.trim();
            if (!t) return null;
            var n = Number(t);
            return isNaN(n) ? t : n;
          }).filter(function (id) {
            return id != null && id !== '';
          });
        }
        if (Object.prototype.hasOwnProperty.call(q, 'q')) {
          this.asinSearch = q.q != null && String(q.q).length ? String(q.q) : '';
        }
        if (Object.prototype.hasOwnProperty.call(q, 'missingCogs')) {
          this.filterMissingCogs = q.missingCogs === '1' || q.missingCogs === 'true';
        }
        if (Object.prototype.hasOwnProperty.call(q, 'buybox')) {
          this.filterByBuyBox = q.buybox === '1' || q.buybox === 'true';
        }
        if (q.view === 'table' || q.view === 'grid') this.viewMode = q.view;
        if (Object.prototype.hasOwnProperty.call(q, 'page') && q.page !== '' && q.page != null) {
          var p = parseInt(q.page, 10);
          if (!isNaN(p) && p >= 0) this.gridCurrentPage = p;
        }
        if (Object.prototype.hasOwnProperty.call(q, 'sort')) {
          this.tableSortKey = q.sort && PRODUCTS_TABLE_SORT_KEYS.indexOf(String(q.sort)) >= 0 ? String(q.sort) : null;
        }
        if (q.sortDir === 'asc' || q.sortDir === 'desc') this.tableSortDir = q.sortDir;
      } finally {
        this.$nextTick(function () {
          _this5._applyingProductsRouteQuery = false;
        });
      }
      return true;
    },
    saveProductsPageState: function saveProductsPageState() {
      try {
        var state = {
          asinSearch: this.asinSearch,
          filterByMarket: this.filterByMarket,
          filterBySellAcc: this.filterBySellAcc,
          filterMissingCogs: this.filterMissingCogs,
          filterByBuyBox: this.filterByBuyBox,
          viewMode: this.viewMode,
          gridCurrentPage: this.gridCurrentPage,
          tableSortKey: this.tableSortKey,
          tableSortDir: this.tableSortDir
        };
        localStorage.setItem(PRODUCTS_PAGE_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(state));
      } catch (e) {
        console.warn('Could not save products page state:', e);
      }
    },
    restoreProductsPageState: function restoreProductsPageState() {
      try {
        var raw = localStorage.getItem(PRODUCTS_PAGE_STORAGE_KEY);
        if (!raw) return;
        var state = JSON.parse(raw);
        if (!state || (typeof state === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(state)) !== 'object') return;
        if (state.asinSearch != null) this.asinSearch = String(state.asinSearch);
        if (Array.isArray(state.filterByMarket)) {
          this.filterByMarket = state.filterByMarket.filter(function (m) {
            return m != null && m !== '';
          });
        }
        if (Array.isArray(state.filterBySellAcc)) {
          this.filterBySellAcc = state.filterBySellAcc.filter(function (id) {
            return id != null && (typeof id === 'string' || typeof id === 'number' && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(id));
          });
        }
        if (typeof state.filterMissingCogs === 'boolean') this.filterMissingCogs = state.filterMissingCogs;
        if (typeof state.filterByBuyBox === 'boolean') this.filterByBuyBox = state.filterByBuyBox;
        if (state.viewMode === 'grid' || state.viewMode === 'table') this.viewMode = state.viewMode;
        if (typeof state.gridCurrentPage === 'number' && state.gridCurrentPage >= 0) {
          this.gridCurrentPage = state.gridCurrentPage;
        }
        if (Object.prototype.hasOwnProperty.call(state, 'tableSortKey')) {
          if (state.tableSortKey === null || PRODUCTS_TABLE_SORT_KEYS.indexOf(state.tableSortKey) >= 0) {
            this.tableSortKey = state.tableSortKey;
          }
        }
        if (state.tableSortDir === 'asc' || state.tableSortDir === 'desc') {
          this.tableSortDir = state.tableSortDir;
        }
      } catch (e) {
        console.warn('Could not restore products page state:', e);
      }
    },
    formatPrice: function formatPrice(price) {
      if (!price && price !== 0) return '0.00';
      return parseFloat(price).toFixed(2);
    },
    calculateMarginValue: function calculateMarginValue(product) {
      var margin = this.getProductMargin(product);
      return margin != null ? margin : 0;
    },
    calculateMarginFromCogs: function calculateMarginFromCogs(cogs, buyBoxPrice) {
      if (!cogs || !buyBoxPrice || buyBoxPrice === 0) return '0';
      var margin = (buyBoxPrice - cogs) / buyBoxPrice * 100;
      return margin.toFixed(0);
    },
    getMarginClass: function getMarginClass(margin) {
      if (margin >= 30) return 'high';
      if (margin >= 20) return 'high';
      if (margin >= 10) return 'medium';
      return 'low';
    },
    getAsin: function getAsin(product) {
      if (product.asin) return product.asin;
      if (product.productUrl) {
        var match = product.productUrl.match(/\/dp\/([A-Z0-9]+)/i);
        return match ? match[1] : '—';
      }
      return '—';
    },
    getBuyBoxStatus: function getBuyBoxStatus(product) {
      if (!product) return null;
      if (product.isSuppressed === true || product.suppressed === true) return 'suppressed';
      if (product.hasBuyBox === true && product.buyBoxWinner === 'you') return 'owned';
      if (product.hasBuyBox === false) return 'lost';
      if (product.buyBoxRotating === true) return 'rotating';
      return null;
    },
    getBuyBoxStatusClass: function getBuyBoxStatusClass(status) {
      if (!status) return '';
      var s = String(status).toLowerCase();
      if (s === 'owned') return 'buybox-owned';
      if (s === 'lost') return 'buybox-lost';
      if (s === 'suppressed') return 'buybox-suppressed';
      if (s === 'rotating') return 'buybox-rotating';
      return '';
    },
    getTableBuyBoxClass: function getTableBuyBoxClass(status) {
      if (!status) return '';
      var s = String(status).toLowerCase();
      if (s === 'owned') return 'owned';
      if (s === 'lost') return 'lost';
      if (s === 'suppressed') return 'suppressed';
      if (s === 'rotating') return 'rotating';
      return '';
    },
    getBuyBoxStatusLabel: function getBuyBoxStatusLabel(status) {
      if (!status) return '—';
      var s = String(status).toLowerCase();
      if (s === 'owned') return 'Owned';
      if (s === 'lost') return 'Lost';
      if (s === 'suppressed') return 'Suppressed';
      if (s === 'rotating') return 'Rotating';
      return status;
    },
    getBuyBoxStatusText: function getBuyBoxStatusText(status) {
      if (!status) return '—';
      var s = String(status).toLowerCase();
      if (s === 'owned') return 'OWNED';
      if (s === 'lost') return 'LOST';
      if (s === 'suppressed') return 'SUPPRESSED';
      if (s === 'rotating') return 'ROTATING';
      return status;
    },
    getMarketplaceEmoji: function getMarketplaceEmoji(marketplace) {
      var map = { US: '🇺🇸', UK: '🇬🇧', CA: '🇨🇦', DE: '🇩🇪', FR: '🇫🇷', IT: '🇮🇹', ES: '🇪🇸', MX: '🇲🇽', BR: '🇧🇷', IN: '🇮🇳', NL: '🇳🇱', BE: '🇧🇪', SE: '🇸🇪', PL: '🇵🇱', AT: '🇦🇹', ZA: '🇿🇦' };
      return map[marketplace] || '🏳️';
    },
    openCogsModal: function openCogsModal(product) {
      console.log('Opening COGS modal for product:', product);
      if (!product || !product.productId) {
        console.error('Product or productId is missing');
        alert('Error: Product data is missing');
        return;
      }

      if (this.$refs.tableProductCostMarginModal) {
        this.$refs.tableProductCostMarginModal.open(product.productId);
      } else {
        console.error('ProductCostMarginModal ref not found');
        alert('Error: Modal component not available');
      }
    },

    handleTableCostMarginUpdated: function handleTableCostMarginUpdated(productId) {
      this.loadProductsFromBackend(this.gridCurrentPage, this.gridPageSize);
    },
    tablePrevPage: function tablePrevPage() {
      if (this.gridCurrentPage > 0) {
        this.loadProductsFromBackend(this.gridCurrentPage - 1);
      }
    },
    tableNextPage: function tableNextPage() {
      if (this.gridCurrentPage < this.gridTotalPages - 1) {
        this.loadProductsFromBackend(this.gridCurrentPage + 1);
      }
    },
    goToTablePage: function goToTablePage(page) {
      if (page >= 0 && page < this.gridTotalPages) {
        this.loadProductsFromBackend(page);
      }
    },
    getTablePageNumber: function getTablePageNumber(index) {
      if (this.gridTotalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, this.gridCurrentPage - 2);
      var endPage = Math.min(this.gridTotalPages - 1, startPage + 4);
      var adjustedStartPage = Math.max(0, endPage - 4);

      return adjustedStartPage + index - 1;
    },
    openChartModal: function openChartModal(product) {
      if (this.$refs.chartModal) {
        this.$refs.chartModal.open(product, null);
      }
    },
    toggleTableSort: function toggleTableSort(column) {
      if (PRODUCTS_TABLE_SORT_KEYS.indexOf(column) === -1) return;
      if (this.tableSortKey !== column) {
        this.tableSortKey = column;
        this.tableSortDir = column === 'product' ? 'asc' : 'desc';
      } else if (this.tableSortDir === 'desc') {
        this.tableSortDir = 'asc';
      } else if (this.tableSortDir === 'asc') {
        this.tableSortKey = null;
        this.tableSortDir = 'desc';
      }
      this.gridCurrentPage = 0;
      this.loadProductsFromBackend(0);
    },
    ratingSummary: function ratingSummary(rating, count) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_reviewHealth_js__["g" /* ratingSummary */])(rating, count);
    },
    tableSortHeadClass: function tableSortHeadClass(column) {
      return {
        'sort-col-active': this.tableSortKey === column,
        'sort-col-asc': this.tableSortKey === column && this.tableSortDir === 'asc',
        'sort-col-desc': this.tableSortKey === column && this.tableSortDir === 'desc'
      };
    },
    loadProductsFromBackend: function loadProductsFromBackend() {
      var _this6 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var currentPage = page !== null ? page : this.gridCurrentPage;

      var params = {};
      if (this.filterByMarket.length > 0) {
        params.marketplaces = this.filterByMarket.join(',');
      }
      if (this.filterBySellAcc.length > 0) {
        params.sellerAccounts = this.filterBySellAcc.join(',');
      }
      if (this.filterMissingCogs) {
        params.missingCogs = 'true';
      }
      if (this.filterByBuyBox) {
        params.buybox = 'true';
      }

      if (this.asinSearch && this.asinSearch.trim()) {
        params.asin = this.asinSearch.trim();
      }

      if (this.tableSortKey) {
        params.sortBy = this.tableSortKey;
        params.sortDir = this.tableSortDir || 'desc';
      }

      params.page = currentPage;
      params.pageSize = this.gridPageSize;

      params.productsOnly = 'true';
      this.loadingApiData = true;
      this.apiError = null;
      console.log('Fetching products with filters and pagination:', params);
      this.$http.get('/api/sentinel/products', { params: params }).then(function (response) {
        console.log('API Response received:', response.body);
        _this6.apiData = response.body;
        _this6.loadingApiData = false;
        if (response.body.totalItems !== undefined) {
          _this6.gridTotalItems = response.body.totalItems;
          _this6.gridTotalPages = response.body.totalPages || 1;
          _this6.gridCurrentPage = response.body.currentPage || 0;
          _this6.gridPageSize = response.body.pageSize || 20;
        } else if (response.body.summary && response.body.summary.totalProducts !== undefined) {
          _this6.gridTotalItems = response.body.summary.totalProducts;
          _this6.gridTotalPages = Math.ceil(response.body.summary.totalProducts / _this6.gridPageSize);
          _this6.gridCurrentPage = currentPage;
        }
        console.log('Pagination info:', {
          totalItems: _this6.gridTotalItems,
          totalPages: _this6.gridTotalPages,
          currentPage: _this6.gridCurrentPage,
          pageSize: _this6.gridPageSize
        });

        console.log('Checking availableFilters:', {
          hasAvailableFilters: !!_this6.apiData.availableFilters,
          availableFilters: _this6.apiData.availableFilters
        });
        if (_this6.apiData.availableFilters) {
          _this6.updateFilterOptions();
        } else {
          console.warn('No availableFilters in API response - filters will be empty');

          if (_this6.apiData.products) {
            var products = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(_this6.apiData.products);
            var marketplaces = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(products.map(function (p) {
              return p.marketplace;
            }).filter(function (m) {
              return m;
            }))));
            var sellerIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(products.map(function (p) {
              return p.sellerId;
            }).filter(function (id) {
              return id != null;
            }))));
            console.log('Extracted marketplaces from products:', marketplaces);
            _this6.filterUserCountries = marketplaces;
            if (_this6.filterByMarket.length > 0) {
              _this6.filterByMarket = _this6.filterByMarket.filter(function (m) {
                return marketplaces.indexOf(m) >= 0;
              });
            }
            if (_this6.filterBySellAcc.length > 0 && sellerIds.length > 0) {
              var idSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(sellerIds.map(function (id) {
                return id != null ? String(id) : null;
              }).filter(Boolean));
              _this6.filterBySellAcc = _this6.filterBySellAcc.filter(function (id) {
                return idSet.has(String(id));
              });
            }
          }
        }
        console.log('Products loaded:', __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(_this6.apiData.products || {}).length);
        console.log('productData computed:', _this6.productData);

        _this6.$nextTick(function () {
          return _this6.initializeDropdowns();
        });
      }, function (error) {
        console.error('Error fetching products:', error);
        _this6.apiError = error.body && error.body.error ? error.body.error : 'Failed to load products';
        _this6.loadingApiData = false;

        if (_this6.$parent && _this6.$parent.productsList) {
          _this6.$parent.productsList();
        }
      });
    },
    initializeDropdowns: function initializeDropdowns() {
      var _this7 = this;

      console.log('initializeDropdowns called', {
        hasSaDropdown: !!this.$refs.saDropdown,
        hasMarketplaceDropdown: !!this.$refs.marketplaceDropdown
      });

      if (this.$refs.saDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.saDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.saDropdown).dropdown({
          onChange: function onChange(v) {
            if (_this7._syncingDropdowns) return;
            if (_this7.loadingApiData) return;
            if (v === '') {
              _this7.filterBySellAcc = [];
            } else {
              _this7.filterBySellAcc = v.split(',').map(Number);
            }

            var dropdown = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(_this7.$refs.saDropdown);
            if (v === '') {
              dropdown.find('.text').text('S.Accounts: All');
            } else {
              var selected = v.split(',');
              dropdown.find('.text').text('S.Accounts: ' + (selected.length === 1 ? '1 selected' : selected.length + ' selected'));
            }

            _this7.gridCurrentPage = 0;
            _this7.loadProductsFromBackend(0);
          },
          placeholder: 'All Accounts',
          fullTextSearch: true
        });
        console.log('Seller account dropdown initialized');
      }

      if (this.$refs.marketplaceDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.marketplaceDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.marketplaceDropdown).dropdown({
          onChange: function onChange(v) {
            if (_this7._syncingDropdowns) return;
            if (_this7.loadingApiData) return;
            if (v === '') {
              _this7.filterByMarket = [];
            } else {
              _this7.filterByMarket = v.split(',');
            }

            var dropdown = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(_this7.$refs.marketplaceDropdown);
            if (v === '') {
              dropdown.find('.text').text('Marketplaces: All');
            } else {
              var selected = v.split(',');
              if (selected.length === 1) {
                dropdown.find('.text').text('Marketplaces: ' + selected[0]);
              } else {
                dropdown.find('.text').text('Marketplaces: ' + selected.length + ' selected');
              }
            }

            _this7.gridCurrentPage = 0;
            _this7.loadProductsFromBackend(0);
          },
          placeholder: 'All Marketplaces',
          fullTextSearch: true
        });
        console.log('Marketplace dropdown initialized');
      }
      this.syncDropdownsToRestoredState();
    },
    syncDropdownsToRestoredState: function syncDropdownsToRestoredState() {
      var _this8 = this;

      this._syncingDropdowns = true;
      try {
        if (this.$refs.saDropdown && this.filterBySellAcc.length > 0) {
          var val = this.filterBySellAcc.map(String).join(',');
          __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.saDropdown).dropdown('set selected', val);
        }
        if (this.$refs.marketplaceDropdown && this.filterByMarket.length > 0) {
          var _val = this.filterByMarket.join(',');
          __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this.$refs.marketplaceDropdown).dropdown('set selected', _val);
        }
      } catch (e) {
        console.warn('Could not sync dropdowns to restored state:', e);
      } finally {
        this.$nextTick(function () {
          setTimeout(function () {
            _this8._syncingDropdowns = false;
          }, 0);
        });
      }
    },
    updateFilterOptions: function updateFilterOptions() {
      console.log('updateFilterOptions called', {
        hasAvailableFilters: !!this.apiData.availableFilters,
        availableFilters: this.apiData.availableFilters
      });
      var canonicalOrder = this.filterCountriesAll.filter(function (c) {
        return c !== 's';
      });
      var fromAf = this.apiData.availableFilters && this.apiData.availableFilters.marketplaces || [];
      var fromProducts = [];
      if (this.apiData && this.apiData.products) {
        fromProducts = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.apiData.products).map(function (p) {
          return p.marketplace;
        }).filter(function (m) {
          return m;
        }))));
      }
      var mergedAf = fromAf.length > 0 ? fromAf : fromProducts.map(function (code) {
        return { code: code };
      });
      this.filterUserCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["f" /* buildMarketplaceFilterCodes */])({
        fromAvailableFilters: mergedAf,
        v1SellersBody: this.v1SellersApiBody,
        canonicalOrder: canonicalOrder
      });
      if (this.filterByMarket.length > 0) {
        var mpSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.filterUserCountries);
        this.filterByMarket = this.filterByMarket.filter(function (m) {
          return mpSet.has(m);
        });
      }
      console.log('Updated marketplaces for filter:', this.filterUserCountries);
      var v1Rows = this.v1SellerAccountRows;
      var apiSa = this.apiData.availableFilters && this.apiData.availableFilters.sellerAccounts;
      var sellerIds = [];
      if (v1Rows != null && v1Rows.length > 0) {
        sellerIds = v1Rows.map(function (r) {
          return r.id;
        });
      } else if (v1Rows != null && apiSa && apiSa.length > 0) {
        sellerIds = apiSa.map(function (sa) {
          return sa.id;
        });
      } else if (v1Rows == null && apiSa && apiSa.length > 0) {
        sellerIds = apiSa.map(function (sa) {
          return sa.id;
        });
      }
      if (sellerIds.length > 0) {
        this.filterShowSASelector = sellerIds.length > 1;
        if (this.filterBySellAcc.length > 0) {
          var idSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(sellerIds.map(String));
          this.filterBySellAcc = this.filterBySellAcc.filter(function (id) {
            return idSet.has(String(id));
          });
        }
        console.log('Seller accounts available:', sellerIds.length);
      } else {
        console.warn('No seller accounts in availableFilters');
        this.filterShowSASelector = false;
        this.filterBySellAcc = [];
      }
    },
    ensureV1SellerAccountRows: function ensureV1SellerAccountRows() {
      var self = this;
      if (self.v1SellerAccountRows !== null) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(self.v1SellerAccountRows);
      }
      if (self._v1SellersPromise) {
        return self._v1SellersPromise;
      }
      self._v1SellersPromise = self.$http.get('/api/v1/sellers').then(function (res) {
        var body = res.body || {};
        self.v1SellersApiBody = body;
        var rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(body));
        self.v1SellerAccountRows = rows;
        return rows;
      }, function () {
        self.v1SellersApiBody = {};
        self.v1SellerAccountRows = [];
        return [];
      }).finally(function () {
        self._v1SellersPromise = null;
      });
      return self._v1SellersPromise;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.path !== '/products') return;
      if (this._applyingProductsRouteQuery) return;
      if (from && from.path === to.path && shallowEqualProductsQuery(this.buildProductsRouteQuery(), to.query)) return;
      var hadUrl = this.applyProductsRouteQuery(to.query);
      if (!hadUrl) {
        this.restoreProductsPageState();
      }
      this.loadProductsFromBackend(this.gridCurrentPage);
    },
    asinSearch: function asinSearch() {
      this.saveProductsPageState();
      this.scheduleProductsUrlSync();
    },

    filterByMarket: {
      handler: function handler() {
        this.saveProductsPageState();
        this.syncProductsRouteQuery();
      },

      deep: true
    },
    filterBySellAcc: {
      handler: function handler() {
        this.saveProductsPageState();
        this.syncProductsRouteQuery();
      },

      deep: true
    },
    filterMissingCogs: function filterMissingCogs() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    filterByBuyBox: function filterByBuyBox() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    viewMode: function viewMode() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    gridCurrentPage: function gridCurrentPage() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    tableSortKey: function tableSortKey() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    tableSortDir: function tableSortDir() {
      this.saveProductsPageState();
      this.syncProductsRouteQuery();
    },
    v1SellerAccountRows: function v1SellerAccountRows() {
      var _this9 = this;

      if (this.v1SellerAccountRows === null) return;
      if (this.apiData && this.apiData.availableFilters) {
        this.updateFilterOptions();
      }
      this.$nextTick(function () {
        return _this9.initializeDropdowns();
      });
    }
  },
  created: function created() {
    var hadUrl = this.applyProductsRouteQuery(this.$route.query);
    if (!hadUrl) {
      this.restoreProductsPageState();
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    this.ensureV1SellerAccountRows();
    this.updateFilters();

    this.$nextTick(function () {
      _this10.initializeDropdowns();
    });

    this.loadProductsFromBackend();
    this.$nextTick(function () {
      _this10.syncProductsRouteQuery();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this._productsUrlTimer) {
      clearTimeout(this._productsUrlTimer);
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buybox_DashboardLayout_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SettingsHubPage',
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_0__components_buybox_DashboardLayout_vue___default.a
  },
  mounted: function mounted() {
    this.clearStuckPageDimmer();
  },
  methods: {
    clearStuckPageDimmer: function clearStuckPageDimmer() {
      try {
        $('body').removeClass('dimmed');
        var $dimmer = $('.ui.dimmer.modals');
        $dimmer.removeClass('visible active animating');
        $dimmer.find('.ui.modal').removeClass('visible active animating');
        $dimmer.css({ display: 'none', 'background-color': '' });
      } catch (e) {}
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_stripePublishableKey_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings_ChangePasswordModal__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings_ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_settings_ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_settings_AddSellerAccount__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_settings_AddSellerAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_settings_AddSellerAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_SellerAccount__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_SellerAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_settings_SellerAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_DailyDigestTiming__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_DailyDigestTiming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_settings_DailyDigestTiming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PasswordInputPair__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PasswordInputPair___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_PasswordInputPair__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blueimp_md5__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_blueimp_md5__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AddSellerAccount: __WEBPACK_IMPORTED_MODULE_11__components_settings_AddSellerAccount___default.a,
    ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_10__components_settings_ChangePasswordModal___default.a,
    SellerAccount: __WEBPACK_IMPORTED_MODULE_12__components_settings_SellerAccount___default.a,
    DailyDigestTiming: __WEBPACK_IMPORTED_MODULE_13__components_settings_DailyDigestTiming___default.a,
    PasswordInputPair: __WEBPACK_IMPORTED_MODULE_14__components_PasswordInputPair___default.a
  },
  data: function data() {
    return {
      emailAddresses: [],
      sellers: [],
      filteredSellers: [],
      message: '',
      successMessage: '',
      teamsMessage: '',
      alertMessage: '',
      error: '',
      sellersDirty: false,
      addEmailAddressInProgress: false,
      emailDirty: false,
      emailsValid: true,
      instantAlert: null,
      initialInstantAlert: null,
      batchingIntervalHours: null,
      initialBatchingIntervalHours: null,
      alertSubject: 'DETAILED',
      initialAlertSubject: 'DETAILED',
      paymentStatusMessage: '',
      paymentMethod: null,
      stripeButtonClicked: false,
      subscriptionCanceled: false,
      hasPaymentDetails: true,
      cancelInProgress: false,
      redeemedNewPricing: false,
      resumeInProgress: false,
      updatePaymentInProgress: false,
      paymentDetailsSaved: false,
      stripeInstance: null,
      paymentElement: null,
      elementsGroup: null,
      setupIntentClientSecret: null,
      isOwner: false,
      watchDogTypesToDisplayName: { 'BAD_REVIEW': 'Recent Review', 'KEYWORD': 'Keyword Tracking', 'PRICE': 'Price Change Alert', 'INVENTORY': 'FBA Stock', 'FBM_INVENTORY': 'FBM Stock' },
      watchDogTypes: ['BAD_REVIEW', 'TOP_REVIEW', 'PRODUCT_DETAILS_RECENT_CHANGE', 'PRODUCT_CATEGORY_RECENT_CHANGE', 'LOST_BUYBOX', 'NO_ADD_TO_CART', 'PRICE', 'KEYWORD'],
      packageDetails: null,
      addonCount: 0,
      autoSelectingAddon: null,
      invoices: [],
      billingName: '',
      editBillingNameState: false,
      alertSettingsAni: false,
      showAdvertisementApiSettings: false,
      authorizations: [],
      googleSheetAuth: null,
      zapierAuth: null,
      hasZapier: false,
      zapierList: [],
      googleSheetsList: [],
      gsheetsConnection: { enabled: false, email: null, spreadsheetId: null, connectionError: false },
      gsheetsArticleLink: 'https://help.sentrykit.com/en/articles/5279959-how-to-reconnect-google-sheet-in-sentrykit',
      firstName: '',
      firstNameOrig: '',
      lastName: '',
      lastNameOrig: '',
      anyAccountMayNeedReAuthorization: false,
      user: {
        firstName: '',
        lastName: '',
        email: ''
      },
      showAllUsers: false,
      selectedOptions: [],
      selectedTeamStorefronts: [],
      storefrontUsers: null,
      alertUser: null,
      selectedAssignedUser: [],
      assignedUserList: [],
      selectedAlertUser: [],
      alertUserList: [],
      selectedAlertUserEmail: null,
      manageAlertSettings: false,
      disableAllAlerts: false,
      enableAllAlerts: false,
      suppressedWatchdogs: [],
      showSuppressedMsg: {},
      tenantUsers: [],
      tenantUsersLoading: false,
      tenantUsersError: ''
    };
  },
  methods: {
    loadTenantUsers: function loadTenantUsers() {
      var _this = this;

      this.tenantUsersLoading = true;
      this.tenantUsersError = '';
      this.$http.get('/api/identity/users').then(function (response) {
        var body = response.body || {};
        var list = Array.isArray(body.users) ? body.users : [];
        _this.tenantUsers = list.map(function (u) {
          var firstName = u.first_name != null ? u.first_name : u.firstName;
          var lastName = u.last_name != null ? u.last_name : u.lastName;
          var fullName = u.full_name != null ? u.full_name : u.fullName;
          if (!fullName && (firstName || lastName)) {
            fullName = [firstName, lastName].filter(Boolean).join(' ');
          }
          return {
            id: u.id,
            email: u.email,
            firstName: firstName,
            lastName: lastName,
            fullName: fullName || '',
            isOwner: !!(u.is_owner != null ? u.is_owner : u.isOwner)
          };
        });
        _this.tenantUsersLoading = false;
        var self = _this;
        _this.$nextTick(function () {
          self.refreshSemanticDropdowns();
        });
      }, function (response) {
        _this.tenantUsersLoading = false;
        var body = response.body || {};
        _this.tenantUsersError = body.message || response.statusText || 'Failed to load users';
      });
    },
    fetchSuppressedWatchdogs: function fetchSuppressedWatchdogs() {
      var _this2 = this;

      this.$http.get('/api/operations/tenant-features/suppressed-alerts').then(function (response) {
        console.log('Suppressed watchdogs API response:', response.body);
        _this2.suppressedWatchdogs = response.body.map(function (x) {
          return x.toUpperCase();
        });
      });
    },
    isSuppressed: function isSuppressed(wdt) {
      console.log('isSuppressed', wdt, this.suppressedWatchdogs);
      if (!Array.isArray(this.suppressedWatchdogs) || this.suppressedWatchdogs.length === 0) return false;
      return this.suppressedWatchdogs.includes(wdt.toUpperCase());
    },

    selectAssignedUser: function selectAssignedUser(option) {
      var _this3 = this;

      var hasAddr = option && option.emailAddressId != null && option.emailAddressId !== '';
      if (hasAddr && option.email) {
        this.selectedAssignedUser.push(option.email);
        this.assignedUserList = this.emailAddresses.filter(function (ea) {
          return _this3.selectedAssignedUser.includes(ea.email);
        });
      } else {
        this.selectedAssignedUser.push('-1');
        this.assignedUserList = this.emailAddresses;
      }
    },
    formatTenantUserDropdownLabel: function formatTenantUserDropdownLabel(u) {
      if (!u) return '';
      var em = u.email || '';
      if (u.fullName && String(u.fullName).trim()) {
        return u.fullName + ' — ' + em;
      }
      return em;
    },
    onAlertUserChange: function onAlertUserChange() {
      var _this4 = this;

      console.log(this.alertUser);
      if (this.alertUser && this.alertUser !== '-1') {
        this.alertUserList = this.emailAddresses.filter(function (ea) {
          return ea.email === _this4.alertUser;
        });
      } else {
        this.alertUserList = [];
      }
    },
    deactiveUsers: function deactiveUsers() {
      var self = this;
      if (!this.selectedOptions || !this.selectedOptions.length) {
        this.error = 'Please select at least one user to deactivate.';
        setTimeout(function () {
          self.error = '';
        }, 5000);
        return;
      }
      var el = __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#deUserConfirmModal');
      el.modal({
        onApprove: function onApprove() {
          self.deleteUser();
          return true;
        }
      });
      el.modal('show');
    },
    deleteUser: function deleteUser() {
      var self = this;
      var selected = (this.selectedOptions || []).slice();
      if (!selected.length) {
        this.hideDeactivateUserModal();
        return;
      }
      this.emailAddresses.filter(function (ea) {
        return selected.indexOf(ea.email) !== -1;
      }).forEach(function (ea) {
        ea.isDeleted = true;
      });
      this.hideDeactivateUserModal();
      var req = this.save();
      if (req && typeof req.then === 'function') {
        req.then(function () {
          self.selectedOptions = [];
          self.$nextTick(function () {
            try {
              if (self.$refs.dropdown && window.$(self.$refs.dropdown).length) {
                window.$(self.$refs.dropdown).dropdown('clear');
              }
            } catch (e) {}
          });
        });
      }
    },
    sellerIdInList: function sellerIdInList(list, storefrontId) {
      if (!list || !list.length || storefrontId === null || storefrontId === undefined || storefrontId === '') return false;
      var sid = String(storefrontId);
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]) === sid) return true;
      }
      return false;
    },

    syncAssignedUserListFromTeamStorefronts: function syncAssignedUserListFromTeamStorefronts() {
      var sids = this.selectedTeamStorefronts || [];
      if (!sids.length) {
        this.assignedUserList = [];
        return;
      }
      var self = this;
      this.assignedUserList = this.emailAddresses.filter(function (ea) {
        if (ea.isDeleted || ea.isPrimary || !ea.isUser) return false;
        return sids.some(function (sf) {
          return self.sellerIdInList(ea.allowedSellerAccounts, sf);
        });
      });
    },
    saveStorefrontTeams: function saveStorefrontTeams() {
      var self = this;
      var sids = (this.selectedTeamStorefronts || []).filter(function (id) {
        return id != null && id !== '';
      });
      if (!sids.length) {
        this.error = 'Select at least one storefront.';
        setTimeout(function () {
          self.error = '';
        }, 5000);
        return;
      }
      if (this.isEmptyObject(this.assignedUserList)) {
        this.error = 'Select at least one user.';
        setTimeout(function () {
          self.error = '';
        }, 5000);
        return;
      }
      this.emailAddresses.filter(function (ea) {
        return self.assignedUserList.some(function (filterEl) {
          return filterEl.email === ea.email;
        });
      }).forEach(function (ea) {
        sids.forEach(function (sid) {
          if (!self.sellerIdInList(ea.allowedSellerAccounts, sid)) {
            ea.allowedSellerAccounts.push(sid);
          }
        });
      });
      this.save('teams');
    },
    deleteAssignedUser: function deleteAssignedUser(ea) {
      var self = this;
      var sids = (this.selectedTeamStorefronts || []).filter(function (id) {
        return id != null && id !== '';
      });
      if (!sids.length) {
        this.error = 'Select storefront(s) above before removing a user from those storefronts.';
        setTimeout(function () {
          self.error = '';
        }, 5000);
        return;
      }
      ea.allowedSellerAccounts = ea.allowedSellerAccounts.filter(function (d) {
        return !sids.some(function (sid) {
          return String(sid) === String(d);
        });
      });
      this.assignedUserList = this.assignedUserList.filter(function (e) {
        return e.email !== ea.email;
      });
      this.updateEmailDirty();
    },
    onDisableAllAlertChange: function onDisableAllAlertChange() {
      var _this5 = this;

      for (var i = 0; i < this.watchDogTypes.length; ++i) {
        var wdt = this.watchDogTypes[i];
        this.enableAllAlerts = !this.disableAllAlerts;
        if (this.disableAllAlerts) {
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].GREEN = false;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].RED = false;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].AMBER = false;
        } else {
          var selectedEmail = this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0];
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].GREEN = selectedEmail.alertsSettings[wdt].orig.GREEN;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].RED = selectedEmail.alertsSettings[wdt].orig.RED;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this5.alertUserList[0].email;
          })[0].alertsSettings[wdt].AMBER = selectedEmail.alertsSettings[wdt].orig.AMBER;
        }
      }
    },
    onEnableAllAlertChange: function onEnableAllAlertChange() {
      var _this6 = this;

      for (var i = 0; i < this.watchDogTypes.length; ++i) {
        var wdt = this.watchDogTypes[i];
        this.disableAllAlerts = !this.enableAllAlerts;
        if (this.enableAllAlerts) {
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].GREEN = true;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].RED = true;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].AMBER = true;
        } else {
          var selectedEmail = this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0];
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].GREEN = selectedEmail.alertsSettings[wdt].orig.GREEN;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].RED = selectedEmail.alertsSettings[wdt].orig.RED;
          this.emailAddresses.filter(function (ea) {
            return ea.email === _this6.alertUserList[0].email;
          })[0].alertsSettings[wdt].AMBER = selectedEmail.alertsSettings[wdt].orig.AMBER;
        }
      }
    },
    convertIntoUser: function convertIntoUser() {
      var _this7 = this;

      if (__WEBPACK_IMPORTED_MODULE_15_jquery___default()(this.$el).find('form.ui.form').form('is valid')) {
        var timezoneOffsetMins = 0 - new Date().getTimezoneOffset();
        var body = {
          email: this.user.email,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          timezoneOffsetMins: timezoneOffsetMins
        };
        this.addEmailAddressInProgress = true;
        this.$http.get('/api/id/generate').then(function (response) {
          var alertsSettings = {};
          for (var i = 0; i < _this7.watchDogTypes.length; ++i) {
            var wdt = _this7.watchDogTypes[i];
            if (wdt === 'SALES_DROP' || wdt === 'PRICE' || wdt === 'INVENTORY' || wdt === 'FBM_INVENTORY') {
              alertsSettings[wdt] = { 'GREEN': false, 'RED': false, 'AMBER': false, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
            } else if (wdt === 'BAD_REVIEW' || wdt === 'TOP_REVIEW') {
              alertsSettings[wdt] = { 'GREEN': false, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
            } else {
              alertsSettings[wdt] = { 'GREEN': true, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
            }
          }
          var primaryEa = _this7.emailAddresses.filter(function (ea) {
            return ea.isPrimary;
          })[0];
          _this7.emailAddresses.splice(_this7.emailAddresses.length, 0, function () {
            var obj = {
              emailAddressId: { value: response.body.id },
              email: body.email,
              originalEmail: '',
              emailValid: false,
              emailVerified: false,
              isNew: true,
              isDeleted: false,
              subscribedToDailyDigestEmail: true,
              subscribedToNewsletter: false,
              manageSubscriptionSettings: false,
              alertsSettings: alertsSettings,
              unsubscribedSellerAccounts: [],
              originalUnsubscribedSellerAccounts: [],
              allowedSellerAccounts: [],
              originalallowedSellerAccounts: [],
              timezoneOffset: primaryEa.timezoneOffset,
              timezoneAdjustToDST: primaryEa.timezoneAdjustToDST,
              digestEmailHour: primaryEa.digestEmailHour,
              isDirty: function isDirty() {
                return true;
              }
            };
            obj.updateDigestTiming = function (timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
              obj.timezoneOffset = timezoneOffset;
              obj.timezoneAdjustToDST = timezoneAdjustToDST;
              obj.digestEmailHour = digestEmailHour;
            };
            return obj;
          }());

          var changedEmailAddresses = _this7.emailAddresses.filter(function (ea) {
            return !ea.isDeleted && ea.isDirty();
          }).map(function (ea) {
            var alertTurnedOn = [];
            var alertTurnedOff = [];
            var sellerTurnedOn = ea.originalUnsubscribedSellerAccounts.filter(function (value) {
              return ea.unsubscribedSellerAccounts.indexOf(value) === -1;
            });
            var sellerTurnedOff = ea.unsubscribedSellerAccounts.filter(function (value) {
              return ea.originalUnsubscribedSellerAccounts.indexOf(value) === -1;
            });
            var sellerAccountAccessOff = ea.originalallowedSellerAccounts.filter(function (value) {
              return ea.allowedSellerAccounts.indexOf(value) === -1;
            });
            var sellerAccountAccessOn = ea.allowedSellerAccounts.filter(function (value) {
              return ea.originalallowedSellerAccounts.indexOf(value) === -1;
            });
            __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(ea.alertsSettings).forEach(function (s) {
              var wdt = s[0];
              var settings = s[1];
              var wdtAlertTurnedOn = [];
              var wdtAlertTurnedOff = [];
              __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(settings.orig).forEach(function (key) {
                if (settings[key] === true && settings.orig[key] === false) wdtAlertTurnedOn.splice(wdtAlertTurnedOn.length, 0, key);
                if (settings[key] === false && settings.orig[key] === true) wdtAlertTurnedOff.splice(wdtAlertTurnedOff.length, 0, key);
              });
              if (wdtAlertTurnedOn.length > 0) alertTurnedOn.splice(alertTurnedOn.length, 0, wdt + ':' + wdtAlertTurnedOn.join(','));
              if (wdtAlertTurnedOff.length > 0) alertTurnedOff.splice(alertTurnedOff.length, 0, wdt + ':' + wdtAlertTurnedOff.join(','));
            });
            return {
              emailAddressId: ea.emailAddressId,
              email: ea.email,
              isNew: ea.isNew,
              subscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
              subscribedToNewsletter: ea.subscribedToNewsletter,
              timezoneOffset: ea.timezoneOffset,
              timezoneAdjustToDST: ea.timezoneAdjustToDST,
              digestEmailHour: ea.digestEmailHour,
              alertTurnedOn: alertTurnedOn.join(';'),
              alertTurnedOff: alertTurnedOff.join(';'),
              sellersTurnedOn: sellerTurnedOn.join(';'),
              sellersTurnedOff: sellerTurnedOff.join(';'),
              sellersAccountAccessOn: sellerAccountAccessOn.join(';'),
              sellersAccountAccessOff: sellerAccountAccessOff.join(';')
            };
          });
          var data = {
            changedEmailAddresses: changedEmailAddresses,
            deletedEmailAddresses: _this7.emailAddresses.filter(function (ea) {
              return !ea.isNew && ea.isDeleted;
            }).map(function (ea) {
              return _this7.normalizeEmailAddressIdForApi(ea.emailAddressId);
            }).filter(function (id) {
              return id != null && id !== '';
            }),
            sellerAccountNewNames: _this7.$refs.sellerAccounts ? _this7.$refs.sellerAccounts.filter(function (a) {
              return a.dirty;
            }).map(function (a) {
              return a.toJson();
            }) : [],
            instantAlert: _this7.instantAlert,
            alertSubject: _this7.alertSubject,
            batchingIntervalMinutes: _this7.batchingIntervalHours * 60,
            firstName: _this7.firstName,
            lastName: _this7.lastName
          };
          _this7.$http.put('/api/identity/settings', data).then(function (response) {
            window.dirty = false;
            _this7.message = 'Changes have been successfully changed';
            setTimeout(function () {
              _this7.message = '';
            }, 3000);
            _this7.$http.post('/api/auth/addUser', body).then(function (response) {
              _this7.addEmailAddressInProgress = false;
              _this7.hideAddUserModal();
              _this7.successMessage = 'Submitted Changes have been Saved';
              setTimeout(function () {
                _this7.successMessage = '';
              }, 5000);

              _this7.loadSettings();
              _this7.loadTenantUsers();
            }, function (response) {
              _this7.error = response.body.error + ': ' + response.body.message;

              _this7.addEmailAddressInProgress = false;
              _this7.hideAddUserModal();
            });

            if (data.sellerAccountNewNames) _this7.$emit('sellerAccountsUpdated');
          }, function (response) {
            _this7.loadSettings();
            _this7.loadTenantUsers();
            _this7.addEmailAddressInProgress = false;
            _this7.error = response.body.message;
          });
        }, function (response) {
          _this7.addEmailAddressInProgress = false;
          _this7.error = response.body.message;
        });
      }
    },
    toggleViewUser: function toggleViewUser() {
      this.showAllUsers = !this.showAllUsers;
      if (this.showAllUsers) {
        this.loadTenantUsers();
      }
    },
    resetUser: function resetUser(i) {
      this.user = {
        firstName: '',
        lastName: '',
        email: ''
      };
      this.emailAddresses[i].convertIntoUser = false;
    },
    openConvertIntoUserModal: function openConvertIntoUserModal(i) {
      if (!this.emailAddresses[i].convertIntoUser) {
        this.user.email = this.emailAddresses[i].email;
      }
      this.emailAddresses[i].convertIntoUser = !this.emailAddresses[i].convertIntoUser;
    },

    normalizeEmailAddressIdForApi: function normalizeEmailAddressIdForApi(id) {
      if (id == null || id === '') return null;
      if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined && id.value !== null) return id.value;
      return id;
    },
    resendVerification: function resendVerification(emailAddress) {
      var _this8 = this;

      var addrId = emailAddress.emailAddressId;
      if (addrId && (typeof addrId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(addrId)) === 'object' && addrId.value !== undefined) addrId = addrId.value;
      this.$http.post('/api/identity/emailverification/' + addrId).then(function (response) {
        _this8.message = 'Verification email has been sent';
        emailAddress.verificationEmailSent = true;
        setTimeout(function () {
          _this8.message = '';
        }, 4000);
        setTimeout(function () {
          emailAddress.verificationEmailSent = false;
        }, 30000);
      }, function (response) {
        _this8.error = response.body.error + ': ' + response.body.message;
      });
    },
    checkSubscribe: function checkSubscribe(sellerKey, index) {
      var keyIndex = this.emailAddresses[index].unsubscribedSellerAccounts.indexOf(sellerKey);
      if (keyIndex !== -1) {
        this.emailAddresses[index].unsubscribedSellerAccounts.splice(keyIndex, 1);
      } else {
        this.emailAddresses[index].unsubscribedSellerAccounts.push(sellerKey);
      }
      this.$forceUpdate();
    },
    checkSellerAccountsAccess: function checkSellerAccountsAccess(sellerKey, index) {
      var keyIndex = this.emailAddresses[index].allowedSellerAccounts.indexOf(sellerKey);
      if (keyIndex !== -1) {
        this.emailAddresses[index].allowedSellerAccounts.splice(keyIndex, 1);
      } else {
        this.emailAddresses[index].allowedSellerAccounts.push(sellerKey);
      }
      this.checkSubscribe(sellerKey, index);
      this.updateEmailDirty();
      this.$forceUpdate();
    },
    save: function save(source) {
      var _this9 = this;

      var changedEmailAddresses = this.emailAddresses.filter(function (ea) {
        return !ea.isDeleted && ea.isDirty();
      }).map(function (ea) {
        var alertTurnedOn = [];
        var alertTurnedOff = [];
        var sellerTurnedOn = ea.originalUnsubscribedSellerAccounts.filter(function (value) {
          return ea.unsubscribedSellerAccounts.indexOf(value) === -1;
        });
        var sellerTurnedOff = ea.unsubscribedSellerAccounts.filter(function (value) {
          return ea.originalUnsubscribedSellerAccounts.indexOf(value) === -1;
        });
        var sellerAccountAccessOff = ea.originalallowedSellerAccounts.filter(function (value) {
          return ea.allowedSellerAccounts.indexOf(value) === -1;
        });
        var sellerAccountAccessOn = ea.allowedSellerAccounts.filter(function (value) {
          return ea.originalallowedSellerAccounts.indexOf(value) === -1;
        });
        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(ea.alertsSettings).forEach(function (s) {
          var wdt = s[0];
          var settings = s[1];
          var wdtAlertTurnedOn = [];
          var wdtAlertTurnedOff = [];
          __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(settings.orig).forEach(function (key) {
            if (settings[key] === true && settings.orig[key] === false) wdtAlertTurnedOn.splice(wdtAlertTurnedOn.length, 0, key);
            if (settings[key] === false && settings.orig[key] === true) wdtAlertTurnedOff.splice(wdtAlertTurnedOff.length, 0, key);
          });
          if (wdtAlertTurnedOn.length > 0) alertTurnedOn.splice(alertTurnedOn.length, 0, wdt + ':' + wdtAlertTurnedOn.join(','));
          if (wdtAlertTurnedOff.length > 0) alertTurnedOff.splice(alertTurnedOff.length, 0, wdt + ':' + wdtAlertTurnedOff.join(','));
        });
        return {
          emailAddressId: ea.emailAddressId,
          email: ea.email,
          isNew: ea.isNew,
          subscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
          subscribedToNewsletter: ea.subscribedToNewsletter,
          timezoneOffset: ea.timezoneOffset,
          timezoneAdjustToDST: ea.timezoneAdjustToDST,
          digestEmailHour: ea.digestEmailHour,
          alertTurnedOn: alertTurnedOn.join(';'),
          alertTurnedOff: alertTurnedOff.join(';'),
          sellersTurnedOn: sellerTurnedOn.join(';'),
          sellersTurnedOff: sellerTurnedOff.join(';'),
          sellersAccountAccessOn: sellerAccountAccessOn.join(';'),
          sellersAccountAccessOff: sellerAccountAccessOff.join(';')
        };
      });
      var data = {
        changedEmailAddresses: changedEmailAddresses,
        deletedEmailAddresses: this.emailAddresses.filter(function (ea) {
          return !ea.isNew && ea.isDeleted;
        }).map(function (ea) {
          return _this9.normalizeEmailAddressIdForApi(ea.emailAddressId);
        }).filter(function (id) {
          return id != null && id !== '';
        }),
        sellerAccountNewNames: this.$refs.sellerAccounts ? this.$refs.sellerAccounts.filter(function (a) {
          return a.dirty;
        }).map(function (a) {
          return a.toJson();
        }) : [],
        instantAlert: this.instantAlert,
        alertSubject: this.alertSubject,
        batchingIntervalMinutes: this.batchingIntervalHours * 60,
        firstName: this.firstName,
        lastName: this.lastName
      };
      return this.$http.put('/api/identity/settings', data).then(function (response) {
        window.dirty = false;
        _this9.message = 'Changes have been successfully changed';
        setTimeout(function () {
          _this9.message = '';
        }, 3000);
        if (source === 'teams') {
          _this9.teamsMessage = 'Submitted Changes have been Saved';
          setTimeout(function () {
            _this9.teamsMessage = '';
          }, 3000);
        } else if (source === 'alerts') {
          _this9.alertMessage = 'Submitted Changes have been Saved';
          setTimeout(function () {
            _this9.alertMessage = '';
          }, 3000);
        }

        _this9.loadSettings();
        _this9.loadTenantUsers();
        if (data.sellerAccountNewNames) _this9.$emit('sellerAccountsUpdated');
        return response;
      }, function (response) {
        var body = response.body || {};
        _this9.error = body.message || response.statusText || 'Save failed';
        _this9.loadSettings();
        _this9.loadTenantUsers();
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.reject(response);
      });
    },
    loadSettings: function loadSettings() {
      var _this10 = this;

      this.$http.get('/api/identity/settings').then(function (response) {
        _this10.email = response.body.email;
        _this10.isOwner = response.body.isOwner;
        _this10.firstName = response.body.firstName;
        _this10.firstNameOrig = response.body.firstName;
        _this10.lastName = response.body.lastName;
        _this10.lastNameOrig = response.body.lastName;

        var body = response.body || {};
        var rawAddresses = [];
        if (Array.isArray(body.emailAddresses)) {
          rawAddresses = body.emailAddresses;
        } else if (body.settings && Array.isArray(body.settings.emailAddresses)) {
          rawAddresses = body.settings.emailAddresses;
        }
        var toBool = function toBool(v) {
          if (v === true || v === 1 || v === '1' || v === 'true') return true;
          if (v === false || v === 0 || v === '0' || v === 'false') return false;
          return undefined;
        };
        rawAddresses.forEach(function (ea) {
          if (ea.allowedSellersAccount && !ea.allowedSellerAccounts) {
            ea.allowedSellerAccounts = ea.allowedSellersAccount;
          }
          if (!ea.allowedSellerAccounts) {
            ea.allowedSellerAccounts = [];
          }
          if (!ea.alertsSettings) {
            ea.alertsSettings = {};
          }
          if (ea.first_name && !ea.firstName) ea.firstName = ea.first_name;
          if (ea.last_name && !ea.lastName) ea.lastName = ea.last_name;
          if (ea.emailAddressId == null && ea.email_address_id != null) ea.emailAddressId = ea.email_address_id;
          if (ea.emailAddressId == null && ea.id != null) ea.emailAddressId = ea.id;

          if (ea.isPrimary === undefined) {
            if (ea.is_primary !== undefined) {
              ea.isPrimary = !!ea.is_primary;
            } else if (toBool(ea.primary) !== undefined) {
              ea.isPrimary = toBool(ea.primary);
            }
          } else {
            var p = toBool(ea.isPrimary);
            if (p !== undefined) ea.isPrimary = p;
          }

          var iu = toBool(ea.isUser);
          if (iu === undefined) iu = toBool(ea.is_user);
          if (iu === undefined) iu = toBool(ea.login_user);
          if (iu === undefined) iu = toBool(ea.loginUser);
          if (iu === undefined) iu = toBool(ea.can_login);
          if (iu === undefined) iu = toBool(ea.canLogin);
          if (iu !== undefined) {
            ea.isUser = iu;
          } else {
            var notifyOnly = [ea.isNotificationOnly, ea.notification_only, ea.notificationOnly, ea.channel_only, ea.channelOnly].some(function (x) {
              return toBool(x) === true;
            });
            ea.isUser = !notifyOnly;
          }
        });

        _this10.emailAddresses = rawAddresses.sort(function (a, b) {
          var c = (a.isPrimary ? -1 : 1) - (b.isPrimary ? -1 : 1);
          if (c !== 0) return c;
          return a.email.localeCompare(b.email);
        }).map(function (ea) {
          return __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.extend(ea, {
            originalEmail: ea.email,
            originalSubscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
            originalSubscribedToNewsletter: ea.subscribedToNewsletter,
            originalTimezoneOffset: ea.timezoneOffset,
            originalTimezoneAdjustToDST: ea.timezoneAdjustToDST,
            originalDigestEmailHour: ea.digestEmailHour,
            manageSubscriptionSettings: false,
            convertIntoUser: false,
            manageSellerPermissions: false,
            alertChanged: function alertChanged() {
              var result = false;
              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(ea.alertsSettings).forEach(function (wd) {
                __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(wd.orig).forEach(function (status) {
                  result = result || wd.orig[status] !== wd[status];
                });
              });
              return result;
            },
            subscribedChanged: function subscribedChanged() {
              var original = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.originalUnsubscribedSellerAccounts);
              var current = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.unsubscribedSellerAccounts);
              if (original.size !== current.size) {
                return false;
              }

              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(original).every(function (element) {
                return current.has(element);
              });
            },
            sellerAccessChanged: function sellerAccessChanged() {
              var original = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.originalallowedSellerAccounts);
              var current = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.allowedSellerAccounts);
              if (original.size !== current.size) {
                return false;
              }

              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(original).every(function (element) {
                return current.has(element);
              });
            },
            isDirty: function isDirty() {
              return this.subscribedToDailyDigestEmail !== this.originalSubscribedToDailyDigestEmail || this.subscribedToNewsletter !== this.originalSubscribedToNewsletter || this.isNew || this.isDeleted || this.email !== this.originalEmail || this.timezoneOffset !== this.originalTimezoneOffset || this.timezoneAdjustToDST !== this.originalTimezoneAdjustToDST || this.digestEmailHour !== this.originalDigestEmailHour || this.alertChanged() || !this.subscribedChanged() || !this.sellerAccessChanged();
            },
            updateDigestTiming: function updateDigestTiming(timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
              ea.timezoneOffset = timezoneOffset;
              ea.timezoneAdjustToDST = timezoneAdjustToDST;
              ea.digestEmailHour = digestEmailHour;
            },
            verificationEmailSent: false
          });
        });
        _this10.emailAddresses.forEach(function (ea) {
          if (ea.unsubscribedSellerAccounts === undefined) {
            ea.unsubscribedSellerAccounts = [];
          }
          ea.originalUnsubscribedSellerAccounts = ea.unsubscribedSellerAccounts.map(function (x) {
            return x;
          });
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(ea.alertsSettings).forEach(function (wd) {
            __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(wd).forEach(function (status) {
              wd.orig = wd.orig || {};
              wd.orig[status] = wd[status];
            });
          });
          if (ea.allowedSellerAccounts === undefined) {
            ea.allowedSellerAccounts = [];
          }
          ea.originalallowedSellerAccounts = ea.allowedSellerAccounts.map(function (x) {
            return x;
          });
        });
        _this10.timezone = response.body.timezoneOffset;
        _this10.initialTimezone = response.body.timezoneOffset;
        _this10.initialTimezoneAdjustToDST = response.body.timezoneAdjustToDST;
        _this10.timezoneAdjustToDST = response.body.timezoneAdjustToDST;
        if (_this10.timezoneElement != null) {
          __WEBPACK_IMPORTED_MODULE_15_jquery___default()(_this10.timezoneElement).dropdown('set exactly', _this10.timezone);
        }
        _this10.dailyDigestTime = response.body.digestEmailHour;
        _this10.initialDailyDigestTime = response.body.digestEmailHour;
        if (_this10.dailyDigestTimeElement != null) {
          __WEBPACK_IMPORTED_MODULE_15_jquery___default()(_this10.dailyDigestTimeElement).dropdown('set exactly', _this10.dailyDigestTime);
        }
        _this10.initialInstantAlert = response.body.instantAlert;
        _this10.instantAlert = response.body.instantAlert;
        _this10.alertSubject = response.body.alertSubject;
        _this10.initialAlertSubject = response.body.alertSubject;
        _this10.batchingIntervalHours = response.body.batchingIntervalMinutes / 60;
        _this10.initialBatchingIntervalHours = _this10.batchingIntervalHours;
        var wdts = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(response.body.watchDogTypesToDisplayName || {});
        for (var i = 0; i < wdts.length; ++i) {
          if (!_this10.watchDogTypesToDisplayName[wdts[i]]) {
            _this10.watchDogTypesToDisplayName[wdts[i]] = response.body.watchDogTypesToDisplayName[wdts[i]];
          }
        }
        wdts = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(_this10.watchDogTypesToDisplayName);
        for (var _i = 0; _i < wdts.length; ++_i) {
          if (_this10.watchDogTypes.indexOf(wdts[_i]) < 0) {
            _this10.watchDogTypes.splice(_this10.watchDogTypes.length, 0, wdts[_i]);
          }
        }
        var sellerAccountsList = Array.isArray(response.body.sellerAccounts) ? response.body.sellerAccounts : [];
        _this10.anyAccountMayNeedReAuthorization = sellerAccountsList.filter(function (sa) {
          return sa.mayNeedReauthorization;
        }).length > 0;
        _this10.sellers = sellerAccountsList;
        var primaryEa = _this10.emailAddresses.filter(function (ea) {
          return ea.isPrimary;
        })[0];
        var allowed = primaryEa && Array.isArray(primaryEa.allowedSellerAccounts) ? primaryEa.allowedSellerAccounts : [];
        var self = _this10;
        _this10.filteredSellers = _this10.sellers.filter(function (s) {
          return self.isOwner || self.sellerIdInList(allowed, s.sellerId && s.sellerId.value !== undefined ? s.sellerId.value : s.sellerId);
        });
        _this10.showAdvertisementApiSettings = response.body.showAdvertisementApiSettings;
        _this10.alertUser = null;
        _this10.updateEmailDirty();
        _this10.onSellerAccountChanged();
        var self = _this10;
        _this10.$nextTick(function () {
          self.refreshSemanticDropdowns();
          if (self.isOwner && self.selectedTeamStorefronts && self.selectedTeamStorefronts.length) {
            self.syncAssignedUserListFromTeamStorefronts();
          }
        });
      }, function (response) {
        var body = response.body || {};
        _this10.error = body.message || response.statusText || 'Failed to load settings';
      });
    },
    refreshSemanticDropdowns: function refreshSemanticDropdowns() {
      var $ = window.$;
      if (!$ || !this.$el) return;
      var refs = [this.$refs.assignedUser, this.$refs.alertUser, this.$refs.dropdown, this.$refs.storefrontTeamSelect];
      for (var i = 0; i < refs.length; i++) {
        var el = refs[i];
        if (!el) continue;
        var $el = $(el);
        if (!$el.length) continue;
        try {
          if (typeof $el.dropdown === 'function') {
            $el.dropdown('refresh');
          }
        } catch (e) {}
      }
    },
    timezoneOffsetMinutes: function timezoneOffsetMinutes() {
      return 0 - new Date().getTimezoneOffset();
    },
    loadBilling: function loadBilling() {
      var _this11 = this;

      this.$http.get('/api/billing/payment-status', { params: { timezoneOffsetMinutes: this.timezoneOffsetMinutes() } }).then(function (response) {
        _this11.paymentStatusMessage = response.body.message;
        _this11.subscriptionCanceled = response.body.canceled;
        _this11.packageDetails = response.body.packageDetails;
        _this11.addonCount = response.body.addonCount;
        _this11.hasPaymentDetails = response.body.hasPaymentDetails;
        _this11.paymentMethod = response.body.paymentMethod;
      }, function (response) {
        _this11.error = response.body.message;
      });
    },
    showAddSellerAccountModal: function showAddSellerAccountModal() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#addSellerAccountModal').modal('show');
    },
    onSellerAccountAdded: function onSellerAccountAdded() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#addSellerAccountModal').modal('hide');
      this.$emit('sellerAccountsUpdated');
      this.$http.get('/api/identity/settings').then(function (response) {
        var sellerIds = _this12.sellers.map(function (s) {
          return s.sellerId.value;
        });
        var newSellers = response.body.sellerAccounts;
        for (var i = 0; i < newSellers.length; ++i) {
          if (sellerIds.indexOf(newSellers[i].sellerId.value) < 0) {
            _this12.sellers.splice(_this12.sellers.length, 0, newSellers[i]);
          }
        }
      }, function (response) {
        _this12.error = response.body.message;
      });
    },
    showInvoiceModal: function showInvoiceModal() {
      var _this13 = this;

      this.$http.get('/api/billing/invoices', { params: { timezoneOffsetMinutes: this.timezoneOffsetMinutes() } }).then(function (response) {
        _this13.invoices = response.body.invoices;
        _this13.billingName = response.body.billingName;
        _this13.editBillingNameState = false;
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#invoicesModal').modal({ centered: false }).modal('show');
      }, function (response) {
        _this13.error = response.body.message;
      });
    },
    saveBillingName: function saveBillingName() {
      var _this14 = this;

      this.editBillingNameState = 'inprogress';
      this.$http.put('/api/billing/billing-details', { billingName: this.billingName }).then(function (response) {
        _this14.$http.get('/api/billing/invoices', { params: { timezoneOffsetMinutes: _this14.timezoneOffsetMinutes() } }).then(function (response) {
          _this14.invoices = response.body.invoices;
          _this14.billingName = response.body.billingName;
          _this14.editBillingNameState = false;
        }, function (response) {
          _this14.error = response.body.message;
        });
      }, function (response) {
        _this14.editBillingNameState = false;
        _this14.error = response.body.message;
      });
    },
    onSellerAccountChanged: function onSellerAccountChanged() {
      this.sellersDirty = this.$refs.sellerAccounts && this.$refs.sellerAccounts.filter(function (s) {
        return s.dirty;
      }).length > 0;
    },
    addEmailAddress: function addEmailAddress() {
      var _this15 = this;

      this.addEmailAddressInProgress = true;
      this.$http.get('/api/id/generate').then(function (response) {
        var alertsSettings = {};
        for (var i = 0; i < _this15.watchDogTypes.length; ++i) {
          var wdt = _this15.watchDogTypes[i];
          if (wdt === 'SALES_DROP' || wdt === 'PRICE' || wdt === 'INVENTORY' || wdt === 'FBM_INVENTORY') {
            alertsSettings[wdt] = { 'GREEN': false, 'RED': false, 'AMBER': false, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
          } else if (wdt === 'BAD_REVIEW' || wdt === 'TOP_REVIEW') {
            alertsSettings[wdt] = { 'GREEN': false, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
          } else {
            alertsSettings[wdt] = { 'GREEN': true, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } };
          }
        }
        var primaryEa = _this15.emailAddresses.filter(function (ea) {
          return ea.isPrimary;
        })[0];
        _this15.emailAddresses.splice(_this15.emailAddresses.length, 0, function () {
          var obj = {
            emailAddressId: { value: response.body.id },
            email: '',
            originalEmail: '',
            emailValid: false,
            emailVerified: false,
            isNew: true,
            isDeleted: false,
            subscribedToDailyDigestEmail: true,
            subscribedToNewsletter: false,
            manageSubscriptionSettings: false,
            alertsSettings: alertsSettings,
            unsubscribedSellerAccounts: [],
            originalUnsubscribedSellerAccounts: [],
            allowedSellerAccounts: [],
            originalallowedSellerAccounts: [],
            timezoneOffset: primaryEa.timezoneOffset,
            timezoneAdjustToDST: primaryEa.timezoneAdjustToDST,
            digestEmailHour: primaryEa.digestEmailHour,
            isDirty: function isDirty() {
              return true;
            }
          };
          obj.updateDigestTiming = function (timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
            obj.timezoneOffset = timezoneOffset;
            obj.timezoneAdjustToDST = timezoneAdjustToDST;
            obj.digestEmailHour = digestEmailHour;
          };
          return obj;
        }());
        _this15.addEmailAddressInProgress = false;
      }, function (response) {
        _this15.addEmailAddressInProgress = false;
        _this15.error = response.body.message;
      });
      return false;
    },
    updateEmailDirty: function updateEmailDirty() {
      this.emailDirty = this.emailAddresses.filter(function (ea) {
        return ea.isDirty();
      }).length > 0;
    },
    deleteEmailAddress: function deleteEmailAddress(i) {
      if (this.emailAddresses[i].isNew) {
        this.emailAddresses.splice(i, 1);
      } else {
        this.emailAddresses[i].isDeleted = true;
      }
      this.updateEmailDirty();
    },
    isValidEmail: function isValidEmail(candidate) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(candidate.email) && (candidate.isPrimary || this.emailAddresses.filter(function (ea) {
        return ea !== candidate && ea.email === candidate.email;
      }).length === 0);
    },
    sellerAccountDeleted: function sellerAccountDeleted(sellerId) {
      var _this16 = this;

      this.message = 'Account deletion in progress';
      setTimeout(function () {
        _this16.message = '';
      }, 3000);
      this.$emit('sellerAccountsUpdated');
      for (var i = 0; i < this.sellers.length; ++i) {
        if (this.sellers[i].sellerId.value === sellerId) {
          this.sellers.splice(i, 1);
          break;
        }
      }
    },
    isEmptyObject: function isEmptyObject(o) {
      return o === null || __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(o).length === 0;
    },
    openStripeWidget: function openStripeWidget() {
      this.stripeButtonClicked = true;

      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentMethods').popup('hide');
      this.initPaymentElement();
    },
    initPaymentElement: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, _ref2, loadStripe, publishableKey, setupIntentResponse, clientSecret, elements;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (!(this.stripeInstance && this.paymentElement)) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentElementModal').modal('show');
                return _context.abrupt('return');

              case 4:
                _context.prev = 4;
                _context.next = 7;
                return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 313));

              case 7:
                _ref2 = _context.sent;
                loadStripe = _ref2.loadStripe;
                publishableKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_stripePublishableKey_js__["a" /* stripePublishableKey */])();
                _context.next = 12;
                return loadStripe(publishableKey);

              case 12:
                this.stripeInstance = _context.sent;

                this.updatePaymentInProgress = true;
                _context.next = 16;
                return this.$http.post('/api/billing/setup-intent/create');

              case 16:
                setupIntentResponse = _context.sent;
                clientSecret = setupIntentResponse.body.clientSecret;
                elements = this.stripeInstance.elements({
                  clientSecret: clientSecret,
                  appearance: {
                    theme: 'stripe'
                  }
                });

                this.elementsGroup = elements;

                this.paymentElement = elements.create('payment');
                this.paymentElement.mount('#payment-element');

                this.setupIntentClientSecret = clientSecret;
                this.updatePaymentInProgress = false;
                __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentElementModal').modal('show');
                _context.next = 33;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](4);

                console.error('Error initializing Payment Element:', _context.t0);
                this.error = 'Failed to load payment form. Please try again.';
                this.updatePaymentInProgress = false;
                this.stripeButtonClicked = false;

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 27]]);
      }));

      function initPaymentElement() {
        return _ref.apply(this, arguments);
      }

      return initPaymentElement;
    }(),
    confirmPaymentMethod: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this17 = this;

        var self, _ref4, submitError;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;

                if (!(!this.stripeInstance || !this.setupIntentClientSecret)) {
                  _context2.next = 4;
                  break;
                }

                this.error = 'Payment form not initialized';
                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;

                this.updatePaymentInProgress = true;

                _context2.next = 8;
                return this.stripeInstance.confirmSetup({
                  elements: this.elementsGroup,
                  confirmParams: {
                    return_url: window.location.origin + '/settings?payment_method_set=success'
                  },
                  redirect: 'if_required'
                });

              case 8:
                _ref4 = _context2.sent;
                submitError = _ref4.error;

                if (!submitError) {
                  _context2.next = 14;
                  break;
                }

                this.error = submitError.message;
                this.updatePaymentInProgress = false;
                return _context2.abrupt('return');

              case 14:
                this.updatePaymentInProgress = false;
                this.message = 'Payment method has been updated';
                this.paymentDetailsSaved = true;
                __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentElementModal').modal('hide');
                this.loadBilling();

                setTimeout(function () {
                  _this17.message = '';
                }, 4000);

                if (this.paymentElement) {
                  this.paymentElement.unmount();
                  this.paymentElement = null;
                }
                this.elementsGroup = null;
                this.setupIntentClientSecret = null;
                this.stripeButtonClicked = false;
                _context2.next = 31;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2['catch'](4);

                console.error('Error confirming payment method:', _context2.t0);
                this.error = _context2.t0.message || 'Failed to update payment method';
                this.updatePaymentInProgress = false;

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 26]]);
      }));

      function confirmPaymentMethod() {
        return _ref3.apply(this, arguments);
      }

      return confirmPaymentMethod;
    }(),
    handlePaymentMethodReturn: function handlePaymentMethodReturn() {
      var _this18 = this;

      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('payment_method_set') === 'success') {
        this.message = 'Payment method has been updated';
        this.paymentDetailsSaved = true;
        this.loadBilling();
        setTimeout(function () {
          _this18.message = '';
        }, 4000);

        window.history.replaceState({}, document.title, '/settings');
      }
    },
    cancelSubscriptionConfirm: function cancelSubscriptionConfirm() {
      var _this19 = this;

      this.cancelInProgress = true;

      this.$http.delete('/api/billing/subscription/cancel').then(function (res) {
        _this19.loadBilling();
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('hide');
        _this19.cancelInProgress = false;
        _this19.error = res.body.message;
        window.alert('Your subscription has now been cancelled. \nYou may still use SentryKit until the end of this billing period.');
        _this19.$router.push('/cancelsubscription');
      }, function (res) {
        _this19.error = res.body.message;
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('hide');
        _this19.cancelInProgress = false;
      });
      return false;
    },
    newPricingOrDiscount: function newPricingOrDiscount() {
      console.info('SettingsPage:');
      console.info(this.$root.hasDailyPricing);
      if (!this.$root.hasDailyPricing) {
        console.info('Offering new plan');
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('hide');
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionNewPricingModal').modal('show');
      } else {
        console.info('Offering discount');
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('show');
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionNewPricingModal').modal('hide');
      }
    },
    redeemNewPricing: function redeemNewPricing() {
      var _this20 = this;

      this.$http.put('/api/billing/subscription/daily').then(function (res) {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionNewPricingModal').modal('hide');
        _this20.cancelInProgress = false;
        _this20.redeemedNewPricing = true;
        _this20.$router.push('/newpricingredeemed');
      }, function (res) {
        _this20.error = res.body.message;
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionNewPricingModal').modal('hide');
        _this20.cancelInProgress = false;
      });
    },
    applyCouponConfirm: function applyCouponConfirm() {
      var _this21 = this;

      this.cancelInProgress = true;
      this.$http.put('/api/billing/subscription/apply/coupon').then(function (res) {
        _this21.loadBilling();
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('hide');
        _this21.cancelInProgress = false;
        if (res.body.message) {
          _this21.error = res.body.message;
        } else {
          _this21.$router.push('/subscription');
        }
      }, function (res) {
        _this21.error = res.body.message;
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscriptionModal').modal('hide');
        _this21.cancelInProgress = false;
      });
    },
    openCancelConfirm: function openCancelConfirm() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscription').modal({
        onApprove: function onApprove(e) {
          return false;
        }
      }).modal('show');
    },
    openResumeConfirm: function openResumeConfirm() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#resumeSubscription').modal({
        onApprove: function onApprove(e) {
          _this22.resumeInProgress = true;
          _this22.$http.put('/api/billing/subscription/resume').then(function (res) {
            _this22.loadBilling();
            __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#resumeSubscription').modal('hide');
            _this22.resumeInProgress = false;
          }, function (res) {
            _this22.error = res.body.message;
            __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#resumeSubscription').modal('hide');
            _this22.resumeInProgress = false;
          });
          return false;
        }
      }).modal('show');
    },
    disabled: function disabled(wdt, status) {
      if (status === 'GREEN') return ['SALES_DROP', 'KEYWORD', 'LOST_BUYBOX', 'BEST_SELLER_BADGE', 'STAR_RATING_RECENT_CHANGE', 'PRICE', 'BAD_REVIEW', 'NO_ADD_TO_CART', 'SEARCH_BAN', 'INVENTORY', 'FBM_INVENTORY'].indexOf(wdt) < 0;
      if (status === 'AMBER') return ['SALES_DROP', 'BAD_REVIEW', 'TOP_REVIEW', 'STAR_RATING_RECENT_CHANGE', 'PRICE', 'INVENTORY'].indexOf(wdt) < 0;
      return false;
    },
    autoSelectProducts: function autoSelectProducts(addonCount) {
      var _this23 = this;

      var productCount = this.packageDetails.baseSubscriptionProducts + addonCount * this.packageDetails.addonSubscriptionProducts;
      this.autoSelectingAddon = addonCount;
      this.$http.put('/api/product/auto-select', { productCount: productCount }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscription').modal('hide');
        _this23.$router.push('/productsettings');
      }, function (res) {
        __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscription').modal('hide');
        _this23.$router.push('/productsettings');
      });
    },
    loadAuthorizations: function loadAuthorizations() {
      var _this24 = this;

      this.$http.get('/api/identity/authorizations').then(function (response) {
        _this24.authorizations = response.body.map(function (a) {
          return __WEBPACK_IMPORTED_MODULE_15_jquery___default.a.extend(a, { clicked: false });
        });
        _this24.googleSheetsList = _this24.authorizations.filter(function (a) {
          return a.name === 'Google Sheets';
        });
        _this24.zapierList = _this24.authorizations.filter(function (a) {
          return a.name === 'Zapier';
        });
        _this24.googleSheetAuth = _this24.googleSheetsList > 0 ? _this24.googleSheetsList[0] : null;
        _this24.zapierAuth = _this24.zapierList > 0 ? _this24.zapierList[0] : null;
      });
    },
    deleteAuthorization: function deleteAuthorization(a) {
      var _this25 = this;

      if (a.clicked) {
        this.$http.delete('/api/identity/authorization/' + a.id).then(function (response) {
          _this25.loadAuthorizations();
        });
      } else {
        a.clicked = true;
      }
    },
    googleSheetsAuthorizationUrl: function googleSheetsAuthorizationUrl() {
      this.$http.get('/api/googlesheets/authorizationurl').then(function (response) {
        window.open(response.body, '_blank');
      });
    },
    googleSheetsUrl: function googleSheetsUrl() {
      window.open('https://docs.google.com/spreadsheets/d/' + this.gsheetsConnection.spreadsheetId, '_blank');
    },
    createAchSource: function createAchSource() {
      var _this26 = this;

      this.updatePaymentInProgress = true;
      this.$http.put('/api/billing/ach-source').then(function (response) {
        _this26.updatePaymentInProgress = false;
        _this26.message = 'Payment method has been updated';
        _this26.paymentDetailsSaved = true;
        _this26.loadBilling();
        setTimeout(function () {
          _this26.message = '';
        }, 4000);
      }, function (response) {
        _this26.updatePaymentInProgress = false;
        _this26.error = response.body.message;
        _this26.loadBilling();
      });
    },
    viewAchDetails: function viewAchDetails() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentMethods').popup('hide');
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentMethodModal').modal('show');
      if (this.paymentMethod && this.paymentMethod.method === 'ach') {
        var progressEl = __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#achProgressBalance');
        if (progressEl) progressEl.progress();
      }
    },
    showAddUserModal: function showAddUserModal() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#addUserModal').modal({ centered: false }).modal('show');
    },
    hideAddUserModal: function hideAddUserModal() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#addUserModal').modal({ centered: false }).modal('hide');
    },
    showDeactivateUserModal: function showDeactivateUserModal() {
      var self = this;
      this.loadTenantUsers();
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#deactivateUserModal').modal({
        centered: false,
        onVisible: function onVisible() {
          self.$nextTick(function () {
            self.refreshSemanticDropdowns();
            try {
              if (self.$refs.dropdown && window.$(self.$refs.dropdown).length) {
                window.$(self.$refs.dropdown).dropdown('clear');
              }
            } catch (e) {}
          });
        }
      }).modal('show');
    },
    hideDeactivateUserModal: function hideDeactivateUserModal() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#deactivateUserModal').modal({ centered: false }).modal('hide');
    }
  },
  computed: {
    timezoneDirty: function timezoneDirty() {
      return this.timezone !== this.initialTimezone || this.timezoneAdjustToDST !== this.initialTimezoneAdjustToDST;
    },
    nameDirty: function nameDirty() {
      return this.firstName !== this.firstNameOrig || this.lastName !== this.lastNameOrig;
    },
    dailyDigestTimeDirty: function dailyDigestTimeDirty() {
      return this.dailyDigestTime !== this.initialDailyDigestTime;
    },
    instantAlertDirty: function instantAlertDirty() {
      return this.initialInstantAlert !== this.instantAlert;
    },
    alertSubjectDirty: function alertSubjectDirty() {
      return this.initialAlertSubject !== this.alertSubject;
    },
    batchingIntervalHoursDirty: function batchingIntervalHoursDirty() {
      return this.initialBatchingIntervalHours !== this.batchingIntervalHours;
    },
    dirty: function dirty() {
      return (this.emailDirty || this.sellersDirty || this.timezoneDirty || this.nameDirty || this.dailyDigestTimeDirty || this.instantAlertDirty || this.instantAlert && this.alertSubjectDirty || !this.instantAlert && this.batchingIntervalHoursDirty) && this.emailsValid;
    },
    packageCost: function packageCost() {
      return this.packageDetails ? this.packageDetails.baseSubscriptionFeeCents + this.packageDetails.addonSubscriptionFeeCents * this.addonCount : null;
    },
    hasEnoughACHFunds: function hasEnoughACHFunds() {
      return this.paymentMethod.details ? this.paymentMethod.details.balance >= this.packageCost : null;
    },

    manageUsersTableRows: function manageUsersTableRows() {
      var self = this;
      var users = Array.isArray(this.tenantUsers) ? this.tenantUsers : [];
      return users.map(function (u) {
        var ea = null;
        for (var i = 0; i < self.emailAddresses.length; i++) {
          var row = self.emailAddresses[i];
          if (!row.isDeleted && row.email === u.email) {
            ea = row;
            break;
          }
        }
        return { user: u, emailAddress: ea };
      });
    },

    primarySettingsAccountEmail: function primarySettingsAccountEmail() {
      var p = this.emailAddresses.filter(function (ea) {
        return ea.isPrimary;
      })[0];
      return p && p.email ? p.email : '';
    },

    tenantUsersForTeamAndAlertsDropdown: function tenantUsersForTeamAndAlertsDropdown() {
      var primary = this.primarySettingsAccountEmail;
      var list = Array.isArray(this.tenantUsers) ? this.tenantUsers : [];
      if (!primary) {
        return list.slice();
      }
      return list.filter(function (u) {
        return u.email && u.email !== primary;
      });
    },

    tenantUsersForDeactivateModal: function tenantUsersForDeactivateModal() {
      var primary = this.primarySettingsAccountEmail;
      var list = Array.isArray(this.tenantUsers) ? this.tenantUsers : [];
      return list.filter(function (u) {
        if (!u.email) return false;
        if (u.isOwner) return false;
        if (primary && u.email === primary) return false;
        return true;
      });
    }
  },
  watch: {
    emailAddresses: {
      handler: function handler(value) {
        var emailsValid = true;
        this.updateEmailDirty();
        for (var i = 0; i < value.length; ++i) {
          var ea = value[i];
          ea.email = ea.email.replace(/[ |\t]/g, '');
          ea.emailValid = this.isValidEmail(ea);
          ea.validationEmailSent = false;
          emailsValid = emailsValid && ea.emailValid;
        }
        this.emailsValid = emailsValid;
      },
      deep: true
    },
    subscribedToDailyDigestEmail: function subscribedToDailyDigestEmail() {
      this.updateEmailDirty();
    },
    subscribedToNewsletter: function subscribedToNewsletter() {
      this.updateEmailDirty();
    },
    dirty: function dirty() {
      window.dirty = this.dirty;
    },
    tenantUsers: function tenantUsers() {
      var self = this;
      this.$nextTick(function () {
        self.refreshSemanticDropdowns();
      });
    }
  },
  created: function created() {
    var _this27 = this;

    this.loadSettings();
    this.loadTenantUsers();
    if (this.$root.paymentStatus !== 0) this.loadBilling();
    this.loadAuthorizations();
    this.$http.get('/api/googlesheets/connection-status').then(function (response) {
      _this27.gsheetsConnection = response.body;
    });
    this.fetchSuppressedWatchdogs();
  },
  mounted: function mounted() {
    var _this28 = this;

    this.handlePaymentMethodReturn();
    this.addNotificationEmailAddressesModalElement = __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#addNotificationEmailAddressesModal');
    this.addNotificationEmailAddressesModalElement.modal({ onApprove: this.addEmailAddress });

    var paymentMethodElement = __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#paymentMethods');
    paymentMethodElement.popup({ on: 'click' });
    __WEBPACK_IMPORTED_MODULE_15_jquery___default()(this.$refs.dropdown).dropdown({
      onChange: function onChange(value, text, $selectedItem) {
        var vals = value ? String(value).split(',').filter(function (v) {
          return v !== '';
        }) : [];
        if (vals.indexOf('-1') !== -1) {
          _this28.selectedOptions = _this28.tenantUsersForDeactivateModal.map(function (u) {
            return u.email;
          });
        } else {
          _this28.selectedOptions = vals;
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_15_jquery___default()(this.$refs.assignedUser).dropdown({
      onChange: function onChange(value, text, $selectedItem) {
        var vals = value ? String(value).split(',').filter(function (v) {
          return v !== '';
        }) : [];
        _this28.selectedAssignedUser = vals;
        if (vals.indexOf('-1') !== -1) {
          _this28.assignedUserList = _this28.emailAddresses;
        } else {
          _this28.assignedUserList = _this28.emailAddresses.filter(function (ea) {
            return vals.indexOf(ea.email) !== -1;
          });
        }
      }
    });
    if (this.$refs.storefrontTeamSelect) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()(this.$refs.storefrontTeamSelect).dropdown({
        fullTextSearch: 'exact',
        onChange: function onChange(value) {
          var vals = value ? String(value).split(',').filter(function (v) {
            return v !== '';
          }) : [];
          self.selectedTeamStorefronts = vals;
          self.syncAssignedUserListFromTeamStorefronts();
        }
      });
    }
    if (this.$refs.alertUser) {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()(this.$refs.alertUser).dropdown({
        onChange: function onChange(value, text, $selectedItem) {
          _this28.alertUser = value || null;
          _this28.onAlertUserChange();
        }
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!window.dirty) {
      next();
    } else if (window.confirm('Please confirm that you want to close your Account Settings.\nYou have some unsaved changes.')) {
      window.dirty = false;
      next();
    }
  },

  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#cancelSubscription').remove();
    __WEBPACK_IMPORTED_MODULE_15_jquery___default()('#invoicesModal').remove();
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_publicAuthRoutes__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_amazonSellingPartnerOAuth__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_googleSignIn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_amazon_wordmark_png__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_amazon_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_amazon_wordmark_png__);











var ASGTG_SOURCE = 'asgtg';
var ASGTG_PROMO_CODE = 'ASGTG20';
var VOICE_INTERVAL_MS = 6500;
var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
var FIELD_ORDER = ['email', 'name', 'password', 'accountType'];
var FIELD_LABELS = { email: 'work email', name: 'your name', password: 'password', accountType: 'seller type' };

var AMAZON_REGIONS = [{ value: 'NA', label: 'North America' }, { value: 'EU', label: 'Europe' }, { value: 'FE', label: 'Asia Pacific' }, { value: 'ME', label: 'Middle East' }, { value: 'IN', label: 'India' }];
var AMAZON_EXPIRED_MESSAGE = 'That Amazon approval expired. Click Sign up with Amazon again. It takes a few seconds.';
var SSO_ERROR_MESSAGES = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__utils_googleSignIn__["a" /* GOOGLE_SSO_ERROR_MESSAGES */], {
  amazon_cancelled: 'Amazon sign-up was cancelled. You can try again or sign up with email.',
  amazon_exchange: "We couldn't finish connecting to Amazon. Please click Sign up with Amazon again.",
  amazon_already_connected: 'This Amazon seller account is already connected to SentryKit. Log in with that account, or contact support@sentrykit.com.',
  amazon_legacy_account: 'This Amazon seller account is registered with legacy SentryKit. Log in with your existing email, or contact support@sentrykit.com to migrate.',
  amazon_failed: 'Something went wrong connecting to Amazon. Please try again or sign up with email.'
});

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var emailhash = this.$root.deeplink ? this.$root.deeplink.indexOf('email=') : -1;
    var initialEmail = emailhash > -1 ? this.$root.deeplink.substr(emailhash + 6) : '';
    return {
      companyName: '',
      accountType: '',
      fullName: '',
      email: initialEmail,
      typedEmail: initialEmail,
      password: '',
      showPassword: false,
      fieldErrors: { email: false, name: false, password: false, accountType: false },
      error: '',
      working: false,
      invite: '',
      signupFormStartedTracked: false,
      chatAvailable: false,
      sellerTypes: [{ value: 'brand', label: 'Private label / brand' }, { value: 'merchant', label: 'Wholesale / distribution' }, { value: 'agency', label: 'Agency / aggregator' }, { value: 'oa', label: 'Online arbitrage' }],
      voices: [{ tab: 'Speed', text: 'The notification arrived even before I saw it in Seller Central, so perfect!', who: 'Seller · Italy' }, { tab: 'Support', text: "I'm really happy with it and the support is excellent.", who: 'Seller · Italy' }, { tab: 'Detail', text: 'Very informative and helpful. … A+ product so far!', who: 'Supplement brand · United States' }, { tab: 'Value', ours: true, text: 'Many tools charge per ASIN, so every new marketplace raises your bill. We charge one flat price per storefront: unlimited ASINs, every marketplace.', who: 'Our pricing promise' }, { tab: 'Teams', text: 'The trial went quite well. … I would like to show this to the MDs of the company world wide', who: 'Electronics brand · United Kingdom' }],
      voiceIndex: 0,
      voiceCycle: 0,
      voicePaused: false,
      voiceTimer: null,
      reduceMotion: false,
      amazonWordmark: __WEBPACK_IMPORTED_MODULE_7__assets_amazon_wordmark_png___default.a,
      amazonRegions: AMAZON_REGIONS,
      amazonRegion: 'NA',
      showRegionPicker: false,
      amazonWorking: false,
      googleSignupEnabled: true,
      finishMode: this.$route.query.finish === 'amazon',
      pendingAmazon: null
    };
  },
  computed: {
    showSignedInBanner: function showSignedInBanner() {
      return !!(this.$root.authCompleted && this.$root.userEmail);
    },
    isAsgtg: function isAsgtg() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_publicAuthRoutes__["d" /* isAsgtgSignupPath */])(this.$route.path);
    },
    showSso: function showSso() {
      return !this.showSignedInBanner && !this.finishMode;
    },

    showAmazon: function showAmazon() {
      return !this.$route.query.amazon_callback_uri;
    },
    signupMethod: function signupMethod() {
      return this.finishMode ? 'amazon' : 'email';
    },
    passwordWeak: function passwordWeak() {
      var regex1 = /.*[_\- !"?$%^&*()+={}[\]:;@'~#|<>,.?\\/0123456789].*/;
      var regex2 = /.*[a-zA-Z].*/;
      return this.password.length < 8 || !regex1.test(this.password) || !regex2.test(this.password);
    },

    nameParts: function nameParts() {
      var parts = this.fullName.trim().split(/\s+/);
      return { first: parts[0] || '', last: parts.slice(1).join(' ') };
    }
  },
  methods: {
    logoutSignedIn: function logoutSignedIn() {
      if (this.$root.signOutUser) this.$root.signOutUser();
    },
    onSignupFormStarted: function onSignupFormStarted() {
      if (this.signupFormStartedTracked) return;
      this.signupFormStartedTracked = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sign_up_form_started', step: 1, method: this.signupMethod });
    },
    fieldValid: function fieldValid(key) {
      switch (key) {
        case 'email':
          return EMAIL_REGEX.test(this.email.trim());
        case 'name':
          return this.nameParts.first !== '';
        case 'password':
          return !this.passwordWeak;
        case 'accountType':
          return this.accountType !== '';
      }
      return true;
    },
    checkField: function checkField(key) {
      var ok = this.fieldValid(key);
      this.fieldErrors[key] = !ok;
      return ok;
    },
    onBlur: function onBlur(key) {
      var value = { email: this.email, name: this.fullName, password: this.password }[key];
      if (value) this.checkField(key);
    },

    onInput: function onInput(key, always) {
      if (always || this.fieldErrors[key]) this.checkField(key);
    },

    onEmailInput: function onEmailInput(e) {
      if (document.activeElement === e.target || !this.typedEmail) {
        this.typedEmail = this.email;
      } else if (this.email !== this.typedEmail) {
        this.email = this.typedEmail;
      }
      this.onInput('email');
    },
    validateAll: function validateAll() {
      var _this = this;

      var order = this.finishMode ? ['email', 'name', 'password'] : FIELD_ORDER;
      return order.filter(function (key) {
        return !_this.checkField(key);
      });
    },
    missingFieldsMessage: function missingFieldsMessage(bad) {
      var labels = bad.map(function (key) {
        return FIELD_LABELS[key];
      });
      var list = labels.length > 1 ? labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1] : labels[0];
      return 'Almost there. Please add your ' + list + '.';
    },
    focusField: function focusField(key) {
      var el = this.$refs[key];
      if (Array.isArray(el)) el = el[0];
      if (el && el.focus) el.focus();
    },
    getRecaptchaToken: function getRecaptchaToken() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var siteKey = window.RECAPTCHA_SITE_KEY;
        if (!siteKey || typeof window.grecaptcha === 'undefined') {
          resolve(null);
          return;
        }
        window.grecaptcha.ready(function () {
          window.grecaptcha.execute(siteKey, { action: 'signup' }).then(resolve, function () {
            resolve(null);
          });
        });
      });
    },
    signup: function signup() {
      var _this2 = this;

      if (this.working) return;
      var bad = this.validateAll();
      if (bad.length) {
        this.error = this.missingFieldsMessage(bad);
        this.focusField(bad[0]);
        return;
      }
      this.working = true;
      this.error = '';
      this.getRecaptchaToken().then(function (recaptchaToken) {
        var timezoneOffsetMins = 0 - new Date().getTimezoneOffset();
        var data = {
          email: _this2.email.trim(),
          firstName: _this2.nameParts.first,
          companyName: _this2.companyName.trim(),
          accountType: _this2.accountType,
          lastName: _this2.nameParts.last,
          password: _this2.password,
          inviteCode: _this2.invite,
          timezoneOffsetMins: timezoneOffsetMins,
          recaptchaToken: recaptchaToken
        };
        if (_this2.isAsgtg) {
          data.source = ASGTG_SOURCE;
          data.inviteCode = ASGTG_PROMO_CODE;
        }

        var endpoint = _this2.finishMode ? '/api/auth/amazon/finish' : '/api/auth/signup/standard';
        _this2.$http.post(endpoint, data).then(function () {
          try {
            window.fpr('referral', { email: data.email });
          } catch (e) {}
          var created = {
            event: 'sign_up_account_created',
            step: 1,
            method: _this2.signupMethod
          };
          if (_this2.accountType) created.seller_type = _this2.accountType;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])(created, function () {
            if (_this2.finishMode) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["d" /* fireConnectStoreSuccess */])('amazon', function () {
                window.location.assign('/welcome');
              });
            } else {
              _this2.login(data);
            }
          });
        }, function (response) {
          _this2.working = false;
          var body = response.body || {};

          if (_this2.finishMode && (response.status === 410 || String(body.code || '').indexOf('amazon_') === 0)) {
            _this2.finishMode = false;
            _this2.pendingAmazon = null;
          }

          var msg = Array.isArray(body.message) ? body.message.map(function (m) {
            return String(m).replace(/\.?$/, '.');
          }).join(' ') : body.message;
          msg = msg || 'Signup failed. Please try again.';
          _this2.error = msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({
            event: 'sign_up_form_error',
            error_field: body.field || 'general',
            error_message: msg
          });
        });
      });
    },
    login: function login(data) {
      var _this3 = this;

      this.$http.post('/api/auth/login/standard', {
        email: data.email,
        password: data.password,
        keepMeSignedIn: true
      }).then(function () {
        _this3.working = false;
        setTimeout(function () {
          _this3.$root.pendingPostCredentialsRedirect = true;
          _this3.$root.checkIfAuthenticated();
        }, 100);
      }, function (response) {
        _this3.working = false;
        _this3.error = response.body.message || 'Account created but login failed. Please try logging in.';
      });
    },
    regionLabel: function regionLabel(code) {
      var match = AMAZON_REGIONS.filter(function (r) {
        return r.value === code;
      })[0];
      return match ? match.label : 'North America';
    },
    startGoogleSignup: function startGoogleSignup() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_googleSignIn__["b" /* startGoogleSignIn */])('signup', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_googleSignIn__["c" /* googleReturnPath */])(this.$route), this.isAsgtg ? ASGTG_SOURCE : '');
    },
    startAmazonSignup: function startAmazonSignup() {
      var _this4 = this;

      if (this.amazonWorking) return;
      this.amazonWorking = true;
      this.error = '';
      var region = this.amazonRegion;
      var location = null;
      var gtmDone = false;
      var go = function go() {
        if (location && gtmDone) window.location = location;
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["c" /* markConnectStoreStarted */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_click', provider: 'amazon' }, function () {
        gtmDone = true;
        go();
      });
      this.$http.get('/api/auth/amazon/start', {
        params: {
          region: region,
          allMarketplaces: true,
          marketplace: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(region),
          marketplaceCodes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonSellingPartnerOAuth__["g" /* regionMarketplaceCodes */])(region).join(','),
          source: this.isAsgtg ? ASGTG_SOURCE : ''
        }
      }).then(function (response) {
        location = response.body.location;
        go();
      }, function (response) {
        _this4.amazonWorking = false;
        _this4.error = response.body && response.body.message || "Couldn't start Amazon sign-up. Please try again.";
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_error', provider: 'amazon', reason: 'start_failed' });
      });
    },
    loadPendingAmazonSignup: function loadPendingAmazonSignup() {
      var _this5 = this;

      var handoff = this.$route.query.handoff;
      if (handoff) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('handoff');
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        } catch (e) {}
      }
      this.$http.get('/api/auth/amazon/pending', { params: handoff ? { handoff: handoff } : {} }).then(function (response) {
        _this5.pendingAmazon = response.body;
      }, function (response) {
        _this5.finishMode = false;
        _this5.error = response.body && response.body.message || AMAZON_EXPIRED_MESSAGE;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_error', provider: 'amazon', reason: 'amazon_expired' });
      });
    },
    showSsoError: function showSsoError(reason) {
      var provider = reason.indexOf('amazon_') === 0 ? 'amazon' : 'google';
      this.error = SSO_ERROR_MESSAGES[reason] || SSO_ERROR_MESSAGES[provider + '_failed'];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sso_error', provider: provider, reason: reason });
    },
    openChat: function openChat() {
      if (typeof window.Intercom === 'function') window.Intercom('show');
    },
    showVoice: function showVoice(n) {
      this.voiceIndex = (n + this.voices.length) % this.voices.length;
      this.voiceCycle++;
    },
    selectVoice: function selectVoice(n) {
      this.showVoice(n);
      this.startVoices();
    },
    startVoices: function startVoices() {
      var _this6 = this;

      clearInterval(this.voiceTimer);
      if (this.reduceMotion || this.isAsgtg) return;
      this.voiceTimer = setInterval(function () {
        if (!_this6.voicePaused) _this6.showVoice(_this6.voiceIndex + 1);
      }, VOICE_INTERVAL_MS);
    },
    pauseVoices: function pauseVoices() {
      this.voicePaused = true;
    },
    resumeVoices: function resumeVoices() {
      this.voicePaused = false;
      this.showVoice(this.voiceIndex);
      this.startVoices();
    }
  },
  created: function created() {
    var _this7 = this;

    this.$root.$emit('fb-pixel-event', 'standard', 'Lead');
    if (this.finishMode) this.loadPendingAmazonSignup();
    if (this.$route.query.sso_error) this.showSsoError(String(this.$route.query.sso_error));
    if (this.isAsgtg) {
      this.invite = ASGTG_PROMO_CODE;
      return;
    }
    if (this.$route.query.code) {
      this.invite = this.$route.query.code;
    }
    if (this.$route.query.ref) {
      this.$http.get('/api/identity/invite/firstPromoter', { params: { ref_id: this.$route.query.ref } }).then(function (response) {
        _this7.invite = response.body.promo_code;
      }, function () {});
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    this.chatAvailable = typeof window.Intercom === 'function';

    this.onPageShow = function (e) {
      if (e.persisted) _this8.amazonWorking = false;
    };
    window.addEventListener('pageshow', this.onPageShow);
    this.startVoices();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voiceTimer);
    window.removeEventListener('pageshow', this.onPageShow);
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_stock_styles_StockDashboard_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_stock_styles_StockDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_stock_styles_StockDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_stock_StockAlertThresholdsPanel_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_stock_StockAlertThresholdsPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_stock_StockAlertThresholdsPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_stock_StockStatCards_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_stock_StockStatCards_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_stock_StockStatCards_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_stock_StockInventoryTable_vue__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_stock_StockInventoryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_stock_StockInventoryTable_vue__);















var STOCK_URL_KEYS = ['status', 'q', 'marketplaces', 'sellerAccounts', 'page', 'sort', 'order'];
var STOCK_TABLE_SORT_KEYS = ['fbaStock', 'fbmStock', 'velocity', 'daysLeft', 'status'];

function shallowEqualStockQuery(next, routeQuery) {
  for (var i = 0; i < STOCK_URL_KEYS.length; i++) {
    var k = STOCK_URL_KEYS[i];
    var nv = next[k] != null ? String(next[k]) : '';
    var rv = routeQuery && routeQuery[k] != null ? String(routeQuery[k]) : '';
    if (nv !== rv) return false;
  }
  return true;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StockPage',
  components: { DashboardLayout: __WEBPACK_IMPORTED_MODULE_8__components_buybox_DashboardLayout_vue___default.a, StockAlertThresholdsPanel: __WEBPACK_IMPORTED_MODULE_9__components_stock_StockAlertThresholdsPanel_vue___default.a, StockStatCards: __WEBPACK_IMPORTED_MODULE_10__components_stock_StockStatCards_vue___default.a, StockInventoryTable: __WEBPACK_IMPORTED_MODULE_11__components_stock_StockInventoryTable_vue___default.a },

  data: function data() {
    return {
      thresholdPanelOpen: false,
      thresholdPanelReady: false,

      activeFilter: 'all',
      searchQuery: '',
      searchTimeout: null,
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      stockFilterData: { availableFilters: null },
      loadingFilters: false,

      tableSortKey: 'fbaStock',
      tableSortDir: 'desc',

      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,

      _syncingDropdowns: false,
      _applyingStockRouteQuery: false
    };
  },

  computed: {
    worldStore: function worldStore() {
      return this.$parent && this.$parent.worldStore;
    },
    hasStockData: function hasStockData() {
      return !!(this.worldStore && this.worldStore.products !== undefined);
    },

    selectedSellerIdSet: function selectedSellerIdSet() {
      var s = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();(this.filterBySellAcc || []).forEach(function (id) {
        s.add(String(id));
      });
      return s;
    },
    sellerAccountsList: function sellerAccountsList() {
      var af = this.stockFilterData && this.stockFilterData.availableFilters;
      if (!af || !af.sellerAccounts || af.sellerAccounts.length === 0) return [];
      return af.sellerAccounts.map(function (sa) {
        return { sellerId: sa.id, accountNickName: sa.name };
      });
    },
    filteredCountries: function filteredCountries() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterUserCountries, this.filterCountriesAll);
    },

    products: function products() {
      if (!this.worldStore || !this.worldStore.products) return [];
      var ids = this.$parent && this.$parent.stockPageProductIds || [];
      var out = [];
      for (var i = 0; i < ids.length; i++) {
        var p = this.worldStore.products[ids[i]];
        if (!p) continue;
        var fulfillable = p.fbaAvailable != null ? p.fbaAvailable : 0;
        var reserved = p.reservedStock != null ? p.reservedStock : 0;
        var pct = p.trend;
        var trendText, trendCls;
        if (pct !== null && pct !== undefined) {
          trendCls = pct > 0 ? 'up' : pct < 0 ? 'down' : 'neutral';
          trendText = pct > 0 ? '↑ +' + pct + '% vs last wk' : pct < 0 ? '↓ ' + pct + '% vs last wk' : '— 0% vs last wk';
        } else {
          trendCls = 'neutral';
          trendText = '';
        }
        out.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, p, {
          _fulfillable: fulfillable,
          _reserved: reserved,
          _fbaTotal: fulfillable + reserved,
          _isTransferring: fulfillable === 0 && reserved > 0,
          _trendText: trendText,
          _trendCls: trendCls
        }));
      }
      return out;
    },

    statsData: function statsData() {
      var s = this.$parent && this.$parent.stocksSummary;
      return {
        totalProducts: s && s.totalProducts || 0,
        healthyStock: s && s.healthyStock || 0,
        lowStockWarning: s && s.lowStockWarning || 0,
        outOfStock: s && s.outOfStock || 0,
        healthyPercentage: s && s.healthyPercentage || 0
      };
    },
    marketplaceCount: function marketplaceCount() {
      var seen = {};
      this.products.forEach(function (p) {
        if (p.marketplace) seen[p.marketplace] = true;
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(seen).length;
    },

    currentPage: function currentPage() {
      return this.$parent ? this.$parent.stocksCurrentPage || 0 : 0;
    },
    totalPages: function totalPages() {
      return this.$parent ? this.$parent.stocksTotalPages || 0 : 0;
    },
    totalItems: function totalItems() {
      return this.$parent ? this.$parent.stocksTotalItems || 0 : 0;
    },
    paginationPages: function paginationPages() {
      var total = this.totalPages;
      var current = this.currentPage;
      var start, end;
      if (total <= 5) {
        start = 0;end = total - 1;
      } else {
        start = Math.max(0, current - 2);
        end = Math.min(total - 1, start + 4);
        start = Math.max(0, end - 4);
      }
      var pages = [];
      for (var i = start; i <= end; i++) {
        pages.push(i);
      }return pages;
    },

    thresholdSellerAccountId: function thresholdSellerAccountId() {
      return this.filterBySellAcc.length === 1 ? String(this.filterBySellAcc[0]) : null;
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.path !== '/stock') return;
      if (this._applyingStockRouteQuery) return;
      if (from && from.path === to.path && shallowEqualStockQuery(this.buildRouteQuery(), to.query)) return;
      this.applyRouteQuery(to.query);
      this.loadPage(this.currentPage);
    },
    filterUserCountries: function filterUserCountries() {
      this.$nextTick(this.initDropdowns);
    },
    sellerAccountsList: function sellerAccountsList() {
      this.$nextTick(this.initDropdowns);
    }
  },

  created: function created() {
    this.applyRouteQuery(this.$route.query);
  },
  mounted: function mounted() {
    this.startTimer();
    this.loadFilters();
    this.loadPage(this.currentPage);
    this.$nextTick(this.initDropdowns);
    this.$nextTick(this.syncRouteQuery);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timerInterval);
    clearTimeout(this.searchTimeout);
  },

  methods: {
    onFilterChange: function onFilterChange(filter) {
      this.activeFilter = filter;
      this.fetchData();
    },
    onSort: function onSort(column) {
      if (STOCK_TABLE_SORT_KEYS.indexOf(column) === -1) return;
      if (this.tableSortKey !== column) {
        this.tableSortKey = column;
        this.tableSortDir = column === 'status' ? 'asc' : 'desc';
      } else {
        this.tableSortDir = this.tableSortDir === 'desc' ? 'asc' : 'desc';
      }
      if (this.$parent) this.$parent.stocksCurrentPage = 0;
      this.loadPage(0, true);
    },
    onSearch: function onSearch(query) {
      this.searchQuery = query;
      clearTimeout(this.searchTimeout);
      var self = this;
      this.searchTimeout = setTimeout(function () {
        self.fetchData();
      }, 500);
    },
    onPage: function onPage(page) {
      var p = Number(page);
      if (p < 0 || p >= this.totalPages) return;
      this.loadPage(p, true);
    },
    onShowDetails: function onShowDetails(productId) {
      if (this.$parent && this.$parent.$refs && this.$parent.$refs.chartModal) {
        var product = this.worldStore.products[productId];
        if (product) this.$parent.$refs.chartModal.open(product, null);
      }
    },

    toggleThresholdPanel: function toggleThresholdPanel() {
      if (this.thresholdPanelOpen) {
        this.thresholdPanelOpen = false;
        this.thresholdPanelReady = false;
      } else if (this.hasStockData) {
        this.thresholdPanelReady = false;
        this.thresholdPanelOpen = true;
      }
    },
    onThresholdClose: function onThresholdClose() {
      this.thresholdPanelOpen = false;
      this.thresholdPanelReady = false;
    },
    onThresholdSaved: function onThresholdSaved() {
      this.refreshSummary();
      this.loadPage(this.currentPage, true);
    },

    fetchArgs: function fetchArgs(page, skipSummary) {
      return [page, this.$parent.stocksPageSize, this.searchQuery.trim() || null, this.activeFilter === 'all' ? null : this.activeFilter, this.filterByMarket.length > 0 ? this.filterByMarket.join(',') : null, this.filterBySellAcc.length > 0 ? this.filterBySellAcc.join(',') : null, this.tableSortKey, this.tableSortDir, !!skipSummary];
    },
    fetchData: function fetchData() {
      if (!this.$parent.stockData) return;
      this.$parent.stocksCurrentPage = 0;
      if (this.activeFilter !== 'all') this.refreshSummary();
      this.$parent.stockData.apply(this.$parent, this.fetchArgs(0));
      this.syncRouteQuery();
    },
    loadPage: function loadPage(page, skipSummary) {
      if (!this.$parent.stockData) return;
      this.$parent.stockData.apply(this.$parent, this.fetchArgs(page, skipSummary));
      this.syncRouteQuery();
    },
    refreshSummary: function refreshSummary() {
      if (!this.$parent.stockSummaryData) return;
      this.$parent.stockSummaryData(this.filterByMarket.length > 0 ? this.filterByMarket.join(',') : null, this.filterBySellAcc.length > 0 ? this.filterBySellAcc.join(',') : null);
    },

    buildRouteQuery: function buildRouteQuery() {
      var o = {};
      if (this.activeFilter !== 'all') o.status = this.activeFilter;
      if (this.searchQuery.trim()) o.q = this.searchQuery.trim();
      if (this.filterByMarket.length) o.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length) o.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      if (this.currentPage > 0) o.page = String(this.currentPage);
      if (this.tableSortKey !== 'fbaStock') o.sort = this.tableSortKey;
      if (this.tableSortDir !== 'desc') o.order = this.tableSortDir;
      return o;
    },
    syncRouteQuery: function syncRouteQuery() {
      if (this._applyingStockRouteQuery || this.$route.path !== '/stock') return;
      var next = this.buildRouteQuery();
      if (shallowEqualStockQuery(next, this.$route.query)) return;
      this.$router.replace({ path: '/stock', query: next });
    },
    applyRouteQuery: function applyRouteQuery(q) {
      if (!q || (typeof q === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(q)) !== 'object') return false;
      var has = STOCK_URL_KEYS.some(function (k) {
        return q[k] != null && q[k] !== '';
      });
      if (!has) return false;
      this._applyingStockRouteQuery = true;
      try {
        this.activeFilter = q.status && ['all', 'healthy', 'low', 'critical'].indexOf(q.status) >= 0 ? q.status : 'all';
        this.searchQuery = q.q != null ? String(q.q) : '';
        this.filterByMarket = q.marketplaces ? String(q.marketplaces).split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean) : [];
        this.filterBySellAcc = q.sellerAccounts ? String(q.sellerAccounts).split(',').map(function (s) {
          var t = s.trim();var n = Number(t);return isNaN(n) ? t : n;
        }).filter(Boolean) : [];
        this.tableSortKey = q.sort && STOCK_TABLE_SORT_KEYS.indexOf(String(q.sort)) >= 0 ? String(q.sort) : 'fbaStock';
        this.tableSortDir = q.order === 'asc' || q.order === 'desc' ? q.order : 'desc';
        if (this.$parent && q.page != null && q.page !== '') {
          var pn = parseInt(q.page, 10);
          if (!isNaN(pn) && pn >= 0) this.$parent.stocksCurrentPage = pn;
        }
      } finally {
        var self = this;
        this.$nextTick(function () {
          self._applyingStockRouteQuery = false;
        });
      }
      return true;
    },

    initDropdowns: function initDropdowns() {
      var self = this;
      if (this.$refs.saDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.saDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.saDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterBySellAcc = v === '' ? [] : v.split(',').map(Number);
            self.fetchData();
          },
          placeholder: 'All Accounts',
          fullTextSearch: true
        });
      }
      if (this.$refs.marketplaceDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.marketplaceDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.marketplaceDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterByMarket = v === '' ? [] : v.split(',');
            self.fetchData();
          },
          placeholder: 'All Marketplaces',
          fullTextSearch: true
        });
      }
    },

    loadFilters: function loadFilters() {
      var self = this;
      this.loadingFilters = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([self.$http.get('/api/sentinel/products', { params: { productsOnly: true, page: 0, pageSize: 1 } }), self.$http.get('/api/v1/sellers').catch(function () {
        return { body: null };
      })]).then(function (results) {
        self.loadingFilters = false;
        var body = results[0] && results[0].body || {};
        var sellersBody = results[1] && results[1].body || {};
        var fromV1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(sellersBody));
        var fromProducts = body.availableFilters && body.availableFilters.sellerAccounts || [];
        var sellerAccounts = fromV1.length > 0 ? fromV1.map(function (r) {
          return { id: r.id, name: r.name };
        }) : fromProducts.map(function (sa) {
          return { id: sa.id, name: sa.name || 'Account ' + sa.id };
        });
        var marketplaces = body.availableFilters && body.availableFilters.marketplaces || [];
        self.filterUserCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["f" /* buildMarketplaceFilterCodes */])({
          fromAvailableFilters: marketplaces,
          v1SellersBody: sellersBody,
          canonicalOrder: self.filterCountriesAll.filter(function (c) {
            return c !== 's';
          })
        });
        if (self.filterByMarket.length > 0) {
          var mpSet = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(self.filterUserCountries);
          self.filterByMarket = self.filterByMarket.filter(function (x) {
            return mpSet.has(x);
          });
        }
        self.stockFilterData.availableFilters = { marketplaces: marketplaces, sellerAccounts: sellerAccounts };
        if (sellerAccounts.length > 0 && self.filterBySellAcc.length > 0) {
          var idSet = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(sellerAccounts.map(function (sa) {
            return String(sa.id);
          }));
          self.filterBySellAcc = self.filterBySellAcc.filter(function (id) {
            return idSet.has(String(id));
          });
        }
        self.$nextTick(self.initDropdowns);
      }, function () {
        self.loadingFilters = false;
        self.stockFilterData.availableFilters = null;
      });
    },

    startTimer: function startTimer() {
      this.lastUpdateTime = Date.now();
      this.lastUpdated = 'just now';
      var self = this;
      this.timerInterval = setInterval(function () {
        var diff = Math.floor((Date.now() - self.lastUpdateTime) / 1000);
        if (diff < 60) self.lastUpdated = diff + 's ago';else if (diff < 3600) self.lastUpdated = Math.floor(diff / 60) + 'm ago';else self.lastUpdated = Math.floor(diff / 3600) + 'h ago';
      }, 1000);
    },

    mpSuffix: function mpSuffix(country) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["a" /* getMarketplaceAmazonSuffix */])(country);
    },
    exportCSV: function exportCSV() {
      var rows = [['Product', 'ASIN', 'Marketplace', 'FBA Fulfillable', 'FBA Transferring', 'FBA Reserved', 'FBA Inbound', 'FBM Stock', 'Velocity', 'Days Left', 'Status']];
      this.products.forEach(function (p) {
        rows.push(['"' + (p.productTitle || '').replace(/"/g, '""') + '"', p.asin || String(p.productId || ''), p.marketplace || '', p._fulfillable, p._reserved, p._reserved, p.fbaInbound != null ? p.fbaInbound : '', p.fbmStock != null ? p.fbmStock : '', p.velocity != null ? p.velocity : '', p.daysLeft != null ? p.daysLeft : '', p.status || 'Unknown']);
      });
      var csv = rows.map(function (r) {
        return r.join(',');
      }).join('\n');
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'stock-inventory-' + new Date().toISOString().slice(0, 10) + '.csv';
      link.click();
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      email: '',
      password: '',
      keepMeSignedIn: true,
      error: '',
      working: false
    };
  },
  methods: {},
  mounted: function mounted() {},
  created: function created() {
    if (window.location.hostname.includes('sentrykit')) {
      window.hj('event', 'cancel_subscription_ev');
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      email: '',
      password: '',
      keepMeSignedIn: true,
      error: '',
      working: false
    };
  },
  methods: {
    nextButtonPress: function nextButtonPress() {
      this.$router.push('/settings');
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_signup_flow_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      working: true,
      error: '',
      message: ''
    };
  },
  computed: {
    token: function token() {
      var t = this.$route.query.token;
      return t != null && String(t).trim() !== '' ? String(t).trim() : '';
    },
    email: function email() {
      var e = this.$route.query.email;
      return e != null && String(e).trim() !== '' ? String(e).trim() : '';
    }
  },
  created: function created() {
    var _this = this;

    if (!this.token || !this.email) {
      this.working = false;
      this.error = 'Invalid verification link. Check the link in your email or request a new one.';
      return;
    }
    this.$http.get('/api/identity/verify-email', {
      params: { token: this.token, email: this.email }
    }).then(function (response) {
      _this.working = false;
      var body = response.body;
      var msg = body && (body.message || body.msg) || 'Your email has been verified.';
      _this.message = msg;
      setTimeout(function () {
        _this.$router.push('/login');
      }, 2500);
    }, function (response) {
      _this.working = false;
      var body = response.body;
      var m = body && (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) === 'object' ? body.message : null;
      _this.error = m || (typeof body === 'string' ? body : '') || 'Verification failed. The link may have expired.';
    });
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_onboardingSessionHints_js__ = __webpack_require__(60);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      status: {
        sellerConnected: false,
        productsImported: false,
        buyboxFetched: false,
        ordersFetched: false,
        completed: false,
        completedAt: null
      },
      error: null,
      pollTimer: null
    };
  },
  computed: {
    userInitials: function userInitials() {
      var email = this.$root.userEmail || '';
      var parts = email.split('@')[0].split(/[._-]/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return (email[0] || 'U').toUpperCase();
    },
    derivedSteps: function derivedSteps() {
      var s = this.status;
      return [{ id: 'account', label: 'Amazon account connected', completedLabel: 'Amazon account connected', completed: !!s.sellerConnected, inProgress: !s.sellerConnected }, { id: 'products', label: 'Products imported', completedLabel: 'Products imported', completed: !!s.productsImported, inProgress: !!s.sellerConnected && !s.productsImported }, { id: 'buybox', label: 'Reading current Buy Box status', completedLabel: 'Buy Box status read', completed: !!s.buyboxFetched, inProgress: !!s.productsImported && !s.buyboxFetched }, { id: 'sales', label: 'Fetching 30-day sales history', completedLabel: '30-day sales history fetched', completed: !!s.ordersFetched, inProgress: !!s.buyboxFetched && !s.ordersFetched }];
    },
    totalSteps: function totalSteps() {
      return 4;
    },
    completedSteps: function completedSteps() {
      var count = 0;
      if (this.status.sellerConnected) count++;
      if (this.status.productsImported) count++;
      if (this.status.buyboxFetched) count++;
      if (this.status.ordersFetched) count++;
      return count;
    },
    progressPercent: function progressPercent() {
      return Math.round(this.completedSteps / this.totalSteps * 100);
    },
    syncCompleteSubtext: function syncCompleteSubtext() {
      return 'Buy Box monitoring active · Sales history loaded';
    },

    effectivelyComplete: function effectivelyComplete() {
      var s = this.status;
      return !!s.completed || !!s.sellerConnected && !!s.productsImported && !!s.buyboxFetched && !!s.ordersFetched;
    }
  },
  methods: {
    fetchStatus: function fetchStatus() {
      var self = this;
      if (self.status.completed) return;
      self.$http.get('/api/v1/onboarding/status').then(function (response) {
        var data = response.body || {};
        self.status.sellerConnected = !!data.sellerConnected;
        self.status.productsImported = !!data.productsImported;
        self.status.buyboxFetched = !!data.buyboxFetched;
        self.status.ordersFetched = !!data.ordersFetched;
        self.status.completed = !!data.completed;
        self.status.completedAt = data.completedAt || null;
        self.error = null;

        var allStepsDone = !!data.sellerConnected && !!data.productsImported && !!data.buyboxFetched && !!data.ordersFetched;
        var pipelineDone = !!data.completed || allStepsDone;
        if (pipelineDone) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_onboardingSessionHints_js__["c" /* setPipelineDoneHint */])();
          if (self.pollTimer) {
            clearInterval(self.pollTimer);
            self.pollTimer = null;
          }
          self.$router.replace('/home');
          return;
        }
      }, function () {
        self.error = 'Unable to fetch onboarding status. Retrying…';
      });
    },
    startPolling: function startPolling() {
      var self = this;
      self.fetchStatus();
      if (self.status.completed) return;
      self.pollTimer = setInterval(function () {
        if (self.status.completed) {
          clearInterval(self.pollTimer);
          self.pollTimer = null;
          return;
        }
        self.fetchStatus();
      }, 60000);
    },
    goToDashboard: function goToDashboard() {
      this.$router.push('/home');
    },
    skipConnectForNow: function skipConnectForNow() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_onboardingSessionHints_js__["g" /* setConnectDeferredHint */])();
      this.$router.push('/home');
    },
    logout: function logout() {
      this.$root.signOutUser();
    }
  },
  mounted: function mounted() {
    var el = document.getElementById('preloadr');
    if (el) {
      el.style.transition = 'opacity 0.5s';
      el.style.opacity = '0';
      setTimeout(function () {
        el.style.display = 'none';
      }, 500);
    }
    this.startPolling();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stock_styles_StockDashboard_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stock_styles_StockDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__stock_styles_StockDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_styles_AllAlertsPage_css__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_styles_AllAlertsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__buybox_styles_AllAlertsPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_listViewUrlSync_js__ = __webpack_require__(27);














var ALERTS_URL_KEYS = ['marketplaces', 'sellerAccounts'];
var ALERTS_TABLE_SORT_KEYS = ['status', 'impact'];

function shallowEqualAlertsQuery(next, routeQuery) {
  for (var i = 0; i < ALERTS_URL_KEYS.length; i++) {
    var k = ALERTS_URL_KEYS[i];
    var nv = next[k] != null ? String(next[k]) : '';
    var rv = routeQuery && routeQuery[k] != null ? String(routeQuery[k]) : '';
    if (nv !== rv) return false;
  }
  return true;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AllAlertsPage',
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_9__buybox_DashboardLayout_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      error: null,
      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,
      searchQuery: '',
      filterStatus: 'all',
      sortBy: 'impact',
      sortDir: 'desc',
      currentPage: 1,
      itemsPerPage: 10,
      totalAlerts: 0,
      totalPages: 1,
      allAlerts: [],
      searchTimeout: null,
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      buyboxFilterData: { availableFilters: null },
      loadingFilters: false,
      exporting: false,
      _syncingDropdowns: false,
      _applyingAlertsRouteQuery: false
    };
  },
  computed: {
    worldStore: function worldStore() {
      return this.$parent && this.$parent.$parent && this.$parent.$parent.worldStore;
    },
    hasWorldStore: function hasWorldStore() {
      return !!(this.worldStore && this.worldStore.products !== undefined);
    },
    sellerAccountsList: function sellerAccountsList() {
      var af = this.buyboxFilterData && this.buyboxFilterData.availableFilters;
      if (!af || !af.sellerAccounts || af.sellerAccounts.length === 0) return [];
      return af.sellerAccounts.map(function (sa) {
        return { sellerId: sa.id, accountNickName: sa.name };
      });
    },
    filteredCountries: function filteredCountries() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterUserCountries, this.filterCountriesAll);
    },
    alertCounts: function alertCounts() {
      return {
        suppressed: this.allAlerts.filter(function (a) {
          return a.statusType === 'suppressed';
        }).length,
        lost: this.allAlerts.filter(function (a) {
          return a.statusType === 'lost';
        }).length,
        contested: this.allAlerts.filter(function (a) {
          return a.statusType === 'contested';
        }).length,
        potential: this.allAlerts.filter(function (a) {
          return a.impactClass === 'positive';
        }).length
      };
    },
    startIndex: function startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex: function endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalAlerts);
    },
    paginatedAlerts: function paginatedAlerts() {
      return this.allAlerts;
    },
    visiblePages: function visiblePages() {
      var pages = [];
      var maxVisible = 5;
      var start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      var end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (var i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    alertsFilterParams: function alertsFilterParams() {
      var params = {};
      if (this.filterByMarket.length > 0) params.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length > 0) params.sellerAccounts = this.filterBySellAcc.join(',');
      return params;
    },
    exportCsv: function exportCsv() {
      if (this.exporting) return;
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.alertsFilterParams());
      if (this.filterStatus !== 'all') params.status = this.filterStatus;
      if (this.searchQuery && this.searchQuery.trim()) params.search = this.searchQuery.trim();
      if (this.sortBy) params.sortBy = this.sortBy;
      if (this.sortDir) params.order = this.sortDir;

      var qs = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');
      var exportUrl = '/api/v1/buybox/dashboard/issues/export' + (qs ? '?' + qs : '');
      var defaultName = 'buybox-issues-' + new Date().toISOString().slice(0, 10) + '.csv';

      this.exporting = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        self.exporting = false;
        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          var cd = xhr.getResponseHeader('Content-Disposition');
          var filename = defaultName;
          if (cd) {
            var m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (m && m[1]) filename = m[1].replace(/['"]/g, '').trim() || defaultName;
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          var reader = new FileReader();
          reader.onload = function () {
            var errorMsg = 'Failed to export issues. Please try again.';
            try {
              var errorJson = JSON.parse(reader.result);
              errorMsg = errorJson.message || errorJson.error || errorMsg;
            } catch (e) {}
            alert(errorMsg);
          };
          reader.readAsText(xhr.response);
        }
      };
      xhr.onerror = function () {
        self.exporting = false;
        alert('Failed to export issues. Please try again.');
      };
      xhr.send();
    },
    getMarketplaceSuffix: function getMarketplaceSuffix(country) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["a" /* getMarketplaceAmazonSuffix */])(country);
    },
    isSellerSelected: function isSellerSelected(sellerId) {
      if (!this.filterBySellAcc || this.filterBySellAcc.length === 0) return false;
      return this.filterBySellAcc.some(function (id) {
        return String(id) === String(sellerId);
      });
    },
    loadBuyboxFilters: function loadBuyboxFilters() {
      var self = this;
      this.loadingFilters = true;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([self.$http.get('/api/sentinel/products', { params: { productsOnly: true, page: 0, pageSize: 1 } }), self.$http.get('/api/v1/sellers').catch(function () {
        return { body: null };
      })]).then(function (results) {
        self.loadingFilters = false;
        var body = results[0] && results[0].body || {};
        var sellersBody = results[1] && results[1].body || {};
        var fromV1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(sellersBody));
        var fromProducts = body.availableFilters && body.availableFilters.sellerAccounts || [];
        var sellerAccounts = fromV1.length > 0 ? fromV1.map(function (r) {
          return { id: r.id, name: r.name };
        }) : fromProducts.map(function (sa) {
          return { id: sa.id, name: sa.name != null ? sa.name : 'Account ' + sa.id };
        });
        var marketplaces = body.availableFilters && body.availableFilters.marketplaces || [];
        self.buyboxFilterData.availableFilters = { marketplaces: marketplaces, sellerAccounts: sellerAccounts };
        self.filterUserCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_sellerAccountsFromV1Api_js__["f" /* buildMarketplaceFilterCodes */])({
          fromAvailableFilters: marketplaces,
          v1SellersBody: sellersBody,
          canonicalOrder: self.filterCountriesAll.filter(function (c) {
            return c !== 's';
          })
        });
        if (self.filterByMarket.length > 0) {
          var mpSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.filterUserCountries);
          self.filterByMarket = self.filterByMarket.filter(function (x) {
            return mpSet.has(x);
          });
        }
        if (sellerAccounts.length > 0 && self.filterBySellAcc.length > 0) {
          var idSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(sellerAccounts.map(function (sa) {
            return String(sa.id);
          }));
          self.filterBySellAcc = self.filterBySellAcc.filter(function (id) {
            return idSet.has(String(id));
          });
        }
        self.$nextTick(function () {
          self.initializeFilterDropdowns();
        });
      }, function () {
        self.loadingFilters = false;
        self.buyboxFilterData.availableFilters = null;
        self.filterUserCountries = [];
      });
    },
    initializeFilterDropdowns: function initializeFilterDropdowns() {
      var self = this;
      if (this.$refs.saDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.saDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.saDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterBySellAcc = v === '' ? [] : v.split(',').map(Number);
            self.currentPage = 1;
            self.fetchIssues();
            self.syncAlertsRouteQuery();
          },
          placeholder: 'All Accounts',
          fullTextSearch: true
        });
      }
      if (this.$refs.marketplaceDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.marketplaceDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.marketplaceDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterByMarket = v === '' ? [] : v.split(',');
            self.currentPage = 1;
            self.fetchIssues();
            self.syncAlertsRouteQuery();
          },
          placeholder: 'All Marketplaces',
          fullTextSearch: true
        });
      }
    },
    buildAlertsRouteQuery: function buildAlertsRouteQuery() {
      var o = {};
      if (this.filterByMarket.length) o.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length) o.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      return o;
    },
    syncAlertsRouteQuery: function syncAlertsRouteQuery() {
      if (this._applyingAlertsRouteQuery || this.$route.path !== '/all-alerts') return;
      var next = this.buildAlertsRouteQuery();
      if (shallowEqualAlertsQuery(next, this.$route.query)) return;
      this.$router.replace({ path: '/all-alerts', query: next });
    },
    applyAlertsRouteQuery: function applyAlertsRouteQuery(q) {
      if (!q || (typeof q === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(q)) !== 'object') return false;
      var has = false;
      for (var i = 0; i < ALERTS_URL_KEYS.length; i++) {
        var k = ALERTS_URL_KEYS[i];
        if (q[k] != null && q[k] !== '') {
          has = true;
          break;
        }
      }
      if (!has) return false;

      this._applyingAlertsRouteQuery = true;
      try {
        if (!Object.prototype.hasOwnProperty.call(q, 'marketplaces')) this.filterByMarket = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'sellerAccounts')) this.filterBySellAcc = [];

        if (Object.prototype.hasOwnProperty.call(q, 'marketplaces') && q.marketplaces) {
          this.filterByMarket = String(q.marketplaces).split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean);
        }
        if (Object.prototype.hasOwnProperty.call(q, 'sellerAccounts') && q.sellerAccounts) {
          this.filterBySellAcc = String(q.sellerAccounts).split(',').map(function (s) {
            var t = s.trim();
            if (!t) return null;
            var n = Number(t);
            return isNaN(n) ? t : n;
          }).filter(function (id) {
            return id != null && id !== '';
          });
        }
      } finally {
        var self = this;
        this.$nextTick(function () {
          self._applyingAlertsRouteQuery = false;
        });
      }
      return true;
    },
    getConfidenceDotClass: function getConfidenceDotClass(statusType) {
      if (statusType === 'suppressed') return 'high';
      if (statusType === 'lost') return 'medium';
      if (statusType === 'contested') return 'low';
      return 'medium';
    },
    sortHeadClass: function sortHeadClass(col) {
      return {
        'sort-col-active': this.sortBy === col,
        'sort-col-asc': this.sortBy === col && this.sortDir === 'asc',
        'sort-col-desc': this.sortBy === col && this.sortDir === 'desc'
      };
    },
    onSort: function onSort(column) {
      if (ALERTS_TABLE_SORT_KEYS.indexOf(column) === -1) return;
      if (this.sortBy !== column) {
        this.sortBy = column;
        this.sortDir = column === 'status' ? 'asc' : 'desc';
      } else {
        this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
      }
      this.currentPage = 1;
      this.fetchIssues();
    },
    fetchIssues: function fetchIssues() {
      var self = this;
      self.loading = true;
      self.error = null;

      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, self.alertsFilterParams(), {
        page: self.currentPage,
        pageSize: self.itemsPerPage
      });

      if (self.filterStatus !== 'all') {
        params.status = self.filterStatus;
      }

      if (self.searchQuery && self.searchQuery.trim()) {
        params.search = self.searchQuery.trim();
      }

      if (self.sortBy) {
        params.sortBy = self.sortBy;
      }
      if (self.sortDir) {
        params.order = self.sortDir;
      }

      self.$http.get('/api/v1/buybox/dashboard/issues', { params: params }).then(function (response) {
        if (response.body) {
          if (response.body.totalItems !== undefined) {
            self.totalAlerts = response.body.totalItems || 0;
            self.totalPages = response.body.totalPages || 1;
          } else if (response.body.meta) {
            self.totalAlerts = response.body.meta.total || 0;
            self.totalPages = response.body.meta.total_pages || 1;
          } else {
            self.totalAlerts = self.allAlerts.length;
            self.totalPages = Math.ceil(self.totalAlerts / self.itemsPerPage);
          }

          self.mapApiDataToAlerts(response.body);
        }
        self.loading = false;
        self.lastUpdateTime = Date.now();
        self.lastUpdated = 'just now';
      }, function (err) {
        console.error('[AllAlertsPage] Failed to fetch issues:', err);
        var errorMsg = 'Failed to load issues';
        if (err.body && err.body.message) {
          errorMsg = err.body.message;
        } else if (err.message) {
          errorMsg = err.message;
        }
        self.error = errorMsg;
        self.loading = false;
      });
    },

    mapApiDataToAlerts: function mapApiDataToAlerts(data) {
      var self = this;
      var items = [];
      if (data.watchdogs && Array.isArray(data.watchdogs)) {
        items = data.watchdogs;
      } else if (data.priority_issues && data.priority_issues.items) {
        items = data.priority_issues.items;
      } else if (data.items && Array.isArray(data.items)) {
        items = data.items;
      } else if (Array.isArray(data)) {
        items = data;
      }

      if (!Array.isArray(items)) {
        items = [];
      }

      this.allAlerts = items.map(function (item, index) {
        var statusType = self.mapStatusType(item.status);
        var impactDisplay = item.estimated_daily_loss_display || '-$0';
        if (statusType === 'owned' && impactDisplay && String(impactDisplay).indexOf('-') === 0) {
          impactDisplay = String(impactDisplay).replace(/^-/, '').trim() || '$0';
        }
        return {
          id: item.product_id || item.id || 'ALT-' + (index + 1),
          product: item.name || item.product_name || item.asin || 'Unknown Product',
          asin: item.asin || '',
          imageUrl: item.image_url || null,
          status: item.status_label || item.status || 'UNKNOWN',
          statusType: statusType,
          description: self.buildDescription(item),
          badge: self.getBadge(item),
          badgeClass: self.getBadgeClass(item),
          impact: impactDisplay,
          impactClass: self.getImpactClass(item, statusType),
          actionButton: item.needs_action ? item.action_label || 'View Details' : null,
          actionButtonClass: item.action_type === 'analyze' ? 'secondary' : 'primary',
          timeAgo: self.formatTimeAgo(item.last_updated || item.created_at),
          productId: item.product_id,
          ownPrice: item.own_price_display,
          competitorPrice: item.competitor_price_display,
          priceGap: item.price_gap_display,
          buyboxWinner: item.buybox_winner,
          confidence: item.confidence
        };
      });
    },

    mapStatusType: function mapStatusType(status) {
      if (!status) return 'lost';
      var statusLower = status.toLowerCase();
      if (statusLower.indexOf('suppress') >= 0) return 'suppressed';
      if (statusLower.indexOf('lost') >= 0 || statusLower.indexOf('competitor') >= 0) return 'lost';
      if (statusLower.indexOf('contest') >= 0) return 'contested';
      if (statusLower.indexOf('owned') >= 0 || statusLower.indexOf('win') >= 0) return 'owned';
      return 'lost';
    },

    buildDescription: function buildDescription(item) {
      if (item.issue_description) {
        var desc = item.issue_description;
        if (item.own_price_display && item.competitor_price_display) {
          desc += ' (You: ' + item.own_price_display + ' vs Competitor: ' + item.competitor_price_display + ')';
        }
        return desc;
      }
      if (item.description) return item.description;
      return 'No description available';
    },

    getBadge: function getBadge(item) {
      if (item.confidence && item.confidence.label) {
        return item.confidence.label.split(' - ')[0];
      }
      if (item.has_price_gap) {
        return '+ Price gap detected';
      }
      return null;
    },

    getBadgeClass: function getBadgeClass(item) {
      if (item.confidence && item.confidence.level) {
        if (item.confidence.level === 'high') return 'success';
        if (item.confidence.level === 'medium') return 'warning';
        if (item.confidence.level === 'low') return 'info';
      }
      if (item.has_price_gap) return 'warning';
      return 'info';
    },

    getImpactClass: function getImpactClass(item, statusType) {
      if (statusType === 'owned') return 'neutral';
      var loss = item.estimated_daily_loss_cents || 0;
      if (loss > 0) return 'negative';
      if (loss < 0) return 'positive';
      var display = item.estimated_daily_loss_display || '';
      if (display.indexOf('+') >= 0) return 'positive';
      return 'negative';
    },

    formatTimeAgo: function formatTimeAgo(timestamp) {
      if (!timestamp) return 'recently';
      try {
        var date = new Date(timestamp);
        var now = new Date();
        var diff = Math.floor((now - date) / 1000);

        if (diff < 60) return diff + 's ago';
        if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
        if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
        return Math.floor(diff / 86400) + 'd ago';
      } catch (e) {
        return 'recently';
      }
    },

    goBack: function goBack() {
      this.$router.push('/home');
    },
    viewProductDetails: function viewProductDetails(productId) {
      this.$router.push({
        path: '/product_details',
        query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(productId, this.$route.fullPath)
      });
    },
    handleActionButton: function handleActionButton(alert) {
      this.viewProductDetails(alert.productId || alert.id);
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchIssues();
        this.scrollToTop();
      }
    },
    nextPage: function nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchIssues();
        this.scrollToTop();
      }
    },
    goToPage: function goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchIssues();
        this.scrollToTop();
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    updateTimeAgo: function updateTimeAgo() {
      if (!this.lastUpdateTime) {
        this.lastUpdated = 'just now';
        return;
      }

      var now = Date.now();
      var diff = Math.floor((now - this.lastUpdateTime) / 1000);

      if (diff < 60) {
        this.lastUpdated = diff + 's ago';
      } else if (diff < 3600) {
        var minutes = Math.floor(diff / 60);
        this.lastUpdated = minutes + 'm ago';
      } else {
        var hours = Math.floor(diff / 3600);
        this.lastUpdated = hours + 'h ago';
      }
    },
    startTimer: function startTimer() {
      var self = this;
      this.timerInterval = setInterval(function () {
        self.updateTimeAgo();
      }, 1000);
    }
  },
  created: function created() {
    this.applyAlertsRouteQuery(this.$route.query);
    this.fetchIssues();
  },
  mounted: function mounted() {
    this.startTimer();
    this.loadBuyboxFilters();
    var self = this;
    this.$nextTick(function () {
      self.initializeFilterDropdowns();
      self.syncAlertsRouteQuery();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.path !== '/all-alerts') return;
      if (this._applyingAlertsRouteQuery) return;
      if (from && from.path === to.path && shallowEqualAlertsQuery(this.buildAlertsRouteQuery(), to.query)) return;
      this.applyAlertsRouteQuery(to.query);
      this.currentPage = 1;
      this.fetchIssues();
    },
    filterUserCountries: function filterUserCountries() {
      this.$nextTick(function () {
        this.initializeFilterDropdowns();
      });
    },
    sellerAccountsList: function sellerAccountsList() {
      this.$nextTick(function () {
        this.initializeFilterDropdowns();
      });
    },
    filterStatus: function filterStatus() {
      this.currentPage = 1;
      this.fetchIssues();
    },
    searchQuery: function searchQuery() {
      this.currentPage = 1;

      var self = this;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(function () {
        self.fetchIssues();
      }, 500);
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_signup_flow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__ = __webpack_require__(32);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AmazonRegionConnect',
  props: {
    showNickname: {
      type: Boolean,
      default: false
    },
    showIntro: {
      type: Boolean,
      default: false
    },
    showPricingMessage: {
      type: Boolean,
      default: false
    },
    redirectPath: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var na = __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */].NA;
    var eu = __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */].EU;
    var me = __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */].ME;
    var ind = __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */].IN;
    var fe = __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */].FE;
    return {
      accName: '',
      errorMsg: null,
      connectingRegion: null,
      allMarketplacesSelection: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */],
      naMarketplaces: na,
      euMarketplaces: eu,
      meMarketplaces: me,
      inMarketplaces: ind,
      feMarketplaces: fe,
      selectedMarketplaceNa: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */],
      selectedMarketplaceEu: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */],
      selectedMarketplaceMe: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */],
      selectedMarketplaceIn: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */],
      selectedMarketplaceFe: __WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["c" /* ALL_MARKETPLACES_SELECTION */]
    };
  },
  mounted: function mounted() {
    var self = this;
    this._onChipPick = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var chip = t.closest('.sk-mkt-chip');
      if (!chip || chip.disabled) return;
      var region = chip.getAttribute('data-region');
      var id = chip.getAttribute('data-marketplace-id');
      if (!region || !id) return;
      e.preventDefault();
      e.stopPropagation();
      self.selectMarketplace(region, id);
    };
    this.$el.addEventListener('mousedown', this._onChipPick, true);
    this.$el.addEventListener('click', this._onChipPick, true);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$el || !this._onChipPick) return;
    this.$el.removeEventListener('mousedown', this._onChipPick, true);
    this.$el.removeEventListener('click', this._onChipPick, true);
  },
  methods: {
    selectedIdForRegion: function selectedIdForRegion(region) {
      if (region === 'NA') return this.selectedMarketplaceNa;
      if (region === 'EU') return this.selectedMarketplaceEu;
      if (region === 'ME') return this.selectedMarketplaceMe;
      if (region === 'IN') return this.selectedMarketplaceIn;
      if (region === 'FE') return this.selectedMarketplaceFe;
      return null;
    },
    isMarketplaceSelected: function isMarketplaceSelected(region, marketplaceId) {
      return String(this.selectedIdForRegion(region) || '') === String(marketplaceId || '');
    },
    selectedMarketplaceLabel: function selectedMarketplaceLabel(region) {
      var id = this.selectedIdForRegion(region);
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["d" /* isAllMarketplacesSelection */])(id)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["e" /* regionAllMarketplacesLabel */])(region);
      var opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["f" /* findConnectMarketplaceOption */])(region, id);
      return opt ? opt.label : '';
    },
    selectMarketplace: function selectMarketplace(region, marketplaceId) {
      if (this.connectingRegion) return;
      var id = String(marketplaceId);
      if (region === 'NA') this.selectedMarketplaceNa = id;else if (region === 'EU') this.selectedMarketplaceEu = id;else if (region === 'ME') this.selectedMarketplaceMe = id;else if (region === 'IN') this.selectedMarketplaceIn = id;else if (region === 'FE') this.selectedMarketplaceFe = id;
    },
    connectRegion: function connectRegion(region, marketplaceId) {
      var self = this;
      self.errorMsg = null;
      self.connectingRegion = region;
      var path = self.redirectPath || self.$route && self.$route.path || '/settings/account';
      var allInRegion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["d" /* isAllMarketplacesSelection */])(marketplaceId);
      var opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["f" /* findConnectMarketplaceOption */])(region, marketplaceId);
      var data = {
        region: region,
        path: path,
        accName: self.accName
      };
      if (allInRegion) {
        data.marketplace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(region);
        data.allMarketplaces = true;
        var codes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["g" /* regionMarketplaceCodes */])(region);
        if (codes.length) {
          data.marketplaceCodes = codes.join(',');
          data.marketplaceCode = codes.join(',');
        }
      } else {
        data.marketplace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(region, marketplaceId);
        data.marketplaceId = marketplaceId;
        if (opt && opt.code) {
          data.marketplaceCode = opt.code;
          data.marketplaceIso31662Code = opt.code.toLowerCase();
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__["c" /* markConnectStoreStarted */])();
      var amazonUrl = null;
      var gtmDone = false;
      function goAmazonWhenReady() {
        if (!amazonUrl || !gtmDone) return;
        window.location = amazonUrl;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_store_started', step: 2 }, function () {
        gtmDone = true;
        goAmazonWhenReady();
      });
      self.$http.get('/api/identity/amazon/authorization/redirect', { params: data }).then(function (response) {
        amazonUrl = response.body.location;
        goAmazonWhenReady();
      }, function (response) {
        self.connectingRegion = null;
        var msg = response.body && response.body.message || 'Failed to start authorization';
        self.errorMsg = msg;
        self.$emit('error', msg);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'connect_store_failed', error_reason: msg });
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stock_styles_StockDashboard_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stock_styles_StockDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__stock_styles_StockDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__buybox_styles_BuyBoxDashboard_css__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__buybox_styles_BuyBoxDashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__buybox_styles_BuyBoxDashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buybox_BuyBoxOwnershipCard_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buybox_BuyBoxOwnershipCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__buybox_BuyBoxOwnershipCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buybox_RevenueImpactCard_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buybox_RevenueImpactCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__buybox_RevenueImpactCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buybox_StatusBreakdown_vue__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buybox_StatusBreakdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__buybox_StatusBreakdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buybox_PriorityIssuesList_vue__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buybox_PriorityIssuesList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__buybox_PriorityIssuesList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_listViewUrlSync_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_requestGate_js__ = __webpack_require__(63);


















var DASH_URL_KEYS = ['marketplaces', 'sellerAccounts', 'status'];

function shallowEqualDashQuery(next, routeQuery) {
  for (var i = 0; i < DASH_URL_KEYS.length; i++) {
    var k = DASH_URL_KEYS[i];
    var nv = next[k] != null ? String(next[k]) : '';
    var rv = routeQuery && routeQuery[k] != null ? String(routeQuery[k]) : '';
    if (nv !== rv) return false;
  }
  return true;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyBoxDashboard',
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue___default.a,
    BuyBoxOwnershipCard: __WEBPACK_IMPORTED_MODULE_9__buybox_BuyBoxOwnershipCard_vue___default.a,
    RevenueImpactCard: __WEBPACK_IMPORTED_MODULE_10__buybox_RevenueImpactCard_vue___default.a,
    StatusBreakdown: __WEBPACK_IMPORTED_MODULE_11__buybox_StatusBreakdown_vue___default.a,
    PriorityIssuesList: __WEBPACK_IMPORTED_MODULE_12__buybox_PriorityIssuesList_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      error: null,
      lastUpdated: 'just now',
      activeTab: 'issues',
      timerInterval: null,
      refreshInterval: null,

      apiData: null,

      ownership: {
        percentage: 0,
        owned: 0,
        total: 0,
        trend: null,
        trendText: '',
        source: 'SP-API',
        field: 'buybox_ownership',
        calculation: '(owned_count / total_count) * 100',
        trendDescription: 'Compare with previous day'
      },
      revenueImpact: {
        amount: '0',
        affectedProducts: 0,
        weeklyImpact: '-$0',
        actionableProducts: 0,
        avgRecovery: 'N/A',
        reportingCurrencySymbol: '$'
      },
      statusBreakdown: [],
      priorityIssues: [],
      needActionCount: 0,
      totalIssues: 0,
      activeStatusFilter: 'suppressed',
      dataSourceName: 'Unknown',
      productsTracked: 0,
      notificationsToday: 0,
      filterByMarket: [],
      filterBySellAcc: [],
      filterCountriesAll: __WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["b" /* MARKETPLACE_FILTER_COUNTRIES_ALL */],
      filterUserCountries: [],
      buyboxFilterData: { availableFilters: null },
      loadingFilters: false,
      exporting: false,
      _syncingDropdowns: false,
      _applyingDashRouteQuery: false,
      _dashFetchDebounce: null,
      _dashRequestGate: null
    };
  },
  computed: {
    worldStore: function worldStore() {
      return this.$parent && this.$parent.$parent && this.$parent.$parent.worldStore;
    },
    hasWorldStore: function hasWorldStore() {
      return !!(this.worldStore && this.worldStore.products !== undefined);
    },
    sellerAccountsList: function sellerAccountsList() {
      var af = this.buyboxFilterData && this.buyboxFilterData.availableFilters;
      if (!af || !af.sellerAccounts || af.sellerAccounts.length === 0) return [];
      return af.sellerAccounts.map(function (sa) {
        return { sellerId: sa.id, accountNickName: sa.name };
      });
    },
    filteredCountries: function filteredCountries() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["c" /* buildMarketplaceFilterDropdownItems */])(this.filterUserCountries, this.filterCountriesAll);
    },

    indexShell: function indexShell() {
      var root = this.$root;
      if (root && root._skIndexShellForDashboard && typeof root._skIndexShellForDashboard.fetchOnboardingStatus === 'function') {
        return root._skIndexShellForDashboard;
      }
      var p = this.$parent;
      while (p) {
        if (typeof p.fetchOnboardingStatus === 'function') return p;
        p = p.$parent;
      }
      return null;
    },
    onboardingStatus: function onboardingStatus() {
      var shell = this.indexShell;
      return shell && shell.onboardingStatus ? shell.onboardingStatus : null;
    },
    indexOnboardingReady: function indexOnboardingReady() {
      var shell = this.indexShell;
      return !!(shell && shell.onboardingStatusReady);
    },
    onboardingComplete: function onboardingComplete() {
      var s = this.onboardingStatus;
      if (!s) return true;
      return !!s.completed || !!s.sellerConnected && !!s.productsImported && !!s.buyboxFetched && !!s.ordersFetched;
    },
    syncPercent: function syncPercent() {
      if (!this.onboardingStatus) return 0;
      var s = this.onboardingStatus;
      var done = 0;
      if (s.sellerConnected) done++;
      if (s.productsImported) done++;
      if (s.buyboxFetched) done++;
      if (s.ordersFetched) done++;
      return Math.round(done / 4 * 100);
    },
    syncStatusMessage: function syncStatusMessage() {
      if (!this.onboardingStatus) return 'Loading…';
      var s = this.onboardingStatus;
      if (!s.sellerConnected) return 'Waiting for Amazon account connection…';
      if (!s.productsImported) return 'Products loaded — importing catalog and ASINs…';
      if (!s.buyboxFetched) return 'Products loaded — Buy Box data and revenue estimates are still coming in.';
      if (!s.ordersFetched) return 'Buy Box data loaded — fetching order history…';
      return 'Finishing up…';
    }
  },
  created: function created() {
    this.applyDashboardRouteQuery(this.$route.query);
  },
  mounted: function mounted() {
    this.startLiveTimer();
    this.loadBuyboxFilters();
    var self = this;
    this.$nextTick(function () {
      self.initializeFilterDropdowns();
    });
    this.fetchDashboardData();
    this.$nextTick(function () {
      self.syncDashboardRouteQuery();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this._dashFetchDebounce) {
      clearTimeout(this._dashFetchDebounce);
      this._dashFetchDebounce = null;
    }
  },
  methods: {
    scheduleDashboardFetch: function scheduleDashboardFetch() {
      var self = this;
      if (self._dashFetchDebounce) clearTimeout(self._dashFetchDebounce);
      self._dashFetchDebounce = setTimeout(function () {
        self._dashFetchDebounce = null;
        self.fetchDashboardData();
      }, 300);
    },
    dashboardFilterParams: function dashboardFilterParams() {
      var params = {};
      if (this.filterByMarket.length > 0) params.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length > 0) params.sellerAccounts = this.filterBySellAcc.join(',');
      return params;
    },
    exportPriorityIssuesCsv: function exportPriorityIssuesCsv() {
      if (this.exporting) return;
      var self = this;
      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.dashboardFilterParams());
      if (this.activeStatusFilter) params.status = this.activeStatusFilter;
      params.sortBy = 'impact';

      var qs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');
      var exportUrl = '/api/v1/buybox/dashboard/issues/export' + (qs ? '?' + qs : '');
      var defaultName = 'buybox-issues-' + new Date().toISOString().slice(0, 10) + '.csv';

      this.exporting = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        self.exporting = false;
        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          var cd = xhr.getResponseHeader('Content-Disposition');
          var filename = defaultName;
          if (cd) {
            var m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (m && m[1]) filename = m[1].replace(/['"]/g, '').trim() || defaultName;
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          var reader = new FileReader();
          reader.onload = function () {
            var errorMsg = 'Failed to export issues. Please try again.';
            try {
              var errorJson = JSON.parse(reader.result);
              errorMsg = errorJson.message || errorJson.error || errorMsg;
            } catch (e) {}
            alert(errorMsg);
          };
          reader.readAsText(xhr.response);
        }
      };
      xhr.onerror = function () {
        self.exporting = false;
        alert('Failed to export issues. Please try again.');
      };
      xhr.send();
    },
    getMarketplaceSuffix: function getMarketplaceSuffix(country) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["a" /* getMarketplaceAmazonSuffix */])(country);
    },
    isSellerSelected: function isSellerSelected(sellerId) {
      if (!this.filterBySellAcc || this.filterBySellAcc.length === 0) return false;
      return this.filterBySellAcc.some(function (id) {
        return String(id) === String(sellerId);
      });
    },
    loadBuyboxFilters: function loadBuyboxFilters() {
      var self = this;
      this.loadingFilters = true;
      var sellersPromise = self.$root.loadV1Sellers ? self.$root.loadV1Sellers().then(function (body) {
        return body;
      }, function () {
        return null;
      }) : self.$http.get('/api/v1/sellers').then(function (res) {
        return res.body || {};
      }, function () {
        return null;
      });
      sellersPromise.then(function (sellersBody) {
        self.loadingFilters = false;
        sellersBody = sellersBody || {};
        var sellerAccounts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(sellersBody)).map(function (r) {
          return { id: r.id, name: r.name };
        });
        var marketplaces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["g" /* extractMarketplaceCodesFromV1SellersBody */])(sellersBody);
        self.buyboxFilterData.availableFilters = { marketplaces: marketplaces, sellerAccounts: sellerAccounts };
        self.filterUserCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sellerAccountsFromV1Api_js__["f" /* buildMarketplaceFilterCodes */])({
          fromAvailableFilters: marketplaces,
          v1SellersBody: sellersBody,
          canonicalOrder: self.filterCountriesAll.filter(function (c) {
            return c !== 's';
          })
        });
        if (self.filterByMarket.length > 0) {
          var mpSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.filterUserCountries);
          self.filterByMarket = self.filterByMarket.filter(function (x) {
            return mpSet.has(x);
          });
        }
        if (sellerAccounts.length > 0 && self.filterBySellAcc.length > 0) {
          var idSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(sellerAccounts.map(function (sa) {
            return String(sa.id);
          }));
          self.filterBySellAcc = self.filterBySellAcc.filter(function (id) {
            return idSet.has(String(id));
          });
        }
        self.$nextTick(function () {
          self.initializeFilterDropdowns();
        });
      }, function () {
        self.loadingFilters = false;
        self.buyboxFilterData.availableFilters = null;
        self.filterUserCountries = [];
      });
    },
    initializeFilterDropdowns: function initializeFilterDropdowns() {
      var self = this;
      if (this.$refs.saDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.saDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.saDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterBySellAcc = v === '' ? [] : v.split(',').map(Number);
            self.scheduleDashboardFetch();
            self.syncDashboardRouteQuery();
          },
          placeholder: 'All Accounts',
          fullTextSearch: true
        });
      }
      if (this.$refs.marketplaceDropdown) {
        try {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.marketplaceDropdown).dropdown('destroy');
        } catch (e) {}
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$refs.marketplaceDropdown).dropdown({
          onChange: function onChange(v) {
            if (self._syncingDropdowns) return;
            self.filterByMarket = v === '' ? [] : v.split(',');
            self.scheduleDashboardFetch();
            self.syncDashboardRouteQuery();
          },
          placeholder: 'All Marketplaces',
          fullTextSearch: true
        });
      }
    },
    fetchDashboardData: function fetchDashboardData() {
      var self = this;
      if (!self._dashRequestGate) self._dashRequestGate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_requestGate_js__["a" /* createRequestGate */])();
      var gate = self._dashRequestGate;
      var gen = gate.begin();
      self.loading = true;
      self.error = null;

      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, self.dashboardFilterParams());

      self.fetchPriorityIssues({
        page: 0,
        pageSize: 5,
        sortBy: 'impact',
        status: self.activeStatusFilter || null,
        _gen: gen
      });

      self.$http.get('/api/v1/buybox/dashboard', gate.trackOpts({ params: params })).then(function (response) {
        if (!gate.isCurrent(gen)) return;
        if (response.body) {
          self.apiData = response.body;
          self.mapApiDataToProps(response.body);
          self.updateLastUpdated(response.body.generated_at || response.body.data_source && response.body.data_source.last_updated);
        }
        self.loading = false;
      }, function (err) {
        if (!gate.isCurrent(gen) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_requestGate_js__["b" /* isRequestAborted */])(err)) return;
        console.error('[BuyBoxDashboard] Failed to fetch dashboard data:', err);
        var errorMsg = 'Failed to load dashboard data';
        if (err.body && err.body.message) {
          errorMsg = err.body.message;
        } else if (err.message) {
          errorMsg = err.message;
        }
        self.error = errorMsg;
        self.loading = false;
      });
    },

    mapApiDataToProps: function mapApiDataToProps(data) {
      var self = this;
      var reportingSym = data.reporting_currency_symbol || data.reportingCurrencySymbol || data.data_source && (data.data_source.reporting_currency_symbol || data.data_source.reportingCurrencySymbol) || '$';

      if (data.buybox_ownership) {
        var bo = data.buybox_ownership;
        this.ownership = {
          percentage: bo.percentage || 0,
          owned: bo.owned_count || 0,
          total: bo.total_count || 0,
          trend: bo.trend,
          trendText: bo.trend || '',
          source: 'SQS Push + SP-API',
          field: 'buybox_ownership',
          calculation: '(owned_count / total_count) * 100',
          trendDescription: bo.subtitle || ''
        };
      }

      if (data.revenue_impact) {
        var ri = data.revenue_impact;
        this.revenueImpact = {
          amount: ri.estimated_daily_loss_dollars !== undefined ? String(ri.estimated_daily_loss_dollars) : '0',
          affectedProducts: ri.actionable && ri.actionable.count !== undefined ? ri.actionable.count : 0,
          weeklyImpact: ri.this_week && ri.this_week.display ? ri.this_week.display : '-' + reportingSym + '0',
          actionableProducts: ri.actionable && ri.actionable.count !== undefined ? ri.actionable.count : 0,
          avgRecovery: ri.avg_recovery && ri.avg_recovery.display ? ri.avg_recovery.display : 'N/A',
          subtitle: ri.subtitle || null,
          reportingCurrencySymbol: ri.reporting_currency_symbol || ri.reportingCurrencySymbol || null
        };
      } else {
        this.revenueImpact = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.revenueImpact, { reportingCurrencySymbol: reportingSym });
      }

      if (data.status_breakdown) {
        var sb = data.status_breakdown;
        var statusArray = [];

        if (sb.suppressed) {
          statusArray.push({
            type: 'suppressed',
            icon: 'ban icon',
            count: sb.suppressed.count || 0,
            label: sb.suppressed.label || 'Suppressed',
            description: sb.suppressed.description || ''
          });
        }

        if (sb.lost_to_competitor) {
          statusArray.push({
            type: 'lost',
            icon: 'arrow down icon',
            count: sb.lost_to_competitor.count || 0,
            label: sb.lost_to_competitor.label || 'Lost to Competitor',
            description: sb.lost_to_competitor.description || ''
          });
        }

        if (sb.contested) {
          statusArray.push({
            type: 'contested',
            icon: 'sync alternate icon',
            count: sb.contested.count || 0,
            label: sb.contested.label || 'Contested',
            description: sb.contested.description || ''
          });
        }

        if (sb.owned) {
          statusArray.push({
            type: 'owned',
            icon: 'check circle icon',
            count: sb.owned.count || 0,
            label: sb.owned.label || 'Owned',
            description: sb.owned.description || ''
          });
        }

        this.statusBreakdown = statusArray;

        var suppressedCount = sb.suppressed && sb.suppressed.count != null ? sb.suppressed.count : 0;
        var lostCount = sb.lost_to_competitor && sb.lost_to_competitor.count != null ? sb.lost_to_competitor.count : 0;
        var contestedCount = sb.contested && sb.contested.count != null ? sb.contested.count : 0;
        this.needActionCount = suppressedCount + lostCount + contestedCount;
      }

      if (data.data_source) {
        var ds = data.data_source;
        this.dataSourceName = ds.source || 'Unknown';
        this.productsTracked = ds.products_tracked || 0;
        this.notificationsToday = ds.notifications_today || 0;
      }
    },

    mapPriorityIssuesFromApi: function mapPriorityIssuesFromApi(pi) {
      var self = this;

      if (!pi) {
        this.totalIssues = 0;
        this.priorityIssues = [];
        return;
      }

      this.totalIssues = pi.total_count || 0;

      if (pi.items && pi.items.length > 0) {
        this.priorityIssues = pi.items.map(function (item) {
          var statusType = self.mapStatusType(item.status);
          var impactDisplay = item.estimated_daily_loss_display || '-$0';
          if (statusType === 'owned' && impactDisplay && String(impactDisplay).indexOf('-') === 0) {
            impactDisplay = String(impactDisplay).replace(/^-/, '').trim() || '$0';
          }
          return {
            product: item.name || item.asin || 'Unknown Product',
            status: item.status_label || item.status || '',
            statusType: statusType,
            confidenceLevel: item.confidence && item.confidence.level ? item.confidence.level : 'medium',
            description: item.issue_description || '',
            badge: item.confidence && item.confidence.label ? item.confidence.label.split(' - ')[0] : null,
            badgeClass: self.mapBadgeClass(item.confidence && item.confidence.level),
            impact: impactDisplay,
            impactClass: self.getImpactClass(item.estimated_daily_loss_display, statusType),
            actionButton: item.needs_action ? item.action_label || 'View' : null,
            actionButtonClass: item.action_type === 'analyze' ? 'secondary' : 'primary',
            productId: item.product_id,
            asin: item.asin,
            imageUrl: item.image_url,
            ownPrice: item.own_price_display,
            competitorPrice: item.competitor_price_display,
            priceGap: item.price_gap_display
          };
        });
      } else {
        this.priorityIssues = [];
      }
    },

    fetchPriorityIssues: function fetchPriorityIssues(options) {
      var self = this;
      if (!self._dashRequestGate) self._dashRequestGate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_requestGate_js__["a" /* createRequestGate */])();
      var gate = self._dashRequestGate;
      var gen = options && options._gen != null ? options._gen : gate.begin();
      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, self.dashboardFilterParams(), {
        page: options && options.page !== undefined ? options.page : 0,
        pageSize: options && options.pageSize !== undefined ? options.pageSize : 5,
        sortBy: options && options.sortBy ? options.sortBy : 'impact'
      });
      if (options && options.status) {
        params.status = options.status;
      }

      this.$http.get('/api/v1/buybox/dashboard/issues', gate.trackOpts({ params: params })).then(function (response) {
        if (!gate.isCurrent(gen)) return;
        if (!response.body) return;
        var body = response.body;
        var pi = body.priority_issues || body;
        self.mapPriorityIssuesFromApi(pi);
      }, function (err) {
        if (!gate.isCurrent(gen) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_requestGate_js__["b" /* isRequestAborted */])(err)) return;
        console.error('[BuyBoxDashboard] Failed to fetch priority issues:', err);
      });
    },

    handleStatusFilter: function handleStatusFilter(statusType) {
      if (this.activeStatusFilter === statusType) {
        this.activeStatusFilter = '';
      } else {
        this.activeStatusFilter = statusType;
      }

      this.fetchPriorityIssues({
        page: 0,
        pageSize: 5,
        sortBy: 'impact',
        status: this.activeStatusFilter || null
      });
      this.syncDashboardRouteQuery();
    },

    mapStatusType: function mapStatusType(status) {
      if (!status) return 'lost';
      var statusLower = status.toLowerCase();
      if (statusLower.indexOf('suppress') >= 0) return 'suppressed';
      if (statusLower.indexOf('lost') >= 0 || statusLower.indexOf('competitor') >= 0) return 'lost';
      if (statusLower.indexOf('contest') >= 0) return 'contested';
      if (statusLower.indexOf('owned') >= 0 || statusLower.indexOf('win') >= 0) return 'owned';
      return 'lost';
    },

    mapBadgeClass: function mapBadgeClass(level) {
      if (!level) return 'info';
      if (level === 'high') return 'warning';
      if (level === 'medium') return 'info';
      if (level === 'low') return 'secondary';
      return 'info';
    },

    getImpactClass: function getImpactClass(display, statusType) {
      if (statusType === 'owned') return 'neutral';
      if (!display) return 'negative';
      var str = String(display).trim();
      if (str.startsWith('+')) return 'positive';
      return 'negative';
    },

    updateLastUpdated: function updateLastUpdated(timestamp) {
      if (timestamp) {
        this.lastUpdated = 'just now';
      }
    },

    startLiveTimer: function startLiveTimer() {
      var self = this;
      var startTime = Date.now();

      this.timerInterval = setInterval(function () {
        var elapsed = Math.floor((Date.now() - startTime) / 1000);

        if (elapsed < 60) {
          self.lastUpdated = elapsed + 's ago';
        } else {
          var minutes = Math.floor(elapsed / 60);
          self.lastUpdated = minutes + 'm ago';
        }
      }, 1000);
    },

    toggleUserMenu: function toggleUserMenu() {
      console.log('User menu toggled');
    },

    viewAllAlerts: function viewAllAlerts() {
      var q = {};
      if (this.filterByMarket.length) q.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length) q.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      this.$router.push({ path: '/all-alerts', query: q });
    },

    buildDashboardRouteQuery: function buildDashboardRouteQuery() {
      var o = {};
      if (this.filterByMarket.length) o.marketplaces = this.filterByMarket.join(',');
      if (this.filterBySellAcc.length) o.sellerAccounts = this.filterBySellAcc.map(String).join(',');
      if (this.activeStatusFilter) o.status = this.activeStatusFilter;
      return o;
    },
    syncDashboardRouteQuery: function syncDashboardRouteQuery() {
      if (this._applyingDashRouteQuery || this.$route.path !== '/home') return;
      var next = this.buildDashboardRouteQuery();
      if (shallowEqualDashQuery(next, this.$route.query)) return;
      this.$router.replace({ path: '/home', query: next });
    },
    applyDashboardRouteQuery: function applyDashboardRouteQuery(q) {
      if (!q || (typeof q === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(q)) !== 'object') return false;
      var has = false;
      for (var i = 0; i < DASH_URL_KEYS.length; i++) {
        var k = DASH_URL_KEYS[i];
        if (q[k] != null && q[k] !== '') {
          has = true;
          break;
        }
      }
      if (!has) return false;

      this._applyingDashRouteQuery = true;
      try {
        if (!Object.prototype.hasOwnProperty.call(q, 'marketplaces')) this.filterByMarket = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'sellerAccounts')) this.filterBySellAcc = [];
        if (!Object.prototype.hasOwnProperty.call(q, 'status')) this.activeStatusFilter = '';

        if (Object.prototype.hasOwnProperty.call(q, 'marketplaces') && q.marketplaces) {
          this.filterByMarket = String(q.marketplaces).split(',').map(function (s) {
            return s.trim();
          }).filter(Boolean);
        }
        if (Object.prototype.hasOwnProperty.call(q, 'sellerAccounts') && q.sellerAccounts) {
          this.filterBySellAcc = String(q.sellerAccounts).split(',').map(function (s) {
            var t = s.trim();
            if (!t) return null;
            var n = Number(t);
            return isNaN(n) ? t : n;
          }).filter(function (id) {
            return id != null && id !== '';
          });
        }
        if (Object.prototype.hasOwnProperty.call(q, 'status')) {
          this.activeStatusFilter = q.status ? String(q.status) : '';
        }
      } finally {
        var self = this;
        this.$nextTick(function () {
          self._applyingDashRouteQuery = false;
        });
      }
      return true;
    },

    viewProductDetails: function viewProductDetails(issue) {
      if (issue && issue.productId) {
        this.syncDashboardRouteQuery();
        this.$router.push({
          path: '/product_details',
          query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(issue.productId, this.$route.fullPath)
        });
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.path !== '/home') return;
      if (this._applyingDashRouteQuery) return;
      if (from && from.path === to.path && shallowEqualDashQuery(this.buildDashboardRouteQuery(), to.query)) return;
      this.applyDashboardRouteQuery(to.query);
      this.fetchDashboardData();
    },
    filterUserCountries: function filterUserCountries() {
      this.$nextTick(function () {
        this.initializeFilterDropdowns();
      });
    },
    sellerAccountsList: function sellerAccountsList() {
      this.$nextTick(function () {
        this.initializeFilterDropdowns();
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__ = __webpack_require__(430);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    working: { type: Boolean, default: false },
    copying: { type: Boolean, default: false },
    error: { type: String, default: '' },
    showTeammateLink: { type: Boolean, default: false },
    linkNote: { type: String, default: '' }
  },
  data: function data() {
    var regionKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["a" /* guessRegionFromBrowser */])();
    var region = __WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["b" /* CONNECT_REGIONS */].filter(function (r) {
      return r.key === regionKey;
    })[0] || __WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["b" /* CONNECT_REGIONS */][0];
    return {
      regions: __WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["b" /* CONNECT_REGIONS */],
      regionKey: region.key,
      selected: region.codes.slice()
    };
  },
  computed: {
    allOn: function allOn() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["c" /* allCodesSelected */])(this.regionKey, this.selected);
    },
    canConnect: function canConnect() {
      return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["d" /* connectAuthorizationParams */])(this.regionKey, this.selected);
    },
    buttonLabel: function buttonLabel() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["e" /* connectButtonLabel */])(this.regionKey, this.selected);
    }
  },
  methods: {
    selectRegion: function selectRegion(key) {
      if (this.working) return;
      var region = __WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["b" /* CONNECT_REGIONS */].filter(function (r) {
        return r.key === key;
      })[0];
      if (!region) return;
      this.regionKey = region.key;
      this.selected = region.codes.slice();
    },
    onToggleAll: function onToggleAll() {
      this.selected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["f" /* toggleAllCodes */])(this.regionKey, this.selected);
    },
    onToggleCode: function onToggleCode(code) {
      this.selected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["g" /* toggleCode */])(this.regionKey, this.selected, code);
    },
    submit: function submit() {
      var params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_connectRegions__["d" /* connectAuthorizationParams */])(this.regionKey, this.selected);
      if (!params || this.working) return;
      this.$emit('connect', params);
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      stats: {
        alerts: 0,
        warnings: 0,
        productsWithIssues: 0,
        totalProducts: 0
      },
      emailConfirmReminder: [],
      apiStats: null
    };
  },
  methods: {
    calcStats: function calcStats(worldStore) {
      var alerts = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      var warnings = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      var productsWithIssues = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

      var watchDogKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(worldStore.watchDogs || {});
      for (var i = 0; i < watchDogKeys.length; ++i) {
        var fullKey = watchDogKeys[i];
        var watchDog = worldStore.watchDogs[fullKey];
        var watchDogName = fullKey.split('_')[0];

        if (watchDog.status === 20 || watchDog.status === 21) continue;

        if (watchDog.hasOwnProperty('issueStatus') && watchDog.issueStatus === 0 && !watchDog.muted) {
          if (watchDog.status === 1 || watchDog.status === 2) {
            var set = watchDog.status === 1 ? warnings : alerts;
            if (watchDog.productGroupId) {
              set.add(watchDogName + '-' + watchDog.productGroupId);
              productsWithIssues.add(watchDog.productGroupId);
            } else if (watchDog.productId) {
              set.add(watchDogName + '-' + watchDog.productId);
              productsWithIssues.add(watchDog.productId);
            }
          }
        }
      }

      return {
        alerts: alerts.size,
        warnings: warnings.size,
        productsWithIssues: productsWithIssues.size,
        totalProducts: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(worldStore.products || {}).length
      };
    },
    updateStatsFromAPI: function updateStatsFromAPI(apiStats) {
      console.log('[Dashboard] updateStatsFromAPI called with:', apiStats);
      this.apiStats = apiStats;
      this.stats = apiStats;
    },
    resetStats: function resetStats() {
      console.log('[Dashboard] resetStats called - clearing old data');
      this.apiStats = null;
      this.stats = { alerts: 0, warnings: 0, productsWithIssues: 0, totalProducts: 0 };
    },
    calcEmailConfirmReminder: function calcEmailConfirmReminder(worldStore) {
      if (Array.isArray(worldStore.unverifiedEmailAddresses)) {
        return worldStore.unverifiedEmailAddresses;
      } else {
        return [];
      }
    }
  },
  watch: {
    '$parent.$parent.worldStore': function $parent$parentWorldStore(worldStore) {
      if (!this.apiStats) {
        this.stats = this.calcStats(worldStore);
      }
      this.emailConfirmReminder = this.calcEmailConfirmReminder(worldStore);
    }
  },
  created: function created() {
    var _this = this;

    if (this.$parent.$parent.worldStore) {
      if (!this.apiStats) {
        this.stats = this.calcStats(this.$parent.$parent.worldStore);
      }
      this.emailConfirmReminder = this.calcEmailConfirmReminder(this.$parent.$parent.worldStore);
    }

    this.$root.$on('dashboard-stats-loaded', function (stats) {
      console.log('[Dashboard] Received pre-loaded stats:', stats);
      _this.updateStatsFromAPI(stats);
    });

    if (this.$root.dashboardStats) {
      console.log('[Dashboard] Using pre-loaded stats from main.js');
      this.updateStatsFromAPI(this.$root.dashboardStats);
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FirstRunSyncModal',
  props: {
    userEmail: {
      type: String,
      default: ''
    },
    onboardingStatus: {
      type: Object,
      default: function _default() {
        return {
          sellerConnected: false,
          productsImported: false,
          buyboxFetched: false,
          ordersFetched: false,
          completed: false
        };
      }
    },
    onDismiss: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: true,
      syncComplete: false,
      syncSteps: [{ id: 'account', label: 'Amazon account connected', completedLabel: 'Amazon account connected' }, { id: 'products', label: 'Products imported', completedLabel: 'Products imported' }, { id: 'buybox', label: 'Reading current Buy Box status', completedLabel: 'Buy Box status read' }, { id: 'sales', label: 'Fetching 30-day sales history', completedLabel: '90-day sales history fetched' }]
    };
  },
  computed: {
    derivedSteps: function derivedSteps() {
      var s = this.onboardingStatus || {};
      return this.syncSteps.map(function (step) {
        var completed = false;
        var inProgress = false;
        if (step.id === 'account') {
          completed = !!s.sellerConnected;
          inProgress = !completed;
        } else if (step.id === 'products') {
          completed = !!s.productsImported;
          inProgress = !!s.sellerConnected && !completed;
        } else if (step.id === 'buybox') {
          completed = !!s.buyboxFetched;
          inProgress = !!s.productsImported && !completed;
        } else if (step.id === 'sales') {
          completed = !!s.ordersFetched;
          inProgress = !!s.buyboxFetched && !completed;
        } else if (step.id === 'intelligence') {
          completed = !!s.completed;
          inProgress = !!s.ordersFetched && !completed;
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, step, { completed: completed, inProgress: inProgress });
      });
    },
    completedStepsCount: function completedStepsCount() {
      return this.derivedSteps.filter(function (s) {
        return s.completed;
      }).length;
    },
    progressPercent: function progressPercent() {
      return this.derivedSteps.length ? Math.round(this.completedStepsCount / this.derivedSteps.length * 100) : 0;
    }
  },
  watch: {
    'onboardingStatus.completed': function onboardingStatusCompleted(val) {
      if (val) this.syncComplete = true;
    }
  },
  created: function created() {
    if (this.onboardingStatus && this.onboardingStatus.completed) {
      this.syncComplete = true;
    }
  },
  methods: {
    goToDashboard: function goToDashboard() {
      this.dismiss();
    },
    dismiss: function dismiss() {
      this.visible = false;
      this.onDismiss();
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, exports) {



/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelpModal__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelpModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HelpModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HelpMenu',
  components: {
    HelpModal: __WEBPACK_IMPORTED_MODULE_1__HelpModal___default.a
  },
  data: function data() {
    return {
      isModalOpen: false,
      helpCenterLink: 'https://help.sentrykit.com/'
    };
  },

  methods: {
    dvlprmd: function dvlprmd() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.stts21kdfslds').removeClass('stts21kdfslds');
    },

    openHelpModal: function openHelpModal(i) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#helpModal').modal({
        centered: false,
        onShow: function onShow() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ui.dimmer.modals').css({
            'backdrop-filter': 'blur(2px)',
            'background-color': 'rgba(0, 0, 0, 0.3)'
          });
          _this.isModalOpen = true;
        },
        onHidden: function onHidden() {
          _this.isModalOpen = false;
          _this.$refs.helpModal.resetState();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ui.dimmer.modals').css({
            'background-color': '',
            'backdrop-filter': ''
          });
        }
      }).modal('show').find('.item').tab('change tab', i);
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      subject: this.category === 'new_feature' ? 'Feature Request' : '',
      contactEmail: this.$root.userEmail,
      ticketContent: '',
      ticketSubmissionResult: null,
      asin: '',
      marketplace: '',
      productExistsWarning: '',
      productExistsError: ''
    };
  },
  props: ['category', 'label', 'lastClosedAt'],
  methods: {
    submitTicket: function submitTicket() {
      var _this = this;

      this.$http.post('/api/support/ticket', {
        email: this.contactEmail,
        subject: this.subject,
        body: this.ticketContent,
        category: this.category,
        asin: this.asin,
        marketplace: this.marketplace
      }).then(function (response) {
        _this.ticketSubmissionResult = true;
      }, function (response) {
        _this.ticketSubmissionResult = false;
      });
    },
    resetState: function resetState() {
      this.subject = '';
      this.ticketContent = '';
      this.ticketSubmissionResult = null;
    },
    updateAsinExistence: function updateAsinExistence() {
      var _this2 = this;

      var params = {};
      if (this.marketplace) params.marketplace = this.marketplace;
      var re = /^[^A-Z0-9]*([A-Z0-9]+)[^A-Z0-9]*$/;
      var m = re.exec(this.asin);
      if (!m) {
        this.productExistsError = '';
        this.productExistsWarning = '';
        return;
      }
      var asin = m[1];
      this.$http.get('/api/product/asin/exists/' + asin, { params: params
      }).then(function (response) {
        _this2.productExistsError = '';
        if (response.body.trackedMarketplaces) {
          if (!params.marketplace && (response.body.trackedMarketplaces.indexOf('US') >= 0 || response.body.trackedMarketplaces.indexOf('UK') >= 0)) {
            _this2.productExistsWarning = '';
          } else {
            _this2.productExistsWarning = 'ASIN ' + asin + ' is only tracked on the following marketplace' + (response.body.trackedMarketplaces.length > 1 ? 's: ' : ': ') + response.body.trackedMarketplaces.join(', ');
          }
        } else {
          _this2.productExistsWarning = '';
        }
      }, function (response) {
        if (response.status === 404) {
          if (params.marketplace) {
            _this2.productExistsError = 'ASIN ' + asin + ' does not exist in the ' + params.marketplace + ' marketplace';
          } else {
            _this2.productExistsError = 'ASIN ' + asin + ' does not exist in SentryKit';
          }
        } else if (response.status === 402) {
          _this2.productExistsError = 'ASIN ' + asin + ' is not tracked. You may start tracking this ASIN in your Product Tracking Settings';
        } else {
          _this2.productExistsError = '';
        }
        _this2.productExistsWarning = '';
      });
    }
  },
  watch: {
    '$root.userEmail': function $rootUserEmail(val) {
      this.contactEmail = val;
    },
    'lastClosedAt': function lastClosedAt(val) {
      this.resetState();
    },
    asin: function asin() {
      this.updateAsinExistence();
    },
    marketplace: function marketplace() {
      this.updateAsinExistence();
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelpModal_SupportTicketForm_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelpModal_SupportTicketForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HelpModal_SupportTicketForm_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'helpModal',
  components: { SupportTicketForm: __WEBPACK_IMPORTED_MODULE_1__HelpModal_SupportTicketForm_vue___default.a },
  data: function data() {
    return {
      lastClosedAt: Date.now()
    };
  },
  methods: {
    hide: function hide() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#helpModal').modal('hide');
    },
    open: function open() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#helpModal').modal('show');
    },
    resetState: function resetState() {
      this.lastClosedAt = Date.now();
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#helpModal .accordion').accordion();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).remove();
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_SpreadsheetConfig__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_SpreadsheetConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__settings_SpreadsheetConfig__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SpreadsheetConfig: __WEBPACK_IMPORTED_MODULE_4__settings_SpreadsheetConfig___default.a
  },
  data: function data() {
    return {
      reds: {},
      ambers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],
      sortedUnfoldedProducts: []
    };
  },
  props: [],
  methods: {
    toMonth: function toMonth(m) {
      return { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }[m];
    },
    salesCountTotal: function salesCountTotal(productIds, t) {
      var _this = this;

      var getSales = function getSales(id) {
        return _this.$parent.$parent.worldStore.products[id].sales;
      };
      if (t === 'y') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id)[1].unitsSold : Number.NaN);
      }, 0);
      if (t === 't') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id)[0].unitsSold : Number.NaN);
      }, 0);
    },
    showProductDetails: function showProductDetails(productId) {
      this.$parent.openProductDetailModal(this.sortedUnfoldedProductsIDs, this.sortedUnfoldedProductsIDs.indexOf(productId));
    },
    starCalc: function starCalc(r, m) {
      var div = Math.floor(r / 10);
      var mod = r % 10;
      if (m === 'f') return mod <= 7 ? div : div + 1;
      if (m === 'h') return Math.abs(mod - 5) <= 2 ? 1 : 0;
      if (m === 'e') return 5 - div - (mod > 2 ? 1 : 0);
    },
    calc: function calc(worldStore) {
      var _this2 = this;

      var productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products);
      var productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products);
      var productGroupIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroupId2productIds);
      var amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
      var redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
      this.reds = redErrorCount.byProductGroupId;
      this.ambers = amberErrorCount.byProductGroupId;
      var productGroupId2products = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        var productGroupId = productGroupIds[i];
        var productIdsForProductGroupId = productGroupId2productIds[productGroupId];
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId) ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(function (p) {
          return p.productId;
        }), productGroupId2productIds[productGroupId]) : productIdsForProductGroupId.sort(function (a, b) {
          var redA = redErrorCount.byProductId[a];
          var redB = redErrorCount.byProductId[b];
          var amberA = amberErrorCount.byProductId[a];
          var amberB = amberErrorCount.byProductId[b];
          var compResult = redB - redA;
          if (compResult !== 0) return compResult;
          return amberB - amberA;
        })).map(function (pid) {
          return worldStore.products[pid];
        });
      }
      this.productGroupId2products = productGroupId2products;
      this.productGroupIds = productGroupIds.sort(function (a0, b0) {
        var a = productGroupId2products[a0][0];
        var b = productGroupId2products[b0][0];
        var compResult = b.marketplace.localeCompare(a.marketplace);
        if (compResult !== 0) return compResult;
        return a.productTitle.localeCompare(b.productTitle);
      });
      var sortedUnfoldedProductsIDs = [];
      for (var _i = 0; _i < this.productGroupIds.length; ++_i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[_i]].map(function (p) {
          return p.productId;
        }));
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs;
      this.groupedProducts = this.productGroupIds.map(function (pgid) {
        return _this2.productGroupId2products[pgid][0];
      });
      this.sortedUnfoldedProducts = this.sortedUnfoldedProductsIDs.map(function (pgid) {
        return _this2.$parent.$parent.worldStore.products[pgid];
      });
    },
    getProductGroupId2productIds: function getProductGroupId2productIds(products) {
      var productGroupId2productIds = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];
        if (productGroupId2productIds[product.productGroupId]) {
          productGroupId2productIds[product.productGroupId].push(product.productId);
        } else {
          productGroupId2productIds[product.productGroupId] = [product.productId];
        }
      }
      return productGroupId2productIds;
    },
    getProductId2ProductGroupId: function getProductId2ProductGroupId(products) {
      var result = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];
        result[product.productId] = product.productGroupId;
      }
      return result;
    },
    getErrorCount: function getErrorCount(productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      var productIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(products);
      var errorCountByProductGroupId = {};
      var errorCountByProductId = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      }
      for (var _i2 = 0; _i2 < productIds.length; ++_i2) {
        errorCountByProductId[productIds[_i2]] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      }
      var watchDogKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(watchDogs);
      for (var _i3 = 0; _i3 < watchDogKeys.length; ++_i3) {
        var fullKey = watchDogKeys[_i3];
        var watchDog = watchDogs[fullKey];
        var watchDogName = fullKey.split('_')[0];
        if (watchDog.status === 20 || watchDog.status === 21) continue;

        var items = [watchDog];
        for (var j = 0; j < items.length; ++j) {
          var item = items[j];
          if (Array.isArray(item)) {
            for (var k = 0; k < item.length; ++k) {
              var item0 = item[k];
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName);
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName);
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName);
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                errorCountByProductGroupId[item.productGroupId].add(watchDogName);
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName);
              }
              if (item.productId) {
                errorCountByProductId[item.productId].add(watchDogName);
              }
            }
          }
        }
      }
      var resultByProductId = {};
      var resultByProductGroupId = {};
      for (var _i4 = 0; _i4 < productIds.length; ++_i4) {
        resultByProductId[productIds[_i4]] = errorCountByProductId[productIds[_i4]].size;
      }
      for (var _i5 = 0; _i5 < productGroupIds.length; ++_i5) {
        resultByProductGroupId[productGroupIds[_i5]] = errorCountByProductGroupId[productGroupIds[_i5]].size;
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId
      };
    },
    addKeepingOrder: function addKeepingOrder(base0, addition0) {
      var base = base0 || [];
      var addition = addition0 || [];
      var result = [];
      for (var i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i]);
      }
      var addition2 = [];
      for (var _i6 = 0; _i6 < addition.length; ++_i6) {
        if (base.indexOf(addition[_i6]) < 0) addition2.push(addition[_i6]);
      }
      var addition3 = addition2.sort();
      for (var _i7 = 0; _i7 < addition3.length; ++_i7) {
        result.push(addition3[_i7]);
      }
      return result;
    },
    getFbmItem: function getFbmItem(productId) {
      var item = this.$parent.$parent.worldStore.watchDogs.fbmInventory.items[productId];
      if (!item) return null;
      var msg = item.statusDetails.message;
      var isBelowThreshold = msg.indexOf('Below the alert threshold of') > -1;
      var isAtThreshold = msg.indexOf('At the alert threshold of') > -1;
      var isOutOfStock = msg.indexOf('ut of stock') > -1;
      var alertThresholdIdx = msg.indexOf('alert threshold of');
      var alertThreshold = null;
      if (alertThresholdIdx > -1) {
        var alertThreshold0 = msg.substring(alertThresholdIdx + 19);
        var alertThreshold0Idx = alertThreshold0.indexOf(')');
        alertThreshold = alertThreshold0.substring(0, alertThreshold0Idx > -1 ? alertThreshold0Idx : alertThreshold0.length);
      }
      return { hasIssue: isBelowThreshold || isAtThreshold || isOutOfStock, alertThreshold: alertThreshold };
    }
  },
  computed: {
    getCardsLayoutSize: function getCardsLayoutSize() {
      var n = this.productGroupIds.length;
      var w = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();

      if (n > 4) return w > 1320 ? 'five' : 'four';
      if (n === 4) return w > 1220 ? 'four' : 'three';else return w > 1440 ? 'four' : 'three';
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.salesQuickInfo').popup({ delay: { show: 0, hide: 0 }, transition: 'fade', position: 'left center' });
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#darkbackgr').stop().fadeOut(200);
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#inventoryList .ui.accordion').accordion();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.salesQuickInfo').popup({ delay: { show: 0, hide: 0 }, transition: 'fade', position: 'left center' });
  },
  watch: {
    '$parent.$parent.worldStore': {
      handler: function handler(worldStore) {
        this.calc(worldStore);
      },
      deep: true
    }
  },
  created: function created() {
    if (this.$parent.$parent.worldStore) {
      this.calc(this.$parent.$parent.worldStore);
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  data: function data() {
    return {};
  },

  created: function created() {
    window.Chart.defaults.global.defaultFontColor = '#aaa';
  },
  methods: {
    render: function render(chartData, options) {
      this.renderChart(chartData, options);
    }
  }
}));

/***/ }),
/* 350 */
/***/ (function(module, exports) {



/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      updateRulesTimer: null,
      updateSellersTimer: null,
      _sellersPollActive: false
    };
  },
  methods: {
    updateSellers: function updateSellers() {
      var self = this;
      var force = this._sellersPollActive === true;
      var loader = this.$root.loadV1Sellers ? this.$root.loadV1Sellers(force) : this.$http.get('/api/v1/sellers').then(function (response) {
        return response.body;
      }, function () {
        return null;
      });
      loader.then(function (body) {
        if (!body) return;
        var item = Array.isArray(body.item) ? body.item : [];
        if (item.length === 0) {
          if (self.$root.anySellerAccountSetupCompleted) {
            self.$store.dispatch('setSellers', item);
          } else {
            if (self.updateSellersTimer === null) {
              self._sellersPollActive = true;
              self.updateSellersTimer = setInterval(self.updateSellers, 1000);
            }
          }
        } else {
          self._sellersPollActive = false;
          if (self.updateSellersTimer !== null) {
            clearInterval(self.updateSellersTimer);
            self.updateSellersTimer = null;
          }
          self.$store.dispatch('setSellers', item);
        }
      }, function () {});
    }
  },
  created: function created() {
    this.updateSellers();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.updateSellersTimer) {
      clearInterval(this.updateSellersTimer);
      this.updateSellersTimer = null;
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notificationReel',

  methods: {
    openDetails: function openDetails(index) {
      if (this.$parent.$parent.worldStore.notifications[index].productId) {
        this.$parent.openProductDetailModal([this.$parent.$parent.worldStore.notifications[index].productId], 0);
      }
    },
    clearList: function clearList() {
      this.$parent.$parent.worldStore.notifications = [];
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PartnerBanner',
  props: ['isFooter']
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      required: true
    },
    passwordLabel: {
      default: 'Password'
    }
  },
  data: function data() {
    return {
      password2: '',
      showPassword: false,
      showPassword2: false,
      regex1: new RegExp('.*[_\\- !"?$%\\^&*()+={}\\[\\]:;@\'~#|<>,.?\\\\/0123456789].*'),
      regex2: new RegExp('.*[a-zA-Z].*'),
      rules: {
        password1: {
          rules: [{
            type: 'minLength[8]',
            prompt: 'Password needs to be minimum 8 characters long'
          }, {
            type: 'regExp',
            value: '.*[a-zA-Z].*',
            prompt: 'Password needs to contain a letter'
          }, {
            type: 'regExp',
            value: '.*[_\\- !"?$%\\^&*()+={}\\[\\]:;@\'~#|<>,.?\\\\/0123456789].*',
            prompt: 'Password needs to contain a digit or symbol'
          }]
        },
        password2: {
          rules: [{
            type: 'match[password1]',
            prompt: 'Passwords do not match'
          }]
        }
      }
    };
  },
  methods: {
    reset: function reset() {
      this.password1 = '';
      this.password2 = '';
    },
    emitPasswordChanged: function emitPasswordChanged() {
      this.$emit('password-changed', { password1: this.password1, password2: this.password2 });
    },
    togglePasswordVisibility: function togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordVisibility2: function togglePasswordVisibility2() {
      this.showPassword2 = !this.showPassword2;
    }
  },
  computed: {
    password1: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    weak: function weak() {
      return this.password1.length < 8 || !this.password1.match(this.regex1) || !this.password1.match(this.regex2);
    },
    mismatch: function mismatch() {
      return this.password2 !== this.password1;
    },
    nonEmptyPasswords: function nonEmptyPasswords() {
      return this.password1 !== '' || this.password2 !== '';
    }
  },
  watch: {
    password1: function password1() {
      this.emitPasswordChanged();
    },
    password2: function password2() {
      this.emitPasswordChanged();
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductCostMarginModal_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductCostMarginModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ProductCostMarginModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_productPricingMixin_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_reviewHealth_js__ = __webpack_require__(51);





var _mixins$components$da;






/* harmony default export */ __webpack_exports__["default"] = (_mixins$components$da = {
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_productPricingMixin_js__["a" /* default */]],
  components: {
    ProductCostMarginModal: __WEBPACK_IMPORTED_MODULE_5__ProductCostMarginModal_vue___default.a
  },
  data: function data() {
    return {
      reds: {},
      ambers: {},
      stockReds: {},
      stockAmbers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],
      currentPage: 0,
      itemsPerPage: 20
    };
  },
  watch: {
    currentPage: function currentPage() {
      this.$emit('page-changed', this.currentPage);
    }
  },
  props: {
    worldStore: {
      type: Object,
      required: true
    },
    filterByMarket: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterBySellAcc: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterMissingCogs: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ratingSummary: function ratingSummary(rating, count) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_reviewHealth_js__["g" /* ratingSummary */])(rating, count);
    },
    toMonth: function toMonth(m) {
      return { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }[m];
    },
    salesCountTotal: function salesCountTotal(productIds, t) {
      var _this = this;

      var getSales = function getSales(id) {
        var product = _this.$parent.$parent.$parent.worldStore.products[id];
        if (product && product.salesToday !== undefined && product.salesYesterday !== undefined) {
          return {
            today: product.salesToday,
            yesterday: product.salesYesterday
          };
        }
        return null;
      };
      if (t === 'y') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).yesterday : 0);
      }, 0);
      if (t === 't') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).today : 0);
      }, 0);
    },
    showProductDetails: function showProductDetails(productId) {
      this.$emit('open-product-details', productId);
    },
    calc: function calc(worldStore) {
      var _this2 = this;

      console.log('ProductCard calc() called');

      if (!worldStore || !worldStore.products) {
        console.warn('ProductCard: worldStore or products is null/undefined');
        this.groupedProducts = [];
        this.productGroupIds = [];
        return;
      }

      console.log('ProductCard calc: processing', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(worldStore.products).length, 'products');
      var productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products);
      var productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products);
      var productGroupIds = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(productGroupId2productIds);

      if (worldStore.reds && worldStore.ambers) {
        this.reds = worldStore.reds;
        this.ambers = worldStore.ambers;
      } else {
        var amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
        var redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
        this.reds = redErrorCount.byProductGroupId;
        this.ambers = amberErrorCount.byProductGroupId;
      }

      var stockAmberErrorCount = this.getWDErrorCount(productGroupIds, 1, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId);
      var stockRedErrorCount = this.getWDErrorCount(productGroupIds, 2, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId);
      this.stockReds = stockRedErrorCount.byProductGroupId;
      this.stockAmbers = stockAmberErrorCount.byProductGroupId;

      var productGroupId2products = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        var productGroupId = productGroupIds[i];
        var productIdsForProductGroupId = productGroupId2productIds[productGroupId];
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId) ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(function (p) {
          return p.productId;
        }), productGroupId2productIds[productGroupId]) : productIdsForProductGroupId.sort(function (a, b) {
          var redA = _this2.reds[a] || 0;
          var redB = _this2.reds[b] || 0;
          var amberA = _this2.ambers[a] || 0;
          var amberB = _this2.ambers[b] || 0;
          var compResult = redB - redA;
          if (compResult !== 0) return compResult;
          return amberB - amberA;
        })).map(function (pid) {
          return worldStore.products[pid];
        });
      }
      this.productGroupId2products = productGroupId2products;
      this.productGroupIds = productGroupIds.sort(function (a0, b0) {
        var a = productGroupId2products[a0][0];
        var b = productGroupId2products[b0][0];
        var compResult = b.marketplace.localeCompare(a.marketplace);
        if (compResult !== 0) return compResult;
        return a.productTitle.localeCompare(b.productTitle);
      });
      var sortedUnfoldedProductsIDs = [];
      for (var _i = 0; _i < this.productGroupIds.length; ++_i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[_i]].map(function (p) {
          return p.productId;
        }));
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs;
      this.groupedProducts = this.productGroupIds.map(function (pgid) {
        var products = _this2.productGroupId2products[pgid];
        if (products && products.length > 0) {
          var firstProduct = products[0];

          if (!firstProduct.productGroupProductIds) {
            firstProduct.productGroupProductIds = products.map(function (p) {
              return p.productId;
            });
          }

          if (!firstProduct.productGroupId) {
            firstProduct.productGroupId = pgid;
          }
          return firstProduct;
        }
        return null;
      }).filter(function (p) {
        return p !== null;
      });

      console.log('ProductCard calc: finished, groupedProducts.length =', this.groupedProducts.length);
      console.log('ProductCard calc: productGroupIds.length =', this.productGroupIds.length);
    },
    getProductGroupId2productIds: function getProductGroupId2productIds(products) {
      var productGroupId2productIds = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];

        var groupId = product.productGroupId || product.productId;
        if (productGroupId2productIds[groupId]) {
          productGroupId2productIds[groupId].push(product.productId);
        } else {
          productGroupId2productIds[groupId] = [product.productId];
        }
      }
      return productGroupId2productIds;
    },
    getProductId2ProductGroupId: function getProductId2ProductGroupId(products) {
      var result = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];

        result[product.productId] = product.productGroupId || product.productId;
      }
      return result;
    },
    getErrorCount: function getErrorCount(productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      var productIds = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(products);
      var errorCountByProductGroupId = {};
      var errorCountByProductId = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      }
      for (var _i2 = 0; _i2 < productIds.length; ++_i2) {
        errorCountByProductId[productIds[_i2]] = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      }
      var watchDogKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(watchDogs);
      for (var _i3 = 0; _i3 < watchDogKeys.length; ++_i3) {
        var fullKey = watchDogKeys[_i3];
        var watchDog = watchDogs[fullKey];
        var watchDogName = fullKey.split('_')[0];
        if (watchDog.status === 20 || watchDog.status === 21) continue;

        var items = [watchDog];
        for (var j = 0; j < items.length; ++j) {
          var item = items[j];
          if (Array.isArray(item)) {
            for (var k = 0; k < item.length; ++k) {
              var item0 = item[k];
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName);
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName);
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName);
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                if (errorCountByProductGroupId[item.productGroupId] && typeof errorCountByProductGroupId[item.productGroupId].add === 'function') {
                  errorCountByProductGroupId[item.productGroupId].add(watchDogName);
                }
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                if (errorCountByProductGroupId[productId2ProductGroupId[item.productId]] && typeof errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add === 'function') {
                  errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName);
                }
              }
              if (item.productId) {
                if (errorCountByProductId[item.productId] && typeof errorCountByProductId[item.productId].add === 'function') {
                  errorCountByProductId[item.productId].add(watchDogName);
                }
              }
            }
          }
        }
      }
      var resultByProductId = {};
      var resultByProductGroupId = {};
      for (var _i4 = 0; _i4 < productIds.length; ++_i4) {
        resultByProductId[productIds[_i4]] = errorCountByProductId[productIds[_i4]].size;
      }
      for (var _i5 = 0; _i5 < productGroupIds.length; ++_i5) {
        resultByProductGroupId[productGroupIds[_i5]] = errorCountByProductGroupId[productGroupIds[_i5]].size;
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId
      };
    },
    getWDErrorCount: function getWDErrorCount(productGroupIds, issueStatus, watchDog, products, productId2ProductGroupId) {
      var productIds = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(products);
      var errorCountByProductGroupId = {};
      var errorCountByProductId = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = 0;
      }
      for (var _i6 = 0; _i6 < productIds.length; ++_i6) {
        errorCountByProductId[productIds[_i6]] = 0;
      }

      if (!watchDog || !watchDog.items) {
        return {
          byProductGroupId: errorCountByProductGroupId,
          byProductId: errorCountByProductId
        };
      }

      var items = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(watchDog.items);
      for (var j = 0; j < items.length; ++j) {
        var item = items[j];
        if (Array.isArray(item)) {
          for (var k = 0; k < item.length; ++k) {
            var item0 = item[k];
            if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
              if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                errorCountByProductGroupId[item0.productGroupId]++;
              } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item0.productId]]++;
              }
              if (item0.productId) {
                errorCountByProductId[item0.productId]++;
              }
            }
          }
        } else {
          if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
            if (item.productGroupId) {
              errorCountByProductGroupId[item.productGroupId]++;
            } else if (item.productId && productId2ProductGroupId[item.productId]) {
              errorCountByProductGroupId[productId2ProductGroupId[item.productId]]++;
            }
            if (item.productId) {
              errorCountByProductId[item.productId]++;
            }
          }
        }
      }

      return {
        byProductId: errorCountByProductId,
        byProductGroupId: errorCountByProductGroupId
      };
    },
    addKeepingOrder: function addKeepingOrder(base0, addition0) {
      var base = base0 || [];
      var addition = addition0 || [];
      var result = [];
      for (var i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i]);
      }
      var addition2 = [];
      for (var _i7 = 0; _i7 < addition.length; ++_i7) {
        if (base.indexOf(addition[_i7]) < 0) addition2.push(addition[_i7]);
      }
      var addition3 = addition2.sort();
      for (var _i8 = 0; _i8 < addition3.length; ++_i8) {
        result.push(addition3[_i8]);
      }
      return result;
    },

    prevPage: function prevPage() {
      console.log('ProductCard prevPage: currentPage before:', this.currentPage);
      if (this.currentPage > 0) {
        this.currentPage--;
        console.log('ProductCard prevPage: currentPage after:', this.currentPage);
      }
    },
    nextPage: function nextPage() {
      console.log('ProductCard nextPage: currentPage before:', this.currentPage, 'totalPages:', this.totalPages);
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
        console.log('ProductCard nextPage: currentPage after:', this.currentPage);
      }
    },
    goToPage: function goToPage(page) {
      console.log('ProductCard goToPage:', page, 'totalPages:', this.totalPages);
      if (page >= 0 && page < this.totalPages) {
        this.currentPage = page;
        console.log('ProductCard goToPage: currentPage set to:', this.currentPage);
      }
    },
    getPageNumber: function getPageNumber(index) {
      if (this.totalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, this.currentPage - 2);
      var endPage = Math.min(this.totalPages - 1, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(0, endPage - 4);
      }

      return startPage + index - 1;
    },
    formatPrice: function formatPrice(price) {
      if (!price && price !== 0) return '0.00';
      return parseFloat(price).toFixed(2);
    },
    calculateMargin: function calculateMargin(product) {
      var margin = this.getProductMargin(product);
      return margin != null ? String(margin) : '0';
    },
    getMarginColorClass: function getMarginColorClass(margin) {
      var marginNum = parseFloat(margin);
      if (marginNum >= 30) return 'margin-high';
      if (marginNum >= 20) return 'margin-good';
      if (marginNum >= 10) return 'margin-medium';
      return 'margin-low';
    },
    getMarginCogsClass: function getMarginCogsClass(margin) {
      var marginNum = parseFloat(margin);
      if (marginNum >= 30) return 'high';
      if (marginNum >= 20) return 'high';
      if (marginNum >= 10) return 'medium';
      return 'low';
    },
    getCardStripeClass: function getCardStripeClass(status) {
      if (!status) return '';
      var s = String(status).toLowerCase();
      if (s === 'owned' || s === 'own' || s === 'winning') return 'owned';
      if (s === 'lost' || s === 'losing') return 'lost';
      if (s === 'suppressed' || s === 'suppress') return 'suppressed';
      if (s === 'rotating') return 'rotating';
      return 'unknown';
    },
    getBuyBoxLabel: function getBuyBoxLabel(status) {
      if (!status) return '—';
      var s = String(status).toLowerCase();
      if (s === 'owned' || s === 'own' || s === 'winning') return 'Owned';
      if (s === 'lost' || s === 'losing') return 'Lost';
      if (s === 'suppressed' || s === 'suppress') return 'Suppressed';
      if (s === 'rotating') return 'Rotating';
      return status;
    },
    getMarketplaceEmoji: function getMarketplaceEmoji(marketplace) {
      var map = { US: '🇺🇸', UK: '🇬🇧', CA: '🇨🇦', DE: '🇩🇪', FR: '🇫🇷', IT: '🇮🇹', ES: '🇪🇸', MX: '🇲🇽', BR: '🇧🇷', IN: '🇮🇳', NL: '🇳🇱' };
      return map[marketplace] || '🏳️';
    },
    calculateMarginFromCogs: function calculateMarginFromCogs(cogs, buyBoxPrice) {
      if (!cogs || !buyBoxPrice || buyBoxPrice === 0) return '0.00';
      var margin = (buyBoxPrice - cogs) / buyBoxPrice * 100;
      return margin.toFixed(0);
    },
    getBuyBoxStatus: function getBuyBoxStatus(product) {
      if (!product) return null;

      if (product.isSuppressed === true || product.suppressed === true) {
        return 'suppressed';
      }

      if (product.hasBuyBox === true && product.buyBoxWinner === 'you') {
        return 'owned';
      } else if (product.hasBuyBox === false) {
        return 'lost';
      }
      if (product.buyBoxRotating === true) return 'rotating';
      return null;
    },
    getBuyBoxStatusClass: function getBuyBoxStatusClass(status) {
      if (!status) return '';
      var statusLower = String(status).toLowerCase();
      if (statusLower === 'owned' || statusLower === 'own' || statusLower === 'winning') return 'status-owned';
      if (statusLower === 'lost' || statusLower === 'losing') return 'status-lost';
      if (statusLower === 'suppressed' || statusLower === 'suppress') return 'status-suppressed';
      if (statusLower === 'rotating') return 'status-rotating';
      return 'status-unknown';
    },
    getBuyBoxStatusText: function getBuyBoxStatusText(status) {
      if (!status) return 'Unknown';
      var statusLower = String(status).toLowerCase();
      if (statusLower === 'owned' || statusLower === 'own' || statusLower === 'winning') return 'OWNED';
      if (statusLower === 'lost' || statusLower === 'losing') return 'LOST';
      if (statusLower === 'suppressed' || statusLower === 'suppress') return 'SUPPRESSED';
      if (statusLower === 'rotating') return 'ROTATING';
      return status;
    },
    getAlertCount: function getAlertCount(product) {
      var pgId = product.productGroupId || product.productId;
      var r = this.reds && this.reds[pgId] || 0;
      var a = this.ambers && this.ambers[pgId] || 0;
      return r + a;
    },
    getAsin: function getAsin(product) {
      if (product.asin) return product.asin;
      if (product.productUrl) {
        var match = product.productUrl.match(/\/dp\/([A-Z0-9]+)/i);
        return match ? match[1] : '—';
      }
      return '—';
    },
    truncateToTwoLines: function truncateToTwoLines(title) {
      if (!title || typeof title !== 'string') return '';
      var maxChars = 55;
      if (title.length <= maxChars) return title;
      var cut = title.slice(0, maxChars);
      var lastSpace = cut.lastIndexOf(' ');
      var truncated = lastSpace > 40 ? cut.slice(0, lastSpace) : cut;
      return truncated.trim() + '...';
    },
    openCogsModal: function openCogsModal(product) {
      var _this3 = this;

      console.log('openCogsModal called', {
        product: product,
        productId: product ? product.productId : 'null',
        productTitle: product ? product.productTitle : 'null',
        currentCogs: product ? product.cogs : 'null'
      });

      if (!product) {
        console.error('openCogsModal called with null product');
        alert('Error: Product data is missing');
        return;
      }

      if (!product.productId) {
        console.error('Product ID is missing');
        alert('Error: Product ID is missing');
        return;
      }

      this.$nextTick(function () {
        if (_this3.$refs.productCostMarginModal) {
          _this3.$refs.productCostMarginModal.open(product.productId);
        } else {
          console.error('ProductCostMarginModal ref not found');
          console.error('Available refs:', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this3.$refs));
          alert('Error: Modal component not available');
        }
      });
    },
    handleCostMarginUpdated: function handleCostMarginUpdated(productId) {
      this.$emit('cogs-updated', productId);
    }
  },
  computed: {
    getCardsLayoutSize: function getCardsLayoutSize() {
      var n = this.productGroupIds.length;
      var w = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).width();

      if (n > 4) return w > 1320 ? 'five' : 'four';
      if (n === 4) return w > 1220 ? 'four' : 'three';else return w > 1440 ? 'four' : 'three';
    },

    totalItems: function totalItems() {
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        return 0;
      }
      var total = this.groupedProducts.length;
      console.log('ProductCard totalItems (server-side):', total);
      return total;
    },
    totalPages: function totalPages() {
      return 1;
    },
    paginatedProducts: function paginatedProducts() {
      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        console.warn('ProductCard: groupedProducts is not an array');
        return [];
      }

      console.log('ProductCard paginatedProducts (server-side):', this.groupedProducts.length);
      return this.groupedProducts;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('.circular[data-content]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' });
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#darkbackgr').stop().fadeOut(200);
    this.$nextTick(function () {
      if (_this4.$refs.productCostMarginModal) {
        console.log('ProductCard mounted: ProductCostMarginModal ref is available');
      } else {
        console.warn('ProductCard mounted: ProductCostMarginModal ref not found');
      }
    });
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$components$da, 'watch', {
  worldStore: {
    handler: function handler(newWorldStore) {
      console.log('ProductCard watch: worldStore changed, products count:', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(newWorldStore && newWorldStore.products || {}).length);
      if (newWorldStore && newWorldStore.products && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(newWorldStore.products).length > 0) {
        console.log('ProductCard watch: calling calc with worldStore');
        this.calc(newWorldStore);
      }
    },
    deep: true
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$components$da, 'created', function created() {
  console.log('ProductCard created');
  console.log('ProductCard: worldStore prop exists:', !!this.worldStore);
  console.log('ProductCard: worldStore.products count:', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.worldStore && this.worldStore.products || {}).length);

  if (this.worldStore && this.worldStore.products) {
    console.log('ProductCard: calling calc with worldStore prop');
    this.calc(this.worldStore);
  } else {
    console.warn('ProductCard: worldStore prop not found or has no products');
  }
}), _mixins$components$da);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductCostMarginModal',
  data: function data() {
    return {
      productId: null,
      productData: null,
      loading: false,
      error: null,
      saving: false,
      formData: {
        supplierCost: 0,
        otherCosts: 0,
        useGlobalDefault: true,
        customMarginPercentage: null
      },
      calculatedData: {
        totalLandedCost: 0,
        breakEvenPrice: 0,
        currentMargin: {
          percentage: 0,
          amount: 0
        },
        floorPrice: 0
      },
      marginMode: 'global'
    };
  },
  computed: {
    currencySymbol: function currencySymbol() {
      return this.productData && this.productData.currency_symbol || '';
    },
    effectiveMarginPercentage: function effectiveMarginPercentage() {
      if (this.formData.useGlobalDefault && this.productData) {
        return this.productData.target_margin.global_default_percentage;
      }
      return this.formData.customMarginPercentage || 0;
    }
  },
  methods: {
    open: function open(productId) {
      var _this = this;

      if (!productId) {
        console.warn('ProductCostMarginModal: open() called without productId');
        return;
      }

      this.productId = productId;
      this.loading = true;
      this.error = null;
      this.productData = null;

      this.$nextTick(function () {
        var $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this.$refs.costMarginModal);
        if (!$modal || !$modal.length) {
          console.error('ProductCostMarginModal: Modal element not found');
          return;
        }

        if ($modal.data('modal')) {
          $modal.modal('destroy');
        }

        $modal.modal({
          closable: true,
          autofocus: false,
          centered: true,
          onHidden: function onHidden() {
            _this.resetForm();
          },
          onApprove: function onApprove() {
            return false;
          }
        });

        $modal.modal('show');
        _this.loadProductData();
      });
    },
    closeModal: function closeModal() {
      var $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.costMarginModal);
      if ($modal && $modal.length) {
        $modal.modal('hide');

        this.$nextTick(function () {
          try {
            if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ui.modal.visible').length) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('dimmed');
            }
          } catch (e) {}
        });
      }
    },
    loadProductData: function loadProductData() {
      var _this2 = this;

      if (!this.productId) {
        this.error = 'Product ID is missing';
        this.loading = false;
        return;
      }

      var cleanId = String(this.productId).replace(/^PROD-/i, '');

      this.loading = true;
      this.error = null;

      this.$http.get('/api/v1/products/' + cleanId + '/cost_margin').then(function (response) {
        _this2.loading = false;
        if (response.body) {
          _this2.productData = response.body;
          _this2.initializeForm();
        } else {
          _this2.error = 'Failed to load product data';
        }
      }, function (error) {
        _this2.loading = false;
        console.error('Error loading product cost/margin data:', error);
        if (error.body && error.body.error) {
          _this2.error = error.body.error;
        } else if (error.body && error.body.message) {
          _this2.error = error.body.message;
        } else {
          _this2.error = 'Failed to load product data. Please try again.';
        }
      });
    },
    initializeForm: function initializeForm() {
      if (!this.productData) return;

      var supplierCost = this.productData.your_costs && this.productData.your_costs.supplier_cost;
      var otherCosts = this.productData.your_costs && this.productData.your_costs.other_costs;

      this.formData.supplierCost = supplierCost !== null && supplierCost !== undefined ? parseFloat(supplierCost) : 0;
      this.formData.otherCosts = otherCosts !== null && otherCosts !== undefined ? parseFloat(otherCosts) : 0;

      if (this.productData.target_margin) {
        this.formData.useGlobalDefault = this.productData.target_margin.use_global_default !== undefined ? this.productData.target_margin.use_global_default : true;
        this.formData.customMarginPercentage = this.productData.target_margin.custom_override_percentage !== null && this.productData.target_margin.custom_override_percentage !== undefined ? parseFloat(this.productData.target_margin.custom_override_percentage) : null;
      } else {
        this.formData.useGlobalDefault = true;
        this.formData.customMarginPercentage = null;
      }

      this.marginMode = this.formData.useGlobalDefault ? 'global' : 'custom';

      if (this.productData.calculations) {
        var calc = this.productData.calculations;
        var currentMargin = calc.current_margin || {};

        this.calculatedData = {
          totalLandedCost: calc.total_landed_cost !== null && calc.total_landed_cost !== undefined ? parseFloat(calc.total_landed_cost) : 0,
          breakEvenPrice: calc.break_even_price !== null && calc.break_even_price !== undefined ? parseFloat(calc.break_even_price) : 0,
          currentMargin: {
            percentage: currentMargin.percentage !== null && currentMargin.percentage !== undefined ? parseFloat(currentMargin.percentage) : 0,
            amount: currentMargin.amount !== null && currentMargin.amount !== undefined ? parseFloat(currentMargin.amount) : 0
          },
          floorPrice: calc.floor_price !== null && calc.floor_price !== undefined ? parseFloat(calc.floor_price) : 0
        };
      } else {
        this.calculatedData = {
          totalLandedCost: this.formData.supplierCost + this.formData.otherCosts,
          breakEvenPrice: 0,
          currentMargin: {
            percentage: 0,
            amount: 0
          },
          floorPrice: 0
        };
      }
    },
    handleSupplierCostInput: function handleSupplierCostInput(event) {
      var value = event.target.value;
      if (value === '' || value === null || value === undefined) {
        this.formData.supplierCost = 0;
      } else {
        var numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.formData.supplierCost = 0;
        } else {
          if (numValue < 0) numValue = 0;

          this.formData.supplierCost = Number(numValue.toFixed(2));
        }
      }
      this.calculateTotals();
    },
    handleOtherCostsInput: function handleOtherCostsInput(event) {
      var value = event.target.value;
      if (value === '' || value === null || value === undefined) {
        this.formData.otherCosts = 0;
      } else {
        var numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.formData.otherCosts = 0;
        } else {
          if (numValue < 0) numValue = 0;

          this.formData.otherCosts = Number(numValue.toFixed(2));
        }
      }
      this.calculateTotals();
    },
    handleCustomMarginInput: function handleCustomMarginInput(event) {
      var value = event.target.value;
      if (value === '' || value === null || value === undefined) {
        this.formData.customMarginPercentage = null;
      } else {
        var numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.formData.customMarginPercentage = null;
        } else {
          if (numValue < 0) numValue = 0;
          if (numValue > 100) numValue = 100;
          this.formData.customMarginPercentage = numValue;
        }
      }
      this.calculateTotals();
    },
    onMarginModeChange: function onMarginModeChange() {
      this.formData.useGlobalDefault = this.marginMode === 'global';
      if (this.formData.useGlobalDefault) {
        this.formData.customMarginPercentage = null;
      }
      this.calculateTotals();
    },
    calculateTotals: function calculateTotals() {
      var supplierCost = typeof this.formData.supplierCost === 'number' ? this.formData.supplierCost : parseFloat(this.formData.supplierCost) || 0;
      var otherCosts = typeof this.formData.otherCosts === 'number' ? this.formData.otherCosts : parseFloat(this.formData.otherCosts) || 0;

      supplierCost = Number(supplierCost);
      otherCosts = Number(otherCosts);

      this.calculatedData.totalLandedCost = supplierCost + otherCosts;

      if (this.productData && this.productData.amazon_fees) {
        var totalFees = this.productData.amazon_fees.total || 0;
        this.calculatedData.breakEvenPrice = this.calculatedData.totalLandedCost + totalFees;
      } else {
        this.calculatedData.breakEvenPrice = this.calculatedData.totalLandedCost;
      }

      if (this.productData && this.productData.product_info && this.productData.product_info.current_price) {
        var price = this.productData.product_info.current_price;
        var totalCost = this.calculatedData.totalLandedCost;
        var _totalFees = this.productData.amazon_fees && this.productData.amazon_fees.total || 0;
        var profit = price - totalCost - _totalFees;
        this.calculatedData.currentMargin.amount = profit;
        this.calculatedData.currentMargin.percentage = price > 0 ? profit / price * 100 : 0;
      }

      var marginDecimal = this.effectiveMarginPercentage / 100;
      var amazonFees = this.productData && this.productData.amazon_fees ? this.productData.amazon_fees : {};
      var referralFeeRate = Number(amazonFees.referral_fee_rate);
      var denominator = 1 - marginDecimal - referralFeeRate;

      if (this.calculatedData.totalLandedCost === 0 || isNaN(referralFeeRate)) {
        this.calculatedData.floorPrice = 0;
      } else if (denominator > 0) {
        this.calculatedData.floorPrice = (this.calculatedData.totalLandedCost + (amazonFees.fba_fulfillment_fee || 0)) / denominator;
      } else {
        this.calculatedData.floorPrice = 0;
      }
    },
    saveSettings: function saveSettings() {
      var _this3 = this;

      if (!this.productId) {
        alert('Error: Product ID is missing');
        return;
      }

      if (this.formData.supplierCost < 0) {
        alert('Supplier cost must be greater than or equal to 0');
        return;
      }

      if (this.formData.otherCosts < 0) {
        alert('Other costs must be greater than or equal to 0');
        return;
      }

      if (!this.formData.useGlobalDefault) {
        if (!this.formData.customMarginPercentage || this.formData.customMarginPercentage < 0 || this.formData.customMarginPercentage > 100) {
          alert('Please enter a valid custom margin percentage (0-100)');
          return;
        }
      }

      this.saving = true;
      var cleanId = String(this.productId).replace(/^PROD-/i, '');

      var payload = {
        cogs: this.formData.supplierCost,
        other_costs: this.formData.otherCosts
      };

      if (!this.formData.useGlobalDefault) {
        payload.custom_margin_percentage = this.formData.customMarginPercentage;
      } else {
        payload.custom_margin_percentage = null;
      }

      this.$http.put('/api/v1/products/' + cleanId + '/update_cost_margin', payload).then(function (response) {
        _this3.saving = false;
        var body = response.body || {};

        var explicitFail = body.success === false || !!(body.error && String(body.error).trim());
        if (!explicitFail) {
          _this3.$emit('cost-margin-updated', _this3.productId);

          _this3.closeModal();
        } else {
          window.alert(body.message || body.error || 'Failed to save settings. Please try again.');
        }
      }, function (error) {
        _this3.saving = false;
        console.error('Error saving cost/margin settings:', error);
        if (error.body && error.body.errors && Array.isArray(error.body.errors)) {
          alert('Error: ' + error.body.errors.join(', '));
        } else if (error.body && error.body.error) {
          alert('Error: ' + error.body.error);
        } else {
          alert('Failed to save settings. Please try again.');
        }
      });
    },
    resetForm: function resetForm() {
      this.productId = null;
      this.productData = null;
      this.loading = false;
      this.error = null;
      this.saving = false;
      this.formData = {
        supplierCost: 0,
        otherCosts: 0,
        useGlobalDefault: true,
        customMarginPercentage: null
      };
      this.calculatedData = {
        totalLandedCost: 0,
        breakEvenPrice: 0,
        currentMargin: {
          percentage: 0,
          amount: 0
        },
        floorPrice: 0
      };
      this.marginMode = 'global';
    },
    formatPrice: function formatPrice(price) {
      if (price === null || price === undefined || isNaN(price)) return '0.00';
      return parseFloat(price).toFixed(2);
    },
    getMarginClass: function getMarginClass(margin) {
      if (margin.percentage >= 0) {
        return 'margin-positive';
      }
      return 'margin-negative';
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showAddKeywordForm: false,
      wdDet: [{ wdType: 'starRatingRecentChange', wdName: 'Star Rating' }, { wdType: 'badReview', wdName: 'Latest Reviews' }, { wdType: 'topReview', wdName: 'Top Rated Reviews' }, { wdType: 'noAddToCart', wdName: 'Has an add-to-cart button' }, { wdType: 'lostBuybox', wdName: 'Buy-box' }, { wdType: 'numberOfSellers', wdName: 'Hijacker Alert' }, { wdType: 'salesDrop', wdName: 'Sales Volume' }, { wdType: 'imageMissing', wdName: 'Has a Main Image' }, { wdType: 'productDetailsRecentChange', wdName: 'Title, Bullets, Description changes' }, { wdType: 'productCategoryRecentChange', wdName: 'Sub-category change' }, { wdType: 'bestSellerBadge', wdName: 'Best Seller Badge' }, { wdType: 'prime', wdName: 'Prime Badge' }, { wdType: 'amazonChoiceBadge', wdName: 'Amazon\'s choice Badge' }, { wdType: 'price', wdName: 'Price' }, { wdType: 'searchBan', wdName: 'Search Result Suppression' }, { wdType: 'fbaFeeChange', wdName: 'FBA Fee Change' }, { wdType: 'subscribeAndSave', wdName: 'Subscribe and Save' }, { wdType: 'parentProductChange', wdName: 'Parent Product Change' }, { wdType: 'adultClassification', wdName: 'Adult Classification' }],
      amaSites: { 'DE': 'www.amazon.de', 'CN': 'www.amazon.cn', 'UK': 'www.amazon.co.uk', 'JP': 'www.amazon.co.jp', 'FR': 'www.amazon.fr', 'ES': 'www.amazon.es', 'IT': 'www.amazon.it', 'US': 'www.amazon.com', 'MX': 'www.amazon.com.mx', 'IN': 'www.amazon.in', 'CA': 'www.amazon.ca', 'BR': 'www.amazon.com.br', 'NL': 'www.amazon.nl', 'BE': 'www.amazon.com.be', 'SE': 'www.amazon.se', 'PL': 'www.amazon.pl', 'AT': 'www.amazon.at', 'ZA': 'www.amazon.co.za' },
      index: 0,
      productIDs: []
    };
  },
  methods: {
    setGalleryParams: function setGalleryParams(index, productIDs) {
      this.index = index;
      this.productIDs = productIDs;
      if (productIDs.length !== 0) window.location.hash = 'pdet-' + productIDs[index];
    },

    prettyfyReviewText: function prettyfyReviewText(t) {
      return t.replace(/(#\d+)/gi, '<span style=\'color:mediumpurple;\'>$1</span>').replace(/([123])-star/gi, '<span style=\'color:orangered;\'>$1&#9733;</span>').replace(/([45])-star/gi, '<span style=\'color:orange;\'>$1&#9733;</span>');
    },

    prettyfyRatingText: function prettyfyRatingText(t) {
      return t.replace(/star rating is ([0-9.]+)[ ,]/gi, 'is <span style=\'color:lightyellow;\'>$1&#9733;</span>').replace(/(\d+) (review|rating)/gi, '<span style=\'color:lightsteelblue;\'>$1</span> $2').replace(/count is (\d+)/gi, 'count is <span style=\'color:lightsteelblue;\'>$1</span>');
    },
    addNewKeyword: function addNewKeyword() {
      var _this = this;

      var keyword = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('#addNewKeywordForm [name=newKeyword]').val().trim();
      if (keyword === '') return;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('#addNewKeywordForm .submit').addClass('loading');
      var tres = parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('#addNewKeywordForm [name=newTreshold]').val());
      this.$http.post('/api/sentinel/watchdog/keyword/create', {
        productId: this.productIDs[this.index],
        keyword: keyword,
        absoluteThreshold: tres > 0 ? tres : null
      }).then(function (response) {
        var locationHeader = response.headers.get('Location') || response.headers.Location;
        var watchDogItemId = null;

        if (locationHeader) {
          var match = locationHeader.match(/\/api\/sentinel\/watchdog\/(\d+)/);
          if (match) {
            watchDogItemId = parseInt(match[1]);
          }
        }

        if (!watchDogItemId) {
          console.error('Failed to extract watchDogId from Location header:', locationHeader);
          window.alert('Error: Could not get keyword ID from server response');
          return;
        }

        var newKeywordKey = 'keyword_' + watchDogItemId;

        var newKeywordItem = {
          marketplace: 'US',
          status: 99,
          statusDetails: { message: 'initializing' },
          settings: { keyword: keyword, absoluteThreshold: tres > 0 ? tres : 1000 },
          muted: false,
          watchDogItemId: watchDogItemId,
          productId: _this.productIDs[_this.index]
        };

        _this.$set(_this.$parent.$parent.worldStore.watchDogs, newKeywordKey, newKeywordItem);

        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.$el).find('#addNewKeywordForm [name=newKeyword]').val('');
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.$el).find('#addNewKeywordForm [name=newTreshold]').val('');
        _this.showAddKeywordForm = false;

        if (_this.$parent.productDetails) {
          _this.$parent.productDetails(_this.productIDs[_this.index]);
        }
      }, function (response) {
        console.error('Add keyword failed:', response);

        if (response.status === 409) {
          window.alert('Keyword already exists for this product');
        } else if (response.status === 400) {
          window.alert('Invalid keyword or threshold value');
        } else {
          window.alert('Error adding keyword - please try again');
        }
      }).finally(function () {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.$el).find('#addNewKeywordForm .submit').removeClass('loading');
      });
    },
    removeKeyword: function removeKeyword(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('[data-wdid=' + id + ']').parent().parent().parent().fadeOut();
      this.$http.put('/api/sentinel/watchdog/keyword/deactivate', { watchDogId: id }).then(function (response) {
        var productId = _this2.productIDs[_this2.index];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this2.$parent.$parent.worldStore.watchDogs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
                key = _step$value[0],
                watchDogItem = _step$value[1];

            if (key.startsWith('keyword_') && watchDogItem.watchDogItemId === id) {
              _this2.$delete(_this2.$parent.$parent.worldStore.watchDogs, key);
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (_this2.$parent.productDetails) {
          _this2.$parent.productDetails(productId);
        }
      }, function (response) {
        window.alert('error :( - please let us know this happened');
      });
    },
    galleryNext: function galleryNext() {
      if (this.galleryNextButton) {
        this.index++;

        var newProductId = this.productIDs[this.index];
        if (this.$parent.productDetails) {
          this.$parent.productDetails(newProductId);
        }
      }
    },
    galleryPrev: function galleryPrev() {
      if (this.galleryPrevButton) {
        this.index--;

        var newProductId = this.productIDs[this.index];
        if (this.$parent.productDetails) {
          this.$parent.productDetails(newProductId);
        }
      }
    },
    hide: function hide() {
      return __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#productDetailModal').modal('hide');
    },
    salesCount: function salesCount(t, productId, salesType) {
      var _this3 = this;

      var getSales = function getSales(id) {
        return _this3.$parent.$parent.worldStore.products[id].sales;
      };
      var getAllChildPIds = function getAllChildPIds(id) {
        return _this3.$parent.$parent.worldStore.products[id].productGroupProductIds;
      };
      var date = function date(t) {
        return t === 'y' || t === 'ytd' ? 1 : 0;
      };

      return getAllChildPIds(productId).reduce(function (prevVal, id) {
        var sales = getSales(id);
        var dateIndex = date(t);
        if (sales && sales[dateIndex] && sales[dateIndex][salesType] !== undefined) {
          return prevVal + sales[dateIndex][salesType];
        }
        return prevVal + 0;
      }, 0);
    },
    numInGroup: function numInGroup() {
      var firstIndex = this.index;
      while (firstIndex >= 0 && this.$parent.$parent.worldStore.products[this.productIDs[this.index]].productGroupId === this.$parent.$parent.worldStore.products[this.productIDs[firstIndex]].productGroupId) {
        firstIndex--;
      }
      return this.index - firstIndex;
    },
    toMonth: function toMonth(m) {
      return { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }[m];
    },
    hasPromoCodes: function hasPromoCodes(k) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.promoCodes[k]).length > 0;
    },
    getIconClasses: function getIconClasses(item) {
      if (item.status === 99) return 'right grey circle icon';
      if (item.status === 0) return 'right green checkmark icon';
      if (item.status === 1 || item.status === 2) {
        if (item.issueStatus > 0 || item.muted) return 'right blue warning circle icon';
        if (item.status === 1) return 'right orange warning circle icon';
        if (item.status === 2) return 'right red warning circle icon';
      }
    },
    cycleIssueStatus: function cycleIssueStatus(wdType, productId) {
      var item = this.$parent.$parent.worldStore.watchDogs[wdType].items[productId];
      if (!item) {
        this.$http.post('/api/webui/p0/rjse', {
          message: 'checkNotNullFailed, wdType:' + wdType + ', productId: ' + productId,
          url: 'cycleIssueStatus()',
          lineNumber: 0,
          columnNumber: 0,
          error: 'checkNotNullFailed'
        });
      } else if (!item.muted && item.status > 0) {
        this.$parent.$parent.setIssueStatus(item.watchDogId, item.issueStatus === 3 ? 0 : item.issueStatus + 1);
      }
    },
    cycleKeywordIssueStatus: function cycleKeywordIssueStatus(productId, index) {
      var item = this.$parent.$parent.worldStore.watchDogs['keyword'].items[productId][index];
      if (!item.muted && item.status > 0) {
        this.$parent.$parent.setIssueStatus(item.watchDogId, item.issueStatus === 3 ? 0 : item.issueStatus + 1);
      }
    }
  },
  computed: {
    galleryPrevButton: function galleryPrevButton() {
      return this.productIDs.length > 1 && this.index > 0;
    },
    galleryNextButton: function galleryNextButton() {
      return this.productIDs.length > 1 && this.index < this.productIDs.length - 1;
    },

    currentProductWatchDogs: function currentProductWatchDogs() {
      var productId = this.productIDs[this.index];
      if (!productId || !this.$parent.$parent.worldStore.watchDogs) {
        console.log('[ProductDetails] No productId or watchDogs:', { productId: productId, hasWatchDogs: !!this.$parent.$parent.worldStore.watchDogs });
        return {};
      }

      var watchDogs = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.$parent.$parent.worldStore.watchDogs)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_step2.value, 2),
              fullKey = _step2$value[0],
              watchDogItem = _step2$value[1];

          var wdType = fullKey.split('_')[0];

          if (wdType === 'keyword') continue;

          if (watchDogItem.productId === productId) {
            watchDogs[wdType] = watchDogItem;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      console.log('[ProductDetails] currentProductWatchDogs for', productId, ':', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(watchDogs));
      return watchDogs;
    },

    currentProductKeywords: function currentProductKeywords() {
      var productId = this.productIDs[this.index];
      if (!productId || !this.$parent.$parent.worldStore.watchDogs) return [];

      var keywords = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.$parent.$parent.worldStore.watchDogs)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_step3.value, 2),
              fullKey = _step3$value[0],
              watchDogItem = _step3$value[1];

          var wdType = fullKey.split('_')[0];

          if (wdType === 'keyword' && watchDogItem.productId === productId) {
            keywords.push(watchDogItem);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      console.log('[ProductDetails] currentProductKeywords for', productId, ':', keywords.length, 'keywords');
      return keywords;
    },
    promoCodes: function promoCodes() {
      var _this4 = this;

      if (!(this.productIDs.length > 0)) return null;else if (this.$parent.$parent.worldStore.products[this.productIDs[this.index]].sales === null) return null;

      var salesRanges = { today: [0], ytd: [1] };
      var productVariations = this.$parent.$parent.worldStore.products[this.productIDs[this.index]].productGroupProductIds;
      var getPCodes = function getPCodes(id, i) {
        var sales = _this4.$parent.$parent.worldStore.products[id].sales;
        if (sales && sales[i] && sales[i].promotionCodesUsedUnits) {
          return sales[i].promotionCodesUsedUnits;
        }
        return {};
      };
      var rslt = {};

      for (var r in salesRanges) {
        rslt[r] = {};
        for (var day in salesRanges[r]) {
          for (var item in productVariations) {
            var codes = getPCodes(productVariations[item], salesRanges[r][day]);
            for (var c in codes) {
              if (rslt[r].hasOwnProperty(c)) {
                rslt[r][c].orders = rslt[r][c].orders + codes[c].orders;
                rslt[r][c].units = rslt[r][c].units + codes[c].units;
              } else {
                rslt[r][c] = { 'orders': codes[c].orders, 'units': codes[c].units };
              }
            }
          }
        }
      }

      return rslt;
    }
  },
  watch: {
    productIDs: function productIDs() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).find('i[data-html]').popup('destroy');
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this5.$el).find('i[data-html]').popup({ delay: { show: 0, hide: 0 }, transition: 'scale' });
      }, 500);
    }
  },

  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this.$el).remove();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineChart__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpreadsheetDownloadWidget__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpreadsheetDownloadWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SpreadsheetDownloadWidget__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LineChart: __WEBPACK_IMPORTED_MODULE_3__LineChart___default.a, SpreadsheetDownloadWidget: __WEBPACK_IMPORTED_MODULE_4__SpreadsheetDownloadWidget___default.a },
  data: function data() {
    var nowDateString = new Date(Date.now()).toISOString().split('T')[0];
    return {
      showChartRangeSelector: false,
      chartRangeDateFrom: nowDateString,
      chartRangeDateTo: nowDateString,
      chartRangeSt: '',
      salesLoading: true,
      promotionsLoading: true,
      promotionsColors: ['rgba(171,201,205,0.8)', 'rgba(101,142,147,0.8)', 'rgba(122,190,128,0.8)', 'rgba(69,149,76,0.8)', 'rgba(255,189,189,0.8)', 'rgba(112,126,96,0.8)', 'rgba(110,96,126,0.8)', 'rgba(141,105,105,0.8)', 'rgba(105,141,105,0.8)', 'rgba(105,141,141,0.8)'],
      visible: false,
      product: null,
      sourceModal: null,
      lookbackDays: 30,
      lastLoadedAt: null
    };
  },
  methods: {
    createDataSet: function createDataSet(color) {
      return {
        backgroundColor: color,
        pointBorderColor: color,
        pointBackgroundColor: color,
        borderColor: color,
        pointHoverBackgroundColor: 'black',
        pointHitRadius: 30,
        fill: false
      };
    },
    formatDate: function formatDate(item) {
      return new Date(item.year, item.month - 1, item.day).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    filterOutStepWithFraction: function filterOutStepWithFraction(value, index, values) {
      if (Math.floor(value) === value) {
        return value;
      }
    },
    loadSalesChart: function loadSalesChart() {
      var _this = this;

      this.$http.get('/api/order/daily-breakdown', {
        params: {
          productGroupId: this.product.productGroupId,
          productId: this.product.productId,
          lookbackDays: this.lookbackDays
        }
      }).then(function (orderResponse) {
        _this.salesLoading = false;
        var hasRanks = false;
        var dates = orderResponse.body.sales.map(_this.formatDate);
        var ranksMap = {};
        var ranks = [];

        var datasets = [];
        if (orderResponse.body.hasVariations) {
          datasets.push(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(_this.createDataSet('#7a969b'), {
            yAxisID: 'y-axis-0',
            label: 'Sales (all variations)',
            data: orderResponse.body.sales.map(function (s) {
              return s.soldUnitsAllVariations;
            })
          }));
          datasets.push(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(_this.createDataSet('#B0CA65'), {
            yAxisID: 'y-axis-0',
            label: 'Sales (this variation)',
            hidden: true,
            data: orderResponse.body.sales.map(function (s) {
              return s.soldUnitsThisVariation;
            })
          }));
        } else {
          datasets.push(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(_this.createDataSet('#7a969b'), {
            yAxisID: 'y-axis-0',
            label: 'Sales',
            data: orderResponse.body.sales.map(function (s) {
              return s.soldUnitsAllVariations;
            })
          }));
        }
        if (hasRanks) {
          datasets.push(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(_this.createDataSet('rgba(211, 165, 133, 0.5)'), {
            yAxisID: 'y-axis-1',
            label: orderResponse.body.hasVariations ? 'Rank (this variation)' : 'Rank',
            hidden: orderResponse.body.hasVariations,
            data: ranks,
            spanGaps: false
          }));
        }
        var dataset = {
          datasets: datasets,
          labels: dates
        };
        var yAxes = [{
          yAxisID: 'y-axis-0',
          scaleLabel: {
            display: true,
            labelString: 'Units Sold'
          },
          ticks: {
            beginAtZero: true,
            suggestedMax: (hasRanks ? 1.6 : 1.05) * orderResponse.body.sales.map(function (s) {
              return s.soldUnitsAllVariations;
            }).concat([1]).reduce(_this.maxReducer),
            callback: _this.filterOutStepWithFraction
          },
          gridLines: {
            display: true,
            color: 'rgba(128, 128, 128, 0.2)'
          }
        }];
        if (hasRanks) {
          yAxes.push({
            yAxisID: 'y-axis-1',
            scaleLabel: {
              display: true,
              labelString: 'BSR'
            },
            ticks: {
              beginAtZero: false,
              reverse: true,
              suggestedMax: 1.6 * ranks.concat([1]).reduce(_this.maxReducer),
              callback: _this.filterOutStepWithFraction
            },
            gridLines: {
              display: false
            },
            position: 'right'
          });
        }
        var options = {
          scales: {
            yAxes: yAxes,
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true,
            position: 'bottom'
          },
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: 'Sales'
          }
        };
        if (_this.visible) _this.$refs.salesLineChart.render(dataset, options);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#chartModal').modal('refresh');
      }, function (orderResponse) {
        console.log(orderResponse.body);
      });
    },
    maxReducer: function maxReducer(prev, current) {
      return prev > current ? prev : current;
    },
    loadPromotionsChart: function loadPromotionsChart() {
      var _this2 = this;

      this.$http.get('/api/order/promotions-daily-breakdown', {
        params: {
          productGroupId: this.product.productGroupId,
          lookbackDays: this.lookbackDays
        }
      }).then(function (promoResponse) {
        _this2.promotionsLoading = false;
        var promotions = promoResponse.body.promotions;
        var promotionKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(promotions);
        var datasets = [];
        for (var i = 0; i < promotionKeys.length; ++i) {
          var promotion = promotionKeys[i];
          datasets.push(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(_this2.createDataSet(_this2.promotionsColors[i % _this2.promotionsColors.length]), {
            label: promotion,
            data: promotions[promotion]
          }));
        }
        var options = {
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Number of Used Promotions'
              },
              ticks: {
                beginAtZero: true,
                suggestedMax: 1.05 * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(promotions).filter(function (p) {
                  return p.length > 0;
                }).map(function (p) {
                  return p.reduce(_this2.maxReducer);
                }).concat([1]).reduce(_this2.maxReducer),
                callback: _this2.filterOutStepWithFraction
              },
              gridLines: {
                display: true,
                color: 'rgba(128, 128, 128, 0.2)'
              }
            }],
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true,
            position: 'bottom'
          },
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: 'Promotions'
          }
        };
        var dataset = {
          datasets: datasets,
          labels: promoResponse.body.dates.map(_this2.formatDate)
        };
        if (_this2.visible) _this2.$refs.promotionsLineChart.render(dataset, options);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#chartModal').modal('refresh');
      }, function (promoResponse) {
        console.log(promoResponse);
      });
    },
    open: function open(product, sourceModal) {
      this.product = product;
      this.sourceModal = sourceModal;
    },
    dateRangeButtonClick: function dateRangeButtonClick() {
      var _this3 = this;

      if (String(this.chartRangeDateFrom).match(/^20\d{2}-[01]\d-[0123]\d$/) === null || String(this.chartRangeDateTo).match(/^20\d{2}-[01]\d-[0123]\d$/) === null) {
        this.chartRangeSt = 'RANGE_ERROR';
        setTimeout(function () {
          if (_this3.chartRangeSt === 'RANGE_ERROR') _this3.chartRangeSt = '';
        }, 2000);
        return;
      }
      this.chartRangeSt = 'LOADING';
    }
  },
  watch: {
    product: function product(val) {
      var _this4 = this;

      if (val) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#chartModal').modal({
          onVisible: function onVisible() {
            _this4.visible = true;
            _this4.lastLoadedAt = Date.now();
            _this4.loadSalesChart();
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.ui.dimmer.modals').css('background-color', 'rgba(0,0,0,0.9)');
          },
          onHidden: function onHidden() {
            _this4.visible = false;
            _this4.salesLoading = true;
            if (_this4.$refs.salesLineChart && _this4.$refs.salesLineChart._chart) _this4.$refs.salesLineChart._chart.destroy();
            _this4.product = null;
            if (_this4.sourceModal) __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + _this4.sourceModal).modal('show');
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.ui.dimmer.modals').css('background-color', '');
          }
        }).modal('show');
      }
    },
    destroyed: function destroyed() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).remove();
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buybox_styles_ProductDetailsPage_css__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buybox_styles_ProductDetailsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__buybox_styles_ProductDetailsPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listViewUrlSync_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__product_details_ProductHeader_vue__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__product_details_ProductHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__product_details_ProductHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_details_DiagnosisPanel_vue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_details_DiagnosisPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__product_details_DiagnosisPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__product_details_CurrentOffers_vue__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__product_details_CurrentOffers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__product_details_CurrentOffers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__product_details_BuyBoxFactors_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__product_details_BuyBoxFactors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__product_details_BuyBoxFactors_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__product_details_SalesVolumeChart_vue__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__product_details_SalesVolumeChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__product_details_SalesVolumeChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__product_details_AccountHealth_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__product_details_AccountHealth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__product_details_AccountHealth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__product_details_RecentEvents_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__product_details_RecentEvents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__product_details_RecentEvents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_details_ListingSignals_vue__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_details_ListingSignals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__product_details_ListingSignals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_details_ReviewHealth_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_details_ReviewHealth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__product_details_ReviewHealth_vue__);







var _methods;















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductDetailsPage',
  components: {
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_8__buybox_DashboardLayout_vue___default.a,
    ProductHeader: __WEBPACK_IMPORTED_MODULE_9__product_details_ProductHeader_vue___default.a,
    DiagnosisPanel: __WEBPACK_IMPORTED_MODULE_10__product_details_DiagnosisPanel_vue___default.a,
    CurrentOffers: __WEBPACK_IMPORTED_MODULE_11__product_details_CurrentOffers_vue___default.a,

    BuyBoxFactors: __WEBPACK_IMPORTED_MODULE_12__product_details_BuyBoxFactors_vue___default.a,
    SalesVolumeChart: __WEBPACK_IMPORTED_MODULE_13__product_details_SalesVolumeChart_vue___default.a,
    AccountHealth: __WEBPACK_IMPORTED_MODULE_14__product_details_AccountHealth_vue___default.a,
    RecentEvents: __WEBPACK_IMPORTED_MODULE_15__product_details_RecentEvents_vue___default.a,
    ListingSignals: __WEBPACK_IMPORTED_MODULE_16__product_details_ListingSignals_vue___default.a,
    ReviewHealth: __WEBPACK_IMPORTED_MODULE_17__product_details_ReviewHealth_vue___default.a
  },
  data: function data() {
    return {
      lastUpdated: 'just now',
      lastUpdateTime: null,
      timerInterval: null,
      loading: true,
      error: null,
      errorTitle: 'Error Loading Product',
      product: null,
      activeTab: 'action',
      recentEventsDays: 7 };
  },

  computed: {
    decodedBackTarget: function decodedBackTarget() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_listViewUrlSync_js__["a" /* decodeBackQuery */])(this.$route.query.back);
    },
    backNavigationLabel: function backNavigationLabel() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_listViewUrlSync_js__["b" /* backLinkLabelForPath */])(this.decodedBackTarget);
    },
    reviewHealthVisible: function reviewHealthVisible() {
      var rh = this.product && this.product.reviewHealth;
      return !!rh && (rh.state === 'ready' || rh.state === 'waiting');
    }
  },
  methods: (_methods = {
    navigateBackToList: function navigateBackToList() {
      var target = this.decodedBackTarget;
      if (target) {
        this.$router.push(target);
        return;
      }
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/products');
      }
    },
    goBack: function goBack() {
      this.navigateBackToList();
    },
    goToAlerts: function goToAlerts() {
      this.$router.push('/all-alerts');
    },
    loadProductData: function loadProductData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var productId, productResponse, productData, apiCalls, _ref, _ref2, salesVolumeResponse, competitorOffersResponse, recentEventsResponse, accountHealthResponse, reviewHealthResponse, salesVolumeData, competitorOffersData, recentEventsData, accountHealthData;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.error = null;
                _this.errorTitle = 'Error Loading Product';

                _context.prev = 3;
                productId = _this.$route.query.id;

                if (productId) {
                  _context.next = 8;
                  break;
                }

                _this.errorTitle = 'Product Not Found';
                throw new Error('Please select a product from the All Alerts page to view details.');

              case 8:
                _context.next = 10;
                return _this.$http.get('/api/v1/products/' + productId);

              case 10:
                productResponse = _context.sent;
                productData = productResponse.body;
                apiCalls = [_this.$http.get('/api/v1/products/' + productId + '/sales_volume?days=30'), _this.$http.get('/api/v1/products/' + productId + '/competitor_offers'), _this.$http.get('/api/v1/products/' + productId + '/recent_events?days=' + _this.recentEventsDays), _this.$http.get('/api/v1/products/' + productId + '/account_health').catch(function (err) {
                  console.warn('Failed to load account health:', err);
                  return { body: null };
                }), _this.$http.get('/api/v1/products/' + productId + '/review_health').catch(function (err) {
                  console.warn('Failed to load review health:', err);
                  return { body: null };
                })];
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(apiCalls);

              case 15:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 5);
                salesVolumeResponse = _ref2[0];
                competitorOffersResponse = _ref2[1];
                recentEventsResponse = _ref2[2];
                accountHealthResponse = _ref2[3];
                reviewHealthResponse = _ref2[4];
                salesVolumeData = salesVolumeResponse.body;
                competitorOffersData = competitorOffersResponse.body;
                recentEventsData = recentEventsResponse.body;
                accountHealthData = accountHealthResponse.body;


                _this.product = _this.transformProductData(productData, salesVolumeData, competitorOffersData, recentEventsData, accountHealthData, reviewHealthResponse.body);

                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context['catch'](3);

                if (_context.t0.status === 404) {
                  _this.errorTitle = 'Product Not Found';
                  _this.error = 'The requested product could not be found.';
                } else if (_context.t0.status === 401) {
                  _this.errorTitle = 'Authentication Required';
                  _this.error = 'Please log in to view product details.';
                } else {
                  _this.error = _context.t0.message || 'Failed to load product details';
                }
                console.error('Error loading product:', _context.t0);

              case 33:
                _context.prev = 33;

                _this.loading = false;
                return _context.finish(33);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 29, 33, 36]]);
      }))();
    },
    transformProductData: function transformProductData(productData, salesVolumeData, competitorOffersData, recentEventsData, accountHealthData, reviewHealthData) {
      return {
        id: productData.product && productData.product.id || 0,
        title: productData.product && productData.product.name || 'Unknown Product',
        asin: productData.product && productData.product.asin || 'N/A',
        sku: productData.product && productData.product.sku || null,
        marketplace: productData.product && productData.product.marketplace.toUpperCase() || 'US',
        brand: productData.product && productData.product.brand || productData.product && productData.product.seller_name || productData.seller_name || productData.brand || null,
        imageUrl: productData.product && productData.product.image_url || 'https://via.placeholder.com/80',
        status: {
          type: this.mapStatusType(productData.buybox_status && productData.buybox_status.status),
          label: productData.buybox_status && productData.buybox_status.label || 'Unknown Status',
          timeAgo: productData.buybox_status && productData.buybox_status.time_since_change || 'recently'
        },
        pricing: {
          yourPrice: productData.your_price && productData.your_price.dollars || 0,
          buyBoxPrice: productData.buybox_price && productData.buybox_price.dollars || 0,
          priceGap: Math.abs(productData.price_gap && productData.price_gap.dollars || 0),
          estDailyLoss: Math.abs(productData.estimated_daily_loss && productData.estimated_daily_loss.dollars || 0),
          fbaStock: productData.fba_stock && productData.fba_stock.quantity || 0,
          fbaTransferring: (productData.fba_stock && productData.fba_stock.fbaTransferring) != null ? productData.fba_stock.fbaTransferring : 0
        },
        diagnosis: {
          confidence: (productData.diagnosis && productData.diagnosis.confidence || 'medium').toLowerCase(),
          primaryCause: productData.diagnosis && productData.diagnosis.cause || 'Unknown cause',
          description: productData.diagnosis && productData.diagnosis.message || 'No diagnosis available'
        },
        currentOffers: this.transformOffers(competitorOffersData && competitorOffersData.offers),
        listingSignals: this.deriveListingSignals(competitorOffersData && competitorOffersData.offers),
        isFeaturedMerchant: this.deriveIsFeaturedMerchant(competitorOffersData && competitorOffersData.offers),
        buyBoxFactors: this.generateBuyBoxFactors(productData),
        salesVolume: this.transformSalesVolume(salesVolumeData),
        accountHealth: this.transformAccountHealth(accountHealthData),
        recentEvents: this.transformRecentEvents(recentEventsData && recentEventsData.events),
        reviewHealth: reviewHealthData && (typeof reviewHealthData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(reviewHealthData)) === 'object' ? reviewHealthData : null
      };
    },
    transformOffers: function transformOffers(offers) {
      if (!offers || !Array.isArray(offers)) return [];

      return offers.map(function (offer) {
        var isWinner = offer.is_winner === true || offer.is_winner === 'true';
        var isMyOffer = offer.is_my_offer === true || offer.is_my_offer === 'true';

        return {
          seller: offer.seller_name || offer.seller_key || offer.seller_id || 'Unknown',
          sellerId: offer.seller_key || offer.seller_id || offer.seller_name || 'Unknown',
          price: offer.price_dollars || offer.price || 0,
          shipping: offer.shipping_dollars || offer.shipping || 0,
          fulfillment: offer.fulfillment || 'FBM',
          status: offer.status || (isWinner ? 'Has Buy Box' : isMyOffer ? 'Lost' : 'Not winning'),
          hasBuyBox: isWinner,
          isMyOffer: isMyOffer,
          isPrime: offer.is_prime || false,
          sellerFeedbackCount: offer.seller_feedback_count || null,
          sellerPositiveFeedbackRating: offer.seller_positive_feedback_rating || null,
          isFeaturedMerchant: offer.is_featured_merchant != null ? offer.is_featured_merchant : null,
          isBestSeller: offer.is_best_seller || false
        };
      });
    },
    deriveListingSignals: function deriveListingSignals(offers) {
      var myOffer = null;
      if (offers && Array.isArray(offers)) {
        for (var i = 0; i < offers.length; i++) {
          if (offers[i].is_my_offer === true || offers[i].is_my_offer === 'true') {
            myOffer = offers[i];
            break;
          }
        }
      }
      return [{ name: 'Best Seller', icon: '🏆', active: myOffer ? !!myOffer.is_best_seller : false }, { name: 'Prime Eligible', icon: '⚡', active: myOffer ? !!myOffer.is_prime : false }];
    },
    deriveIsFeaturedMerchant: function deriveIsFeaturedMerchant(offers) {
      if (!offers || !Array.isArray(offers)) return true;
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].is_my_offer === true || offers[i].is_my_offer === 'true') {
          return offers[i].is_featured_merchant !== false;
        }
      }
      return false;
    },
    generateBuyBoxFactors: function generateBuyBoxFactors(productData) {
      var factors = [];

      var priceGapDollars = productData.price_gap && productData.price_gap.dollars || 0;
      if (priceGapDollars !== 0) {
        factors.push({
          name: 'Price',
          status: priceGapDollars < 0 ? 'issue' : 'ok',
          description: productData.price_gap && productData.price_gap.formatted || '$0.00',
          icon: 'dollar sign'
        });
      } else {
        factors.push({
          name: 'Price',
          status: 'ok',
          description: 'Competitive',
          icon: 'dollar sign'
        });
      }

      var bothFba = productData.diagnosis && productData.diagnosis.details && productData.diagnosis.details.both_fba || false;
      factors.push({
        name: 'Fulfillment',
        status: bothFba ? 'ok' : 'warning',
        description: bothFba ? 'Both FBA' : productData.diagnosis && productData.diagnosis.details && productData.diagnosis.details.our_fulfillment || 'Unknown',
        icon: 'shipping fast'
      });

      var isAvailable = productData.fba_stock && productData.fba_stock.is_available || false;
      factors.push({
        name: 'Stock Level',
        status: isAvailable ? 'ok' : 'issue',
        description: isAvailable ? 'In stock' : 'Out of stock',
        icon: 'boxes'
      });

      return factors;
    },
    transformSalesVolume: function transformSalesVolume(salesVolumeData) {
      if (!salesVolumeData) {
        return {
          dailyAverage: 0,
          last7Days: 0,
          last7DaysChange: 0,
          estMonthlyRevenue: 0,
          chartData: []
        };
      }

      var dailyAverage = 0;
      if (typeof salesVolumeData.daily_average === 'number') {
        dailyAverage = salesVolumeData.daily_average;
      } else if (salesVolumeData.daily_average && salesVolumeData.daily_average.units !== undefined) {
        dailyAverage = salesVolumeData.daily_average.units;
      }

      var last7Days = 0;
      var last7DaysChange = 0;
      if (salesVolumeData.last_7_days) {
        last7Days = salesVolumeData.last_7_days.units || 0;
        last7DaysChange = salesVolumeData.last_7_days.percentage_change || 0;
      } else if (salesVolumeData.seven_day_change) {
        last7Days = salesVolumeData.seven_day_change.units || 0;
        last7DaysChange = salesVolumeData.seven_day_change.percentage || 0;
      }

      var estMonthlyRevenue = 0;
      if (salesVolumeData.estimated_monthly_revenue) {
        estMonthlyRevenue = salesVolumeData.estimated_monthly_revenue.dollars || 0;
      }

      return {
        dailyAverage: dailyAverage,
        last7Days: last7Days,
        last7DaysChange: last7DaysChange,
        estMonthlyRevenue: estMonthlyRevenue,
        chartData: (salesVolumeData.chart_data || []).map(function (item) {
          return {
            date: item.date || item.formatted_date || '',
            units: item.units || 0
          };
        })
      };
    },
    handleRecentEventsPeriodChange: function handleRecentEventsPeriodChange(days) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var productId, recentEventsResponse, recentEventsData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.recentEventsDays = days;

                if (!(!_this2.product || !_this2.product.id)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                productId = _this2.product.id;
                _context2.next = 7;
                return _this2.$http.get('/api/v1/products/' + productId + '/recent_events?days=' + days);

              case 7:
                recentEventsResponse = _context2.sent;
                recentEventsData = recentEventsResponse.body;

                if (_this2.product) {
                  _this2.$set(_this2.product, 'recentEvents', _this2.transformRecentEvents(recentEventsData && recentEventsData.events));
                }
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](3);

                console.error('Error loading recent events:', _context2.t0);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 12]]);
      }))();
    },
    transformRecentEvents: function transformRecentEvents(events) {
      if (!events || !Array.isArray(events)) {
        return [];
      }

      return events.map(function (event) {
        return {
          type: this.mapEventType(event.type),
          title: event.message || 'Event occurred',
          timeAgo: this.formatTimeAgo(event.timestamp)
        };
      }.bind(this));
    },
    transformAccountHealth: function transformAccountHealth(accountHealthData) {
      if (!accountHealthData) {
        return {
          allMetricsHealthy: false,
          metrics: [],
          message: 'Account health data not available'
        };
      }

      var allMetricsHealthy = accountHealthData.status === 'healthy';

      var metrics = [];
      if (accountHealthData.metrics && Array.isArray(accountHealthData.metrics)) {
        metrics = accountHealthData.metrics.map(function (metric) {
          return {
            name: metric.name || 'Unknown Metric',
            value: metric.value || 'N/A',
            threshold: metric.target || 'N/A',
            status: metric.status || 'unknown',
            rawValue: metric.raw_value
          };
        });
      }

      return {
        allMetricsHealthy: allMetricsHealthy,
        metrics: metrics,
        message: accountHealthData.message || (allMetricsHealthy ? 'All Metrics Healthy - No issues affecting Buy Box eligibility' : 'Some metrics need attention'),
        status: accountHealthData.status || 'unknown',
        lastUpdated: accountHealthData.last_updated || null,
        dataSource: accountHealthData.data_source || null
      };
    },
    mapEventType: function mapEventType(type) {
      var typeMap = {
        'buybox_lost': 'lost',
        'buybox_won': 'won',
        'competitor_price_drop': 'price-drop',
        'price_change': 'price-change',
        'inventory_change': 'inventory',
        'review_health': 'review-health'
      };
      return typeMap[type] || 'info';
    },
    formatTimeAgo: function formatTimeAgo(timestamp) {
      var now = new Date();
      var eventTime = new Date(timestamp);
      var diffMs = now - eventTime;
      var diffSec = Math.floor(diffMs / 1000);
      var diffMin = Math.floor(diffSec / 60);
      var diffHr = Math.floor(diffMin / 60);
      var diffDay = Math.floor(diffHr / 24);

      if (diffMin < 1) return 'just now';
      if (diffMin < 60) return diffMin + ' minute' + (diffMin > 1 ? 's' : '') + ' ago';
      if (diffHr < 24) {
        var remainingMin = diffMin % 60;
        return diffHr + ' hour' + (diffHr > 1 ? 's' : '') + ' ' + remainingMin + ' minute' + (remainingMin !== 1 ? 's' : '') + ' ago';
      }
      return diffDay + ' day' + (diffDay > 1 ? 's' : '') + ' ago';
    },
    mapStatusType: function mapStatusType(status) {
      if (!status) return 'lost';
      var statusLower = status.toLowerCase();
      if (statusLower.includes('suppress')) return 'suppressed';
      if (statusLower.includes('lost')) return 'lost';
      if (statusLower.includes('contest')) return 'contested';
      if (statusLower.includes('won') || statusLower.includes('win')) return 'won';
      return 'lost';
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'mapEventType', function mapEventType(type) {
    var typeMap = {
      'buybox_lost': 'lost',
      'buybox_won': 'won',
      'competitor_price_drop': 'price-drop',
      'price_change': 'price-change',
      'inventory_change': 'inventory',
      'review_health': 'review-health'
    };
    return typeMap[type] || 'info';
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'formatTimeAgo', function formatTimeAgo(timestamp) {
    var now = new Date();
    var eventTime = new Date(timestamp);
    var diffMs = now - eventTime;
    var diffSec = Math.floor(diffMs / 1000);
    var diffMin = Math.floor(diffSec / 60);
    var diffHr = Math.floor(diffMin / 60);
    var diffDay = Math.floor(diffHr / 24);

    if (diffMin < 1) return 'just now';
    if (diffMin < 60) return diffMin + ' minute' + (diffMin > 1 ? 's' : '') + ' ago';
    if (diffHr < 24) {
      var remainingMin = diffMin % 60;
      return diffHr + ' hour' + (diffHr > 1 ? 's' : '') + ' ' + remainingMin + ' minute' + (remainingMin !== 1 ? 's' : '') + ' ago';
    }
    return diffDay + ' day' + (diffDay > 1 ? 's' : '') + ' ago';
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handlePriceUpdate', function handlePriceUpdate(newPrice) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var productId;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              productId = _this3.$route.query.id;
              _context3.next = 4;
              return _this3.loadProductData();

            case 4:

              console.log('Price updated successfully to:', newPrice);

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.error('Error updating price:', _context3.t0);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'updateTimeAgo', function updateTimeAgo() {
    if (!this.lastUpdateTime) {
      this.lastUpdated = 'just now';
      return;
    }

    var now = Date.now();
    var diff = Math.floor((now - this.lastUpdateTime) / 1000);

    if (diff < 60) {
      this.lastUpdated = diff + 's ago';
    } else if (diff < 3600) {
      var minutes = Math.floor(diff / 60);
      this.lastUpdated = minutes + 'm ago';
    } else {
      var hours = Math.floor(diff / 3600);
      this.lastUpdated = hours + 'h ago';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'startTimer', function startTimer() {
    var _this4 = this;

    this.lastUpdateTime = Date.now();
    this.lastUpdated = 'just now';

    this.timerInterval = setInterval(function () {
      _this4.updateTimeAgo();
    }, 1000);
  }), _methods),
  mounted: function mounted() {
    this.startTimer();
    this.loadProductData();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },

  watch: {
    '$route.query.id': {
      handler: function handler() {
        this.loadProductData();
      }
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      reds: {},
      ambers: {},
      stockReds: {},
      stockAmbers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],

      currentPage: 0,
      itemsPerPage: 20
    };
  },
  props: [],
  methods: {
    toMonth: function toMonth(m) {
      return { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }[m];
    },
    salesCountTotal: function salesCountTotal(productIds, t) {
      var _this = this;

      var getSales = function getSales(id) {
        var product = _this.$parent.$parent.worldStore.products[id];
        if (product && product.salesToday !== undefined && product.salesYesterday !== undefined) {
          return {
            today: product.salesToday,
            yesterday: product.salesYesterday
          };
        }
        return null;
      };
      if (t === 'y') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).yesterday : 0);
      }, 0);
      if (t === 't') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).today : 0);
      }, 0);
    },
    showProductDetails: function showProductDetails(productId) {
      this.$parent.openProductDetailModal(this.sortedUnfoldedProductsIDs, this.sortedUnfoldedProductsIDs.indexOf(productId));
    },
    starCalc: function starCalc(r, m) {
      if (r === null || r === undefined || isNaN(r)) {
        return m === 'f' ? 0 : m === 'h' ? 0 : m === 'e' ? 5 : 0;
      }
      var div = Math.floor(r / 10);
      var mod = r % 10;
      if (m === 'f') return Math.max(0, mod <= 7 ? div : div + 1);
      if (m === 'h') return Math.abs(mod - 5) <= 2 ? 1 : 0;
      if (m === 'e') return Math.max(0, 5 - div - (mod > 2 ? 1 : 0));
    },
    calc: function calc(worldStore) {
      var _this2 = this;

      if (!worldStore || !worldStore.products) {
        console.warn('ProductList: worldStore or products is null/undefined');
        this.groupedProducts = [];
        this.productGroupIds = [];
        return;
      }

      var productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products);
      var productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products);
      var productGroupIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroupId2productIds);

      if (worldStore.reds && worldStore.ambers) {
        this.reds = worldStore.reds;
        this.ambers = worldStore.ambers;
      } else {
        var amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
        var redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId);
        this.reds = redErrorCount.byProductGroupId;
        this.ambers = amberErrorCount.byProductGroupId;
      }

      var stockAmberErrorCount = worldStore.watchDogs && worldStore.watchDogs.inventory ? this.getWDErrorCount(productGroupIds, 1, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId) : { byProductGroupId: {}, byProductId: {} };
      var stockRedErrorCount = worldStore.watchDogs && worldStore.watchDogs.inventory ? this.getWDErrorCount(productGroupIds, 2, worldStore.watchDogs.inventory, worldStore.products, productId2ProductGroupId) : { byProductGroupId: {}, byProductId: {} };
      this.stockReds = stockRedErrorCount.byProductGroupId;
      this.stockAmbers = stockAmberErrorCount.byProductGroupId;

      var productGroupId2products = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        var productGroupId = productGroupIds[i];
        var productIdsForProductGroupId = productGroupId2productIds[productGroupId];
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId) ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(function (p) {
          return p.productId;
        }), productGroupId2productIds[productGroupId]) : productIdsForProductGroupId.sort(function (a, b) {
          var redA = _this2.reds[a] || 0;
          var redB = _this2.reds[b] || 0;
          var amberA = _this2.ambers[a] || 0;
          var amberB = _this2.ambers[b] || 0;
          var compResult = redB - redA;
          if (compResult !== 0) return compResult;
          return amberB - amberA;
        })).map(function (pid) {
          return worldStore.products[pid];
        });
      }
      this.productGroupId2products = productGroupId2products;
      this.productGroupIds = productGroupIds.sort(function (a0, b0) {
        var a = productGroupId2products[a0][0];
        var b = productGroupId2products[b0][0];
        var compResult = b.marketplace.localeCompare(a.marketplace);
        if (compResult !== 0) return compResult;
        return a.productTitle.localeCompare(b.productTitle);
      });
      var sortedUnfoldedProductsIDs = [];
      for (var _i = 0; _i < this.productGroupIds.length; ++_i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[_i]].map(function (p) {
          return p.productId;
        }));
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs;
      this.groupedProducts = this.productGroupIds.map(function (pgid) {
        var products = _this2.productGroupId2products[pgid];
        return products && products.length > 0 ? products[0] : null;
      }).filter(function (p) {
        return p !== null;
      });
    },
    getProductGroupId2productIds: function getProductGroupId2productIds(products) {
      var productGroupId2productIds = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];
        if (productGroupId2productIds[product.productGroupId]) {
          productGroupId2productIds[product.productGroupId].push(product.productId);
        } else {
          productGroupId2productIds[product.productGroupId] = [product.productId];
        }
      }
      return productGroupId2productIds;
    },
    getProductId2ProductGroupId: function getProductId2ProductGroupId(products) {
      var result = {};
      var productValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(products);
      for (var i = 0; i < productValues.length; ++i) {
        var product = productValues[i];
        result[product.productId] = product.productGroupId;
      }
      return result;
    },
    getErrorCount: function getErrorCount(productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      var productIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(products);
      var errorCountByProductGroupId = {};
      var errorCountByProductId = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      }
      for (var _i2 = 0; _i2 < productIds.length; ++_i2) {
        errorCountByProductId[productIds[_i2]] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      }
      var watchDogKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(watchDogs);
      for (var _i3 = 0; _i3 < watchDogKeys.length; ++_i3) {
        var fullKey = watchDogKeys[_i3];
        var watchDog = watchDogs[fullKey];
        var watchDogName = fullKey.split('_')[0];
        if (watchDog.status === 20 || watchDog.status === 21) continue;

        var items = [watchDog];
        for (var j = 0; j < items.length; ++j) {
          var item = items[j];
          if (Array.isArray(item)) {
            for (var k = 0; k < item.length; ++k) {
              var item0 = item[k];
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName);
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName);
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName);
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                errorCountByProductGroupId[item.productGroupId].add(watchDogName);
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName);
              }
              if (item.productId) {
                errorCountByProductId[item.productId].add(watchDogName);
              }
            }
          }
        }
      }
      var resultByProductId = {};
      var resultByProductGroupId = {};
      for (var _i4 = 0; _i4 < productIds.length; ++_i4) {
        resultByProductId[productIds[_i4]] = errorCountByProductId[productIds[_i4]].size;
      }
      for (var _i5 = 0; _i5 < productGroupIds.length; ++_i5) {
        resultByProductGroupId[productGroupIds[_i5]] = errorCountByProductGroupId[productGroupIds[_i5]].size;
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId
      };
    },
    getWDErrorCount: function getWDErrorCount(productGroupIds, issueStatus, watchDog, products, productId2ProductGroupId) {
      var productIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(products);
      var errorCountByProductGroupId = {};
      var errorCountByProductId = {};
      for (var i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = 0;
      }
      for (var _i6 = 0; _i6 < productIds.length; ++_i6) {
        errorCountByProductId[productIds[_i6]] = 0;
      }

      var items = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(watchDog.items);
      for (var j = 0; j < items.length; ++j) {
        var item = items[j];
        if (Array.isArray(item)) {
          for (var k = 0; k < item.length; ++k) {
            var item0 = item[k];
            if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
              if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                errorCountByProductGroupId[item0.productGroupId]++;
              } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item0.productId]]++;
              }
              if (item0.productId) {
                errorCountByProductId[item0.productId]++;
              }
            }
          }
        } else {
          if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
            if (item.productGroupId) {
              errorCountByProductGroupId[item.productGroupId]++;
            } else if (item.productId && productId2ProductGroupId[item.productId]) {
              errorCountByProductGroupId[productId2ProductGroupId[item.productId]]++;
            }
            if (item.productId) {
              errorCountByProductId[item.productId]++;
            }
          }
        }
      }

      return {
        byProductId: errorCountByProductId,
        byProductGroupId: errorCountByProductGroupId
      };
    },
    addKeepingOrder: function addKeepingOrder(base0, addition0) {
      var base = base0 || [];
      var addition = addition0 || [];
      var result = [];
      for (var i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i]);
      }
      var addition2 = [];
      for (var _i7 = 0; _i7 < addition.length; ++_i7) {
        if (base.indexOf(addition[_i7]) < 0) addition2.push(addition[_i7]);
      }
      var addition3 = addition2.sort();
      for (var _i8 = 0; _i8 < addition3.length; ++_i8) {
        result.push(addition3[_i8]);
      }
      return result;
    },

    prevPage: function prevPage() {
      console.log('ProductList prevPage: currentPage before:', this.currentPage);
      if (this.currentPage > 0) {
        this.currentPage--;
        console.log('ProductList prevPage: currentPage after:', this.currentPage);
      }
    },
    nextPage: function nextPage() {
      console.log('ProductList nextPage: currentPage before:', this.currentPage, 'totalPages:', this.totalPages);
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
        console.log('ProductList nextPage: currentPage after:', this.currentPage);
      }
    },
    goToPage: function goToPage(page) {
      console.log('ProductList goToPage:', page, 'totalPages:', this.totalPages);
      if (page >= 0 && page < this.totalPages) {
        this.currentPage = page;
        console.log('ProductList goToPage: currentPage set to:', this.currentPage);
      }
    },
    getPageNumber: function getPageNumber(index) {
      if (this.totalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, this.currentPage - 2);
      var endPage = Math.min(this.totalPages - 1, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(0, endPage - 4);
      }

      return startPage + index - 1;
    }
  },
  computed: {
    getCardsLayoutSize: function getCardsLayoutSize() {
      var n = this.productGroupIds.length;
      var w = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).width();

      if (n > 4) return w > 1320 ? 'five' : 'four';
      if (n === 4) return w > 1220 ? 'four' : 'three';else return w > 1440 ? 'four' : 'three';
    },

    totalItems: function totalItems() {
      var _this3 = this;

      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        return 0;
      }

      var filteredProducts = this.groupedProducts.filter(function (product) {
        if (!product) return false;
        return (_this3.$parent.filterByMarket.length === 0 || _this3.$parent.filterByMarket.indexOf(product.marketplace) >= 0) && (_this3.$parent.filterBySellAcc.length === 0 || _this3.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0);
      });
      var total = filteredProducts.length;
      console.log('ProductList totalItems (filtered):', total);
      return total;
    },
    totalPages: function totalPages() {
      var pages = Math.ceil(this.totalItems / this.itemsPerPage);
      console.log('ProductList totalPages:', pages, 'itemsPerPage:', this.itemsPerPage);
      return pages;
    },
    paginatedProducts: function paginatedProducts() {
      var _this4 = this;

      if (!this.groupedProducts || !Array.isArray(this.groupedProducts)) {
        console.warn('ProductList: groupedProducts is not an array');
        return [];
      }

      var filteredProducts = this.groupedProducts.filter(function (product) {
        if (!product) return false;
        return (_this4.$parent.filterByMarket.length === 0 || _this4.$parent.filterByMarket.indexOf(product.marketplace) >= 0) && (_this4.$parent.filterBySellAcc.length === 0 || _this4.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0);
      });

      var start = this.currentPage * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      var result = filteredProducts.slice(start, end);

      console.log('ProductList paginatedProducts:', result.length, 'currentPage:', this.currentPage, 'start:', start, 'end:', end);
      console.log('ProductList groupedProducts full array length:', this.groupedProducts.length);
      console.log('ProductList filteredProducts length:', filteredProducts.length);
      return result;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).find('.circular[data-content]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' });
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#darkbackgr').stop().fadeOut(200);
  },
  watch: {
    '$parent.$parent.worldStore': {
      handler: function handler(worldStore) {
        this.calc(worldStore);
      },
      deep: true
    }
  },
  created: function created() {
    if (this.$parent.$parent.worldStore) {
      this.calc(this.$parent.$parent.worldStore);
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_listViewUrlSync_js__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTableView',
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      currentPage: 0,
      itemsPerPage: 20,
      cogsModalProduct: null,
      cogsInput: '',
      savingCogs: false
    };
  },

  computed: {
    totalItems: function totalItems() {
      return this.products.length;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    startItem: function startItem() {
      return this.currentPage * this.itemsPerPage + 1;
    },
    endItem: function endItem() {
      return Math.min((this.currentPage + 1) * this.itemsPerPage, this.totalItems);
    },
    paginatedProducts: function paginatedProducts() {
      var start = this.currentPage * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      return this.products.slice(start, end);
    },
    visiblePages: function visiblePages() {
      var pages = [];
      var maxVisible = 5;
      var startPage = Math.max(0, this.currentPage - 2);
      var endPage = Math.min(this.totalPages - 1, startPage + maxVisible - 1);

      if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(0, endPage - maxVisible + 1);
      }

      for (var i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    formatPrice: function formatPrice(price) {
      if (!price && price !== 0) return '0.00';
      return parseFloat(price).toFixed(2);
    },
    calculateMargin: function calculateMargin(product) {
      if (!product.cogs || !product.buyBoxPrice || product.buyBoxPrice === 0) return 0;
      var margin = (product.buyBoxPrice - product.cogs) / product.buyBoxPrice * 100;
      return margin.toFixed(0);
    },
    calculateMarginFromCogs: function calculateMarginFromCogs(cogs, buyBoxPrice) {
      if (!cogs || !buyBoxPrice || buyBoxPrice === 0) return '0';
      var margin = (buyBoxPrice - cogs) / buyBoxPrice * 100;
      return margin.toFixed(0);
    },
    getMarginClass: function getMarginClass(margin) {
      var m = parseFloat(margin);
      if (m > 20) return 'margin-good';
      if (m >= 15) return 'margin-ok';
      return 'margin-poor';
    },
    salesCountTotal: function salesCountTotal(productIds, t) {
      var _this = this;

      var getSales = function getSales(id) {
        var product = _this.$parent.$parent.$parent.worldStore.products[id];
        if (product && product.salesToday !== undefined && product.salesYesterday !== undefined) {
          return {
            today: product.salesToday,
            yesterday: product.salesYesterday
          };
        }
        return null;
      };
      if (t === 'y') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).yesterday : 0);
      }, 0);
      if (t === 't') return productIds.reduce(function (prevVal, id) {
        return prevVal + (getSales(id) !== null ? getSales(id).today : 0);
      }, 0);
      return 0;
    },
    showProductDetails: function showProductDetails(productId) {
      var cleanId = String(productId).replace(/^PROD-/i, '');
      this.$router.push({ path: '/product_details', query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(cleanId, this.$route.fullPath) });
    },
    openCogsModal: function openCogsModal(product) {
      this.cogsModalProduct = product;
      this.cogsInput = product.cogs ? String(product.cogs) : '';
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tableCogsModal').modal('show');
    },
    saveCogs: function saveCogs() {
      var _this2 = this;

      if (!this.cogsModalProduct || !this.cogsInput) return;

      var cogsValue = parseFloat(this.cogsInput);
      if (isNaN(cogsValue) || cogsValue < 0) {
        alert('Please enter a valid COGS amount');
        return;
      }

      this.savingCogs = true;
      var productId = this.cogsModalProduct.productId;
      var cleanId = String(productId).replace(/^PROD-/i, '');

      this.$http.put('/api/v1/products/' + cleanId, {
        cogs: cogsValue
      }).then(function (response) {
        if (_this2.$parent.$parent.$parent.worldStore && _this2.$parent.$parent.$parent.worldStore.products) {
          _this2.$set(_this2.$parent.$parent.$parent.worldStore.products[productId], 'cogs', cogsValue);
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tableCogsModal').modal('hide');
        _this2.savingCogs = false;
        _this2.cogsModalProduct = null;
        _this2.cogsInput = '';
      }, function (response) {
        _this2.savingCogs = false;
        var errorMsg = response.body && response.body.error ? response.body.error : 'Failed to save COGS';
        alert('Error: ' + errorMsg);
      });
    },
    openChartModal: function openChartModal(product) {
      this.$emit('open-chart', product);
    },
    prevPage: function prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    nextPage: function nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
      }
    },
    goToPage: function goToPage(page) {
      this.currentPage = page;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tableCogsModal').modal({
        onHide: function onHide() {
          _this3.cogsModalProduct = null;
          _this3.cogsInput = '';
        }
      });
    });
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var nowDateString = new Date(Date.now()).toISOString().split('T')[0];
    return {
      includeAllProducts: false,
      emails: [],
      rangeDays: 90,
      rangeDateFrom: nowDateString,
      rangeDateTo: nowDateString,
      sendPhase: null,
      urlSlug: {
        'sales': 'SALES'
      }
    };
  },
  props: ['chartLastLoadedAt', 'product', 'variant'],
  methods: {
    send: function send() {
      var _this = this;

      if (Number(this.rangeDays) === -1) {
        if (String(this.rangeDateFrom).match(/^20\d{2}-[01]\d-[0123]\d$/) === null || String(this.rangeDateTo).match(/^20\d{2}-[01]\d-[0123]\d$/) === null) {
          this.sendPhase = 'DATE_INPUT_ERROR';
          setTimeout(function () {
            if (_this.sendPhase === 'DATE_INPUT_ERROR') _this.sendPhase = '';
          }, 3000);
          return;
        } else {
          this.sendPhase = '';
        }
      }

      this.sendPhase = 'IN_PROGRESS';
      this.$http.post('/api/order/spreadsheet/v1.2/' + this.urlSlug[this.variant] + '/email-request', {
        productGroupId: this.includeAllProducts ? null : this.product.productGroupId,
        lookbackDays: this.rangeDays,
        rangeDateFrom: this.rangeDateFrom,
        rangeDateTo: this.rangeDateTo,
        emailAddresses: this.selectedEmailAddresses
      }).then(function (resp) {
        _this.sendPhase = 'OK_FRESH';
        setTimeout(function () {
          if (_this.sendPhase === 'OK_FRESH') _this.sendPhase = 'OK';
        }, 5000);
      }, function (resp) {
        _this.sendPhase = resp.status === 429 ? 'TOO_MANY_REQUESTS' : 'FAILED';
      });
    },
    init: function init() {
      this.$http.get('/api/identity/email-addresses').then(function (resp) {
        this.emails = resp.body.filter(function (e) {
          return e.isVerified;
        }).map(function (e) {
          return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(e, { selected: false });
        });
        if (this.emails.length === 1) this.emails[0].selected = true;
      }, function (resp) {
        console.log(resp);
      });
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#downloadSpreadsheetAccordion' + this.variant).accordion('refresh');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#emailsDropdown').dropdown();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).find('.message .close').click(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.message').hide(200);
    });
  },
  watch: {
    'chartLastLoadedAt': function chartLastLoadedAt(val) {
      this.init();
      this.includeAllProducts = false;
    }
  },
  computed: {
    selectedEmailAddresses: function selectedEmailAddresses() {
      return this.emails.filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.email;
      });
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WatchdogItem__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WatchdogItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WatchdogItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_AmazonChoiceBadgeConfig__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_AmazonChoiceBadgeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__settings_AmazonChoiceBadgeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_StarRatingRecentChangeConfig__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_StarRatingRecentChangeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__settings_StarRatingRecentChangeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings_CategoryChangeConfig__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings_CategoryChangeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__settings_CategoryChangeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings_BestSellerBadgeConfig__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings_BestSellerBadgeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__settings_BestSellerBadgeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__settings_ListingSuspendedConfig__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__settings_ListingSuspendedConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__settings_ListingSuspendedConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settings_SpreadsheetConfig__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settings_SpreadsheetConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__settings_SpreadsheetConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings_ProductDetailsRecentChangeConfig__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings_ProductDetailsRecentChangeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__settings_ProductDetailsRecentChangeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__settings_FBAFeeChangeConfig__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__settings_FBAFeeChangeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__settings_FBAFeeChangeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__settings_StoreFrontWhiteListConfig__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__settings_StoreFrontWhiteListConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__settings_StoreFrontWhiteListConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__settings_SubscribeAndSaveConfig__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__settings_SubscribeAndSaveConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__settings_SubscribeAndSaveConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__settings_ParentProductChangeConfig__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__settings_ParentProductChangeConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__settings_ParentProductChangeConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PartnerBanner__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PartnerBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__PartnerBanner__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    WatchdogItem: __WEBPACK_IMPORTED_MODULE_3__WatchdogItem___default.a, AmazonChoiceBadgeConfig: __WEBPACK_IMPORTED_MODULE_4__settings_AmazonChoiceBadgeConfig___default.a, StarRatingRecentChangeConfig: __WEBPACK_IMPORTED_MODULE_5__settings_StarRatingRecentChangeConfig___default.a, CategoryChangeConfig: __WEBPACK_IMPORTED_MODULE_6__settings_CategoryChangeConfig___default.a, BestSellerBadgeConfig: __WEBPACK_IMPORTED_MODULE_7__settings_BestSellerBadgeConfig___default.a, ListingSuspendedConfig: __WEBPACK_IMPORTED_MODULE_8__settings_ListingSuspendedConfig___default.a, SpreadsheetConfig: __WEBPACK_IMPORTED_MODULE_9__settings_SpreadsheetConfig___default.a, ProductDetailsRecentChangeConfig: __WEBPACK_IMPORTED_MODULE_10__settings_ProductDetailsRecentChangeConfig___default.a, FBAFeeChangeConfig: __WEBPACK_IMPORTED_MODULE_11__settings_FBAFeeChangeConfig___default.a, StoreFrontWhiteListConfig: __WEBPACK_IMPORTED_MODULE_12__settings_StoreFrontWhiteListConfig___default.a, SubscribeAndSaveConfig: __WEBPACK_IMPORTED_MODULE_13__settings_SubscribeAndSaveConfig___default.a, ParentProductChangeConfig: __WEBPACK_IMPORTED_MODULE_14__settings_ParentProductChangeConfig___default.a, PartnerBanner: __WEBPACK_IMPORTED_MODULE_15__PartnerBanner___default.a
  },
  data: function data() {
    return {
      wdInfo: {
        'badSellerFeedback': { 'name': 'Bad Seller Feedback', 'desc': 'Alert if there is new recent bad seller feedback.', 'ccf': '2 hours' },
        'listingSuspended': { 'name': 'Suspended Listings', 'desc': 'Check if Amazon indicates a problem with a listing.', 'ccf': '10 minutes' },
        'lostBuybox': { 'name': 'Buy-box', 'desc': 'Alert if the buybox is lost to another seller.', 'ccf': '30 minutes' },
        'salesDrop': { 'name': 'Sales Volume', 'desc': 'Alert if there is a sharp drop in the sales volume. Warn if sales are slowly decreasing over a few days.', 'ccf': '30 minutes' },
        'imageMissing': { 'name': 'Main Image', 'desc': 'Alert if main image of the product had been taken down.', 'ccf': '30 minutes' },
        'starRatingRecentChange': { 'name': 'Star Rating Change', 'desc': 'Alert if rating changes by half a star. Optional: warn on every 0.1 change too.', 'ccf': '2.5 hours' },
        'badReview': { 'name': 'Latest Reviews 1', 'desc': 'Alert when there is bad review in the Latest Reviews section at #1-#3. Warn when there is bad review at #4-#10.', 'ccf': '2 hours' },
        'topReview': { 'name': 'Top Rated Reviews', 'desc': 'Alert when there is bad review in the Top Rated Reviews section at #1-#3. Warn when there is bad review at #4-#10.', 'ccf': '4 hours' },
        'noAddToCart': { 'name': 'Add-to-Cart Button', 'desc': 'Alert if there is no add to cart button on the listing.', 'ccf': '30 minutes' },
        'keyword': { 'name': 'Search Rank', 'desc': 'Alert if the Search Rank for a given Keyword falls below a treshold', 'ccf': '6 hours' },
        'productDetailsRecentChange': { 'name': 'Product Details Change', 'desc': 'Track the Title, Image, Bulletpoints, Description, Dimension and Weight changes of a product.', 'ccf': '30 minutes' },
        'numberOfSellers': { 'name': 'Hijacker Alert', 'desc': 'Monitor the number of active sellers on a listing.', 'ccf': '15 minutes' },
        'bestSellerBadge': { 'name': 'Best Seller Badge', 'desc': 'Monitor whether the product has the Best Seller Badge in one of its categories.', 'ccf': '30 minutes' },
        'productCategoryRecentChange': { 'name': 'Main/Sub-Cat Change', 'desc': 'Alert when the sub-category or the main category of a product has changed', 'ccf': '1.5 hours' },
        'price': { 'name': 'Price Change', 'desc': 'Alert when another seller has a lower price than you.', 'ccf': '15 minutes' },
        'searchBan': { 'name': 'Search Result Suppression', 'desc': 'Alert when the product does not appear in the search results.', 'ccf': '3 hours' },
        'inventory': { 'name': 'FBA Stock', 'desc': 'Alert when the product goes low on stock.', 'ccf': '90 minutes' },
        'fbmInventory': { 'name': 'FBM Stock', 'desc': 'Alert when the product goes low on stock.', 'ccf': '90 minutes' },
        'fbaFeeChange': { 'name': 'FBA Fee Change', 'desc': 'Alert when the latest orders\' FBA Fee changed', 'ccf': '1 day' },
        'prime': { 'name': 'Prime badge', 'desc': 'Monitor whether the product has a Prime Badge', 'ccf': '30 minutes' },
        'amazonChoiceBadge': { 'name': 'Amazon\'s choice badge', 'desc': 'Monitor whether the product has an Amazon\'s choice badge', 'ccf': '30 minutes' },
        'subscribeAndSave': { 'name': 'Subscribe and Save', 'desc': 'Monitor whether the product has a Subscribe and Save option', 'ccf': '30 minutes' },
        'parentProductChange': { 'name': 'Parent Product Change', 'desc': 'Alert when the parent product has changed', 'ccf': '31 minutes' },
        'adultClassification': { 'name': 'Adult Classification', 'desc': 'Alert when Amazon classifies the listing as adult, or removes that classification', 'ccf': '30 minutes' },
        'reviewHealth': { 'name': 'Review Health', 'desc': 'Alert when the star rating or rating count drops, or new critical reviews come in. Checked once a day from Amazon\'s review data, which runs 1–2 days behind.', 'ccf': '1 day' }
      },
      groupByParent: this.wdtype === 'badReview' || this.wdtype === 'topReview' || this.wdtype === 'keyword' || this.wdtype === 'starRatingRecentChange' || this.wdtype === 'inventory' || this.wdtype === 'fbmInventory',
      accountLevelWd: this.wdtype === 'listingSuspended' || this.wdtype === 'badSellerFeedback',
      ishovered: false,
      currentTab: 99,
      muteRingAni: false,
      tabsToDisplay: ['ok', 'red', 'mute'],
      wdl: {
        ok: { color: 'green', listcolor: { 0: 'green', 99: 'grey' }, listicon: 'check', icon: 'checkmark', bpos: 'bottom left', sortfn: function sortfn(i) {
            return (i.status === 99 || i.status === 0) && !i.muted;
          }, blurb: 'Products without issues' },
        red: { color: 'red', listcolor: { 1: 'orange', 2: 'red' }, listicon: 'warning circle', icon: 'alarm', bpos: 'bottom center', sortfn: function sortfn(i) {
            return (i.status === 1 || i.status === 2) && !i.muted && i.issueStatus < 3;
          }, blurb: 'Issues needing attention' },
        amber: { color: 'orange', listcolor: { 1: 'orange' }, listicon: 'warning circle', icon: 'alarm', bpos: 'bottom center', sortfn: function sortfn(i) {
            return i.status === 1 && !i.muted && i.issueStatus < 3;
          }, blurb: 'Issues needing attention' },
        mute: { color: 'blue', listcolor: { 1: 'blue', 2: 'blue' }, listicon: 'triangle', icon: 'mute alarm outline', bpos: 'bottom right', sortfn: function sortfn(i) {
            return i.issueStatus === 3 && (i.status === 1 || i.status === 2) || i.muted;
          }, blurb: '- Issues marked as Done<br>&nbsp;&nbsp;<small>and</small><br>- Muted Products' }
      },
      emailAlertIndicator: this.wd.alertsEnabled,
      filterString: '',
      filterCategory: '',
      dimTimeOutObj: null,
      topShader: false,
      bottomShader: false,
      markAllSeenInProgress: false,
      showConfiguration: false,
      isConfigurable: ['starRatingRecentChange', 'productCategoryRecentChange', 'bestSellerBadge', 'listingSuspended', 'inventory', 'fbmInventory', 'productDetailsRecentChange', 'salesDrop', 'fbaFeeChange', 'numberOfSellers', 'lostBuybox', 'amazonChoiceBadge', 'subscribeAndSave', 'parentProductChange'].indexOf(this.wdtype) >= 0,
      hoveredForSomeTime: false,
      hoveredForALittle: false,
      showSuppressedMsg: false,
      tooltipX: 0,
      tooltipY: 0,

      currentPage: 0,
      itemsPerPage: 10

    };
  },

  props: ['wdtype', 'wd', 'detSel', 'nth', 'scrollIntoView', 'suppressedWatchdogs'],
  computed: {
    isSuppressed: function isSuppressed() {
      var backendType = this.toBackendEnumFormat(this.wdtype);
      var result = Array.isArray(this.suppressedWatchdogs) && this.suppressedWatchdogs.includes(backendType);
      console.log('[Watchdog] wdtype:', this.wdtype, 'as backendType:', backendType, 'suppressedWatchdogs:', this.suppressedWatchdogs, 'isSuppressed:', result);
      return result;
    },

    wdSorted: function wdSorted() {
      var _this = this;

      var wdArr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.wd.items);
      var wds = {};

      for (var i in this.tabsToDisplay) {
        if (this.groupByParent) {
          wds[this.tabsToDisplay[i]] = this.groupify(wdArr).filter(this.wdl[this.tabsToDisplay[i]].sortfn);
        } else {
          wds[this.tabsToDisplay[i]] = wdArr.filter(this.wdl[this.tabsToDisplay[i]].sortfn);
        }

        if (this.$parent.filterBySellAcc.length > 0) wds[this.tabsToDisplay[i]] = wds[this.tabsToDisplay[i]].filter(function (i) {
          return _this.$parent.filterBySellAcc.indexOf(i.sellerId) >= 0;
        });

        if (this.$parent.filterByMarket.length > 0) wds[this.tabsToDisplay[i]] = wds[this.tabsToDisplay[i]].filter(function (i) {
          return _this.$parent.filterByMarket.indexOf(i.marketplace) >= 0;
        });

        if (!this.accountLevelWd) {
          var products = this.$parent.$parent.worldStore.products;
          wds[this.tabsToDisplay[i]].sort(function (a, b) {
            var prodA = a.productId && products[a.productId] ? products[a.productId] : null;
            var prodB = b.productId && products[b.productId] ? products[b.productId] : null;
            var titleA = prodA && prodA.productTitle ? prodA.productTitle : '';
            var titleB = prodB && prodB.productTitle ? prodB.productTitle : '';
            return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
          });

          if (this.tabsToDisplay[i] === 'red') wds[this.tabsToDisplay[i]].sort(function (a, b) {
            return b.status - a.status;
          });
        }
      }
      return wds;
    },
    newAlertCount: function newAlertCount() {
      return this.wdSorted['red'].reduce(function (prevVal, item) {
        return prevVal + (item.issueStatus === 0 && !item.muted ? 1 : 0);
      }, 0);
    },
    muteCount: function muteCount() {
      return this.wdSorted['mute'].reduce(function (prevVal, item) {
        return prevVal + (item.muted ? 1 : 0);
      }, 0);
    },
    showPartnerCards: {
      get: function get() {
        return this.$parent.showPartnerCards;
      },
      set: function set() {
        this.$parent.showPartnerCards = false;
      }
    },

    totalItems: function totalItems() {
      return this.filteredResults(this.wdSorted[this.tabsToDisplay[this.currentTab]]).length;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    paginatedItems: function paginatedItems() {
      var filteredItems = this.filteredResults(this.wdSorted[this.tabsToDisplay[this.currentTab]]);
      var start = this.currentPage * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      return filteredItems.slice(start, end);
    }
  },
  created: function created() {
    if (this.wdSorted['red'].length > 0 || this.wdSorted['mute'].length - this.muteCount > 0) this.currentTab = 1;
    this.$parent.wdNewErrorCounts[this.wdtype] = this.newAlertCount;
    this.$parent.wdMenuUpdateTrigger = this.wdtype + this.newAlertCount;
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('a[data-html]').popup({ delay: { show: 500, hide: 0 }, transition: 'fade' });
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.ui.dropdown').dropdown({
      onChange: function onChange(value) {
        _this2.filterCategory = value;
      }
    });
    console.log('[DEPLOY TEST] Watchdog.vue loaded at', new Date());
    console.log('[Watchdog] prop suppressedWatchdogs from parent:', this.suppressedWatchdogs);
  },
  watch: {
    suppressedWatchdogs: function suppressedWatchdogs(val) {
      console.log('[Watchdog] suppressedWatchdogs changed:', val);
    },

    detSel: function detSel(val) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.wdTabC').attr('style', this.setWDCHeight());
    },
    wd: function wd() {
      if (!this.ishovered && (this.wdSorted['red'].length > 0 || this.wdSorted['mute'].length - this.muteCount > 0)) this.currentTab = 1;
      this.emailAlertIndicator = this.wd.alertsEnabled;
    },
    currentTab: function currentTab() {},
    filterString: function filterString() {},
    filterCategory: function filterCategory() {},

    newAlertCount: function newAlertCount() {
      this.$parent.wdNewErrorCounts[this.wdtype] = this.newAlertCount;
      this.$parent.wdMenuUpdateTrigger = this.wdtype + this.newAlertCount;
    }
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      if (this.isSuppressed) {
        this.showSuppressedMsg = true;
      }
    },
    handleMouseMove: function handleMouseMove(event) {
      if (this.isSuppressed) {
        this.tooltipX = event.clientX + 15;
        this.tooltipY = event.clientY + 15;
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      this.showSuppressedMsg = false;
      this.hoverState(false);
    },
    toBackendEnumFormat: function toBackendEnumFormat(str) {
      return str.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
    },

    markAllSeen: function markAllSeen(wdtype) {
      var _this3 = this;

      var watchDogIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.wd.items).filter(function (i) {
        return (i.status === 1 || i.status === 2) && !i.muted && i.issueStatus === 0;
      }).map(function (i) {
        return i.watchDogId;
      }));
      if (watchDogIds.size > 0) {
        var timestamp = Date.now();
        this.$parent.$parent.stateChangeRequestInFlight.add(timestamp);
        this.markAllSeenInProgress = true;
        this.$http.put('/api/sentinel/watchdog/bulk-set-issue-status', { issueStatus: 1, watchDogIds: watchDogIds }).then(function (response) {
          var items = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this3.wd.items);
          for (var i = 0; i < items.length; ++i) {
            var item = items[i];
            if (watchDogIds.has(item.watchDogId)) item.issueStatus = 1;
          }
          _this3.markAllSeenInProgress = false;
          _this3.$parent.$parent.stateChangeRequestInFlight.delete(timestamp);
        }, function (response) {
          _this3.markAllSeenInProgress = false;
          _this3.$parent.$parent.stateChangeRequestInFlight.delete(timestamp);
        });
      }
    },
    setCurrentTab: function setCurrentTab(i) {
      this.currentTab = i;this.$parent.$parent.onboarder('wdtabs');
    },

    filteredResults: function filteredResults(arr) {
      var _this4 = this;

      if (this.filterString === '' && this.filterCategory === '' || this.accountLevelWd || this.wdtype === 'keywords') return arr;else {
        var cat = Number(this.filterCategory);
        return arr.filter(function (item) {
          if (cat > 0 && _this4.currentTab === 1) {
            if (cat < 3 && item.issueStatus !== cat) return false;
            if (cat >= 3 && item.status !== cat - 2) return false;
          }
          return _this4.$parent.$parent.worldStore.products[item.productId].productTitle.toLowerCase().indexOf(_this4.filterString.toLowerCase()) >= 0 || _this4.$parent.$parent.worldStore.products[item.productId].productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, '$1').toLowerCase().indexOf(_this4.filterString.toLowerCase()) >= 0;
        });
      }
    },
    fixScrolling: function fixScrolling(e) {
      if (!this.hoveredForSomeTime) return;
      var t = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.wdTabC');
      if (t.innerHeight() === t.get(0).scrollHeight) return;
      if (e.wheelDelta > 0 && t.scrollTop() === 0) {
        e.preventDefault();
      } else {
        if (e.wheelDelta < 0 && t.scrollTop() === t.get(0).scrollHeight - t.innerHeight()) {
          e.preventDefault();
        }
      }
    },
    setInnerShaders: function setInnerShaders(e) {
      var t = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.wdTabC');
      this.topShader = t.scrollTop() > 3;
      this.bottomShader = t.get(0).scrollHeight - t.innerHeight() - 5 >= t.scrollTop();
    },
    setWDCHeight: function setWDCHeight() {
      if (this.detSel === 'wc') return 'height:240px;';
      if (this.currentTab === 99) return '';
      var n = this.wdSorted[this.tabsToDisplay[this.currentTab]].length;
      return 'height:' + (n > 4 ? '525' : n * 130 + 20) + 'px;';
    },
    groupify: function groupify(a) {
      var seen = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      return a.filter(function (item) {
        return !item.productGroupId && !item.productCollectionId || (!item.productGroupId || seen.has(item.productGroupId) ? false : seen.add(item.productGroupId)) || (!item.productCollectionId || seen.has(item.productCollectionId) ? false : seen.add(item.productCollectionId));
      });
    },
    hoverState: function hoverState(state) {
      var _this5 = this;

      if (this.ishovered === state) return;
      if (this.$parent.dashboardIsAnimating === true) return;
      this.ishovered = state;

      if (this.ishovered) setTimeout(function () {
        if (_this5.ishovered) __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this5.$el).find('.wdTabC').css('overflow-y', 'auto');
      }, 800);else __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('.wdTabC').css('overflow-y', 'hidden');

      if (this.ishovered) setTimeout(function () {
        if (_this5.ishovered) _this5.hoveredForSomeTime = true;
      }, 2000);else this.hoveredForSomeTime = false;

      if (this.scrollIntoView) setTimeout(function () {
        if (_this5.ishovered) _this5.scrollIntoViewIfOutOfView(_this5.$el);
      }, 500);

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).css('z-index', 99);
      if (state) setTimeout(function () {
        if (_this5.ishovered) __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#darkbackgr').stop().fadeIn(1200);
      }, 2000);else __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#darkbackgr').stop().fadeOut(500);
      clearTimeout(this.dimTimeOutObj);
      if (!state) this.dimTimeOutObj = setTimeout(function () {
        return __WEBPACK_IMPORTED_MODULE_2_jquery___default()(_this5.$el).css('z-index', 0);
      }, 500);
    },
    scrollIntoViewIfOutOfView: function scrollIntoViewIfOutOfView(el) {
      var topOfPage = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var heightOfPage = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var elH = el.offsetHeight;
      if (elH > heightOfPage) return null;
      var elY = 0;
      for (var p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) {
        elY += p.offsetTop;
      }

      if (topOfPage + heightOfPage < elY + elH && this.nth !== 0) {
        this.stopScrollAniOnUserEvent();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').stop().animate({ scrollTop: elY - heightOfPage + elH + 30 }, 700, this.releaseUserEventListener);
      } else if (elY < topOfPage) {
        this.stopScrollAniOnUserEvent();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').stop().animate({ scrollTop: elY - 30 }, 700, this.releaseUserEventListener);
      } else __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').stop();
    },
    stopScrollAniOnUserEvent: function stopScrollAniOnUserEvent() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').on('scroll wheel DOMMouseScroll mousewheel touchmove', function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').stop();
      });
    },
    releaseUserEventListener: function releaseUserEventListener() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body,html').off('scroll wheel DOMMouseScroll mousewheel touchmove');
    },
    doMuteRingAni: function doMuteRingAni() {
      var _this6 = this;

      this.muteRingAni = true;
      setTimeout(function () {
        _this6.muteRingAni = false;
      }, 1100);
    },
    isWatchdogTypeSuppressed: function isWatchdogTypeSuppressed(wdt) {
      var backendType = this.toBackendEnumFormat(wdt);
      var result = Array.isArray(this.suppressedWatchdogs) && this.suppressedWatchdogs.includes(backendType);
      return result;
    },

    prevPage: function prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    nextPage: function nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
      }
    },
    goToPage: function goToPage(page) {
      if (page >= 0 && page < this.totalPages) {
        this.currentPage = page;
      }
    },
    getPageNumber: function getPageNumber(index) {
      if (this.totalPages <= 5) {
        return index - 1;
      }

      var startPage = Math.max(0, this.currentPage - 2);
      var endPage = Math.min(this.totalPages - 1, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(0, endPage - 4);
      }

      return startPage + index - 1;
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imageLoaded: false
    };
  },
  props: ['item', 'itemtype', 'itemprops', 'wdtype', 'groupByParent', 'detSel'],
  methods: {
    muteItem: function muteItem(m) {
      var _this = this;

      if (this.itemtype !== 'mute') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).fadeOut(600, function () {
          _this.$emit('muteRingAni');
          _this.item.muted = !_this.item.muted;
        });
      } else {
        this.item.muted = !this.item.muted;
      }
      var timestamp = Date.now();
      this.$parent.$parent.$parent.stateChangeRequestInFlight.add(timestamp);
      this.$http.post('/api/sentinel/watchdog/' + (m < 1 ? 'un' : '') + 'mute/' + this.item.watchDogId, {
        minutes: m
      }).then(function (response) {
        _this.$parent.$parent.$parent.stateChangeRequestInFlight.delete(timestamp);

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this.$el).find('.mutemenu').html('...').fadeIn(300);

        _this.$parent.$parent.$parent.stateOfTheWorld();
      }, function (response) {
        _this.$parent.$parent.$parent.stateChangeRequestInFlight.delete(timestamp);

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this.$el).find('.mutemenu').fadeIn(300);
      });
    },
    setIssueStatus: function setIssueStatus(val) {
      var _this2 = this;

      if (val === 3 && this.itemtype !== 'mute') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).fadeOut(600, function () {
          _this2.$emit('muteRingAni');
          _this2.$parent.$parent.$parent.setIssueStatus(_this2.item.watchDogId, val);
        });
      } else {
        this.$parent.$parent.$parent.setIssueStatus(this.item.watchDogId, val);
      }
    },
    showProductDetails: function showProductDetails() {
      if (this.item.productId !== null) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).popup('hide all');
        this.$parent.$parent.openProductDetailModal([this.item.productId], 0);
      }
    },
    getMarketplaceFlag: function getMarketplaceFlag(item) {
      if (!item || !item.marketplace) return 'flag';
      var marketplace = item.marketplace.toLowerCase();
      var isEU = item.productCollectionId && ['uk', 'de', 'fr', 'es', 'it'].indexOf(marketplace) > -1;
      return (isEU ? 'eu' : marketplace.replace('uk', 'gb')) + ' flag';
    },
    getProductTitle: function getProductTitle(productId) {
      var products = this.$parent.$parent.$parent.worldStore.products;
      if (!products) return '(Product data unavailable)';

      if (productId && products[productId]) {
        return products[productId].productTitle || '';
      }

      var item = this.item;
      if (item && item.productGroupId) {
        if (products[item.productGroupId]) {
          return products[item.productGroupId].productTitle || '';
        }

        var productKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(products);
        for (var i = 0; i < productKeys.length; i++) {
          var prod = products[productKeys[i]];
          if (prod && (prod.productGroupId === item.productGroupId || prod.id === item.productGroupId)) {
            return prod.productTitle || '';
          }
        }
      }

      return '';
    },
    prettyfyReviewText: function prettyfyReviewText(t) {
      if (!t) return '';
      return t.replace(/;|(and)/gi, ' <small style=\'color:grey;\'>&nbsp;&nbsp;&amp;&nbsp;&nbsp;</small>').replace(/(#\d+)/gi, '<span style=\'color:purple;\'>$1</span>').replace(/(\d)-star/gi, '<span style=\'color:orange;\'>$1&#9733;</span>');
    },
    prettyfyRatingText: function prettyfyRatingText(t) {
      if (!t) return '';
      return t.replace(/star rating is ([45][.0-9]*),?/gi, 'is <span style=\'color:orange;\'>$1&#9733;</span>').replace(/star rating is ([123][.0-9]*),?/gi, 'is <span style=\'color:darkred;\'>$1&#9733;</span>').replace(/(\d+) (rating|review)/gi, '<span style=\'color:purple;\'>$1</span> $2').replace(/(review|rating) count is (\d+)/gi, ' <small style=\'color:grey;\'>&nbsp;&nbsp;&amp;&nbsp;&nbsp;</small> $1 count is <span style=\'color:purple;\'>$2</span>');
    },
    qqq: function qqq(q) {
      window.alert(q);
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('.circular[data-content], .ui.dropdown span[data-html]').popup({ delay: { show: 0, hide: 0 }, transition: 'fade' });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).find('.ui.dropdown').dropdown({ action: 'hide' });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          _this3.imageLoaded = true;
          observer.disconnect();
        }
      }, { threshold: 0.1 });
      observer.observe(this.$el);
    } else {
      this.imageLoaded = true;
    }
  },
  watch: {}
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wdInfo: [{ 'icon': 'warehouse', 'id': 'inventory', 'name': 'FBA Stock', 'padding': '0 3px' }, { 'icon': 'warehouse', 'id': 'fbmInventory', 'name': 'FBM Stock', 'padding': '0 3px' }, { 'icon': 'unordered list', 'id': 'productDetailsRecentChange', 'name': 'Product Details Change', 'padding': '5px 6px 0 6px' }, { 'icon': 'image', 'id': 'imageMissing', 'name': 'Main Image', 'padding': '0 6px' }, { 'icon': 'unordered list', 'id': 'productCategoryRecentChange', 'name': 'Category Change', 'padding': '0 6px' }, { 'icon': 'trophy', 'id': 'bestSellerBadge', 'name': 'Best Seller Badge', 'padding': '0 5px' }, { 'icon': 'check', 'id': 'prime', 'name': 'Prime Badge', 'padding': '0 7px' }, { 'icon': 'bookmark', 'id': 'amazonChoiceBadge', 'name': 'Amazon\'s choice Badge', 'padding': '0 7px' }, { 'icon': 'sync', 'id': 'subscribeAndSave', 'name': 'Subscribe And Save', 'padding': '0 5px' }, { 'icon': 'sitemap', 'id': 'parentProductChange', 'name': 'Parent Product Change', 'padding': '0 5px' }, { 'icon': 'eye slash', 'id': 'adultClassification', 'name': 'Adult Classification', 'padding': '0 5px' }, { 'icon': 'dollar sign', 'id': 'price', 'name': 'Price Change', 'padding': '0px 11px 0px 8px' }, { 'icon': 'user secret', 'id': 'numberOfSellers', 'name': 'Hijacker Alert', 'padding': '0px 7px 0px 7px' }, { 'icon': 'add to cart', 'id': 'lostBuybox', 'name': 'Buy-box', 'padding': '0px 7px 0px 2px' }, { 'icon': 'add to cart', 'id': 'noAddToCart', 'name': 'Add-to-Cart Button', 'padding': '0px 7px 0px 2px' }, { 'icon': 'line chart', 'id': 'salesDrop', 'name': 'Sales Volume', 'padding': '0 6px' }, { 'icon': 'dolly flatbed', 'id': 'fbaFeeChange', 'name': 'FBA Fee Change', 'padding': '0px 3px 0px 1px' }, { 'icon': 'warning sign', 'id': 'listingSuspended', 'name': 'Suspended Listings', 'padding': '0 5px' }, { 'icon': 'search minus', 'id': 'searchBan', 'name': 'Search Result Suppression', 'padding': '0 5px' }, { 'icon': 'comment alternate', 'id': 'badReview', 'name': 'Latest Reviews', 'padding': '0 4px' }, { 'icon': 'comment alternate', 'id': 'topReview', 'name': 'Top Rated Reviews', 'padding': '0 4px' }, { 'icon': 'star', 'id': 'starRatingRecentChange', 'name': 'Star Rating', 'padding': '0 4px 0 5px' }, { 'icon': 'comment alternate outline', 'id': 'badSellerFeedback', 'name': 'Bad Seller Fback', 'padding': '0 5px' }]
    };
  },
  props: ['wdNewErrorCounts', 'wdMenuUpdateTrigger'],
  methods: {
    scrollTo: function scrollTo(wdtype) {
      var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-wdtype=' + wdtype + ']')[0];

      var heightOfPage = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var elH = el.offsetHeight;
      var elY = 0;for (var p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) {
        elY += p.offsetTop;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body,html').stop().animate({ scrollTop: elY - (heightOfPage - elH) / 2 }, 450);
    },
    isMenuEntryVisible: function isMenuEntryVisible(wdtype) {
      try {
        return this.$parent.$parent.worldStore.watchDogs[wdtype].status !== 21;
      } catch (err) {
        return true;
      }
    }
  },

  mounted: function mounted() {},
  watch: {
    wdnewerrorcounts: function wdnewerrorcounts() {
      console.log('valt');
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_BuyBoxOwnershipCard_css__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_BuyBoxOwnershipCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_BuyBoxOwnershipCard_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyBoxOwnershipCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_subscriptionBilling__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CanceledLockoutOverlay',
  props: {
    stripOffsetPx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    overlayStyle: function overlayStyle() {
      return { top: this.stripOffsetPx + 'px' };
    },
    copy: function copy() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_subscriptionBilling__["k" /* canceledLockoutCopyFromSummary */])(this.$root.subscriptionSummary);
    }
  },
  methods: {
    signOut: function signOut() {
      if (this.$root.signOutUser) {
        this.$root.signOutUser();
      }
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardSidebar_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DashboardSidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrialStrip_vue__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrialStrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TrialStrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrialLockoutOverlay_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrialLockoutOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TrialLockoutOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CanceledLockoutOverlay_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CanceledLockoutOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CanceledLockoutOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PastDueLockoutOverlay_vue__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PastDueLockoutOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PastDueLockoutOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_billingUpgrade__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__ = __webpack_require__(92);












var BILLING_PATH = '/settings/billing';
var STRIP_HEIGHT = 40;
var VERIFY_STRIP_PATH_PREFIXES = ['/home', '/products', '/stock', '/fee-claims', '/settings'];

function pathShowsVerifyStrip(path) {
  if (!path) return false;
  for (var i = 0; i < VERIFY_STRIP_PATH_PREFIXES.length; i++) {
    var p = VERIFY_STRIP_PATH_PREFIXES[i];
    if (path === p || path.indexOf(p + '/') === 0) return true;
  }
  return false;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardLayout',
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue___default.a,
    DashboardSidebar: __WEBPACK_IMPORTED_MODULE_1__DashboardSidebar_vue___default.a,
    TrialStrip: __WEBPACK_IMPORTED_MODULE_2__TrialStrip_vue___default.a,
    TrialLockoutOverlay: __WEBPACK_IMPORTED_MODULE_3__TrialLockoutOverlay_vue___default.a,
    CanceledLockoutOverlay: __WEBPACK_IMPORTED_MODULE_4__CanceledLockoutOverlay_vue___default.a,
    PastDueLockoutOverlay: __WEBPACK_IMPORTED_MODULE_5__PastDueLockoutOverlay_vue___default.a
  },
  props: {
    lastUpdated: {
      type: String,
      default: 'just now'
    }
  },
  data: function data() {
    return {
      trialStripDismissed: false
    };
  },
  computed: {
    sidebarItems: function sidebarItems() {
      var items = [{ id: 'home', label: 'Dashboard', icon: 'th icon', path: '/home' }, { id: 'products', label: 'Products', icon: 'bookmark icon', path: '/products' }, { id: 'issues', label: 'Alerts', icon: 'bell icon', path: '/issues' }, { id: 'stock', label: 'Stock', icon: 'cube icon', path: '/stock' }];

      if (this.$root.feeClaims) {
        var count = this.$root.feeClaimsToClaimCount;
        items.push({ id: 'feeClaims', label: 'Fee Claims', icon: 'dollar sign icon', path: '/fee-claims', badgeCount: count > 0 ? count : null });
      }
      items.push({ id: 'settings', label: 'Settings', icon: 'setting icon', path: '/settings' });
      return items;
    },
    onboardingComplete: function onboardingComplete() {
      var root = this.$parent && this.$parent.$parent && this.$parent.$parent.$parent;
      return root && root.onboardingStatus ? root.onboardingStatus.completed : true;
    },
    subscriptionSummary: function subscriptionSummary() {
      return this.$root.subscriptionSummary || null;
    },
    billingContext: function billingContext() {
      return {
        hasDailyPricing: this.$root.hasDailyPricing,
        billingUserTypeRaw: this.$root.billingUserTypeRaw,
        billingSummary: this.$root.billingSummary,
        packageDetails: this.$root.billingPackageDetails,
        tenantId: this.$root.tenantId
      };
    },
    trialStripContent: function trialStripContent() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__["d" /* shouldShowTrialStrip */])(this.subscriptionSummary, this.trialStripDismissed, this.billingContext)) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__["e" /* trialStripContentFromSummary */])(this.subscriptionSummary, this.billingContext);
    },
    hasTrialStripVisible: function hasTrialStripVisible() {
      return this.trialStripContent != null;
    },
    hasVerifyStripVisible: function hasVerifyStripVisible() {
      return this.$root.emailVerified === false && pathShowsVerifyStrip(this.$route.path);
    },
    verifyStripContent: function verifyStripContent() {
      if (!this.hasVerifyStripVisible) return null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__["h" /* verifyEmailStripContent */])({
        email: this.$root.unverifiedEmail || this.$root.userEmail,
        verificationEmailSent: this.$root.verificationEmailSent,
        verificationEmailSending: this.$root.verificationEmailSending
      });
    },
    topStripHeight: function topStripHeight() {
      var n = (this.hasVerifyStripVisible ? 1 : 0) + (this.hasTrialStripVisible ? 1 : 0);
      return n * STRIP_HEIGHT;
    },
    hasTopStrips: function hasTopStrips() {
      return this.topStripHeight > 0;
    },
    cancelLockoutActive: function cancelLockoutActive() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__["f" /* shouldShowCanceledLockout */])(this.subscriptionSummary, this.$root.paymentStatus);
    },
    billingPaymentModalFlowActive: function billingPaymentModalFlowActive() {
      return !!(this.$root && this.$root.billingPaymentModalFlowActive);
    },
    pastDueLockoutActive: function pastDueLockoutActive() {
      if (this.billingPaymentModalFlowActive) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__["g" /* shouldShowPastDueLockout */])(this.subscriptionSummary, this.billingContext);
    },
    trialLockoutActive: function trialLockoutActive() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_subscriptionBilling__["h" /* shouldShowTrialLockout */])(this.subscriptionSummary, this.billingContext);
    },
    subscriptionLockoutActive: function subscriptionLockoutActive() {
      if (this.billingPaymentModalFlowActive) return false;
      return this.cancelLockoutActive || this.pastDueLockoutActive || this.trialLockoutActive;
    }
  },
  watch: {
    '$route.path': function $routePath() {
      this.enforceSubscriptionLockoutRoute();
    },
    '$route.hash': function $routeHash() {
      this.enforceSubscriptionLockoutRoute();
    },
    subscriptionLockoutActive: function subscriptionLockoutActive(active) {
      if (active) this.enforceSubscriptionLockoutRoute();
    },
    '$root.paymentStatus': function $rootPaymentStatus() {
      if (this.subscriptionLockoutActive) {
        this.enforceSubscriptionLockoutRoute();
      }
    },
    subscriptionSummary: function subscriptionSummary() {
      if (this.subscriptionLockoutActive) {
        this.enforceSubscriptionLockoutRoute();
      }
    },
    '$root.authCompleted': function $rootAuthCompleted(done) {
      if (done) this.ensureEmailVerificationLoaded();
    },
    '$root.userEmail': function $rootUserEmail(email) {
      if (email) this.ensureEmailVerificationLoaded();
    },
    '$root.feeClaims': function $rootFeeClaims(on) {
      if (on && this.$root.loadFeeClaimsCount) this.$root.loadFeeClaimsCount();
    }
  },
  mounted: function mounted() {
    var self = this;
    var schedule = this.$root.scheduleAfterFirstPaint ? this.$root.scheduleAfterFirstPaint.bind(this.$root) : function (fn) {
      setTimeout(fn, 50);
    };
    schedule(function () {
      self.ensureBillingContextOnRoot();
      if (self.$root.loadSubscriptionSummary) {
        self.$root.loadSubscriptionSummary();
      }
      self.ensureEmailVerificationLoaded();
      if (self.$root.feeClaims && self.$root.loadFeeClaimsCount) self.$root.loadFeeClaimsCount();
    });
    this._onVisibilityChange = function () {
      if (document.visibilityState === 'visible') {
        self.ensureEmailVerificationLoaded(true);
      }
    };
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    this.enforceSubscriptionLockoutRoute();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
  },
  methods: {
    ensureEmailVerificationLoaded: function ensureEmailVerificationLoaded(force) {
      var root = this.$root;
      if (!root || !root.loadEmailVerificationStatus) return;
      if (!force && root.emailVerified != null) return;
      if (!root.userEmail && !root.authCompleted) return;
      root.loadEmailVerificationStatus(!!force);
    },
    ensureBillingContextOnRoot: function ensureBillingContextOnRoot() {
      var root = this.$root;
      if (!root) return;
      if (root.billingUserTypeRaw != null) {
        this.ensureEmailVerificationLoaded();
        return;
      }
      if (!root.loadIdentitySettings) {
        this.ensureEmailVerificationLoaded();
        return;
      }
      root.loadIdentitySettings().then(function () {
        if (root.loadEmailVerificationStatus && root.emailVerified == null) {
          root.loadEmailVerificationStatus();
        }
      }, function () {
        if (root.loadEmailVerificationStatus && root.emailVerified == null) {
          root.loadEmailVerificationStatus();
        }
      });
    },
    isBillingPath: function isBillingPath(path) {
      if (!path) return false;
      return path === BILLING_PATH || path.indexOf(BILLING_PATH + '/') === 0;
    },
    billingLockoutTarget: function billingLockoutTarget() {
      return BILLING_PATH;
    },
    enforceSubscriptionLockoutRoute: function enforceSubscriptionLockoutRoute() {
      if (!this.subscriptionLockoutActive) return;
      var target = this.billingLockoutTarget;
      if (this.$route.fullPath === target) return;
      if (!this.pastDueLockoutActive && this.isBillingPath(this.$route.path)) return;
      this.$router.replace(target);
    },
    navigateTo: function navigateTo(path) {
      if (this.subscriptionLockoutActive && !this.isBillingPath(path)) {
        this.$router.push(this.billingLockoutTarget);
        return;
      }
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    onVerifyStripCta: function onVerifyStripCta() {
      var self = this;
      if (!this.$root.resendEmailVerification) {
        if (this.$route.path !== __WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__["i" /* ACCOUNT_SETTINGS_PATH */]) {
          this.$router.push(__WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__["i" /* ACCOUNT_SETTINGS_PATH */]);
        }
        return;
      }
      this.$root.resendEmailVerification().then(function () {}, function () {
        if (self.$route.path !== __WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__["i" /* ACCOUNT_SETTINGS_PATH */]) {
          self.$router.push(__WEBPACK_IMPORTED_MODULE_8__utils_emailVerification__["i" /* ACCOUNT_SETTINGS_PATH */]);
        }
      });
    },
    onTrialStripCta: function onTrialStripCta(hash) {
      var content = this.trialStripContent;
      if (content && content.ctaAction === 'resume' && this.$root.resumeSubscription) {
        var self = this;
        this.$root.resumeSubscription().then(function () {
          if (self.$route.path !== BILLING_PATH) {
            self.$router.push(BILLING_PATH);
          }
        }, function () {
          if (self.$route.path !== BILLING_PATH) {
            self.$router.push(BILLING_PATH);
          }
        });
        return;
      }
      if (hash === '#payment-method') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_billingUpgrade__["a" /* requestOpenBillingPaymentModal */])(this);
        return;
      }
      var target = BILLING_PATH + (hash || '');
      if (this.$route.fullPath !== target) {
        this.$router.push(target);
      }
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_DashboardSidebar_css__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_DashboardSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_DashboardSidebar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_orderVolumeBilling_js__ = __webpack_require__(48);






var brandAssets = __webpack_require__(97);
var logoShieldIcon = brandAssets.logoShieldIcon;

var iconMap = {
  home: {
    white: __webpack_require__(615),
    grey: __webpack_require__(614)
  },
  products: {
    white: __webpack_require__(619),
    grey: __webpack_require__(618)
  },
  issues: {
    white: __webpack_require__(613),
    grey: __webpack_require__(612)
  },
  stock: {
    white: __webpack_require__(623),
    grey: __webpack_require__(622)
  },
  feeClaims: {
    white: __webpack_require__(617),
    grey: __webpack_require__(616)
  },
  settings: {
    white: __webpack_require__(621),
    grey: __webpack_require__(620)
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardSidebar',
  props: {
    items: {
      type: Array,
      required: true
    },
    currentPath: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      logoShieldIcon: logoShieldIcon,
      iconMap: iconMap
    };
  },
  computed: {
    mainNavItems: function mainNavItems() {
      return this.items.filter(function (item) {
        return item.id !== 'settings';
      });
    },
    isSettingsActive: function isSettingsActive() {
      return this.currentPath === '/settings' || this.currentPath.indexOf('/settings/') === 0;
    }
  },
  mounted: function mounted() {
    var self = this;
    var schedule = this.$root.scheduleAfterFirstPaint ? this.$root.scheduleAfterFirstPaint.bind(this.$root) : function (fn) {
      setTimeout(fn, 50);
    };
    schedule(function () {
      self.loadSidebarBillingContext();
    });
  },
  methods: {
    timezoneOffsetMinutes: function timezoneOffsetMinutes() {
      return 0 - new Date().getTimezoneOffset();
    },

    loadSidebarBillingContext: function loadSidebarBillingContext() {
      var self = this;
      if (this.$root.loadSubscriptionSummary) {
        this.$root.loadSubscriptionSummary();
      }
      var identityPromise = this.$root.loadIdentitySettings ? this.$root.loadIdentitySettings() : this.$http.get('/api/identity/settings').then(function (res) {
        return res.body || {};
      }, function () {
        return {};
      });
      identityPromise.then(function (body) {
        body = body || {};
        var tenantId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_orderVolumeBilling_js__["a" /* tenantIdFromIdentityBody */])(body);
        if (self.$root) {
          self.$root.tenantId = tenantId || self.$root.tenantId;
          self.$root.hasDailyPricing = !!body.dailyPricing;
          self.$root.billingUserTypeRaw = body.subscriptionBillingUserType || body.user_type || body.billingUserType || body.billing_user_type || self.$root.billingUserTypeRaw;
        }
      });
      var paymentPromise = this.$root.loadPaymentStatus ? this.$root.loadPaymentStatus() : this.$http.get('/api/billing/payment-status', {
        params: { timezoneOffsetMinutes: this.timezoneOffsetMinutes() }
      }).then(function (res) {
        return res.body || {};
      }, function () {
        return {};
      });
      paymentPromise.then(function (body) {
        body = body || {};
        if (!self.$root) return;
        self.$root.billingPackageDetails = body.packageDetails || null;
        var bsRaw = body.billingSummary || body.billing_summary || {};
        self.$root.billingSummary = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, bsRaw);
        var fromPayment = body.user_type || body.userType || body.subscriptionBillingUserType;
        if (fromPayment) self.$root.billingUserTypeRaw = fromPayment;
      });
    },
    onNavClick: function onNavClick(path) {
      if (this.disabled) return;
      this.$emit('navigate', path);
    },
    onNavHover: function onNavHover(item) {
      if (!item || item.path !== '/issues') return;
      if (this.currentPath === '/issues') return;
      if (this.$root && typeof this.$root.prefetchIssuesAlertCounts === 'function') {
        this.$root.prefetchIssuesAlertCounts();
      }
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TrialLockout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_subscriptionBilling__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__ = __webpack_require__(62);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PastDueLockoutOverlay',
  props: {
    stripOffsetPx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    overlayStyle: function overlayStyle() {
      return { top: this.stripOffsetPx + 'px' };
    },
    copy: function copy() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_subscriptionBilling__["j" /* pastDueLockoutCopyFromSummary */])(this.$root.subscriptionSummary);
    }
  },
  methods: {
    goUpdatePayment: function goUpdatePayment() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__["a" /* requestOpenBillingPaymentModal */])(this);
    },
    signOut: function signOut() {
      if (this.$root.signOutUser) {
        this.$root.signOutUser();
      }
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_PriorityIssuesList_css__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_PriorityIssuesList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_PriorityIssuesList_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PriorityIssuesList',
  props: {
    issues: {
      type: Array,
      required: true
    },
    needActionCount: {
      type: Number,
      default: 0
    },
    totalIssues: {
      type: Number,
      required: true
    },
    syncing: {
      type: Boolean,
      default: false
    },
    exporting: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getConfidenceDotClass: function getConfidenceDotClass(issue) {
      if (issue.confidenceLevel) {
        if (issue.confidenceLevel === 'high') return 'high';
        if (issue.confidenceLevel === 'medium') return 'medium';
        if (issue.confidenceLevel === 'low') return 'low';
      }

      if (issue.statusType === 'suppressed') return 'status-suppressed';
      if (issue.statusType === 'lost') return 'status-lost';
      if (issue.statusType === 'contested') return 'status-contested';
      if (issue.statusType === 'owned') return 'status-owned';
      return 'medium';
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_RevenueImpactCard_css__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_RevenueImpactCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_RevenueImpactCard_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RevenueImpactCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    reportingSymbol: function reportingSymbol() {
      return this.data && this.data.reportingCurrencySymbol || '$';
    }
  },
  methods: {
    formatCompactAmount: function formatCompactAmount(val) {
      var sym = this.reportingSymbol;
      var num = parseFloat(String(val).replace(/[^0-9.-]/g, ''));
      if (isNaN(num)) return sym + val;
      var abs = Math.abs(num);
      var sign = num < 0 ? '-' + sym : sym;
      var formatted;
      if (abs >= 1000000) {
        formatted = (abs / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      } else if (abs >= 1000) {
        var kVal = abs / 1000;
        formatted = (kVal >= 100 ? Math.round(kVal) : kVal.toFixed(1).replace(/\.0$/, '')) + 'K';
      } else {
        formatted = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(num) ? String(num) : num.toFixed(2);
      }
      return sign + formatted;
    },
    formatCompactValue: function formatCompactValue(val) {
      if (val == null) return '';
      var sym = this.reportingSymbol;
      var str = String(val).trim();
      var match = str.match(/(-?)\s*[^0-9-]*\s*([0-9,]+\.?[0-9]*)\s*([kKmM]?)/i);
      if (!match) return str.replace(/\$/g, sym);
      var sign = str.indexOf('-') >= 0 ? '-' + sym : sym;
      var num = parseFloat(match[2].replace(/,/g, ''));
      var suffix = (match[3] || '').toUpperCase();
      if (isNaN(num)) return val;
      if (suffix === 'K') num = num * 1000;
      if (suffix === 'M') num = num * 1000000;
      var abs = Math.abs(num);
      var formatted;
      if (abs >= 1000000) {
        formatted = (abs / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      } else if (abs >= 1000) {
        var kVal = abs / 1000;
        formatted = (kVal >= 100 ? Math.round(kVal) : kVal.toFixed(1).replace(/\.0$/, '')) + 'K';
      } else {
        formatted = abs >= 1 ? abs.toFixed(1).replace(/\.0$/, '') : abs.toFixed(2);
      }
      return sign + formatted;
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_StatusBreakdown_css__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_StatusBreakdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_StatusBreakdown_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusBreakdown',
  props: {
    statusData: {
      type: Array,
      required: true
    },
    activeType: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TopNavbar_css__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TopNavbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TopNavbar_css__);



var brandAssets = __webpack_require__(97);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopNavbar',
  data: function data() {
    return {
      sentrykitWordmark: brandAssets.sentrykitWordmark
    };
  },
  props: {
    lastUpdated: {
      type: String,
      default: 'just now'
    },
    userEmail: {
      type: String,
      default: ''
    }
  },
  methods: {
    signOut: function signOut() {
      if (this.$root.signOutUser) {
        this.$root.signOutUser();
      } else {
        this.$http.get('/api/auth/signout').then(function () {});
        document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        sessionStorage.removeItem('worldStore');
        this.$router.push('/login');
      }
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_TrialLockout_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_TrialLockout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_TrialLockout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_subscriptionBilling__ = __webpack_require__(26);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrialLockoutOverlay',
  props: {
    stripOffsetPx: {
      type: Number,
      default: 40
    }
  },
  data: function data() {
    return {
      busy: false,
      errorMessage: '',
      comparePlansOpen: false
    };
  },
  computed: {
    overlayStyle: function overlayStyle() {
      return { top: this.stripOffsetPx + 'px' };
    },
    selectedPlanKey: function selectedPlanKey() {
      var summary = this.$root.subscriptionSummary;
      var isPro = summary ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_subscriptionBilling__["l" /* isProPlanFromSummary */])(summary) : false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_subscriptionBilling__["m" /* displaySelectedPlanKeyFromContext */])(summary, isPro);
    }
  },
  methods: {
    goBilling: function goBilling(plan) {
      var path = '/settings/billing';
      var query = {};
      if (plan === 'starter') query.plan = 'starter';
      if (plan === 'pro') query.upgrade = 'pro';
      if (this.$route.path !== path || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query)) {
        this.$router.push({ path: path, query: query });
      }
    },
    startProUpgradeFlow: function startProUpgradeFlow() {
      var self = this;
      if (this.busy) return;
      this.busy = true;
      this.errorMessage = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__["b" /* resolveHasPaymentMethod */])(this).then(function (hasPm) {
        if (!hasPm) {
          self.busy = false;
          if (self.$root) self.$root.pendingUpgradePlan = 'pro';
          self.goBilling('pro');
          return;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__["c" /* upgradeSubscriptionToPro */])(self).then(function () {
          self.busy = false;
        }, function (res) {
          self.busy = false;
          var body = res && res.body;
          self.errorMessage = body && body.message || 'Upgrade failed. Add or update your payment method on billing.';
          if (self.$root) self.$root.pendingUpgradePlan = 'pro';
          self.goBilling('pro');
        });
      }, function () {
        self.busy = false;
        if (self.$root) self.$root.pendingUpgradePlan = 'pro';
        self.goBilling('pro');
      });
    },
    signOut: function signOut() {
      if (this.$root.signOutUser) {
        this.$root.signOutUser();
      }
    },
    openComparePlans: function openComparePlans() {
      this.comparePlansOpen = true;
    },
    closeComparePlans: function closeComparePlans() {
      this.comparePlansOpen = false;
    },
    onCompareSelectStarter: function onCompareSelectStarter() {
      this.closeComparePlans();
      this.startStarterUpgradeFlow();
    },
    startStarterUpgradeFlow: function startStarterUpgradeFlow() {
      var self = this;
      if (this.busy) return;
      this.busy = true;
      this.errorMessage = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__["b" /* resolveHasPaymentMethod */])(this).then(function (hasPm) {
        if (!hasPm) {
          self.busy = false;
          if (self.$root) self.$root.pendingUpgradePlan = 'starter';
          self.goBilling('starter');
          return;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_billingUpgrade__["d" /* upgradeSubscriptionToPlan */])(self, 'starter').then(function () {
          self.busy = false;
        }, function (res) {
          self.busy = false;
          var body = res && res.body;
          self.errorMessage = body && body.message || 'Upgrade failed. Add or update your payment method on billing.';
          if (self.$root) self.$root.pendingUpgradePlan = 'starter';
          self.goBilling('starter');
        });
      }, function () {
        self.busy = false;
        if (self.$root) self.$root.pendingUpgradePlan = 'starter';
        self.goBilling('starter');
      });
    },
    onCompareSelectPro: function onCompareSelectPro() {
      this.closeComparePlans();
      this.startProUpgradeFlow();
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialStrip_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_TrialStrip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_TrialStrip_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrialStrip',
  props: {
    content: {
      type: Object,
      default: null
    },
    offsetTop: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onCta: function onCta() {
      this.$emit('cta', this.content && this.content.ctaHash ? this.content.ctaHash : '');
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_AlertCategoriesSidebar_css__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_AlertCategoriesSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_AlertCategoriesSidebar_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertCategoriesSidebar',
  props: {
    alertCounts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activeCategory: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      groups: [{
        id: 'buybox',
        name: 'BUY BOX & PRICING',
        items: [{ id: 'lostBuybox', name: 'Buy Box Issues', icon: 'shopping bag' }, { id: 'price', name: 'Price Change', icon: 'dollar sign' }, { id: 'competitorPrice', name: 'Competitor Price', icon: 'balance scale' }, { id: 'competitivePrice', name: 'Competitive Price', icon: 'globe', tenantFlag: 'competitivePriceAlerts' }]
      }, {
        id: 'competitive',
        name: 'COMPETITIVE',
        items: [{ id: 'numberOfSellers', name: 'Hijacker Alert', icon: 'user secret' }]
      }, {
        id: 'listingHealth',
        name: 'LISTING HEALTH',
        items: [{ id: 'listingSuspended', name: 'Suspended Listings', icon: 'exclamation triangle' }, { id: 'searchBan', name: 'Search Suppression', icon: 'search minus' }, { id: 'reviewHealth', name: 'Review Health', icon: 'star half alternate' }]
      }, {
        id: 'productContent',
        name: 'PRODUCT CONTENT',
        items: [{ id: 'productDetailsRecentChange', name: 'Product Details Change', icon: 'file alternate' }, { id: 'imageMissing', name: 'Main Image', icon: 'image' }, { id: 'productCategoryRecentChange', name: 'Category Change', icon: 'folder open' }, { id: 'parentProductChange', name: 'Parent Product Change', icon: 'sitemap' }, { id: 'adultClassification', name: 'Adult Classification', icon: 'eye slash' }]
      }, {
        id: 'inventory',
        name: 'INVENTORY',
        items: [{ id: 'inventory', name: 'FBA Stock', icon: 'circle outline' }, { id: 'fbmInventory', name: 'FBM Stock', icon: 'warehouse' }, { id: 'salesDrop', name: 'Sales Volume', icon: 'chart line' }, { id: 'fbaFeeChange', name: 'FBA Fee Change', icon: 'dolly flatbed' }]
      }, {
        id: 'badges',
        name: 'BADGES',
        items: [{ id: 'bestSellerBadge', name: 'Best Seller Badge', icon: 'trophy' }, { id: 'prime', name: 'Prime Badge', icon: 'check' }]
      }]
    };
  },
  computed: {
    totalCount: function totalCount() {
      var counts = this.alertCounts || {};
      var total = 0;
      for (var g = 0; g < this.groups.length; g++) {
        var items = this.groups[g].items;
        for (var i = 0; i < items.length; i++) {
          if (!this.isVisible(items[i])) continue;
          var id = items[i].id;
          var n = counts[id];
          if (typeof n === 'number' && n > 0) total += n;
        }
      }
      return total;
    },
    totalCountClass: function totalCountClass() {
      var total = this.totalCount;
      if (total === 0) return 'count-ok';
      if (total >= 5) return 'count-alert';
      return 'count-warning';
    }
  },
  methods: {
    selectCategory: function selectCategory(id) {
      this.$emit('select', id === 'all' ? '' : id);
    },

    isVisible: function isVisible(item) {
      if (item.tenantFlag && !(this.$root && this.$root[item.tenantFlag] === true)) return false;
      var counts = this.alertCounts;
      if (counts && counts[item.id] === -1) return false;
      return true;
    },
    displayCount: function displayCount(id) {
      var count = this.alertCounts[id];
      if (count === undefined || count === null) return '\u2014';
      return count;
    },
    countClass: function countClass(id) {
      var count = this.alertCounts[id];
      if (count === undefined || count === null) return 'count-none';
      if (count === 0) return 'count-ok';
      if (count >= 5) return 'count-alert';
      return 'count-warning';
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__ = __webpack_require__(64);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertThresholdsInline',
  props: {
    item: { type: Object, default: null },

    productId: { type: [String, Number], default: null },

    sellerAccountId: { type: String, default: null },
    productTitle: { type: String, default: '' },
    marketplace: { type: String, default: '' },

    stockThresholdsApiBase: { type: String, default: '/api/v1/stock-alert-thresholds' },

    apiBaseUrl: { type: String, default: '/api/v1/watchdogs' }
  },
  data: function data() {
    return {
      form: {
        amberThreshold: null,
        redThreshold: null,
        amberDays: null,
        redDays: null,
        velocityLookbackDays: null
      },
      saving: false,
      saveError: null
    };
  },
  computed: {
    marketplaceLabel: function marketplaceLabel() {
      if (!this.marketplace) return '';
      var m = this.marketplace.toUpperCase();
      var map = { US: 'US', UK: 'UK', CA: 'CA', DE: 'DE', FR: 'FR', ES: 'ES', IT: 'IT', MX: 'MX', BR: 'BR', IN: 'IN', NL: 'NL' };
      return map[m] || m;
    },
    resolvedProductId: function resolvedProductId() {
      if (this.productId != null && this.productId !== '') return String(this.productId);
      return this.item ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(this.item) : '';
    }
  },
  watch: {
    item: {
      handler: function handler() {
        this.loadFromItemFallback();
      },
      immediate: true
    },
    productId: function productId() {
      this.loadFromItemFallback();
      this.hydrateFromStockApiSilent();
    }
  },
  mounted: function mounted() {
    this.hydrateFromStockApiSilent();
  },
  methods: {
    httpParams: function httpParams() {
      var p = {};
      if (this.sellerAccountId) p.seller_account_id = this.sellerAccountId;
      return p;
    },
    inputFilledClass: function inputFilledClass(v) {
      return v !== null && v !== undefined && v !== '' && !isNaN(Number(v)) ? 'has-value' : '';
    },

    loadFromItemFallback: function loadFromItemFallback() {
      var s = this.item && this.item.settings ? this.item.settings : {};
      function num(v) {
        var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["g" /* unwrapApiNumber */])(v);
        if (n === null) return null;
        return n >= 0 ? n : null;
      }
      function numPos(v) {
        var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["g" /* unwrapApiNumber */])(v);
        if (n === null) return null;
        return n > 0 ? n : null;
      }
      function val(a, b) {
        return a !== undefined && a !== null ? a : b;
      }
      this.form = {
        amberThreshold: num(val(s.amberThreshold, s.amber_threshold)),
        redThreshold: num(val(s.redThreshold, s.red_threshold)),
        amberDays: num(val(s.amberDays, s.amber_days)),
        redDays: num(val(s.redDays, s.red_days)),
        velocityLookbackDays: numPos(val(s.velocityLookbackDays, s.velocity_lookback_days))
      };
    },

    hydrateFromStockApiSilent: function hydrateFromStockApiSilent() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      var self = this;
      var base = this.stockThresholdsApiBase;
      var opts = function opts(extra) {
        return {
          params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.httpParams(), {
            channel: 'fba',
            product_ids: pid,
            _skcb: Date.now()
          }, extra || {}),
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
          timeout: 45000
        };
      };
      var apply = function apply(res) {
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["d" /* extractThresholdGetItems */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["c" /* httpResponseEntity */])(res));
        var i;
        for (i = 0; i < items.length; i++) {
          var row = items[i];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["a" /* productIdFromThresholdRow */])(row) !== pid) continue;
          var raw = row.settings;
          if (raw == null) raw = {};else if (typeof raw === 'string') {
            try {
              raw = JSON.parse(raw);
            } catch (e) {
              raw = {};
            }
          }
          var settings = (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw !== null ? raw : {};
          self.form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["h" /* formFieldsFromFbaSettings */])(settings);
          return;
        }
      };
      this.$http.get(base, opts()).then(function (res) {
        apply(res);
      }).catch(function (res) {
        if (res && res.status === 304) {
          return self.$http.get(base, opts({ _skretry: Date.now() })).then(function (res2) {
            apply(res2);
          });
        }
      });
    },
    toPayload: function toPayload() {
      var toVal = function toVal(v) {
        if (v === null || v === '' || v === undefined) return null;
        var n = Number(v);
        return isNaN(n) ? null : n;
      };
      var vel = this.form.velocityLookbackDays;
      var velocityLookbackDays = vel !== null && vel !== '' && !isNaN(Number(vel)) ? Number(vel) : null;
      return {
        amber_threshold: toVal(this.form.amberThreshold),
        red_threshold: toVal(this.form.redThreshold),
        amber_days: toVal(this.form.amberDays),
        red_days: toVal(this.form.redDays),
        velocity_lookback_days: velocityLookbackDays
      };
    },
    applySavedPayloadToItem: function applySavedPayloadToItem(settings) {
      var item = this.item;
      if (!item) return;
      if (!item.settings) this.$set(item, 'settings', {});
      var s = settings;
      if (Object.prototype.hasOwnProperty.call(s, 'amber_threshold')) {
        this.$set(item.settings, 'amber_threshold', s.amber_threshold);
        this.$set(item.settings, 'amberThreshold', s.amber_threshold);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'red_threshold')) {
        this.$set(item.settings, 'red_threshold', s.red_threshold);
        this.$set(item.settings, 'redThreshold', s.red_threshold);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'amber_days')) {
        this.$set(item.settings, 'amber_days', s.amber_days);
        this.$set(item.settings, 'amberDays', s.amber_days);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'red_days')) {
        this.$set(item.settings, 'red_days', s.red_days);
        this.$set(item.settings, 'redDays', s.red_days);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'velocity_lookback_days')) {
        this.$set(item.settings, 'velocity_lookback_days', s.velocity_lookback_days);
        this.$set(item.settings, 'velocityLookbackDays', s.velocity_lookback_days);
      }
    },
    save: function save() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      this.saving = true;
      this.saveError = null;
      var settings = this.toPayload();
      var body = {
        channel: 'fba',
        updates: [{ product_id: pid, settings: settings }]
      };
      var self = this;
      this.$http.patch(this.stockThresholdsApiBase, body, { params: this.httpParams(), timeout: 60000 }).then(function (res) {
        self.saving = false;
        var failed = res.body && res.body.failed;
        if (failed > 0) {
          self.saveError = 'Some updates failed. Check results from the server.';
          return;
        }
        self.applySavedPayloadToItem(settings);
        self.$emit('saved');
      }, function (err) {
        self.saving = false;
        self.saveError = err.body && err.body.message || err.statusText || 'Failed to save settings';
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__ = __webpack_require__(64);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FBMAlertThresholdsInline',
  props: {
    item: { type: Object, default: null },

    productId: { type: [String, Number], default: null },

    sellerAccountId: { type: String, default: null },
    productTitle: { type: String, default: '' },

    stockThresholdsApiBase: { type: String, default: '/api/v1/stock-alert-thresholds' },

    apiBaseUrl: { type: String, default: '/api/v1/watchdogs' }
  },
  data: function data() {
    return {
      form: {
        redThreshold: null
      },
      saving: false,
      saveError: null
    };
  },
  computed: {
    marketplaceLabel: function marketplaceLabel() {
      var m = this.item && this.item.marketplace ? this.item.marketplace.toUpperCase() : '';
      var map = { US: 'US', UK: 'UK', CA: 'CA', DE: 'DE', FR: 'FR', ES: 'ES', IT: 'IT', MX: 'MX', BR: 'BR', IN: 'IN', NL: 'NL' };
      return map[m] || m;
    },
    resolvedProductId: function resolvedProductId() {
      if (this.productId != null && this.productId !== '') return String(this.productId);
      return this.item ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(this.item) : '';
    },
    fbmInputFilled: function fbmInputFilled() {
      var v = this.form.redThreshold;
      return v !== null && v !== undefined && v !== '' && !isNaN(Number(v)) ? 'has-value' : '';
    }
  },
  watch: {
    item: {
      handler: function handler() {
        this.loadFromItemFallback();
      },
      immediate: true
    },
    productId: function productId() {
      this.loadFromItemFallback();
      this.hydrateFromStockApiSilent();
    }
  },
  mounted: function mounted() {
    this.hydrateFromStockApiSilent();
  },
  methods: {
    httpParams: function httpParams() {
      var p = {};
      if (this.sellerAccountId) p.seller_account_id = this.sellerAccountId;
      return p;
    },
    getMarketplaceFlag: function getMarketplaceFlag(marketplace) {
      if (!marketplace) return 'flag';
      var m = marketplace.toLowerCase();
      return (m === 'uk' ? 'gb' : m).replace('uk', 'gb');
    },

    loadFromItemFallback: function loadFromItemFallback() {
      var s = this.item && this.item.settings ? this.item.settings : {};
      this.form = {
        redThreshold: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["f" /* fbmThresholdFromSettings */])(s)
      };
    },

    hydrateFromStockApiSilent: function hydrateFromStockApiSilent() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      var self = this;
      this.$http.get(this.stockThresholdsApiBase, {
        params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.httpParams(), {
          channel: 'fbm',
          product_ids: pid
        }),
        timeout: 45000
      }).then(function (res) {
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["d" /* extractThresholdGetItems */])(res.body);
        var i;
        for (i = 0; i < items.length; i++) {
          var row = items[i];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["a" /* productIdFromThresholdRow */])(row) !== pid) continue;
          var raw = row.settings;
          if (raw == null) raw = {};else if (typeof raw === 'string') {
            try {
              raw = JSON.parse(raw);
            } catch (e) {
              raw = {};
            }
          }
          var settings = (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw !== null ? raw : {};
          self.form = { redThreshold: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_stockAlertThresholdsApiParse__["f" /* fbmThresholdFromSettings */])(settings) };
          return;
        }
      }, function () {});
    },
    toPayload: function toPayload() {
      var v = this.form.redThreshold;
      var threshold = v !== null && v !== '' && !isNaN(Number(v)) ? Number(v) : null;
      return { threshold: threshold };
    },
    applySavedPayloadToItem: function applySavedPayloadToItem(settings) {
      var item = this.item;
      if (!item) return;
      var t = settings.threshold;
      if (!item.settings) this.$set(item, 'settings', {});
      this.$set(item.settings, 'threshold', t);
      this.$set(item.settings, 'redThreshold', t);
      this.$set(item.settings, 'red_threshold', t);
    },
    save: function save() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      this.saving = true;
      this.saveError = null;
      var settings = this.toPayload();
      var body = {
        channel: 'fbm',
        updates: [{ product_id: pid, settings: settings }]
      };
      var self = this;
      this.$http.patch(this.stockThresholdsApiBase, body, { params: this.httpParams(), timeout: 60000 }).then(function (res) {
        self.saving = false;
        var failed = res.body && res.body.failed;
        if (failed > 0) {
          self.saveError = 'Some updates failed. Check results from the server.';
          return;
        }
        self.applySavedPayloadToItem(settings);
        self.$emit('saved');
      }, function (err) {
        self.saving = false;
        self.saveError = err.body && err.body.message || err.statusText || 'Failed to save settings';
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlertThresholdsInline_vue__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlertThresholdsInline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AlertThresholdsInline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FBMAlertThresholdsInline_vue__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FBMAlertThresholdsInline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FBMAlertThresholdsInline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesVolumeThresholdsInline_vue__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesVolumeThresholdsInline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SalesVolumeThresholdsInline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_reviewHealth_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__ = __webpack_require__(49);









function isLikelyHttpImageUrl(url) {
  if (!url || typeof url !== 'string') return false;
  var t = url.trim();
  return (/^https?:\/\//i.test(t)
  );
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesCategoryCard',
  components: {
    AlertThresholdsInline: __WEBPACK_IMPORTED_MODULE_0__AlertThresholdsInline_vue___default.a,
    'fbm-alert-thresholds-inline': __WEBPACK_IMPORTED_MODULE_1__FBMAlertThresholdsInline_vue___default.a,
    'sales-volume-thresholds-inline': __WEBPACK_IMPORTED_MODULE_2__SalesVolumeThresholdsInline_vue___default.a
  },
  props: {
    item: { type: Object, required: true },
    wdtype: { type: String, required: true },
    products: { type: Object, default: function _default() {
        return {};
      } },
    statusLabel: { type: String, default: '' },
    statusClass: { type: String, default: '' },
    apiBaseUrl: { type: String, default: '/api/v1/watchdogs' },
    stockAlertThresholdsApiBaseUrl: { type: String, default: '/api/v1/stock-alert-thresholds' },
    salesVolumeThresholdsApiBaseUrl: { type: String, default: '/api/v1/sales-volume-alert-thresholds' },
    sellerAccountIdForThresholds: { type: String, default: null },
    markResolveBusy: { type: Boolean, default: false },

    issuesListTab: { type: String, default: 'active' },
    highlightedAlertId: { type: String, default: '' },
    filterByMarket: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      showAlertThresholds: false
    };
  },
  computed: {
    showRightSide: function showRightSide() {
      if (this.statusClass === 'muted') return false;

      if (this.statusClass === 'resolved') return !!(this.viewUrl || this.sellerCentralUrl);
      if (this.statusClass === 'suppressed' || this.statusClass === 'rotating') return false;
      return true;
    },
    showMarkResolvedButton: function showMarkResolvedButton() {
      if (this.issuesListTab === 'resolved') return false;
      if (!this.showRightSide || !this.item) return false;
      if (!this.item.watchDogId || this.item.muted) return false;
      return this.item.issueStatus !== 3;
    },
    showAlertThresholdsButton: function showAlertThresholdsButton() {
      if (!(this.wdtype === 'inventory' || this.wdtype === 'fbmInventory' || this.wdtype === 'salesDrop')) return false;
      if (!this.item) return false;
      if (this.wdtype === 'salesDrop') return !!(this.item.watchDogId && this.routeProductId);
      return !!(this.item.watchDogId || this.routeProductId);
    },
    marketplaceCode: function marketplaceCode() {
      var item = this.item || {};
      var p = this.product || {};
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(item.marketplace || p.marketplace);
    },
    marketplaceLabel: function marketplaceLabel() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["c" /* marketplaceColumnLabel */])(this.marketplaceCode);
    },
    marketplaceFlagClass: function marketplaceFlagClass() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["d" /* marketplaceFlagClass */])(this.marketplaceCode);
    },
    marketplaceFilterActive: function marketplaceFilterActive() {
      var code = this.marketplaceCode;
      if (!code || !this.filterByMarket || this.filterByMarket.length === 0) return false;
      for (var i = 0; i < this.filterByMarket.length; i++) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(this.filterByMarket[i]) === code) return true;
      }
      return false;
    },

    feeSku: function feeSku() {
      if (this.wdtype !== 'fbaFeeChange') return '';
      var d = this.item && this.item.statusDetails || {};
      var sku = d.sellerSku || this.product && this.product.sku || '';
      return sku && String(sku).toUpperCase() !== this.displayAsin ? String(sku) : '';
    },

    feeReason: function feeReason() {
      if (this.wdtype !== 'fbaFeeChange') return null;
      var d = this.item && this.item.statusDetails || {};
      var line = d.reasonLine ? String(d.reasonLine) : '';
      if (!line) return null;
      var tone = d.reason === 'remeasured_down' ? 'down' : d.reason === 'remeasured_up' ? 'up' : 'info';
      var at = line.indexOf(' · ');
      if (tone === 'info' || at < 0) return { tone: tone, lead: tone === 'info' ? '' : line, rest: tone === 'info' ? line : '' };
      return { tone: tone, lead: line.slice(0, at) + ': ', rest: line.slice(at + 3) };
    },

    feeClaimDownloadUrl: function feeClaimDownloadUrl() {
      if (this.wdtype !== 'fbaFeeChange' || this.issuesListTab === 'resolved') return null;
      var claim = this.item && this.item.statusDetails && this.item.statusDetails.feeClaim;
      return claim && claim.downloadUrl ? claim.downloadUrl : null;
    },
    displayAsin: function displayAsin() {
      var item = this.item || {};
      var p = this.product || {};
      var asin = item.asin || p.asin || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["e" /* extractAsinFromUrl */])(p.productUrl || '');
      return asin ? String(asin).toUpperCase() : '';
    },
    alertDomId: function alertDomId() {
      var item = this.item || {};
      if (item.watchDogId != null && item.watchDogId !== '') return String(item.watchDogId);
      if (item.watchDogItemId != null && item.watchDogItemId !== '') return String(item.watchDogItemId);
      return '';
    },
    isHighlighted: function isHighlighted() {
      if (!this.highlightedAlertId || !this.item) return false;
      var t = String(this.highlightedAlertId);
      if (this.item.watchDogId != null && String(this.item.watchDogId) === t) return true;
      if (this.item.watchDogItemId != null && String(this.item.watchDogItemId) === t) return true;
      return false;
    },
    amazonListingUrl: function amazonListingUrl() {
      var p = this.product || {};
      var asin = this.displayAsin;
      var fallback = p.productUrl || null;
      if (!asin && !fallback) return null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["a" /* amazonListingUrl */])(asin, this.marketplaceCode, fallback);
    },
    sellerCentralUrl: function sellerCentralUrl() {
      if (this.wdtype === 'badReview' || this.wdtype === 'topReview') return null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["f" /* sellerCentralAsinUrl */])(this.displayAsin, this.marketplaceCode);
    },

    reviewHealthInfo: function reviewHealthInfo() {
      if (this.wdtype !== 'reviewHealth') return null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_reviewHealth_js__["f" /* reviewHealthDetails */])(this.item && this.item.statusDetails);
    },
    viewUrl: function viewUrl() {
      if (this.reviewHealthInfo && this.reviewHealthInfo.reviewsUrl) return this.reviewHealthInfo.reviewsUrl;
      if (this.wdtype === 'badReview' && this.product && this.product.productReviewsUrl) {
        return this.rewriteAmazonUrlHost(this.product.productReviewsUrl) || this.product.productReviewsUrl;
      }
      if (this.wdtype === 'topReview' && this.product && this.product.productTopReviewsUrl) {
        return this.rewriteAmazonUrlHost(this.product.productTopReviewsUrl) || this.product.productTopReviewsUrl;
      }
      return this.amazonListingUrl;
    },
    viewUrlLabel: function viewUrlLabel() {
      if (this.wdtype === 'badReview') return 'Latest Reviews';
      if (this.wdtype === 'topReview') return 'Top Rated Reviews';
      if (this.reviewHealthInfo && this.reviewHealthInfo.reviewsUrl) return 'Read reviews on Amazon';
      return 'View on Amazon';
    },
    product: function product() {
      return this.item.productId && this.products[this.item.productId] ? this.products[this.item.productId] : null;
    },
    productThumbUrl: function productThumbUrl() {
      if (!this.product) return null;
      var u = this.product.largeImageUrl || this.product.imageUrl;
      return isLikelyHttpImageUrl(u) ? String(u).trim() : null;
    },
    productTitle: function productTitle() {
      if (this.product) return this.product.productTitle || '';
      if (this.item.title && String(this.item.title).trim()) return String(this.item.title).trim();
      return '(Product data unavailable)';
    },
    routeProductId: function routeProductId() {
      if (this.item.productId != null && this.item.productId !== '') return this.item.productId;
      return null;
    },
    changeDescriptionTableRows: function changeDescriptionTableRows() {
      var tableWdtypes = {
        productDetailsRecentChange: true,
        productCategoryRecentChange: true,
        parentProductChange: true
      };
      if (!tableWdtypes[this.wdtype]) return null;
      var msg = this.item && this.item.statusDetails && this.item.statusDetails.message;
      if (!msg) return null;
      var parsed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["a" /* parseProductDetailChangeRows */])(String(msg));
      if (!parsed || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["b" /* isImageOnlyUpdatedRows */])(parsed)) return null;
      return parsed.map(function (r) {
        var bRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["c" /* formatChangeCellBefore */])(r.before);
        var aRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["d" /* formatChangeCellAfter */])(r.after);
        var bd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["e" /* truncateChangeCell */])(bRaw);
        var ad = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_productDetailChangeMessage_js__["e" /* truncateChangeCell */])(aRaw);
        return {
          field: r.field,
          beforeDisplay: bd.text,
          afterDisplay: ad.text,
          beforeTitle: bd.truncated ? bRaw : '',
          afterTitle: ad.truncated ? aRaw : ''
        };
      });
    }
  },
  methods: {
    rewriteAmazonUrlHost: function rewriteAmazonUrlHost(url) {
      if (!url || typeof url !== 'string') return null;
      try {
        var u = new URL(url);
        if (!/amazon\./i.test(u.hostname)) return null;
        u.hostname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_amazonMarketplaceUrls_js__["g" /* amazonHostForMarketplace */])(this.marketplaceCode, url);
        return u.toString();
      } catch (e) {
        return null;
      }
    },
    onMarketplaceChipClick: function onMarketplaceChipClick() {
      if (!this.marketplaceCode) return;
      this.$emit('filter-marketplace', this.marketplaceCode);
    },
    formatDate: function formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleDateString('en-US');
    },
    mute: function mute(minutes) {
      this.$emit('mute', this.item, minutes);
    },
    openProductDetails: function openProductDetails() {
      if (!this.routeProductId) return;
      this.$emit('view-product', this.routeProductId);
    },
    toggleAlertThresholds: function toggleAlertThresholds() {
      this.showAlertThresholds = !this.showAlertThresholds;
    },
    onThresholdsSaved: function onThresholdsSaved() {
      this.showAlertThresholds = false;
      this.$emit('saved');
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IssuesCategoryCard_vue__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IssuesCategoryCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IssuesCategoryCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalesVolumeThresholdsPanel_vue__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalesVolumeThresholdsPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SalesVolumeThresholdsPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_listViewUrlSync_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_watchdogSummaryApi_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_IssuesCategoryDetail_css__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_IssuesCategoryDetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_IssuesCategoryDetail_css__);















var LIST_WINDOW = 10;

var LIST_ROW_HEIGHT = 88;

function readCents(details, snakeKey, camelKey) {
  var v = details[snakeKey] != null ? details[snakeKey] : details[camelKey];
  if (v == null || v === '') return null;
  var n = Number(v);
  return isNaN(n) ? null : n;
}

function fbaFeeDeltaCents(item) {
  var d = item && item.statusDetails || {};
  var prev = readCents(d, 'previous_fba_fulfillment_fee_cents', 'previousFbaFulfillmentFeeCents');
  if (prev == null) prev = readCents(d, 'previous_fba_fee_cents', 'previousFbaFeeCents');
  var curr = readCents(d, 'current_fba_fulfillment_fee_cents', 'currentFbaFulfillmentFeeCents');
  if (curr == null) curr = readCents(d, 'current_fba_fee_cents', 'currentFbaFeeCents');
  if (prev == null || curr == null) return null;
  return curr - prev;
}

function competitorPriceChangeLabel(item) {
  var d = item && item.statusDetails || {};
  var change = d.last_competitor_change || d.lastCompetitorChange || {};
  var oldC = Number(change.old_cents != null ? change.old_cents : change.oldCents);
  var newC = Number(change.new_cents != null ? change.new_cents : change.newCents);
  if (!isFinite(oldC) || !isFinite(newC)) return 'Price change';
  if (newC > oldC) return 'Increased';
  if (newC < oldC) return 'Decreased';
  return 'Price change';
}

function resolveIndexPageAncestor(vm) {
  var p = vm.$parent;
  while (p) {
    if (p.worldStore && Array.isArray(p.wdList)) return p;
    p = p.$parent;
  }
  return null;
}

var WD_INFO = {
  lostBuybox: { name: 'Buy Box Issues', ccf: '30 minutes' },
  price: { name: 'Price Change', ccf: '15 minutes' },
  numberOfSellers: { name: 'Hijacker Alert', ccf: '15 minutes' },
  listingSuspended: { name: 'Suspended Listings', ccf: '10 minutes' },
  searchBan: { name: 'Search Suppression', ccf: '3 hours' },
  keyword: { name: 'Keyword Tracking', ccf: '—' },
  noAddToCart: { name: 'Add-to-Cart Button', ccf: '30 minutes' },
  productDetailsRecentChange: { name: 'Product Details Change', ccf: '30 minutes' },
  imageMissing: { name: 'Main Image', ccf: '30 minutes' },
  productCategoryRecentChange: { name: 'Category Change', ccf: '1.5 hours' },
  parentProductChange: { name: 'Parent Product Change', ccf: '31 minutes' },
  adultClassification: { name: 'Adult Classification', ccf: '30 minutes' },
  inventory: { name: 'FBA Stock', ccf: '90 minutes' },
  fbmInventory: { name: 'FBM Stock', ccf: '90 minutes' },
  salesDrop: { name: 'Sales Volume', ccf: '30 minutes' },
  fbaFeeChange: { name: 'FBA Fee Change', ccf: '1 day' },
  competitorPrice: { name: 'Competitor Price', ccf: 'Real-time' },
  competitivePrice: { name: 'Competitive Price', ccf: 'Real-time' },
  reviewHealth: { name: 'Review Health', ccf: '1 day' },
  bestSellerBadge: { name: 'Best Seller Badge', ccf: '30 minutes' },
  prime: { name: 'Prime Badge', ccf: '30 minutes' },
  amazonChoiceBadge: { name: "Amazon's Choice", ccf: '30 minutes' },
  subscribeAndSave: { name: 'Subscribe & Save', ccf: '30 minutes' },
  badReview: { name: 'Latest Reviews', ccf: '2 hours' },
  topReview: { name: 'Top Rated Reviews', ccf: '4 hours' },
  starRatingRecentChange: { name: 'Star Rating', ccf: '2.5 hours' },
  badSellerFeedback: { name: 'Bad Seller Feedback', ccf: '2 hours' }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesCategoryDetail',
  components: { IssuesCategoryCard: __WEBPACK_IMPORTED_MODULE_5__IssuesCategoryCard_vue___default.a, SalesVolumeThresholdsPanel: __WEBPACK_IMPORTED_MODULE_6__SalesVolumeThresholdsPanel_vue___default.a },
  props: {
    wdtype: { type: String, required: true },
    wd: { type: Object, required: true },
    filterByMarket: { type: Array, default: function _default() {
        return [];
      } },
    filterBySellAcc: { type: Array, default: function _default() {
        return [];
      } },
    dateRange: { type: String, default: 'today' },
    alertThresholdsApiBaseUrl: { type: String, default: '/api/v1/watchdogs' },
    stockAlertThresholdsApiBaseUrl: { type: String, default: '/api/v1/stock-alert-thresholds' },
    salesVolumeThresholdsApiBaseUrl: { type: String, default: '/api/v1/sales-volume-alert-thresholds' },
    issuesListTab: { type: String, default: 'active' },

    resolvedHidden: { type: Boolean, default: false },

    issueProducts: { type: Object, default: function _default() {
        return {};
      } },
    marketplaceFilterOptions: { type: Array, default: function _default() {
        return [];
      } },
    highlightedAlertId: { type: String, default: '' },
    itemsMeta: { type: Object, default: null },

    feeDirection: { type: String, default: '' },
    itemsLoading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      searchQuery: '',
      bulkResolveInProgress: false,
      showSalesConfigurePanel: false,
      salesVolumeThresholdPanelDataReady: true,
      markResolveBusyIds: {},
      listWindowStart: 0,
      exportingChangeLog: false,
      exportChangeLogError: ''
    };
  },
  computed: {
    categoryName: function categoryName() {
      return WD_INFO[this.wdtype] && WD_INFO[this.wdtype].name || this.wdtype;
    },
    products: function products() {
      var idx = resolveIndexPageAncestor(this);
      var base = idx && idx.worldStore && idx.worldStore.products || {};
      var extra = this.issueProducts || {};
      if (!extra || (typeof extra === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(extra)) !== 'object' || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(extra).length === 0) return base;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, base, extra);
    },
    activeItems: function activeItems() {
      return this.getFilteredItems('active');
    },
    resolvedItems: function resolvedItems() {
      return this.getFilteredItems('resolved');
    },
    activeCount: function activeCount() {
      var st = this.wd.summaryTotals;
      if (st && typeof st.activeRed === 'number' && typeof st.activeYellow === 'number') {
        return st.activeRed + st.activeYellow;
      }
      return this.activeItems.length;
    },
    resolvedCount: function resolvedCount() {
      var st = this.wd.summaryTotals;
      if (st && typeof st.resolved === 'number') {
        return st.resolved;
      }
      return this.resolvedItems.length;
    },
    newAlertCount: function newAlertCount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["d" /* countIssuesNewAlertsFiltered */])(this.wd.items, this.products, this.filterByMarket, this.filterBySellAcc, this.dateRange);
    },
    displayedItems: function displayedItems() {
      if (this.resolvedHidden || this.issuesListTab === 'active') return this.filterBySearch(this.activeItems);
      return this.filterBySearch(this.resolvedItems);
    },
    windowedDisplayedItems: function windowedDisplayedItems() {
      var all = this.displayedItems || [];
      if (all.length <= LIST_WINDOW) return all;
      var start = Math.max(0, Math.min(this.listWindowStart, Math.max(0, all.length - LIST_WINDOW)));
      return all.slice(start, start + LIST_WINDOW);
    },
    listVirtualPadTop: function listVirtualPadTop() {
      var all = this.displayedItems || [];
      if (all.length <= LIST_WINDOW) return 0;
      var start = Math.max(0, Math.min(this.listWindowStart, Math.max(0, all.length - LIST_WINDOW)));
      return start * LIST_ROW_HEIGHT;
    },
    listVirtualPadBottom: function listVirtualPadBottom() {
      var all = this.displayedItems || [];
      if (all.length <= LIST_WINDOW) return 0;
      var start = Math.max(0, Math.min(this.listWindowStart, Math.max(0, all.length - LIST_WINDOW)));
      var after = Math.max(0, all.length - (start + LIST_WINDOW));
      return after * LIST_ROW_HEIGHT;
    },
    stockThresholdSellerAccountId: function stockThresholdSellerAccountId() {
      if (this.filterBySellAcc && this.filterBySellAcc.length === 1) return String(this.filterBySellAcc[0]);
      return null;
    },
    canMarkAllResolved: function canMarkAllResolved() {
      if (this.issuesListTab !== 'active') return false;
      return this.displayedItems.some(function (item) {
        return !!(item && item.watchDogId && !item.muted && item.issueStatus !== 3);
      });
    },
    marketplaceColumnFilterValue: function marketplaceColumnFilterValue() {
      var m = this.filterByMarket || [];
      if (m.length === 1) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(m[0]);
      return '';
    }
  },
  watch: {
    displayedItems: function displayedItems() {
      this.listWindowStart = 0;
    },
    issuesListTab: function issuesListTab() {
      this.listWindowStart = 0;
    }
  },
  methods: {
    onIssuesListScroll: function onIssuesListScroll() {
      var all = this.displayedItems || [];
      if (all.length <= LIST_WINDOW) {
        this.listWindowStart = 0;
        return;
      }
      var el = this.$refs.issuesListScroll;
      if (!el) return;
      var next = Math.floor(el.scrollTop / LIST_ROW_HEIGHT);
      var maxStart = Math.max(0, all.length - LIST_WINDOW);
      if (next < 0) next = 0;
      if (next > maxStart) next = maxStart;
      if (next !== this.listWindowStart) this.listWindowStart = next;
    },
    getFilteredItems: function getFilteredItems(tab) {
      var items = this.wd.items || {};
      var arr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(items);
      arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["a" /* filterIssuesItemsGlobally */])(arr, this.products, this.filterByMarket, this.filterBySellAcc, this.dateRange);

      if (tab === 'active') {
        arr = arr.filter(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["c" /* isIssuesActiveTabItem */]);
      } else {
        arr = arr.filter(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["b" /* isIssuesResolvedTabItem */]);
      }

      if (this.wdtype === 'fbaFeeChange' && this.feeDirection) {
        var dir = this.feeDirection === 'decrease' ? 1 : -1;
        return arr.sort(function (a, b) {
          var da = fbaFeeDeltaCents(a);
          var db = fbaFeeDeltaCents(b);
          if (da == null) return db == null ? 0 : 1;
          if (db == null) return -1;
          return dir * (da - db);
        });
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["e" /* sortIssuesItemsForTab */])(arr, tab, this.products);
    },
    onFeeDirectionChange: function onFeeDirectionChange(e) {
      this.$emit('issues-fee-direction-change', e && e.target ? e.target.value : '');
    },
    onSearchInput: function onSearchInput() {
      this.$emit('issues-search-change', this.searchQuery);
    },
    filterBySearch: function filterBySearch(arr) {
      if (!this.searchQuery.trim()) return arr;
      var q = this.searchQuery.toLowerCase();
      var products = this.products;
      return arr.filter(function (item) {
        var prod = item.productId && products[item.productId] ? products[item.productId] : null;
        var asin = '';
        var title = '';
        var mp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(item.marketplace);
        if (prod) {
          title = (prod.productTitle || '').toLowerCase();
          asin = (prod.asin || '').toLowerCase();
          if (!asin) {
            var fromUrl = (prod.productUrl || '').match(/\/dp\/([A-Z0-9]+)/i);
            asin = fromUrl ? fromUrl[1].toLowerCase() : '';
          }
          if (!mp) mp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(prod.marketplace);
        }
        if (!asin && item.asin) asin = String(item.asin).toLowerCase();
        var mpLabel = mp ? (mp + ' marketplace').toLowerCase() : '';
        if (title.indexOf(q) >= 0 || asin.indexOf(q) >= 0 || mp.toLowerCase().indexOf(q) >= 0 || mpLabel.indexOf(q) >= 0) {
          return true;
        }
        var blob = '';
        if (item.title) blob += ' ' + String(item.title);
        if (item.statusDetails && item.statusDetails.message) blob += ' ' + String(item.statusDetails.message);
        return blob.toLowerCase().indexOf(q) >= 0;
      });
    },
    marketplaceOptionLabel: function marketplaceOptionLabel(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["c" /* marketplaceColumnLabel */])(code) || code;
    },
    onMarketplaceColumnFilter: function onMarketplaceColumnFilter(e) {
      var v = e && e.target ? e.target.value : '';
      this.$emit('filter-market', v ? [v] : []);
    },
    onMarketplaceChipFilter: function onMarketplaceChipFilter(code) {
      var next = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */])(code);
      if (!next) return;
      var current = (this.filterByMarket || []).map(__WEBPACK_IMPORTED_MODULE_9__utils_amazonMarketplaceUrls_js__["b" /* normalizeMarketplaceCode */]);
      if (current.length === 1 && current[0] === next) {
        this.$emit('filter-market', []);
        return;
      }
      this.$emit('filter-market', [next]);
    },
    getStatusLabel: function getStatusLabel(item) {
      if (item.muted) return 'Muted';
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["f" /* isCompetitorPriceOpenChange */])(item)) return competitorPriceChangeLabel(item);
      if (item.issueStatus === 3 || item.status === 99) return 'RESOLVED';
      if (this.issuesListTab === 'resolved' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["b" /* isIssuesResolvedTabItem */])(item)) {
        return 'RESOLVED';
      }
      if (this.wdtype === 'lostBuybox' && item.statusDetails) {
        var msg = (item.statusDetails.message || '').toLowerCase();
        var d = item.statusDetails;
        if (msg.indexOf('suppress') >= 0) return 'SUPPRESSED';
        if (msg.indexOf('lost') >= 0 || msg.indexOf('another seller') >= 0 || d.lost_to_another_seller || d.lost_to_amazon || d.lost_to_whitelisted_seller) return 'LOST';
        if (msg.indexOf('rotat') >= 0) return 'ROTATING';
        if (d.has_own_offer && !d.lost_to_another_seller && !d.lost_to_amazon && !d.lost_to_whitelisted_seller) return 'ROTATING';
      }
      if (item.status === 2) return 'Alert';
      if (item.status === 1) return 'Warning';
      return 'OK';
    },
    getStatusClass: function getStatusClass(item) {
      if (item.muted) return 'muted';
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["f" /* isCompetitorPriceOpenChange */])(item)) return 'warning';
      if (item.issueStatus === 3 || item.status === 99) return 'resolved';
      if (this.issuesListTab === 'resolved' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_issuesAlertFilters_js__["b" /* isIssuesResolvedTabItem */])(item)) {
        return 'resolved';
      }
      if (this.wdtype === 'lostBuybox' && item.statusDetails) {
        var msg = (item.statusDetails.message || '').toLowerCase();
        var d = item.statusDetails;
        if (msg.indexOf('suppress') >= 0) return 'suppressed';
        if (msg.indexOf('lost') >= 0 || msg.indexOf('another seller') >= 0 || d.lost_to_another_seller || d.lost_to_amazon || d.lost_to_whitelisted_seller) return 'lost';
        if (msg.indexOf('rotat') >= 0) return 'rotating';
        if (d.has_own_offer && !d.lost_to_another_seller && !d.lost_to_amazon && !d.lost_to_whitelisted_seller) return 'rotating';
      }
      if (item.status === 2) return 'alert';
      if (item.status === 1) return 'warning';
      return 'ok';
    },

    applyLocalSummaryTotalsForResolve: function applyLocalSummaryTotalsForResolve(item, count) {
      var n = count != null ? count : 1;
      var st = this.wd && this.wd.summaryTotals;
      if (!st) return;
      var next = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, st);
      var isYellow = item && (item.status === 1 || item.status === '1');
      if (isYellow && typeof next.activeYellow === 'number') {
        next.activeYellow = Math.max(0, next.activeYellow - n);
      } else if (typeof next.activeRed === 'number') {
        next.activeRed = Math.max(0, next.activeRed - n);
      }
      if (typeof next.resolved === 'number') {
        next.resolved = next.resolved + n;
      }
      this.$set(this.wd, 'summaryTotals', next);
    },

    synthesizeAlertCountsDelta: function synthesizeAlertCountsDelta(item, count) {
      var n = count != null ? count : 1;
      var isYellow = item && (item.status === 1 || item.status === '1');
      return {
        watchdog_type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_watchdogSummaryApi_js__["f" /* watchdogTypeToApiParam */])(this.wdtype),
        red: isYellow ? 0 : -n,
        yellow: isYellow ? -n : 0
      };
    },
    markItemResolved: function markItemResolved(item) {
      if (!item || !item.watchDogId || item.issueStatus === 3) return;
      var wid = item.watchDogId;
      if (this.markResolveBusyIds[wid]) return;
      this.$set(this.markResolveBusyIds, wid, true);
      var indexPage = resolveIndexPageAncestor(this);
      var self = this;
      if (!indexPage || !indexPage.stateChangeRequestInFlight) {
        self.$delete(self.markResolveBusyIds, wid);
        return;
      }
      var timestamp = Date.now();
      indexPage.stateChangeRequestInFlight.add(timestamp);
      this.$http.post('/api/sentinel/watchdog/set-issue-status/' + encodeURIComponent(String(wid)) + '/3', {}).then(function (response) {
        var prevStatus = item.status;
        item.issueStatus = 3;
        self.applyLocalSummaryTotalsForResolve({ status: prevStatus }, 1);
        indexPage.stateChangeRequestInFlight.delete(timestamp);
        var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_watchdogSummaryApi_js__["g" /* parseSummaryJsonPayload */])(response);
        if (body && body.alert_counts_delta) {
          self.$emit('alert-counts-delta', body.alert_counts_delta);
        } else {
          self.$emit('alert-counts-delta', self.synthesizeAlertCountsDelta({ status: prevStatus }, 1));
        }
        self.$delete(self.markResolveBusyIds, wid);
      }, function () {
        indexPage.stateChangeRequestInFlight.delete(timestamp);
        self.$delete(self.markResolveBusyIds, wid);
      });
    },
    muteItem: function muteItem(item, minutes) {
      var self = this;
      var indexPage = resolveIndexPageAncestor(this);
      if (indexPage && indexPage.stateChangeRequestInFlight) {
        var timestamp = Date.now();
        indexPage.stateChangeRequestInFlight.add(timestamp);
        this.$http.post('/api/sentinel/watchdog/' + (minutes < 1 ? 'un' : '') + 'mute/' + item.watchDogId, { minutes: minutes }).then(function () {
          item.muted = minutes >= 1;
          indexPage.stateChangeRequestInFlight.delete(timestamp);
        }, function () {
          indexPage.stateChangeRequestInFlight.delete(timestamp);
        });
      }
    },

    markAllResolved: function markAllResolved() {
      var resolveTargets = this.displayedItems.filter(function (item) {
        return !!(item && item.watchDogId && !item.muted && item.issueStatus !== 3);
      });
      var issueIds = resolveTargets.map(function (item) {
        return item.watchDogId;
      });
      if (!issueIds.length) return;
      var indexPage = resolveIndexPageAncestor(this);
      if (!indexPage || !indexPage.stateChangeRequestInFlight) return;

      var timestamp = Date.now();
      indexPage.stateChangeRequestInFlight.add(timestamp);
      this.bulkResolveInProgress = true;

      this.$http.post('/api/sentinel/watchdog/set-issue-status-bulk', { issue_ids: issueIds, status: 'resolved' }).then(function (response) {
        this.bulkResolveInProgress = false;
        indexPage.stateChangeRequestInFlight.delete(timestamp);
        if (response.status !== 200) return;

        var yellowN = 0;
        var redN = 0;
        resolveTargets.forEach(function (entry) {
          entry.issueStatus = 3;
          if (entry.status === 1 || entry.status === '1') yellowN += 1;else redN += 1;
        });
        var st = this.wd.summaryTotals;
        if (st) {
          var next = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, st);
          if (typeof next.activeYellow === 'number') next.activeYellow = Math.max(0, next.activeYellow - yellowN);
          if (typeof next.activeRed === 'number') next.activeRed = Math.max(0, next.activeRed - redN);
          if (typeof next.resolved === 'number') next.resolved = next.resolved + issueIds.length;
          this.$set(this.wd, 'summaryTotals', next);
        }
        this.$emit('alert-counts-delta', {
          watchdog_type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_watchdogSummaryApi_js__["f" /* watchdogTypeToApiParam */])(this.wdtype),
          red: -redN,
          yellow: -yellowN
        });

        this.$emit('issues-summary-refresh-request');
      }.bind(this), function () {
        this.bulkResolveInProgress = false;
        indexPage.stateChangeRequestInFlight.delete(timestamp);
      }.bind(this));
    },
    viewProduct: function viewProduct(productId) {
      if (!productId) return;
      var cleanId = String(productId).replace(/^PROD-/i, '');
      var issuesPage = this.$parent;
      if (issuesPage && typeof issuesPage.syncIssuesRouteQuery === 'function') {
        issuesPage.syncIssuesRouteQuery();
      }
      this.$router.push({ path: '/product_details', query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_listViewUrlSync_js__["c" /* buildProductDetailsQuery */])(cleanId, this.$route.fullPath) });
    },

    onAlertThresholdsSaved: function onAlertThresholdsSaved() {},

    exportChangeLog: function exportChangeLog() {
      var self = this;
      if (self.exportingChangeLog) return;
      self.exportingChangeLog = true;
      self.exportChangeLogError = '';
      var to = new Date();
      var from = new Date(to.getTime() - 29 * 24 * 3600 * 1000);
      var iso = function iso(d) {
        return d.toISOString().slice(0, 10);
      };
      var params = { from: iso(from), to: iso(to) };
      if (self.filterByMarket && self.filterByMarket.length === 1) params.marketplace = self.filterByMarket[0];
      var sellerIds = self.filterBySellAcc && self.filterBySellAcc.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(self.filterBySellAcc.map(String)) : self.$http.get('/api/v1/sellers').then(function (res) {
        return (res.body && res.body.item || []).map(function (it) {
          return String(it.sellerId && it.sellerId.value !== undefined ? it.sellerId.value : it.sellerId);
        });
      });
      sellerIds.then(function (ids) {
        return ids.reduce(function (chain, id) {
          return chain.then(function () {
            return self.$http.get('/api/v1/sellers/' + encodeURIComponent(id) + '/competitive-price-changes.csv', { params: params, responseType: 'blob' }).then(function (res) {
              var name = 'competitive-price-changes-' + id + '-' + params.from + '-' + params.to + '.csv';
              var cd = res.headers && res.headers.get && res.headers.get('Content-Disposition');
              var m = cd && cd.match(/filename="([^"]+)"/);
              if (m) name = m[1];
              var url = window.URL.createObjectURL(res.body);
              var a = document.createElement('a');
              a.href = url;
              a.download = name;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            });
          });
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve());
      }).then(function () {
        self.exportingChangeLog = false;
      }, function () {
        self.exportingChangeLog = false;
        self.exportChangeLogError = 'Export failed. Please try again.';
      });
    },
    toggleSalesConfigurePanel: function toggleSalesConfigurePanel() {
      this.showSalesConfigurePanel = !this.showSalesConfigurePanel;
      if (this.showSalesConfigurePanel) {
        this.salesVolumeThresholdPanelDataReady = false;
      }
    },
    closeSalesConfigurePanel: function closeSalesConfigurePanel() {
      this.showSalesConfigurePanel = false;
    },
    onSalesVolumeThresholdsLoadComplete: function onSalesVolumeThresholdsLoadComplete() {
      this.salesVolumeThresholdPanelDataReady = true;
    },
    onSalesVolumePanelSaved: function onSalesVolumePanelSaved() {
      this.showSalesConfigurePanel = false;
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__ = __webpack_require__(101);






function numVal(v) {
  if (v === undefined || v === null || v === '') return null;
  var n = Number(v);
  return !isNaN(n) && n >= 0 ? n : null;
}

function formFromItem(item) {
  var s = item && item.settings ? item.settings : {};
  return {
    noSalesHours: numVal(s.no_sales_hours != null ? s.no_sales_hours : s.noSalesHours),
    dailyFloor: numVal(s.daily_sales_floor != null ? s.daily_sales_floor : s.dailyFloor),
    dailyCeiling: numVal(s.daily_sales_ceiling != null ? s.daily_sales_ceiling : s.dailyCeiling),
    rollingDrop: numVal(s.rolling_drop_percent != null ? s.rolling_drop_percent : s.rollingDropPercent),
    rollingSpike: numVal(s.rolling_spike_percent != null ? s.rolling_spike_percent : s.rollingSpikePercent),
    rollingDays: numVal(s.rolling_avg_days != null ? s.rolling_avg_days : s.rollingAvgDays),
    rollingMinUnits: numVal(s.rolling_min_units != null ? s.rolling_min_units : s.rollingMinUnits),
    bsrAbove: numVal(s.bsr_alert_above != null ? s.bsr_alert_above : s.bsrAlertAbove)
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SalesVolumeThresholdsInline',
  props: {
    item: { type: Object, required: true },
    productId: { type: [String, Number], default: null },
    sellerAccountId: { type: String, default: null },
    productTitle: { type: String, default: '' },
    marketplace: { type: String, default: '' },
    salesVolumeThresholdsApiBase: { type: String, default: '/api/v1/sales-volume-alert-thresholds' }
  },
  data: function data() {
    return {
      form: formFromItem(null),
      saving: false,
      saveError: null
    };
  },
  computed: {
    marketplaceLabel: function marketplaceLabel() {
      if (!this.marketplace) return '—';
      var m = String(this.marketplace).toUpperCase();
      return m === 'GB' ? 'UK' : m;
    },
    resolvedProductId: function resolvedProductId() {
      if (this.productId != null && this.productId !== '') return String(this.productId);
      return this.item ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__["g" /* salesVolumeListingIdFromProduct */])(this.item) : '';
    }
  },
  watch: {
    item: {
      handler: function handler() {
        this.form = formFromItem(this.item);
      },
      immediate: true
    },
    productId: function productId() {
      this.form = formFromItem(this.item);
      this.hydrateFromApiSilent();
    }
  },
  mounted: function mounted() {
    this.hydrateFromApiSilent();
  },
  methods: {
    httpParams: function httpParams() {
      var p = {};
      if (this.sellerAccountId) p.seller_account_id = this.sellerAccountId;
      return p;
    },
    hydrateFromApiSilent: function hydrateFromApiSilent() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      var self = this;
      var base = this.salesVolumeThresholdsApiBase;
      var opts = function opts(extra) {
        return {
          params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
            product_ids: pid,
            _skcb: Date.now()
          }, extra || {}),
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
          timeout: 45000
        };
      };
      var apply = function apply(res) {
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__["e" /* extractSalesVolumeListItems */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__["a" /* salesVolumeHttpResponseEntity */])(res));
        var i;
        for (i = 0; i < items.length; i++) {
          var row = items[i];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__["c" /* productIdFromSalesVolumeRow */])(row) !== pid) continue;
          var raw = row.settings;
          if (raw == null) raw = {};else if (typeof raw === 'string') {
            try {
              raw = JSON.parse(raw);
            } catch (e) {
              raw = {};
            }
          }
          var settings = (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw !== null ? raw : {};
          self.form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_salesVolumeAlertThresholdsApiParse_js__["f" /* formFieldsFromSalesVolumeSettings */])(settings);
          return;
        }
      };
      this.$http.get(base, opts()).then(function (res) {
        apply(res);
      }).catch(function (res) {
        if (res && res.status === 304) {
          return self.$http.get(base, opts({ _skretry: Date.now() })).then(function (res2) {
            apply(res2);
          });
        }
      });
    },
    applySavedPayloadToItem: function applySavedPayloadToItem(settings) {
      var item = this.item;
      if (!item) return;
      if (!item.settings) this.$set(item, 'settings', {});
      var s = settings;
      if (Object.prototype.hasOwnProperty.call(s, 'no_sales_hours')) {
        this.$set(item.settings, 'no_sales_hours', s.no_sales_hours);
        this.$set(item.settings, 'noSalesHours', s.no_sales_hours);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'rolling_drop_percent')) {
        this.$set(item.settings, 'rolling_drop_percent', s.rolling_drop_percent);
        this.$set(item.settings, 'rollingDropPercent', s.rolling_drop_percent);
      }
      if (Object.prototype.hasOwnProperty.call(s, 'rolling_avg_days')) {
        this.$set(item.settings, 'rolling_avg_days', s.rolling_avg_days);
        this.$set(item.settings, 'rollingAvgDays', s.rolling_avg_days);
      }
    },

    inlineSettingsPayload: function inlineSettingsPayload() {
      function part(v) {
        if (v === null || v === undefined || v === '') return null;
        var n = Number(v);
        return isNaN(n) ? null : n;
      }
      return {
        no_sales_hours: part(this.form.noSalesHours),
        rolling_drop_percent: part(this.form.rollingDrop),
        rolling_avg_days: part(this.form.rollingDays)
      };
    },
    save: function save() {
      var pid = this.resolvedProductId;
      if (!pid) return;
      this.saving = true;
      this.saveError = null;
      var settings = this.inlineSettingsPayload();
      var body = { updates: [{ product_id: pid, settings: settings }] };
      var self = this;
      this.$http.patch(this.salesVolumeThresholdsApiBase, body, { params: this.httpParams(), timeout: 60000 }).then(function (res) {
        self.saving = false;
        var failed = res.body && res.body.failed;
        if (failed > 0) {
          self.saveError = 'Some updates failed. Check results from the server.';
          return;
        }
        self.applySavedPayloadToItem(settings);
        self.$emit('saved');
      }, function (err) {
        self.saving = false;
        self.saveError = err.body && err.body.message || err.statusText || 'Failed to save settings';
      });
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__ = __webpack_require__(101);








function unwrapListResponseEntity(res) {
  if (Array.isArray(res)) return res;
  var e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["a" /* salesVolumeHttpResponseEntity */])(res);
  e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["b" /* parseJsonIfNeeded */])(e);
  if (e != null) return e;
  if (res && (typeof res === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(res)) === 'object' && !Array.isArray(res) && res.data != null) {
    var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["b" /* parseJsonIfNeeded */])(res.data);
    if (d != null && (typeof d === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(d)) === 'object') return d;
  }
  return null;
}

function bodyObjectFromResponse(rawBody) {
  var b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["b" /* parseJsonIfNeeded */])(rawBody);
  if (b == null) b = rawBody;
  if (b != null && (typeof b === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b)) === 'object' && !Array.isArray(b)) return b;
  return {};
}

function parseSettingsRaw(raw) {
  if (raw == null) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }
  return (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(raw)) === 'object' ? raw : {};
}

function normalizeApiListingRow(apiRow) {
  if (!apiRow || (typeof apiRow === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(apiRow)) !== 'object') return null;
  var pid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["c" /* productIdFromSalesVolumeRow */])(apiRow);
  if (!pid) return null;
  return {
    productId: String(pid),
    asin: apiRow.asin != null ? String(apiRow.asin) : '',
    marketplace: apiRow.marketplace != null ? String(apiRow.marketplace) : '',
    sellerId: apiRow.seller_id != null ? String(apiRow.seller_id) : apiRow.sellerId != null ? String(apiRow.sellerId) : ''
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SalesVolumeThresholdsPanel',
  props: {
    panelOpen: { type: Boolean, default: false },

    thresholdsApiBase: { type: String, default: '/api/v1/sales-volume-alert-thresholds' },

    sellerAccountId: { type: String, default: null },

    listPage: { type: Number, default: 0 },
    listPageSize: { type: Number, default: 100 }
  },
  data: function data() {
    return {
      listRows: [],
      listTotal: 0,

      rowApiSettings: {},
      salesSubtype: 'hours',
      forms: {},
      saving: false,
      saveError: null,
      thresholdsLoading: false,
      thresholdsLoadError: null,

      thresholdsFetchSeq: 0,
      subtypeTabs: [{ id: 'hours', label: 'Hours without Sales' }, { id: 'fixed', label: 'Daily Fixed Limits' }, { id: 'rolling', label: 'Rolling Average' }, { id: 'bsr', label: 'BSR Limits' }]
    };
  },
  computed: {
    activeColumns: function activeColumns() {
      if (this.salesSubtype === 'hours') {
        return [{ key: 'h', label: 'Alert if no sales in last' }];
      }
      if (this.salesSubtype === 'fixed') {
        return [{ key: 'f1', label: 'Alert if drops below' }, { key: 'f2', label: 'Alert if spikes above' }];
      }
      if (this.salesSubtype === 'rolling') {
        return [{ key: 'r1', label: 'Drop alert (%)' }, { key: 'r2', label: 'Spike alert (%)' }, { key: 'r3', label: 'Avg over (days)' }, { key: 'r4', label: 'Min units' }];
      }
      return [{ key: 'b', label: 'Alert if BSR goes above' }];
    }
  },
  watch: {
    panelOpen: function panelOpen(open) {
      if (!open) return;
      this.reloadThresholdsFromApi();
    },
    listPage: function listPage() {
      if (this.panelOpen) this.reloadThresholdsFromApi();
    },
    listPageSize: function listPageSize() {
      if (this.panelOpen) this.reloadThresholdsFromApi();
    }
  },

  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      if (self.panelOpen) {
        self.reloadThresholdsFromApi();
      }
    });
  },
  methods: {
    listGetParams: function listGetParams() {
      return {
        page: this.listPage,
        page_size: this.listPageSize
      };
    },
    listGetRequestOptions: function listGetRequestOptions(extraParams) {
      return {
        params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.listGetParams(), { _skcb: Date.now() }, extraParams || {}),
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
        timeout: 45000
      };
    },
    httpParams: function httpParams() {
      var p = {};
      if (this.sellerAccountId) p.seller_account_id = this.sellerAccountId;
      return p;
    },
    reloadThresholdsFromApi: function reloadThresholdsFromApi() {
      return this.loadThresholdsFromApi();
    },
    rowKey: function rowKey(row) {
      return row && row.productId ? String(row.productId) : 'unknown';
    },
    marketplaceCode: function marketplaceCode(mp) {
      if (!mp) return '—';
      var m = String(mp).toUpperCase();
      return m === 'GB' ? 'UK' : m;
    },
    marketplaceFlagClass: function marketplaceFlagClass(mp) {
      if (!mp) return 'flag';
      var m = String(mp).toLowerCase();
      return (m === 'uk' ? 'gb' : m).replace('uk', 'gb');
    },
    buildPayload: function buildPayload(form) {
      return { settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["d" /* salesVolumeFormToApiSettings */])(form) };
    },
    loadThresholdsFromApi: function loadThresholdsFromApi() {
      var self = this;

      var finish = function finish() {
        self.$emit('thresholds-load-complete');
      };
      if (!this.panelOpen) {
        finish();
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (!this.$http || typeof this.$http.get !== 'function') {
        this.thresholdsLoadError = 'HTTP client is not available.';
        finish();
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
      this.thresholdsFetchSeq += 1;
      var seq = this.thresholdsFetchSeq;
      this.thresholdsLoading = true;
      this.thresholdsLoadError = null;
      var base = this.thresholdsApiBase;

      var applyPayload = function applyPayload(res) {
        if (seq !== self.thresholdsFetchSeq) return;
        var entity = unwrapListResponseEntity(res);
        var bodyObj = bodyObjectFromResponse(entity);
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["e" /* extractSalesVolumeListItems */])(entity);
        if (items.length === 0 && entity && Array.isArray(entity.items)) {
          items = entity.items;
        }
        var total = bodyObj.total != null ? Number(bodyObj.total) : items.length;
        if (isNaN(total)) total = items.length;
        var nextRows = [];
        var nextForms = {};
        var nextApi = {};
        var j;
        for (j = 0; j < items.length; j++) {
          var apiRow = items[j];
          var lr = normalizeApiListingRow(apiRow);
          if (!lr) continue;
          var raw = parseSettingsRaw(apiRow.settings);
          nextRows.push(lr);
          var k = self.rowKey(lr);
          nextForms[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["f" /* formFieldsFromSalesVolumeSettings */])(raw);
          nextApi[lr.productId] = raw && (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(raw)) === 'object' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, raw) : {};
        }
        self.listRows = nextRows;
        self.listTotal = total;
        self.forms = nextForms;
        self.rowApiSettings = nextApi;
      };

      var run = function run(extra) {
        return self.$http.get(base, self.listGetRequestOptions(extra)).then(function (res) {
          applyPayload(res);
        });
      };

      return run(null).catch(function (res) {
        if (res && res.status === 304) {
          return run({ _skretry: Date.now() });
        }
        if (seq === self.thresholdsFetchSeq) {
          self.thresholdsLoadError = res.body && res.body.message || res.statusText || 'Could not load thresholds';
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).then(function () {
        if (seq === self._fetchSeq) {
          self.thresholdsLoading = false;
        }
        finish();
      });
    },
    mergeSavedIntoRowApiSettings: function mergeSavedIntoRowApiSettings(productId, settings) {
      var pid = String(productId);
      var prev = this.rowApiSettings[pid] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.rowApiSettings[pid]) === 'object' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.rowApiSettings[pid]) : {};
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(settings || {});
      var i;
      for (i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!Object.prototype.hasOwnProperty.call(settings, key)) continue;
        var val = settings[key];
        if (val === null || val === undefined) delete prev[key];else prev[key] = val;
      }
      this.$set(this.rowApiSettings, pid, prev);
    },
    saveAll: function saveAll() {
      var self = this;
      if (this.listRows.length === 0) return;
      this.saving = true;
      this.saveError = null;
      var updates = [];
      var i;
      for (i = 0; i < this.listRows.length; i++) {
        var row = this.listRows[i];
        var k = this.rowKey(row);
        var form = this.forms[k];
        if (!row.productId || !form) continue;
        updates.push({
          product_id: String(row.productId),
          settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_salesVolumeAlertThresholdsApiParse_js__["d" /* salesVolumeFormToApiSettings */])(form)
        });
      }
      if (updates.length === 0) {
        this.saving = false;
        this.saveError = 'No listing id for these rows — cannot save.';
        return;
      }
      this.$http.patch(this.thresholdsApiBase, { updates: updates }, { params: this.httpParams(), timeout: 60000 }).then(function (res) {
        var body = res.body || {};
        var results = body.results || [];
        var failed = body.failed != null ? Number(body.failed) : results.filter(function (x) {
          return x && x.ok === false;
        }).length;
        if (failed > 0) {
          var firstErr = results.filter(function (x) {
            return x && x.ok === false;
          })[0];
          self.saveError = firstErr && firstErr.error ? String(firstErr.error) : 'Some rows failed to save (' + failed + ')';
          self.saving = false;
          return;
        }
        for (i = 0; i < updates.length; i++) {
          self.mergeSavedIntoRowApiSettings(updates[i].product_id, updates[i].settings);
        }
        self.saving = false;
        self.$emit('saved');
      }, function (err) {
        self.saving = false;
        self.saveError = err.body && err.body.message || err.statusText || 'Failed to save thresholds';
      });
    },
    downloadCsv: function downloadCsv() {
      var self = this;
      var qs = [];
      if (this.sellerAccountId) qs.push('seller_account_id=' + encodeURIComponent(this.sellerAccountId));
      var qstr = qs.length ? '?' + qs.join('&') : '';
      var exportUrl = this.thresholdsApiBase + '/export.csv' + qstr;
      var defaultName = 'sales-volume-thresholds-' + new Date().toISOString().slice(0, 10) + '.csv';
      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          var cd = xhr.getResponseHeader('Content-Disposition');
          var filename = defaultName;
          if (cd) {
            var m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (m && m[1]) filename = m[1].replace(/['"]/g, '').trim() || defaultName;
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          self.saveError = 'Could not download CSV.';
        }
      };
      xhr.onerror = function () {
        self.saveError = 'CSV download failed.';
      };
      xhr.send();
    },
    isCsvFile: function isCsvFile(file) {
      if (!file || !file.name) return false;
      if (!/\.csv$/i.test(file.name)) return false;
      if (!file.type) return true;
      return file.type === 'text/csv' || file.type === 'application/csv' || file.type === 'text/plain' || file.type === 'application/octet-stream';
    },
    importCsv: function importCsv(e) {
      var input = e.target;
      if (!input.files || !input.files[0]) return;
      var file = input.files[0];
      if (!this.isCsvFile(file)) {
        this.saveError = 'Please choose a CSV file (.csv).';
        input.value = '';
        return;
      }
      var formData = new window.FormData();
      formData.append('file', file, file.name || 'sales-volume-thresholds-import.csv');
      var self = this;
      var q = [];
      if (this.sellerAccountId) q.push('seller_account_id=' + encodeURIComponent(this.sellerAccountId));
      var qimp = q.length ? '?' + q.join('&') : '';
      this.$http.post(this.thresholdsApiBase + '/import.csv' + qimp, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function () {
        if (self.panelOpen) self.reloadThresholdsFromApi();
        self.$emit('saved');
        input.value = '';
      }, function (err) {
        self.saveError = err.body && err.body.message || 'CSV import failed';
        input.value = '';
      });
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsCards_vue__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsCards_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StatisticsCards_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep_vue__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WorkflowStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CSVExample_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CSVExample_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CSVExample_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUploadArea_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUploadArea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FileUploadArea_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BulkImportSection',
  components: {
    StatisticsCards: __WEBPACK_IMPORTED_MODULE_0__StatisticsCards_vue___default.a,
    WorkflowStep: __WEBPACK_IMPORTED_MODULE_1__WorkflowStep_vue___default.a,
    CSVExample: __WEBPACK_IMPORTED_MODULE_2__CSVExample_vue___default.a,
    FileUploadArea: __WEBPACK_IMPORTED_MODULE_3__FileUploadArea_vue___default.a
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    downloading: {
      type: Boolean,
      default: false
    },
    uploading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CSVExample'
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DefaultMarginTargetSection',
  props: {
    settings: {
      type: Object,
      required: true
    },
    formulaDescription: {
      type: String,
      default: 'Floor Price = (Landed Cost + Amazon Fees) ÷ (1 - Margin%)'
    },
    formulaExample: {
      type: Object,
      default: function _default() {
        return {
          landed_cost: 10.50,
          amazon_fees: 7.52,
          margin_percentage: 20.0,
          result: 22.53
        };
      }
    }
  },
  mounted: function mounted() {
    this.initializeToggle();
  },
  methods: {
    initializeToggle: function initializeToggle() {
      this.$nextTick(function () {
        if (typeof $ !== 'undefined') {
          $('.ui.checkbox').checkbox();
        }
      });
    },
    onMarginChange: function onMarginChange(event) {
      var value = parseFloat(event.target.value) || 0;
      if (value < 0) value = 0;
      if (value > 100) value = 100;
      this.$emit('margin-change', value);
    },
    onToggleChange: function onToggleChange(event) {
      var checked = event.target.checked;
      this.$nextTick(function () {
        if (typeof $ !== 'undefined') {
          $('.ui.checkbox').checkbox('set checked', checked);
        }
      });
      this.$emit('toggle-change', checked);
    },
    formatPrice: function formatPrice(price) {
      if (price === null || price === undefined || isNaN(price)) return '$0.00';
      return '$' + parseFloat(price).toFixed(2);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileUploadArea',
  props: {
    uploading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isDragging: false,
      uploadedFile: null
    };
  },
  methods: {
    triggerFileInput: function triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    handleFileSelect: function handleFileSelect(event) {
      var file = event.target.files[0];
      if (file) {
        this.validateAndSetFile(file);
      }
    },
    handleFileDrop: function handleFileDrop(event) {
      this.isDragging = false;
      var file = event.dataTransfer.files[0];
      if (file) {
        this.validateAndSetFile(file);
      }
    },
    validateAndSetFile: function validateAndSetFile(file) {
      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.$emit('error', 'Invalid file type. Please upload a CSV file.');
        return;
      }

      var maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$emit('error', 'File size exceeds 10MB limit. Please upload a smaller file.');
        return;
      }

      this.uploadedFile = file;
      this.$emit('file-selected', file);
    },
    removeFile: function removeFile() {
      this.uploadedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.$emit('file-removed');
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatisticsCards',
  props: {
    statistics: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          totalProducts: 0,
          costsSet: 0,
          missingCosts: 0,
          percentageSet: 0
        };
      }
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkflowStep',
  props: {
    stepNumber: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountHealth',
  props: {
    accountHealth: {
      type: Object,
      required: true
    },
    isFeaturedMerchant: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyBoxFactors',
  props: {
    factors: {
      type: Array,
      required: true
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_currency__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CurrentOffers',
  props: {
    offers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    marketplace: {
      type: String,
      default: 'US'
    }
  },
  computed: {
    currencySymbol: function currencySymbol() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_currency__["a" /* getCurrencyForMarketplace */])(this.marketplace);
    }
  },
  methods: {
    statusClass: function statusClass(offer) {
      if (offer.hasBuyBox) return 'winner';
      if (offer.isMyOffer) return 'lost';
      return 'not-winning';
    },
    formatFeedbackCount: function formatFeedbackCount(count) {
      if (count == null) return '0';
      if (count >= 1000) return (count / 1000).toFixed(count >= 10000 ? 0 : 1).replace(/\.0$/, '') + 'k';
      return String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    sellerStorefrontUrl: function sellerStorefrontUrl(sellerId) {
      if (!sellerId || typeof sellerId !== 'string') return null;
      var id = sellerId.trim();

      if (!/^A[A-Z0-9]{9,}$/i.test(id)) return null;
      var suffix = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api__["a" /* getMarketplaceAmazonSuffix */])(this.marketplace) || 'com';
      return 'https://www.amazon.' + suffix + '/sp?ie=UTF8&seller=' + encodeURIComponent(id);
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiagnosisPanel',
  props: {
    diagnosis: {
      type: Object,
      required: true
    }
  },
  computed: {
    confidenceLabel: function confidenceLabel() {
      var c = (this.diagnosis.confidence || 'medium').toLowerCase();
      if (c === 'high') return 'High Confidence';
      if (c === 'low') return 'Low Confidence';
      return 'Medium Confidence';
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListingSignals',
  props: {
    signals: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_currency__ = __webpack_require__(50);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductHeader',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusType: function statusType() {
      return this.product.status.type || 'lost';
    },
    isWon: function isWon() {
      return this.statusType === 'won' || this.statusType === 'owned';
    },
    isLost: function isLost() {
      return this.statusType === 'lost';
    },
    isSuppressed: function isSuppressed() {
      return this.statusType === 'suppressed';
    },
    isContested: function isContested() {
      return this.statusType === 'contested';
    },
    marketplaceLabel: function marketplaceLabel() {
      var m = (this.product.marketplace || 'US').toUpperCase();
      if (m === 'US') return '🇺🇸 US Marketplace';
      if (m === 'UK') return '🇬🇧 UK Marketplace';
      if (m === 'DE') return '🇩🇪 DE Marketplace';
      if (m === 'CA') return '🇨🇦 CA Marketplace';
      return m + ' Marketplace';
    },
    currencySymbol: function currencySymbol() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_currency__["a" /* getCurrencyForMarketplace */])(this.product.marketplace);
    },
    alertBanner: function alertBanner() {
      if (this.isWon) return { visible: false };
      if (this.isLost) return {
        visible: true,
        bannerClass: 'banner-lost',
        text: 'A competitor is winning the Buy Box at a lower price. Review the diagnosis below to decide your next step.'
      };
      if (this.isSuppressed) return {
        visible: true,
        bannerClass: 'banner-suppressed',
        text: 'Amazon has suppressed the Buy Box — no seller is winning it. Likely cause: external retailers have a lower price.'
      };
      if (this.isContested) return {
        visible: true,
        bannerClass: 'banner-contested',
        text: 'The Buy Box is rotating between you and a competitor. Prices are closely matched — Amazon is sharing impressions.'
      };
      return { visible: false };
    },
    statusTimeText: function statusTimeText() {
      var timeAgo = this.product.status.timeAgo || '';
      if (this.isWon) return 'Holding for ' + timeAgo;
      if (this.isContested) return 'Rotating · ' + timeAgo;
      return 'Since ' + timeAgo;
    },

    bbPriceDisplay: function bbPriceDisplay() {
      if (this.isWon) return this.currencySymbol + this.formatPrice(this.product.pricing.yourPrice);
      if (this.isSuppressed) return '—';
      if (this.isContested) return this.currencySymbol + this.formatPrice(this.product.pricing.buyBoxPrice || this.product.pricing.yourPrice);
      return this.product.pricing.buyBoxPrice ? this.currencySymbol + this.formatPrice(this.product.pricing.buyBoxPrice) : '—';
    },
    bbPriceClass: function bbPriceClass() {
      if (this.isWon) return 'success';
      if (this.isSuppressed) return 'muted';
      if (this.isContested) return 'info';
      return 'highlight';
    },
    bbPriceSub: function bbPriceSub() {
      if (this.isWon) return "You're winning";
      if (this.isSuppressed) return 'No Buy Box active';
      if (this.isContested) return 'Prices matched';
      return this.product.pricing.buyBoxPrice ? 'Competitor winning' : 'No data';
    },
    bbPriceSubClass: function bbPriceSubClass() {
      if (this.isWon) return 'ok';
      if (this.isSuppressed) return '';
      if (this.isContested) return 'info';
      return 'warn';
    },

    priceGapDisplay: function priceGapDisplay() {
      if (this.isWon) return this.currencySymbol + '0.00';
      if (this.isSuppressed) return '—';
      if (this.isContested) return '-' + this.currencySymbol + '0.00';
      return this.product.pricing.priceGap ? '+' + this.currencySymbol + this.formatPrice(this.product.pricing.priceGap) : this.currencySymbol + '0.00';
    },
    priceGapClass: function priceGapClass() {
      if (this.isWon) return 'success';
      if (this.isSuppressed) return 'muted';
      if (this.isContested) return 'info';
      return 'warning';
    },
    priceGapSub: function priceGapSub() {
      if (this.isWon) return 'No gap';
      if (this.isSuppressed) return 'Not applicable';
      if (this.isContested) return 'Prices tied';
      return this.product.pricing.priceGap ? this.calculatePercentage() + '% above Buy Box' : 'No gap';
    },
    priceGapSubClass: function priceGapSubClass() {
      if (this.isWon) return 'ok';
      if (this.isSuppressed) return '';
      if (this.isContested) return 'info';
      return 'warn';
    },

    lossLabel: function lossLabel() {
      if (this.isWon) return 'Daily Revenue';
      if (this.isSuppressed) return 'Est. Daily Impact';
      if (this.isContested) return 'BB Win Rate (24h)';
      return 'Est. Daily Loss';
    },
    lossValueDisplay: function lossValueDisplay() {
      if (this.isContested) return '-60%';
      var amount = Math.abs(this.product.pricing.estDailyLoss || 0);
      var formatted = this.currencySymbol + this.formatPrice(amount);
      return this.isWon ? formatted : '-' + formatted;
    },
    lossValueClass: function lossValueClass() {
      if (this.isWon) return 'success';
      if (this.isContested) return 'info';
      return 'critical';
    },
    lossSub: function lossSub() {
      if (this.isWon) return 'Based on BB-held days avg';
      if (this.isSuppressed) return 'Fallback: 30d avg (no BB data)';
      if (this.isContested) return 'Partial revenue capture';
      return 'Based on BB-held days avg';
    },
    lossSubClass: function lossSubClass() {
      if (this.isWon) return 'ok';
      if (this.isContested) return 'info';
      return 'bad';
    },
    lossTooltipText: function lossTooltipText() {
      if (this.isWon) return 'Revenue you earn while holding the Buy Box.';
      if (this.isSuppressed) return 'Estimated daily revenue impact from Buy Box suppression.';
      if (this.isContested) return 'Percentage of time you hold the Buy Box in the last 24 hours.';
      return 'Revenue you may be losing while not holding the Buy Box.';
    }
  },
  methods: {
    formatPrice: function formatPrice(val) {
      if (val == null || val === '') return '0.00';
      return Number(val).toFixed(2);
    },
    calculatePercentage: function calculatePercentage() {
      if (this.product.pricing.yourPrice && this.product.pricing.priceGap) {
        return Math.round(this.product.pricing.priceGap / this.product.pricing.yourPrice * 100);
      }
      return 0;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecentEvents',
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      selectedPeriod: '7d'
    };
  },
  computed: {
    daysToShow: function daysToShow() {
      var periodMap = { '7d': 7, '30d': 30, '90d': 90 };
      return periodMap[this.selectedPeriod] || 7;
    },
    filteredEvents: function filteredEvents() {
      return this.events || [];
    }
  },
  methods: {
    setPeriod: function setPeriod(period) {
      this.selectedPeriod = period;
      this.$emit('period-changed', this.daysToShow);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReviewHealth',
  props: {
    reviewHealth: {
      type: Object,
      default: null
    }
  },
  computed: {
    state: function state() {
      return this.reviewHealth && this.reviewHealth.state || 'hidden';
    },
    visible: function visible() {
      return this.state === 'ready' || this.state === 'waiting';
    },
    waiting: function waiting() {
      return this.state === 'waiting' || !this.latest;
    },
    latest: function latest() {
      return this.reviewHealth && this.reviewHealth.latest || null;
    },
    previous: function previous() {
      return this.reviewHealth && this.reviewHealth.previous || null;
    },
    watchdog: function watchdog() {
      return this.reviewHealth && this.reviewHealth.watchdog || null;
    },
    status: function status() {
      return this.watchdog && this.watchdog.status ? String(this.watchdog.status).toLowerCase() : '';
    },
    ratingText: function ratingText() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["a" /* formatRating */])(this.latest && this.latest.display_rating);
    },
    previousRatingText: function previousRatingText() {
      var p = this.previous;
      if (!p || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["b" /* numOrNull */])(p.display_rating) == null) return '';
      var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["c" /* formatSnapshotDate */])(p.snapshot_date);
      return 'was ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["a" /* formatRating */])(p.display_rating) + (date ? ' on ' + date : '');
    },
    countText: function countText() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["d" /* formatCount */])(this.latest && this.latest.total_rating_count);
    },
    countDeltaText: function countDeltaText() {
      var p = this.previous;
      if (!p || !this.latest) return '';
      var delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["e" /* formatSignedDelta */])(this.latest.total_rating_count, p.total_rating_count);
      if (delta == null) return '';
      var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["c" /* formatSnapshotDate */])(p.snapshot_date);
      return delta + (date ? ' since ' + date : '');
    },
    critical30dText: function critical30dText() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["d" /* formatCount */])(this.reviewHealth && this.reviewHealth.critical_reviews_30d);
    },
    asOfText: function asOfText() {
      return this.latest ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["c" /* formatSnapshotDate */])(this.latest.snapshot_date, true) : '';
    },
    reviewsUrl: function reviewsUrl() {
      return this.reviewHealth && this.reviewHealth.reviews_url || null;
    },

    sparkline: function sparkline() {
      var history = this.reviewHealth && Array.isArray(this.reviewHealth.history) ? this.reviewHealth.history : [];
      var pts = [];
      history.forEach(function (h) {
        var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["b" /* numOrNull */])(h && h.total_rating_count);
        if (n != null) pts.push(n);
      });
      if (pts.length < 2) return null;
      var min = Math.min.apply(null, pts);
      var max = Math.max.apply(null, pts);
      var span = max - min;
      var step = 200 / (pts.length - 1);
      var points = pts.map(function (v, i) {
        var y = span === 0 ? 20 : 36 - (v - min) / span * 32;
        return (i * step).toFixed(1) + ',' + y.toFixed(1);
      }).join(' ');
      return {
        points: points,
        days: history.length,
        firstText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["d" /* formatCount */])(pts[0]),
        lastText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_reviewHealth_js__["d" /* formatCount */])(pts[pts.length - 1])
      };
    }
  },
  methods: {
    flagged: function flagged(reason) {
      if (this.status !== 'red' && this.status !== 'amber') return false;
      var reasons = this.watchdog && this.watchdog.reasons || [];
      return reasons.indexOf(reason) >= 0;
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_currency__ = __webpack_require__(50);




var CHART_PAD = { top: 12, right: 16, bottom: 28, left: 40 };
var CHART_NAVY = '#1B4B82';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SalesVolumeChart',
  props: {
    salesData: {
      type: Object,
      required: true
    },
    marketplace: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      selectedPeriod: '30d',
      hoveredIdx: null,
      tooltipVisible: false,
      tooltipDate: '',
      tooltipValue: '',
      tooltipSub: ''
    };
  },
  computed: {
    currencySymbol: function currencySymbol() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_currency__["a" /* getCurrencyForMarketplace */])(this.marketplace);
    },
    daysToShow: function daysToShow() {
      var map = { '7d': 7, '30d': 30, '90d': 90 };
      return map[this.selectedPeriod] || 30;
    },
    chartData: function chartData() {
      var allData = this.salesData.chartData || this.salesData.chart_data || [];
      if (allData.length === 0) return [];
      return allData.slice(-this.daysToShow);
    },
    estimatedUnitPrice: function estimatedUnitPrice() {
      var avg = this.dailyAverageValue;
      var revenue = this.salesData.estMonthlyRevenue || this.salesData.estimated_monthly_revenue && this.salesData.estimated_monthly_revenue.dollars || 0;
      if (avg > 0 && revenue > 0) return revenue / (avg * 30);
      return 17;
    },
    dailyAverageValue: function dailyAverageValue() {
      return this.salesData.dailyAverage || this.salesData.daily_average || 0;
    },
    last7DaysValue: function last7DaysValue() {
      if (this.salesData.last7Days !== undefined) return this.salesData.last7Days;
      if (this.salesData.last_7_days && this.salesData.last_7_days.units !== undefined) return this.salesData.last_7_days.units;
      return 0;
    },
    last7DaysChangeValue: function last7DaysChangeValue() {
      if (this.salesData.last7DaysChange !== undefined) return this.salesData.last7DaysChange;
      if (this.salesData.last_7_days && this.salesData.last_7_days.percentage_change !== undefined) return this.salesData.last_7_days.percentage_change;
      return 0;
    },
    monthlyRevenueValue: function monthlyRevenueValue() {
      if (this.salesData.estMonthlyRevenue !== undefined) return this.salesData.estMonthlyRevenue.toLocaleString();
      if (this.salesData.estimated_monthly_revenue && this.salesData.estimated_monthly_revenue.dollars !== undefined) return this.salesData.estimated_monthly_revenue.dollars.toLocaleString();
      return '0';
    }
  },
  methods: {
    setPeriod: function setPeriod(period) {
      this.selectedPeriod = period;
      this.hoveredIdx = null;
      this.tooltipVisible = false;
      var self = this;
      this.$nextTick(function () {
        self.drawChart(null);
      });
    },
    parseDate: function parseDate(dateStr) {
      if (!dateStr) return new Date();
      var s = String(dateStr);
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
        return new Date(s + 'T12:00:00');
      }
      var months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
      var parts = s.split(' ');
      if (parts.length === 2 && months[parts[0]] !== undefined) {
        return new Date(2026, months[parts[0]], parseInt(parts[1]));
      }
      return new Date(s);
    },
    formatDate: function formatDate(dateStr) {
      var d = this.parseDate(dateStr);
      if (isNaN(d.getTime())) return String(dateStr);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    },
    drawChart: function drawChart(hIdx) {
      var wrapper = this.$refs.chartWrapper;
      var canvas = this.$refs.salesCanvas;
      if (!wrapper || !canvas) return;

      var data = this.chartData;
      if (!data || data.length === 0) return;

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var W = wrapper.clientWidth;
      var H = wrapper.clientHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.scale(dpr, dpr);
      ctx.clearRect(0, 0, W, H);

      var PAD = CHART_PAD;
      var cw = W - PAD.left - PAD.right;
      var ch = H - PAD.top - PAD.bottom;
      var values = data.map(function (d) {
        return d.units || 0;
      });
      var maxV = Math.max.apply(null, values);
      var minV = Math.max(0, Math.min.apply(null, values) - 4);
      var range = maxV - minV + 1;

      function sy(v) {
        return PAD.top + ch - (v - minV) / range * ch;
      }
      function sx(i) {
        return PAD.left + (data.length > 1 ? i / (data.length - 1) * cw : cw / 2);
      }

      ctx.font = '11px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
      var gridFracs = [0, 0.33, 0.66, 1];
      for (var g = 0; g < gridFracs.length; g++) {
        var v = Math.round(minV + gridFracs[g] * (maxV - minV));
        var y = sy(v);
        ctx.strokeStyle = '#E2E8F0';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 4]);
        ctx.beginPath();
        ctx.moveTo(PAD.left, y);
        ctx.lineTo(W - PAD.right, y);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = '#94A3B8';
        ctx.textAlign = 'right';
        ctx.fillText(v, PAD.left - 5, y + 4);
      }

      var step = data.length <= 7 ? 1 : data.length <= 30 ? 5 : 15;
      ctx.textAlign = 'center';
      ctx.fillStyle = '#94A3B8';
      for (var i = 0; i < data.length; i++) {
        if (i % step === 0 || i === data.length - 1) {
          ctx.fillText(this.formatDate(data[i].date), sx(i), H - 5);
        }
      }

      var grad = ctx.createLinearGradient(0, PAD.top, 0, H - PAD.bottom);
      grad.addColorStop(0, 'rgba(27,75,130,0.22)');
      grad.addColorStop(1, 'rgba(27,75,130,0)');
      ctx.beginPath();
      ctx.moveTo(sx(0), sy(data[0].units));
      for (var i = 1; i < data.length; i++) {
        ctx.lineTo(sx(i), sy(data[i].units));
      }
      ctx.lineTo(sx(data.length - 1), H - PAD.bottom);
      ctx.lineTo(sx(0), H - PAD.bottom);
      ctx.closePath();
      ctx.fillStyle = grad;
      ctx.fill();

      ctx.beginPath();
      ctx.strokeStyle = CHART_NAVY;
      ctx.lineWidth = 2.5;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      for (var i = 0; i < data.length; i++) {
        if (i === 0) ctx.moveTo(sx(i), sy(data[i].units));else ctx.lineTo(sx(i), sy(data[i].units));
      }
      ctx.stroke();

      if (hIdx !== null && hIdx >= 0 && hIdx < data.length) {
        var hx = sx(hIdx);
        var hy = sy(data[hIdx].units);

        ctx.strokeStyle = 'rgba(27,75,130,0.2)';
        ctx.lineWidth = 1;
        ctx.setLineDash([4, 3]);
        ctx.beginPath();
        ctx.moveTo(hx, PAD.top);
        ctx.lineTo(hx, H - PAD.bottom);
        ctx.stroke();
        ctx.setLineDash([]);

        ctx.beginPath();
        ctx.arc(hx, hy, 6, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(27,75,130,0.15)';
        ctx.fill();

        ctx.beginPath();
        ctx.arc(hx, hy, 3.5, 0, Math.PI * 2);
        ctx.fillStyle = CHART_NAVY;
        ctx.fill();
        ctx.strokeStyle = 'white';
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }
    },
    onMouseMove: function onMouseMove(e) {
      var wrapper = this.$refs.chartWrapper;
      var canvas = this.$refs.salesCanvas;
      if (!wrapper || !canvas) return;

      var data = this.chartData;
      if (!data || data.length === 0) return;

      var rect = canvas.getBoundingClientRect();
      var mx = e.clientX - rect.left;
      var my = e.clientY - rect.top;
      var W = wrapper.clientWidth;
      var H = wrapper.clientHeight;
      var PAD = CHART_PAD;
      var cw = W - PAD.left - PAD.right;

      this.hoveredIdx = Math.max(0, Math.min(data.length - 1, Math.round((mx - PAD.left) / cw * (data.length - 1))));
      this.drawChart(this.hoveredIdx);

      var pt = data[this.hoveredIdx];
      this.tooltipDate = this.formatDate(pt.date);
      this.tooltipValue = pt.units + ' units sold';
      var estRevenue = Math.round(pt.units * this.estimatedUnitPrice);
      this.tooltipSub = '-' + this.currencySymbol + estRevenue.toLocaleString() + ' est. revenue';

      var tW = 168;
      var tH = 70;
      var left = mx + 14;
      var top = my - tH / 2;
      if (left + tW > W - 8) left = mx - tW - 14;
      if (top < 4) top = 4;
      if (top + tH > H - 4) top = H - tH - 4;

      var tooltip = this.$refs.chartTooltip;
      if (tooltip) {
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
      }
      this.tooltipVisible = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.tooltipVisible = false;
      this.hoveredIdx = null;
      this.drawChart(null);
    }
  },
  watch: {
    chartData: function chartData() {
      var self = this;
      this.$nextTick(function () {
        self.drawChart(null);
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      self.drawChart(null);
    });
    this._resizeHandler = function () {
      self.drawChart(self.hoveredIdx);
    };
    window.addEventListener('resize', this._resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['currentPage', 'currentPageRequested', 'maxPage'],
  methods: {
    backToOne: function backToOne() {
      if (!this.disabledFirstPage) this.$emit('back-to-1');
    },
    backToPrevious: function backToPrevious() {
      if (!this.disabledPreviousPage) this.$emit('back');
    },
    forwardToNext: function forwardToNext() {
      if (!this.disabledNextPage) this.$emit('forward');
    },
    forwardToLast: function forwardToLast() {
      if (!this.disabledLastPage) this.$emit('forward-all-the-way');
    }
  },
  computed: {
    disabledFirstPage: function disabledFirstPage() {
      return this.currentPage === 0 || this.currentPage !== this.currentPageRequested;
    },
    disabledPreviousPage: function disabledPreviousPage() {
      return this.currentPage === 0 || this.currentPage !== this.currentPageRequested;
    },
    disabledNextPage: function disabledNextPage() {
      return this.currentPage === this.maxPage || this.currentPage !== this.currentPageRequested;
    },
    disabledLastPage: function disabledLastPage() {
      return this.currentPage === this.maxPage || this.currentPage !== this.currentPageRequested;
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      shortName: this.product.shortName,
      indeterminate: this.product.active === null && !this.product.showOrig,
      value: !this.product.showOrig,
      state: this.product.active === null && !this.product.showOrig ? 'ignoredUntilFirstSale' : this.product.showOrig ? 'tracked' : 'ignored'
    };
  },
  props: ['product', 'automaticallyTrackNewProducts'],
  watch: {
    shortName: function shortName(val) {
      this.$emit('shortName-changed', { productId: this.product.productId, shortName: val });
    },
    state: function state(val) {
      if (this.state === 'ignoredUntilFirstSale') {
        this.value = true;
        this.indeterminate = true;
        this.$emit('show-changed', { productId: this.product.productId, show: null });
      } else {
        var _val = this.state === 'tracked';
        this.value = !_val;
        this.indeterminate = false;
        this.$emit('show-changed', { productId: this.product.productId, show: _val });
      }
    }
  },
  methods: {
    cycleState: function cycleState() {
      if (this.state === 'ignoredUntilFirstSale') {
        this.state = 'tracked';
      } else if (this.state === 'ignored') {
        this.state = 'ignoredUntilFirstSale';
      } else {
        this.state = 'ignored';
      }
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangePasswordModal__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddSellerAccount_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddSellerAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AddSellerAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_amazonSellingPartnerOAuth__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_productAddonBilling_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_orderVolumeBilling_js__ = __webpack_require__(48);
















var REGION_MARKETPLACE = { NA: 'us', EU: 'gb', IN: 'in', ME: 'ae', FE: 'jp' };
var MP_LABELS = { us: 'US', gb: 'UK', uk: 'UK', ca: 'CA', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', jp: 'JP', au: 'AU', 'in': 'IN', mx: 'MX', br: 'BR', nl: 'NL', sa: 'SA', ae: 'AE', sg: 'SG', se: 'SE', pl: 'PL', be: 'BE', at: 'AT', za: 'ZA', tr: 'TR', eg: 'EG' };

var NOTIFICATION_PREFS_SELLERS_URL_V1 = '/api/v1/notification-preferences/sellers';
var googleSheetsLogo = __webpack_require__(624);
var zapierLogo = __webpack_require__(625);

function userAccountRoleNorm(ua) {
  var r = String((ua && ua.role) != null ? ua.role : 'member').toLowerCase();
  if (r === 'admin' || r === 'owner') return 'admin';
  return 'member';
}

function userAccountIsWorkspaceOwner(ua) {
  return ua && (ua.is_owner === true || ua.isOwner === true);
}

function identitySettingsIsOwner(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(body)) !== 'object') return false;
  if (body.isOwner === true || body.is_owner === true) return true;
  if (body.isOwner === false || body.is_owner === false) return false;

  if (false) return true;
  return false;
}

function identitySettingsSellerAccounts(body) {
  if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(body)) !== 'object') return [];
  if (Array.isArray(body.sellerAccounts)) return body.sellerAccounts;
  if (Array.isArray(body.seller_accounts)) return body.seller_accounts;
  if (Array.isArray(body.sellers)) return body.sellers;
  return [];
}

function destroySemanticModal(selector) {
  try {
    var $m = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(selector);
    if (!$m.length || !$m.data('module-modal')) return;
    $m.modal('hide');
    $m.modal('destroy');
  } catch (e) {}
}

function clearStuckPageDimmer() {
  try {
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()('body').removeClass('dimmed');
    var $dimmer = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.ui.dimmer.modals');
    $dimmer.removeClass('visible active animating');
    $dimmer.find('.ui.modal').removeClass('visible active animating');
    $dimmer.css({ display: 'none', 'background-color': '' });
  } catch (e) {}
}

function userAccountIsAdminRow(ua) {
  if (!ua) return false;
  if (userAccountIsWorkspaceOwner(ua)) return true;
  return userAccountRoleNorm(ua) === 'admin';
}

function userAccountEmailVerifiedFromSettings(ua) {
  if (!ua) return true;
  var v = ua.emailVerified;
  if (v === undefined || v === null) v = ua.email_verified;
  if (v === undefined || v === null) return true;
  return v === true || v === 'true' || v === 1 || v === '1';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountTeamSettings',
  components: { ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_6__ChangePasswordModal___default.a, AddSellerAccount: __WEBPACK_IMPORTED_MODULE_7__AddSellerAccount_vue___default.a },
  data: function data() {
    return {
      googleSheetsLogo: googleSheetsLogo,
      zapierLogo: zapierLogo,
      loading: false,
      loadError: null,
      isOwner: false,
      loginEmail: '',
      firstName: '',
      firstNameOrig: '',
      lastName: '',
      lastNameOrig: '',
      sellers: [],
      filteredSellers: [],
      sellerNickNames: {},
      savingKillSwitches: {},
      teamUserAccounts: [],
      tenantUsers: [],
      packageDetails: null,
      addonCount: 0,

      hasDailyPricing: false,
      gsheetsConnection: { enabled: false, email: null, spreadsheetId: null, connectionError: false },
      authorizations: [],
      savingProfile: false,
      savingSellers: false,
      savingTeam: false,
      successMsg: '',
      errorMsg: '',
      assignModalMember: null,
      savingAssignModal: false,
      deletingSellerId: null,
      savingMemberRoleUserId: null,
      inviteEmail: '',
      inviteFirstName: '',
      inviteLastName: '',
      inviteSubmitting: false,
      verificationEmailSendingId: null
    };
  },
  computed: {
    profileDirty: function profileDirty() {
      return this.firstName !== this.firstNameOrig || this.lastName !== this.lastNameOrig;
    },
    sellersDirty: function sellersDirty() {
      var self = this;
      return this.filteredSellers.some(function (s) {
        var id = self.sellerIdVal(s);
        return self.sellerNickNames[id] !== undefined && self.sellerNickNames[id] !== s.nickName;
      });
    },
    teamDirty: function teamDirty() {
      if (!this.isOwner) return false;
      var self = this;
      return this.memberRows.some(function (row) {
        var ea = row.emailAddress;
        if (!ea || row.user.isOwner || ea.isDeleted) return false;
        return !self.sellerAccessEqual(ea);
      });
    },
    planName: function planName() {
      if (this.hasDailyPricing) return 'SentryKit Daily Usage Plan';
      if (!this.packageDetails) return '—';
      return this.packageDetails.name || this.packageDetails.packageName || 'Starter';
    },
    planDetail: function planDetail() {
      if (this.hasDailyPricing) return 'Billed monthly based on the number of ASINs you track';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_productAddonBilling_js__["b" /* formatAccountPlanPricingSubline */])(this.packageDetails, this.addonCount);
    },
    starterMaxStorefronts: function starterMaxStorefronts() {
      return __WEBPACK_IMPORTED_MODULE_12__utils_orderVolumeBilling_js__["q" /* STARTER_MAX_STOREFRONTS */];
    },
    isStarterPlan: function isStarterPlan() {
      if (this.hasDailyPricing) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_orderVolumeBilling_js__["r" /* isStarterOrderVolumePlan */])(this.packageDetails, null, {
        subscriptionSummary: this.$root && this.$root.subscriptionSummary
      });
    },
    canAddStorefront: function canAddStorefront() {
      if (!this.isOwner) return false;

      if (false) return true;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_orderVolumeBilling_js__["s" /* canAddStorefrontForPlan */])(this.packageDetails, this.sellers.length, {
        subscriptionSummary: this.$root && this.$root.subscriptionSummary
      });
    },
    storefrontSummary: function storefrontSummary() {
      if (!this.sellers.length) return 'None connected';
      return this.sellers.map(function (s) {
        return s.nickName || s.region;
      }).join(' · ');
    },
    teamSummary: function teamSummary() {
      if (this.teamUserAccounts.length) {
        var admins = 0;
        var members = 0;
        this.teamUserAccounts.forEach(function (a) {
          if (userAccountIsAdminRow(a)) admins++;else members++;
        });
        var parts = [];
        if (admins) parts.push(admins + ' admin' + (admins > 1 ? 's' : ''));
        if (members) parts.push(members + ' member' + (members > 1 ? 's' : ''));
        return parts.join(' · ') || '—';
      }
      var owners = this.tenantUsers.filter(function (u) {
        return u.isOwner;
      }).length;
      var mem = this.tenantUsers.length - owners;
      var p = [];
      if (owners) p.push(owners + ' admin');
      if (mem) p.push(mem + ' member' + (mem > 1 ? 's' : ''));
      return p.join(' · ') || '—';
    },
    inviteEmailTrimmed: function inviteEmailTrimmed() {
      return (this.inviteEmail || '').trim();
    },
    accountCreatedDisplay: function accountCreatedDisplay() {
      if (this.packageDetails && this.packageDetails.createdAt) {
        return new Date(this.packageDetails.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      }
      return '—';
    },
    billingCycleDisplay: function billingCycleDisplay() {
      return this.packageDetails ? 'Monthly billing' : '';
    },
    zapierAuthorizations: function zapierAuthorizations() {
      return this.authorizations.filter(function (a) {
        return a.name === 'Zapier';
      });
    },
    hasZapier: function hasZapier() {
      return this.zapierAuthorizations.length > 0;
    },
    zapierConnectedSince: function zapierConnectedSince() {
      var list = this.zapierAuthorizations;
      if (!list.length || !list[0].timestamp) return '';
      return 'since ' + new Date(list[0].timestamp).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    zapierDirectoryUrl: function zapierDirectoryUrl() {
      return "https://zapier.com/apps/sentrykit/integrations" || 'https://zapier.com/apps/sentrykit/integrations';
    },
    zapierTriggersDocUrl: function zapierTriggersDocUrl() {
      return "https://ltvfund-my.sharepoint.com/:w:/g/personal/abdul_hannan_ltv_fund/IQAPt3SrZgQcTrN2lWS0xkrxARdxkda1344Eyetk0Ekf6bQ?e=8qlmXG" || 'https://docs.google.com/document/d/15O8b4mBsAb7ccIrL05jcxJCuo9_kDemcXkgjwMy_VA4/edit?usp=sharing';
    },
    memberRows: function memberRows() {
      var self = this;
      if (this.teamUserAccounts.length) {
        return this.teamUserAccounts.map(function (account) {
          var accountEmail = account.email || '';
          var matchedUser = null;
          for (var i = 0; i < self.tenantUsers.length; i++) {
            var tenantUser = self.tenantUsers[i];
            if (tenantUser.email && String(tenantUser.email).toLowerCase() === String(accountEmail).toLowerCase()) {
              matchedUser = tenantUser;
              break;
            }
          }
          var isAdminRow = userAccountIsAdminRow(account);
          var userId = account.userId != null ? account.userId : matchedUser ? matchedUser.id : null;
          var user = {
            id: userId,
            email: accountEmail || (matchedUser ? matchedUser.email : ''),
            firstName: account.firstName || (matchedUser ? matchedUser.firstName : '') || '',
            lastName: account.lastName || (matchedUser ? matchedUser.lastName : '') || '',
            fullName: account.fullName || (matchedUser ? matchedUser.fullName : '') || '',
            isOwner: !!isAdminRow
          };
          if (!Array.isArray(account.allowedSellerAccounts)) account.allowedSellerAccounts = [];
          if (!Array.isArray(account.originalallowedSellerAccounts)) {
            account.originalallowedSellerAccounts = account.allowedSellerAccounts.map(function (x) {
              return x;
            });
          }
          account.isDeleted = false;
          account.isPrimary = !!isAdminRow;
          account.isUser = !isAdminRow;
          account.email = user.email;
          return { user: user, emailAddress: account };
        });
      }
      return [];
    }
  },
  watch: {
    profileDirty: 'syncGlobalDirty',
    sellersDirty: 'syncGlobalDirty',
    teamDirty: 'syncGlobalDirty'
  },
  created: function created() {
    window.dirty = false;
  },
  mounted: function mounted() {
    clearStuckPageDimmer();
    this.fetchAll();
    this.initAddStorefrontModal();
  },
  beforeDestroy: function beforeDestroy() {
    destroySemanticModal('#addSellerAccountModal');
    clearStuckPageDimmer();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (window.dirty) {
      if (window.confirm('You have unsaved changes. Leave anyway?')) {
        window.dirty = false;next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    fetchAll: function fetchAll() {
      this.loading = true;
      this.loadError = null;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.$http.get('/api/identity/settings'), this.$http.get('/api/identity/users'), this.$http.get('/api/billing/payment-status', { params: { timezoneOffsetMinutes: 0 - new Date().getTimezoneOffset() } }).catch(function () {
        return null;
      }), this.$http.get('/api/googlesheets/connection-status').catch(function () {
        return null;
      }), this.$http.get('/api/identity/authorizations').catch(function () {
        return null;
      })]).then(function (results) {
        self.loading = false;
        self.processSettings(results[0]);
        self.ensureTenantStorefrontsLoaded();
        self.processUsers(results[1]);
        if (results[2]) self.processBilling(results[2]);
        if (results[3]) self.gsheetsConnection = results[3].body || self.gsheetsConnection;
        if (results[4]) self.authorizations = results[4].body || [];
      }).catch(function (err) {
        self.loading = false;
        var body = err && err.body || {};
        self.loadError = body.message || 'Failed to load settings';
      });
    },
    processSettings: function processSettings(response) {
      var body = response.body || {};
      this.hasDailyPricing = !!body.dailyPricing;
      this.loginEmail = body.email || '';
      this.isOwner = identitySettingsIsOwner(body);
      this.firstName = body.firstName || body.first_name || '';
      this.firstNameOrig = this.firstName;
      this.lastName = body.lastName || body.last_name || '';
      this.lastNameOrig = this.lastName;
      var rawSellers = identitySettingsSellerAccounts(body);
      this.sellers = rawSellers;
      var rawUserAccounts = Array.isArray(body.user_account) ? body.user_account : [];
      this.teamUserAccounts = rawUserAccounts.map(function (ua) {
        var sellerIds = Array.isArray(ua.sellerIds) ? ua.sellerIds : Array.isArray(ua.seller_ids) ? ua.seller_ids : [];
        var emailAddrId = ua.emailAddressId != null ? ua.emailAddressId : ua.email_address_id != null ? ua.email_address_id : null;
        if (emailAddrId == null && ua.userAccountId != null) emailAddrId = ua.userAccountId;
        if (emailAddrId == null && ua.user_account_id != null) emailAddrId = ua.user_account_id;
        if (emailAddrId == null && ua.id != null) emailAddrId = ua.id;
        var wsOwner = userAccountIsWorkspaceOwner(ua);
        var roleNorm = userAccountRoleNorm(ua);
        var adminRow = userAccountIsAdminRow(ua);
        var fn = ua.firstName != null ? ua.firstName : ua.first_name;
        var ln = ua.lastName != null ? ua.lastName : ua.last_name;
        var full = ua.fullName != null ? ua.fullName : ua.full_name;
        if (!full && (fn || ln)) full = [fn, ln].filter(Boolean).join(' ');
        return {
          userId: ua.userId != null ? ua.userId : ua.user_id,
          email: ua.email || '',
          role: ua.role != null ? ua.role : 'member',
          roleNormalized: roleNorm,
          is_owner: wsOwner,
          isOwner: wsOwner,
          firstName: fn || '',
          lastName: ln || '',
          fullName: full || '',
          emailAddressId: emailAddrId,
          allowedSellerAccounts: sellerIds.map(function (id) {
            return id;
          }),
          originalallowedSellerAccounts: sellerIds.map(function (id) {
            return id;
          }),
          isDeleted: false,
          isPrimary: adminRow,
          isUser: !adminRow,
          emailVerified: userAccountEmailVerifiedFromSettings(ua)
        };
      });
      this.syncRootEmailVerificationFromTeam();
      this.applyStorefrontDisplayList(rawSellers);
    },

    syncRootEmailVerificationFromTeam: function syncRootEmailVerificationFromTeam() {
      var root = this.$root;
      if (!root || !root.applyEmailVerificationStatus) return;
      var login = String(this.loginEmail || root.userEmail || '').toLowerCase();
      if (!login) return;
      var match = this.teamUserAccounts.filter(function (ua) {
        return String(ua.email || '').toLowerCase() === login;
      })[0];
      if (!match) return;

      if (root.emailVerified === true && !match.emailVerified) return;
      root.applyEmailVerificationStatus({
        emailVerified: !!match.emailVerified,
        email: match.email,
        emailAddressId: match.emailAddressId
      });
    },

    applyStorefrontDisplayList: function applyStorefrontDisplayList(list) {
      this.filteredSellers = Array.isArray(list) ? list.slice() : [];
      this.sellerNickNames = {};
    },
    mapV1SellerRowToStorefront: function mapV1SellerRowToStorefront(row) {
      if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(row)) !== 'object') return null;
      var sid = row.sellerId != null ? row.sellerId : row.seller_id;
      if (sid != null && (typeof sid === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(sid)) === 'object' && sid.value !== undefined) sid = sid.value;
      if (sid == null || sid === '') sid = row.id;
      if (sid != null && (typeof sid === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(sid)) === 'object' && sid.value !== undefined) sid = sid.value;
      if (sid == null || sid === '') return null;
      var skey = row.sellerKey != null ? row.sellerKey : row.seller_key;
      if (skey != null && (typeof skey === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(skey)) === 'object' && skey.value !== undefined) skey = skey.value;
      var mp = row.marketplace;
      if (mp == null || mp === '') mp = row.marketplaces || row.marketplaceCodes || row.marketplace_codes;
      var flags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__["a" /* flagsFromSellerRow */])(row);
      return {
        sellerId: sid,
        sellerKey: skey != null ? skey : sid,
        nickName: row.nickName || row.nickname || row.accountNickName || row.name || '',
        region: row.region || row.marketplaceRegion || 'NA',
        marketplace: mp,
        marketplaceId: row.marketplaceId || row.marketplace_id || null,
        mayNeedReauthorization: !!(row.mayNeedReauthorization || row.may_need_reauthorization),
        setupCompleted: row.setupCompleted !== false && row.setup_completed !== false,
        alertsEnabled: flags.alertsEnabled
      };
    },
    ensureTenantStorefrontsLoaded: function ensureTenantStorefrontsLoaded() {
      var self = this;
      var identitySellers = Array.isArray(this.sellers) ? this.sellers.slice() : [];
      return this.$http.get('/api/v1/sellers').then(function (res) {
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(res.body || {});
        var mapped = items.map(function (row) {
          return self.mapV1SellerRowToStorefront(row);
        }).filter(Boolean);
        if (mapped.length) {
          self.sellers = mapped;
          self.applyStorefrontDisplayList(mapped);
        } else {
          var mappedIdentity = identitySellers.map(function (row) {
            return self.mapV1SellerRowToStorefront(row) || row;
          }).filter(Boolean);
          self.applyStorefrontDisplayList(mappedIdentity.length ? mappedIdentity : identitySellers);
        }
      }, function () {
        var mappedIdentityFail = identitySellers.map(function (row) {
          return self.mapV1SellerRowToStorefront(row) || row;
        }).filter(Boolean);
        self.applyStorefrontDisplayList(mappedIdentityFail.length ? mappedIdentityFail : identitySellers);
      });
    },
    processUsers: function processUsers(response) {
      var body = response.body || {};
      var list = Array.isArray(body.users) ? body.users : [];
      this.tenantUsers = list.map(function (u) {
        var fn = u.first_name != null ? u.first_name : u.firstName;
        var ln = u.last_name != null ? u.last_name : u.lastName;
        var full = u.full_name != null ? u.full_name : u.fullName;
        var em = u.email || u.user_email || u.userEmail;
        if (!full && (fn || ln)) full = [fn, ln].filter(Boolean).join(' ');
        return {
          id: u.id != null ? u.id : u.user_id != null ? u.user_id : u.userId != null ? u.userId : u.uid != null ? u.uid : u.user && (u.user.id || u.user.user_id),
          email: em,
          firstName: fn,
          lastName: ln,
          fullName: full || '',
          isOwner: !!(u.is_owner != null ? u.is_owner : u.isOwner)
        };
      });
    },
    processBilling: function processBilling(response) {
      var body = response.body || {};
      this.packageDetails = body.packageDetails || null;
      var pd = this.packageDetails;
      this.addonCount = body.addonCount != null ? body.addonCount : pd && pd.addonCount != null ? pd.addonCount : 0;
    },
    sellerIdVal: function sellerIdVal(s) {
      if (!s) return null;
      if (s.sellerId != null) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(s.sellerId) === 'object' && s.sellerId.value !== undefined) return s.sellerId.value;
        return s.sellerId;
      }
      if (s.seller_id != null) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(s.seller_id) === 'object' && s.seller_id.value !== undefined) return s.seller_id.value;
        return s.seller_id;
      }
      if (s.id != null) return s.id;
      return null;
    },
    sellerKeyVal: function sellerKeyVal(s) {
      if (!s) return '';
      if (s.sellerKey != null) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(s.sellerKey) === 'object' && s.sellerKey.value !== undefined) return s.sellerKey.value;
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(s.sellerKey) !== 'object') return s.sellerKey;
      }
      if (s.seller_key != null && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(s.seller_key) !== 'object') return s.seller_key;
      var id = this.sellerIdVal(s);
      return id != null ? id : '';
    },
    sellerMarketplaceFlag: function sellerMarketplaceFlag(s) {
      var mp = s.marketplaceIso31662Code || REGION_MARKETPLACE[s.region] || 'us';return mp.toLowerCase();
    },
    sellerMarketplaceCode: function sellerMarketplaceCode(s) {
      var mp = this.sellerMarketplaceFlag(s);return MP_LABELS[mp] || mp.toUpperCase();
    },
    sellerMarketplaceChips: function sellerMarketplaceChips(s) {
      var self = this;
      var arr = s && (s.marketplace || s.marketplaces || s.marketplaceCodes || s.marketplace_codes);
      if (arr && !Array.isArray(arr) && typeof arr === 'string') arr = arr.split(',');
      if (Array.isArray(arr) && arr.length > 0) {
        var seen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(null);
        var chips = [];
        for (var i = 0; i < arr.length; i++) {
          var raw = arr[i];
          if (raw == null || raw === '') continue;
          if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(raw)) === 'object') {
            raw = raw.code || raw.marketplace || raw.marketplaceCode || raw.marketplace_code || raw.countryCode;
          }
          if (raw == null || raw === '') continue;
          var code = String(raw).trim().toLowerCase();
          if (code === 'gb') code = 'uk';
          if (seen[code]) continue;
          seen[code] = true;
          chips.push({ flag: code === 'uk' ? 'gb' : code, label: MP_LABELS[code] || code.toUpperCase() });
        }
        if (chips.length > 0) return chips;
      }
      var f = self.sellerMarketplaceFlag(s);
      return [{ flag: f, label: self.sellerMarketplaceCode(s) }];
    },
    sellerNicknameDisplay: function sellerNicknameDisplay(seller) {
      var id = this.sellerIdVal(seller);
      if (id != null && id !== '' && this.sellerNickNames[id] !== undefined) {
        return this.sellerNickNames[id];
      }
      return seller && seller.nickName != null ? seller.nickName : '';
    },
    onNickNameInput: function onNickNameInput(seller, value) {
      var id = this.sellerIdVal(seller);
      if (id == null || id === '') return;
      this.$set(this.sellerNickNames, id, value);
    },
    sellerAlertsEnabled: function sellerAlertsEnabled(seller) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__["a" /* flagsFromSellerRow */])(seller).alertsEnabled;
    },
    killSwitchKey: function killSwitchKey(seller, field) {
      var id = this.sellerIdVal(seller);
      if (id == null || id === '') return '';
      return String(id) + ':' + field;
    },
    killSwitchBusy: function killSwitchBusy(seller) {
      var id = this.sellerIdVal(seller);
      if (id == null || id === '') return false;
      var sid = String(id);
      return !!this.savingKillSwitches[sid + ':alertsEnabled'];
    },
    patchSellerOnLists: function patchSellerOnLists(id, updated) {
      var self = this;
      function apply(list) {
        if (!Array.isArray(list)) return;
        for (var i = 0; i < list.length; i++) {
          if (String(self.sellerIdVal(list[i])) === String(id)) {
            self.$set(list, i, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, list[i], updated));
            break;
          }
        }
      }
      apply(this.filteredSellers);
      apply(this.sellers);
    },
    onStopToggle: function onStopToggle(seller, field, stopChecked) {
      if (!this.isOwner) return;
      var id = this.sellerIdVal(seller);
      if (id == null || id === '') return;
      if (this.killSwitchBusy(seller)) return;
      var key = this.killSwitchKey(seller, field);
      if (!key) return;
      var prev = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, seller);
      var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__["b" /* patchBodyForStopToggle */])(field, stopChecked);
      var optimistic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__["c" /* mergeKillSwitchFlags */])(seller, body);
      this.patchSellerOnLists(id, optimistic);
      this.$set(this.savingKillSwitches, key, true);
      var self = this;
      this.$http.patch('/api/v1/sellers/' + encodeURIComponent(String(id)), body).then(function (res) {
        self.$set(self.savingKillSwitches, key, false);
        self.patchSellerOnLists(id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_sellerKillSwitches_js__["c" /* mergeKillSwitchFlags */])(optimistic, res.body || {}));
      }, function (err) {
        self.$set(self.savingKillSwitches, key, false);
        self.patchSellerOnLists(id, prev);
        if (err && err.status === 401) return;
        var msg = err && err.body && err.body.message;
        if (Array.isArray(msg)) msg = msg.filter(Boolean).join(', ');
        self.flashError(typeof msg === 'string' && msg || err && err.message || 'Could not update seller alerts');
      });
    },
    memberAssignedAccounts: function memberAssignedAccounts(member) {
      if (!member.emailAddress || !member.emailAddress.allowedSellerAccounts) return [];
      var self = this;
      return member.emailAddress.allowedSellerAccounts.map(function (sid) {
        var seller = self.sellers.filter(function (s) {
          return String(self.sellerIdVal(s)) === String(sid);
        })[0];
        return seller ? seller.nickName : String(sid);
      });
    },
    memberIsVerified: function memberIsVerified(member) {
      return member.emailAddress ? !!member.emailAddress.emailVerified : false;
    },

    memberEmailAddressId: function memberEmailAddressId(member) {
      var ea = member && member.emailAddress;
      if (ea) {
        var id = ea.emailAddressId != null ? ea.emailAddressId : ea.email_address_id;
        if (id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined) id = id.value;
        if (id != null && id !== '') return id;
      }
      var uid = member && member.user && member.user.id != null ? member.user.id : null;
      return uid != null && uid !== '' ? uid : null;
    },
    memberVerificationButtonKey: function memberVerificationButtonKey(member) {
      var id = this.memberEmailAddressId(member);
      return id != null ? String(id) : '';
    },
    isSelfMemberRow: function isSelfMemberRow(member) {
      if (!member || !member.user || !member.user.email || !this.loginEmail) return false;
      return String(member.user.email).toLowerCase() === String(this.loginEmail).toLowerCase();
    },
    canSendVerificationForMember: function canSendVerificationForMember(member) {
      return this.isOwner || this.isSelfMemberRow(member);
    },
    showVerifyEmailButton: function showVerifyEmailButton(member) {
      if (this.memberIsVerified(member)) return false;
      if (!this.memberEmailAddressId(member)) return false;
      return this.canSendVerificationForMember(member);
    },
    sendMemberVerificationEmail: function sendMemberVerificationEmail(member) {
      var self = this;
      if (!this.showVerifyEmailButton(member)) return;
      var addrId = this.memberEmailAddressId(member);
      if (addrId == null || addrId === '') {
        this.flashError('Missing email record for this member.');
        return;
      }
      var idKey = String(addrId);
      this.verificationEmailSendingId = idKey;
      this.errorMsg = '';
      this.$http.post('/api/identity/emailverification/' + encodeURIComponent(idKey)).then(function () {
        self.verificationEmailSendingId = null;
        var email = member.user && member.user.email ? member.user.email : '';
        self.flash('Verification email sent to ' + email);
      }).catch(function (err) {
        self.verificationEmailSendingId = null;
        var b = err && err.body;
        var msg = b && (b.message || b.error) || err.message || 'Could not send verification email';
        self.flashError(typeof msg === 'string' ? msg : 'Could not send verification email');
      });
    },
    sellerAccessEqual: function sellerAccessEqual(ea) {
      var o = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a((ea.originalallowedSellerAccounts || []).map(String));
      var c = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a((ea.allowedSellerAccounts || []).map(String));
      if (o.size !== c.size) return false;
      var ok = true;
      o.forEach(function (x) {
        if (!c.has(x)) ok = false;
      });
      return ok;
    },
    syncGlobalDirty: function syncGlobalDirty() {
      window.dirty = !!(this.profileDirty || this.sellersDirty || this.teamDirty);
    },
    memberRoleIsLocked: function memberRoleIsLocked(member) {
      var ea = member && member.emailAddress;
      if (!ea) return true;
      return ea.is_owner === true || ea.isOwner === true;
    },

    memberRoleBadgeLabel: function memberRoleBadgeLabel(member) {
      var ea = member && member.emailAddress;
      var u = member && member.user;
      var ws = ea && (ea.is_owner === true || ea.isOwner === true);
      var r = ea ? String(ea.role || '').toLowerCase() : '';
      var adminRole = r === 'admin' || r === 'owner';
      if (ws && adminRole) return 'Admin & Owner';
      if (ws) return 'Owner';
      if (u && u.isOwner) return 'Admin';
      return 'Member';
    },
    memberRoleSelectValue: function memberRoleSelectValue(member) {
      var ea = member && member.emailAddress;
      if (!ea) return 'member';
      return ea.roleNormalized === 'admin' ? 'admin' : 'member';
    },
    onMemberRoleChange: function onMemberRoleChange(member, nextRole) {
      var self = this;
      if (!this.isOwner || this.memberRoleIsLocked(member)) return;
      var ea = member.emailAddress;
      if (!ea) return;
      var prev = this.memberRoleSelectValue(member);
      if (nextRole === prev) return;
      var rawUserId = ea.userId != null ? ea.userId : ea.user_id;
      if (rawUserId == null || rawUserId === '') {
        rawUserId = member.user && member.user.id != null ? member.user.id : null;
      }
      var userId = rawUserId != null && (typeof rawUserId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(rawUserId)) === 'object' && rawUserId.value !== undefined ? rawUserId.value : rawUserId;
      if (userId == null || userId === '') {
        this.flashError('Cannot update role: missing user id.');
        return;
      }
      this.savingMemberRoleUserId = userId;
      this.errorMsg = '';
      this.$http.patch('/api/v1/users/' + encodeURIComponent(String(userId)) + '/role', { role: nextRole }).then(function () {
        self.savingMemberRoleUserId = null;
        self.flash('Role updated');
        self.fetchAll();
      }).catch(function (err) {
        self.savingMemberRoleUserId = null;
        self.flashError(err.body && err.body.message || err.message || 'Role update failed');
      });
    },
    openAssignSellersModal: function openAssignSellersModal(member) {
      if (!member.emailAddress || !this.isOwner) return;
      if (this.memberRoleIsLocked(member)) return;
      this.assignModalMember = member;
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#assignSellersModal').modal('show');
      });
    },
    closeAssignSellersModal: function closeAssignSellersModal() {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#assignSellersModal').modal('hide');
      this.assignModalMember = null;
      this.savingAssignModal = false;
    },
    confirmAssignSellersModal: function confirmAssignSellersModal() {
      var self = this;
      var member = this.assignModalMember;
      if (!member || !member.emailAddress || !this.isOwner) {
        this.closeAssignSellersModal();
        return;
      }
      var ea = member.emailAddress;
      this.savingAssignModal = true;
      this.errorMsg = '';
      this.persistNotificationPrefsSellerAssignments(ea, member.user).then(function () {
        self.savingAssignModal = false;
        window.dirty = false;
        self.flash('Assignments saved');
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#assignSellersModal').modal('hide');
        self.assignModalMember = null;
        self.fetchAll();
      }).catch(function (err) {
        self.savingAssignModal = false;
        var msg = err.body && err.body.message || err.message || 'Save failed';
        self.flashError(msg);
      });
    },
    assignModalSellerChecked: function assignModalSellerChecked(seller) {
      if (!this.assignModalMember || !this.assignModalMember.emailAddress) return false;
      var id = String(this.sellerIdVal(seller));
      var list = this.assignModalMember.emailAddress.allowedSellerAccounts || [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]) === id) return true;
      }
      return false;
    },
    assignModalToggleSeller: function assignModalToggleSeller(seller) {
      if (!this.assignModalMember || !this.assignModalMember.emailAddress) return;
      var ea = this.assignModalMember.emailAddress;
      var id = this.sellerIdVal(seller);
      var list = (ea.allowedSellerAccounts || []).slice();
      var ix = -1;
      for (var j = 0; j < list.length; j++) {
        if (String(list[j]) === String(id)) {
          ix = j;
          break;
        }
      }
      if (ix >= 0) list.splice(ix, 1);else list.push(id);
      this.$set(ea, 'allowedSellerAccounts', list);
    },
    prefsSellerIdsForEa: function prefsSellerIdsForEa(ea) {
      var self = this;
      var list = this.sellers.filter(function (s) {
        var sid = self.sellerIdVal(s);
        return (ea.allowedSellerAccounts || []).some(function (id) {
          return String(id) === String(sid);
        });
      });
      return list.map(function (s) {
        var sid = self.sellerIdVal(s);
        var raw = sid != null && (typeof sid === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(sid)) === 'object' && sid.value !== undefined ? sid.value : sid;
        if (raw == null || raw === '') return null;
        var str = String(raw).trim();
        var n = Number(str);
        if (!isNaN(n) && isFinite(n) && /^-?\d+$/.test(str)) return n;
        return str;
      }).filter(function (x) {
        return x != null && x !== '';
      });
    },
    tenantUserIdForNotificationPrefs: function tenantUserIdForNotificationPrefs(email) {
      if (!email) return null;
      var em = String(email).toLowerCase();
      for (var i = 0; i < this.tenantUsers.length; i++) {
        var u = this.tenantUsers[i];
        if (!u.email || String(u.email).toLowerCase() !== em || u.isOwner) continue;
        var id = u.id;
        var raw = id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined ? id.value : id;
        if (raw == null || raw === '') continue;
        var str = String(raw).trim();
        var n = Number(str);
        if (!isNaN(n) && isFinite(n) && /^-?\d+$/.test(str)) return n;
        return raw;
      }
      return null;
    },
    persistNotificationPrefsSellerAssignments: function persistNotificationPrefsSellerAssignments(ea) {
      var userId = ea && ea.userId != null ? ea.userId : null;
      var sellerIds = this.prefsSellerIdsForEa(ea);
      var payload = {
        seller_ids: sellerIds
      };
      if (userId != null && userId !== '') payload.user_id = userId;
      return this.$http.put(NOTIFICATION_PREFS_SELLERS_URL_V1, payload);
    },
    changePassword: function changePassword() {
      this.$refs.changePasswordModal.show();
    },
    addStorefront: function addStorefront() {
      if (!this.canAddStorefront) return;
      this.initAddStorefrontModal();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addSellerAccountModal').modal('show');
    },
    initAddStorefrontModal: function initAddStorefrontModal() {
      destroySemanticModal('#addSellerAccountModal');
      var $m = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#addSellerAccountModal');
      if (!$m.length) return;
      $m.modal({
        detachable: true,
        autofocus: false,
        observeChanges: false,
        closable: true,
        onHidden: function onHidden() {
          clearStuckPageDimmer();
        }
      });
    },
    resetInviteMemberForm: function resetInviteMemberForm() {
      this.inviteEmail = '';
      this.inviteFirstName = '';
      this.inviteLastName = '';
    },
    inviteMember: function inviteMember() {
      this.resetInviteMemberForm();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#inviteMemberModal').modal('show');
    },
    closeInviteMemberModal: function closeInviteMemberModal() {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#inviteMemberModal').modal('hide');
      this.resetInviteMemberForm();
    },
    submitInviteMember: function submitInviteMember() {
      var email = this.inviteEmailTrimmed;
      if (!email) {
        this.flashError('Enter an email address.');
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.flashError('Enter a valid email address.');
        return;
      }
      var self = this;
      var timezoneOffsetMins = 0 - new Date().getTimezoneOffset();
      var payload = {
        email: email,
        firstName: (this.inviteFirstName || '').trim(),
        lastName: (this.inviteLastName || '').trim(),
        timezoneOffsetMins: timezoneOffsetMins
      };
      this.inviteSubmitting = true;
      this.$http.post('/api/auth/addUser', payload).then(function () {
        self.inviteSubmitting = false;
        self.flash('Invitation sent to ' + email + '. They will also receive an email to verify their address.');
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#inviteMemberModal').modal('hide');
        self.resetInviteMemberForm();
        self.fetchAll();
      }).catch(function (err) {
        self.inviteSubmitting = false;
        var b = err && err.body;
        var msg = b && (b.error || b.message) || err.message || 'Failed to send invitation';
        self.flashError(msg);
      });
    },
    saveProfile: function saveProfile() {
      this.savingProfile = true;
      var self = this;
      this.$http.put('/api/identity/settings', {
        firstName: this.firstName,
        lastName: this.lastName,
        changedEmailAddresses: [],
        deletedEmailAddresses: [],
        sellerAccountNewNames: []
      }).then(function () {
        self.savingProfile = false;
        self.firstNameOrig = self.firstName;
        self.lastNameOrig = self.lastName;
        window.dirty = false;
        self.flash('Profile saved');
      }).catch(function (err) {
        self.savingProfile = false;
        self.flashError(err.body && err.body.message || 'Save failed');
      });
    },
    saveSellers: function saveSellers() {
      var self = this;
      var updates = [];
      this.filteredSellers.forEach(function (s) {
        var id = self.sellerIdVal(s);
        if (id == null || id === '') return;
        if (self.sellerNickNames[id] !== undefined && self.sellerNickNames[id] !== s.nickName) {
          updates.push({ id: id, name: String(self.sellerNickNames[id]).trim() });
        }
      });
      if (!updates.length) return;
      this.savingSellers = true;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(updates.map(function (u) {
        var path = '/api/v1/sellers/' + encodeURIComponent(String(u.id));
        return self.$http.put(path, { name: u.name });
      })).then(function () {
        self.savingSellers = false;
        self.sellerNickNames = {};
        window.dirty = false;
        self.flash('Storefronts saved');
        self.fetchAll();
      }).catch(function (err) {
        self.savingSellers = false;
        self.flashError(err.body && err.body.message || err.message || 'Save failed');
      });
    },
    saveTeam: function saveTeam() {
      var self = this;
      var dirtyRows = this.memberRows.filter(function (row) {
        var ea = row.emailAddress;
        return !!(ea && !row.user.isOwner && !ea.isDeleted && !self.sellerAccessEqual(ea));
      });
      if (!dirtyRows.length) {
        this.flash('No assignment changes to save');
        return;
      }

      this.savingTeam = true;
      this.errorMsg = '';
      var chain = dirtyRows.map(function (row) {
        return self.persistNotificationPrefsSellerAssignments(row.emailAddress, row.user);
      });

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(chain).then(function () {
        self.savingTeam = false;
        window.dirty = false;
        self.flash('Team assignments saved');
        self.fetchAll();
      }).catch(function (err) {
        self.savingTeam = false;
        var msg = err.body && err.body.message || err.message || 'Save failed';
        self.flashError(msg);
      });
    },
    reauthorizeSeller: function reauthorizeSeller(seller) {
      var data = {
        region: seller.region,
        marketplace: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(seller.region, seller.marketplaceId || seller.marketplace_id),
        path: this.$route.path,
        accName: seller.nickName,
        expectedSellerKey: this.sellerKeyVal(seller)
      };
      this.$http.get('/api/identity/amazon/authorization/redirect', { params: data }).then(function (response) {
        window.location = response.body.location;
      }).catch(function (err) {
        window.alert(err.body && err.body.message || 'Re-authorization failed');
      });
    },
    deleteSeller: function deleteSeller(seller) {
      if (!window.confirm('Delete storefront ' + (seller.nickName || this.sellerKeyVal(seller)) + '?')) return;
      var sid = this.sellerIdVal(seller);
      if (sid == null || sid === '') {
        this.flashError('Cannot delete storefront: missing seller id.');
        return;
      }
      var self = this;
      var sidKey = String(sid);
      this.deletingSellerId = sidKey;
      this.$http.delete('/api/v1/sellers/' + encodeURIComponent(sidKey)).then(function () {
        self.deletingSellerId = null;
        self.flash('Storefront removed');
        self.fetchAll();
      }).catch(function (err) {
        self.deletingSellerId = null;
        self.flashError(err.body && err.body.message || 'Delete failed');
      });
    },
    removeMember: function removeMember(member) {
      if (!window.confirm('Remove ' + (member.user.fullName || member.user.email) + ' from the team?')) return;
      if (this.memberRoleIsLocked(member)) {
        this.flashError('Cannot remove the workspace owner.');
        return;
      }
      if (member.user && member.user.isOwner) {
        this.flashError('Cannot remove an admin account from here.');
        return;
      }
      var ea = member.emailAddress;
      var self = this;
      if (!ea) {
        this.flashError('No email record found for this member.');
        return;
      }
      var rawUserId = ea.userId != null ? ea.userId : ea.user_id;
      if (rawUserId == null || rawUserId === '') {
        rawUserId = member.user && member.user.id != null ? member.user.id : null;
      }
      var userId = rawUserId != null && (typeof rawUserId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(rawUserId)) === 'object' && rawUserId.value !== undefined ? rawUserId.value : rawUserId;
      if (userId == null || userId === '') {
        this.flashError('Cannot remove member: missing user id.');
        return;
      }
      this.$http.delete('/api/v1/users/' + encodeURIComponent(String(userId))).then(function () {
        self.flash('Member removed');
        self.fetchAll();
      }).catch(function (err) {
        self.flashError(err.body && err.body.message || err.message || 'Remove failed');
      });
    },
    connectGoogleSheets: function connectGoogleSheets() {
      this.$http.get('/api/googlesheets/authorizationurl').then(function (r) {
        window.open(r.body, '_blank');
      });
    },
    openGoogleSheet: function openGoogleSheet() {
      if (this.gsheetsConnection.spreadsheetId) window.open('https://docs.google.com/spreadsheets/d/' + this.gsheetsConnection.spreadsheetId, '_blank');
    },
    revokeGoogleSheets: function revokeGoogleSheets() {
      if (!window.confirm('Revoke Google Sheets connection?')) return;
      var gs = this.authorizations.filter(function (a) {
        return a.name === 'Google Sheets';
      });
      if (gs.length) {
        var self = this;
        this.$http.delete('/api/identity/authorization/' + gs[0].id).then(function () {
          self.fetchAll();
        });
      }
    },
    revokeZapier: function revokeZapier() {
      if (!window.confirm('Revoke Zapier connection?')) return;
      var zapier = this.zapierAuthorizations;
      if (!zapier.length) return;
      var self = this;
      this.$http.delete('/api/identity/authorization/' + zapier[0].id).then(function () {
        self.flash('Zapier connection revoked');
        self.fetchAll();
      }).catch(function (err) {
        self.flashError(err.body && err.body.message || err.message || 'Revoke failed');
      });
    },
    onAddSellerError: function onAddSellerError(msg) {
      this.flashError(msg);
    },
    flash: function flash(msg) {
      this.successMsg = msg;var self = this;setTimeout(function () {
        self.successMsg = '';
      }, 3000);
    },
    flashError: function flashError(msg) {
      this.errorMsg = msg;var self = this;setTimeout(function () {
        self.errorMsg = '';
      }, 5000);
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AmazonRegionConnect_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AmazonRegionConnect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AmazonRegionConnect_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AmazonRegionConnect: __WEBPACK_IMPORTED_MODULE_0__AmazonRegionConnect_vue___default.a
  },
  props: {
    showNickname: {
      default: true,
      type: Boolean
    },
    cssClass: {
      default: '',
      type: String
    }
  },
  methods: {
    onConnectError: function onConnectError(message) {
      this.$emit('error', message);
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);









var MP_LABELS = { us: 'US', gb: 'UK', uk: 'UK', ca: 'CA', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', jp: 'JP', au: 'AU', 'in': 'IN', mx: 'MX', br: 'BR', nl: 'NL', sa: 'SA', ae: 'AE', sg: 'SG', se: 'SE', pl: 'PL', be: 'BE', at: 'AT', za: 'ZA', tr: 'TR', eg: 'EG' };
var REGION_MARKETPLACE = { NA: 'us', EU: 'gb', IN: 'in', ME: 'ae', FE: 'jp' };

var ROWS = [{ id: 'buybox_lost', alertCategory: 'buybox_lost', category: 'Buy Box & Pricing', title: 'Buy Box Issues', includes: 'Buy Box state, winning seller ID, listing price, shipping cost, fulfillment type (FBA/FBM), seller feedback rating, Prime status.', wdt: 'LOST_BUYBOX', deliveryRealtimeBadgeOnly: true, delayMinutesConfigurable: true, brandFilter: 'buybox_lost', brandFilterHint: 'Only alert when the Buy Box is lost on listings of these brands.' }, { id: 'no_featured_offer', alertCategory: 'no_featured_offer', category: 'Buy Box & Pricing', title: 'No Featured Offer (nobody holds the Buy Box)', includes: 'ASIN, SKU, since when, likely cause, and whether it is still unowned or back to you. Real-time re-checks the listing after about 25 minutes before emailing; Daily lists them in one morning email.', note: 'Separate from Buy Box Issues: turning this off does not stop Buy Box lost alerts.', localKey: 'NO_FEATURED_OFFER', deliveryOptions: ['realtime', 'daily'], brandFilter: 'no_featured_offer', brandFilterHint: 'Only alert when nobody holds the Buy Box on listings of these brands.' }, { id: 'competitor_price', alertCategory: 'listing_price_change', category: 'Buy Box & Pricing', title: 'Price Change', includes: 'ASIN, seller ID, old price, new price, % change, fulfillment type, Buy Box impact.', wdt: 'PRICE', deliveryRealtimeBadgeOnly: true, brandFilter: 'price_change', brandFilterHint: 'Only alert when your price changes on listings of these brands.' }, { id: 'competitor_price_change', alertCategory: 'competitor_price_change', category: 'Buy Box & Pricing', title: 'Competitor Price Change', includes: 'ASIN, competitor seller ID, old competitor price, new competitor price, % change, Buy Box impact.', localKey: 'COMPETITOR_PRICE_CHANGE', deliveryRealtimeBadgeOnly: true, brandFilter: 'competitor_price', brandFilterHint: 'Only alert when a competitor changes their price on listings of these brands.' }, { id: 'competitive_price', alertCategory: 'competitive_price', category: 'Buy Box & Pricing', title: "Amazon competitive price (external price check)", includes: 'When your price + shipping goes above Amazon\'s competitive price, and when it comes back within it: ASIN, SKU, brand, competitive price old → new, your price + shipping per offer, gap, Buy Box holder, Manage Inventory link.', localKey: 'COMPETITIVE_PRICE', deliveryRealtimeBadgeOnly: true, tenantFlag: 'competitivePriceAlerts', brandFilter: 'competitive_price', brandFilterHint: 'Only alert (and include in the daily changes email) on listings of these brands. Separate from the Competitor Price Change list.' }, { id: 'competitive_price_change', alertCategory: 'competitive_price_change', category: 'Buy Box & Pricing', title: 'Amazon competitive price changes (daily)', includes: 'Every change Amazon made to its competitive price in the last 24 hours: counts per brand, listings above it now, CSV of all changes.', localKey: 'COMPETITIVE_PRICE_CHANGE', digestFixed: true, tenantFlag: 'competitivePriceAlerts', brandFilter: 'competitive_price', brandFilterHint: 'Same brand list as Amazon competitive price (external price check). The daily email only includes listings of these brands.' }, { id: 'price_floor', alertCategory: 'price_floor_breach', category: 'Buy Box & Pricing', title: 'Price Floor Breach', includes: 'ASIN, competitor price, your floor price, COGS, margin delta, recommended action.', note: 'Requires COGS to be set.', localKey: 'PRICE_FLOOR', alwaysOn: true, deliveryRealtimeBadgeOnly: true }, { id: 'hijacker', alertCategory: 'hijacker', category: 'Competitive', title: 'Hijacker Alert', includes: 'ASIN, seller ID, business name, location, feedback rating, current price, fulfillment type, storefront link.', localKey: 'HIJACKER', defaultOn: true, deliveryRealtimeBadgeOnly: true, brandFilter: 'hijacker', brandFilterHint: 'Only alert when a new seller appears on listings of these brands.' }, { id: 'suspended', alertCategory: 'listing_suppressed', category: 'Listing Health', title: 'Suspended Listings', includes: 'ASIN, suspension reason, suspension date, reinstatement steps (where Amazon provides them), and an all-clear email once Amazon stops reporting the issue.', localKey: 'LISTING_SUPPRESSED', defaultOn: true, deliveryRealtimeBadgeOnly: true, subtypes: 'listing_suppressed', brandFilter: 'listing_suppressed', brandFilterHint: 'Only alert when Amazon reports a listing issue on listings of these brands.' }, { id: 'review_health', alertCategory: 'review_health', category: 'Listing Health', title: 'Review Health', includes: 'Star rating drops, rating count drops (reviews removed or split from a variation), and new critical reviews, per listing. Checked once a day from Amazon\'s review data, which runs 1–2 days behind. One email per storefront when something changes.', localKey: 'REVIEW_HEALTH', subtypes: 'review_health', deliveryRealtimeBadgeOnly: true, fixedBadge: 'Daily', settingsKey: 'review_health', brandFilter: 'review_health', brandFilterHint: 'Only alert when ratings or reviews change on listings of these brands.' }, { id: 'account_health', alertCategory: 'account_health', category: 'Account Health', title: 'Account Health Changes', includes: 'Account status changes (Normal / At risk / Deactivated), Account Health Rating, and policy violation counts per category (food and product safety, authenticity, IP complaints, listing policy and more), checked every 6 hours. Amazon gives counts, not the ASIN; the email links to Account Health in Seller Central. With threaded emails, listing issues and their all-clears land in the same Account health conversation.', localKey: 'ACCOUNT_HEALTH', deliveryRealtimeBadgeOnly: true }, { id: 'content_change', alertCategory: 'content_change', category: 'Product Content', title: 'Product Details Change', includes: 'ASIN, field changed (title / description / bullets / brand / A+ content), main image changes, category and parent ASIN / variation updates where applicable, before and after values, change timestamp.', wdt: 'PRODUCT_DETAILS_RECENT_CHANGE', subtypes: 'content_change', brandFilter: 'content_change', brandFilterHint: 'Only alert when product details change on listings of these brands. Includes adult classification.' }, { id: 'attribute_change', alertCategory: 'attribute_change', category: 'Product Content', title: 'Backend Attribute Changes', includes: 'Changes to the attributes behind your listing (compliance, price, fulfilment, variations, identifiers, content, images), with before and after values. Larger changes come with a PDF.', localKey: 'ATTRIBUTE_CHANGE', deliveryRealtimeBadgeOnly: true, subtypes: 'attribute_change', noMarketplaceFilter: true, brandFilter: 'attribute_change', brandFilterHint: 'Only alert when backend attributes change on listings of these brands.' }, { id: 'low_stock', alertCategory: 'stock_alert', category: 'Inventory', title: 'FBA & FBM Stock', includes: 'FBA: ASIN, fulfillable units, pending transshipment units, days of runway, threshold breached. FBM: SKU, available units, days of runway, threshold breached.', wdt: 'INVENTORY', brandFilter: 'stock_alert', brandFilterHint: 'Only alert on stock changes for listings of these brands. Shared with Stock Recovered and Stock Critical.' }, { id: 'stock_recovered', alertCategory: 'stock_alert_recovered', category: 'Inventory', title: 'Stock Recovered (Amber → Green)', includes: 'ASIN, units recovered, previous warning threshold, current fulfillable units, days of runway restored.', wdt: 'INVENTORY', brandFilter: 'stock_alert', brandFilterHint: 'Same brand list as FBA & FBM Stock. Recoveries are sent only for listings of these brands.' }, { id: 'stock_critical', alertCategory: 'stock_alert_critical', category: 'Inventory', title: 'Stock Critical (Amber → Red)', includes: 'ASIN, current fulfillable units, critical threshold breached, days of runway remaining, revenue at risk.', wdt: 'INVENTORY', brandFilter: 'stock_alert', brandFilterHint: 'Same brand list as FBA & FBM Stock. Critical stock is sent only for listings of these brands.' }, { id: 'sales_drop', alertCategory: 'sales_volume_alert', category: 'Inventory', title: 'Sales Volume', includes: 'ASIN, current 7-day velocity, baseline velocity, % change, revenue delta.', wdt: 'SALES_DROP', brandFilter: 'sales_volume', brandFilterHint: 'Only alert when sales volume changes on listings of these brands.' }, { id: 'fba_fee', alertCategory: 'fba_fee_change', category: 'Inventory', title: 'FBA Fee Change', includes: 'ASIN, fee type (referral / fulfillment / storage), old fee, new fee, margin impact.', localKey: 'FBA_FEE', brandFilter: 'fba_fee_change', brandFilterHint: 'Only alert when the FBA fee changes on listings of these brands.' }, { id: 'digest_summary', alertCategory: 'daily_portfolio_digest', category: 'Digests', title: 'Daily Portfolio Digest', includes: 'Morning summary of your portfolio status.', localKey: 'DAILY_PORTFOLIO_DIGEST', digestFixed: true }];

var ALERT_CATEGORY_ALIASES = {
  daily_consolidated_digest: 'daily_portfolio_digest'
};

function rowForAlertCategory(alertCategory) {
  var cat = String(alertCategory || '');
  var mapped = ALERT_CATEGORY_ALIASES[cat] || cat;
  return ROWS.filter(function (r) {
    return r.alertCategory === mapped;
  })[0] || null;
}

function normalizeBuyboxDelayMinutes(raw) {
  if (raw == null || raw === '' || raw === 'immediate' || raw === 'null') return null;
  var s = String(raw).trim();
  if (!/^\d+$/.test(s)) return null;
  var n = parseInt(s, 10);
  if (n < 20 || n > 40) return null;
  return n;
}

function validateBuyboxDelayMinutesInput(raw) {
  if (raw == null || String(raw).trim() === '') {
    return { value: null, error: 'Enter a value between 20 and 40 minutes' };
  }
  var s = String(raw).trim();
  if (!/^\d+$/.test(s)) {
    return { value: null, error: 'Enter a whole number between 20 and 40 minutes' };
  }
  var n = parseInt(s, 10);
  if (n < 20 || n > 40) {
    return { value: null, error: 'Delay must be between 20 and 40 minutes' };
  }
  return { value: n, error: null };
}

var NOTIFICATION_PREFS_URL = '/api/v1/notification-preferences';
var NOTIFICATION_PREFS_USERS_URL = '/api/v1/notification-preferences/users';
var NOTIFICATION_PREFS_LOCALE_URL = '/api/v1/notification-preferences/locale';
var NOTIFICATION_PREFS_MARKETPLACES_URL = '/api/v1/notification-preferences/marketplaces';

var NO_MARKETPLACE_CATEGORIES = ['amazon_connection', 'account_status'];

var ALERT_SUBTYPES = {
  content_change: [{ key: 'title', label: 'Title' }, { key: 'bullet_points', label: 'Bullet points' }, { key: 'description', label: 'Description' }, { key: 'brand', label: 'Brand' }, { key: 'images', label: 'Images' }, { key: 'category', label: 'Category' }, { key: 'variations', label: 'Parent / variations' }, { key: 'adult_classification', label: 'Adult classification' }],
  listing_suppressed: [{ key: 'suppression', label: 'Suppressed or hidden from search' }, { key: 'compliance', label: 'Compliance issues (action required)' }, { key: 'gating', label: 'Restricted (approval needed)' }],
  review_health: [{ key: 'rating_drop', label: 'Star rating drops' }, { key: 'rating_count_drop', label: 'Rating count drops' }, { key: 'critical_reviews', label: 'New critical reviews' }],
  attribute_change: [{ key: 'safety_and_compliance', label: 'Compliance & safety' }, { key: 'offer', label: 'Price' }, { key: 'shipping', label: 'Fulfilment' }, { key: 'variations', label: 'Variations' }, { key: 'product_identity', label: 'Identity & classification' }, { key: 'product_details', label: 'Content' }, { key: 'images', label: 'Images' }]
};

var ROW_SETTINGS_DEFAULTS = {
  review_health: { rating_sensitivity: 'half_star', min_rating_count_drop: 1 }
};

function normalizeRowSettings(settingsKey, raw) {
  var defaults = ROW_SETTINGS_DEFAULTS[settingsKey] || {};
  var src = raw && (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(raw)) === 'object' ? raw : {};
  var out = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, defaults);
  if (settingsKey === 'review_health') {
    out.rating_sensitivity = src.rating_sensitivity === 'tenth' ? 'tenth' : 'half_star';
    var n = parseInt(src.min_rating_count_drop, 10);
    out.min_rating_count_drop = !isNaN(n) && n >= 1 ? n : defaults.min_rating_count_drop;
  }
  return out;
}

function mpApiCode(code) {
  var c = String(code || '').toUpperCase();
  return c === 'GB' ? 'UK' : c;
}

function normalizeMpScope(scope) {
  if (scope == null) return null;
  var out = {};
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(scope).sort().forEach(function (k) {
    var v = scope[k];
    if (Array.isArray(v)) out[k] = v.slice().sort();
  });
  return out;
}
var SELLERS_URL = '/api/v1/sellers';

function sellerBrandsUrl(sellerId) {
  return SELLERS_URL + '/' + encodeURIComponent(sellerId) + '/brands';
}

var BRAND_FILTER_ALERTS = ['hijacker', 'buybox_lost', 'price_change', 'competitor_price', 'competitive_price', 'no_featured_offer', 'listing_suppressed', 'content_change', 'attribute_change', 'stock_alert', 'sales_volume', 'fba_fee_change', 'review_health'];

var USER_BRAND_ALLOWLISTS_URL = SELLERS_URL + '/brand-allowlists';

function sellerBrandAllowlistUrl(sellerId, alert) {
  return SELLERS_URL + '/' + encodeURIComponent(sellerId) + '/brand-allowlists/' + encodeURIComponent(alert);
}

function emptyBrandAllowlists() {
  var out = {};
  BRAND_FILTER_ALERTS.forEach(function (a) {
    out[a] = {};
  });
  return out;
}

function cleanBrand(value) {
  var text = String(value == null ? '' : value);
  if (text.normalize) text = text.normalize('NFKC');
  return text.replace(/[\u200B-\u200D\u2060\uFEFF]/g, '').replace(/\s+/g, ' ').trim();
}

function brandKey(value) {
  return cleanBrand(value).toLowerCase();
}

function numericIdList(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map(function (x) {
    return Number(x);
  }).filter(function (n) {
    return !isNaN(n) && n > 0;
  });
}

var NOTIFICATION_LOCALE_LABELS = {
  en: 'English',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  es: 'Spanish',
  pt: 'Portuguese',
  nl: 'Dutch',
  pl: 'Polish'
};

var WEEKLY_SCHEDULE_DAY_DEFAULT = 'Monday';
var WEEKLY_SCHEDULE_DAYS = [{ api: 'Monday', label: 'Mon' }, { api: 'Tuesday', label: 'Tue' }, { api: 'Wednesday', label: 'Wed' }, { api: 'Thursday', label: 'Thu' }, { api: 'Friday', label: 'Fri' }, { api: 'Saturday', label: 'Sat' }, { api: 'Sunday', label: 'Sun' }];
var WEEKDAY_TO_API_LOOKUP = function () {
  var m = {};
  var legacyKeys = [['mon', 'Monday'], ['tue', 'Tuesday'], ['wed', 'Wednesday'], ['thu', 'Thursday'], ['fri', 'Friday'], ['sat', 'Saturday'], ['sun', 'Sunday']];
  legacyKeys.forEach(function (pair) {
    m[pair[0]] = pair[1];
    m[pair[1].toLowerCase()] = pair[1];
  });
  return m;
}();

function userAccountRowIsAdmin(ua) {
  if (!ua) return false;
  if (ua.is_owner === true || ua.isOwner === true) return true;
  if (ua.is_primary === true || ua.isPrimary === true) return true;
  var r = String(ua.role != null ? ua.role : '').toLowerCase();
  return r === 'admin' || r === 'owner';
}

function userAccountEmailVerifiedFromSettings(ua) {
  if (!ua) return true;
  var v = ua.emailVerified;
  if (v === undefined || v === null) v = ua.email_verified;
  if (v === undefined || v === null) return true;
  return v === true || v === 'true' || v === 1 || v === '1';
}

function normalizeDeliveryWeekday(raw) {
  if (raw == null || String(raw).trim() === '') return WEEKLY_SCHEDULE_DAY_DEFAULT;
  var s = String(raw).trim();
  var lc = s.toLowerCase();
  var hit = WEEKDAY_TO_API_LOOKUP[lc];
  return hit || WEEKLY_SCHEDULE_DAY_DEFAULT;
}

function normalizeEmailKeyStatic(email) {
  return email ? String(email).trim().toLowerCase() : '';
}

var IANA_TIMEZONE_ALIASES_FOR_API = {
  'asia/saigon': 'Asia/Ho_Chi_Minh',
  'asia/calcutta': 'Asia/Kolkata',
  'asia/katmandu': 'Asia/Kathmandu',
  'asia/rangoon': 'Asia/Yangon',
  'asia/chungking': 'Asia/Chongqing',
  'asia/ujung_pandang': 'Asia/Makassar',
  'europe/kiev': 'Europe/Kyiv',
  'pacific/samoa': 'Pacific/Pago_Pago',
  'us/pacific-new': 'America/Los_Angeles'
};

function canonicalIanaTimezoneForApi(tz) {
  if (typeof tz !== 'string') return tz;
  var trimmed = tz.trim();
  if (!trimmed) return trimmed;
  var mapped = IANA_TIMEZONE_ALIASES_FOR_API[trimmed.toLowerCase()];
  return mapped || trimmed;
}

function browserIanaTimezoneStatic() {
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof tz === 'string' && tz.trim()) return canonicalIanaTimezoneForApi(tz);
  } catch (e) {}
  return 'UTC';
}

function scheduleTimezoneFromDeliverySchedule(ds) {
  if (!ds || (typeof ds === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(ds)) !== 'object') return '';
  var t = ds.timezone != null ? ds.timezone : ds.time_zone;
  if (typeof t !== 'string' || !t.trim()) return '';
  return canonicalIanaTimezoneForApi(t);
}

function timeZonesEquivalentForUi(a, b) {
  if (!a || !b) return false;
  var ca = canonicalIanaTimezoneForApi(String(a));
  var cb = canonicalIanaTimezoneForApi(String(b));
  if (ca.toLowerCase() === cb.toLowerCase()) return true;
  var na = ca.toLowerCase();
  var nb = cb.toLowerCase();
  var utcish = ['utc', 'etc/utc', 'gmt', 'etc/gmt', 'zulu'];
  return utcish.indexOf(na) >= 0 && utcish.indexOf(nb) >= 0;
}

function calendarPartsInTimeZone(ms, iana) {
  var dtf = new Intl.DateTimeFormat('en-CA', {
    timeZone: iana,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  var parts = {};
  dtf.formatToParts(new Date(ms)).forEach(function (p) {
    if (p.type !== 'literal') parts[p.type] = p.value;
  });
  return { y: +parts.year, m0: +parts.month - 1, d: +parts.day };
}

function utcMillisForWallClockOnCalendarDateInIana(y, month0, day, hour, minute, iana) {
  var est = Date.UTC(y, month0, day, 12, 0, 0, 0);
  var lo = est - 36 * 3600000;
  var hi = est + 36 * 3600000;
  var dtf = new Intl.DateTimeFormat('en-CA', {
    timeZone: iana,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    second: '2-digit'
  });
  function partsAt(utcMs) {
    var parts = {};
    dtf.formatToParts(new Date(utcMs)).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    var ph = +parts.hour;
    if (ph === 24) ph = 0;
    return { y: +parts.year, m0: +parts.month - 1, d: +parts.day, h: ph, min: +parts.minute };
  }
  for (var i = 0; i < 48; i++) {
    var mid = Math.floor((lo + hi) / 2);
    var pt = partsAt(mid);
    var dayCmp = (pt.y - y) * 400 + (pt.m0 - month0) * 40 + (pt.d - day);
    if (dayCmp !== 0) {
      if (dayCmp < 0) lo = mid + 1;else hi = mid - 1;
      continue;
    }
    var hm = (pt.h - hour) * 3600000 + (pt.min - minute) * 60000;
    if (hm === 0) return mid;
    if (hm < 0) lo = mid + 1;else hi = mid - 1;
  }
  return Math.floor((lo + hi) / 2);
}

function upcomingCalendarPartsForWeekdayInIana(weekdayCanonical, iana) {
  var want = normalizeDeliveryWeekday(weekdayCanonical);
  for (var add = 0; add < 21; add++) {
    var cap = calendarPartsInTimeZone(Date.now() + add * 86400000, iana);
    var noonish = utcMillisForWallClockOnCalendarDateInIana(cap.y, cap.m0, cap.d, 12, 0, iana);
    var wdStr = new Intl.DateTimeFormat('en-US', { timeZone: iana, weekday: 'long' }).format(new Date(noonish));
    if (wdStr === want) return cap;
  }
  return calendarPartsInTimeZone(Date.now(), iana);
}

function deliveryScheduleHourToBrowserLocalHour(scheduleHour, deliverySchedule, freq, weekdayFromSchedule) {
  var h = Math.floor(Number(scheduleHour));
  if (isNaN(h) || h < 0 || h > 23) return scheduleHour;
  var srcTz = scheduleTimezoneFromDeliverySchedule(deliverySchedule);
  var browserTz = browserIanaTimezoneStatic();
  if (!srcTz || timeZonesEquivalentForUi(srcTz, browserTz)) return h;
  var ymd;
  if (String(freq || '').toLowerCase() === 'weekly' && weekdayFromSchedule != null && String(weekdayFromSchedule).trim() !== '') {
    ymd = upcomingCalendarPartsForWeekdayInIana(weekdayFromSchedule, srcTz);
  } else {
    ymd = calendarPartsInTimeZone(Date.now(), srcTz);
  }
  try {
    var utcMs = utcMillisForWallClockOnCalendarDateInIana(ymd.y, ymd.m0, ymd.d, h, 0, srcTz);
    return new Date(utcMs).getHours();
  } catch (e) {
    return h;
  }
}

function identityUsersListFromBody(body) {
  var list = [];
  if (Array.isArray(body)) list = body;else if (body && Array.isArray(body.users)) list = body.users;
  if (!list.length) return [];
  return list.map(function (u) {
    var em = u.email || u.user_email || u.userEmail || '';
    var id = u.id != null ? u.id : u.user_id != null ? u.user_id : u.userId != null ? u.userId : null;
    if (id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined) id = id.value;
    return { email: String(em).trim(), id: id };
  }).filter(function (x) {
    return x.email;
  });
}

function mergeUserIdsFromIdentityUsers(emailRows, identityUsersBody) {
  var tenant = identityUsersListFromBody(identityUsersBody);
  if (!tenant.length || !emailRows || !emailRows.length) return;
  emailRows.forEach(function (ea) {
    var ek = normalizeEmailKeyStatic(ea.email);
    if (!ek) return;
    for (var i = 0; i < tenant.length; i++) {
      var tu = tenant[i];
      if (normalizeEmailKeyStatic(tu.email) === ek && tu.id != null && tu.id !== '') {
        ea.userId = tu.id;
        return;
      }
    }
  });
}

function augmentEmailRows(ea, apiWdts) {
  ea.isNew = !!ea.isNew;
  ea.isDeleted = !!ea.isDeleted;
  ea.originalEmail = ea.email;
  ea.originalSubscribedToDailyDigestEmail = ea.subscribedToDailyDigestEmail;
  ea.originalSubscribedToNewsletter = ea.subscribedToNewsletter;
  ea.originalTimezoneOffset = ea.timezoneOffset;
  ea.originalTimezoneAdjustToDST = ea.timezoneAdjustToDST;
  ea.originalDigestEmailHour = ea.digestEmailHour;
  if (!ea.unsubscribedSellerAccounts) ea.unsubscribedSellerAccounts = [];
  ea.originalUnsubscribedSellerAccounts = ea.unsubscribedSellerAccounts.map(function (x) {
    return x;
  });
  if (!ea.allowedSellerAccounts) ea.allowedSellerAccounts = [];
  ea.originalallowedSellerAccounts = ea.allowedSellerAccounts.map(function (x) {
    return x;
  });
  if (!ea.alertsSettings) ea.alertsSettings = {};
  var merge = apiWdts.slice();
  merge.forEach(function (w) {
    if (!ea.alertsSettings[w]) {
      ea.alertsSettings[w] = { RED: false, AMBER: false, GREEN: false };
    }
    var wd = ea.alertsSettings[w];
    wd.orig = { RED: !!wd.RED, AMBER: !!wd.AMBER, GREEN: !!wd.GREEN };
  });
  ea.alertChanged = function () {
    var ch = false;
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(ea.alertsSettings).forEach(function (key) {
      var wd = ea.alertsSettings[key];
      if (String(key).indexOf('__LOCAL__') === 0) return;
      if (!wd || !wd.orig) return;['RED', 'AMBER', 'GREEN'].forEach(function (k) {
        if (wd[k] !== wd.orig[k]) ch = true;
      });
    });
    return ch;
  };
  ea.subscribedChanged = function () {
    var o = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.originalUnsubscribedSellerAccounts);
    var c = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.unsubscribedSellerAccounts || []);
    return o.size === c.size && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(o).every(function (id) {
      return c.has(id);
    });
  };
  ea.sellerAccessChanged = function () {
    var o = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.originalallowedSellerAccounts);
    var c = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(ea.allowedSellerAccounts || []);
    return o.size === c.size && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(o).every(function (id) {
      return c.has(id);
    });
  };
  ea.isDirty = function () {
    return this.subscribedToDailyDigestEmail !== this.originalSubscribedToDailyDigestEmail || this.subscribedToNewsletter !== this.originalSubscribedToNewsletter || this.isNew || this.isDeleted || this.email !== this.originalEmail || this.digestEmailHour !== this.originalDigestEmailHour || this.timezoneOffset !== this.originalTimezoneOffset || this.timezoneAdjustToDST !== this.originalTimezoneAdjustToDST || this.alertChanged() || !this.subscribedChanged() || !this.sellerAccessChanged();
  };
  return ea;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertSettings',
  data: function data() {
    return {
      loading: false,
      loadError: null,
      isOwner: false,
      loginEmail: '',
      firstName: '',
      lastName: '',
      emailAddresses: [],
      sellers: [],
      packageDetails: null,
      watchDogTypes: [],
      selectedUserEmail: '',
      saving: false,
      successMsg: '',
      errorMsg: '',
      rowDelivery: {},

      rowDigestHour: {},

      rowDelayMinutes: {},

      rowDelayDraft: {},

      rowDelayError: {},

      rowDelayCustomOn: {},
      digestHourOptions: [],
      weeklyDay: {},
      lsPrefix: 'als_dm:',
      localRowOn: {},

      prefsSnapshot: '',

      notificationPrefsByUser: {},
      notificationPrefsBulkLoaded: false,

      notificationScopeByUser: {},
      offerActivityDigest: false,

      threadedAlerts: false,
      inboxModeSaving: false,

      canEditThreadedAlerts: true,
      showInboxMode: true,
      inboxModeOptions: [{ value: false, label: 'Separate emails', hint: 'One email per alert.' }, { value: true, label: 'Threaded', hint: 'Alerts stack into one conversation per alert type. A new conversation starts after 100 alerts.' }],

      competitivePriceAlerts: false,
      digestSaving: false,
      notificationLocale: 'en',
      supportedNotificationLocales: ['en', 'fr', 'de', 'it', 'es', 'pt', 'nl', 'pl'],
      localeSaving: false,
      localeError: null,
      localeSaved: false,

      rowSellerIds: {},

      openStorefrontRowId: null,

      storefrontMenuError: {},

      brandAllowlist: emptyBrandAllowlists(),

      brandAllowlistSnapshot: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(emptyBrandAllowlists()),
      brandAllowlistLoaded: false,

      defaultMpScope: {},

      defaultMpScopeSnapshot: '{}',

      rowMpScope: {},

      mpBoxOpen: {},

      rowMutedSubtypes: {},

      subtypeBoxOpen: {},

      subtypeError: {},

      rowSettings: {},

      settingsBoxOpen: {},

      brandFilterOpen: {},

      brandPickerKey: null,
      brandQuery: '',

      brandOptionsCache: {},
      brandOptionsLoading: false,
      brandQueryTimer: null
    };
  },
  computed: {
    notificationLocaleOptions: function notificationLocaleOptions() {
      var codes = Array.isArray(this.supportedNotificationLocales) && this.supportedNotificationLocales.length ? this.supportedNotificationLocales : ['en', 'fr', 'de', 'it', 'es', 'pt', 'nl', 'pl'];
      return codes.map(function (code) {
        return { code: code, label: NOTIFICATION_LOCALE_LABELS[code] || code.toUpperCase() };
      });
    },
    isProPlan: function isProPlan() {
      if (!this.packageDetails) return false;
      var name = (this.packageDetails.name || this.packageDetails.packageName || '').toLowerCase();
      if (name.indexOf('pro') >= 0) return true;
      var cents = this.packageDetails.baseSubscriptionFeeCents;
      return cents != null && cents >= 4900;
    },
    selectedEa: function selectedEa() {
      var self = this;
      var key = self.normalizeEmailKey(self.selectedUserEmail);
      return this.emailAddresses.filter(function (ea) {
        return !ea.isDeleted && self.normalizeEmailKey(ea.email) === key;
      })[0] || null;
    },
    dropdownUsers: function dropdownUsers() {
      var self = this;
      var users = [];
      this.emailAddresses.forEach(function (ea) {
        if (ea.isDeleted || !ea.email) return;
        users.push({
          email: ea.email,
          firstName: ea.firstName || '',
          lastName: ea.lastName || '',
          fullName: ea.fullName || '',
          isOwner: !!(ea.isPrimary || userAccountRowIsAdmin(ea)),
          is_owner: ea.is_owner === true || ea.isOwner === true,
          role: ea.role != null ? ea.role : 'member'
        });
      });
      if (!this.isOwner && this.loginEmail) {
        var loginKey = self.normalizeEmailKey(self.loginEmail);
        return users.filter(function (u) {
          return self.normalizeEmailKey(u.email) === loginKey;
        });
      }
      return users;
    },

    assignedStorefronts: function assignedStorefronts() {
      var ea = this.selectedEa;
      if (!ea) return [];
      var assignedSet = this.assignedSellerIdSetForSelectedUser();
      var list = this.availableSellersForSelectedUser().filter(function (s) {
        var sid = s.sellerId && s.sellerId.value !== undefined ? s.sellerId.value : s.sellerId;
        return assignedSet.has(String(sid));
      });
      return list.map(function (s, idx) {
        var sid = s.sellerId && s.sellerId.value !== undefined ? s.sellerId.value : s.sellerId;
        var codes;
        if (Array.isArray(s.marketplaceCodes) && s.marketplaceCodes.length) {
          codes = s.marketplaceCodes.map(function (c) {
            return String(c).toLowerCase();
          });
        } else {
          var mp = (s.marketplaceIso31662Code || REGION_MARKETPLACE[s.region] || 'us').toLowerCase();
          if (mp === 'us' || (s.region || '') === 'NA') codes = ['us', 'ca', 'mx'];else if (mp === 'gb' || (s.region || '') === 'EU') codes = ['gb', 'de', 'fr'];else codes = [mp === 'gb' ? 'gb' : mp];
        }
        return {
          key: String(sid) + '-' + idx,
          id: Number(sid),
          name: s.nickName || 'Storefront ' + String(sid).slice(-6),
          mpCodes: codes
        };
      });
    },

    brandFilterEditable: function brandFilterEditable() {
      return !!this.isOwner || this.selectedUserEmail === this.loginEmail;
    },
    brandAllowlistChanged: function brandAllowlistChanged() {
      return this.serializedBrandAllowlist() !== this.brandAllowlistSnapshot;
    },

    hasMultiMp: function hasMultiMp() {
      var self = this;
      return this.assignedStorefronts.some(function (sf) {
        return self.sfMpCodes(sf).length > 1;
      });
    },
    mpStorefrontsAll: function mpStorefrontsAll() {
      var self = this;
      return this.assignedStorefronts.filter(function (sf) {
        return self.sfMpCodes(sf).length > 1;
      });
    },

    mpDefaultEditable: function mpDefaultEditable() {
      return !!this.isOwner || this.selectedUserEmail === this.loginEmail;
    },
    defaultMpScopeChanged: function defaultMpScopeChanged() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(normalizeMpScope(this.defaultMpScope)) !== this.defaultMpScopeSnapshot;
    },
    categorizedRows: function categorizedRows() {
      var map = {};var grouped = [];var idx = {};
      var self = this;
      ROWS.forEach(function (row, ord) {
        if (!self.rowAvailable(row)) return;
        if (!idx[row.category]) idx[row.category] = 0;
        var r = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, row, { _sort: idx[row.category]++ });
        if (!map[row.category]) {
          map[row.category] = { name: row.category, rows: [] };
          grouped.push(map[row.category]);
        }
        map[row.category].rows.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, r, { _ord: ord }));
      });
      grouped.forEach(function (cat) {
        cat.rows.sort(function (a, b) {
          return a._ord - b._ord;
        });
      });
      return grouped;
    },
    hasDelayValidationError: function hasDelayValidationError() {
      var errs = this.rowDelayError || {};
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errs).some(function (k) {
        return !!errs[k];
      });
    },
    hasChanges: function hasChanges() {
      if (this.loading) return false;
      if (this.hasDelayValidationError) return true;
      if (this.brandAllowlistChanged) return true;
      if (this.defaultMpScopeChanged) return true;
      var cur = this.serializedPrefsForCompare();
      if (!this.prefsSnapshot) return false;
      return cur !== this.prefsSnapshot;
    },
    weekDaysList: function weekDaysList() {
      return WEEKLY_SCHEDULE_DAYS;
    },
    weeklyScheduleDayDefault: function weeklyScheduleDayDefault() {
      return WEEKLY_SCHEDULE_DAY_DEFAULT;
    },

    alertTypesCount: function alertTypesCount() {
      var self = this;
      return ROWS.filter(function (r) {
        return !!r.alertCategory && self.rowAvailable(r);
      }).length;
    }
  },
  watch: {
    hasChanges: function hasChanges(v) {
      window.dirty = !!v;
    },
    selectedUserEmail: function selectedUserEmail() {
      var self = this;
      self.rowSellerIds = {};
      self.rowMpScope = {};
      self.mpBoxOpen = {};
      self.rowMutedSubtypes = {};
      self.subtypeBoxOpen = {};
      self.subtypeError = {};
      self.rowSettings = {};
      self.settingsBoxOpen = {};
      self.openStorefrontRowId = null;
      self.storefrontMenuError = {};
      self.hydrateDeliveryFromLs();
      self.hydrateLocalRowToggles();
      self.loadBrandAllowlists();
      self.loadNotificationPreferencesFromApi({ forceUserGet: true }).then(function () {
        self.capturePrefsSnapshot();
      }).catch(function () {
        self.capturePrefsSnapshot();
      });
    }
  },
  created: function created() {
    var hrs = [];
    for (var h = 0; h <= 23; h++) {
      hrs.push(h);
    }this.digestHourOptions = hrs;
    window.dirty = false;
  },
  mounted: function mounted() {
    this.fetchAll().catch(function () {});
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
    if (this.brandQueryTimer) clearTimeout(this.brandQueryTimer);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (window.dirty) {
      window.confirm('You have unsaved changes. Leave anyway?') ? (window.dirty = false, next()) : next(false);
    } else next();
  },
  methods: {
    rowLocked: function rowLocked(row) {
      return !!(row.lockedStarter && !this.isProPlan);
    },

    deliveryRealtimeBadgeOnly: function deliveryRealtimeBadgeOnly(row) {
      return !!row.deliveryRealtimeBadgeOnly;
    },

    deliveryOptionsForRow: function deliveryOptionsForRow(row) {
      return row && row.deliveryOptions || ['realtime', 'daily', 'weekly'];
    },
    fetchAll: function fetchAll() {
      var self = this;
      this.loading = true;
      this.loadError = null;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([self.$http.get('/api/identity/settings'), self.$http.get('/api/identity/users').catch(function () {
        return { body: null };
      }), self.$http.get('/api/billing/payment-status', {
        params: { timezoneOffsetMinutes: 0 - new Date().getTimezoneOffset() }
      }).catch(function () {
        return { body: null };
      })]).then(function (results) {
        self.loading = false;
        var body = results[0].body || {};
        var identityUsersBody = results[1] ? results[1].body : null;
        var digestFlag = body.offerActivityDigest;
        if (digestFlag == null) digestFlag = body.offer_activity_digest;
        self.offerActivityDigest = digestFlag === true || digestFlag === 1 || digestFlag === '1' || digestFlag === 'true';
        self.threadedAlerts = body.threadedAlerts === true;
        self.canEditThreadedAlerts = body.canEditThreadedAlerts !== false;
        self.competitivePriceAlerts = body.competitivePriceAlerts === true;
        self.loginEmail = body.email || '';
        self.isOwner = !!body.isOwner;
        self.firstName = body.firstName || '';
        self.lastName = body.lastName || '';
        var rawWdts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(body.watchDogTypesToDisplayName || {}).filter(function () {
          return true;
        });
        var base = ['BAD_REVIEW', 'TOP_REVIEW', 'PRODUCT_DETAILS_RECENT_CHANGE', 'PRODUCT_CATEGORY_RECENT_CHANGE', 'LOST_BUYBOX', 'NO_ADD_TO_CART', 'PRICE', 'KEYWORD', 'INVENTORY', 'FBM_INVENTORY', 'SALES_DROP'];
        rawWdts.forEach(function (k) {
          if (base.indexOf(k) < 0) base.push(k);
        });
        self.watchDogTypes = base;
        var rawEa = Array.isArray(body.user_account) ? body.user_account.map(function (ua) {
          var fn = ua.first_name != null ? ua.first_name : ua.firstName;
          var ln = ua.last_name != null ? ua.last_name : ua.lastName;
          var full = ua.full_name != null ? ua.full_name : ua.fullName;
          if (!full && (fn || ln)) full = [fn, ln].filter(Boolean).join(' ');
          var sellerIds = Array.isArray(ua.sellerIds) ? ua.sellerIds : Array.isArray(ua.seller_ids) ? ua.seller_ids : [];
          var emailAddrId = ua.emailAddressId != null ? ua.emailAddressId : ua.email_address_id != null ? ua.email_address_id : null;
          if (emailAddrId == null && ua.id != null) emailAddrId = ua.id;
          return {
            email: ua.email || '',
            firstName: fn || '',
            lastName: ln || '',
            fullName: full || '',
            userId: ua.userId != null ? ua.userId : ua.user_id,
            emailAddressId: emailAddrId,
            role: ua.role != null ? ua.role : 'member',
            is_owner: ua.is_owner === true || ua.isOwner === true,
            isPrimary: userAccountRowIsAdmin(ua),
            allowedSellerAccounts: sellerIds.map(function (id) {
              return id;
            }),
            unsubscribedSellerAccounts: [],
            alertsSettings: {},
            emailVerified: userAccountEmailVerifiedFromSettings(ua)
          };
        }) : [];
        rawEa.forEach(function (ea) {
          if (ea.isPrimary === undefined && ea.is_primary !== undefined) ea.isPrimary = !!ea.is_primary;
          if (ea.emailAddressId == null && ea.email_address_id != null) ea.emailAddressId = ea.email_address_id;
          if (ea.emailAddressId == null && ea.id != null) ea.emailAddressId = ea.id;
          if (ea.allowedSellersAccount && !ea.allowedSellerAccounts) ea.allowedSellerAccounts = ea.allowedSellersAccount;
          if (!ea.allowedSellerAccounts) ea.allowedSellerAccounts = [];
        });
        mergeUserIdsFromIdentityUsers(rawEa, identityUsersBody);
        self.sellers = Array.isArray(body.sellerAccounts) ? body.sellerAccounts : [];
        self.emailAddresses = rawEa.map(function (ea) {
          return augmentEmailRows(ea, self.watchDogTypes);
        }).sort(function (a, b) {
          if (a.isPrimary && !b.isPrimary) return -1;
          if (!a.isPrimary && b.isPrimary) return 1;
          return String(a.email).localeCompare(String(b.email));
        });
        self.resolveInitialSelectedUserEmail();
        self.hydrateDeliveryFromLs();
        self.hydrateLocalRowToggles();
        self.loadBrandAllowlists();
        var pack = results[2] && results[2].body;
        self.packageDetails = pack && pack.packageDetails ? pack.packageDetails : null;
        if (self.isOwner) {
          return self.fetchNotificationPreferencesUsersBulk().catch(function () {}).then(function () {
            return self.loadNotificationPreferencesFromApi();
          }).then(function () {
            self.capturePrefsSnapshot();
          });
        }
        return self.loadNotificationPreferencesFromApi({ forceUserGet: true }).then(function () {
          self.capturePrefsSnapshot();
        });
      }).catch(function (err) {
        self.loading = false;
        self.loadError = err.body && err.body.message || 'Failed to load';
        throw err;
      });
    },
    ensureWd: function ensureWd(ea, wdt) {
      if (!wdt || !ea || !ea.alertsSettings) return { RED: false, AMBER: false, GREEN: false };
      if (!ea.alertsSettings[wdt]) {
        this.$set(ea.alertsSettings, wdt, { RED: false, AMBER: false, GREEN: false, orig: { RED: false, AMBER: false, GREEN: false } });
      }
      var wd = ea.alertsSettings[wdt];
      if (!wd.orig) wd.orig = { RED: !!wd.RED, AMBER: !!wd.AMBER, GREEN: !!wd.GREEN };
      return wd;
    },
    hydrateLocalRowToggles: function hydrateLocalRowToggles() {
      var self = this;
      self.localRowOn = {};
      try {
        var store = JSON.parse(window.localStorage.getItem('als_local_row_on') || '{}');
        var userMap = store[self.selectedUserEmail] || {};
        ROWS.forEach(function (row) {
          if (!row.localKey) return;
          if (userMap[row.id] === true || userMap[row.id] === false) {
            self.$set(self.localRowOn, row.id, userMap[row.id] === true);
          } else {
            self.$set(self.localRowOn, row.id, row.digestFixed === true || row.defaultOn === true);
          }
        });
      } catch (e) {}
    },
    persistLocalRowOnJson: function persistLocalRowOnJson() {
      var self = this;
      try {
        var store = JSON.parse(window.localStorage.getItem('als_local_row_on') || '{}');
        var nest = {};
        ROWS.forEach(function (row) {
          if (!row.localKey) return;
          nest[row.id] = self.localRowOn[row.id] === true;
        });
        store[self.selectedUserEmail] = nest;
        window.localStorage.setItem('als_local_row_on', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store));
      } catch (e) {}
    },
    rowOn: function rowOn(row) {
      var ea = this.selectedEa;
      if (!ea || row.alwaysOn) return false;
      if (this.rowLocked(row)) return false;
      if (row.localKey) {
        return this.localRowOn[row.id] === true;
      }
      if (!row.wdt) return false;
      var wd = this.ensureWd(ea, row.wdt);
      return !!(wd.RED || wd.AMBER || wd.GREEN);
    },
    onRowToggle: function onRowToggle(row, on) {
      var ea = this.selectedEa;
      if (!ea || row.alwaysOn) return;
      if (this.rowLocked(row)) return;
      if (row.localKey) {
        this.$set(this.localRowOn, row.id, on);
        this.persistLocalRowOnJson();
        return;
      }
      if (!row.wdt) return;
      var wd = this.ensureWd(ea, row.wdt);
      if (!wd.orig) wd.orig = { RED: wd.RED, AMBER: wd.AMBER, GREEN: wd.GREEN };
      wd.RED = wd.AMBER = wd.GREEN = on;
    },
    hydrationKey: function hydrationKey(rid) {
      return this.selectedUserEmail + '|' + rid;
    },

    resolveInitialSelectedUserEmail: function resolveInitialSelectedUserEmail() {
      var self = this;
      if (!self.isOwner && self.loginEmail) {
        var loginKey = self.normalizeEmailKey(self.loginEmail);
        var match = self.emailAddresses.filter(function (ea) {
          return !ea.isDeleted && self.normalizeEmailKey(ea.email) === loginKey;
        })[0];
        self.selectedUserEmail = match ? match.email : self.loginEmail;
        return;
      }
      var primary = self.emailAddresses.filter(function (e) {
        return e.isPrimary;
      })[0];
      self.selectedUserEmail = (primary || self.emailAddresses[0] || {}).email || self.loginEmail || '';
    },

    selectedUserIdForApi: function selectedUserIdForApi() {
      var ea = this.selectedEa;
      if (!ea) return null;
      var raw = ea.userId != null ? ea.userId : ea.user_id;
      if (raw == null || raw === '') return null;
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw.value !== undefined) return raw.value;
      return raw;
    },

    hydrateDeliveryFromLs: function hydrateDeliveryFromLs() {
      var self = this;
      ROWS.forEach(function (row) {
        if (row.alwaysOn || row.digestFixed) return;
        try {
          var dm = window.localStorage.getItem(self.lsPrefix + self.hydrationKey(row.id));
          if (dm === 'daily' || dm === 'weekly' || dm === 'realtime') {
            self.$set(self.rowDelivery, row.id, dm);
          } else {
            self.$set(self.rowDelivery, row.id, 'realtime');
          }
          var wd = window.localStorage.getItem('als_wday|' + self.hydrationKey(row.id));
          self.$set(self.weeklyDay, row.id, normalizeDeliveryWeekday(wd || WEEKLY_SCHEDULE_DAY_DEFAULT));
        } catch (e) {
          self.$set(self.rowDelivery, row.id, 'realtime');
        }
      });
      ROWS.forEach(function (row) {
        if (row.alwaysOn && !row.digestFixed) return;
        try {
          var hk = window.localStorage.getItem('als_hour|' + self.hydrationKey(row.id));
          if (hk != null && hk !== '') {
            var nh = Number(hk);
            if (!isNaN(nh)) self.$set(self.rowDigestHour, row.id, nh);else self.$set(self.rowDigestHour, row.id, undefined);
          } else {
            self.$set(self.rowDigestHour, row.id, undefined);
          }
        } catch (e2) {
          self.$set(self.rowDigestHour, row.id, undefined);
        }
      });
      ROWS.forEach(function (row) {
        if (!row.delayMinutesConfigurable) return;
        try {
          var delayRaw = window.localStorage.getItem('als_delay|' + self.hydrationKey(row.id));
          var delayN = normalizeBuyboxDelayMinutes(delayRaw);
          self.applyBuyboxDelayState(row, delayN);
        } catch (e3) {
          self.applyBuyboxDelayState(row, null);
        }
      });
    },
    delayMinutesForRow: function delayMinutesForRow(row) {
      if (!row || !row.delayMinutesConfigurable) return null;
      return normalizeBuyboxDelayMinutes(this.rowDelayMinutes[row.id]);
    },
    delayDraftForRow: function delayDraftForRow(row) {
      if (!row) return '';
      var d = this.rowDelayDraft[row.id];
      if (d != null) return d;
      var n = this.delayMinutesForRow(row);
      return n == null ? '' : String(n);
    },
    delayErrorForRow: function delayErrorForRow(row) {
      if (!row) return '';
      return this.rowDelayError[row.id] || '';
    },
    isBuyboxDelayCustom: function isBuyboxDelayCustom(row) {
      if (!row || !row.delayMinutesConfigurable) return false;
      if (this.rowDelayCustomOn[row.id] === true) return true;
      return this.delayMinutesForRow(row) != null;
    },
    applyBuyboxDelayState: function applyBuyboxDelayState(row, delayN) {
      if (!row || !row.delayMinutesConfigurable) return;
      var n = normalizeBuyboxDelayMinutes(delayN);
      this.$set(this.rowDelayMinutes, row.id, n);
      this.$set(this.rowDelayError, row.id, '');
      if (n == null) {
        this.$set(this.rowDelayCustomOn, row.id, false);
        this.$set(this.rowDelayDraft, row.id, '');
      } else {
        this.$set(this.rowDelayCustomOn, row.id, true);
        this.$set(this.rowDelayDraft, row.id, String(n));
      }
      try {
        window.localStorage.setItem('als_delay|' + this.hydrationKey(row.id), n == null ? '' : String(n));
      } catch (e) {}
    },
    setBuyboxDelayImmediate: function setBuyboxDelayImmediate(row) {
      if (!row || !row.delayMinutesConfigurable) return;
      this.applyBuyboxDelayState(row, null);
    },

    enableBuyboxDelayInput: function enableBuyboxDelayInput(row) {
      if (!row || !row.delayMinutesConfigurable) return;
      if (this.isBuyboxDelayCustom(row) && this.delayMinutesForRow(row) != null && !this.delayErrorForRow(row)) return;
      this.applyBuyboxDelayState(row, 20);
    },
    onBuyboxDelayInput: function onBuyboxDelayInput(row, raw) {
      if (!row || !row.delayMinutesConfigurable) return;
      this.$set(this.rowDelayCustomOn, row.id, true);
      this.$set(this.rowDelayDraft, row.id, raw == null ? '' : String(raw));
      var parsed = validateBuyboxDelayMinutesInput(raw);
      if (parsed.error) {
        this.$set(this.rowDelayError, row.id, parsed.error);
        return;
      }
      this.$set(this.rowDelayError, row.id, '');
      this.$set(this.rowDelayMinutes, row.id, parsed.value);
      try {
        window.localStorage.setItem('als_delay|' + this.hydrationKey(row.id), String(parsed.value));
      } catch (e) {}
    },
    digestHourForRow: function digestHourForRow(rowId) {
      var h = this.rowDigestHour[rowId];
      if (h == null || h === '') return 8;
      var n = Number(h);
      return isNaN(n) ? 8 : n;
    },
    setDigestHourForRow: function setDigestHourForRow(rowId, hour) {
      var n = Number(hour);
      if (isNaN(n)) return;
      this.$set(this.rowDigestHour, rowId, n);
      try {
        window.localStorage.setItem('als_hour|' + this.hydrationKey(rowId), String(n));
      } catch (e) {}
      if (rowId === 'digest_summary' && this.selectedEa) {
        this.$set(this.selectedEa, 'digestEmailHour', n);
      }
    },

    deliveryFor: function deliveryFor(row) {
      if (row.alwaysOn) return 'realtime';
      var v = this.rowDelivery[row.id];
      if (row.deliveryOptions && row.deliveryOptions.indexOf(v) === -1) return 'realtime';
      if (v === 'daily' || v === 'weekly' || v === 'realtime') return v;
      return 'realtime';
    },
    setDelivery: function setDelivery(row, mode) {
      this.$set(this.rowDelivery, row.id, mode);
      try {
        window.localStorage.setItem(this.lsPrefix + this.hydrationKey(row.id), mode);
      } catch (e) {}
    },
    setWeeklyDay: function setWeeklyDay(rowId, v) {
      this.$set(this.weeklyDay, rowId, normalizeDeliveryWeekday(v));
      try {
        window.localStorage.setItem('als_wday|' + this.hydrationKey(rowId), v);
      } catch (e) {}
    },
    formatUserLabel: function formatUserLabel(u) {
      var name = u.fullName || [u.firstName, u.lastName].filter(Boolean).join(' ') || u.email;
      if (!u.isOwner) return name + ' — Member';
      var ws = u.is_owner === true;
      var r = String(u.role || '').toLowerCase();
      var adminRole = r === 'admin' || r === 'owner';
      if (ws && adminRole) return name + ' — Admin & Owner';
      if (ws) return name + ' — Owner';
      return name + ' — Admin';
    },
    mpLabel: function mpLabel(code) {
      return MP_LABELS[code] || String(code).toUpperCase();
    },
    mpFlagClass: function mpFlagClass(code) {
      return code === 'gb' ? 'gb' : code;
    },
    formatDigestHour: function formatDigestHour(h) {
      var p = h >= 12 ? 'PM' : 'AM';
      var x = h > 12 ? h - 12 : h === 0 ? 12 : h;
      return x + ':00 ' + p;
    },
    serializedPrefsForCompare: function serializedPrefsForCompare() {
      var arr = this.buildPreferencesArray();
      arr.sort(function (a, b) {
        return String(a.alert_category).localeCompare(String(b.alert_category));
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(arr);
    },

    rowAvailable: function rowAvailable(row) {
      return !row.tenantFlag || this[row.tenantFlag] === true;
    },
    buildPreferencesArray: function buildPreferencesArray() {
      var self = this;
      var out = [];
      ROWS.forEach(function (row) {
        if (!row.alertCategory) return;

        if (!self.rowAvailable(row)) return;
        var hour = self.digestHourForRow(row.id);
        var d = self.deliveryApiForRow(row, hour);
        var pref = {
          alert_category: row.alertCategory,
          enabled: self.rowEnabledForPreference(row),
          seller_ids: self.rowSellerIdsFor(row).slice(),
          delivery_frequency: d.frequency,
          delivery_schedule: d.schedule
        };

        if (row.delayMinutesConfigurable) {
          pref.delay_minutes = self.delayMinutesForRow(row);
        }

        if (self.rowSupportsOwnMp(row)) {
          pref.marketplace_scope = normalizeMpScope(self.rowMpScope[row.id]);
        }
        if (row.subtypes) {
          pref.muted_subtypes = self.mutedSubtypesFor(row).slice().sort();
        }
        if (row.settingsKey) {
          pref.settings = self.rowSettingsFor(row);
        }
        out.push(pref);
      });
      return out;
    },

    rowSellerIdsFor: function rowSellerIdsFor(row) {
      var ids = row && this.rowSellerIds[row.id];
      if (!Array.isArray(ids)) return [];
      return ids.slice().sort(function (a, b) {
        return a - b;
      });
    },
    showStorefrontChip: function showStorefrontChip(row) {
      if (!row.alertCategory || row.alwaysOn || this.rowLocked(row)) return false;
      if (!this.rowOn(row)) return false;
      return this.assignedStorefronts.length > 1;
    },
    selectedAssignedStorefronts: function selectedAssignedStorefronts(row) {
      var ids = this.rowSellerIdsFor(row);
      if (!ids.length) return this.assignedStorefronts;
      return this.assignedStorefronts.filter(function (sf) {
        return ids.indexOf(sf.id) >= 0;
      });
    },
    storefrontChipLabel: function storefrontChipLabel(row) {
      if (!this.rowSellerIdsFor(row).length) return 'All storefronts';
      return this.selectedAssignedStorefronts(row).length + ' of ' + this.assignedStorefronts.length + ' storefronts';
    },
    storefrontChipTooltip: function storefrontChipTooltip(row) {
      if (!this.rowSellerIdsFor(row).length) return 'All storefronts';
      var names = this.selectedAssignedStorefronts(row).map(function (sf) {
        return sf.name;
      });
      return names.length ? names.join(', ') : 'No assigned storefronts selected';
    },

    storefrontSelectionStale: function storefrontSelectionStale(row) {
      if (!row.alertCategory || row.alwaysOn || this.rowLocked(row) || !this.rowOn(row)) return false;
      if (!this.rowSellerIdsFor(row).length) return false;
      return this.selectedAssignedStorefronts(row).length === 0;
    },
    storefrontSelected: function storefrontSelected(row, sellerId) {
      var ids = this.rowSellerIdsFor(row);
      return ids.length > 0 && ids.indexOf(sellerId) >= 0;
    },
    toggleStorefrontMenu: function toggleStorefrontMenu(row) {
      this.brandPickerKey = null;
      this.$set(this.storefrontMenuError, row.id, '');
      this.openStorefrontRowId = this.openStorefrontRowId === row.id ? null : row.id;
    },
    setRowSellerIds: function setRowSellerIds(row, ids) {
      var assignedIds = this.assignedStorefronts.map(function (sf) {
        return sf.id;
      });
      var uniq = ids.filter(function (id, i) {
        return ids.indexOf(id) === i;
      });
      var coversAll = assignedIds.length > 0 && assignedIds.every(function (id) {
        return uniq.indexOf(id) >= 0;
      });
      this.$set(this.rowSellerIds, row.id, coversAll ? [] : uniq);
      this.$set(this.storefrontMenuError, row.id, '');
    },
    setStorefrontsAll: function setStorefrontsAll(row) {
      this.setRowSellerIds(row, []);
    },
    setStorefrontsOnly: function setStorefrontsOnly(row) {
      if (this.rowSellerIdsFor(row).length) return;
      var first = this.assignedStorefronts[0];
      if (first) this.setRowSellerIds(row, [first.id]);
    },
    onStorefrontCheck: function onStorefrontCheck(row, sellerId, checked, evt) {
      var assignedIds = this.assignedStorefronts.map(function (sf) {
        return sf.id;
      });
      var current = this.rowSellerIdsFor(row);

      var base = current.filter(function (id) {
        return assignedIds.indexOf(id) >= 0;
      });
      var next = checked ? base.concat([sellerId]) : base.filter(function (id) {
        return id !== sellerId;
      });
      if (!next.length) {
        if (evt && evt.target) evt.target.checked = true;
        this.$set(this.storefrontMenuError, row.id, 'Pick at least one storefront, or turn the alert off.');
        return;
      }
      this.setRowSellerIds(row, next);
    },
    onDocumentClick: function onDocumentClick(e) {
      var t = e && e.target;
      if (t && t.closest && (t.closest('.als-sf-chip') || t.closest('.als-bf-add'))) return;
      this.openStorefrontRowId = null;
      this.brandPickerKey = null;
    },
    subtypeOptions: function subtypeOptions(row) {
      return ALERT_SUBTYPES[row.subtypes] || [];
    },
    mutedSubtypesFor: function mutedSubtypesFor(row) {
      var muted = this.rowMutedSubtypes[row.id];
      return Array.isArray(muted) ? muted : [];
    },
    subtypeOn: function subtypeOn(row, key) {
      return this.mutedSubtypesFor(row).indexOf(key) < 0;
    },

    subtypeBoxVisible: function subtypeBoxVisible(row) {
      if (!row.subtypes || this.rowLocked(row)) return false;
      return row.alwaysOn || this.rowOn(row);
    },
    subtypeSummary: function subtypeSummary(row) {
      var all = this.subtypeOptions(row).length;
      var on = all - this.mutedSubtypesFor(row).length;
      return on === all ? 'all types' : on + ' of ' + all + ' types';
    },

    onSubtypeCheck: function onSubtypeCheck(row, key, checked, evt) {
      var muted = this.mutedSubtypesFor(row).filter(function (k) {
        return k !== key;
      });
      if (!checked) muted = muted.concat([key]);
      if (muted.length >= this.subtypeOptions(row).length) {
        if (evt && evt.target) evt.target.checked = true;
        this.$set(this.subtypeError, row.id, row.alwaysOn ? 'Keep at least one type. This alert is always on.' : 'Keep at least one type, or turn the alert off.');
        return;
      }
      this.$set(this.subtypeError, row.id, '');
      this.$set(this.rowMutedSubtypes, row.id, muted);
    },
    setAllSubtypes: function setAllSubtypes(row) {
      this.$set(this.subtypeError, row.id, '');
      this.$set(this.rowMutedSubtypes, row.id, []);
    },

    rowSettingsFor: function rowSettingsFor(row) {
      return normalizeRowSettings(row.settingsKey, this.rowSettings[row.id]);
    },
    setRowSetting: function setRowSetting(row, key, value) {
      var next = this.rowSettingsFor(row);
      next[key] = value;
      this.$set(this.rowSettings, row.id, normalizeRowSettings(row.settingsKey, next));
    },

    onMinRatingCountDropChange: function onMinRatingCountDropChange(row, evt) {
      var n = parseInt(evt.target.value, 10);
      if (!isNaN(n) && n >= 1) this.setRowSetting(row, 'min_rating_count_drop', n);
      evt.target.value = this.rowSettingsFor(row).min_rating_count_drop;
    },
    reviewSensitivitySummary: function reviewSensitivitySummary(row) {
      var st = this.rowSettingsFor(row);
      var n = st.min_rating_count_drop;
      return (st.rating_sensitivity === 'tenth' ? 'every 0.1 drop' : 'every half-star') + ', rating count drops of ' + n + (n === 1 ? ' or more' : '+');
    },

    sfMpCodes: function sfMpCodes(sf) {
      var seen = {};
      return (sf.mpCodes || []).reduce(function (acc, raw) {
        var code = mpApiCode(raw);
        if (code && !seen[code]) {
          seen[code] = true;
          acc.push({ raw: raw, code: code });
        }
        return acc;
      }, []);
    },
    mpEntry: function mpEntry(scope, sf) {
      var v = scope ? scope[String(sf.id)] : undefined;
      return Array.isArray(v) ? v : 'all';
    },
    mpIsAll: function mpIsAll(scope, sf) {
      return this.mpEntry(scope, sf) === 'all';
    },
    mpChipOn: function mpChipOn(scope, sf, code) {
      var v = this.mpEntry(scope, sf);
      return v !== 'all' && v.indexOf(code) >= 0;
    },
    setMpAll: function setMpAll(scope, sf) {
      if (scope) this.$set(scope, String(sf.id), 'all');
    },

    toggleMpChip: function toggleMpChip(scope, sf, code) {
      if (!scope) return;
      var all = this.sfMpCodes(sf).map(function (m) {
        return m.code;
      });
      var cur = this.mpEntry(scope, sf);
      var next;
      if (cur === 'all') {
        next = [code];
      } else {
        next = cur.indexOf(code) >= 0 ? cur.filter(function (c) {
          return c !== code;
        }) : cur.concat([code]);
      }
      var known = next.filter(function (c) {
        return all.indexOf(c) >= 0;
      });
      if (!known.length || known.length === all.length) {
        this.$set(scope, String(sf.id), 'all');
      } else {
        this.$set(scope, String(sf.id), all.filter(function (c) {
          return next.indexOf(c) >= 0;
        }));
      }
    },

    mpStale: function mpStale(scope, sf) {
      var v = this.mpEntry(scope, sf);
      if (v === 'all') return false;
      var codes = this.sfMpCodes(sf).map(function (m) {
        return m.code;
      });
      return !v.some(function (c) {
        return codes.indexOf(c) >= 0;
      });
    },

    mpScopeSummary: function mpScopeSummary(scope, storefronts) {
      var self = this;
      var parts = [];(storefronts || []).forEach(function (sf) {
        var v = self.mpEntry(scope, sf);
        if (v === 'all') return;
        var labels = v.map(function (c) {
          return MP_LABELS[c.toLowerCase()] || c;
        });
        parts.push(storefronts.length > 1 || self.assignedStorefronts.length > 1 ? sf.name + ': ' + labels.join(', ') : labels.join(', '));
      });
      return parts.length ? parts.join(' · ') : 'All marketplaces';
    },

    rowSupportsOwnMp: function rowSupportsOwnMp(row) {
      return !!row.alertCategory && !row.alwaysOn && !row.digestFixed && !row.noMarketplaceFilter && NO_MARKETPLACE_CATEGORIES.indexOf(row.alertCategory) < 0;
    },

    mpStorefronts: function mpStorefronts(row) {
      var self = this;
      return this.brandStorefronts(row).filter(function (sf) {
        return self.sfMpCodes(sf).length > 1;
      });
    },

    mpBoxVisible: function mpBoxVisible(row) {
      return this.rowSupportsOwnMp(row) && this.rowOn(row) && !this.rowLocked(row) && this.mpStorefronts(row).length > 0;
    },
    rowMpOwn: function rowMpOwn(row) {
      return this.rowMpScope[row.id] != null;
    },
    setRowMpMode: function setRowMpMode(row, own) {
      if (own) {
        if (!this.rowMpOwn(row)) this.$set(this.rowMpScope, row.id, JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.defaultMpScope || {})));
      } else {
        this.$set(this.rowMpScope, row.id, null);
      }
      this.$set(this.mpBoxOpen, row.id, true);
    },

    mpPillVisible: function mpPillVisible(row) {
      if (!this.mpBoxVisible(row)) return false;
      if (this.rowMpOwn(row)) return true;
      return this.mpScopeSummary(this.defaultMpScope, this.mpStorefronts(row)) !== 'All marketplaces';
    },
    mpPillText: function mpPillText(row) {
      var own = this.rowMpOwn(row);
      return (own ? 'Own · ' : 'Default · ') + this.mpScopeSummary(own ? this.rowMpScope[row.id] : this.defaultMpScope, this.mpStorefronts(row));
    },
    applyDefaultMpScope: function applyDefaultMpScope() {
      var k = this.normalizeEmailKey(this.selectedUserEmail);
      var scope = k ? this.notificationScopeByUser[k] : null;
      var raw = scope && scope.alertMarketplaceScope ? scope.alertMarketplaceScope : {};
      this.defaultMpScope = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(raw));
      this.defaultMpScopeSnapshot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(normalizeMpScope(this.defaultMpScope));
    },
    saveDefaultMpScope: function saveDefaultMpScope() {
      var self = this;
      if (!self.defaultMpScopeChanged) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      return self.$http.patch(NOTIFICATION_PREFS_MARKETPLACES_URL, {
        user_email: self.selectedUserEmail,
        alert_marketplace_scope: normalizeMpScope(self.defaultMpScope)
      }).then(function (res) {
        var body = res && res.body || {};
        var k = self.normalizeEmailKey(self.selectedUserEmail);
        if (k && self.notificationScopeByUser[k]) {
          self.$set(self.notificationScopeByUser[k], 'alertMarketplaceScope', body.alert_marketplace_scope || {});
        }
        self.applyDefaultMpScope();
      });
    },
    serializedBrandAllowlist: function serializedBrandAllowlist() {
      var src = this.brandAllowlist || {};
      var out = {};
      BRAND_FILTER_ALERTS.forEach(function (alert) {
        var lists = src[alert] || {};
        out[alert] = {};
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(lists).sort().forEach(function (k) {
          out[alert][k] = (lists[k] || []).slice();
        });
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(out);
    },
    brandsFor: function brandsFor(alert, sellerId) {
      return (this.brandAllowlist[alert] || {})[String(sellerId)] || [];
    },

    brandStorefronts: function brandStorefronts(row) {
      var ids = this.rowSellerIdsFor(row);
      if (!ids.length) return this.assignedStorefronts;
      return this.assignedStorefronts.filter(function (sf) {
        return ids.indexOf(sf.id) >= 0;
      });
    },
    brandFilterSummary: function brandFilterSummary(row) {
      var self = this;
      var n = this.brandStorefronts(row).filter(function (sf) {
        return self.brandsFor(row.brandFilter, sf.id).length > 0;
      }).length;
      if (!n) return '';
      return ' · ' + n + ' storefront' + (n === 1 ? '' : 's') + ' filtered';
    },
    brandFilterIsOpen: function brandFilterIsOpen(alert) {
      return this.brandFilterOpen[alert] !== false;
    },
    setBrandFilterOpen: function setBrandFilterOpen(alert, open) {
      if (this.brandFilterIsOpen(alert) !== !!open) this.$set(this.brandFilterOpen, alert, !!open);
    },

    brandPickerKeyFor: function brandPickerKeyFor(rowId, sellerId) {
      return rowId + '|' + String(sellerId);
    },

    loadBrandAllowlists: function loadBrandAllowlists() {
      var self = this;
      var userId = self.selectedUserIdForApi();
      var params = userId != null && userId !== '' ? { user_id: userId } : {};
      return self.$http.get(USER_BRAND_ALLOWLISTS_URL, { params: params }).then(function (res) {
        var lists = res.body && res.body.lists || {};
        var map = emptyBrandAllowlists();
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(lists).forEach(function (sid) {
          var perAlert = lists[sid] || {};
          BRAND_FILTER_ALERTS.forEach(function (alert) {
            var list = perAlert[alert];
            map[alert][String(sid)] = Array.isArray(list) ? list.slice() : [];
          });
        });
        self.brandAllowlist = map;
        self.brandAllowlistSnapshot = self.serializedBrandAllowlist();
        self.brandAllowlistLoaded = true;

        var open = {};
        BRAND_FILTER_ALERTS.forEach(function (alert) {
          open[alert] = !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(map[alert]).some(function (k) {
            return map[alert][k].length > 0;
          });
        });
        self.brandFilterOpen = open;
      }).catch(function () {
        self.brandAllowlistLoaded = false;
      });
    },
    setBrandList: function setBrandList(alert, sellerId, list) {
      if (!this.brandAllowlist[alert]) this.$set(this.brandAllowlist, alert, {});
      this.$set(this.brandAllowlist[alert], String(sellerId), list);
    },
    removeBrand: function removeBrand(alert, sellerId, idx) {
      var list = this.brandsFor(alert, sellerId).slice();
      list.splice(idx, 1);
      this.setBrandList(alert, sellerId, list);
    },
    addBrand: function addBrand(alert, sellerId, brand) {
      var clean = cleanBrand(brand);
      if (!clean) return;
      var list = this.brandsFor(alert, sellerId).slice();
      var exists = list.some(function (b) {
        return brandKey(b) === brandKey(clean);
      });
      if (!exists) list.push(clean);
      this.setBrandList(alert, sellerId, list);
      this.brandPickerKey = null;
      this.brandQuery = '';
    },
    addTypedBrand: function addTypedBrand(alert, sellerId) {
      if (!this.brandQuery.trim()) return;
      var q = brandKey(this.brandQuery);
      var match = this.brandPickerOptions(alert, sellerId).filter(function (o) {
        return brandKey(o.brand) === q;
      })[0];
      this.addBrand(alert, sellerId, match ? match.brand : this.brandQuery);
    },
    toggleBrandPicker: function toggleBrandPicker(alert, sellerId, rowId) {
      var k = this.brandPickerKeyFor(rowId || alert, sellerId);
      this.openStorefrontRowId = null;
      if (this.brandPickerKey === k) {
        this.brandPickerKey = null;
        return;
      }
      this.brandPickerKey = k;
      this.brandQuery = '';
      this.fetchBrandOptions(sellerId, '');
      var self = this;
      this.$nextTick(function () {
        var el = self.$el && self.$el.querySelector('.als-bf-search');
        if (el) el.focus();
      });
    },
    onBrandQuery: function onBrandQuery(sellerId, value) {
      var self = this;
      this.brandQuery = value;
      if (this.brandQueryTimer) clearTimeout(this.brandQueryTimer);
      this.brandQueryTimer = setTimeout(function () {
        self.fetchBrandOptions(sellerId, value);
      }, 250);
    },

    brandOptionsCacheKey: function brandOptionsCacheKey(sellerId, q) {
      return String(sellerId) + '|' + brandKey(q);
    },
    fetchBrandOptions: function fetchBrandOptions(sellerId, q) {
      var self = this;
      var key = this.brandOptionsCacheKey(sellerId, q);
      if (this.brandOptionsCache[key]) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      var query = String(q || '').trim();
      this.brandOptionsLoading = !this.brandOptionsCache[this.brandOptionsCacheKey(sellerId, '')];
      return this.$http.get(sellerBrandsUrl(sellerId), { params: query ? { q: query } : {} }).then(function (res) {
        var list = res.body && res.body.brands || [];
        self.$set(self.brandOptionsCache, key, list);
        self.brandOptionsLoading = false;
      }).catch(function () {
        self.$set(self.brandOptionsCache, key, []);
        self.brandOptionsLoading = false;
      });
    },

    brandPickerOptions: function brandPickerOptions(alert, sellerId) {
      var q = brandKey(this.brandQuery);
      var list = this.brandOptionsCache[this.brandOptionsCacheKey(sellerId, this.brandQuery)];
      if (!list) {
        list = (this.brandOptionsCache[this.brandOptionsCacheKey(sellerId, '')] || []).filter(function (o) {
          return brandKey(o.brand).indexOf(q) >= 0;
        });
      }
      var taken = this.brandsFor(alert, sellerId).map(brandKey);
      return list.filter(function (o) {
        return taken.indexOf(brandKey(o.brand)) < 0;
      });
    },
    brandQueryIsCustom: function brandQueryIsCustom(alert, sellerId) {
      var q = brandKey(this.brandQuery);
      if (!q) return false;
      if (this.brandsFor(alert, sellerId).some(function (b) {
        return brandKey(b) === q;
      })) return false;
      return !this.brandPickerOptions(alert, sellerId).some(function (o) {
        return brandKey(o.brand) === q;
      });
    },

    saveBrandAllowlists: function saveBrandAllowlists() {
      var self = this;
      if (!self.brandFilterEditable || !self.brandAllowlistChanged) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      var before = emptyBrandAllowlists();
      try {
        before = JSON.parse(self.brandAllowlistSnapshot) || before;
      } catch (e) {}
      var changed = [];
      BRAND_FILTER_ALERTS.forEach(function (alert) {
        var now = self.brandAllowlist[alert] || {};
        var was = before[alert] || {};
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(now).forEach(function (k) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(now[k] || []) !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(was[k] || [])) changed.push({ alert: alert, sellerId: k });
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(changed.map(function (c) {
        var userId = self.selectedUserIdForApi();
        var params = userId != null && userId !== '' ? { user_id: userId } : {};
        return self.$http.patch(sellerBrandAllowlistUrl(c.sellerId, c.alert), { brand_allowlist: self.brandsFor(c.alert, c.sellerId) }, { params: params }).then(function (res) {
          var saved = res.body && res.body.brand_allowlist;
          if (Array.isArray(saved)) self.setBrandList(c.alert, c.sellerId, saved.slice());
        });
      })).then(function () {
        self.brandAllowlistSnapshot = self.serializedBrandAllowlist();
      });
    },
    assignedSellerIdSetForSelectedUser: function assignedSellerIdSetForSelectedUser() {
      var k = this.normalizeEmailKey(this.selectedUserEmail);
      var scope = k ? this.notificationScopeByUser[k] : null;
      var assigned = scope && Array.isArray(scope.assignedSellerIds) ? scope.assignedSellerIds : null;
      if (!assigned) {
        var ea = this.selectedEa;
        assigned = ea && Array.isArray(ea.allowedSellerAccounts) ? ea.allowedSellerAccounts : [];
      }
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(assigned.map(function (id) {
        return String(id);
      }));
    },
    availableSellersForSelectedUser: function availableSellersForSelectedUser() {
      var k = this.normalizeEmailKey(this.selectedUserEmail);
      var scope = k ? this.notificationScopeByUser[k] : null;
      if (scope && Array.isArray(scope.availableSellers)) return scope.availableSellers;
      return this.sellers;
    },
    rowEnabledForPreference: function rowEnabledForPreference(row) {
      if (row.alwaysOn) return true;
      if (this.rowLocked(row)) return false;
      return this.rowOn(row);
    },

    browserIanaTimezoneForApi: function browserIanaTimezoneForApi() {
      return browserIanaTimezoneStatic();
    },
    deliveryApiForRow: function deliveryApiForRow(row, hour) {
      var digestTz = { timezone: this.browserIanaTimezoneForApi() };
      if (row.digestFixed) {
        return { frequency: 'daily', schedule: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ hour: hour }, digestTz) };
      }
      if (row.alwaysOn) {
        return { frequency: 'real_time', schedule: {} };
      }
      if (this.deliveryRealtimeBadgeOnly(row) || this.rowLocked(row)) {
        return { frequency: 'real_time', schedule: {} };
      }
      var mode = this.deliveryFor(row);
      if (mode === 'realtime') {
        return { frequency: 'real_time', schedule: {} };
      }
      if (mode === 'daily') {
        return { frequency: 'daily', schedule: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ hour: hour }, digestTz) };
      }
      if (mode === 'weekly') {
        var sched = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ hour: hour, weekday: normalizeDeliveryWeekday(this.weeklyDay[row.id]) }, digestTz);
        return { frequency: 'weekly', schedule: sched };
      }
      return { frequency: 'real_time', schedule: {} };
    },
    capturePrefsSnapshot: function capturePrefsSnapshot() {
      this.prefsSnapshot = this.serializedPrefsForCompare();
    },
    normalizeEmailKey: function normalizeEmailKey(email) {
      return email ? String(email).trim().toLowerCase() : '';
    },

    preferencesArrayFromSettingsBody: function preferencesArrayFromSettingsBody(body) {
      if (!body) return null;
      if (Array.isArray(body)) return body;
      if (Array.isArray(body.preferences)) return body.preferences;
      if (body.data && Array.isArray(body.data.preferences)) return body.data.preferences;
      return null;
    },

    normalizeNotificationUsersResponse: function normalizeNotificationUsersResponse(body) {
      var out = {};
      var self = this;
      function store(email, prefs) {
        if (!email || !Array.isArray(prefs)) return;
        out[self.normalizeEmailKey(email)] = prefs;
      }
      if (!body) return out;
      if (Array.isArray(body)) {
        body.forEach(function (u) {
          store(u.user_email || u.email || u.userEmail, u.preferences || u.preference_list || u.notification_preferences);
        });
        return out;
      }
      if ((typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(body)) === 'object') {
        var rootEmail = body.user_email || body.email || body.userEmail;
        var rootPrefs = body.preferences || body.preference_list || body.notification_preferences;
        if (rootEmail && Array.isArray(rootPrefs) && body.users == null && !body.preferences_by_user && !body.preferencesByUser) {
          store(rootEmail, rootPrefs);
        }
      }
      var pbu = body.preferences_by_user || body.preferencesByUser || body.by_user;
      if (pbu && (typeof pbu === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(pbu)) === 'object' && !Array.isArray(pbu)) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(pbu).forEach(function (em) {
          var v = pbu[em];
          if (Array.isArray(v)) store(em, v);else if (v && Array.isArray(v.preferences)) store(em, v.preferences);
        });
      }
      var users = body.users || body.data || body.results || body.items;
      if (Array.isArray(users)) {
        users.forEach(function (u) {
          store(u.user_email || u.email || u.userEmail || u.mail, u.preferences || u.preference_list || u.notification_preferences);
        });
      }
      return out;
    },
    normalizeAvailableSellerForUi: function normalizeAvailableSellerForUi(seller, idx) {
      if (!seller || (typeof seller === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(seller)) !== 'object') return null;
      var sid = seller.sellerId != null ? seller.sellerId : seller.seller_id != null ? seller.seller_id : seller.id != null ? seller.id : null;
      if (sid != null && (typeof sid === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(sid)) === 'object' && sid.value !== undefined) sid = sid.value;
      if (sid == null || sid === '') return null;
      var name = seller.nickName || seller.nick_name || seller.seller_name || seller.store_name || seller.name || 'Storefront ' + String(sid).slice(-6);
      var mpCodes = null;
      if (Array.isArray(seller.marketplace_codes) && seller.marketplace_codes.length) {
        mpCodes = seller.marketplace_codes.map(function (c) {
          return String(c).toLowerCase();
        });
      } else if (Array.isArray(seller.marketplaceCodes) && seller.marketplaceCodes.length) {
        mpCodes = seller.marketplaceCodes.map(function (c) {
          return String(c).toLowerCase();
        });
      }
      return {
        sellerId: sid,
        nickName: name,
        marketplaceIso31662Code: seller.marketplaceIso31662Code || seller.marketplace_iso31662_code || seller.marketplace || mpCodes && mpCodes[0] || '',
        marketplaceCodes: mpCodes,
        region: seller.region || '',
        key: String(sid) + '-' + String(idx)
      };
    },
    notificationScopeFromBody: function notificationScopeFromBody(body) {
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(body)) !== 'object') return null;
      var root = body.data && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(body.data) === 'object' ? body.data : body;
      var assignedSellers = root.assigned_sellers || root.assignedSellers;
      var assignedIds = root.assigned_seller_ids || root.assignedSellerIds;
      var available = root.available_sellers || root.availableSellers;
      if (!Array.isArray(available) && Array.isArray(root.preferences)) {
        var seenAvail = {};
        available = [];
        root.preferences.forEach(function (pref) {
          if (!Array.isArray(pref.available_sellers)) return;
          pref.available_sellers.forEach(function (s) {
            var sid = s.id != null ? s.id : s.seller_id != null ? s.seller_id : null;
            var key = sid != null ? String(sid) : s.name || '';
            if (!key || seenAvail[key]) return;
            seenAvail[key] = true;
            available.push(s);
          });
        });
        if (!available.length) available = null;
      }
      if (!Array.isArray(assignedSellers) && !Array.isArray(assignedIds) && !Array.isArray(available)) return null;
      var normalizedAssigned;
      if (Array.isArray(assignedSellers)) {
        normalizedAssigned = assignedSellers.map(function (item) {
          if (!item || (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) !== 'object') return null;
          var id = item.seller_id != null ? item.seller_id : item.sellerId != null ? item.sellerId : null;
          if (id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined) id = id.value;
          return id != null && id !== '' ? id : null;
        }).filter(function (id) {
          return id != null;
        });
      } else {
        normalizedAssigned = Array.isArray(assignedIds) ? assignedIds.map(function (id) {
          if (id != null && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(id)) === 'object' && id.value !== undefined) return id.value;
          return id;
        }).filter(function (id) {
          return id != null && id !== '';
        }) : [];
      }
      var normalizedAvailable = Array.isArray(available) ? available.map(this.normalizeAvailableSellerForUi).filter(function (s) {
        return s != null;
      }) : [];
      var mpScope = root.alert_marketplace_scope || root.alertMarketplaceScope;
      return {
        assignedSellerIds: normalizedAssigned,
        availableSellers: normalizedAvailable,
        alertMarketplaceScope: mpScope && (typeof mpScope === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(mpScope)) === 'object' ? mpScope : {}
      };
    },
    hydrateNotificationScopeUsersResponse: function hydrateNotificationScopeUsersResponse(body) {
      var self = this;
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(body)) !== 'object') return;
      var users = Array.isArray(body) ? body : body.users || body.data || body.results || body.items;
      if (!Array.isArray(users)) return;
      users.forEach(function (u) {
        if (!u || (typeof u === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(u)) !== 'object') return;
        var em = u.user_email || u.email || u.userEmail || u.mail;
        var k = self.normalizeEmailKey(em);
        if (!k) return;
        var scope = self.notificationScopeFromBody(u);
        if (!scope) return;
        self.$set(self.notificationScopeByUser, k, scope);
      });
    },
    fetchNotificationPreferencesUsersBulk: function fetchNotificationPreferencesUsersBulk() {
      var self = this;
      return self.$http.get(NOTIFICATION_PREFS_USERS_URL).then(function (res) {
        var body = res.body || {};
        self.notificationPrefsByUser = self.normalizeNotificationUsersResponse(body);
        self.hydrateNotificationScopeUsersResponse(body);
        self.notificationPrefsBulkLoaded = true;
      }).catch(function () {
        self.notificationPrefsBulkLoaded = false;
      });
    },

    prefsFromBulkCache: function prefsFromBulkCache(email) {
      var k = this.normalizeEmailKey(email);
      if (!this.notificationPrefsBulkLoaded || !k) return undefined;
      if (!Object.prototype.hasOwnProperty.call(this.notificationPrefsByUser, k)) return undefined;
      var prefs = this.notificationPrefsByUser[k];
      if (Array.isArray(prefs) && prefs.length === 0) return undefined;
      return prefs;
    },

    loadNotificationPreferencesFromApi: function loadNotificationPreferencesFromApi(opts) {
      var self = this;
      var force = opts && opts.forceUserGet === true;
      if (!self.selectedUserEmail) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      if (!force) {
        var cached = self.prefsFromBulkCache(self.selectedUserEmail);
        if (cached !== undefined) {
          self.applyNotificationPreferences(Array.isArray(cached) ? cached : []);
          self.applyDefaultMpScope();
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
      }
      return self.$http.get(NOTIFICATION_PREFS_URL, { params: { user_email: self.selectedUserEmail } }).then(function (res) {
        var body = res.body || {};
        var scope = self.notificationScopeFromBody(body);
        var k = self.normalizeEmailKey(self.selectedUserEmail);
        if (k && scope) self.$set(self.notificationScopeByUser, k, scope);
        var prefs = self.preferencesArrayFromSettingsBody(body);
        if (Array.isArray(prefs)) self.applyNotificationPreferences(prefs);
        self.applyDefaultMpScope();
        self.applyNotificationLocaleFromBody(body);
      });
    },
    applyNotificationLocaleFromBody: function applyNotificationLocaleFromBody(body) {
      var locale = body.notification_locale || body.notificationLocale || 'en';
      this.notificationLocale = String(locale).toLowerCase();
      var supported = body.supported_notification_locales || body.supportedNotificationLocales;
      if (Array.isArray(supported) && supported.length) {
        this.supportedNotificationLocales = supported.map(function (c) {
          return String(c).toLowerCase();
        });
      }
    },
    saveNotificationLocale: function saveNotificationLocale() {
      var self = this;
      if (!self.selectedUserEmail) return;
      self.localeSaving = true;
      self.localeError = null;
      self.localeSaved = false;
      self.$http.patch(NOTIFICATION_PREFS_LOCALE_URL, {
        user_email: self.selectedUserEmail,
        notification_locale: self.notificationLocale
      }).then(function () {
        self.localeSaving = false;
        self.localeSaved = true;
        setTimeout(function () {
          self.localeSaved = false;
        }, 2500);
      }, function (err) {
        self.localeSaving = false;
        var body = err.body || {};
        self.localeError = body.message || body.error || 'Could not save notification language.';
      });
    },
    applyNotificationPreferences: function applyNotificationPreferences(prefs) {
      var self = this;
      var ea = this.selectedEa;
      if (!ea || !Array.isArray(prefs) || prefs.length === 0) return;
      prefs.forEach(function (p) {
        var row = rowForAlertCategory(p.alert_category);
        if (!row) return;
        self.$set(self.rowSellerIds, row.id, numericIdList(p.seller_ids));
        var ownMp = p.marketplace_scope && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(p.marketplace_scope) === 'object' ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(p.marketplace_scope)) : null;
        self.$set(self.rowMpScope, row.id, ownMp);
        if (ownMp && self.mpBoxOpen[row.id] === undefined) self.$set(self.mpBoxOpen, row.id, true);
        if (row.subtypes) {
          self.$set(self.rowMutedSubtypes, row.id, Array.isArray(p.muted_subtypes) ? p.muted_subtypes.slice() : []);
        }
        if (row.settingsKey) {
          self.$set(self.rowSettings, row.id, normalizeRowSettings(row.settingsKey, p.settings));
        }
        var en = p.enabled === true;
        if (row.alwaysOn && !row.digestFixed) {} else if (row.digestFixed) {
          if (row.localKey) self.$set(self.localRowOn, row.id, en);
          if (p.delivery_schedule && p.delivery_schedule.hour != null) {
            var dhRaw = Number(p.delivery_schedule.hour);
            var dsDigest = p.delivery_schedule || {};
            var dh = deliveryScheduleHourToBrowserLocalHour(dhRaw, dsDigest, 'daily', null);
            self.$set(self.rowDigestHour, row.id, dh);
            self.$set(ea, 'digestEmailHour', dh);
            try {
              window.localStorage.setItem('als_hour|' + self.hydrationKey(row.id), String(dh));
            } catch (eH) {}
          }
        } else if (row.localKey) {
          self.$set(self.localRowOn, row.id, en);
        } else if (row.wdt) {
          var wd = self.ensureWd(ea, row.wdt);
          if (!wd.orig) wd.orig = { RED: wd.RED, AMBER: wd.AMBER, GREEN: wd.GREEN };
          wd.RED = wd.AMBER = wd.GREEN = en;
        }
        var freq = String(p.delivery_frequency || 'real_time').toLowerCase();
        var uiDel = freq === 'real_time' ? 'realtime' : freq;
        if (!self.deliveryRealtimeBadgeOnly(row) && !row.alwaysOn && !row.digestFixed && !self.rowLocked(row)) {
          var coerced = uiDel;
          self.$set(self.rowDelivery, row.id, coerced);
          try {
            window.localStorage.setItem(self.lsPrefix + self.hydrationKey(row.id), coerced);
          } catch (e) {}
        }
        var ds = p.delivery_schedule || {};
        if (ds.hour != null && ea && !row.digestFixed && (freq === 'daily' || freq === 'weekly')) {
          var rowHRaw = Number(ds.hour);
          var rowH = deliveryScheduleHourToBrowserLocalHour(rowHRaw, ds, freq, ds.weekday);
          self.$set(self.rowDigestHour, row.id, rowH);
          try {
            window.localStorage.setItem('als_hour|' + self.hydrationKey(row.id), String(rowH));
          } catch (eHr) {}
        }
        if (ds.weekday != null && row.id && freq === 'weekly') {
          var wdayCanonical = normalizeDeliveryWeekday(ds.weekday);
          self.$set(self.weeklyDay, row.id, wdayCanonical);
          try {
            window.localStorage.setItem('als_wday|' + self.hydrationKey(row.id), wdayCanonical);
          } catch (e2) {}
        }
        if (row.delayMinutesConfigurable) {
          self.applyBuyboxDelayState(row, normalizeBuyboxDelayMinutes(p.delay_minutes));
        }
      });
      try {
        self.persistLocalRowOnJson();
      } catch (e3) {}
    },
    onInboxModeChange: function onInboxModeChange(threaded) {
      var self = this;
      var prev = this.threadedAlerts;
      if (prev === threaded) return;
      this.threadedAlerts = threaded;
      this.inboxModeSaving = true;
      this.$http.put('/api/identity/settings', { threadedAlerts: threaded }).then(function (res) {
        self.inboxModeSaving = false;
        var body = res && res.body || {};
        if (body.threadedAlerts != null) self.threadedAlerts = body.threadedAlerts === true;
        self.successMsg = 'Inbox mode: ' + (self.threadedAlerts ? 'Threaded' : 'Separate emails') + '.';
        setTimeout(function () {
          self.successMsg = '';
        }, 2800);
      }, function (err) {
        self.inboxModeSaving = false;
        self.threadedAlerts = prev;
        var msg = err && err.body && err.body.message;
        if (Array.isArray(msg)) msg = msg.filter(Boolean).join(', ');
        self.errorMsg = msg || 'Failed to save inbox mode';
        setTimeout(function () {
          self.errorMsg = '';
        }, 4500);
      });
    },
    onDigestToggle: function onDigestToggle(on) {
      var self = this;
      var next = !!on;
      var prev = this.offerActivityDigest;
      this.offerActivityDigest = next;
      this.digestSaving = true;
      this.$http.put('/api/identity/settings', { offerActivityDigest: next }).then(function (res) {
        self.digestSaving = false;
        var body = res && res.body || {};
        var v = body.offerActivityDigest;
        if (v == null) v = body.offer_activity_digest;
        if (v != null) {
          self.offerActivityDigest = v === true || v === 1 || v === '1' || v === 'true';
        }
        self.successMsg = 'Offer activity digest ' + (self.offerActivityDigest ? 'on' : 'off') + '.';
        setTimeout(function () {
          self.successMsg = '';
        }, 2800);
      }, function (err) {
        self.digestSaving = false;
        self.offerActivityDigest = prev;
        var msg = err && err.body && err.body.message;
        if (Array.isArray(msg)) msg = msg.filter(Boolean).join(', ');
        self.errorMsg = msg || 'Failed to save digest setting';
        setTimeout(function () {
          self.errorMsg = '';
        }, 4500);
      });
    },
    save: function save() {
      var self = this;
      if (!self.hasChanges) return;
      if (self.hasDelayValidationError) {
        self.errorMsg = 'Fix the Buy Box delay: enter a whole number between 20 and 40 minutes.';
        setTimeout(function () {
          self.errorMsg = '';
        }, 4500);
        return;
      }
      var userId = self.selectedUserIdForApi();
      if (userId == null || userId === '') {
        self.errorMsg = 'Cannot save: missing user id for this member.';
        setTimeout(function () {
          self.errorMsg = '';
        }, 4500);
        return;
      }
      self.saving = true;
      var body = { preferences: self.buildPreferencesArray() };
      var params = { user_email: self.selectedUserEmail, user_id: userId };

      self.saveDefaultMpScope().then(function () {
        return self.$http.put(NOTIFICATION_PREFS_URL, body, { params: params });
      }).then(function () {
        return self.saveBrandAllowlists();
      }).then(function () {
        self.persistLocalRowOnJson();
        if (self.isOwner) {
          return self.fetchNotificationPreferencesUsersBulk().catch(function () {});
        }
      }).then(function () {
        return self.loadNotificationPreferencesFromApi({ forceUserGet: true });
      }).then(function () {
        self.capturePrefsSnapshot();
        window.dirty = false;
        self.saving = false;
        self.successMsg = 'Preferences saved.';
        setTimeout(function () {
          self.successMsg = '';
        }, 2800);
      }).catch(function (err) {
        self.saving = false;
        self.errorMsg = err.body && err.body.message || 'Save failed';
        setTimeout(function () {
          self.errorMsg = '';
        }, 4500);
      });
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      sensitivity: null,
      sensitivityOrig: null,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/amazonChoiceBadge').then(function (response) {
        _this.loading = false;
        _this.sensitivity = response.body.sensitivity;
        _this.sensitivityOrig = response.body.sensitivity;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/amazonChoiceBadge', {
        sensitivity: this.sensitivity
      }).then(function (response) {
        _this2.loading = false;
        _this2.sensitivityOrig = _this2.sensitivity;
        _this2.dirty = _this2.sensitivity !== _this2.sensitivityOrig;
      }, function (response) {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    sensitivity: function sensitivity() {
      this.dirty = this.sensitivity !== this.sensitivityOrig;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApiKeysSettings',

  data: function data() {
    return {
      loading: false,
      loadError: null,
      apiKeys: [],

      showForm: false,
      formName: '',
      submitting: false,
      formError: null,

      tokenModal: { show: false, token: '' },
      copied: false,

      revokeConfirmId: null,
      revokingId: null
    };
  },

  mounted: function mounted() {
    this.fetchAll();
  },

  methods: {
    fetchAll: function fetchAll() {
      this.loading = true;
      this.loadError = null;
      var self = this;
      this.$http.get('/api/v1/api_keys').then(function (res) {
        self.loading = false;
        self.apiKeys = (res.body || {}).api_keys || [];
      }).catch(function (err) {
        self.loading = false;
        var body = err && err.body || {};
        var msg = body.message;
        self.loadError = Array.isArray(msg) ? msg.join(', ') : msg || 'Failed to load API keys';
      });
    },

    openForm: function openForm() {
      this.showForm = true;
      this.formName = '';
      this.formError = null;
    },

    closeForm: function closeForm() {
      this.showForm = false;
      this.formError = null;
    },

    createKey: function createKey() {
      this.formError = null;
      this.submitting = true;
      var self = this;
      var payload = {
        api_key: {
          name: this.formName.trim() || 'API key',
          scopes: ['read']
        }
      };
      this.$http.post('/api/v1/api_keys', payload).then(function (res) {
        self.submitting = false;
        var key = (res.body || {}).api_key || {};
        var token = key.token || '';
        delete key.token;
        self.apiKeys.unshift(key);
        self.closeForm();
        self.tokenModal = { show: true, token: token };
      }).catch(function (err) {
        self.submitting = false;
        var body = err && err.body || {};
        var msg = body.message;
        self.formError = Array.isArray(msg) ? msg.join(', ') : msg || 'Failed to create API key';
      });
    },

    confirmRevoke: function confirmRevoke(id) {
      this.revokeConfirmId = id;
    },

    revokeKey: function revokeKey(id) {
      this.revokingId = id;
      var self = this;
      this.$http.delete('/api/v1/api_keys/' + id).then(function () {
        self.revokingId = null;
        self.revokeConfirmId = null;
        var now = new Date().toISOString();
        var idx = self.apiKeys.findIndex(function (k) {
          return k.id === id;
        });
        if (idx > -1) {
          var updated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, self.apiKeys[idx], { revoked_at: now });
          self.$set(self.apiKeys, idx, updated);
        }
      }).catch(function (err) {
        self.revokingId = null;
        var body = err && err.body || {};
        alert(Array.isArray(body.message) ? body.message.join(', ') : body.message || 'Failed to revoke key');
      });
    },

    closeTokenModal: function closeTokenModal() {
      this.tokenModal = { show: false, token: '' };
      this.copied = false;
    },

    copyToClipboard: function copyToClipboard(text) {
      var self = this;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          self.copied = true;
          setTimeout(function () {
            self.copied = false;
          }, 2500);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        self.copied = true;
        setTimeout(function () {
          self.copied = false;
        }, 2500);
      }
    },

    formatDate: function formatDate(iso) {
      if (!iso) return '—';
      try {
        var d = new Date(iso);
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
      } catch (e) {
        return iso;
      }
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      sensitivity: null,
      sensitivityOrig: null,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/bestSellerBadge').then(function (response) {
        _this.loading = false;
        _this.sensitivity = response.body.sensitivity;
        _this.sensitivityOrig = response.body.sensitivity;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/bestSellerBadge', {
        sensitivity: this.sensitivity
      }).then(function (response) {
        _this2.loading = false;
        _this2.sensitivityOrig = _this2.sensitivity;
        _this2.dirty = _this2.sensitivity !== _this2.sensitivityOrig;
      }, function (response) {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    sensitivity: function sensitivity() {
      this.dirty = this.sensitivity !== this.sensitivityOrig;
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      alertOnCategoryGroupChange: false,
      alertOnCategoryTypeNameChange: false,
      alertOnCategoryGroupChangeOrig: false,
      alertOnCategoryTypeNameChangeOrig: false,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/productCategoryRecentChange').then(function (response) {
        _this.loading = false;
        _this.alertOnCategoryGroupChangeOrig = _this.alertOnCategoryGroupChange = response.body.alertOnCategoryGroupChange;
        _this.alertOnCategoryTypeNameChangeOrig = _this.alertOnCategoryTypeNameChange = response.body.alertOnCategoryTypeNameChange;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/productCategoryRecentChange', {
        alertOnCategoryGroupChange: this.alertOnCategoryGroupChange,
        alertOnCategoryTypeNameChange: this.alertOnCategoryTypeNameChange
      }).then(function (response) {
        _this2.alertOnCategoryGroupChangeOrig = _this2.alertOnCategoryGroupChange;
        _this2.alertOnCategoryTypeNameChangeOrig = _this2.alertOnCategoryTypeNameChange;
        _this2.updateDirty();
      }, function (response) {
        _this2.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = this.alertOnCategoryGroupChange !== this.alertOnCategoryGroupChangeOrig || this.alertOnCategoryTypeNameChange !== this.alertOnCategoryTypeNameChangeOrig;
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    alertOnCategoryGroupChange: function alertOnCategoryGroupChange() {
      this.updateDirty();
    },
    alertOnCategoryTypeNameChange: function alertOnCategoryTypeNameChange() {
      this.updateDirty();
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PasswordInputPair__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PasswordInputPair___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PasswordInputPair__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PasswordInputPair: __WEBPACK_IMPORTED_MODULE_0__PasswordInputPair___default.a
  },
  data: function data() {
    return {
      oldPassword: '',
      password: '',
      error: ''
    };
  },
  methods: {
    show: function show() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#changePasswordModal').modal({
        onApprove: function onApprove() {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#changePasswordModal').find('.ui.form').submit();
          return false;
        },
        allowMultiple: true
      }).modal('show');
    }
  },
  mounted: function mounted() {
    var fields = {
      oldPassword: {
        rules: [{
          type: 'empty',
          prompt: 'Please provide your current password'
        }]
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(fields, this.$refs.passwordPair.rules);
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#changePasswordModal').find('.ui.form').form({
      fields: fields,
      onSuccess: function onSuccess() {
        var data = {
          oldPassword: self.oldPassword,
          newPassword: self.password
        };
        self.oldPassword = '';
        self.$refs.passwordPair.reset();
        self.$http.post('/api/auth/changepassword', data).then(function (response) {
          self.error = '';
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#changePasswordFeedbackModal').modal('show');
        }, function (response) {
          self.error = response.body.message;
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#changePasswordFeedbackModal').modal('show');
        });
      }
    });
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      timezoneOffset: this.emailAddress.timezoneOffset,
      timezoneAdjustToDST: this.emailAddress.timezoneAdjustToDST,
      timezoneElement: null,
      digestEmailHour: this.emailAddress.digestEmailHour,
      dailyDigestTimeElement: null,
      dirty: false
    };
  },
  props: ['emailAddress'],
  methods: {
    toJson: function toJson() {
      return {
        sellerId: this.seller.sellerId,
        name: this.name
      };
    },
    recalc: function recalc() {
      this.dirty = this.timezoneOffset !== this.emailAddress.originalTimezoneOffset || this.timezoneAdjustToDST !== this.emailAddress.originalTimezoneAdjustToDST || this.digestEmailHour !== this.emailAddress.originalDigestEmailHour;
      this.$emit('digestTimingUpdated', this.timezoneOffset, this.timezoneAdjustToDST, this.digestEmailHour);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.timezoneElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).find('.timezone.ui.selection.dropdown')[0];
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.timezoneElement).dropdown({
      onChange: function onChange(value, text) {
        _this.timezoneOffset = parseInt(value);
      }
    });
    if (this.timezoneOffset != null) __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.timezoneElement).dropdown('set exactly', this.timezoneOffset);
    this.dailyDigestTimeElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).find('.dailydigesttime.ui.selection.dropdown')[0];
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.dailyDigestTimeElement).dropdown({
      onChange: function onChange(value, text) {
        _this.digestEmailHour = parseInt(value);
      }
    });
    if (this.digestEmailHour != null) __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.dailyDigestTimeElement).dropdown('set exactly', this.digestEmailHour);
  },
  watch: {
    timezoneOffset: function timezoneOffset() {
      this.recalc();
    },
    timezoneAdjustToDST: function timezoneAdjustToDST() {
      this.recalc();
    },
    digestEmailHour: function digestEmailHour() {
      this.recalc();
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      skipPackageDimensionChangeIfNoFeeChange: false,
      skipPackageDimensionChangeIfNoFeeChangeOrig: false,
      sendAlertForEstimateChanges: true,
      sendAlertForEstimateChangesOrig: true,
      sendAlertForOrderDataChanges: true,
      sendAlertForOrderDataChangesOrig: true,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/fbaFeeChange').then(function (response) {
        _this.loading = false;
        _this.skipPackageDimensionChangeIfNoFeeChange = response.body.skipPackageDimensionChangeIfNoFeeChange;
        _this.skipPackageDimensionChangeIfNoFeeChangeOrig = response.body.skipPackageDimensionChangeIfNoFeeChange;
        _this.sendAlertForEstimateChanges = response.body.sendAlertForEstimateChanges;
        _this.sendAlertForEstimateChangesOrig = response.body.sendAlertForEstimateChanges;
        _this.sendAlertForOrderDataChanges = response.body.sendAlertForOrderDataChanges;
        _this.sendAlertForOrderDataChangesOrig = response.body.sendAlertForOrderDataChanges;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/fbaFeeChange', {
        skipPackageDimensionChangeIfNoFeeChange: this.skipPackageDimensionChangeIfNoFeeChange,
        sendAlertForEstimateChanges: this.sendAlertForEstimateChanges,
        sendAlertForOrderDataChanges: this.sendAlertForOrderDataChanges
      }).then(function (response) {
        _this2.skipPackageDimensionChangeIfNoFeeChangeOrig = _this2.skipPackageDimensionChangeIfNoFeeChange;
        _this2.sendAlertForEstimateChangesOrig = _this2.sendAlertForEstimateChanges;
        _this2.sendAlertForOrderDataChangesOrig = _this2.sendAlertForOrderDataChanges;
        _this2.updateDirty();
      }, function (response) {
        _this2.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = this.skipPackageDimensionChangeIfNoFeeChange !== this.skipPackageDimensionChangeIfNoFeeChangeOrig || this.sendAlertForEstimateChanges !== this.sendAlertForEstimateChangesOrig || this.sendAlertForOrderDataChanges !== this.sendAlertForOrderDataChangesOrig;
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    skipPackageDimensionChangeIfNoFeeChange: function skipPackageDimensionChangeIfNoFeeChange() {
      this.updateDirty();
    },
    sendAlertForEstimateChanges: function sendAlertForEstimateChanges() {
      this.updateDirty();
    },
    sendAlertForOrderDataChanges: function sendAlertForOrderDataChanges() {
      this.updateDirty();
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      suppressChildAsinRetiries: false,
      suppressChildAsinRetiriesOrig: false,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/listingSuspended').then(function (response) {
        _this.loading = false;
        _this.suppressChildAsinRetiries = !response.body.showChildAsinRetiries;
        _this.suppressChildAsinRetiriesOrig = _this.suppressChildAsinRetiries;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/listingSuspended', {
        showChildAsinRetiries: !this.suppressChildAsinRetiries
      }).then(function (response) {
        _this2.suppressChildAsinRetiriesOrig = _this2.suppressChildAsinRetiries;
        _this2.updateDirty();
      }, function (response) {
        _this2.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = this.suppressChildAsinRetiries !== this.suppressChildAsinRetiriesOrig;
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    suppressChildAsinRetiries: function suppressChildAsinRetiries() {
      this.updateDirty();
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      sensitivity: null,
      sensitivityOrig: null,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/parentProductChange').then(function (response) {
        _this.loading = false;
        _this.sensitivity = response.body.sensitivity;
        _this.sensitivityOrig = response.body.sensitivity;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/parentProductChange', {
        sensitivity: this.sensitivity
      }).then(function (response) {
        _this2.loading = false;
        _this2.sensitivityOrig = _this2.sensitivity;
        _this2.dirty = _this2.sensitivity !== _this2.sensitivityOrig;
      }, function (response) {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    sensitivity: function sensitivity() {
      this.dirty = this.sensitivity !== this.sensitivityOrig;
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      skipPackageDimensionChangeIfNoFeeChange: false,
      skipPackageDimensionChangeIfNoFeeChangeOrig: false,
      alertForParentChanges: false,
      alertForParentChangesOrig: false,
      alertForOwnOfferPriceChanges: false,
      alertForOwnOfferPriceChangesOrig: false,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/productDetailsRecentChange').then(function (response) {
        _this.loading = false;
        _this.skipPackageDimensionChangeIfNoFeeChange = response.body.skipPackageDimensionChangeIfNoFeeChange;
        _this.skipPackageDimensionChangeIfNoFeeChangeOrig = response.body.skipPackageDimensionChangeIfNoFeeChange;
        _this.alertForParentChanges = response.body.alertForParentChanges;
        _this.alertForParentChangesOrig = response.body.alertForParentChanges;
        _this.alertForOwnOfferPriceChanges = response.body.alertForOwnOfferPriceChanges;
        _this.alertForOwnOfferPriceChangesOrig = response.body.alertForOwnOfferPriceChanges;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/productDetailsRecentChange', {
        skipPackageDimensionChangeIfNoFeeChange: this.skipPackageDimensionChangeIfNoFeeChange,
        alertForParentChanges: this.alertForParentChanges,
        alertForOwnOfferPriceChanges: this.alertForOwnOfferPriceChanges
      }).then(function (response) {
        _this2.skipPackageDimensionChangeIfNoFeeChangeOrig = _this2.skipPackageDimensionChangeIfNoFeeChange;
        _this2.alertForParentChangesOrig = _this2.alertForParentChanges;
        _this2.alertForOwnOfferPriceChangesOrig = _this2.alertForOwnOfferPriceChanges;
        _this2.updateDirty();
      }, function (response) {
        _this2.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = this.skipPackageDimensionChangeIfNoFeeChange !== this.skipPackageDimensionChangeIfNoFeeChangeOrig || this.alertForParentChanges !== this.alertForParentChangesOrig || this.alertForOwnOfferPriceChanges !== this.alertForOwnOfferPriceChangesOrig;
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    skipPackageDimensionChangeIfNoFeeChange: function skipPackageDimensionChangeIfNoFeeChange() {
      this.updateDirty();
    },
    alertForParentChanges: function alertForParentChanges() {
      this.updateDirty();
    },
    alertForOwnOfferPriceChanges: function alertForOwnOfferPriceChanges() {
      this.updateDirty();
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);







var MARKETPLACE_LABELS = {
  us: 'US', uk: 'UK', gb: 'UK', ca: 'CA', de: 'DE', fr: 'FR',
  it: 'IT', es: 'ES', jp: 'JP', au: 'AU', 'in': 'IN', mx: 'MX',
  br: 'BR', nl: 'NL', sa: 'SA', ae: 'AE', sg: 'SG', se: 'SE',
  pl: 'PL', be: 'BE', at: 'AT', za: 'ZA', tr: 'TR', eg: 'EG'
};

var MP_EMOJI = {
  us: '🇺🇸', uk: '🇬🇧', gb: '🇬🇧', ca: '🇨🇦', de: '🇩🇪', fr: '🇫🇷',
  it: '🇮🇹', es: '🇪🇸', jp: '🇯🇵', au: '🇦🇺', 'in': '🇮🇳', mx: '🇲🇽',
  br: '🇧🇷', nl: '🇳🇱', sa: '🇸🇦', ae: '🇦🇪', sg: '🇸🇬', se: '🇸🇪',
  pl: '🇵🇱', be: '🇧🇪', at: '🇦🇹', za: '🇿🇦', tr: '🇹🇷', eg: '🇪🇬'
};

function normalizeMarketplaceCode(code) {
  return code != null ? String(code).trim().toLowerCase() : '';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductTrackingSettings',
  data: function data() {
    return {
      sellerAccounts: [],
      allProducts: [],
      productMap: {},
      accountsSetupPending: [],

      selectedStorefront: 'all',
      selectedMarketplace: 'all',
      searchText: '',
      showIgnoredOnly: false,

      currentPage: 0,

      pageSize: 30,

      automaticallyTrackNewProducts: false,
      originalAutomaticallyTrackNewProducts: false,

      loading: false,
      saving: false,
      loadError: null,

      bulkCsvResult: '',
      bulkCsvResultLevel: '',
      bulkCsvErrors: [],
      bulkCsvUploading: false,
      bulkCsvDownloading: false,

      useServerList: false,
      serverTotalFiltered: 0,
      serverTotalPages: 1,
      serverIgnoredCount: null,

      serverMarketplaceCodes: null,

      sellerApiMarketplaceCodes: null,
      searchDebounceTimer: null,
      hasLoadedOnce: false,

      _listInflight: 0,
      _listRequestId: 0,
      _listHttpPromise: null,
      _listLoadTimer: null,

      _ingestingListResponse: false,
      bulkIgnoreBusy: false,
      bulkIgnoreMessage: '',
      bulkIgnoreLevel: 'ok'
    };
  },
  computed: {
    showLoadingOverlay: function showLoadingOverlay() {
      return this.loading && !this.hasLoadedOnce;
    },
    fatalLoadError: function fatalLoadError() {
      if (!this.loadError || this.loading) return false;
      var acc = this.sellerAccounts || [];
      var rows = this.allProducts || [];
      return acc.length === 0 && rows.length === 0;
    },
    storefronts: function storefronts() {
      return this.sellerAccounts.map(function (acc) {
        return { sellerId: acc.sellerId, name: acc.name };
      });
    },

    availableMarketplaces: function availableMarketplaces() {
      var self = this;
      var seen = {};
      var ordered = [];
      function addCodes(arr) {
        if (!Array.isArray(arr)) return;
        for (var i = 0; i < arr.length; i++) {
          var c = normalizeMarketplaceCode(arr[i]);
          if (!c || seen[c]) continue;
          seen[c] = true;
          ordered.push(c);
        }
      }
      if (this.useServerList) addCodes(this.serverMarketplaceCodes);
      addCodes(this.sellerApiMarketplaceCodes);
      var base = this.selectedStorefront === 'all' ? this.allProducts : this.allProducts.filter(function (p) {
        return String(p._sellerId) === String(self.selectedStorefront);
      });
      for (var j = 0; j < base.length; j++) {
        var c = normalizeMarketplaceCode(base[j].marketplaceIso31662Code);
        if (!c || seen[c]) continue;
        seen[c] = true;
        ordered.push(c);
      }
      var out = [];
      for (var k = 0; k < ordered.length; k++) {
        var code = ordered[k];
        out.push({ code: code, label: MARKETPLACE_LABELS[code] || code.toUpperCase() });
      }
      return out;
    },

    filteredProducts: function filteredProducts() {
      if (this.useServerList) return this.allProducts;
      var self = this;
      var products = this.allProducts;

      if (this.selectedStorefront !== 'all') {
        var sf = String(this.selectedStorefront);
        products = products.filter(function (p) {
          return String(p._sellerId) === sf;
        });
      }
      if (this.selectedMarketplace !== 'all') {
        products = products.filter(function (p) {
          return normalizeMarketplaceCode(p.marketplaceIso31662Code) === self.selectedMarketplace;
        });
      }
      if (this.showIgnoredOnly) {
        products = products.filter(function (p) {
          return !p.show;
        });
      }
      if (this.searchText) {
        var terms = this.searchText.toLowerCase().split(/\s+/).filter(function (t) {
          return t.length > 0;
        });
        var pattern = new RegExp('^.*' + terms.map(function (t) {
          return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }).join('.*') + '.*$');
        products = products.filter(function (p) {
          return p.asin1 && pattern.test(p.asin1.toLowerCase()) || p.shortName && pattern.test(p.shortName.toLowerCase()) || p.productName && pattern.test(p.productName.toLowerCase());
        });
      }
      return products;
    },
    totalPages: function totalPages() {
      if (this.useServerList) {
        var n = this.serverTotalFiltered > 0 ? this.serverTotalFiltered : this.allProducts.length;
        return Math.max(1, Math.ceil(n / this.pageSize));
      }
      return Math.max(1, Math.ceil(this.filteredProducts.length / this.pageSize));
    },
    tableRows: function tableRows() {
      if (this.useServerList) return this.allProducts;
      var start = this.currentPage * this.pageSize;
      return this.filteredProducts.slice(start, start + this.pageSize);
    },
    summaryFilteredCount: function summaryFilteredCount() {
      if (this.useServerList) return this.serverTotalFiltered;
      return this.filteredProducts.length;
    },
    ignoredCount: function ignoredCount() {
      if (this.useServerList && this.serverIgnoredCount != null) return this.serverIgnoredCount;
      return this.allProducts.filter(function (p) {
        return !p.show;
      }).length;
    },
    searchTextTrimmed: function searchTextTrimmed() {
      return (this.searchText || '').trim();
    },

    bulkIgnoreAvailable: function bulkIgnoreAvailable() {
      return this.useServerList && (this.selectedStorefront !== 'all' || this.selectedMarketplace !== 'all');
    },
    bulkIgnoreScopeLabel: function bulkIgnoreScopeLabel() {
      var parts = [];
      if (this.selectedStorefront !== 'all') {
        var sf = String(this.selectedStorefront);
        var acc = this.storefronts.filter(function (a) {
          return String(a.sellerId) === sf;
        })[0];
        parts.push(acc ? acc.name : 'this storefront');
      } else {
        parts.push('all storefronts');
      }
      parts.push(this.selectedMarketplace !== 'all' ? this.mpLabel(this.selectedMarketplace) : 'all marketplaces');
      return parts.join(' · ');
    },
    hasChanges: function hasChanges() {
      if (this.automaticallyTrackNewProducts !== this.originalAutomaticallyTrackNewProducts) return true;
      var ids = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.productMap);
      for (var i = 0; i < ids.length; i++) {
        var p = this.productMap[ids[i]];
        if (p.shortName !== p._originalShortName) return true;
        if (p.show !== p._originalShow) return true;
        if (p.active !== p._originalActive) return true;
      }
      return false;
    }
  },
  watch: {
    searchText: function searchText(val, prev) {
      if (val === prev) return;
      if (this._ingestingListResponse) return;
      this.currentPage = 0;
      this.scheduleReloadFromFilters();
    },
    selectedStorefront: function selectedStorefront() {
      if (this._ingestingListResponse) return;
      this.currentPage = 0;
      this.loadProductTrackingPage({ resetPage: true });
    },
    selectedMarketplace: function selectedMarketplace() {
      if (this._ingestingListResponse) return;
      this.currentPage = 0;
      this.loadProductTrackingPage({ resetPage: true });
    },
    showIgnoredOnly: function showIgnoredOnly(val, prev) {
      if (val === prev) return;
      if (this._ingestingListResponse) return;
      this.currentPage = 0;
      this.loadProductTrackingPage({ resetPage: true });
    },
    hasChanges: function hasChanges(val) {
      window.dirty = val;
    }
  },
  created: function created() {
    window.dirty = false;
  },
  mounted: function mounted() {
    this.loadSellerMarketplaces();
    this.loadProductTrackingPage({ resetPage: true });
  },
  beforeDestroy: function beforeDestroy() {
    if (this._bulkIgnoreMsgTimer) clearTimeout(this._bulkIgnoreMsgTimer);
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    if (this._listLoadTimer) {
      clearTimeout(this._listLoadTimer);
      this._listLoadTimer = null;
    }
    this.abortListRequest();
  },
  methods: {
    storefrontNameFor: function storefrontNameFor(product) {
      if (product._sellerName) return product._sellerName;
      var sid = String(product._sellerId);
      var acc = this.storefronts.filter(function (a) {
        return String(a.sellerId) === sid;
      })[0];
      return acc ? acc.name : '—';
    },

    bulkIgnoreEstimate: function bulkIgnoreEstimate(ignore) {
      if (this.searchTextTrimmed || this.showIgnoredOnly || this.serverIgnoredCount == null) return null;
      var ignored = Number(this.serverIgnoredCount) || 0;
      var total = Number(this.serverTotalFiltered) || 0;
      return ignore ? Math.max(0, total - ignored) : ignored;
    },
    bulkIgnoreButtonLabel: function bulkIgnoreButtonLabel(ignore) {
      var n = this.bulkIgnoreEstimate(ignore);
      var verb = ignore ? 'Ignore' : 'Un-ignore';
      if (n == null) return verb + ' all';
      return verb + ' all ' + n.toLocaleString() + ' product' + (n === 1 ? '' : 's');
    },
    bulkIgnoreBody: function bulkIgnoreBody(ignore, dryRun) {
      var body = { ignore: !!ignore };
      if (this.selectedStorefront !== 'all') body.sellerAccount = String(this.selectedStorefront);
      if (this.selectedMarketplace !== 'all') body.marketplace = this.selectedMarketplace;
      if (this.searchTextTrimmed) body.q = this.searchTextTrimmed;
      if (dryRun) body.dryRun = true;
      return body;
    },

    startBulkIgnore: function startBulkIgnore(ignore) {
      var self = this;
      if (this.bulkIgnoreBusy || this.hasChanges) return;
      this.bulkIgnoreBusy = true;
      this.bulkIgnoreMessage = '';
      this.$http.post('/api/product/settings/bulk-ignore', this.bulkIgnoreBody(ignore, true)).then(function (res) {
        var n = Number((res.body || {}).matched) || 0;
        if (!n) {
          self.bulkIgnoreBusy = false;
          self.setBulkIgnoreMessage('Nothing to change — every matching product is already ' + (ignore ? 'ignored' : 'tracked') + '.', 'ok');
          return;
        }
        var scope = self.bulkIgnoreScopeLabel + (self.searchTextTrimmed ? ' matching “' + self.searchTextTrimmed + '”' : '');
        var noun = n.toLocaleString() + ' product' + (n === 1 ? '' : 's');
        var question = ignore ? 'This will stop alerts for ' + noun + ' in ' + scope + '. Continue?' : 'This will start tracking and alerting on ' + noun + ' in ' + scope + ' again. Continue?';
        if (!window.confirm(question)) {
          self.bulkIgnoreBusy = false;
          return;
        }
        return self.$http.post('/api/product/settings/bulk-ignore', self.bulkIgnoreBody(ignore, false)).then(function (applied) {
          var body = applied.body || {};
          self.bulkIgnoreBusy = false;
          if (body.queued) {
            self.setBulkIgnoreMessage((ignore ? 'Ignoring ' : 'Un-ignoring ') + noun + ' in the background. Counts update when it finishes.', 'ok');
            setTimeout(function () {
              self.loadProductTrackingPage({ resetPage: false });
            }, 5000);
          } else {
            var done = Number(body.updated) || 0;
            self.setBulkIgnoreMessage((ignore ? 'Ignored ' : 'Un-ignored ') + done.toLocaleString() + ' product' + (done === 1 ? '' : 's') + '.', 'ok');
          }
          self.loadProductTrackingPage({ resetPage: false });
        });
      }).catch(function (err) {
        self.bulkIgnoreBusy = false;
        var msg = err && err.body && (err.body.error || err.body.message) || 'Could not update products.';
        self.setBulkIgnoreMessage(msg, 'err');
      });
    },
    setBulkIgnoreMessage: function setBulkIgnoreMessage(msg, level) {
      var self = this;
      this.bulkIgnoreMessage = msg;
      this.bulkIgnoreLevel = level || 'ok';
      if (this._bulkIgnoreMsgTimer) clearTimeout(this._bulkIgnoreMsgTimer);
      this._bulkIgnoreMsgTimer = setTimeout(function () {
        self.bulkIgnoreMessage = '';
      }, 8000);
    },
    mpLabel: function mpLabel(code) {
      var c = normalizeMarketplaceCode(code);
      return MARKETPLACE_LABELS[c] || (c ? c.toUpperCase() : '');
    },
    mpEmoji: function mpEmoji(code) {
      var c = normalizeMarketplaceCode(code);
      return MP_EMOJI[c] || '';
    },
    setStorefront: function setStorefront(val) {
      this.selectedStorefront = val === 'all' ? 'all' : String(val);
    },
    setMarketplace: function setMarketplace(val) {
      this.selectedMarketplace = val;
    },
    abortListRequest: function abortListRequest() {
      var p = this._listHttpPromise;
      if (p && typeof p.abort === 'function') {
        try {
          p.abort();
        } catch (e) {}
      }
      this._listHttpPromise = null;
    },

    buildProductSettingsQueryParams: function buildProductSettingsQueryParams() {
      var params = {
        for: 'product-tracking-settings',
        page: String(this.currentPage),
        pageSize: String(this.pageSize)
      };
      if (this.selectedStorefront !== 'all') params.sellerAccount = String(this.selectedStorefront);
      if (this.selectedMarketplace !== 'all') params.marketplace = this.selectedMarketplace;
      var q = (this.searchText || '').trim();
      if (q) params.q = q;
      if (this.showIgnoredOnly) params.ignoredOnly = '1';
      return params;
    },
    normalizeProductRow: function normalizeProductRow(p, fallbackSellerId, fallbackSellerName) {
      if (p.productId == null && p.product_id != null) p.productId = p.product_id;
      if (p.productId == null && p.id != null) p.productId = p.id;
      if (p.marketplaceIso31662Code == null && p.marketplace_iso31662_code != null) {
        p.marketplaceIso31662Code = p.marketplace_iso31662_code;
      }
      if (p._sellerId == null && p.sellerId != null) p._sellerId = p.sellerId;
      if (p._sellerId == null && p.seller_id != null) p._sellerId = p.seller_id;
      if (p._sellerId == null && fallbackSellerId != null) p._sellerId = fallbackSellerId;
      if (p._sellerId != null) p._sellerId = String(p._sellerId);
      if (p._sellerName == null && p.sellerName != null) p._sellerName = p.sellerName;
      if (p._sellerName == null && fallbackSellerName != null) p._sellerName = fallbackSellerName;
      if (p._originalShortName === undefined) p._originalShortName = p.shortName;
      if (p._originalShow === undefined) p._originalShow = p.show;
      if (p._originalActive === undefined) p._originalActive = p.active;
    },
    scheduleReloadFromFilters: function scheduleReloadFromFilters() {
      var self = this;
      this.currentPage = 0;
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(function () {
        self.searchDebounceTimer = null;
        self.loadProductTrackingPage({ resetPage: true });
      }, 400);
    },
    goToPage: function goToPage(page) {
      var max = Math.max(0, this.totalPages - 1);
      var p = Math.max(0, Math.min(max, page));
      if (p === this.currentPage) return;
      this.currentPage = p;
      this.loadProductTrackingPage({ resetPage: false });
    },

    loadSellerMarketplaces: function loadSellerMarketplaces() {
      var self = this;
      this.$http.get('/api/v1/sellers').then(function (res) {
        var body = res && (res.body != null ? res.body : res.data) || {};
        var raw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_sellerAccountsFromV1Api_js__["g" /* extractMarketplaceCodesFromV1SellersBody */])(body);
        var seen = {};
        var out = [];
        for (var i = 0; i < raw.length; i++) {
          var c = normalizeMarketplaceCode(raw[i]);
          if (!c || seen[c]) continue;
          seen[c] = true;
          out.push(c);
        }
        self.sellerApiMarketplaceCodes = out;
      }, function () {
        if (self.sellerApiMarketplaceCodes == null) self.sellerApiMarketplaceCodes = [];
      });
    },

    mergeUnwrappedProductSettingsBody: function mergeUnwrappedProductSettingsBody(top, inner) {
      if (!top || !inner || top === inner) return inner;
      var merged = inner;
      function copyIfNeeded() {
        if (merged === inner) merged = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, inner);
      }
      var keys = ['products', 'productList', 'totalFiltered', 'total_filtered', 'totalPages', 'total_pages', 'currentPage', 'current_page', 'pageSize', 'page_size', 'ignoredCount', 'ignored_count', 'totalIgnored', 'total_ignored', 'availableMarketplaces', 'available_marketplaces', 'listMode', 'list_mode', 'pagination', 'automaticallyTrackNewProducts', 'automatically_track_new_products'];
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        var innerVal = merged[k];
        var topVal = top[k];
        if (topVal == null) continue;
        var innerMissing = innerVal == null;
        var innerProductsEmpty = k === 'products' && Array.isArray(innerVal) && innerVal.length === 0;
        var innerListEmpty = k === 'productList' && Array.isArray(innerVal) && innerVal.length === 0;
        if (innerMissing || innerProductsEmpty || innerListEmpty) {
          copyIfNeeded();
          merged[k] = topVal;
        }
      }
      return merged;
    },

    parseSettingsResponseFromHttp: function parseSettingsResponseFromHttp(response) {
      if (!response) return {};
      var raw = response.body != null ? response.body : response.data;
      if (raw == null && typeof response.bodyText === 'string' && response.bodyText.length) {
        try {
          raw = JSON.parse(response.bodyText);
        } catch (e) {
          raw = null;
        }
      }
      if (raw == null) return {};
      if (typeof raw === 'string') {
        try {
          raw = JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      if ((typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) !== 'object' || raw === null || Array.isArray(raw)) return {};
      var top = raw;

      var inner = raw.data;
      if (inner != null && (typeof inner === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(inner)) === 'object' && !Array.isArray(inner) && (inner.sellerAccounts != null || inner.products != null || inner.listMode != null || inner.list_mode != null)) {
        raw = this.mergeUnwrappedProductSettingsBody(top, inner);
      } else {
        inner = raw.payload;
        if (inner != null && (typeof inner === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(inner)) === 'object' && !Array.isArray(inner) && (inner.sellerAccounts != null || inner.products != null)) {
          raw = this.mergeUnwrappedProductSettingsBody(top, inner);
        } else {
          inner = raw.result;
          if (inner != null && (typeof inner === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(inner)) === 'object' && !Array.isArray(inner) && (inner.sellerAccounts != null || inner.products != null)) {
            raw = this.mergeUnwrappedProductSettingsBody(top, inner);
          }
        }
      }
      return raw;
    },
    loadProductTrackingPage: function loadProductTrackingPage(options) {
      var opts = options || {};
      if (opts.resetPage) this.currentPage = 0;
      var reqId = ++this._listRequestId;
      this.abortListRequest();
      if (this._listLoadTimer) {
        clearTimeout(this._listLoadTimer);
        this._listLoadTimer = null;
      }
      this._listInflight = (this._listInflight || 0) + 1;
      this.loading = true;
      this.loadError = null;
      this.bulkCsvResult = '';
      this.bulkCsvResultLevel = '';
      this.bulkCsvErrors = [];
      var self = this;
      var finishedThisRequest = false;
      var finishListRequest = function finishListRequest() {
        if (finishedThisRequest) return;
        finishedThisRequest = true;
        if (self._listLoadTimer) {
          clearTimeout(self._listLoadTimer);
          self._listLoadTimer = null;
        }
        if (reqId === self._listRequestId) self._listHttpPromise = null;
        self._listInflight = Math.max(0, (self._listInflight || 1) - 1);
        if (self._listInflight === 0) self.loading = false;
      };
      this.$http.get('/api/product/settings', { params: this.buildProductSettingsQueryParams() }).then(function (response) {
        self._ingestingListResponse = true;
        try {
          self.ingestSettingsResponse(self.parseSettingsResponseFromHttp(response));
          self.loadError = null;
          self.hasLoadedOnce = true;
        } catch (e) {
          console.error('[ProductTrackingSettings] ingest failed', e);
          self.loadError = 'Could not read server response.';
        } finally {
          self._ingestingListResponse = false;
        }
        finishListRequest();
      }, function (err) {
        if (reqId !== self._listRequestId) {
          finishListRequest();
          return;
        }
        if (err && err.status === 0) {
          finishListRequest();
          return;
        }
        var status = err && err.status;
        if (status === 401 || status === 403) {
          self.loadError = err.body && err.body.message || err.statusText || 'Request failed';
          finishListRequest();
          return;
        }
        self.loadError = err.body && err.body.message || err.statusText || 'Request failed';
        finishListRequest();
      });
    },

    ingestSettingsResponse: function ingestSettingsResponse(body) {
      var accounts = body.sellerAccounts || body.seller_accounts || [];
      this.sellerAccounts = accounts;
      this.accountsSetupPending = accounts.filter(function (a) {
        return !a.setupCompleted;
      }).map(function (a) {
        return a.sellerId;
      });
      this.originalAutomaticallyTrackNewProducts = !!(body.automaticallyTrackNewProducts != null ? body.automaticallyTrackNewProducts : body.automatically_track_new_products);
      this.automaticallyTrackNewProducts = this.originalAutomaticallyTrackNewProducts;

      var pag = body.pagination || {};
      var totalFilteredRaw = body.totalFiltered != null ? body.totalFiltered : body.total_filtered;
      if (totalFilteredRaw == null) totalFilteredRaw = pag.totalItems != null ? pag.totalItems : pag.total_items;
      var totalPagesRaw = body.totalPages != null ? body.totalPages : body.total_pages;
      if (totalPagesRaw == null) totalPagesRaw = pag.totalPages != null ? pag.totalPages : pag.total_pages;
      var pageSizeRaw = body.pageSize != null ? body.pageSize : body.page_size;
      if (pageSizeRaw == null) pageSizeRaw = pag.pageSize != null ? pag.pageSize : pag.page_size;
      var curPageRaw = body.currentPage != null ? body.currentPage : body.current_page;
      if (curPageRaw == null) curPageRaw = pag.currentPage != null ? pag.currentPage : pag.current_page;

      var totalFiltered = totalFilteredRaw != null ? Number(totalFilteredRaw) : null;
      var totalPages = totalPagesRaw != null ? Number(totalPagesRaw) : null;
      var pageSizeResp = pageSizeRaw != null ? Number(pageSizeRaw) : null;
      var curPageResp = curPageRaw != null ? Number(curPageRaw) : null;

      var rootProducts = Array.isArray(body.products) ? body.products : Array.isArray(body.productList) ? body.productList : [];

      this.useServerList = true;
      if (pageSizeResp != null && !isNaN(pageSizeResp) && pageSizeResp > 0) this.pageSize = pageSizeResp;
      if (curPageResp != null && !isNaN(curPageResp)) this.currentPage = curPageResp;

      if (totalFiltered != null && !isNaN(totalFiltered)) {
        this.serverTotalFiltered = totalFiltered;
      } else if (totalPages != null && !isNaN(totalPages) && curPageResp != null && !isNaN(curPageResp) && curPageResp >= totalPages - 1) {
        this.serverTotalFiltered = (totalPages - 1) * this.pageSize + rootProducts.length;
      } else {
        this.serverTotalFiltered = rootProducts.length;
      }

      if (totalPages != null && !isNaN(totalPages)) this.serverTotalPages = Math.max(1, totalPages);else {
        this.serverTotalPages = Math.max(1, Math.ceil(this.serverTotalFiltered / this.pageSize));
      }

      var ignRaw = body.ignoredCount != null ? body.ignoredCount : body.ignored_count;
      if (ignRaw == null) ignRaw = body.totalIgnored != null ? body.totalIgnored : body.total_ignored;
      var ign = ignRaw != null ? Number(ignRaw) : null;
      this.serverIgnoredCount = ign != null && !isNaN(ign) ? ign : null;

      var mps = body.availableMarketplaces != null ? body.availableMarketplaces : body.available_marketplaces;
      if (Array.isArray(mps) && mps.length) {
        this.serverMarketplaceCodes = mps.map(function (x) {
          return normalizeMarketplaceCode(typeof x === 'string' ? x : x.code || x.marketplace || '');
        }).filter(Boolean);
      } else if (!(this.serverMarketplaceCodes && this.serverMarketplaceCodes.length)) {
        this.serverMarketplaceCodes = null;
      }

      this.productMap = {};
      for (var i = 0; i < rootProducts.length; i++) {
        var row = rootProducts[i];
        this.normalizeProductRow(row, null, null);
        this.$set(this.productMap, row.productId, row);
      }
      this.allProducts = rootProducts;
    },
    fetchSettings: function fetchSettings() {
      this.loadSellerMarketplaces();
      this.loadProductTrackingPage({ resetPage: true });
    },
    onShortNameInput: function onShortNameInput(product, value) {
      this.$set(product, 'shortName', value);
    },
    onToggleIgnore: function onToggleIgnore(product) {
      if (product.show) {
        this.$set(product, 'show', false);
        this.$set(product, 'active', false);
      } else {
        this.$set(product, 'show', true);
        this.$set(product, 'active', true);
      }
    },
    save: function save() {
      var result = [];
      var productIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.productMap);
      for (var i = 0; i < productIds.length; i++) {
        var productId = productIds[i];
        var p = this.productMap[productId];
        var shortNameChanged = p.shortName !== p._originalShortName;
        var showChanged = p.show !== p._originalShow || p._originalActive !== p.active;
        if (shortNameChanged || showChanged) {
          var r = { productId: productId };
          if (shortNameChanged) r.shortName = p.shortName;
          if (showChanged) {
            if (p.active === null) {
              r.ignoredUntilNextOrder = true;
              r.show = false;
            } else {
              if (p._originalActive === null) r.ignoredUntilNextOrder = false;
              r.show = p.show;
            }
          }
          result.push(r);
        }
      }
      var data = {
        products: result,
        accountsSetupDone: this.accountsSetupPending,
        automaticallyTrackNewProducts: this.automaticallyTrackNewProducts !== this.originalAutomaticallyTrackNewProducts ? this.automaticallyTrackNewProducts : null
      };
      var hadPending = this.accountsSetupPending.length > 0;
      this.saving = true;
      this.$http.put('/api/product/settings', data).then(function () {
        var pmap = this.productMap;
        var ids = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pmap);
        for (var i = 0; i < ids.length; i++) {
          var p = pmap[ids[i]];
          p._originalShortName = p.shortName;
          p._originalShow = p.show;
          p._originalActive = p.active;
        }
        this.originalAutomaticallyTrackNewProducts = this.automaticallyTrackNewProducts;
        this.accountsSetupPending = [];
        if (hadPending) this.$root.anySellerAccountSetupCompleted = true;
        this.saving = false;
        window.dirty = false;
        if (this.hasChanges) {
          this.loadProductTrackingPage({ resetPage: false });
        }
      }.bind(this), function () {
        this.saving = false;
      }.bind(this));
    },
    discard: function discard() {
      var pmap = this.productMap;
      var ids = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(pmap);
      for (var i = 0; i < ids.length; i++) {
        var p = pmap[ids[i]];
        this.$set(p, 'shortName', p._originalShortName);
        this.$set(p, 'show', p._originalShow);
        this.$set(p, 'active', p._originalActive);
      }
      this.automaticallyTrackNewProducts = this.originalAutomaticallyTrackNewProducts;
      window.dirty = false;
      this.bulkCsvResult = '';
      this.bulkCsvResultLevel = '';
      this.bulkCsvErrors = [];
    },
    isBulkCsvFile: function isBulkCsvFile(file) {
      if (!file || !file.name) return false;
      if (!/\.csv$/i.test(file.name)) return false;
      if (!file.type) return true;
      return file.type === 'text/csv' || file.type === 'application/csv' || file.type === 'text/plain' || file.type === 'application/octet-stream';
    },
    setBulkCsvResult: function setBulkCsvResult(message, level, errors) {
      this.bulkCsvResult = message || '';
      this.bulkCsvErrors = Array.isArray(errors) ? errors.map(function (e) {
        return String(e);
      }) : [];
      this.bulkCsvResultLevel = level === 'ok' ? 'pts-bulk-result--ok' : level === 'warn' ? 'pts-bulk-result--warn' : level === 'err' ? 'pts-bulk-result--err' : '';
    },
    bulkCsvErrorsFromBody: function bulkCsvErrorsFromBody(body) {
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return [];
      var list = [];
      if (body.results && Array.isArray(body.results.errors)) list = body.results.errors;else if (Array.isArray(body.errors)) list = body.errors;
      return list.map(function (e) {
        return String(e);
      });
    },
    bulkCsvMessageFromBody: function bulkCsvMessageFromBody(body, fallbackOk) {
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return fallbackOk;
      if (body.message != null && String(body.message).trim() !== '') return String(body.message).trim();
      if (body.error != null && String(body.error).trim() !== '') return String(body.error).trim();
      if (body.detail != null && String(body.detail).trim() !== '') return String(body.detail).trim();
      return fallbackOk;
    },
    bulkCsvSummaryFromBody: function bulkCsvSummaryFromBody(body, errors) {
      var results = body && body.results;
      if (results && (typeof results === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(results)) === 'object') {
        var parts = [];
        if (results.total_rows != null) parts.push(results.total_rows + ' row(s)');
        if (results.updated != null) parts.push(results.updated + ' updated');
        if (results.skipped != null) parts.push(results.skipped + ' skipped');
        if (parts.length) {
          var summary = 'Import finished: ' + parts.join(', ') + '.';
          if (errors.length) return summary;
          return summary;
        }
      }
      if (errors.length) return 'Import completed with errors.';
      return this.bulkCsvMessageFromBody(body, 'CSV imported successfully.');
    },
    normalizeBulkCsvImportBody: function normalizeBulkCsvImportBody(rawBody) {
      if (rawBody == null) return {};
      if (typeof rawBody === 'string') {
        var trimmed = rawBody.trim();
        if (trimmed.indexOf('<!DOCTYPE') === 0 || trimmed.indexOf('<html') === 0) return {};
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          return {};
        }
      }
      if ((typeof rawBody === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rawBody)) !== 'object' || Array.isArray(rawBody)) return {};
      return rawBody;
    },
    bulkCsvImportSucceeded: function bulkCsvImportSucceeded(body) {
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(body)) !== 'object') return false;

      if (body.success === true || body.ok === true) return true;
      if (body.success === false || body.ok === false) return false;
      var errors = this.bulkCsvErrorsFromBody(body);
      if (errors.length) return false;
      if (body.failed != null && Number(body.failed) > 0) return false;
      var results = body.results;
      if (results && Number(results.updated) > 0) return true;
      return body.success !== false;
    },
    applyBulkCsvResponse: function applyBulkCsvResponse(body) {
      var errors = this.bulkCsvErrorsFromBody(body);
      var ok = this.bulkCsvImportSucceeded(body);
      var level = ok ? errors.length ? 'warn' : 'ok' : 'err';
      var msg = this.bulkCsvSummaryFromBody(body, errors);
      if (!ok && !errors.length) {
        msg = this.bulkCsvMessageFromBody(body, 'CSV import failed.');
      }
      this.setBulkCsvResult(msg, level, errors);
      if (ok) {
        this.loadProductTrackingPage({ resetPage: false });
      }
    },
    downloadBulkCsvExport: function downloadBulkCsvExport() {
      var self = this;
      var qs = ['for=' + encodeURIComponent('product-tracking-settings')];
      if (this.selectedStorefront !== 'all') {
        qs.push('sellerAccount=' + encodeURIComponent(String(this.selectedStorefront)));
      }
      if (this.selectedMarketplace !== 'all') {
        qs.push('marketplace=' + encodeURIComponent(this.selectedMarketplace));
      }
      var q = (this.searchText || '').trim();
      if (q) qs.push('q=' + encodeURIComponent(q));
      if (this.showIgnoredOnly) qs.push('ignoredOnly=1');
      var exportUrl = '/api/product/settings/export-active-csv?' + qs.join('&');
      var defaultName = 'product-tracking-' + new Date().toISOString().slice(0, 10) + '.csv';

      this.bulkCsvDownloading = true;
      this.setBulkCsvResult('', '', []);

      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        self.bulkCsvDownloading = false;
        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          var cd = xhr.getResponseHeader('Content-Disposition');
          var filename = defaultName;
          if (cd) {
            var m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (m && m[1]) filename = m[1].replace(/['"]/g, '').trim() || defaultName;
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          var reader = new FileReader();
          reader.onload = function () {
            var msg = 'Could not download CSV.';
            try {
              var j = JSON.parse(reader.result);
              if (j.message) msg = j.message;
            } catch (e) {}
            self.setBulkCsvResult(msg, 'err', []);
          };
          reader.readAsText(xhr.response);
        }
      };
      xhr.onerror = function () {
        self.bulkCsvDownloading = false;
        self.setBulkCsvResult('Download failed. Check your connection and try again.', 'err', []);
      };
      xhr.send();
    },
    onBulkCsvFile: function onBulkCsvFile(e) {
      var input = e.target;
      var file = input.files && input.files[0];
      if (!file) return;
      if (!this.isBulkCsvFile(file)) {
        this.setBulkCsvResult('Please choose a CSV file (.csv).', 'err');
        input.value = '';
        return;
      }
      var self = this;
      var formData = new window.FormData();
      formData.append('file', file, file.name || 'product-tracking-import.csv');
      this.bulkCsvUploading = true;
      this.setBulkCsvResult('', '', []);
      this.$http.post('/api/product/settings/import-active-csv', formData).then(function (res) {
        var headers = res.headers || {};
        var contentType = headers.get ? headers.get('Content-Type') : headers['Content-Type'] || headers['content-type'];
        var ct = (contentType || '').toLowerCase();
        if (ct.indexOf('text/html') !== -1 || typeof res.body === 'string' && res.body.trim().indexOf('<!DOCTYPE') === 0) {
          self.setBulkCsvResult('Upload failed: server configuration error. Please contact support.', 'err');
          input.value = '';
          self.bulkCsvUploading = false;
          return;
        }
        var body = self.normalizeBulkCsvImportBody(res.body);
        self.applyBulkCsvResponse(body);
        input.value = '';
        self.bulkCsvUploading = false;
      }, function (err) {
        var body = self.normalizeBulkCsvImportBody(err.body);
        var errors = self.bulkCsvErrorsFromBody(body);
        var msg = self.bulkCsvSummaryFromBody(body, errors);
        if (!errors.length) {
          msg = self.bulkCsvMessageFromBody(body, '') || (err.statusText ? String(err.statusText) : '') || 'CSV import failed.';
        }
        self.setBulkCsvResult(msg, 'err', errors);
        input.value = '';
        self.bulkCsvUploading = false;
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!window.dirty) {
      next();
    } else if (window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
      window.dirty = false;
      next();
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_amazonSellingPartnerOAuth__ = __webpack_require__(32);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dirty: false,
      editAuthToken: false,
      name: this.seller.nickName,
      authToken: '****' + this.seller.authTokenLast6Digit,
      hasNoAccess: false
    };
  },
  props: ['seller', 'showAdvertisementApiSettings', 'anyAccountMayNeedReAuthorization', 'isOwner'],
  methods: {
    toJson: function toJson() {
      return {
        sellerId: this.seller.sellerId,
        name: this.isNameDirty() ? this.name : null,
        mwsAuthToken: this.isAuthTokenDirty() ? this.authToken : null
      };
    },
    requestDeleteAccount: function requestDeleteAccount() {
      var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#deleteSellerAccountModal');
      el.modal({ onApprove: this.deleteAccount });
      el.modal('show');
    },
    deleteAccount: function deleteAccount() {
      var _this = this;

      this.$http.delete('/api/v1/sellers/' + this.seller.sellerId.value).then(function (response) {
        _this.$emit('sellerAccountDeleted', _this.seller.sellerId.value);
      }, function (response) {
        _this.error = response.body.error + ': ' + response.body.message;
      });
    },
    isNameDirty: function isNameDirty() {
      return this.name !== this.seller.nickName;
    },
    isAuthTokenDirty: function isAuthTokenDirty() {
      return this.authToken !== '******' + this.seller.authTokenLast6Digit;
    },
    checkIfDirty: function checkIfDirty() {
      var dirty = this.dirty;
      this.dirty = this.isNameDirty() || this.isAuthTokenDirty();
      if (dirty !== this.dirty) this.$emit('account-changed');
    },
    redirectToAdvertisementAuthPage: function redirectToAdvertisementAuthPage() {
      window.location = 'https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.938fa2b8ac364f26a3a3fbf100505b53&scope=cpc_advertising:campaign_management&response_type=code&redirect_uri=' + encodeURIComponent(window.location.origin) + '%2Ft0%2Fidentity%2Fadconnect&state=' + this.seller.sellerId.value;
    },
    reauthorize: function reauthorize() {
      var data = {
        region: this.seller.region,
        marketplace: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(this.seller.region, this.seller.marketplaceId || this.seller.marketplace_id),
        path: this.$route.path,
        accName: this.name,
        expectedSellerKey: this.seller.sellerKey.value
      };
      this.$http.get('/api/identity/amazon/authorization/redirect', { params: data }).then(function (response) {
        window.location = response.body.location;
      }, function (response) {
        window.alert(response.body.message);
      });
    }
  },
  watch: {
    seller: {
      handler: function handler(val) {
        this.editAuthToken = false;
        this.authToken = '******' + val.authTokenLast6Digit;
        this.checkIfDirty();
      },
      deep: true
    },
    name: function name() {
      this.checkIfDirty();
    },
    authToken: function authToken() {
      this.checkIfDirty();
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__ = __webpack_require__(429);






function isoDay(d) {
  var m = String(d.getMonth() + 1);
  var day = String(d.getDate());
  return d.getFullYear() + '-' + (m.length < 2 ? '0' + m : m) + '-' + (day.length < 2 ? '0' + day : day);
}

var ROLE_TOOLTIP = 'Authorised reseller and Ignore send no emails for that seller on that marketplace: no new-seller (hijacker), ' + 'Buy Box lost, competitor price or No Featured Offer emails (No Featured Offer: when they held the Buy Box just before). ' + 'Amazon Retail never triggers new-seller or No Featured Offer emails; its Buy Box wins are batched into the offer activity digest ' + '(every 15 minutes) when it is on in Alert Settings, and email immediately while it is off. Watchlist always emails.';

var ASSIGNABLE_ROLES = [{ value: 'UNKNOWN', label: 'Unclassified' }, { value: 'AMAZON', label: 'Amazon Retail' }, { value: 'AUTHORISED', label: 'Authorised reseller' }, { value: 'WATCH', label: 'Watchlist' }, { value: 'IGNORE', label: 'Ignore' }];

var ROLE_LABELS = {
  UNKNOWN: 'Unclassified',
  AMAZON: 'Amazon Retail',
  AUTHORISED: 'Authorised',
  WATCH: 'Watchlist',
  IGNORE: 'Ignore'
};

function apiMessage(err) {
  var msg = err && err.body && err.body.message;
  if (Array.isArray(msg)) return msg.filter(Boolean).join(', ');
  if (typeof msg === 'string' && msg) return msg;
  return err && err.statusText || 'Something went wrong';
}

function parseBool(v) {
  return v === true || v === 1 || v === '1' || v === 'true';
}

function roleOf(row) {
  var chip = row && row.chip;
  var raw = chip && chip.role || row && row.role || '';
  return String(raw).toUpperCase();
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SellersSettings',
  data: function data() {
    return {
      loading: false,
      loadError: null,
      rows: [],
      totalItems: 0,
      page: 1,
      pageSize: 50,
      selectedIds: [],
      bulkRole: 'AUTHORISED',
      bulkSaving: false,
      backfilling: false,
      savingIds: {},
      labelDrafts: {},
      highlightId: null,
      offerActivityDigest: false,
      successMsg: '',
      errorMsg: '',
      toastTimer: null,
      exporting: false,
      storefronts: [],
      marketplaceCodes: [],
      filterSellerId: '',
      filterMarketplace: '',
      classifiedCount: 0,
      refreshedAt: null,
      exportOpen: false,
      exportFrom: '',
      exportTo: '',
      exportFormat: 'csv'
    };
  },
  computed: {
    assignableRoles: function assignableRoles() {
      return ASSIGNABLE_ROLES;
    },
    roleTooltip: function roleTooltip() {
      return ROLE_TOOLTIP;
    },
    classifiedPercent: function classifiedPercent() {
      if (!this.totalItems) return 0;
      return Math.min(100, Math.round(this.classifiedCount / this.totalItems * 100));
    },
    refreshedLabel: function refreshedLabel() {
      if (!this.refreshedAt) return 'not yet';
      var d = new Date(this.refreshedAt);
      if (isNaN(d.getTime())) return 'not yet';
      var time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      var today = new Date();
      var yesterday = new Date(today.getTime() - 86400000);
      if (d.toDateString() === today.toDateString()) return 'today at ' + time;
      if (d.toDateString() === yesterday.toDateString()) return 'yesterday at ' + time;
      return d.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' }) + ' at ' + time;
    },
    exportRangeError: function exportRangeError() {
      if (!this.exportFrom || !this.exportTo) return 'Pick both dates.';
      if (this.exportFrom > this.exportTo) return '“From” must be on or before “To”.';
      return '';
    },
    hasActiveFilters: function hasActiveFilters() {
      return !!(this.filterSellerId || this.filterMarketplace);
    },
    catalogEmpty: function catalogEmpty() {
      return this.totalItems === 0 && !this.loading && !this.hasActiveFilters;
    },
    listFilterKey: function listFilterKey() {
      return this.filterSellerId + '|' + this.filterMarketplace + '|' + this.queryToken();
    },
    storefrontOptions: function storefrontOptions() {
      var list = this.storefronts.slice();
      var current = this.filterSellerId;
      if (!current) return list;
      var found = list.some(function (s) {
        return String(s.id) === String(current);
      });
      if (!found) list.push({ id: current, name: 'Storefront ' + current });
      return list;
    },
    marketplaceOptions: function marketplaceOptions() {
      var list = this.marketplaceCodes.slice();
      var current = this.filterMarketplace;
      if (current && list.indexOf(current) < 0) list = list.concat([current]);
      return list;
    },
    selectableRows: function selectableRows() {
      return this.rows.filter(function (row) {
        return roleOf(row) !== 'SELF';
      });
    },
    allSelectableChecked: function allSelectableChecked() {
      if (!this.selectableRows.length) return false;
      var selected = this.selectedIds;
      return this.selectableRows.every(function (row) {
        return selected.indexOf(row.id) > -1;
      });
    },
    totalPages: function totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize) || 1);
    },
    pageLabel: function pageLabel() {
      if (!this.totalItems) return '0 sellers';
      var start = (this.page - 1) * this.pageSize + 1;
      var end = Math.min(this.page * this.pageSize, this.totalItems);
      return start + '–' + end + ' of ' + this.totalItems;
    }
  },
  watch: {
    listFilterKey: function listFilterKey() {
      this.page = 1;
      this.fetchList();
    }
  },
  mounted: function mounted() {
    this.clearFilterQuery();
    this.fetchList();
    this.loadDigestFlag();
    this.loadStorefronts();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
  methods: {
    queryToken: function queryToken() {
      var q = this.$route.query || {};
      var t = q.token;
      if (Array.isArray(t)) t = t[0];
      return t ? String(t) : '';
    },
    queryMarketplace: function queryMarketplace() {
      var m = this.filterMarketplace;
      if (!m) return '';
      m = String(m).toUpperCase();
      if (m === 'GB') m = 'UK';
      return m;
    },
    querySellerId: function querySellerId() {
      var s = this.filterSellerId;
      return s != null && s !== '' ? String(s) : '';
    },
    clearFilterQuery: function clearFilterQuery() {
      var q = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query || {});
      if (q.seller_id == null && q.sellerId == null && q.marketplace == null) return;
      delete q.seller_id;
      delete q.sellerId;
      delete q.marketplace;
      this.$router.replace({ query: q });
    },
    loadStorefronts: function loadStorefronts() {
      var self = this;
      this.$http.get('/api/v1/sellers').then(function (res) {
        var body = res && res.body || {};
        self.storefronts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api_js__["d" /* mapV1SellersToFilterAccounts */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api_js__["e" /* extractV1SellersItems */])(body));
        self.marketplaceCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_sellerAccountsFromV1Api_js__["g" /* extractMarketplaceCodesFromV1SellersBody */])(body);
      }, function () {
        if (!self.storefronts.length) self.storefronts = [];
        if (!self.marketplaceCodes.length) self.marketplaceCodes = [];
      });
    },
    fetchList: function fetchList() {
      var self = this;
      this.loading = true;
      this.loadError = null;
      var params = {
        page: this.page,
        pageSize: this.pageSize
      };
      var token = this.queryToken();
      var marketplace = this.queryMarketplace();
      var sellerId = this.querySellerId();
      if (token) params.token = token;
      if (marketplace) params.marketplace = marketplace;
      if (sellerId) params.seller_id = sellerId;
      return this.$http.get('/api/v1/account-sellers', { params: params }).then(function (res) {
        var body = res.body || {};
        var list = body.account_sellers || [];
        self.rows = list;
        var total = body.totalItems;
        if (total == null && body.meta) total = body.meta.total;
        self.totalItems = total != null ? Number(total) : list.length;
        var pg = body.currentPage;
        if (pg == null && body.meta) pg = body.meta.page;
        if (pg != null && Number(pg) > 0) self.page = Number(pg);
        var ps = body.pageSize;
        if (ps == null && body.meta) ps = body.meta.per_page;
        if (ps != null && Number(ps) > 0) self.pageSize = Number(ps);
        self.classifiedCount = Number(body.classifiedCount) || 0;
        self.refreshedAt = body.refreshedAt || null;
        var drafts = {};
        list.forEach(function (row) {
          drafts[row.id] = row.label == null ? '' : String(row.label);
        });
        self.labelDrafts = drafts;
        self.selectedIds = [];
        self.loading = false;
        self.afterListLoaded();
      }, function (err) {
        self.loading = false;
        if (err && err.status === 401) return;
        var msg = apiMessage(err);
        self.loadError = msg;
        if (self.rows.length) self.toastError(msg);
      });
    },
    afterListLoaded: function afterListLoaded() {
      var self = this;
      var open = this.rows.filter(function (row) {
        return row.editor_open === true;
      })[0];
      var token = this.queryToken();
      var marketplace = this.queryMarketplace();
      if (!open && token) {
        open = this.rows.filter(function (row) {
          var sameToken = self.merchantToken(row) === token;
          if (!sameToken) return false;
          if (!marketplace) return true;
          return self.marketplaceCode(row) === marketplace;
        })[0];
      }
      this.highlightId = open ? open.id : null;
      if (!open) return;
      this.$nextTick(function () {
        var el = document.getElementById('seller-row-' + open.id);
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'center' });
        var chip = open.chip || {};
        if (chip.name_this_seller === true) {
          var input = el && el.querySelector('.sls-name-input');
          if (input) {
            input.focus();
            if (input.select) input.select();
          }
        }
      });
    },
    loadDigestFlag: function loadDigestFlag() {
      var self = this;
      this.$http.get('/api/identity/settings').then(function (res) {
        var body = res.body || {};
        var v = body.offerActivityDigest;
        if (v == null) v = body.offer_activity_digest;
        self.offerActivityDigest = parseBool(v);
      }, function () {});
    },
    goToPage: function goToPage(p) {
      var next = Math.min(this.totalPages, Math.max(1, p));
      if (next === this.page) return;
      this.page = next;
      this.fetchList();
    },
    backfill: function backfill() {
      var self = this;
      this.backfilling = true;
      var firstScan = this.catalogEmpty;
      this.$http.post('/api/v1/account-sellers/backfill').then(function (res) {
        self.backfilling = false;
        var body = res.body || {};
        var added = body.added != null ? Number(body.added) : Number(body.upserted || 0);
        if (body.refreshedAt) self.refreshedAt = body.refreshedAt;
        if (firstScan) {
          self.toastOk(added ? 'Found ' + added + ' seller' + (added === 1 ? '' : 's') + '.' : 'No competing sellers found yet.');
        } else {
          self.toastOk(added ? 'Refreshed — ' + added + ' new seller' + (added === 1 ? '' : 's') + ' found' : 'Refreshed — no new sellers found');
        }
        self.page = 1;
        self.fetchList();
      }, function (err) {
        self.backfilling = false;
        if (err && err.status === 401) return;
        self.toastError(apiMessage(err));
      });
    },
    isSelf: function isSelf(row) {
      return roleOf(row) === 'SELF';
    },
    merchantToken: function merchantToken(row) {
      var chip = row && row.chip;
      return chip && chip.token || row && row.merchant_token || '';
    },
    marketplaceCode: function marketplaceCode(row) {
      return String(row && row.marketplace_code || '').toUpperCase();
    },
    displayName: function displayName(row) {
      var chip = row && row.chip;
      if (chip && chip.display_name) return chip.display_name;
      return this.merchantToken(row);
    },
    profileUrl: function profileUrl(row) {
      var chip = row && row.chip;
      var url = chip && chip.profile_url;
      return typeof url === 'string' && url ? url : null;
    },
    pillLabel: function pillLabel(row) {
      var chip = row && row.chip;
      return chip && chip.pill ? chip.pill : '';
    },
    pillTone: function pillTone(row) {
      var chip = row && row.chip;
      var tone = chip && chip.tone;
      if (tone === 'positive' || tone === 'informational' || tone === 'alarm' || tone === 'caution' || tone === 'neutral') {
        return tone;
      }
      return 'neutral';
    },
    asinCount: function asinCount(row) {
      var n = row && row.asin_count;
      if (n == null || n === '') return 0;
      var num = Number(n);
      return isNaN(num) ? 0 : num;
    },
    roleValue: function roleValue(row) {
      var r = roleOf(row);
      if (r === 'SELF') return r;
      for (var i = 0; i < ASSIGNABLE_ROLES.length; i++) {
        if (ASSIGNABLE_ROLES[i].value === r) return r;
      }
      return 'UNKNOWN';
    },
    labelDraft: function labelDraft(row) {
      if (Object.prototype.hasOwnProperty.call(this.labelDrafts, row.id)) {
        return this.labelDrafts[row.id];
      }
      return row.label == null ? '' : String(row.label);
    },
    onLabelInput: function onLabelInput(row, value) {
      this.$set(this.labelDrafts, row.id, value);
    },
    namePlaceholder: function namePlaceholder(row) {
      return row && row.suggested_label ? row.suggested_label + '?' : 'Name this seller…';
    },
    showNameHint: function showNameHint(row) {
      var chip = row && row.chip;
      return !!(chip && chip.name_this_seller);
    },
    showDigestNote: function showDigestNote(row) {
      if (this.offerActivityDigest) return false;
      var r = roleOf(row);
      return r === 'AMAZON';
    },
    roleHelper: function roleHelper(row) {
      var r = this.roleValue(row);
      if (r === 'IGNORE') return 'No emails for this id on this marketplace (Buy Box, new seller, competitor price, No Featured Offer).';
      if (r === 'AUTHORISED') return 'Known reseller, not a hijacker. No emails for this id on this marketplace; Buy Box moves still show in Issues.';
      if (r === 'AMAZON') return 'Shown as Amazon Retail. No new-seller or No Featured Offer alerts; Buy Box wins go to the offer activity digest when it is on.';
      if (r === 'WATCH') return 'Alarm. Emails send. Copy may say “hijacker”.';
      return 'Not classified yet. New-seller and Buy Box alerts send as normal.';
    },
    roleLabel: function roleLabel(role) {
      return ROLE_LABELS[String(role || '').toUpperCase()] || role;
    },

    formatDay: function formatDay(iso) {
      if (!iso) return '—';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '—';
      var today = new Date();
      if (d.toDateString() === today.toDateString()) return 'Today';
      if (d.toDateString() === new Date(today.getTime() - 86400000).toDateString()) return 'Yesterday';
      return d.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
    },
    hasSuggestion: function hasSuggestion(row) {
      if (!row || this.isSelf(row) || !row.suggested_label) return false;
      return String(this.labelDraft(row) || '').trim() === '' && !row.label;
    },

    acceptSuggestion: function acceptSuggestion(row) {
      var self = this;
      var body = { label: row.suggested_label };
      if (row.suggested_role && roleOf(row) === 'UNKNOWN') body.role = row.suggested_role;
      this.$set(this.savingIds, row.id, true);
      this.$http.patch('/api/v1/account-sellers/' + encodeURIComponent(String(row.id)), body).then(function (res) {
        self.$set(self.savingIds, row.id, false);
        var updated = res.body && res.body.account_seller || res.body;
        if (updated) self.applyRow(updated);
        self.classifiedCount += body.role ? 1 : 0;
      }, function (err) {
        self.$set(self.savingIds, row.id, false);
        if (err && err.status === 401) return;
        self.toastError(apiMessage(err));
      });
    },
    isSelected: function isSelected(id) {
      return this.selectedIds.indexOf(id) > -1;
    },
    toggleSelected: function toggleSelected(id, on) {
      var next = this.selectedIds.slice();
      var i = next.indexOf(id);
      if (on && i < 0) next.push(id);
      if (!on && i > -1) next.splice(i, 1);
      this.selectedIds = next;
    },
    toggleSelectAll: function toggleSelectAll(on) {
      if (!on) {
        this.selectedIds = [];
        return;
      }
      this.selectedIds = this.selectableRows.map(function (row) {
        return row.id;
      });
    },
    applyRow: function applyRow(updated) {
      if (!updated || updated.id == null) return;
      var i = -1;
      for (var n = 0; n < this.rows.length; n++) {
        if (this.rows[n].id === updated.id) {
          i = n;break;
        }
      }
      if (i > -1) this.$set(this.rows, i, updated);
      this.$set(this.labelDrafts, updated.id, updated.label == null ? '' : String(updated.label));
    },
    saveLabel: function saveLabel(row) {
      if (this.isSelf(row) || this.savingIds[row.id]) return;
      var next = String(this.labelDraft(row) || '').trim();
      var prev = row.label == null ? '' : String(row.label);
      if (next === prev) return;
      var self = this;
      this.$set(this.savingIds, row.id, true);
      this.$http.patch('/api/v1/account-sellers/' + encodeURIComponent(String(row.id)), {
        label: next
      }).then(function (res) {
        self.$set(self.savingIds, row.id, false);
        var updated = res.body && res.body.account_seller || res.body;
        if (updated) self.applyRow(updated);
      }, function (err) {
        self.$set(self.savingIds, row.id, false);
        self.$set(self.labelDrafts, row.id, prev);
        if (err && err.status === 401) return;
        self.toastError(apiMessage(err));
      });
    },
    saveRole: function saveRole(row, role) {
      if (this.isSelf(row)) return;
      var next = String(role || '').toUpperCase();
      if (next === 'SELF') return;
      if (next === roleOf(row)) return;
      var self = this;
      this.$set(this.savingIds, row.id, true);
      this.$http.patch('/api/v1/account-sellers/' + encodeURIComponent(String(row.id)), {
        role: next
      }).then(function (res) {
        self.$set(self.savingIds, row.id, false);
        var updated = res.body && res.body.account_seller || res.body;
        if (updated) self.applyRow(updated);
      }, function (err) {
        self.$set(self.savingIds, row.id, false);
        if (err && err.status === 401) return;
        self.toastError(apiMessage(err));
      });
    },

    applyBulkRole: function applyBulkRole() {
      if (!this.selectedIds.length || !this.bulkRole || this.bulkSaving) return;
      var role = String(this.bulkRole).toUpperCase();
      if (role === 'SELF') return;
      var self = this;
      var n = this.selectedIds.length;
      this.bulkSaving = true;
      this.$http.patch('/api/v1/account-sellers/bulk_update', {
        ids: this.selectedIds.slice(),
        role: role
      }).then(function () {
        self.bulkSaving = false;
        self.selectedIds = [];
        self.toastOk('Role updated for ' + n + ' seller' + (n === 1 ? '' : 's'));
        self.fetchList();
      }, function (err) {
        self.bulkSaving = false;
        if (err && err.status === 401) return;
        self.toastError(apiMessage(err));
      });
    },

    exportSelected: function exportSelected() {
      var self = this;
      var picked = this.rows.filter(function (row) {
        return self.selectedIds.indexOf(row.id) > -1;
      });
      if (!picked.length) return;
      var cells = picked.map(function (row) {
        return [self.merchantToken(row), row.label || self.displayName(row), self.roleLabel(roleOf(row)), self.marketplaceCode(row), self.asinCount(row), row.first_seen || '', row.last_seen || '', (row.asins || []).join(', ')];
      });
      var blob = new window.Blob([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["a" /* sellersCsv */])(cells)], { type: 'text/csv;charset=utf-8' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["b" /* triggerBlobDownload */])(blob, 'sentrykit-sellers-selected-' + isoDay(new Date()) + '.csv');
      this.toastOk('Exported ' + picked.length + ' selected row' + (picked.length === 1 ? '' : 's') + ' as CSV');
    },
    openExport: function openExport() {
      var to = new Date();
      var from = new Date(to.getTime() - 90 * 86400000);
      if (!this.exportTo) this.exportTo = isoDay(to);
      if (!this.exportFrom) this.exportFrom = isoDay(from);
      this.exportOpen = true;
    },
    toastOk: function toastOk(msg) {
      this.errorMsg = '';
      this.successMsg = msg;
      this.scheduleToastClear();
    },
    toastError: function toastError(msg) {
      this.successMsg = '';
      this.errorMsg = msg;
      this.scheduleToastClear();
    },
    scheduleToastClear: function scheduleToastClear() {
      var self = this;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(function () {
        self.successMsg = '';
        self.errorMsg = '';
      }, 4000);
    },
    exportReport: function exportReport() {
      if (this.exporting || this.exportRangeError) return;
      var self = this;
      var xlsx = this.exportFormat === 'xlsx';
      var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["c" /* accountSellersReportUrl */])({
        sellerId: this.filterSellerId || undefined,
        marketplace: this.filterMarketplace || undefined,
        from: this.exportFrom,
        to: this.exportTo,
        fileFormat: this.exportFormat
      });
      this.exporting = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        self.exporting = false;
        var status = xhr.status;
        if (status === 401) return;
        if (status < 200 || status >= 300 || !xhr.response) {
          self.toastError('Export failed. Please try again.');
          return;
        }
        var blob = xhr.response;
        var filename = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["d" /* filenameFromContentDisposition */])(xhr.getResponseHeader('Content-Disposition'), 'sentrykit-competing-sellers.' + (xlsx ? 'xlsx' : 'csv'));
        self.exportOpen = false;
        if (xlsx) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["b" /* triggerBlobDownload */])(blob, filename);
          self.toastOk('Export downloaded.');
          return;
        }
        var reader = new FileReader();
        reader.onload = function () {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["e" /* csvHasDataRows */])(reader.result)) {
            self.toastOk('No seller activity in that window for this storefront / marketplace.');
          } else {
            self.toastOk('Export downloaded.');
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["b" /* triggerBlobDownload */])(blob, filename);
        };
        reader.onerror = function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_accountSellersReport_js__["b" /* triggerBlobDownload */])(blob, filename);
        };
        reader.readAsText(blob);
      };
      xhr.onerror = function () {
        self.exporting = false;
        self.toastError('Export failed. Please try again.');
      };
      xhr.send();
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: false,
      message: ''
    };
  },
  props: ['watchDogName', 'apiPrefix'],
  methods: {
    exportExcel: function exportExcel() {
      window.open('/api/sentinel/spreadsheet/' + this.apiPrefix + '/v1.0/export', '_self');
    },
    importExcel: function importExcel(e) {
      var _this = this;

      if (!e.target.files) return;
      var formData = new window.FormData();
      formData.append('file', e.target.files[0], this.apiPrefix + '-config-import.xlsx');
      this.$http.post('/api/sentinel/spreadsheet/' + this.apiPrefix + '/v1.0/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (resp) {
        _this.resetFiles();
        _this.error = false;
        _this.message = 'Spreadsheet successfully imported';
        setTimeout(function () {
          _this.message = '';
        }, 3000);
      }, function (resp) {
        _this.error = true;
        _this.message = 'Error during spreadsheet import';
        setTimeout(function () {
          _this.message = '';
        }, 3000);
      });
    },
    resetFiles: function resetFiles() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#hidden-' + this.apiPrefix + '-config-import-file').val('');
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      oneTenthUp: false,
      oneTenthDown: false,
      oneTenthUpOrig: false,
      oneTenthDownOrig: false,
      reviewCountDropMinimumThreshold: 1,
      reviewCountDropMinimumThresholdOrig: 1,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/starRatingRecentChange').then(function (response) {
        _this.loading = false;
        _this.oneTenthUp = response.body.oneTenthPrecisionUp;
        _this.oneTenthDown = response.body.oneTenthPrecisionDown;
        _this.reviewCountDropMinimumThreshold = response.body.reviewCountDropMinimumThreshold;
        _this.oneTenthUpOrig = _this.oneTenthUp;
        _this.oneTenthDownOrig = _this.oneTenthDown;
        _this.reviewCountDropMinimumThresholdOrig = _this.reviewCountDropMinimumThreshold;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/starRatingRecentChange', {
        oneTenthPrecisionUp: this.oneTenthUp,
        oneTenthPrecisionDown: this.oneTenthDown,
        reviewCountDropMinimumThreshold: this.reviewCountDropMinimumThreshold
      }).then(function (response) {
        _this2.oneTenthUpOrig = _this2.oneTenthUp;
        _this2.oneTenthDownOrig = _this2.oneTenthDown;
        _this2.reviewCountDropMinimumThresholdOrig = _this2.reviewCountDropMinimumThreshold;
        _this2.updateDirty();
      }, function (response) {
        _this2.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = this.oneTenthUp !== this.oneTenthUpOrig || this.oneTenthDown !== this.oneTenthDownOrig || this.reviewCountDropMinimumThreshold !== this.reviewCountDropMinimumThresholdOrig;
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    oneTenthUp: function oneTenthUp() {
      this.updateDirty();
    },
    oneTenthDown: function oneTenthDown() {
      this.updateDirty();
    },
    reviewCountDropMinimumThreshold: function reviewCountDropMinimumThreshold() {
      this.updateDirty();
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      marketplaceDomains: ['www.amazon.com', 'www.amazon.ca', 'www.amazon.com.mx', 'www.amazon.co.uk', 'www.amazon.de', 'www.amazon.fr', 'www.amazon.es', 'www.amazon.it'],
      marketplaces: ['US', 'CA', 'MX', 'UK', 'DE', 'FR', 'ES', 'IT'],
      whiteList: [],
      whiteOrig: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(),
      whiteListURL: '',
      whiteListURLParsed: null,
      whiteListURLError: false,
      whiteListURLErrorURL: null,
      loading: true,
      dirty: false
    };
  },
  props: ['watchDogType'],
  methods: {
    addToWhiteList: function addToWhiteList() {
      var _this = this;

      if (this.whiteListURLParsed == null) return;
      if (this.whiteList.filter(function (w) {
        return w.url === _this.whiteListURLParsed.url;
      }).length === 0) {
        this.whiteList.splice(this.whiteList.length, 0, this.whiteListURLParsed);
      }
      this.whiteListURLParsed = null;
      this.whiteListURLError = false;
      this.whiteListURL = '';
    },
    load: function load() {
      var _this2 = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/' + this.watchDogType).then(function (response) {
        _this2.loading = false;
        if (!response.body.whiteList) return;
        var wl = response.body.whiteList;
        var res = [];
        var marketplaces = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(wl);
        for (var i = 0; i < marketplaces.length; ++i) {
          var m = marketplaces[i];
          var l = wl[m].sellerKeys;
          for (var j = 0; j < l.length; ++j) {
            var e = l[j];
            res.splice(res.length, 0, {
              marketplace: m,
              sellerId: e.value,
              url: 'https://' + _this2.marketplaceDomains[_this2.marketplaces.indexOf(m)] + '/sp?seller=' + e.value
            });
          }
        }
        _this2.whiteList = res.sort(function (a, b) {
          var mIdxA = _this2.marketplaces.indexOf(a.marketplace);
          var mIdxB = _this2.marketplaces.indexOf(b.marketplace);
          if (mIdxA < mIdxB) return -1;
          if (mIdxB < mIdxA) return 1;
          return a.sellerId.localeCompare(b.sellerId);
        });
        _this2.whiteListOrig = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(res.map(function (u) {
          return u.url;
        }));
      }, function (response) {
        _this2.loading = false;
      });
    },
    save: function save() {
      var _this3 = this;

      var wl = {};
      for (var i = 0; i < this.whiteList.length; ++i) {
        var w = this.whiteList[i];
        if (wl[w.marketplace]) {
          var sellerKeys = wl[w.marketplace].sellerKeys;
          sellerKeys.splice(sellerKeys.length, 0, { value: w.sellerId });
        } else {
          wl[w.marketplace] = { sellerKeys: [{ value: w.sellerId }] };
        }
      }
      var res = { whiteList: wl };
      this.$http.put('/api/sentinel/watchdogtype/settings/' + this.watchDogType, res).then(function (response) {
        _this3.whiteListOrig = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(_this3.whiteList.map(function (u) {
          return u.url;
        }));
        _this3.updateDirty();
      }, function (response) {
        _this3.loading = false;
      });
    },
    updateDirty: function updateDirty() {
      this.dirty = !this.eqSet(this.whiteListOrig, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.whiteList.map(function (w) {
        return w.url;
      })));
    },
    eqSet: function eqSet(as, bs) {
      if (as.size !== bs.size) return false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(as), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var a = _step.value;
          if (!bs.has(a)) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    removeFromWhiteList: function removeFromWhiteList(url) {
      for (var i = 0; i < this.whiteList.length; ++i) {
        var w = this.whiteList[i];
        if (url === w.url) {
          this.whiteList.splice(i, 1);
          break;
        }
      }
    },
    getWhiteListURLErrorURL: function getWhiteListURLErrorURL() {
      try {
        if (this.$store.getters.sellers) {
          var sellers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.sellers);
          if (sellers.length === 0) return 'https://www.amazon.com/sp?marketplaceID=ATVPDKIKX0DER&seller=AHI6RGNHINEJM';
          return sellers[0].storeFrontURL;
        }
      } catch (err) {}
      return 'https://www.amazon.com/sp?marketplaceID=ATVPDKIKX0DER&seller=AHI6RGNHINEJM';
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    whiteListURL: function whiteListURL(val) {
      if (!val) {
        this.whiteListURLParsed = null;
        this.whiteListURLError = false;
        this.whiteListURLErrorURL = null;
        return;
      }
      try {
        var url = new URL(val);
        var domainIdx = this.marketplaceDomains.indexOf(url.host);
        var sellerId = url.searchParams.get('seller');
        if (domainIdx > -1 && sellerId) {
          var cleanUrl = 'https://' + url.host + '/sp?seller=' + sellerId;
          this.whiteListURLParsed = { marketplaceIdx: domainIdx, sellerId: sellerId, marketplace: this.marketplaces[domainIdx], url: cleanUrl };
          this.whiteListURLError = false;
          this.whiteListURLErrorURL = null;
        } else {
          this.whiteListURLParsed = null;
          this.whiteListURLError = true;
          this.whiteListURLErrorURL = this.getWhiteListURLErrorURL();
        }
      } catch (e) {
        this.whiteListURLParsed = null;
        this.whiteListURLError = true;
        this.whiteListURLErrorURL = this.getWhiteListURLErrorURL();
      }
    },
    whiteList: {
      handler: function handler() {
        this.updateDirty();
      },
      deep: true
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      sensitivity: null,
      sensitivityOrig: null,
      dirty: false
    };
  },
  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/api/sentinel/watchdogtype/settings/subscribeAndSave').then(function (response) {
        _this.loading = false;
        _this.sensitivity = response.body.sensitivity;
        _this.sensitivityOrig = response.body.sensitivity;
      }, function (response) {
        _this.loading = false;
      });
    },
    close: function close() {
      this.$parent.showConfiguration = false;
    },
    save: function save() {
      var _this2 = this;

      this.$http.put('/api/sentinel/watchdogtype/settings/subscribeAndSave', {
        sensitivity: this.sensitivity
      }).then(function (response) {
        _this2.loading = false;
        _this2.sensitivityOrig = _this2.sensitivity;
        _this2.dirty = _this2.sensitivity !== _this2.sensitivityOrig;
      }, function (response) {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    sensitivity: function sensitivity() {
      this.dirty = this.sensitivity !== this.sensitivityOrig;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_billingScreenVariant_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_stripePublishableKey_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_productAddonBilling_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_watchdogSummaryApi_js__ = __webpack_require__(33);









var _name$data$watch$comp;









/* harmony default export */ __webpack_exports__["default"] = (_name$data$watch$comp = {
  name: 'SubscriptionBillingSettings',
  data: function data() {
    return {
      loading: true,
      loadError: null,
      activeTab: 'plans',
      isOwner: false,
      tenantId: null,
      hasDailyPricing: false,
      periodEnd: '',
      periodEndEpoch: null,
      periodStart: null,
      packageDetails: null,
      addonCount: 0,
      proStorefrontCount: 5,
      showVolumePricing: false,
      paymentStatusMessage: '',
      paymentMethod: null,
      hasPaymentDetails: false,
      subscriptionCanceled: false,
      resumeInProgress: false,
      invoices: [],
      nextBillingFromInvoices: null,
      message: '',
      error: '',
      stripeButtonClicked: false,
      upgradeInProgress: false,
      updatePaymentInProgress: false,
      cancelModalVisible: false,
      cancelModalStep: 1,
      cancelPreview: null,
      cancelPreviewLoading: false,
      cancelPreviewError: '',
      cancelFlowError: '',
      cancelFlowSubmitting: false,
      cancelSaveOfferReached: false,
      cancelSaveOutcome: null,
      cancelSurveyReason: '',
      cancelSurveyAlertTags: [],
      cancelSurveyCompetitor: '',
      cancelStayAnswer: '',
      cancelDetailText: '',
      planChangeMailtoOverride: '',
      cancelReasonOptions: [{ id: 'too_expensive', label: "It's too expensive", subtitle: "Pricing isn't right for me" }, { id: 'missing_features', label: 'Missing features I need', subtitle: "The product doesn't do what I need" }, {
        id: 'too_many_alerts',
        label: "Too many alerts and not the ones I'm looking for",
        subtitle: 'Alert volume or relevance is the issue'
      }, { id: 'found_alternative', label: 'I found a better alternative', subtitle: 'Switching to another tool' }, { id: 'not_selling_amazon', label: 'No longer selling on Amazon', subtitle: 'Closed my Amazon business or paused' }, { id: 'something_else', label: 'Something else', subtitle: 'None of the above' }],
      cancelAlertTagOptions: [{ id: 'buy_box_lost', label: 'Buy Box Lost' }, { id: 'hijacker_detected', label: 'Hijacker Detected' }, { id: 'listing_suppressed', label: 'Listing Suppressed' }, { id: 'out_of_stock', label: 'Out of Stock' }, { id: 'competitor_price_change', label: 'Competitor Price Change' }, { id: 'low_stock', label: 'Low Stock' }, { id: 'price_floor_breach', label: 'Price Floor Breach' }, { id: 'sales_volume_drop', label: 'Sales Volume Drop' }, { id: 'content_changed', label: 'Content Changed' }, { id: 'margin_threshold', label: 'Margin Threshold' }, { id: 'daily_portfolio_digest', label: 'Daily Portfolio Digest' }],
      competitorOptions: ['Prefer not to say', 'BQool', 'Aura', 'Seller Snap', 'RepricerExpress', 'Informed.co', 'Going manual / no tool', 'Other'],
      stripeInstance: null,
      paymentElement: null,
      elementsGroup: null,
      setupIntentClientSecret: null,
      calculatedTotalDailyCost: 0,
      forcastedAmount: 0,
      dailyCostBreakdownData: [],
      showForecastedColumn: true,
      billingSummary: {},
      billingUserTypeRawFromIdentity: null,
      paymentModalTitle: 'Update payment method',
      savedPaymentMethods: [],
      upgradeModalOpen: false,
      upgradeModalPhase: 'confirm',
      upgradeModalPlanKey: 'pro',
      setDefaultInProgress: false,
      detachInProgress: false,
      orderVolumeLoading: false,
      orderVolumeError: null,
      orderVolumeData: null,
      orderVolumeChecked: false,
      periodChangesLoading: false,
      periodChangesError: null,
      periodChangesData: null,
      periodChangesFetched: false,

      subscriptionSummary: null,
      selectPlanInProgress: false
    };
  },
  watch: {
    activeTab: function activeTab(tab) {
      if (tab === 'usage' && this.showUsageTab && (!this.orderVolumeChecked || !this.periodChangesFetched) && !this.usageTabLoading) {
        this.loadUsageTabData();
      }
    },
    showUsageTab: function showUsageTab(visible) {
      if (!visible && this.activeTab === 'usage') {
        this.activeTab = 'plans';
      }
    },
    '$route.query.tab': function $routeQueryTab() {
      this.applyBillingTabFromRoute();
    },
    '$route.query.upgrade': function $routeQueryUpgrade() {
      this.tryFulfillUpgradeRouteIntent();
    },
    '$route.query.plan': function $routeQueryPlan() {
      this.tryApplyPlanQuerySelection();
    }
  },
  computed: {
    billingVariant: function billingVariant() {
      var raw = this.billingSummary && this.billingSummary.userType || this.billingSummary && this.billingSummary.user_type || this.billingUserTypeRawFromIdentity || this.packageDetails && this.packageDetails.subscriptionBillingUserType;
      return this.normalizeBillingScreenVariant(raw);
    },
    billingEmailDisplay: function billingEmailDisplay() {
      var fromSummary = this.billingSummary && (this.billingSummary.billingEmail || this.billingSummary.billing_email);
      if (fromSummary) return fromSummary;
      return this.$root.userEmail || '—';
    },
    planChangeMailHref: function planChangeMailHref() {
      if (this.planChangeMailtoOverride) return this.planChangeMailtoOverride;
      return 'mailto:support@sentrykit.com?subject=SentryKit%20plan%20change';
    },
    isCancelScheduledActive: function isCancelScheduledActive() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["n" /* isSubscriptionCancelScheduledActive */])(this.subscriptionSummary);
    },
    showResumeSubscriptionBanner: function showResumeSubscriptionBanner() {
      return !!(this.canManageBilling && this.isCancelScheduledActive);
    },
    resumeBannerDescription: function resumeBannerDescription() {
      var end = this.nextBillingDateDisplay;
      if (end && end !== '—') {
        return 'Your plan is set to cancel on ' + end + '. Resume now to stay on ' + this.currentPlanTitle + ' with no interruption.';
      }
      return 'Your plan is set to cancel at the end of this billing period. Resume now to keep it active.';
    },
    showCancelSubscriptionBanner: function showCancelSubscriptionBanner() {
      if (this.isCancelScheduledActive) return false;
      var ps = this.$root.paymentStatus;
      var payStates = ps === 2 || ps === 3 || ps === 4;
      return !!(this.isOwner && !this.subscriptionCanceled && payStates);
    },
    cancelFooterKeepLabel: function cancelFooterKeepLabel() {
      if (this.cancelModalStep === 1 && this.cancelPreview && this.cancelPreview.alreadyScheduledForCancel) {
        return this.resumeInProgress ? 'Resuming…' : 'Resume subscription';
      }
      return 'Keep my subscription';
    },
    cancelBannerDescription: function cancelBannerDescription() {
      var p = this.cancelPreview;
      if (p && p.periodEndFormatted) {
        return "You'll keep full access until " + p.periodEndFormatted + '. No proration.';
      }
      return "You'll keep full access until the end of your current billing period. No proration.";
    },
    cancelReasonSummaryLabel: function cancelReasonSummaryLabel() {
      var self = this;
      var hit = this.cancelReasonOptions.find(function (o) {
        return o.id === self.cancelSurveyReason;
      });
      return hit ? hit.label : this.cancelSurveyReason || '—';
    },
    cancelSurveyAlertHuman: function cancelSurveyAlertHuman() {
      var map = {};
      this.cancelAlertTagOptions.forEach(function (t) {
        map[t.id] = t.label;
      });
      return this.cancelSurveyAlertTags.map(function (id) {
        return map[id] || id;
      }).join(', ');
    },
    cancelModalPeriodEndDisplay: function cancelModalPeriodEndDisplay() {
      var p = this.cancelPreview;
      if (p && p.periodEndFormatted) return p.periodEndFormatted;
      if (this.periodEnd && this.periodEnd !== '—') return this.periodEnd;
      return 'the end of your billing period';
    },
    cancelFooterContinueLabel: function cancelFooterContinueLabel() {
      if (this.cancelModalStep === 4) {
        return this.cancelFlowSubmitting ? 'Submitting…' : 'Confirm cancellation';
      }
      return 'Continue →';
    },
    cancelFooterContinueDisabled: function cancelFooterContinueDisabled() {
      if (this.cancelFlowSubmitting) return true;
      if (this.cancelModalStep === 1) {
        if (this.cancelPreviewLoading) return true;
        if (!this.cancelPreview) return true;
        if (this.cancelPreview.alreadyScheduledForCancel) return true;
        return false;
      }
      if (this.cancelModalStep === 3) return !this.cancelSurveyReason;
      return false;
    },
    legacyPlanTitle: function legacyPlanTitle() {
      if (this.billingSummary && this.billingSummary.planName) return this.billingSummary.planName;
      if (this.billingSummary && this.billingSummary.plan_title) return this.billingSummary.plan_title;
      var n = this.packageDetails && (this.packageDetails.name || this.packageDetails.packageName);
      return n || 'SentryKit Legacy';
    },
    legacyPricingLine: function legacyPricingLine() {
      if (this.billingSummary && this.billingSummary.pricingDescription) return this.billingSummary.pricingDescription;
      if (this.billingSummary && this.billingSummary.pricing_description) return this.billingSummary.pricing_description;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_productAddonBilling_js__["a" /* formatLegacyBillingPricingLine */])(this.packageDetails, this.addonCount);
    },
    legacyFootnote: function legacyFootnote() {
      return this.billingSummary && (this.billingSummary.grandfatherNote || this.billingSummary.grandfather_note) || "You're on a grandfathered plan. Pricing and features have been preserved from your original signup.";
    },
    dailyPlanTitle: function dailyPlanTitle() {
      if (this.hasDailyPricing) return 'SentryKit Daily Usage Plan';
      return this.billingSummary && (this.billingSummary.planName || this.billingSummary.plan_title) || 'SentryKit Daily Usage Plan';
    },
    dailyPlanSubtitle: function dailyPlanSubtitle() {
      return this.billingSummary && (this.billingSummary.planSubtitle || this.billingSummary.plan_subtitle) || 'Billed monthly based on the number of ASINs you track';
    },
    dailyFootnote: function dailyFootnote() {
      return this.billingSummary && (this.billingSummary.dailyDisclaimer || this.billingSummary.daily_disclaimer) || 'Your invoice amount changes when ASIN counts change. Adjust tracked ASINs anytime from the Products page.';
    },
    summaryLastBilledAmount: function summaryLastBilledAmount() {
      var cents = this.billingSummary && (this.billingSummary.lastBilledAmountCents != null ? this.billingSummary.lastBilledAmountCents : this.billingSummary.last_billed_amount_cents);
      if (cents != null) return (Number(cents) / 100).toFixed(2);
      var inv = this.invoices[0];
      if (inv && inv.totalAmount != null) return (inv.totalAmount / 100).toFixed(2);
      return '—';
    },
    summaryLastBilledDetail: function summaryLastBilledDetail() {
      var dateRaw = this.billingSummary && (this.billingSummary.lastBilledDate || this.billingSummary.last_billed_date || this.billingSummary.lastBilledAt);
      var label = this.billingSummary && (this.billingSummary.lastBilledStatus || this.billingSummary.last_billed_status) || 'Paid';
      if (dateRaw) return this.formatInvoiceDate(dateRaw) + ' · ' + label;
      var inv = this.invoices[0];
      if (inv) return this.formatInvoiceDate(this.invoicePaidOn(inv)) + ' · ' + label;
      return '—';
    },
    summaryAsinsDisplay: function summaryAsinsDisplay() {
      var bs = this.billingSummary;
      var n = bs && (bs.trackedAsinsCount != null ? bs.trackedAsinsCount : bs.tracked_asins_count != null ? bs.tracked_asins_count : bs.asinsTracked != null ? bs.asinsTracked : bs.asins_tracked);
      if (n != null && n !== '') return String(n);
      var rows = this.dailyCostBreakdownData;
      if (rows && rows.length) {
        var last = rows[rows.length - 1];
        if (last && last.quantity != null) return String(last.quantity);
      }
      return '—';
    },
    projectedMonthAmount: function projectedMonthAmount() {
      var cents = this.billingSummary && (this.billingSummary.projectedMonthAmountCents != null ? this.billingSummary.projectedMonthAmountCents : this.billingSummary.projected_month_amount_cents);
      if (cents != null) return (Number(cents) / 100).toFixed(2);
      if (this.billingVariant === 'daily_usage' || this.hasDailyPricing) {
        if (this.dailyCostBreakdownData.length) {
          return (this.calculatedTotalDailyCost + this.forcastedAmount).toFixed(2);
        }
        return '0.00';
      }
      return this.nextBillAmount;
    },
    projectedMonthUsesEstimate: function projectedMonthUsesEstimate() {
      if (this.billingVariant !== 'daily_usage' && !this.hasDailyPricing) return false;
      return this.dailyCostBreakdownData.length > 0;
    },
    projectedMonthSubtext: function projectedMonthSubtext() {
      if (this.isDailyUsageTrialExpiredNoPayment) {
        return 'Add a payment method to resume billing';
      }
      if ((this.billingVariant === 'daily_usage' || this.hasDailyPricing) && !this.dailyCostBreakdownData.length) {
        return 'No usage billed this period yet';
      }
      return 'Based on current ASIN count';
    },
    displayCardInfo: function displayCardInfo() {
      if (!this.paymentMethod || this.paymentMethod.method !== 'card') return null;
      var pm = this.paymentMethod;
      var d = pm.details || pm.card || {};
      var brand = (pm.brand || d.brand || d.cardBrand || 'Card').toString();
      var short = brand.length <= 4 ? brand.toUpperCase() : brand.slice(0, 4).toUpperCase();
      var last4 = (pm.last4 != null ? pm.last4 : d.last4 || d.lastFour || '••••').toString();
      var expM = pm.exp_month != null ? pm.exp_month : pm.expMonth != null ? pm.expMonth : d.exp_month != null ? d.exp_month : d.expMonth;
      var expY = pm.exp_year != null ? pm.exp_year : pm.expYear != null ? pm.expYear : d.exp_year != null ? d.exp_year : d.expYear;
      var prettyBrand = brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
      var metaParts = ['Brand: ' + prettyBrand, 'Last 4: ' + last4];
      var expDisp = this.formatCardExpiryDisplay(expM, expY);
      if (expDisp) metaParts.push('Expires: ' + expDisp);
      var created = d.created || pm.createdAt || pm.created;
      if (created) {
        var cd = typeof created === 'number' ? new Date(created * 1000) : new Date(created);
        if (!isNaN(cd.getTime())) {
          metaParts.push('Added ' + cd.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }));
        }
      }
      var label = prettyBrand + ' •••• ' + last4;
      return { brandShort: short, label: label, metaLine: metaParts.join(' · ') || 'Card on file' };
    },
    primaryPaymentButtonLabel: function primaryPaymentButtonLabel() {
      if (this.paymentMethod && this.paymentMethod.method === 'ach') return 'View bank details';
      var listHasCard = this.savedPaymentMethods.some(function (p) {
        return p.kind === 'card';
      });
      if (listHasCard || this.hasPaymentDetails && this.paymentMethod && this.paymentMethod.method === 'card') {
        return 'Update card';
      }
      return 'Add card';
    },
    showNextBillLine: function showNextBillLine() {
      return this.hasDailyPricing || this.billingVariant === 'daily_usage';
    },
    isNewBillingVariant: function isNewBillingVariant() {
      return this.billingVariant === 'new';
    },
    isPaymentPastDue: function isPaymentPastDue() {
      if (!this.isNewBillingVariant) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["o" /* isSubscriptionStatusPastDue */])(this.subscriptionSummary);
    },
    isTrialBillingActive: function isTrialBillingActive() {
      if (!this.isNewBillingVariant) return false;
      if (this.isPaymentPastDue) return false;
      if (this.subscriptionSummary) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["p" /* isTrialActiveFromSummary */])(this.subscriptionSummary);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["b" /* isTrialOrderVolumeUser */])(this.orderVolumeContext);
    },

    isTrialBillingExpired: function isTrialBillingExpired() {
      if (!this.isNewBillingVariant) return false;
      if (this.isPaymentPastDue) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["q" /* isTrialExpiredFromSummary */])(this.subscriptionSummary);
    },

    isDailyUsageTrialExpiredNoPayment: function isDailyUsageTrialExpiredNoPayment() {
      if (this.billingVariant !== 'daily_usage') return false;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["q" /* isTrialExpiredFromSummary */])(this.subscriptionSummary)) return false;
      return !this.hasStripePaymentMethodOnFile;
    },

    hasStripePaymentMethodOnFile: function hasStripePaymentMethodOnFile() {
      if (this.subscriptionSummary && this.subscriptionSummary.paymentInfoAdded) return true;
      if (this.savedPaymentMethods && this.savedPaymentMethods.length > 0) return true;
      if (this.displayCardInfo) return true;
      if (this.paymentMethod && this.paymentMethod.method === 'ach') return true;
      if (this.paymentMethod && this.paymentMethod.method === 'card') return true;
      return false;
    },

    canManageBilling: function canManageBilling() {
      return this.isOwner;
    },
    hasTenantBillingSnapshot: function hasTenantBillingSnapshot() {
      return !!(this.packageDetails || this.subscriptionSummary || this.billingSummary && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(this.billingSummary).length > 0 || this.invoices.length > 0);
    },
    billingPageSubtitle: function billingPageSubtitle() {
      if (!this.canManageBilling) {
        return 'View your plan, usage, and billing history. Contact your account admin to make changes.';
      }
      if (this.isPaymentPastDue) return 'Your last payment failed. Update your payment method to keep your subscription active.';
      if (this.isTrialBillingExpired) return 'Your trial has ended. Pick a plan to resume service.';
      if (this.isDailyUsageTrialExpiredNoPayment) {
        return 'Your trial has ended. Add a payment method to resume daily usage billing.';
      }
      return 'Manage your plan, review usage, and access billing history.';
    },
    isFlatYearlyPlan: function isFlatYearlyPlan() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["r" /* isFlatYearlyPlanFromSummary */])(this.subscriptionSummary)) return true;
      if (!this.packageDetails) return false;
      var key = (this.packageDetails.packageKey || this.packageDetails.package_key || '').toString().toUpperCase();
      if (key === 'FLAT_YEARLY') return true;
      var tier = (this.packageDetails.tier || '').toString().toLowerCase();
      if (tier === 'flat_yearly') return true;
      var name = (this.packageDetails.name || this.packageDetails.packageName || this.packageDetails.planLabel || '').toLowerCase();
      return name.indexOf('flat yearly') >= 0;
    },
    isProPlan: function isProPlan() {
      if (this.isFlatYearlyPlan) return false;
      if (this.subscriptionSummary && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["s" /* planNameFromSummary */])(this.subscriptionSummary)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["l" /* isProPlanFromSummary */])(this.subscriptionSummary);
      }
      if (!this.packageDetails) return false;
      var key = (this.packageDetails.packageKey || this.packageDetails.package_key || '').toString().toUpperCase();
      if (key === 'PRO' || key === 'PRO_ANNUAL') return true;
      var name = (this.packageDetails.name || this.packageDetails.packageName || '').toLowerCase();
      if (name.indexOf('pro') >= 0) return true;
      var cents = this.packageDetails.baseSubscriptionFeeCents;
      return cents != null && cents >= 4900;
    },
    currentPlanTitle: function currentPlanTitle() {
      if (this.isFlatYearlyPlan) return 'Flat Yearly Subscription';
      var fromSummary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["s" /* planNameFromSummary */])(this.subscriptionSummary);
      if (fromSummary) return fromSummary;
      return (this.isProPlan ? 'Pro' : 'Starter') + ' Plan';
    },
    flatYearlyPriceLabel: function flatYearlyPriceLabel() {
      var cents = this.packageDetails && (this.packageDetails.baseSubscriptionFeeCents || this.packageDetails.base_subscription_fee_cents);
      var dollars = cents != null && cents !== '' && !isNaN(Number(cents)) ? Number(cents) / 100 : 600;
      var amount = Math.floor(dollars) === dollars ? String(dollars) : dollars.toFixed(2);
      return '$' + amount + ' / year';
    },
    currentPlanSubtitle: function currentPlanSubtitle() {
      if (this.isPaymentPastDue) {
        return 'Payment failed — update your card below to stay on this plan';
      }
      if (this.isFlatYearlyPlan) return this.flatYearlyPriceLabel;
      if (this.isTrialBillingActive) {
        return 'Free trial · ' + this.planAfterTrialLabel + ' (' + this.planPriceLabel(this.planAfterTrialKey) + ') after trial';
      }
      if (this.isProAnnualPlan) return 'Pro Annual · ' + this.planPriceLabel('pro_annual') + ', billed yearly';
      if (this.isProPlan) return 'Pro · ' + this.planPriceLabel('pro');
      return 'Starter · ' + this.planPriceLabel('starter');
    },
    subscriptionStatusLabel: function subscriptionStatusLabel() {
      if (!this.subscriptionSummary || !this.subscriptionSummary.status) return '';
      if (this.isPaymentPastDue) return 'Payment failed';
      if (this.isTrialBillingExpired) return 'Trial ended';
      if (this.isTrialBillingActive) return 'Trial';
      if (this.isCancelScheduledActive) return 'Cancels ' + this.nextBillingDateDisplay;
      if (this.subscriptionSummary.status === 'active') return 'Active';
      return this.subscriptionSummary.status;
    },
    nextBillingDateDisplay: function nextBillingDateDisplay() {
      if (this.subscriptionSummary) {
        var fromSummary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["t" /* formatSubscriptionEndDate */])(this.subscriptionSummary, function (d) {
          return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        });
        if (fromSummary !== '—') return fromSummary;
      }
      var fromInv = this.nextBillingFromInvoices != null && String(this.nextBillingFromInvoices).trim() ? String(this.nextBillingFromInvoices).trim() : '';
      if (fromInv) return fromInv;
      if (!this.periodEnd || this.periodEnd === '-') return '—';
      return this.periodEnd;
    },
    trialPeriodEndEpoch: function trialPeriodEndEpoch() {
      if (this.subscriptionSummary) {
        var e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["u" /* subscriptionEndEpochFromSummary */])(this.subscriptionSummary);
        if (e != null) return e;
      }
      return this.periodEndEpoch;
    },
    nextBillAmount: function nextBillAmount() {
      if (this.hasDailyPricing && this.dailyCostBreakdownData.length) {
        return (this.calculatedTotalDailyCost + this.forcastedAmount).toFixed(2);
      }
      if (this.packageDetails) {
        var base = this.packageDetails.baseSubscriptionFeeCents || 0;
        var add = (this.packageDetails.addonSubscriptionFeeCents || 0) * (this.addonCount || 0);
        return ((base + add) / 100).toFixed(2);
      }
      return '0.00';
    },
    achAlreadyOnFile: function achAlreadyOnFile() {
      if (this.paymentMethod && this.paymentMethod.method === 'ach') return true;
      return this.savedPaymentMethods.some(function (p) {
        return p.kind === 'ach';
      });
    },

    hasPaymentMethodOnFile: function hasPaymentMethodOnFile() {
      if (this.subscriptionSummary && this.subscriptionSummary.paymentInfoAdded) return true;
      if (this.savedPaymentMethods && this.savedPaymentMethods.length > 0) return true;
      if (this.displayCardInfo) return true;
      if (this.paymentMethod && this.paymentMethod.method === 'ach') return true;
      if (this.paymentMethod && this.paymentMethod.method === 'card') return true;
      return !!this.hasPaymentDetails;
    },
    orderVolumeEligible: function orderVolumeEligible() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["c" /* isOrderVolumeBillingEligible */])(this.orderVolumeData);
    },
    showUsageTab: function showUsageTab() {
      if (!__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["d" /* ORDER_VOLUME_UI_ENABLED */]) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["e" /* shouldShowOrderVolumeUi */])(this.packageDetails, this.orderVolumeData, {
        billingVariant: this.billingVariant,
        subscriptionSummary: this.subscriptionSummary,
        hasDailyPricing: this.hasDailyPricing,
        billingUserTypeRaw: this.billingUserTypeRawFromIdentity,
        billingSummary: this.billingSummary
      });
    },
    effectiveTenantId: function effectiveTenantId() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["f" /* tenantIdFromOrderVolumeBody */])(this.orderVolumeData) || this.tenantId || this.$root && this.$root.tenantId || null;
    },
    proMonthlyOrderCap: function proMonthlyOrderCap() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["g" /* proMonthlyOrderLimitForTenant */])(this.effectiveTenantId);
    },
    proOrderCapLabel: function proOrderCapLabel() {
      var cap = this.proMonthlyOrderCap;
      return cap != null ? cap.toLocaleString('en-US') : '';
    },
    proStorefrontRate: function proStorefrontRate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["h" /* proStorefrontUnitRate */])(this.proStorefrontCount + 1);
    },
    proStorefrontTotalPrice: function proStorefrontTotalPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["i" /* proMonthlyPriceForStorefrontCount */])(this.proStorefrontCount);
    },
    proStorefrontHint: function proStorefrontHint() {
      var n = this.proStorefrontCount;
      var INCL = __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["j" /* PRO_INCLUDED_STOREFRONTS */];
      if (n < INCL) return INCL - n + ' more storefront' + (INCL - n > 1 ? 's' : '') + ' included';
      return INCL + ' included · next storefront +$' + this.proStorefrontRate;
    },
    userHasNoMonthlyOrderCap: function userHasNoMonthlyOrderCap() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["k" /* userHasNoMonthlyOrderCap */])(this.orderVolumeContext);
    },
    orderVolumeContext: function orderVolumeContext() {
      return {
        orderVolumeBody: this.orderVolumeData,
        packageDetails: this.packageDetails,
        paymentStatus: this.$root.paymentStatus,
        hasPaymentMethodOnFile: this.hasPaymentMethodOnFile,
        subscriptionSummary: this.subscriptionSummary,
        tenantId: this.effectiveTenantId
      };
    },
    isTrialOrderVolumeUser: function isTrialOrderVolumeUser() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["b" /* isTrialOrderVolumeUser */])(this.orderVolumeContext);
    },
    orderVolumeMonthly: function orderVolumeMonthly() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["l" /* resolveMonthlyOrderVolumeForDisplay */])(this.packageDetails, this.orderVolumeData, this.periodEndEpoch, this.orderVolumeContext);
    },
    orderVolumeShowLimit: function orderVolumeShowLimit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["m" /* shouldShowOrderVolumeLimit */])(this.orderVolumeMonthly, this.orderVolumeContext);
    },
    orderVolumePeriodRange: function orderVolumePeriodRange() {
      var dates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["n" /* currentBillingMonthDateStrings */])(this.periodStart, this.periodEndEpoch);
      if (!dates) return '—';
      return this.formatUsageDateRange(dates.periodStart, dates.periodEnd);
    },
    orderVolumeUsedDisplay: function orderVolumeUsedDisplay() {
      return this.formatUsageCount(this.orderVolumeMonthly && this.orderVolumeMonthly.used);
    },
    orderVolumeLimitDisplay: function orderVolumeLimitDisplay() {
      return this.formatUsageCount(this.orderVolumeMonthly && this.orderVolumeMonthly.limit);
    },
    orderVolumePercentUsed: function orderVolumePercentUsed() {
      var pct = this.orderVolumeMonthly && this.orderVolumeMonthly.percentUsed;
      if (pct == null || isNaN(Number(pct))) return 0;
      return Math.min(100, Math.max(0, Number(pct)));
    },
    orderVolumeProgressWidth: function orderVolumeProgressWidth() {
      return this.orderVolumePercentUsed + '%';
    },
    orderVolumePercentDisplay: function orderVolumePercentDisplay() {
      var m = this.orderVolumeMonthly;
      if (!m || m.percentUsed == null || isNaN(Number(m.percentUsed))) return '0.0';
      return Number(m.percentUsed).toFixed(1);
    },
    orderVolumeRemainingDisplay: function orderVolumeRemainingDisplay() {
      return this.formatUsageCount(this.orderVolumeMonthly && this.orderVolumeMonthly.remaining);
    },
    orderVolumeResetsDisplay: function orderVolumeResetsDisplay() {
      var raw = this.orderVolumeMonthly && this.orderVolumeMonthly.resetsAt;
      return raw ? this.formatUsageShortDate(raw) : '—';
    },
    orderVolumeOrdersThisMonthDisplay: function orderVolumeOrdersThisMonthDisplay() {
      return this.formatUsageCount(this.orderVolumeData && this.orderVolumeData.ordersThisMonth);
    },
    orderVolumeOrdersCompareLine: function orderVolumeOrdersCompareLine() {
      var d = this.orderVolumeData;
      if (!d) return '—';
      var last = this.formatUsageCount(d.ordersLastMonth);
      var pct = d.ordersChangePercent;
      if (pct == null || isNaN(Number(pct))) return 'vs. ' + last + ' last month';
      var sign = Number(pct) > 0 ? '+' : '';
      return 'vs. ' + last + ' last month (' + sign + Number(pct).toFixed(1) + '%)';
    },
    orderVolumeAvgDailyDisplay: function orderVolumeAvgDailyDisplay() {
      var n = this.orderVolumeData && this.orderVolumeData.avgDailyOrders;
      if (n == null || isNaN(Number(n))) return '—';
      return Number(n).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    orderVolumeProjectedDisplay: function orderVolumeProjectedDisplay() {
      return this.formatUsageCount(this.orderVolumeData && this.orderVolumeData.projectedMonthEndOrders);
    },
    orderVolumeConnectedCountDisplay: function orderVolumeConnectedCountDisplay() {
      var accounts = this.orderVolumeData && this.orderVolumeData.connectedAccounts || [];
      return String(accounts.length);
    },
    orderVolumeConnectedAccountsLine: function orderVolumeConnectedAccountsLine() {
      var accounts = this.orderVolumeData && this.orderVolumeData.connectedAccounts || [];
      if (!accounts.length) return 'No connected seller accounts';
      if (accounts.length === 1) {
        var a = accounts[0];
        var name = (a.name || a.sellerName || 'Seller').trim();
        var mps = (a.marketplaces || []).join(', ');
        return mps ? name + ' · ' + mps : name;
      }
      return accounts.map(function (a) {
        var n = (a.name || a.sellerName || 'Seller').trim();
        var mp = (a.marketplaces || []).join(', ');
        return mp ? n + ' (' + mp + ')' : n;
      }).join(' · ');
    },
    orderVolumeAsinsDisplay: function orderVolumeAsinsDisplay() {
      return this.formatUsageCount(this.orderVolumeData && this.orderVolumeData.asinsMonitored);
    },
    orderVolumeChangesCaughtDisplay: function orderVolumeChangesCaughtDisplay() {
      var pc = this.periodChangesParsed;
      if (pc && pc.total != null && !isNaN(Number(pc.total))) {
        return Number(pc.total).toLocaleString('en-US');
      }
      if (pc && pc.watchdogChangesCount != null && !isNaN(Number(pc.watchdogChangesCount))) {
        return Number(pc.watchdogChangesCount).toLocaleString('en-US');
      }
      var n = this.orderVolumeData && this.orderVolumeData.changesCaught;
      if (n == null || isNaN(Number(n))) return '—';
      return Number(n).toLocaleString('en-US');
    },
    periodChangesParsed: function periodChangesParsed() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_watchdogSummaryApi_js__["b" /* parsePeriodChangesBody */])(this.periodChangesData);
    },
    usageTabLoading: function usageTabLoading() {
      return this.orderVolumeLoading || this.periodChangesLoading;
    },
    usageTabError: function usageTabError() {
      return this.orderVolumeError;
    },
    usageBillingPeriodLine: function usageBillingPeriodLine() {
      var pc = this.periodChangesParsed;
      var start = pc.periodStart;
      var end = pc.periodEnd;
      if (start && end) {
        var range = this.formatUsageDateRange(start, end);
        var status = this.usagePeriodStatusSuffix;
        return status ? 'Billing period: ' + range + ' · ' + status : 'Billing period: ' + range;
      }
      var dates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["n" /* currentBillingMonthDateStrings */])(this.periodStart, this.periodEndEpoch);
      if (!dates) return 'Billing period: —';
      var fallback = this.formatUsageDateRange(dates.periodStart, dates.periodEnd);
      var suffix = this.usagePeriodStatusSuffix;
      return suffix ? 'Billing period: ' + fallback + ' · ' + suffix : 'Billing period: ' + fallback;
    },
    usagePeriodStatusSuffix: function usagePeriodStatusSuffix() {
      if (this.isTrialBillingExpired) return 'trial ended';
      if (this.isTrialBillingActive) return 'trial';
      if (this.subscriptionStatusLabel) return String(this.subscriptionStatusLabel).toLowerCase();
      return '';
    },
    usageCurrentPlanName: function usageCurrentPlanName() {
      if (this.isFlatYearlyPlan) return 'Flat Yearly Subscription';
      if (this.isInTrialState) return 'Free trial';
      return this.planDisplayName(this.currentPlanKey) || (this.isProPlan ? 'Pro' : 'Starter');
    },
    usagePlanPriceSubline: function usagePlanPriceSubline() {
      if (this.isFlatYearlyPlan) return this.flatYearlyPriceLabel;
      if (this.isInTrialState) return this.planAfterTrialLabel + ' after trial · ' + this.planPriceLabel(this.planAfterTrialKey);
      if (this.isProAnnualPlan) return this.planPriceLabel('pro_annual');
      if (this.isProPlan) {
        var count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["o" /* connectedStorefrontsCountFromPeriodChanges */])(this.periodChangesData);
        if (count == null) count = this.proStorefrontCount;
        var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["i" /* proMonthlyPriceForStorefrontCount */])(count);
        return '$' + price.toLocaleString('en-US') + (this.isTrialBillingActive ? ' / mo after trial' : ' / mo');
      }
      return this.isTrialBillingActive ? '$' + __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["p" /* STARTER_MONTHLY_PRICE */] + ' / mo after trial' : '$' + __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["p" /* STARTER_MONTHLY_PRICE */] + ' / mo';
    },
    usageStorefrontsCountDisplay: function usageStorefrontsCountDisplay() {
      var pc = this.periodChangesParsed;
      if (pc.connectedStorefrontsCount != null && !isNaN(Number(pc.connectedStorefrontsCount))) {
        return this.formatUsageCount(pc.connectedStorefrontsCount);
      }
      return this.orderVolumeConnectedCountDisplay;
    },
    usageNextChargeShortDisplay: function usageNextChargeShortDisplay() {
      var epoch = this.trialPeriodEndEpoch;
      if (epoch != null) {
        var d = new Date(Number(epoch) * 1000);
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        }
      }
      var full = this.nextBillingDateDisplay;
      if (!full || full === '—') return '—';
      var parsed = new Date(full);
      if (!isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }
      return full;
    },
    usageNextChargeSubline: function usageNextChargeSubline() {
      if (this.isTrialBillingActive) return 'When your trial ends';
      if (this.isTrialBillingExpired) return 'Trial ended';
      return 'Next billing date';
    },
    usageAsinsMonitoredDisplay: function usageAsinsMonitoredDisplay() {
      var pc = this.periodChangesParsed;
      if (pc.activeListedAsinsCount != null && !isNaN(Number(pc.activeListedAsinsCount))) {
        return this.formatUsageCount(pc.activeListedAsinsCount);
      }
      return this.orderVolumeAsinsDisplay;
    },
    usageMarketplacesCountDisplay: function usageMarketplacesCountDisplay() {
      var pc = this.periodChangesParsed;
      if (pc.marketplacesCoveredCount != null && !isNaN(Number(pc.marketplacesCoveredCount))) {
        return this.formatUsageCount(pc.marketplacesCoveredCount);
      }
      var accounts = this.orderVolumeData && this.orderVolumeData.connectedAccounts || [];
      var seen = {};
      accounts.forEach(function (a) {
        ;(a.marketplaces || []).forEach(function (mp) {
          if (mp) seen[String(mp).toUpperCase()] = true;
        });
      });
      var n = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(seen).length;
      if (n > 0) return String(n);
      if (pc.connectedStorefrontsCount != null) return this.formatUsageCount(pc.connectedStorefrontsCount);
      return this.orderVolumeConnectedCountDisplay;
    },
    usageChecksRunDisplay: function usageChecksRunDisplay() {
      var pc = this.periodChangesParsed;
      var n = pc.checksRunCount != null && !isNaN(Number(pc.checksRunCount)) ? pc.checksRunCount : pc.watchdogChangesCount;
      if (n == null || isNaN(Number(n))) return '—';
      return this.formatUsageCount(n);
    },
    usageChecksPerDayLine: function usageChecksPerDayLine() {
      var pc = this.periodChangesParsed;
      var checks = pc.checksRunCount != null && !isNaN(Number(pc.checksRunCount)) ? Number(pc.checksRunCount) : Number(pc.watchdogChangesCount);
      if (isNaN(checks) || checks <= 0) return '';
      var start = pc.periodStart;
      var end = pc.periodEnd;
      if (!start || !end) return '';
      var s = new Date(String(start).indexOf('T') >= 0 ? start : start + 'T12:00:00');
      var e = new Date(String(end).indexOf('T') >= 0 ? end : end + 'T12:00:00');
      if (isNaN(s.getTime()) || isNaN(e.getTime())) return '';
      var days = Math.max(1, Math.round((e.getTime() - s.getTime()) / (24 * 60 * 60 * 1000)) + 1);
      var perDay = Math.round(checks / days);
      return '~' + perDay.toLocaleString('en-US') + ' / day';
    },
    usageCategoriesWithBars: function usageCategoriesWithBars() {
      var pc = this.periodChangesParsed;
      var rows = pc.categories || [];
      var max = 0;
      rows.forEach(function (row) {
        var c = Number(row.count) || 0;
        if (c > max) max = c;
      });
      return rows.map(function (row) {
        return {
          key: row.key,
          label: row.label,
          count: row.count,
          countDisplay: Number(row.count).toLocaleString('en-US'),
          barWidth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_watchdogSummaryApi_js__["c" /* periodChangesCategoryBarWidth */])(row.count, max)
        };
      });
    },
    usageAlertDeliveryChannels: function usageAlertDeliveryChannels() {
      return ['Email', 'Slack', 'Google Sheets', 'Zapier'];
    },

    currentPlanKey: function currentPlanKey() {
      if (this.isFlatYearlyPlan) return null;
      var fromSummary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["v" /* currentPlanKeyFromSummary */])(this.subscriptionSummary);
      if (fromSummary) return fromSummary;
      if (!this.packageDetails) return null;
      var key = String(this.packageDetails.packageKey || this.packageDetails.package_key || '').toUpperCase();
      if (key === 'PRO_ANNUAL') return 'pro_annual';
      if (key === 'PRO') return 'pro';
      if (key === 'STARTER') return 'starter';
      return this.isProPlan ? 'pro' : null;
    },
    isProAnnualPlan: function isProAnnualPlan() {
      return this.currentPlanKey === 'pro_annual';
    },
    isInTrialState: function isInTrialState() {
      return this.isTrialBillingActive || this.isTrialBillingExpired;
    },

    trialPlanChosen: function trialPlanChosen() {
      if (!this.isInTrialState) return false;
      return this.currentPlanKey === 'pro' || this.currentPlanKey === 'pro_annual';
    },
    planAfterTrialKey: function planAfterTrialKey() {
      if (!this.isInTrialState) return null;
      return this.trialPlanChosen ? this.currentPlanKey : 'starter';
    },
    planAfterTrialLabel: function planAfterTrialLabel() {
      return this.planDisplayName(this.planAfterTrialKey) || '—';
    },
    planAfterTrialSub: function planAfterTrialSub() {
      if (!this.trialPlanChosen) return 'Unless you choose ' + this.upgradeChoicesLabel + ' below';
      return 'Change anytime before ' + this.nextBillingDateDisplay;
    },
    proAnnualPriceCents: function proAnnualPriceCents() {
      var fromSummary = this.subscriptionSummary && this.subscriptionSummary.proAnnualPriceCents;
      if (fromSummary != null) return fromSummary;
      if (this.isProAnnualPlan && this.packageDetails && this.packageDetails.baseSubscriptionFeeCents) {
        return Number(this.packageDetails.baseSubscriptionFeeCents);
      }
      return null;
    },

    showProAnnualCard: function showProAnnualCard() {
      if (this.isProAnnualPlan) return true;
      return __WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["w" /* PRO_ANNUAL_UI_ENABLED */] && this.proAnnualPriceCents != null;
    },

    upgradeChoicesLabel: function upgradeChoicesLabel() {
      return this.showProAnnualCard ? 'Pro or Pro Annual' : 'Pro';
    },
    proAnnualPriceDisplay: function proAnnualPriceDisplay() {
      var cents = this.proAnnualPriceCents;
      var dollars = cents != null ? cents / 100 : 600;
      return Math.floor(dollars) === dollars ? dollars.toLocaleString('en-US') : dollars.toFixed(2);
    },
    proAnnualFootnote: function proAnnualFootnote() {
      if (this.isProAnnualPlan && !this.isInTrialState) return 'Renews ' + this.nextBillingDateDisplay + '.';
      return 'Billed $' + this.proAnnualPriceDisplay + ' up front for 12 months.';
    },
    planSectionHeading: function planSectionHeading() {
      if (this.isTrialBillingExpired) return 'Pick a plan to resume service';
      if (this.isTrialBillingActive) return 'Choose your plan for after the trial';
      return 'Change plan';
    },
    planSectionHelp: function planSectionHelp() {
      if (this.isTrialBillingExpired) {
        return 'Your data is safe. Pick a plan and add a card to turn your alerts back on.';
      }
      if (this.isTrialBillingActive) {
        if (this.trialPlanChosen) {
          return this.planAfterTrialLabel + ' starts when your trial ends on ' + this.nextBillingDateDisplay + '. Nothing is charged before then, and you can switch any time.';
        }
        return 'Nothing is charged during your free trial. Starter starts automatically when it ends unless you choose ' + this.upgradeChoicesLabel + '.';
      }
      return 'Unlimited ASINs and all marketplaces on every plan. Only storefronts affect your price.';
    },

    connectedStorefrontCount: function connectedStorefrontCount() {
      var fromPeriod = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["o" /* connectedStorefrontsCountFromPeriodChanges */])(this.periodChangesData);
      if (fromPeriod != null) return fromPeriod;
      var accounts = this.orderVolumeData && this.orderVolumeData.connectedAccounts;
      return Array.isArray(accounts) ? accounts.length : null;
    },
    upgradeModalPlanName: function upgradeModalPlanName() {
      return this.planDisplayName(this.upgradeModalPlanKey);
    },
    upgradeModalPriceLabel: function upgradeModalPriceLabel() {
      if (this.upgradeModalPlanKey === 'pro_annual') return '$' + this.proAnnualPriceDisplay + '/year';
      if (this.upgradeModalPlanKey === 'starter') return '$' + __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["p" /* STARTER_MONTHLY_PRICE */] + '/month';
      return '$49/month';
    },
    upgradeModalTitle: function upgradeModalTitle() {
      var name = this.upgradeModalPlanName;
      if (this.isInTrialState) return 'Choose ' + name + ' for after your trial?';
      if (this.upgradeModalPlanKey === 'pro_annual' && this.currentPlanKey === 'pro') return 'Switch Pro to yearly billing?';
      return 'Upgrade to ' + name + '?';
    },
    upgradeModalChargeToday: function upgradeModalChargeToday() {
      if (this.isTrialBillingActive) return '$0 — your free trial continues';
      if (this.upgradeModalPlanKey === 'pro_annual') {
        return '$' + this.proAnnualPriceDisplay + ', minus credit for unused time on your current plan';
      }
      return 'The difference for the rest of this month';
    },
    upgradeModalRenewLabel: function upgradeModalRenewLabel() {
      return this.isTrialBillingActive ? 'First charge' : 'Renews';
    },
    upgradeModalRenewValue: function upgradeModalRenewValue() {
      if (this.isTrialBillingActive) return this.nextBillingDateDisplay + ' (when your trial ends)';
      return this.upgradeModalPlanKey === 'pro_annual' ? 'Every year from today' : 'Every month on your usual billing date';
    },
    upgradeModalNote: function upgradeModalNote() {
      var notes = [];
      var count = this.connectedStorefrontCount;
      if (this.upgradeModalPlanKey !== 'starter' && count != null && count > __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["j" /* PRO_INCLUDED_STOREFRONTS */]) {
        notes.push('You have ' + count + ' storefronts. Storefront ' + (__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["j" /* PRO_INCLUDED_STOREFRONTS */] + 1) + ' onward is billed ' + (this.upgradeModalPlanKey === 'pro_annual' ? 'yearly at 12× the monthly volume rate.' : 'monthly at the volume rates.'));
      }
      if (this.upgradeModalPlanKey === 'starter' && this.isInTrialState && count != null && count > 2) {
        notes.push('Starter includes 2 storefronts. Your ' + count + ' connected storefronts keep working, but you can’t add more.');
      }
      if (this.upgradeModalPlanKey === 'pro_annual' && !this.isInTrialState) {
        notes.push('If your card is declined, you stay on your current plan.');
      }
      return notes.join(' ');
    },
    upgradeModalConfirmLabel: function upgradeModalConfirmLabel() {
      if (this.isInTrialState) return 'Choose ' + this.upgradeModalPlanName;
      if (this.upgradeModalPlanKey === 'pro_annual') return 'Pay & switch';
      return 'Confirm upgrade';
    },
    upgradeModalNoPaymentTail: function upgradeModalNoPaymentTail() {
      if (this.isTrialBillingActive) {
        return 'Add a card to choose it — nothing is charged until your trial ends on ' + this.nextBillingDateDisplay + '.';
      }
      return 'Add a card to continue. You’re only charged when you confirm the switch.';
    },
    trialDaysRemaining: function trialDaysRemaining() {
      if (this.isTrialBillingExpired) return 0;
      if (!this.isTrialBillingActive) return null;
      var epoch = this.trialPeriodEndEpoch;
      if (epoch == null) return null;
      var now = Date.now();
      var endMs = Number(epoch) * 1000;
      if (isNaN(endMs)) return null;
      var diff = endMs - now;
      return Math.max(0, Math.ceil(diff / (24 * 60 * 60 * 1000)));
    },
    trialDaysRemainingDisplay: function trialDaysRemainingDisplay() {
      var n = this.trialDaysRemaining;
      if (n == null) return '—';
      return String(n);
    },
    trialLengthDays: function trialLengthDays() {
      var start = this.periodStart;
      var end = this.trialPeriodEndEpoch;
      if (start != null && end != null) {
        var startNum = Number(start);
        var endNum = Number(end);
        if (!isNaN(startNum) && !isNaN(endNum) && endNum > startNum) {
          var days = Math.round((endNum - startNum) / 86400);
          if (days >= 1) return days;
        }
      }
      return 14;
    },
    trialDayOfDisplay: function trialDayOfDisplay() {
      var total = this.trialLengthDays;
      var rem = this.trialDaysRemaining;
      if (rem == null) return 'Day — of ' + total;
      var day = Math.max(1, Math.min(total, total - rem + 1));
      return 'Day ' + day + ' of ' + total;
    },
    trialProgressWidth: function trialProgressWidth() {
      var total = this.trialLengthDays;
      var rem = this.trialDaysRemaining;
      if (rem == null) return '0%';
      var day = Math.max(1, Math.min(total, total - rem + 1));
      var pct = (day - 1) / total * 100;
      return Math.max(0, Math.min(100, pct)).toFixed(1) + '%';
    }
  },
  mounted: function mounted() {
    var self = this;
    this.handlePaymentMethodReturn();
    __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPlanChangeModal').modal({ autofocus: false });
    __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsBillingEmailModal').modal({ autofocus: false });
    __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsAchDetailsModal').modal({ autofocus: false });
  },
  methods: {
    normalizeBillingScreenVariant: function normalizeBillingScreenVariant(raw) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_billingScreenVariant_js__["c" /* resolveBillingScreenVariant */])({
        hasDailyPricing: this.hasDailyPricing,
        packageDetails: this.packageDetails,
        billingUserTypeRaw: raw,
        billingSummary: this.billingSummary
      });
    },
    wirePaymentPopups: function wirePaymentPopups() {
      var self = this;
      this.$nextTick(function () {
        var addEl = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentMethodsAdd');
        var popupEl = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPayPopupAdd');
        if (!addEl.length || !popupEl.length) return;
        try {
          addEl.popup('destroy');
        } catch (e) {}
        addEl.popup({ on: 'click', popup: popupEl, position: 'bottom left' });
        var $payModal = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentElementModal');
        if ($payModal.length) {
          try {
            $payModal.modal('destroy');
          } catch (e) {}
          $payModal.modal({
            closable: true,
            onHide: function onHide() {
              self.endBillingPaymentModalFlow();
              return true;
            }
          });
        }
      });
    },
    startBillingPaymentModalFlow: function startBillingPaymentModalFlow() {
      if (this.$root) this.$root.billingPaymentModalFlowActive = true;
    },
    endBillingPaymentModalFlow: function endBillingPaymentModalFlow() {
      if (this.$root) {
        this.$root.billingPaymentModalFlowActive = false;
        this.$root.pendingOpenBillingPaymentModal = false;
      }
    },
    openPlanChangeModal: function openPlanChangeModal() {
      if (!this.canManageBilling) return;
      this.planChangeMailtoOverride = '';
      __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPlanChangeModal').modal('show');
    },
    openBillingEmailModal: function openBillingEmailModal() {
      if (!this.canManageBilling) return;
      __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsBillingEmailModal').modal('show');
    },
    openPrimaryPaymentUpdate: function openPrimaryPaymentUpdate() {
      if (!this.canManageBilling) return;
      this.startBillingPaymentModalFlow();
      if (this.paymentMethod && this.paymentMethod.method === 'ach') {
        this.viewAchDetails();
        return;
      }
      this.paymentModalTitle = this.hasPaymentDetails ? 'Update card' : 'Add card';
      this.initPaymentElement();
    },
    openStripeWidgetFromAdd: function openStripeWidgetFromAdd() {
      try {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentMethodsAdd').popup('hide');
      } catch (e) {}
      this.stripeButtonClicked = true;
      this.paymentModalTitle = 'Add payment method';
      this.initPaymentElement();
    },
    createAchFromAdd: function createAchFromAdd() {
      try {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentMethodsAdd').popup('hide');
      } catch (e) {}
      this.createAchSource();
    },
    timezoneOffsetMinutes: function timezoneOffsetMinutes() {
      return 0 - new Date().getTimezoneOffset();
    },
    scrollToPaymentMethod: function scrollToPaymentMethod() {
      this.handleBillingOpenPaymentModal();
    },
    fetchAll: function fetchAll() {
      var self = this;
      this.loading = true;
      this.loadError = null;
      this.nextBillingFromInvoices = null;
      this.$http.get('/api/identity/settings').then(function (res) {
        var body = res.body || {};
        self.isOwner = !!(body.isOwner != null ? body.isOwner : body.is_owner);
        self.tenantId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["a" /* tenantIdFromIdentityBody */])(body);
        self.hasDailyPricing = !!body.dailyPricing;
        self.periodEndEpoch = body.periodEnd;
        self.periodStart = body.periodStart;
        self.periodEnd = body.periodEnd && body.periodEnd !== 0 ? self.formatPeriodEndDate(body.periodEnd) : '—';
        self.billingUserTypeRawFromIdentity = body.subscriptionBillingUserType || body.user_type || body.billingUserType || body.billing_user_type || null;
        if (self.$root) {
          self.$root.tenantId = self.tenantId;
          self.$root.billingUserTypeRaw = self.billingUserTypeRawFromIdentity;
        }
        if (self.$root && self.$root.loadSubscriptionSummary) {
          self.$root.loadSubscriptionSummary();
        }
        self.loadBilling();
        self.loadInvoices();
        if (self.hasDailyPricing) {
          self.dailyCostBreakdown();
        }
      }, function (err) {
        self.loading = false;
        self.loadError = err.body && err.body.message || 'Failed to load';
      });
    },
    applySubscriptionSummary: function applySubscriptionSummary(body) {
      var summary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["b" /* normalizeSubscriptionSummary */])(body);
      this.subscriptionSummary = summary;
      if (this.$root) {
        this.$root.subscriptionSummary = summary;
        this.$root.$emit('subscription-summary-updated', summary);
      }
      if (!summary) return;
      if (summary.cancelAtPeriodEnd) {
        this.subscriptionCanceled = true;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["x" /* isSubscriptionStatusActive */])(summary) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["o" /* isSubscriptionStatusPastDue */])(summary)) {
        this.subscriptionCanceled = false;
      }
      var epoch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["u" /* subscriptionEndEpochFromSummary */])(summary);
      if (epoch != null) {
        this.periodEndEpoch = epoch;
        this.periodEnd = this.formatPeriodEndDate(epoch);
      }
      if (summary.paymentInfoAdded) this.hasPaymentDetails = true;
    },
    applyPaymentStatusResponse: function applyPaymentStatusResponse(body) {
      body = body || {};
      this.paymentStatusMessage = body.message;
      this.subscriptionCanceled = body.canceled;
      if (this.$root && body.paymentStatus != null) {
        this.$root.paymentStatus = body.paymentStatus;
      }
      this.packageDetails = body.packageDetails;
      if (this.$root) this.$root.billingPackageDetails = this.packageDetails;
      this.addonCount = body.addonCount;
      this.hasPaymentDetails = !!body.hasPaymentDetails;
      this.paymentMethod = body.paymentMethod;
      var bsRaw = body.billingSummary || body.billing_summary || {};
      var bs = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.billingSummary || {}, bsRaw);
      if (!bs.userType && !bs.user_type && (body.user_type || body.userType)) {
        bs.userType = body.user_type || body.userType;
      }
      if (body.trackedAsinsCount != null || body.tracked_asins_count != null) {
        bs.trackedAsinsCount = body.trackedAsinsCount != null ? body.trackedAsinsCount : body.tracked_asins_count;
      }
      this.billingSummary = bs;
    },
    finishBillingLoad: function finishBillingLoad() {
      var self = this;
      self.loading = false;
      self.$nextTick(function () {
        if (self.canManageBilling) self.wirePaymentPopups();
        if (self.billingVariant === 'daily_usage' && !self.hasDailyPricing) {
          self.dailyCostBreakdown();
        }
        self.maybePrefetchOrderVolume();
        self.maybeCompletePendingUpgrade();
        self.tryFulfillUpgradeRouteIntent();
        self.tryApplyPlanQuerySelection();
        self.maybeOpenPendingPaymentModal();
      });
    },
    maybeOpenPendingPaymentModal: function maybeOpenPendingPaymentModal() {
      if (!this.$root || !this.$root.pendingOpenBillingPaymentModal) return;
      this.handleBillingOpenPaymentModal();
    },
    handleBillingOpenPaymentModal: function handleBillingOpenPaymentModal() {
      if (!this.canManageBilling) {
        this.endBillingPaymentModalFlow();
        return;
      }
      this.startBillingPaymentModalFlow();
      var self = this;
      if (this.loading) {
        var unwatch = this.$watch('loading', function (val) {
          if (!val) {
            if (typeof unwatch === 'function') unwatch();
            self.$root.pendingOpenBillingPaymentModal = false;
            self.activeTab = 'plans';
            self.openPrimaryPaymentUpdate();
          }
        });
        return;
      }
      if (this.$root) this.$root.pendingOpenBillingPaymentModal = false;
      this.activeTab = 'plans';
      this.openPrimaryPaymentUpdate();
    },

    loadBilling: function loadBilling() {
      var self = this;
      var tzParams = { timezoneOffsetMinutes: this.timezoneOffsetMinutes() };
      var summaryPromise = this.$http.get('/api/billing/subscription/summary').catch(function () {
        return { body: null };
      });
      var paymentPromise = this.$http.get('/api/billing/payment-status', { params: tzParams }).catch(function () {
        return { body: null, _failed: true };
      });
      var dailyPromise = this.$http.get('/api/billing/daily-billing-status', { params: tzParams }).catch(function () {
        return { body: null };
      });
      var pmListPromise = this.isOwner ? this.$http.get('/api/billing/payment-methods').then(function (res) {
        return { paymentMethodsOk: true, body: res.body };
      }).catch(function () {
        return { paymentMethodsOk: false, body: null };
      }) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ paymentMethodsOk: false, body: null });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([paymentPromise, dailyPromise, pmListPromise, summaryPromise]).then(function (results) {
        var paymentResponse = results[0];
        var dailyResponse = results[1];
        var pmResponse = results[2];
        var summaryResponse = results[3];

        if (paymentResponse.body && !paymentResponse._failed) {
          self.applyPaymentStatusResponse(paymentResponse.body);
        }
        if (dailyResponse && dailyResponse.body) {
          self.billingSummary = self.mergeDailyBillingStatusSummary(self.billingSummary || {}, dailyResponse.body);
        }
        if (pmResponse && pmResponse.paymentMethodsOk) {
          self.applyPaymentMethodsResponse(pmResponse.body);
        }
        if (summaryResponse && summaryResponse.body) {
          self.applySubscriptionSummary(summaryResponse.body);
        }
        if (self.$root) {
          self.$root.billingSummary = self.billingSummary;
          if (!self.$root.billingUserTypeRaw && self.billingUserTypeRawFromIdentity) {
            self.$root.billingUserTypeRaw = self.billingUserTypeRawFromIdentity;
          }
        }

        var hasSnapshot = !!(self.packageDetails || self.subscriptionSummary || self.billingSummary && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(self.billingSummary).length > 0);
        if (paymentResponse._failed && !hasSnapshot) {
          self.loadError = 'Could not load account billing';
          self.loading = false;
          return;
        }
        self.finishBillingLoad();
      }).catch(function () {
        self.loading = false;
        self.loadError = 'Failed to load billing';
      });
    },

    mergeDailyBillingStatusSummary: function mergeDailyBillingStatusSummary(base, dailyBody) {
      if (!dailyBody || (typeof dailyBody === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(dailyBody)) !== 'object') return base;
      var overlay = dailyBody.billingSummary || dailyBody.billing_summary;
      if (overlay && (typeof overlay === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(overlay)) === 'object') {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, base, overlay);
      }
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, base, dailyBody);
    },
    extractPaymentMethodsArray: function extractPaymentMethodsArray(body) {
      if (body == null) return [];
      if (Array.isArray(body)) return body;
      if ((typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(body)) !== 'object') return [];
      var arr = body.paymentMethods || body.payment_methods || body.methods || body.items || body.data;
      return Array.isArray(arr) ? arr : [];
    },
    normalizeSavedPaymentMethodRow: function normalizeSavedPaymentMethodRow(row) {
      if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(row)) !== 'object') return null;
      var method = (row.method || row.type || '').toString().toLowerCase().replace(/-/g, '_');
      var isDefault = !!(row.isDefault || row.default || row.is_default || row.primary);
      if (method === 'card' || row.card) {
        var d = row.details || row.card || {};
        var brand = (row.brand != null ? row.brand : d.brand || d.cardBrand || 'Card').toString();
        var short = brand.length <= 4 ? brand.toUpperCase() : brand.slice(0, 4).toUpperCase();
        var last4 = (row.last4 != null ? row.last4 : d.last4 || d.lastFour || '••••').toString();
        var expM = row.exp_month != null ? row.exp_month : row.expMonth != null ? row.expMonth : d.exp_month != null ? d.exp_month : d.expMonth;
        var expY = row.exp_year != null ? row.exp_year : row.expYear != null ? row.expYear : d.exp_year != null ? d.exp_year : d.expYear;
        var prettyBrand = brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
        var metaParts = ['Brand: ' + prettyBrand, 'Last 4: ' + last4];
        var expDisp = this.formatCardExpiryDisplay(expM, expY);
        if (expDisp) metaParts.push('Expires: ' + expDisp);
        var created = d.created || row.createdAt || row.created;
        if (created) {
          var cd = typeof created === 'number' ? new Date(created * 1000) : new Date(created);
          if (!isNaN(cd.getTime())) {
            metaParts.push('Added ' + cd.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }));
          }
        }
        var label = prettyBrand + ' •••• ' + last4;
        return {
          kind: 'card',
          id: row.id || row.payment_method_id || row.paymentMethodId,
          brandShort: short,
          label: label,
          metaLine: metaParts.join(' · ') || 'Card on file',
          isDefault: isDefault
        };
      }
      if (method === 'ach' || method === 'us_bank_account' || row.us_bank_account || row.ach) {
        var bank = row.details || row.us_bank_account || row.ach || {};
        var bankName = (bank.bank_name || bank.bankName || '').toString();
        var last4b = bank.last4 || bank.lastFour || '';
        var label = bankName && last4b ? bankName + ' · •••• ' + last4b : bankName ? bankName + ' · •••• ' + (last4b || '••••') : 'Bank transfer (ACH)';
        return {
          kind: 'ach',
          id: row.id || row.payment_method_id || row.paymentMethodId,
          brandShort: 'ACH',
          label: label,
          metaLine: 'Bank account on file',
          isDefault: isDefault
        };
      }
      return null;
    },

    formatCardExpiryDisplay: function formatCardExpiryDisplay(expM, expY) {
      if (expM == null || expY == null || expM === '' || expY === '') return '';
      var m = Number(expM);
      var yNum = Number(expY);
      if (isNaN(m) || isNaN(yNum) || m < 1 || m > 12) return '';
      var padM = m < 10 ? '0' + m : String(m);
      if (yNum >= 1000) return padM + '/' + yNum;
      var yStr = String(expY);
      var fullYear = yStr.length === 2 ? 2000 + yNum : yNum;
      return padM + '/' + String(fullYear).slice(-2);
    },
    applyPaymentMethodsResponse: function applyPaymentMethodsResponse(body) {
      var raw = this.extractPaymentMethodsArray(body);
      var list = [];
      for (var i = 0; i < raw.length; i++) {
        var normalized = this.normalizeSavedPaymentMethodRow(raw[i]);
        if (normalized) list.push(normalized);
      }
      if (list.length === 0 && body && (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(body)) === 'object' && !Array.isArray(body)) {
        var single = this.normalizeSavedPaymentMethodRow(body);
        if (single) list.push(single);
      }
      this.savedPaymentMethods = list;
    },
    loadInvoices: function loadInvoices() {
      var self = this;
      this.$http.get('/api/billing/invoices', { params: { timezoneOffsetMinutes: this.timezoneOffsetMinutes() } }).then(function (response) {
        var body = response.body || {};
        self.invoices = body.invoices || [];
        var nb = body.nextBilling != null ? body.nextBilling : body.next_billing;
        self.nextBillingFromInvoices = nb != null && String(nb).trim() !== '' ? String(nb).trim() : null;
      }, function () {
        self.nextBillingFromInvoices = null;
      });
    },
    formatPeriodEndDate: function formatPeriodEndDate(timestamp) {
      var date = new Date(timestamp * 1000);
      date.setDate(date.getDate() + 1);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    formatInvoiceDate: function formatInvoiceDate(fromStr) {
      if (!fromStr) return '—';
      var d = new Date(fromStr);
      if (isNaN(d.getTime())) return fromStr;
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    invoicePaidOn: function invoicePaidOn(inv) {
      return inv.paidOn || inv.to || inv.from;
    },
    invoiceDescription: function invoiceDescription(inv, idx) {
      var d = this.formatInvoiceDate(this.invoicePaidOn(inv));
      if (this.billingVariant === 'legacy') return this.legacyPlanTitle + ' — ' + d;
      if (this.billingVariant === 'daily_usage') return this.dailyPlanTitle + ' — ' + d;
      var plan = this.isFlatYearlyPlan ? 'Flat Yearly Subscription' : this.planDisplayName(this.currentPlanKey) || (this.isProPlan ? 'Pro' : 'Starter');
      return plan + ' Plan — ' + d;
    },
    downloadAllInvoices: function downloadAllInvoices() {
      var self = this;
      this.invoices.forEach(function (inv, i) {
        if (inv.url) {
          setTimeout(function () {
            window.open(inv.url, '_blank');
          }, i * 400);
        }
      });
    },
    dailyCostBreakdown: function dailyCostBreakdown() {
      var self = this;
      this.calculatedTotalDailyCost = 0;
      this.forcastedAmount = 0;
      this.$http.get('/api/billing/daily-cost-breakdown', {
        params: { lastDays: false, from: this.periodStart, to: this.periodEndEpoch }
      }).then(function (response) {
        self.dailyCostBreakdownData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(response.body.dailyCostBreakdowns || []));
        var mainLen = self.dailyCostBreakdownData.length;
        self.showForecastedColumn = mainLen <= 30;
        var lastDay = self.dailyCostBreakdownData[mainLen - 1];
        if (lastDay && self.showForecastedColumn) {
          self.forcastedAmount = lastDay.amount / 100 * (30 - mainLen);
        }
        var loopRange = mainLen <= 30 ? 30 : mainLen;
        for (var i = 0; i < loopRange; i++) {
          if (self.dailyCostBreakdownData[i]) {
            self.calculatedTotalDailyCost += parseFloat((self.dailyCostBreakdownData[i].amount / 100).toFixed(2));
          }
        }
        if (!self.showForecastedColumn) self.forcastedAmount = 0;
      }, function () {});
    },
    planPriceLabel: function planPriceLabel(key) {
      if (key === 'pro_annual') return '$' + this.proAnnualPriceDisplay + ' / year';
      if (key === 'pro') return '$49 / mo';
      return '$' + __WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["p" /* STARTER_MONTHLY_PRICE */] + ' / mo';
    },
    planDisplayName: function planDisplayName(key) {
      return { starter: 'Starter', pro: 'Pro', pro_annual: 'Pro Annual' }[key] || '';
    },

    planCard: function planCard(key) {
      var name = this.planDisplayName(key);
      var current = this.currentPlanKey;
      var card = { ribbon: '', ribbonTone: 'orange', current: false, selected: false, recommended: false, label: '', disabled: false, primary: false, title: '' };

      if (this.isInTrialState) {
        var verb = this.isTrialBillingExpired ? 'Resume on ' : this.trialPlanChosen ? 'Switch to ' : 'Choose ';
        if (this.trialPlanChosen && key === current) {
          card.selected = true;
          card.ribbon = 'Plan after trial';
          if (this.isTrialBillingExpired) {
            card.label = 'Resume on ' + name + ' →';
            card.primary = true;
          } else {
            card.label = '✓ Plan after trial';
            card.disabled = true;
          }
        } else if (!this.trialPlanChosen && key === 'starter') {
          if (this.isTrialBillingExpired) {
            card.label = 'Resume on Starter →';
          } else {
            card.label = 'Default after trial';
            card.disabled = true;
            card.title = 'Starter starts automatically when your trial ends.';
          }
        } else {
          if (!this.trialPlanChosen && key === 'pro') {
            card.recommended = true;
            card.ribbon = '★ Recommended';
            card.primary = true;
          }
          card.label = verb + name + ' →';
        }
      } else {
        var rank = { starter: 1, pro: 2, pro_annual: 3 };
        if (key === current) {
          card.current = true;
          card.ribbon = 'Current plan';
          card.ribbonTone = 'navy';
          card.label = 'Current plan';
          card.disabled = true;
        } else if (current && rank[key] < rank[current]) {
          card.label = 'Downgrade';
          card.disabled = true;
          card.title = 'Downgrades aren’t available in the app yet. Email support to change plans.';
        } else {
          card.primary = true;
          if (key === 'pro_annual') {
            card.label = current === 'pro' ? 'Switch to yearly billing →' : 'Upgrade to Pro Annual →';
          } else {
            card.label = 'Upgrade to ' + name + ' →';
            if (key === 'pro') card.ribbon = 'Most popular';
          }
          if (this.isPaymentPastDue) {
            card.disabled = true;
            card.title = 'Update your payment method before changing plans.';
          }
        }
      }

      if (this.upgradeInProgress || this.selectPlanInProgress) {
        card.disabled = true;
        if (this.upgradeModalPlanKey === key && !card.current) card.label = 'Switching…';
      }
      if (!this.isOwner) card.disabled = true;
      return card;
    },
    planCardClasses: function planCardClasses(key) {
      var card = this.planCard(key);
      return ['sbs-plan-card', 'sbs-plan-' + (key === 'pro_annual' ? 'annual' : key), { current: card.current, selected: card.selected, recommended: card.recommended }];
    },
    planButtonClasses: function planButtonClasses(key) {
      var card = this.planCard(key);
      return ['sbs-btn', 'sbs-btn-block', card.primary ? 'sbs-btn-upgrade' : 'sbs-btn-outline', { 'sbs-btn-muted': card.disabled && !card.primary }];
    },
    onPlanAction: function onPlanAction(key) {
      if (key === 'pro_annual' && !this.showProAnnualCard) return;
      if (this.planCard(key).disabled) return;
      this.openUpgradeModal(key);
    },
    openUpgradeModal: function openUpgradeModal(planKey) {
      this.upgradeModalPlanKey = this.planDisplayName(planKey) ? planKey : 'pro';
      if (!this.hasPaymentMethodOnFile) {
        if (this.$root) this.$root.pendingUpgradePlan = this.upgradeModalPlanKey;
        this.upgradeModalPhase = 'no_payment';
        this.upgradeModalOpen = true;
        return;
      }
      this.upgradeModalPhase = 'confirm';
      this.upgradeModalOpen = true;
    },
    clearPlanQueryParam: function clearPlanQueryParam() {
      if (!this.$route.query || !this.$route.query.plan) return;
      var q = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      delete q.plan;
      this.$router.replace({ path: this.$route.path, query: q, hash: this.$route.hash || '' });
    },
    tryApplyPlanQuerySelection: function tryApplyPlanQuerySelection() {
      if (this.loading) return;
      if (!this.canManageBilling) {
        this.clearPlanQueryParam();
        return;
      }
      var plan = this.$route.query && this.$route.query.plan;
      if (!this.planDisplayName(plan)) return;
      if (!this.isTrialBillingActive && !this.isTrialBillingExpired) {
        this.clearPlanQueryParam();
        return;
      }
      this.onPlanAction(plan);
      this.clearPlanQueryParam();
    },
    closeUpgradeModal: function closeUpgradeModal() {
      if (this.upgradeInProgress) return;
      this.upgradeModalOpen = false;
    },
    onUpgradeModalAddPayment: function onUpgradeModalAddPayment() {
      if (this.$root) this.$root.pendingUpgradePlan = this.upgradeModalPlanKey;
      this.upgradeModalOpen = false;
      var self = this;
      this.$nextTick(function () {
        self.openPrimaryPaymentUpdate();
      });
    },
    clearUpgradeQueryParam: function clearUpgradeQueryParam() {
      if (!this.$route.query || !this.$route.query.upgrade) return;
      var q = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      delete q.upgrade;
      this.$router.replace({ path: this.$route.path, query: q, hash: this.$route.hash || '' });
    },
    tryFulfillUpgradeRouteIntent: function tryFulfillUpgradeRouteIntent() {
      if (this.loading) return;
      var upgrade = this.$route.query && this.$route.query.upgrade;
      if (upgrade !== 'pro' || !this.isOwner) return;
      if (this.isProPlan) {
        if (this.$root) this.$root.pendingUpgradePlan = null;
        this.clearUpgradeQueryParam();
        return;
      }
      if (this.hasPaymentMethodOnFile) {
        this.clearUpgradeQueryParam();
        this.upgradeModalPlanKey = 'pro';
        this.upgradeModalPhase = 'confirm';
        this.upgradeModalOpen = true;
        return;
      }
      if (this.$root) this.$root.pendingUpgradePlan = 'pro';
      this.upgradeModalPlanKey = 'pro';
      this.upgradeModalPhase = 'no_payment';
      this.upgradeModalOpen = true;
    },
    maybeCompletePendingUpgrade: function maybeCompletePendingUpgrade() {
      if (!this.$root || !this.$root.pendingUpgradePlan) return;
      if (!this.isOwner) return;
      var plan = this.$root.pendingUpgradePlan;
      if (plan === this.currentPlanKey && plan !== 'starter') {
        this.$root.pendingUpgradePlan = null;
        this.clearUpgradeQueryParam();
        return;
      }
      if (plan === 'starter' && this.currentPlanKey === 'starter' && this.subscriptionSummary && this.subscriptionSummary.status === 'active') {
        this.$root.pendingUpgradePlan = null;
        this.clearPlanQueryParam();
        return;
      }
      if (!this.hasPaymentMethodOnFile) return;
      this.$root.pendingUpgradePlan = null;
      this.clearUpgradeQueryParam();
      this.clearPlanQueryParam();
      this.upgradeModalOpen = false;
      this.upgradeModalPlanKey = plan;
      this.confirmUpgradeToPlan(plan);
    },
    confirmUpgradeModal: function confirmUpgradeModal() {
      this.confirmUpgradeToPlan(this.upgradeModalPlanKey);
    },
    confirmUpgradeToPlan: function confirmUpgradeToPlan(planKey) {
      var self = this;
      planKey = this.planDisplayName(planKey) ? planKey : 'pro';
      var wasInTrial = this.isTrialBillingActive;
      if (!this.hasPaymentMethodOnFile) {
        this.upgradeModalPlanKey = planKey;
        this.upgradeModalPhase = 'no_payment';
        this.upgradeModalOpen = true;
        if (this.$root) this.$root.pendingUpgradePlan = planKey;
        return;
      }
      this.upgradeInProgress = true;
      this.selectPlanInProgress = true;
      this.error = '';
      this.$http.put('/api/billing/subscription/upgrade', { plan: planKey }).then(function () {
        if (self.$root) {
          self.$root.pendingUpgradePlan = null;
        }
        self.upgradeModalOpen = false;
        self.clearUpgradeQueryParam();
        self.clearPlanQueryParam();
        var name = self.planDisplayName(planKey);
        self.message = wasInTrial ? name + ' will start when your trial ends.' : "You're now on the " + name + ' plan.';
        if (self.$root && self.$root.loadSubscriptionSummary) self.$root.loadSubscriptionSummary(true);
        return self.loadBilling();
      }, function (res) {
        var body = res && res.body;
        self.error = body && body.message || 'Could not change your plan. Please try again or contact support.';
      }).then(function () {
        setTimeout(function () {
          self.message = '';
        }, 5000);
        self.upgradeInProgress = false;
        self.selectPlanInProgress = false;
      });
    },
    unmountPaymentElement: function unmountPaymentElement() {
      this.endBillingPaymentModalFlow();
      if (this.paymentElement) {
        try {
          this.paymentElement.unmount();
        } catch (e) {}
        this.paymentElement = null;
      }
    },
    initPaymentElement: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, loadStripe, publishableKey, setupIntentResponse, clientSecret, elements;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (this.stripeInstance && !this.paymentElement) {
                  this.stripeInstance = null;
                }

                if (!(this.stripeInstance && this.paymentElement)) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentElementModal').modal('show');
                return _context.abrupt('return');

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 313));

              case 8:
                loadStripe = _context.sent.loadStripe;
                publishableKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_stripePublishableKey_js__["a" /* stripePublishableKey */])();
                _context.next = 12;
                return loadStripe(publishableKey);

              case 12:
                this.stripeInstance = _context.sent;

                this.updatePaymentInProgress = true;
                _context.next = 16;
                return this.$http.post('/api/billing/setup-intent/create');

              case 16:
                setupIntentResponse = _context.sent;
                clientSecret = setupIntentResponse.body.clientSecret;
                elements = this.stripeInstance.elements({ clientSecret: clientSecret, appearance: { theme: 'stripe' } });

                this.elementsGroup = elements;
                this.paymentElement = elements.create('payment');
                this.paymentElement.mount('#sbs-payment-element');
                this.setupIntentClientSecret = clientSecret;
                this.updatePaymentInProgress = false;
                __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentElementModal').modal('show');
                _context.next = 34;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](5);

                console.error(_context.t0);
                this.error = 'Failed to load payment form. Please try again.';
                this.updatePaymentInProgress = false;
                this.stripeButtonClicked = false;
                this.endBillingPaymentModalFlow();

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 27]]);
      }));

      function initPaymentElement() {
        return _ref.apply(this, arguments);
      }

      return initPaymentElement;
    }(),
    confirmPaymentMethod: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var self, returnUrl, result, pmId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;

                if (!(!this.stripeInstance || !this.setupIntentClientSecret)) {
                  _context2.next = 4;
                  break;
                }

                this.error = 'Payment form not initialized';
                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;

                this.updatePaymentInProgress = true;
                returnUrl = window.location.origin + '/settings/billing?payment_method_set=success';

                if (this.$root && this.$root.pendingUpgradePlan === 'pro') {
                  returnUrl += '&upgrade=pro';
                } else if (this.$root && this.$root.pendingUpgradePlan === 'starter') {
                  returnUrl += '&plan=starter';
                }
                _context2.next = 10;
                return this.stripeInstance.confirmSetup({
                  elements: this.elementsGroup,
                  confirmParams: { return_url: returnUrl },
                  redirect: 'if_required'
                });

              case 10:
                result = _context2.sent;

                if (!result.error) {
                  _context2.next = 15;
                  break;
                }

                this.error = result.error.message;
                this.updatePaymentInProgress = false;
                return _context2.abrupt('return');

              case 15:
                pmId = result.setupIntent && result.setupIntent.payment_method;

                if (!pmId) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 17;
                _context2.next = 20;
                return this.$http.put('/api/billing/payment-methods/default', { paymentMethodId: pmId });

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](17);

                console.warn('Could not set new card as default:', _context2.t0);

              case 25:
                this.updatePaymentInProgress = false;
                this.message = 'Payment method has been updated';
                __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentElementModal').modal('hide');
                this.endBillingPaymentModalFlow();
                this.loadBilling();
                setTimeout(function () {
                  self.message = '';
                }, 4000);
                if (this.paymentElement) {
                  this.paymentElement.unmount();
                  this.paymentElement = null;
                }
                this.elementsGroup = null;
                this.setupIntentClientSecret = null;
                this.stripeInstance = null;
                this.stripeButtonClicked = false;
                this.paymentModalTitle = 'Update payment method';
                _context2.next = 43;
                break;

              case 39:
                _context2.prev = 39;
                _context2.t1 = _context2['catch'](4);

                this.error = _context2.t1.message || 'Failed to update payment method';
                this.updatePaymentInProgress = false;

              case 43:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 39], [17, 22]]);
      }));

      function confirmPaymentMethod() {
        return _ref2.apply(this, arguments);
      }

      return confirmPaymentMethod;
    }(),
    handlePaymentMethodReturn: function handlePaymentMethodReturn() {
      if (!this.canManageBilling) return;
      var self = this;
      var params = new URLSearchParams(window.location.search);
      if (params.get('payment_method_set') === 'success') {
        if (this.$root) {
          if (params.get('upgrade') === 'pro') {
            this.$root.pendingUpgradePlan = 'pro';
          } else if (params.get('plan') === 'starter') {
            this.$root.pendingUpgradePlan = 'starter';
          }
        }
        var returnedPmId = params.get('setup_intent_payment_method') || '';
        if (returnedPmId) {
          this.$http.put('/api/billing/payment-methods/default', { paymentMethodId: returnedPmId }).catch(function () {});
        }
        this.message = 'Payment method has been updated';
        this.loadBilling();
        setTimeout(function () {
          self.message = '';
        }, 4000);
        window.history.replaceState({}, document.title, '/settings/billing');
      }
    },
    removePaymentMethod: function removePaymentMethod(pm) {
      if (!pm || !pm.id || this.detachInProgress) return;
      if (!window.confirm('Remove this payment method from your account?')) return;
      var self = this;
      this.detachInProgress = true;
      this.error = '';
      this.$http.delete('/api/billing/payment-methods/' + encodeURIComponent(pm.id)).then(function () {
        self.message = 'Payment method removed';
        self.loadBilling();
        setTimeout(function () {
          self.message = '';
        }, 4000);
        self.detachInProgress = false;
      }, function (res) {
        var body = res && res.body;
        self.error = body && body.message || 'Could not remove payment method.';
        self.detachInProgress = false;
      });
    },
    setPaymentMethodAsDefault: function setPaymentMethodAsDefault(pmId) {
      var self = this;
      if (this.detachInProgress) return;
      this.setDefaultInProgress = true;
      this.error = '';
      this.$http.put('/api/billing/payment-methods/default', { paymentMethodId: pmId }).then(function () {
        self.message = 'Default payment method updated';
        self.loadBilling();
        setTimeout(function () {
          self.message = '';
        }, 4000);
        self.setDefaultInProgress = false;
      }, function (res) {
        var body = res && res.body;
        self.error = body && body.message || 'Failed to set default payment method.';
        self.setDefaultInProgress = false;
      });
    },
    createAchSource: function createAchSource() {
      var self = this;
      this.updatePaymentInProgress = true;
      this.$http.put('/api/billing/ach-source').then(function () {
        self.updatePaymentInProgress = false;
        self.message = 'Payment method has been updated';
        self.loadBilling();
        setTimeout(function () {
          self.message = '';
        }, 4000);
      }, function (response) {
        self.updatePaymentInProgress = false;
        self.error = response.body.message;
        self.loadBilling();
      });
    },
    viewAchDetails: function viewAchDetails() {
      try {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsPaymentMethodsAdd').popup('hide');
      } catch (e) {}
      __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#sbsAchDetailsModal').modal('show');
    },
    resetCancellationSurveyFields: function resetCancellationSurveyFields() {
      this.cancelSurveyReason = '';
      this.cancelSurveyAlertTags = [];
      this.cancelSurveyCompetitor = '';
      this.cancelStayAnswer = '';
      this.cancelDetailText = '';
      this.cancelFlowError = '';
    },
    cancelProgressSegClass: function cancelProgressSegClass(n) {
      if (n < this.cancelModalStep) return 'sbs-cancel-progress-seg--done';
      if (n === this.cancelModalStep) return 'sbs-cancel-progress-seg--current';
      return '';
    },
    onCancelFooterKeep: function onCancelFooterKeep() {
      if (this.cancelModalStep === 1 && this.cancelPreview && this.cancelPreview.alreadyScheduledForCancel) {
        this.resumeSubscription({ closeCancelModal: true });
        return;
      }
      this.closeCancelWizardIfIdle();
    },
    resumeSubscription: function resumeSubscription(opts) {
      var self = this;
      var options = opts || {};
      if (this.resumeInProgress) return;
      this.resumeInProgress = true;
      this.error = '';
      var request = this.$root.resumeSubscription ? this.$root.resumeSubscription() : this.$http.put(__WEBPACK_IMPORTED_MODULE_12__utils_subscriptionBilling_js__["c" /* SUBSCRIPTION_RESUME_URL */]).then(function () {
        if (self.$root.loadSubscriptionSummary) {
          return self.$root.loadSubscriptionSummary();
        }
      });
      request.then(function () {
        self.resumeInProgress = false;
        self.subscriptionCanceled = false;
        if (options.closeCancelModal) {
          self.cancelModalVisible = false;
          self.cancelModalStep = 1;
        }
        self.message = 'Your subscription is active again.';
        setTimeout(function () {
          self.message = '';
        }, 6000);
        return self.loadBilling();
      }, function (err) {
        self.resumeInProgress = false;
        self.error = err.body && err.body.message || 'Could not resume subscription. Please try again.';
      });
    },
    onCancelFooterContinue: function onCancelFooterContinue() {
      if (this.cancelFooterContinueDisabled) return;
      if (this.cancelModalStep === 1) {
        this.goCancelStep(2);
        return;
      }
      if (this.cancelModalStep === 2) {
        this.onCancelSaveOfferNo();
        return;
      }
      if (this.cancelModalStep === 3) {
        this.goCancelStep(4);
        return;
      }
      if (this.cancelModalStep === 4) {
        this.submitCancellationFlow();
      }
    },
    fetchCancelSubscriptionPreview: function fetchCancelSubscriptionPreview() {
      var self = this;
      this.cancelPreviewLoading = true;
      this.cancelPreviewError = '';
      this.$http.get('/api/billing/subscription/cancel/preview', {
        params: { timezoneOffsetMinutes: self.timezoneOffsetMinutes() }
      }).then(function (res) {
        self.cancelPreview = res.body || res.data || null;
        self.cancelPreviewLoading = false;
      }, function (res) {
        var msg = res && res.body && res.body.message;
        self.cancelPreviewError = msg || 'Unable to load cancellation details.';
        self.cancelPreviewLoading = false;
      });
    },
    openCancelWizard: function openCancelWizard() {
      if (!this.isOwner) return;
      this.planChangeMailtoOverride = '';
      this.resetCancellationSurveyFields();
      this.cancelSaveOfferReached = false;
      this.cancelSaveOutcome = null;
      this.cancelModalStep = 1;
      this.cancelModalVisible = true;
      this.fetchCancelSubscriptionPreview();
    },
    closeCancelWizardIfIdle: function closeCancelWizardIfIdle() {
      if (this.cancelFlowSubmitting) return;
      this.cancelModalVisible = false;
      this.cancelModalStep = 1;
    },
    goCancelStep: function goCancelStep(step) {
      if (this.cancelFlowSubmitting) return;
      if (step === 4 && !this.cancelSurveyReason) return;
      if (step === 2) {
        this.cancelSaveOfferReached = true;
      }
      this.cancelModalStep = step;
    },
    onCancelSaveOfferNo: function onCancelSaveOfferNo() {
      if (this.cancelFlowSubmitting) return;
      this.cancelSaveOutcome = false;
      this.cancelModalStep = 3;
    },
    onCancelSaveOfferYes: function onCancelSaveOfferYes() {
      var self = this;
      if (this.cancelFlowSubmitting) return;
      this.cancelSaveOutcome = true;
      this.cancelFlowSubmitting = true;
      this.cancelFlowError = '';
      this.$http.post('/api/billing/subscription/cancel/save-offer', { accepted: true }).then(function () {
        self.cancelFlowSubmitting = false;
        self.cancelModalVisible = false;
        self.cancelModalStep = 1;
        self.message = 'Thanks — we received your request. Our team will reach out about a custom plan shortly.';
        setTimeout(function () {
          self.message = '';
        }, 8000);
      }, function (res) {
        var msg = res && res.body && res.body.message;
        self.cancelFlowError = msg || 'Could not send your request. Please try again or email support@sentrykit.com.';
        self.cancelFlowSubmitting = false;
      });
    },
    submitCancellationFlow: function submitCancellationFlow() {
      var self = this;
      if (!this.cancelSurveyReason || this.cancelFlowSubmitting) return;
      var stayPayload = null;
      if (this.cancelStayAnswer === 'yes') {
        stayPayload = true;
      } else if (this.cancelStayAnswer === 'no') {
        stayPayload = false;
      }

      var body = {
        cancellationReason: this.cancelSurveyReason,
        detailText: this.cancelDetailText,
        competitor: this.cancelSurveyReason === 'found_alternative' ? this.cancelSurveyCompetitor : '',
        alertTypes: this.cancelSurveyReason === 'too_many_alerts' ? [].concat(this.cancelSurveyAlertTags || []) : [],
        stayResponse: stayPayload,
        cancelSaveOfferShown: !!this.cancelSaveOfferReached,
        saveOfferAccepted: this.cancelSaveOfferReached ? this.cancelSaveOutcome : null
      };

      this.cancelFlowSubmitting = true;
      this.cancelFlowError = '';
      this.$http.post('/api/billing/subscription/cancel/complete', body).then(function () {
        self.cancelFlowSubmitting = false;
        self.cancelModalVisible = false;
        self.message = 'Cancellation processed. Watch your inbox for a confirmation email.';
        setTimeout(function () {
          self.message = '';
        }, 6000);
        self.fetchAll();
      }, function (res) {
        var msg = res && res.body && res.body.message;
        self.cancelFlowError = msg || 'Stripe could not complete cancellation — please retry.';
        self.cancelFlowSubmitting = false;
      });
    },
    maybePrefetchOrderVolume: function maybePrefetchOrderVolume() {
      if (!__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["d" /* ORDER_VOLUME_UI_ENABLED */]) return;
      if (this.orderVolumeChecked || this.orderVolumeLoading) return;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["e" /* shouldShowOrderVolumeUi */])(this.packageDetails, this.orderVolumeData, {
        billingVariant: this.billingVariant,
        subscriptionSummary: this.subscriptionSummary,
        hasDailyPricing: this.hasDailyPricing,
        billingUserTypeRaw: this.billingUserTypeRawFromIdentity,
        billingSummary: this.billingSummary
      })) {
        return;
      }
      this.loadUsageTabData({ silent: true });
    },
    loadUsageTabData: function loadUsageTabData(opts) {
      if (!__WEBPACK_IMPORTED_MODULE_9__utils_orderVolumeBilling_js__["d" /* ORDER_VOLUME_UI_ENABLED */]) return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
      var self = this;
      var silent = opts && opts.silent;
      this.periodChangesLoading = true;
      if (!silent) {
        this.periodChangesError = null;
      }
      var periodReq = this.$http.get('/api/v1/watchdogs/summary/period_changes', { params: { time_range: 'all_time' } });
      periodReq.then(function (res) {
        self.periodChangesData = res.body || {};
        self.periodChangesLoading = false;
        self.periodChangesFetched = true;
        self.orderVolumeChecked = true;
        if (!self.showUsageTab && self.activeTab === 'usage') {
          self.activeTab = 'plans';
        }
        self.applyBillingTabFromRoute();
      }, function (err) {
        self.periodChangesError = err.body && err.body.message || 'Failed to load monitoring summary';
        self.periodChangesData = null;
        self.periodChangesLoading = false;
        self.periodChangesFetched = true;
        self.orderVolumeChecked = true;
        if (!self.showUsageTab && self.activeTab === 'usage') {
          self.activeTab = 'plans';
        }
        self.applyBillingTabFromRoute();
      });
      return periodReq;
    },
    loadOrderVolume: function loadOrderVolume(opts) {
      return this.loadUsageTabData(opts);
    },
    formatUsageCount: function formatUsageCount(n) {
      if (n == null || n === '' || isNaN(Number(n))) return '—';
      return Number(n).toLocaleString('en-US');
    },
    formatUsageShortDate: function formatUsageShortDate(isoDate) {
      if (!isoDate) return '—';
      var d = new Date(String(isoDate).indexOf('T') >= 0 ? isoDate : isoDate + 'T12:00:00');
      if (isNaN(d.getTime())) return isoDate;
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    },
    applyBillingTabFromRoute: function applyBillingTabFromRoute() {
      var tab = this.$route && this.$route.query && this.$route.query.tab;
      if (tab === 'usage') {
        if (this.showUsageTab) {
          this.activeTab = 'usage';
        } else if (this.orderVolumeChecked) {
          this.activeTab = 'plans';
        }
        return;
      }
      if (tab === 'history' || tab === 'plans') {
        this.activeTab = tab;
      }
    },
    formatUsageDateRange: function formatUsageDateRange(start, end) {
      if (!start || !end) return '—';
      var s = new Date(String(start).indexOf('T') >= 0 ? start : start + 'T12:00:00');
      var e = new Date(String(end).indexOf('T') >= 0 ? end : end + 'T12:00:00');
      if (isNaN(s.getTime()) || isNaN(e.getTime())) return start + ' – ' + end;
      var sOpts = { month: 'short', day: 'numeric' };
      var eOpts = { month: 'short', day: 'numeric', year: 'numeric' };
      if (s.getFullYear() === e.getFullYear()) {
        return s.toLocaleDateString('en-US', sOpts) + ' – ' + e.toLocaleDateString('en-US', eOpts);
      }
      return s.toLocaleDateString('en-US', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, sOpts, { year: 'numeric' })) + ' – ' + e.toLocaleDateString('en-US', eOpts);
    }
  },
  created: function created() {
    var self = this;
    this.applyBillingTabFromRoute();
    this.fetchAll();
    if (this.$root) {
      this._onSubscriptionResumed = function () {
        self.loadBilling();
      };
      this._onBillingOpenPaymentModal = function () {
        self.handleBillingOpenPaymentModal();
      };
      this.$root.$on('subscription-resumed', this._onSubscriptionResumed);
      this.$root.$on('billing-open-payment-modal', this._onBillingOpenPaymentModal);
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$watch$comp, 'mounted', function mounted() {
  var self = this;
  if (!this.$root) return;
  this.$root.openBillingPaymentModal = function () {
    self.handleBillingOpenPaymentModal();
  };
  if (this.$root.pendingOpenBillingPaymentModal) {
    this.$nextTick(function () {
      self.maybeOpenPendingPaymentModal();
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$watch$comp, 'beforeDestroy', function beforeDestroy() {
  this.endBillingPaymentModalFlow();
  if (this.$root) {
    if (this._onSubscriptionResumed) {
      this.$root.$off('subscription-resumed', this._onSubscriptionResumed);
    }
    if (this._onBillingOpenPaymentModal) {
      this.$root.$off('billing-open-payment-modal', this._onBillingOpenPaymentModal);
    }
    if (this.$root.openBillingPaymentModal) {
      this.$root.openBillingPaymentModal = null;
    }
  }
}), _name$data$watch$comp);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WebhooksSettings',

  data: function data() {
    return {
      loading: false,
      loadError: null,
      webhooks: [],
      alertTypes: [],

      showForm: false,
      formUrl: '',
      formAllTypes: true,
      formSelectedTypes: [],
      submitting: false,
      formError: null,

      togglingIds: [],
      expandedId: null,

      deliveries: {},
      deliveriesLoading: {},

      testResults: {},
      testPending: {},

      rotatePending: {},

      secretModal: { show: false, secret: '', isRotation: false },
      copied: null,

      deleteConfirmId: null,
      deleting: false
    };
  },

  mounted: function mounted() {
    this.fetchAll();
  },

  methods: {
    fetchAll: function fetchAll() {
      this.loading = true;
      this.loadError = null;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$http.get('/api/v1/webhooks'), this.$http.get('/api/v1/webhooks/alert_types')]).then(function (results) {
        self.loading = false;
        self.webhooks = (results[0].body || {}).webhooks || [];
        self.alertTypes = (results[1].body || {}).alert_types || [];
      }).catch(function (err) {
        self.loading = false;
        var body = err && err.body || {};
        var msg = body.message;
        self.loadError = Array.isArray(msg) ? msg.join(', ') : msg || 'Failed to load webhooks';
      });
    },

    openForm: function openForm() {
      this.showForm = true;
      this.formUrl = '';
      this.formAllTypes = true;
      this.formSelectedTypes = [];
      this.formError = null;
    },

    closeForm: function closeForm() {
      this.showForm = false;
      this.formError = null;
    },

    createWebhook: function createWebhook() {
      this.formError = null;
      if (!this.formUrl) {
        this.formError = 'Endpoint URL is required.';
        return;
      }
      if (!this.formUrl.startsWith('https://')) {
        this.formError = 'URL must start with https://';
        return;
      }
      if (!this.formAllTypes && this.formSelectedTypes.length === 0) {
        this.formError = 'Select at least one alert type, or enable "All alert types".';
        return;
      }
      this.submitting = true;
      var self = this;
      var payload = {
        webhook: {
          url: this.formUrl,
          subscribed_alert_types: this.formAllTypes ? [] : this.formSelectedTypes,
          seller_account_ids: []
        }
      };
      this.$http.post('/api/v1/webhooks', payload).then(function (res) {
        self.submitting = false;
        var wh = (res.body || {}).webhook || {};
        self.webhooks.unshift(wh);
        self.closeForm();
        self.secretModal = { show: true, secret: wh.signing_secret || '', isRotation: false };
      }).catch(function (err) {
        self.submitting = false;
        var body = err && err.body || {};
        var msg = body.message;
        self.formError = Array.isArray(msg) ? msg.join(', ') : msg || 'Failed to create webhook';
      });
    },

    toggleEnabled: function toggleEnabled(wh) {
      var id = wh.id;
      if (this.togglingIds.indexOf(id) > -1) return;
      this.togglingIds.push(id);
      var self = this;
      this.$http.patch('/api/v1/webhooks/' + id, { webhook: { enabled: !wh.enabled } }).then(function (res) {
        self.togglingIds = self.togglingIds.filter(function (x) {
          return x !== id;
        });
        var updated = (res.body || {}).webhook;
        if (updated) {
          var idx = self.webhooks.findIndex(function (w) {
            return w.id === id;
          });
          if (idx > -1) self.$set(self.webhooks, idx, updated);
        }
      }).catch(function () {
        self.togglingIds = self.togglingIds.filter(function (x) {
          return x !== id;
        });
      });
    },

    reenableWebhook: function reenableWebhook(wh) {
      this.toggleEnabled({ id: wh.id, enabled: false });
    },

    confirmDelete: function confirmDelete(id) {
      this.deleteConfirmId = id;
    },

    deleteWebhook: function deleteWebhook(id) {
      this.deleting = true;
      var self = this;
      this.$http.delete('/api/v1/webhooks/' + id).then(function () {
        self.deleting = false;
        self.deleteConfirmId = null;
        self.webhooks = self.webhooks.filter(function (w) {
          return w.id !== id;
        });
        if (self.expandedId === id) self.expandedId = null;
      }).catch(function (err) {
        self.deleting = false;
        var body = err && err.body || {};
        var msg = body.message;
        self.formError = Array.isArray(msg) ? msg.join(', ') : msg || 'Failed to delete webhook';
      });
    },

    toggleExpand: function toggleExpand(id) {
      if (this.expandedId === id) {
        this.expandedId = null;
        return;
      }
      this.expandedId = id;
      if (!this.deliveries[id]) {
        this.loadDeliveries(id);
      }
    },

    loadDeliveries: function loadDeliveries(id) {
      this.$set(this.deliveriesLoading, id, true);
      var self = this;
      this.$http.get('/api/v1/webhooks/' + id + '/deliveries').then(function (res) {
        self.$set(self.deliveriesLoading, id, false);
        self.$set(self.deliveries, id, (res.body || {}).deliveries || []);
      }).catch(function () {
        self.$set(self.deliveriesLoading, id, false);
        self.$set(self.deliveries, id, []);
      });
    },

    sendTest: function sendTest(id) {
      this.$set(this.testPending, id, true);
      this.$set(this.testResults, id, null);
      var self = this;
      this.$http.post('/api/v1/webhooks/' + id + '/test').then(function (res) {
        self.$set(self.testPending, id, false);
        var b = res.body || {};
        var label = b.delivered ? 'Delivered (' + b.status + ', ' + b.latency_ms + 'ms)' : 'Failed — ' + (b.error || 'HTTP ' + b.status);
        self.$set(self.testResults, id, { ok: !!b.delivered, label: label });
      }).catch(function (err) {
        self.$set(self.testPending, id, false);
        var body = err && err.body || {};
        var msg = body.message;
        self.$set(self.testResults, id, { ok: false, label: Array.isArray(msg) ? msg.join(', ') : msg || 'Request failed' });
      });
    },

    rotateSecret: function rotateSecret(id) {
      if (!confirm('Rotate signing secret? Your old secret stays valid for 24 hours.')) return;
      this.$set(this.rotatePending, id, true);
      var self = this;
      this.$http.post('/api/v1/webhooks/' + id + '/rotate_secret').then(function (res) {
        self.$set(self.rotatePending, id, false);
        var wh = (res.body || {}).webhook || {};
        self.secretModal = { show: true, secret: wh.signing_secret || '', isRotation: true };
      }).catch(function (err) {
        self.$set(self.rotatePending, id, false);
        var body = err && err.body || {};
        alert(Array.isArray(body.message) ? body.message.join(', ') : body.message || 'Failed to rotate secret');
      });
    },

    closeSecretModal: function closeSecretModal() {
      this.secretModal = { show: false, secret: '', isRotation: false };
      this.copied = null;
    },

    copyToClipboard: function copyToClipboard(text, key) {
      var self = this;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(function () {
          self.copied = key;
          setTimeout(function () {
            if (self.copied === key) self.copied = null;
          }, 2500);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        self.copied = key;
        setTimeout(function () {
          if (self.copied === key) self.copied = null;
        }, 2500);
      }
    },

    labelFor: function labelFor(token) {
      if (!token) return '';
      var map = {
        BUY_BOX_ISSUES: 'Buy Box Issues',
        PRICE_CHANGE: 'Price Change',
        HIJACKER_ALERT: 'Hijacker Alert',
        SUSPENDED_LISTINGS: 'Suspended Listings',
        PRODUCT_DETAILS_CHANGE: 'Product Details Change',
        FBA_FBM_STOCK: 'FBA/FBM Stock',
        FBM_STOCK: 'FBM Stock',
        SALES_VOLUME: 'Sales Volume',
        FBA_FEE_CHANGE: 'FBA Fee Change'
      };
      return map[token] || token.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
    },

    truncateUrl: function truncateUrl(url) {
      if (!url) return '';
      try {
        var u = new URL(url);
        var s = u.host + u.pathname;
        return s.length > 52 ? s.slice(0, 49) + '…' : s;
      } catch (e) {
        return url.length > 52 ? url.slice(0, 49) + '…' : url;
      }
    },

    healthClass: function healthClass(wh) {
      if (!wh.enabled && wh.disabled_reason) return 'whs-health-red';
      if (wh.consecutive_failure_count > 0) return 'whs-health-amber';
      if (wh.last_success_at) return 'whs-health-green';
      return 'whs-health-grey';
    },

    healthLabel: function healthLabel(wh) {
      if (!wh.enabled && wh.disabled_reason) {
        var r = wh.disabled_reason.replace(/_/g, ' ');
        return 'Disabled (' + r + ')';
      }
      if (wh.consecutive_failure_count > 0) return 'Failing';
      if (wh.last_success_at) return 'Healthy';
      return 'No deliveries yet';
    },

    formatTime: function formatTime(iso) {
      if (!iso) return '—';
      try {
        var d = new Date(iso);
        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return iso;
      }
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_StockAlertThresholdsPanel_css__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_StockAlertThresholdsPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_StockAlertThresholdsPanel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__ = __webpack_require__(64);









function displayRowFromThresholdItem(row) {
  var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["a" /* productIdFromThresholdRow */])(row);
  if (!id) return null;
  var title = row.productTitle || row.product_title || row.productName || row.product_name || row.title || '';
  if (typeof title === 'string') title = title.trim();
  if (!title) {
    var asin = row.asin || '';
    title = asin ? 'ASIN ' + asin : 'Listing #' + id;
  }
  return {
    productId: id,
    productTitle: title,
    asin: row.asin || '',
    marketplace: row.marketplace || ''
  };
}

function bodyObjectFromResponse(rawBody) {
  var b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["b" /* parseJsonIfNeeded */])(rawBody);
  if (b == null) b = rawBody;
  if (b != null && (typeof b === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(b)) === 'object' && !Array.isArray(b)) return b;
  return {};
}

function unwrapApiNumber(v) {
  if (v === undefined || v === null || v === '') return null;
  if (typeof v === 'number' && !isNaN(v)) return v;
  if (typeof v === 'string') {
    var t = v.trim();
    if (t === '') return null;
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(v)) === 'object' && v !== null) {
    if ('value' in v) return unwrapApiNumber(v.value);
    if ('$numberDecimal' in v) return unwrapApiNumber(v.$numberDecimal);
  }
  var x = Number(v);
  return isNaN(x) ? null : x;
}

function numNonNeg(v) {
  var n = unwrapApiNumber(v);
  if (n === null) return null;
  return n >= 0 ? n : null;
}

function numPos(v) {
  var n = unwrapApiNumber(v);
  if (n === null) return null;
  return n > 0 ? n : null;
}

function pick(a, b) {
  return a !== undefined && a !== null ? a : b;
}

function emptyFbaForm() {
  return {
    amberThreshold: null,
    redThreshold: null,
    amberDays: null,
    redDays: null,
    velocityLookbackDays: null
  };
}

function formFromFbaSettings(s) {
  s = s || {};
  var f = emptyFbaForm();
  f.amberThreshold = numNonNeg(pick(s.amberThreshold, s.amber_threshold));
  f.redThreshold = numNonNeg(pick(s.redThreshold, s.red_threshold));
  f.amberDays = numNonNeg(pick(s.amberDays, s.amber_days));
  f.redDays = numNonNeg(pick(s.redDays, s.red_days));
  f.velocityLookbackDays = numPos(pick(s.velocityLookbackDays, s.velocity_lookback_days));
  return f;
}

function toPayloadVal(v) {
  var n = unwrapApiNumber(v);
  return n;
}

function fbmThresholdFromSettings(s) {
  if (!s || (typeof s === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(s)) !== 'object') return null;
  var t = pick(s.threshold, pick(s.fbm_threshold, pick(s.redThreshold, s.red_threshold)));
  var n = unwrapApiNumber(t);
  return n !== null && n >= 0 ? n : null;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StockAlertThresholdsPanel',
  props: {
    panelOpen: { type: Boolean, default: false },

    thresholdsApiBase: { type: String, default: '/api/v1/stock-alert-thresholds' },

    sellerAccountId: { type: String, default: null }
  },
  data: function data() {
    return {
      activeTab: 'fba',
      fbaForms: {},
      fbmForms: {},

      fbaSettingsByProductId: {},
      fbmSettingsByProductId: {},
      rowDirtyFba: {},
      rowDirtyFbm: {},
      dirty: false,
      saving: false,
      saveError: null,
      csvMessage: '',
      csvMessageIsError: false,
      _csvToastTimer: null,
      thresholdsLoading: false,
      thresholdsLoadError: null,
      _fetchSeq: 0,
      csvDownloading: false,

      thresholdsDataRevision: 0,

      fbaListRows: [],
      fbmListRows: [],

      fbaListTotal: null,
      fbmListTotal: null
    };
  },
  computed: {
    fbaRows: function fbaRows() {
      return this.fbaListRows;
    },
    fbmRows: function fbmRows() {
      return this.fbmListRows;
    },
    fbaTotalCount: function fbaTotalCount() {
      if (this.fbaListTotal != null && !isNaN(Number(this.fbaListTotal))) return Number(this.fbaListTotal);
      return this.fbaListRows.length;
    },
    fbmTotalCount: function fbmTotalCount() {
      if (this.fbmListTotal != null && !isNaN(Number(this.fbmListTotal))) return Number(this.fbmListTotal);
      return this.fbmListRows.length;
    },
    hasDirtyThresholds: function hasDirtyThresholds() {
      if (this.activeTab === 'fba') {
        for (var id in this.rowDirtyFba) {
          if (this.rowDirtyFba[id]) return true;
        }
        return false;
      }
      for (var id2 in this.rowDirtyFbm) {
        if (this.rowDirtyFbm[id2]) return true;
      }
      return false;
    },

    hasRowsToSaveOnActiveTab: function hasRowsToSaveOnActiveTab() {
      if (this.activeTab === 'fba') return this.fbaRows.length > 0;
      return this.fbmRows.length > 0;
    }
  },
  watch: {
    panelOpen: function panelOpen(open) {
      if (!open) return;
      this.reloadThresholdsFromApi();
    },
    sellerAccountId: function sellerAccountId() {
      if (!this.panelOpen) return;
      this.ensureFormShells();

      this.reloadThresholdsFromApi();
    }
  },
  created: function created() {
    this.ensureFormShells();
  },
  mounted: function mounted() {
    this.ensureFormShells();
  },
  methods: {
    httpParams: function httpParams() {
      var p = {};
      if (this.sellerAccountId) p.seller_account_id = this.sellerAccountId;
      return p;
    },

    listGetParams: function listGetParams() {
      return {};
    },

    reloadThresholdsFromApi: function reloadThresholdsFromApi() {
      this.ensureFormShells();
      return this.loadThresholdsFromApi();
    },
    loadThresholdsFromApi: function loadThresholdsFromApi() {
      var self = this;
      this._fetchSeq += 1;
      var seq = this._fetchSeq;
      this.thresholdsLoading = true;
      this.thresholdsLoadError = null;
      var errFba = null;
      var errFbm = null;
      var finish = function finish() {
        if (seq !== self._fetchSeq) return;
        self.thresholdsLoading = false;
        if (errFba && errFbm) {
          self.thresholdsLoadError = errFba.body && errFba.body.message || errFba.statusText || 'Could not load alert thresholds';
        } else if (errFba || errFbm) {
          self.thresholdsLoadError = 'Some threshold data could not be loaded (e.g. API not available). Edits may save once the server exposes this endpoint.';
        } else {
          self.thresholdsLoadError = null;
        }
        self.syncAllForms(!!self.hasDirtyThresholds);
        if (self.activeTab === 'fbm' && self.fbmRows.length === 0 && self.fbaRows.length > 0) {
          self.activeTab = 'fba';
        }
      };

      return this.fetchThresholdsChannel('fba').catch(function (e) {
        errFba = e;
      }).then(function () {
        return self.fetchThresholdsChannel('fbm').catch(function (e) {
          errFbm = e;
        });
      }).then(function () {
        finish();
      }).catch(function () {
        if (seq !== self._fetchSeq) return;
        self.thresholdsLoading = false;
        self.thresholdsLoadError = 'Could not load alert thresholds';
      }).then(function () {
        self.$emit('thresholds-load-complete');
      });
    },

    applyThresholdsListPayload: function applyThresholdsListPayload(channel, res) {
      var entity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["c" /* httpResponseEntity */])(res);
      var bodyObj = bodyObjectFromResponse(entity);
      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["d" /* extractThresholdGetItems */])(entity);
      var merge = {};
      var listRows = [];
      var i;
      for (i = 0; i < items.length; i++) {
        var row = items[i];
        var pid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["a" /* productIdFromThresholdRow */])(row);
        if (!pid) continue;
        var dr = displayRowFromThresholdItem(row);
        if (dr) listRows.push(dr);
        var raw = row.settings;
        if (raw == null) raw = {};else if (typeof raw === 'string') {
          try {
            raw = JSON.parse(raw);
          } catch (e) {
            raw = {};
          }
        }
        merge[pid] = (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw !== null ? raw : {};
      }
      var total = bodyObj.total != null ? Number(bodyObj.total) : null;
      if (channel === 'fba') {
        this.fbaListRows = listRows;
        this.fbaListTotal = total;
        this.fbaSettingsByProductId = merge;
      } else {
        this.fbmListRows = listRows;
        this.fbmListTotal = total;
        this.fbmSettingsByProductId = merge;
      }

      this.syncAllForms(!!this.hasDirtyThresholds);
    },
    listGetRequestOptions: function listGetRequestOptions(channel, extraParams) {
      return {
        params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.listGetParams(), { channel: channel, _skcb: Date.now() }, extraParams || {}),
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        },
        timeout: 45000
      };
    },

    fetchThresholdsChannel: function fetchThresholdsChannel(channel) {
      var self = this;
      var base = this.thresholdsApiBase;
      var run = function run(extra) {
        return self.$http.get(base, self.listGetRequestOptions(channel, extra)).then(function (res) {
          self.applyThresholdsListPayload(channel, res);
        });
      };
      return run(null).catch(function (res) {
        if (res && res.status === 304) {
          return run({ _skretry: Date.now() });
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res);
      });
    },
    mergeSettingsIntoCache: function mergeSettingsIntoCache(channel, updates) {
      var map = channel === 'fba' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.fbaSettingsByProductId) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.fbmSettingsByProductId);
      for (var u = 0; u < updates.length; u++) {
        var up = updates[u];
        var pid = String(up.product_id);
        var prev = map[pid] || {};
        var next = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, prev);
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(up.settings || {});
        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];
          next[key] = up.settings[key];
        }
        map[pid] = next;
      }
      if (channel === 'fba') this.fbaSettingsByProductId = map;else this.fbmSettingsByProductId = map;
    },
    asinFor: function asinFor(product) {
      if (product.asin) return product.asin;
      if (product.productUrl) {
        var m = product.productUrl.match(/\/dp\/([A-Z0-9]+)/i);
        if (m) return m[1];
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(product) || '';
    },
    listingId: function listingId(product) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(product);
    },
    marketplaceLabel: function marketplaceLabel(mp) {
      if (!mp) return '';
      var m = String(mp).toUpperCase();
      var map = { US: 'US', UK: 'UK', CA: 'CA', DE: 'DE', FR: 'FR', ES: 'ES', IT: 'IT', MX: 'MX', BR: 'BR', IN: 'IN', NL: 'NL', GB: 'UK' };
      return map[m] || m;
    },
    flagClass: function flagClass(marketplace) {
      if (!marketplace) return 'us';
      var m = String(marketplace).toLowerCase();
      return (m === 'uk' ? 'gb' : m).replace('uk', 'gb');
    },

    ensureFormShells: function ensureFormShells() {
      var i;
      for (i = 0; i < this.fbaRows.length; i++) {
        var p = this.fbaRows[i];
        var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(p);
        if (!id || this.fbaForms[id]) continue;
        this.$set(this.fbaForms, id, formFromFbaSettings(this.fbaSettingsByProductId[id]));
      }
      for (i = 0; i < this.fbmRows.length; i++) {
        var q = this.fbmRows[i];
        var id2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(q);
        if (!id2 || this.fbmForms[id2]) continue;
        this.$set(this.fbmForms, id2, { threshold: fbmThresholdFromSettings(this.fbmSettingsByProductId[id2]) });
      }
    },

    syncAllForms: function syncAllForms(preserveDirty, dirtyClearScope) {
      preserveDirty = !!preserveDirty;
      dirtyClearScope = dirtyClearScope || null;
      var fba = {};
      var fbm = {};
      var i;
      var self = this;
      function keepFbaUserForm(id) {
        if (preserveDirty && self.rowDirtyFba[id] && self.fbaForms[id]) return true;

        if (!preserveDirty && dirtyClearScope === 'fbm' && self.rowDirtyFba[id] && self.fbaForms[id]) return true;
        return false;
      }
      function keepFbmUserForm(id) {
        if (preserveDirty && self.rowDirtyFbm[id] && self.fbmForms[id]) return true;

        if (!preserveDirty && dirtyClearScope === 'fba' && self.rowDirtyFbm[id] && self.fbmForms[id]) return true;
        return false;
      }
      for (i = 0; i < this.fbaRows.length; i++) {
        var p = this.fbaRows[i];
        var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(p);
        if (!id) continue;
        if (keepFbaUserForm(id)) {
          fba[id] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.fbaForms[id]);
        } else {
          fba[id] = formFromFbaSettings(this.fbaSettingsByProductId[id]);
        }
      }
      for (i = 0; i < this.fbmRows.length; i++) {
        var q = this.fbmRows[i];
        var id2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(q);
        if (!id2) continue;
        if (keepFbmUserForm(id2)) {
          fbm[id2] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.fbmForms[id2]);
        } else {
          fbm[id2] = { threshold: fbmThresholdFromSettings(this.fbmSettingsByProductId[id2]) };
        }
      }
      this.fbaForms = fba;
      this.fbmForms = fbm;
      if (!preserveDirty) {
        if (dirtyClearScope === 'fba') {
          this.rowDirtyFba = {};
        } else if (dirtyClearScope === 'fbm') {
          this.rowDirtyFbm = {};
        } else {
          this.rowDirtyFba = {};
          this.rowDirtyFbm = {};
        }
        this.saveError = null;
        var anyDirtyAfterClear = false;
        for (var k in this.rowDirtyFba) {
          if (this.rowDirtyFba[k]) {
            anyDirtyAfterClear = true;break;
          }
        }
        if (!anyDirtyAfterClear) {
          for (var k2 in this.rowDirtyFbm) {
            if (this.rowDirtyFbm[k2]) {
              anyDirtyAfterClear = true;break;
            }
          }
        }
        this.dirty = anyDirtyAfterClear;
      } else {
        var anyDirty = false;
        for (var k3 in this.rowDirtyFba) {
          if (this.rowDirtyFba[k3]) {
            anyDirty = true;break;
          }
        }
        if (!anyDirty) {
          for (var k4 in this.rowDirtyFbm) {
            if (this.rowDirtyFbm[k4]) {
              anyDirty = true;break;
            }
          }
        }
        this.dirty = anyDirty;
      }
    },
    markFbaDirty: function markFbaDirty(productId) {
      this.$set(this.rowDirtyFba, String(productId), true);
      this.dirty = true;
    },
    markFbmDirty: function markFbmDirty(productId) {
      this.$set(this.rowDirtyFbm, String(productId), true);
      this.dirty = true;
    },
    inputClassesFba: function inputClassesFba(productId, field) {
      var id = String(productId);
      var form = this.fbaForms[id];
      if (!form) return '';
      var v = form[field];
      var filled = v !== null && v !== undefined && v !== '' && !isNaN(Number(v));
      var dirty = this.rowDirtyFba[id];
      return {
        'stock-tp-input-filled': filled,
        'stock-tp-input-dirty': dirty
      };
    },
    inputClassesFbmObj: function inputClassesFbmObj(productId) {
      var id = String(productId);
      var form = this.fbmForms[id];
      if (!form) return {};
      var v = form.threshold;
      var filled = v !== null && v !== undefined && v !== '' && !isNaN(Number(v));
      var dirty = this.rowDirtyFbm[id];
      return {
        'stock-tp-input-filled': filled,
        'stock-tp-input-dirty': dirty
      };
    },
    buildFbaPayload: function buildFbaPayload(form) {
      var vel = form.velocityLookbackDays;
      var velocityLookbackDays = vel !== null && vel !== '' && !isNaN(Number(vel)) ? Number(vel) : null;
      return {
        settings: {
          amber_threshold: toPayloadVal(form.amberThreshold),
          red_threshold: toPayloadVal(form.redThreshold),
          amber_days: toPayloadVal(form.amberDays),
          red_days: toPayloadVal(form.redDays),
          velocity_lookback_days: velocityLookbackDays
        }
      };
    },

    saveAll: function saveAll() {
      var self = this;
      this.saving = true;
      this.saveError = null;
      var channel = this.activeTab === 'fba' ? 'fba' : 'fbm';
      var updates = [];
      if (this.activeTab === 'fba') {
        for (var i = 0; i < this.fbaRows.length; i++) {
          var p = this.fbaRows[i];
          var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(p);
          if (!id) continue;
          var form = this.fbaForms[id] || formFromFbaSettings(this.fbaSettingsByProductId[id]);
          updates.push({
            product_id: id,
            settings: this.buildFbaPayload(form).settings
          });
        }
      } else {
        for (var j = 0; j < this.fbmRows.length; j++) {
          var q = this.fbmRows[j];
          var id2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_stockAlertThresholdsApiParse__["e" /* listingIdFromProduct */])(q);
          if (!id2) continue;
          var fform = this.fbmForms[id2] || { threshold: fbmThresholdFromSettings(this.fbmSettingsByProductId[id2]) };
          var v = fform.threshold;
          var threshold = v !== null && v !== '' && !isNaN(Number(v)) ? Number(v) : null;
          updates.push({
            product_id: id2,
            settings: { threshold: threshold }
          });
        }
      }
      if (updates.length === 0) {
        this.saving = false;
        return;
      }
      this.$http.patch(this.thresholdsApiBase, { channel: channel, updates: updates }, { params: this.httpParams(), timeout: 60000 }).then(function (res) {
        var body = res.body || {};
        var results = body.results || [];
        var failed = body.failed != null ? Number(body.failed) : results.filter(function (x) {
          return x && x.ok === false;
        }).length;
        if (failed > 0) {
          var firstErr = results.filter(function (x) {
            return x && x.ok === false;
          })[0];
          self.saveError = firstErr && firstErr.error ? String(firstErr.error) : 'Some rows failed to save (' + failed + ')';
          self.saving = false;
          return;
        }
        self.mergeSettingsIntoCache(channel, updates);
        self.saving = false;
        self.syncAllForms(false, channel);
        self.$emit('saved');
      }, function (err) {
        self.saving = false;
        self.saveError = err.body && err.body.message || 'Failed to save thresholds';
      });
    },
    downloadCsv: function downloadCsv() {
      var self = this;
      var ch = this.activeTab === 'fba' ? 'fba' : 'fbm';
      var qs = [];
      qs.push('channel=' + encodeURIComponent(ch));
      if (this.sellerAccountId) qs.push('seller_account_id=' + encodeURIComponent(this.sellerAccountId));
      var exportUrl = this.thresholdsApiBase + '/export.csv?' + qs.join('&');
      var defaultName = 'stock-thresholds-' + ch + '-' + new Date().toISOString().slice(0, 10) + '.csv';

      this.csvDownloading = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', exportUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        self.csvDownloading = false;
        if (xhr.status === 200) {
          var blob = xhr.response;
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          var cd = xhr.getResponseHeader('Content-Disposition');
          var filename = defaultName;
          if (cd) {
            var m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (m && m[1]) filename = m[1].replace(/['"]/g, '').trim() || defaultName;
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          var reader = new FileReader();
          reader.onload = function () {
            var msg = 'Could not download CSV.';
            try {
              var j = JSON.parse(reader.result);
              if (j.message) msg = j.message;
            } catch (e) {}
            self.showCsvToast(msg, true);
          };
          reader.readAsText(xhr.response);
        }
      };
      xhr.onerror = function () {
        self.csvDownloading = false;
        self.showCsvToast('Download failed. Check your connection and try again.', true);
      };
      xhr.send();
    },
    isCsvFile: function isCsvFile(file) {
      if (!file || !file.name) return false;
      if (!/\.csv$/i.test(file.name)) return false;
      if (!file.type) return true;
      return file.type === 'text/csv' || file.type === 'application/csv' || file.type === 'text/plain' || file.type === 'application/octet-stream';
    },
    uploadCsv: function uploadCsv(e) {
      var input = e.target;
      if (!input.files || !input.files[0]) return;
      var file = input.files[0];
      if (!this.isCsvFile(file)) {
        this.showCsvToast('Please choose a CSV file (.csv).', true);
        input.value = '';
        return;
      }
      var ch = this.activeTab === 'fba' ? 'fba' : 'fbm';
      var formData = new window.FormData();
      formData.append('file', file, file.name || 'thresholds-import.csv');
      var self = this;
      var q = ['channel=' + encodeURIComponent(ch)];
      if (this.sellerAccountId) q.push('seller_account_id=' + encodeURIComponent(this.sellerAccountId));
      this.$http.post(this.thresholdsApiBase + '/import.csv?' + q.join('&'), formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        var b = res.body || {};
        var errList = b.errors || [];
        var failed = b.failed != null ? Number(b.failed) : errList.length;
        if (failed > 0) {
          self.showCsvToast('Import finished with ' + failed + ' error(s). Check your CSV and try again.', true);
        } else {
          self.showCsvToast('CSV imported. Thresholds will refresh below.', false);
        }
        self.loadThresholdsFromApi();
        self.$emit('spreadsheet-imported');
        input.value = '';
      }, function (err) {
        self.showCsvToast(err.body && err.body.message || 'Import failed. Check the file format and try again.', true);
        input.value = '';
      });
    },
    showCsvToast: function showCsvToast(msg, isError) {
      var self = this;
      if (this._csvToastTimer) clearTimeout(this._csvToastTimer);
      this.csvMessage = msg;
      this.csvMessageIsError = isError;
      this._csvToastTimer = setTimeout(function () {
        self.csvMessage = '';
      }, 5000);
    },
    requestClose: function requestClose() {
      if (this.dirty) {
        if (!window.confirm('Discard unsaved changes?')) return;
      }
      this.$emit('close');
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var SORT_COLUMNS = [{ key: 'fbaStock', label: 'FBA Stock', align: 'right' }, { key: 'fbmStock', label: 'FBM Stock', align: 'right' }, { key: 'velocity', label: 'Velocity', align: 'right' }, { key: 'daysLeft', label: 'Stock Runway', align: 'right' }, { key: 'status', label: 'Status', align: 'center' }];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StockInventoryTable',
  props: {
    products: { type: Array, default: function _default() {
        return [];
      } },
    sortKey: { type: String, default: 'fbaStock' },
    sortDir: { type: String, default: 'desc' },
    searchQuery: { type: String, default: '' },
    currentPage: { type: Number, default: 0 },
    totalPages: { type: Number, default: 0 },
    totalItems: { type: Number, default: 0 },
    paginationPages: { type: Array, default: function _default() {
        return [];
      } }
  },
  computed: {
    sortableColumns: function sortableColumns() {
      return SORT_COLUMNS;
    }
  },
  methods: {
    headClass: function headClass(col) {
      return {
        'sort-col-active': this.sortKey === col,
        'sort-col-asc': this.sortKey === col && this.sortDir === 'asc',
        'sort-col-desc': this.sortKey === col && this.sortDir === 'desc'
      };
    },
    fmtNum: function fmtNum(n) {
      if (n == null) return '0';
      var num = Number(n);
      return num >= 1000 ? num.toLocaleString() : String(num);
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StockStatCards',
  props: {
    stats: { type: Object, required: true },
    activeFilter: { type: String, default: 'all' },
    marketplaceCount: { type: Number, default: 0 }
  },
  computed: {
    cards: function cards() {
      return [{
        filter: 'all',
        color: 'blue',
        icon: 'warehouse',
        value: this.stats.totalProducts,
        label: 'Total Products',
        sublabel: 'Tracked across ' + this.marketplaceCount + ' marketplace' + (this.marketplaceCount !== 1 ? 's' : '')
      }, {
        filter: 'healthy',
        color: 'green',
        icon: 'check circle',
        value: this.stats.healthyStock,
        label: 'Healthy Stock',
        sublabel: this.stats.healthyPercentage + '% of products'
      }, {
        filter: 'low',
        color: 'amber',
        icon: 'exclamation triangle',
        value: this.stats.lowStockWarning,
        label: 'Low Stock Warning',
        sublabel: 'Reorder soon'
      }, {
        filter: 'critical',
        color: 'red',
        icon: 'times circle',
        value: this.stats.outOfStock,
        label: 'Out of Stock',
        sublabel: 'Revenue at risk'
      }];
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexPage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IndexPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnonUserPage__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnonUserPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AnonUserPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LoginPage__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HomePage__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SignupPage__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SignupPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SignupPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SettingsPage__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SettingsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SettingsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SettingsHubPage_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SettingsHubPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SettingsHubPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_ProductTrackingSettings_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_ProductTrackingSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_settings_ProductTrackingSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_AlertSettings_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_AlertSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_settings_AlertSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_AccountTeamSettings_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_AccountTeamSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_settings_AccountTeamSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_SubscriptionBillingSettings_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_SubscriptionBillingSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_settings_SubscriptionBillingSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_WebhooksSettings_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_WebhooksSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_settings_WebhooksSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_settings_ApiKeysSettings_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_settings_ApiKeysSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_settings_ApiKeysSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_settings_SellersSettings_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_settings_SellersSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_settings_SellersSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_orderVolumeBilling_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProductSettingsPage__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProductSettingsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ProductSettingsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SubscriptionConfirmPage__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SubscriptionConfirmPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__SubscriptionConfirmPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SubscriptionCancelledPage__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SubscriptionCancelledPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__SubscriptionCancelledPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ConnectSellerAccountPage__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ConnectSellerAccountPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ConnectSellerAccountPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ConnectInvitePage__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ConnectInvitePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ConnectInvitePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PasswordResetPage__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PasswordResetPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__PasswordResetPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__VerifyEmailPage__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__VerifyEmailPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__VerifyEmailPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ForgotPasswordPage__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ForgotPasswordPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ForgotPasswordPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__NewPricingRedeemedPage_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__NewPricingRedeemedPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__NewPricingRedeemedPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__BuyBoxDashboardPage_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__BuyBoxDashboardPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__BuyBoxDashboardPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AllAlertsPageWrapper_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AllAlertsPageWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__AllAlertsPageWrapper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_ProductDetailsPage_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_ProductDetailsPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_ProductDetailsPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ProductsPage_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ProductsPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ProductsPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__IssuesPage_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__IssuesPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__IssuesPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_subscriptionBilling__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_sharedApiSession__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_watchdogSummaryApi_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__StockPage_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__StockPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__StockPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__FeeClaimsPage_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__FeeClaimsPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__FeeClaimsPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__PricingCostsPage_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__PricingCostsPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__PricingCostsPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__WelcomePage_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__WelcomePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__WelcomePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_amazonSellingPartnerOAuth__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_alertEmailDeepLink_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_gtmEvents__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_calendly__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__styles_global_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__styles_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__semantic_2_3_1_semantic_min_css__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__semantic_2_3_1_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__semantic_2_3_1_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__semantic_2_3_1_semantic_min_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__semantic_2_3_1_semantic_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__semantic_2_3_1_semantic_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_vue_resource__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__directives_preventAutofill_js__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__store_index_js__ = __webpack_require__(274);
























































__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_51_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.directive('prevent-autofill', __WEBPACK_IMPORTED_MODULE_52__directives_preventAutofill_js__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var POST_LOGIN_REDIRECT_KEY = 'sk_post_login_redirect';

function capturePostLoginRedirect(path, search) {
  var p = String(path || '');
  if (!p || p === '/' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(p)) return;
  var dest = p + (search || '');
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, dest);
  } catch (e) {}
}

function stripQueryParam(name) {
  try {
    var url = new URL(window.location.href);
    if (!url.searchParams.has(name)) return;
    url.searchParams.delete(name);
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } catch (e) {}
}

function readCookie(name) {
  var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function consumePostLoginRedirect() {
  try {
    var dest = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    if (dest && dest.charAt(0) === '/') return dest;
  } catch (e) {}
  return null;
}

var INTERCOM_API_BASE = 'https://api-iam.intercom.io';

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_6__AnonUserPage___default.a,
  children: [{
    path: '/login', component: __WEBPACK_IMPORTED_MODULE_7__LoginPage___default.a
  }, {
    path: '/signup', component: __WEBPACK_IMPORTED_MODULE_9__SignupPage___default.a
  }, {
    path: '/ASGTG/signup', component: __WEBPACK_IMPORTED_MODULE_9__SignupPage___default.a
  }, {
    path: '/asgtg/signup', component: __WEBPACK_IMPORTED_MODULE_9__SignupPage___default.a
  }, {
    path: '/forgotpassword', component: __WEBPACK_IMPORTED_MODULE_27__ForgotPasswordPage___default.a
  }, {
    path: '/resetpassword', component: __WEBPACK_IMPORTED_MODULE_25__PasswordResetPage___default.a
  }, {
    path: '/verify-email', component: __WEBPACK_IMPORTED_MODULE_26__VerifyEmailPage___default.a
  }]

}, {
  path: '/connect', component: __WEBPACK_IMPORTED_MODULE_23__ConnectSellerAccountPage___default.a
}, {
  path: '/connect/invite/:token', component: __WEBPACK_IMPORTED_MODULE_24__ConnectInvitePage___default.a
}, {
  path: '/welcome', component: __WEBPACK_IMPORTED_MODULE_41__WelcomePage_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_5__IndexPage___default.a,
  children: [{
    path: '/home', component: __WEBPACK_IMPORTED_MODULE_29__BuyBoxDashboardPage_vue___default.a, name: 'Home'
  }, {
    path: '/old-dashboard', component: __WEBPACK_IMPORTED_MODULE_8__HomePage___default.a, name: 'OldDashboard'
  }, {
    path: '/products', component: __WEBPACK_IMPORTED_MODULE_32__ProductsPage_vue___default.a, name: 'Products'
  }, {
    path: '/issues', component: __WEBPACK_IMPORTED_MODULE_33__IssuesPage_vue___default.a, name: 'Issues'
  }, {
    path: '/alerts',
    redirect: function redirect(to) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_43__utils_alertEmailDeepLink_js__["a" /* issuesLocationFromAlertsEmailQuery */])(to.query);
    }
  }, {
    path: '/stock', component: __WEBPACK_IMPORTED_MODULE_38__StockPage_vue___default.a, name: 'Stock'
  }, {
    path: '/fee-claims', component: __WEBPACK_IMPORTED_MODULE_39__FeeClaimsPage_vue___default.a, name: 'FeeClaims'
  }, {
    path: '/settings',
    component: __WEBPACK_IMPORTED_MODULE_11__SettingsHubPage_vue___default.a,
    redirect: function redirect(to) {
      if (to.query && to.query.tab === 'notifications') {
        return { path: '/settings/alerts', query: {} };
      }
      return { path: '/settings/product-tracking' };
    },
    children: [{ path: 'product-tracking', name: 'SettingsProductTracking', component: __WEBPACK_IMPORTED_MODULE_12__components_settings_ProductTrackingSettings_vue___default.a }, { path: 'account', name: 'SettingsAccount', component: __WEBPACK_IMPORTED_MODULE_14__components_settings_AccountTeamSettings_vue___default.a }, { path: 'alerts', name: 'SettingsAlerts', component: __WEBPACK_IMPORTED_MODULE_13__components_settings_AlertSettings_vue___default.a }, { path: 'sellers', name: 'SettingsSellers', component: __WEBPACK_IMPORTED_MODULE_18__components_settings_SellersSettings_vue___default.a }, { path: 'billing', name: 'SettingsBilling', component: __WEBPACK_IMPORTED_MODULE_15__components_settings_SubscriptionBillingSettings_vue___default.a }, { path: 'bulk-cogs', name: 'SettingsBulkCogs', component: __WEBPACK_IMPORTED_MODULE_40__PricingCostsPage_vue___default.a }, { path: 'webhooks', name: 'SettingsWebhooks', component: __WEBPACK_IMPORTED_MODULE_16__components_settings_WebhooksSettings_vue___default.a }, { path: 'api-keys', name: 'SettingsApiKeys', component: __WEBPACK_IMPORTED_MODULE_17__components_settings_ApiKeysSettings_vue___default.a }]
  }, { path: '/productsettings', redirect: '/settings/product-tracking' }, { path: '/keywordsettings', redirect: '/settings/product-tracking' }, { path: '/subscription-and-billing', redirect: '/settings/billing' }, { path: '/pricing-costs', redirect: '/settings/bulk-cogs' }, {
    path: '/all-alerts', component: __WEBPACK_IMPORTED_MODULE_30__AllAlertsPageWrapper_vue___default.a, name: 'AllAlerts'
  }, {
    path: '/product_details', component: __WEBPACK_IMPORTED_MODULE_31__components_ProductDetailsPage_vue___default.a, name: 'ProductDetails'
  }, {
    path: '/subscription', component: __WEBPACK_IMPORTED_MODULE_21__SubscriptionConfirmPage___default.a, name: 'Subscription'
  }, {
    path: '/cancelsubscription', component: __WEBPACK_IMPORTED_MODULE_22__SubscriptionCancelledPage___default.a, name: 'SubscriptionCancelled'
  }, {
    path: '/newpricingredeemed', component: __WEBPACK_IMPORTED_MODULE_28__NewPricingRedeemedPage_vue___default.a, name: 'NewPricingRedeemed'
  }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  if (document.cookie.search('uliprecheck=1') === -1) {
    return next();
  }
  var path = to.path;
  var pipelineDoneHint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["a" /* readPipelineDoneHint */])();
  var connectDeferredHint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["b" /* readConnectDeferredHint */])();
  var allowHomeLanding = pipelineDoneHint || connectDeferredHint;
  if (path === '/' || path === '/login') {
    if (path === '/' && from.path === '/login') return next();
    if (allowHomeLanding) return next({ path: '/home', replace: true });
    return next({ path: '/welcome', replace: true });
  }
  if (path === '/home' && from.path !== '/welcome' && from.path !== '/login' && !allowHomeLanding) {
    return next({ path: '/welcome', replace: true });
  }
  next();
});

var deeplink = window.location.hash;
if (window.location.pathname === '/logout') document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

var params = new URL(document.location).searchParams;

if (document.cookie.search('uliprecheck=1') === -1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(window.location.pathname)) {
  capturePostLoginRedirect(window.location.pathname, window.location.search);
  router.push('/login');
}
if (document.cookie.search('uliprecheck=1') !== -1 && !(window.location.pathname === '/welcome' || window.location.pathname === '/connect' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["b" /* isConnectInvitePath */])(window.location.pathname) || window.location.pathname === '/old-dashboard' || window.location.pathname === '/products' || window.location.pathname === '/issues' || window.location.pathname === '/alerts' || window.location.pathname === '/stock' || window.location.pathname === '/settings' || window.location.pathname.indexOf('/settings/') === 0 || window.location.pathname === '/all-alerts' || window.location.pathname === '/product_details' || window.location.pathname === '/forgotpassword' || window.location.pathname === '/resetpassword' || window.location.pathname === '/verify-email' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["c" /* isSignupPath */])(window.location.pathname))) {
  var _skLanding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["a" /* readPipelineDoneHint */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["b" /* readConnectDeferredHint */])() ? '/home' : '/welcome';
  router.push(_skLanding);
}

new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
  store: __WEBPACK_IMPORTED_MODULE_53__store_index_js__["a" /* default */],
  router: router,
  data: function data() {
    return {
      deeplink: deeplink,
      offline: false,
      authCompleted: false,
      userEmail: null,
      userFirstName: null,
      userFullName: null,
      userId: null,

      connectWelcome: null,
      anySellerAccountSetupCompleted: false,
      secondsSinceFirstSellerAccountCreated: null,
      paymentStatus: null,
      facebookPixelInitialized: false,
      facebookPixelEventQueue: [],
      defaultPath: '/home',
      intercomAppId: null,
      amazonCallBackUri: '',
      amazonState: '',
      sellingPartnerId: '',
      hasDailyPricing: false,
      newPricingMessage: '',
      intercomMessengerBooted: false,

      pendingPostCredentialsRedirect: false,

      accountType: null,

      apiAccessToken: null,

      subscriptionSummary: null,

      billingPackageDetails: null,

      tenantId: null,

      competitivePriceAlerts: false,

      feeClaims: false,

      feeClaimsToClaimCount: null,

      billingUserTypeRaw: null,
      billingSummary: null,

      pendingUpgradePlan: null,

      emailVerified: null,

      unverifiedEmail: null,

      verificationEmailAddressId: null,
      verificationEmailSent: false,
      verificationEmailSending: false
    };
  },
  methods: {
    applyEmailVerificationStatus: function applyEmailVerificationStatus(status) {
      if (!status) return;
      this.emailVerified = !!status.emailVerified;
      this.unverifiedEmail = status.email || this.userEmail || null;
      if (status.emailAddressId != null && status.emailAddressId !== '') {
        this.verificationEmailAddressId = status.emailAddressId;
      }
      if (this.emailVerified) {
        this.verificationEmailSent = false;
        this.verificationEmailSending = false;
      }
    },
    applyIdentitySettingsBilling: function applyIdentitySettingsBilling(body) {
      if (!body || (typeof body === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(body)) !== 'object') return;
      this.hasDailyPricing = !!body.dailyPricing;
      this.competitivePriceAlerts = body.competitivePriceAlerts === true;
      this.feeClaims = body.feeClaims === true;
      this.tenantId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_orderVolumeBilling_js__["a" /* tenantIdFromIdentityBody */])(body) || this.tenantId;
      var ut = body.subscriptionBillingUserType || body.user_type || body.billingUserType || body.billing_user_type || null;
      if (ut != null) this.billingUserTypeRaw = ut;
    },

    loadIdentitySettings: function loadIdentitySettings(force) {
      var self = this;
      return this._apiSession.get('identitySettings', function () {
        return self.$http.get(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["a" /* IDENTITY_SETTINGS_URL */]).then(function (res) {
          return res.body || {};
        }, function () {
          return {};
        });
      }, force).then(function (body) {
        self.applyIdentitySettingsBilling(body);
        return body;
      });
    },

    loadFeeClaimsCount: function loadFeeClaimsCount(force) {
      var self = this;
      if (!this.feeClaims) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(null);
      return this._apiSession.get('feeClaimsCount', function () {
        return self.$http.get('/api/v1/fee-claims/count').then(function (res) {
          return res.body && res.body.toClaimCount != null ? res.body.toClaimCount : null;
        }, function () {
          return null;
        });
      }, force).then(function (count) {
        self.feeClaimsToClaimCount = count;
        return count;
      });
    },

    loadEmailAddresses: function loadEmailAddresses(force) {
      var self = this;
      return this._apiSession.get('emailAddresses', function () {
        return self.$http.get(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["b" /* EMAIL_ADDRESSES_URL */]).then(function (res) {
          return res.body || {};
        }, function () {
          return {};
        });
      }, force);
    },

    loadPaymentStatus: function loadPaymentStatus(force) {
      var self = this;
      var tz = 0 - new Date().getTimezoneOffset();
      return this._apiSession.get('paymentStatus:' + tz, function () {
        return self.$http.get('/api/billing/payment-status', {
          params: { timezoneOffsetMinutes: tz }
        }).then(function (res) {
          return res.body || {};
        }, function () {
          return {};
        });
      }, force);
    },

    loadV1Sellers: function loadV1Sellers(force) {
      var self = this;
      return this._apiSession.get('v1Sellers', function () {
        return self.$http.get('/api/v1/sellers').then(function (res) {
          return res.body || {};
        }, function () {
          return null;
        });
      }, force);
    },

    loadOnboardingStatus: function loadOnboardingStatus(force) {
      var self = this;
      return this._apiSession.get('onboardingStatus', function () {
        return self.$http.get('/api/v1/onboarding/status').then(function (res) {
          return res.body || {};
        }, function () {
          return null;
        });
      }, force);
    },

    loadEmailVerificationStatus: function loadEmailVerificationStatus(force) {
      var self = this;
      if (!this.userEmail && !this.authCompleted) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(null);
      }
      if (!force && this._emailVerificationResolved !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this._emailVerificationResolved);
      }
      if (!force && this._emailVerificationLoadPromise) return this._emailVerificationLoadPromise;
      if (force) {
        this._apiSession.clear('identitySettings');
        this._apiSession.clear('emailAddresses');
        this._emailVerificationResolved = undefined;
      }

      function fromEmailAddresses() {
        return self.loadEmailAddresses(force).then(function (body) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["c" /* verificationStatusFromEmailAddresses */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["d" /* emailAddressListFromResponseBody */])(body), self.userEmail);
        }, function () {
          return null;
        });
      }

      function fromSettings() {
        return self.loadIdentitySettings(force).then(function (body) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["e" /* verificationStatusFromIdentitySettings */])(body, self.userEmail || body.email);
        }, function () {
          return null;
        });
      }

      this._emailVerificationLoadPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([fromSettings(), fromEmailAddresses()]).then(function (results) {
        var settingsStatus = results[0];
        var emailsStatus = results[1];
        var status = null;

        if (emailsStatus && emailsStatus.emailVerified === true) status = emailsStatus;else if (settingsStatus && settingsStatus.emailVerified === true) status = settingsStatus;else if (emailsStatus) status = emailsStatus;else if (settingsStatus) status = settingsStatus;
        if (status) self.applyEmailVerificationStatus(status);
        self._emailVerificationResolved = status;
        self._emailVerificationLoadPromise = null;
        return status;
      }, function (err) {
        self._emailVerificationLoadPromise = null;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
      return this._emailVerificationLoadPromise;
    },
    loadEmailVerificationFromSettings: function loadEmailVerificationFromSettings() {
      var self = this;
      return this.loadIdentitySettings().then(function (body) {
        var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["e" /* verificationStatusFromIdentitySettings */])(body, self.userEmail || body.email);
        if (status) self.applyEmailVerificationStatus(status);
        return status;
      }, function () {
        return null;
      });
    },
    resendEmailVerification: function resendEmailVerification() {
      var self = this;
      var email = this.unverifiedEmail || this.userEmail;
      if (!email) {
        return this.loadEmailVerificationStatus().then(function () {
          if (!self.unverifiedEmail && !self.userEmail) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('Missing email for verification'));
          }
          return self.resendEmailVerification();
        });
      }
      if (this.verificationEmailSending) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      this.verificationEmailSending = true;
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["f" /* EMAIL_VERIFICATION_RESEND_URL */], { email: email }).then(function () {
        self.verificationEmailSending = false;
        self.verificationEmailSent = true;
      }, function (err) {
        self.verificationEmailSending = false;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
    },
    loadSubscriptionSummary: function loadSubscriptionSummary(force) {
      var self = this;
      if (!this.authCompleted && !this.userEmail) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(null);
      }
      return this._apiSession.get('subscriptionSummary', function () {
        return self.$http.get(__WEBPACK_IMPORTED_MODULE_34__utils_subscriptionBilling__["a" /* SUBSCRIPTION_SUMMARY_URL */]).then(function (res) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_subscriptionBilling__["b" /* normalizeSubscriptionSummary */])(res.body || {});
        }, function () {
          return null;
        });
      }, force).then(function (summary) {
        self.subscriptionSummary = summary;
        self.$emit('subscription-summary-updated', self.subscriptionSummary);
        return self.subscriptionSummary;
      });
    },

    resumeSubscription: function resumeSubscription() {
      var self = this;
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_34__utils_subscriptionBilling__["c" /* SUBSCRIPTION_RESUME_URL */]).then(function () {
        return self.loadSubscriptionSummary(true).then(function (summary) {
          self.$emit('subscription-resumed', summary);
          return summary;
        });
      });
    },

    claimSsoLogin: function claimSsoLogin() {
      var _this = this;

      var code = new URL(window.location.href).searchParams.get('sso');
      if (!code) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      stripQueryParam('sso');
      var never = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {});
      return this.$http.post('/api/auth/sso/claim', { code: code }).then(function (response) {
        var midAppstoreHandoff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["c" /* isSignupPath */])(window.location.pathname) && new URL(window.location.href).searchParams.get('amazon_callback_uri');
        if (response.body && (response.body.newAccount || midAppstoreHandoff)) {
          _this.pendingPostCredentialsRedirect = true;
          return;
        }
        window.location.assign(window.location.origin + (consumePostLoginRedirect() || '/'));
        return never;
      }, function (response) {
        var reason = response.status === 423 ? 'account_locked' : 'google_expired';
        var url = new URL(window.location.href);
        url.searchParams.set('sso_error', reason);
        window.location.replace(url.pathname + url.search);
        return never;
      });
    },

    trackSsoSignup: function trackSsoSignup() {
      var method = readCookie('sk_sso_signup');
      if (!method || !this.userEmail) return;
      document.cookie = 'sk_sso_signup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      this.connectWelcome = method;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_gtmEvents__["a" /* pushGtmEvent */])({ event: 'sign_up_account_created', step: 1, method: method });
      try {
        window.fpr('referral', { email: this.userEmail });
      } catch (e) {}
    },
    checkIfAuthenticated: function checkIfAuthenticated() {
      var _this2 = this;

      this.$http.get('/api/auth/isauthenticated').then(function (response) {
        if (!response.body || response.body.authenticated === false || !response.body.email) {
          _this2.pendingPostCredentialsRedirect = false;
          _this2.handleSignedOut(response);
          return;
        }
        var allowRedirectsFromAuthPages = _this2.pendingPostCredentialsRedirect;
        _this2.pendingPostCredentialsRedirect = false;

        _this2.userEmail = response.body.email;
        _this2.userFirstName = response.body.firstName || null;
        _this2.userFullName = response.body.fullName || null;
        _this2.userId = response.body.userId || null;
        _this2.accountType = response.body.accountType || null;
        _this2.trackSsoSignup();
        _this2.tenantId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_orderVolumeBilling_js__["a" /* tenantIdFromIdentityBody */])(response.body) || _this2.tenantId;

        var authVerify = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_35__utils_emailVerification__["g" /* verificationStatusFromAuthBody */])(response.body);
        if (authVerify && authVerify.emailVerified === true) {
          _this2.applyEmailVerificationStatus(authVerify);
        }
        setTimeout(function () {
          _this2.$http.post('/api/auth/extend').then(function (response) {}, function (response) {});
        }, 60000);
        setInterval(function () {
          _this2.$http.post('/api/auth/extend').then(function (response) {}, function (response) {});
        }, 2700000);

        _this2.anySellerAccountSetupCompleted = response.body.anySellerAccountSetupCompleted;
        _this2.paymentStatus = response.body.paymentStatus;
        _this2.secondsSinceFirstSellerAccountCreated = response.body.secondsSinceFirstSellerAccountCreated;

        if (_this2.anySellerAccountSetupCompleted && _this2.secondsSinceFirstSellerAccountCreated != null && _this2.secondsSinceFirstSellerAccountCreated < 9999) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_44__utils_gtmEvents__["b" /* maybeFireConnectStoreSuccess */])();
        }

        if (response.body.defaultPath) {
          _this2.defaultPath = response.body.defaultPath;
        } else if (_this2.secondsSinceFirstSellerAccountCreated != null && _this2.secondsSinceFirstSellerAccountCreated < 9999) {
          _this2.defaultPath = '/welcome';
        } else {
          _this2.defaultPath = '/home';
        }
        _this2.readAppstoreHandoffParams();

        var goRootAfterLogin = allowRedirectsFromAuthPages && _this2.$route.path === '/login';

        var reopenedSignup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["c" /* isSignupPath */])(_this2.$route.path) && !allowRedirectsFromAuthPages && _this2.$route.query.finish !== 'amazon' && !_this2.amazonCallBackUri && !_this2.amazonState && !_this2.sellingPartnerId;

        if (goRootAfterLogin) {
          _this2.fbPixelEventHandler('custom', 'LoggedInToApp');
          var afterLogin = consumePostLoginRedirect() || '/';
          window.location.assign(window.location.origin + afterLogin);
          return;
        } else if (reopenedSignup) {
          _this2.$router.replace(_this2.anySellerAccountSetupCompleted ? '/home' : { path: '/connect', query: { from: 'signup' } });
          _this2.fbPixelEventHandler('custom', 'LoggedInToApp');
        } else if (_this2.secondsSinceFirstSellerAccountCreated) {
          var authenticatedPages = ['/home', '/welcome', '/old-dashboard', '/products', '/issues', '/alerts', '/stock', '/settings', '/all-alerts', '/product_details'];
          var isOnAuthPage = authenticatedPages.includes(_this2.$route.path) || _this2.$route.path.indexOf('/settings/') === 0;
          if (!isOnAuthPage && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(_this2.$route.path) && _this2.$route.path !== '/connect') {
            _this2.$router.push('/welcome');
          }
          _this2.$root.$emit('fb-pixel-event', 'custom', 'LoggedInToApp');
          setTimeout(function () {
            console.log('[Main] Authentication complete, loading dashboard stats');
            _this2.loadDashboardStats();
          }, 1000);
        } else if ((_this2.paymentStatus === 1 || !_this2.anySellerAccountSetupCompleted) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["b" /* readConnectDeferredHint */])() && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(_this2.$route.path) || allowRedirectsFromAuthPages)) {
          _this2.$router.push('/connect');
          _this2.fbPixelEventHandler('custom', 'LoggedInToApp');
          setTimeout(function () {
            console.log('[Main] Authentication complete, loading dashboard stats');
            _this2.loadDashboardStats();
          }, 1000);
        } else if (_this2.amazonCallBackUri !== '') {
          var qp = _this2.$route.query;
          var region = qp.region || 'NA';
          var data = {
            path: _this2.$route.path,
            accName: '',
            expectedSellerKey: _this2.sellingPartnerId,
            amazonState: _this2.amazonState,
            amazonCallbackUrl: _this2.amazonCallBackUri,
            region: region,
            marketplace: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_42__utils_amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(region, qp.marketplace)
          };
          _this2.$http.get('/api/identity/amazon/authorization/redirect', { params: data }).then(function (response) {
            _this2.clearAmazon();
            window.location = response.body.location;
            return;
          }, function (response) {
            _this2.clearAmazon();
            _this2.clicked = null;
            _this2.$emit('error', response.body.message);
          });
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(_this2.$route.path) && _this2.$route.path !== '/connect' && _this2.$route.path !== '/home' && _this2.$route.path !== '/welcome' && _this2.$route.path !== '/settings' && _this2.$route.path.indexOf('/settings/') !== 0 && _this2.$route.path !== '/all-alerts' && _this2.$route.path !== '/product_details' && _this2.$route.path !== '/issues' && _this2.$route.path !== '/alerts') {
          _this2.$router.push('/welcome');
          _this2.fbPixelEventHandler('custom', 'LoggedInToApp');

          setTimeout(function () {
            console.log('[Main] Authentication complete, loading dashboard stats');
            _this2.loadDashboardStats();
          }, 1000);
        } else {
          _this2.fbPixelEventHandler('custom', 'LoggedInToApp');

          setTimeout(function () {
            console.log('[Main] Authentication complete, loading dashboard stats');
            _this2.loadDashboardStats();
          }, 1000);
        }

        if (!goRootAfterLogin && (_this2.$route.path === '/' || _this2.$route.path === '/welcome' || _this2.$route.path === '/home') && _this2.paymentStatus !== 1 && _this2.anySellerAccountSetupCompleted && !_this2.amazonCallBackUri) {
          _this2.loadOnboardingStatus().then(function (data) {
            if (!data) return;
            var pipelineDone = !!data.completed || !!data.sellerConnected && !!data.productsImported && !!data.buyboxFetched && !!data.ordersFetched;
            var path = _this2.$route.path;
            if (pipelineDone) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["c" /* setPipelineDoneHint */])();
              if (path === '/welcome' || path === '/') {
                _this2.$router.replace('/home');
              }
              return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["d" /* clearPipelineDoneHint */])();
            if (path === '/home' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["b" /* readConnectDeferredHint */])()) {
              _this2.$router.push('/welcome');
            }
          }, function () {});
        }

        _this2.authCompleted = true;
        _this2.intercomAppId = response.body.intercomAppId || "rl23bhij";

        var self = _this2;
        var intercomEmail = _this2.userEmail;
        var intercomHash = response.body.userHash;
        var intercomJwt = response.body.intercom_user_jwt || response.body.intercomUserJwt;
        _this2.scheduleAfterFirstPaint(function () {
          self.loadSubscriptionSummary();
          self.loadEmailVerificationStatus();
          self.getDailyBillingStatus();
          self.loadIntercom(intercomEmail, intercomHash, intercomJwt);
        });
      }, function (response) {
        _this2.handleSignedOut(response);
      });
    },

    readAppstoreHandoffParams: function readAppstoreHandoffParams() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["c" /* isSignupPath */])(this.$route.path)) return;
      var params = this.$route.query;
      this.amazonCallBackUri = params.amazon_callback_uri || '';
      this.amazonState = params.amazon_state || '';
      this.sellingPartnerId = params.selling_partner_id || '';
    },

    handleSignedOut: function handleSignedOut(response) {
      this.readAppstoreHandoffParams();

      if (response.status === 0) {
        return;
      }
      document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["e" /* clearOnboardingSessionHints */])();
      var signedOut = response.status === 401 || response.status === 403 || !!(response.body && response.body.authenticated === false);
      if (signedOut) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_47__utils_publicAuthRoutes__["a" /* isPublicAuthPath */])(this.$route.path)) {
          capturePostLoginRedirect(this.$route.fullPath);
          this.$router.push('/login');
        }
      } else {
        console.log('Unexpected error status: ' + response.status);
      }
      this.authCompleted = false;
      this.intercomAppId = response.body && response.body.intercomAppId || null;
      this.resetIntercom();
    },

    prefetchIssuesAlertCounts: function prefetchIssuesAlertCounts() {
      var self = this;
      if (!this._apiSession) this._apiSession = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_sharedApiSession__["a" /* createSharedApiSession */])();
      return this._apiSession.get('prefetchAlertCounts', function () {
        return self.$http.get('/api/v1/watchdogs/summary/alert_counts', {
          params: { time_range: 'all_time', _cb: Date.now() },
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
          }
        }).then(function (res) {
          var payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__utils_watchdogSummaryApi_js__["a" /* parseAlertCountsHttpPayload */])(res);
          self._prefetchedAlertCounts = {
            payload: payload,
            at: Date.now(),
            filterKey: 'all'
          };
          return payload;
        }, function () {
          return null;
        });
      });
    },

    scheduleAfterFirstPaint: function scheduleAfterFirstPaint(fn) {
      if (typeof fn !== 'function') return;
      var run = function run() {
        try {
          fn();
        } catch (err) {
          console.error('[scheduleAfterFirstPaint]', err);
        }
      };
      var kick = function kick() {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(run, { timeout: 2000 });
        } else {
          setTimeout(run, 50);
        }
      };
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(kick);
        });
      } else {
        setTimeout(kick, 0);
      }
    },
    getDailyBillingStatus: function getDailyBillingStatus() {
      var _this3 = this;

      this.$http.get('/api/billing/daily-billing-status').then(function (res) {
        _this3.hasDailyPricing = res.body.hasDailyPricing === true;
        _this3.newPricingMessage = res.body.message;
      }, function (res) {
        _this3.error = res.body.message;
        console.info('Error while trying to get daily billing status');
      });
    },
    clearAmazon: function clearAmazon() {
      this.sellingPartnerId = '';
      this.amazonCallBackUri = '';
      this.amazonState = '';
    },

    signOutUser: function signOutUser(redirectPath) {
      var dest = typeof redirectPath === 'string' && redirectPath.charAt(0) === '/' ? redirectPath : '/login';
      this.$http.get('/api/auth/signout').then(function () {});
      document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46__utils_onboardingSessionHints_js__["e" /* clearOnboardingSessionHints */])();
      try {
        sessionStorage.removeItem('worldStore');
      } catch (e) {}
      this.authCompleted = false;
      this.userEmail = null;
      this.userFirstName = null;
      this.userFullName = null;
      this.userId = null;
      this.connectWelcome = null;
      this.subscriptionSummary = null;
      this.billingPackageDetails = null;
      this.pendingUpgradePlan = null;
      this.emailVerified = null;
      this.unverifiedEmail = null;
      this.verificationEmailAddressId = null;
      this.verificationEmailSent = false;
      this.verificationEmailSending = false;
      this._emailVerificationResolved = undefined;
      this._emailVerificationLoadPromise = null;
      if (this._apiSession) this._apiSession.clear();
      this.resetIntercom();
      this.$router.push(dest);
    },
    fbPixelInit: function fbPixelInit() {
      if (this.facebookPixelInitialized) return;

      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';
        n.queue = [];t = b.createElement(e);t.async = !0;
        t.src = v;s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '2279917682283795');
      window.fbq('track', 'PageView');

      this.facebookPixelInitialized = true;
      for (var i = 0; i < this.facebookPixelEventQueue.length; ++i) {
        var e = this.facebookPixelEventQueue[i];
        this.fbPixelEventHandler(e.type, e.event, e.params);
      }
      this.facebookPixelEventQueue = [];
    },
    fbPixelEventHandler: function fbPixelEventHandler(type, event, params) {
      if (this.facebookPixelInitialized) {
        var operation = type === 'standard' ? 'track' : 'trackCustom';
        if (params) window.fbq(operation, event, params);else window.fbq(operation, event);
      } else {
        this.facebookPixelEventQueue.splice(this.facebookPixelEventQueue.length, 0, { type: type, event: event, params: params });
      }
    },

    loadIntercom: function loadIntercom(userEmail, userHash, intercomUserJwt) {
      var appId = this.intercomAppId || "rl23bhij";
      var self = this;
      if (!appId) {
        this.intercomMessengerBooted = false;
        return;
      }
      if (typeof window.Intercom !== 'function') {
        this.intercomMessengerBooted = false;
        return;
      }
      var jwt = intercomUserJwt && String(intercomUserJwt).trim() ? String(intercomUserJwt).trim() : null;
      var runBoot = function runBoot() {
        if (typeof window.Intercom !== 'function') return;
        var baseSettings = { api_base: INTERCOM_API_BASE, app_id: appId };
        try {
          window.Intercom('shutdown');
        } catch (e) {}

        var identity = {};
        if (self.userFullName) identity.name = self.userFullName;
        if (jwt) {
          window.intercomSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, baseSettings);
          window.Intercom('boot', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
            api_base: INTERCOM_API_BASE,
            app_id: appId,
            intercom_user_jwt: jwt
          }, identity));
        } else if (userEmail && userHash) {
          if (self.userId) identity.user_id = self.userId;
          window.intercomSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, baseSettings);
          window.Intercom('boot', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
            api_base: INTERCOM_API_BASE,
            app_id: appId,
            email: userEmail,
            user_hash: userHash
          }, identity));
        } else {
          window.intercomSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, baseSettings);
          window.Intercom('boot', {
            api_base: INTERCOM_API_BASE,
            app_id: appId
          });
        }
        self.intercomMessengerBooted = true;
      };

      var scheduleBoot = function scheduleBoot() {
        setTimeout(runBoot, 0);
      };
      if (document.readyState === 'complete') {
        scheduleBoot();
      } else {
        window.addEventListener('load', function onLoadIntercom() {
          window.removeEventListener('load', onLoadIntercom);
          scheduleBoot();
        });
      }
    },
    resetIntercom: function resetIntercom() {
      this.intercomMessengerBooted = false;
      if (typeof window.Intercom !== 'function') return;
      window.Intercom('shutdown');
      var appId = this.intercomAppId || "rl23bhij";
      if (!appId) return;
      window.intercomSettings = {
        api_base: INTERCOM_API_BASE,
        app_id: appId
      };
      window.Intercom('boot', {
        api_base: INTERCOM_API_BASE,
        app_id: appId
      });
      this.intercomMessengerBooted = true;
    },
    showIntercom: function showIntercom() {
      if (typeof window.Intercom !== 'function') return;
      window.Intercom('show');
    },
    loadDashboardStats: function loadDashboardStats() {
      console.log('[Main] loadDashboardStats called - pre-loading stats for better UX');
    }
  },
  created: function created() {
    var _this4 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_45__utils_calendly__["a" /* registerCalendlyTracking */])();

    this._apiSession = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__utils_sharedApiSession__["a" /* createSharedApiSession */])();
    this._emailVerificationResolved = undefined;
    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.http.interceptors.push(function (request, next) {
      if (_this4.loginNeeded && request.url !== '/api/auth/login/standard') {
        _this4.log('Login needed, suppressing request ' + request.method + ' ' + request.url);
        return;
      }
      next(function (response) {
        if (response.ok === false && (response.status === 0 || response.status === 502 || response.status === 503 || response.status === 504 || response.status === 500 && response.body.startsWith('Error occured while trying to proxy to'))) {
          if (_this4.offline === false) _this4.offline = true;
        } else if (_this4.offline) {
          _this4.offline = false;
        }
      });
    });
    this.$http.get('/api/auth/csrf').then(function (response) {
      var t = response.body;
      _this4.apiAccessToken = t.token;
      __WEBPACK_IMPORTED_MODULE_3_vue___default.a.http.headers.common[t.headerName] = t.token;
      if (window.location.pathname === '/logout') {
        _this4.$http.get('/api/auth/signout').then(function (response) {
          window.location('/login');
        });
      } else {
        _this4.claimSsoLogin().then(function () {
          return _this4.checkIfAuthenticated();
        });
      }
    }, function (response) {
      if ((typeof console === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(console)) === 'object' && typeof console.log === 'function') {
        console.log('errors');
        console.log(response);
      }

      if (_this4.offline) document.write('Your connection seems to be down at the moment.');
    });
    window.onerror = function (message, url, lineNumber, columnNumber, error) {
      _this4.$http.post('/api/webui/p0/rjse', {
        message: message,
        url: url,
        lineNumber: lineNumber,
        columnNumber: columnNumber,
        error: error
      });
      return false;
    };
    window.onbeforeunload = function (evt) {
      if (window.dirty) {
        var message = 'Are you sure you want to leave? You have some unsaved changes.';
        if (typeof evt === 'undefined') {
          evt = window.event;
        }
        if (evt) {
          evt.returnValue = message;
        }
        return message;
      }
    };
    this.$on('fb-pixel-event', this.fbPixelEventHandler);
    var self = this;
    this.$router.afterEach(function () {
      if (self.authCompleted && self.intercomMessengerBooted && typeof window.Intercom === 'function') {
        try {
          window.Intercom('update');
        } catch (e) {}
      }
    });
  },
  mounted: function mounted() {
    var self = this;
    this.scheduleAfterFirstPaint(function () {
      self.fbPixelInit();
    });
  }
}).$mount('#app');

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSellers2", function() { return setSellers2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(95);


var setSellers2 = function setSellers2(_ref, sellerList) {
  var commit = _ref.commit;

  var sellers = sellerList.reduce(function (m, s) {
    m[s.sellerId.value] = s;
    return m;
  }, {});
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SET_SELLERS */], sellers);
};

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(95);



var state = {
  sellers: null
};

var getters = {
  sellers: function sellers(state) {
    return state.sellers;
  }
};

var actions = {
  setSellers: function setSellers(state, sellerList) {
    var sellers = sellerList.reduce(function (m, s) {
      m[s.sellerId.value] = s;
      return m;
    }, {});
    state.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_SELLERS */], sellers);
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_SELLERS */], function (state, sellers) {
  state.sellers = sellers;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export accountSellersReportQueryString */
/* unused harmony export SELLER_EXPORT_HEADERS */
/* unused harmony export csvCell */
/* harmony export (immutable) */ __webpack_exports__["a"] = sellersCsv;
/* harmony export (immutable) */ __webpack_exports__["c"] = accountSellersReportUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = filenameFromContentDisposition;
/* harmony export (immutable) */ __webpack_exports__["e"] = csvHasDataRows;
/* harmony export (immutable) */ __webpack_exports__["b"] = triggerBlobDownload;


var DEFAULT_FILENAME = 'sentrykit-competing-sellers.csv';

function accountSellersReportQueryString(params) {
  params = params || {};
  var parts = [];
  var sellerId = params.sellerId;
  if (sellerId != null && sellerId !== '') {
    parts.push('seller_id=' + encodeURIComponent(String(sellerId)));
  }
  var marketplace = params.marketplace;
  if (marketplace != null && String(marketplace).trim() !== '') {
    parts.push('marketplace=' + encodeURIComponent(String(marketplace).trim()));
  }

  ;['from', 'to'].forEach(function (key) {
    var v = params[key];
    if (v != null && String(v).trim() !== '') parts.push(key + '=' + encodeURIComponent(String(v).trim()));
  });
  if (params.fileFormat === 'xlsx') parts.push('file_format=xlsx');
  return parts.join('&');
}

var SELLER_EXPORT_HEADERS = ['Merchant Token ID', 'Seller Name', 'Role', 'Marketplace', 'ASIN Count', 'First Seen', 'Last Seen', 'ASINs'];

function csvCell(value) {
  var text = value == null ? '' : String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = "'" + text;
  if (/[",\n\r]/.test(text)) text = '"' + text.replace(/"/g, '""') + '"';
  return text;
}

function sellersCsv(rows) {
  var lines = [SELLER_EXPORT_HEADERS.map(csvCell).join(',')];(rows || []).forEach(function (cells) {
    lines.push(cells.map(csvCell).join(','));
  });
  return '\uFEFF' + lines.join('\r\n') + '\r\n';
}

function accountSellersReportUrl(params) {
  var qs = accountSellersReportQueryString(params);
  return '/api/v1/account-sellers/report' + (qs ? '?' + qs : '');
}

function filenameFromContentDisposition(header, fallback) {
  var defaultName = fallback || DEFAULT_FILENAME;
  if (!header) return defaultName;
  var quoted = String(header).match(/filename="([^"]+)"/);
  if (quoted && quoted[1]) return quoted[1];
  var any = String(header).match(/filename\*?=(?:UTF-8''|['"]?)([^;\n"]+)/i);
  if (any && any[1]) {
    try {
      return decodeURIComponent(any[1].replace(/['"]/g, '').trim()) || defaultName;
    } catch (e) {
      var name = any[1].replace(/['"]/g, '').trim();
      if (name) return name;
    }
  }
  return defaultName;
}

function csvHasDataRows(text) {
  var s = String(text == null ? '' : text).replace(/^\uFEFF/, '');
  s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  var lines = s.split('\n');
  var count = 0;
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].trim() !== '') count++;
    if (count > 1) return true;
  }
  return false;
}

function triggerBlobDownload(blob, filename) {
  if (!blob || typeof document === 'undefined') return;
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || DEFAULT_FILENAME);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONNECT_REGIONS; });
/* unused harmony export connectRegion */
/* unused harmony export connectRegionName */
/* unused harmony export guessRegionFromUtcOffset */
/* harmony export (immutable) */ __webpack_exports__["a"] = guessRegionFromBrowser;
/* unused harmony export selectedCodes */
/* harmony export (immutable) */ __webpack_exports__["c"] = allCodesSelected;
/* harmony export (immutable) */ __webpack_exports__["f"] = toggleAllCodes;
/* harmony export (immutable) */ __webpack_exports__["g"] = toggleCode;
/* harmony export (immutable) */ __webpack_exports__["e"] = connectButtonLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = connectAuthorizationParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amazonSellingPartnerOAuth__ = __webpack_require__(32);



var CONNECT_REGIONS = [{ key: 'NA', name: 'North America' }, { key: 'EU', name: 'Europe' }, { key: 'ME', name: 'Middle East' }, { key: 'IN', name: 'India' }, { key: 'FE', name: 'Asia Pacific' }].map(function (r) {
  var marketplaces = __WEBPACK_IMPORTED_MODULE_0__amazonSellingPartnerOAuth__["b" /* AMAZON_CONNECT_MARKETPLACES_BY_REGION */][r.key];
  return {
    key: r.key,
    name: r.name,
    codes: marketplaces.map(function (o) {
      return o.code;
    }),
    marketplaces: marketplaces
  };
});

function connectRegion(key) {
  var k = String(key || '').toUpperCase();
  for (var i = 0; i < CONNECT_REGIONS.length; i++) {
    if (CONNECT_REGIONS[i].key === k) return CONNECT_REGIONS[i];
  }
  return null;
}

function connectRegionName(key) {
  var r = connectRegion(key);
  return r ? r.name : '';
}

function guessRegionFromUtcOffset(offsetHours) {
  var o = Number(offsetHours);
  if (isNaN(o) || o <= -2) return 'NA';
  if (o < 3) return 'EU';
  if (o < 5) return 'ME';
  if (o < 6.5) return 'IN';
  return 'FE';
}

function guessRegionFromBrowser(date) {
  var d = date || new Date();
  return guessRegionFromUtcOffset(-d.getTimezoneOffset() / 60);
}

function inRegionOrder(region, codes) {
  var list = Array.isArray(codes) ? codes : [];
  return region.codes.filter(function (c) {
    return list.indexOf(c) !== -1;
  });
}

function selectedCodes(key, selected) {
  var r = connectRegion(key);
  return r ? inRegionOrder(r, selected) : [];
}

function allCodesSelected(key, selected) {
  var r = connectRegion(key);
  return !!r && inRegionOrder(r, selected).length === r.codes.length;
}

function toggleAllCodes(key, selected) {
  var r = connectRegion(key);
  if (!r) return [];
  if (r.codes.length === 1) return r.codes.slice();
  return allCodesSelected(key, selected) ? [] : r.codes.slice();
}

function toggleCode(key, selected, code) {
  var r = connectRegion(key);
  if (!r) return [];
  if (r.codes.length === 1) return r.codes.slice();
  var current = inRegionOrder(r, selected);
  if (r.codes.indexOf(code) === -1) return current;
  var next = current.indexOf(code) === -1 ? current.concat([code]) : current.filter(function (c) {
    return c !== code;
  });
  return inRegionOrder(r, next);
}

function connectButtonLabel(key, selected) {
  var r = connectRegion(key);
  var codes = r ? inRegionOrder(r, selected) : [];
  if (!codes.length) return 'Pick at least one marketplace';
  if (codes.length === r.codes.length) return 'Connect Amazon ' + r.name + ' →';
  return 'Connect Amazon ' + codes.join(', ') + ' →';
}

function connectAuthorizationParams(key, selected) {
  var r = connectRegion(key);
  var codes = r ? inRegionOrder(r, selected) : [];
  if (!codes.length) return null;
  var all = codes.length === r.codes.length;
  var first = r.marketplaces[r.codes.indexOf(codes[0])];
  return {
    region: r.key,
    allMarketplaces: all,
    marketplaceCodes: codes.join(','),
    marketplaceCode: codes.join(','),
    marketplace: all ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__amazonSellingPartnerOAuth__["a" /* amazonAuthorizationQueryMarketplace */])(r.key) : first.marketplaceId
  };
}

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeWatchdogTypesForItemsFetch;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchSummaryItemsForTypes;
/* harmony export (immutable) */ __webpack_exports__["c"] = refreshIssuesSummaryQuiet;
/* harmony export (immutable) */ __webpack_exports__["d"] = runIssuesSummaryFetchCore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__requestGate_js__ = __webpack_require__(63);








function issuesBaseParams(vm) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["e" /* buildSummaryRequestParams */])(vm.filterByMarket, vm.filterBySellAcc, vm.dateRange, {
    start: vm.customDateStart,
    end: vm.customDateEnd
  });
}

function ensureIssuesGate(vm) {
  if (!vm._issuesRequestGate) vm._issuesRequestGate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__requestGate_js__["a" /* createRequestGate */])();
  return vm._issuesRequestGate;
}

function getSummaryAlertCounts(vm, alertParams, gate, gen) {
  var baseOpts = {
    params: alertParams,
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    }
  };
  var opts = gate ? gate.trackOpts(baseOpts) : baseOpts;
  return vm.$http.get('/api/v1/watchdogs/summary/alert_counts', opts).catch(function (res) {
    if (gate && gen != null && !gate.isCurrent(gen)) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(res);
    if (res && res.status === 304) {
      var retryParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, alertParams, { _skretry: Date.now() });
      var retryOpts = gate ? gate.trackOpts({
        params: retryParams,
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      }) : {
        params: retryParams,
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      };
      return vm.$http.get('/api/v1/watchdogs/summary/alert_counts', retryOpts);
    }
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(res);
  });
}

function computeWatchdogTypesForItemsFetch(vm, host) {
  return computeTypesToFetch(vm, host.wdList || []);
}

function computeTypesToFetch(vm, wdList) {
  var wdSet = {};
  for (var wi = 0; wi < wdList.length; wi++) {
    wdSet[wdList[wi]] = true;
  }var types = [];
  var dw = vm.displayedWatchdogs || [];
  for (var di = 0; di < dw.length; di++) {
    if (wdSet[dw[di]]) types.push(dw[di]);
  }

  if (types.length === 0 && wdList.length > 0) {
    if (vm.activeCategory && wdList.indexOf(vm.activeCategory) >= 0) {
      types = [vm.activeCategory];
    } else {
      types = wdList.slice();
    }
  }

  return types;
}

function clearStaleWatchdogItems(vm, host, wdList, types) {
  for (var ci = 0; ci < wdList.length; ci++) {
    var wClear = wdList[ci];
    if (types.indexOf(wClear) >= 0) continue;
    var wdClear = host.worldStore.watchDogs[wClear];
    if (wdClear) {
      vm.$set(wdClear, 'items', {});
      vm.$delete(wdClear, 'summaryTotals');
    }
  }
}

function filtersAllowUnscopedPrefetch(vm) {
  return (!vm.filterByMarket || vm.filterByMarket.length === 0) && (!vm.filterBySellAcc || vm.filterBySellAcc.length === 0) && (!vm.dateRange || vm.dateRange === 'all' || vm.dateRange === 'all_time');
}

function fetchSummaryItemsForTypes(vm, host, types, onDone) {
  function finish() {
    if (typeof onDone === 'function') onDone();
  }

  var gate = ensureIssuesGate(vm);
  var gen = gate.generation();
  var baseParams = issuesBaseParams(vm);
  var wdList = host.wdList || [];

  clearStaleWatchdogItems(vm, host, wdList, types);
  vm.issuesItemsLoading = true;

  if (!types || types.length === 0) {
    vm.issuesItemsLoading = false;
    finish();
    return;
  }

  var pending = types.length;
  function oneItemDone() {
    pending -= 1;
    if (pending <= 0) {
      if (gate.isCurrent(gen)) vm.issuesItemsLoading = false;
      finish();
    }
  }

  types.forEach(function (t) {
    var iparams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, baseParams, {
      watchdog_type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["f" /* watchdogTypeToApiParam */])(t),
      page: vm.issuesListPage || 1,
      per_page: 10,
      list: vm.issuesResolvedHidden ? 'active' : vm.issuesListTab === 'resolved' ? 'resolved' : 'active',
      _cb: Date.now()
    });
    if (vm.issuesSearchQuery) iparams.q = vm.issuesSearchQuery;
    if (t === 'fbaFeeChange' && vm.issuesFeeDirection) iparams.fee_direction = vm.issuesFeeDirection;
    if (!vm.issuesResolvedHidden && vm.issuesFocusPending && vm.highlightedAlertId) {
      iparams.focus_watchdog_id = vm.highlightedAlertId;
    }

    vm.$http.get('/api/v1/watchdogs/summary/items', gate.trackOpts({
      params: iparams,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    })).then(function (ir) {
      if (!gate.isCurrent(gen)) {
        oneItemDone();
        return;
      }
      var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["g" /* parseSummaryJsonPayload */])(ir);
      var meta = body && body.meta;
      if (meta && (meta.resolved_hidden === true || meta.resolvedHidden === true)) {
        vm.issuesResolvedHidden = true;
        if (vm.issuesListTab === 'resolved') vm.issuesListTab = 'active';
      } else if (meta) {
        vm.issuesResolvedHidden = false;
      }
      if (meta && meta.list && meta.list !== vm.issuesListTab) {
        vm.issuesListTab = meta.list;
      }
      if (meta && meta.page) vm.issuesListPage = meta.page;
      vm.issuesItemsMeta = meta || null;
      vm.issuesFocusPending = false;
      var maps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["h" /* summaryItemsToLegacyMaps */])(body, t);
      var mergeProducts = maps.productsPatch || {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(mergeProducts).forEach(function (pk) {
        vm.$set(vm.issueProductsMap, pk, mergeProducts[pk]);
      });
      var wdHost = host.worldStore.watchDogs[t];
      if (wdHost) {
        vm.$set(wdHost, 'items', maps.items || {});
        if (maps.summaryTotals == null) {
          vm.$delete(wdHost, 'summaryTotals');
        } else {
          vm.$set(wdHost, 'summaryTotals', maps.summaryTotals);
        }
      }
      vm.$forceUpdate();
      if (typeof vm.tryFocusDeepLinkedAlert === 'function') {
        vm.$nextTick(function () {
          vm.tryFocusDeepLinkedAlert();
        });
      }
      oneItemDone();
    }).catch(function (itemErr) {
      if (!gate.isCurrent(gen) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__requestGate_js__["b" /* isRequestAborted */])(itemErr)) {
        oneItemDone();
        return;
      }
      console.error('[IssuesPage] summary/items failed for', t, itemErr);
      var wdFail = host.worldStore.watchDogs[t];
      if (wdFail) {
        vm.$set(wdFail, 'items', {});
        vm.$delete(wdFail, 'summaryTotals');
      }
      vm.$forceUpdate();
      oneItemDone();
    });
  });

  if (vm._pendingIssuesScrollCategory) {
    var c = vm._pendingIssuesScrollCategory;
    vm._pendingIssuesScrollCategory = null;
    vm.$nextTick(function () {
      if (typeof vm.scrollIssuesListToCategory === 'function') {
        vm.scrollIssuesListToCategory(c);
      }
    });
  }
}

function refreshIssuesSummaryQuiet(vm, host, onDone) {
  function finish() {
    if (typeof onDone === 'function') onDone();
  }

  var gate = ensureIssuesGate(vm);
  var gen = gate.begin();
  var baseParams = issuesBaseParams(vm);
  var alertParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, baseParams, { _cb: Date.now() });
  var types = computeWatchdogTypesForItemsFetch(vm, host);

  var pending = 2;
  function oneDone() {
    pending -= 1;
    if (pending <= 0) finish();
  }

  fetchSummaryItemsForTypes(vm, host, types, oneDone);

  getSummaryAlertCounts(vm, alertParams, gate, gen).then(function (response) {
    if (!gate.isCurrent(gen)) {
      oneDone();
      return;
    }
    try {
      var countsPayload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["a" /* parseAlertCountsHttpPayload */])(response);
      vm.summaryAlertCounts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["i" /* parseAlertCountsBody */])(countsPayload, null);
    } catch (parseErr) {
      console.error('[IssuesPage] alert_counts quiet refresh parse failed:', parseErr);
    }
    vm.lastUpdateTime = Date.now();
    vm.lastUpdated = 'just now';
    vm.updateFilters();
    vm.$forceUpdate();
    oneDone();
  }).catch(function (err) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__requestGate_js__["b" /* isRequestAborted */])(err)) {
      console.error('[IssuesPage] alert_counts quiet refresh failed:', err);
    }
    oneDone();
  });
}

function applyPrefetchedAlertCounts(vm) {
  if (!filtersAllowUnscopedPrefetch(vm)) return false;
  var root = vm.$root;
  var pref = root && root._prefetchedAlertCounts;
  if (!pref || !pref.payload || pref.filterKey !== 'all') return false;
  if (Date.now() - pref.at > 60000) return false;
  try {
    vm.summaryAlertCounts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["i" /* parseAlertCountsBody */])(pref.payload, null);
    return true;
  } catch (e) {
    return false;
  }
}

function runIssuesSummaryFetchCore(vm, host, onDone) {
  function finish() {
    if (typeof onDone === 'function') onDone();
  }

  var gate = ensureIssuesGate(vm);
  var gen = gate.begin();
  var baseParams = issuesBaseParams(vm);
  var alertParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, baseParams, { _cb: Date.now() });
  var wdList = host.wdList || [];
  var types = computeTypesToFetch(vm, wdList);

  var pending = 2;
  function oneDone() {
    pending -= 1;
    if (pending <= 0) finish();
  }

  fetchSummaryItemsForTypes(vm, host, types, function () {
    if (!gate.isCurrent(gen)) {
      oneDone();
      return;
    }
    vm.loading = false;
    vm.lastUpdateTime = Date.now();
    vm.lastUpdated = 'just now';
    vm.updateFilters();
    vm.$forceUpdate();
    oneDone();
  });

  if (applyPrefetchedAlertCounts(vm)) {
    vm.updateFilters();
    vm.$forceUpdate();
    oneDone();
    return;
  }

  getSummaryAlertCounts(vm, alertParams, gate, gen).then(function (response) {
    if (!gate.isCurrent(gen)) {
      oneDone();
      return;
    }
    try {
      try {
        var countsPayload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["a" /* parseAlertCountsHttpPayload */])(response);
        vm.summaryAlertCounts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__watchdogSummaryApi_js__["i" /* parseAlertCountsBody */])(countsPayload, null);
      } catch (parseErr) {
        console.error('[IssuesPage] alert_counts parse failed:', parseErr);
        vm.summaryAlertCounts = {};
      }

      vm.updateFilters();
      vm.$forceUpdate();
    } catch (handlerErr) {
      console.error('[IssuesPage] alert_counts handler failed:', handlerErr);
    }
    oneDone();
  }).catch(function (err) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__requestGate_js__["b" /* isRequestAborted */])(err) || !gate.isCurrent(gen)) {
      oneDone();
      return;
    }
    console.error('[IssuesPage] alert_counts failed:', err);
    if (vm.loading) {
      var errorMsg = 'Failed to load alerts';
      if (err && err.body && err.body.message) {
        errorMsg = err.body.message;
      } else if (err && err.message) {
        errorMsg = err.message;
      }
      vm.error = errorMsg;
      vm.loading = false;
    }
    oneDone();
  });
}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseProductDetailChangeRows;
/* harmony export (immutable) */ __webpack_exports__["b"] = isImageOnlyUpdatedRows;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatChangeCellBefore;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatChangeCellAfter;
/* harmony export (immutable) */ __webpack_exports__["e"] = truncateChangeCell;
/* unused harmony export CELL_TRUNCATE */


var CELL_TRUNCATE = 60;

var SEGMENT_SPLIT = /,\s+(?=(?:Title|Brand|Manufacturer|Description|Bullet(?:\s+Point)?|Image|Images|Item type|Product type|Generic keyword|Color|Material|Size|Browse node|Pattern|Style)\b)/i;

function normalizeArrowIndex(rest) {
  var i = rest.indexOf(' → ');
  if (i >= 0) return { i: i, len: 3 };
  i = rest.indexOf(' -> ');
  if (i >= 0) return { i: i, len: 4 };
  i = rest.indexOf('→');
  if (i >= 0) return { i: i, len: 1 };
  i = rest.indexOf('->');
  if (i >= 0) return { i: i, len: 2 };
  return null;
}

function parseProductDetailChangeRows(raw) {
  if (raw == null || typeof raw !== 'string') return null;
  var text = raw.trim();
  if (!text) return null;

  var parts = text.split(SEGMENT_SPLIT).map(function (s) {
    return s.trim();
  }).filter(Boolean);
  if (parts.length === 0) return null;

  var rows = [];
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i];
    if (/^images?\s+updated$/i.test(p)) {
      rows.push({ field: 'Image', before: '—', after: 'Updated' });
      continue;
    }
    var m = p.match(/^([^:]+):\s*([\s\S]*)$/);
    if (!m) return null;
    var field = m[1].trim();
    var rest = m[2];
    var arrow = normalizeArrowIndex(rest);
    if (arrow) {
      var before = rest.slice(0, arrow.i).trim();
      var after = rest.slice(arrow.i + arrow.len).trim();
      rows.push({ field: field, before: before, after: after });
    } else {
      rows.push({ field: field, before: '—', after: rest.trim() });
    }
  }
  return rows.length ? rows : null;
}

function isImageOnlyUpdatedRows(rows) {
  if (!rows || rows.length !== 1) return false;
  var r = rows[0];
  if (String(r.field).trim().toLowerCase() !== 'image') return false;
  var b = String(r.before == null ? '' : r.before).trim();
  var a = String(r.after == null ? '' : r.after).trim();
  if (!/^updated$/i.test(a)) return false;
  return b === '' || b === '—' || b === '-' || b === '–' || /^n\/a$/i.test(b);
}

function formatChangeCellBefore(v) {
  if (v == null) return '—';
  var t = String(v).trim();
  if (!t) return '—';
  if (/^n\/a$/i.test(t)) return '(not previously tracked)';
  return t;
}

function formatChangeCellAfter(v) {
  if (v == null) return '—';
  var t = String(v).trim();
  if (!t) return '—';
  if (/^n\/a$/i.test(t)) return '(not previously tracked)';
  return t;
}

function truncateChangeCell(v, maxLen) {
  var cap = maxLen != null ? maxLen : CELL_TRUNCATE;
  if (v == null) return { text: '', full: '', truncated: false };
  var t = String(v);
  if (t.length <= cap) return { text: t, full: t, truncated: false };
  return { text: t.slice(0, cap - 1) + '…', full: t, truncated: true };
}



/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCogsFromRecord */
/* unused harmony export getBuyBoxPriceFromRecord */
/* unused harmony export findProductsById */
/* unused harmony export findWorldStoreProducts */
/* unused harmony export getProductCatalog */
/* unused harmony export resolveProductCogs */
/* unused harmony export resolveProductBuyBoxPrice */
/* unused harmony export resolveProductMargin */
/* unused harmony export hasProductCogs */
/* unused harmony export createProductReader */
/* harmony export (immutable) */ __webpack_exports__["a"] = createProductReaderFromVm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



function parsePositiveMoney(value) {
  if (value === null || value === undefined || value === '') return null;
  var n = parseFloat(value);
  if (isNaN(n) || n <= 0) return null;
  return n;
}

function getCogsFromRecord(record) {
  if (!record) return null;
  return parsePositiveMoney(record.cogs) || parsePositiveMoney(record.supplierCost) || parsePositiveMoney(record.supplier_cost);
}

function getBuyBoxPriceFromRecord(record) {
  if (!record) return null;
  return parsePositiveMoney(record.buyBoxPrice) || parsePositiveMoney(record.buy_box_price) || parsePositiveMoney(record.currentPrice) || parsePositiveMoney(record.current_price);
}

function recordsForLookup(product, productsById, worldStoreProducts) {
  if (!product) return [];
  var out = [product];
  var id = product.productId;
  if (!id) return out;
  if (productsById && productsById[id] && productsById[id] !== product) {
    out.push(productsById[id]);
  }
  if (worldStoreProducts && worldStoreProducts[id] && worldStoreProducts[id] !== product) {
    out.push(worldStoreProducts[id]);
  }
  return out;
}

function findProductsById(vm) {
  var cur = vm;
  while (cur) {
    if (cur.apiData && cur.apiData.products) return cur.apiData.products;
    if (cur.worldStore && cur.worldStore.products) return cur.worldStore.products;
    if (cur.productData && cur.productData.products) return cur.productData.products;
    cur = cur.$parent;
  }
  return null;
}

function findWorldStoreProducts(vm) {
  var cur = vm;
  while (cur) {
    if (cur.worldStore && cur.worldStore.products) return cur.worldStore.products;
    cur = cur.$parent;
  }
  return null;
}

function getProductCatalog(vm) {
  return {
    productsById: findProductsById(vm),
    worldStoreProducts: findWorldStoreProducts(vm)
  };
}

function resolveProductCogs(product, productsById, worldStoreProducts) {
  var records = recordsForLookup(product, productsById, worldStoreProducts);
  for (var i = 0; i < records.length; i++) {
    var cogs = getCogsFromRecord(records[i]);
    if (cogs != null) return cogs;
  }
  return null;
}

function resolveProductBuyBoxPrice(product, productsById, worldStoreProducts) {
  var records = recordsForLookup(product, productsById, worldStoreProducts);
  for (var i = 0; i < records.length; i++) {
    var price = getBuyBoxPriceFromRecord(records[i]);
    if (price != null) return price;
  }
  return null;
}

function marginFromRecord(record) {
  if (!record || record.margin === null || record.margin === undefined) return null;
  var m = parseFloat(record.margin);
  if (isNaN(m)) return null;
  return Math.round(m);
}

function resolveProductMargin(product, productsById, worldStoreProducts) {
  var records = recordsForLookup(product, productsById, worldStoreProducts);
  for (var i = 0; i < records.length; i++) {
    var m = marginFromRecord(records[i]);
    if (m != null) return m;
  }
  var cogs = resolveProductCogs(product, productsById, worldStoreProducts);
  var price = resolveProductBuyBoxPrice(product, productsById, worldStoreProducts);
  if (cogs == null || price == null) return null;
  return Math.round((price - cogs) / price * 100);
}

function hasProductCogs(product, productsById, worldStoreProducts) {
  return resolveProductCogs(product, productsById, worldStoreProducts) != null;
}

function createProductReader(catalog) {
  var productsById = catalog && catalog.productsById ? catalog.productsById : null;
  var worldStoreProducts = catalog && catalog.worldStoreProducts ? catalog.worldStoreProducts : null;

  return {
    hasCogs: function hasCogs(product) {
      return hasProductCogs(product, productsById, worldStoreProducts);
    },
    getCogs: function getCogs(product) {
      return resolveProductCogs(product, productsById, worldStoreProducts);
    },
    getMargin: function getMargin(product) {
      return resolveProductMargin(product, productsById, worldStoreProducts);
    },
    getBuyBoxPrice: function getBuyBoxPrice(product) {
      return resolveProductBuyBoxPrice(product, productsById, worldStoreProducts);
    },
    read: function read(product) {
      if (!product) return null;
      var cogs = resolveProductCogs(product, productsById, worldStoreProducts);
      var margin = resolveProductMargin(product, productsById, worldStoreProducts);
      var buyBoxPrice = resolveProductBuyBoxPrice(product, productsById, worldStoreProducts);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, product, {
        cogs: cogs != null ? cogs : product.cogs,
        margin: margin != null ? margin : product.margin,
        buyBoxPrice: buyBoxPrice != null ? buyBoxPrice : product.buyBoxPrice
      });
    }
  };
}

function createProductReaderFromVm(vm) {
  return createProductReader(getProductCatalog(vm));
}

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sellerFlagEnabled */
/* harmony export (immutable) */ __webpack_exports__["a"] = flagsFromSellerRow;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeKillSwitchFlags;
/* harmony export (immutable) */ __webpack_exports__["b"] = patchBodyForStopToggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



function sellerFlagEnabled(v) {
  if (v === false || v === 0 || v === '0' || v === 'false') return false;
  return true;
}

function readFlag(obj, camel, snake) {
  if (!obj) return true;
  if (obj[camel] !== undefined && obj[camel] !== null) return sellerFlagEnabled(obj[camel]);
  if (obj[snake] !== undefined && obj[snake] !== null) return sellerFlagEnabled(obj[snake]);
  return true;
}

function hasFlag(obj, camel, snake) {
  if (!obj) return false;
  return obj[camel] !== undefined && obj[camel] !== null || obj[snake] !== undefined && obj[snake] !== null;
}

function flagsFromSellerRow(row) {
  return {
    alertsEnabled: readFlag(row, 'alertsEnabled', 'alerts_enabled')
  };
}

function mergeKillSwitchFlags(seller, body) {
  var next = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, seller || {});
  if (hasFlag(body, 'alertsEnabled', 'alerts_enabled')) {
    next.alertsEnabled = readFlag(body, 'alertsEnabled', 'alerts_enabled');
  } else if (next.alertsEnabled === undefined) {
    next.alertsEnabled = true;
  }
  return next;
}

function patchBodyForStopToggle(field, stopChecked) {
  var body = {};
  body[field] = !stopChecked;
  return body;
}

/***/ }),
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */,
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 127,
	"./af.js": 127,
	"./ar": 134,
	"./ar-dz": 128,
	"./ar-dz.js": 128,
	"./ar-kw": 129,
	"./ar-kw.js": 129,
	"./ar-ly": 130,
	"./ar-ly.js": 130,
	"./ar-ma": 131,
	"./ar-ma.js": 131,
	"./ar-sa": 132,
	"./ar-sa.js": 132,
	"./ar-tn": 133,
	"./ar-tn.js": 133,
	"./ar.js": 134,
	"./az": 135,
	"./az.js": 135,
	"./be": 136,
	"./be.js": 136,
	"./bg": 137,
	"./bg.js": 137,
	"./bm": 138,
	"./bm.js": 138,
	"./bn": 140,
	"./bn-bd": 139,
	"./bn-bd.js": 139,
	"./bn.js": 140,
	"./bo": 141,
	"./bo.js": 141,
	"./br": 142,
	"./br.js": 142,
	"./bs": 143,
	"./bs.js": 143,
	"./ca": 144,
	"./ca.js": 144,
	"./cs": 145,
	"./cs.js": 145,
	"./cv": 146,
	"./cv.js": 146,
	"./cy": 147,
	"./cy.js": 147,
	"./da": 148,
	"./da.js": 148,
	"./de": 151,
	"./de-at": 149,
	"./de-at.js": 149,
	"./de-ch": 150,
	"./de-ch.js": 150,
	"./de.js": 151,
	"./dv": 152,
	"./dv.js": 152,
	"./el": 153,
	"./el.js": 153,
	"./en-au": 154,
	"./en-au.js": 154,
	"./en-ca": 155,
	"./en-ca.js": 155,
	"./en-gb": 156,
	"./en-gb.js": 156,
	"./en-ie": 157,
	"./en-ie.js": 157,
	"./en-il": 158,
	"./en-il.js": 158,
	"./en-in": 159,
	"./en-in.js": 159,
	"./en-nz": 160,
	"./en-nz.js": 160,
	"./en-sg": 161,
	"./en-sg.js": 161,
	"./eo": 162,
	"./eo.js": 162,
	"./es": 166,
	"./es-do": 163,
	"./es-do.js": 163,
	"./es-mx": 164,
	"./es-mx.js": 164,
	"./es-us": 165,
	"./es-us.js": 165,
	"./es.js": 166,
	"./et": 167,
	"./et.js": 167,
	"./eu": 168,
	"./eu.js": 168,
	"./fa": 169,
	"./fa.js": 169,
	"./fi": 170,
	"./fi.js": 170,
	"./fil": 171,
	"./fil.js": 171,
	"./fo": 172,
	"./fo.js": 172,
	"./fr": 175,
	"./fr-ca": 173,
	"./fr-ca.js": 173,
	"./fr-ch": 174,
	"./fr-ch.js": 174,
	"./fr.js": 175,
	"./fy": 176,
	"./fy.js": 176,
	"./ga": 177,
	"./ga.js": 177,
	"./gd": 178,
	"./gd.js": 178,
	"./gl": 179,
	"./gl.js": 179,
	"./gom-deva": 180,
	"./gom-deva.js": 180,
	"./gom-latn": 181,
	"./gom-latn.js": 181,
	"./gu": 182,
	"./gu.js": 182,
	"./he": 183,
	"./he.js": 183,
	"./hi": 184,
	"./hi.js": 184,
	"./hr": 185,
	"./hr.js": 185,
	"./hu": 186,
	"./hu.js": 186,
	"./hy-am": 187,
	"./hy-am.js": 187,
	"./id": 188,
	"./id.js": 188,
	"./is": 189,
	"./is.js": 189,
	"./it": 191,
	"./it-ch": 190,
	"./it-ch.js": 190,
	"./it.js": 191,
	"./ja": 192,
	"./ja.js": 192,
	"./jv": 193,
	"./jv.js": 193,
	"./ka": 194,
	"./ka.js": 194,
	"./kk": 195,
	"./kk.js": 195,
	"./km": 196,
	"./km.js": 196,
	"./kn": 197,
	"./kn.js": 197,
	"./ko": 198,
	"./ko.js": 198,
	"./ku": 199,
	"./ku.js": 199,
	"./ky": 200,
	"./ky.js": 200,
	"./lb": 201,
	"./lb.js": 201,
	"./lo": 202,
	"./lo.js": 202,
	"./lt": 203,
	"./lt.js": 203,
	"./lv": 204,
	"./lv.js": 204,
	"./me": 205,
	"./me.js": 205,
	"./mi": 206,
	"./mi.js": 206,
	"./mk": 207,
	"./mk.js": 207,
	"./ml": 208,
	"./ml.js": 208,
	"./mn": 209,
	"./mn.js": 209,
	"./mr": 210,
	"./mr.js": 210,
	"./ms": 212,
	"./ms-my": 211,
	"./ms-my.js": 211,
	"./ms.js": 212,
	"./mt": 213,
	"./mt.js": 213,
	"./my": 214,
	"./my.js": 214,
	"./nb": 215,
	"./nb.js": 215,
	"./ne": 216,
	"./ne.js": 216,
	"./nl": 218,
	"./nl-be": 217,
	"./nl-be.js": 217,
	"./nl.js": 218,
	"./nn": 219,
	"./nn.js": 219,
	"./oc-lnc": 220,
	"./oc-lnc.js": 220,
	"./pa-in": 221,
	"./pa-in.js": 221,
	"./pl": 222,
	"./pl.js": 222,
	"./pt": 224,
	"./pt-br": 223,
	"./pt-br.js": 223,
	"./pt.js": 224,
	"./ro": 225,
	"./ro.js": 225,
	"./ru": 226,
	"./ru.js": 226,
	"./sd": 227,
	"./sd.js": 227,
	"./se": 228,
	"./se.js": 228,
	"./si": 229,
	"./si.js": 229,
	"./sk": 230,
	"./sk.js": 230,
	"./sl": 231,
	"./sl.js": 231,
	"./sq": 232,
	"./sq.js": 232,
	"./sr": 234,
	"./sr-cyrl": 233,
	"./sr-cyrl.js": 233,
	"./sr.js": 234,
	"./ss": 235,
	"./ss.js": 235,
	"./sv": 236,
	"./sv.js": 236,
	"./sw": 237,
	"./sw.js": 237,
	"./ta": 238,
	"./ta.js": 238,
	"./te": 239,
	"./te.js": 239,
	"./tet": 240,
	"./tet.js": 240,
	"./tg": 241,
	"./tg.js": 241,
	"./th": 242,
	"./th.js": 242,
	"./tk": 243,
	"./tk.js": 243,
	"./tl-ph": 244,
	"./tl-ph.js": 244,
	"./tlh": 245,
	"./tlh.js": 245,
	"./tr": 246,
	"./tr.js": 246,
	"./tzl": 247,
	"./tzl.js": 247,
	"./tzm": 249,
	"./tzm-latn": 248,
	"./tzm-latn.js": 248,
	"./tzm.js": 249,
	"./ug-cn": 250,
	"./ug-cn.js": 250,
	"./uk": 251,
	"./uk.js": 251,
	"./ur": 252,
	"./ur.js": 252,
	"./uz": 254,
	"./uz-latn": 253,
	"./uz-latn.js": 253,
	"./uz.js": 254,
	"./vi": 255,
	"./vi.js": 255,
	"./x-pseudo": 256,
	"./x-pseudo.js": 256,
	"./yo": 257,
	"./yo.js": 257,
	"./zh-cn": 258,
	"./zh-cn.js": 258,
	"./zh-hk": 259,
	"./zh-hk.js": 259,
	"./zh-mo": 260,
	"./zh-mo.js": 260,
	"./zh-tw": 261,
	"./zh-tw.js": 261
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;

/***/ }),
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amazon-wordmark.96691c1.png";

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashboard-grey.0540f16.svg";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashboard-white.7305152.svg";

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0JBQzJEMCIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjkiLz4KPHBhdGggZD0iTTE1IDkuNWMtLjUtMS0xLjYtMS41LTMtMS41LTEuNyAwLTMgLjgtMyAyczEuMyAxLjcgMyAyIDMgLjggMyAyLTEuMyAyLTMgMmMtMS40IDAtMi42LS42LTMtMS42TTEyIDZ2Mm0wIDh2MiIvPgo8L3N2Zz4K"

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjkiLz4KPHBhdGggZD0iTTE1IDkuNWMtLjUtMS0xLjYtMS41LTMtMS41LTEuNyAwLTMgLjgtMyAyczEuMyAxLjcgMyAyIDMgLjggMyAyLTEuMyAyLTMgMmMtMS40IDAtMi42LS42LTMtMS42TTEyIDZ2Mm0wIDh2MiIvPgo8L3N2Zz4K"

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/products-grey.77d6c7a.svg";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/products-white.c31ec23.svg";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/settings-grey.603598a.svg";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/settings-white.7baf9ca.svg";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stock-grey.a7a94a8.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stock-white.b9e7cd1.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google-sheets.393ac4e.png";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zapier.a915616.png";

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sentrykit-2-wordmark.689eac9.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/raghav-112.e86e227.jpg";

/***/ }),
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.7","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  "data-v-6e06ca1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-44032bf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  "data-v-2cf6a058",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  "data-v-2c30c0cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  "data-v-199f9af3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  "data-v-261c34d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  "data-v-52d3b922",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-70f3d441",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  "data-v-286e15e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-6a1556bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-7d4673a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  "data-v-385149a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-5dcd452e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-5c108871",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  "data-v-0f7fb5ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  "data-v-f46a47a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(755),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  "data-v-b070748c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  "data-v-0431d599",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-4ccbbb3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui middle aligned grid",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "id": "anonbg"
    }
  }, [_c('div', {
    staticClass: "mt4 column"
  }, [_vm._m(0), _vm._v(" "), _c('center', [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Thank you for continuing your subscription."), _c('br'), _vm._v("\n              We appreciate being able to service your account."), _c('br'), _vm._v("\n              This confirms that we will apply a 25% discount to your monthly fee for the next 6 months."), _c('br'), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "ui right labeled icon large button setupStep",
    staticStyle: {
      "margin": "auto",
      "display": "block"
    },
    on: {
      "click": _vm.nextButtonPress
    }
  }, [_c('i', {
    staticClass: "right arrow icon"
  }), _vm._v("\n              link to account settings to view subscription\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Check out our most recent blogs if they can provide any help for your Amazon business!\n              "), _c('hr', {
    staticClass: "solid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid container",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "ui stackable doubling three cards"
  }, [_c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/streamline-product-issue-management-how-an-integrated-issue-tracker-simplifies-amazon-asin-management",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Streamline Product Issue Management: How an Integrated Issue Tracker Simplifies Amazon ASIN Management\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Amazon ASINs, or Amazon Standard Identification Numbers, are unique alphanumeric codes assigned to each product listed on the Amazon marketplace. Learn More Here!\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/elevate-your-inventory-management-game-a-glance-at-your-total-and-sellable-stock",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(87)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Elevate Your Inventory Management Game: A Glance at Your Total and Sellable Stock\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Inventory management is the backbone of a successful e-commerce business, and keeping a close eye on your stock levels is crucial.\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/the-ultimate-guide-to-mastering-amazon-ppc-advertising-boost-your-sales-with-effective-search-engine-marketing-strategies",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      The Ultimate Guide to Mastering Amazon PPC Advertising: Boost Your Sales with Effective Search Engine Marketing Strategies\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      In this ultimate guide, we will delve into the world of Amazon PPC advertising and equip you with the knowledge and techniques needed to master this powerful marketing tool.\n                    ")])])])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center"
  }, [_c('img', {
    staticStyle: {
      "width": "350px",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": __webpack_require__(47)
    }
  })])
}]}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skipPackageDimensionChangeIfNoFeeChange),
      expression: "skipPackageDimensionChangeIfNoFeeChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334456"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPackageDimensionChangeIfNoFeeChange) ? _vm._i(_vm.skipPackageDimensionChangeIfNoFeeChange, null) > -1 : (_vm.skipPackageDimensionChangeIfNoFeeChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.skipPackageDimensionChangeIfNoFeeChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.skipPackageDimensionChangeIfNoFeeChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334456"
    }
  }, [_vm._v("Dimension changes: Only alert if FBA fee changed as well")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertForParentChanges),
      expression: "alertForParentChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334458"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertForParentChanges) ? _vm._i(_vm.alertForParentChanges, null) > -1 : (_vm.alertForParentChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertForParentChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertForParentChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertForParentChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertForParentChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334458"
    }
  }, [_vm._v("Parent ASIN: Alert if parent ASIN changes")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertForOwnOfferPriceChanges),
      expression: "alertForOwnOfferPriceChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334459"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertForOwnOfferPriceChanges) ? _vm._i(_vm.alertForOwnOfferPriceChanges, null) > -1 : (_vm.alertForOwnOfferPriceChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertForOwnOfferPriceChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertForOwnOfferPriceChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertForOwnOfferPriceChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertForOwnOfferPriceChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334459"
    }
  }, [_vm._v("Offer price: Alert if your offer price changes")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
}]}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-alerts-page-wrapper"
  }, [_c('AllAlertsPage')], 1)
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "15px 5px 5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "HIGH"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "HIGH")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "HIGH"
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "MEDIUM"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "MEDIUM")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "MEDIUM"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "LOW"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "LOW")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "LOW"
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No Delay: "), _c('small', [_vm._v("You get alerts promptly after we detect a change in Amazon. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("WARNING:")]), _vm._v(" This can result in a lot of notifications! Subscribe and Save can change frequently and repeatedly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Moderate Delay "), _c('small', [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("[RECOMMENDED]")]), _vm._v(": We apply a small delay to the Subscribe and Save alerts so we can filter out short-lived changes. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Strong Filtering: "), _c('small', [_vm._v("We only notify if Subscribe and Save option is lost or gained for a solid amount of time."), _c('br'), _vm._v(" Use this setting if you are getting too many Subscribe and Save alerts.")])])
}]}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.signals && _vm.signals.length > 0) ? _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
    }
  })])]), _vm._v("\n      Listing Signals\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "listing-signals"
  }, _vm._l((_vm.signals), function(signal, index) {
    return _c('div', {
      key: index,
      staticClass: "signal-item"
    }, [_c('div', {
      staticClass: "signal-icon"
    }, [_vm._v(_vm._s(signal.icon))]), _vm._v(" "), _c('div', {
      staticClass: "signal-body"
    }, [_c('div', {
      staticClass: "signal-name"
    }, [_vm._v(_vm._s(signal.name))]), _vm._v(" "), _c('div', {
      staticClass: "signal-status",
      class: signal.active ? 'active' : 'inactive'
    }, [_c('span', {
      staticClass: "signal-dot"
    }), _vm._v(_vm._s(signal.active ? 'Active' : 'Not active') + "\n        ")])])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'field focus' + (_vm.nonEmptyPasswords && _vm.weak ? ' error' : ''),
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.passwordLabel))]), _vm._v(" "), ((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password1) ? _vm._i(_vm.password1, null) > -1 : (_vm.password1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password1 = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password1, null)
    },
    on: {
      "change": function($event) {
        _vm.password1 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "0.5rem",
      "top": "50%",
      "transform": "translateY(-50%)",
      "cursor": "pointer",
      "display": "flex",
      "align-items": "center",
      "height": "100%"
    },
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_c('i', {
    class: _vm.showPassword ? 'eye slash icon' : 'eye icon',
    staticStyle: {
      "font-size": "small",
      "padding": "2px",
      "margin-top": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "position": "relative"
    }
  }, [((_vm.showPassword2 ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : (_vm.password2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password2 = $$c
        }
      }
    }
  }) : ((_vm.showPassword2 ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password2, null)
    },
    on: {
      "change": function($event) {
        _vm.password2 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": _vm.showPassword2 ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "0.5rem",
      "top": "50%",
      "transform": "translateY(-50%)",
      "cursor": "pointer",
      "display": "flex",
      "align-items": "center",
      "height": "100%"
    },
    on: {
      "click": _vm.togglePasswordVisibility2
    }
  }, [_c('i', {
    class: _vm.showPassword2 ? 'eye slash icon' : 'eye icon',
    staticStyle: {
      "font-size": "small"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-reset-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Min. 8 characters",
      "required": "",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.password && _vm.passwordWeak) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Must be 8+ characters with a letter and number/symbol")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-row sk-mt-4"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword2 ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : (_vm.password2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password2 = $$c
        }
      }
    }
  }) : ((_vm.showPassword2 ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password2, null)
    },
    on: {
      "change": function($event) {
        _vm.password2 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Repeat password",
      "required": "",
      "type": _vm.showPassword2 ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword2 = !_vm.showPassword2
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.password2 && _vm.passwordMismatch) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-6",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isFormValid || _vm.working
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v("Set Password →")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Remember your password? "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Set a new password")]), _vm._v(" "), _c('p', [_vm._v("Choose a strong password with at least 8 characters.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("New Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Confirm Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "40px",
      "min-width": "240px"
    }
  }, [_c('div', {
    staticClass: "ui right floated pagination menu"
  }, [_c('a', {
    class: (_vm.disabledFirstPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.backToOne()
      }
    }
  }, [_c('i', {
    staticClass: "angle double left icon"
  })]), _vm._v(" "), _c('a', {
    class: (_vm.disabledPreviousPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.backToPrevious()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.maxPage + 1))]), _vm._v(" "), _c('a', {
    class: (_vm.disabledNextPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.forwardToNext()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })]), _vm._v(" "), _c('a', {
    class: (_vm.disabledLastPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.forwardToLast()
      }
    }
  }, [_c('i', {
    staticClass: "angle double right icon"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oneTenthDown),
      expression: "oneTenthDown"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334455"
    },
    domProps: {
      "checked": Array.isArray(_vm.oneTenthDown) ? _vm._i(_vm.oneTenthDown, null) > -1 : (_vm.oneTenthDown)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.oneTenthDown,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.oneTenthDown = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.oneTenthDown = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.oneTenthDown = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oneTenthUp),
      expression: "oneTenthUp"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334456"
    },
    domProps: {
      "checked": Array.isArray(_vm.oneTenthUp) ? _vm._i(_vm.oneTenthUp, null) > -1 : (_vm.oneTenthUp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.oneTenthUp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.oneTenthUp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.oneTenthUp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.oneTenthUp = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._v("\n                 \n                \n            Report review count drops greater than or equal to\n            "), _c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "90px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviewCountDropMinimumThreshold),
      expression: "reviewCountDropMinimumThreshold"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "size": "3"
    },
    domProps: {
      "value": (_vm.reviewCountDropMinimumThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviewCountDropMinimumThreshold = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("reviews")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334455"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v("Alerts:")]), _vm._v(" \n                warn at every "), _c('b', [_vm._v("0.1 rating drop")]), _vm._v(" not just "), _c('i', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "yellow fitted star outline icon"
  }), _c('i', {
    staticClass: "yellow fitted half star icon"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334456"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "checkmark circle icon"
  }), _vm._v("Notifications:")]), _vm._v(" \n                  by "), _c('b', [_vm._v("0.1 improvements")]), _vm._v(" not just "), _c('i', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "yellow fitted star outline icon"
  }), _c('i', {
    staticClass: "yellow fitted half star icon"
  })])])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-box-dashboard-page"
  }, [_c('BuyBoxDashboard')], 1)
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-sidebar-wrapper",
    class: {
      'sidebar-disabled': _vm.disabled
    }
  }, [_c('div', {
    staticClass: "dashboard-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-top"
  }, [_c('div', {
    staticClass: "sidebar-brand"
  }, [_c('div', {
    staticClass: "sidebar-logo"
  }, [_c('img', {
    staticClass: "sidebar-logo-img",
    attrs: {
      "src": _vm.logoShieldIcon,
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-logo-divider"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "sidebar-nav"
  }, [_vm._l((_vm.mainNavItems), function(item) {
    return _c('a', {
      key: item.id,
      class: ['nav-item', {
        active: _vm.currentPath === item.path
      }],
      on: {
        "click": function($event) {
          return _vm.onNavClick(item.path)
        },
        "mouseenter": function($event) {
          return _vm.onNavHover(item)
        }
      }
    }, [(_vm.iconMap[item.id]) ? _c('img', {
      staticClass: "nav-icon-svg",
      attrs: {
        "src": _vm.currentPath === item.path ? _vm.iconMap[item.id].white : _vm.iconMap[item.id].grey,
        "alt": item.label
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nav-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.badgeCount != null) ? _c('span', {
      class: ['nav-badge', item.badge === 'warning' ? 'warning' : '']
    }, [_vm._v(_vm._s(item.badgeCount))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav-divider"
  }), _vm._v(" "), _c('a', {
    class: ['nav-item', {
      active: _vm.isSettingsActive
    }],
    attrs: {
      "title": "Settings"
    },
    on: {
      "click": function($event) {
        return _vm.onNavClick('/settings')
      }
    }
  }, [_c('img', {
    staticClass: "nav-icon-svg",
    attrs: {
      "src": _vm.isSettingsActive ? _vm.iconMap.settings.white : _vm.iconMap.settings.grey,
      "alt": "Settings"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Settings")])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui left rail hideOnMobileSite",
    staticStyle: {
      "left": "20px",
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "ui xstickyx"
  }, [_c('div', {
    staticClass: "ui list"
  }, _vm._l((_vm.wdInfo), function(i) {
    return (_vm.isMenuEntryVisible(i.id)) ? _c('a', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.scrollTo(i.id)
        }
      }
    }, [(_vm.wdNewErrorCounts[i.id] > 0) ? _c('i', {
      class: 'large ' + i.icon + ' icon',
      style: ('padding:' + i.padding + ';color:brown;position:relative;')
    }, [_c('div', [_vm._v(_vm._s(_vm.wdNewErrorCounts[i.id]))])]) : _c('i', {
      class: 'large ' + i.icon + ' icon',
      style: ('padding:' + i.padding + ';color:grey;')
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "header"
    }, [_vm._v(_vm._s(i.name))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.wdMenuUpdateTrigger))])])])
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow-step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v(_vm._s(_vm.stepNumber))]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', {
    staticClass: "step-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "step-description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150px"
    }
  }, [_c('div', {
    staticClass: "ui checkbox",
    attrs: {
      "width": "300px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timezoneAdjustToDST),
      expression: "timezoneAdjustToDST"
    }],
    attrs: {
      "type": "checkbox",
      "name": "timezoneAdjustToDST"
    },
    domProps: {
      "checked": Array.isArray(_vm.timezoneAdjustToDST) ? _vm._i(_vm.timezoneAdjustToDST, null) > -1 : (_vm.timezoneAdjustToDST)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.timezoneAdjustToDST,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.timezoneAdjustToDST = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.timezoneAdjustToDST = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.timezoneAdjustToDST = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Adjust to Daylight Saving Time")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "dailydigesttime ui selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "digestTime"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Daily Digest Time")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "0"
    }
  }, [_vm._v("12am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_vm._v("1am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_vm._v("2am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_vm._v("3am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_vm._v("4am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "5"
    }
  }, [_vm._v("5am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "6"
    }
  }, [_vm._v("6am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7"
    }
  }, [_vm._v("7am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "8"
    }
  }, [_vm._v("8am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "9"
    }
  }, [_vm._v("9am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "10"
    }
  }, [_vm._v("10am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "11"
    }
  }, [_vm._v("11am")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "12"
    }
  }, [_vm._v("12pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "13"
    }
  }, [_vm._v("1pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "14"
    }
  }, [_vm._v("2pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "15"
    }
  }, [_vm._v("3pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "16"
    }
  }, [_vm._v("4pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "17"
    }
  }, [_vm._v("5pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "18"
    }
  }, [_vm._v("6pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "19"
    }
  }, [_vm._v("7pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "20"
    }
  }, [_vm._v("8pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "21"
    }
  }, [_vm._v("9pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "22"
    }
  }, [_vm._v("10pm")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "23"
    }
  }, [_vm._v("11pm")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "timezone ui selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-12"
    }
  }, [_vm._v("UTC-12 (Baker Island)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-11"
    }
  }, [_vm._v("UTC-11 (Niue)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-10"
    }
  }, [_vm._v("UTC-10 (Honolulu, Tahiti)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-9"
    }
  }, [_vm._v("UTC-09 (Alaska)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-8"
    }
  }, [_vm._v("UTC-08 (Los Angeles, Seattle, Vancouver)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-7"
    }
  }, [_vm._v("UTC-07 (Denver, Edmonton, Tijuana)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-6"
    }
  }, [_vm._v("UTC-06 (Austin, Chicago, Mexico City, Milwaukee)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-5"
    }
  }, [_vm._v("UTC-05 (Lima, New York, Miami, Montreal)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-4"
    }
  }, [_vm._v("UTC-04 (Caracas, Halifax)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-3"
    }
  }, [_vm._v("UTC-03 (Buenos Aires, Montevideo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-2"
    }
  }, [_vm._v("UTC-02 (Rio de Janeiro, São Paulo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    }
  }, [_vm._v("UTC-01")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "0"
    }
  }, [_vm._v("UTC+00 (London, Lisbon, Reykjavik)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_vm._v("UTC+01 (Amsterdam, Berlin, Oslo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_vm._v("UTC+02 (Athens, Cairo, Helsinki, Johannesburg)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_vm._v("UTC+03 (Istanbul, Moscow, Madagascar)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_vm._v("UTC+04 (Dubai, Tbilisi)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "5"
    }
  }, [_vm._v("UTC+05 (Lahore, Yekaterinburg)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "6"
    }
  }, [_vm._v("UTC+06 (Almaty, Kathmandu)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7"
    }
  }, [_vm._v("UTC+07 (Bangkok, Jakarta)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "8"
    }
  }, [_vm._v("UTC+08 (Beijing, Hong Kong, Kuala Lumpur, Perth)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "9"
    }
  }, [_vm._v("UTC+09 (Seoul, Tokyo)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "10"
    }
  }, [_vm._v("UTC+10 (Vladivostok)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "11"
    }
  }, [_vm._v("UTC+11 (Melbourne, Sydney)")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "12"
    }
  }, [_vm._v("UTC+12 (Auckland)")])])])])
}]}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-sidebar"
  }, [_c('div', {
    staticClass: "alert-sidebar-header"
  }, [_vm._v("ALERT CATEGORIES")]), _vm._v(" "), _c('div', {
    staticClass: "alert-sidebar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "alert-sidebar-item",
    class: {
      active: _vm.activeCategory === '' || _vm.activeCategory === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.selectCategory('all')
      }
    }
  }, [_c('i', {
    staticClass: "bell icon alert-sidebar-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "alert-sidebar-name"
  }, [_vm._v("All Alerts")]), _vm._v(" "), _c('span', {
    class: ['alert-sidebar-count', 'notranslate', _vm.totalCountClass],
    attrs: {
      "translate": "no"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.totalCount) + "\n    ")])]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "alert-sidebar-group"
    }, [_c('div', {
      staticClass: "alert-sidebar-group-header"
    }, [_c('span', {
      staticClass: "alert-sidebar-group-name"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _vm._l((group.badges), function(badge) {
      return _c('span', {
        key: badge.text,
        class: ['alert-sidebar-badge', 'badge-' + badge.color]
      }, [_vm._v("\n        " + _vm._s(badge.text) + "\n      ")])
    })], 2), _vm._v(" "), _vm._l((group.items), function(item) {
      return _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isVisible(item)),
          expression: "isVisible(item)"
        }],
        key: item.id,
        class: ['alert-sidebar-item', {
          active: _vm.activeCategory === item.id
        }],
        on: {
          "click": function($event) {
            return _vm.selectCategory(item.id)
          }
        }
      }, [_c('i', {
        class: item.icon + ' icon alert-sidebar-icon'
      }), _vm._v(" "), _c('span', {
        staticClass: "alert-sidebar-name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        class: ['alert-sidebar-count', 'notranslate', _vm.countClass(item.id)],
        attrs: {
          "translate": "no"
        }
      }, [_vm._v("\n        " + _vm._s(_vm.displayCount(item.id)) + "\n      ")])])
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('div', {
    staticClass: "product-details-page"
  }, [_c('div', {
    staticClass: "product-details-content"
  }, [(!_vm.loading && !_vm.error && _vm.product) ? _c('div', {
    staticClass: "product-details-back-wrap"
  }, [_c('button', {
    staticClass: "product-details-back-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navigateBackToList
    }
  }, [_vm._v("\n        ← " + _vm._s(_vm.backNavigationLabel) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "ui active loader"
  }), _vm._v(" "), _c('p', [_vm._v("Loading product details...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-container"
  }, [_c('i', {
    staticClass: "exclamation triangle huge icon"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "error-actions"
  }, [_c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.goToAlerts
    }
  }, [_vm._v("View All Alerts")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Go Back")])])]) : (_vm.product) ? _c('div', {
    staticClass: "product-content-grid"
  }, [_c('div', {
    staticClass: "grid-full"
  }, [_c('ProductHeader', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full"
  }, [_c('CurrentOffers', {
    attrs: {
      "offers": _vm.product.currentOffers,
      "marketplace": _vm.product.marketplace
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full"
  }, [_c('SalesVolumeChart', {
    attrs: {
      "salesData": _vm.product.salesVolume,
      "marketplace": _vm.product.marketplace
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full",
    class: {
      'two-column': _vm.reviewHealthVisible
    }
  }, [_c('ListingSignals', {
    attrs: {
      "signals": _vm.product.listingSignals
    }
  }), _vm._v(" "), (_vm.reviewHealthVisible) ? _c('ReviewHealth', {
    attrs: {
      "reviewHealth": _vm.product.reviewHealth
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full two-column"
  }, [_c('AccountHealth', {
    attrs: {
      "accountHealth": _vm.product.accountHealth,
      "isFeaturedMerchant": _vm.product.isFeaturedMerchant
    }
  }), _vm._v(" "), _c('RecentEvents', {
    attrs: {
      "events": _vm.product.recentEvents
    },
    on: {
      "period-changed": _vm.handleRecentEventsPeriodChange
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-layout",
    class: {
      'has-top-strips': _vm.hasTopStrips,
      'trial-lockout-active': _vm.subscriptionLockoutActive
    },
    style: (_vm.hasTopStrips ? {
      '--strip-h': _vm.topStripHeight + 'px'
    } : null)
  }, [(_vm.verifyStripContent) ? _c('TrialStrip', {
    attrs: {
      "content": _vm.verifyStripContent,
      "offset-top": 0
    },
    on: {
      "cta": _vm.onVerifyStripCta
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trialStripContent) ? _c('TrialStrip', {
    attrs: {
      "content": _vm.trialStripContent,
      "offset-top": _vm.hasVerifyStripVisible ? 40 : 0
    },
    on: {
      "dismiss": function($event) {
        _vm.trialStripDismissed = true
      },
      "cta": _vm.onTrialStripCta
    }
  }) : _vm._e(), _vm._v(" "), _c('TopNavbar', {
    attrs: {
      "lastUpdated": _vm.lastUpdated,
      "userEmail": _vm.$root.userEmail || ''
    }
  }, [_c('template', {
    slot: "filters"
  }, [_vm._t("navbarFilters")], 2)], 2), _vm._v(" "), _c('DashboardSidebar', {
    attrs: {
      "items": _vm.sidebarItems,
      "currentPath": _vm.$route.path,
      "disabled": !_vm.onboardingComplete
    },
    on: {
      "navigate": _vm.navigateTo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.cancelLockoutActive) ? _c('CanceledLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : (_vm.pastDueLockoutActive && !_vm.billingPaymentModalFlowActive) ? _c('PastDueLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : (_vm.trialLockoutActive) ? _c('TrialLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "div",
      "id": "inventoryList"
    }
  }, [_c('table', {
    key: 'setupAlerts',
    staticClass: "ui very compact table",
    staticStyle: {
      "border-bottom-left-radius": "0",
      "border-bottom-right-radius": "0"
    }
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup FBA Inventory Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBA Inventory',
      "api-prefix": 'inventory'
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup FBM Inventory Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBM Inventory',
      "api-prefix": 'fbm_inventory'
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup Sales Volume Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'Sales Volume',
      "api-prefix": 'salesdrop'
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    key: 'productsStock',
    staticClass: "horizontal-scroll-container",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "ui very compact table",
    staticStyle: {
      "border-top-left-radius": "0",
      "border-top-right-radius": "0",
      "background-color": "transparent"
    }
  }, _vm._l((_vm.sortedUnfoldedProducts), function(product) {
    return ((_vm.$parent.filterByMarket.length == 0 || _vm.$parent.filterByMarket.indexOf(product.marketplace) >= 0) && (_vm.$parent.filterBySellAcc.length == 0 || _vm.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0) && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('tr', {
      key: product.productId,
      attrs: {
        "set": _vm.fbmItem = _vm.getFbmItem(product.productId)
      }
    }, [_c('td', {
      staticClass: "ui collapsing "
    }, [_c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag'
    }), _vm._v(" "), _c('small', [_c('a', {
      attrs: {
        "href": "#",
        "qqstyle": "text-decoration:underline;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1")) + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "ui collapsing"
    }, [_c('img', {
      staticClass: "ui image tiny",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": product.largeImageUrl
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProductDetails(product.productId)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: " four wide "
    }, [_c('div', {
      staticStyle: {
        "max-height": "5.5em",
        "overflow": "hidden"
      }
    }, [_vm._v("\n            " + _vm._s(product.productTitle) + "\n          ")])]), _vm._v(" "), (product.ageHours > -1) ? _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_c('div', {
      staticClass: "salesQuickInfo",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-html": '<img src=\'/api/sentinel/watchdog/salesdropchart/' + _vm.$parent.$parent.worldStore.watchDogs.salesDrop.items[product.productId].watchDogId + '\' style=\'height:200px;\'/>'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(product.salesYesterday))]), _vm._v("  units sold ystd. "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(product.salesToday))]), _vm._v("  so far today (" + _vm._s(product.marketplace) + ")\n          ")])]) : _c('td', {}, [_c('i', {
      staticClass: "dollar icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n          Sales data not avail. yet\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres') >= 0) ? _c('i', {
      staticClass: "large icons",
      attrs: {
        "data-tooltip": "No alert thresholds have been set yet. Use setup at the top."
      }
    }, [_c('i', {
      staticClass: "warehouse grey icon",
      staticStyle: {
        "opacity": ".4"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "yellow inverted corner exclamation triangle icon",
      staticStyle: {
        "opacity": ".4"
      }
    })]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 0) ? _c('i', {
      staticClass: "large green checkmark icon"
    }) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 1) ? _c('i', {}, [_c('i', {
      staticClass: "large orange exclamation triangle icon"
    })]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 2) ? _c('i', {}, [_c('i', {
      staticClass: "large red exclamation triangle icon"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(product.inboundQty > 0) ? _c('div', {
      staticStyle: {
        "line-height": "1.5em"
      }
    }, [_vm._v("\n            FBA Total inv.:  "), _c('strong', [_vm._v(_vm._s(product.totalQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Available:        "), _c('strong', [_vm._v(_vm._s(product.inStockQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Inbound:     "), _c('strong', [_vm._v(_vm._s(product.inboundQty))])]) : _c('div', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n            FBA Total inv.:  "), _c('strong', [_vm._v(_vm._s(product.totalQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Available:        "), _c('strong', [_vm._v(_vm._s(product.inStockQty))])])]), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status > 0) ? _c('td', {
      staticClass: "collapsing"
    }, [(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres') === -1) ? _c('span', {
      staticStyle: {
        "color": "#b33"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace(/(\d+)/gi, '<b style=\'color:#444;\'>$1</b>').replace('; est.', '.<br>Est.'))
      }
    }) : (product.totalQty == 0) ? _c('span', {
      staticStyle: {
        "color": "#b33"
      }
    }, [_vm._v("\n          Out of Stock\n        ")]) : _vm._e()]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.match(/.*days left.*/)) ? _c('td', {
      staticClass: "collapsing"
    }, [_c('h3', {
      staticClass: "ui header"
    }, [_c('span', {
      staticStyle: {
        "color": "purple"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*days left: (\d*).*/, '$1')) + "\n          ")]), _vm._v(" days left\n            "), _c('div', {
      staticClass: "sub header"
    }, [_vm._v("\n              based on last\n              " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].settings.velocityLookbackDays) + "d\n            ")])])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(_vm.fbmItem === null || _vm.fbmItem.alertThreshold === null) ? _c('i', {
      staticClass: "large icons",
      attrs: {
        "data-tooltip": "No alert thresholds have been set yet. Use setup at the top."
      }
    }, [_c('i', {
      staticClass: "warehouse grey icon",
      staticStyle: {
        "opacity": ".4"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "yellow inverted corner exclamation triangle icon",
      staticStyle: {
        "opacity": ".4"
      }
    })]) : (!_vm.fbmItem.hasIssue) ? _c('i', {
      staticClass: "large green checkmark icon"
    }) : _c('i', {}, [_c('i', {
      staticClass: "large red exclamation triangle icon"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "padding-right": "30px"
      }
    }, [(_vm.fbmItem) ? _c('div', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n            FBM Total inv.:    "), _c('strong', [_vm._v(_vm._s(product.fbmQty ? product.fbmQty : 0))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.fbmItem.alertThreshold) ? _c('span', [_vm._v("FBM Threshold:        "), _c('strong', [_vm._v(_vm._s(_vm.fbmItem.alertThreshold))])]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-category-card",
    class: {
      'has-right-side': _vm.showRightSide,
      'has-thresholds-expanded': _vm.showAlertThresholds,
      'is-row-clickable': _vm.routeProductId,
      'is-highlighted': _vm.isHighlighted
    },
    attrs: {
      "data-alert-id": _vm.alertDomId,
      "tabindex": _vm.routeProductId ? 0 : -1
    },
    on: {
      "click": _vm.openProductDetails,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.openProductDetails.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.openProductDetails.apply(null, arguments)
      }]
    }
  }, [_c('div', {
    staticClass: "issues-category-card-left"
  }, [_c('div', {
    staticClass: "issues-category-card-icon",
    class: _vm.statusClass
  }, [(_vm.statusClass === 'resolved') ? _c('i', {
    staticClass: "check icon"
  }) : (_vm.statusClass === 'ok') ? _c('i', {
    staticClass: "check icon"
  }) : (_vm.statusClass === 'suppressed') ? _c('i', {
    staticClass: "ban icon"
  }) : (_vm.statusClass === 'alert') ? _c('i', {
    staticClass: "ban icon"
  }) : (_vm.statusClass === 'rotating') ? _c('i', {
    staticClass: "sync alternate icon"
  }) : (_vm.statusClass === 'lost') ? _c('i', {
    staticClass: "time icon"
  }) : _c('i', {
    staticClass: "time icon"
  })]), _vm._v(" "), (_vm.productThumbUrl) ? [_c('img', {
    staticClass: "issues-category-card-thumb",
    attrs: {
      "src": _vm.productThumbUrl,
      "alt": "",
      "loading": "lazy",
      "decoding": "async"
    }
  })] : _c('div', {
    staticClass: "issues-category-card-thumb-placeholder",
    class: {
      'is-clickable': _vm.routeProductId
    }
  }, [_c('i', {
    staticClass: "image icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-product"
  }, [_c('span', {
    staticClass: "issues-category-card-title"
  }, [_c('span', {
    staticClass: "issues-category-card-title-text",
    class: {
      'issues-category-card-title-link': _vm.routeProductId
    }
  }, [_vm._v(_vm._s(_vm.productTitle))])]), _vm._v(" "), (_vm.displayAsin) ? _c('span', {
    staticClass: "issues-category-card-asin"
  }, [_vm._v(_vm._s(_vm.feeSku ? _vm.feeSku + ' · ' + _vm.displayAsin : _vm.displayAsin))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: ['issues-category-card-status', _vm.statusClass]
  }, [_vm._v(_vm._s(_vm.statusLabel))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-marketplace",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.marketplaceCode) ? _c('button', {
    staticClass: "issues-marketplace-chip",
    class: {
      'is-filtered': _vm.marketplaceFilterActive
    },
    attrs: {
      "type": "button",
      "title": 'Filter alerts to ' + _vm.marketplaceLabel
    },
    on: {
      "click": _vm.onMarketplaceChipClick
    }
  }, [_c('i', {
    class: _vm.marketplaceFlagClass
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))])]) : _c('span', {
    staticClass: "issues-marketplace-empty"
  }, [_vm._v("—")])]), _vm._v(" "), (_vm.showRightSide) ? [_c('div', {
    staticClass: "issues-category-card-right"
  }, [(_vm.changeDescriptionTableRows) ? [_c('div', {
    staticClass: "issues-change-desc-table-wrap"
  }, [_c('table', {
    staticClass: "issues-change-desc-table",
    attrs: {
      "role": "grid",
      "aria-label": "Listing changes"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.changeDescriptionTableRows), function(row, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "issues-change-desc-field"
    }, [_vm._v(_vm._s(row.field))]), _vm._v(" "), _c('td', {
      staticClass: "issues-change-desc-cell",
      attrs: {
        "title": row.beforeTitle ? row.beforeTitle : undefined
      }
    }, [_vm._v(_vm._s(row.beforeDisplay))]), _vm._v(" "), _c('td', {
      staticClass: "issues-change-desc-cell",
      attrs: {
        "title": row.afterTitle ? row.afterTitle : undefined
      }
    }, [_vm._v(_vm._s(row.afterDisplay))])])
  }), 0)])])] : (_vm.reviewHealthInfo) ? _c('div', {
    staticClass: "issues-category-card-message issues-review-health"
  }, [_vm._l((_vm.reviewHealthInfo.rows), function(row) {
    return _c('div', {
      key: row.reason,
      staticClass: "issues-review-health-row"
    }, [_vm._v(_vm._s(row.text))])
  }), _vm._v(" "), (!_vm.reviewHealthInfo.rows.length && _vm.item.statusDetails && _vm.item.statusDetails.message) ? _c('div', {
    staticClass: "issues-review-health-row"
  }, [_vm._v(_vm._s(_vm.item.statusDetails.message))]) : _vm._e(), _vm._v(" "), (_vm.reviewHealthInfo.variationAsins.length) ? _c('div', {
    staticClass: "issues-review-health-variations"
  }, [_vm._v("Also affects " + _vm._s(_vm.reviewHealthInfo.variationAsins.length) + " variation" + _vm._s(_vm.reviewHealthInfo.variationAsins.length === 1 ? '' : 's') + ": " + _vm._s(_vm.reviewHealthInfo.variationAsins.join(', ')))]) : _vm._e()], 2) : _c('div', {
    staticClass: "issues-category-card-message"
  }, [_vm._v("\n        " + _vm._s(_vm.item.statusDetails && _vm.item.statusDetails.message ? _vm.item.statusDetails.message : '') + "\n        "), (_vm.feeReason) ? _c('div', {
    staticClass: "issues-fee-reason",
    class: 'is-' + _vm.feeReason.tone
  }, [(_vm.feeReason.lead) ? _c('span', {
    staticClass: "issues-fee-reason-lead"
  }, [_vm._v(_vm._s(_vm.feeReason.lead))]) : _vm._e(), _vm._v(_vm._s(_vm.feeReason.rest) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-actions",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.sellerCentralUrl) ? _c('a', {
    staticClass: "issues-category-card-btn issues-category-card-btn-orange",
    attrs: {
      "href": _vm.sellerCentralUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          View in Seller Central\n        ")]) : _vm._e(), _vm._v(" "), (_vm.viewUrl) ? _c('a', {
    staticClass: "issues-category-card-btn",
    class: _vm.sellerCentralUrl ? 'issues-category-card-btn-blue' : 'issues-category-card-btn-orange',
    attrs: {
      "href": _vm.viewUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.viewUrlLabel) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feeClaimDownloadUrl) ? _c('a', {
    staticClass: "issues-category-card-btn issues-category-card-btn-green",
    attrs: {
      "href": _vm.feeClaimDownloadUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          Download orders\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showMarkResolvedButton) ? _c('button', {
    staticClass: "issues-category-card-btn issues-category-card-btn-resolve",
    attrs: {
      "type": "button",
      "disabled": _vm.markResolveBusy
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('mark-resolved', _vm.item)
      }
    }
  }, [_vm._v("\n          Mark as resolved\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showAlertThresholdsButton) ? _c('button', {
    staticClass: "issues-category-card-btn issues-category-card-btn-settings",
    class: {
      active: _vm.showAlertThresholds
    },
    attrs: {
      "title": "Alert thresholds"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAlertThresholds.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "cog icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.item.muted) ? _c('a', {
    staticClass: "issues-category-card-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mute(-1)
      }
    }
  }, [_vm._v("Un-mute")]) : _vm._e()])], 2), _vm._v(" "), (_vm.item.date) ? _c('div', {
    staticClass: "issues-category-card-date"
  }, [_vm._v("\n      " + _vm._s(_vm.formatDate(_vm.item.date)) + "\n    ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showAlertThresholds && _vm.showAlertThresholdsButton) ? _c('div', {
    staticClass: "issues-category-card-thresholds",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.wdtype === 'inventory') ? _c('AlertThresholdsInline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "marketplace": _vm.item.marketplace || '',
      "stock-thresholds-api-base": _vm.stockAlertThresholdsApiBaseUrl,
      "api-base-url": _vm.apiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : (_vm.wdtype === 'fbmInventory') ? _c('fbm-alert-thresholds-inline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "stock-thresholds-api-base": _vm.stockAlertThresholdsApiBaseUrl,
      "api-base-url": _vm.apiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : (_vm.wdtype === 'salesDrop') ? _c('sales-volume-thresholds-inline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "marketplace": _vm.item.marketplace || '',
      "sales-volume-thresholds-api-base": _vm.salesVolumeThresholdsApiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Before")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("After")])])])
}]}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertOnCategoryTypeNameChange),
      expression: "alertOnCategoryTypeNameChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox312455"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertOnCategoryTypeNameChange) ? _vm._i(_vm.alertOnCategoryTypeNameChange, null) > -1 : (_vm.alertOnCategoryTypeNameChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertOnCategoryTypeNameChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertOnCategoryTypeNameChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertOnCategoryTypeNameChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertOnCategoryTypeNameChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox312455"
    }
  }, [_vm._v("\n                Main Category: Alert if Product Type changes\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertOnCategoryGroupChange),
      expression: "alertOnCategoryGroupChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox312456"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertOnCategoryGroupChange) ? _vm._i(_vm.alertOnCategoryGroupChange, null) > -1 : (_vm.alertOnCategoryGroupChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertOnCategoryGroupChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertOnCategoryGroupChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertOnCategoryGroupChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertOnCategoryGroupChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox312456"
    }
  }, [_vm._v("\n                Main Category: Alert if Product Group changes\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
}]}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table-view"
  }, [_c('table', {
    staticClass: "ui very basic table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      staticClass: "product-row"
    }, [_c('td', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-info"
    }, [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": product.largeImageUrl || '/placeholder.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-details"
    }, [_c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "product-title",
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_vm._v("\n                " + _vm._s(product.productTitle) + "\n              ")])])])]), _vm._v(" "), _c('td', {
      staticClass: "sales-cell"
    }, [_c('div', {
      staticClass: "sales-info"
    }, [_c('div', [_vm._v(_vm._s(_vm.salesCountTotal([product.productId], 'y')) + " units sold ystd.")]), _vm._v(" "), _c('div', {
      staticClass: "sales-today"
    }, [_vm._v(_vm._s(_vm.salesCountTotal([product.productId], 't')) + " so far today (" + _vm._s(product.marketplace.toUpperCase()) + ")")])])]), _vm._v(" "), _c('td', {
      staticClass: "cogs-cell"
    }, [(product.cogs && product.cogs > 0) ? _c('div', {
      staticClass: "cogs-value"
    }, [_vm._v("\n            $" + _vm._s(_vm.formatPrice(product.cogs)) + "\n          ")]) : _c('div', {
      staticClass: "cogs-empty"
    }, [_c('span', {
      staticClass: "empty-dash"
    }, [_vm._v("—")]), _vm._v(" "), _c('button', {
      staticClass: "add-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add")])])]), _vm._v(" "), _c('td', {
      staticClass: "margin-cell"
    }, [(product.cogs && product.cogs > 0 && product.buyBoxPrice) ? _c('span', {
      staticClass: "margin-value",
      class: _vm.getMarginClass(_vm.calculateMargin(product))
    }, [_vm._v("\n            " + _vm._s(_vm.calculateMargin(product)) + "%\n          ")]) : _c('span', {
      staticClass: "margin-empty"
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
      staticClass: "actions-cell"
    }, [_c('button', {
      staticClass: "ui icon button mini",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openChartModal(product)
        }
      }
    }, [_c('i', {
      staticClass: "chart bar icon"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v("\n      Showing " + _vm._s(_vm.startItem) + " - " + _vm._s(_vm.endItem) + " of " + _vm._s(_vm.totalItems) + " products\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((_vm.visiblePages), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page + 1) + "\n      ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "tableCogsModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Set COGS for Product")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Product")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cogsModalProduct ? _vm.cogsModalProduct.productTitle : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("COGS (Cost of Goods Sold) $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cogsInput),
      expression: "cogsInput"
    }],
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "Enter COGS amount"
    },
    domProps: {
      "value": (_vm.cogsInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveCogs.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cogsInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.cogsInput && _vm.cogsModalProduct && _vm.cogsModalProduct.buyBoxPrice) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Preview")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("COGS:")]), _vm._v(" $" + _vm._s(_vm.formatPrice(parseFloat(_vm.cogsInput) || 0))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Box Price:")]), _vm._v(" $" + _vm._s(_vm.formatPrice(_vm.cogsModalProduct.buyBoxPrice))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Margin:")]), _vm._v(" " + _vm._s(_vm.calculateMarginFromCogs(parseFloat(_vm.cogsInput) || 0, _vm.cogsModalProduct.buyBoxPrice)) + "%\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui cancel button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.savingCogs
    },
    on: {
      "click": _vm.saveCogs
    }
  }, [_vm._v("\n        Save\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "product-column"
  }, [_vm._v("PRODUCT")]), _vm._v(" "), _c('th', {
    staticClass: "sales-column"
  }, [_vm._v("SALES")]), _vm._v(" "), _c('th', {
    staticClass: "cogs-column highlighted"
  }, [_vm._v("COGS")]), _vm._v(" "), _c('th', {
    staticClass: "margin-column highlighted"
  }, [_vm._v("MARGIN")]), _vm._v(" "), _c('th', {
    staticClass: "actions-column"
  })])])
}]}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-reset-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('router-link', {
    staticClass: "sk-logo",
    attrs: {
      "to": "/login"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z",
      "fill": "#F5841F",
      "opacity": "0.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z",
      "stroke": "#F5841F",
      "stroke-width": "1.5",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11 16l3.5 3.5L21 12",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "sk-logo-text"
  }, [_vm._v("SentryKit")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Verify email")]), _vm._v(" "), (_vm.working) ? _c('p', [_vm._v("Confirming your email address…")]) : (!_vm.token || !_vm.email) ? _c('p', [_vm._v("This link is missing required parameters.")]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.working) ? _c('div', {
    staticClass: "sk-login-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-thresholds-inline fba-thresholds-inline"
  }, [_c('div', {
    staticClass: "fba-inline-title"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v(" "), _c('span', [_vm._v("Alert Thresholds — " + _vm._s(_vm.productTitle) + " · " + _vm._s(_vm.marketplaceLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-fields"
  }, [_c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Warning (units)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.amberThreshold),
      expression: "form.amberThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.amberThreshold)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.amberThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amberThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("units left")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Alert (units)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redThreshold),
      expression: "form.redThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.redThreshold)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("units left")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Warning (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.amberDays),
      expression: "form.amberDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.amberDays)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.amberDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amberDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days of stock")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Alert (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redDays),
      expression: "form.redDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.redDays)],
    attrs: {
      "type": "number",
      "min": "-1",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days of stock")])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-field"
  }, [_c('label', [_vm._v("Avg interval")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.velocityLookbackDays),
      expression: "form.velocityLookbackDays",
      modifiers: {
        "number": true
      }
    }],
    class: ['fba-inline-input', _vm.inputFilledClass(_vm.form.velocityLookbackDays)],
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "14",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.velocityLookbackDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "velocityLookbackDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fba-field-hint"
  }, [_vm._v("days for avg")])])]), _vm._v(" "), _c('div', {
    staticClass: "fba-inline-actions"
  }, [_c('button', {
    staticClass: "fba-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.resolvedProductId
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "fba-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "fba-inline-hint"
  }, [_vm._v("Leave blank to use account defaults.")])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "alert-thresholds-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "alert-thresholds-loading"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Saving…\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.isSellerSelected(sa.sellerId)
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.isSellerSelected(sa.sellerId)) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-alerts-page"
  }, [_c('div', {
    staticClass: "alerts-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading issues...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load issues")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.fetchIssues
    }
  }, [_vm._v("Retry")])]) : [_c('div', {
    staticClass: "alerts-header"
  }, [_c('div', {
    staticClass: "header-info"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Issues")]), _vm._v(" "), _c('span', {
    staticClass: "total-count"
  }, [_vm._v(_vm._s(_vm.totalAlerts) + " total alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "filter-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suppressed"
    }
  }, [_vm._v("Suppressed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost"
    }
  }, [_vm._v("Lost to Competitor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "contested"
    }
  }, [_vm._v("Contested")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "owned"
    }
  }, [_vm._v("Owned")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search alerts..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "export-button",
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n          " + _vm._s(_vm.exporting ? 'Exporting…' : 'Export CSV') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "alerts-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("PRODUCT")]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.sortHeadClass('status'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Status"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSort('status')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSort('status')
      }
    }
  }, [_vm._v("\n                STATUS\n                "), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.sortBy === 'status' && _vm.sortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.sortBy === 'status' && _vm.sortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.sortHeadClass('impact'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Est. Daily"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSort('impact')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSort('impact')
      }
    }
  }, [_vm._v("\n                EST. DAILY\n                "), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.sortBy === 'impact' && _vm.sortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.sortBy === 'impact' && _vm.sortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', [_vm._v("ACTION")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedAlerts), function(alert, index) {
    return _c('tr', {
      key: index,
      staticClass: "alert-row"
    }, [_c('td', {
      staticClass: "product-cell",
      on: {
        "click": function($event) {
          return _vm.viewProductDetails(alert.productId || alert.id)
        }
      }
    }, [_c('div', {
      staticClass: "product-image-wrap"
    }, [_c('div', {
      staticClass: "product-image-placeholder"
    }), _vm._v(" "), (alert.imageUrl) ? _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": alert.imageUrl,
        "alt": alert.product
      },
      on: {
        "error": function (e) { return e.target.style.display = 'none'; }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name-line"
    }, [_c('span', {
      staticClass: "product-name clickable"
    }, [_vm._v(_vm._s(alert.product))])]), _vm._v(" "), (alert.asin) ? _c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(alert.asin))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "status-cell"
    }, [_c('span', {
      staticClass: "alert-status",
      class: alert.statusType
    }, [_vm._v(_vm._s(alert.status))])]), _vm._v(" "), _c('td', {
      staticClass: "impact-cell"
    }, [_c('span', {
      staticClass: "impact-value",
      class: alert.impactClass
    }, [_vm._v(_vm._s(alert.impact))])]), _vm._v(" "), _c('td', {
      staticClass: "action-cell"
    }, [_c('a', {
      staticClass: "view-details-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleActionButton(alert)
        }
      }
    }, [_vm._v("\n                View Details >\n              ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v("\n        Showing " + _vm._s(_vm.startIndex + 1) + "-" + _vm._s(_vm.endIndex) + " of " + _vm._s(_vm.totalAlerts) + " alerts\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-controls"
  }, [_c('button', {
    staticClass: "pagination-button",
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('i', {
    staticClass: "chevron left icon"
  }), _vm._v("\n          Previous\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-numbers"
  }, _vm._l((_vm.visiblePages), function(page) {
    return _c('button', {
      key: page,
      class: ['page-number', {
        active: page === _vm.currentPage
      }],
      on: {
        "click": function($event) {
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n          ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "pagination-button",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n          Next\n          "), _c('i', {
    staticClass: "chevron right icon"
  })])])])]], 2)])], 2)
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui card",
    class: {
      hasalert: (_vm.wdSorted['red'].length > 0 || _vm.wdSorted['mute'].length > 0),
      stts21kdfslds: (_vm.wd.status == 21)
    },
    attrs: {
      "data-wdtype": _vm.wdtype
    },
    on: {
      "mouseover": function($event) {
        return _vm.hoverState(true)
      },
      "mouseleave": _vm.handleMouseLeave,
      "mouseenter": _vm.handleMouseEnter,
      "mousemove": _vm.handleMouseMove
    }
  }, [(_vm.showSuppressedMsg && _vm.isSuppressed) ? _c('div', {
    staticClass: "suppressed-tooltip",
    style: ({
      top: _vm.tooltipY + 'px',
      left: _vm.tooltipX + 'px'
    })
  }, [_vm._v("\n       Upgrade your plan to unlock this alert and access all 25+ critical notifications\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'greyed-out-card': _vm.isSuppressed
    }
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-shadow": "1px 1px 2px #DDD",
      "font-size": "24px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAlertCount > 0),
      expression: "newAlertCount>0"
    }],
    staticClass: "ui red horizontal label",
    staticStyle: {
      "text-shadow": "none",
      "padding": "5px 6px 4px",
      "margin": "-21px",
      "position": "absolute"
    }
  }, [_vm._v(_vm._s(_vm.newAlertCount) + " new")]), _vm._v(" "), _c('i', {
    class: (_vm.wd.status === 0 ? 'green' : 'orange') + ' power icon'
  }), _vm._v("\n\n      " + _vm._s(_vm.wdInfo[_vm.wdtype].name) + "\n      "), (_vm.wd.status === 20) ? _c('span', [_vm._v("[preview]")]) : _vm._e(), _vm._v("\n\n       "), (_vm.isConfigurable) ? _c('a', {
    staticStyle: {
      "color": "steelblue",
      "font-size": "small",
      "font-weight": "normal",
      "text-shadow": "none"
    },
    on: {
      "click": function($event) {
        _vm.showConfiguration = !_vm.showConfiguration
      }
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v("Configure\n      ")]) : _vm._e()]), _vm._v(" "), _c('small', {
    staticClass: "cchfreq"
  }, [_vm._v(" current check frequency: " + _vm._s(_vm.wdInfo[_vm.wdtype].ccf) + " ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off",
      "onsubmit": "return false;"
    }
  }, [(!_vm.accountLevelWd) ? _c('div', {
    staticClass: "ui mini right icon input",
    staticStyle: {
      "position": "absolute",
      "top": "38px",
      "right": "15px"
    }
  }, [_c('div', {
    staticClass: "ui mini floating dropdown labeled icon button",
    style: (_vm.currentTab !== 1 ? 'display : none' : null)
  }, [_c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Filter")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.accountLevelWd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterString),
      expression: "filterString"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    staticStyle: {
      "padding": "4px"
    },
    style: (_vm.filterString ? 'background-color:lightsalmon;border:1px solid orange;' : ''),
    attrs: {
      "type": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.filterString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterString = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'muteRingAni': _vm.muteRingAni
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wdTabControls"
  }, [_vm._l((_vm.tabsToDisplay), function(x, i) {
    return _c('a', {
      class: 'ui small label ' + (_vm.currentTab == i ? _vm.wdl[x].color + ' actvtb' : '') + (_vm.wdSorted[x].length > 0 ? '' : ' disabled'),
      attrs: {
        "data-html": _vm.wdl[x].blurb,
        "data-variation": "inverted mini",
        "data-position": _vm.wdl[x].bpos
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentTab(i)
        }
      }
    }, [_c('i', {
      class: _vm.wdl[x].icon + ' icon ' + (_vm.currentTab != i ? _vm.wdl[x].color : '') + (_vm.wdSorted[x].length == 0 && (x == 'red' || x == 'amber') ? ' outline' : '')
    }), _vm._v("\n         " + _vm._s(_vm.wdSorted[x].length) + "\n      ")])
  }), _vm._v(" "), _c('a', {
    class: 'ui small label ' + (_vm.currentTab == 99 ? 'grey actvtb' : ''),
    on: {
      "click": function($event) {
        return _vm.setCurrentTab(99)
      }
    }
  }, [_vm._v("info 1")]), _vm._v(" "), (_vm.$parent.$parent.onboarding.wdtabs) ? _c('div', {
    staticClass: "onboarding ui left pointing large yellow label",
    staticStyle: {
      "position": "absolute",
      "padding-bottom": "9px",
      "margin-top": "4px",
      "z-index": "11"
    },
    attrs: {
      "data-onboarding": "wdtabs"
    }
  }, [_vm._v("\n        These are Tabs! - "), _c('small', [_vm._v("Click any of them to dismiss this note")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft"
    }
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAlertCount > 0 && _vm.currentTab == 1),
      expression: "newAlertCount>0&&currentTab==1"
    }],
    staticClass: "markAllSeen",
    on: {
      "click": function($event) {
        return _vm.markAllSeen(_vm.wdtype)
      }
    }
  }, [(_vm.markAllSeenInProgress) ? _c('i', {
    staticClass: "black tight notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        [mark all new as seen]\n      ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "wdTabCwrap"
  }, [_c('div', {
    staticClass: "shadow-top",
    class: {
      active: _vm.topShader
    }
  }), _vm._v(" "), _c('div', {
    class: 'wdTabC ui ' + (_vm.currentTab == 99 ? 'grey' : _vm.wdl[_vm.tabsToDisplay[_vm.currentTab]].color) + ' basic segment',
    style: (_vm.setWDCHeight()),
    on: {
      "mousewheel": _vm.fixScrolling,
      "scroll": _vm.setInnerShaders
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.showConfiguration && _vm.wdtype == 'amazonChoiceBadge') ? _c('AmazonChoiceBadgeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'starRatingRecentChange') ? _c('StarRatingRecentChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'productCategoryRecentChange') ? _c('CategoryChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'bestSellerBadge') ? _c('BestSellerBadgeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'listingSuspended') ? _c('ListingSuspendedConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'subscribeAndSave') ? _c('SubscribeAndSaveConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'parentProductChange') ? _c('ParentProductChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'inventory') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBA Stock',
      "api-prefix": 'inventory'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'fbmInventory') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBM Stock',
      "api-prefix": 'fbm_inventory'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'salesDrop') ? _c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'Sales Volume',
      "api-prefix": 'salesdrop'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'productDetailsRecentChange') ? _c('ProductDetailsRecentChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && _vm.wdtype == 'fbaFeeChange') ? _c('FBAFeeChangeConfig') : _vm._e(), _vm._v(" "), (_vm.showConfiguration && (_vm.wdtype == 'numberOfSellers' || _vm.wdtype == 'lostBuybox')) ? _c('StoreFrontWhiteListConfig', {
    attrs: {
      "watchDogType": _vm.wdtype
    }
  }) : (_vm.currentTab == 99) ? _c('div', {
    key: "99",
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui center aligned basic segment badges",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('a', {
    staticClass: "ui green tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 0
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.wdSorted.ok.length))]), _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "green check icon"
  }), _vm._v("OK")])]), _vm._v(" "), _c('a', {
    staticClass: "ui red tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 1
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.wdSorted.red.length) + " ")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Issues")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wdSorted.mute.length > 0),
      expression: "wdSorted.mute.length>0"
    }],
    staticClass: "ui blue tiny statistic",
    on: {
      "click": function($event) {
        _vm.currentTab = 2
      }
    }
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.wdSorted.mute.length))]), _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "mute alarm outline icon"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "nine wide column"
  }, [_c('div', {
    staticClass: "ui center aligned basic very padded segment",
    staticStyle: {
      "margin-top": "30px",
      "min-height": "150px",
      "border": "1px solid #eee",
      "border-radius": "6px"
    }
  }, [_c('span', {
    staticClass: "ui left corner label"
  }, [_c('i', {
    staticClass: "info circle icon"
  })]), _vm._v("\n             " + _vm._s(_vm.wdInfo[_vm.wdtype].desc) + "\n          ")])])]) : (_vm.currentTab !== 99) ? _c('div', {
    key: _vm.currentTab,
    staticClass: "ui list"
  }, [(_vm.wdSorted[_vm.tabsToDisplay[_vm.currentTab]].length == 0) ? _c('div', [_vm._v("\n                 \n          "), (_vm.tabsToDisplay[_vm.currentTab] == 'ok') ? _c('span', [_vm._v("No items to show")]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'red' && _vm.wdSorted.red.length == 0) ? _c('span', [_vm._v("No current Alerts")]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'mute') ? _c('span', [_vm._v("No Muted alerts or Alerts marked as Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterString !== '' || _vm.filterCategory !== '') ? _c('div', [(_vm.filteredResults(_vm.wdSorted[_vm.tabsToDisplay[_vm.currentTab]]).length == 0) ? _c('span', [_vm._v("No items match your filter, try a different one.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paginatedItems), function(item) {
    return _c('WatchdogItem', {
      key: item.watchDogItemId,
      attrs: {
        "item": item,
        "itemtype": _vm.tabsToDisplay[_vm.currentTab],
        "itemprops": _vm.wdl[_vm.tabsToDisplay[_vm.currentTab]],
        "wdtype": _vm.wdtype,
        "groupByParent": _vm.groupByParent,
        "detSel": _vm.detSel
      },
      on: {
        "muteRingAni": _vm.doMuteRingAni
      }
    })
  }), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin": "10px 0",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "ui mini pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.totalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getPageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui mini message",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + "\n            (" + _vm._s(_vm.totalItems) + " total items)\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.tabsToDisplay[_vm.currentTab] == 'red' && _vm.wdSorted.mute.length > 0) ? _c('a', {
    key: "rndmkey349857",
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.currentTab = 2
      }
    }
  }, [_c('i', {
    staticClass: "right blue warning icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "description"
  }, [((_vm.wdSorted.mute.length - _vm.muteCount) > 0) ? _c('span', [_vm._v("\n                You " + _vm._s(_vm.wdSorted.red.length > 0 ? 'also' : '') + " have "), _c('strong', [_vm._v(_vm._s(_vm.wdSorted.mute.length - _vm.muteCount))]), _vm._v(" issue" + _vm._s(_vm.wdSorted.mute.length > 1 ? 's' : '') + " marked as Done.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.muteCount > 0) ? _c('span', [_vm._v("\n                  "), _c('strong', [_vm._v(_vm._s(_vm.muteCount))]), _vm._v(" product" + _vm._s(_vm.muteCount > 1 ? 's' : '') + " on Mute.\n              ")]) : _vm._e()])])]) : _vm._e()], 2) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shadow-bottom",
    class: {
      active: _vm.bottomShader
    }
  })]), _vm._v(" "), ( false) ? _c('div', {
    staticClass: "extra content"
  }, [(_vm.isConfigurable) ? _c('div', {
    staticStyle: {
      "width": "160px",
      "float": "left"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showConfiguration = !_vm.showConfiguration
      }
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v("Configure")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui mini left icon input",
    staticStyle: {
      "margin": "-5px 0px -5px 5px",
      "float": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterString),
      expression: "filterString"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filter results..."
    },
    domProps: {
      "value": (_vm.filterString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  })]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterString),
      expression: "filterString"
    }],
    staticStyle: {
      "color": "orange",
      "float": "right"
    }
  }, [_vm._v("Current filter:")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Filter by issue status\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_c('i', {
    staticClass: "unhide icon"
  }), _vm._v("\n              Seen\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_c('i', {
    staticClass: "time icon"
  }), _vm._v("\n              In progress\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Filter by alert type\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_c('i', {
    staticClass: "orange circle icon"
  }), _vm._v("\n              Warning\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_c('i', {
    staticClass: "red circle icon"
  }), _vm._v("\n              Alert\n            ")])])
}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-header-card",
    class: _vm.statusType
  }, [_c('div', {
    staticClass: "status-tint"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.imageUrl,
      "alt": _vm.product.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('h1', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))]), _vm._v(" "), (_vm.product.brand) ? _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Brand: ")]), _vm._v(_vm._s(_vm.product.brand))]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "label"
  }, [_vm._v("ASIN: ")]), _vm._v(_vm._s(_vm.product.asin))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('span', {
    staticClass: "status-badge",
    class: _vm.statusType
  }, [(_vm.isWon) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]) : (_vm.isSuppressed) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.93",
      "y1": "4.93",
      "x2": "19.07",
      "y2": "19.07"
    }
  })]) : (_vm.isContested) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "17 1 21 5 17 9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 11V9a4 4 0 0 1 4-4h14"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 23 3 19 7 15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 13v2a4 4 0 0 1-4 4H3"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "5",
      "x2": "12",
      "y2": "19"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "19 12 12 19 5 12"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.product.status.label) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "product-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Your Price")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.product.pricing.yourPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        Buy Box Price\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.bbPriceClass
  }, [_vm._v(_vm._s(_vm.bbPriceDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.bbPriceSubClass
  }, [_vm._v(_vm._s(_vm.bbPriceSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        Price Gap\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.priceGapClass
  }, [_vm._v(_vm._s(_vm.priceGapDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.priceGapSubClass
  }, [_vm._v(_vm._s(_vm.priceGapSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        " + _vm._s(_vm.lossLabel) + "\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v(_vm._s(_vm.lossLabel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lossTooltipText))])])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value",
    class: _vm.lossValueClass
  }, [_vm._v(_vm._s(_vm.lossValueDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext",
    class: _vm.lossSubClass
  }, [_vm._v(_vm._s(_vm.lossSub))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("\n        FBA Stock\n        "), _c('span', {
    staticClass: "tooltip-trigger"
  }, [_c('svg', {
    staticClass: "info-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "stat-value success"
  }, [_vm._v(_vm._s(_vm.product.pricing.fbaStock))]), _vm._v(" "), _c('div', {
    staticClass: "stat-subtext"
  }, [_vm._v("Fulfillable: " + _vm._s(_vm.product.pricing.fbaStock) + " · Transferring: " + _vm._s(_vm.product.pricing.fbaTransferring || 0))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("Buy Box Price")]), _vm._v(" "), _c('p', [_vm._v("The landed price of the seller currently winning the Buy Box.")]), _vm._v(" "), _c('p', [_vm._v("Shows \"—\" when the Buy Box is suppressed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("Price Gap")]), _vm._v(" "), _c('p', [_vm._v("The difference between your price and the Buy Box price. A positive gap means you're priced higher.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v("FBA Stock")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Fulfillable:")]), _vm._v(" Ships today from FC.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Transferring:")]), _vm._v(" Moving between FCs — Amazon can still route orders to these units.")])])
}]}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-volume-configure-panel"
  }, [_c('div', {
    staticClass: "sales-volume-configure-header"
  }, [_c('div', [_c('div', {
    staticClass: "sales-volume-configure-title"
  }, [_vm._v("Sales Volume Alert Thresholds")]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-configure-subtitle"
  }, [_vm._v("\n        Listings and saved thresholds come from the API. Changes apply to all future alerts for that product.\n      ")]), _vm._v(" "), (_vm.listTotal > _vm.listRows.length) ? _c('div', {
    staticClass: "sales-volume-configure-cap-note"
  }, [_vm._v("\n        Showing " + _vm._s(_vm.listRows.length) + " of " + _vm._s(_vm.listTotal) + " listings (page " + _vm._s(_vm.listPage) + ").\n        Use Download CSV to edit the rest in bulk.\n      ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "sales-volume-configure-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), (_vm.thresholdsLoadError) ? _c('div', {
    staticClass: "sales-volume-thresholds-load-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.thresholdsLoadError) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-subtype-tabs"
  }, _vm._l((_vm.subtypeTabs), function(tab) {
    return _c('button', {
      key: tab.id,
      class: ['sales-volume-subtype-tab', {
        active: _vm.salesSubtype === tab.id
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.salesSubtype = tab.id
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-pane-body"
  }, [(_vm.salesSubtype === 'hours') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when a product has had no sales for this many consecutive hours. Default: 72 hrs.\n    ")]) : (_vm.salesSubtype === 'fixed') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Set absolute daily sales floor/ceiling. Alert fires when sales drop below or spike above these values.\n    ")]) : (_vm.salesSubtype === 'rolling') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when daily sales deviate from the rolling average by a percentage.\n    ")]) : (_vm.salesSubtype === 'bsr') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when Best Seller Rank spikes above this number (higher rank = fewer sales).\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-table-wrap"
  }, [_c('table', {
    staticClass: "sales-volume-settings-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-product"
  }, [_vm._v("Listing")]), _vm._v(" "), _c('th', {
    staticClass: "col-mkt"
  }, [_vm._v("Mkt")]), _vm._v(" "), _vm._l((_vm.activeColumns), function(col) {
    return _c('th', {
      key: col.key
    }, [_vm._v(_vm._s(col.label))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.listRows), function(row) {
    return _c('tr', {
      key: _vm.rowKey(row)
    }, [_c('td', [_c('div', {
      staticClass: "sales-volume-asin-info"
    }, [_c('span', {
      staticClass: "sales-volume-asin-name"
    }, [_vm._v(_vm._s(row.asin || '—'))]), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-asin-code"
    }, [_vm._v("ID " + _vm._s(row.productId))])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "sales-volume-mkt"
    }, [_c('i', {
      class: _vm.marketplaceFlagClass(row.marketplace) + ' flag'
    }), _vm._v("\n                " + _vm._s(_vm.marketplaceCode(row.marketplace)) + "\n              ")])]), _vm._v(" "), (_vm.salesSubtype === 'hours') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].noSalesHours),
        expression: "forms[rowKey(row)].noSalesHours",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "72 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].noSalesHours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "noSalesHours", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("hours")])])])] : (_vm.salesSubtype === 'fixed') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].dailyFloor),
        expression: "forms[rowKey(row)].dailyFloor",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].dailyFloor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "dailyFloor", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units/day")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].dailyCeiling),
        expression: "forms[rowKey(row)].dailyCeiling",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].dailyCeiling)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "dailyCeiling", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units/day")])])])] : (_vm.salesSubtype === 'rolling') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingDrop),
        expression: "forms[rowKey(row)].rollingDrop",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "100",
        "placeholder": "30 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingDrop)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingDrop", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("%")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingSpike),
        expression: "forms[rowKey(row)].rollingSpike",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "100",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingSpike)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingSpike", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("%")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingDays),
        expression: "forms[rowKey(row)].rollingDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "14 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingDays)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingDays", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingMinUnits),
        expression: "forms[rowKey(row)].rollingMinUnits",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "3 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingMinUnits)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingMinUnits", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units")])])])] : (_vm.salesSubtype === 'bsr') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].bsrAbove),
        expression: "forms[rowKey(row)].bsrAbove",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "not set"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].bsrAbove)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "bsrAbove", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])] : _vm._e()], 2)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-csv-strip"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-csv-actions"
  }, [_c('button', {
    staticClass: "sales-volume-btn-csv sales-volume-btn-csv-dl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n        Download CSV\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "sales-volume-csv-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "sales-volume-btn-csv sales-volume-btn-csv-ul"
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("\n        Upload CSV\n        "), _c('input', {
    staticClass: "sales-volume-csv-file",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.importCsv
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-panel-footer"
  }, [_c('span', {
    staticClass: "sales-volume-footer-note"
  }, [_vm._v("Changes apply to future alerts only — existing alerts are unaffected.")]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-footer-actions"
  }, [_c('button', {
    staticClass: "sales-volume-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sales-volume-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.listRows.length === 0
    },
    on: {
      "click": _vm.saveAll
    }
  }, [(_vm.saving) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        Save Changes\n      ")])])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "sales-volume-panel-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-volume-csv-label"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v("\n      Large catalog?\n      "), _c('strong', [_vm._v("Download → edit in bulk → re-upload")])])
}]}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "whs-loading"
  }, [_c('div', {
    staticClass: "whs-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "whs-error"
  }, [_c('p', {
    staticClass: "whs-error-title"
  }, [_vm._v("Could not load webhooks")]), _vm._v(" "), _c('p', {
    staticClass: "whs-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_c('div', {
    staticClass: "whs-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showForm) ? _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "6px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Add webhook\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.showForm) ? _c('div', {
    staticClass: "whs-card whs-form-card"
  }, [_c('h3', {
    staticClass: "whs-card-title"
  }, [_vm._v("New webhook")]), _vm._v(" "), (_vm.formError) ? _c('div', {
    staticClass: "whs-alert-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUrl),
      expression: "formUrl"
    }],
    staticClass: "whs-input",
    attrs: {
      "type": "url",
      "placeholder": "https://hooks.example.com/sentrykit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.formUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "whs-field"
  }, [_c('label', {
    staticClass: "whs-field-label"
  }, [_vm._v("ALERT TYPES")]), _vm._v(" "), _c('label', {
    staticClass: "whs-check-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAllTypes),
      expression: "formAllTypes"
    }],
    staticClass: "whs-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formAllTypes) ? _vm._i(_vm.formAllTypes, null) > -1 : (_vm.formAllTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formAllTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formAllTypes = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formAllTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formAllTypes = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (!_vm.formAllTypes) ? _c('div', {
    staticClass: "whs-type-grid"
  }, _vm._l((_vm.alertTypes), function(t) {
    return _c('label', {
      key: t,
      staticClass: "whs-type-chip-label",
      class: {
        'active': _vm.formSelectedTypes.indexOf(t) > -1
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formSelectedTypes),
        expression: "formSelectedTypes"
      }],
      staticClass: "whs-type-hidden-cb",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": t,
        "checked": Array.isArray(_vm.formSelectedTypes) ? _vm._i(_vm.formSelectedTypes, t) > -1 : (_vm.formSelectedTypes)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formSelectedTypes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formSelectedTypes = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formSelectedTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.formSelectedTypes = $$c
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(_vm.labelFor(t)) + "\n          ")])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.formAllTypes && _vm.formSelectedTypes.length === 0) ? _c('p', {
    staticClass: "whs-field-hint whs-field-hint-warn"
  }, [_vm._v("Select at least one alert type, or enable \"All alert types\".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "whs-form-actions"
  }, [_c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    class: {
      'whs-btn-loading': _vm.submitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.createWebhook
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitting ? 'Creating…' : 'Create webhook') + "\n        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.webhooks.length && !_vm.showForm) ? _c('div', {
    staticClass: "whs-empty"
  }, [_c('svg', {
    staticClass: "whs-empty-icon",
    attrs: {
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "6",
      "y": "10",
      "width": "36",
      "height": "28",
      "rx": "3",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 18h36",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 28h8M14 33h16",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "38",
      "cy": "38",
      "r": "8",
      "fill": "var(--bg-light)",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 38h6M38 35v6",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "whs-empty-title"
  }, [_vm._v("No webhooks yet")]), _vm._v(" "), _c('p', {
    staticClass: "whs-empty-sub"
  }, [_vm._v("Add an endpoint and we'll deliver alert notifications the moment they fire.")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "5px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Add webhook\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.webhooks.length) ? _c('div', {
    staticClass: "whs-list"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.webhooks), function(wh) {
    return _c('div', {
      key: wh.id,
      staticClass: "whs-row-wrap"
    }, [(!wh.enabled && wh.disabled_reason === 'consecutive_failures') ? _c('div', {
      staticClass: "whs-banner-error",
      attrs: {
        "role": "alert"
      }
    }, [_c('svg', {
      staticStyle: {
        "flex-shrink": "0"
      },
      attrs: {
        "width": "15",
        "height": "15",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v(" "), _c('span', [_vm._v("Auto-disabled after repeated delivery failures. Fix your endpoint, then\n            "), _c('button', {
      staticClass: "whs-banner-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.reenableWebhook(wh)
        }
      }
    }, [_vm._v("re-enable it")]), _vm._v(".\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "whs-row",
      class: {
        'whs-row-off': !wh.enabled,
        'whs-row-expanded': _vm.expandedId === wh.id
      }
    }, [_c('div', {
      staticClass: "whs-col-url"
    }, [_c('span', {
      staticClass: "whs-url-text",
      attrs: {
        "title": wh.url
      }
    }, [_vm._v(_vm._s(_vm.truncateUrl(wh.url)))])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-types"
    }, [(!wh.subscribed_alert_types.length) ? _c('span', {
      staticClass: "whs-chip whs-chip-all"
    }, [_vm._v("All types")]) : [_vm._l((wh.subscribed_alert_types.slice(0, 2)), function(t) {
      return _c('span', {
        key: t,
        staticClass: "whs-chip"
      }, [_vm._v(_vm._s(_vm.labelFor(t)))])
    }), _vm._v(" "), (wh.subscribed_alert_types.length > 2) ? _c('span', {
      staticClass: "whs-chip whs-chip-more"
    }, [_vm._v("+" + _vm._s(wh.subscribed_alert_types.length - 2))]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
      staticClass: "whs-col-health"
    }, [_c('span', {
      staticClass: "whs-health",
      class: _vm.healthClass(wh)
    }, [_vm._v(_vm._s(_vm.healthLabel(wh)))])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-toggle"
    }, [_c('button', {
      staticClass: "whs-toggle",
      class: {
        'whs-toggle-on': wh.enabled
      },
      attrs: {
        "type": "button",
        "disabled": _vm.togglingIds.indexOf(wh.id) > -1,
        "title": wh.enabled ? 'Disable webhook' : 'Enable webhook',
        "aria-pressed": wh.enabled
      },
      on: {
        "click": function($event) {
          return _vm.toggleEnabled(wh)
        }
      }
    }, [_c('span', {
      staticClass: "whs-toggle-knob"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-actions"
    }, [_c('button', {
      staticClass: "whs-icon-btn",
      attrs: {
        "type": "button",
        "title": _vm.expandedId === wh.id ? 'Collapse' : 'Expand details'
      },
      on: {
        "click": function($event) {
          return _vm.toggleExpand(wh.id)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [(_vm.expandedId === wh.id) ? _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
      }
    }) : _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "whs-icon-btn whs-icon-btn-danger",
      attrs: {
        "type": "button",
        "title": "Delete webhook"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(wh.id)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "15",
        "height": "15",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zm-1 5a1 1 0 012 0v6a1 1 0 11-2 0V7zm4 0a1 1 0 012 0v6a1 1 0 11-2 0V7z"
      }
    })])])])]), _vm._v(" "), (_vm.expandedId === wh.id) ? _c('div', {
      staticClass: "whs-detail"
    }, [_c('div', {
      staticClass: "whs-detail-actions"
    }, [_c('button', {
      staticClass: "whs-btn whs-btn-outline whs-btn-sm",
      class: {
        'whs-btn-loading': _vm.testPending[wh.id]
      },
      attrs: {
        "type": "button",
        "disabled": _vm.testPending[wh.id]
      },
      on: {
        "click": function($event) {
          return _vm.sendTest(wh.id)
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "margin-right": "5px",
        "vertical-align": "-1px"
      },
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.testPending[wh.id] ? 'Sending…' : 'Send test event') + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "whs-btn whs-btn-outline whs-btn-sm",
      class: {
        'whs-btn-loading': _vm.rotatePending[wh.id]
      },
      attrs: {
        "type": "button",
        "disabled": _vm.rotatePending[wh.id]
      },
      on: {
        "click": function($event) {
          return _vm.rotateSecret(wh.id)
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "margin-right": "5px",
        "vertical-align": "-1px"
      },
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.rotatePending[wh.id] ? 'Rotating…' : 'Rotate secret') + "\n            ")]), _vm._v(" "), (_vm.testResults[wh.id]) ? _c('span', {
      staticClass: "whs-test-result",
      class: _vm.testResults[wh.id].ok ? 'whs-result-ok' : 'whs-result-fail'
    }, [(_vm.testResults[wh.id].ok) ? _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        "clip-rule": "evenodd"
      }
    })]) : _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.testResults[wh.id].label) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "whs-delivery-wrap"
    }, [_c('p', {
      staticClass: "whs-delivery-label"
    }, [_vm._v("Recent deliveries")]), _vm._v(" "), (_vm.deliveriesLoading[wh.id]) ? _c('div', {
      staticClass: "whs-delivery-loading"
    }, [_c('div', {
      staticClass: "whs-spinner whs-spinner-sm"
    }), _vm._v(" Loading…\n            ")]) : (_vm.deliveries[wh.id] && !_vm.deliveries[wh.id].length) ? _c('div', {
      staticClass: "whs-delivery-empty"
    }, [_vm._v("\n              No deliveries recorded yet. Use \"Send test event\" to verify your endpoint works.\n            ")]) : (_vm.deliveries[wh.id] && _vm.deliveries[wh.id].length) ? _c('table', {
      staticClass: "whs-delivery-table"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveries[wh.id]), function(d) {
      return _c('tr', {
        key: d.id
      }, [_c('td', [_c('span', {
        staticClass: "whs-delivery-status",
        class: d.success ? 'whs-d-ok' : 'whs-d-fail'
      }, [(d.success) ? _c('svg', {
        attrs: {
          "width": "12",
          "height": "12",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
          "clip-rule": "evenodd"
        }
      })]) : _c('svg', {
        attrs: {
          "width": "12",
          "height": "12",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v("\n                      " + _vm._s(d.response_code || (d.success ? '200' : 'Err')) + "\n                    ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labelFor(d.event_type)))]), _vm._v(" "), _c('td', [_vm._v("#" + _vm._s(d.attempt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.latency_ms != null ? d.latency_ms + 'ms' : '—'))]), _vm._v(" "), _c('td', {
        staticClass: "whs-delivery-time"
      }, [_vm._v(_vm._s(_vm.formatTime(d.attempted_at)))])])
    }), 0)]) : _vm._e()])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-info-card"
  }, [_c('div', {
    staticClass: "whs-info-card-head"
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Verifying signatures in your receiver\n      ")]), _vm._v(" "), _vm._m(6)])] : _vm._e(), _vm._v(" "), (_vm.secretModal.show) ? _c('div', {
    staticClass: "whs-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeSecretModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "whs-modal"
  }, [_c('div', {
    staticClass: "whs-modal-icon-wrap whs-modal-icon-amber"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "whs-modal-title"
  }, [_vm._v(_vm._s(_vm.secretModal.isRotation ? 'New signing secret' : 'Webhook created — save your secret'))]), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.secretModal.isRotation) ? _c('p', {
    staticClass: "whs-modal-note"
  }, [_vm._v("\n        Your "), _c('strong', [_vm._v("previous secret stays valid for 24 hours")]), _vm._v(" so you can update your receiver without downtime.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-secret-box"
  }, [_c('code', {
    staticClass: "whs-secret-code"
  }, [_vm._v(_vm._s(_vm.secretModal.secret))]), _vm._v(" "), _c('button', {
    staticClass: "whs-copy-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.secretModal.secret, 'secret')
      }
    }
  }, [(_vm.copied !== 'secret') ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    }
  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.copied === 'secret' ? '✓ Copied!' : 'Copy') + "\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary whs-modal-done-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSecretModal
    }
  }, [_vm._v("Done, I've copied it")])])]) : _vm._e(), _vm._v(" "), (_vm.deleteConfirmId != null) ? _c('div', {
    staticClass: "whs-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.deleteConfirmId = null
      }
    }
  }, [_c('div', {
    staticClass: "whs-modal whs-modal-sm"
  }, [_c('h3', {
    staticClass: "whs-modal-title"
  }, [_vm._v("Delete webhook?")]), _vm._v(" "), _c('p', {
    staticClass: "whs-modal-body"
  }, [_vm._v("This permanently removes the webhook and stops all future deliveries. This cannot be undone.")]), _vm._v(" "), _c('div', {
    staticClass: "whs-modal-btns"
  }, [_c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        _vm.deleteConfirmId = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-danger",
    class: {
      'whs-btn-loading': _vm.deleting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebhook(_vm.deleteConfirmId)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deleting ? 'Deleting…' : 'Delete webhook') + "\n        ")])])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs-page-head-text"
  }, [_c('h1', {
    staticClass: "whs-title"
  }, [_vm._v("Webhooks")]), _vm._v(" "), _c('p', {
    staticClass: "whs-subtitle"
  }, [_vm._v("Receive real-time alert notifications at your own URL. Works with n8n, Make, Zapier, webhook.site, or your own server.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "whs-field-label"
  }, [_vm._v("ENDPOINT URL "), _c('span', {
    staticClass: "whs-required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-field-hint"
  }, [_vm._v("Must start with "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("https://")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "whs-check-label"
  }, [_c('strong', [_vm._v("All alert types")]), _vm._v(" — receive every alert as it fires")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs-list-head"
  }, [_c('div', {
    staticClass: "whs-col-url"
  }, [_vm._v("Endpoint")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-types"
  }, [_vm._v("Alert types")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-health"
  }, [_vm._v("Health")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-toggle"
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-actions"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Event type")]), _vm._v(" "), _c('th', [_vm._v("Attempt")]), _vm._v(" "), _c('th', [_vm._v("Latency")]), _vm._v(" "), _c('th', [_vm._v("Time")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-info-card-text"
  }, [_vm._v("Each delivery includes "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("X-SentryKit-Signature: t=<unix>,v1=<hmac>")]), _vm._v(". Verify with "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("HMAC-SHA256(secret, \"t.raw_body\")")]), _vm._v(" and reject timestamps older than 5 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-modal-body"
  }, [_c('strong', [_vm._v("Copy this now — it won't be shown again.")]), _vm._v(" Paste it into your receiver to verify our signature.\n      ")])
}]}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "helpMenuWrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "helpButtonGroup"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.helpCenterLink,
      "target": "_blank",
      "data-tooltip": "Have questions? Go to our NEW help center",
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_c('i', {
    staticClass: "ui dwhite big question circle outline icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "data-tooltip": "Contact us or report an issue",
      "data-position": "right center",
      "data-inverted": ""
    },
    on: {
      "click": [function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal('second')
      }, function($event) {
        if (!$event.altKey) { return null; }
        if (!$event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.dvlprmd.apply(null, arguments)
      }]
    }
  }, [_c('i', {
    staticClass: "ui dwhite big bug icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "data-tooltip": "Suggest a new feature",
      "data-position": "right center",
      "data-inverted": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal('third')
      }
    }
  }, [_c('i', {
    staticClass: "ui dwhite big lightbulb outline icon"
  })])]), _vm._v(" "), _c('HelpModal', {
    ref: "helpModal"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "first-run-sync-modal-overlay"
  }, [_c('div', {
    staticClass: "first-run-sync-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h1', {
    staticClass: "app-title"
  }, [_vm._v("SentryKit")]), _vm._v(" "), _c('span', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.userEmail))])]), _vm._v(" "), (!_vm.syncComplete) ? _c('div', {
    staticClass: "modal-body syncing"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Setting up your workspace....")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("\n        Syncing your Amazon catalog and setting up real-time Buy Box monitoring. Takes 2 - 5 minutes for most accounts.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "sync-steps"
  }, _vm._l((_vm.derivedSteps), function(step, index) {
    return _c('li', {
      key: step.id,
      staticClass: "sync-step"
    }, [(step.completed) ? _c('i', {
      staticClass: "check circle icon green"
    }) : (step.inProgress) ? _c('i', {
      staticClass: "circle notch loading icon"
    }) : _c('i', {
      staticClass: "circle outline icon grey"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.completed ? step.completedLabel : step.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "progress-section"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Item " + _vm._s(_vm.completedStepsCount) + "/" + _vm._s(_vm.derivedSteps.length) + " complete")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    staticClass: "progress-bar-fill",
    style: ({
      width: _vm.progressPercent + '%'
    })
  })])]), _vm._v(" "), _c('button', {
    staticClass: "go-to-dashboard-btn",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n        Go to Dashboard\n        "), _c('i', {
    staticClass: "arrow right icon"
  })])]) : _c('div', {
    staticClass: "modal-body ready"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "ready-message"
  }, [_vm._v("All 90-day Buy Box monitoring and historic data loaded!")]), _vm._v(" "), _c('ul', {
    staticClass: "sync-steps"
  }, _vm._l((_vm.derivedSteps), function(step) {
    return _c('li', {
      key: step.id,
      staticClass: "sync-step completed"
    }, [_c('i', {
      staticClass: "check circle icon green"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.completedLabel))])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "go-to-dashboard-btn ready-btn",
    on: {
      "click": _vm.dismiss
    }
  }, [_c('i', {
    staticClass: "check circle icon"
  }), _vm._v("\n        Your dashboard is ready - Go to Dashboard\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "footer-text"
  }, [_vm._v("All data secured.")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sync-complete-banner"
  }, [_c('i', {
    staticClass: "check circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Sync complete")])])
}]}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-navbar"
  }, [_c('div', {
    staticClass: "navbar-left"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "navbar-wordmark",
    attrs: {
      "src": _vm.sentrykitWordmark,
      "alt": "SentryKit 2.0"
    }
  })])]), _vm._v(" "), (_vm.$slots.filters) ? _c('div', {
    staticClass: "navbar-center"
  }, [_vm._t("filters")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-right"
  }, [_vm._t("right", function() {
    return [(_vm.userEmail) ? _c('div', {
      staticClass: "navbar-account"
    }, [_c('span', {
      staticClass: "navbar-user-email"
    }, [_vm._v(_vm._s(_vm.userEmail))]), _vm._v(" "), _c('span', {
      staticClass: "navbar-account-sep",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('button', {
      staticClass: "navbar-logout",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.signOut
      }
    }, [_vm._v("Log out")])]) : _vm._e()]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-category-detail",
    attrs: {
      "data-wdtype": _vm.wdtype
    }
  }, [_c('div', {
    staticClass: "issues-category-header"
  }, [_c('h2', {
    staticClass: "issues-category-title"
  }, [(_vm.newAlertCount > 0) ? _c('span', {
    staticClass: "issues-category-new-badge"
  }, [_vm._v(_vm._s(_vm.newAlertCount) + " new")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.categoryName) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-toolbar"
  }, [_c('div', {
    staticClass: "issues-category-tabs"
  }, [(!_vm.resolvedHidden) ? _c('button', {
    class: ['issues-category-tab', {
      active: _vm.issuesListTab === 'resolved'
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('issues-tab-change', 'resolved')
      }
    }
  }, [_c('i', {
    staticClass: "check icon"
  }), _vm._v(" Resolved "), _c('span', {
    staticClass: "tab-count"
  }, [_vm._v(_vm._s(_vm.resolvedCount))])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['issues-category-tab', 'active-tab', {
      active: _vm.issuesListTab === 'active' || _vm.resolvedHidden,
      'has-active-count': _vm.activeCount > 0
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('issues-tab-change', 'active')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activeCount) + " Active\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-actions"
  }, [_c('div', {
    staticClass: "issues-category-marketplace-filter"
  }, [_c('i', {
    staticClass: "globe icon"
  }), _vm._v(" "), _c('select', {
    staticClass: "issues-category-marketplace-select",
    attrs: {
      "aria-label": "Filter by marketplace"
    },
    domProps: {
      "value": _vm.marketplaceColumnFilterValue
    },
    on: {
      "change": _vm.onMarketplaceColumnFilter
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All marketplaces")]), _vm._v(" "), _vm._l((_vm.marketplaceFilterOptions), function(c) {
    return _c('option', {
      key: c,
      domProps: {
        "value": c
      }
    }, [_vm._v("\n            " + _vm._s(_vm.marketplaceOptionLabel(c)) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.wdtype === 'fbaFeeChange') ? _c('div', {
    staticClass: "issues-category-marketplace-filter"
  }, [_c('i', {
    staticClass: "sort amount down icon"
  }), _vm._v(" "), _c('select', {
    staticClass: "issues-category-marketplace-select",
    attrs: {
      "aria-label": "Sort by FBA fee change"
    },
    domProps: {
      "value": _vm.feeDirection
    },
    on: {
      "change": _vm.onFeeDirectionChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Newest first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "increase"
    }
  }, [_vm._v("Fee increase (largest first)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "decrease"
    }
  }, [_vm._v("Fee decrease (largest first)")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "issues-category-search"
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "issues-category-search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.onSearchInput]
    }
  })]), _vm._v(" "), (_vm.wdtype === 'salesDrop') ? _c('button', {
    staticClass: "issues-category-configure-btn",
    class: {
      open: _vm.showSalesConfigurePanel
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSalesConfigurePanel
    }
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n        Configure Thresholds\n      ")]) : _vm._e(), _vm._v(" "), (_vm.wdtype === 'competitivePrice') ? _c('button', {
    staticClass: "issues-category-configure-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.exportingChangeLog,
      "title": "Every change of Amazon's competitive price in the last 30 days (CSV per storefront)"
    },
    on: {
      "click": _vm.exportChangeLog
    }
  }, [_c('i', {
    class: _vm.exportingChangeLog ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n        Export change log\n      ")]) : _vm._e(), _vm._v(" "), (_vm.exportChangeLogError) ? _c('p', {
    staticClass: "issues-category-export-error"
  }, [_vm._v(_vm._s(_vm.exportChangeLogError))]) : _vm._e(), _vm._v(" "), (_vm.canMarkAllResolved) ? _c('button', {
    staticClass: "issues-category-configure-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkResolveInProgress
    },
    on: {
      "click": _vm.markAllResolved
    }
  }, [(_vm.bulkResolveInProgress) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.itemsMeta && _vm.itemsMeta.total_pages > 1 ? 'Mark page as resolved' : 'Mark all as resolved') + "\n      ")]) : _vm._e()])]), _vm._v(" "), (_vm.wdtype === 'salesDrop') ? [(_vm.showSalesConfigurePanel && !_vm.salesVolumeThresholdPanelDataReady) ? _c('div', {
    staticClass: "sales-volume-thresholds-prefetch-bar",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('span', [_vm._v("Loading sales volume thresholds…")])]) : _vm._e(), _vm._v(" "), (_vm.showSalesConfigurePanel) ? _c('div', {
    class: {
      'sales-volume-thresholds-panel-wrap--prefetch': !_vm.salesVolumeThresholdPanelDataReady
    }
  }, [_c('SalesVolumeThresholdsPanel', {
    attrs: {
      "panel-open": _vm.showSalesConfigurePanel,
      "thresholds-api-base": _vm.salesVolumeThresholdsApiBaseUrl,
      "seller-account-id": _vm.stockThresholdSellerAccountId
    },
    on: {
      "close": _vm.closeSalesConfigurePanel,
      "saved": _vm.onSalesVolumePanelSaved,
      "thresholds-load-complete": _vm.onSalesVolumeThresholdsLoadComplete
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    ref: "issuesListScroll",
    staticClass: "issues-category-list",
    on: {
      "&scroll": function($event) {
        return _vm.onIssuesListScroll.apply(null, arguments)
      }
    }
  }, [(_vm.displayedItems.length > 0) ? _c('div', {
    staticClass: "issues-category-list-head",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "issues-col-product"
  }, [_vm._v("Product")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-marketplace"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-change"
  }, [_vm._v("Change")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-date"
  }, [_vm._v("Date")])]) : _vm._e(), _vm._v(" "), (_vm.listVirtualPadTop > 0) ? _c('div', {
    staticClass: "issues-list-virtual-spacer",
    style: ({
      height: _vm.listVirtualPadTop + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.windowedDisplayedItems), function(item) {
    return _c('IssuesCategoryCard', {
      key: item.watchDogItemId || item.watchDogId,
      attrs: {
        "item": item,
        "wdtype": _vm.wdtype,
        "issues-list-tab": _vm.issuesListTab,
        "products": _vm.products,
        "status-label": _vm.getStatusLabel(item),
        "status-class": _vm.getStatusClass(item),
        "api-base-url": _vm.alertThresholdsApiBaseUrl,
        "stock-alert-thresholds-api-base-url": _vm.stockAlertThresholdsApiBaseUrl,
        "sales-volume-thresholds-api-base-url": _vm.salesVolumeThresholdsApiBaseUrl,
        "seller-account-id-for-thresholds": _vm.stockThresholdSellerAccountId,
        "mark-resolve-busy": !!_vm.markResolveBusyIds[item.watchDogId],
        "highlighted-alert-id": _vm.highlightedAlertId,
        "filter-by-market": _vm.filterByMarket
      },
      on: {
        "mute": _vm.muteItem,
        "view-product": _vm.viewProduct,
        "saved": _vm.onAlertThresholdsSaved,
        "mark-resolved": _vm.markItemResolved,
        "filter-marketplace": _vm.onMarketplaceChipFilter
      }
    })
  }), _vm._v(" "), (_vm.listVirtualPadBottom > 0) ? _c('div', {
    staticClass: "issues-list-virtual-spacer",
    style: ({
      height: _vm.listVirtualPadBottom + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsLoading && _vm.displayedItems.length === 0) ? _c('div', {
    staticClass: "issues-category-empty"
  }, [_vm._v("\n      Loading alerts…\n    ")]) : (_vm.displayedItems.length === 0) ? _c('div', {
    staticClass: "issues-category-empty"
  }, [(_vm.issuesListTab === 'active') ? [_vm._v("No current alerts")] : [_vm._v("No resolved issues")]], 2) : _vm._e(), _vm._v(" "), (_vm.itemsMeta && _vm.itemsMeta.total_pages > 1) ? _c('div', {
    staticClass: "issues-category-pager"
  }, [_c('button', {
    staticClass: "issues-category-pager-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.itemsMeta.page <= 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('issues-page-change', _vm.itemsMeta.page - 1)
      }
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(_vm.itemsMeta.page) + " of " + _vm._s(_vm.itemsMeta.total_pages))]), _vm._v(" "), _c('button', {
    staticClass: "issues-category-pager-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.itemsMeta.page >= _vm.itemsMeta.total_pages
    },
    on: {
      "click": function($event) {
        return _vm.$emit('issues-page-change', _vm.itemsMeta.page + 1)
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats"
  }, [(_vm.deletingSellerId != null) ? _c('div', {
    staticClass: "ats-action-overlay",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "ats-loading"
  }, [_c('div', {
    staticClass: "ats-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "ats-error"
  }, [_c('p', {
    staticClass: "ats-error-title"
  }, [_vm._v("Could not load account settings")]), _vm._v(" "), _c('p', {
    staticClass: "ats-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("ACCOUNT OVERVIEW")]), _vm._v(" "), _c('div', {
    staticClass: "ats-overview-grid"
  }, [_c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("ACCOUNT OWNER")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": 'mailto:' + _vm.loginEmail
    }
  }, [_vm._v(_vm._s(_vm.loginEmail))])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("PLAN")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.planName))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.planDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("CONNECTED STOREFRONTS")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.sellers.length))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.storefrontSummary))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("TEAM MEMBERS")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.teamUserAccounts.length))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.teamSummary))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("ACCOUNT CREATED")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.accountCreatedDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.billingCycleDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("PROFILE")]), _vm._v(" "), _c('div', {
    staticClass: "ats-profile-row"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("FIRST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LAST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ats-field",
    staticStyle: {
      "max-width": "380px"
    }
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LOGIN EMAIL")]), _vm._v(" "), _c('div', {
    staticClass: "ats-input ats-input-readonly"
  }, [_vm._v(_vm._s(_vm.loginEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-profile-actions"
  }, [_c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "ats-btn ats-btn-primary",
    class: {
      'ats-btn-loading': _vm.savingProfile
    },
    attrs: {
      "disabled": !_vm.profileDirty
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("CONNECTED STOREFRONTS")]), _vm._v(" "), _c('div', {
    staticClass: "ats-card"
  }, [_c('div', {
    staticClass: "ats-card-header"
  }, [_vm._m(2), _vm._v(" "), (_vm.canAddStorefront) ? _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.addStorefront
    }
  }, [_vm._v("+ Add Storefront")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ats-table-wrap"
  }, [_c('table', {
    staticClass: "ats-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SELLER ID")]), _vm._v(" "), _c('th', [_vm._v("NICKNAME")]), _vm._v(" "), _c('th', [_vm._v("REGION")]), _vm._v(" "), _c('th', [_vm._v("MARKETPLACES")]), _vm._v(" "), _c('th', [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Overrides per-alert storefront and brand settings."
    }
  }, [_vm._v("STOP ALL ALERTS")]), _vm._v(" "), (_vm.isOwner) ? _c('th', [_vm._v("ACTIONS")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.filteredSellers.length === 0) ? _c('tr', [_c('td', {
    staticClass: "ats-empty",
    attrs: {
      "colspan": _vm.isOwner ? 7 : 6
    }
  }, [_vm._v("No storefronts connected yet.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSellers), function(seller) {
    return _c('tr', {
      key: _vm.sellerIdVal(seller)
    }, [_c('td', {
      staticClass: "ats-cell-mono"
    }, [_vm._v(_vm._s(_vm.sellerKeyVal(seller)))]), _vm._v(" "), _c('td', [(_vm.isOwner) ? _c('input', {
      staticClass: "ats-input ats-input-sm",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "data-lpignore": "true",
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm.sellerNicknameDisplay(seller)
      },
      on: {
        "input": function($event) {
          return _vm.onNickNameInput(seller, $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "ats-cell-text"
    }, [_vm._v(_vm._s(_vm.sellerNicknameDisplay(seller) || '—'))])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-center"
    }, [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-mp-badges"
    }, _vm._l((_vm.sellerMarketplaceChips(seller)), function(mp, mpIdx) {
      return _c('span', {
        key: _vm.sellerKeyVal(seller) + '-' + mp.flag + '-' + mpIdx,
        staticClass: "ats-mp-badge"
      }, [_c('i', {
        class: mp.flag + ' flag'
      }), _vm._v(" " + _vm._s(mp.label) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('td', [(seller.mayNeedReauthorization) ? _c('span', {
      staticClass: "ats-badge ats-badge-warn"
    }, [_vm._v("Re-auth needed")]) : _c('span', {
      staticClass: "ats-badge ats-badge-ok"
    }, [_vm._v("Authorized")])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-center"
    }, [_c('label', {
      staticClass: "ats-toggle",
      class: {
        'ats-toggle-busy': _vm.killSwitchBusy(seller)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "aria-label": "Stop all alerts",
        "disabled": !_vm.isOwner || _vm.killSwitchBusy(seller)
      },
      domProps: {
        "checked": !_vm.sellerAlertsEnabled(seller)
      },
      on: {
        "change": function($event) {
          return _vm.onStopToggle(seller, 'alertsEnabled', $event.target.checked)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ats-toggle-slider"
    })])]), _vm._v(" "), (_vm.isOwner) ? _c('td', {
      staticClass: "ats-cell-actions"
    }, [_c('button', {
      staticClass: "ats-icon-btn",
      attrs: {
        "title": "Re-authorize"
      },
      on: {
        "click": function($event) {
          return _vm.reauthorizeSeller(seller)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 001.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "ats-icon-btn ats-icon-btn-danger",
      attrs: {
        "type": "button",
        "title": "Delete storefront",
        "disabled": _vm.deletingSellerId != null
      },
      on: {
        "click": function($event) {
          return _vm.deleteSeller(seller)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })])])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "ats-card-footer"
  }, [(_vm.isStarterPlan && !_vm.canAddStorefront) ? _c('span', {
    staticClass: "ats-note"
  }, [_vm._v("Starter plan includes up to " + _vm._s(_vm.starterMaxStorefronts) + " storefronts.")]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    staticClass: "ats-btn ats-btn-primary",
    class: {
      'ats-btn-loading': _vm.savingSellers
    },
    attrs: {
      "disabled": !_vm.sellersDirty
    },
    on: {
      "click": _vm.saveSellers
    }
  }, [_vm._v("Save Changes")]) : _c('p', {
    staticClass: "ats-member-readonly-hint"
  }, [_vm._v("View only — contact your account admin to add or edit storefronts.")])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("TEAM")]), _vm._v(" "), _c('div', {
    staticClass: "ats-card"
  }, [_c('div', {
    staticClass: "ats-card-header"
  }, [_vm._m(3), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.inviteMember
    }
  }, [_vm._v("+ Invite Member")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ats-table-wrap"
  }, [_c('table', {
    staticClass: "ats-table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [(_vm.memberRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "ats-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No team members yet.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.memberRows), function(member) {
    return _c('tr', {
      key: 'm-' + (member.user.id != null ? member.user.id : member.user.email)
    }, [_c('td', [_c('div', {
      staticClass: "ats-member-info"
    }, [_c('span', {
      staticClass: "ats-member-name"
    }, [_vm._v(_vm._s(member.user.fullName || member.user.email))]), _vm._v(" "), _c('a', {
      staticClass: "ats-member-email",
      attrs: {
        "href": 'mailto:' + member.user.email
      }
    }, [_vm._v(_vm._s(member.user.email))])])]), _vm._v(" "), _c('td', [(_vm.memberRoleIsLocked(member)) ? _c('span', {
      staticClass: "ats-badge ats-badge-role-admin"
    }, [_vm._v(_vm._s(_vm.memberRoleBadgeLabel(member)))]) : (_vm.isOwner && member.emailAddress) ? _c('select', {
      staticClass: "ats-role-select",
      attrs: {
        "disabled": _vm.savingMemberRoleUserId != null
      },
      domProps: {
        "value": _vm.memberRoleSelectValue(member)
      },
      on: {
        "change": function($event) {
          return _vm.onMemberRoleChange(member, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "member"
      }
    }, [_vm._v("Member")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "admin"
      }
    }, [_vm._v("Admin")])]) : (member.user.isOwner) ? _c('span', {
      staticClass: "ats-badge ats-badge-role-admin"
    }, [_vm._v(_vm._s(_vm.memberRoleBadgeLabel(member)))]) : _c('span', {
      staticClass: "ats-badge ats-badge-role-member"
    }, [_vm._v("Member")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-account-pills"
    }, [(member.user.isOwner) ? [_c('span', {
      staticClass: "ats-pill-account"
    }, [_vm._v("All accounts")])] : [_vm._l((_vm.memberAssignedAccounts(member)), function(acc) {
      return _c('span', {
        key: acc,
        staticClass: "ats-pill-account"
      }, [_vm._v(_vm._s(acc))])
    }), _vm._v(" "), (_vm.isOwner && !member.user.isOwner && member.emailAddress) ? _c('a', {
      staticClass: "ats-edit-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openAssignSellersModal(member)
        }
      }
    }, [_vm._v("+ Edit")]) : _vm._e()]], 2)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-status-cell"
    }, [(_vm.memberIsVerified(member)) ? _c('span', {
      staticClass: "ats-badge ats-badge-ok"
    }, [_vm._v("Verified")]) : _c('span', {
      staticClass: "ats-badge ats-badge-warn"
    }, [_vm._v("Not verified")]), _vm._v(" "), (_vm.showVerifyEmailButton(member)) ? _c('button', {
      staticClass: "ats-btn ats-btn-outline ats-btn-verify-email",
      class: {
        'ats-btn-loading': _vm.verificationEmailSendingId === _vm.memberVerificationButtonKey(member)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.verificationEmailSendingId === _vm.memberVerificationButtonKey(member)
      },
      on: {
        "click": function($event) {
          return _vm.sendMemberVerificationEmail(member)
        }
      }
    }, [_vm._v("\n                    Resend Verification Email\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-actions"
    }, [(member.user.isOwner) ? _c('span', {
      staticClass: "ats-text-muted"
    }, [_vm._v("—")]) : (_vm.isOwner) ? _c('button', {
      staticClass: "ats-icon-btn ats-icon-btn-danger",
      attrs: {
        "title": "Remove member"
      },
      on: {
        "click": function($event) {
          return _vm.removeMember(member)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })])]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("INTEGRATIONS")]), _vm._v(" "), _c('div', {
    staticClass: "ats-integrations-grid"
  }, [_c('div', {
    staticClass: "ats-int-card"
  }, [_c('div', {
    staticClass: "ats-int-icon"
  }, [_c('img', {
    staticClass: "ats-int-logo",
    attrs: {
      "src": _vm.googleSheetsLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-body"
  }, [_c('span', {
    staticClass: "ats-int-name"
  }, [_vm._v("Google Sheets")]), _vm._v(" "), (_vm.gsheetsConnection.email) ? _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v(_vm._s(_vm.gsheetsConnection.email))]) : _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Export alerts to a spreadsheet")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-actions"
  }, [(_vm.gsheetsConnection.email && _vm.gsheetsConnection.email !== 'pending') ? [_c('span', {
    staticClass: "ats-badge ats-badge-ok"
  }, [_vm._v("Connected")]), _vm._v(" "), (_vm.gsheetsConnection.spreadsheetId) ? _c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openGoogleSheet.apply(null, arguments)
      }
    }
  }, [_vm._v("Open →")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ats-link ats-link-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revokeGoogleSheets.apply(null, arguments)
      }
    }
  }, [_vm._v("Revoke")])] : _c('button', {
    staticClass: "ats-btn ats-btn-connect",
    on: {
      "click": _vm.connectGoogleSheets
    }
  }, [_vm._v("Connect")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-card"
  }, [_c('div', {
    staticClass: "ats-int-icon"
  }, [_c('img', {
    staticClass: "ats-int-logo",
    attrs: {
      "src": _vm.zapierLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-body"
  }, [_c('span', {
    staticClass: "ats-int-name"
  }, [_vm._v("Zapier")]), _vm._v(" "), (_vm.hasZapier) ? _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Connected" + _vm._s(_vm.zapierConnectedSince ? ' · ' + _vm.zapierConnectedSince : ''))]) : _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Trigger Zaps from SentryKit alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-actions"
  }, [(_vm.hasZapier) ? [_c('span', {
    staticClass: "ats-badge ats-badge-ok"
  }, [_vm._v("Connected")]), _vm._v(" "), _c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": _vm.zapierTriggersDocUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Triggers →")]), _vm._v(" "), _c('a', {
    staticClass: "ats-link ats-link-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revokeZapier.apply(null, arguments)
      }
    }
  }, [_vm._v("Revoke")])] : _c('a', {
    staticClass: "ats-btn ats-btn-connect",
    attrs: {
      "href": _vm.zapierDirectoryUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Connect")])], 2)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ats-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "ats-toast ats-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ats-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "ats-toast ats-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('change-password-modal', {
    ref: "changePasswordModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal add-storefront-modal",
    attrs: {
      "id": "addSellerAccountModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Connect Amazon storefront")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "add-storefront-modal-desc"
  }, [_vm._v("Approve SentryKit on Amazon.")]), _vm._v(" "), _c('add-seller-account', {
    attrs: {
      "show-nickname": true
    },
    on: {
      "error": _vm.onAddSellerError
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "assignSellersModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Assign storefronts")]), _vm._v(" "), (_vm.assignModalMember) ? _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "assign-modal-intro"
  }, [_vm._v("\n        Choose which connected storefronts "), _c('strong', [_vm._v(_vm._s(_vm.assignModalMember.user.fullName || _vm.assignModalMember.user.email))]), _vm._v(" can access. They only receive alerts for assigned accounts.\n      ")]), _vm._v(" "), (!_vm.sellers.length) ? _c('div', {
    staticClass: "assign-modal-empty"
  }, [_vm._v("No storefronts connected yet.")]) : _c('div', {
    staticClass: "assign-seller-list"
  }, _vm._l((_vm.sellers), function(seller) {
    return _c('label', {
      key: 'assign-seller-' + _vm.sellerIdVal(seller),
      staticClass: "assign-seller-row"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.assignModalSellerChecked(seller)
      },
      on: {
        "change": function($event) {
          return _vm.assignModalToggleSeller(seller)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "assign-seller-label"
    }, [_vm._v(_vm._s(seller.nickName || _vm.sellerKeyVal(seller)))]), _vm._v(" "), _c('span', {
      staticClass: "assign-seller-meta"
    }, [_vm._v(_vm._s(_vm.sellerKeyVal(seller)))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button",
      "disabled": _vm.savingAssignModal
    },
    on: {
      "click": _vm.confirmAssignSellersModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savingAssignModal ? 'Saving…' : 'Done') + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "inviteMemberModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Invite team member")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "invite-modal-intro"
  }, [_vm._v("\n        We will email them an invitation. Only the account owner can add users.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "invite-modal-form"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteEmail),
      expression: "inviteEmail"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "email",
      "autocomplete": "off",
      "data-lpignore": "true",
      "placeholder": "colleague@company.com"
    },
    domProps: {
      "value": (_vm.inviteEmail)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitInviteMember.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "invite-modal-name-row"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("FIRST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteFirstName),
      expression: "inviteFirstName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.inviteFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteFirstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LAST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteLastName),
      expression: "inviteLastName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.inviteLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteLastName = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button",
      "disabled": _vm.inviteSubmitting
    },
    on: {
      "click": _vm.closeInviteMemberModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.inviteSubmitting,
      disabled: _vm.inviteSubmitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.inviteSubmitting || !_vm.inviteEmailTrimmed
    },
    on: {
      "click": _vm.submitInviteMember
    }
  }, [_vm._v("\n        Send invitation\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-action-overlay-inner"
  }, [_c('div', {
    staticClass: "ats-spinner"
  }), _vm._v(" "), _c('p', {
    staticClass: "ats-action-overlay-text"
  }, [_vm._v("Removing storefront…")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-header"
  }, [_c('h2', {
    staticClass: "ats-title"
  }, [_vm._v("Account & Team")]), _vm._v(" "), _c('p', {
    staticClass: "ats-subtitle"
  }, [_vm._v("Manage your profile, connected Amazon accounts, team members, and integrations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "ats-card-title"
  }, [_vm._v("Storefronts (Seller ID)")]), _vm._v(" "), _c('p', {
    staticClass: "ats-card-desc"
  }, [_vm._v("Each connected storefront is monitored across all its marketplaces. Adding storefronts may affect your plan cost. Stop-all-alerts and stop-backend-attributes only halt outbound alerts or ATTR scans; dashboards and watchdogs keep updating.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "ats-card-title"
  }, [_vm._v("Members & Access")]), _vm._v(" "), _c('p', {
    staticClass: "ats-card-desc"
  }, [_vm._v("Admin can configure alerts and manage all accounts. Members receive alerts for their assigned accounts only.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("MEMBER")]), _vm._v(" "), _c('th', [_vm._v("ROLE")]), _vm._v(" "), _c('th', [_vm._v("ASSIGNED ACCOUNTS")]), _vm._v(" "), _c('th', [_vm._v("STATUS")]), _vm._v(" "), _c('th', [_vm._v("ACTIONS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-card-footer"
  }, [_c('span', {
    staticClass: "ats-note"
  }, [_vm._v("Account assignment changes are saved when you click Done in the assignment dialog.")])])
}]}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-connect-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [_c('div', {
    staticClass: "sk-two-col-card sk-invite-card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('div', {
    staticClass: "sk-spinner",
    staticStyle: {
      "margin": "0 auto 16px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loading…")])]) : (_vm.status === 'used') ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('div', {
    staticClass: "sk-amz-connected"
  }, [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Done. " + _vm._s(_vm.inviterName) + " can see your listings in SentryKit now.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("You can close this page. No SentryKit account was created for you.")])]) : (_vm.status === 'expired' || _vm.status === 'missing') ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('h1', [_vm._v("This link can't be used")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v(_vm._s(_vm.status === 'expired' ? 'This link has expired. Ask them to copy a new one from SentryKit.' : 'This link is not valid.'))])]) : _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('p', {
    staticClass: "sk-invite-lead"
  }, [_vm._v(_vm._s(_vm.inviterName) + " asked you to connect " + _vm._s(_vm.accountLabel) + "'s Amazon store to SentryKit.")]), _vm._v(" "), _c('connect-region-form', {
    attrs: {
      "working": _vm.working,
      "error": _vm.error
    },
    on: {
      "connect": _vm.startConnect
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "https://sentrykit.com"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])])
}]}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['add-seller-account', _vm.cssClass]
  }, [_c('amazon-region-connect', {
    attrs: {
      "show-nickname": _vm.showNickname,
      "show-pricing-message": !_vm.$root.hasDailyPricing,
      "redirect-path": _vm.$route.path
    },
    on: {
      "error": _vm.onConnectError
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skipPackageDimensionChangeIfNoFeeChange),
      expression: "skipPackageDimensionChangeIfNoFeeChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPackageDimensionChangeIfNoFeeChange) ? _vm._i(_vm.skipPackageDimensionChangeIfNoFeeChange, null) > -1 : (_vm.skipPackageDimensionChangeIfNoFeeChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.skipPackageDimensionChangeIfNoFeeChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.skipPackageDimensionChangeIfNoFeeChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334457"
    }
  }, [_vm._v("Dimension changes: Only alert if FBA fee changed as well")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendAlertForEstimateChanges),
      expression: "sendAlertForEstimateChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457b"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendAlertForEstimateChanges) ? _vm._i(_vm.sendAlertForEstimateChanges, null) > -1 : (_vm.sendAlertForEstimateChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendAlertForEstimateChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendAlertForEstimateChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendAlertForEstimateChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendAlertForEstimateChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendAlertForOrderDataChanges),
      expression: "sendAlertForOrderDataChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334457c"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendAlertForOrderDataChanges) ? _vm._i(_vm.sendAlertForOrderDataChanges, null) > -1 : (_vm.sendAlertForOrderDataChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendAlertForOrderDataChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendAlertForOrderDataChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendAlertForOrderDataChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendAlertForOrderDataChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334457b"
    }
  }, [_vm._v("Send alerts for FBA fee estimate changes "), _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.sentrykit.com/knb/fbafeealerts.html"
    }
  }, [_vm._v("[more info...]")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334457c"
    }
  }, [_vm._v("Send alerts for FBA fee changes in order data "), _c('small', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.sentrykit.com/knb/fbafeealerts.html"
    }
  }, [_vm._v("[more info...]")])])])
}]}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'loadingIndicator': _vm.loadingIndicator,
      'hasSOTW': _vm.hasSOTW
    }
  }, [(_vm.offline) ? _c('div', {
    staticClass: "ui floating warning message",
    staticStyle: {
      "opacity": ".8",
      "position": "fixed",
      "top": "0",
      "left": "20px",
      "z-index": "111"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('You seem to be offline')))]) : _vm._e(), _vm._v(" "), (_vm.$root.authCompleted) ? _c('model-sellers', {
    ref: "modelSellers"
  }) : _vm._e(), _vm._v(" "), (_vm.showFirstRunSyncModal) ? _c('first-run-sync-modal', {
    attrs: {
      "user-email": _vm.$root.userEmail,
      "onboarding-status": _vm.onboardingStatus,
      "on-dismiss": _vm.onFirstRunSyncDismiss
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": _vm.transitionMode
    }
  }, [_c('router-view', {
    on: {
      "sellerAccountsUpdated": function($event) {
        return _vm.$refs.modelSellers.updateSellers()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "stts21kdfslds"
  }), _vm._v(" "), _c('product-details-chart-modal', {
    ref: "chartModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "errorModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm._f("translate")('Error')))]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v(_vm._s(_vm._f("translate")('Close')))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "loginModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Log-in")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [(_vm.loginError) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('div', [_vm._v(_vm._s(_vm.loginError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "required": "true",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autofocus": "true",
      "required": "true"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepMeSignedIn),
      expression: "keepMeSignedIn"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.keepMeSignedIn) ? _vm._i(_vm.keepMeSignedIn, null) > -1 : (_vm.keepMeSignedIn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.keepMeSignedIn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.keepMeSignedIn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.keepMeSignedIn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.keepMeSignedIn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("translate")('Keep me signed in')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui primary ok button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('Log in')))])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.announcement != null && _vm.announcement != _vm.closedAnnouncementText),
      expression: "announcement!=null&&announcement!=closedAnnouncementText"
    }],
    staticClass: "ui orange message SKannouncement"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.closedAnnouncementText = _vm.announcement
      }
    }
  }), _vm._v(" "), _c('strong', [_vm._v("[Announcement]")]), _vm._v("      " + _vm._s(_vm.announcement) + "\n    ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountErrors != null && !_vm.accountErrorsTextClosed),
      expression: "accountErrors!=null&&!accountErrorsTextClosed"
    }],
    staticClass: "ui red message SKannouncement"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.accErrorBoxClose
    }
  }), _vm._v(" "), _c('strong', [_vm._v("[IMPORTANT]")]), _vm._v("      " + _vm._s(_vm.accountErrors) + "\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "manyAsinsModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Light UI (beta) available")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Lot's of products to show. You might benefit from our new Light UI. Simpler, snappier."), _c('br'), _vm._v("And you can always switch back just by reloading the page.")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui grey deny button"
  }, [_vm._v("No, Continue")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive button"
  }, [_vm._v("Try out Light UI")])])])
}]}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Minimum Margin Target")]), _vm._v(" "), _c('div', {
    staticClass: "margin-input-wrapper"
  }, [_c('input', {
    staticClass: "margin-input",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.settings.defaultMarginPercentage
    },
    on: {
      "input": _vm.onMarginChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "percent-symbol"
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', {
    staticClass: "form-hint"
  }, [_vm._v("Applied to all products unless overridden")]), _vm._v(" "), _c('p', {
    staticClass: "form-description"
  }, [_vm._v("\n      This is the minimum profit margin you want to maintain. Floor prices are calculated to protect this margin.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "toggle-wrapper"
  }, [_c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Alert when price approaches floor")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox",
    class: {
      checked: _vm.settings.floorPriceAlertEnabled
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.settings.floorPriceAlertEnabled
    },
    on: {
      "change": _vm.onToggleChange
    }
  }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('p', {
    staticClass: "form-hint"
  }, [_vm._v("Get notified when any product's margin drops below your target")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('strong', [_vm._v("How floor price is calculated:")]), _vm._v(" "), _c('div', {
    staticClass: "formula"
  }, [_vm._v("\n        " + _vm._s(_vm.formulaDescription) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_vm._v("\n        Example: (" + _vm._s(_vm.formatPrice(_vm.formulaExample.landed_cost)) + " + " + _vm._s(_vm.formatPrice(_vm.formulaExample.amazon_fees)) + ") ÷ (1-" + _vm._s((_vm.formulaExample.margin_percentage / 100).toFixed(2)) + ") = " + _vm._s(_vm.formatPrice(_vm.formulaExample.result)) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Default Margin Target")]), _vm._v(" "), _c('span', {
    staticClass: "required-badge"
  }, [_vm._v("REQUIRED")])])
}]}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted vertical footer segment",
    attrs: {
      "ssstyle": "z-index:-2;height:25vh;"
    }
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    attrs: {
      "ssstyle": "position:fixed; bottom:0;"
    }
  }, [_c('div', {
    staticClass: "ui inverted divided equal height stackable grid",
    staticStyle: {
      "padding": "5vh 0",
      "ssz-index": "-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('first')
      }
    }
  }, [_vm._v("F.A.Q")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('second')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('third')
      }
    }
  }, [_vm._v("Feature Requests")])])]), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Quick Links")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/productsettings')
      }
    }
  }, [_vm._v("Product Tracking Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/settings')
      }
    }
  }, [_vm._v("Email Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/settings')
      }
    }
  }, [_vm._v("Account Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://sentrykit.com/press-release",
      "target": "_blank"
    }
  }, [_vm._v("Press Release")])])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "three wide column"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(47)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seven wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Made with "), _c('i', {
    staticClass: "compact red heart icon",
    staticStyle: {
      "margin": "-6px 1px"
    }
  }), _vm._v(" by entrepreneurs for entrepreneurs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "grey"
    }
  }, [_c('span', {}, [_vm._v("We use cookies for login and minor things.")]), _vm._v(" "), _c('span', {}, [_vm._v("We don't share, sell or rent your data.")]), _vm._v(" "), _c('span', {}, [_vm._v("Your data sleeps and travels encrypted.")]), _vm._v(" "), _c('span', {}, [_vm._v("We don't sell on Amazon.")])])])
}]}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "helpModal"
    }
  }, [_c('div', {
    staticClass: "scrolling content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "second"
    }
  }, [_c('support-ticket-form', {
    ref: "issueSupportTicketForm",
    attrs: {
      "category": 'issue',
      "label": 'Question / Issue in detail',
      "lastClosedAt": _vm.lastClosedAt
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "third"
    }
  }, [_c('support-ticket-form', {
    ref: "newFeatureSupportTicketForm",
    attrs: {
      "category": 'new_feature',
      "label": 'Request a new feature',
      "lastClosedAt": _vm.lastClosedAt
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui secondary pointing menu"
  }, [_c('a', {
    staticClass: "blue item",
    attrs: {
      "data-tab": "first"
    }
  }, [_vm._v("Frequently Asked Questions")]), _vm._v(" "), _c('a', {
    staticClass: "olive active item",
    attrs: {
      "data-tab": "second"
    }
  }, [_vm._v("Contact Us / Report an Issue")]), _vm._v(" "), _c('a', {
    staticClass: "brown item",
    attrs: {
      "data-tab": "third"
    }
  }, [_vm._v("Feature Requests")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tab basic segment",
    attrs: {
      "data-tab": "first"
    }
  }, [_c('div', {
    staticClass: "ui accordion"
  }, [_c('h5', [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I have some products I can't see on my dashboard.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("\n          By default SentryKit will start to track every ASIN that has had a sale recently. Products with an active offer but no sales will be ignored until the first sale occurs to save you on SentryKit fees. "), _c('br'), _c('br'), _vm._v("\n          You can change all of these in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n          (Products with no active offer will be excluded from every list)\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I have a "), _c('i', [_vm._v("lot")]), _vm._v(" of products, do I have to pick/ignore them one by one?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("A bulk edit option is available. Check out the Import/Export section in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(" at the bottom of the screen.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Does SentryKit automatically track my new products?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("By default, yes. Both new products and long-time inactive products that started selling again (unless they are on your ignore list). "), _c('br'), _c('br'), _vm._v("\n        You can change this in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(", look for the section directly above the Save button.")])]), _vm._v(" "), _c('h5', [_vm._v("E-mails")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Help, sooo many e-mails, what to do?!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("\n          - "), _c('b', [_vm._v("To change your alert subscriptions:")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" -> E-mail -> Manage "), _c('br'), _c('br'), _vm._v("\n          - "), _c('b', [_vm._v("Mute a specific Alert for a Specific ASIN:")]), _vm._v(" Select the \"Issues\" tab on your dashboard. Hover over a product then click the \"Mute...\" dropdown button."), _c('br'), _c('br'), _vm._v("\n          - "), _c('b', [_vm._v("Rewise what ASINs")]), _vm._v(" you would like SentryKit to track in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        How can I add a notification e-mail address for a team member?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Head to your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(", click \"Add New\" below your email address. Click \"Manage\" next to the newly added address to subscribe to alerts and notifications."), _c('br'), _c('br'), _vm._v("\n        - "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("!")])]), _vm._v(" - Please note that these additional email addresses can not be used for log-in.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Notification for "), _c('i', [_vm._v("every")]), _vm._v(" review not just the critical ones, is that available?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Yes! "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" -> E-mail -> Manage -> tick the \"Notice\" checkbox in the first row, then save your settings on the bottom of the screen. All set!")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        I'm getting a lot of image change alerts lately, but I didn't change anything.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Amazon recently started swapping between product images. This is usually temporary but the change appears on the Amazon API thus triggering an image change alert in SentryKit. We are looking into ways to filter these more effectively. "), _c('br'), _c('br'), _vm._v("\n        - "), _c('b', [_vm._v("Mute frequently occuring image change alerts")]), _vm._v(" right from the alert email: "), _c('br'), _vm._v("Look for the link reading \"*NEW* Don't notify me when the same image change occurs again\"")])]), _vm._v(" "), _c('h5', [_vm._v("Other")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        How does the pricing work?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("- SentryKit has a Pay-What-You-Use pricing model. Your monthly fee is based on how many ASINs you track. After connecting your Seller Account SentryKit will add all ASINs to your dashboard that have had at least one sale recently. "), _c('br'), _c('br'), _vm._v("\n        - You can change what you track in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/productsettings"
    }
  }, [_vm._v("Product Settings")]), _vm._v(" at any time - your monthly fee will be recalculated automatically. "), _c('br'), _vm._v("(Also here: setting to add new ASINs to the dashboard automatically. Default is yes.) "), _c('br'), _c('br'), _vm._v("\n        - You can see your current montly fee in your "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(", next to your Stripe details.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        Can I add more Seller Accounts? (How about EU accounts?)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Yes, as many as you want to! ==> "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(". American and EU/UK marketplaces are all supported.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n        My question is not listed here...\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "transition hidden"
  }, [_vm._v("Send us a quick note in the next tab. We read and respond to every message.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black cancel button"
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted accordion",
    staticStyle: {
      "padding-top": "10px",
      "max-width": "800px",
      "clear": "both"
    },
    attrs: {
      "id": 'downloadSpreadsheetAccordion' + _vm.variant
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_vm._v("Send to")]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [(_vm.emails.length > 0) ? _c('div', {
    staticClass: "ui inverted form"
  }, _vm._l((_vm.emails), function(e) {
    return _c('div', {
      staticClass: "inline field"
    }, [_c('div', {
      staticClass: "ui checkbox labelCursorFix"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.selected),
        expression: "e.selected"
      }],
      attrs: {
        "id": e.email,
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(e.selected) ? _vm._i(e.selected, null) > -1 : (e.selected)
      },
      on: {
        "change": function($event) {
          var $$a = e.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(e, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(e, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(e, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": e.email
      }
    }, [_vm._v(_vm._s(e.email))])])])
  }), 0) : _c('div', [_vm._v("\n           You have no verified email addresses\n         ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('div', {
    staticClass: "ui inverted form"
  }, [_c('div', {
    staticClass: "inline field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeAllProducts),
      expression: "includeAllProducts"
    }],
    attrs: {
      "id": "includeAllProducts",
      "type": "checkbox",
      "data-lpignore": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeAllProducts) ? _vm._i(_vm.includeAllProducts, null) > -1 : (_vm.includeAllProducts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeAllProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeAllProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeAllProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeAllProducts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includeAllProducts"
    }
  }, [_vm._v("Include ALL my products in the spreadsheet")])])]), _vm._v(" "), _c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDays),
      expression: "rangeDays"
    }],
    attrs: {
      "type": "radio",
      "name": "daterange",
      "id": "daterange1",
      "value": "90",
      "checked": "checked"
    },
    domProps: {
      "checked": _vm._q(_vm.rangeDays, "90")
    },
    on: {
      "change": function($event) {
        _vm.rangeDays = "90"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDays),
      expression: "rangeDays"
    }],
    attrs: {
      "type": "radio",
      "name": "daterange",
      "id": "daterange2",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.rangeDays, "-1")
    },
    on: {
      "change": function($event) {
        _vm.rangeDays = "-1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "daterange2"
    }
  }, [_vm._v("Custom dates")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [(_vm.rangeDays == -1) ? _c('div', {
    staticClass: "inline field",
    class: _vm.sendPhase === 'DATE_INPUT_ERROR' ? 'error' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDateFrom),
      expression: "rangeDateFrom"
    }],
    staticStyle: {
      "width": "165px"
    },
    attrs: {
      "name": "datefrom",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.rangeDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeDateTo),
      expression: "rangeDateTo"
    }],
    staticStyle: {
      "width": "165px"
    },
    attrs: {
      "name": "dateto",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.rangeDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeDateTo = $event.target.value
      }
    }
  })]) : _vm._e()])], 1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui primary button",
    class: _vm.sendPhase === 'IN_PROGRESS' ? 'loading' : _vm.selectedEmailAddresses.length == 0 || _vm.emails.length == 0 || _vm.sendPhase === 'OK_FRESH' ? 'disabled' : '',
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v("Send")])]), _vm._v(" "), _c('div', {
    staticClass: "nine wide column"
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedEmailAddresses.length < 1 && _vm.emails.length > 0),
      expression: "selectedEmailAddresses.length<1 && emails.length > 0"
    }],
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("\n                select an email "), _c('br'), _vm._v("\n                address above\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendPhase === 'OK_FRESH' || _vm.sendPhase === 'FAILED' || _vm.sendPhase === 'TOO_MANY_REQUESTS'),
      expression: "sendPhase === 'OK_FRESH' || sendPhase === 'FAILED' || sendPhase === 'TOO_MANY_REQUESTS'"
    }],
    staticClass: "ui positive message"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.sendPhase === 'OK_FRESH') ? _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Your request has been received\n          ")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'OK_FRESH') ? _c('p', [_vm._v("The spreadsheet will be delivered to your inbox in a couple of minutes.")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'TOO_MANY_REQUESTS') ? _c('div', [_vm._v("The system is already compiling a spreadsheet for you, please try again in a couple of minutes.")]) : _vm._e(), _vm._v(" "), (_vm.sendPhase === 'FAILED') ? _c('div', [_vm._v("Could not send request")]) : _vm._e()])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.3em"
    }
  }, [_vm._v("\n         \n    "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('i', {
    staticClass: "olive large chart bar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "daterange1"
    }
  }, [_vm._v("Last 90 days    "), _c('span', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("- or -")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "thirteen wide column",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_vm._v("\n         This feature is currently in [Preview] - we are likely to change / add things to it."), _c('br'), _vm._v("\n         Is there something you'd like to see in the generated spreadsheets? Let us know by sending a feature request. "), _c('br'), _c('br'), _vm._v("\n         Also, while in preview: date range is 120 days max, earliest date is 60 days before signing up to SentryKit. (Need more? Contact us to lift your limits.)\n       ")])])
}]}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "ui container",
    attrs: {
      "id": "prodSetP"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('h1', {
    staticClass: "ui inverted grey header",
    staticStyle: {
      "position": "relative",
      "text-shadow": "#333 1px 2px 3px"
    }
  }, [_c('i', {
    staticClass: "cubes icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Product Tracking Settings\n    ")]), _vm._v(" "), (_vm.$root.anySellerAccountSetupCompleted) ? _c('button', {
    staticClass: "small ui compact button",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("Back")]) : _vm._e()]), _vm._v(" "), (_vm.loadingdata) ? _c('div', {
    staticClass: "sentrk_s",
    staticStyle: {
      "margin": "150px auto"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loadingdata) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Could not load product tracking settings")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchProductTrackingSettings
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.$root.anySellerAccountSetupCompleted) ? _c('div', {
    staticClass: "ui info  message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      First time here?\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$root.anySellerAccountSetupCompleted) ? _c('div', {
    staticClass: "ui info  message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      About these marketplaces\n    ")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui attached segment"
  }, [_c('div', {
    staticStyle: {
      "min-height": "40px"
    }
  }, [_c('div', {
    staticClass: "ui input left floated menu"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filter by ASIN, Title or Short-Hand Name",
      "size": "40"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.maxPage > 0) ? _c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "maxPage": _vm.maxPage,
      "currentPageRequested": _vm.currentPageRequested
    },
    on: {
      "back-to-1": function($event) {
        _vm.currentPageRequested = 0
      },
      "back": function($event) {
        _vm.currentPageRequested = Math.max(0, _vm.currentPage - 1)
      },
      "forward": function($event) {
        _vm.currentPageRequested = Math.min(_vm.maxPage, _vm.currentPage + 1)
      },
      "forward-all-the-way": function($event) {
        _vm.currentPageRequested = _vm.maxPage
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.deepVisible), function(acc) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loadingdata && !_vm.loadError),
        expression: "!loadingdata && !loadError"
      }],
      key: acc.sellerId,
      staticClass: "ui attached segment"
    }, [_c('h4', [_vm._v("Account " + _vm._s(acc.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
      class: 'ui very basic ' + (acc.products == null ? 'blurring dimmable ' : '') + 'table'
    }, [_vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), (acc.products != null && acc.products.length > 0) ? _c('tbody', _vm._l((acc.products), function(p) {
      return _c('product-row', {
        key: p.productId,
        attrs: {
          "product": p,
          "automaticallyTrackNewProducts": _vm.automaticallyTrackNewProducts
        },
        on: {
          "shortName-changed": function($event) {
            return _vm.onShortNameChange($event)
          },
          "show-changed": function($event) {
            return _vm.onShowChange($event)
          }
        }
      })
    }), 1) : (acc.products != null) ? _c('tbody', [_c('td', {
      staticClass: "ui center aligned",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Could not detect any products with recent sale")])]) : _c('tbody', [_vm._m(4, true), _vm._v(" "), _c('td', [_vm._v("Image")])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui attached message"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v(_vm._s(_vm.activeCount) + " tracked listings"), (_vm.activeCount != _vm.originalActiveCount) ? _c('span', [_vm._v(" (*)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.automaticallyTrackNewProducts),
      expression: "automaticallyTrackNewProducts"
    }],
    staticClass: "ui right pointing blue basic label",
    staticStyle: {
      "background-color": "#fff !important"
    }
  }, [_vm._v("Important")]), _vm._v(" "), _c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.automaticallyTrackNewProducts),
      expression: "automaticallyTrackNewProducts"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "automaticallyTrackNewProducts"
    },
    domProps: {
      "checked": Array.isArray(_vm.automaticallyTrackNewProducts) ? _vm._i(_vm.automaticallyTrackNewProducts, null) > -1 : (_vm.automaticallyTrackNewProducts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.automaticallyTrackNewProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.automaticallyTrackNewProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.automaticallyTrackNewProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.automaticallyTrackNewProducts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Automatically track new products upon first sale")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.automaticallyTrackNewProducts),
      expression: "!automaticallyTrackNewProducts"
    }],
    staticClass: "ui left pointing orange label"
  }, [_c('span', {
    attrs: {
      "data-inverted": "",
      "data-tooltip": "Keep this ON, especially for new accounts",
      "data-position": "top right"
    }
  }, [_vm._v("\n            Recommended setting: ON\n            ")])])]), _vm._v(" "), (_vm.maxPage > 0) ? _c('div', {
    staticClass: "six wide column"
  }, [(_vm.maxPage > 0) ? _c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "maxPage": _vm.maxPage,
      "currentPageRequested": _vm.currentPageRequested
    },
    on: {
      "back-to-1": function($event) {
        _vm.currentPageRequested = 0
      },
      "back": function($event) {
        _vm.currentPageRequested = Math.max(0, _vm.currentPage - 1)
      },
      "forward": function($event) {
        _vm.currentPageRequested = Math.min(_vm.maxPage, _vm.currentPage + 1)
      },
      "forward-all-the-way": function($event) {
        _vm.currentPageRequested = _vm.maxPage
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('br', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }]
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui primary button",
    class: {
      'loading': _vm.savingdata
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.$root.anySellerAccountSetupCompleted) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingdata && !_vm.loadError),
      expression: "!loadingdata && !loadError"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "data-inverted": "",
      "data-tooltip": "Bulk-edit your Product Settings in a spreadsheet",
      "data-position": "top center"
    }
  }, [_c('div', {
    staticClass: "ui right pointing purple label",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("Export\n    ")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "ui labeled icon button",
    attrs: {
      "for": "hidden-product-import-file"
    },
    on: {
      "click": _vm.resetFiles
    }
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("Import\n      ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "hidden-product-import-file"
    },
    on: {
      "change": _vm.importExcel
    }
  })])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Products that sold at least one unit in the last few weeks appear here.")]), _vm._v(" "), _c('li', [_vm._v("This list keeps updating automatically. Easy.")]), _vm._v(" "), _c('li', [_vm._v("\"Ignore\" products you are not interested in following. We preselected the ones seemingly not selling much.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Once we detect activity in a new marketplace it will appear here too.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted dimmer"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "black text"
  }, [_vm._v("Syncing your account from Amazon, this may take a while..")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("   Ignore   ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Title / Short-Hand Name on SentryKit ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "us flag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui positive message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Pro Tip\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("It is a good idea to set a Short-Hand name for your products. This is how we display your products on SentryKit and all emails.")]), _vm._v(" "), _c('li', [_vm._v("We recommend doing this now but you can always come back here later. Check out the menu on top right corner.")])])])
}]}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('div', {
    staticClass: "issues-navbar-filters",
    attrs: {
      "slot": "navbarFilters"
    },
    slot: "navbarFilters"
  }, [_c('div', {
    ref: "filterSA",
    staticClass: "ui multiple dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "users icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text issues-navbar-dd-summary"
  }, [_vm._v("S.Accounts: All")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Seller Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l(((_vm.sellerAccountsList || [])), function(sa) {
    return _c('div', {
      key: sa.sellerId,
      staticClass: "item",
      attrs: {
        "data-value": sa.sellerId
      }
    }, [_c('i', {
      class: (sa.region === 'NA' ? 'olive' : 'teal') + ' circle compact icon'
    }), _vm._v(_vm._s(sa.accountNickName) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "filterC",
    staticClass: "ui multiple dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "globe icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text issues-navbar-dd-summary"
  }, [_vm._v("Marketplaces: All")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Marketplaces")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.filterCountriesForDropdown), function(c) {
    return _c('div', {
      key: c,
      class: c === 's' ? 'divider' : 'item',
      attrs: {
        "data-value": c
      }
    }, [(c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag'
    }) : _vm._e(), _vm._v(_vm._s(c !== 's' ? c : '') + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "filterDate",
    staticClass: "ui dropdown issues-navbar-dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "daterange"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Date Range: " + _vm._s(_vm.dateRangeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7d"
    }
  }, [_vm._v("Last 7 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "30d"
    }
  }, [_vm._v("Last 30 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "90d"
    }
  }, [_vm._v("Last 90 Days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "all"
    }
  }, [_vm._v("All Time")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "custom"
    }
  }, [_vm._v("Custom range…")])])]), _vm._v(" "), (_vm.showCustomDatePicker) ? _c('form', {
    staticClass: "issues-custom-date-range",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.applyCustomDateRange.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customDraftStart),
      expression: "customDraftStart"
    }],
    attrs: {
      "type": "date",
      "min": _vm.customDateMin,
      "max": _vm.customDraftEnd || _vm.customDateMax,
      "aria-label": "Start date",
      "required": ""
    },
    domProps: {
      "value": (_vm.customDraftStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customDraftStart = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "issues-custom-date-sep"
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customDraftEnd),
      expression: "customDraftEnd"
    }],
    attrs: {
      "type": "date",
      "min": _vm.customDraftStart || _vm.customDateMin,
      "max": _vm.customDateMax,
      "aria-label": "End date",
      "required": ""
    },
    domProps: {
      "value": (_vm.customDraftEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customDraftEnd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "issues-custom-date-btn primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.customDraftValid
    }
  }, [_vm._v("Apply")]), _vm._v(" "), _c('button', {
    staticClass: "issues-custom-date-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCustomDateRange
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "issues-custom-date-hint"
  }, [_vm._v("Last 90 days only")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issues-dashboard"
  }, [_c('div', {
    staticClass: "issues-main-layout"
  }, [_c('AlertCategoriesSidebar', {
    attrs: {
      "alertCounts": _vm.wdAlertCounts,
      "activeCategory": _vm.activeCategory
    },
    on: {
      "select": _vm.scrollToWatchdog
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "issues-main-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "issues-loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading alerts…")])]) : (_vm.error) ? _c('div', {
    staticClass: "issues-error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load alerts")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "issues-retry-btn",
    on: {
      "click": _vm.fetchWatchdogsData
    }
  }, [_vm._v("Retry")])]) : _c('div', {
    key: "1",
    staticClass: "wide",
    attrs: {
      "id": "wdCont"
    }
  }, [_c('div', {
    staticClass: "issues-category-list-wrapper",
    attrs: {
      "id": "context"
    }
  }, _vm._l((_vm.displayedWatchdogs), function(i) {
    return (_vm.issuesWorldStore && _vm.issuesWorldStore.watchDogs[i]) ? _c('IssuesCategoryDetail', {
      key: i,
      attrs: {
        "wdtype": i,
        "wd": _vm.issuesWorldStore.watchDogs[i],
        "filterByMarket": _vm.filterByMarket,
        "filterBySellAcc": _vm.filterBySellAcc,
        "dateRange": 'all',
        "issues-list-tab": _vm.issuesListTab,
        "resolved-hidden": _vm.issuesResolvedHidden,
        "marketplace-filter-options": _vm.marketplaceColumnOptions,
        "highlighted-alert-id": _vm.highlightedAlertId,
        "items-meta": _vm.issuesItemsMeta,
        "fee-direction": _vm.issuesFeeDirection,
        "items-loading": _vm.issuesItemsLoading,
        "alert-thresholds-api-base-url": _vm.alertThresholdsApiBaseUrl,
        "stock-alert-thresholds-api-base-url": _vm.stockAlertThresholdsApiBaseUrl,
        "sales-volume-thresholds-api-base-url": _vm.salesVolumeThresholdsApiBaseUrl,
        "issue-products": _vm.issueProductsMap
      },
      on: {
        "issues-tab-change": _vm.onIssuesTabChange,
        "alert-counts-delta": _vm.onAlertCountsDelta,
        "issues-page-change": _vm.onIssuesPageChange,
        "issues-search-change": _vm.onIssuesSearchChange,
        "issues-fee-direction-change": _vm.onIssuesFeeDirectionChange,
        "issues-summary-refresh-request": _vm.onIssuesSummaryRefreshRequest,
        "filter-market": _vm.onMarketplaceColumnFilter
      }
    }) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "height": "100vh",
      "width": "100vw",
      "background-color": "rgba(0,0,0,.6)",
      "pointer-events": "none",
      "z-index": "11",
      "display": "none"
    },
    attrs: {
      "id": "darkbackgr"
    }
  })])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "HIGH"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "HIGH")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "HIGH"
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "MEDIUM"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "MEDIUM")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "MEDIUM"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "LOW"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "LOW")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "LOW"
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No Delay: "), _c('small', [_vm._v("You get alerts promptly after we detect a change in  Amazon. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("WARNING:")]), _vm._v(" This can result in a lot of notifications! Amazon Choice Badges can change frequently and repeatedly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Moderate Delay "), _c('small', [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("[RECOMMENDED]")]), _vm._v(": We apply a small delay to the Amazon Choice Badge alerts so we can filter out short-lived changes. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Strong Filtering: "), _c('small', [_vm._v("We only notify if the Amazon Choice Badge is lost or gained for a solid amount of time."), _c('br'), _vm._v(" Use this setting if you are getting too many Amazon Choice Badge alerts.")])])
}]}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Connect your Amazon store")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("Approve SentryKit on Amazon. It takes about a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-region-label",
    attrs: {
      "id": "connect-region-label"
    }
  }, [_vm._v("Where do you sell?")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-list",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "connect-region-label"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('div', {
      key: region.key,
      staticClass: "sk-region-row",
      class: {
        'is-selected': region.key === _vm.regionKey
      }
    }, [_c('label', {
      staticClass: "sk-region-radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "connect-region",
        "disabled": _vm.working
      },
      domProps: {
        "value": region.key,
        "checked": region.key === _vm.regionKey
      },
      on: {
        "change": function($event) {
          return _vm.selectRegion(region.key)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-region-name"
    }, [_vm._v(_vm._s(region.name))]), _vm._v(" "), _c('span', {
      staticClass: "sk-region-codes"
    }, [_vm._v(_vm._s(region.codes.join(', ')))])]), _vm._v(" "), (region.key === _vm.regionKey) ? _c('div', {
      staticClass: "sk-chip-row",
      attrs: {
        "role": "group",
        "aria-label": region.name + ' marketplaces'
      }
    }, [(region.codes.length > 1) ? _c('button', {
      staticClass: "sk-chip",
      class: {
        'is-on': _vm.allOn
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.allOn ? 'true' : 'false',
        "disabled": _vm.working
      },
      on: {
        "click": _vm.onToggleAll
      }
    }, [_vm._v("All")]) : _vm._e(), _vm._v(" "), _vm._l((region.codes), function(code) {
      return _c('button', {
        key: code,
        staticClass: "sk-chip",
        class: {
          'is-on': _vm.selected.indexOf(code) !== -1,
          'is-locked': region.codes.length === 1
        },
        attrs: {
          "type": "button",
          "aria-pressed": _vm.selected.indexOf(code) !== -1 ? 'true' : 'false',
          "disabled": _vm.working || region.codes.length === 1
        },
        on: {
          "click": function($event) {
            return _vm.onToggleCode(code)
          }
        }
      }, [_vm._v(_vm._s(code))])
    })], 2) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "sk-region-note"
  }, [_vm._v("Selling in more than one region? Connect one now and add the others from Settings later.")]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-connect-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.working || !_vm.canConnect
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.working ? 'Opening Amazon…' : _vm.buttonLabel))]), _vm._v(" "), _c('p', {
    staticClass: "sk-after-btn"
  }, [_vm._v("You'll sign in on Amazon's own page.")]), _vm._v(" "), (_vm.showTeammateLink) ? _c('p', {
    staticClass: "sk-teammate"
  }, [_vm._v("\n    Not the main Seller Central user?\n    "), _c('button', {
    staticClass: "sk-text-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.copying
    },
    on: {
      "click": function($event) {
        return _vm.$emit('copy-link')
      }
    }
  }, [_vm._v("Copy a link")]), _vm._v("\n    for your teammate and they can connect it.\n    "), (_vm.linkNote) ? _c('span', {
    staticClass: "sk-link-note"
  }, [_vm._v(_vm._s(_vm.linkNote))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.authCompleted) ? _c('div', {
    staticClass: "sk-connect-page"
  }, [_c('div', {
    staticClass: "sk-topbar sk-topbar-with-action"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "sk-topbar-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$root.signOutUser()
      }
    }
  }, [_vm._v("Log out")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-steps-bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-step-connector"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-step",
    class: _vm.currentStep === 5 ? 'sk-step-done' : 'sk-step-active'
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v(_vm._s(_vm.currentStep === 5 ? '✓' : '2'))]), _vm._v("\n      Connect Amazon\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [(_vm.welcomeMode && _vm.currentStep === 4 && !_vm.loadingText) ? _c('div', {
    staticClass: "sk-welcome-strip"
  }, [(_vm.welcomeMode === 'sso') ? [_c('p', {
    staticClass: "sk-welcome-main"
  }, [_vm._v("Your account is ready"), (_vm.welcomeName) ? _c('span', [_vm._v(", " + _vm._s(_vm.welcomeName))]) : _vm._e(), _vm._v(". One step left.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-welcome-sub"
  }, [_vm._v("Signed in as " + _vm._s(_vm.$root.userEmail) + " · "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.notYou
    }
  }, [_vm._v("Not you?")])])] : [_c('p', {
    staticClass: "sk-welcome-main"
  }, [_vm._v("You're signed in as " + _vm._s(_vm.$root.userEmail) + ". One step left: connect your Amazon store.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-welcome-sub"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.notYou
    }
  }, [_vm._v("Not you?")])])]], 2) : _vm._e(), _vm._v(" "), (_vm.loadingText) ? _c('div', {
    staticClass: "sk-two-col-card sk-loading-card"
  }, [_c('div', {
    staticClass: "sk-spinner",
    staticStyle: {
      "margin": "0 auto 16px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "var(--sk-text-mid, #4a6080)"
    }
  }, [_vm._v(_vm._s(_vm.loadingText))])]) : (_vm.currentStep === 4 && _vm.freeSubscriptionReady) ? _c('div', {
    key: "step-4",
    staticClass: "sk-two-col-card"
  }, [_c('div', {
    staticClass: "sk-trust-panel"
  }, [_c('h2', {
    staticClass: "sk-steps-heading"
  }, [_vm._v("What happens when you click Connect")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sk-help"
  }, [_c('img', {
    staticClass: "sk-help-photo",
    attrs: {
      "src": _vm.raghavPhoto,
      "alt": "Raghav from SentryKit"
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "sk-help-title"
  }, [_vm._v("Rather connect it together?")]), _vm._v(" "), _c('p', {
    staticClass: "sk-help-copy"
  }, [_vm._v("I'm Raghav from SentryKit. Book a call and we'll connect your store together, or ask me anything first.")]), _vm._v(" "), _c('div', {
    staticClass: "sk-help-actions"
  }, [_c('button', {
    staticClass: "sk-help-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bookCall
    }
  }, [_vm._v("Book a call")]), _vm._v(" "), _c('button', {
    staticClass: "sk-help-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openChat
    }
  }, [_vm._v("Chat with me")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-panel sk-connect-form-panel"
  }, [(_vm.billingSetupWarning) ? _c('div', {
    staticClass: "sk-billing-warning"
  }, [_c('span', [_vm._v(_vm._s(_vm.billingSetupWarning))]), _vm._v(" "), _c('button', {
    staticClass: "sk-billing-warning-retry",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ensureFreeSubscriptionThenConnect
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _c('connect-region-form', {
    attrs: {
      "working": _vm.connecting,
      "copying": _vm.copyingLink,
      "error": _vm.cardError,
      "show-teammate-link": true,
      "link-note": _vm.linkNote
    },
    on: {
      "connect": _vm.startConnect,
      "copy-link": _vm.copyTeammateLink
    }
  })], 1)]) : (_vm.currentStep === 5) ? _c('div', {
    key: "step-5",
    staticClass: "sk-two-col-card sk-success-card"
  }, [_c('div', {
    staticClass: "sk-success-wrap"
  }, [_c('div', {
    staticClass: "sk-success-icon"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#16a34a"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("You're all set!")]), _vm._v(" "), _c('p', [_vm._v("Your SentryKit account is ready. Amazon is loading your store and ASINs — this usually takes a few minutes.")]), _vm._v(" "), _c('button', {
    staticClass: "sk-cta-btn",
    staticStyle: {
      "max-width": "320px",
      "margin": "0 auto"
    },
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n          Go to Dashboard →\n        ")])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-step sk-step-done"
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v("✓")]), _vm._v("\n      Create Account\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "sk-steps"
  }, [_c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Approve on Amazon.")]), _vm._v("\n              Sign in to Seller Central and approve SentryKit for the marketplaces you picked.\n            ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Your listings load on their own.")]), _vm._v("\n              Every ASIN in those marketplaces is added for you. Nothing to upload or copy.\n            ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Monitoring starts.")]), _vm._v("\n              Alerts come to your email. Send them to Slack, Teams or ClickUp whenever you like.\n            ")])])])
}]}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.offers && _vm.offers.length > 0) ? _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 00-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 010 7.75"
    }
  })])]), _vm._v("\n      Current Offers on This ASIN\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('button', {
    staticClass: "btn-secondary"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 10 12 15 17 10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "15",
      "x2": "12",
      "y2": "3"
    }
  })]), _vm._v("\n        Export CSV\n      ")])])]), _vm._v(" "), _c('table', {
    staticClass: "data-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.offers), function(offer, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "seller-cell"
    }, [(offer.hasBuyBox) ? _c('span', {
      staticClass: "seller-badge winner"
    }, [_vm._v("Winner")]) : _vm._e(), _vm._v(" "), (offer.isMyOffer) ? _c('span', {
      staticClass: "seller-badge you"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (_vm.sellerStorefrontUrl(offer.sellerId)) ? _c('a', {
      staticClass: "seller-id seller-id-link",
      attrs: {
        "href": _vm.sellerStorefrontUrl(offer.sellerId),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(offer.sellerId))]) : _c('span', {
      staticClass: "seller-id"
    }, [_vm._v(_vm._s(offer.sellerId))])])]), _vm._v(" "), _c('td', {
      staticClass: "align-right price-cell",
      class: {
        winner: offer.hasBuyBox,
        you: offer.isMyOffer
      }
    }, [_vm._v("\n          " + _vm._s(_vm.currencySymbol) + _vm._s(offer.price.toFixed(2)) + "\n        ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "fulfillment-badge",
      class: offer.fulfillment.toLowerCase()
    }, [_vm._v("\n            " + _vm._s(offer.fulfillment) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "feedback-cell"
    }, [(offer.sellerPositiveFeedbackRating != null) ? [_c('span', {
      staticClass: "feedback-pct"
    }, [_vm._v(_vm._s(offer.sellerPositiveFeedbackRating) + "%")]), _vm._v(" "), _c('span', {
      staticClass: "feedback-count"
    }, [_vm._v(" positive · " + _vm._s(_vm.formatFeedbackCount(offer.sellerFeedbackCount)) + " ratings")])] : _c('span', {
      staticClass: "feedback-count"
    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "status-text",
      class: _vm.statusClass(offer)
    }, [_vm._v("\n            " + _vm._s(offer.status) + "\n          ")])])])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "align-right"
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Fulfillment")]), _vm._v(" "), _c('th', [_vm._v("Seller Rating")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-card-wrapper"
  }, [_c('transition-group', {
    class: 'ui stackable doubling ' + _vm.getCardsLayoutSize + ' cards',
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "div"
    }
  }, _vm._l((_vm.paginatedProducts), function(product) {
    return _c('a', {
      key: product.productId,
      class: ['product-card', 'ui card'],
      attrs: {
        "title": product.productTitle || 'Product'
      },
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('div', {
      staticClass: "card-stripe",
      class: _vm.getBuyBoxStatus(product) ? _vm.getCardStripeClass(_vm.getBuyBoxStatus(product)) : 'unknown'
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-area"
    }, [(product.largeImageUrl) ? _c('img', {
      staticClass: "card-product-image",
      attrs: {
        "src": product.largeImageUrl,
        "alt": ""
      }
    }) : _c('svg', {
      staticClass: "placeholder",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "14",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      }
    })]), _vm._v(" "), (_vm.getAlertCount(product) > 0) ? _c('div', {
      staticClass: "card-alert-badge"
    }, [_vm._v(_vm._s(_vm.getAlertCount(product)) + " alert" + _vm._s(_vm.getAlertCount(product) !== 1 ? 's' : ''))]) : _vm._e(), _vm._v(" "), (_vm.getBuyBoxStatus(product)) ? _c('div', {
      staticClass: "card-bb"
    }, [_c('span', {
      staticClass: "bb-badge",
      class: _vm.getCardStripeClass(_vm.getBuyBoxStatus(product))
    }, [_vm._v(_vm._s(_vm.getBuyBoxLabel(_vm.getBuyBoxStatus(product))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "card-market"
    }, [_c('span', {
      staticClass: "market-tag"
    }, [_vm._v(_vm._s(_vm.getMarketplaceEmoji(product.marketplace.toUpperCase())) + " " + _vm._s(product.marketplace))])]), _vm._v(" "), _c('div', {
      staticClass: "card-name",
      attrs: {
        "title": product.productTitle
      }
    }, [_vm._v(_vm._s(_vm.truncateToTwoLines(product.productTitle)))]), _vm._v(" "), _c('div', {
      staticClass: "card-asin"
    }, [_vm._v(_vm._s(_vm.getAsin(product)))]), _vm._v(" "), _c('div', {
      staticClass: "card-rating",
      attrs: {
        "title": product.reviewHealthStatus === 'red' ? (product.reviewHealthNote || '') : null
      }
    }, [_vm._v(_vm._s(_vm.ratingSummary(product.rating, product.reviewCount))), (product.reviewHealthStatus === 'red') ? _c('span', {
      staticClass: "card-rating-dot"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-cogs-strip",
      class: {
        missing: !_vm.hasProductCogs(product)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? [_c('div', {
      staticClass: "cogs-col cogs-col-clickable",
      attrs: {
        "title": "Edit product cost and margin"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("COGS")]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-value"
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.getProductCogs(product))))])]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "cogs-col cogs-col-add cogs-col-with-edit"
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("Margin")]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-value",
      class: _vm.getMarginCogsClass(_vm.calculateMargin(product))
    }, [_vm._v(_vm._s(_vm.calculateMargin(product)) + "%")]), _vm._v(" "), _c('span', {
      staticClass: "add-cogs edit-cogs-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("Edit COGS")])])] : [_c('div', {
      staticClass: "cogs-col"
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("COGS")]), _c('div', {
      staticClass: "cogs-strip-value empty"
    }, [_vm._v("Not set")])]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "cogs-col cogs-col-add"
    }, [_c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add COGS")])])]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('span', {
      staticClass: "card-footer-sales"
    }, [_c('strong', [_vm._v(_vm._s(product.salesYesterday))]), _vm._v(" units ystd.")]), _vm._v(" "), _c('div', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$parent.$parent.$refs.chartModal && _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    })])])])])
  }), 0), _vm._v(" "), _c('ProductCostMarginModal', {
    ref: "productCostMarginModal",
    on: {
      "cost-margin-updated": _vm.handleCostMarginUpdated
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    class: ['trial-strip', _vm.content.tone],
    style: (_vm.offsetTop ? {
      top: _vm.offsetTop + 'px'
    } : null)
  }, [_c('div', {
    staticClass: "trial-strip-left"
  }, [_c('svg', {
    staticClass: "trial-strip-icon",
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [(_vm.content.tone === 'expired') ? [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })] : (_vm.content.tone === 'past-due') ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })] : (_vm.content.tone === 'red') ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })] : (_vm.content.ctaAction === 'resend-verification') ? [_c('path', {
    attrs: {
      "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22,6 12,13 2,6"
    }
  })] : [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "trial-strip-body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.messageHtml)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "trial-strip-right"
  }, [_c('button', {
    staticClass: "trial-strip-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCta
    }
  }, [_vm._v("\n      " + _vm._s(_vm.content.ctaLabel) + "\n    ")]), _vm._v(" "), (_vm.content.dismissible) ? _c('button', {
    staticClass: "trial-strip-dismiss",
    attrs: {
      "type": "button",
      "title": "Dismiss"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('dismiss')
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore && !_vm.loadingApiData) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: sa.sellerId,
      staticClass: "item",
      class: {
        selected: _vm.filterBySellAcc.indexOf(sa.sellerId) >= 0
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.filterBySellAcc.indexOf(sa.sellerId) >= 0) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c == 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c != 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c != 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "products-page"
  }, [_c('div', {
    staticClass: "products-content"
  }, [(_vm.hasWorldStore && !_vm.loadingApiData) ? _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "toolbar-title-group"
  }, [_c('span', {
    staticClass: "toolbar-title"
  }, [_vm._v("Products")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill total"
  }, [_vm._v(_vm._s(_vm.totalProducts) + " total")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill cogs-ok"
  }, [_vm._v(_vm._s(_vm.cogsSetCount) + " COGS set")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill cogs-missing"
  }, [_vm._v(_vm._s(_vm.cogsMissingCount) + " missing")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar-gap"
  }), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('span', {
    staticClass: "search-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asinSearch),
      expression: "asinSearch"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.asinSearch),
      expression: "asinSearch"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products or ASIN…"
    },
    domProps: {
      "value": (_vm.asinSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAsinSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.asinSearch = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.asinSearch) ? _c('i', {
    staticClass: "times circle icon clear-search",
    on: {
      "click": _vm.clearAsinSearch
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "quick-filter",
    class: {
      active: _vm.filterByBuyBox
    },
    on: {
      "click": _vm.toggleBuyBoxFilter
    }
  }, [_vm._v("\n        Buy Box: All\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "quick-filter",
    class: {
      active: _vm.filterMissingCogs
    },
    on: {
      "click": _vm.toggleMissingCogsFilter
    }
  }, [_vm._v("\n        Missing COGS "), _c('span', {
    staticClass: "qf-count"
  }, [_vm._v(_vm._s(_vm.cogsMissingCount))])]), _vm._v(" "), _c('button', {
    staticClass: "btn-import",
    on: {
      "click": _vm.handleImportCogs
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1"
    }
  }), _c('polyline', {
    attrs: {
      "points": "7 10 12 15 17 10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "15",
      "x2": "12",
      "y2": "3"
    }
  })]), _vm._v("\n        Import COGS\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "view-toggle"
  }, [_c('button', {
    staticClass: "view-btn",
    class: {
      active: _vm.viewMode === 'grid'
    },
    attrs: {
      "title": "Grid view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'grid'
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "3",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "3",
      "y": "14",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "14",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "view-btn",
    class: {
      active: _vm.viewMode === 'table'
    },
    attrs: {
      "title": "Table view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'table'
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    key: "2",
    staticClass: "ui fluid container",
    attrs: {
      "id": "prodCont"
    }
  }, [(_vm.loadingApiData || !_vm.hasWorldStore) ? _c('div', {
    staticClass: "ui active centered inline loader",
    staticStyle: {
      "margin": "50px 0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.apiError && !_vm.loadingApiData) ? _c('div', {
    staticClass: "ui error message",
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Failed to Load Products")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.apiError))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.loadProductsFromBackend()
      }
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.productData && _vm.productData.products && Object.keys(_vm.productData.products).length > 0 && _vm.viewMode === 'grid' && !_vm.loadingApiData) ? _c('ProductCard', {
    key: 'grid-' + _vm.gridCurrentPage,
    ref: "productCard",
    attrs: {
      "worldStore": _vm.productData,
      "filterByMarket": _vm.filterByMarket,
      "filterBySellAcc": _vm.filterBySellAcc,
      "filterMissingCogs": _vm.filterMissingCogs
    },
    on: {
      "open-product-details": _vm.showProductDetails,
      "cogs-updated": _vm.handleCogsUpdated
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.productData && _vm.productData.products && Object.keys(_vm.productData.products).length > 0 && _vm.viewMode === 'table' && !_vm.loadingApiData) ? _c('div', {
    staticClass: "table-view",
    attrs: {
      "id": "tableView"
    }
  }, [_c('div', {
    staticClass: "products-table-wrap"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-img"
  }), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('product'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by product name or ASIN"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('product')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('product')
      }
    }
  }, [_vm._v("Product / ASIN"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'product' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'product' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('buyBox'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Buy Box status"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('buyBox')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('buyBox')
      }
    }
  }, [_vm._v("Buy Box"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'buyBox' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'buyBox' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('rating'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by star rating"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('rating')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('rating')
      }
    }
  }, [_vm._v("Rating"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'rating' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'rating' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('salesYesterday'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by units sold yesterday"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('salesYesterday')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('salesYesterday')
      }
    }
  }, [_vm._v("Sales (ystd.)"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'salesYesterday' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'salesYesterday' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('salesToday'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by units sold today"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('salesToday')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('salesToday')
      }
    }
  }, [_vm._v("Sales (today)"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'salesToday' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'salesToday' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('cogs'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by COGS"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('cogs')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('cogs')
      }
    }
  }, [_vm._v("COGS"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'cogs' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'cogs' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('margin'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by margin %"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('margin')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('margin')
      }
    }
  }, [_vm._v("Margin"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'margin' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'margin' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      staticClass: "clickable-row",
      class: {
        'cogs-missing-row': !(product.cogs && parseFloat(product.cogs) > 0)
      },
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "product-thumb"
    }, [(product.largeImageUrl) ? _c('img', {
      attrs: {
        "src": product.largeImageUrl,
        "alt": ""
      }
    }) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.5"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "14",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "product-meta"
    }, [_c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(_vm.getAsin(product)))]), _vm._v(" "), _c('span', {
      staticClass: "market-tag"
    }, [_vm._v(_vm._s(_vm.getMarketplaceEmoji((product.marketplace || '').toUpperCase())) + " " + _vm._s(product.marketplace || '—'))])])])])]), _vm._v(" "), _c('td', [(_vm.getBuyBoxStatus(product)) ? _c('span', {
      staticClass: "bb-badge",
      class: _vm.getTableBuyBoxClass(_vm.getBuyBoxStatus(product))
    }, [_vm._v(_vm._s(_vm.getBuyBoxStatusLabel(_vm.getBuyBoxStatus(product))))]) : _c('span', {
      staticClass: "bb-badge unknown"
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "rating-cell",
      class: {
        'rating-unknown': _vm.ratingSummary(product.rating, product.reviewCount) === '—'
      }
    }, [_vm._v(_vm._s(_vm.ratingSummary(product.rating, product.reviewCount)))]), _vm._v(" "), (product.reviewHealthStatus === 'red') ? _c('span', {
      staticClass: "rating-alert-dot",
      attrs: {
        "title": product.reviewHealthNote || 'Review Health alert',
        "aria-label": product.reviewHealthNote || 'Review Health alert',
        "role": "img"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-primary"
    }, [_vm._v(_vm._s(product.salesYesterday || 0) + " units")]), _vm._v(" "), _c('div', {
      staticClass: "sales-sub"
    }, [_vm._v("Yesterday")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-primary"
    }, [_vm._v(_vm._s(product.salesToday || 0) + " units")]), _vm._v(" "), _c('div', {
      staticClass: "sales-sub"
    }, [_vm._v("So far today")])]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? _c('span', {
      staticClass: "cogs-val cogs-val-editable",
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.getProductCogs(product))))]) : _c('span', {
      staticClass: "cogs-empty"
    }, [_vm._v("Not set")])]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? [(_vm.getProductMargin(product) != null) ? _c('span', {
      staticClass: "margin-pill cogs-val-editable",
      class: _vm.getMarginClass(_vm.getProductMargin(product)),
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v(_vm._s(_vm.getProductMargin(product)) + "%")]) : _c('span', {
      staticClass: "margin-pill low cogs-val-editable",
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("—")]), _vm._v(" "), _c('div', {
      staticClass: "table-edit-cogs-wrap"
    }, [_c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("Edit COGS")])])] : _c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add COGS")])], 2), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openChartModal(product)
        }
      }
    }, [_c('div', {
      staticClass: "action-btn"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment products-pagination-segment"
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.tablePrevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.gridTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.gridCurrentPage === _vm.getTablePageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToTablePage(_vm.getTablePageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getTablePageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage >= (_vm.gridTotalPages - 1)
    },
    on: {
      "click": function($event) {
        return _vm.tableNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.gridCurrentPage + 1) + " of " + _vm._s(_vm.gridTotalPages) + "\n            (" + _vm._s(_vm.gridTotalItems) + " total products)\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasWorldStore && _vm.viewMode === 'grid') ? _c('div', {
    staticClass: "ui center aligned segment products-pagination-segment"
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevGridPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.gridTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.gridCurrentPage === _vm.getGridPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToGridPage(_vm.getGridPageNumber(page))
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getGridPageNumber(page) + 1) + "\n          ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage >= (_vm.gridTotalPages - 1)
    },
    on: {
      "click": function($event) {
        return _vm.nextGridPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          Showing page " + _vm._s(_vm.gridCurrentPage + 1) + " of " + _vm._s(_vm.gridTotalPages) + "\n          (" + _vm._s(_vm.gridTotalItems) + " total products)\n        ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('ProductDetails', {
    ref: "productDetails"
  }), _vm._v(" "), _c('ProductDetailsChartModal', {
    ref: "chartModal"
  }), _vm._v(" "), _c('ProductCostMarginModal', {
    ref: "tableProductCostMarginModal",
    on: {
      "cost-margin-updated": _vm.handleTableCostMarginUpdated
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-stat-cards"
  }, _vm._l((_vm.cards), function(card) {
    return _c('div', {
      key: card.filter,
      class: ['stock-stat-card', 'filter-' + card.filter, {
        active: _vm.activeFilter === card.filter
      }],
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('filter-change', card.filter)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.$emit('filter-change', card.filter)
        }
      }
    }, [_c('div', {
      class: ['stock-stat-icon', card.color]
    }, [_c('i', {
      class: card.icon + ' icon'
    })]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-info"
    }, [_c('div', {
      staticClass: "stock-stat-value"
    }, [_vm._v(_vm._s(card.value))]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-label"
    }, [_vm._v(_vm._s(card.label))]), _vm._v(" "), _c('div', {
      staticClass: "stock-stat-sublabel"
    }, [_vm._v(_vm._s(card.sublabel))])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.isSellerSelected(sa.sellerId)
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.isSellerSelected(sa.sellerId)) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buybox-dashboard"
  }, [_c('div', {
    staticClass: "dashboard-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading dashboard data...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load dashboard")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.fetchDashboardData
    }
  }, [_vm._v("Retry")])]) : [_c('div', {
    staticClass: "dashboard-stats"
  }, [(!_vm.onboardingComplete) ? _c('div', {
    staticClass: "stat-card ownership-card sk-skeleton-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("BUY BOX OWNERSHIP "), _c('i', {
    staticClass: "info circle icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-sm",
    staticStyle: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-pill"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v("\n            Reading Buy Box status…\n          ")])]) : _c('BuyBoxOwnershipCard', {
    attrs: {
      "data": _vm.ownership
    }
  }), _vm._v(" "), (!_vm.onboardingComplete) ? _c('div', {
    staticClass: "stat-card revenue-card sk-skeleton-card"
  }, [_c('div', {
    staticClass: "stat-header revenue-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("EST. DAILY REVENUE IMPACT "), _c('i', {
    staticClass: "info circle icon"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "stat-tag"
  }, [_vm._v("ESTIMATE")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-sm",
    staticStyle: {
      "width": "85%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block-wide"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-pill"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v("\n            Awaiting Buy Box & sales data…\n          ")])]) : _c('RevenueImpactCard', {
    attrs: {
      "data": _vm.revenueImpact
    }
  })], 1), _vm._v(" "), (!_vm.onboardingComplete) ? _c('div', {
    staticClass: "sk-skeleton-section"
  }, [_c('div', {
    staticClass: "sk-section-label"
  }, [_vm._v("BUY BOX STATUS BREAKDOWN")]), _vm._v(" "), _c('div', {
    staticClass: "sk-status-grid"
  }, _vm._l((4), function(n) {
    return _c('div', {
      key: n,
      staticClass: "sk-status-placeholder"
    }, [_c('div', {
      staticClass: "sk-skel-block sk-skel-sm",
      staticStyle: {
        "width": "40%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sk-skel-block sk-skel-xs",
      staticStyle: {
        "width": "60%"
      }
    })])
  }), 0)]) : _c('StatusBreakdown', {
    attrs: {
      "statusData": _vm.statusBreakdown,
      "activeType": _vm.activeStatusFilter
    },
    on: {
      "status-click": _vm.handleStatusFilter
    }
  }), _vm._v(" "), _c('PriorityIssuesList', {
    attrs: {
      "issues": _vm.onboardingComplete ? _vm.priorityIssues : [],
      "needActionCount": _vm.needActionCount,
      "totalIssues": _vm.totalIssues,
      "syncing": !_vm.onboardingComplete,
      "exporting": _vm.exporting
    },
    on: {
      "viewAll": _vm.viewAllAlerts,
      "export": _vm.exportPriorityIssuesCsv,
      "product-click": _vm.viewProductDetails,
      "action-click": _vm.viewProductDetails
    }
  })]], 2)])], 2)
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon message",
    class: _vm.isFooter ? 'footer-partner' : 'in-watchdog'
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        return _vm.$emit('dismiss')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "mini ui icon button",
    attrs: {
      "href": "https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit",
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isFooter ? 'Learn more' : '')), _c('i', {
    staticClass: "arrow right icon"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "width": "min(35vmin, 350px)",
      "line-height": "0"
    },
    attrs: {
      "href": "https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://d9hhrg4mnvzow.cloudfront.net/register.payoneer.com/en/solution/capital-advance/5f9c1dd5-payoneer-capital-advance-logo-dark-sml_1000000000000000000028.png",
      "alt": "banner"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Need cash to replenish stock?   SentryKit users get "), _c('strong', [_vm._v("10% fee rebate")]), _vm._v(" on their first Payoneer Capital Advance.")])
}]}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "trial-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "trial-lockout-title"
    }
  }, [_vm._v("Your trial has ended")]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub"
  }, [_vm._v("\n      Pick a plan to resume access to your dashboard, alerts, and tracking. Your data is safe —\n      service resumes the moment you complete checkout.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plans"
  }, [_c('button', {
    class: ['trial-lockout-plan', {
      selected: _vm.selectedPlanKey === 'starter'
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startStarterUpgradeFlow
    }
  }, [(_vm.selectedPlanKey === 'starter') ? _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("Your selection")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    class: ['trial-lockout-plan', 'recommended', {
      selected: _vm.selectedPlanKey === 'pro'
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startProUpgradeFlow
    }
  }, [(_vm.selectedPlanKey === 'pro') ? _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("Your selection")]) : _c('span', {
    staticClass: "trial-lockout-plan-badge"
  }, [_vm._v("★ Recommended")]), _vm._v(" "), _c('div', {
    staticClass: "trial-lockout-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('button', {
    staticClass: "trial-lockout-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.startProUpgradeFlow
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Please wait…' : 'Continue with Pro →') + "\n    ")]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "trial-lockout-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.openComparePlans
    }
  }, [_vm._v("Compare plans")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])]), _vm._v(" "), (_vm.comparePlansOpen) ? _c('div', {
    staticClass: "trial-compare-backdrop",
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeComparePlans.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "trial-compare-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "trial-compare-title",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "trial-compare-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeComparePlans
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-compare-title",
    attrs: {
      "id": "trial-compare-title"
    }
  }, [_vm._v("Compare plans")]), _vm._v(" "), _c('p', {
    staticClass: "trial-compare-sub"
  }, [_vm._v("Pick the plan that fits your order volume. You can change plans anytime from billing.")]), _vm._v(" "), _c('div', {
    staticClass: "trial-compare-grid"
  }, [_c('div', {
    class: ['trial-compare-col', {
      selected: _vm.selectedPlanKey === 'starter'
    }]
  }, [(_vm.selectedPlanKey === 'starter') ? _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("Your selection")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "trial-compare-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "trial-compare-btn trial-compare-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.onCompareSelectStarter
    }
  }, [_vm._v("\n            Choose Starter\n          ")])]), _vm._v(" "), _c('div', {
    class: ['trial-compare-col', 'trial-compare-col-pro', {
      selected: _vm.selectedPlanKey === 'pro'
    }]
  }, [(_vm.selectedPlanKey === 'pro') ? _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("Your selection")]) : _c('span', {
    staticClass: "trial-compare-badge"
  }, [_vm._v("★ Recommended")]), _vm._v(" "), _c('h3', {
    staticClass: "trial-compare-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "trial-compare-plus"
  }, [_vm._v("Everything in Starter, plus:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "trial-compare-btn trial-compare-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.onCompareSelectPro
    }
  }, [_vm._v("\n            " + _vm._s(_vm.busy ? 'Please wait…' : 'Continue with Pro →') + "\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-plan-price"
  }, [_vm._v("$19"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-plan-price"
  }, [_vm._v("$49"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trial-compare-price"
  }, [_vm._v("$19"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "trial-compare-features"
  }, [_c('li', [_vm._v("All alert types · real-time delivery")]), _vm._v(" "), _c('li', [_vm._v("Directional signals from Day 1")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Pattern insights from Day 15")])]), _vm._v(" "), _c('li', [_vm._v("Action signals from Day 30+")]), _vm._v(" "), _c('li', [_vm._v("COGS, floor price & margin alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trial-compare-price"
  }, [_vm._v("$49"), _c('span', {
    staticClass: "per"
  }, [_vm._v("/mo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "trial-compare-features"
  }, [_c('li', [_c('strong', [_vm._v("Competitor seller profiles")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Seller name, location & storefront")])])])
}]}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "center aligned",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_c('div', {
    staticClass: "ui checkbox",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "dnt"
    },
    domProps: {
      "indeterminate": _vm.indeterminate,
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : (_vm.value)
    },
    on: {
      "click": function($event) {
        return _vm.cycleState()
      },
      "change": function($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.value = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label')]), _vm._v(" "), _c('br'), _vm._v(" "), (this.state === 'ignored' || (this.state === 'ignoredUntilFirstSale' && !_vm.automaticallyTrackNewProducts)) ? _c('div', {
    staticClass: "ui tiny label"
  }, [_vm._v("Ignored")]) : (this.state === 'ignoredUntilFirstSale') ? _c('div', {
    staticClass: "ui tiny label"
  }, [_vm._v("Ignored until next order")]) : _c('div', [_vm._v(" ")])]), _vm._v(" "), _c('td', {
    staticClass: "product-settings-image-cell"
  }, [_c('i', {
    class: _vm.product.marketplaceIso31662Code + ' flag'
  }), _vm._v(" "), _c('a', {
    staticClass: "product-settings-image-link",
    attrs: {
      "href": _vm.product.productPage,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "product-settings-row-thumb",
    attrs: {
      "src": _vm.product.imageUrl,
      "alt": _vm.product.productName || ''
    }
  }), _vm._v(" "), _c('br'), _c('small', [_vm._v("[" + _vm._s(_vm.product.asin1) + "]")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.productName) + " "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortName),
      expression: "shortName"
    }],
    staticStyle: {
      "margin-left": "-15px"
    },
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "size": "40"
    },
    domProps: {
      "value": (_vm.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui tiny left pointing label"
  }, [_vm._v("\n      Short-hand name\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic large long modal",
    staticStyle: {
      "min-height": "99vh"
    },
    attrs: {
      "id": "productDetailModal"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.galleryPrevButton),
      expression: "galleryPrevButton"
    }],
    staticClass: "ui massive circular inverted basic icon button",
    staticStyle: {
      "position": "absolute",
      "top": "200px",
      "left": "-10%",
      "opacity": ".4"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.galleryPrev.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), (_vm.productIDs.length > 0) ? _c('div', {
    staticClass: "header prodDetOverlayHeader"
  }, [_c('i', {
    class: '' + (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace.toLowerCase().replace('uk', 'gb') : 'us') + ' flag'
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl,
      "target": "_blank",
      "data-tooltip": "View Product On Amazon",
      "data-inverted": "",
      "data-position": "right center"
    }
  }, [_c('i', {
    staticClass: "blue external share icon"
  }), _vm._v("\n      " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1") : 'N/A') + "\n      -\n      " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productTitle))])]) : _vm._e(), _vm._v(" "), (_vm.productIDs.length > 0) ? _c('div', {
    staticClass: "content "
  }, [_c('div', {
    staticClass: "ui stackable grid",
    attrs: {
      "id": "muteAble"
    }
  }, [_c('div', {
    staticClass: "five wide column"
  }, [_c('div', {
    staticClass: "ui image"
  }, [(_vm.productIDs.length > 1 && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length > 1) ? _c('div', {
    staticClass: "floating ui grey label",
    staticStyle: {
      "left": "93%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.numInGroup()) + "  of  " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].isAdultFlag) ? _c('div', {
    staticClass: "floating ui big red label",
    staticStyle: {
      "left": "-2%",
      "top": "-5%"
    },
    attrs: {
      "data-tooltip": "!! Adult Item flag in ON - product does not appear on standard amazon search !!",
      "data-position": "right center"
    }
  }, [_c('i', {
    staticClass: "icon circle warning"
  }), _vm._v(" 18+\n            ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "ui image medium",
    staticStyle: {
      "max-height": "240px",
      "max-width": "240px",
      "height": "auto",
      "width": "auto",
      "border-radius": "3px"
    },
    attrs: {
      "src": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].largeImageUrl
    }
  })]), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].ageHours > -1) ? _c('div', [_c('br'), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].bsrRank !== null) ? _c('div', [_vm._v("\n            BSR "), _c('small', [_vm._v("(24h avg.): ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#a291fb",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].bsrRank) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "width": "275px",
      "border": "1px solid #333"
    }
  }, [_c('div', {
    staticClass: "ui inverted violet tiny statistic",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("today so far")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].day : 'N/A') + " " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.toMonth(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].month) : '') + "    (" + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].unitsSold : 0))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted violet tiny statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].day : 'N/A') + " " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.toMonth(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].month) : '') + "   (" + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].unitsSold : 0))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length > 1) ? _c('div', [_c('div', {
    staticClass: "ui inverted brown tiny statistic"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "visibility": "hidden",
      "height": "0"
    }
  }, [_vm._v("today so far")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.salesCount('t', _vm.productIDs[_vm.index], 'unitsSold')))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted brown tiny statistic"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "visibility": "hidden",
      "height": "0"
    }
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.salesCount('y', _vm.productIDs[_vm.index], 'unitsSold')))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]) : _vm._e(), _vm._v(" "), _vm._l((['today', 'ytd']), function(day) {
    return _c('div', {
      staticStyle: {
        "width": "110px",
        "float": "left",
        "margin": "0 9px 1px 0"
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasPromoCodes(day)),
        expression: "hasPromoCodes(day)"
      }],
      staticClass: "ui brown tiny tag label"
    }, [_vm._v("Promo codes")]), _vm._v(" "), _vm._l((_vm.promoCodes[day]), function(val, key) {
      return _c('small', {
        staticStyle: {
          "display": "block"
        },
        attrs: {
          "data-tooltip": key + ' : ' + val.units + ' units from ' + val.orders + ' orders',
          "data-position": "right center"
        }
      }, [(val.units !== val.orders) ? _c('span', [_vm._v("\n                   - " + _vm._s(key.slice(0, 25)) + ": "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(" " + _vm._s(val.units))]), _vm._v(" ( from "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(_vm._s(val.orders))]), _vm._v(" ord.)\n                ")]) : _c('span', [_vm._v("\n                   - " + _vm._s(key.slice(0, 25)) + ": "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(" " + _vm._s(val.units) + " units")])])])
    }), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasPromoCodes(day)),
        expression: "hasPromoCodes(day)"
      }],
      staticStyle: {
        "color": "grey"
      }
    }, [_vm._v("\n                - no code:\n                  " + _vm._s(_vm.salesCount(day, _vm.productIDs[_vm.index], 'organicUnits')) + " u.\n                  (" + _vm._s(_vm.salesCount(day, _vm.productIDs[_vm.index], 'organicOrders')) + " ord.)\n              ")])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui mini compact basic brown button",
    staticStyle: {
      "padding": "3px 6px",
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]], 'productDetailModal')
      }
    }
  }, [_vm._v("\n              See full month...\n            ")])], 2), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].fbaFeeEstimate !== null) ? _c('div', [_vm._v("\n            FBA Fee estimate: "), _c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].fbaFeeEstimate) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(based on current weight and size)")])]) : _vm._e()]) : _c('div', [_c('br'), _c('br'), _c('br'), _vm._v("\n            Syncing in progress."), _c('br'), _vm._v(" Sales and Promo-code data not yet available.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('h4', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v("Product Listing Health")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed divided list",
    staticStyle: {
      "margin-left": "0px"
    }
  }, _vm._l((_vm.wdDet), function(i) {
    return (_vm.currentProductWatchDogs[i.wdType]) ? _c('div', {
      staticClass: "item",
      class: {
        'muteAble': !_vm.currentProductWatchDogs[i.wdType].muted && (_vm.currentProductWatchDogs[i.wdType].status == 1 || _vm.currentProductWatchDogs[i.wdType].status == 2),
        'issueSt0': _vm.currentProductWatchDogs[i.wdType].issueStatus == 0,
        'issueSt1': _vm.currentProductWatchDogs[i.wdType].issueStatus == 1,
        'issueSt2': _vm.currentProductWatchDogs[i.wdType].issueStatus == 2,
        'issueSt3': _vm.currentProductWatchDogs[i.wdType].issueStatus == 3,
        'stts21kdfslds': (_vm.currentProductWatchDogs[i.wdType].status == 21)
      },
      attrs: {
        "data-wdtype": i.wdType
      }
    }, [(i.wdType == 'lostBuybox' && _vm.currentProductWatchDogs[i.wdType].statusDetails && _vm.currentProductWatchDogs[i.wdType].statusDetails.message && _vm.currentProductWatchDogs[i.wdType].statusDetails.message.indexOf('no offers from any sellers') >= 0) ? _c('i', {
      staticClass: "right grey warning circle icon"
    }) : _c('i', {
      class: _vm.getIconClasses(_vm.currentProductWatchDogs[i.wdType]),
      on: {
        "click": function($event) {
          return _vm.cycleIssueStatus(i.wdType, _vm.productIDs[_vm.index])
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "width": "100%",
        "color": "#8a8a8a"
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(_vm.currentProductWatchDogs[i.wdType].muted) ? _c('i', {
      staticClass: " mute alarm outline icon"
    }) : _vm._e(), _vm._v(" "), (!_vm.currentProductWatchDogs[i.wdType].muted && _vm.currentProductWatchDogs[i.wdType].status > 0) ? _c('span', [(_vm.currentProductWatchDogs[i.wdType].issueStatus == 1) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs[i.wdType].issueStatus == 2) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs[i.wdType].issueStatus == 3) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (i.wdType == 'badReview') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productReviewsUrl,
        "target": "_blank",
        "data-tooltip": "View The Latest Reviews On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'topReview') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productTopReviewsUrl,
        "target": "_blank",
        "data-tooltip": "View The Top Rated Reviews On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'lostBuybox') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productOffersUrl,
        "target": "_blank",
        "data-tooltip": "View All Offer For This ASIN On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'salesDrop') ? _c('span', [_vm._v("\n                    " + _vm._s(i.wdName) + "  \n                    "), _c('div', {
      staticClass: "ui brown compact basic icon button",
      staticStyle: {
        "float": "right",
        "margin": "1px"
      },
      on: {
        "click": function($event) {
          return _vm.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]], 'productDetailModal')
        }
      }
    }, [_c('i', {
      staticClass: " large chart bar outline icon"
    })]), _vm._v(" "), (_vm.$parent.$parent.onboarding.saleschrt) ? _c('div', {
      staticClass: "onboarding ui right pointing large yellow label labelCursorFix",
      staticStyle: {
        "position": "absolute",
        "left": "160px",
        "cursor": "pointer"
      },
      attrs: {
        "data-onboarding": "saleschrt"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.onboarder('saleschrt')
        }
      }
    }, [_vm._v("\n                      Detailed Sales Chart + BSR"), _c('br'), _vm._v(" "), _c('small', {
      staticStyle: {
        "float": "right",
        "margin-top": "5px"
      }
    }, [_vm._v("Click this note to dismiss")])]) : _vm._e()]) : _c('span', [_vm._v("\n                    " + _vm._s(i.wdName) + "\n                  ")])]), _vm._v(" "), (i.wdType == 'topReview' || i.wdType == 'badReview') ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.prettyfyReviewText(_vm.currentProductWatchDogs[i.wdType].statusDetails.message))
      }
    }) : (i.wdType == 'starRatingRecentChange') ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.prettyfyRatingText(_vm.currentProductWatchDogs[i.wdType].statusDetails.message))
      }
    }) : _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.currentProductWatchDogs[i.wdType].statusDetails.message)
      }
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "five wide column"
  }, [(_vm.currentProductWatchDogs.inventory && _vm.currentProductWatchDogs.inventory.status !== 21) ? _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "border": "1px solid #333"
    }
  }, [_c('h4', [_vm._v("FBA Stock level")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed list"
  }, [_c('div', {
    staticClass: "item inventoryItem",
    class: {
      'muteAble': !_vm.currentProductWatchDogs.inventory.muted && (_vm.currentProductWatchDogs.inventory.status == 1 || _vm.currentProductWatchDogs.inventory.status == 2),
      'issueSt0': _vm.currentProductWatchDogs.inventory.issueStatus == 0,
      'issueSt1': _vm.currentProductWatchDogs.inventory.issueStatus == 1,
      'issueSt2': _vm.currentProductWatchDogs.inventory.issueStatus == 2,
      'issueSt3': _vm.currentProductWatchDogs.inventory.issueStatus == 3
    }
  }, [_c('i', {
    staticClass: "big ",
    class: _vm.getIconClasses(_vm.currentProductWatchDogs.inventory),
    on: {
      "click": function($event) {
        return _vm.cycleIssueStatus('inventory', _vm.productIDs[_vm.index])
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message ? _vm.currentProductWatchDogs.inventory.statusDetails.message.replace(/\(.*\)/gi, '').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : '')
    }
  }), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message && _vm.currentProductWatchDogs.inventory.statusDetails.message.indexOf('No alert threshold') !== -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "data-tooltip": "You can set Inventory alerts on the 'FBA Stock' tab"
    }
  }, [_c('small', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v("[No FBA Inventory Alerts Set - hover for more]")])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message && _vm.currentProductWatchDogs.inventory.statusDetails.message.toLowerCase().indexOf('(') > -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [(_vm.currentProductWatchDogs.inventory.muted) ? _c('i', {
    staticClass: " mute alarm outline icon"
  }) : _vm._e(), _vm._v(" "), ((!_vm.currentProductWatchDogs.inventory.muted) && _vm.currentProductWatchDogs.inventory.status > 0) ? _c('span', [(_vm.currentProductWatchDogs.inventory.issueStatus == 1) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.issueStatus == 2) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.issueStatus == 3) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message ? _vm.currentProductWatchDogs.inventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory && _vm.currentProductWatchDogs.fbmInventory.status !== 21) ? _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "border": "1px solid #333"
    }
  }, [_c('h4', [_vm._v("FBM Stock level")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed list"
  }, [_c('div', {
    staticClass: "item fbmInventoryItem",
    class: {
      'muteAble': !_vm.currentProductWatchDogs.fbmInventory.muted && (_vm.currentProductWatchDogs.fbmInventory.status == 1 || _vm.currentProductWatchDogs.fbmInventory.status == 2),
      'issueSt0': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 0,
      'issueSt1': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 1,
      'issueSt2': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 2,
      'issueSt3': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 3
    }
  }, [_c('i', {
    staticClass: "big ",
    class: _vm.getIconClasses(_vm.currentProductWatchDogs.fbmInventory),
    on: {
      "click": function($event) {
        return _vm.cycleIssueStatus('fbmInventory', _vm.productIDs[_vm.index])
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message ? _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/\(.*\)/gi, '').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : '')
    }
  }), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.indexOf('No alert threshold') !== -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "data-tooltip": "You can set Inventory alerts on the 'FBM Stock' tab"
    }
  }, [_c('small', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v("[No FBM Inventory Alerts Set - hover for more]")])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.toLowerCase().indexOf('(') > -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [(_vm.currentProductWatchDogs.fbmInventory.muted) ? _c('i', {
    staticClass: " mute alarm outline icon"
  }) : _vm._e(), _vm._v(" "), ((!_vm.currentProductWatchDogs.fbmInventory.muted) && _vm.currentProductWatchDogs.fbmInventory.status > 0) ? _c('span', [(_vm.currentProductWatchDogs.fbmInventory.issueStatus == 1) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.issueStatus == 2) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.issueStatus == 3) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message ? _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Primary Keywords Search Rank")]), _vm._v(" "), (_vm.currentProductKeywords.length > 0) ? _c('div', {
    staticClass: "ui inverted relaxed list",
    attrs: {
      "id": "keywordsList"
    }
  }, _vm._l((_vm.currentProductKeywords), function(k, i) {
    return _c('div', {
      key: k.watchDogItemId,
      staticClass: "item",
      class: {
        'muteAble': (k.status == 1 || k.status == 2) && !k.muted,
        'issueSt0': k.issueStatus == 0,
        'issueSt1': k.issueStatus == 1,
        'issueSt2': k.issueStatus == 2,
        'issueSt3': k.issueStatus == 3
      }
    }, [_c('i', {
      class: _vm.getIconClasses(k),
      on: {
        "click": function($event) {
          return _vm.cycleKeywordIssueStatus(_vm.productIDs[_vm.index], i)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(k.muted) ? _c('i', {
      staticClass: " mute alarm outline icon"
    }) : _vm._e(), _vm._v(" "), (!k.muted && (k.status == 1 || k.status == 2)) ? _c('span', [(k.issueStatus == 1) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (k.issueStatus == 2) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (k.issueStatus == 3) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'http://' + _vm.amaSites[k.marketplace] + '/s/?field-keywords=' + (k.settings && k.settings.keyword ? k.settings.keyword : ''),
        "target": "_blank",
        "data-tooltip": "View Keyword On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    \"" + _vm._s(k.settings && k.settings.keyword ? k.settings.keyword : 'N/A') + "\"\n                    "), _c('i', {
      staticClass: "blue external share icon"
    })]), _vm._v(" "), (k.settings && k.settings.absoluteThreshold > 0 && k.settings.absoluteThreshold < 1000) ? _c('small', {
      staticStyle: {
        "color": "#aaa"
      },
      attrs: {
        "data-tooltip": 'Alert if rank falls below ' + k.settings.absoluteThreshold,
        "data-position": "top center"
      }
    }, [_vm._v("\n                    ("), _c('i', {
      staticClass: "right small alarm icon"
    }), _vm._v("< rank " + _vm._s(k.settings.absoluteThreshold) + ")\n                  ")]) : _vm._e(), _vm._v(" "), (k.hasOwnProperty('watchDogId')) ? _c('a', {
      staticClass: "removeKeyword",
      attrs: {
        "data-wdid": k.watchDogId,
        "data-tooltip": "Hold [Shift] + Click To Remove",
        "data-position": "top center"
      },
      on: {
        "click": function($event) {
          if (!$event.shiftKey) { return null; }
          $event.preventDefault();
          return _vm.removeKeyword(k.watchDogId)
        }
      }
    }, [_vm._v("Del Kwrd")]) : _vm._e()]), _vm._v("\n                " + _vm._s(k.statusDetails.message) + "\n              ")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.showAddKeywordForm && _vm.currentProductKeywords.length < 8) ? _c('button', {
    staticClass: "ui mini compact basic labeled icon button teal",
    class: {
      'olive': _vm.currentProductKeywords.length == 0
    },
    staticStyle: {
      "position": "absolute"
    },
    on: {
      "click": function($event) {
        _vm.showAddKeywordForm = true
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v("Add\n          ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddKeywordForm),
      expression: "showAddKeywordForm"
    }],
    staticClass: "ui mini form",
    attrs: {
      "id": "addNewKeywordForm"
    }
  }, [_c('div', {
    staticClass: "eleven wide required field"
  }, [_c('input', {
    attrs: {
      "name": "newKeyword",
      "type": "text",
      "placeholder": "New Keyword Phrase To Track",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline fields"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Alert if rank falls below this rank :  ")]), _vm._v(" "), _c('div', {
    staticClass: "three wide field",
    attrs: {
      "data-tooltip": "Rank 1-150 or leave blank for no Alerts",
      "data-position": "bottom center"
    }
  }, [_c('input', {
    attrs: {
      "name": "newTreshold",
      "type": "text",
      "placeholder": "Rank",
      "value": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui mini submit primary button",
    on: {
      "click": _vm.addNewKeyword
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('div', {
    staticClass: "ui mini button",
    on: {
      "click": function($event) {
        _vm.showAddKeywordForm = false
      }
    }
  }, [_vm._v("Cancel")])])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._v("\n    hit ESC or click\n    "), _c('div', {
    staticClass: "ui inverted button",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }, [_vm._v("OK")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.galleryNextButton),
      expression: "galleryNextButton"
    }],
    staticClass: "ui massive circular inverted basic icon button",
    staticStyle: {
      "position": "absolute",
      "top": "200px",
      "right": "-10%",
      "opacity": ".4"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.galleryNext.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })]), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v("total in grp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v("total in grp")])])
}]}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "ui container",
    attrs: {
      "id": "prodSetP"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('h1', {
    staticClass: "ui inverted grey header",
    staticStyle: {
      "position": "relative",
      "text-shadow": "#333 1px 2px 3px"
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "small ui compact button",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "ui padded segment"
  }, [(_vm.message) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.message = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + "\n          ")])]) : (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui two column stackable padded grid"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui two column centered grid",
    staticStyle: {
      "margin-top": "-1rem"
    }
  }, [_c('div', {
    staticClass: "four wide"
  }, [(_vm.isOwner) ? _c('button', {
    staticClass: "ui labeled icon button borderButton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddSellerAccountModal
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add Storefront (Seller ID)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.sellersDirty ? 'changed-color' : ''
  }, [_vm._v("Seller Accounts")])]), _vm._v(" "), (!_vm.isEmptyObject(_vm.sellers)) ? _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "three wide"
  }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    staticClass: "four wide"
  }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
    staticClass: "three wide"
  }, [_vm._v("Auth Token")]), _vm._v(" "), (_vm.showAdvertisementApiSettings) ? _c('th', {
    staticClass: "two wide",
    attrs: {
      "data-tooltip": "Advertisement spending data is used by the Profit Dashboard"
    }
  }, [_vm._v("Connect to Ad API")]) : _vm._e(), _vm._v(" "), (_vm.anyAccountMayNeedReAuthorization) ? _c('th', {
    staticClass: "one wide"
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Re-Authorize")]), _vm._v(" "), (_vm.isOwner) ? _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSellers), function(s) {
    return _c('seller-account', {
      key: s.sellerId.value,
      ref: "sellerAccounts",
      refInFor: true,
      attrs: {
        "seller": s,
        "showAdvertisementApiSettings": _vm.showAdvertisementApiSettings,
        "anyAccountMayNeedReAuthorization": _vm.anyAccountMayNeedReAuthorization,
        "isOwner": _vm.isOwner
      },
      on: {
        "account-changed": _vm.onSellerAccountChanged,
        "sellerAccountDeleted": _vm.sellerAccountDeleted
      }
    })
  }), 1)])]) : _c('div', {
    staticClass: "twelve wide column"
  }, [_c('i', [_vm._v("No seller accounts found")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: _vm.dirty ? 'ui right floated primary button' : 'ui right floated primary disabled button',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_vm._m(3)]), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                " + _vm._s(_vm.successMessage) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("View, manage, or add/deactivate users")]), _vm._v(" "), _c('div', {
    staticClass: "four column centered row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddUserModal
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add User")])]), _vm._v(" "), (!_vm.showAllUsers) ? _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleViewUser
    }
  }, [_c('i', {
    staticClass: "eye icon"
  }), _vm._v("View All Users")])]) : _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleViewUser
    }
  }, [_c('i', {
    staticClass: "eye slash outline icon"
  }), _vm._v("Hide All Users")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showDeactivateUserModal
    }
  }, [_c('i', {
    staticClass: "trash alternate outline icon"
  }), _vm._v("Deactivate Users")])])])]), _vm._v(" "), (_vm.showAllUsers) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('table', {
    staticClass: "ui very basic table emailSettingsTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [(_vm.tenantUsersLoading && _vm.tenantUsers.length === 0) ? _c('tr', [_c('td', {
    staticClass: "disabled",
    staticStyle: {
      "text-align": "center",
      "padding": "1.5em"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        Loading users…\n                      ")])]) : [_vm._l((_vm.manageUsersTableRows), function(row) {
    return _c('tr', {
      key: 'manage-user-' + row.user.id
    }, [_c('td', {
      staticClass: "six wide"
    }, [_vm._v("\n                          " + _vm._s(row.user.email) + "\n                          "), (row.user.isOwner) ? _c('span', {
      staticClass: "ui tiny green basic label",
      staticStyle: {
        "margin-left": "0.5em"
      }
    }, [_vm._v("Owner")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [(row.emailAddress) ? [_c('div', {
      class: row.emailAddress.emailVerified && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui green basic label' : 'ui red basic label',
      staticStyle: {
        "min-width": "90px",
        "text-align": "center",
        "margin-right": "10px",
        "background-color": "#fff !important"
      }
    }, [_vm._v(_vm._s(row.emailAddress.emailVerified ? 'Verified' : 'Not verified'))]), _vm._v(" "), _c('button', {
      class: !row.emailAddress.emailVerified && !row.emailAddress.isNew && !row.emailAddress.verificationEmailSent && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button',
      attrs: {
        "data-tooltip": "Resend Verification E-Mail",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.resendVerification(row.emailAddress)
        }
      }
    }, [_c('i', {
      staticClass: "mail icon"
    })])] : _c('span', {
      staticClass: "disabled"
    }, [_vm._v("—")])], 2)])
  }), _vm._v(" "), (!_vm.tenantUsersLoading && _vm.manageUsersTableRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "disabled",
    staticStyle: {
      "text-align": "center",
      "padding": "1.5em"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                          No users on this account yet. Use Add User to invite teammates.\n                        ")])]) : _vm._e()]], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_vm._m(5)]), _vm._v(" "), (_vm.teamsMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                " + _vm._s(_vm.teamsMessage) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Storefronts")]), _vm._v(" "), _c('div', {
    ref: "storefrontTeamSelect",
    staticClass: "ui fluid multiple search selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedTeamStorefronts"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select storefronts")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.sellers), function(seller) {
    return _c('div', {
      key: 'team-sf-' + (seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId),
      staticClass: "item",
      attrs: {
        "data-value": String(seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId)
      }
    }, [_vm._v("\n                        " + _vm._s(seller.nickName) + "\n                      ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "eight wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Select User")]), _vm._v(" "), [_c('div', {
    ref: "assignedUser",
    staticClass: "ui multiple selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedAssignedUser"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select Users")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    },
    on: {
      "click": _vm.selectAssignedUser
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.tenantUsersForTeamAndAlertsDropdown), function(u) {
    return _c('div', {
      key: 'team-user-' + u.id,
      staticClass: "item",
      attrs: {
        "data-value": u.email
      },
      on: {
        "click": function($event) {
          return _vm.selectAssignedUser({
            email: u.email,
            emailAddressId: u.id
          })
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                          ")])
  })], 2)])]], 2)])]), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, _vm._l((_vm.assignedUserList), function(ea, i) {
    return (!ea.isDeleted && !ea.isPrimary) ? _c('tbody', {
      key: ea.emailAddressId
    }, [_c('tr', [_c('td', {
      staticClass: "six wide"
    }, [_vm._v(_vm._s(ea.email))]), _vm._v(" "), _c('td', {
      staticClass: "four wide"
    }, [_vm._v(_vm._s(ea.firstName))]), _vm._v(" "), _c('td', {
      staticClass: "four wide"
    }, [_vm._v(_vm._s(ea.lastName))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui tiny icon button",
      attrs: {
        "data-tooltip": "Delete Storefront User"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAssignedUser(ea)
        }
      }
    }, [_c('i', {
      staticClass: "trash alternate outline icon"
    })])])])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: (_vm.isEmptyObject(_vm.assignedUserList) || !_vm.selectedTeamStorefronts.length) ? 'ui right floated primary disabled button' : 'ui right floated primary button',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveStorefrontTeams.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row margin-top-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "-5px"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.alertMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    " + _vm._s(_vm.alertMessage) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Optimize your teams performance, by customizing indivual user alerts, warnings and product improvements.")])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Select User")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertUser),
      expression: "alertUser"
    }],
    ref: "alertUser",
    staticClass: "ui search selection dropdown",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onAlertUserChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select user")]), _vm._v(" "), _vm._l((_vm.tenantUsersForTeamAndAlertsDropdown), function(u) {
    return _c('option', {
      key: 'alert-user-' + u.id,
      domProps: {
        "value": u.email
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [(_vm.isOwner && _vm.alertUser) ? _c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.manageAlertSettings = !_vm.manageAlertSettings
      }
    }
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("Customize Alert")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('div', {
    staticClass: "ui divider"
  })]) : _vm._e(), _vm._v(" "), (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "six wide"
  }, [_vm._v("Enable all email alerts")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableAllAlerts),
      expression: "enableAllAlerts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enableAllAlerts) ? _vm._i(_vm.enableAllAlerts, null) > -1 : (_vm.enableAllAlerts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.enableAllAlerts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableAllAlerts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enableAllAlerts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableAllAlerts = $$c
        }
      }, _vm.onEnableAllAlertChange]
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "six wide"
  }, [_vm._v("Disable all email alerts")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disableAllAlerts),
      expression: "disableAllAlerts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.disableAllAlerts) ? _vm._i(_vm.disableAllAlerts, null) > -1 : (_vm.disableAllAlerts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.disableAllAlerts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disableAllAlerts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disableAllAlerts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disableAllAlerts = $$c
        }
      }, _vm.onDisableAllAlertChange]
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, _vm._l((_vm.alertUserList), function(ea, i) {
    return (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
      staticClass: "ui sixteen wide column"
    }, [_c('div', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui centered segment"
    }, [_c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "color": "purple",
        "padding": "10px"
      }
    }, [_c('small', [_vm._v("A more detailed description of each alert type is available\n                                "), _c('br'), _vm._v(" in the [Issues] section, under the [info] tab of each box.\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('i', {
      staticClass: "warning circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Alert: An issue that needs your attention.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Alert\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "orange"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Warning: A lesser important issue.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Warning\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "width": "85px"
      }
    }, [_c('i', {
      staticClass: "checkmark circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Improvement: A positive change.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Imprv.\n                              ")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.watchDogTypes), function(wdt) {
      return _c('tr', {
        key: wdt,
        class: {
          'greyed-out': _vm.isSuppressed(wdt)
        }
      }, [_c('td', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_vm._v("\n                              Subscribe to \"" + _vm._s(_vm.watchDogTypesToDisplayName[wdt]) + "\" Emails\n                            ")]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['RED']),
          expression: "ea.alertsSettings[wdt]['RED']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['RED']) ? _vm._i(ea.alertsSettings[wdt]['RED'], null) > -1 : (ea.alertsSettings[wdt]['RED'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['RED'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'RED', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['AMBER']),
          expression: "ea.alertsSettings[wdt]['AMBER']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['AMBER']) ? _vm._i(ea.alertsSettings[wdt]['AMBER'], null) > -1 : (ea.alertsSettings[wdt]['AMBER'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['AMBER'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'AMBER', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['GREEN']),
          expression: "ea.alertsSettings[wdt]['GREEN']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['GREEN']) ? _vm._i(ea.alertsSettings[wdt]['GREEN'], null) > -1 : (ea.alertsSettings[wdt]['GREEN'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['GREEN'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'GREEN', $$c)
            }
          }
        }
      }) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "160px"
      }
    }, [_vm._v("Team Setting Defaults")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "80px"
      }
    }, [_vm._v(" ")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Daily Digest Email")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToDailyDigestEmail),
        expression: "ea.subscribedToDailyDigestEmail"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToDailyDigestEmail) ? _vm._i(ea.subscribedToDailyDigestEmail, null) > -1 : (ea.subscribedToDailyDigestEmail)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToDailyDigestEmail,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToDailyDigestEmail", $$c)
          }
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to SentryKit Product Updates")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToNewsletter),
        expression: "ea.subscribedToNewsletter"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToNewsletter) ? _vm._i(ea.subscribedToNewsletter, null) > -1 : (ea.subscribedToNewsletter)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToNewsletter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToNewsletter", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToNewsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToNewsletter", $$c)
          }
        }
      }
    })])])])])]), _vm._v(" "), _c('daily-digest-timing', {
      attrs: {
        "emailAddress": ea
      },
      on: {
        "digestTimingUpdated": ea.updateDigestTiming
      }
    }), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()], 1)])]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: _vm.emailDirty ? 'ui right floated primary button' : 'ui right floated primary disabled button',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('alerts')
      }
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Set up team notification channels, like Slack or Teams, for group alerts.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.emailDirty ? 'changed-color' : '',
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_vm._v("Email Alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('table', {
    staticClass: "ui very basic table emailSettingsTable"
  }, _vm._l((_vm.emailAddresses), function(ea, i) {
    return (!ea.isDeleted && (!ea.isUser || ea.isPrimary) && (_vm.isOwner || ea.isPrimary)) ? _c('tbody', {
      key: ea.emailAddressId
    }, [_c('tr', [(!ea.isNew && !ea.isPrimary) ? _c('td', {
      staticClass: "seven wide"
    }, [_vm._v(_vm._s(ea.email))]) : _c('td', {
      staticClass: "seven wide"
    }, [_c('div', {
      class: ea.emailValid ? 'field' : 'error field'
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.email),
        expression: "ea.email"
      }],
      staticClass: "ui input focus",
      attrs: {
        "name": "emailaddrs",
        "data-lpignore": "true",
        "required": "required",
        "maxlength": "100"
      },
      domProps: {
        "value": (ea.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(ea, "email", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [_c('div', {
      class: ea.emailVerified && ea.email === ea.originalEmail ? 'ui green basic label' : 'ui red basic label',
      staticStyle: {
        "min-width": "90px",
        "text-align": "center",
        "margin-right": "10px",
        "background-color": "#fff !important"
      }
    }, [_vm._v(_vm._s(ea.emailVerified ? 'Verified' : 'Not verified'))]), _vm._v(" "), _c('button', {
      class: !ea.emailVerified && !ea.isNew && !ea.verificationEmailSent && ea.email === ea.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button',
      attrs: {
        "data-tooltip": "Resend Verification E-Mail",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.resendVerification(ea)
        }
      }
    }, [_c('i', {
      staticClass: "mail icon"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [(i == 0) ? _c('div', {
      class: {
        'alertSettingsAni': _vm.alertSettingsAni
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui labeled tiny icon button borderButton",
      on: {
        "click": function($event) {
          ea.manageSubscriptionSettings = !ea.manageSubscriptionSettings
        }
      }
    }, [_c('i', {
      staticClass: "sliders horizontal icon"
    }), _vm._v("Manage Alerts\n                        ")])]), _vm._v(" "), (ea.isUser && !ea.isPrimary && _vm.isOwner) ? _c('td', {
      staticClass: "five wide"
    }, [_c('div', {
      staticClass: "ui labeled tiny orange icon button",
      on: {
        "click": function($event) {
          ea.manageSellerPermissions = !ea.manageSellerPermissions
        }
      }
    }, [_c('i', {
      staticClass: "cogs horizontal icon"
    }), _vm._v("Manage Permissions\n                        ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "one wide"
    }, [(ea.isPrimary) ? _c('i', [_vm._v("Account Login Address")]) : _c('div', {
      staticClass: "ui tiny icon button",
      on: {
        "click": function($event) {
          return _vm.deleteEmailAddress(i)
        }
      }
    }, [_c('i', {
      staticClass: "trash alternate outline icon"
    })])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeDown"
      }
    }, [(ea.convertIntoUser) ? _c('tr', {
      staticStyle: {
        "max-width": "500px"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [_c('form', {
      staticClass: "ui form",
      attrs: {
        "action": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Name *")]), _vm._v(" "), _c('div', {
      staticClass: "two fields"
    }, [_c('div', {
      staticClass: "field focus"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.firstName),
        expression: "user.firstName"
      }],
      attrs: {
        "type": "text",
        "name": "firstName",
        "placeholder": _vm.$t('First Name'),
        "required": "true",
        "autofocus": "true"
      },
      domProps: {
        "value": (_vm.user.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.lastName),
        expression: "user.lastName"
      }],
      attrs: {
        "type": "text",
        "name": "lastName",
        "placeholder": _vm.$t('Last Name'),
        "required": "true",
        "autofocus": "true"
      },
      domProps: {
        "value": (_vm.user.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "lastName", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email *')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.email),
        expression: "user.email"
      }],
      attrs: {
        "id": "email",
        "type": "email",
        "name": "email",
        "placeholder": _vm.$t('Email'),
        "readonly": "true"
      },
      domProps: {
        "value": (_vm.user.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ui tiny blue icon button",
      on: {
        "click": function($event) {
          return _vm.convertIntoUser(i)
        }
      }
    }, [_vm._v("\n                              convert\n                            ")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeDown"
      }
    }, [(ea.manageSubscriptionSettings) ? _c('tr', [_c('td', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [_c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "color": "purple",
        "padding": "10px"
      }
    }, [_c('small', [_vm._v("A more detailed description of each alert type is available\n                                    "), _c('br'), _vm._v(" in the [Issues] section, under the [info] tab of each box.\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('i', {
      staticClass: "warning circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Alert: An issue that needs your attention.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Alert\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "orange"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Warning: A lesser important issue.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Warning\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "width": "85px"
      }
    }, [_c('i', {
      staticClass: "checkmark circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Improvement: A positive change.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Imprv.\n                                  ")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.watchDogTypes), function(wdt) {
      return _c('tr', {
        key: wdt,
        class: {
          'greyed-out': _vm.isSuppressed(wdt)
        }
      }, [_c('td', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_vm._v("\n                                  Subscribe to \"" + _vm._s(_vm.watchDogTypesToDisplayName[wdt]) + "\" Emails\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['RED']),
          expression: "ea.alertsSettings[wdt]['RED']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['RED']) ? _vm._i(ea.alertsSettings[wdt]['RED'], null) > -1 : (ea.alertsSettings[wdt]['RED'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['RED'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'RED', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['AMBER']),
          expression: "ea.alertsSettings[wdt]['AMBER']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['AMBER']) ? _vm._i(ea.alertsSettings[wdt]['AMBER'], null) > -1 : (ea.alertsSettings[wdt]['AMBER'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['AMBER'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'AMBER', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['GREEN']),
          expression: "ea.alertsSettings[wdt]['GREEN']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['GREEN']) ? _vm._i(ea.alertsSettings[wdt]['GREEN'], null) > -1 : (ea.alertsSettings[wdt]['GREEN'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['GREEN'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'GREEN', $$c)
            }
          }
        }
      }) : _vm._e()])])
    }), 0)]), _vm._v(" "), (!_vm.isEmptyObject(_vm.filteredSellers)) ? _c('div', {
      staticClass: "twelve wide column"
    }, [_c('h3', [_vm._v("\n                              Seller accounts subscribed\n                            ")]), _vm._v(" "), _c('table', {
      staticClass: "ui very basic compact table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "three wide"
    }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
      staticClass: "one wide"
    }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Subscribed")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSellers), function(seller) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.nickName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "padding-left": "35px"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": ea.unsubscribedSellerAccounts.indexOf(seller.sellerId.value) === -1
        },
        on: {
          "click": function($event) {
            return _vm.checkSubscribe(seller.sellerId.value, i)
          }
        }
      })])])
    }), 0)])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "160px"
      }
    }, [_vm._v("Daily Digest")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "80px"
      }
    }, [_vm._v(" ")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Daily Digest Email")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToDailyDigestEmail),
        expression: "ea.subscribedToDailyDigestEmail"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToDailyDigestEmail) ? _vm._i(ea.subscribedToDailyDigestEmail, null) > -1 : (ea.subscribedToDailyDigestEmail)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToDailyDigestEmail,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToDailyDigestEmail", $$c)
          }
        }
      }
    })])])])]), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "240px"
      }
    }, [_vm._v("Product Updates")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Product Updates")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [(!ea.isPrimary) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToNewsletter),
        expression: "ea.subscribedToNewsletter"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToNewsletter) ? _vm._i(ea.subscribedToNewsletter, null) > -1 : (ea.subscribedToNewsletter)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToNewsletter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToNewsletter", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToNewsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToNewsletter", $$c)
          }
        }
      }
    })]) : _c('span', [_c('input', {
      staticStyle: {
        "margin-top": "3px"
      },
      attrs: {
        "type": "checkbox",
        "checked": "checked",
        "disabled": "disabled"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "data-tooltip": "For the Primary Email address Product Update messages are always on."
      }
    }, [_c('i', {
      staticClass: "ui question circle icon"
    })])])])])])]), _vm._v(" "), _c('daily-digest-timing', {
      attrs: {
        "emailAddress": ea
      },
      on: {
        "digestTimingUpdated": ea.updateDigestTiming
      }
    }), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', [(ea.manageSellerPermissions) ? _c('tr', [_c('td', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [(!_vm.isEmptyObject(_vm.sellers)) ? _c('div', {
      staticClass: "twelve wide column"
    }, [_c('h3', [_vm._v("\n                                Seller accounts Permission\n                              ")]), _vm._v(" "), _c('table', {
      staticClass: "ui very basic compact table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "three wide"
    }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
      staticClass: "one wide"
    }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Access")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sellers), function(seller) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.nickName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "padding-left": "35px"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": ea.allowedSellerAccounts.indexOf(seller.sellerId.value) !== -1
        },
        on: {
          "click": function($event) {
            return _vm.checkSellerAccountsAccess(seller.sellerId.value, i)
          }
        }
      })])])
    }), 0)]), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])], 1) : _vm._e()
  }), 0), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    class: _vm.addEmailAddressInProgress ? 'ui loading button' : 'ui  labeled icon button borderButton',
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addEmailAddress()
      }
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add New Email Channel")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui basic segment"
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Connect third-party apps")])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui placeholder segment"
  }, [_c('div', {
    staticClass: "ui two column very relaxed stackable grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_c('a', {
    class: _vm.zapierAuth && _vm.zapierAuth.length > 0 ? 'ui labeled icon button borderButton' : 'ui labeled icon button',
    attrs: {
      "target": "_blank",
      "href": "https://zapier.com/engine/auth/start/App240321CLIAPI@1.0.0/?_zapier_account_id=4400475"
    }
  }, [_c('i', {
    staticClass: "plug icon"
  }), _vm._v("\n                              Connect Zapier")])])])])]), _vm._v(" "), (_vm.zapierList.length > 0) ? _c('div', {
    staticClass: "six wide column"
  }, [_c('span', [_vm._v("Check out all the ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/document/d/15O8b4mBsAb7ccIrL05jcxJCuo9_kDemcXkgjwMy_VA4/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("triggers")]), _vm._v(" you can use in your SentryKit Zaps.\n                        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasZapier) ? _c('table', {
    staticClass: "ui striped very basic table",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('tbody', _vm._l((_vm.zapierList), function(z) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v("Added at " + _vm._s(new Date(z.timestamp).toLocaleDateString()))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.a.clicked ? 'ui primary button' : 'ui button',
      on: {
        "click": function($event) {
          return _vm.deleteAuthorization(z)
        }
      }
    }, [_vm._v(_vm._s(z.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'))])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.gsheetsConnection.enabled && _vm.isOwner) ? _c('div', [(_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "five wide column"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "six wide column"
  }, [(_vm.gsheetsConnection.spreadsheetId) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.googleSheetsUrl()
      }
    }
  }, [_vm._v("Open SentryKit Spreadsheet")])]) : _vm._e(), _c('br'), _vm._v("\n                        (" + _vm._s(_vm.gsheetsConnection.email == 'pending' ? 'pending' : 'Connected as ' + _vm.gsheetsConnection.email) + ")\n                        "), (_vm.gsheetsConnection.connectionError) ? _c('div', {
    staticClass: "ui yellow message"
  }, [_c('i', {
    staticClass: "icon exclamation triangle"
  }), _vm._v("\n                          WARNING: SentryKit "), _c('b', [_vm._v("cannot access")]), _vm._v(" your spreadsheet\n                          "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": ".3em",
      "right": ".4em"
    },
    attrs: {
      "data-tooltip": "Click here for more info"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.gsheetsArticleLink,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fitted small circular question inverted icon link"
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', _vm._l((_vm.googleSheetsList), function(g) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Added at " + _vm._s(new Date(g.timestamp).toLocaleDateString()))]), _vm._v(" "), _c('td', [_c('div', {
      class: g.clicked ? 'ui primary button' : 'ui button',
      on: {
        "click": function($event) {
          return _vm.deleteAuthorization(g)
        }
      }
    }, [_vm._v(_vm._s(g.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "five wide column"
  }, [_c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "2rem"
    }
  }, [_c('a', {
    staticClass: "ui labeled icon button",
    on: {
      "click": function($event) {
        return _vm.googleSheetsAuthorizationUrl()
      }
    }
  }, [_c('i', {
    staticClass: "google icon"
  }), _vm._v("\n                            Connect Google Sheets")])])])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("\n                    |\n                  ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Account-level email alert preferences")]), _vm._v("\n              Account-level settings will affect all users in all storefronts\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.instantAlertDirty ? 'changed-color' : ''
  }, [_vm._v("Alert Email Preferences")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instantAlert),
      expression: "instantAlert"
    }],
    attrs: {
      "type": "radio",
      "name": "instantAlert",
      "id": "radioInstantAlert01"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.instantAlert, true)
    },
    on: {
      "change": function($event) {
        _vm.instantAlert = true
      }
    }
  }), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instantAlert),
      expression: "instantAlert"
    }],
    attrs: {
      "type": "radio",
      "name": "instantAlert",
      "id": "radioInstantAlert02"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.instantAlert, false)
    },
    on: {
      "change": function($event) {
        _vm.instantAlert = false
      }
    }
  }), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.instantAlert === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.alertSubjectDirty ? 'changed-color' : ''
  }, [_c('br'), _vm._v("Alert Email Subject")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "grouped fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertSubject),
      expression: "alertSubject"
    }],
    attrs: {
      "type": "radio",
      "value": "SIMPLE",
      "id": "radioAlertSubject01"
    },
    domProps: {
      "checked": _vm._q(_vm.alertSubject, "SIMPLE")
    },
    on: {
      "change": function($event) {
        _vm.alertSubject = "SIMPLE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAlertSubject01"
    }
  }, [_vm._v("\n                        Simple Subject Line - "), _c('i', [_vm._v("e.g. New SentryKit Notification (Mon, Jul 31, 2017)")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Great for simplicity: Gmail can group these messages by calendar day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertSubject),
      expression: "alertSubject"
    }],
    attrs: {
      "type": "radio",
      "value": "DETAILED",
      "id": "radioAlertSubject02"
    },
    domProps: {
      "checked": _vm._q(_vm.alertSubject, "DETAILED")
    },
    on: {
      "change": function($event) {
        _vm.alertSubject = "DETAILED"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAlertSubject02"
    }
  }, [_vm._v("\n                        Detailed Subject Line - "), _c('i', [_vm._v("e.g. [alert] Buy-box lost - ProductName [ASIN] (Mon, Jul 31, 2017, 10:25 GMT+02:00)")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Great for creating custom email filters for specific products or issue types")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.instantAlert === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.batchingIntervalHoursDirty ? 'changed-color' : ''
  }, [_vm._v("Batching Interval")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.batchingIntervalHours),
      expression: "batchingIntervalHours",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "Batching Interval",
      "min": "1",
      "max": "24"
    },
    domProps: {
      "value": (_vm.batchingIntervalHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.batchingIntervalHours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("hours")])])])])])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Account Management")]), _vm._v("\n              Change account owner settings, download invoices and update passwords\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('button', {
    staticClass: "ui labeled icon button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.changePasswordModal.show()
      }
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v("Change password")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide middle aligned column"
  }, [_c('h4', {
    class: _vm.nameDirty ? 'changed-color' : ''
  }, [_vm._v("Account Owner")])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "ui input",
    attrs: {
      "name": "firstName",
      "data-lpignore": "true",
      "required": "true",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "ui input",
    attrs: {
      "name": "lastName",
      "data-lpignore": "true",
      "required": "true",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.$root.paymentStatus !== 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.paymentStatusMessage))]), _vm._v(" "), _c('div', {
    class: 'ui labeled icon button',
    attrs: {
      "id": "paymentMethods"
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v(_vm._s(_vm.hasPaymentDetails ? 'Change' : 'Add') + " payment method\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid popup"
  }, [_c('div', {
    staticClass: "ui two column center aligned very relaxed grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Card")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.stripeButtonClicked || _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    staticStyle: {
      "margin": "0.5em 0 1.7em"
    },
    attrs: {
      "id": "stripeButton",
      "type": "button"
    },
    on: {
      "click": _vm.openStripeWidget
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v(_vm._s(_vm.hasPaymentDetails ? 'Change' : 'Set') + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached teal label"
  }, [_vm._v("Recommended")]), _vm._v(" "), (_vm.paymentMethod && _vm.paymentMethod.method === 'card') ? _c('div', {
    staticClass: "ui bottom attached small blue label"
  }, [_vm._v("\n                        Selected\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("ACH transfer")]), _vm._v(" "), _c('div', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress || _vm.paymentMethod && _vm.paymentMethod.method === 'ach'
    },
    staticStyle: {
      "margin": "0.5em 0 1.7em"
    },
    on: {
      "click": _vm.createAchSource
    }
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("Set\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached label"
  }, [_vm._v("Beta")]), _vm._v(" "), (_vm.paymentMethod && _vm.paymentMethod.method === 'ach') ? _c('div', {
    staticClass: "ui bottom attached small blue label",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.viewAchDetails
    }
  }, [_vm._v("\n                        Selected (Click for details)\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("\n                    OR\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    staticStyle: {
      "margin-left": "60px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showInvoiceModal
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v("Invoices")]), _vm._v(" "), (!_vm.subscriptionCanceled) ? _c('button', {
    staticClass: "ui labeled icon button",
    staticStyle: {
      "opacity": "0.7",
      "margin-right": "10%",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCancelConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Cancel my subscription")]) : _c('button', {
    class: 'ui labeled icon ' + (_vm.hasPaymentDetails ? '' : 'disabled ') + 'button',
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openResumeConfirm
    }
  }, [_c('i', {
    staticClass: "play icon"
  }), _vm._v("Re-activate subscription")]), _vm._v(" "), _vm._m(18)])]) : _vm._e()], 1)]), _vm._v(" "), _c('change-password-modal', {
    ref: "changePasswordModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal add-storefront-modal",
    attrs: {
      "id": "addSellerAccountModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Connect Amazon storefront")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('p', {
    staticClass: "add-storefront-modal-desc"
  }, [_vm._v("Approve SentryKit on Amazon.")]), _vm._v(" "), _c('add-seller-account', {
    attrs: {
      "show-nickname": true
    },
    on: {
      "sellerAccountAdded": _vm.onSellerAccountAdded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "successModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.successMessage))])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscriptionModal"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('button', {
    staticClass: "ui basic cancel inverted button",
    on: {
      "click": _vm.cancelSubscriptionConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "ui button primary submit",
    on: {
      "click": _vm.applyCouponConfirm
    }
  }, [_vm._v("Get 25% Off")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic cancel inverted button"
  }, [_vm._v("Back to Account Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscriptionNewPricingModal"
    }
  }, [_c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("We appreciate you as a subscriber and we don't want to see you go.")]), _vm._v(" "), _c('p', [_vm._v("We'd like to offer you our new pricing, featuring daily ASIN tracking!"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$root.newPricingMessage))])]), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('button', {
    staticClass: "ui basic cancel inverted button",
    on: {
      "click": _vm.cancelSubscriptionConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "ui button primary submit",
    on: {
      "click": _vm.redeemNewPricing
    }
  }, [_vm._v("Redeem New Pricing")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic cancel inverted button"
  }, [_vm._v("Back to Account Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscription"
    }
  }, [_c('div', {
    staticClass: "ui icon yellow header"
  }, [_vm._v("It looks like you are attempting to cancel your subscription")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('div', {
    class: 'ui red basic ok inverted ' + (_vm.cancelInProgress ? 'loading ' : '') + 'button',
    on: {
      "click": _vm.newPricingOrDiscount
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "resumeSubscription"
    }
  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    class: 'ui green ok inverted ' + (_vm.resumeInProgress ? 'loading ' : '') + 'button'
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "invoicesModal"
    }
  }, [_c('div', {
    staticClass: "ui button",
    class: _vm.editBillingNameState ? ['disabled'] : [],
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.editBillingNameState = true
      }
    }
  }, [_c('i', {
    staticClass: "pencil alternate icon"
  }), _vm._v("Update name on Invoice")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (!_vm.editBillingNameState && _vm.invoices.length > 0) ? _c('div', {
    staticClass: "ui icon header"
  }, [_vm._v("Invoices")]) : _vm._e(), _vm._v(" "), _c('center', [(!_vm.editBillingNameState) ? _c('div', {
    staticClass: "scrolling content",
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.invoices.length > 0) ? _c('table', {
    staticClass: "ui striped table",
    staticStyle: {
      "width": "600px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Invoice start date")]), _vm._v(" "), _c('th', [_vm._v("Invoice end date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i.from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.totalAmount / 100.0) + " USD")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": i.url,
        "target": "_blank"
      }
    }, [_vm._v("View Invoice")])])])
  }), 0)]) : _c('div', {
    staticStyle: {
      "margin-top": "150px",
      "margin-bottom": "150px"
    }
  }, [_vm._v("You have no invoices yet")])]) : _vm._e()]), _vm._v(" "), (!_vm.editBillingNameState) ? _c('div', {
    staticClass: "actions"
  }, [_vm._m(28)]) : _c('div', {
    staticClass: "scrolling content ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Name on Invoice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingName),
      expression: "billingName"
    }],
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.billingName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billingName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    class: _vm.editBillingNameState == 'inprogress' ? ['loading'] : [],
    on: {
      "click": _vm.saveBillingName
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "ui button",
    class: _vm.editBillingNameState == 'inprogress' ? ['disabled'] : [],
    on: {
      "click": function($event) {
        _vm.editBillingNameState = false
      }
    }
  }, [_vm._v("Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui tiny modal",
    attrs: {
      "id": "paymentMethodModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.paymentMethod) ? [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n              ACH Details\n            ")]), _vm._v(" "), (_vm.paymentMethod.details) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-bottom": "3.5em"
    }
  }, [(_vm.packageCost) ? _c('div', [_vm._m(29), _vm._v(" "), _c('h4', {
    staticClass: "ui center aligned header",
    class: {
      warning: !_vm.hasEnoughACHFunds
    }
  }, [_vm._v("\n                  Your current balance is $" + _vm._s(_vm.paymentMethod.details.balance / 100.0) + " USD\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui indicating progress",
    attrs: {
      "id": "achProgressBalance",
      "data-value": _vm.paymentMethod.details.balance,
      "data-total": _vm.packageCost
    }
  }, [_vm._m(30), _vm._v(" "), (_vm.hasEnoughACHFunds) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                    You have enough funds for the next charge of your current subscription fee ($" + _vm._s(_vm.packageCost / 100.0) + ")\n                  ")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                    You don't have enough funds for the next charge of your current subscription fee ($" + _vm._s(_vm.packageCost / 100.0) + "). Please add funds using info below before billing date.\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "ui two column relaxed grid"
  }, _vm._l((_vm.paymentMethod.details), function(value, name) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "right aligned column",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_c('h4', [_vm._v(_vm._s(name.replaceAll('_', ' ')))])]), _vm._v(" "), _c('div', {
      staticClass: "left aligned column"
    }, [_vm._v(_vm._s(name === 'balance' ? value / 100.0 : value))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui bottom attached label",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                This is a beta feature, if you found some inconsistency please "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.showIntercom.apply(null, arguments)
      }
    }
  }, [_vm._v("contact us")])])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "paymentElementModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.paymentElement && _vm.paymentElement.unmount()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Update Payment Method\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "payment-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "payment-element-errors",
      "role": "alert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.paymentElement && _vm.paymentElement.unmount();
        _vm.$('#paymentElementModal').modal('hide')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.updatePaymentInProgress
    },
    attrs: {
      "disabled": _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.confirmPaymentMethod
    }
  }, [_vm._v("\n              Update Payment Method\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "addUserModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Add User")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "ui"
  }, [_c('form', {
    staticClass: "ui form",
    attrs: {
      "action": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field focus"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName",
      "placeholder": _vm.$t('First Name'),
      "required": "true",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName",
      "placeholder": _vm.$t('Last Name'),
      "required": "true",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email *')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "id": "email1",
      "type": "email",
      "name": "email1",
      "placeholder": _vm.$t('Email'),
      "required": "true"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    class: _vm.addEmailAddressInProgress ? 'ui right floated loading button' : 'ui right floated primary button',
    on: {
      "click": function($event) {
        return _vm.convertIntoUser()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('br'), _c('br')])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "deactivateUserModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Deactivate Users")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_vm._m(32), _vm._v(" "), [_c('div', [_c('div', {
    ref: "dropdown",
    staticClass: "ui multiple selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedOptions"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select Users")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.tenantUsersForDeactivateModal), function(u) {
    return _c('div', {
      key: 'deactivate-user-' + u.id,
      staticClass: "item",
      attrs: {
        "data-value": u.email
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                          ")])
  })], 2)])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui right floated red button",
    on: {
      "click": _vm.deactiveUsers
    }
  }, [_vm._v("Deactivate")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), (_vm.paymentDetailsSaved) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.paymentDetailsSaved = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Payment details have been saved successfully")])]) : (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui primary disabled button',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.dirty) ? _c('div', {
    staticClass: "ui basic left pointing label"
  }, [_vm._v("\n        Save for the changes to take effect\n      ")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticStyle: {
      "color": "peru"
    }
  }, [_vm._v("Sentry")]), _c('span', {
    staticStyle: {
      "color": "steelblue"
    }
  }, [_vm._v("Kit")]), _vm._v("\n           Settings\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marginBotton-1"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Storefront (Seller ID)\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Set up and manage storefront(s) to mirror your team structure (e.g. agencies may set up by brand client, merchants may set up multiple storefronts, and brands may set up by product family).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Your Users\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "six wide"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Last Name")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Storefront Teams\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Select one or more storefronts, then choose users to grant access to "), _c('strong', [_vm._v("all")]), _vm._v(" of those storefronts at once (or use Seller account Permission under each email to fine-tune)."), _c('br'), _vm._v("The table lists teammates who already have access to at least one of the selected storefronts.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                      Manage User Alerts\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "-5px"
    }
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Email Channel Alerts\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n                  Account Settings\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Manage your account-level email settings affecting all users. You can connect a "), _c('br'), _vm._v("third party app, set your instant or batched alerts and alert email settings.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,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",
      "width": "70px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": "data:image/png;base64,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"
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "2rem"
    }
  }, [_c('a', {
    staticClass: "ui labeled icon button bordered-button-green",
    attrs: {
      "href": "https://myaccount.google.com/permissions",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "google icon"
  }), _vm._v("Google Settings")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "radioInstantAlert01"
    }
  }, [_vm._v("Instant Alerts"), _c('br'), _c('small', [_vm._v("(each alert in its own separate email, "), _c('br'), _vm._v("sent immediately)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "radioInstantAlert02"
    }
  }, [_vm._v("Batched Alerts"), _c('br'), _c('small', [_vm._v("(group multiple alerts into one message, "), _c('br'), _vm._v("less emails, slower)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "two wide middle aligned column"
  }, [_c('h4', [_vm._v("Account Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "two wide column"
  }, [_c('h4', [_vm._v("Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui yellow segment",
    staticStyle: {
      "width": "90%",
      "clear": "both"
    }
  }, [_c('small', [_vm._v("\n                  Our payment processor is "), _c('a', {
    attrs: {
      "href": "https://stripe.com/about",
      "target": "_blank"
    }
  }, [_vm._v("Stripe")]), _vm._v(". All billing info, credit card numbers etc. go directly to them through their secure overlay.\n                  "), _c('br'), _vm._v("We never see or store anything - simply get a note from them that everything is good.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "deleteSellerAccountModal"
    }
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("Would you like to remove you seller account?")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("Your data for this account will be permanently deleted, however you can re-add this account any time in the future.")]), _vm._v(" "), _c('p', [_vm._v("The removal process may take a few minutes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "deUserConfirmModal"
    }
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("Would you like to deactivate selected users?")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("Your data for this account will be permanently deleted, however you can re-add this user any time in the future.")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("We appreciate you as a subscriber, we don't want to see you go.")]), _vm._v(" "), _c('p', [_vm._v("Here's 25% off for your next 6 months."), _c('br'), _vm._v("If you cancel, your subscription will stop auto renewing today and you will not be eligible for any discount offers."), _c('br'), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you still choose to cancel now, your subscription will stop auto renewing"), _c('br'), _vm._v("today and you will not be eligible for any future discount offers.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Back to Account Settings")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "play icon"
  }), _vm._v("Would you like to resume your subscription?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("You may cancel your subscription any time in the future.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted cancel button"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v("Close")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "dollar sign icon"
  }), _vm._v("\n                  Current Balance\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("\n                Bank Info\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("User")])])])
}]}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "costMarginModal",
    staticClass: "ui modal",
    attrs: {
      "id": "productCostMarginModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Product Cost & Margin\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Configure costs to calculate accurate floor price")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "ui active centered inline loader"
  }), _vm._v(" "), _c('p', [_vm._v("Loading product data...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-container"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.loadProductData
    }
  }, [_vm._v("Retry")])]) : (_vm.productData) ? _c('div', [_c('div', {
    staticClass: "product-info-section"
  }, [_c('div', {
    staticClass: "product-image"
  }, [(_vm.productData.product_info.image_url) ? _c('img', {
    attrs: {
      "src": _vm.productData.product_info.image_url,
      "alt": _vm.productData.product_info.name
    }
  }) : _c('div', {
    staticClass: "product-placeholder"
  }, [_c('i', {
    staticClass: "box icon"
  }), _vm._v(" "), _c('span', [_vm._v("Product")])])]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('h3', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productData.product_info.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [_c('span', {
    staticClass: "asin"
  }, [_vm._v("ASIN: " + _vm._s(_vm.productData.product_info.asin))])]), _vm._v(" "), _c('div', {
    staticClass: "current-price"
  }, [_vm._v("\n            Current: " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("YOUR COSTS")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Supplier Cost (COGS)")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.formData.supplierCost
    },
    on: {
      "input": _vm.handleSupplierCostInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("What you paid your supplier")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Costs (per unit)")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.formData.otherCosts
    },
    on: {
      "input": _vm.handleOtherCostsInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("Shipping, prep, labeling, customs — whatever applies to you")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group total-cost"
  }, [_c('label', [_vm._v("Total Landed Cost")]), _vm._v(" "), _c('div', {
    staticClass: "total-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.totalLandedCost)) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("Amazon Fees (at " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "fee-row"
  }, [_c('span', [_vm._v("\n            Referral Fee\n            "), (_vm.productData.amazon_fees.referral_fee_estimated) ? _c('span', {
    staticClass: "hint",
    attrs: {
      "title": "Amazon hasn't quoted this product's referral fee yet; using the most common rate (15%)."
    }
  }, [_vm._v("(estimated)")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.referral_fee)))])]), _vm._v(" "), (_vm.productData.amazon_fees.fba_fee_applies) ? _c('div', {
    staticClass: "fee-row"
  }, [_c('span', [_vm._v("FBA Fulfillment Fee")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.fba_fulfillment_fee)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-row total-fee"
  }, [_c('span', [_vm._v("Total Amazon Fees")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.amazon_fees.total)))])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h4', {
    staticClass: "section-title"
  }, [_vm._v("TARGET MARGIN")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('div', {
    staticClass: "radio-option",
    class: {
      active: _vm.formData.useGlobalDefault
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginMode),
      expression: "marginMode"
    }],
    attrs: {
      "type": "radio",
      "id": "useGlobalDefault",
      "value": "global"
    },
    domProps: {
      "checked": _vm._q(_vm.marginMode, "global")
    },
    on: {
      "change": [function($event) {
        _vm.marginMode = "global"
      }, _vm.onMarginModeChange]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useGlobalDefault"
    }
  }, [_c('span', {
    staticClass: "radio-label"
  }, [_vm._v("Use Global Default")]), _vm._v(" "), _c('span', {
    staticClass: "radio-value"
  }, [_vm._v(_vm._s(_vm.productData.target_margin.global_default_percentage) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "radio-hint"
  }, [_vm._v("Same as all products")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio-option",
    class: {
      active: !_vm.formData.useGlobalDefault
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginMode),
      expression: "marginMode"
    }],
    attrs: {
      "type": "radio",
      "id": "customOverride",
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.marginMode, "custom")
    },
    on: {
      "change": [function($event) {
        _vm.marginMode = "custom"
      }, _vm.onMarginModeChange]
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (!_vm.formData.useGlobalDefault) ? _c('div', {
    staticClass: "form-group custom-margin"
  }, [_c('label', [_vm._v("Custom Margin Target")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "max": "100",
      "placeholder": "0"
    },
    domProps: {
      "value": _vm.formData.customMarginPercentage
    },
    on: {
      "input": _vm.handleCustomMarginInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "percent"
  }, [_vm._v("%")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "summary-section"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Your Landed Cost")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.totalLandedCost)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Break-even Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.breakEvenPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Current Margin @ " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.productData.product_info.current_price)))]), _vm._v(" "), _c('span', {
    class: _vm.getMarginClass(_vm.calculatedData.currentMargin)
  }, [_vm._v("\n            • " + _vm._s(_vm.formatPrice(_vm.calculatedData.currentMargin.percentage)) + "% (" + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.currentMargin.amount)) + ")\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row floor-price"
  }, [_c('span', [_vm._v("Your Floor Price (@ " + _vm._s(_vm.effectiveMarginPercentage) + "% margin)")]), _vm._v(" "), _c('span', {
    staticClass: "floor-price-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatPrice(_vm.calculatedData.floorPrice)) + "\n            "), (!_vm.formData.useGlobalDefault) ? _c('span', {
    staticClass: "override-badge"
  }, [_vm._v("OVERRIDE")]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer-buttons"
  }, [_c('button', {
    staticClass: "ui cancel button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button save-button",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n        Save Settings\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "customOverride"
    }
  }, [_c('span', {
    staticClass: "radio-label"
  }, [_vm._v("Custom Override")]), _vm._v(" "), _c('span', {
    staticClass: "radio-hint"
  }, [_vm._v("Set unique target")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Fees auto-update when price changes")])])
}]}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-threshold-panel"
  }, [_c('div', {
    staticClass: "stock-tp-header"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "stock-tp-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.requestClose
    }
  }, [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-tabs"
  }, [_c('button', {
    class: ['stock-tp-tab', {
      active: _vm.activeTab === 'fba'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'fba'
      }
    }
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("\n      FBA Stock\n      "), _c('span', {
    staticClass: "stock-tp-tab-count"
  }, [_vm._v(_vm._s(_vm.fbaRows.length) + " products")])]), _vm._v(" "), _c('button', {
    class: ['stock-tp-tab', {
      active: _vm.activeTab === 'fbm'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'fbm'
      }
    }
  }, [_c('i', {
    staticClass: "home icon"
  }), _vm._v("\n      FBM Stock\n      "), _c('span', {
    staticClass: "stock-tp-tab-count"
  }, [_vm._v(_vm._s(_vm.fbmRows.length) + " products")])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-pane', {
      active: _vm.activeTab === 'fba'
    }]
  }, [(_vm.fbaTotalCount > _vm.fbaRows.length) ? _c('p', {
    staticClass: "stock-tp-cap-note"
  }, [_vm._v("\n      Showing "), _c('strong', [_vm._v(_vm._s(_vm.fbaRows.length))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.fbaTotalCount))]), _vm._v(" listings on this server page.\n      Use "), _c('strong', [_vm._v("Download CSV")]), _vm._v(" for the full catalog or adjust API pagination.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-table-wrap"
  }, [(_vm.fbaRows.length > 0) ? _c('table', {
    staticClass: "stock-tp-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.fbaRows), function(p) {
    return _c('tr', {
      key: 'fba-' + _vm.listingId(p) + '-' + _vm.thresholdsDataRevision,
      class: {
        'stock-tp-row-dirty': _vm.rowDirtyFba[_vm.listingId(p)]
      }
    }, [_c('td', [_c('span', {
      staticClass: "stock-tp-product-name",
      attrs: {
        "title": p.productTitle
      }
    }, [_vm._v(_vm._s(p.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-tp-product-meta"
    }, [_c('span', {
      staticClass: "stock-tp-asin"
    }, [_vm._v(_vm._s(_vm.asinFor(p)))]), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-mkt"
    }, [_c('i', {
      class: _vm.flagClass(p.marketplace) + ' flag'
    }), _vm._v("\n                  " + _vm._s(_vm.marketplaceLabel(p.marketplace)) + "\n                ")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].amberThreshold),
        expression: "fbaForms[listingId(p)].amberThreshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'amberThreshold'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].amberThreshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "amberThreshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].redThreshold),
        expression: "fbaForms[listingId(p)].redThreshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'redThreshold'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].redThreshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "redThreshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].amberDays),
        expression: "fbaForms[listingId(p)].amberDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'amberDays'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].amberDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "amberDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].redDays),
        expression: "fbaForms[listingId(p)].redDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'redDays'),
      attrs: {
        "type": "number",
        "min": "-1",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].redDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "redDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbaForms[_vm.listingId(p)].velocityLookbackDays),
        expression: "fbaForms[listingId(p)].velocityLookbackDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFba(_vm.listingId(p), 'velocityLookbackDays'),
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "14"
      },
      domProps: {
        "value": (_vm.fbaForms[_vm.listingId(p)].velocityLookbackDays)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbaForms[_vm.listingId(p)], "velocityLookbackDays", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbaDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("days")])])])])
  }), 0)]) : _c('div', {
    staticClass: "stock-tp-empty"
  }, [_vm._v("No FBA listings returned for thresholds.")])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-pane', {
      active: _vm.activeTab === 'fbm'
    }]
  }, [(_vm.fbmTotalCount > _vm.fbmRows.length) ? _c('p', {
    staticClass: "stock-tp-cap-note"
  }, [_vm._v("\n      Showing "), _c('strong', [_vm._v(_vm._s(_vm.fbmRows.length))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.fbmTotalCount))]), _vm._v(" FBM listings on this server page.\n      Use "), _c('strong', [_vm._v("Download CSV")]), _vm._v(" for the full catalog or adjust API pagination.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-table-wrap"
  }, [(_vm.fbmRows.length > 0) ? _c('table', {
    staticClass: "stock-tp-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.fbmRows), function(p) {
    return _c('tr', {
      key: 'fbm-' + _vm.listingId(p) + '-' + _vm.thresholdsDataRevision,
      class: {
        'stock-tp-row-dirty': _vm.rowDirtyFbm[_vm.listingId(p)]
      }
    }, [_c('td', [_c('span', {
      staticClass: "stock-tp-product-name",
      attrs: {
        "title": p.productTitle
      }
    }, [_vm._v(_vm._s(p.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-tp-product-meta"
    }, [_c('span', {
      staticClass: "stock-tp-asin"
    }, [_vm._v(_vm._s(_vm.asinFor(p)))]), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-mkt"
    }, [_vm._v("FBM — own warehouse")])])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('span', {
      staticClass: "stock-tp-mkt"
    }, [_c('i', {
      class: _vm.flagClass(p.marketplace) + ' flag'
    }), _vm._v("\n                " + _vm._s(_vm.marketplaceLabel(p.marketplace)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "stock-tp-td-center"
    }, [_c('div', {
      staticClass: "stock-tp-input-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.fbmForms[_vm.listingId(p)].threshold),
        expression: "fbmForms[listingId(p)].threshold",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "stock-tp-input",
      class: _vm.inputClassesFbmObj(_vm.listingId(p)),
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.fbmForms[_vm.listingId(p)].threshold)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fbmForms[_vm.listingId(p)], "threshold", _vm._n($event.target.value))
        }, function($event) {
          _vm.markFbmDirty(_vm.listingId(p))
        }],
        "change": function($event) {
          _vm.markFbmDirty(_vm.listingId(p))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "stock-tp-input-unit"
    }, [_vm._v("units")])])])])
  }), 0)]) : _c('div', {
    staticClass: "stock-tp-empty"
  }, [_vm._v("No FBM listings returned for thresholds.")])])]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-csv-strip"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-csv-actions"
  }, [_c('button', {
    staticClass: "stock-tp-btn-csv stock-tp-btn-csv-dl",
    attrs: {
      "type": "button",
      "disabled": _vm.csvDownloading
    },
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    class: _vm.csvDownloading ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n        " + _vm._s(_vm.csvDownloading ? 'Downloading…' : 'Download CSV') + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "stock-tp-csv-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "stock-tp-btn-csv stock-tp-btn-csv-ul"
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("\n        Upload CSV\n        "), _c('input', {
    staticClass: "stock-tp-csv-file",
    attrs: {
      "type": "file",
      "accept": ".csv,text/csv,application/csv"
    },
    on: {
      "change": _vm.uploadCsv
    }
  })])])]), _vm._v(" "), _c('div', {
    class: ['stock-tp-dirty-banner', {
      visible: _vm.dirty
    }]
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v("\n    You have unsaved changes.\n  ")]), _vm._v(" "), (_vm.thresholdsLoading) ? _c('div', {
    staticClass: "stock-tp-loading-banner"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v("\n    Loading thresholds…\n  ")]) : _vm._e(), _vm._v(" "), (_vm.thresholdsLoadError && !_vm.thresholdsLoading) ? _c('div', {
    staticClass: "stock-tp-panel-error stock-tp-load-warning"
  }, [_vm._v("\n    " + _vm._s(_vm.thresholdsLoadError) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-footer"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-footer-actions"
  }, [_c('button', {
    staticClass: "stock-tp-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.requestClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "stock-tp-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.hasRowsToSaveOnActiveTab
    },
    on: {
      "click": _vm.saveAll
    }
  }, [(_vm.saving) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        Save All Thresholds\n      ")])])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "stock-tp-panel-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.csvMessage) ? _c('div', {
    class: _vm.csvMessageIsError ? 'stock-tp-panel-error' : 'stock-tp-csv-toast'
  }, [_vm._v(_vm._s(_vm.csvMessage))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-header-icon"
  }, [_c('i', {
    staticClass: "setting icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "stock-tp-title"
  }, [_vm._v("Stock Alert Thresholds")]), _vm._v(" "), _c('div', {
    staticClass: "stock-tp-subtitle"
  }, [_vm._v("\n        Configure per-ASIN stock thresholds across your full product portfolio. These drive Low Stock & Out of Stock alerts on the Alerts page.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "220px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-units-group",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alert by Units")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-days-group",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Alert by Days of Stock")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-interval",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Avg Calc Interval")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Warning threshold")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Critical alert")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-days"
  }, [_vm._v("Warning threshold")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-days"
  }, [_vm._v("Critical alert")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('th', {
    staticClass: "stock-tp-th-center stock-tp-th-sub-units"
  }, [_vm._v("Alert below")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-csv-label"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Managing a large catalog? "), _c('strong', [_vm._v("Download as CSV")]), _vm._v(" → edit thresholds in bulk → re-upload.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-tp-footer-note"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v("\n      Leave any field blank to use account defaults (14 days for Low Stock). Thresholds apply to both the Stock page status and Alerts page triggers.\n    ")])
}]}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ticketSubmissionResult == null) ? _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "field"
  }, [_c('label', [_vm._v("Your Contact E-Mail Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category !== 'new_feature'),
      expression: "category !== 'new_feature'"
    }],
    staticClass: "field"
  }, [_c('label', [_vm._v("Summary")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticketContent),
      expression: "ticketContent"
    }],
    attrs: {
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.ticketContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ticketContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category !== 'new_feature'),
      expression: "category !== 'new_feature'"
    }],
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("ASIN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asin),
      expression: "asin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.asin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.asin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Marketplace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "helpModalMarketplace"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.marketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US"
    }
  }, [_vm._v("US")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("CA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MX"
    }
  }, [_vm._v("MX")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BR"
    }
  }, [_vm._v("BR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UK"
    }
  }, [_vm._v("UK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("DE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("FR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("IT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("NL")])])])]), _vm._v(" "), (_vm.productExistsError) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productExistsError))])])]) : _vm._e(), _vm._v(" "), (_vm.productExistsWarning) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productExistsWarning))])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": function($event) {
        return _vm.submitTicket()
      }
    }
  }, [_vm._v("Submit")])]) : (_vm.ticketSubmissionResult === true) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "ui large header",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Thank You for contacting us!")]), _vm._v(" "), _c('span', {
    staticClass: "ui medium header"
  }, [_vm._v("We have received your message and we'll get back to you shortly.")])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "ui medium header",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Something went wrong while processing your message")]), _vm._v(" "), _c('p', {
    staticClass: "ui small header"
  }, [_vm._v("Please e-mail support@sentrykit.com")])])])
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-breakdown"
  }, [_c('h3', {
    staticClass: "section-title-secondary"
  }, [_vm._v("BUY BOX STATUS BREAKDOWN")]), _vm._v(" "), _c('div', {
    staticClass: "status-cards"
  }, _vm._l((_vm.statusData), function(status) {
    return _c('div', {
      key: status.type,
      class: ['status-card', status.type, {
        active: _vm.activeType === status.type
      }],
      on: {
        "click": function($event) {
          return _vm.$emit('status-click', status.type)
        }
      }
    }, [_c('div', {
      staticClass: "status-content"
    }, [_c('div', {
      staticClass: "status-icon"
    }, [_c('i', {
      class: status.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "status-count"
    }, [_vm._v(_vm._s(status.count))]), _vm._v(" "), _c('div', {
      staticClass: "status-label"
    }, [_vm._v(_vm._s(status.label))]), _vm._v(" "), _c('div', {
      staticClass: "status-description"
    }, [_vm._v(_vm._s(status.description))])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-child"
  }), _c('div', {
    staticClass: "sk-circle2 sk-child"
  }), _c('div', {
    staticClass: "sk-circle3 sk-child"
  }), _c('div', {
    staticClass: "sk-circle4 sk-child"
  }), _c('div', {
    staticClass: "sk-circle5 sk-child"
  }), _c('div', {
    staticClass: "sk-circle6 sk-child"
  }), _c('div', {
    staticClass: "sk-circle7 sk-child"
  }), _c('div', {
    staticClass: "sk-circle8 sk-child"
  }), _c('div', {
    staticClass: "sk-circle9 sk-child"
  }), _c('div', {
    staticClass: "sk-circle10 sk-child"
  }), _c('div', {
    staticClass: "sk-circle11 sk-child"
  }), _c('div', {
    staticClass: "sk-circle12 sk-child"
  }), _c('div', {
    staticClass: "sk-text"
  })])
}]}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fbm-thresholds-inline"
  }, [_c('div', {
    staticClass: "fbm-inline-title"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v(" "), _c('span', [_vm._v("Alert Threshold — " + _vm._s(_vm.productTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-inline-fields"
  }, [_c('div', {
    staticClass: "fbm-mkt-group"
  }, [_c('div', {
    staticClass: "fbm-mkt-group-label"
  }, [_c('i', {
    class: _vm.getMarketplaceFlag(_vm.item && _vm.item.marketplace ? _vm.item.marketplace : null) + ' flag'
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-mkt-fields"
  }, [_c('div', {
    staticClass: "fbm-inline-field"
  }, [_c('label', [_vm._v("Alert below")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redThreshold),
      expression: "form.redThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fbm-inline-input', _vm.fbmInputFilled],
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fbm-field-unit"
  }, [_vm._v("units")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-inline-actions"
  }, [_c('button', {
    staticClass: "fbm-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.resolvedProductId
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "fbm-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "fbm-inline-hint"
  }, [_vm._v("Alert fires when your FBM stock drops below this level.")])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "fbm-inline-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "fbm-inline-loading"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Saving…\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [(_vm.message) ? _c('div', {
    class: 'ui ' + (_vm.error ? 'negative' : 'positive') + ' message'
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n  Step #1:     "), _c('div', {
    staticClass: "ui labeled icon button",
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("Download " + _vm._s(_vm.watchDogName) + " Alert Settings")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n\n  Step #2:     Edit your settings in bulk in the Spreadsheet\n  "), _c('br'), _c('br'), _vm._v("\n\n  Step #3:     \n  "), _c('span', [_c('label', {
    staticClass: "ui labeled icon button",
    attrs: {
      "for": 'hidden-' + _vm.apiPrefix + '-config-import-file'
    },
    on: {
      "click": _vm.resetFiles
    }
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("Upload " + _vm._s(_vm.watchDogName) + " Alert Settings\n    ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": 'hidden-' + _vm.apiPrefix + '-config-import-file'
    },
    on: {
      "change": _vm.importExcel
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "ui tiny compact button",
    on: {
      "click": function($event) {
        _vm.$parent.showConfiguration = false
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("\n    Back \n  ")]), _vm._v(" "), _c('br'), _vm._v("  \n  \n")])
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-signup-page"
  }, [(_vm.showSignedInBanner) ? _c('div', {
    staticClass: "sk-signed-in-banner"
  }, [_vm._v("\n    You're signed in as "), _c('strong', [_vm._v(_vm._s(_vm.$root.userEmail))]), _vm._v(".\n    "), _c('button', {
    staticClass: "sk-signed-in-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logoutSignedIn
    }
  }, [_vm._v("Log out")]), _vm._v("\n    to create a different account.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-topbar sk-topbar-split"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "sk-topbar-login",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Already a customer? "), _c('b', [_vm._v("Log in")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-steps-bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-step-connector"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-step",
    class: {
      'sk-step-done': _vm.finishMode
    }
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v(_vm._s(_vm.finishMode ? '✓' : '2'))]), _vm._v("\n      Connect Amazon "), _c('small', {
    staticClass: "sk-step-time"
  }, [_vm._v("· ~1 min")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [_c('div', {
    staticClass: "sk-two-col-card"
  }, [_c('div', {
    staticClass: "sk-trust-panel",
    class: {
      'sk-trust-panel-asgtg': _vm.isAsgtg,
      'sk-story': !_vm.isAsgtg
    }
  }, [(_vm.isAsgtg) ? [_c('span', {
    staticClass: "sk-panel-badge"
  }, [_vm._v("ASGTG Partner Offer")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "sk-panel-h sk-asgtg-h"
  }, [_vm._v("Every signal on your Amazon listings — Buy Box, fees, suppression, stock, rank and more.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-panel-sub"
  }, [_vm._v("Built for sellers who found SentryKit through ASGTG. Real-time alerts the moment something changes, so problems get caught before they compound.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-asgtg-signals-lead"
  }, [_vm._v("50+ signals across nine groups — every one of them on every plan.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)] : [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sk-feed",
    attrs: {
      "aria-label": "Example alerts"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sk-alert"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-bb",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 7h16l-1.5 11a2 2 0 0 1-2 1.7H7.5a2 2 0 0 1-2-1.7L4 7z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 7a3 3 0 0 1 6 0",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "sk-alert"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-tx",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 20h4L19 9l-4-4L4 16v4z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "sk-alert sk-alert-dim"
  }, [_c('span', {
    staticClass: "sk-alert-ic sk-alert-ic-fee",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3S9.5 10.4 12 11s4.5 1.6 4.5 3.5-2 3-4.5 3-4.5-1.3-4.5-3",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('section', {
    staticClass: "sk-voices",
    attrs: {
      "aria-labelledby": "sk-voices-h"
    },
    on: {
      "mouseenter": _vm.pauseVoices,
      "mouseleave": _vm.resumeVoices,
      "focusin": _vm.pauseVoices,
      "focusout": _vm.resumeVoices
    }
  }, [_c('div', {
    staticClass: "sk-voices-head"
  }, [_c('h3', {
    attrs: {
      "id": "sk-voices-h"
    }
  }, [_vm._v("What sellers tell us")]), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": "What sellers mention"
    }
  }, _vm._l((_vm.voices), function(v, k) {
    return _c('button', {
      key: v.tab,
      attrs: {
        "type": "button",
        "role": "tab",
        "aria-selected": k === _vm.voiceIndex ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.selectVoice(k)
        }
      }
    }, [_vm._v(_vm._s(v.tab))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-stage"
  }, _vm._l((_vm.voices), function(v, k) {
    return _c('figure', {
      key: v.tab,
      staticClass: "sk-voice",
      class: {
        on: k === _vm.voiceIndex
      },
      attrs: {
        "role": "tabpanel"
      }
    }, [(v.ours) ? _c('p', {
      staticClass: "sk-voice-promise"
    }, [_vm._v(_vm._s(v.text))]) : _c('blockquote', [_vm._v("\"" + _vm._s(v.text) + "\"")]), _vm._v(" "), _c('figcaption', {
      class: {
        ours: v.ours
      }
    }, [_vm._v(_vm._s(v.who))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sk-voices-bar",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    key: _vm.voiceCycle,
    class: {
      run: !_vm.voicePaused && !_vm.reduceMotion
    }
  })]), _vm._v(" "), _vm._m(13)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sk-form-panel"
  }, [(_vm.finishMode) ? [_c('div', {
    staticClass: "sk-amz-connected"
  }, [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Amazon connected"), (_vm.pendingAmazon) ? [_vm._v(": " + _vm._s(_vm.pendingAmazon.marketplaceCount) + " " + _vm._s(_vm.pendingAmazon.marketplaceCount === 1 ? 'marketplace' : 'marketplaces') + " in " + _vm._s(_vm.regionLabel(_vm.pendingAmazon.region)))] : _vm._e()], 2), _vm._v(" "), _c('h1', [_vm._v("Finish setting up")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("Add your email, name and password.")])] : _c('h1', [_vm._v("Start your 14-day free trial")]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-offer"
  }, [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-perks"
  }, [_c('div', {
    staticClass: "sk-perk"
  }, [_c('span', {
    staticClass: "sk-perk-ic",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "8",
      "r": "3.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.5 20c.6-3.4 3.3-5.5 6.5-5.5s5.9 2.1 6.5 5.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 4.6a3.5 3.5 0 0 1 0 6.8M18.5 14.8c1.6.8 2.7 2.6 3 5.2"
    }
  })])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "sk-perk"
  }, [_c('span', {
    staticClass: "sk-perk-ic",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.4A8.5 8.5 0 1 1 21 12z"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 12h.01M12 12h.01M15.5 12h.01"
    }
  })])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), (_vm.isAsgtg) ? _c('div', {
    staticClass: "sk-via-asgtg"
  }, [_c('span', [_vm._v("✓")]), _vm._v(" Signing up via "), _c('b', [_vm._v("ASGTG")]), _vm._v(" — your member offer is already applied.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSso) ? _c('div', {
    staticClass: "sk-sso"
  }, [_c('span', {
    staticClass: "sk-field-label"
  }, [_vm._v("Sign up with")]), _vm._v(" "), _c('div', {
    staticClass: "sk-sso-row"
  }, [(_vm.googleSignupEnabled) ? _c('button', {
    staticClass: "sk-sso-google",
    attrs: {
      "type": "button",
      "aria-label": "Sign up with Google"
    },
    on: {
      "click": _vm.startGoogleSignup
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 48 48",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFC107",
      "d": "M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FF3D00",
      "d": "M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#4CAF50",
      "d": "M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#1976D2",
      "d": "M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"
    }
  })]), _vm._v("\n              Google\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showAmazon) ? _c('button', {
    staticClass: "sk-sso-amz",
    class: {
      loading: _vm.amazonWorking
    },
    attrs: {
      "type": "button",
      "aria-busy": _vm.amazonWorking ? 'true' : 'false',
      "aria-label": "Sign up with Amazon"
    },
    on: {
      "click": _vm.startAmazonSignup
    }
  }, [(_vm.amazonWorking) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('img', {
    staticClass: "sk-amz-logo",
    attrs: {
      "src": _vm.amazonWordmark,
      "alt": "Amazon"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.showAmazon) ? _c('div', {
    staticClass: "sk-region-pick"
  }, [(!_vm.showRegionPicker) ? _c('button', {
    staticClass: "sk-link-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showRegionPicker = true
      }
    }
  }, [_vm._v("Selling outside North America?")]) : _c('label', {
    staticClass: "sk-region-select"
  }, [_c('span', [_vm._v("Amazon region")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amazonRegion),
      expression: "amazonRegion"
    }],
    staticClass: "sk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amazonRegion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.amazonRegions), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.label))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-or"
  }, [_vm._v("or sign up with email")])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": "",
      "autocomplete": "on"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signup.apply(null, arguments)
      },
      "focusin": _vm.onSignupFormStarted
    }
  }, [_c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.email
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-email"
    }
  }, [_vm._v("Work email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.email
    },
    attrs: {
      "id": "signup-email",
      "type": "email",
      "name": "email",
      "inputmode": "email",
      "autocomplete": "email",
      "autocapitalize": "off",
      "spellcheck": "false",
      "placeholder": "you@yourbrand.com",
      "aria-invalid": _vm.fieldErrors.email ? 'true' : 'false'
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('email')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.onEmailInput]
    }
  }), _vm._v(" "), (_vm.fieldErrors.email) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Enter a valid email address, like name@company.com.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.name
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-name"
    }
  }, [_vm._v("Your name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    ref: "name",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.name
    },
    attrs: {
      "id": "signup-name",
      "type": "text",
      "name": "name",
      "autocomplete": "name",
      "placeholder": "First and last name",
      "aria-invalid": _vm.fieldErrors.name ? 'true' : 'false'
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('name')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }, function($event) {
        return _vm.onInput('name')
      }]
    }
  }), _vm._v(" "), (_vm.fieldErrors.name) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Tell us what to call you.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.password
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": function($event) {
        return _vm.onInput('password')
      },
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": function($event) {
        return _vm.onInput('password')
      },
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "sk-input",
    class: {
      error: _vm.fieldErrors.password
    },
    attrs: {
      "id": "signup-password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "At least 8 characters",
      "aria-describedby": "signup-pw-hint",
      "aria-invalid": _vm.fieldErrors.password ? 'true' : 'false',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur('password')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.onInput('password')
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button",
      "aria-label": _vm.showPassword ? 'Hide password' : 'Show password',
      "aria-pressed": _vm.showPassword ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])]), _vm._v(" "), (_vm.fieldErrors.password) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Use 8+ characters with a letter and a number or symbol.")]) : _c('div', {
    staticClass: "sk-pw-hint",
    class: {
      met: _vm.password && !_vm.passwordWeak
    },
    attrs: {
      "id": "signup-pw-hint"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.password && !_vm.passwordWeak ? '✓' : '○'))]), _vm._v(" At least 8 characters\n            ")])]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "field",
    class: {
      'has-error': _vm.fieldErrors.accountType
    }
  }, [_c('span', {
    staticClass: "sk-field-label",
    attrs: {
      "id": "signup-seller-type-label"
    }
  }, [_vm._v("What kind of seller are you?")]), _vm._v(" "), _c('div', {
    staticClass: "sk-seg",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "signup-seller-type-label"
    }
  }, [_vm._l((_vm.sellerTypes), function(opt, k) {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.accountType),
        expression: "accountType"
      }],
      key: opt.value + '-input',
      ref: k === 0 ? 'accountType' : null,
      refInFor: true,
      attrs: {
        "id": 'signup-st-' + opt.value,
        "type": "radio",
        "name": "accountType"
      },
      domProps: {
        "value": opt.value,
        "checked": _vm._q(_vm.accountType, opt.value)
      },
      on: {
        "change": [function($event) {
          _vm.accountType = opt.value
        }, function($event) {
          return _vm.onInput('accountType', true)
        }]
      }
    }), _vm._v(" "), _c('label', {
      key: opt.value + '-label',
      attrs: {
        "for": 'signup-st-' + opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])]
  })], 2), _vm._v(" "), (_vm.fieldErrors.accountType) ? _c('div', {
    staticClass: "sk-field-error"
  }, [_vm._v("Pick the one closest to you. It tailors your alerts.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "sk-input",
    attrs: {
      "id": "signup-company",
      "type": "text",
      "name": "organization",
      "autocomplete": "organization",
      "placeholder": "e.g. Acme Brands LLC"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sk-cta-btn",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "aria-busy": _vm.working ? 'true' : 'false'
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : (_vm.finishMode) ? _c('span', [_vm._v("Finish & start syncing →")]) : _c('span', [_vm._v("Create account & continue →")])]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), (!_vm.finishMode) ? _c('div', {
    staticClass: "sk-next-note"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5l8-3z",
      "stroke": "#1E9E6A",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 12l2.5 2.5 4.5-5",
      "stroke": "#1E9E6A",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.chatAvailable) ? _c('div', {
    staticClass: "sk-form-footer"
  }, [_vm._v("\n          Questions first? "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_vm._v("Chat with us")])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-step sk-step-active"
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v("1")]), _vm._v("\n      Create account "), _c('small', {
    staticClass: "sk-step-time"
  }, [_vm._v("· ~1 min")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-asgtg-rating"
  }, [_c('span', {
    staticClass: "sk-asgtg-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('b', [_vm._v("4.8/5")]), _vm._v(" · "), _c('span', {
    staticClass: "sk-asgtg-trust"
  }, [_vm._v("Trusted by 3,000+ Amazon brands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-asgtg-grid"
  }, [_c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("01")]), _vm._v("Fees & margin")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("02")]), _vm._v("Buy Box & pricing")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("03")]), _vm._v("Account health & policy")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("04")]), _vm._v("Listing health & suppression")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("05")]), _vm._v("Product content & fields")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("06")]), _vm._v("Reviews & feedback")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("07")]), _vm._v("Rank & visibility")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("08")]), _vm._v("Inventory & fulfilment")]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-cell"
  }, [_c('span', {
    staticClass: "n"
  }, [_vm._v("09")]), _vm._v("Competitors & hijackers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-panel-reviews"
  }, [_c('div', {
    staticClass: "sk-asgtg-review"
  }, [_c('div', {
    staticClass: "sk-asgtg-stars sk-asgtg-quote-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('p', {
    staticClass: "sk-review-text"
  }, [_vm._v("\"Reliable and powerful. The alerts land immediately — it catches everything across our catalogue without us having to check anything manually.\"")]), _vm._v(" "), _c('span', {
    staticClass: "sk-review-who"
  }, [_vm._v("Maximilian A. · Founder, Small Business · G2")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-asgtg-review"
  }, [_c('div', {
    staticClass: "sk-asgtg-stars sk-asgtg-quote-stars"
  }, [_vm._v("★★★★★")]), _vm._v(" "), _c('p', {
    staticClass: "sk-review-text"
  }, [_vm._v("\"The timeliness of notifications and the detail of 'before/after' changes. Excellent customer support.\"")]), _vm._v(" "), _c('span', {
    staticClass: "sk-review-who"
  }, [_vm._v("Verified User · Small Business · G2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sk-eyebrow"
  }, [_vm._v("Amazon listing & account monitoring")]), _vm._v(" "), _c('h2', {
    staticClass: "sk-story-h"
  }, [_vm._v("See every change to your Amazon listings the moment it happens.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-story-sub"
  }, [_vm._v("Buy Box, hijackers, suppressions, fees, title and image edits. Sent to Email, Slack, Teams or ClickUp, wherever your team already works.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-feed-head"
  }, [_c('span', [_vm._v("What your alerts look like")]), _c('span', {
    staticClass: "sk-live"
  }, [_c('i'), _vm._v("Monitoring")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("Buy Box lost")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_vm._v("An unknown seller took it at "), _c('b', [_vm._v("$24.99")]), _vm._v(". Your offer: $26.49.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Slack")]), _c('br'), _vm._v("just now")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("Title changed")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_c('s', [_vm._v("Turmeric Curcumin Capsules, 120 Count")]), _c('br'), _c('b', [_vm._v("Turmeric Capsules, 60 Count")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Email")]), _c('br'), _vm._v("4 min ago")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-alert-t"
  }, [_vm._v("FBA fee increased")]), _c('div', {
    staticClass: "sk-alert-d"
  }, [_vm._v("+$0.61 per unit. Amazon moved this item to a new size tier.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-alert-m"
  }, [_c('span', {
    staticClass: "sk-alert-ch"
  }, [_vm._v("Teams")]), _c('br'), _vm._v("1 h ago")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-feed-foot"
  }, [_vm._v("Before and after on every change, across "), _c('b', [_vm._v("50+ signals")]), _vm._v(" per listing.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sk-voices-foot"
  }, [_vm._v("From customer emails to our team. Sellers across the US, UK, Italy, Germany, Austria and beyond. "), _c('a', {
    attrs: {
      "href": "https://www.g2.com/products/sentrykit/reviews",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Public reviews on G2 →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" No credit card")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Full access to every alert")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Cancel anytime")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-perk-t"
  }, [_vm._v("Dedicated onboarding")]), _c('div', {
    staticClass: "sk-perk-d"
  }, [_vm._v("For every account, every plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sk-perk-t"
  }, [_vm._v("Immediate support")]), _c('div', {
    staticClass: "sk-perk-d"
  }, [_vm._v("Real people, anytime you need us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "signup-company"
    }
  }, [_vm._v("Company "), _c('span', {
    staticClass: "sk-opt"
  }, [_vm._v("Optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sk-legal"
  }, [_vm._v("By creating an account you agree to SentryKit's "), _c('a', {
    attrs: {
      "href": "https://www.sentrykit.com/terms",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.sentrykit.com/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Next: connect Amazon.")]), _vm._v(" You approve access on Amazon's own Seller Central screen, so we never see your password. SentryKit doesn't edit your listings, prices or inventory.")])
}]}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "als-loading"
  }, [_c('div', {
    staticClass: "als-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "als-error"
  }, [_c('p', {
    staticClass: "als-error-title"
  }, [_vm._v("Could not load alert settings")]), _vm._v(" "), _c('p', {
    staticClass: "als-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "als-btn als-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "als-hint-banner",
    attrs: {
      "role": "note"
    }
  }, [_c('svg', {
    staticClass: "als-hint-icon",
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showInboxMode) ? _c('div', {
    staticClass: "als-config-card als-inbox-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Inbox mode")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("How alert emails land in your inbox."), (!_vm.canEditThreadedAlerts) ? [_vm._v(" Only the account owner or an admin can change this.")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "als-inbox-options",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Inbox mode"
    }
  }, _vm._l((_vm.inboxModeOptions), function(opt) {
    return _c('label', {
      key: opt.value,
      staticClass: "als-inbox-option",
      class: {
        'als-inbox-option-sel': _vm.threadedAlerts === opt.value,
        'als-toggle-busy': _vm.inboxModeSaving
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "als-inbox-mode",
        "disabled": _vm.inboxModeSaving || !_vm.canEditThreadedAlerts
      },
      domProps: {
        "checked": _vm.threadedAlerts === opt.value
      },
      on: {
        "change": function($event) {
          return _vm.onInboxModeChange(opt.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "als-inbox-option-text"
    }, [_c('strong', [_vm._v(_vm._s(opt.label))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(opt.hint))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "als-config-card als-digest-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "als-toggle",
    class: {
      'als-toggle-busy': _vm.digestSaving
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.digestSaving
    },
    domProps: {
      "checked": _vm.offerActivityDigest
    },
    on: {
      "change": function($event) {
        return _vm.onDigestToggle($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "als-toggle-slider"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "als-config-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Configuring alerts for")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v(_vm._s(_vm.isOwner ? 'Admin only · Members receive alerts based on this configuration' : 'Your personal alert preferences'))])]), _vm._v(" "), (_vm.dropdownUsers.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUserEmail),
      expression: "selectedUserEmail"
    }],
    staticClass: "als-user-select",
    attrs: {
      "disabled": !_vm.isOwner
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUserEmail = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownUsers), function(u) {
    return _c('option', {
      key: u.email,
      domProps: {
        "value": u.email
      }
    }, [_vm._v(_vm._s(_vm.formatUserLabel(u)))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "als-brands"
  }, [(_vm.hasMultiMp) ? _c('div', {
    staticClass: "als-mp-default-head"
  }, [_c('span', {
    staticClass: "als-mp-default-title"
  }, [_vm._v("Default marketplaces")]), _vm._v(" "), _c('span', {
    staticClass: "als-mp-default-hint"
  }, [_vm._v("Every alert sends for these unless you give it its own marketplaces below.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedStorefronts), function(br) {
    return _c('div', {
      key: br.key,
      staticClass: "als-brand-row"
    }, [_c('span', {
      staticClass: "als-brand-name"
    }, [_vm._v(_vm._s(br.name))]), _vm._v(" "), (_vm.sfMpCodes(br).length > 1) ? _c('div', {
      staticClass: "als-mp-chips",
      attrs: {
        "role": "group",
        "aria-label": br.name + ' default marketplaces'
      }
    }, [_c('button', {
      class: ['als-mp-chip', 'als-mp-chip-all', {
        active: _vm.mpIsAll(_vm.defaultMpScope, br)
      }],
      attrs: {
        "type": "button",
        "aria-pressed": _vm.mpIsAll(_vm.defaultMpScope, br) ? 'true' : 'false',
        "disabled": !_vm.mpDefaultEditable
      },
      on: {
        "click": function($event) {
          return _vm.setMpAll(_vm.defaultMpScope, br)
        }
      }
    }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sfMpCodes(br)), function(mp) {
      return _c('button', {
        key: 'dmp-' + br.key + '-' + mp.code,
        class: ['als-mp-chip', {
          active: _vm.mpChipOn(_vm.defaultMpScope, br, mp.code)
        }],
        attrs: {
          "type": "button",
          "aria-pressed": _vm.mpChipOn(_vm.defaultMpScope, br, mp.code) ? 'true' : 'false',
          "disabled": !_vm.mpDefaultEditable
        },
        on: {
          "click": function($event) {
            return _vm.toggleMpChip(_vm.defaultMpScope, br, mp.code)
          }
        }
      }, [_c('i', {
        class: _vm.mpFlagClass(mp.raw) + ' flag'
      }), _vm._v(_vm._s(_vm.mpLabel(mp.raw)))])
    })], 2) : _c('div', {
      staticClass: "als-mp-tags"
    }, _vm._l((br.mpCodes), function(code) {
      return _c('span', {
        key: code,
        staticClass: "als-mp-tag"
      }, [_c('i', {
        class: _vm.mpFlagClass(code) + ' flag'
      }), _vm._v(_vm._s(_vm.mpLabel(code)) + "\n            ")])
    }), 0), _vm._v(" "), (_vm.mpStale(_vm.defaultMpScope, br)) ? _c('p', {
      staticClass: "als-mp-warn"
    }, [_vm._v("No active marketplace selected for " + _vm._s(br.name) + ". Alerts that follow your default send nothing for it.")]) : _vm._e()])
  }), _vm._v(" "), (!_vm.assignedStorefronts.length) ? _c('p', {
    staticClass: "als-muted-sm"
  }, [_vm._v("No storefronts assigned.")]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "als-config-footer"
  }, [_vm._v("\n        Assignment managed in "), _c('router-link', {
    staticClass: "als-link",
    attrs: {
      "to": "/settings/account"
    }
  }, [_vm._v("Account & Team")]), _vm._v(".\n        Narrow any alert to specific storefronts using the Storefronts selector on each alert.\n        "), (_vm.hasMultiMp) ? [_vm._v("Products in muted marketplaces are still tracked and stay on your dashboard.")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "als-config-card als-locale-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notificationLocale),
      expression: "notificationLocale"
    }],
    staticClass: "als-user-select",
    attrs: {
      "disabled": _vm.localeSaving || (!_vm.isOwner && _vm.selectedUserEmail !== _vm.loginEmail)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notificationLocale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.saveNotificationLocale]
    }
  }, _vm._l((_vm.notificationLocaleOptions), function(opt) {
    return _c('option', {
      key: opt.code,
      domProps: {
        "value": opt.code
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 0)]), _vm._v(" "), (_vm.localeSaving) ? _c('p', {
    staticClass: "als-muted-sm"
  }, [_vm._v("Saving language…")]) : (_vm.localeError) ? _c('p', {
    staticClass: "als-error-msg als-locale-error"
  }, [_vm._v(_vm._s(_vm.localeError))]) : (_vm.localeSaved) ? _c('p', {
    staticClass: "als-muted-sm als-locale-saved"
  }, [_vm._v("Language saved.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "als-panel"
  }, _vm._l((_vm.categorizedRows), function(cat) {
    return _c('div', {
      key: 'cat-' + cat.name
    }, [_c('div', {
      staticClass: "als-cat"
    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), _vm._l((cat.rows), function(row) {
      return _c('div', {
        key: row.id,
        staticClass: "als-row-wrap"
      }, [_c('div', {
        staticClass: "als-row",
        class: {
          'als-row-locked': _vm.rowLocked(row)
        }
      }, [_c('div', {
        staticClass: "als-row-main"
      }, [_c('div', {
        staticClass: "als-alert-title"
      }, [_vm._v("\n                " + _vm._s(row.title) + "\n                "), (_vm.mpPillVisible(row)) ? _c('span', {
        class: ['als-mp-pill', {
          'als-mp-pill-own': _vm.rowMpOwn(row)
        }]
      }, [_vm._v(_vm._s(_vm.mpPillText(row)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "als-alert-desc"
      }, [_c('span', {
        staticClass: "als-includes-label"
      }, [_vm._v("Includes:")]), _vm._v("\n                " + _vm._s(row.includes) + "\n                "), (row.note) ? _c('span', {
        staticClass: "als-note"
      }, [_vm._v(_vm._s(row.note))]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "als-row-controls"
      }, [_c('div', {
        staticClass: "als-row-controls-stack"
      }, [_c('div', {
        staticClass: "als-row-controls-top"
      }, [(row.alwaysOn) ? _c('span', {
        staticClass: "als-pill-on"
      }, [_vm._v("Always on")]) : (_vm.rowLocked(row)) ? _c('span', {
        staticClass: "als-starter-lock als-starter-lock--toggle"
      }, [_c('svg', {
        attrs: {
          "width": "14",
          "height": "14",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M5 9V7a5 5 0 0110 0v2h1a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a2 2 0 012-2h1zm2 0h6V7a3 3 0 10-6 0v2z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v("\n                    Starter+\n                  ")]) : [(_vm.showStorefrontChip(row)) ? _c('div', {
        staticClass: "als-sf-chip",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('button', {
        staticClass: "als-sf-chip-btn",
        attrs: {
          "type": "button",
          "title": _vm.storefrontChipTooltip(row),
          "aria-expanded": _vm.openStorefrontRowId === row.id ? 'true' : 'false'
        },
        on: {
          "click": function($event) {
            return _vm.toggleStorefrontMenu(row)
          }
        }
      }, [_vm._v(_vm._s(_vm.storefrontChipLabel(row)) + " "), _c('span', {
        staticClass: "als-sf-caret"
      }, [_vm._v("▾")])]), _vm._v(" "), (_vm.openStorefrontRowId === row.id) ? _c('div', {
        staticClass: "als-sf-menu",
        attrs: {
          "role": "dialog",
          "aria-label": "Storefronts for this alert"
        }
      }, [_c('label', {
        staticClass: "als-sf-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'sf-mode-' + row.id
        },
        domProps: {
          "checked": !_vm.rowSellerIdsFor(row).length
        },
        on: {
          "change": function($event) {
            return _vm.setStorefrontsAll(row)
          }
        }
      }), _vm._v("\n                          All storefronts\n                        ")]), _vm._v(" "), _c('label', {
        staticClass: "als-sf-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'sf-mode-' + row.id
        },
        domProps: {
          "checked": _vm.rowSellerIdsFor(row).length > 0
        },
        on: {
          "change": function($event) {
            return _vm.setStorefrontsOnly(row)
          }
        }
      }), _vm._v("\n                          Only selected:\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "als-sf-list"
      }, _vm._l((_vm.assignedStorefronts), function(sf) {
        return _c('label', {
          key: 'sf-' + row.id + '-' + sf.key,
          staticClass: "als-sf-opt"
        }, [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.storefrontSelected(row, sf.id)
          },
          on: {
            "change": function($event) {
              return _vm.onStorefrontCheck(row, sf.id, $event.target.checked, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "als-sf-name"
        }, [_vm._v(_vm._s(sf.name))]), _vm._v(" "), _c('span', {
          staticClass: "als-sf-flags"
        }, _vm._l((sf.mpCodes), function(code) {
          return _c('i', {
            key: 'f-' + sf.key + '-' + code,
            class: _vm.mpFlagClass(code) + ' flag',
            attrs: {
              "title": _vm.mpLabel(code)
            }
          })
        }), 0)])
      }), 0), _vm._v(" "), (_vm.storefrontMenuError[row.id]) ? _c('p', {
        staticClass: "als-sf-err"
      }, [_vm._v(_vm._s(_vm.storefrontMenuError[row.id]))]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "als-sf-note"
      }, [_vm._v("“All” also covers storefronts you add later.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', {
        staticClass: "als-toggle"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowOn(row)
        },
        on: {
          "change": function($event) {
            return _vm.onRowToggle(row, $event.target.checked)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "als-toggle-slider"
      })])]], 2), _vm._v(" "), (row.delayMinutesConfigurable && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-row-controls-bottom als-delay-inline"
      }, [_c('div', {
        staticClass: "als-seg",
        attrs: {
          "role": "group",
          "aria-label": "Buy Box alert delay"
        }
      }, [_c('button', {
        class: ['als-seg-btn', {
          active: !_vm.isBuyboxDelayCustom(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setBuyboxDelayImmediate(row)
          }
        }
      }, [_vm._v("Real-time")]), _vm._v(" "), _c('button', {
        class: ['als-seg-btn', {
          active: _vm.isBuyboxDelayCustom(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.enableBuyboxDelayInput(row)
          }
        }
      }, [_vm._v("Custom")])]), _vm._v(" "), (_vm.isBuyboxDelayCustom(row)) ? [_c('input', {
        class: ['als-delay-input', {
          'als-delay-input-err': !!_vm.delayErrorForRow(row)
        }],
        attrs: {
          "type": "number",
          "min": "20",
          "max": "40",
          "step": "1"
        },
        domProps: {
          "value": _vm.delayDraftForRow(row)
        },
        on: {
          "input": function($event) {
            return _vm.onBuyboxDelayInput(row, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "als-delay-unit"
      }, [_vm._v("min")])] : _vm._e()], 2) : (!row.delayMinutesConfigurable && (row.alwaysOn || row.digestFixed || _vm.deliveryRealtimeBadgeOnly(row) || (!_vm.rowLocked(row) && !row.alwaysOn && !_vm.deliveryRealtimeBadgeOnly(row)))) ? _c('div', {
        staticClass: "als-row-controls-bottom"
      }, [(row.alwaysOn) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v(_vm._s(row.digestFixed ? 'Digest' : 'Real-time'))])] : (row.digestFixed) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v("Digest")])] : (_vm.deliveryRealtimeBadgeOnly(row)) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v(_vm._s(row.fixedBadge || 'Real-time'))])] : [_c('div', {
        staticClass: "als-seg",
        attrs: {
          "role": "group"
        }
      }, _vm._l((_vm.deliveryOptionsForRow(row)), function(opt) {
        return _c('button', {
          key: opt,
          class: ['als-seg-btn', {
            active: _vm.deliveryFor(row) === opt
          }],
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.setDelivery(row, opt)
            }
          }
        }, [_vm._v(_vm._s(opt === 'realtime' ? 'Real-time' : (opt === 'daily' ? 'Daily' : 'Weekly')))])
      }), 0)]], 2) : _vm._e()]), _vm._v(" "), (row.delayMinutesConfigurable && _vm.rowOn(row) && !_vm.rowLocked(row) && _vm.delayErrorForRow(row)) ? _c('p', {
        staticClass: "als-delay-error-inline"
      }, [_vm._v(_vm._s(_vm.delayErrorForRow(row)))]) : _vm._e(), _vm._v(" "), (_vm.storefrontSelectionStale(row)) ? _c('p', {
        staticClass: "als-sf-warn"
      }, [_vm._v("No assigned storefronts selected — this alert won't send.")]) : _vm._e()])]), _vm._v(" "), (_vm.subtypeBoxVisible(row)) ? _c('details', {
        staticClass: "als-bf als-st",
        attrs: {
          "open": !!_vm.subtypeBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.subtypeBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Alert me about\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.subtypeSummary(row)))])]), _vm._v(" "), _c('div', {
        staticClass: "als-st-grid",
        attrs: {
          "role": "group",
          "aria-label": row.title + ' types'
        }
      }, _vm._l((_vm.subtypeOptions(row)), function(opt) {
        return _c('label', {
          key: 'st-' + row.id + '-' + opt.key,
          staticClass: "als-st-opt"
        }, [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.subtypeOn(row, opt.key)
          },
          on: {
            "change": function($event) {
              return _vm.onSubtypeCheck(row, opt.key, $event.target.checked, $event)
            }
          }
        }), _vm._v("\n                " + _vm._s(opt.label) + "\n              ")])
      }), 0), _vm._v(" "), (_vm.subtypeError[row.id]) ? _c('p', {
        staticClass: "als-mp-warn"
      }, [_vm._v(_vm._s(_vm.subtypeError[row.id]))]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [(_vm.mutedSubtypesFor(row).length) ? _c('button', {
        staticClass: "als-st-reset",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setAllSubtypes(row)
          }
        }
      }, [_vm._v("Turn all back on")]) : _vm._e(), _vm._v("\n              New types Amazon adds later are on automatically.\n            ")])]) : _vm._e(), _vm._v(" "), (row.settingsKey === 'review_health' && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('details', {
        staticClass: "als-bf als-st",
        attrs: {
          "open": !!_vm.settingsBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.settingsBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Sensitivity\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.reviewSensitivitySummary(row)))])]), _vm._v(" "), _c('p', {
        staticClass: "als-settings-label"
      }, [_vm._v("Star rating drop")]), _vm._v(" "), _c('div', {
        staticClass: "als-st-grid",
        attrs: {
          "role": "radiogroup",
          "aria-label": row.title + ' rating sensitivity'
        }
      }, [_c('label', {
        staticClass: "als-st-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'rs-' + row.id
        },
        domProps: {
          "checked": _vm.rowSettingsFor(row).rating_sensitivity === 'half_star'
        },
        on: {
          "change": function($event) {
            return _vm.setRowSetting(row, 'rating_sensitivity', 'half_star')
          }
        }
      }), _vm._v("\n                Every half-star the customer sees (default)\n              ")]), _vm._v(" "), _c('label', {
        staticClass: "als-st-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'rs-' + row.id
        },
        domProps: {
          "checked": _vm.rowSettingsFor(row).rating_sensitivity === 'tenth'
        },
        on: {
          "change": function($event) {
            return _vm.setRowSetting(row, 'rating_sensitivity', 'tenth')
          }
        }
      }), _vm._v("\n                Every 0.1 drop\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "als-settings-line"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Minimum rating-count drop")]), _vm._v(" "), _c('input', {
        staticClass: "als-delay-input",
        attrs: {
          "type": "number",
          "min": "1",
          "step": "1"
        },
        domProps: {
          "value": _vm.rowSettingsFor(row).min_rating_count_drop
        },
        on: {
          "change": function($event) {
            return _vm.onMinRatingCountDropChange(row, $event)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (_vm.hasMultiMp && (row.alwaysOn || (row.digestFixed && _vm.rowOn(row) && !_vm.rowLocked(row)))) ? _c('p', {
        staticClass: "als-mp-follow als-mp-follow-row"
      }, [_vm._v("\n            Marketplaces: follows your default ("), _c('b', [_vm._v(_vm._s(_vm.mpScopeSummary(_vm.defaultMpScope, _vm.mpStorefrontsAll)))]), _vm._v("). " + _vm._s(row.alwaysOn ? 'Always-on alerts can\'t have their own set.' : 'This digest can\'t have its own set.') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mpBoxVisible(row)) ? _c('details', {
        staticClass: "als-bf als-mp",
        attrs: {
          "open": !!_vm.mpBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.mpBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Marketplaces\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.rowMpOwn(row) ? 'own set' : 'follows default'))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-hint"
      }, [_vm._v("Which marketplaces send this alert. Use your default, or pick a different set just for this alert.")]), _vm._v(" "), _c('div', {
        staticClass: "als-seg als-mp-mode",
        attrs: {
          "role": "group",
          "aria-label": row.title + ' marketplace mode'
        }
      }, [_c('button', {
        class: ['als-seg-btn', {
          active: !_vm.rowMpOwn(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setRowMpMode(row, false)
          }
        }
      }, [_vm._v("Use default")]), _vm._v(" "), _c('button', {
        class: ['als-seg-btn', {
          active: _vm.rowMpOwn(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setRowMpMode(row, true)
          }
        }
      }, [_vm._v("Own marketplaces")])]), _vm._v(" "), (_vm.rowMpOwn(row)) ? _vm._l((_vm.mpStorefronts(row)), function(sf) {
        return _c('div', {
          key: 'mp-' + row.id + '-' + sf.key,
          staticClass: "als-bf-line"
        }, [(_vm.mpStorefronts(row).length > 1) ? _c('span', {
          staticClass: "als-bf-name"
        }, [_vm._v(_vm._s(sf.name))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "als-mp-chips",
          attrs: {
            "role": "group",
            "aria-label": sf.name + ' marketplaces for ' + row.title
          }
        }, [_c('button', {
          class: ['als-mp-chip', 'als-mp-chip-all', {
            active: _vm.mpIsAll(_vm.rowMpScope[row.id], sf)
          }],
          attrs: {
            "type": "button",
            "aria-pressed": _vm.mpIsAll(_vm.rowMpScope[row.id], sf) ? 'true' : 'false'
          },
          on: {
            "click": function($event) {
              return _vm.setMpAll(_vm.rowMpScope[row.id], sf)
            }
          }
        }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sfMpCodes(sf)), function(mp) {
          return _c('button', {
            key: 'rmp-' + row.id + '-' + sf.key + '-' + mp.code,
            class: ['als-mp-chip', {
              active: _vm.mpChipOn(_vm.rowMpScope[row.id], sf, mp.code)
            }],
            attrs: {
              "type": "button",
              "aria-pressed": _vm.mpChipOn(_vm.rowMpScope[row.id], sf, mp.code) ? 'true' : 'false'
            },
            on: {
              "click": function($event) {
                return _vm.toggleMpChip(_vm.rowMpScope[row.id], sf, mp.code)
              }
            }
          }, [_c('i', {
            class: _vm.mpFlagClass(mp.raw) + ' flag'
          }), _vm._v(_vm._s(_vm.mpLabel(mp.raw)))])
        })], 2), _vm._v(" "), (_vm.mpStale(_vm.rowMpScope[row.id], sf)) ? _c('p', {
          staticClass: "als-mp-warn"
        }, [_vm._v("No active marketplace selected for " + _vm._s(sf.name) + ". This alert sends nothing for it.")]) : _vm._e()])
      }) : _c('p', {
        staticClass: "als-mp-follow"
      }, [_vm._v("Following default: "), _c('b', [_vm._v(_vm._s(_vm.mpScopeSummary(_vm.defaultMpScope, _vm.mpStorefronts(row))))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [_vm._v("Applies only to " + _vm._s(_vm.selectedUserEmail === _vm.loginEmail ? 'your' : _vm.selectedUserEmail + '’s') + " emails")])], 2) : _vm._e(), _vm._v(" "), (row.brandFilter && _vm.rowOn(row) && !_vm.rowLocked(row) && _vm.brandStorefronts(row).length) ? _c('details', {
        staticClass: "als-bf",
        attrs: {
          "open": _vm.brandFilterIsOpen(row.brandFilter)
        },
        on: {
          "toggle": function($event) {
            return _vm.setBrandFilterOpen(row.brandFilter, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Brand filter\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— optional" + _vm._s(_vm.brandFilterSummary(row)))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-hint"
      }, [_vm._v(_vm._s(row.brandFilterHint) + " Leave empty to be alerted on every listing.")]), _vm._v(" "), _vm._l((_vm.brandStorefronts(row)), function(sf) {
        return _c('div', {
          key: 'bf-' + row.brandFilter + '-' + sf.key,
          staticClass: "als-bf-line"
        }, [(_vm.brandStorefronts(row).length > 1) ? _c('span', {
          staticClass: "als-bf-name"
        }, [_vm._v(_vm._s(sf.name))]) : _vm._e(), _vm._v(" "), (!_vm.brandsFor(row.brandFilter, sf.id).length) ? _c('span', {
          staticClass: "als-bf-all"
        }, [_vm._v("All brands")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandsFor(row.brandFilter, sf.id)), function(b, bi) {
          return _c('span', {
            key: 'bp-' + row.brandFilter + '-' + sf.key + '-' + bi,
            staticClass: "als-bf-pill"
          }, [_vm._v("\n                " + _vm._s(b) + "\n                "), (_vm.brandFilterEditable) ? _c('button', {
            staticClass: "als-bf-x",
            attrs: {
              "type": "button",
              "aria-label": 'Remove ' + b
            },
            on: {
              "click": function($event) {
                return _vm.removeBrand(row.brandFilter, sf.id, bi)
              }
            }
          }, [_vm._v("×")]) : _vm._e()])
        }), _vm._v(" "), (_vm.brandFilterEditable) ? _c('div', {
          staticClass: "als-bf-add",
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('button', {
          staticClass: "als-bf-add-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.toggleBrandPicker(row.brandFilter, sf.id, row.id)
            }
          }
        }, [_vm._v("+ Add brand ▾")]), _vm._v(" "), (_vm.brandPickerKey === _vm.brandPickerKeyFor(row.id, sf.id)) ? _c('div', {
          staticClass: "als-bf-pick"
        }, [_c('input', {
          staticClass: "als-bf-search",
          attrs: {
            "type": "text",
            "placeholder": "Search or type a brand"
          },
          domProps: {
            "value": _vm.brandQuery
          },
          on: {
            "input": function($event) {
              return _vm.onBrandQuery(sf.id, $event.target.value)
            },
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              $event.preventDefault();
              return _vm.addTypedBrand(row.brandFilter, sf.id)
            }
          }
        }), _vm._v(" "), (_vm.brandOptionsLoading) ? _c('p', {
          staticClass: "als-bf-empty"
        }, [_vm._v("Loading brands…")]) : [_vm._l((_vm.brandPickerOptions(row.brandFilter, sf.id)), function(opt) {
          return _c('button', {
            key: 'bo-' + opt.brand,
            staticClass: "als-bf-opt",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return _vm.addBrand(row.brandFilter, sf.id, opt.brand)
              }
            }
          }, [_c('span', [_vm._v(_vm._s(opt.brand))]), _c('small', [_vm._v(_vm._s(opt.asin_count) + " ASIN" + _vm._s(opt.asin_count === 1 ? '' : 's'))])])
        }), _vm._v(" "), (_vm.brandQueryIsCustom(row.brandFilter, sf.id)) ? _c('button', {
          staticClass: "als-bf-opt als-bf-custom",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.addTypedBrand(row.brandFilter, sf.id)
            }
          }
        }, [_vm._v("Use “" + _vm._s(_vm.brandQuery.trim()) + "”")]) : _vm._e(), _vm._v(" "), (!_vm.brandPickerOptions(row.brandFilter, sf.id).length && !_vm.brandQueryIsCustom(row.brandFilter, sf.id)) ? _c('p', {
          staticClass: "als-bf-empty"
        }, [_vm._v("No more brands in this catalog")]) : _vm._e()]], 2) : _vm._e()]) : _vm._e()], 2)
      }), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [_vm._v("Applies only to " + _vm._s(_vm.selectedUserEmail === _vm.loginEmail ? 'your' : _vm.selectedUserEmail + '’s') + " emails" + _vm._s(_vm.brandFilterEditable ? '' : ' · Only the account owner or an admin can edit another user’s filter'))])], 2) : _vm._e(), _vm._v(" "), (!row.alwaysOn && !_vm.deliveryRealtimeBadgeOnly(row) && (row.digestFixed || _vm.deliveryFor(row) === 'daily') && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-subrow"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Send at")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.digestHourForRow(row.id)
        },
        on: {
          "change": function($event) {
            _vm.setDigestHourForRow(row.id, Number($event.target.value))
          }
        }
      }, _vm._l((_vm.digestHourOptions), function(h) {
        return _c('option', {
          key: h,
          domProps: {
            "value": h
          }
        }, [_vm._v(_vm._s(_vm.formatDigestHour(h)))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-hint"
      }, [_vm._v(_vm._s(row.digestFixed ? 'Browser local time' : 'Browser local time · consolidated with other daily alerts'))])]) : _vm._e(), _vm._v(" "), (!row.alwaysOn && !row.digestFixed && !_vm.deliveryRealtimeBadgeOnly(row) && _vm.deliveryFor(row) === 'weekly' && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-subrow"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Every")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.weeklyDay[row.id] || _vm.weeklyScheduleDayDefault
        },
        on: {
          "change": function($event) {
            return _vm.setWeeklyDay(row.id, $event.target.value)
          }
        }
      }, _vm._l((_vm.weekDaysList), function(d) {
        return _c('option', {
          key: d.api,
          domProps: {
            "value": d.api
          }
        }, [_vm._v(_vm._s(d.label))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("at")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.digestHourForRow(row.id)
        },
        on: {
          "change": function($event) {
            _vm.setDigestHourForRow(row.id, Number($event.target.value))
          }
        }
      }, _vm._l((_vm.digestHourOptions), function(h) {
        return _c('option', {
          key: 'wh-' + h,
          domProps: {
            "value": h
          }
        }, [_vm._v(_vm._s(_vm.formatDigestHour(h)))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-hint"
      }, [_vm._v("Browser local time · consolidated with other weekly alerts")])]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "als-footer-bar"
  }, [_c('button', {
    staticClass: "als-btn als-btn-primary",
    class: {
      'als-btn-loading': _vm.saving
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.hasChanges || _vm.saving || _vm.hasDelayValidationError
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save Preferences")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "als-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "als-toast als-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "als-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "als-toast als-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als-page-head"
  }, [_c('div', {
    staticClass: "als-page-head-text"
  }, [_c('h1', {
    staticClass: "als-title"
  }, [_vm._v("Alert Settings")]), _vm._v(" "), _c('p', {
    staticClass: "als-subtitle"
  }, [_vm._v("Choose which alerts you receive and how often.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als-hint-body"
  }, [_c('strong', [_vm._v("Real-time")]), _vm._v(" alerts deliver the moment Amazon broadcasts the change. "), _c('strong', [_vm._v("Daily")]), _vm._v(" bundles changes into one morning email. "), _c('strong', [_vm._v("Weekly")]), _vm._v(" rolls them into your Monday digest.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Offer activity digest")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("When on, Buy Box losses to Amazon Retail or authorised resellers batch every 15 minutes instead of sending immediately. Ignore still never emails.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Notification language")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("Email labels and copy only — your listing titles and Amazon field values are never translated. Saves automatically when you change the selection.")])])
}]}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "changePasswordModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('form', {
    staticClass: "ui form",
    attrs: {
      "action": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Old Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    attrs: {
      "id": "oldPassword",
      "type": "password",
      "placeholder": "Current password",
      "required": "true"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('password-input-pair', {
    ref: "passwordPair",
    attrs: {
      "password-label": 'New Password'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui error message"
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "changePasswordFeedbackModal"
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui red header"
  }, [_vm._v("Could not change your password")]) : _c('div', {
    staticClass: "header"
  }, [_vm._v("Your password has been changed successfully")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive button"
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black ok button"
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('div', {
    staticClass: "settings-hub"
  }, [_c('div', {
    staticClass: "settings-nav-panel"
  }, [_c('div', {
    staticClass: "settings-hub-title-wrap"
  }, [_c('h1', {
    staticClass: "settings-hub-title"
  }, [_vm._v("Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("ACCOUNT")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/product-tracking",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Product Tracking")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/account",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Account & Team")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("NOTIFICATIONS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/alerts",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Alert Settings")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/sellers",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Hijacker")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("BILLING & COSTS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/billing",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Subscription & Billing")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/bulk-cogs",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Bulk COGS & Margins")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "settings-nav-group"
  }, [_c('div', {
    staticClass: "settings-nav-group-label"
  }, [_vm._v("INTEGRATIONS")]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/webhooks",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Webhooks")])]), _vm._v(" "), _c('router-link', {
    staticClass: "settings-nav-item",
    attrs: {
      "to": "/settings/api-keys",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('svg', {
    staticClass: "settings-nav-icon",
    attrs: {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("API Keys")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "settings-content-panel"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-cards"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalProducts.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Total Products")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.costsSet.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Costs Set")]), _vm._v(" "), _c('div', {
    staticClass: "stat-percentage"
  }, [_vm._v("(" + _vm._s(_vm.statistics.percentageSet) + "%)")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.missingCosts.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Missing Costs")])])])
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upload-area",
    class: {
      'dragover': _vm.isDragging,
      'uploading': _vm.uploading
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.isDragging = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.isDragging = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.handleFileDrop.apply(null, arguments)
      },
      "click": _vm.triggerFileInput
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFileSelect
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "cloud upload icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "upload-text"
  }, [_vm._v("Click to upload or drag and drop")]), _vm._v(" "), _c('p', {
    staticClass: "upload-hint"
  }, [_vm._v("CSV file up to 10MB")])]), _vm._v(" "), (_vm.uploadedFile) ? _c('div', {
    staticClass: "uploaded-file"
  }, [_c('i', {
    staticClass: "file icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.uploadedFile.name))]), _vm._v(" "), _c('button', {
    staticClass: "remove-file",
    on: {
      "click": _vm.removeFile
    }
  }, [_c('i', {
    staticClass: "times icon"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-login-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sk-google-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.continueWithGoogle
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 48 48",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFC107",
      "d": "M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FF3D00",
      "d": "M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#4CAF50",
      "d": "M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#1976D2",
      "d": "M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"
    }
  })]), _vm._v("\n        Continue with Google\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "sk-google-hint"
  }, [_vm._v("Signed up with Google? Use Continue with Google, or "), _c('router-link', {
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v("reset your password")]), _vm._v(".")], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-or"
  }, [_vm._v("or log in with email")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "sk-input",
    attrs: {
      "type": "email",
      "placeholder": "you@company.com",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-row sk-mt-4"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-password-wrap"
  }, [((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "sk-input",
    attrs: {
      "placeholder": "Enter your password",
      "required": "",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sk-toggle-pw",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-opts sk-mt-4"
  }, [_c('router-link', {
    staticClass: "sk-forgot-link",
    attrs: {
      "to": "/forgotpassword"
    }
  }, [_vm._v("Forgot password?")])], 1), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-4",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.working
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v("Log In →")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Don't have an account? "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign up free")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Log in to your account")]), _vm._v(" "), _c('p', [_vm._v("Welcome back. Enter your credentials to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Password "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seller.region))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "ui input focus",
    attrs: {
      "required": "true",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.authToken))]), _vm._v(" "), (_vm.showAdvertisementApiSettings) ? _c('td', [(_vm.seller.connectedToAdvertisementApi) ? _c('center', [_c('i', {
    staticClass: "check circle outline icon"
  })]) : _c('center', [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Authorize SentryKit to access Advertisement data"
    },
    on: {
      "click": _vm.redirectToAdvertisementAuthPage
    }
  }, [_c('i', {
    staticClass: "plug icon"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.anyAccountMayNeedReAuthorization) ? _c('td', {
    staticClass: "one wide"
  }, [_c('div', {
    attrs: {
      "data-tooltip": "May Need Re-Authorization"
    }
  }, [(_vm.seller.mayNeedReauthorization) ? _c('i', {
    staticClass: "exclamation triangle icon"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "one wide"
  }, [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Re-Authorize"
    },
    on: {
      "click": function($event) {
        return _vm.reauthorize()
      }
    }
  }, [_c('i', {
    staticClass: "linkify icon"
  })])]), _vm._v(" "), (_vm.isOwner) ? _c('td', {
    staticClass: "one wide"
  }, [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Delete Account"
    },
    on: {
      "click": function($event) {
        return _vm.requestDeleteAccount()
      }
    }
  }, [_c('i', {
    staticClass: "trash alternate outline icon"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui middle aligned grid",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "id": "anonbg"
    }
  }, [_c('div', {
    staticClass: "mt4 column"
  }, [_vm._m(0), _vm._v(" "), _c('center', [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Thank you for continuing your subscription."), _c('br'), _vm._v("\n              We appreciate being able to service your account."), _c('br'), _vm._v(" "), (_vm.$root.newPricingMessage !== '') ? _c('div', [_vm._v("\n                This confirms that you " + _vm._s(_vm.$root.newPricingMessage)), _c('br'), _c('br')]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "ui right labeled icon large button setupStep",
    staticStyle: {
      "margin": "auto",
      "display": "block"
    },
    on: {
      "click": _vm.nextButtonPress
    }
  }, [_c('i', {
    staticClass: "right arrow icon"
  }), _vm._v("\n              link to account settings to view subscription\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Check out our most recent blogs if they can provide any help for your Amazon business!\n              "), _c('hr', {
    staticClass: "solid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid container",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "ui stackable doubling three cards"
  }, [_c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/streamline-product-issue-management-how-an-integrated-issue-tracker-simplifies-amazon-asin-management",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Streamline Product Issue Management: How an Integrated Issue Tracker Simplifies Amazon ASIN Management\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Amazon ASINs, or Amazon Standard Identification Numbers, are unique alphanumeric codes assigned to each product listed on the Amazon marketplace. Learn More Here!\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/elevate-your-inventory-management-game-a-glance-at-your-total-and-sellable-stock",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(87)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Elevate Your Inventory Management Game: A Glance at Your Total and Sellable Stock\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Inventory management is the backbone of a successful e-commerce business, and keeping a close eye on your stock levels is crucial.\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/the-ultimate-guide-to-mastering-amazon-ppc-advertising-boost-your-sales-with-effective-search-engine-marketing-strategies",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      The Ultimate Guide to Mastering Amazon PPC Advertising: Boost Your Sales with Effective Search Engine Marketing Strategies\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      In this ultimate guide, we will delve into the world of Amazon PPC advertising and equip you with the knowledge and techniques needed to master this powerful marketing tool.\n                    ")])])])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center"
  }, [_c('img', {
    staticStyle: {
      "width": "350px",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": __webpack_require__(47)
    }
  })])
}]}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-anon-wrapper"
  }, [_c('div', {
    staticClass: "devNote"
  }, [_vm._v("v_3.4.2")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings-section"
  }, [_vm._m(0), _vm._v(" "), _c('StatisticsCards', {
    attrs: {
      "statistics": _vm.statistics
    }
  }), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "1",
      "title": "Download your product list",
      "description": "Get a CSV with all your products. Fill in the COGS and Other Costs columns."
    }
  }, [_c('button', {
    staticClass: "download-button",
    attrs: {
      "disabled": _vm.downloading
    },
    on: {
      "click": function($event) {
        return _vm.$emit('download-template')
      }
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n      Download CSV Template\n    ")]), _vm._v(" "), _c('CSVExample')], 1), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "2",
      "title": "Fill in your costs",
      "description": "Open in Excel or Google Sheets. Enter COGS (required) and Other Costs (optional - shipping, prep, etc.)"
    }
  }), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "3",
      "title": "Upload completed file",
      "description": "Drag and drop your file or click to browse."
    }
  }, [_c('FileUploadArea', {
    attrs: {
      "uploading": _vm.uploading
    },
    on: {
      "file-selected": function($event) {
        return _vm.$emit('file-selected', $event)
      },
      "file-removed": function($event) {
        return _vm.$emit('file-removed')
      },
      "error": function($event) {
        return _vm.$emit('error', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Bulk Import Product Costs")]), _vm._v(" "), _c('span', {
    staticClass: "optional-badge"
  }, [_vm._v("OPTIONAL")])])
}]}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-welcome-page"
  }, [(_vm.$root.userEmail) ? _c('div', {
    staticClass: "sk-welcome-user"
  }, [_c('span', {
    staticClass: "sk-user-initials"
  }, [_vm._v(_vm._s(_vm.userInitials))]), _vm._v(" "), _c('span', {
    staticClass: "sk-user-email"
  }, [_vm._v(_vm._s(_vm.$root.userEmail))]), _vm._v(" "), _c('button', {
    staticClass: "sk-welcome-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-welcome-main"
  }, [_c('div', {
    staticClass: "sk-welcome-card"
  }, [(_vm.effectivelyComplete) ? _c('div', {
    staticClass: "sk-sync-complete-banner"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#16a34a",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Sync complete")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.syncCompleteSubtext))])])]) : _c('div', {
    staticClass: "sk-welcome-header"
  }, [_c('h1', [_vm._v("Setting up your workspace…")]), _vm._v(" "), _c('p', [_vm._v("Syncing your Amazon catalog and setting up real-time Buy Box monitoring. Takes 2–5 minutes for most accounts.")])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-checklist"
  }, _vm._l((_vm.derivedSteps), function(step, i) {
    return _c('div', {
      key: step.id,
      staticClass: "sk-check-item",
      class: {
        done: step.completed
      }
    }, [_c('div', {
      staticClass: "sk-check-icon"
    }, [(step.completed) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 20 20",
        "fill": "#16a34a"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
        "clip-rule": "evenodd"
      }
    })]) : (step.inProgress) ? _c('div', {
      staticClass: "sk-check-spinner-wrap"
    }, [_c('div', {
      staticClass: "sk-check-spinner"
    })]) : _c('div', {
      staticClass: "sk-check-pending"
    })]), _vm._v(" "), (i < _vm.derivedSteps.length - 1) ? _c('div', {
      staticClass: "sk-check-line"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sk-check-label"
    }, [_vm._v(_vm._s(step.completed ? step.completedLabel : step.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-bar-wrap"
  }, [_c('span', {
    staticClass: "sk-progress-left"
  }, [_vm._v(_vm._s(_vm.effectivelyComplete ? 'All done' : 'Sync in progress'))]), _vm._v(" "), _c('span', {
    staticClass: "sk-progress-right",
    class: {
      done: _vm.effectivelyComplete
    }
  }, [_vm._v(_vm._s(_vm.progressPercent) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-bar"
  }, [_c('div', {
    staticClass: "sk-progress-fill",
    class: {
      done: _vm.effectivelyComplete
    },
    style: ({
      width: _vm.progressPercent + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-label"
  }, [_vm._v(_vm._s(_vm.completedSteps) + " of " + _vm._s(_vm.totalSteps) + " steps complete")]), _vm._v(" "), (_vm.effectivelyComplete) ? _c('button', {
    staticClass: "sk-btn sk-btn-done",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]), _vm._v("\n        Your dashboard is ready — Go to Dashboard\n      ")]) : _c('button', {
    staticClass: "sk-btn sk-btn-progress",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]), _vm._v("\n        Go to Dashboard\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "sk-footer-text"
  }, [_vm._v(_vm._s(_vm.effectivelyComplete ? "From tomorrow, you'll land directly on your dashboard." : 'Sync continues in the background. Your dashboard will update automatically as data comes in.'))]), _vm._v(" "), _c('p', {
    staticClass: "sk-footer-text sk-regions-hint"
  }, [_vm._v("Selling in more regions? Add them from "), _c('router-link', {
    attrs: {
      "to": "/settings/sellers"
    }
  }, [_vm._v("Settings → Sellers")]), _vm._v(".")], 1), _vm._v(" "), (!_vm.effectivelyComplete) ? _c('p', {
    staticClass: "sk-skip-row"
  }, [_c('button', {
    staticClass: "sk-skip-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.skipConnectForNow
    }
  }, [_vm._v("\n          Skip for now — connect Amazon later\n        ")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amazon-region-connect"
  }, [(_vm.showNickname) ? _c('div', {
    staticClass: "sk-field sk-seller-nickname"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accName),
      expression: "accName"
    }],
    attrs: {
      "id": "seller-account-nickname",
      "type": "text",
      "placeholder": "e.g. US main account",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.accName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accName = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showPricingMessage && _vm.$root.newPricingMessage) ? _c('p', {
    staticClass: "sk-pricing-note"
  }, [_vm._v("\n    Introducing New Daily ASIN tracking! "), _c('strong', [_vm._v(_vm._s(_vm.$root.newPricingMessage))])]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), (_vm.showIntro) ? _c('div', {
    staticClass: "sk-connect-intro"
  }, [_c('h3', [_vm._v("How it works")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-grid"
  }, [_c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'NA'
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Americas marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('NA', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "NA",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Americas marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('NA', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('NA', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('NA', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.naMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('NA', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "NA",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('NA', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('NA', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('NA', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('NA')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('NA')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('NA', _vm.selectedMarketplaceNa)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'NA' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'EU'
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Europe marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('EU', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "EU",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Europe marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('EU', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('EU', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('EU', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.euMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('EU', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "EU",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('EU', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('EU', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('EU', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('EU')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('EU')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('EU', _vm.selectedMarketplaceEu)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'EU' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'ME'
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Middle East marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('ME', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "ME",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Middle East marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('ME', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('ME', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('ME', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.meMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('ME', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "ME",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('ME', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('ME', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('ME', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('ME')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('ME')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('ME', _vm.selectedMarketplaceMe)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'ME' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'IN'
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips sk-mkt-chips--solo",
    attrs: {
      "role": "group",
      "aria-label": "India marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('IN', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "IN",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "India marketplace",
      "aria-pressed": _vm.isMarketplaceSelected('IN', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "sk-mkt-chip",
    class: {
      'is-selected': _vm.isMarketplaceSelected('IN', _vm.inMarketplaces[0].marketplaceId)
    },
    attrs: {
      "type": "button",
      "data-region": "IN",
      "data-marketplace-id": _vm.inMarketplaces[0].marketplaceId,
      "title": "India",
      "aria-pressed": _vm.isMarketplaceSelected('IN', _vm.inMarketplaces[0].marketplaceId) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.inMarketplaces[0].marketplaceId)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.inMarketplaces[0].marketplaceId)
      }
    }
  }, [_vm._v("\n          IN\n        ")])]), _vm._v(" "), (_vm.selectedMarketplaceLabel('IN')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('IN')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions sk-region-card-actions--tight"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('IN', _vm.selectedMarketplaceIn)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'IN' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'FE'
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Asia Pacific marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('FE', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "FE",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Asia Pacific marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('FE', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('FE', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('FE', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.feMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('FE', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "FE",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('FE', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('FE', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('FE', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('FE')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('FE')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('FE', _vm.selectedMarketplaceFe)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'FE' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "seller-account-nickname"
    }
  }, [_vm._v("Storefront nickname "), _c('span', {
    staticClass: "sk-optional"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pick a marketplace (or "), _c('strong', [_vm._v("All")]), _vm._v(" for every country in that region), then authorize. Amazon opens a secure page; once you approve, SentryKit loads your store and ASINs automatically.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌎")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Americas")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("US, Canada, Mexico, Brazil")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🇪🇺")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("UK, Germany, France, Spain, Italy, Netherlands, Belgium, Sweden, Poland, South Africa")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌐")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Middle East")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("UAE, Saudi Arabia, Egypt, Turkey")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🇮🇳")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("India")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("Amazon.in")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌏")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Asia Pacific")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("Japan, Australia, Singapore")])])])
}]}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui middle aligned grid",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "id": "anonbg"
    }
  }, [_c('div', {
    staticClass: "mt4 column"
  }, [_vm._m(0), _vm._v(" "), _c('center', [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              We're sad to see you go."), _c('br'), _vm._v("\n              Your subscription will no longer auto-renew."), _c('br'), _vm._v(" "), _vm._v("\n              Thank you for being a valued SentryKit customer and we hope to see you again."), _c('br'), _vm._v("\n              In order to help us improve our service, we'd appreciate your feedback with a short survey,"), _c('br'), _vm._v("\n              following this message.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Check out our most recent blogs if they can provide any help for your Amazon business!\n              "), _c('hr', {
    staticClass: "solid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid container",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "ui stackable doubling three cards"
  }, [_c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/streamline-product-issue-management-how-an-integrated-issue-tracker-simplifies-amazon-asin-management",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Streamline Product Issue Management: How an Integrated Issue Tracker Simplifies Amazon ASIN Management\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Amazon ASINs, or Amazon Standard Identification Numbers, are unique alphanumeric codes assigned to each product listed on the Amazon marketplace. Learn More Here!\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/elevate-your-inventory-management-game-a-glance-at-your-total-and-sellable-stock",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(87)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Elevate Your Inventory Management Game: A Glance at Your Total and Sellable Stock\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Inventory management is the backbone of a successful e-commerce business, and keeping a close eye on your stock levels is crucial.\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/the-ultimate-guide-to-mastering-amazon-ppc-advertising-boost-your-sales-with-effective-search-engine-marketing-strategies",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(88)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      The Ultimate Guide to Mastering Amazon PPC Advertising: Boost Your Sales with Effective Search Engine Marketing Strategies\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      In this ultimate guide, we will delve into the world of Amazon PPC advertising and equip you with the knowledge and techniques needed to master this powerful marketing tool.\n                    ")])])])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center"
  }, [_c('img', {
    staticStyle: {
      "width": "350px",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": __webpack_require__(47)
    }
  })])
}]}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-costs-page",
    class: {
      'pricing-costs-page--settings': _vm.inSettingsHub
    },
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.inSettingsHub ? 'Bulk COGS & Margins' : 'Pricing & Costs'))]), _vm._v(" "), (!_vm.inSettingsHub) ? _c('button', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v(" Back\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('DefaultMarginTargetSection', {
    attrs: {
      "settings": _vm.settings,
      "formula-description": _vm.formulaDescription,
      "formula-example": _vm.formulaExample
    },
    on: {
      "margin-change": _vm.onMarginChange,
      "toggle-change": _vm.onToggleChange
    }
  }), _vm._v(" "), _c('BulkImportSection', {
    attrs: {
      "statistics": _vm.statistics,
      "downloading": _vm.downloading,
      "uploading": _vm.uploading
    },
    on: {
      "download-template": _vm.downloadCSVTemplate,
      "file-selected": _vm.handleFileSelected,
      "file-removed": _vm.handleFileRemoved,
      "error": _vm.handleError
    }
  }), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.successMessage = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.successMessage))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.errorMessage = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('button', {
    staticClass: "cancel-button",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "save-button",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n      Save Changes\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-volume-thresholds-inline"
  }, [_c('div', {
    staticClass: "sv-inline-title"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v(" "), _c('span', [_vm._v("Adjust Threshold — " + _vm._s(_vm.productTitle) + " · " + _vm._s(_vm.marketplaceLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "sv-inline-fields"
  }, [_c('div', {
    staticClass: "sv-inline-field"
  }, [_c('label', [_vm._v("No-sales alert after")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.noSalesHours),
      expression: "form.noSalesHours",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "sv-inline-input",
    class: {
      'has-value': _vm.form.noSalesHours != null && _vm.form.noSalesHours !== ''
    },
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "72",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.noSalesHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "noSalesHours", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sv-field-unit"
  }, [_vm._v("hours")])]), _vm._v(" "), _c('div', {
    staticClass: "sv-inline-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sv-inline-field"
  }, [_c('label', [_vm._v("Drop alert")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.rollingDrop),
      expression: "form.rollingDrop",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "sv-inline-input",
    class: {
      'has-value': _vm.form.rollingDrop != null && _vm.form.rollingDrop !== ''
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.rollingDrop)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rollingDrop", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sv-field-unit"
  }, [_vm._v("% vs avg")])]), _vm._v(" "), _c('div', {
    staticClass: "sv-inline-field"
  }, [_c('label', [_vm._v("Avg over")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.rollingDays),
      expression: "form.rollingDays",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "sv-inline-input",
    class: {
      'has-value': _vm.form.rollingDays != null && _vm.form.rollingDays !== ''
    },
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "14",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.rollingDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rollingDays", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sv-field-unit"
  }, [_vm._v("days")])])]), _vm._v(" "), _c('div', {
    staticClass: "sv-inline-actions"
  }, [_c('button', {
    staticClass: "sv-inline-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.resolvedProductId
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "sv-inline-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "sv-inline-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "sv-inline-loading"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Saving…")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sv-inline-note"
  }, [_vm._v("Or configure all products via "), _c('strong', [_vm._v("Configure Thresholds")]), _vm._v(" above.")])
}]}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card ownership-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_c('span', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.data.percentage))]), _vm._v(" "), _c('span', {
    staticClass: "percentage-symbol"
  }, [_vm._v("%")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-description"
  }, [_vm._v("\n    You hold the Buy Box on "), _c('strong', [_vm._v(_vm._s(_vm.data.owned) + " of " + _vm._s(_vm.data.total))]), _vm._v(" tracked products.\n  ")]), _vm._v(" "), (_vm.data.trendText) ? _c('div', {
    staticClass: "stat-trend"
  }, [_c('span', {
    staticClass: "trend-badge",
    class: {
      negative: _vm.data.trend < 0,
      positive: _vm.data.trend > 0
    }
  }, [(_vm.data.trend < 0) ? _c('i', {
    staticClass: "chart line icon"
  }) : (_vm.data.trend > 0) ? _c('i', {
    staticClass: "chart line icon"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.data.trendText) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-header"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("BUY BOX OWNERSHIP")]), _vm._v(" "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Buy Box ownership percentage across tracked products"
    }
  })])
}]}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.showProductDetails()
      }
    }
  }, [(_vm.wdtype == 'lostBuybox' && _vm.item.statusDetails && _vm.item.statusDetails.message && _vm.item.statusDetails.message.indexOf('no offers from any sellers') >= 0) ? _c('i', {
    class: 'right grey warning circle big icon'
  }) : _c('i', {
    class: 'right ' + (_vm.item.issueStatus > 0 && (_vm.item.status == 1 || _vm.item.status == 2) ? 'blue' : _vm.itemprops.listcolor[_vm.item.status]) + ' ' + _vm.itemprops.listicon + ' big icon'
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.date !== null),
      expression: "item.date !== null"
    }],
    staticClass: "ui basic top right attached label"
  }, [_vm._v("\n    " + _vm._s((new Date(_vm.item.date)).toLocaleDateString('en-US')) + "\n    "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n      " + _vm._s((new Date(_vm.item.date)).toLocaleTimeString('en-US')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.detSel == 'wd' && _vm.item.productId !== null && _vm.imageLoaded) ? _c('img', {
    staticClass: "left floated small ui image",
    staticStyle: {
      "max-width": "110px",
      "max-height": "110px",
      "width": "auto",
      "height": "auto",
      "border-radius": "2px"
    },
    attrs: {
      "src": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].largeImageUrl
    }
  }) : (_vm.detSel == 'wd' && _vm.item.productId !== null) ? _c('div', {
    staticClass: "left floated small ui image",
    staticStyle: {
      "width": "110px",
      "height": "110px",
      "background": "#f5f5f5",
      "border-radius": "2px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('i', {
    staticClass: "grey image icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.item.productId !== null || _vm.item.productGroupId !== null || _vm.item.marketplace !== null) ? _c('div', {
    staticClass: "ui left floated basic segment description",
    staticStyle: {
      "width": "19%",
      "max-height": "113px",
      "padding": "0",
      "margin": "0",
      "overflow": "hidden",
      "text-overflow": "clip"
    }
  }, [(_vm.item.productId !== null || _vm.item.productGroupId !== null) ? _c('span', [_c('i', {
    class: _vm.getMarketplaceFlag(_vm.item)
  }), _vm._v(" "), (_vm.groupByParent && _vm.item.productGroupProductIds && _vm.item.productGroupProductIds.length > 1) ? _c('span', {
    staticClass: "ui mini circular grey label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    },
    attrs: {
      "data-content": _vm.item.productGroupProductIds.length + ' variations in this group',
      "data-position": "top left",
      "data-variation": "mini"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.productGroupProductIds.length) + "\n        ")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getProductTitle(_vm.item.productId)) + "\n      ")]) : (_vm.item.marketplace && _vm.item.sellerId && _vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId]) ? _c('div', {
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId].accountNickName) + " - " + _vm._s(_vm.item.marketplace) + " marketplace")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui right floated basic segment header",
    style: ('width:' + (_vm.item.productId !== null ? '58' : '80') + '%; padding:0; margin:0; font-size:16px;')
  }, [(_vm.wdtype == 'salesDrop') ? _c('img', {
    staticClass: "right floated small ui image",
    attrs: {
      "src": '/api/sentinel/watchdog/salesdropchart/' + _vm.item.watchDogId
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId], null)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [(_vm.item.muted) ? _c('i', {
    staticClass: "blue mute alarm outline icon"
  }) : _vm._e()]), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('span', [(_vm.item.issueStatus == 1) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue unhide icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("Seen")]) : (_vm.item.issueStatus == 2) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue time  icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("In Progress")]) : (_vm.item.issueStatus == 3) ? _c('span', {
    staticClass: "ui tiny circular blue label",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "ui inverted blue check icon",
    staticStyle: {
      "margin-right": "3px"
    }
  }), _vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.wdtype == 'badReview' || _vm.wdtype == 'topReview') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prettyfyReviewText(_vm.item.statusDetails.message))
    }
  }) : (_vm.wdtype == 'starRatingRecentChange') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prettyfyRatingText(_vm.item.statusDetails.message))
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.item.statusDetails.message)
    }
  }), _vm._v(" "), (_vm.wdtype != 'listingSuspended') ? _c('div', {
    staticClass: "description issueStatusButton",
    staticStyle: {
      "margin-top": "35px",
      "position": "relative"
    }
  }, [(_vm.item.productId !== null && _vm.wdtype != 'badReview' && _vm.wdtype != 'topReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("View on Amazon")]) : (_vm.item.productId !== null && _vm.wdtype == 'badReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productReviewsUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("Latest Reviews")]) : (_vm.item.productId !== null && _vm.wdtype == 'topReview') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.products[_vm.item.productId].productTopReviewsUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v(" Top Rated Reviews")]) : (_vm.wdtype == 'badSellerFeedback') ? _c('a', {
    staticClass: "ui tiny orange basic compact icon button",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.$parent.$parent.$parent.worldStore.sellerAccounts[_vm.item.sellerId].feedbackUrls[_vm.item.marketplace]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "icon external share"
  }), _vm._v("View on Amazon")]) : _vm._e(), _vm._v(" "), _c('span'), _vm._v("\n          \n\n        "), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('span', {
    staticClass: "issueStatusButton",
    staticStyle: {
      "position": "absolute",
      "top": "-20px",
      "font-size": "11px"
    }
  }, [_c('i', {
    staticClass: "grey book icon",
    staticStyle: {
      "margin-right": "1px"
    }
  }), _vm._v("Issue Status\n          ")]) : _vm._e(), _vm._v(" "), ((_vm.item.status === 1 || _vm.item.status === 2) && !_vm.item.muted) ? _c('div', {
    staticClass: "ui tiny basic blue compact buttons issueStatusButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [(_vm.item.issueStatus == 0) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(1)
      }
    }
  }, [_vm._v("Mark as Seen")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 1) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(2)
      }
    }
  }, [_vm._v("Mark as In Progress")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 2) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(3)
      }
    }
  }, [_vm._v("Mark as Done")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus == 3) ? _c('div', {
    staticClass: "ui disabled button"
  }, [_vm._v("Mark as ➔")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui top right pointing dropdown icon button"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "small menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_vm._v("Mark issue as ...")]), _vm._v(" "), (_vm.item.issueStatus != 0) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(0)
      }
    }
  }, [_c('i', {
    staticClass: "hide icon"
  }), _vm._v(" New")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 1) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(1)
      }
    }
  }, [_c('i', {
    staticClass: "unhide icon"
  }), _vm._v(" Seen")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 2) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(2)
      }
    }
  }, [_c('i', {
    staticClass: "time icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.item.issueStatus != 3) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.setIssueStatus(3)
      }
    }
  }, [_c('i', {
    staticClass: "check icon"
  }), _vm._v(" Done")]) : _vm._e()])])]) : _vm._e(), _vm._v("\n          \n\n        "), _vm._v(" "), (!_vm.item.muted) ? _c('div', {
    staticClass: "ui tiny basic compact button issueStatusButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui top right pointing dropdown"
  }, [_c('span', {
    attrs: {
      "data-html": 'Mute this alert type' + (_vm.$parent.accountLevelWd ? '' : ('<br>for this product ' + (_vm.groupByParent && _vm.item.productGroupProductIds && _vm.item.productGroupProductIds.length > 1 ? 'and variations' : ''))),
      "data-variation": "mini",
      "data-position": "right center"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$parent.accountLevelWd ? 'Mute' : 'Mute Product...') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "small menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_vm._v("Mute for ...")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24)
      }
    }
  }, [_vm._v("24h")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 3)
      }
    }
  }, [_vm._v("3 days")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 7)
      }
    }
  }, [_vm._v("1 week")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 14)
      }
    }
  }, [_vm._v("2 weeks")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 30)
      }
    }
  }, [_vm._v("1 month")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 61)
      }
    }
  }, [_vm._v("2 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.muteItem(60 * 24 * 999)
      }
    }
  }, [_vm._v("Until I turn it back on")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.muted) ? _c('a', {
    staticClass: "ui tiny basic label",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.muteItem(-1)
      }
    }
  }, [_vm._v("Un-mute")]) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.$parent.onboarding.issuestatus && _vm.itemtype === 'red') ? _c('div', {
    staticClass: "onboarding ui up pointing large yellow label",
    staticStyle: {
      "margin": "10px 0 0 40px"
    },
    attrs: {
      "data-onboarding": "issuestatus"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n          Mark as Seen - This is very useful!"), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("Click [Mark as Seen] to dismiss these notes")])]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-cont"
  }, [_c('h1', {
    staticClass: "white text"
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui inverted small statistics",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "red inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("unchecked")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.stats.alerts) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n       Alerts\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "orange inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("unchecked")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.stats.warnings) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      Warnings\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "purple inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("in")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.stats.productsWithIssues) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      Products\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "green inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Of")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.stats.totalProducts) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      total\n    ")])])]), _vm._v(" "), (_vm.$root.authCompleted && _vm.$parent.$parent.onboarding.syncing && _vm.$root.secondsSinceFirstSellerAccountCreated < 9999) ? _c('div', {
    staticClass: "ui icon message",
    staticStyle: {
      "text-shadow": "none"
    },
    attrs: {
      "data-onboarding": "syncing"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.$parent.onboarder('syncing')
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.emailConfirmReminder.length > 0) ? _c('div', {
    staticClass: "ui icon message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('i', {
    staticClass: "mail outline icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Check your inbox and confirm\n      "), _vm._l((_vm.emailConfirmReminder), function(email, index) {
    return _c('strong', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > 0),
        expression: "index>0"
      }]
    }, [_vm._v(",")]), _vm._v(" " + _vm._s(email))])
  }), _vm._v(".\n      "), _c('br'), _vm._v(" "), _c('small', [_vm._v("It is also a good idea to whilelist @SentryKit.com e-mail addresses.")])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 402) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is unfortunately suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("We really tried but couldn't charge you for the current running month.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" and get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 99402) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is currently suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("Sorry, but after multiple attempts we still couldn't charge you for the current month.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" then get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 403) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is currently suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("Sorry, it seems your payment plan has been cancelled.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" then get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 3) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Payment Failed\n  ")]), _vm._v(" "), _c('p', [_vm._v("Your payment for this running month of your SentryKit subscription failed.")]), _vm._v(" "), _c('p', [_vm._v("No worries, we get it that this can happen. We left everything running for you but you are now running on credit.")]), _vm._v(" "), _c('p', [_vm._v("Please add or change the payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to continue using the service distruption free.")], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n      Hi there and welcome! Things are still syncing up, but you can already get started.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In a few hours all modules will be fully on-line.\n    ")])])
}]}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "sbs-loading"
  }, [_c('div', {
    staticClass: "sbs-spinner"
  })]) : (_vm.loadError) ? _c('div', {
    staticClass: "sbs-error"
  }, [_c('p', {
    staticClass: "sbs-error-title"
  }, [_vm._v("Could not load billing")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-btn sbs-btn-outline",
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _c('div', {
    staticClass: "sbs-inner"
  }, [_c('header', {
    staticClass: "sbs-header"
  }, [_c('h1', {
    staticClass: "sbs-title"
  }, [_vm._v("Subscription & Billing")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-subtitle"
  }, [_vm._v(_vm._s(_vm.billingPageSubtitle))])]), _vm._v(" "), _c('nav', {
    staticClass: "sbs-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'plans'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'plans'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'plans'
      }
    }
  }, [_vm._v("Pricing & Plans")]), _vm._v(" "), (_vm.showUsageTab) ? _c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'usage'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'usage'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'usage'
      }
    }
  }, [_vm._v("Usage")]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'history'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'history'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'history'
      }
    }
  }, [_vm._v("Billing History")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'plans'),
      expression: "activeTab === 'plans'"
    }],
    staticClass: "sbs-panel"
  }, [(_vm.billingVariant === 'new') ? [(_vm.isPaymentPastDue) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Update your payment method below to restore billing and keep your alerts running. Your plan and data are unchanged.")])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-btn sbs-btn-upgrade sbs-past-due-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scrollToPaymentMethod
    }
  }, [_vm._v("Update payment method →")]) : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Ask your account admin to update the payment method on file.")])]) : (_vm.isTrialBillingExpired) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v("Trial completed")]), _vm._v(" "), _c('span', [_vm._v("Ended " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stats"
  }, [_c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("During your trial")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Changes caught")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.orderVolumeChangesCaughtDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("In the last 7 days")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v(_vm._s(_vm.trialPlanChosen ? 'Your plan' : 'Recommended plan'))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.trialPlanChosen ? _vm.planAfterTrialLabel : 'Pro'))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v(_vm._s(_vm.canManageBilling ? (_vm.trialPlanChosen ? 'Add a payment method to resume' : 'Pick a plan below to resume') : 'Ask your admin to choose a plan'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Your alerts are paused. Pick a plan below to resume tracking — your data is safe.' : 'Your alerts are paused. Ask your account admin to choose a plan — your data is safe.'))])])]) : (_vm.isTrialBillingActive) ? _c('div', {
    staticClass: "sbs-trial-block"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })])]), _vm._v(" "), _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("You're on a free " + _vm._s(_vm.trialLengthDays) + "-day trial")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v(_vm._s(_vm.trialDaysRemainingDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.trialDayOfDisplay))]), _vm._v(" "), _c('span', [_vm._v("Trial ends " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    style: ({
      width: _vm.trialProgressWidth
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stats"
  }, [_c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Changes caught")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.orderVolumeChangesCaughtDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("In the last 7 days")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Plan after trial")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.planAfterTrialLabel))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v(_vm._s(_vm.planAfterTrialSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Track as many orders as you need during your trial. Pick a plan below — you can change it any time before your trial ends.' : 'Track as many orders as you need during your trial. Your admin manages plan selection for this account.'))])])]) : _c('div', {
    staticClass: "sbs-current-plan"
  }, [_c('div', {
    staticClass: "sbs-current-icon"
  }, [_c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2L3 14h8l-1 8 10-12h-8l1-8z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-current-main"
  }, [_c('span', {
    staticClass: "sbs-current-name"
  }, [_vm._v(_vm._s(_vm.currentPlanTitle))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-current-meta"
  }, [_vm._v(_vm._s(_vm.currentPlanSubtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-current-next"
  }, [_c('span', {
    staticClass: "sbs-current-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-current-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), (_vm.canManageBilling && !_vm.isFlatYearlyPlan) ? [_c('h2', {
    staticClass: "sbs-section-heading"
  }, [_vm._v(_vm._s(_vm.planSectionHeading))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plans-help"
  }, [_vm._v(_vm._s(_vm.planSectionHelp))]), _vm._v(" "), _c('div', {
    class: ['sbs-plan-cards', {
      'sbs-plan-cards-3': _vm.showProAnnualCard
    }]
  }, [_c('div', {
    class: _vm.planCardClasses('starter')
  }, [(_vm.planCard('starter').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('starter').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('starter').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("For brands on 1–2 storefronts")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("2 storefronts included")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('starter'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('starter').disabled,
      "title": _vm.planCard('starter').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('starter')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('starter').label))]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sbs-plan-footnote"
  }, [_vm._v("Need more storefronts? Pro scales with you.")])]), _vm._v(" "), _c('div', {
    class: _vm.planCardClasses('pro')
  }, [(_vm.planCard('pro').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('pro').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('pro').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("Scales with your storefronts")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("5 storefronts included")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('pro'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('pro').disabled,
      "title": _vm.planCard('pro').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('pro')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('pro').label))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-plus-label"
  }, [_vm._v("EVERYTHING IN STARTER, PLUS")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-counter"
  }, [_c('div', {
    staticClass: "sbs-sf-counter-q"
  }, [_vm._v("How many storefronts do you manage?")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-counter-row"
  }, [_c('button', {
    staticClass: "sbs-sf-step",
    attrs: {
      "type": "button",
      "aria-label": "Fewer storefronts",
      "disabled": _vm.proStorefrontCount <= 1
    },
    on: {
      "click": function($event) {
        _vm.proStorefrontCount = Math.max(1, _vm.proStorefrontCount - 1)
      }
    }
  }, [_vm._v("−")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-sf-count"
  }, [_vm._v(_vm._s(_vm.proStorefrontCount))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-sf-step",
    attrs: {
      "type": "button",
      "aria-label": "More storefronts",
      "disabled": _vm.proStorefrontCount >= 120
    },
    on: {
      "click": function($event) {
        _vm.proStorefrontCount = Math.min(120, _vm.proStorefrontCount + 1)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-hint"
  }, [_vm._v(_vm._s(_vm.proStorefrontHint))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-total-box"
  }, [_c('span', {
    staticClass: "sbs-sf-total-label"
  }, [_vm._v("Your Pro plan")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-sf-total-price"
  }, [_vm._v("$" + _vm._s(_vm.proStorefrontTotalPrice)), _c('span', {
    staticClass: "sbs-sf-total-period"
  }, [_vm._v(" /month")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-save"
  }, [_vm._v("↓ Every storefront you add costs less than the last")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-sf-vol-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showVolumePricing = !_vm.showVolumePricing
      }
    }
  }, [_vm._v("\n                View volume pricing " + _vm._s(_vm.showVolumePricing ? '▴' : '▾') + "\n              ")]), _vm._v(" "), (_vm.showVolumePricing) ? _c('table', {
    staticClass: "sbs-sf-vol-table"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)]) : _vm._e()])]), _vm._v(" "), (_vm.showProAnnualCard) ? _c('div', {
    class: _vm.planCardClasses('pro_annual')
  }, [(_vm.planCard('pro_annual').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('pro_annual').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('pro_annual').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Pro Annual")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("Pro, paid once a year")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v(_vm._s(_vm.proAnnualPriceDisplay))]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("5 storefronts included · one invoice a year")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('pro_annual'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('pro_annual').disabled,
      "title": _vm.planCard('pro_annual').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('pro_annual')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('pro_annual').label))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-plus-label"
  }, [_vm._v("EVERYTHING IN PRO, PLUS")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "sbs-plan-footnote"
  }, [_vm._v(_vm._s(_vm.proAnnualFootnote))])]) : _vm._e()])] : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Plan changes are managed by your account admin.")]), _vm._v(" "), (!_vm.canManageBilling) ? _c('div', {
    staticClass: "sbs-your-plan-stats sbs-member-billing-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Orders this month")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.orderVolumeOrdersThisMonthDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.orderVolumeOrdersCompareLine))])])]) : _vm._e()] : (_vm.billingVariant === 'legacy') ? [_c('div', {
    staticClass: "sbs-your-plan-card"
  }, [_c('span', {
    staticClass: "sbs-your-plan-badge"
  }, [_vm._v("Your plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-head"
  }, [_c('div', {
    staticClass: "sbs-your-plan-head-main"
  }, [_c('h2', {
    staticClass: "sbs-your-plan-title"
  }, [_vm._v(_vm._s(_vm.legacyPlanTitle))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-desc"
  }, [_vm._v(_vm._s(_vm.legacyPricingLine))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-next"
  }, [_c('span', {
    staticClass: "sbs-your-plan-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("ASINs tracked")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v("Across all marketplaces")])])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-foot"
  }, [_vm._v(_vm._s(_vm.legacyFootnote))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-email-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPlanChangeModal
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a1.99 1.99 0 00-1.997 1.884z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
    }
  })]), _vm._v("\n          Looking to change plans? Email us →\n        ")]) : _vm._e()] : [(_vm.isDailyUsageTrialExpiredNoPayment) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired sbs-daily-trial-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v("Trial completed")]), _vm._v(" "), _c('span', [_vm._v("Ended " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Add a payment method below to resume daily usage billing and keep your alerts running. Your tracked ASINs and data are unchanged.' : 'Your trial has ended and no payment method is on file. Ask your account admin to add a payment method to resume billing.'))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-btn sbs-btn-upgrade sbs-past-due-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scrollToPaymentMethod
    }
  }, [_vm._v("Add payment method →")]) : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Ask your account admin to add a payment method on file.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-card sbs-your-plan-daily"
  }, [_c('span', {
    staticClass: "sbs-your-plan-badge"
  }, [_vm._v("Your plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-head"
  }, [_c('div', {
    staticClass: "sbs-your-plan-head-main"
  }, [_c('h2', {
    staticClass: "sbs-your-plan-title"
  }, [_vm._v(_vm._s(_vm.dailyPlanTitle))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-desc"
  }, [_vm._v(_vm._s(_vm.dailyPlanSubtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-next"
  }, [_c('span', {
    staticClass: "sbs-your-plan-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Projected this month")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.projectedMonthUsesEstimate ? '~' : '') + "$" + _vm._s(_vm.projectedMonthAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.projectedMonthSubtext))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-asin-meter"
  }, [_c('span', {
    staticClass: "sbs-asin-meter-label"
  }, [_vm._v("ASINs currently tracked")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-asin-meter-value"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay) + " ASINs")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-foot"
  }, [_vm._v(_vm._s(_vm.dailyFootnote))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-email-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPlanChangeModal
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a1.99 1.99 0 00-1.997 1.884z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
    }
  })]), _vm._v("\n          Looking to change plans? Email us →\n        ")]) : _vm._e()], _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.canManageBilling && (_vm.$root.paymentStatus !== 0 || _vm.billingVariant === 'new' || _vm.isDailyUsageTrialExpiredNoPayment)) ? _c('div', {
    staticClass: "sbs-payment-method-section",
    attrs: {
      "id": "payment-method"
    }
  }, [_c('h2', {
    staticClass: "sbs-section-heading"
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-payment-method-sub"
  }, [_vm._v("Used for all SentryKit subscription charges")]), _vm._v(" "), (_vm.savedPaymentMethods.length) ? _c('div', {
    staticClass: "sbs-pm-list"
  }, _vm._l((_vm.savedPaymentMethods), function(pm, idx) {
    return _c('div', {
      key: pm.id || idx,
      class: ['sbs-pm-display', {
        'sbs-pm-ach': pm.kind === 'ach'
      }]
    }, [_c('span', {
      staticClass: "sbs-pm-brand",
      class: {
        'sbs-pm-bank': pm.kind === 'ach'
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(pm.brandShort))]), _vm._v(" "), _c('div', {
      staticClass: "sbs-pm-display-main"
    }, [_c('div', {
      staticClass: "sbs-pm-display-top"
    }, [_c('span', {
      staticClass: "sbs-pm-display-title"
    }, [_vm._v(_vm._s(pm.label))]), _vm._v(" "), _c('div', {
      staticClass: "sbs-pm-display-actions"
    }, [(pm.isDefault) ? _c('span', {
      staticClass: "sbs-pm-default-badge"
    }, [_vm._v("Default")]) : _vm._e(), _vm._v(" "), (!pm.isDefault && pm.id && _vm.savedPaymentMethods.length > 1) ? _c('button', {
      staticClass: "sbs-pm-set-default-link",
      attrs: {
        "type": "button",
        "disabled": _vm.setDefaultInProgress || _vm.detachInProgress
      },
      on: {
        "click": function($event) {
          return _vm.setPaymentMethodAsDefault(pm.id)
        }
      }
    }, [_vm._v("Set as default")]) : _vm._e(), _vm._v(" "), (pm.id) ? _c('button', {
      staticClass: "sbs-pm-remove-link",
      attrs: {
        "type": "button",
        "disabled": _vm.detachInProgress
      },
      on: {
        "click": function($event) {
          return _vm.removePaymentMethod(pm)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "sbs-pm-display-meta"
    }, [_vm._v(_vm._s(pm.metaLine))])])])
  }), 0) : (_vm.displayCardInfo) ? _c('div', {
    staticClass: "sbs-pm-display"
  }, [_c('span', {
    staticClass: "sbs-pm-brand",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.displayCardInfo.brandShort))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-display-main"
  }, [_c('div', {
    staticClass: "sbs-pm-display-top"
  }, [_c('span', {
    staticClass: "sbs-pm-display-title"
  }, [_vm._v(_vm._s(_vm.displayCardInfo.label))]), _vm._v(" "), _vm._m(16)]), _vm._v(" "), _c('span', {
    staticClass: "sbs-pm-display-meta"
  }, [_vm._v(_vm._s(_vm.displayCardInfo.metaLine))])])]) : (_vm.paymentMethod && _vm.paymentMethod.method === 'ach') ? _c('div', {
    staticClass: "sbs-pm-display sbs-pm-ach"
  }, [_c('span', {
    staticClass: "sbs-pm-brand sbs-pm-bank"
  }, [_vm._v("ACH")]), _vm._v(" "), _vm._m(17)]) : _c('div', {
    staticClass: "sbs-pm-empty"
  }, [_c('p', [_vm._v("No card or bank account on file yet.")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-actions"
  }, [_c('button', {
    staticClass: "sbs-btn sbs-btn-primary sbs-btn-with-icon",
    attrs: {
      "type": "button",
      "disabled": _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.openPrimaryPaymentUpdate
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zm-2.207 2.207L3 14v3h3l8.379-8.379-2.828-2.828z"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.primaryPaymentButtonLabel) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-btn sbs-btn-outline sbs-btn-with-icon sbs-pm-add-wrap",
    attrs: {
      "id": "sbsPaymentMethodsAdd"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n            Add new method\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid popup sbs-pay-popup",
    attrs: {
      "id": "sbsPayPopupAdd"
    }
  }, [_c('div', {
    staticClass: "ui two column center aligned very relaxed grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Card")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.stripeButtonClicked || _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openStripeWidgetFromAdd
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v("Add card\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached teal label"
  }, [_vm._v("Recommended")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("ACH transfer")]), _vm._v(" "), _c('div', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress || _vm.achAlreadyOnFile
    },
    on: {
      "click": _vm.createAchFromAdd
    }
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("Set ACH\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached label"
  }, [_vm._v("Beta")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("OR")])])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-billing-email-row"
  }, [_vm._v("\n          Billing email: "), _c('strong', [_vm._v(_vm._s(_vm.billingEmailDisplay))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-link-inline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openBillingEmailModal
    }
  }, [_vm._v("Change")])]), _vm._v(" "), (_vm.billingVariant === 'new' && _vm.showNextBillLine) ? _c('p', {
    staticClass: "sbs-next-bill"
  }, [_vm._v("Based on the current number of ASINs you are tracking, your next bill, charged to the payment method above, will be: "), _c('strong', [_vm._v("$" + _vm._s(_vm.nextBillAmount))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showResumeSubscriptionBanner) ? _c('div', {
    staticClass: "sbs-resume-banner",
    attrs: {
      "role": "region",
      "aria-label": "Resume subscription"
    }
  }, [_c('div', {
    staticClass: "sbs-resume-banner-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7L8 5z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-resume-banner-text"
  }, [_c('h3', {
    staticClass: "sbs-resume-banner-title"
  }, [_vm._v("Subscription ending soon")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-resume-banner-desc"
  }, [_vm._v(_vm._s(_vm.resumeBannerDescription))])]), _vm._v(" "), _c('button', {
    staticClass: "sbs-resume-banner-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.resumeInProgress
    },
    on: {
      "click": _vm.resumeSubscription
    }
  }, [_vm._v(_vm._s(_vm.resumeInProgress ? 'Resuming…' : 'Resume subscription'))])]) : (_vm.showCancelSubscriptionBanner) ? _c('div', {
    staticClass: "sbs-cancel-banner",
    attrs: {
      "role": "region",
      "aria-label": "Cancel subscription"
    }
  }, [_c('div', {
    staticClass: "sbs-cancel-banner-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7v6M12 16h.01",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-banner-text"
  }, [_c('h3', {
    staticClass: "sbs-cancel-banner-title"
  }, [_vm._v("Cancel subscription")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-banner-desc"
  }, [_vm._v(_vm._s(_vm.cancelBannerDescription))])]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-banner-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCancelWizard
    }
  }, [_vm._v("Cancel subscription")])]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sbs-flash sbs-flash-ok",
    attrs: {
      "role": "status"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-flash-close",
    attrs: {
      "type": "button",
      "aria-label": "Dismiss"
    },
    on: {
      "click": function($event) {
        _vm.message = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sbs-flash sbs-flash-err",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-flash-close",
    attrs: {
      "type": "button",
      "aria-label": "Dismiss"
    },
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e()], 2), _vm._v(" "), (_vm.showUsageTab) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'usage'),
      expression: "activeTab === 'usage'"
    }],
    staticClass: "sbs-panel"
  }, [(_vm.usageTabLoading) ? _c('div', {
    staticClass: "sbs-usage-loading"
  }, [_c('div', {
    staticClass: "sbs-spinner"
  })]) : (_vm.usageTabError) ? _c('div', {
    staticClass: "sbs-usage-error"
  }, [_c('p', {
    staticClass: "sbs-error-msg"
  }, [_vm._v(_vm._s(_vm.usageTabError))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-btn sbs-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadUsageTabData
    }
  }, [_vm._v("Retry")])]) : [_c('h2', {
    staticClass: "sbs-usage-title"
  }, [_vm._v("Usage")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-usage-subtitle"
  }, [_vm._v(_vm._s(_vm.usageBillingPeriodLine))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucards"
  }, [_c('div', {
    staticClass: "sbs-ucard"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Current plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageCurrentPlanName))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v(_vm._s(_vm.usagePlanPriceSubline))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard sbs-ucard-lever"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Storefronts connected")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageStorefrontsCountDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("The only thing that affects your price")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Next charge")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageNextChargeShortDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v(_vm._s(_vm.usageNextChargeSubline))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ublock"
  }, [_c('h3', {
    staticClass: "sbs-ublock-title"
  }, [_vm._v("What we're monitoring for you")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucards sbs-ucards-inner"
  }, [_c('div', {
    staticClass: "sbs-ucard sbs-ucard-muted"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageAsinsMonitoredDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("Unlimited on your plan")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard sbs-ucard-muted"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Marketplaces covered")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageMarketplacesCountDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("Unlimited on your plan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ublock"
  }, [_c('h3', {
    staticClass: "sbs-ublock-title"
  }, [_vm._v("What we caught this period")]), _vm._v(" "), (!_vm.usageCategoriesWithBars.length) ? _c('div', {
    staticClass: "sbs-usage-empty"
  }, [_vm._v("No changes recorded this period.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usageCategoriesWithBars), function(row) {
    return _c('div', {
      key: row.key || row.label,
      staticClass: "sbs-usage-bar"
    }, [_c('span', {
      staticClass: "sbs-usage-bar-name"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('span', {
      staticClass: "sbs-usage-bar-track"
    }, [_c('span', {
      staticClass: "sbs-usage-bar-fill",
      style: ({
        width: row.barWidth
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "sbs-usage-bar-num"
    }, [_vm._v(_vm._s(row.countDisplay))])])
  })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'history'),
      expression: "activeTab === 'history'"
    }],
    staticClass: "sbs-panel"
  }, [_c('div', {
    staticClass: "sbs-history-card"
  }, [_c('div', {
    staticClass: "sbs-history-head"
  }, [_c('h2', {
    staticClass: "sbs-history-title"
  }, [_vm._v("Billing History")]), _vm._v(" "), (_vm.invoices.length) ? _c('button', {
    staticClass: "sbs-link-download",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadAllInvoices
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n            Download all\n          ")]) : _vm._e()]), _vm._v(" "), (!_vm.invoices.length) ? _c('div', {
    staticClass: "sbs-empty-invoices"
  }, [_vm._v("You have no invoices yet.")]) : _c('div', {
    staticClass: "sbs-history-table-wrap"
  }, [_c('table', {
    staticClass: "sbs-history-table"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(inv, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(_vm.formatInvoiceDate(_vm.invoicePaidOn(inv))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.invoiceDescription(inv, idx)))]), _vm._v(" "), _c('td', {
      staticClass: "sbs-col-amt"
    }, [_c('strong', [_vm._v("$" + _vm._s((inv.totalAmount / 100).toFixed(2)))])]), _vm._v(" "), _vm._m(19, true), _vm._v(" "), _c('td', [(inv.url) ? _c('a', {
      staticClass: "sbs-receipt-link",
      attrs: {
        "href": inv.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("Receipt")]) : _vm._e()])])
  }), 0)])])])])]), _vm._v(" "), (_vm.cancelModalVisible) ? _c('div', {
    staticClass: "sbs-cancel-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeCancelWizardIfIdle.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sbs-cancel-sheet",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sbs-cancel-title"
    }
  }, [_c('button', {
    staticClass: "sbs-cancel-close",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting,
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCancelWizardIfIdle
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-progress",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l((4), function(n) {
    return _c('span', {
      key: n,
      class: ['sbs-cancel-progress-seg', _vm.cancelProgressSegClass(n)]
    })
  }), 0), _vm._v(" "), _c('header', {
    staticClass: "sbs-cancel-header"
  }, [_c('h2', {
    staticClass: "sbs-cancel-heading",
    attrs: {
      "id": "sbs-cancel-title"
    }
  }, [_vm._v("Are you sure you want to cancel?")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-subtitle"
  }, [_vm._v("\n          Your subscription will remain active until "), _c('strong', [_vm._v(_vm._s(_vm.cancelModalPeriodEndDisplay))]), _vm._v(".\n          You can resume anytime before then.\n        ")])]), _vm._v(" "), (_vm.cancelPreviewError && _vm.cancelModalStep === 1) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelPreviewError))]) : _vm._e(), _vm._v(" "), (_vm.cancelModalStep === 1) ? _c('div', {
    staticClass: "sbs-cancel-body"
  }, [(_vm.cancelPreview && _vm.cancelPreview.alreadyScheduledForCancel) ? _c('p', {
    staticClass: "sbs-cancel-impact-plain"
  }, [_vm._v("\n          Cancellation is scheduled for the end of "), _c('strong', [_vm._v(_vm._s(_vm.cancelPreview.periodEndFormatted))]), _vm._v(".\n          You still have access until then. Click "), _c('strong', [_vm._v("Resume subscription")]), _vm._v(" below to keep your plan active and billing on schedule.\n        ")]) : (_vm.cancelPreviewLoading) ? _c('p', {
    staticClass: "sbs-cancel-impact-plain"
  }, [_vm._v("Loading your billing timeline…")]) : (_vm.cancelPreview) ? _c('div', {
    staticClass: "sbs-cancel-impact-box"
  }, [_c('p', {
    staticClass: "sbs-cancel-impact-row sbs-cancel-impact-row--ok"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--ok",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✓")]), _vm._v(" "), _c('span', [_vm._v("You'll keep full access until "), _c('strong', [_vm._v(_vm._s(_vm.cancelPreview.periodEndFormatted))]), _vm._v(". No prorated refund — you've already paid for this period.")])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-impact-row"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--warn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("⏱")]), _vm._v(" "), _c('span', [_vm._v("Your "), _c('strong', [_vm._v("30-day alert history, COGS data, and competitor profiles")]), _vm._v(" stay in your account for " + _vm._s(_vm.cancelPreview.dataRetentionDays || 90) + " days in case you come back.")])]), _vm._v(" "), (_vm.cancelPreview.showLegacyMigrationWarning) ? _c('p', {
    staticClass: "sbs-cancel-warn-legacy sbs-cancel-warn-legacy--in-box"
  }, [_vm._v("\n            You migrated from our legacy billing platform — double-check exporting anything you rely on before access changes.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.cancelPreview.stripeWillCancelImmediately) ? _c('p', {
    staticClass: "sbs-cancel-warn sbs-cancel-warn--in-box"
  }, [_vm._v("\n            We could not detect a reusable card or bank mandate on file, so cancelling will stop your subscription immediately.\n          ")]) : _vm._e()]) : _vm._e()]) : (_vm.cancelModalStep === 2) ? [_c('div', {
    staticClass: "sbs-cancel-body"
  }, [_c('div', {
    staticClass: "sbs-cancel-save-offer"
  }, [_c('h3', {
    staticClass: "sbs-cancel-save-offer-title"
  }, [_vm._v("Wait — would a customized plan keep you here?")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-save-offer-text"
  }, [_vm._v("\n              If pricing, capacity, or alert volume is the issue, we can build a plan around your specific setup — different ASIN cap, alert filtering, or a discounted rate. No pressure: it's just a 5-min email.\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-save-offer-yes",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting
    },
    on: {
      "click": _vm.onCancelSaveOfferYes
    }
  }, [_vm._v("\n              Yes, talk to me about a custom plan\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-save-offer-no",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting
    },
    on: {
      "click": _vm.onCancelSaveOfferNo
    }
  }, [_vm._v("\n              No thanks, continue cancelling\n            ")]), _vm._v(" "), (_vm.cancelFlowError) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelFlowError))]) : _vm._e()])])] : (_vm.cancelModalStep === 3) ? [_c('div', {
    staticClass: "sbs-cancel-body sbs-cancel-body--survey"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-reason-list",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "sbs-cancel-reason-heading"
    }
  }, _vm._l((_vm.cancelReasonOptions), function(opt) {
    return _c('label', {
      key: opt.id,
      class: ['sbs-cancel-reason-card', {
        'sbs-cancel-reason-card--selected': _vm.cancelSurveyReason === opt.id
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cancelSurveyReason),
        expression: "cancelSurveyReason"
      }],
      staticClass: "sbs-cancel-reason-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": opt.id,
        "checked": _vm._q(_vm.cancelSurveyReason, opt.id)
      },
      on: {
        "change": function($event) {
          _vm.cancelSurveyReason = opt.id
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sbs-cancel-reason-copy"
    }, [_c('span', {
      staticClass: "sbs-cancel-reason-title"
    }, [_vm._v(_vm._s(opt.label))]), _vm._v(" "), _c('span', {
      staticClass: "sbs-cancel-reason-sub"
    }, [_vm._v(_vm._s(opt.subtitle))])])])
  }), 0), _vm._v(" "), (_vm.cancelSurveyReason === 'too_many_alerts') ? _c('div', {
    staticClass: "sbs-cancel-pills-block",
    attrs: {
      "id": "condAlerts"
    }
  }, [_c('p', {
    staticClass: "sbs-cancel-pills-heading"
  }, [_vm._v("Which alert types? (select all that apply)")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-pills-wrap"
  }, _vm._l((_vm.cancelAlertTagOptions), function(tag) {
    return _c('label', {
      key: tag.id,
      class: ['sbs-cancel-pill', {
        'sbs-cancel-pill--on': _vm.cancelSurveyAlertTags.indexOf(tag.id) !== -1
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cancelSurveyAlertTags),
        expression: "cancelSurveyAlertTags"
      }],
      staticClass: "sbs-cancel-pill-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": tag.id,
        "checked": Array.isArray(_vm.cancelSurveyAlertTags) ? _vm._i(_vm.cancelSurveyAlertTags, tag.id) > -1 : (_vm.cancelSurveyAlertTags)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.cancelSurveyAlertTags,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.cancelSurveyAlertTags = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.cancelSurveyAlertTags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.cancelSurveyAlertTags = $$c
          }
        }
      }
    }), _vm._v("\n                " + _vm._s(tag.label) + "\n              ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-pills-hint"
  }, [_vm._v("Helps us tune alert relevance for everyone.")])]) : _vm._e(), _vm._v(" "), (_vm.cancelSurveyReason === 'found_alternative') ? _c('div', {
    staticClass: "sbs-cancel-survey-section",
    attrs: {
      "id": "condCompetitor"
    }
  }, [_c('label', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "for": "sbs-cancel-comp"
    }
  }, [_vm._v("Which tool are you switching to?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelSurveyCompetitor),
      expression: "cancelSurveyCompetitor"
    }],
    staticClass: "sbs-cancel-select",
    attrs: {
      "id": "sbs-cancel-comp"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cancelSurveyCompetitor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select…")]), _vm._v(" "), _vm._l((_vm.competitorOptions), function(c) {
    return _c('option', {
      key: c,
      domProps: {
        "value": c
      }
    }, [_vm._v(_vm._s(c))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-survey-section"
  }, [_c('label', {
    staticClass: "sbs-cancel-field-label"
  }, [_vm._v("Is there anything we can do to make you stay?")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-segment",
    attrs: {
      "role": "group",
      "aria-label": "Would you stay"
    }
  }, [_c('button', {
    class: ['sbs-cancel-segment-btn', {
      'sbs-cancel-segment-btn--active': _vm.cancelStayAnswer === 'yes'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelStayAnswer = 'yes'
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    class: ['sbs-cancel-segment-btn', {
      'sbs-cancel-segment-btn--active': _vm.cancelStayAnswer === 'no'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelStayAnswer = 'no'
      }
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-survey-section"
  }, [_vm._m(22), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelDetailText),
      expression: "cancelDetailText"
    }],
    staticClass: "sbs-cancel-textarea",
    attrs: {
      "id": "sbs-cancel-detail",
      "rows": "4",
      "maxlength": "7500",
      "placeholder": "What could we have done better? What feature would have changed your mind?"
    },
    domProps: {
      "value": (_vm.cancelDetailText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cancelDetailText = $event.target.value
      }
    }
  })])])] : (_vm.cancelModalStep === 4) ? [_c('div', {
    staticClass: "sbs-cancel-body"
  }, [_c('div', {
    staticClass: "sbs-cancel-final-box"
  }, [_c('p', {
    staticClass: "sbs-cancel-final-box-text"
  }, [_c('span', {
    staticClass: "sbs-cancel-final-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("!")]), _vm._v(" "), _c('strong', [_vm._v("Final step.")]), _vm._v("\n              When you click \"Confirm cancellation\" below, your subscription will be set to cancel on\n              "), _c('strong', [_vm._v(_vm._s(_vm.cancelModalPeriodEndDisplay))]), _vm._v(". You can resume anytime before that date with one click.\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-final-copy"
  }, [_vm._v("\n            After this, you'll get a confirmation email from us and your access will continue exactly as today until the end of the period. We'll be sad to see you go.\n          ")]), _vm._v(" "), (_vm.cancelFlowError) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelFlowError))]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "sbs-cancel-footer"
  }, [_c('button', {
    staticClass: "sbs-cancel-footer-keep",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting || _vm.resumeInProgress
    },
    on: {
      "click": _vm.onCancelFooterKeep
    }
  }, [_vm._v(_vm._s(_vm.cancelFooterKeepLabel))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-footer-continue",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFooterContinueDisabled
    },
    on: {
      "click": _vm.onCancelFooterContinue
    }
  }, [_vm._v(_vm._s(_vm.cancelFooterContinueLabel))])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsPaymentElementModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.unmountPaymentElement
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.paymentModalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sbs-payment-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sbs-payment-element-errors",
      "role": "alert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive right labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.confirmPaymentMethod
    }
  }, [_vm._v("\n        Save"), _c('i', {
    staticClass: "checkmark icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsPlanChangeModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Plan changes")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("To change your subscription or discuss billing options, email our team.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "ui primary button",
    attrs: {
      "href": _vm.planChangeMailHref
    }
  }, [_vm._v("Email support@sentrykit.com →")])])]), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsBillingEmailModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Billing email")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("Receipts and billing notices are sent to "), _c('strong', [_vm._v(_vm._s(_vm.billingEmailDisplay))]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("To update the email on file with Stripe, contact support and we'll take care of it.")]), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('div', {
    staticClass: "ui tiny modal",
    attrs: {
      "id": "sbsAchDetailsModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.paymentMethod) ? [_c('div', {
    staticClass: "header"
  }, [_vm._v("ACH details")]), _vm._v(" "), (_vm.paymentMethod.details) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-bottom": "2em"
    }
  }, [_c('div', {
    staticClass: "ui relaxed divided list"
  }, _vm._l((_vm.paymentMethod.details), function(value, name) {
    return _c('div', {
      key: name,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(String(name).replace(/_/g, ' ')))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(name === 'balance' ? (value / 100).toFixed(2) + ' USD' : value))])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._m(26)], 2), _vm._v(" "), (_vm.upgradeModalOpen) ? _c('div', {
    staticClass: "sbs-min-modal-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeUpgradeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sbs-min-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sbs-upg-title",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.upgradeModalPhase === 'no_payment') ? [_c('h3', {
    staticClass: "sbs-min-modal-title",
    attrs: {
      "id": "sbs-upg-title"
    }
  }, [_vm._v("Add a card to choose " + _vm._s(_vm.upgradeModalPlanName))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-min-modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.upgradeModalPlanName) + " is "), _c('strong', [_vm._v(_vm._s(_vm.upgradeModalPriceLabel))]), _vm._v(".\n          " + _vm._s(_vm.upgradeModalNoPaymentTail) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-min-modal-actions"
  }, [_c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeUpgradeModal
    }
  }, [_vm._v("Not now")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onUpgradeModalAddPayment
    }
  }, [_vm._v("Add card")])])] : [_c('h3', {
    staticClass: "sbs-min-modal-title",
    attrs: {
      "id": "sbs-upg-title"
    }
  }, [_vm._v(_vm._s(_vm.upgradeModalTitle))]), _vm._v(" "), _c('dl', {
    staticClass: "sbs-min-modal-summary"
  }, [_c('div', [_c('dt', [_vm._v("New plan")]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalPlanName) + " · " + _vm._s(_vm.upgradeModalPriceLabel))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Charged today")]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalChargeToday))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v(_vm._s(_vm.upgradeModalRenewLabel))]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalRenewValue))])])]), _vm._v(" "), (_vm.upgradeModalNote) ? _c('p', {
    staticClass: "sbs-min-modal-body sbs-min-modal-note"
  }, [_vm._v(_vm._s(_vm.upgradeModalNote))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-min-modal-actions"
  }, [_c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.upgradeInProgress
    },
    on: {
      "click": _vm.closeUpgradeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.upgradeInProgress
    },
    on: {
      "click": _vm.confirmUpgradeModal
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upgradeInProgress ? 'Switching…' : _vm.upgradeModalConfirmLabel) + "\n          ")])])]], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Payment failed")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your last payment didn't go through")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Trial Ended")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your free trial has ended")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sbs-trial-badge"
  }, [_c('span', {
    staticClass: "sbs-trial-pulse-dot"
  }), _vm._v("Trial Active")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v("19")]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features"
  }, [_c('li', [_vm._v("Unlimited ASINs & all marketplaces")]), _vm._v(" "), _c('li', [_vm._v("2 storefronts included")]), _vm._v(" "), _c('li', [_vm._v("All alert types · real-time delivery")]), _vm._v(" "), _c('li', [_vm._v("COGS, floor price & margin alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v("49")]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features sbs-plan-features-pro"
  }, [_c('li', [_vm._v("Competitor seller profiles")]), _vm._v(" "), _c('li', [_vm._v("Seller name, location & storefront")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("AI Mode")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-phase-pill"
  }, [_vm._v("Phase 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Storefronts")]), _c('th', [_vm._v("Per storefront")]), _c('th', [_vm._v("Volume saving")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v("1–5")]), _c('td', [_vm._v("Included in $49")]), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6–15")]), _c('td', [_vm._v("$19")]), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("16–30")]), _c('td', [_vm._v("$14")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~26% lower")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("31–60")]), _c('td', [_vm._v("$10")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~47% lower")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("61+")]), _c('td', [_vm._v("$7")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~63% lower")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features sbs-plan-features-pro"
  }, [_c('li', [_vm._v("One payment covers the whole year")]), _vm._v(" "), _c('li', [_vm._v("No monthly card charges to track")]), _vm._v(" "), _c('li', [_vm._v("Extra storefronts billed yearly at the Pro rates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Trial Ended")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your free trial has ended")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-enterprise-bar"
  }, [_c('div', {
    staticClass: "sbs-enterprise-bar-text"
  }, [_c('strong', [_vm._v("Agency / Enterprise")]), _vm._v(" "), _c('span', [_vm._v("For white-label, invoicing, SLAs or volume terms · custom pricing from ~$199/mo")])]), _vm._v(" "), _c('a', {
    staticClass: "sbs-enterprise-bar-btn",
    attrs: {
      "href": "mailto:support@sentrykit.com"
    }
  }, [_vm._v("Talk to us →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-pm-display-actions"
  }, [_c('span', {
    staticClass: "sbs-pm-default-badge"
  }, [_vm._v("Default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-pm-display-main"
  }, [_c('div', {
    staticClass: "sbs-pm-display-top"
  }, [_c('span', {
    staticClass: "sbs-pm-display-title"
  }, [_vm._v("Bank transfer (ACH)")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-display-actions"
  }, [_c('span', {
    staticClass: "sbs-pm-default-badge"
  }, [_vm._v("Default")])])]), _vm._v(" "), _c('span', {
    staticClass: "sbs-pm-display-meta"
  }, [_vm._v("Tap “View bank details” for account info.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "sbs-col-amt"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "sbs-status-paid"
  }, [_c('span', {
    staticClass: "sbs-status-dot"
  }), _vm._v("Paid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-cancel-impact-row"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--warn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("⏱")]), _vm._v(" "), _c('span', [_vm._v("After that date, all "), _c('strong', [_vm._v("real-time alerts")]), _vm._v(" stop. Buy Box monitoring, hijacker detection, suppression alerts — all paused.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "id": "sbs-cancel-reason-heading"
    }
  }, [_vm._v("Why are you cancelling? "), _c('span', {
    staticClass: "sbs-cancel-req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "for": "sbs-cancel-detail"
    }
  }, [_vm._v("\n              Anything else you want us to know? "), _c('span', {
    staticClass: "sbs-cancel-opt"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "ui primary button",
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20billing%20email%20change"
    }
  }, [_vm._v("Contact support →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-table-section"
  }, [_c('div', {
    staticClass: "stock-table-toolbar"
  }, [_c('div', {
    staticClass: "stock-table-toolbar-left"
  }, [_c('span', {
    staticClass: "stock-table-title"
  }, [_vm._v("\n        Inventory Table\n        "), _c('span', {
    staticClass: "stock-table-count"
  }, [_vm._v(" " + _vm._s(_vm.products.length) + " products")])])]), _vm._v(" "), _c('div', {
    staticClass: "stock-table-toolbar-right"
  }, [_c('form', {
    staticClass: "stock-search-wrapper",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "stock-search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products..."
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        return _vm.$emit('search', $event.target.value)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search', $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "stock-inventory-table"
  }, [_vm._m(0), _vm._v(" "), _c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _vm._v(" "), _vm._l((_vm.sortableColumns), function(col) {
    return _c('th', {
      key: col.key,
      class: ['text-' + col.align, 'th-sort']
    }, [_c('span', {
      staticClass: "sort-col-head",
      class: _vm.headClass(col.key),
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": 'Sort by ' + col.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('sort', col.key)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.$emit('sort', col.key)
        }
      }
    }, [_vm._v("\n              " + _vm._s(col.label) + "\n              "), _c('span', {
      staticClass: "sort-col-icons",
      attrs: {
        "aria-hidden": "true"
      }
    }, [(_vm.sortKey === col.key && _vm.sortDir === 'asc') ? _c('svg', {
      staticClass: "sort-icon-filled",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M12 8l7 9H5z"
      }
    })]) : (_vm.sortKey === col.key && _vm.sortDir === 'desc') ? _c('svg', {
      staticClass: "sort-icon-filled",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M12 16l-7-9h14z"
      }
    })]) : _c('svg', {
      staticClass: "sort-icon-neutral",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
      }
    })])])])])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.products), function(product) {
    return _c('tr', {
      key: product.productId
    }, [_c('td', [_c('div', {
      staticClass: "stock-product-cell"
    }, [_c('img', {
      staticClass: "stock-product-img",
      attrs: {
        "src": product.imageUrl || product.largeImageUrl
      },
      on: {
        "click": function($event) {
          return _vm.$emit('show-details', product.productId)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "stock-product-info"
    }, [_c('span', {
      staticClass: "stock-product-title",
      attrs: {
        "title": product.productTitle
      }
    }, [_vm._v(_vm._s(product.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-product-meta"
    }, [_c('span', {
      staticClass: "stock-product-asin"
    }, [_vm._v(_vm._s(product.asin || String(product.productId || '')))]), _vm._v(" "), _c('span', {
      staticClass: "stock-product-separator"
    }, [_vm._v("|")]), _vm._v(" "), _c('i', {
      class: product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin": "0"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(product.marketplace))])])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-qty-cell"
    }, [_c('div', {
      class: ['stock-qty-main', {
        'stock-qty-transferring': product._isTransferring
      }]
    }, [_vm._v("\n                " + _vm._s(product._fbaTotal) + "\n              ")]), _vm._v(" "), (product.fbaStockDetails) ? [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v(_vm._s(product.fbaStockDetails))])] : (product._fulfillable === 0) ? [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Fulfillable: " + _vm._s(product._fulfillable))]), _vm._v(" "), (product._reserved > 0) ? _c('div', {
      staticClass: "stock-transfer-pill"
    }, [_c('i', {
      staticClass: "exchange icon"
    }), _vm._v("\n                  " + _vm._s(product._reserved) + " transferring between FCs\n                ")]) : _vm._e(), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("\n                  Inbound: " + _vm._s(_vm.fmtNum(product.fbaInbound)) + "\n                ")]) : _vm._e()] : [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Fulfillable: " + _vm._s(product._fulfillable))]), _vm._v(" "), _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Transferring: " + _vm._s(product._reserved))]), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("\n                  Inbound: " + _vm._s(_vm.fmtNum(product.fbaInbound)) + "\n                ")]) : _vm._e()]], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-qty-cell"
    }, [(product.fbmStock != null && product.fbmStock > 0) ? [_c('div', {
      staticClass: "stock-qty-main"
    }, [_vm._v(_vm._s(product.fbmStock))]), _vm._v(" "), _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Own warehouse")])] : _c('div', {
      staticClass: "stock-qty-main stock-qty-na"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-velocity-cell"
    }, [(product.velocity !== null && product.velocity !== undefined) ? [_c('div', {
      staticClass: "stock-velocity-value"
    }, [_vm._v(_vm._s(product.velocity) + "/day")]), _vm._v(" "), _c('div', {
      class: ['stock-velocity-trend', product._trendCls]
    }, [_vm._v(_vm._s(product._trendText))])] : _c('div', {
      staticClass: "stock-velocity-value stock-velocity-placeholder"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-days-cell"
    }, [(product.daysLeft !== null && product.daysLeft !== undefined) ? [_c('div', {
      class: ['stock-days-value', product.healthStatus || '']
    }, [_vm._v("\n                  " + _vm._s(product.daysLeftDisplay || (product.daysLeft + ' days')) + "\n                ")]), _vm._v(" "), (product.daysLeftSubtitle) ? _c('div', {
      staticClass: "stock-days-detail"
    }, [_vm._v(_vm._s(product.daysLeftSubtitle))]) : _vm._e(), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-inbound-badge-wrapper"
    }, [_c('div', {
      staticClass: "stock-inbound-badge"
    }, [_c('i', {
      staticClass: "info circle icon"
    }), _vm._v("\n                    +" + _vm._s(product.fbaInbound) + " inbound not counted\n                  ")])]) : _vm._e()] : _c('div', {
      staticClass: "stock-days-value stock-days-placeholder"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: ['stock-status-badge', product.healthStatus || 'unknown']
    }, [_vm._v("\n              " + _vm._s(product.status || 'Unknown') + "\n            ")])])])
  }), _vm._v(" "), (_vm.products.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "stock-empty-state"
  }, [_c('i', {
    staticClass: "warehouse icon"
  }), _vm._v(" "), (_vm.searchQuery) ? _c('p', [_vm._v("No products match your search.")]) : _c('p', [_vm._v("No inventory data available yet.")])])])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.products.length > 0) ? _c('div', {
    staticClass: "stock-table-legend"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "stock-pagination"
  }, [_c('button', {
    staticClass: "stock-pagination-btn",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.$emit('page', _vm.currentPage - 1)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon",
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _vm._l((_vm.paginationPages), function(page) {
    return _c('button', {
      key: page,
      class: ['stock-pagination-btn', {
        active: _vm.currentPage === page
      }],
      on: {
        "click": function($event) {
          return _vm.$emit('page', page)
        }
      }
    }, [_vm._v("\n      " + _vm._s(page + 1) + "\n    ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "stock-pagination-btn",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('page', _vm.currentPage + 1)
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon",
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "stock-pagination-info"
  }, [_vm._v("\n      Page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + " (" + _vm._s(_vm.totalItems) + " items)\n    ")])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "stock-col-product"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-fba"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-fbm"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-velocity"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-runway"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-status"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-legend-header"
  }, [_c('div', {
    staticClass: "stock-legend-title"
  }, [_vm._v("Status logic:")]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-items"
  }, [_c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot critical"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Out of Stock")]), _vm._v(" — Fulfillable + Transferring = 0, no inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot low"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Low Stock")]), _vm._v(" — Effective runway ≤ 14 days")])]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot healthy"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Healthy")]), _vm._v(" — Effective runway > 14 days")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-legend-note"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Effective Stock = Fulfillable + Transferring (reservedStock). Inbound (not yet at FC) shown as info — excluded from runway.")])])
}]}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "csv-example"
  }, [_c('div', {
    staticClass: "csv-header"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("ASIN")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("Current Price")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_vm._v("COGS")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_vm._v("Other Costs")])]), _vm._v(" "), _c('div', {
    staticClass: "csv-row"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU-12345")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("B07K8XYZ")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("\"Argan Body Wash\"")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("24.99")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("8.50")])]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("2.00")])])]), _vm._v(" "), _c('div', {
    staticClass: "csv-row"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU-67890")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("B08SM5NNQ")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("\"Body Lotion\"")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("19.99")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("5.25")])]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  })])])
}]}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card revenue-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stat-value revenue"
  }, [_c('span', {
    staticClass: "revenue-symbol"
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "revenue-amount"
  }, [_vm._v(_vm._s(_vm.formatCompactAmount(_vm.data.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "revenue-period"
  }, [_vm._v("/day")])]), _vm._v(" "), (_vm.data.subtitle) ? _c('div', {
    staticClass: "stat-subtitle"
  }, [_vm._v("\n    " + _vm._s(_vm.data.subtitle) + "\n  ")]) : _c('div', {
    staticClass: "stat-description"
  }, [_vm._v("\n    From "), _c('strong', [_vm._v(_vm._s(_vm.data.affectedProducts) + " products")]), _vm._v(" where you don't hold the Buy Box.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue-breakdown"
  }, [_c('div', {
    staticClass: "breakdown-item weekly-impact"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "breakdown-value negative"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCompactValue(_vm.data.weeklyImpact)))])])]), _vm._v(" "), _c('div', {
    staticClass: "breakdown-item actionable-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "breakdown-value actionable"
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.actionableProducts) + " products")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-header revenue-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("EST. DAILY REVENUE IMPACT")]), _vm._v(" "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Estimated daily revenue impact from products where you don't hold the Buy Box"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breakdown-label"
  }, [_vm._v("\n        THIS WEEK (EST.)\n        "), _c('i', {
    staticClass: "info circle icon small",
    attrs: {
      "title": "Weekly Revenue Impact: Cumulative estimated revenue impact over the past 7 days"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breakdown-label"
  }, [_vm._v("\n        ACTIONABLE\n        "), _c('i', {
    staticClass: "info circle icon small",
    attrs: {
      "title": "Actionable Products: Products where you can potentially win back the Buy Box through price adjustment"
    }
  })])
}]}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "22 12 18 12 15 21 9 3 6 12 2 12"
    }
  })])]), _vm._v("\n      Sales Volume\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('div', {
    staticClass: "time-filter"
  }, [_c('button', {
    staticClass: "time-filter-btn",
    class: {
      active: _vm.selectedPeriod === '7d'
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('7d')
      }
    }
  }, [_vm._v("7d")]), _vm._v(" "), _c('button', {
    staticClass: "time-filter-btn",
    class: {
      active: _vm.selectedPeriod === '30d'
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('30d')
      }
    }
  }, [_vm._v("30d")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    ref: "chartWrapper",
    staticClass: "chart-wrapper",
    on: {
      "mousemove": _vm.onMouseMove,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('canvas', {
    ref: "salesCanvas"
  }), _vm._v(" "), _c('div', {
    ref: "chartTooltip",
    staticClass: "chart-tooltip",
    class: {
      visible: _vm.tooltipVisible
    }
  }, [_c('div', {
    staticClass: "chart-tooltip-date"
  }, [_vm._v(_vm._s(_vm.tooltipDate))]), _vm._v(" "), _c('div', {
    staticClass: "chart-tooltip-value"
  }, [_vm._v(_vm._s(_vm.tooltipValue))]), _vm._v(" "), _c('div', {
    staticClass: "chart-tooltip-sub"
  }, [_vm._v(_vm._s(_vm.tooltipSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stats"
  }, [_c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Daily Average")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.dailyAverageValue) + " units")])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Last 7 Days")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.last7DaysValue) + " units "), _c('span', {
    staticClass: "trend",
    class: _vm.last7DaysChangeValue >= 0 ? 'up' : 'down'
  }, [_vm._v(_vm._s(_vm.last7DaysChangeValue >= 0 ? '↑' : '↓') + " " + _vm._s(Math.abs(_vm.last7DaysChangeValue)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat"
  }, [_c('div', {
    staticClass: "sales-stat-label"
  }, [_vm._v("Est. Monthly Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "sales-stat-value"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.monthlyRevenueValue))])])])])])
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "aks-loading"
  }, [_c('div', {
    staticClass: "aks-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "aks-error"
  }, [_c('p', {
    staticClass: "aks-error-title"
  }, [_vm._v("Could not load API keys")]), _vm._v(" "), _c('p', {
    staticClass: "aks-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_c('div', {
    staticClass: "aks-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showForm) ? _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "6px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Create API key\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aks-hint-banner",
    attrs: {
      "role": "note"
    }
  }, [_c('svg', {
    staticStyle: {
      "flex-shrink": "0"
    },
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showForm) ? _c('div', {
    staticClass: "aks-card aks-form-card"
  }, [_c('h3', {
    staticClass: "aks-form-title"
  }, [_vm._v("Create API key")]), _vm._v(" "), (_vm.formError) ? _c('div', {
    staticClass: "aks-alert-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aks-field"
  }, [_c('label', {
    staticClass: "aks-field-label"
  }, [_vm._v("KEY NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formName),
      expression: "formName"
    }],
    staticClass: "aks-input",
    attrs: {
      "type": "text",
      "placeholder": "e.g. Production script, Zapier integration",
      "maxlength": "100",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.formName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aks-field-hint"
  }, [_vm._v("Optional — helps you identify this key later.")])]), _vm._v(" "), _c('div', {
    staticClass: "aks-form-actions"
  }, [_c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    class: {
      'aks-btn-loading': _vm.submitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.createKey
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitting ? 'Creating…' : 'Create key') + "\n        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.apiKeys.length && !_vm.showForm) ? _c('div', {
    staticClass: "aks-empty"
  }, [_c('svg', {
    staticClass: "aks-empty-icon",
    attrs: {
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4",
      "y": "14",
      "width": "40",
      "height": "24",
      "rx": "3",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17",
      "cy": "26",
      "r": "5",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 26h10M32 26l4 4M32 26l4-4",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17",
      "cy": "26",
      "r": "2",
      "fill": "currentColor",
      "opacity": "0.35"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "aks-empty-title"
  }, [_vm._v("No API keys yet")]), _vm._v(" "), _c('p', {
    staticClass: "aks-empty-sub"
  }, [_vm._v("Create a key to authenticate your scripts and integrations with the SentryKit REST API.")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "5px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Create API key\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.apiKeys.length) ? _c('div', {
    staticClass: "aks-card"
  }, [_c('table', {
    staticClass: "aks-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.apiKeys), function(key) {
    return _c('tr', {
      key: key.id,
      class: {
        'aks-row-revoked': key.revoked_at
      }
    }, [_c('td', {
      staticClass: "aks-cell-name"
    }, [_c('span', {
      staticClass: "aks-key-name"
    }, [_vm._v(_vm._s(key.name || 'Unnamed key'))]), _vm._v(" "), (key.revoked_at) ? _c('span', {
      staticClass: "aks-badge-revoked"
    }, [_vm._v("Revoked")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-key"
    }, [_c('code', {
      staticClass: "aks-prefix"
    }, [_vm._v(_vm._s(key.token_prefix)), _c('span', {
      staticClass: "aks-prefix-dots"
    }, [_vm._v("••••")])])]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-scopes"
    }, _vm._l((key.scopes), function(s) {
      return _c('span', {
        key: s,
        staticClass: "aks-scope-chip"
      }, [_vm._v(_vm._s(s))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-meta"
    }, [_vm._v(_vm._s(key.last_used_at ? _vm.formatDate(key.last_used_at) : 'Never'))]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-meta"
    }, [_vm._v(_vm._s(_vm.formatDate(key.created_at)))]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-action"
    }, [(!key.revoked_at) ? _c('button', {
      staticClass: "aks-revoke-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.revokingId === key.id
      },
      on: {
        "click": function($event) {
          return _vm.confirmRevoke(key.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.revokingId === key.id ? 'Revoking…' : 'Revoke') + "\n              ")]) : _vm._e()])])
  }), 0)])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.tokenModal.show) ? _c('div', {
    staticClass: "aks-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeTokenModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "aks-modal"
  }, [_c('div', {
    staticClass: "aks-modal-icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "aks-modal-title"
  }, [_vm._v("API key created — save it now")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "aks-token-box"
  }, [_c('code', {
    staticClass: "aks-token-code"
  }, [_vm._v(_vm._s(_vm.tokenModal.token))]), _vm._v(" "), _c('button', {
    staticClass: "aks-copy-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.tokenModal.token)
      }
    }
  }, [(!_vm.copied) ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    }
  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.copied ? '✓ Copied!' : 'Copy') + "\n        ")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary aks-modal-done-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeTokenModal
    }
  }, [_vm._v("Done, I've copied it")])])]) : _vm._e(), _vm._v(" "), (_vm.revokeConfirmId != null) ? _c('div', {
    staticClass: "aks-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.revokeConfirmId = null
      }
    }
  }, [_c('div', {
    staticClass: "aks-modal aks-modal-sm"
  }, [_c('div', {
    staticClass: "aks-modal-icon-wrap aks-modal-icon-danger"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "aks-modal-title"
  }, [_vm._v("Revoke API key?")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "aks-modal-btns"
  }, [_c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.revokingId != null
    },
    on: {
      "click": function($event) {
        _vm.revokeConfirmId = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-danger",
    class: {
      'aks-btn-loading': _vm.revokingId != null
    },
    attrs: {
      "type": "button",
      "disabled": _vm.revokingId != null
    },
    on: {
      "click": function($event) {
        return _vm.revokeKey(_vm.revokeConfirmId)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.revokingId != null ? 'Revoking…' : 'Revoke key') + "\n        ")])])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks-page-head-text"
  }, [_c('h1', {
    staticClass: "aks-title"
  }, [_vm._v("API Keys")]), _vm._v(" "), _c('p', {
    staticClass: "aks-subtitle"
  }, [_vm._v("Authenticate requests to the SentryKit REST API from your own scripts, apps, or integrations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        Use your key in the "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("Authorization: Bearer sk_live_…")]), _vm._v(" header when calling\n        "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("https://api.sentrykit.com/api/external/v1/")]), _vm._v(".\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Scopes")]), _vm._v(" "), _c('th', [_vm._v("Last used")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aks-modal-body"
  }, [_c('strong', [_vm._v("Copy this key now — it won't be shown again.")]), _vm._v("\n        Use it as "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("Authorization: Bearer <key>")]), _vm._v(" in your API requests.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks-example-block"
  }, [_c('p', {
    staticClass: "aks-example-label"
  }, [_vm._v("Example request")]), _vm._v(" "), _c('code', {
    staticClass: "aks-example-code"
  }, [_vm._v("curl -H \"Authorization: Bearer sk_live_…\" \\"), _c('br'), _vm._v("  https://api.sentrykit.com/api/external/v1/alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aks-modal-body"
  }, [_vm._v("This immediately stops the key from authenticating. Any integration using it will break. "), _c('strong', [_vm._v("There is no undo")]), _vm._v(" — you'll need to create a new key.")])
}]}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "past-due-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "past-due-lockout-title"
    }
  }, [_vm._v(_vm._s(_vm.copy.title))]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub",
    domProps: {
      "innerHTML": _vm._s(_vm.copy.messageHtml)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "trial-lockout-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goUpdatePayment
    }
  }, [_vm._v("\n      Update payment method →\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('a', {
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20payment%20failed"
    }
  }, [_vm._v("Contact support")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])])])
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "canceled-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "canceled-lockout-title"
    }
  }, [_vm._v(_vm._s(_vm.copy.title))]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub",
    domProps: {
      "innerHTML": _vm._s(_vm.copy.messageHtml)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('a', {
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20subscription%20reactivation"
    }
  }, [_vm._v("Contact support")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])])])
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buybox-factors-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "factors-grid"
  }, _vm._l((_vm.factors), function(factor, index) {
    return _c('div', {
      key: index,
      staticClass: "factor-item"
    }, [_c('div', {
      staticClass: "factor-label"
    }, [_vm._v(_vm._s(factor.name))]), _vm._v(" "), _c('div', {
      staticClass: "factor-value-row"
    }, [_c('span', {
      staticClass: "factor-value"
    }, [_vm._v(_vm._s(factor.description))]), _vm._v(" "), (factor.status === 'ok') ? _c('i', {
      staticClass: "check icon status-ok"
    }) : _c('i', {
      staticClass: "times icon status-issue"
    })])])
  }), 0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "title-icon"
  }, [_vm._v("📊")]), _vm._v("\n      Buy Box Factors\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "factor-note"
  }, [_c('span', {
    staticClass: "note-icon"
  }, [_vm._v("💡")]), _vm._v(" "), _c('span', {
    staticClass: "note-text"
  }, [_c('strong', [_vm._v("Price gap is the primary issue.")]), _vm._v(" Matching or beating $14.99 would likely recover the Buy Box since other factors are equal.\n    ")])])
}]}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "HIGH"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "HIGH")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "HIGH"
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "MEDIUM"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "MEDIUM")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "MEDIUM"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "LOW"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "LOW")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "LOW"
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No Delay: "), _c('small', [_vm._v("You get alerts promptly after a change occurs in the Amazon API. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("WARNING:")]), _vm._v(" This can result in a lot of notifications! Best Seller Badges can change frequently and repeatedly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Moderate Delay "), _c('small', [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("[RECOMMENDED]")]), _vm._v(": We apply a small delay to the Best Seller Badge alerts so we can filter out short-lived changes. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Strong Filtering: "), _c('small', [_vm._v("We only notify if the Best Seller Badge is lost or gained for a solid amount of time."), _c('br'), _vm._v(" Use this setting if you are getting too many Best Seller Badge alerts.")])])
}]}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic large long modal",
    staticStyle: {
      "min-height": "90vh"
    },
    attrs: {
      "id": "chartModal"
    }
  }, [(_vm.product) ? _c('div', {
    staticClass: "header"
  }, [(_vm.product) ? _c('img', {
    staticClass: "ui image medium",
    staticStyle: {
      "max-height": "75px",
      "max-width": "75px",
      "height": "auto",
      "width": "auto",
      "border-radius": "3px",
      "float": "left",
      "margin-right": "20px",
      "margin-top": "10px"
    },
    attrs: {
      "src": _vm.product.largeImageUrl
    }
  }) : _vm._e(), _vm._v("\n    Sales data for " + _vm._s(_vm.product.productTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "10px"
    }
  }), _vm._v(" "), _c('spreadsheet-download-widget', {
    attrs: {
      "variant": "sales",
      "chartLastLoadedAt": _vm.lastLoadedAt,
      "product": _vm.product
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui inverted mini form stts21kdfslds",
    staticStyle: {
      "float": "right",
      "margin-right": "40px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeDown",
      "mode": "out-in"
    }
  }, [(!_vm.showChartRangeSelector) ? _c('div', {
    key: 1
  }, [_vm._v("\n      Currently showing: Last 30 days - "), _c('span', {
    staticClass: "ui compact mini button",
    on: {
      "click": function($event) {
        _vm.showChartRangeSelector = true
      }
    }
  }, [_vm._v("Select Date")])]) : _vm._e(), _vm._v(" "), (_vm.showChartRangeSelector) ? _c('div', {
    key: 2,
    staticClass: "inline field",
    class: {
      'error': _vm.chartRangeSt === 'RANGE_ERROR'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartRangeDateFrom),
      expression: "chartRangeDateFrom"
    }],
    staticStyle: {
      "width": "125px",
      "padding": "6px",
      "margin-top": "-3px"
    },
    attrs: {
      "name": "datefrom",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.chartRangeDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chartRangeDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartRangeDateTo),
      expression: "chartRangeDateTo"
    }],
    staticStyle: {
      "width": "125px",
      "padding": "6px",
      "margin-top": "-3px"
    },
    attrs: {
      "name": "dateto",
      "type": "date",
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.chartRangeDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chartRangeDateTo = $event.target.value
      }
    }
  }), _vm._v("\n            \n          "), _c('span', {
    staticClass: "ui compact small button",
    class: {
      'loading': _vm.chartRangeSt === 'LOADING'
    },
    on: {
      "click": _vm.dateRangeButtonClick
    }
  }, [_vm._v("Go")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.product) ? _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px",
      "min-height": "400px"
    }
  }, [_c('line-chart', {
    ref: "salesLineChart"
  })], 1), (_vm.salesLoading) ? _c('div', {
    staticClass: "ui loader"
  }) : _vm._e(), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_vm._v("\n    hit ESC or click\n    "), _c('div', {
    staticClass: "ui inverted ok button"
  }, [_vm._v("OK")])])
}]}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasStockData) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.selectedSellerIdSet.has(String(sa.sellerId))
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.selectedSellerIdSet.has(String(sa.sellerId))) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.mpSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "stock-dashboard"
  }, [_c('div', {
    staticClass: "stock-dashboard-content"
  }, [_c('div', {
    staticClass: "stock-page-header stock-page-header-with-actions"
  }, [_c('div', {
    staticClass: "stock-page-header-text"
  }, [_c('h1', {
    staticClass: "stock-page-title"
  }, [_vm._v("Stock Dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "stock-page-subtitle"
  }, [_vm._v("Monitor FBA & FBM inventory levels across all products")])]), _vm._v(" "), (_vm.hasStockData) ? _c('div', {
    staticClass: "stock-page-header-actions"
  }, [_c('button', {
    staticClass: "stock-thresholds-btn",
    class: {
      open: _vm.thresholdPanelOpen
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleThresholdPanel
    }
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n            Alert Thresholds\n            "), _c('i', {
    staticClass: "angle down icon stock-thresholds-chevron"
  })]), _vm._v(" "), _c('button', {
    staticClass: "stock-export-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n            Export CSV\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.hasStockData && _vm.thresholdPanelOpen && !_vm.thresholdPanelReady) ? _c('div', {
    staticClass: "stock-thresholds-prefetch-bar",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('span', [_vm._v("Loading alert thresholds…")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasStockData && _vm.thresholdPanelOpen),
      expression: "hasStockData && thresholdPanelOpen"
    }],
    class: {
      'stock-thresholds-panel-wrap--prefetch': !_vm.thresholdPanelReady
    }
  }, [_c('StockAlertThresholdsPanel', {
    ref: "thresholdsPanel",
    attrs: {
      "panel-open": _vm.hasStockData && _vm.thresholdPanelOpen,
      "seller-account-id": _vm.thresholdSellerAccountId
    },
    on: {
      "close": _vm.onThresholdClose,
      "saved": _vm.onThresholdSaved,
      "spreadsheet-imported": _vm.onThresholdSaved,
      "thresholds-load-complete": function($event) {
        _vm.thresholdPanelReady = true
      }
    }
  })], 1), _vm._v(" "), _c('StockStatCards', {
    attrs: {
      "stats": _vm.statsData,
      "active-filter": _vm.activeFilter,
      "marketplace-count": _vm.marketplaceCount
    },
    on: {
      "filter-change": _vm.onFilterChange
    }
  }), _vm._v(" "), _c('StockInventoryTable', {
    attrs: {
      "products": _vm.products,
      "sort-key": _vm.tableSortKey,
      "sort-dir": _vm.tableSortDir,
      "search-query": _vm.searchQuery,
      "current-page": _vm.currentPage,
      "total-pages": _vm.totalPages,
      "total-items": _vm.totalItems,
      "pagination-pages": _vm.paginationPages
    },
    on: {
      "sort": _vm.onSort,
      "search": _vm.onSearch,
      "page": _vm.onPage,
      "show-details": _vm.onShowDetails
    }
  })], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "15px 5px 5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "HIGH"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "HIGH")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "HIGH"
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "MEDIUM"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "MEDIUM")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "MEDIUM"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "LOW"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "LOW")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "LOW"
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No Delay: "), _c('small', [_vm._v("You get alerts promptly after we detect a change in Amazon. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("WARNING:")]), _vm._v(" This can result in a lot of notifications! Subscribe and Save can change frequently and repeatedly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Moderate Delay "), _c('small', [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("[RECOMMENDED]")]), _vm._v(": We apply a small delay to the Subscribe and Save alerts so we can filter out short-lived changes. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Strong Filtering: "), _c('small', [_vm._v("We only notify if Subscribe and Save option is lost or gained for a solid amount of time."), _c('br'), _vm._v(" Use this setting if you are getting too many Subscribe and Save alerts.")])])
}]}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pts"
  }, [(_vm.fatalLoadError) ? _c('div', {
    staticClass: "pts-loading"
  }, [_c('div', {
    staticClass: "pts-error"
  }, [_c('p', {
    staticClass: "pts-error-title"
  }, [_vm._v("Could not load product tracking settings")]), _vm._v(" "), _c('p', {
    staticClass: "pts-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-outline",
    on: {
      "click": _vm.fetchSettings
    }
  }, [_vm._v("Retry")])])]) : _c('div', {
    staticClass: "pts-shell"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoadingOverlay),
      expression: "showLoadingOverlay"
    }],
    staticClass: "pts-loading pts-loading--overlay",
    attrs: {
      "aria-busy": "true"
    }
  }, [_c('div', {
    staticClass: "pts-spinner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pts-shell-body",
    class: {
      'pts-shell-body--inactive': _vm.showLoadingOverlay
    }
  }, [(_vm.loadError && !_vm.fatalLoadError) ? _c('div', {
    staticClass: "pts-inline-error"
  }, [_c('p', {
    staticClass: "pts-inline-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchSettings
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-card"
  }, [_c('p', {
    staticClass: "pts-filter-hint"
  }, [_vm._v("Filter by account & marketplace — select one or both to narrow results")]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-main"
  }, [_c('div', {
    staticClass: "pts-filter-group"
  }, [_c('label', {
    staticClass: "pts-filter-label"
  }, [_vm._v("Storefront")]), _vm._v(" "), _c('div', {
    staticClass: "pts-pills pts-pills--cols-2"
  }, [_c('button', {
    class: ['pts-pill', {
      active: _vm.selectedStorefront === 'all'
    }],
    on: {
      "click": function($event) {
        return _vm.setStorefront('all')
      }
    }
  }, [_vm._v("All accounts")]), _vm._v(" "), _vm._l((_vm.storefronts), function(acc) {
    return _c('button', {
      key: acc.sellerId,
      class: ['pts-pill', {
        active: String(_vm.selectedStorefront) === String(acc.sellerId)
      }],
      on: {
        "click": function($event) {
          return _vm.setStorefront(acc.sellerId)
        }
      }
    }, [_vm._v(_vm._s(acc.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-group pts-filter-group-mp"
  }, [_c('label', {
    staticClass: "pts-filter-label"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('div', {
    staticClass: "pts-pills pts-pills--cols-2 pts-pills--mp"
  }, [_c('button', {
    class: ['pts-pill', {
      active: _vm.selectedMarketplace === 'all'
    }],
    on: {
      "click": function($event) {
        return _vm.setMarketplace('all')
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.availableMarketplaces), function(mp) {
    return _c('button', {
      key: mp.code,
      class: ['pts-pill', {
        active: _vm.selectedMarketplace === mp.code
      }],
      on: {
        "click": function($event) {
          return _vm.setMarketplace(mp.code)
        }
      }
    }, [(_vm.mpEmoji(mp.code)) ? _c('span', {
      staticClass: "pts-mp-emoji",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.mpEmoji(mp.code)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(mp.label))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pts-filter-search-col"
  }, [_c('div', {
    staticClass: "pts-search-wrap"
  }, [_c('svg', {
    staticClass: "pts-search-icon",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "pts-search-input",
    attrs: {
      "id": "pts-search-input",
      "type": "search",
      "placeholder": "Search ASIN or name..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pts-summary-bar"
  }, [_c('span', {
    staticClass: "pts-summary"
  }, [_vm._v("\n        Showing "), _c('strong', [_vm._v(_vm._s(_vm.summaryFilteredCount))]), _vm._v(" products\n        · "), _c('strong', [_vm._v(_vm._s(_vm.ignoredCount))]), _vm._v(" ignored\n        "), (_vm.ignoredCount > 0) ? [_vm._v(" · alerts suppressed")] : _vm._e()], 2), _vm._v(" "), _c('label', {
    staticClass: "pts-show-ignored"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showIgnoredOnly),
      expression: "showIgnoredOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showIgnoredOnly) ? _vm._i(_vm.showIgnoredOnly, null) > -1 : (_vm.showIgnoredOnly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showIgnoredOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showIgnoredOnly = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showIgnoredOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showIgnoredOnly = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pts-show-ignored-box"
  }), _vm._v(" "), _c('span', [_vm._v("Show ignored only")])])]), _vm._v(" "), (_vm.bulkIgnoreAvailable) ? _c('div', {
    staticClass: "pts-bulk-ignore"
  }, [_c('span', {
    staticClass: "pts-bulk-ignore-scope"
  }, [_vm._v("All products in "), _c('strong', [_vm._v(_vm._s(_vm.bulkIgnoreScopeLabel))]), (_vm.searchTextTrimmed) ? [_vm._v(" matching “" + _vm._s(_vm.searchTextTrimmed) + "”")] : _vm._e(), _vm._v(":")], 2), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-ignore-actions"
  }, [(_vm.bulkIgnoreEstimate(true) !== 0) ? _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkIgnoreBusy || _vm.hasChanges,
      "title": _vm.hasChanges ? 'Save or discard your changes first' : ''
    },
    on: {
      "click": function($event) {
        return _vm.startBulkIgnore(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.bulkIgnoreButtonLabel(true)))]) : _vm._e(), _vm._v(" "), (_vm.bulkIgnoreEstimate(false) !== 0) ? _c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkIgnoreBusy || _vm.hasChanges,
      "title": _vm.hasChanges ? 'Save or discard your changes first' : ''
    },
    on: {
      "click": function($event) {
        return _vm.startBulkIgnore(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.bulkIgnoreButtonLabel(false)))]) : _vm._e()]), _vm._v(" "), (_vm.bulkIgnoreMessage) ? _c('p', {
    staticClass: "pts-bulk-result",
    class: 'pts-bulk-result--' + _vm.bulkIgnoreLevel
  }, [_vm._v(_vm._s(_vm.bulkIgnoreMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-card"
  }, [_c('h3', {
    staticClass: "pts-bulk-title"
  }, [_vm._v("Bulk update (CSV)")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pts-bulk-actions"
  }, [_c('button', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkCsvDownloading
    },
    on: {
      "click": _vm.downloadBulkCsvExport
    }
  }, [_vm._v(_vm._s(_vm.bulkCsvDownloading ? 'Downloading…' : 'Download product CSV'))]), _vm._v(" "), _c('label', {
    staticClass: "pts-btn pts-btn-outline pts-btn-sm pts-bulk-file-label",
    class: {
      'pts-bulk-file-label--busy': _vm.bulkCsvUploading
    }
  }, [_c('input', {
    staticClass: "pts-bulk-file-input",
    attrs: {
      "type": "file",
      "accept": ".csv,text/csv,text/plain",
      "disabled": _vm.bulkCsvUploading
    },
    on: {
      "change": _vm.onBulkCsvFile
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pts-bulk-file-text"
  }, [_vm._v(_vm._s(_vm.bulkCsvUploading ? 'Uploading…' : 'Upload CSV'))])])]), _vm._v(" "), (_vm.bulkCsvResult) ? _c('p', {
    staticClass: "pts-bulk-result",
    class: _vm.bulkCsvResultLevel
  }, [_vm._v(_vm._s(_vm.bulkCsvResult))]) : _vm._e(), _vm._v(" "), (_vm.bulkCsvErrors.length) ? _c('ul', {
    staticClass: "pts-bulk-errors"
  }, _vm._l((_vm.bulkCsvErrors), function(errLine, idx) {
    return _c('li', {
      key: 'bulk-csv-err-' + idx
    }, [_vm._v(_vm._s(errLine))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pts-table-wrap"
  }, [_c('table', {
    staticClass: "pts-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.tableRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "pts-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No products match the current filters.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableRows), function(product, rowIdx) {
    return _c('tr', {
      key: product.productId != null ? product.productId : ('pts-row-' + rowIdx),
      staticClass: "pts-row"
    }, [_c('td', {
      staticClass: "pts-cell-product"
    }, [_c('div', {
      staticClass: "pts-product-wrap"
    }, [_c('a', {
      staticClass: "pts-product-img-link",
      attrs: {
        "href": product.productPage,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [(product.imageUrl) ? _c('img', {
      staticClass: "pts-product-img",
      attrs: {
        "src": product.imageUrl,
        "alt": product.productName || ''
      }
    }) : _c('div', {
      staticClass: "pts-product-img-placeholder"
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
        "clip-rule": "evenodd"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "pts-product-info"
    }, [_c('span', {
      staticClass: "pts-product-name"
    }, [_vm._v(_vm._s(product.productName || product.asin1))]), _vm._v(" "), _c('span', {
      staticClass: "pts-product-asin"
    }, [_vm._v(_vm._s(product.asin1))])])])]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-storefront"
    }, [_vm._v(_vm._s(_vm.storefrontNameFor(product)))]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-mp"
    }, [_c('span', {
      staticClass: "pts-mp-badge"
    }, [(_vm.mpEmoji(product.marketplaceIso31662Code)) ? _c('span', {
      staticClass: "pts-mp-emoji",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.mpEmoji(product.marketplaceIso31662Code)))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.mpLabel(product.marketplaceIso31662Code)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-shortname"
    }, [_c('input', {
      staticClass: "pts-shortname-input",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "data-lpignore": "true"
      },
      domProps: {
        "value": product.shortName
      },
      on: {
        "input": function($event) {
          return _vm.onShortNameInput(product, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "pts-cell-ignore"
    }, [_c('label', {
      staticClass: "pts-toggle"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !product.show
      },
      on: {
        "change": function($event) {
          return _vm.onToggleIgnore(product)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pts-toggle-slider"
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pts-pagination"
  }, [_c('span', {
    staticClass: "pts-page-label"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('div', {
    staticClass: "pts-page-controls"
  }, [_c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(0)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "pts-page-num"
  }, [_vm._v(_vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "pts-page-btn",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.totalPages - 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0zm-4 0a1 1 0 010-1.414L10.586 10 6.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
      "clip-rule": "evenodd"
    }
  })])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pts-slide-up"
    }
  }, [(_vm.hasChanges) ? _c('div', {
    staticClass: "pts-changes-bar"
  }, [_c('span', {
    staticClass: "pts-changes-text"
  }, [_c('span', {
    staticClass: "pts-changes-dot"
  }), _vm._v("\n          You have unsaved changes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pts-changes-actions"
  }, [_c('button', {
    staticClass: "pts-btn pts-btn-outline",
    on: {
      "click": _vm.discard
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('button', {
    staticClass: "pts-btn pts-btn-primary",
    class: {
      'pts-btn-loading': _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save changes")])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pts-header"
  }, [_c('h2', {
    staticClass: "pts-title"
  }, [_vm._v("Product Tracking Settings")]), _vm._v(" "), _c('p', {
    staticClass: "pts-subtitle"
  }, [_vm._v("Manage which products SentryKit monitors. Ignored products won't generate alerts but remain in your catalog.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pts-bulk-desc"
  }, [_vm._v("\n        Upload a CSV with headers "), _c('strong', [_vm._v("asin")]), _vm._v(", "), _c('strong', [_vm._v("marketplace")]), _vm._v(", and "), _c('strong', [_vm._v("ignore")]), _vm._v(".\n        Marketplace codes match the filters (e.g. "), _c('code', [_vm._v("us")]), _vm._v(", "), _c('code', [_vm._v("uk")]), _vm._v(", "), _c('code', [_vm._v("de")]), _vm._v(").\n        "), _c('strong', [_vm._v("ignore")]), _vm._v(": "), _c('code', [_vm._v("true")]), _vm._v(" / "), _c('code', [_vm._v("false")]), _vm._v(", "), _c('code', [_vm._v("yes")]), _vm._v(" / "), _c('code', [_vm._v("no")]), _vm._v(", or "), _c('code', [_vm._v("1")]), _vm._v(" / "), _c('code', [_vm._v("0")]), _vm._v(".\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "pts-th-product"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-storefront"
  }, [_vm._v("Storefront")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-mp"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-shortname"
  }, [_vm._v("Short-hand name")]), _vm._v(" "), _c('th', {
    staticClass: "pts-th-ignore"
  }, [_vm._v("Ignore")])])])
}]}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homeWrap"
    }
  }, [(_vm.$parent.loadingIndicator) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100vw",
      "height": "100vh",
      "background": "rgba(0,0,0,0.7)",
      "z-index": "9999",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dash-wrap",
    class: {
      'shut': _vm.dashboardIsFolded
    }
  }, [_c('div', {
    staticClass: "dash-bg"
  }), _vm._v(" "), _c('Dashboard', {
    ref: "dashboard"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dashboardIsFolded),
      expression: "!dashboardIsFolded"
    }],
    attrs: {
      "id": "dashSmallDetails"
    }
  }, [_c('div', {
    attrs: {
      "data-html": "<img src='/static/dninfo.png' style='margin:-3px -5px -19px -5px'/>'",
      "data-variation": "inverted mini",
      "data-position": "top left"
    }
  }, [_vm._v("\n        Auto Refresh SentryKit Data: "), _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("Always ON")]), _vm._v(" "), _c('br'), _vm._v("\n        Desktop Notifications:\n        "), (_vm.desktopNotifPerm == 'default') ? _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("Browser Setting")]) : _vm._e(), _vm._v(" "), (_vm.desktopNotifPerm == 'granted') ? _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("ON")]) : _vm._e(), _vm._v(" "), (_vm.desktopNotifPerm == 'denied') ? _c('span', {
    staticStyle: {
      "color": "#935"
    }
  }, [_vm._v("OFF")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "help circle icon"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [(_vm.$parent.worldStore.notifications) ? _c('NotificationReel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dashboardIsFolded),
      expression: "!dashboardIsFolded"
    }]
  }) : _vm._e()], 1), _vm._v(" "), _c('HelpMenu', {
    ref: "helpMenu"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "dash-scroll",
    attrs: {
      "href": "#"
    },
    on: {
      "click": [function($event) {
        if (!$event.shiftKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal.apply(null, arguments)
      }, function($event) {
        $event.preventDefault();
        return _vm.toggleDashboard.apply(null, arguments)
      }]
    }
  }, [_c('span'), _vm._v(_vm._s(_vm._f("translate")('Scroll')))])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboardIsFolded),
      expression: "dashboardIsFolded"
    }],
    staticClass: "ui tiny basic circular icon button hideOnMobileSite",
    staticStyle: {
      "position": "absolute",
      "top": "30px",
      "left": "50%",
      "margin-left": "-90px",
      "z-index": "102"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDashboard.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "angle double up icon"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Back to the Home screen")]), _vm._v(" "), (_vm.$parent.worldStore.notifications) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.worldStore.notifications.length > 0),
      expression: "$parent.worldStore.notifications.length>0"
    }],
    staticClass: "floating ui violet mini label",
    staticStyle: {
      "border-radius": "9px"
    },
    attrs: {
      "data-tooltip": "Recent Notifications",
      "data-inverted": "",
      "data-position": "right center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.worldStore.notifications.length))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboardIsFolded),
      expression: "dashboardIsFolded"
    }],
    staticClass: "hideOnMobileSite",
    attrs: {
      "id": "detailsSelector"
    }
  }, [(_vm.$parent.onboarding.viewtype) ? _c('div', {
    staticClass: "onboarding ui left pointing large yellow label",
    staticStyle: {
      "position": "absolute",
      "left": "475px",
      "z-index": "111"
    },
    attrs: {
      "data-onboarding": "viewtype"
    }
  }, [_vm._v("\n      Sort by Products or by Issues - will come really handy!"), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("Click on [ISSUES] to dismiss this note")])]) : _vm._e(), _vm._v("\n\n    View  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'pr' || _vm.detSel == 'pr2' ? 'active' : 'basic'),
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.switchToProdView()
      }, function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.setDetailView('pr2')
      }]
    }
  }, [_c('i', {
    staticClass: "cubes icon"
  }), _vm._v("   Products\n    ")]), _vm._v("\n     -or-  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'wd' || _vm.detSel == 'wc' ? 'active' : 'basic'),
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.setDetailView('wd')
      }, function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.setDetailView('wc')
      }]
    }
  }, [_c('i', {
    staticClass: "list layout icon"
  }), _vm._v("   Issues\n    ")]), _vm._v("\n     -or-  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'inv' ? 'active' : 'basic'),
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('inv')
      }
    }
  }, [_c('i', {
    staticClass: "warehouse icon"
  }), _vm._v("     Stock\n      "), _c('div', {
    staticClass: "floating ui inverted  red label",
    staticStyle: {
      "top": "4px",
      "padding": "2px 4px",
      "border-radius": "8px"
    }
  }, [_vm._v("new")])]), _vm._v("\n                   \n                   \n    "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "margin-left": "-10px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterShowSASelector),
      expression: "filterShowSASelector"
    }],
    staticClass: "ui multiple dropdown filtersa",
    staticStyle: {
      "padding": "0 20px 0 0"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_vm._v("Filter S.Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin": "3px"
    }
  }, [_vm._v("\n          Seller Accounts\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.$parent.worldStore.sellerAccounts), function(sa) {
    return _c('div', {
      staticClass: "item",
      attrs: {
        "data-value": sa.sellerId
      }
    }, [_c('i', {
      class: (sa.region == 'NA' ? 'olive' : 'teal') + ' circle compact icon'
    }), _vm._v(_vm._s(sa.accountNickName) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterUserCountries.length > 1),
      expression: "filterUserCountries.length>1"
    }],
    staticClass: "ui multiple dropdown filterc",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_vm._v("Filter Marketplaces")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin": "3px"
    }
  }, [_vm._v("\n          Marketplaces\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      class: c == 's' ? 'divider' : 'item',
      attrs: {
        "data-value": c
      }
    }, [(c != 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag'
    }) : _vm._e(), _vm._v(_vm._s(c != 's' ? c : '') + "\n          ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "ui checkbox labelCursorFix",
    style: ('display:none;    margin-left:180px; margin-top:10px;' + (_vm.detSel === 'pr' ? 'opacity:0;' : ''))
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortListByImportance),
      expression: "sortListByImportance"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "sortListByImportance",
      "id": "sortListByImportance"
    },
    domProps: {
      "checked": Array.isArray(_vm.sortListByImportance) ? _vm._i(_vm.sortListByImportance, null) > -1 : (_vm.sortListByImportance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sortListByImportance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sortListByImportance = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sortListByImportance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sortListByImportance = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "labelCursorFix",
    attrs: {
      "for": "sortListByImportance"
    }
  }, [_vm._v("Show Problems on top")])]), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "55px",
      "left": "46%",
      "transform": "translateX(41vw)",
      "width": "100px",
      "height": "40px"
    }
  }, [_c('i', {
    staticClass: "big icon th  ",
    style: ('cursor:pointer; color:' + (_vm.detSel == 'pr' ? 'yellow;' : '#eee')),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "big icon bars",
    style: ('cursor:pointer; color:' + (_vm.detSel == 'pr2' ? 'yellow;' : '#eee')),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr2')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      opn: _vm.dashboardIsFolded
    },
    attrs: {
      "id": "mainContainer"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    staticClass: "ui blue message onlyOnMobileSite",
    staticStyle: {
      "cursor": "pointer",
      "margin": "20px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr')
      }
    }
  }, [_vm._v("\n      On SentryKit Mobile only the "), _c('strong', [_vm._v("Product View")]), _vm._v(" is available."), _c('br'), _c('br'), _vm._v("\n      Tap this message to switch to that.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 402 || _vm.$root.paymentStatus == 403) ? _c('div', {
    staticClass: "ui red message onlyOnMobileSite",
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._v("\n      Your SentryKit account is unfortunately suspended. We couldn't charge you for the current month."), _c('br'), _c('br'), _vm._v("\n      Please update your payment method in "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(".\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    key: "2",
    staticClass: "ui fluid container",
    staticStyle: {
      "padding": "0 4vh"
    },
    attrs: {
      "id": "prodCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.detSel == 'pr') ? _c('ProductCard', {
    ref: "productCard"
  }) : _vm._e(), _vm._v(" "), (_vm.detSel == 'pr2') ? _c('ProductList', {
    ref: "productList"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px",
      "background-color": "#f8f8f8",
      "border": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.getCurrentPage() === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.getTotalPages())), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.getCurrentPage() === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getPageNumber(page) + 1) + "\n          ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.getCurrentPage() >= (_vm.getTotalPages() - 1)
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          Showing page " + _vm._s(_vm.getCurrentPage() + 1) + " of " + _vm._s(_vm.getTotalPages()) + "\n          (" + _vm._s(_vm.getTotalItems()) + " total products)\n        ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'inv') ? _c('div', {
    key: "3",
    staticClass: "ui fluid container",
    staticStyle: {
      "padding": "0 7vw"
    },
    attrs: {
      "id": "prodCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('InventoryList'), _vm._v(" "), (_vm.$parent.stocksTotalPages > 1) ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.$parent.stocksCurrentPage === 0
    },
    on: {
      "click": _vm.prevStocksPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.$parent.stocksTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.$parent.stocksCurrentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.loadStocksPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getPageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.$parent.stocksCurrentPage >= _vm.$parent.stocksTotalPages - 1
    },
    on: {
      "click": _vm.nextStocksPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.$parent.stocksCurrentPage + 1) + " of " + _vm._s(_vm.$parent.stocksTotalPages) + "\n            (" + _vm._s(_vm.$parent.stocksTotalItems) + " total items)\n          ")])]) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    key: "1",
    class: _vm.detSel == 'wd' ? 'wide' : '',
    attrs: {
      "id": "wdCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "componentFade",
      "appear": ""
    }
  }, [_c('WatchdogMenu', {
    attrs: {
      "wdNewErrorCounts": _vm.wdNewErrorCounts,
      "wdMenuUpdateTrigger": _vm.wdMenuUpdateTrigger
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui stackable cards hideOnMobileSite",
    attrs: {
      "id": "context"
    }
  }, _vm._l((_vm.wdListSorted), function(i, index) {
    return _c('Watchdog', {
      key: i,
      attrs: {
        "wdtype": i,
        "wd": _vm.$parent.worldStore.watchDogs[i],
        "detSel": _vm.detSel,
        "scrollIntoView": true,
        "nth": index,
        "suppressed-watchdogs": _vm.suppressedWatchdogs
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "height": "100vh",
      "width": "100vw",
      "background-color": "rgba(0,0,0,.6)",
      "pointer-events": "none",
      "z-index": "11",
      "display": "none"
    },
    attrs: {
      "id": "darkbackgr"
    }
  }) : _vm._e()]), _vm._v(" "), _c('ProductDetails', {
    ref: "productDetails"
  }), _vm._v(" "), _c('LoadingSpinner', {
    class: {
      'side': _vm.dashboardIsFolded
    }
  }), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ui active inverted loader"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white",
      "margin-top": "60px",
      "font-size": "16px"
    }
  }, [_vm._v("Loading data...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "30px 0px 0px 75px"
    }
  }, [_c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "background": "none",
      "border": "none",
      "-webkit-box-shadow": "none"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px",
      "margin": "-15px"
    },
    attrs: {
      "src": __webpack_require__(47)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted black segment onlyOnMobileSite",
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "10px",
      "width": "140px",
      "z-index": "101"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "#f2711c"
    }
  }, [_vm._v("Sentry")]), _c('span', {
    staticStyle: {
      "color": "#3bd"
    }
  }, [_vm._v("Kit")]), _vm._v(" "), _c('span', {}, [_vm._v("Mobile")])]), _vm._v(" "), _c('small')])
}]}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sls"
  }, [_c('div', {
    staticClass: "sls-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.catalogEmpty) ? _c('div', {
    staticClass: "sls-head-actions"
  }, [_c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExport
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 15V3"
    }
  })]), _vm._v("\n        Export\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sls-status-line"
  }, [_vm._v("\n        Last updated "), _c('strong', [_vm._v(_vm._s(_vm.refreshedLabel))]), _vm._v(" · refreshes automatically every day\n        "), _c('button', {
    staticClass: "sls-refresh-btn",
    class: {
      'sls-refresh-spin': _vm.backfilling
    },
    attrs: {
      "type": "button",
      "title": "Re-scan your listings now",
      "aria-label": "Refresh now",
      "disabled": _vm.backfilling
    },
    on: {
      "click": _vm.backfill
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sls-filter-bar"
  }, [_c('div', {
    staticClass: "sls-filters"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSellerId),
      expression: "filterSellerId"
    }],
    staticClass: "sls-select sls-filter-select",
    attrs: {
      "aria-label": "Storefront"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSellerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All storefronts")]), _vm._v(" "), _vm._l((_vm.storefrontOptions), function(acc) {
    return _c('option', {
      key: 'sf-' + acc.id,
      domProps: {
        "value": String(acc.id)
      }
    }, [_vm._v(_vm._s(acc.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterMarketplace),
      expression: "filterMarketplace"
    }],
    staticClass: "sls-select sls-filter-select",
    attrs: {
      "aria-label": "Marketplace"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterMarketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All marketplaces")]), _vm._v(" "), _vm._l((_vm.marketplaceOptions), function(code) {
    return _c('option', {
      key: 'mp-' + code,
      domProps: {
        "value": code
      }
    }, [_vm._v(_vm._s(code))])
  })], 2)])]), _vm._v(" "), (_vm.loading && !_vm.rows.length) ? _c('div', {
    staticClass: "sls-loading"
  }, [_c('div', {
    staticClass: "sls-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.rows.length && !_vm.loading) ? _c('div', {
    staticClass: "sls-error"
  }, [_c('p', {
    staticClass: "sls-error-title"
  }, [_vm._v("Could not load sellers")]), _vm._v(" "), _c('p', {
    staticClass: "sls-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchList
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (_vm.rows.length || (!_vm.loading && !_vm.loadError)) ? [(_vm.catalogEmpty) ? _c('div', {
    staticClass: "sls-empty"
  }, [_c('svg', {
    staticClass: "sls-empty-icon",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.6",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    }
  }), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "sls-empty-title"
  }, [_vm._v("See who's competing for your Buy Box")]), _vm._v(" "), _c('p', {
    staticClass: "sls-empty-copy"
  }, [_vm._v("Backfilling scans your ASINs for every seller who currently has a competing offer on them. Name them once and every future alert uses their name instead of a random-looking ID.")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-primary",
    class: {
      'sls-btn-loading': _vm.backfilling
    },
    attrs: {
      "type": "button",
      "disabled": _vm.backfilling
    },
    on: {
      "click": _vm.backfill
    }
  }, [_vm._v(_vm._s(_vm.backfilling ? 'Scanning your listings…' : 'Backfill from your listings'))])])]) : [(_vm.totalItems) ? _c('div', {
    staticClass: "sls-progress"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.classifiedCount))]), _vm._v(" of " + _vm._s(_vm.totalItems) + " sellers classified")]), _vm._v(" "), _c('div', {
    staticClass: "sls-progress-bar",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    style: ({
      width: _vm.classifiedPercent + '%'
    })
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedIds.length) ? _c('div', {
    staticClass: "sls-bulkbar"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.selectedIds.length))]), _vm._v(" selected")]), _vm._v(" "), _c('div', {
    staticClass: "sls-bulkbar-actions"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkRole),
      expression: "bulkRole"
    }],
    staticClass: "sls-select sls-bulk-select",
    attrs: {
      "aria-label": "Role for selected sellers"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkRole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.assignableRoles), function(opt) {
    return _c('option', {
      key: 'bulk-' + opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    class: {
      'sls-btn-loading': _vm.bulkSaving
    },
    attrs: {
      "type": "button",
      "disabled": _vm.bulkSaving
    },
    on: {
      "click": _vm.applyBulkRole
    }
  }, [_vm._v("Apply role")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportSelected
    }
  }, [_vm._v("Export selected")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sls-table-wrap",
    class: {
      'sls-table-busy': _vm.loading,
      'sls-table-wrap--bulk': _vm.selectedIds.length
    }
  }, [_c('table', {
    staticClass: "sls-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sls-th-check"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "aria-label": "Select all on this page",
      "disabled": !_vm.selectableRows.length
    },
    domProps: {
      "checked": _vm.allSelectableChecked
    },
    on: {
      "change": function($event) {
        return _vm.toggleSelectAll($event.target.checked)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Marketplace")]), _vm._v(" "), _c('th', [_vm._v("Seller")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Role "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": _vm.roleTooltip,
      "aria-label": _vm.roleTooltip
    }
  }, [_vm._v("ⓘ")])]), _vm._v(" "), _c('th', {
    staticClass: "sls-th-sorted",
    attrs: {
      "title": "Sorted by ASIN count, highest first"
    }
  }, [_vm._v("ASINs ▼")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('tbody', [(!_vm.rows.length && !_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "sls-td-empty",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No competing offers for this storefront / marketplace.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.id,
      class: {
        'sls-row-highlight': _vm.highlightId === row.id,
        'sls-row-suggested': _vm.hasSuggestion(row)
      },
      attrs: {
        "id": 'seller-row-' + row.id
      }
    }, [_c('td', {
      staticClass: "sls-td-check"
    }, [(!_vm.isSelf(row)) ? _c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row.id,
        "checked": _vm.isSelected(row.id)
      },
      on: {
        "change": function($event) {
          return _vm.toggleSelected(row.id, $event.target.checked)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "sls-mp-badge"
    }, [_vm._v(_vm._s(_vm.marketplaceCode(row)))])]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seller"
    }, [(_vm.profileUrl(row)) ? _c('a', {
      staticClass: "sls-seller-name",
      attrs: {
        "href": _vm.profileUrl(row),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(_vm.displayName(row)))]) : _c('span', {
      staticClass: "sls-seller-name"
    }, [_vm._v(_vm._s(_vm.displayName(row)))]), _vm._v(" "), _c('div', {
      staticClass: "sls-token"
    }, [_vm._v(_vm._s(_vm.merchantToken(row)))])]), _vm._v(" "), _c('td', [(_vm.isSelf(row)) ? _c('span', {
      staticClass: "sls-pill sls-pill-informational"
    }, [_vm._v("You")]) : (_vm.pillLabel(row)) ? _c('span', {
      staticClass: "sls-pill",
      class: 'sls-pill-' + _vm.pillTone(row)
    }, [_vm._v(_vm._s(_vm.pillLabel(row)))]) : _c('span', {
      staticClass: "sls-pill sls-pill-neutral"
    }, [_vm._v("New")])]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-name"
    }, [_c('input', {
      staticClass: "sls-name-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.namePlaceholder(row),
        "disabled": _vm.savingIds[row.id]
      },
      domProps: {
        "value": _vm.labelDraft(row)
      },
      on: {
        "input": function($event) {
          return _vm.onLabelInput(row, $event.target.value)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.saveLabel(row)
        },
        "blur": function($event) {
          return _vm.saveLabel(row)
        }
      }
    }), _vm._v(" "), (_vm.hasSuggestion(row)) ? _c('button', {
      staticClass: "sls-suggest",
      attrs: {
        "type": "button",
        "disabled": _vm.savingIds[row.id]
      },
      on: {
        "click": function($event) {
          return _vm.acceptSuggestion(row)
        }
      }
    }, [_vm._v("Use “" + _vm._s(row.suggested_label) + "”" + _vm._s(row.suggested_role ? ' as ' + _vm.roleLabel(row.suggested_role) : ''))]) : (_vm.showNameHint(row)) ? _c('p', {
      staticClass: "sls-field-hint"
    }, [_vm._v("Name this seller so the next alert uses it.")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-role"
    }, [(_vm.isSelf(row)) ? [_c('span', {
      staticClass: "sls-you"
    }, [_vm._v("Your account")])] : [_c('select', {
      staticClass: "sls-select",
      attrs: {
        "title": _vm.roleHelper(row),
        "disabled": !!_vm.savingIds[row.id]
      },
      domProps: {
        "value": _vm.roleValue(row)
      },
      on: {
        "change": function($event) {
          return _vm.saveRole(row, $event.target.value)
        }
      }
    }, _vm._l((_vm.assignableRoles), function(opt) {
      return _c('option', {
        key: opt.value,
        domProps: {
          "value": opt.value
        }
      }, [_vm._v(_vm._s(opt.label))])
    }), 0), _vm._v(" "), (_vm.showDigestNote(row)) ? _c('p', {
      staticClass: "sls-field-hint"
    }, [_vm._v("Instant Buy Box emails until Offer activity digest is on.")]) : _vm._e()]], 2), _vm._v(" "), _c('td', {
      staticClass: "sls-td-asins"
    }, [_vm._v(_vm._s(_vm.asinCount(row)))]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seen"
    }, [_vm._v(_vm._s(_vm.formatDay(row.first_seen)))]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seen"
    }, [_vm._v(_vm._s(_vm.formatDay(row.last_seen)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sls-pagination"
  }, [_c('span', {
    staticClass: "sls-page-label"
  }, [_vm._v(_vm._s(_vm.pageLabel))]), _vm._v(" "), _c('div', {
    staticClass: "sls-page-controls"
  }, [_c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1 || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(1)
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1 || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.page - 1)
      }
    }
  }, [_vm._v("‹")]), _vm._v(" "), _c('span', {
    staticClass: "sls-page-num"
  }, [_vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.totalPages || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.page + 1)
      }
    }
  }, [_vm._v("›")]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.totalPages || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.totalPages)
      }
    }
  }, [_vm._v("»")])])])]] : _vm._e(), _vm._v(" "), (_vm.exportOpen) ? _c('div', {
    staticClass: "sls-modal-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.exportOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "sls-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sls-export-title"
    }
  }, [_c('h3', {
    staticClass: "sls-modal-title",
    attrs: {
      "id": "sls-export-title"
    }
  }, [_vm._v("Export sellers")]), _vm._v(" "), _c('p', {
    staticClass: "sls-modal-hint"
  }, [_vm._v("Only sellers with offer activity inside this window are included. Storefront and marketplace filters apply.")]), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-dates"
  }, [_c('label', [_vm._v("From"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFrom),
      expression: "exportFrom"
    }],
    attrs: {
      "type": "date",
      "max": _vm.exportTo
    },
    domProps: {
      "value": (_vm.exportFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exportFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("To"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportTo),
      expression: "exportTo"
    }],
    attrs: {
      "type": "date",
      "min": _vm.exportFrom
    },
    domProps: {
      "value": (_vm.exportTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exportTo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-formats"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFormat),
      expression: "exportFormat"
    }],
    attrs: {
      "type": "radio",
      "value": "csv"
    },
    domProps: {
      "checked": _vm._q(_vm.exportFormat, "csv")
    },
    on: {
      "change": function($event) {
        _vm.exportFormat = "csv"
      }
    }
  }), _vm._v(" CSV")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFormat),
      expression: "exportFormat"
    }],
    attrs: {
      "type": "radio",
      "value": "xlsx"
    },
    domProps: {
      "checked": _vm._q(_vm.exportFormat, "xlsx")
    },
    on: {
      "change": function($event) {
        _vm.exportFormat = "xlsx"
      }
    }
  }), _vm._v(" XLSX")])]), _vm._v(" "), (_vm.exportRangeError) ? _c('p', {
    staticClass: "sls-modal-error"
  }, [_vm._v(_vm._s(_vm.exportRangeError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-actions"
  }, [_c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportOpen = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-primary sls-btn-compact",
    class: {
      'sls-btn-loading': _vm.exporting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.exporting || !!_vm.exportRangeError
    },
    on: {
      "click": _vm.exportReport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? 'Exporting…' : 'Export'))])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sls-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "sls-toast sls-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sls-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "sls-toast sls-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sls-page-head-text"
  }, [_c('h1', {
    staticClass: "sls-title"
  }, [_vm._v("Hijacker")]), _vm._v(" "), _c('p', {
    staticClass: "sls-subtitle"
  }, [_vm._v("Name competitors and choose how SentryKit treats them on each marketplace.")]), _vm._v(" "), _c('p', {
    staticClass: "sls-page-note"
  }, [_vm._v("Storefront and marketplace change which sellers you see below. A seller's name and role are saved per marketplace and apply across all your storefronts.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("First seen "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": "When SentryKit first saw this seller's current offer on one of your ASINs."
    }
  }, [_vm._v("ⓘ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Last seen on Buy Box "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": "The most recent time this seller's offer on one of your ASINs changed or was confirmed."
    }
  }, [_vm._v("ⓘ")])])
}]}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-forgot-page"
  }, [_c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main"
  }, [_c('div', {
    staticClass: "sk-card"
  }, [_vm._m(0), _vm._v(" "), (_vm.response === 200) ? _c('div', {
    staticClass: "sk-success-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v("\n        Password reset email has been sent. Check your inbox.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.response !== null && _vm.response !== 200) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M12 8v4m0 4h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.response === 404 ? 'We could not find this email address in our database.' : 'There was a problem sending the reset email. Please try again.') + "\n      ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendPasswordResetEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sk-form-row"
  }, [_c('div', {
    staticClass: "sk-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "sk-input",
    attrs: {
      "type": "email",
      "placeholder": "you@company.com",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "sk-btn sk-btn-primary sk-mt-6",
    class: {
      loading: _vm.working
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.working || _vm.sent
    }
  }, [(_vm.working) ? _c('span', {
    staticClass: "sk-spinner"
  }) : _c('span', [_vm._v(_vm._s(_vm.sent ? 'Email Sent ✓' : 'Send Reset Link →'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-login-link"
  }, [_vm._v("Remember your password? "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-card-header"
  }, [_c('h2', [_vm._v("Reset your password")]), _vm._v(" "), _c('p', [_vm._v("Enter your email address and we'll send you a link to reset your password.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card recent-events-card"
  }, [_c('div', {
    staticClass: "recent-events-header"
  }, [_c('div', {
    staticClass: "recent-events-title-row"
  }, [_c('div', {
    staticClass: "recent-events-icon-wrap",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "recent-events-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "recent-events-heading"
  }, [_vm._v("Recent Events")])]), _vm._v(" "), _c('div', {
    staticClass: "recent-events-segment",
    attrs: {
      "role": "group",
      "aria-label": "Time range"
    }
  }, [_c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '7d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('7d')
      }
    }
  }, [_vm._v("7d")]), _vm._v(" "), _c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '30d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('30d')
      }
    }
  }, [_vm._v("30d")]), _vm._v(" "), _c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '90d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('90d')
      }
    }
  }, [_vm._v("90d")])])]), _vm._v(" "), _c('div', {
    staticClass: "recent-events-list"
  }, [_vm._l((_vm.filteredEvents), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "recent-events-row"
    }, [_c('div', {
      staticClass: "recent-events-description"
    }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('div', {
      staticClass: "recent-events-meta"
    }, [_vm._v(_vm._s(event.timeAgo))])])
  }), _vm._v(" "), (!_vm.filteredEvents || _vm.filteredEvents.length === 0) ? _c('p', {
    staticClass: "recent-events-empty"
  }, [_vm._v("No events in this period.")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-section"
  }, [_c('div', {
    staticClass: "issues-header"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("\n      Priority Issues\n      "), _c('span', {
    staticClass: "need-action-badge"
  }, [_vm._v(_vm._s(_vm.needActionCount) + " Need Action")])]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('button', {
    staticClass: "export-button",
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": function($event) {
        return _vm.$emit('export')
      }
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n        " + _vm._s(_vm.exporting ? 'Exporting…' : 'Export CSV') + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "view-all-link",
    on: {
      "click": function($event) {
        return _vm.$emit('viewAll')
      }
    }
  }, [_vm._v("\n        View all " + _vm._s(_vm.totalIssues) + " issues >\n      ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section-dev-notes"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "issues-list"
  }, _vm._l((_vm.issues), function(issue, index) {
    return _c('div', {
      key: index,
      staticClass: "issue-row"
    }, [_c('div', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-image-wrap"
    }, [_c('div', {
      staticClass: "product-image-placeholder"
    }), _vm._v(" "), (issue.imageUrl) ? _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": issue.imageUrl,
        "alt": issue.product
      },
      on: {
        "error": function (e) { return e.target.style.display = 'none'; }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name-line"
    }, [_c('span', {
      staticClass: "product-name clickable",
      on: {
        "click": function($event) {
          return _vm.$emit('product-click', issue)
        }
      }
    }, [_vm._v(_vm._s(issue.product))])]), _vm._v(" "), (issue.asin) ? _c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(issue.asin))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "status-cell"
    }, [_c('span', {
      staticClass: "issue-status",
      class: issue.statusType
    }, [_vm._v(_vm._s(issue.status))])]), _vm._v(" "), _c('div', {
      staticClass: "impact-cell"
    }, [_c('span', {
      staticClass: "impact-value",
      class: issue.impactClass
    }, [_vm._v(_vm._s(issue.impact))])]), _vm._v(" "), _c('div', {
      staticClass: "action-cell"
    }, [_c('a', {
      staticClass: "view-details-link",
      on: {
        "click": function($event) {
          return _vm.$emit('action-click', issue)
        }
      }
    }, [_vm._v("\n          View Details >\n        ")])])])
  }), 0), _vm._v(" "), (_vm.syncing) ? _c('div', {
    staticClass: "sync-issues-note"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#2980b9",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Buy Box issues will appear here once the scan completes.")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-table-header"
  }, [_c('span', [_vm._v("PRODUCT")]), _vm._v(" "), _c('span', [_vm._v("STATUS")]), _vm._v(" "), _c('span', {
    staticClass: "est-daily-header"
  }, [_vm._v("\n      EST. DAILY\n      "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Estimated daily revenue impact"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ACTION")])])
}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "eight wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.suppressChildAsinRetiries),
      expression: "suppressChildAsinRetiries"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "lsCheckbox18425"
    },
    domProps: {
      "checked": Array.isArray(_vm.suppressChildAsinRetiries) ? _vm._i(_vm.suppressChildAsinRetiries, null) > -1 : (_vm.suppressChildAsinRetiries)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.suppressChildAsinRetiries,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.suppressChildAsinRetiries = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.suppressChildAsinRetiries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.suppressChildAsinRetiries = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lsCheckbox18425"
    }
  }, [_vm._v("Do not alert of child ASIN suspension")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-list-wrapper"
  }, [_c('transition-group', {
    staticClass: "ui very compact table",
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "table"
    }
  }, _vm._l((_vm.paginatedProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('td', {
      staticClass: "ui collapsing"
    }, [_c('img', {
      staticClass: "ui image tiny",
      attrs: {
        "src": product.largeImageUrl,
        "qqqstyle": "max-height:140px; max-width:100%; height:auto; width:auto; margin:5px auto 1px;"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: " four wide"
    }, [_c('div', {
      staticStyle: {
        "max-height": "5.5em",
        "overflow": "hidden"
      }
    }, [(product.productGroupProductIds.length > 1) ? _c('span', {
      staticClass: "ui mini circular grey label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n          " + _vm._s(product.productGroupProductIds.length) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag'
    }), _vm._v("\n        " + _vm._s(product.productTitle) + "\n      ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [(_vm.reds[product.productGroupId]) ? _c('span', {
      staticClass: "ui red horizontal label",
      staticStyle: {
        "margin-right": "1px",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.reds[product.productGroupId]) + " new issue" + _vm._s(_vm.reds[product.productGroupId] > 1 ? 's' : '  '))]) : _vm._e(), _vm._v(" "), (_vm.reds[product.productGroupId] > 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.ambers[product.productGroupId]) ? _c('span', {
      staticClass: "ui orange horizontal label",
      staticStyle: {
        "margin": "0 2px 0 0",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.ambers[product.productGroupId]) + " new warn.")]) : _vm._e()]), _vm._v(" "), (product.reviewCount !== null) ? _c('td', {
      staticClass: "two wide",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._l((_vm.starCalc(product.starRating, 'f')), function(n) {
      return _c('i', {
        staticClass: "yellow fitted star icon"
      })
    }), _vm._l((_vm.starCalc(product.starRating, 'h')), function(n) {
      return _c('i', {
        staticClass: "icons"
      }, [_c('i', {
        staticClass: "yellow fitted star outline icon"
      }), _c('i', {
        staticClass: "yellow fitted half star icon"
      })])
    }), _vm._l((_vm.starCalc(product.starRating, 'e')), function(n) {
      return _c('i', {
        staticClass: "yellow fitted star outline icon"
      })
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.badReview && _vm.$parent.$parent.worldStore.watchDogs.badReview.items && _vm.$parent.$parent.worldStore.watchDogs.topReview && _vm.$parent.$parent.worldStore.watchDogs.topReview.items && _vm.$parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId) && _vm.$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId) && ((_vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status == 2 && _vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus == 0) || (_vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status == 2 && _vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus == 0))) ? _c('i', {
      staticClass: "fitted red warning icon"
    }) : (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.badReview && _vm.$parent.$parent.worldStore.watchDogs.badReview.items && _vm.$parent.$parent.worldStore.watchDogs.topReview && _vm.$parent.$parent.worldStore.watchDogs.topReview.items && _vm.$parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId) && _vm.$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId) && ((_vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status == 1 && _vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus == 0) || (_vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status == 1 && _vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus == 0))) ? _c('i', {
      staticClass: "fitted orange warning icon"
    }) : _c('i', [_vm._v("   ")]), _vm._v("\n\n      " + _vm._s(product.reviewCount) + " " + _vm._s(product.reviewCount > 1 ? 'ratings' : 'rating') + "\n    ")], 2) : _c('td', {}, [_c('i', {
      staticClass: "yellow empty star icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n        Review data not avail. yet\n    ")]), _vm._v(" "), (product.ageHours > -1) ? _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_c('div', {
      attrs: {
        "data-tooltip": 'Today: ' + product.salesTodayDate + ' ' + _vm.toMonth(product.salesTodayMonth) + ' in Amazon ' + product.marketplace + ' time'
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.salesCountTotal(product.productGroupProductIds, 'y')))]), _vm._v(" units sold ystd. "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.salesCountTotal(product.productGroupProductIds, 't')))]), _vm._v(" so far today (" + _vm._s(product.marketplace) + ")\n      ")])]) : _c('td', {}, [_c('i', {
      staticClass: "dollar icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n        Sales data not avail. yet\n    ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "chartbutton ui right floated basic brown button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('i', {
      staticClass: "bar chart icon",
      staticStyle: {
        "margin": "0"
      }
    })])]), _vm._v(" "), (product.bsrRank !== null) ? _c('td', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n      BSR\n      "), _c('small', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v("(24h avg.) ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#a291fb",
        "font-weight": "bold"
      }
    }, [_vm._v("\n        " + _vm._s(product.bsrRank) + "\n      ")])]) : _vm._e(), _vm._v(" "), (product.productGroupProductIds.length > 1 && _vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('td', {
      staticClass: "three wide"
    }, [(_vm.stockReds[product.productGroupId] == 0 && _vm.stockAmbers[product.productGroupId] == 0) ? _c('span', [_c('span', {
      staticClass: "ui mini circular grey label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "cursor": "pointer"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n            " + _vm._s(product.productGroupProductIds.length) + "\n          ")]), _vm._v(" "), _c('small', [_vm._v("SKUs")])]) : _c('span', [_c('i', {
      staticClass: "brown warehouse icon"
    }), _vm._v("\n          Stock:\n          "), (_vm.stockReds[product.productGroupId]) ? _c('div', {
      staticClass: "ui tiny compact circular red label",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "warning icon"
    }), _vm._v(_vm._s(_vm.stockReds[product.productGroupId]))]) : _vm._e(), _vm._v(" "), (_vm.stockAmbers[product.productGroupId]) ? _c('div', {
      staticClass: "ui tiny compact circular orange label",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "warning icon"
    }), _vm._v(_vm._s(_vm.stockAmbers[product.productGroupId]))]) : _vm._e(), _vm._v("\n          of "), _c('span', {
      staticClass: "ui mini circular  label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "cursor": "pointer"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n            " + _vm._s(product.productGroupProductIds.length) + "\n          ")]), _vm._v(" "), _c('small', [_vm._v("SKUs")])])]) : _vm._e(), _vm._v(" "), (product.productGroupProductIds.length === 1 && _vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('td', {
      staticClass: "three wide",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [(_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 0) ? _c('i', {
      staticClass: "green checkmark icon"
    }) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 1) ? _c('i', {
      staticClass: "orange circle warning icon"
    }) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 2) ? _c('i', {
      staticClass: "red circle warning checkmark icon"
    }) : _vm._e(), _vm._v("\n\n        " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/,.* (\d+)\..*/gi, ' ($1 avail.)').replace(/Total in stock/gi, 'Stock') : '') + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*\((.+)\)/gi, '$1').replace(/Total in stock/gi, 'Stock').replace(/No alert threshold set;?/, '') : '') + "\n    ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px",
      "background-color": "#f8f8f8",
      "border": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.totalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getPageNumber(page) + 1) + "\n    ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    Showing page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + " \n    (" + _vm._s(_vm.totalItems) + " total products)\n    "), _c('br'), _vm._v("\n    DEBUG: groupedProducts=" + _vm._s(_vm.groupedProducts ? _vm.groupedProducts.length : 'undefined') + ", \n    itemsPerPage=" + _vm._s(_vm.itemsPerPage) + ", \n    totalPages=" + _vm._s(_vm.totalPages) + "\n  ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.sellerOptions.length > 1 || _vm.marketplaceOptions.length > 1) ? _c('div', {
    staticClass: "navbar-filters fee-claims-filters"
  }, [(_vm.sellerOptions.length > 1) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellerId),
      expression: "sellerId"
    }],
    staticClass: "fee-claims-filter",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sellerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.load]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("S.Accounts: All")]), _vm._v(" "), _vm._l((_vm.sellerOptions), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": String(s.id)
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.marketplaceOptions.length > 1) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "fee-claims-filter",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.marketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.load]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Marketplaces: All")]), _vm._v(" "), _vm._l((_vm.marketplaceOptions), function(m) {
    return _c('option', {
      key: m,
      domProps: {
        "value": m
      }
    }, [_vm._v("Amazon." + _vm._s(_vm.mpSuffix(m)))])
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims"
  }, [_c('div', {
    staticClass: "fee-claims-content"
  }, [_c('h1', {
    staticClass: "fee-claims-title"
  }, [_vm._v("Fee Claims")]), _vm._v(" "), _c('p', {
    staticClass: "fee-claims-subtitle"
  }, [_vm._v("When Amazon re-measures a product, you may be owed money on past orders, or paying too much on new ones.")]), _vm._v(" "), (_vm.notAvailable) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v("Fee Claims isn't switched on for this account.")]) : [(_vm.showKpis) ? _c('div', {
    staticClass: "fee-claims-kpis"
  }, [_c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Ready to claim")]), _vm._v(" "), _c('div', {
    staticClass: "v green",
    class: {
      multi: _vm.kpiAmounts('readyToClaimCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('readyToClaimCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v(_vm._s(_vm.plural(_vm.kpis.readyToClaimOrders, 'order')) + " · " + _vm._s(_vm.plural(_vm.kpis.readyToClaimProducts, 'product')))])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Claim within 7 days")]), _vm._v(" "), _c('div', {
    staticClass: "v",
    class: {
      red: _vm.kpis.claimWithin7DaysCents > 0,
      multi: _vm.kpiAmounts('claimWithin7DaysCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('claimWithin7DaysCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v("oldest orders leave Amazon's 90 days")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Filed, waiting")]), _vm._v(" "), _c('div', {
    staticClass: "v",
    class: {
      multi: _vm.kpiAmounts('filedCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('filedCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v(_vm._s(_vm.plural(_vm.kpis.filedCount, 'claim')) + " open")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Recovered")]), _vm._v(" "), _c('div', {
    staticClass: "v green",
    class: {
      multi: _vm.kpiAmounts('recoveredCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('recoveredCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v("since you started")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-sumbar"
  }, [_c('button', {
    staticClass: "fee-claims-btn green",
    attrs: {
      "type": "button",
      "disabled": !_vm.counts.to_claim || _vm.downloadingAll
    },
    on: {
      "click": _vm.downloadAll
    }
  }, [_c('i', {
    class: _vm.downloadingAll ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n            Download all claimable orders (XLSX)\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "fee-claims-muted"
  }, [_vm._v("Every product in one file: Summary, Orders to claim, How to file.")]), _vm._v(" "), _c('button', {
    staticClass: "fee-claims-howlink",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.howOpen = !_vm.howOpen
      }
    }
  }, [_vm._v("How to claim")])]), _vm._v(" "), (_vm.downloadError) ? _c('div', {
    staticClass: "fee-claims-error"
  }, [_vm._v(_vm._s(_vm.downloadError))]) : _vm._e(), _vm._v(" "), (_vm.howOpen) ? _c('div', {
    staticClass: "fee-claims-how"
  }, [_c('ol', [_c('li', [_vm._v("Download the order list for the product.")]), _vm._v(" "), _c('li', [_vm._v("In Seller Central, open a Seller Support case for FBA fees and attach the file.")]), _vm._v(" "), _c('li', [_vm._v("When Amazon refunds it, mark it here as Refunded.")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-muted"
  }, [_vm._v("Amazon only looks at orders from the last 90 days, so claim the oldest first.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-seg"
  }, _vm._l((_vm.tabs), function(t) {
    return _c('button', {
      key: t.key,
      class: {
        on: _vm.filter === t.key
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setFilter(t.key)
        }
      }
    }, [_vm._v(_vm._s(t.label) + " (" + _vm._s(_vm.counts[t.key] || 0) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-table"
  }, [_c('div', {
    staticClass: "fee-claims-head"
  }, [_c('div', [_vm._v("Product")]), _vm._v(" "), _c('div', [_vm._v("What Amazon changed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.isFeeUp ? 'New fee' : 'Orders'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.isFeeUp ? 'Extra / unit' : 'Amount'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.filter === 'to_claim' ? 'Claim by' : ''))]), _vm._v(" "), _c('div', [_vm._v("Status")])]), _vm._v(" "), (_vm.loading && !_vm.claims.length) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Loading…")]) : (_vm.loadError) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v(_vm._s(_vm.loadError))]) : (!_vm.claims.length) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v("Nothing here.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.claims), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "fee-claims-row"
    }, [_c('div', {
      staticClass: "prod"
    }, [(c.imageUrl) ? _c('img', {
      staticClass: "img",
      attrs: {
        "src": c.imageUrl,
        "alt": "",
        "loading": "lazy"
      }
    }) : _c('div', {
      staticClass: "img placeholder"
    }, [_c('i', {
      staticClass: "image icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "prod-info"
    }, [_c('div', {
      staticClass: "t",
      attrs: {
        "title": c.title
      }
    }, [_vm._v(_vm._s(c.title))]), _vm._v(" "), _c('dl', {
      staticClass: "ids"
    }, [_c('dt', [_vm._v("SKU")]), _c('dd', {
      staticClass: "mono",
      attrs: {
        "title": c.sellerSku
      }
    }, [_vm._v(_vm._s(c.sellerSku || '—'))]), _vm._v(" "), _c('dt', [_vm._v("ASIN")]), _vm._v(" "), _c('dd', {
      staticClass: "mono"
    }, [(_vm.asinUrl(c)) ? _c('a', {
      attrs: {
        "href": _vm.asinUrl(c),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(c.asin))]) : [_vm._v(_vm._s(c.asin || '—'))]], 2), _vm._v(" "), _c('dt', [_vm._v("FNSKU")]), _c('dd', {
      staticClass: "mono"
    }, [_vm._v(_vm._s(c.fnsku || '—'))])]), _vm._v(" "), _c('span', {
      staticClass: "mp"
    }, [_vm._v(_vm._s(c.marketplace))])])]), _vm._v(" "), _c('div', {
      staticClass: "what"
    }, [_c('table', {
      staticClass: "cmp"
    }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Before")]), _vm._v(" "), _c('th', [_vm._v("After (Amazon now)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.comparisonRows(c)), function(r) {
      return _c('tr', {
        key: r.measure
      }, [_c('th', [_vm._v(_vm._s(_vm.measureLabel(r.measure)))]), _vm._v(" "), _c('td', {
        staticClass: "before"
      }, [_vm._v(_vm._s(r.before || 'No change'))]), _vm._v(" "), _c('td', {
        staticClass: "after"
      }, [_vm._v("\n                      " + _vm._s(r.after || '—') + "\n                      "), (r.listing) ? _c('div', {
        staticClass: "listing",
        class: {
          differs: r.listingDiffers
        }
      }, [_vm._v("Your listing: " + _vm._s(r.listing))]) : _vm._e()])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "fee"
    }, [_c('th', [_vm._v("FBA fee")]), _vm._v(" "), _c('td', {
      staticClass: "before"
    }, [_vm._v(_vm._s(_vm.money(c.previousFeeCents, c.currency)))]), _vm._v(" "), _c('td', {
      staticClass: "after",
      class: _vm.isUp(c) ? 'amber' : 'green'
    }, [_vm._v(_vm._s(_vm.money(c.currentFeeCents, c.currency)))])])], 2)]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', [_vm._v("Re-measured " + _vm._s(_vm.shortDate(c.feeChangedOn)))]), _vm._v(" "), (c.matchesListing) ? _c('span', {
      staticClass: "tag good"
    }, [_c('i', {
      staticClass: "check icon"
    }), _vm._v("Now matches your listing")]) : (c.listingDiffers && c.listingDiffers.length) ? _c('span', {
      staticClass: "tag warn"
    }, [_vm._v("Differs from your listing")]) : _vm._e(), _vm._v(" "), (c.reversesChangeOn) ? _c('span', {
      staticClass: "tag"
    }, [_vm._v("Reverses the " + _vm._s(_vm.shortDate(c.reversesChangeOn)) + " increase")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [(_vm.isUp(c)) ? [_vm._v(_vm._s(_vm.money(c.currentFeeCents, c.currency)))] : (c.orderListStatus === 'pending') ? [_c('span', {
      staticClass: "fee-claims-muted"
    }, [_vm._v("Checking…")])] : [_vm._v(_vm._s(c.orders != null ? c.orders : '—'))]], 2), _vm._v(" "), _c('div', {
      staticClass: "amt",
      class: _vm.isUp(c) ? 'amber' : 'green'
    }, [(_vm.isUp(c)) ? [_vm._v("+" + _vm._s(_vm.money(c.currentFeeCents - c.previousFeeCents, c.currency)))] : (c.claimCents != null) ? [_vm._v(_vm._s(_vm.money(c.claimCents, c.currency)))] : [_vm._v("—")]], 2), _vm._v(" "), _c('div', {
      staticClass: "when"
    }, [(_vm.filter === 'to_claim' && c.claimBy) ? _c('div', {
      staticClass: "date",
      class: {
        soon: c.claimByDueSoon
      }
    }, [_vm._v(_vm._s(_vm.shortDate(c.claimBy)))]) : _vm._e(), _vm._v(" "), (c.downloadUrl && !_vm.isUp(c) && _vm.filter !== 'done') ? _c('button', {
      staticClass: "fee-claims-btn green small",
      attrs: {
        "type": "button",
        "disabled": _vm.downloadingId === c.id
      },
      on: {
        "click": function($event) {
          return _vm.downloadOne(c)
        }
      }
    }, [_c('i', {
      class: _vm.downloadingId === c.id ? 'notched circle loading icon' : 'download icon'
    }), _vm._v("\n                Download orders\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isUp(c) && c.productId) ? _c('button', {
      staticClass: "fee-claims-btn small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewProduct(c)
        }
      }
    }, [_vm._v("View product")]) : _vm._e(), _vm._v(" "), (_vm.rowError.id === c.id) ? _c('div', {
      staticClass: "fee-claims-error"
    }, [_vm._v(_vm._s(_vm.rowError.message))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('select', {
      staticClass: "fee-claims-status",
      attrs: {
        "disabled": _vm.savingId === c.id
      },
      domProps: {
        "value": c.status
      },
      on: {
        "change": function($event) {
          return _vm.setStatus(c, $event.target.value)
        }
      }
    }, _vm._l((c.statuses), function(s) {
      return _c('option', {
        key: s,
        domProps: {
          "value": s
        }
      }, [_vm._v(_vm._s(_vm.statusLabel(s)))])
    }), 0)])])
  })], 2)]], 2)])], 2)
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted list",
    attrs: {
      "id": "dashNotificationReel"
    },
    on: {
      "wheel": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.$parent.worldStore.notifications.length > 0),
      expression: "$parent.$parent.worldStore.notifications.length>0"
    }],
    staticClass: "ui header",
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('span', {
    staticClass: "ui violet empty circular label"
  }), _vm._v("\n    Recent Notifications:\n    "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "font-weight": "normal",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearList.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      [clear list]\n    ")])]), _vm._v(" "), _vm._l((_vm.$parent.$parent.worldStore.notifications), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.openDetails(index)
        }
      }
    }, [(item.productId !== null && _vm.$parent.$parent.worldStore.products[item.productId]) ? _c('img', {
      staticClass: "ui mini image",
      attrs: {
        "src": _vm.$parent.$parent.worldStore.products[item.productId].largeImageUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      class: 'header ' + item.notificationLevel
    }, [_vm._v(_vm._s(item.notificationType))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.message))])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.$parent.worldStore.notifications.length == 0),
      expression: "$parent.$parent.worldStore.notifications.length == 0"
    }],
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("\n    Leave the site open, the latest "), _c('span', {
    staticClass: "ALERT"
  }, [_vm._v("Alerts")]), _vm._v(" "), _c('br'), _vm._v(" and "), _c('span', {
    staticClass: "NOTICE"
  }, [_vm._v("Notifications")]), _vm._v(" will appear here too.\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
    }
  })])]), _vm._v("\n      Your Account Health\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-gate",
    class: _vm.isFeaturedMerchant ? '' : 'not-eligible'
  }, [_c('div', {
    staticClass: "featured-gate-icon",
    class: _vm.isFeaturedMerchant ? '' : 'critical'
  }, [(_vm.isFeaturedMerchant) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "featured-gate-label"
  }, [_vm._v("Featured Merchant: " + _vm._s(_vm.isFeaturedMerchant ? 'Eligible' : 'Not Eligible'))]), _vm._v(" "), _c('div', {
    staticClass: "featured-gate-sub"
  }, [_vm._v(_vm._s(_vm.isFeaturedMerchant ? 'You can compete for the Buy Box on this ASIN' : 'You cannot win the Buy Box on this ASIN'))])]), _vm._v(" "), _c('span', {
    staticClass: "featured-gate-code"
  }, [_vm._v("IsFeaturedMerchant: " + _vm._s(_vm.isFeaturedMerchant ? 'true' : 'false'))])]), _vm._v(" "), ((_vm.accountHealth.metrics || []).length) ? _c('div', {
    staticClass: "health-metrics"
  }, _vm._l(((_vm.accountHealth.metrics || [])), function(metric, index) {
    return _c('div', {
      key: index,
      staticClass: "health-metric"
    }, [_c('span', {
      staticClass: "health-metric-name"
    }, [_vm._v(_vm._s(metric.name))]), _vm._v(" "), _c('span', {
      staticClass: "health-metric-value",
      class: metric.status
    }, [_vm._v(_vm._s(metric.value) + " "), _c('span', {
      staticClass: "threshold"
    }, [_vm._v(_vm._s(metric.threshold))])])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "health-note"
  }, [_vm._v("\n    These metrics govern your "), _c('strong', [_vm._v("Featured Merchant")]), _vm._v(" status. If ODR exceeds 1%, Amazon can revoke Buy Box eligibility account-wide — "), _c('code', [_vm._v("IsFeaturedMerchant")]), _vm._v(" flips to "), _c('code', [_vm._v("false")]), _vm._v(" and you cannot win any Buy Box regardless of price.\n  ")])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "section-card review-health-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    }
  })])]), _vm._v("\n      Review Health\n    ")])]), _vm._v(" "), (_vm.waiting) ? _c('div', {
    staticClass: "review-health-waiting"
  }, [_vm._v("\n    Waiting for Amazon's first review data\n  ")]) : [_c('div', {
    staticClass: "health-metrics review-health-metrics"
  }, [_c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Star rating")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('rating_drop')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ratingText) + "\n          "), (_vm.previousRatingText) ? _c('span', {
    staticClass: "threshold"
  }, [_vm._v(_vm._s(_vm.previousRatingText))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Rating count")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('rating_count_drop')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.countText) + "\n          "), (_vm.countDeltaText) ? _c('span', {
    staticClass: "threshold"
  }, [_vm._v(_vm._s(_vm.countDeltaText))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Critical reviews, last 30 days")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('new_critical_reviews')
    }
  }, [_vm._v(_vm._s(_vm.critical30dText))])]), _vm._v(" "), (_vm.sparkline) ? _c('div', {
    staticClass: "review-health-trend"
  }, [_c('div', {
    staticClass: "review-health-trend-label"
  }, [_c('span', [_vm._v("Rating count, last " + _vm._s(_vm.sparkline.days) + " days")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sparkline.firstText) + " → " + _vm._s(_vm.sparkline.lastText))])]), _vm._v(" "), _c('svg', {
    staticClass: "review-health-sparkline",
    attrs: {
      "viewBox": "0 0 200 40",
      "preserveAspectRatio": "none",
      "role": "img",
      "aria-label": 'Rating count trend: ' + _vm.sparkline.firstText + ' to ' + _vm.sparkline.lastText
    }
  }, [_c('polyline', {
    attrs: {
      "points": _vm.sparkline.points,
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round",
      "stroke-linecap": "round"
    }
  })])]) : _vm._e()])], _vm._v(" "), _c('div', {
    staticClass: "review-health-footer"
  }, [(_vm.asOfText) ? _c('span', {
    staticClass: "review-health-asof"
  }, [_vm._v("Amazon data as of " + _vm._s(_vm.asOfText))]) : _vm._e(), _vm._v(" "), (_vm.reviewsUrl) ? _c('a', {
    staticClass: "review-health-link",
    attrs: {
      "href": _vm.reviewsUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Read reviews on Amazon")]) : _vm._e()])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagnosis-card"
  }, [_c('span', {
    staticClass: "dev-annotation calculated"
  }, [_vm._v("Your Logic")]), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-header"
  }, [_c('div', {
    staticClass: "diagnosis-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })])]), _vm._v("\n      Diagnosis\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "live-badge"
  }, [_vm._v("Live Data")])]), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-content"
  }, [_c('div', {
    staticClass: "diagnosis-headline"
  }, [_c('h3', [_vm._v(_vm._s(_vm.diagnosis.primaryCause))]), _vm._v(" "), _c('span', {
    staticClass: "confidence-badge"
  }, [_vm._v("• " + _vm._s(_vm.confidenceLabel))])]), _vm._v(" "), _c('p', {
    staticClass: "diagnosis-text"
  }, [_vm._v(_vm._s(_vm.diagnosis.description))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-notes"
  }, [_c('div', {
    staticClass: "dev-notes-title"
  }, [_vm._v("Developer Notes — Diagnosis Logic")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("High Confidence:")]), _vm._v(" Price gap > 5% AND both FBA (or both FBM)")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Medium Confidence:")]), _vm._v(" Price gap < 5% OR mixed fulfillment")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Low Confidence:")]), _vm._v(" Price is competitive, non-price factor suspected")])])])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.whiteList.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', [_vm._v("Whitelisted sellers")]), _vm._v(" "), _c('table', {
    staticClass: "ui very basic compact table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.whiteList), function(w) {
    return _c('tr', {
      key: w.url
    }, [_c('td', [_vm._v(_vm._s(w.sellerId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(w.marketplace))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": w.url,
        "target": "_blank"
      }
    }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "mini basic ui icon button",
      on: {
        "click": function($event) {
          return _vm.removeFromWhiteList(w.url)
        }
      }
    }, [_c('i', {
      staticClass: "close icon"
    })])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "ui button submit",
    class: {
      'disabled': _vm.whiteListURLParsed == null
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addToWhiteList
    }
  }, [_vm._v("Whitelist Seller by Feedback Page URL")])])]), _vm._v(" "), _c('div', {
    staticClass: "eight wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field",
    class: {
      'error': _vm.whiteListURLError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whiteListURL),
      expression: "whiteListURL"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Seller Feedback URL",
      "required": "required"
    },
    domProps: {
      "value": (_vm.whiteListURL)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addToWhiteList.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.whiteListURL = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (_vm.whiteListURLError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui error message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Wrong URL format")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("Expecting URL for a seller's feedback page, for example: "), _c('a', {
    attrs: {
      "href": this.whiteListURLErrorURL,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(this.whiteListURLErrorURL))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "two wide"
  }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Link")]), _vm._v(" "), _c('th', {
    staticClass: "four wide"
  }, [_vm._v("Remove")])])])
}]}

/***/ }),
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[426]);


// WEBPACK FOOTER //
// static/js/app.9ebffbcfebfb4c7a1bb7.js